/* eslint-disable */

import { AllTypesProps, ReturnTypes } from './const';
type ZEUS_INTERFACES = GraphQLTypes["_Field"] | GraphQLTypes["MutationResult"]
type ZEUS_UNIONS = GraphQLTypes["_Argument"] | GraphQLTypes["_PathFragment"]

export type ValueTypes = {
    ["_Column"]: AliasType<{
	name?:boolean,
	type?:boolean,
	enumName?:boolean,
	defaultValue?:boolean,
	nullable?:boolean,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: boolean
}>;
	["_Field"]:AliasType<{
		name?:boolean,
	type?:boolean,
	nullable?:boolean,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"];
		['...on _Column']?: Omit<ValueTypes["_Column"],keyof ValueTypes["_Field"]>;
		['...on _Relation']?: Omit<ValueTypes["_Relation"],keyof ValueTypes["_Field"]>;
		__typename?: boolean
}>;
	["_Rule"]: AliasType<{
	message?:ValueTypes["_RuleMessage"],
	validator?:boolean,
		__typename?: boolean
}>;
	["_RuleMessage"]: AliasType<{
	text?:boolean,
		__typename?: boolean
}>;
	["_Validator"]: AliasType<{
	operation?:boolean,
	arguments?:ValueTypes["_Argument"],
		__typename?: boolean
}>;
	["_Argument"]: AliasType<{		["...on _ValidatorArgument"] : ValueTypes["_ValidatorArgument"],
		["...on _PathArgument"] : ValueTypes["_PathArgument"],
		["...on _LiteralArgument"] : ValueTypes["_LiteralArgument"]
		__typename?: boolean
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:boolean,
		__typename?: boolean
}>;
	["_PathArgument"]: AliasType<{
	path?:boolean,
		__typename?: boolean
}>;
	["_LiteralArgument"]: AliasType<{
	value?:boolean,
		__typename?: boolean
}>;
	/** Json custom scalar type */
["Json"]:unknown;
	["_Relation"]: AliasType<{
	name?:boolean,
	type?:boolean,
	side?:boolean,
	targetEntity?:boolean,
	ownedBy?:boolean,
	inversedBy?:boolean,
	nullable?:boolean,
	onDelete?:boolean,
	orphanRemoval?:boolean,
	orderBy?:ValueTypes["_OrderBy"],
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: boolean
}>;
	["_RelationSide"]:_RelationSide;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_OrderBy"]: AliasType<{
	path?:boolean,
	direction?:boolean,
		__typename?: boolean
}>;
	["_OrderByDirection"]:_OrderByDirection;
	["Query"]: AliasType<{
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:boolean,
getBlogPage?: [{	by:ValueTypes["BlogPageUniqueWhere"],	filter?:ValueTypes["BlogPageWhere"] | null},ValueTypes["BlogPage"]],
listBlogPage?: [{	filter?:ValueTypes["BlogPageWhere"] | null,	orderBy?:ValueTypes["BlogPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPage"]],
paginateBlogPage?: [{	filter?:ValueTypes["BlogPageWhere"] | null,	orderBy?:ValueTypes["BlogPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPageConnection"]],
validateCreateBlogPage?: [{	data:ValueTypes["BlogPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPage?: [{	by:ValueTypes["BlogPageUniqueWhere"],	data:ValueTypes["BlogPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPost?: [{	by:ValueTypes["BlogPostUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
listBlogPost?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPost"]],
paginateBlogPost?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostConnection"]],
validateCreateBlogPost?: [{	data:ValueTypes["BlogPostCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPost?: [{	by:ValueTypes["BlogPostUniqueWhere"],	data:ValueTypes["BlogPostUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostTag?: [{	by:ValueTypes["BlogPostTagUniqueWhere"],	filter?:ValueTypes["BlogPostTagWhere"] | null},ValueTypes["BlogPostTag"]],
listBlogPostTag?: [{	filter?:ValueTypes["BlogPostTagWhere"] | null,	orderBy?:ValueTypes["BlogPostTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostTag"]],
paginateBlogPostTag?: [{	filter?:ValueTypes["BlogPostTagWhere"] | null,	orderBy?:ValueTypes["BlogPostTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostTagConnection"]],
validateCreateBlogPostTag?: [{	data:ValueTypes["BlogPostTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostTag?: [{	by:ValueTypes["BlogPostTagUniqueWhere"],	data:ValueTypes["BlogPostTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getBodyTag?: [{	by:ValueTypes["BodyTagUniqueWhere"],	filter?:ValueTypes["BodyTagWhere"] | null},ValueTypes["BodyTag"]],
listBodyTag?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BodyTag"]],
paginateBodyTag?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BodyTagConnection"]],
validateCreateBodyTag?: [{	data:ValueTypes["BodyTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBodyTag?: [{	by:ValueTypes["BodyTagUniqueWhere"],	data:ValueTypes["BodyTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getBodyTagCategory?: [{	by:ValueTypes["BodyTagCategoryUniqueWhere"],	filter?:ValueTypes["BodyTagCategoryWhere"] | null},ValueTypes["BodyTagCategory"]],
listBodyTagCategory?: [{	filter?:ValueTypes["BodyTagCategoryWhere"] | null,	orderBy?:ValueTypes["BodyTagCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BodyTagCategory"]],
paginateBodyTagCategory?: [{	filter?:ValueTypes["BodyTagCategoryWhere"] | null,	orderBy?:ValueTypes["BodyTagCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BodyTagCategoryConnection"]],
validateCreateBodyTagCategory?: [{	data:ValueTypes["BodyTagCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBodyTagCategory?: [{	by:ValueTypes["BodyTagCategoryUniqueWhere"],	data:ValueTypes["BodyTagCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getDidYouKnow?: [{	by:ValueTypes["DidYouKnowUniqueWhere"],	filter?:ValueTypes["DidYouKnowWhere"] | null},ValueTypes["DidYouKnow"]],
listDidYouKnow?: [{	filter?:ValueTypes["DidYouKnowWhere"] | null,	orderBy?:ValueTypes["DidYouKnowOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DidYouKnow"]],
paginateDidYouKnow?: [{	filter?:ValueTypes["DidYouKnowWhere"] | null,	orderBy?:ValueTypes["DidYouKnowOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DidYouKnowConnection"]],
validateCreateDidYouKnow?: [{	data:ValueTypes["DidYouKnowCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDidYouKnow?: [{	by:ValueTypes["DidYouKnowUniqueWhere"],	data:ValueTypes["DidYouKnowUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["Medium"]],
listMedium?: [{	filter?:ValueTypes["MediumWhere"] | null,	orderBy?:ValueTypes["MediumOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Medium"]],
paginateMedium?: [{	filter?:ValueTypes["MediumWhere"] | null,	orderBy?:ValueTypes["MediumOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumConnection"]],
validateCreateMedium?: [{	data:ValueTypes["MediumCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	data:ValueTypes["MediumUpdateInput"]},ValueTypes["_ValidationResult"]],
getNutritionalValue?: [{	by:ValueTypes["NutritionalValueUniqueWhere"],	filter?:ValueTypes["NutritionalValueWhere"] | null},ValueTypes["NutritionalValue"]],
listNutritionalValue?: [{	filter?:ValueTypes["NutritionalValueWhere"] | null,	orderBy?:ValueTypes["NutritionalValueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NutritionalValue"]],
paginateNutritionalValue?: [{	filter?:ValueTypes["NutritionalValueWhere"] | null,	orderBy?:ValueTypes["NutritionalValueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NutritionalValueConnection"]],
validateCreateNutritionalValue?: [{	data:ValueTypes["NutritionalValueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNutritionalValue?: [{	by:ValueTypes["NutritionalValueUniqueWhere"],	data:ValueTypes["NutritionalValueUpdateInput"]},ValueTypes["_ValidationResult"]],
getPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
listPage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Page"]],
paginatePage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageConnection"]],
validateCreatePage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePage?: [{	by:ValueTypes["PageUniqueWhere"],	data:ValueTypes["PageUpdateInput"]},ValueTypes["_ValidationResult"]],
getReference?: [{	by:ValueTypes["ReferenceUniqueWhere"],	filter?:ValueTypes["ReferenceWhere"] | null},ValueTypes["Reference"]],
listReference?: [{	filter?:ValueTypes["ReferenceWhere"] | null,	orderBy?:ValueTypes["ReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Reference"]],
paginateReference?: [{	filter?:ValueTypes["ReferenceWhere"] | null,	orderBy?:ValueTypes["ReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ReferenceConnection"]],
validateCreateReference?: [{	data:ValueTypes["ReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateReference?: [{	by:ValueTypes["ReferenceUniqueWhere"],	data:ValueTypes["ReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getReferenceList?: [{	by:ValueTypes["ReferenceListUniqueWhere"],	filter?:ValueTypes["ReferenceListWhere"] | null},ValueTypes["ReferenceList"]],
listReferenceList?: [{	filter?:ValueTypes["ReferenceListWhere"] | null,	orderBy?:ValueTypes["ReferenceListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ReferenceList"]],
paginateReferenceList?: [{	filter?:ValueTypes["ReferenceListWhere"] | null,	orderBy?:ValueTypes["ReferenceListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ReferenceListConnection"]],
validateCreateReferenceList?: [{	data:ValueTypes["ReferenceListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateReferenceList?: [{	by:ValueTypes["ReferenceListUniqueWhere"],	data:ValueTypes["ReferenceListUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
listVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Video"]],
paginateVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	data:ValueTypes["VideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getBrand?: [{	by:ValueTypes["BrandUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
listBrand?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Brand"]],
paginateBrand?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandConnection"]],
validateCreateBrand?: [{	data:ValueTypes["BrandCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBrand?: [{	by:ValueTypes["BrandUniqueWhere"],	data:ValueTypes["BrandUpdateInput"]},ValueTypes["_ValidationResult"]],
getBrandDistributor?: [{	by:ValueTypes["BrandDistributorUniqueWhere"],	filter?:ValueTypes["BrandDistributorWhere"] | null},ValueTypes["BrandDistributor"]],
listBrandDistributor?: [{	filter?:ValueTypes["BrandDistributorWhere"] | null,	orderBy?:ValueTypes["BrandDistributorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandDistributor"]],
paginateBrandDistributor?: [{	filter?:ValueTypes["BrandDistributorWhere"] | null,	orderBy?:ValueTypes["BrandDistributorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandDistributorConnection"]],
validateCreateBrandDistributor?: [{	data:ValueTypes["BrandDistributorCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBrandDistributor?: [{	by:ValueTypes["BrandDistributorUniqueWhere"],	data:ValueTypes["BrandDistributorUpdateInput"]},ValueTypes["_ValidationResult"]],
getDogSize?: [{	by:ValueTypes["DogSizeUniqueWhere"],	filter?:ValueTypes["DogSizeWhere"] | null},ValueTypes["DogSize"]],
listDogSize?: [{	filter?:ValueTypes["DogSizeWhere"] | null,	orderBy?:ValueTypes["DogSizeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogSize"]],
paginateDogSize?: [{	filter?:ValueTypes["DogSizeWhere"] | null,	orderBy?:ValueTypes["DogSizeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogSizeConnection"]],
validateCreateDogSize?: [{	data:ValueTypes["DogSizeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDogSize?: [{	by:ValueTypes["DogSizeUniqueWhere"],	data:ValueTypes["DogSizeUpdateInput"]},ValueTypes["_ValidationResult"]],
getProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
listProduct?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
paginateProduct?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
validateCreateProduct?: [{	data:ValueTypes["ProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	data:ValueTypes["ProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductionMethod?: [{	by:ValueTypes["ProductionMethodUniqueWhere"],	filter?:ValueTypes["ProductionMethodWhere"] | null},ValueTypes["ProductionMethod"]],
listProductionMethod?: [{	filter?:ValueTypes["ProductionMethodWhere"] | null,	orderBy?:ValueTypes["ProductionMethodOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductionMethod"]],
paginateProductionMethod?: [{	filter?:ValueTypes["ProductionMethodWhere"] | null,	orderBy?:ValueTypes["ProductionMethodOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductionMethodConnection"]],
validateCreateProductionMethod?: [{	data:ValueTypes["ProductionMethodCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductionMethod?: [{	by:ValueTypes["ProductionMethodUniqueWhere"],	data:ValueTypes["ProductionMethodUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductLine?: [{	by:ValueTypes["ProductLineUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLine"]],
listProductLine?: [{	filter?:ValueTypes["ProductLineWhere"] | null,	orderBy?:ValueTypes["ProductLineOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductLine"]],
paginateProductLine?: [{	filter?:ValueTypes["ProductLineWhere"] | null,	orderBy?:ValueTypes["ProductLineOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductLineConnection"]],
validateCreateProductLine?: [{	data:ValueTypes["ProductLineCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductLine?: [{	by:ValueTypes["ProductLineUniqueWhere"],	data:ValueTypes["ProductLineUpdateInput"]},ValueTypes["_ValidationResult"]],
getBreed?: [{	by:ValueTypes["BreedUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
listBreed?: [{	filter?:ValueTypes["BreedWhere"] | null,	orderBy?:ValueTypes["BreedOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Breed"]],
paginateBreed?: [{	filter?:ValueTypes["BreedWhere"] | null,	orderBy?:ValueTypes["BreedOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BreedConnection"]],
validateCreateBreed?: [{	data:ValueTypes["BreedCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBreed?: [{	by:ValueTypes["BreedUniqueWhere"],	data:ValueTypes["BreedUpdateInput"]},ValueTypes["_ValidationResult"]],
getDog?: [{	by:ValueTypes["DogUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
listDog?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Dog"]],
paginateDog?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogConnection"]],
validateCreateDog?: [{	data:ValueTypes["DogCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDog?: [{	by:ValueTypes["DogUniqueWhere"],	data:ValueTypes["DogUpdateInput"]},ValueTypes["_ValidationResult"]],
getUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
listUser?: [{	filter?:ValueTypes["UserWhere"] | null,	orderBy?:ValueTypes["UserOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["User"]],
paginateUser?: [{	filter?:ValueTypes["UserWhere"] | null,	orderBy?:ValueTypes["UserOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UserConnection"]],
validateCreateUser?: [{	data:ValueTypes["UserCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUser?: [{	by:ValueTypes["UserUniqueWhere"],	data:ValueTypes["UserUpdateInput"]},ValueTypes["_ValidationResult"]],
getVeterinary?: [{	by:ValueTypes["VeterinaryUniqueWhere"],	filter?:ValueTypes["VeterinaryWhere"] | null},ValueTypes["Veterinary"]],
listVeterinary?: [{	filter?:ValueTypes["VeterinaryWhere"] | null,	orderBy?:ValueTypes["VeterinaryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Veterinary"]],
paginateVeterinary?: [{	filter?:ValueTypes["VeterinaryWhere"] | null,	orderBy?:ValueTypes["VeterinaryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["VeterinaryConnection"]],
validateCreateVeterinary?: [{	data:ValueTypes["VeterinaryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVeterinary?: [{	by:ValueTypes["VeterinaryUniqueWhere"],	data:ValueTypes["VeterinaryUpdateInput"]},ValueTypes["_ValidationResult"]],
getNutritionalValueOfProduct?: [{	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null},ValueTypes["NutritionalValueOfProduct"]],
listNutritionalValueOfProduct?: [{	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null,	orderBy?:ValueTypes["NutritionalValueOfProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NutritionalValueOfProduct"]],
paginateNutritionalValueOfProduct?: [{	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null,	orderBy?:ValueTypes["NutritionalValueOfProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NutritionalValueOfProductConnection"]],
validateCreateNutritionalValueOfProduct?: [{	data:ValueTypes["NutritionalValueOfProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNutritionalValueOfProduct?: [{	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],	data:ValueTypes["NutritionalValueOfProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getReview?: [{	by:ValueTypes["ReviewUniqueWhere"],	filter?:ValueTypes["ReviewWhere"] | null},ValueTypes["Review"]],
listReview?: [{	filter?:ValueTypes["ReviewWhere"] | null,	orderBy?:ValueTypes["ReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Review"]],
paginateReview?: [{	filter?:ValueTypes["ReviewWhere"] | null,	orderBy?:ValueTypes["ReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ReviewConnection"]],
validateCreateReview?: [{	data:ValueTypes["ReviewCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateReview?: [{	by:ValueTypes["ReviewUniqueWhere"],	data:ValueTypes["ReviewUpdateInput"]},ValueTypes["_ValidationResult"]],
getDogBodyType?: [{	by:ValueTypes["DogBodyTypeUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null},ValueTypes["DogBodyType"]],
listDogBodyType?: [{	filter?:ValueTypes["DogBodyTypeWhere"] | null,	orderBy?:ValueTypes["DogBodyTypeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogBodyType"]],
paginateDogBodyType?: [{	filter?:ValueTypes["DogBodyTypeWhere"] | null,	orderBy?:ValueTypes["DogBodyTypeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogBodyTypeConnection"]],
validateCreateDogBodyType?: [{	data:ValueTypes["DogBodyTypeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDogBodyType?: [{	by:ValueTypes["DogBodyTypeUniqueWhere"],	data:ValueTypes["DogBodyTypeUpdateInput"]},ValueTypes["_ValidationResult"]],
getDogBodyTypeCategory?: [{	by:ValueTypes["DogBodyTypeCategoryUniqueWhere"],	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null},ValueTypes["DogBodyTypeCategory"]],
listDogBodyTypeCategory?: [{	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null,	orderBy?:ValueTypes["DogBodyTypeCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogBodyTypeCategory"]],
paginateDogBodyTypeCategory?: [{	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null,	orderBy?:ValueTypes["DogBodyTypeCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogBodyTypeCategoryConnection"]],
validateCreateDogBodyTypeCategory?: [{	data:ValueTypes["DogBodyTypeCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDogBodyTypeCategory?: [{	by:ValueTypes["DogBodyTypeCategoryUniqueWhere"],	data:ValueTypes["DogBodyTypeCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["Url"]],
listUrl?: [{	filter?:ValueTypes["UrlWhere"] | null,	orderBy?:ValueTypes["UrlOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Url"]],
paginateUrl?: [{	filter?:ValueTypes["UrlWhere"] | null,	orderBy?:ValueTypes["UrlOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UrlConnection"]],
validateCreateUrl?: [{	data:ValueTypes["UrlCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	data:ValueTypes["UrlUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null},ValueTypes["FooterLink"]],
listFooterLink?: [{	filter?:ValueTypes["FooterLinkWhere"] | null,	orderBy?:ValueTypes["FooterLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLink"]],
paginateFooterLink?: [{	filter?:ValueTypes["FooterLinkWhere"] | null,	orderBy?:ValueTypes["FooterLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLinkConnection"]],
validateCreateFooterLink?: [{	data:ValueTypes["FooterLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	data:ValueTypes["FooterLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getBrandsPage?: [{	by:ValueTypes["BrandsPageUniqueWhere"],	filter?:ValueTypes["BrandsPageWhere"] | null},ValueTypes["BrandsPage"]],
listBrandsPage?: [{	filter?:ValueTypes["BrandsPageWhere"] | null,	orderBy?:ValueTypes["BrandsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandsPage"]],
paginateBrandsPage?: [{	filter?:ValueTypes["BrandsPageWhere"] | null,	orderBy?:ValueTypes["BrandsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandsPageConnection"]],
validateCreateBrandsPage?: [{	data:ValueTypes["BrandsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBrandsPage?: [{	by:ValueTypes["BrandsPageUniqueWhere"],	data:ValueTypes["BrandsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
listHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePage"]],
paginateHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getIngredientsPage?: [{	by:ValueTypes["IngredientsPageUniqueWhere"],	filter?:ValueTypes["IngredientsPageWhere"] | null},ValueTypes["IngredientsPage"]],
listIngredientsPage?: [{	filter?:ValueTypes["IngredientsPageWhere"] | null,	orderBy?:ValueTypes["IngredientsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["IngredientsPage"]],
paginateIngredientsPage?: [{	filter?:ValueTypes["IngredientsPageWhere"] | null,	orderBy?:ValueTypes["IngredientsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["IngredientsPageConnection"]],
validateCreateIngredientsPage?: [{	data:ValueTypes["IngredientsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIngredientsPage?: [{	by:ValueTypes["IngredientsPageUniqueWhere"],	data:ValueTypes["IngredientsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductReview?: [{	by:ValueTypes["ProductReviewUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
listProductReview?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReview"]],
paginateProductReview?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewConnection"]],
validateCreateProductReview?: [{	data:ValueTypes["ProductReviewCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductReview?: [{	by:ValueTypes["ProductReviewUniqueWhere"],	data:ValueTypes["ProductReviewUpdateInput"]},ValueTypes["_ValidationResult"]],
getScore?: [{	by:ValueTypes["ScoreUniqueWhere"],	filter?:ValueTypes["ScoreWhere"] | null},ValueTypes["Score"]],
listScore?: [{	filter?:ValueTypes["ScoreWhere"] | null,	orderBy?:ValueTypes["ScoreOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Score"]],
paginateScore?: [{	filter?:ValueTypes["ScoreWhere"] | null,	orderBy?:ValueTypes["ScoreOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ScoreConnection"]],
validateCreateScore?: [{	data:ValueTypes["ScoreCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateScore?: [{	by:ValueTypes["ScoreUniqueWhere"],	data:ValueTypes["ScoreUpdateInput"]},ValueTypes["_ValidationResult"]],
getAge?: [{	by:ValueTypes["AgeUniqueWhere"],	filter?:ValueTypes["AgeWhere"] | null},ValueTypes["Age"]],
listAge?: [{	filter?:ValueTypes["AgeWhere"] | null,	orderBy?:ValueTypes["AgeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Age"]],
paginateAge?: [{	filter?:ValueTypes["AgeWhere"] | null,	orderBy?:ValueTypes["AgeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AgeConnection"]],
validateCreateAge?: [{	data:ValueTypes["AgeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAge?: [{	by:ValueTypes["AgeUniqueWhere"],	data:ValueTypes["AgeUpdateInput"]},ValueTypes["_ValidationResult"]],
getCountry?: [{	by:ValueTypes["CountryUniqueWhere"],	filter?:ValueTypes["CountryWhere"] | null},ValueTypes["Country"]],
listCountry?: [{	filter?:ValueTypes["CountryWhere"] | null,	orderBy?:ValueTypes["CountryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Country"]],
paginateCountry?: [{	filter?:ValueTypes["CountryWhere"] | null,	orderBy?:ValueTypes["CountryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CountryConnection"]],
validateCreateCountry?: [{	data:ValueTypes["CountryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCountry?: [{	by:ValueTypes["CountryUniqueWhere"],	data:ValueTypes["CountryUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostReview?: [{	by:ValueTypes["BlogPostReviewUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReview"]],
listBlogPostReview?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostReview"]],
paginateBlogPostReview?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostReviewConnection"]],
validateCreateBlogPostReview?: [{	data:ValueTypes["BlogPostReviewCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostReview?: [{	by:ValueTypes["BlogPostReviewUniqueWhere"],	data:ValueTypes["BlogPostReviewUpdateInput"]},ValueTypes["_ValidationResult"]],
getDogActivity?: [{	by:ValueTypes["DogActivityUniqueWhere"],	filter?:ValueTypes["DogActivityWhere"] | null},ValueTypes["DogActivity"]],
listDogActivity?: [{	filter?:ValueTypes["DogActivityWhere"] | null,	orderBy?:ValueTypes["DogActivityOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogActivity"]],
paginateDogActivity?: [{	filter?:ValueTypes["DogActivityWhere"] | null,	orderBy?:ValueTypes["DogActivityOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogActivityConnection"]],
validateCreateDogActivity?: [{	data:ValueTypes["DogActivityCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDogActivity?: [{	by:ValueTypes["DogActivityUniqueWhere"],	data:ValueTypes["DogActivityUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocial?: [{	by:ValueTypes["SocialUniqueWhere"],	filter?:ValueTypes["SocialWhere"] | null},ValueTypes["Social"]],
listSocial?: [{	filter?:ValueTypes["SocialWhere"] | null,	orderBy?:ValueTypes["SocialOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Social"]],
paginateSocial?: [{	filter?:ValueTypes["SocialWhere"] | null,	orderBy?:ValueTypes["SocialOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialConnection"]],
validateCreateSocial?: [{	data:ValueTypes["SocialCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocial?: [{	by:ValueTypes["SocialUniqueWhere"],	data:ValueTypes["SocialUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReferenceGalleryImage?: [{	by:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null},ValueTypes["ContentReferenceGalleryImage"]],
listContentReferenceGalleryImage?: [{	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null,	orderBy?:ValueTypes["ContentReferenceGalleryImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReferenceGalleryImage"]],
paginateContentReferenceGalleryImage?: [{	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null,	orderBy?:ValueTypes["ContentReferenceGalleryImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceGalleryImageConnection"]],
validateCreateContentReferenceGalleryImage?: [{	data:ValueTypes["ContentReferenceGalleryImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReferenceGalleryImage?: [{	by:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],	data:ValueTypes["ContentReferenceGalleryImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getItem?: [{	by:ValueTypes["ItemUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
listItem?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Item"]],
paginateItem?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemConnection"]],
validateCreateItem?: [{	data:ValueTypes["ItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItem?: [{	by:ValueTypes["ItemUniqueWhere"],	data:ValueTypes["ItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemSubCategory?: [{	by:ValueTypes["ItemSubCategoryUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
listItemSubCategory?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemSubCategory"]],
paginateItemSubCategory?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemSubCategoryConnection"]],
validateCreateItemSubCategory?: [{	data:ValueTypes["ItemSubCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemSubCategory?: [{	by:ValueTypes["ItemSubCategoryUniqueWhere"],	data:ValueTypes["ItemSubCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemCategory?: [{	by:ValueTypes["ItemCategoryUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
listItemCategory?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemCategory"]],
paginateItemCategory?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemCategoryConnection"]],
validateCreateItemCategory?: [{	data:ValueTypes["ItemCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemCategory?: [{	by:ValueTypes["ItemCategoryUniqueWhere"],	data:ValueTypes["ItemCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemFlavorCategory?: [{	by:ValueTypes["ItemFlavorCategoryUniqueWhere"],	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null},ValueTypes["ItemFlavorCategory"]],
listItemFlavorCategory?: [{	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null,	orderBy?:ValueTypes["ItemFlavorCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemFlavorCategory"]],
paginateItemFlavorCategory?: [{	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null,	orderBy?:ValueTypes["ItemFlavorCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemFlavorCategoryConnection"]],
validateCreateItemFlavorCategory?: [{	data:ValueTypes["ItemFlavorCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemFlavorCategory?: [{	by:ValueTypes["ItemFlavorCategoryUniqueWhere"],	data:ValueTypes["ItemFlavorCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemDeclensionFourthVariant?: [{	by:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
listItemDeclensionFourthVariant?: [{	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,	orderBy?:ValueTypes["ItemDeclensionFourthVariantOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemDeclensionFourthVariant"]],
paginateItemDeclensionFourthVariant?: [{	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,	orderBy?:ValueTypes["ItemDeclensionFourthVariantOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemDeclensionFourthVariantConnection"]],
validateCreateItemDeclensionFourthVariant?: [{	data:ValueTypes["ItemDeclensionFourthVariantCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemDeclensionFourthVariant?: [{	by:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],	data:ValueTypes["ItemDeclensionFourthVariantUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemDeclensionSeventhVariant?: [{	by:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null},ValueTypes["ItemDeclensionSeventhVariant"]],
listItemDeclensionSeventhVariant?: [{	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null,	orderBy?:ValueTypes["ItemDeclensionSeventhVariantOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemDeclensionSeventhVariant"]],
paginateItemDeclensionSeventhVariant?: [{	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null,	orderBy?:ValueTypes["ItemDeclensionSeventhVariantOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemDeclensionSeventhVariantConnection"]],
validateCreateItemDeclensionSeventhVariant?: [{	data:ValueTypes["ItemDeclensionSeventhVariantCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemDeclensionSeventhVariant?: [{	by:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"],	data:ValueTypes["ItemDeclensionSeventhVariantUpdateInput"]},ValueTypes["_ValidationResult"]],
getMediaCard?: [{	by:ValueTypes["MediaCardUniqueWhere"],	filter?:ValueTypes["MediaCardWhere"] | null},ValueTypes["MediaCard"]],
listMediaCard?: [{	filter?:ValueTypes["MediaCardWhere"] | null,	orderBy?:ValueTypes["MediaCardOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MediaCard"]],
paginateMediaCard?: [{	filter?:ValueTypes["MediaCardWhere"] | null,	orderBy?:ValueTypes["MediaCardOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediaCardConnection"]],
validateCreateMediaCard?: [{	data:ValueTypes["MediaCardCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMediaCard?: [{	by:ValueTypes["MediaCardUniqueWhere"],	data:ValueTypes["MediaCardUpdateInput"]},ValueTypes["_ValidationResult"]],
getInfoCard?: [{	by:ValueTypes["InfoCardUniqueWhere"],	filter?:ValueTypes["InfoCardWhere"] | null},ValueTypes["InfoCard"]],
listInfoCard?: [{	filter?:ValueTypes["InfoCardWhere"] | null,	orderBy?:ValueTypes["InfoCardOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["InfoCard"]],
paginateInfoCard?: [{	filter?:ValueTypes["InfoCardWhere"] | null,	orderBy?:ValueTypes["InfoCardOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["InfoCardConnection"]],
validateCreateInfoCard?: [{	data:ValueTypes["InfoCardCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInfoCard?: [{	by:ValueTypes["InfoCardUniqueWhere"],	data:ValueTypes["InfoCardUpdateInput"]},ValueTypes["_ValidationResult"]],
getNumberedCard?: [{	by:ValueTypes["NumberedCardUniqueWhere"],	filter?:ValueTypes["NumberedCardWhere"] | null},ValueTypes["NumberedCard"]],
listNumberedCard?: [{	filter?:ValueTypes["NumberedCardWhere"] | null,	orderBy?:ValueTypes["NumberedCardOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NumberedCard"]],
paginateNumberedCard?: [{	filter?:ValueTypes["NumberedCardWhere"] | null,	orderBy?:ValueTypes["NumberedCardOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NumberedCardConnection"]],
validateCreateNumberedCard?: [{	data:ValueTypes["NumberedCardCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNumberedCard?: [{	by:ValueTypes["NumberedCardUniqueWhere"],	data:ValueTypes["NumberedCardUpdateInput"]},ValueTypes["_ValidationResult"]],
getRegisterClaim?: [{	by:ValueTypes["RegisterClaimUniqueWhere"],	filter?:ValueTypes["RegisterClaimWhere"] | null},ValueTypes["RegisterClaim"]],
listRegisterClaim?: [{	filter?:ValueTypes["RegisterClaimWhere"] | null,	orderBy?:ValueTypes["RegisterClaimOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RegisterClaim"]],
paginateRegisterClaim?: [{	filter?:ValueTypes["RegisterClaimWhere"] | null,	orderBy?:ValueTypes["RegisterClaimOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RegisterClaimConnection"]],
validateCreateRegisterClaim?: [{	data:ValueTypes["RegisterClaimCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRegisterClaim?: [{	by:ValueTypes["RegisterClaimUniqueWhere"],	data:ValueTypes["RegisterClaimUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostReviewReaction?: [{	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null},ValueTypes["BlogPostReviewReaction"]],
listBlogPostReviewReaction?: [{	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewReactionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostReviewReaction"]],
paginateBlogPostReviewReaction?: [{	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewReactionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostReviewReactionConnection"]],
validateCreateBlogPostReviewReaction?: [{	data:ValueTypes["BlogPostReviewReactionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostReviewReaction?: [{	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],	data:ValueTypes["BlogPostReviewReactionUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductReviewReaction?: [{	by:ValueTypes["ProductReviewReactionUniqueWhere"],	filter?:ValueTypes["ProductReviewReactionWhere"] | null},ValueTypes["ProductReviewReaction"]],
listProductReviewReaction?: [{	filter?:ValueTypes["ProductReviewReactionWhere"] | null,	orderBy?:ValueTypes["ProductReviewReactionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReviewReaction"]],
paginateProductReviewReaction?: [{	filter?:ValueTypes["ProductReviewReactionWhere"] | null,	orderBy?:ValueTypes["ProductReviewReactionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewReactionConnection"]],
validateCreateProductReviewReaction?: [{	data:ValueTypes["ProductReviewReactionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductReviewReaction?: [{	by:ValueTypes["ProductReviewReactionUniqueWhere"],	data:ValueTypes["ProductReviewReactionUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductPackage?: [{	by:ValueTypes["ProductPackageUniqueWhere"],	filter?:ValueTypes["ProductPackageWhere"] | null},ValueTypes["ProductPackage"]],
listProductPackage?: [{	filter?:ValueTypes["ProductPackageWhere"] | null,	orderBy?:ValueTypes["ProductPackageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductPackage"]],
paginateProductPackage?: [{	filter?:ValueTypes["ProductPackageWhere"] | null,	orderBy?:ValueTypes["ProductPackageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductPackageConnection"]],
validateCreateProductPackage?: [{	data:ValueTypes["ProductPackageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductPackage?: [{	by:ValueTypes["ProductPackageUniqueWhere"],	data:ValueTypes["ProductPackageUpdateInput"]},ValueTypes["_ValidationResult"]],
getBrandManufacturer?: [{	by:ValueTypes["BrandManufacturerUniqueWhere"],	filter?:ValueTypes["BrandManufacturerWhere"] | null},ValueTypes["BrandManufacturer"]],
listBrandManufacturer?: [{	filter?:ValueTypes["BrandManufacturerWhere"] | null,	orderBy?:ValueTypes["BrandManufacturerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandManufacturer"]],
paginateBrandManufacturer?: [{	filter?:ValueTypes["BrandManufacturerWhere"] | null,	orderBy?:ValueTypes["BrandManufacturerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandManufacturerConnection"]],
validateCreateBrandManufacturer?: [{	data:ValueTypes["BrandManufacturerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBrandManufacturer?: [{	by:ValueTypes["BrandManufacturerUniqueWhere"],	data:ValueTypes["BrandManufacturerUpdateInput"]},ValueTypes["_ValidationResult"]],
getElement?: [{	by:ValueTypes["ElementUniqueWhere"],	filter?:ValueTypes["ElementWhere"] | null},ValueTypes["Element"]],
listElement?: [{	filter?:ValueTypes["ElementWhere"] | null,	orderBy?:ValueTypes["ElementOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Element"]],
paginateElement?: [{	filter?:ValueTypes["ElementWhere"] | null,	orderBy?:ValueTypes["ElementOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ElementConnection"]],
validateCreateElement?: [{	data:ValueTypes["ElementCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateElement?: [{	by:ValueTypes["ElementUniqueWhere"],	data:ValueTypes["ElementUpdateInput"]},ValueTypes["_ValidationResult"]],
getElementOfProduct?: [{	by:ValueTypes["ElementOfProductUniqueWhere"],	filter?:ValueTypes["ElementOfProductWhere"] | null},ValueTypes["ElementOfProduct"]],
listElementOfProduct?: [{	filter?:ValueTypes["ElementOfProductWhere"] | null,	orderBy?:ValueTypes["ElementOfProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ElementOfProduct"]],
paginateElementOfProduct?: [{	filter?:ValueTypes["ElementOfProductWhere"] | null,	orderBy?:ValueTypes["ElementOfProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ElementOfProductConnection"]],
validateCreateElementOfProduct?: [{	data:ValueTypes["ElementOfProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateElementOfProduct?: [{	by:ValueTypes["ElementOfProductUniqueWhere"],	data:ValueTypes["ElementOfProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getSuitabilityCategory?: [{	by:ValueTypes["SuitabilityCategoryUniqueWhere"],	filter?:ValueTypes["SuitabilityCategoryWhere"] | null},ValueTypes["SuitabilityCategory"]],
listSuitabilityCategory?: [{	filter?:ValueTypes["SuitabilityCategoryWhere"] | null,	orderBy?:ValueTypes["SuitabilityCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SuitabilityCategory"]],
paginateSuitabilityCategory?: [{	filter?:ValueTypes["SuitabilityCategoryWhere"] | null,	orderBy?:ValueTypes["SuitabilityCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SuitabilityCategoryConnection"]],
validateCreateSuitabilityCategory?: [{	data:ValueTypes["SuitabilityCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSuitabilityCategory?: [{	by:ValueTypes["SuitabilityCategoryUniqueWhere"],	data:ValueTypes["SuitabilityCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductFeature?: [{	by:ValueTypes["ProductFeatureUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null},ValueTypes["ProductFeature"]],
listProductFeature?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFeature"]],
paginateProductFeature?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFeatureConnection"]],
validateCreateProductFeature?: [{	data:ValueTypes["ProductFeatureCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductFeature?: [{	by:ValueTypes["ProductFeatureUniqueWhere"],	data:ValueTypes["ProductFeatureUpdateInput"]},ValueTypes["_ValidationResult"]],
getSuitabilityItem?: [{	by:ValueTypes["SuitabilityItemUniqueWhere"],	filter?:ValueTypes["SuitabilityItemWhere"] | null},ValueTypes["SuitabilityItem"]],
listSuitabilityItem?: [{	filter?:ValueTypes["SuitabilityItemWhere"] | null,	orderBy?:ValueTypes["SuitabilityItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SuitabilityItem"]],
paginateSuitabilityItem?: [{	filter?:ValueTypes["SuitabilityItemWhere"] | null,	orderBy?:ValueTypes["SuitabilityItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SuitabilityItemConnection"]],
validateCreateSuitabilityItem?: [{	data:ValueTypes["SuitabilityItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSuitabilityItem?: [{	by:ValueTypes["SuitabilityItemUniqueWhere"],	data:ValueTypes["SuitabilityItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getRegion?: [{	by:ValueTypes["RegionUniqueWhere"],	filter?:ValueTypes["RegionWhere"] | null},ValueTypes["Region"]],
listRegion?: [{	filter?:ValueTypes["RegionWhere"] | null,	orderBy?:ValueTypes["RegionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Region"]],
paginateRegion?: [{	filter?:ValueTypes["RegionWhere"] | null,	orderBy?:ValueTypes["RegionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RegionConnection"]],
validateCreateRegion?: [{	data:ValueTypes["RegionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRegion?: [{	by:ValueTypes["RegionUniqueWhere"],	data:ValueTypes["RegionUpdateInput"]},ValueTypes["_ValidationResult"]],
getGranuleSize?: [{	by:ValueTypes["GranuleSizeUniqueWhere"],	filter?:ValueTypes["GranuleSizeWhere"] | null},ValueTypes["GranuleSize"]],
listGranuleSize?: [{	filter?:ValueTypes["GranuleSizeWhere"] | null,	orderBy?:ValueTypes["GranuleSizeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GranuleSize"]],
paginateGranuleSize?: [{	filter?:ValueTypes["GranuleSizeWhere"] | null,	orderBy?:ValueTypes["GranuleSizeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GranuleSizeConnection"]],
validateCreateGranuleSize?: [{	data:ValueTypes["GranuleSizeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGranuleSize?: [{	by:ValueTypes["GranuleSizeUniqueWhere"],	data:ValueTypes["GranuleSizeUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemAlias?: [{	by:ValueTypes["ItemAliasUniqueWhere"],	filter?:ValueTypes["ItemAliasWhere"] | null},ValueTypes["ItemAlias"]],
listItemAlias?: [{	filter?:ValueTypes["ItemAliasWhere"] | null,	orderBy?:ValueTypes["ItemAliasOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemAlias"]],
paginateItemAlias?: [{	filter?:ValueTypes["ItemAliasWhere"] | null,	orderBy?:ValueTypes["ItemAliasOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemAliasConnection"]],
validateCreateItemAlias?: [{	data:ValueTypes["ItemAliasCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemAlias?: [{	by:ValueTypes["ItemAliasUniqueWhere"],	data:ValueTypes["ItemAliasUpdateInput"]},ValueTypes["_ValidationResult"]],
getSemanticKey?: [{	by:ValueTypes["SemanticKeyUniqueWhere"],	filter?:ValueTypes["SemanticKeyWhere"] | null},ValueTypes["SemanticKey"]],
listSemanticKey?: [{	filter?:ValueTypes["SemanticKeyWhere"] | null,	orderBy?:ValueTypes["SemanticKeyOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SemanticKey"]],
paginateSemanticKey?: [{	filter?:ValueTypes["SemanticKeyWhere"] | null,	orderBy?:ValueTypes["SemanticKeyOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SemanticKeyConnection"]],
validateCreateSemanticKey?: [{	data:ValueTypes["SemanticKeyCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSemanticKey?: [{	by:ValueTypes["SemanticKeyUniqueWhere"],	data:ValueTypes["SemanticKeyUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductFlag?: [{	by:ValueTypes["ProductFlagUniqueWhere"],	filter?:ValueTypes["ProductFlagWhere"] | null},ValueTypes["ProductFlag"]],
listProductFlag?: [{	filter?:ValueTypes["ProductFlagWhere"] | null,	orderBy?:ValueTypes["ProductFlagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFlag"]],
paginateProductFlag?: [{	filter?:ValueTypes["ProductFlagWhere"] | null,	orderBy?:ValueTypes["ProductFlagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFlagConnection"]],
validateCreateProductFlag?: [{	data:ValueTypes["ProductFlagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductFlag?: [{	by:ValueTypes["ProductFlagUniqueWhere"],	data:ValueTypes["ProductFlagUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductFlagOfProduct?: [{	by:ValueTypes["ProductFlagOfProductUniqueWhere"],	filter?:ValueTypes["ProductFlagOfProductWhere"] | null},ValueTypes["ProductFlagOfProduct"]],
listProductFlagOfProduct?: [{	filter?:ValueTypes["ProductFlagOfProductWhere"] | null,	orderBy?:ValueTypes["ProductFlagOfProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFlagOfProduct"]],
paginateProductFlagOfProduct?: [{	filter?:ValueTypes["ProductFlagOfProductWhere"] | null,	orderBy?:ValueTypes["ProductFlagOfProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFlagOfProductConnection"]],
validateCreateProductFlagOfProduct?: [{	data:ValueTypes["ProductFlagOfProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductFlagOfProduct?: [{	by:ValueTypes["ProductFlagOfProductUniqueWhere"],	data:ValueTypes["ProductFlagOfProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductEvaluation?: [{	by:ValueTypes["ProductEvaluationUniqueWhere"],	filter?:ValueTypes["ProductEvaluationWhere"] | null},ValueTypes["ProductEvaluation"]],
listProductEvaluation?: [{	filter?:ValueTypes["ProductEvaluationWhere"] | null,	orderBy?:ValueTypes["ProductEvaluationOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductEvaluation"]],
paginateProductEvaluation?: [{	filter?:ValueTypes["ProductEvaluationWhere"] | null,	orderBy?:ValueTypes["ProductEvaluationOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductEvaluationConnection"]],
validateCreateProductEvaluation?: [{	data:ValueTypes["ProductEvaluationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductEvaluation?: [{	by:ValueTypes["ProductEvaluationUniqueWhere"],	data:ValueTypes["ProductEvaluationUpdateInput"]},ValueTypes["_ValidationResult"]],
getAd?: [{	by:ValueTypes["AdUniqueWhere"],	filter?:ValueTypes["AdWhere"] | null},ValueTypes["Ad"]],
listAd?: [{	filter?:ValueTypes["AdWhere"] | null,	orderBy?:ValueTypes["AdOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Ad"]],
paginateAd?: [{	filter?:ValueTypes["AdWhere"] | null,	orderBy?:ValueTypes["AdOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AdConnection"]],
validateCreateAd?: [{	data:ValueTypes["AdCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAd?: [{	by:ValueTypes["AdUniqueWhere"],	data:ValueTypes["AdUpdateInput"]},ValueTypes["_ValidationResult"]],
getEvaluationInfo?: [{	by:ValueTypes["EvaluationInfoUniqueWhere"],	filter?:ValueTypes["EvaluationInfoWhere"] | null},ValueTypes["EvaluationInfo"]],
listEvaluationInfo?: [{	filter?:ValueTypes["EvaluationInfoWhere"] | null,	orderBy?:ValueTypes["EvaluationInfoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EvaluationInfo"]],
paginateEvaluationInfo?: [{	filter?:ValueTypes["EvaluationInfoWhere"] | null,	orderBy?:ValueTypes["EvaluationInfoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EvaluationInfoConnection"]],
validateCreateEvaluationInfo?: [{	data:ValueTypes["EvaluationInfoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEvaluationInfo?: [{	by:ValueTypes["EvaluationInfoUniqueWhere"],	data:ValueTypes["EvaluationInfoUpdateInput"]},ValueTypes["_ValidationResult"]],
getConsumptionMessage?: [{	by:ValueTypes["ConsumptionMessageUniqueWhere"],	filter?:ValueTypes["ConsumptionMessageWhere"] | null},ValueTypes["ConsumptionMessage"]],
listConsumptionMessage?: [{	filter?:ValueTypes["ConsumptionMessageWhere"] | null,	orderBy?:ValueTypes["ConsumptionMessageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ConsumptionMessage"]],
paginateConsumptionMessage?: [{	filter?:ValueTypes["ConsumptionMessageWhere"] | null,	orderBy?:ValueTypes["ConsumptionMessageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ConsumptionMessageConnection"]],
validateCreateConsumptionMessage?: [{	data:ValueTypes["ConsumptionMessageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateConsumptionMessage?: [{	by:ValueTypes["ConsumptionMessageUniqueWhere"],	data:ValueTypes["ConsumptionMessageUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentText?: [{	by:ValueTypes["ContentTextUniqueWhere"],	filter?:ValueTypes["ContentTextWhere"] | null},ValueTypes["ContentText"]],
listContentText?: [{	filter?:ValueTypes["ContentTextWhere"] | null,	orderBy?:ValueTypes["ContentTextOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentText"]],
paginateContentText?: [{	filter?:ValueTypes["ContentTextWhere"] | null,	orderBy?:ValueTypes["ContentTextOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentTextConnection"]],
validateCreateContentText?: [{	data:ValueTypes["ContentTextCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentText?: [{	by:ValueTypes["ContentTextUniqueWhere"],	data:ValueTypes["ContentTextUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentTextBlock?: [{	by:ValueTypes["ContentTextBlockUniqueWhere"],	filter?:ValueTypes["ContentTextBlockWhere"] | null},ValueTypes["ContentTextBlock"]],
listContentTextBlock?: [{	filter?:ValueTypes["ContentTextBlockWhere"] | null,	orderBy?:ValueTypes["ContentTextBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentTextBlock"]],
paginateContentTextBlock?: [{	filter?:ValueTypes["ContentTextBlockWhere"] | null,	orderBy?:ValueTypes["ContentTextBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentTextBlockConnection"]],
validateCreateContentTextBlock?: [{	data:ValueTypes["ContentTextBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentTextBlock?: [{	by:ValueTypes["ContentTextBlockUniqueWhere"],	data:ValueTypes["ContentTextBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductReviewStats?: [{	by:ValueTypes["ProductReviewStatsUniqueWhere"],	filter?:ValueTypes["ProductReviewStatsWhere"] | null},ValueTypes["ProductReviewStats"]],
listProductReviewStats?: [{	filter?:ValueTypes["ProductReviewStatsWhere"] | null,	orderBy?:ValueTypes["ProductReviewStatsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReviewStats"]],
paginateProductReviewStats?: [{	filter?:ValueTypes["ProductReviewStatsWhere"] | null,	orderBy?:ValueTypes["ProductReviewStatsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewStatsConnection"]],
getBlogPostReviewStats?: [{	by:ValueTypes["BlogPostReviewStatsUniqueWhere"],	filter?:ValueTypes["BlogPostReviewStatsWhere"] | null},ValueTypes["BlogPostReviewStats"]],
listBlogPostReviewStats?: [{	filter?:ValueTypes["BlogPostReviewStatsWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewStatsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostReviewStats"]],
paginateBlogPostReviewStats?: [{	filter?:ValueTypes["BlogPostReviewStatsWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewStatsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostReviewStatsConnection"]],
getComparatorPage?: [{	by:ValueTypes["ComparatorPageUniqueWhere"],	filter?:ValueTypes["ComparatorPageWhere"] | null},ValueTypes["ComparatorPage"]],
listComparatorPage?: [{	filter?:ValueTypes["ComparatorPageWhere"] | null,	orderBy?:ValueTypes["ComparatorPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ComparatorPage"]],
paginateComparatorPage?: [{	filter?:ValueTypes["ComparatorPageWhere"] | null,	orderBy?:ValueTypes["ComparatorPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ComparatorPageConnection"]],
validateCreateComparatorPage?: [{	data:ValueTypes["ComparatorPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateComparatorPage?: [{	by:ValueTypes["ComparatorPageUniqueWhere"],	data:ValueTypes["ComparatorPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLoginPage?: [{	by:ValueTypes["LoginPageUniqueWhere"],	filter?:ValueTypes["LoginPageWhere"] | null},ValueTypes["LoginPage"]],
listLoginPage?: [{	filter?:ValueTypes["LoginPageWhere"] | null,	orderBy?:ValueTypes["LoginPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LoginPage"]],
paginateLoginPage?: [{	filter?:ValueTypes["LoginPageWhere"] | null,	orderBy?:ValueTypes["LoginPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LoginPageConnection"]],
validateCreateLoginPage?: [{	data:ValueTypes["LoginPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLoginPage?: [{	by:ValueTypes["LoginPageUniqueWhere"],	data:ValueTypes["LoginPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getRegisterPage?: [{	by:ValueTypes["RegisterPageUniqueWhere"],	filter?:ValueTypes["RegisterPageWhere"] | null},ValueTypes["RegisterPage"]],
listRegisterPage?: [{	filter?:ValueTypes["RegisterPageWhere"] | null,	orderBy?:ValueTypes["RegisterPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RegisterPage"]],
paginateRegisterPage?: [{	filter?:ValueTypes["RegisterPageWhere"] | null,	orderBy?:ValueTypes["RegisterPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RegisterPageConnection"]],
validateCreateRegisterPage?: [{	data:ValueTypes["RegisterPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRegisterPage?: [{	by:ValueTypes["RegisterPageUniqueWhere"],	data:ValueTypes["RegisterPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getResultsPage?: [{	by:ValueTypes["ResultsPageUniqueWhere"],	filter?:ValueTypes["ResultsPageWhere"] | null},ValueTypes["ResultsPage"]],
listResultsPage?: [{	filter?:ValueTypes["ResultsPageWhere"] | null,	orderBy?:ValueTypes["ResultsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ResultsPage"]],
paginateResultsPage?: [{	filter?:ValueTypes["ResultsPageWhere"] | null,	orderBy?:ValueTypes["ResultsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ResultsPageConnection"]],
validateCreateResultsPage?: [{	data:ValueTypes["ResultsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateResultsPage?: [{	by:ValueTypes["ResultsPageUniqueWhere"],	data:ValueTypes["ResultsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getSearchPage?: [{	by:ValueTypes["SearchPageUniqueWhere"],	filter?:ValueTypes["SearchPageWhere"] | null},ValueTypes["SearchPage"]],
listSearchPage?: [{	filter?:ValueTypes["SearchPageWhere"] | null,	orderBy?:ValueTypes["SearchPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SearchPage"]],
paginateSearchPage?: [{	filter?:ValueTypes["SearchPageWhere"] | null,	orderBy?:ValueTypes["SearchPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SearchPageConnection"]],
validateCreateSearchPage?: [{	data:ValueTypes["SearchPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSearchPage?: [{	by:ValueTypes["SearchPageUniqueWhere"],	data:ValueTypes["SearchPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getWizardPage?: [{	by:ValueTypes["WizardPageUniqueWhere"],	filter?:ValueTypes["WizardPageWhere"] | null},ValueTypes["WizardPage"]],
listWizardPage?: [{	filter?:ValueTypes["WizardPageWhere"] | null,	orderBy?:ValueTypes["WizardPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["WizardPage"]],
paginateWizardPage?: [{	filter?:ValueTypes["WizardPageWhere"] | null,	orderBy?:ValueTypes["WizardPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["WizardPageConnection"]],
validateCreateWizardPage?: [{	data:ValueTypes["WizardPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateWizardPage?: [{	by:ValueTypes["WizardPageUniqueWhere"],	data:ValueTypes["WizardPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getBreastfeedingCategory?: [{	by:ValueTypes["BreastfeedingCategoryUniqueWhere"],	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null},ValueTypes["BreastfeedingCategory"]],
listBreastfeedingCategory?: [{	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null,	orderBy?:ValueTypes["BreastfeedingCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BreastfeedingCategory"]],
paginateBreastfeedingCategory?: [{	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null,	orderBy?:ValueTypes["BreastfeedingCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BreastfeedingCategoryConnection"]],
validateCreateBreastfeedingCategory?: [{	data:ValueTypes["BreastfeedingCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBreastfeedingCategory?: [{	by:ValueTypes["BreastfeedingCategoryUniqueWhere"],	data:ValueTypes["BreastfeedingCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getDogReproduction?: [{	by:ValueTypes["DogReproductionUniqueWhere"],	filter?:ValueTypes["DogReproductionWhere"] | null},ValueTypes["DogReproduction"]],
listDogReproduction?: [{	filter?:ValueTypes["DogReproductionWhere"] | null,	orderBy?:ValueTypes["DogReproductionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogReproduction"]],
paginateDogReproduction?: [{	filter?:ValueTypes["DogReproductionWhere"] | null,	orderBy?:ValueTypes["DogReproductionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogReproductionConnection"]],
validateCreateDogReproduction?: [{	data:ValueTypes["DogReproductionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDogReproduction?: [{	by:ValueTypes["DogReproductionUniqueWhere"],	data:ValueTypes["DogReproductionUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactFormMessage?: [{	by:ValueTypes["ContactFormMessageUniqueWhere"],	filter?:ValueTypes["ContactFormMessageWhere"] | null},ValueTypes["ContactFormMessage"]],
listContactFormMessage?: [{	filter?:ValueTypes["ContactFormMessageWhere"] | null,	orderBy?:ValueTypes["ContactFormMessageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactFormMessage"]],
paginateContactFormMessage?: [{	filter?:ValueTypes["ContactFormMessageWhere"] | null,	orderBy?:ValueTypes["ContactFormMessageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactFormMessageConnection"]],
validateCreateContactFormMessage?: [{	data:ValueTypes["ContactFormMessageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactFormMessage?: [{	by:ValueTypes["ContactFormMessageUniqueWhere"],	data:ValueTypes["ContactFormMessageUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null},ValueTypes["ContactPage"]],
listContactPage?: [{	filter?:ValueTypes["ContactPageWhere"] | null,	orderBy?:ValueTypes["ContactPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactPage"]],
paginateContactPage?: [{	filter?:ValueTypes["ContactPageWhere"] | null,	orderBy?:ValueTypes["ContactPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactPageConnection"]],
validateCreateContactPage?: [{	data:ValueTypes["ContactPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	data:ValueTypes["ContactPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getBugReport?: [{	by:ValueTypes["BugReportUniqueWhere"],	filter?:ValueTypes["BugReportWhere"] | null},ValueTypes["BugReport"]],
listBugReport?: [{	filter?:ValueTypes["BugReportWhere"] | null,	orderBy?:ValueTypes["BugReportOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BugReport"]],
paginateBugReport?: [{	filter?:ValueTypes["BugReportWhere"] | null,	orderBy?:ValueTypes["BugReportOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BugReportConnection"]],
validateCreateBugReport?: [{	data:ValueTypes["BugReportCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBugReport?: [{	by:ValueTypes["BugReportUniqueWhere"],	data:ValueTypes["BugReportUpdateInput"]},ValueTypes["_ValidationResult"]],
getColor?: [{	by:ValueTypes["ColorUniqueWhere"],	filter?:ValueTypes["ColorWhere"] | null},ValueTypes["Color"]],
listColor?: [{	filter?:ValueTypes["ColorWhere"] | null,	orderBy?:ValueTypes["ColorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Color"]],
paginateColor?: [{	filter?:ValueTypes["ColorWhere"] | null,	orderBy?:ValueTypes["ColorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ColorConnection"]],
validateCreateColor?: [{	data:ValueTypes["ColorCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateColor?: [{	by:ValueTypes["ColorUniqueWhere"],	data:ValueTypes["ColorUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemGroup?: [{	by:ValueTypes["ItemGroupUniqueWhere"],	filter?:ValueTypes["ItemGroupWhere"] | null},ValueTypes["ItemGroup"]],
listItemGroup?: [{	filter?:ValueTypes["ItemGroupWhere"] | null,	orderBy?:ValueTypes["ItemGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemGroup"]],
paginateItemGroup?: [{	filter?:ValueTypes["ItemGroupWhere"] | null,	orderBy?:ValueTypes["ItemGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemGroupConnection"]],
validateCreateItemGroup?: [{	data:ValueTypes["ItemGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemGroup?: [{	by:ValueTypes["ItemGroupUniqueWhere"],	data:ValueTypes["ItemGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getSearchResult?: [{	by:ValueTypes["SearchResultUniqueWhere"],	filter?:ValueTypes["SearchResultWhere"] | null},ValueTypes["SearchResult"]],
listSearchResult?: [{	filter?:ValueTypes["SearchResultWhere"] | null,	orderBy?:ValueTypes["SearchResultOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SearchResult"]],
paginateSearchResult?: [{	filter?:ValueTypes["SearchResultWhere"] | null,	orderBy?:ValueTypes["SearchResultOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SearchResultConnection"]],
getProductEvaluationSummary?: [{	by:ValueTypes["ProductEvaluationSummaryUniqueWhere"],	filter?:ValueTypes["ProductEvaluationSummaryWhere"] | null},ValueTypes["ProductEvaluationSummary"]],
listProductEvaluationSummary?: [{	filter?:ValueTypes["ProductEvaluationSummaryWhere"] | null,	orderBy?:ValueTypes["ProductEvaluationSummaryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductEvaluationSummary"]],
paginateProductEvaluationSummary?: [{	filter?:ValueTypes["ProductEvaluationSummaryWhere"] | null,	orderBy?:ValueTypes["ProductEvaluationSummaryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductEvaluationSummaryConnection"]],
validateCreateProductEvaluationSummary?: [{	data:ValueTypes["ProductEvaluationSummaryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductEvaluationSummary?: [{	by:ValueTypes["ProductEvaluationSummaryUniqueWhere"],	data:ValueTypes["ProductEvaluationSummaryUpdateInput"]},ValueTypes["_ValidationResult"]],
getProtectedAction?: [{	by:ValueTypes["ProtectedActionUniqueWhere"],	filter?:ValueTypes["ProtectedActionWhere"] | null},ValueTypes["ProtectedAction"]],
listProtectedAction?: [{	filter?:ValueTypes["ProtectedActionWhere"] | null,	orderBy?:ValueTypes["ProtectedActionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProtectedAction"]],
paginateProtectedAction?: [{	filter?:ValueTypes["ProtectedActionWhere"] | null,	orderBy?:ValueTypes["ProtectedActionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProtectedActionConnection"]],
validateCreateProtectedAction?: [{	data:ValueTypes["ProtectedActionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProtectedAction?: [{	by:ValueTypes["ProtectedActionUniqueWhere"],	data:ValueTypes["ProtectedActionUpdateInput"]},ValueTypes["_ValidationResult"]],
getBrandAlias?: [{	by:ValueTypes["BrandAliasUniqueWhere"],	filter?:ValueTypes["BrandAliasWhere"] | null},ValueTypes["BrandAlias"]],
listBrandAlias?: [{	filter?:ValueTypes["BrandAliasWhere"] | null,	orderBy?:ValueTypes["BrandAliasOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandAlias"]],
paginateBrandAlias?: [{	filter?:ValueTypes["BrandAliasWhere"] | null,	orderBy?:ValueTypes["BrandAliasOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandAliasConnection"]],
validateCreateBrandAlias?: [{	data:ValueTypes["BrandAliasCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBrandAlias?: [{	by:ValueTypes["BrandAliasUniqueWhere"],	data:ValueTypes["BrandAliasUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductAlias?: [{	by:ValueTypes["ProductAliasUniqueWhere"],	filter?:ValueTypes["ProductAliasWhere"] | null},ValueTypes["ProductAlias"]],
listProductAlias?: [{	filter?:ValueTypes["ProductAliasWhere"] | null,	orderBy?:ValueTypes["ProductAliasOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductAlias"]],
paginateProductAlias?: [{	filter?:ValueTypes["ProductAliasWhere"] | null,	orderBy?:ValueTypes["ProductAliasOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductAliasConnection"]],
validateCreateProductAlias?: [{	data:ValueTypes["ProductAliasCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductAlias?: [{	by:ValueTypes["ProductAliasUniqueWhere"],	data:ValueTypes["ProductAliasUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductLineAlias?: [{	by:ValueTypes["ProductLineAliasUniqueWhere"],	filter?:ValueTypes["ProductLineAliasWhere"] | null},ValueTypes["ProductLineAlias"]],
listProductLineAlias?: [{	filter?:ValueTypes["ProductLineAliasWhere"] | null,	orderBy?:ValueTypes["ProductLineAliasOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductLineAlias"]],
paginateProductLineAlias?: [{	filter?:ValueTypes["ProductLineAliasWhere"] | null,	orderBy?:ValueTypes["ProductLineAliasOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductLineAliasConnection"]],
validateCreateProductLineAlias?: [{	data:ValueTypes["ProductLineAliasCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductLineAlias?: [{	by:ValueTypes["ProductLineAliasUniqueWhere"],	data:ValueTypes["ProductLineAliasUpdateInput"]},ValueTypes["_ValidationResult"]],
getGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null},ValueTypes["GenericPage"]],
listGenericPage?: [{	filter?:ValueTypes["GenericPageWhere"] | null,	orderBy?:ValueTypes["GenericPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GenericPage"]],
paginateGenericPage?: [{	filter?:ValueTypes["GenericPageWhere"] | null,	orderBy?:ValueTypes["GenericPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GenericPageConnection"]],
validateCreateGenericPage?: [{	data:ValueTypes["GenericPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	data:ValueTypes["GenericPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentLinks?: [{	by:ValueTypes["ContentLinksUniqueWhere"],	filter?:ValueTypes["ContentLinksWhere"] | null},ValueTypes["ContentLinks"]],
listContentLinks?: [{	filter?:ValueTypes["ContentLinksWhere"] | null,	orderBy?:ValueTypes["ContentLinksOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentLinks"]],
paginateContentLinks?: [{	filter?:ValueTypes["ContentLinksWhere"] | null,	orderBy?:ValueTypes["ContentLinksOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentLinksConnection"]],
validateCreateContentLinks?: [{	data:ValueTypes["ContentLinksCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentLinks?: [{	by:ValueTypes["ContentLinksUniqueWhere"],	data:ValueTypes["ContentLinksUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentLinksItem?: [{	by:ValueTypes["ContentLinksItemUniqueWhere"],	filter?:ValueTypes["ContentLinksItemWhere"] | null},ValueTypes["ContentLinksItem"]],
listContentLinksItem?: [{	filter?:ValueTypes["ContentLinksItemWhere"] | null,	orderBy?:ValueTypes["ContentLinksItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentLinksItem"]],
paginateContentLinksItem?: [{	filter?:ValueTypes["ContentLinksItemWhere"] | null,	orderBy?:ValueTypes["ContentLinksItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentLinksItemConnection"]],
validateCreateContentLinksItem?: [{	data:ValueTypes["ContentLinksItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentLinksItem?: [{	by:ValueTypes["ContentLinksItemUniqueWhere"],	data:ValueTypes["ContentLinksItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReferenceImage?: [{	by:ValueTypes["ContentReferenceImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceImageWhere"] | null},ValueTypes["ContentReferenceImage"]],
listContentReferenceImage?: [{	filter?:ValueTypes["ContentReferenceImageWhere"] | null,	orderBy?:ValueTypes["ContentReferenceImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReferenceImage"]],
paginateContentReferenceImage?: [{	filter?:ValueTypes["ContentReferenceImageWhere"] | null,	orderBy?:ValueTypes["ContentReferenceImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceImageConnection"]],
validateCreateContentReferenceImage?: [{	data:ValueTypes["ContentReferenceImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReferenceImage?: [{	by:ValueTypes["ContentReferenceImageUniqueWhere"],	data:ValueTypes["ContentReferenceImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeoData?: [{	by:ValueTypes["SeoDataUniqueWhere"],	filter?:ValueTypes["SeoDataWhere"] | null},ValueTypes["SeoData"]],
listSeoData?: [{	filter?:ValueTypes["SeoDataWhere"] | null,	orderBy?:ValueTypes["SeoDataOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SeoData"]],
paginateSeoData?: [{	filter?:ValueTypes["SeoDataWhere"] | null,	orderBy?:ValueTypes["SeoDataOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoDataConnection"]],
validateCreateSeoData?: [{	data:ValueTypes["SeoDataCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeoData?: [{	by:ValueTypes["SeoDataUniqueWhere"],	data:ValueTypes["SeoDataUpdateInput"]},ValueTypes["_ValidationResult"]],
getTenantPerson?: [{	by:ValueTypes["TenantPersonUniqueWhere"],	filter?:ValueTypes["TenantPersonWhere"] | null},ValueTypes["TenantPerson"]],
listTenantPerson?: [{	filter?:ValueTypes["TenantPersonWhere"] | null,	orderBy?:ValueTypes["TenantPersonOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TenantPerson"]],
paginateTenantPerson?: [{	filter?:ValueTypes["TenantPersonWhere"] | null,	orderBy?:ValueTypes["TenantPersonOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TenantPersonConnection"]],
getBrandFlavor?: [{	by:ValueTypes["BrandFlavorUniqueWhere"],	filter?:ValueTypes["BrandFlavorWhere"] | null},ValueTypes["BrandFlavor"]],
listBrandFlavor?: [{	filter?:ValueTypes["BrandFlavorWhere"] | null,	orderBy?:ValueTypes["BrandFlavorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandFlavor"]],
paginateBrandFlavor?: [{	filter?:ValueTypes["BrandFlavorWhere"] | null,	orderBy?:ValueTypes["BrandFlavorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandFlavorConnection"]],
getProductLineFlavor?: [{	by:ValueTypes["ProductLineFlavorUniqueWhere"],	filter?:ValueTypes["ProductLineFlavorWhere"] | null},ValueTypes["ProductLineFlavor"]],
listProductLineFlavor?: [{	filter?:ValueTypes["ProductLineFlavorWhere"] | null,	orderBy?:ValueTypes["ProductLineFlavorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductLineFlavor"]],
paginateProductLineFlavor?: [{	filter?:ValueTypes["ProductLineFlavorWhere"] | null,	orderBy?:ValueTypes["ProductLineFlavorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductLineFlavorConnection"]],
getProductItemDeclensionFourthCategory?: [{	by:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"],	filter?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null},ValueTypes["ProductItemDeclensionFourthCategory"]],
listProductItemDeclensionFourthCategory?: [{	filter?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null,	orderBy?:ValueTypes["ProductItemDeclensionFourthCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductItemDeclensionFourthCategory"]],
paginateProductItemDeclensionFourthCategory?: [{	filter?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null,	orderBy?:ValueTypes["ProductItemDeclensionFourthCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductItemDeclensionFourthCategoryConnection"]],
getAgeCategory?: [{	by:ValueTypes["AgeCategoryUniqueWhere"],	filter?:ValueTypes["AgeCategoryWhere"] | null},ValueTypes["AgeCategory"]],
listAgeCategory?: [{	filter?:ValueTypes["AgeCategoryWhere"] | null,	orderBy?:ValueTypes["AgeCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AgeCategory"]],
paginateAgeCategory?: [{	filter?:ValueTypes["AgeCategoryWhere"] | null,	orderBy?:ValueTypes["AgeCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AgeCategoryConnection"]],
validateCreateAgeCategory?: [{	data:ValueTypes["AgeCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAgeCategory?: [{	by:ValueTypes["AgeCategoryUniqueWhere"],	data:ValueTypes["AgeCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getFilterCombo?: [{	by:ValueTypes["FilterComboUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
listFilterCombo?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FilterCombo"]],
paginateFilterCombo?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilterComboConnection"]],
validateCreateFilterCombo?: [{	data:ValueTypes["FilterComboCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFilterCombo?: [{	by:ValueTypes["FilterComboUniqueWhere"],	data:ValueTypes["FilterComboUpdateInput"]},ValueTypes["_ValidationResult"]],
getImportCache?: [{	by:ValueTypes["ImportCacheUniqueWhere"],	filter?:ValueTypes["ImportCacheWhere"] | null},ValueTypes["ImportCache"]],
listImportCache?: [{	filter?:ValueTypes["ImportCacheWhere"] | null,	orderBy?:ValueTypes["ImportCacheOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImportCache"]],
paginateImportCache?: [{	filter?:ValueTypes["ImportCacheWhere"] | null,	orderBy?:ValueTypes["ImportCacheOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImportCacheConnection"]],
validateCreateImportCache?: [{	data:ValueTypes["ImportCacheCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImportCache?: [{	by:ValueTypes["ImportCacheUniqueWhere"],	data:ValueTypes["ImportCacheUpdateInput"]},ValueTypes["_ValidationResult"]],
getSite?: [{	by:ValueTypes["SiteUniqueWhere"],	filter?:ValueTypes["SiteWhere"] | null},ValueTypes["Site"]],
listSite?: [{	filter?:ValueTypes["SiteWhere"] | null,	orderBy?:ValueTypes["SiteOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Site"]],
paginateSite?: [{	filter?:ValueTypes["SiteWhere"] | null,	orderBy?:ValueTypes["SiteOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SiteConnection"]],
validateCreateSite?: [{	data:ValueTypes["SiteCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSite?: [{	by:ValueTypes["SiteUniqueWhere"],	data:ValueTypes["SiteUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactSubmission?: [{	by:ValueTypes["ContactSubmissionUniqueWhere"],	filter?:ValueTypes["ContactSubmissionWhere"] | null},ValueTypes["ContactSubmission"]],
listContactSubmission?: [{	filter?:ValueTypes["ContactSubmissionWhere"] | null,	orderBy?:ValueTypes["ContactSubmissionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactSubmission"]],
paginateContactSubmission?: [{	filter?:ValueTypes["ContactSubmissionWhere"] | null,	orderBy?:ValueTypes["ContactSubmissionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactSubmissionConnection"]],
validateCreateContactSubmission?: [{	data:ValueTypes["ContactSubmissionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactSubmission?: [{	by:ValueTypes["ContactSubmissionUniqueWhere"],	data:ValueTypes["ContactSubmissionUpdateInput"]},ValueTypes["_ValidationResult"]],
getTOPXBrand?: [{	by:ValueTypes["TOPXBrandUniqueWhere"],	filter?:ValueTypes["TOPXBrandWhere"] | null},ValueTypes["TOPXBrand"]],
listTOPXBrand?: [{	filter?:ValueTypes["TOPXBrandWhere"] | null,	orderBy?:ValueTypes["TOPXBrandOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TOPXBrand"]],
paginateTOPXBrand?: [{	filter?:ValueTypes["TOPXBrandWhere"] | null,	orderBy?:ValueTypes["TOPXBrandOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TOPXBrandConnection"]],
validateCreateTOPXBrand?: [{	data:ValueTypes["TOPXBrandCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTOPXBrand?: [{	by:ValueTypes["TOPXBrandUniqueWhere"],	data:ValueTypes["TOPXBrandUpdateInput"]},ValueTypes["_ValidationResult"]],
getTOPXBrandCategory?: [{	by:ValueTypes["TOPXBrandCategoryUniqueWhere"],	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null},ValueTypes["TOPXBrandCategory"]],
listTOPXBrandCategory?: [{	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null,	orderBy?:ValueTypes["TOPXBrandCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TOPXBrandCategory"]],
paginateTOPXBrandCategory?: [{	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null,	orderBy?:ValueTypes["TOPXBrandCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TOPXBrandCategoryConnection"]],
validateCreateTOPXBrandCategory?: [{	data:ValueTypes["TOPXBrandCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTOPXBrandCategory?: [{	by:ValueTypes["TOPXBrandCategoryUniqueWhere"],	data:ValueTypes["TOPXBrandCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getTOPXProduct?: [{	by:ValueTypes["TOPXProductUniqueWhere"],	filter?:ValueTypes["TOPXProductWhere"] | null},ValueTypes["TOPXProduct"]],
listTOPXProduct?: [{	filter?:ValueTypes["TOPXProductWhere"] | null,	orderBy?:ValueTypes["TOPXProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TOPXProduct"]],
paginateTOPXProduct?: [{	filter?:ValueTypes["TOPXProductWhere"] | null,	orderBy?:ValueTypes["TOPXProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TOPXProductConnection"]],
validateCreateTOPXProduct?: [{	data:ValueTypes["TOPXProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTOPXProduct?: [{	by:ValueTypes["TOPXProductUniqueWhere"],	data:ValueTypes["TOPXProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getTOPXProductCategory?: [{	by:ValueTypes["TOPXProductCategoryUniqueWhere"],	filter?:ValueTypes["TOPXProductCategoryWhere"] | null},ValueTypes["TOPXProductCategory"]],
listTOPXProductCategory?: [{	filter?:ValueTypes["TOPXProductCategoryWhere"] | null,	orderBy?:ValueTypes["TOPXProductCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TOPXProductCategory"]],
paginateTOPXProductCategory?: [{	filter?:ValueTypes["TOPXProductCategoryWhere"] | null,	orderBy?:ValueTypes["TOPXProductCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TOPXProductCategoryConnection"]],
validateCreateTOPXProductCategory?: [{	data:ValueTypes["TOPXProductCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTOPXProductCategory?: [{	by:ValueTypes["TOPXProductCategoryUniqueWhere"],	data:ValueTypes["TOPXProductCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReferenceList?: [{	by:ValueTypes["ContentReferenceListUniqueWhere"],	filter?:ValueTypes["ContentReferenceListWhere"] | null},ValueTypes["ContentReferenceList"]],
listContentReferenceList?: [{	filter?:ValueTypes["ContentReferenceListWhere"] | null,	orderBy?:ValueTypes["ContentReferenceListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReferenceList"]],
paginateContentReferenceList?: [{	filter?:ValueTypes["ContentReferenceListWhere"] | null,	orderBy?:ValueTypes["ContentReferenceListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceListConnection"]],
validateCreateContentReferenceList?: [{	data:ValueTypes["ContentReferenceListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReferenceList?: [{	by:ValueTypes["ContentReferenceListUniqueWhere"],	data:ValueTypes["ContentReferenceListUpdateInput"]},ValueTypes["_ValidationResult"]],
getBrandCount?: [{	by:ValueTypes["BrandCountUniqueWhere"],	filter?:ValueTypes["BrandCountWhere"] | null},ValueTypes["BrandCount"]],
listBrandCount?: [{	filter?:ValueTypes["BrandCountWhere"] | null,	orderBy?:ValueTypes["BrandCountOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandCount"]],
paginateBrandCount?: [{	filter?:ValueTypes["BrandCountWhere"] | null,	orderBy?:ValueTypes["BrandCountOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandCountConnection"]],
getProductCount?: [{	by:ValueTypes["ProductCountUniqueWhere"],	filter?:ValueTypes["ProductCountWhere"] | null},ValueTypes["ProductCount"]],
listProductCount?: [{	filter?:ValueTypes["ProductCountWhere"] | null,	orderBy?:ValueTypes["ProductCountOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductCount"]],
paginateProductCount?: [{	filter?:ValueTypes["ProductCountWhere"] | null,	orderBy?:ValueTypes["ProductCountOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductCountConnection"]],
	transaction?:ValueTypes["QueryTransaction"],
	_info?:ValueTypes["Info"],
		__typename?: boolean
}>;
	["_Schema"]: AliasType<{
	enums?:ValueTypes["_Enum"],
	entities?:ValueTypes["_Entity"],
		__typename?: boolean
}>;
	["_Enum"]: AliasType<{
	name?:boolean,
	values?:boolean,
		__typename?: boolean
}>;
	["_Entity"]: AliasType<{
	name?:boolean,
	customPrimaryAllowed?:boolean,
	fields?:ValueTypes["_Field"],
	unique?:ValueTypes["_UniqueConstraint"],
		__typename?: boolean
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:boolean,
		__typename?: boolean
}>;
	["BlogPage"]: AliasType<{
	_meta?:ValueTypes["BlogPageMeta"],
	id?:boolean,
	unique?:boolean,
	title?:boolean,
redirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
draft?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
redirectsByFrom?: [{	by:ValueTypes["BlogPageRedirectsByFromUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
paginateRedirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
		__typename?: boolean
}>;
	["BlogPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	redirects?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	draft?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["FieldMeta"]: AliasType<{
	readable?:boolean,
	updatable?:boolean,
		__typename?: boolean
}>;
	["UUID"]:unknown;
	["One"]:One;
	["Redirect"]: AliasType<{
	_meta?:ValueTypes["RedirectMeta"],
	id?:boolean,
	to?:boolean,
	order?:boolean,
	from?:boolean,
genericPage?: [{	filter?:ValueTypes["GenericPageWhere"] | null},ValueTypes["GenericPage"]],
itemCategory?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
brandsPage?: [{	filter?:ValueTypes["BrandsPageWhere"] | null},ValueTypes["BrandsPage"]],
blogPage?: [{	filter?:ValueTypes["BlogPageWhere"] | null},ValueTypes["BlogPage"]],
contactPage?: [{	filter?:ValueTypes["ContactPageWhere"] | null},ValueTypes["ContactPage"]],
wizardPage?: [{	filter?:ValueTypes["WizardPageWhere"] | null},ValueTypes["WizardPage"]],
comparatorPage?: [{	filter?:ValueTypes["ComparatorPageWhere"] | null},ValueTypes["ComparatorPage"]],
blogPost?: [{	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
		__typename?: boolean
}>;
	["RedirectMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	to?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	from?:ValueTypes["FieldMeta"],
	genericPage?:ValueTypes["FieldMeta"],
	itemCategory?:ValueTypes["FieldMeta"],
	brandsPage?:ValueTypes["FieldMeta"],
	blogPage?:ValueTypes["FieldMeta"],
	contactPage?:ValueTypes["FieldMeta"],
	wizardPage?:ValueTypes["FieldMeta"],
	comparatorPage?:ValueTypes["FieldMeta"],
	blogPost?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["GenericPage"]: AliasType<{
	_meta?:ValueTypes["GenericPageMeta"],
	id?:boolean,
	title?:boolean,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
redirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
draft?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
redirectsByFrom?: [{	by:ValueTypes["GenericPageRedirectsByFromUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
paginateRedirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
		__typename?: boolean
}>;
	["GenericPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	redirects?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	draft?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Linkable"]: AliasType<{
	_meta?:ValueTypes["LinkableMeta"],
	id?:boolean,
	url?:boolean,
genericPage?: [{	filter?:ValueTypes["GenericPageWhere"] | null},ValueTypes["GenericPage"]],
		__typename?: boolean
}>;
	["LinkableMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	genericPage?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["GenericPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	redirects?:ValueTypes["RedirectWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	draft?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["GenericPageWhere"] | undefined | null)[],
	or?:(ValueTypes["GenericPageWhere"] | undefined | null)[],
	not?:ValueTypes["GenericPageWhere"] | null
};
	["UUIDCondition"]: {
	and?:ValueTypes["UUIDCondition"][],
	or?:ValueTypes["UUIDCondition"][],
	not?:ValueTypes["UUIDCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["UUID"] | null,
	notEq?:ValueTypes["UUID"] | null,
	in?:ValueTypes["UUID"][],
	notIn?:ValueTypes["UUID"][],
	lt?:ValueTypes["UUID"] | null,
	lte?:ValueTypes["UUID"] | null,
	gt?:ValueTypes["UUID"] | null,
	gte?:ValueTypes["UUID"] | null
};
	["StringCondition"]: {
	and?:ValueTypes["StringCondition"][],
	or?:ValueTypes["StringCondition"][],
	not?:ValueTypes["StringCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:string | null,
	notEq?:string | null,
	in?:string[],
	notIn?:string[],
	lt?:string | null,
	lte?:string | null,
	gt?:string | null,
	gte?:string | null,
	contains?:string | null,
	startsWith?:string | null,
	endsWith?:string | null,
	containsCI?:string | null,
	startsWithCI?:string | null,
	endsWithCI?:string | null
};
	["LinkableWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	genericPage?:ValueTypes["GenericPageWhere"] | null,
	and?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	not?:ValueTypes["LinkableWhere"] | null
};
	["RedirectWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	to?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	from?:ValueTypes["StringCondition"] | null,
	genericPage?:ValueTypes["GenericPageWhere"] | null,
	itemCategory?:ValueTypes["ItemCategoryWhere"] | null,
	brandsPage?:ValueTypes["BrandsPageWhere"] | null,
	blogPage?:ValueTypes["BlogPageWhere"] | null,
	contactPage?:ValueTypes["ContactPageWhere"] | null,
	wizardPage?:ValueTypes["WizardPageWhere"] | null,
	comparatorPage?:ValueTypes["ComparatorPageWhere"] | null,
	blogPost?:ValueTypes["BlogPostWhere"] | null,
	and?:(ValueTypes["RedirectWhere"] | undefined | null)[],
	or?:(ValueTypes["RedirectWhere"] | undefined | null)[],
	not?:ValueTypes["RedirectWhere"] | null
};
	["IntCondition"]: {
	and?:ValueTypes["IntCondition"][],
	or?:ValueTypes["IntCondition"][],
	not?:ValueTypes["IntCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["ItemCategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	shortDescription?:ValueTypes["StringCondition"] | null,
	subCategories?:ValueTypes["ItemSubCategoryWhere"] | null,
	blogPosts?:ValueTypes["BlogPostWhere"] | null,
	items?:ValueTypes["ItemWhere"] | null,
	products?:ValueTypes["ProductWhere"] | null,
	featureDependencies?:ValueTypes["ProductFeatureWhere"] | null,
	declensionSixth?:ValueTypes["StringCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	comparatorGroupId?:ValueTypes["StringCondition"] | null,
	ads?:ValueTypes["AdWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	redirects?:ValueTypes["RedirectWhere"] | null,
	declensionsFourth?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	group?:ValueTypes["ItemGroupWhere"] | null,
	declensionSeventh?:ValueTypes["StringCondition"] | null,
	slugWith?:ValueTypes["StringCondition"] | null,
	slugWithNegative?:ValueTypes["StringCondition"] | null,
	declensionSeventhNegative?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	draft?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["ItemCategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["ItemCategoryWhere"] | undefined | null)[],
	not?:ValueTypes["ItemCategoryWhere"] | null
};
	["ItemSubCategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	items?:ValueTypes["ItemWhere"] | null,
	isFlavorCategory?:ValueTypes["BooleanCondition"] | null,
	isAllergenTag?:ValueTypes["BooleanCondition"] | null,
	isMostCommonAllergenTag?:ValueTypes["BooleanCondition"] | null,
	products?:ValueTypes["ProductWhere"] | null,
	featureDependencies?:ValueTypes["ProductFeatureWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	category?:ValueTypes["ItemCategoryWhere"] | null,
	flavorCategory?:ValueTypes["ItemFlavorCategoryWhere"] | null,
	dogs?:ValueTypes["DogWhere"] | null,
	iconNegative?:ValueTypes["ImageWhere"] | null,
	negativeWording?:ValueTypes["StringCondition"] | null,
	icon?:ValueTypes["ImageWhere"] | null,
	brands?:ValueTypes["BrandFlavorWhere"] | null,
	productLines?:ValueTypes["ProductLineFlavorWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	flavorSlug?:ValueTypes["StringCondition"] | null,
	flavorDeclensionSeventh?:ValueTypes["StringCondition"] | null,
	filterCombosFlavor?:ValueTypes["FilterComboWhere"] | null,
	filterCombosAllergy?:ValueTypes["FilterComboWhere"] | null,
	isFilterFlavor?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["ItemSubCategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["ItemSubCategoryWhere"] | undefined | null)[],
	not?:ValueTypes["ItemSubCategoryWhere"] | null
};
	["ItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	positiveForBodyTags?:ValueTypes["BodyTagWhere"] | null,
	negativeForBodyTags?:ValueTypes["BodyTagWhere"] | null,
	subCategories?:ValueTypes["ItemSubCategoryWhere"] | null,
	categories?:ValueTypes["ItemCategoryWhere"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	animalProteinStatus?:ValueTypes["ContentAmountCondition"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmountCondition"] | null,
	featuresOfProduct?:ValueTypes["ProductFeatureWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	referenceList?:ValueTypes["ReferenceListWhere"] | null,
	blogPost?:ValueTypes["BlogPostWhere"] | null,
	declensionFourth?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,
	declensionSeventh?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	aliases?:ValueTypes["ItemAliasWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	draft?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["ItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ItemWhere"] | undefined | null)[],
	not?:ValueTypes["ItemWhere"] | null
};
	["BodyTagWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	blogPosts?:ValueTypes["BlogPostWhere"] | null,
	positiveProducts?:ValueTypes["ProductWhere"] | null,
	negativeProducts?:ValueTypes["ProductWhere"] | null,
	positiveItems?:ValueTypes["ItemWhere"] | null,
	negativeItems?:ValueTypes["ItemWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	category?:ValueTypes["BodyTagCategoryWhere"] | null,
	icon?:ValueTypes["ImageWhere"] | null,
	dogs?:ValueTypes["DogWhere"] | null,
	labelFor?:ValueTypes["StringCondition"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	filterCombos?:ValueTypes["FilterComboWhere"] | null,
	and?:(ValueTypes["BodyTagWhere"] | undefined | null)[],
	or?:(ValueTypes["BodyTagWhere"] | undefined | null)[],
	not?:ValueTypes["BodyTagWhere"] | null
};
	["BlogPostWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	author?:ValueTypes["StringCondition"] | null,
	readingTime?:ValueTypes["StringCondition"] | null,
	publishedAt?:ValueTypes["DateTimeCondition"] | null,
	blogPostTags?:ValueTypes["BlogPostTagWhere"] | null,
	tags?:ValueTypes["BodyTagWhere"] | null,
	title?:ValueTypes["StringCondition"] | null,
	listedOnHomePage?:ValueTypes["BooleanCondition"] | null,
	reviews?:ValueTypes["BlogPostReviewWhere"] | null,
	itemCategories?:ValueTypes["ItemCategoryWhere"] | null,
	items?:ValueTypes["ItemWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	referenceList?:ValueTypes["ReferenceListWhere"] | null,
	user?:ValueTypes["UserWhere"] | null,
	isComparatorLinked?:ValueTypes["BooleanCondition"] | null,
	ads?:ValueTypes["AdWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	note?:ValueTypes["StringCondition"] | null,
	isActive?:ValueTypes["BooleanCondition"] | null,
	redirects?:ValueTypes["RedirectWhere"] | null,
	automated?:ValueTypes["BooleanCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	draft?:ValueTypes["ContentWhere"] | null,
	slugInternal?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["BlogPostWhere"] | undefined | null)[],
	or?:(ValueTypes["BlogPostWhere"] | undefined | null)[],
	not?:ValueTypes["BlogPostWhere"] | null
};
	["DateTimeCondition"]: {
	and?:ValueTypes["DateTimeCondition"][],
	or?:ValueTypes["DateTimeCondition"][],
	not?:ValueTypes["DateTimeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["DateTime"] | null,
	notEq?:ValueTypes["DateTime"] | null,
	in?:ValueTypes["DateTime"][],
	notIn?:ValueTypes["DateTime"][],
	lt?:ValueTypes["DateTime"] | null,
	lte?:ValueTypes["DateTime"] | null,
	gt?:ValueTypes["DateTime"] | null,
	gte?:ValueTypes["DateTime"] | null
};
	["DateTime"]:unknown;
	["BlogPostTagWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	blogPosts?:ValueTypes["BlogPostWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	color?:ValueTypes["ColorWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	and?:(ValueTypes["BlogPostTagWhere"] | undefined | null)[],
	or?:(ValueTypes["BlogPostTagWhere"] | undefined | null)[],
	not?:ValueTypes["BlogPostTagWhere"] | null
};
	["ColorWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	colorHex?:ValueTypes["StringCondition"] | null,
	bodyTagCategory?:ValueTypes["BodyTagCategoryWhere"] | null,
	blogPostTag?:ValueTypes["BlogPostTagWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	itemFlavorCategories?:ValueTypes["ItemFlavorCategoryWhere"] | null,
	and?:(ValueTypes["ColorWhere"] | undefined | null)[],
	or?:(ValueTypes["ColorWhere"] | undefined | null)[],
	not?:ValueTypes["ColorWhere"] | null
};
	["BodyTagCategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	tags?:ValueTypes["BodyTagWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	color?:ValueTypes["ColorWhere"] | null,
	and?:(ValueTypes["BodyTagCategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["BodyTagCategoryWhere"] | undefined | null)[],
	not?:ValueTypes["BodyTagCategoryWhere"] | null
};
	["ItemFlavorCategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	items?:ValueTypes["ItemSubCategoryWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	color?:ValueTypes["ColorWhere"] | null,
	and?:(ValueTypes["ItemFlavorCategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["ItemFlavorCategoryWhere"] | undefined | null)[],
	not?:ValueTypes["ItemFlavorCategoryWhere"] | null
};
	["BooleanCondition"]: {
	and?:ValueTypes["BooleanCondition"][],
	or?:ValueTypes["BooleanCondition"][],
	not?:ValueTypes["BooleanCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:boolean | null,
	notEq?:boolean | null,
	in?:boolean[],
	notIn?:boolean[],
	lt?:boolean | null,
	lte?:boolean | null,
	gt?:boolean | null,
	gte?:boolean | null
};
	["BlogPostReviewWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	publishedAt?:ValueTypes["DateTimeCondition"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewReactionWhere"] | null,
	blogPost?:ValueTypes["BlogPostWhere"] | null,
	user?:ValueTypes["UserWhere"] | null,
	stats?:ValueTypes["BlogPostReviewStatsWhere"] | null,
	fullName?:ValueTypes["StringCondition"] | null,
	breed?:ValueTypes["BreedWhere"] | null,
	age?:ValueTypes["AgeWhere"] | null,
	url?:ValueTypes["StringCondition"] | null,
	isVisible?:ValueTypes["BooleanCondition"] | null,
	response?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["BlogPostReviewWhere"] | undefined | null)[],
	or?:(ValueTypes["BlogPostReviewWhere"] | undefined | null)[],
	not?:ValueTypes["BlogPostReviewWhere"] | null
};
	["BlogPostReviewReactionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	sentiment?:ValueTypes["SentimentTypeCondition"] | null,
	user?:ValueTypes["UserWhere"] | null,
	blogPostReview?:ValueTypes["BlogPostReviewWhere"] | null,
	and?:(ValueTypes["BlogPostReviewReactionWhere"] | undefined | null)[],
	or?:(ValueTypes["BlogPostReviewReactionWhere"] | undefined | null)[],
	not?:ValueTypes["BlogPostReviewReactionWhere"] | null
};
	["SentimentTypeCondition"]: {
	and?:ValueTypes["SentimentTypeCondition"][],
	or?:ValueTypes["SentimentTypeCondition"][],
	not?:ValueTypes["SentimentTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["SentimentType"] | null,
	notEq?:ValueTypes["SentimentType"] | null,
	in?:ValueTypes["SentimentType"][],
	notIn?:ValueTypes["SentimentType"][],
	lt?:ValueTypes["SentimentType"] | null,
	lte?:ValueTypes["SentimentType"] | null,
	gt?:ValueTypes["SentimentType"] | null,
	gte?:ValueTypes["SentimentType"] | null
};
	["SentimentType"]:SentimentType;
	["UserWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	dogs?:ValueTypes["DogWhere"] | null,
	veterinary?:ValueTypes["VeterinaryWhere"] | null,
	email?:ValueTypes["StringCondition"] | null,
	blogPostReviews?:ValueTypes["BlogPostReviewWhere"] | null,
	productReviews?:ValueTypes["ProductReviewWhere"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewReactionWhere"] | null,
	productReviewReactions?:ValueTypes["ProductReviewReactionWhere"] | null,
	tenantPersonId?:ValueTypes["UUIDCondition"] | null,
	fullName?:ValueTypes["StringCondition"] | null,
	blogPosts?:ValueTypes["BlogPostWhere"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	verifiedAt?:ValueTypes["DateTimeCondition"] | null,
	avatar?:ValueTypes["ImageWhere"] | null,
	contactFormMessages?:ValueTypes["ContactFormMessageWhere"] | null,
	bugReports?:ValueTypes["BugReportWhere"] | null,
	verifiedEmail?:ValueTypes["StringCondition"] | null,
	protectedActions?:ValueTypes["ProtectedActionWhere"] | null,
	blockedAt?:ValueTypes["DateTimeCondition"] | null,
	tenantPerson?:ValueTypes["TenantPersonWhere"] | null,
	note?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["UserWhere"] | undefined | null)[],
	or?:(ValueTypes["UserWhere"] | undefined | null)[],
	not?:ValueTypes["UserWhere"] | null
};
	["DogWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	gender?:ValueTypes["GenderTypeCondition"] | null,
	weight?:ValueTypes["FloatCondition"] | null,
	customIdealWeight?:ValueTypes["FloatCondition"] | null,
	breed?:ValueTypes["BreedWhere"] | null,
	age?:ValueTypes["AgeWhere"] | null,
	bodyType?:ValueTypes["DogBodyTypeWhere"] | null,
	owner?:ValueTypes["UserWhere"] | null,
	activity?:ValueTypes["DogActivityWhere"] | null,
	fedProduct?:ValueTypes["ProductWhere"] | null,
	reproduction?:ValueTypes["DogReproductionWhere"] | null,
	allergies?:ValueTypes["ItemSubCategoryWhere"] | null,
	illnesses?:ValueTypes["BodyTagWhere"] | null,
	name?:ValueTypes["StringCondition"] | null,
	avatar?:ValueTypes["ImageWhere"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	and?:(ValueTypes["DogWhere"] | undefined | null)[],
	or?:(ValueTypes["DogWhere"] | undefined | null)[],
	not?:ValueTypes["DogWhere"] | null
};
	["GenderTypeCondition"]: {
	and?:ValueTypes["GenderTypeCondition"][],
	or?:ValueTypes["GenderTypeCondition"][],
	not?:ValueTypes["GenderTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["GenderType"] | null,
	notEq?:ValueTypes["GenderType"] | null,
	in?:ValueTypes["GenderType"][],
	notIn?:ValueTypes["GenderType"][],
	lt?:ValueTypes["GenderType"] | null,
	lte?:ValueTypes["GenderType"] | null,
	gt?:ValueTypes["GenderType"] | null,
	gte?:ValueTypes["GenderType"] | null
};
	["GenderType"]:GenderType;
	["FloatCondition"]: {
	and?:ValueTypes["FloatCondition"][],
	or?:ValueTypes["FloatCondition"][],
	not?:ValueTypes["FloatCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["BreedWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	dogs?:ValueTypes["DogWhere"] | null,
	litterSize?:ValueTypes["IntCondition"] | null,
	reviews?:ValueTypes["ReviewWhere"] | null,
	name?:ValueTypes["StringCondition"] | null,
	dailyEnergyRequirement?:ValueTypes["IntCondition"] | null,
	ages?:ValueTypes["AgeWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	averageWeightFemale?:ValueTypes["FloatCondition"] | null,
	averageWeightMale?:ValueTypes["FloatCondition"] | null,
	suitabilityCategory?:ValueTypes["SuitabilityCategoryWhere"] | null,
	productReviews?:ValueTypes["ProductReviewWhere"] | null,
	blogPostReviews?:ValueTypes["BlogPostReviewWhere"] | null,
	labelFor?:ValueTypes["StringCondition"] | null,
	size?:ValueTypes["DogSizeWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	filterCombos?:ValueTypes["FilterComboWhere"] | null,
	and?:(ValueTypes["BreedWhere"] | undefined | null)[],
	or?:(ValueTypes["BreedWhere"] | undefined | null)[],
	not?:ValueTypes["BreedWhere"] | null
};
	["ReviewWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	dogBreeds?:ValueTypes["BreedWhere"] | null,
	text?:ValueTypes["StringCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	author?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ReviewWhere"] | undefined | null)[],
	or?:(ValueTypes["ReviewWhere"] | undefined | null)[],
	not?:ValueTypes["ReviewWhere"] | null
};
	["AgeWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	dogs?:ValueTypes["DogWhere"] | null,
	breeds?:ValueTypes["BreedWhere"] | null,
	ageRange?:ValueTypes["AgeRangeTypeCondition"] | null,
	categoryLabel?:ValueTypes["AgeLabelTypeCondition"] | null,
	suitabilityCategories?:ValueTypes["SuitabilityCategoryWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	productReviews?:ValueTypes["ProductReviewWhere"] | null,
	blogPostReviews?:ValueTypes["BlogPostReviewWhere"] | null,
	label?:ValueTypes["StringCondition"] | null,
	categoryOrder?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["AgeWhere"] | undefined | null)[],
	or?:(ValueTypes["AgeWhere"] | undefined | null)[],
	not?:ValueTypes["AgeWhere"] | null
};
	["AgeRangeTypeCondition"]: {
	and?:ValueTypes["AgeRangeTypeCondition"][],
	or?:ValueTypes["AgeRangeTypeCondition"][],
	not?:ValueTypes["AgeRangeTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["AgeRangeType"] | null,
	notEq?:ValueTypes["AgeRangeType"] | null,
	in?:ValueTypes["AgeRangeType"][],
	notIn?:ValueTypes["AgeRangeType"][],
	lt?:ValueTypes["AgeRangeType"] | null,
	lte?:ValueTypes["AgeRangeType"] | null,
	gt?:ValueTypes["AgeRangeType"] | null,
	gte?:ValueTypes["AgeRangeType"] | null
};
	["AgeRangeType"]:AgeRangeType;
	["AgeLabelTypeCondition"]: {
	and?:ValueTypes["AgeLabelTypeCondition"][],
	or?:ValueTypes["AgeLabelTypeCondition"][],
	not?:ValueTypes["AgeLabelTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["AgeLabelType"] | null,
	notEq?:ValueTypes["AgeLabelType"] | null,
	in?:ValueTypes["AgeLabelType"][],
	notIn?:ValueTypes["AgeLabelType"][],
	lt?:ValueTypes["AgeLabelType"] | null,
	lte?:ValueTypes["AgeLabelType"] | null,
	gt?:ValueTypes["AgeLabelType"] | null,
	gte?:ValueTypes["AgeLabelType"] | null
};
	["AgeLabelType"]:AgeLabelType;
	["SuitabilityCategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	dogSizes?:ValueTypes["DogSizeWhere"] | null,
	dogActivities?:ValueTypes["DogActivityWhere"] | null,
	breeds?:ValueTypes["BreedWhere"] | null,
	suitabilityItems?:ValueTypes["SuitabilityItemWhere"] | null,
	dogAges?:ValueTypes["AgeWhere"] | null,
	isPregnant?:ValueTypes["BooleanCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	isBreastfeeding?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["SuitabilityCategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["SuitabilityCategoryWhere"] | undefined | null)[],
	not?:ValueTypes["SuitabilityCategoryWhere"] | null
};
	["DogSizeWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	breeds?:ValueTypes["BreedWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	products?:ValueTypes["ProductWhere"] | null,
	suitabilityCategory?:ValueTypes["SuitabilityCategoryWhere"] | null,
	name?:ValueTypes["SizeTypeCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	isFilterVisible?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["DogSizeWhere"] | undefined | null)[],
	or?:(ValueTypes["DogSizeWhere"] | undefined | null)[],
	not?:ValueTypes["DogSizeWhere"] | null
};
	["ProductWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	nutritionalValues?:ValueTypes["NutritionalValueOfProductWhere"] | null,
	name?:ValueTypes["StringCondition"] | null,
	positiveForBodyTags?:ValueTypes["BodyTagWhere"] | null,
	negativeForBodyTags?:ValueTypes["BodyTagWhere"] | null,
	reviews?:ValueTypes["ProductReviewWhere"] | null,
	score?:ValueTypes["IntCondition"] | null,
	dogs?:ValueTypes["DogWhere"] | null,
	firstFiveItems?:ValueTypes["StringCondition"] | null,
	detailedComposition?:ValueTypes["StringCondition"] | null,
	guaranteedAnalysis?:ValueTypes["StringCondition"] | null,
	isVeterinaryDiet?:ValueTypes["BooleanCondition"] | null,
	packagings?:ValueTypes["ProductPackageWhere"] | null,
	itemSubCategories?:ValueTypes["ItemSubCategoryWhere"] | null,
	itemCategories?:ValueTypes["ItemCategoryWhere"] | null,
	elements?:ValueTypes["ElementOfProductWhere"] | null,
	isSearchVisible?:ValueTypes["BooleanCondition"] | null,
	isSuitableForEliminationDiet?:ValueTypes["BooleanCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	recommendedDogSizes?:ValueTypes["DogSizeWhere"] | null,
	granuleSizes?:ValueTypes["GranuleSizeWhere"] | null,
	productLine?:ValueTypes["ProductLineWhere"] | null,
	flags?:ValueTypes["ProductFlagOfProductWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	recommendedActivity?:ValueTypes["DogActivityWhere"] | null,
	brand?:ValueTypes["BrandWhere"] | null,
	metabolizedEnergy?:ValueTypes["FloatCondition"] | null,
	cheapnessValue?:ValueTypes["FloatCondition"] | null,
	aliases?:ValueTypes["ProductAliasWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	animalProteinStatus?:ValueTypes["ContentAmountCondition"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmountCondition"] | null,
	evaluation?:ValueTypes["ProductEvaluationWhere"] | null,
	missingComposition?:ValueTypes["BooleanCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	czkPerMetabolizedEnergy?:ValueTypes["FloatCondition"] | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null,
	ageCategories?:ValueTypes["AgeCategoryWhere"] | null,
	customMetaTitle?:ValueTypes["StringCondition"] | null,
	customMetaDescription?:ValueTypes["StringCondition"] | null,
	isSuitableForCastrated?:ValueTypes["BooleanCondition"] | null,
	heurekaImage?:ValueTypes["ImageWhere"] | null,
	topx?:ValueTypes["TOPXProductWhere"] | null,
	and?:(ValueTypes["ProductWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductWhere"] | undefined | null)[],
	not?:ValueTypes["ProductWhere"] | null
};
	["NutritionalValueOfProductWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	product?:ValueTypes["ProductWhere"] | null,
	amount?:ValueTypes["FloatCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	nutritionalValue?:ValueTypes["NutritionalValueWhere"] | null,
	and?:(ValueTypes["NutritionalValueOfProductWhere"] | undefined | null)[],
	or?:(ValueTypes["NutritionalValueOfProductWhere"] | undefined | null)[],
	not?:ValueTypes["NutritionalValueOfProductWhere"] | null
};
	["NutritionalValueWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	products?:ValueTypes["NutritionalValueOfProductWhere"] | null,
	suitabilityNutritionalValues?:ValueTypes["SuitabilityItemWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	icon?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["NutritionalValueWhere"] | undefined | null)[],
	or?:(ValueTypes["NutritionalValueWhere"] | undefined | null)[],
	not?:ValueTypes["NutritionalValueWhere"] | null
};
	["SuitabilityItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	min?:ValueTypes["FloatCondition"] | null,
	max?:ValueTypes["FloatCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	element?:ValueTypes["ElementWhere"] | null,
	nutritionalValue?:ValueTypes["NutritionalValueWhere"] | null,
	category?:ValueTypes["SuitabilityCategoryWhere"] | null,
	and?:(ValueTypes["SuitabilityItemWhere"] | undefined | null)[],
	or?:(ValueTypes["SuitabilityItemWhere"] | undefined | null)[],
	not?:ValueTypes["SuitabilityItemWhere"] | null
};
	["ElementWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	products?:ValueTypes["ElementOfProductWhere"] | null,
	featureDependencies?:ValueTypes["ProductFeatureWhere"] | null,
	suitabilityElements?:ValueTypes["SuitabilityItemWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	unit?:ValueTypes["StringCondition"] | null,
	filterOrder?:ValueTypes["IntCondition"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	declensionSeventh?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ElementWhere"] | undefined | null)[],
	or?:(ValueTypes["ElementWhere"] | undefined | null)[],
	not?:ValueTypes["ElementWhere"] | null
};
	["ElementOfProductWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	amount?:ValueTypes["FloatCondition"] | null,
	product?:ValueTypes["ProductWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	element?:ValueTypes["ElementWhere"] | null,
	and?:(ValueTypes["ElementOfProductWhere"] | undefined | null)[],
	or?:(ValueTypes["ElementOfProductWhere"] | undefined | null)[],
	not?:ValueTypes["ElementOfProductWhere"] | null
};
	["ProductFeatureWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	category?:ValueTypes["FeatureCategoryTypeCondition"] | null,
	value?:ValueTypes["FeatureValueTypeCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	linkItem?:ValueTypes["ItemWhere"] | null,
	dependentElement?:ValueTypes["ElementWhere"] | null,
	dependentCategory?:ValueTypes["ItemCategoryWhere"] | null,
	dependentSubCategory?:ValueTypes["ItemSubCategoryWhere"] | null,
	dependentFlag?:ValueTypes["ProductFlagWhere"] | null,
	and?:(ValueTypes["ProductFeatureWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductFeatureWhere"] | undefined | null)[],
	not?:ValueTypes["ProductFeatureWhere"] | null
};
	["FeatureCategoryTypeCondition"]: {
	and?:ValueTypes["FeatureCategoryTypeCondition"][],
	or?:ValueTypes["FeatureCategoryTypeCondition"][],
	not?:ValueTypes["FeatureCategoryTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["FeatureCategoryType"] | null,
	notEq?:ValueTypes["FeatureCategoryType"] | null,
	in?:ValueTypes["FeatureCategoryType"][],
	notIn?:ValueTypes["FeatureCategoryType"][],
	lt?:ValueTypes["FeatureCategoryType"] | null,
	lte?:ValueTypes["FeatureCategoryType"] | null,
	gt?:ValueTypes["FeatureCategoryType"] | null,
	gte?:ValueTypes["FeatureCategoryType"] | null
};
	["FeatureCategoryType"]:FeatureCategoryType;
	["FeatureValueTypeCondition"]: {
	and?:ValueTypes["FeatureValueTypeCondition"][],
	or?:ValueTypes["FeatureValueTypeCondition"][],
	not?:ValueTypes["FeatureValueTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["FeatureValueType"] | null,
	notEq?:ValueTypes["FeatureValueType"] | null,
	in?:ValueTypes["FeatureValueType"][],
	notIn?:ValueTypes["FeatureValueType"][],
	lt?:ValueTypes["FeatureValueType"] | null,
	lte?:ValueTypes["FeatureValueType"] | null,
	gt?:ValueTypes["FeatureValueType"] | null,
	gte?:ValueTypes["FeatureValueType"] | null
};
	["FeatureValueType"]:FeatureValueType;
	["ProductFlagWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	productFeatures?:ValueTypes["ProductFeatureWhere"] | null,
	products?:ValueTypes["ProductFlagOfProductWhere"] | null,
	and?:(ValueTypes["ProductFlagWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductFlagWhere"] | undefined | null)[],
	not?:ValueTypes["ProductFlagWhere"] | null
};
	["ProductFlagOfProductWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	value?:ValueTypes["ProductFlagValueCondition"] | null,
	product?:ValueTypes["ProductWhere"] | null,
	flag?:ValueTypes["ProductFlagWhere"] | null,
	and?:(ValueTypes["ProductFlagOfProductWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductFlagOfProductWhere"] | undefined | null)[],
	not?:ValueTypes["ProductFlagOfProductWhere"] | null
};
	["ProductFlagValueCondition"]: {
	and?:ValueTypes["ProductFlagValueCondition"][],
	or?:ValueTypes["ProductFlagValueCondition"][],
	not?:ValueTypes["ProductFlagValueCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ProductFlagValue"] | null,
	notEq?:ValueTypes["ProductFlagValue"] | null,
	in?:ValueTypes["ProductFlagValue"][],
	notIn?:ValueTypes["ProductFlagValue"][],
	lt?:ValueTypes["ProductFlagValue"] | null,
	lte?:ValueTypes["ProductFlagValue"] | null,
	gt?:ValueTypes["ProductFlagValue"] | null,
	gte?:ValueTypes["ProductFlagValue"] | null
};
	["ProductFlagValue"]:ProductFlagValue;
	["ImageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	alt?:ValueTypes["StringCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	hash?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ImageWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageWhere"] | undefined | null)[],
	not?:ValueTypes["ImageWhere"] | null
};
	["ProductReviewWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	publishedAt?:ValueTypes["DateTimeCondition"] | null,
	productReviewReactions?:ValueTypes["ProductReviewReactionWhere"] | null,
	score?:ValueTypes["ScoreWhere"] | null,
	product?:ValueTypes["ProductWhere"] | null,
	user?:ValueTypes["UserWhere"] | null,
	stats?:ValueTypes["ProductReviewStatsWhere"] | null,
	fullName?:ValueTypes["StringCondition"] | null,
	breed?:ValueTypes["BreedWhere"] | null,
	age?:ValueTypes["AgeWhere"] | null,
	url?:ValueTypes["StringCondition"] | null,
	isVisible?:ValueTypes["BooleanCondition"] | null,
	response?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ProductReviewWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductReviewWhere"] | undefined | null)[],
	not?:ValueTypes["ProductReviewWhere"] | null
};
	["ProductReviewReactionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	sentiment?:ValueTypes["SentimentTypeCondition"] | null,
	user?:ValueTypes["UserWhere"] | null,
	productReview?:ValueTypes["ProductReviewWhere"] | null,
	and?:(ValueTypes["ProductReviewReactionWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductReviewReactionWhere"] | undefined | null)[],
	not?:ValueTypes["ProductReviewReactionWhere"] | null
};
	["ScoreWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	productReviews?:ValueTypes["ProductReviewWhere"] | null,
	starsAmount?:ValueTypes["IntCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ScoreWhere"] | undefined | null)[],
	or?:(ValueTypes["ScoreWhere"] | undefined | null)[],
	not?:ValueTypes["ScoreWhere"] | null
};
	["ProductReviewStatsWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	total?:ValueTypes["IntCondition"] | null,
	positive?:ValueTypes["IntCondition"] | null,
	negative?:ValueTypes["IntCondition"] | null,
	productReview?:ValueTypes["ProductReviewWhere"] | null,
	and?:(ValueTypes["ProductReviewStatsWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductReviewStatsWhere"] | undefined | null)[],
	not?:ValueTypes["ProductReviewStatsWhere"] | null
};
	["ProductPackageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	price?:ValueTypes["IntCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["StringCondition"] | null,
	product?:ValueTypes["ProductWhere"] | null,
	amount?:ValueTypes["FloatCondition"] | null,
	externalId?:ValueTypes["StringCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	positionId?:ValueTypes["StringCondition"] | null,
	heurekaPrice?:ValueTypes["IntCondition"] | null,
	heurekaLink?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ProductPackageWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductPackageWhere"] | undefined | null)[],
	not?:ValueTypes["ProductPackageWhere"] | null
};
	["GranuleSizeWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	products?:ValueTypes["ProductWhere"] | null,
	name?:ValueTypes["GranuleSizeTypeCondition"] | null,
	and?:(ValueTypes["GranuleSizeWhere"] | undefined | null)[],
	or?:(ValueTypes["GranuleSizeWhere"] | undefined | null)[],
	not?:ValueTypes["GranuleSizeWhere"] | null
};
	["GranuleSizeTypeCondition"]: {
	and?:ValueTypes["GranuleSizeTypeCondition"][],
	or?:ValueTypes["GranuleSizeTypeCondition"][],
	not?:ValueTypes["GranuleSizeTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["GranuleSizeType"] | null,
	notEq?:ValueTypes["GranuleSizeType"] | null,
	in?:ValueTypes["GranuleSizeType"][],
	notIn?:ValueTypes["GranuleSizeType"][],
	lt?:ValueTypes["GranuleSizeType"] | null,
	lte?:ValueTypes["GranuleSizeType"] | null,
	gt?:ValueTypes["GranuleSizeType"] | null,
	gte?:ValueTypes["GranuleSizeType"] | null
};
	["GranuleSizeType"]:GranuleSizeType;
	["ProductLineWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	products?:ValueTypes["ProductWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	brand?:ValueTypes["BrandWhere"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	aliases?:ValueTypes["ProductLineAliasWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	flavors?:ValueTypes["ProductLineFlavorWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	customMetaDescription?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ProductLineWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductLineWhere"] | undefined | null)[],
	not?:ValueTypes["ProductLineWhere"] | null
};
	["BrandWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	products?:ValueTypes["ProductWhere"] | null,
	link?:ValueTypes["StringCondition"] | null,
	countriesOfProduction?:ValueTypes["CountryWhere"] | null,
	manufacturers?:ValueTypes["BrandManufacturerWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	promotedOnSearchPlace?:ValueTypes["IntCondition"] | null,
	promotedOnBrandsPagePlace?:ValueTypes["IntCondition"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	productLines?:ValueTypes["ProductLineWhere"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	methodOfProduction?:ValueTypes["ProductionMethodWhere"] | null,
	distributor?:ValueTypes["BrandDistributorWhere"] | null,
	aliases?:ValueTypes["BrandAliasWhere"] | null,
	ads?:ValueTypes["AdWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	flavors?:ValueTypes["BrandFlavorWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	customMetaDescription?:ValueTypes["StringCondition"] | null,
	filterCombos?:ValueTypes["FilterComboWhere"] | null,
	topx?:ValueTypes["TOPXBrandWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	draft?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["BrandWhere"] | undefined | null)[],
	or?:(ValueTypes["BrandWhere"] | undefined | null)[],
	not?:ValueTypes["BrandWhere"] | null
};
	["CountryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	brands?:ValueTypes["BrandWhere"] | null,
	manufacturers?:ValueTypes["BrandManufacturerWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	region?:ValueTypes["RegionWhere"] | null,
	and?:(ValueTypes["CountryWhere"] | undefined | null)[],
	or?:(ValueTypes["CountryWhere"] | undefined | null)[],
	not?:ValueTypes["CountryWhere"] | null
};
	["BrandManufacturerWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["StringCondition"] | null,
	brands?:ValueTypes["BrandWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	residence?:ValueTypes["CountryWhere"] | null,
	and?:(ValueTypes["BrandManufacturerWhere"] | undefined | null)[],
	or?:(ValueTypes["BrandManufacturerWhere"] | undefined | null)[],
	not?:ValueTypes["BrandManufacturerWhere"] | null
};
	["RegionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	countries?:ValueTypes["CountryWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	adjective?:ValueTypes["StringCondition"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	filterCombos?:ValueTypes["FilterComboWhere"] | null,
	and?:(ValueTypes["RegionWhere"] | undefined | null)[],
	or?:(ValueTypes["RegionWhere"] | undefined | null)[],
	not?:ValueTypes["RegionWhere"] | null
};
	["FilterComboWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	breed?:ValueTypes["BreedWhere"] | null,
	brand?:ValueTypes["BrandWhere"] | null,
	region?:ValueTypes["RegionWhere"] | null,
	ageCategory?:ValueTypes["AgeCategoryWhere"] | null,
	treatment?:ValueTypes["BodyTagWhere"] | null,
	flavor?:ValueTypes["ItemSubCategoryWhere"] | null,
	allergy?:ValueTypes["ItemSubCategoryWhere"] | null,
	and?:(ValueTypes["FilterComboWhere"] | undefined | null)[],
	or?:(ValueTypes["FilterComboWhere"] | undefined | null)[],
	not?:ValueTypes["FilterComboWhere"] | null
};
	["SeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	description?:ValueTypes["StringCondition"] | null,
	ogTitle?:ValueTypes["StringCondition"] | null,
	ogDescription?:ValueTypes["StringCondition"] | null,
	ogImage?:ValueTypes["ImageWhere"] | null,
	blogPage?:ValueTypes["BlogPageWhere"] | null,
	brandsPage?:ValueTypes["BrandsPageWhere"] | null,
	comparatorPage?:ValueTypes["ComparatorPageWhere"] | null,
	genericPage?:ValueTypes["GenericPageWhere"] | null,
	homePage?:ValueTypes["HomePageWhere"] | null,
	ingredientsPage?:ValueTypes["IngredientsPageWhere"] | null,
	loginPage?:ValueTypes["LoginPageWhere"] | null,
	registerPage?:ValueTypes["RegisterPageWhere"] | null,
	searchPage?:ValueTypes["SearchPageWhere"] | null,
	wizardPage?:ValueTypes["WizardPageWhere"] | null,
	contactPage?:ValueTypes["ContactPageWhere"] | null,
	group?:ValueTypes["GroupTypeCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["SeoWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoWhere"] | undefined | null)[],
	not?:ValueTypes["SeoWhere"] | null
};
	["BlogPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	redirects?:ValueTypes["RedirectWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	draft?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["BlogPageWhere"] | undefined | null)[],
	or?:(ValueTypes["BlogPageWhere"] | undefined | null)[],
	not?:ValueTypes["BlogPageWhere"] | null
};
	["OneCondition"]: {
	and?:ValueTypes["OneCondition"][],
	or?:ValueTypes["OneCondition"][],
	not?:ValueTypes["OneCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["One"] | null,
	notEq?:ValueTypes["One"] | null,
	in?:ValueTypes["One"][],
	notIn?:ValueTypes["One"][],
	lt?:ValueTypes["One"] | null,
	lte?:ValueTypes["One"] | null,
	gt?:ValueTypes["One"] | null,
	gte?:ValueTypes["One"] | null
};
	["ContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	blocks?:ValueTypes["ContentBlockWhere"] | null,
	and?:(ValueTypes["ContentWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentWhere"] | undefined | null)[],
	not?:ValueTypes["ContentWhere"] | null
};
	["ContentBlockWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	json?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	references?:ValueTypes["ContentReferenceWhere"] | null,
	automatedContentBlockSlug?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	not?:ValueTypes["ContentBlockWhere"] | null
};
	["ContentReferenceWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["ContentReferenceTypeCondition"] | null,
	block?:ValueTypes["ContentBlockWhere"] | null,
	primaryText?:ValueTypes["StringCondition"] | null,
	secondaryText?:ValueTypes["StringCondition"] | null,
	fact?:ValueTypes["StringCondition"] | null,
	images?:ValueTypes["ContentReferenceGalleryImageWhere"] | null,
	relatedBlogPost?:ValueTypes["BlogPostWhere"] | null,
	relatedBrand?:ValueTypes["BrandWhere"] | null,
	relatedProduct?:ValueTypes["ProductWhere"] | null,
	relatedIngredient?:ValueTypes["ItemWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	badge?:ValueTypes["StringCondition"] | null,
	longVersion?:ValueTypes["BooleanCondition"] | null,
	relatedBrandFull?:ValueTypes["BrandWhere"] | null,
	relatedProductFull?:ValueTypes["ProductWhere"] | null,
	list?:ValueTypes["ContentReferenceListWhere"] | null,
	outline?:ValueTypes["ContentLinksWhere"] | null,
	video?:ValueTypes["VideoWhere"] | null,
	image?:ValueTypes["ContentReferenceImageWhere"] | null,
	defaultOpen?:ValueTypes["BooleanCondition"] | null,
	badgeColor?:ValueTypes["StringCondition"] | null,
	isMain?:ValueTypes["BooleanCondition"] | null,
	ad?:ValueTypes["AdWhere"] | null,
	and?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	not?:ValueTypes["ContentReferenceWhere"] | null
};
	["ContentReferenceTypeCondition"]: {
	and?:ValueTypes["ContentReferenceTypeCondition"][],
	or?:ValueTypes["ContentReferenceTypeCondition"][],
	not?:ValueTypes["ContentReferenceTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentReferenceType"] | null,
	notEq?:ValueTypes["ContentReferenceType"] | null,
	in?:ValueTypes["ContentReferenceType"][],
	notIn?:ValueTypes["ContentReferenceType"][],
	lt?:ValueTypes["ContentReferenceType"] | null,
	lte?:ValueTypes["ContentReferenceType"] | null,
	gt?:ValueTypes["ContentReferenceType"] | null,
	gte?:ValueTypes["ContentReferenceType"] | null
};
	["ContentReferenceType"]:ContentReferenceType;
	["ContentReferenceGalleryImageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	reference?:ValueTypes["ContentReferenceWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	alignment?:ValueTypes["AlignmentTypeCondition"] | null,
	and?:(ValueTypes["ContentReferenceGalleryImageWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentReferenceGalleryImageWhere"] | undefined | null)[],
	not?:ValueTypes["ContentReferenceGalleryImageWhere"] | null
};
	["AlignmentTypeCondition"]: {
	and?:ValueTypes["AlignmentTypeCondition"][],
	or?:ValueTypes["AlignmentTypeCondition"][],
	not?:ValueTypes["AlignmentTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["AlignmentType"] | null,
	notEq?:ValueTypes["AlignmentType"] | null,
	in?:ValueTypes["AlignmentType"][],
	notIn?:ValueTypes["AlignmentType"][],
	lt?:ValueTypes["AlignmentType"] | null,
	lte?:ValueTypes["AlignmentType"] | null,
	gt?:ValueTypes["AlignmentType"] | null,
	gte?:ValueTypes["AlignmentType"] | null
};
	["AlignmentType"]:AlignmentType;
	["LinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	externalLink?:ValueTypes["StringCondition"] | null,
	isTargetBlank?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["LinkWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkWhere"] | undefined | null)[],
	not?:ValueTypes["LinkWhere"] | null
};
	["ContentReferenceListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	relatedProduct?:ValueTypes["ProductWhere"] | null,
	relatedBrand?:ValueTypes["BrandWhere"] | null,
	list?:ValueTypes["ContentReferenceWhere"] | null,
	badge?:ValueTypes["StringCondition"] | null,
	badgeColor?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ContentReferenceListWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentReferenceListWhere"] | undefined | null)[],
	not?:ValueTypes["ContentReferenceListWhere"] | null
};
	["ContentLinksWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["ContentLinksItemWhere"] | null,
	and?:(ValueTypes["ContentLinksWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentLinksWhere"] | undefined | null)[],
	not?:ValueTypes["ContentLinksWhere"] | null
};
	["ContentLinksItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	target?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["ContentLinksWhere"] | null,
	and?:(ValueTypes["ContentLinksItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentLinksItemWhere"] | undefined | null)[],
	not?:ValueTypes["ContentLinksItemWhere"] | null
};
	["VideoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	src?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	duration?:ValueTypes["FloatCondition"] | null,
	poster?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["VideoWhere"] | undefined | null)[],
	or?:(ValueTypes["VideoWhere"] | undefined | null)[],
	not?:ValueTypes["VideoWhere"] | null
};
	["ContentReferenceImageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	alignment?:ValueTypes["AlignmentTypeCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	link?:ValueTypes["StringCondition"] | null,
	targetBlank?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["ContentReferenceImageWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentReferenceImageWhere"] | undefined | null)[],
	not?:ValueTypes["ContentReferenceImageWhere"] | null
};
	["AdWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	isBrandSectionVisible?:ValueTypes["BooleanCondition"] | null,
	isBlogPostSectionVisible?:ValueTypes["BooleanCondition"] | null,
	isIngredientSectionVisible?:ValueTypes["BooleanCondition"] | null,
	isResultsVisible?:ValueTypes["BooleanCondition"] | null,
	isSearchVisible?:ValueTypes["BooleanCondition"] | null,
	blogPosts?:ValueTypes["BlogPostWhere"] | null,
	itemCategories?:ValueTypes["ItemCategoryWhere"] | null,
	brands?:ValueTypes["BrandWhere"] | null,
	isActive?:ValueTypes["BooleanCondition"] | null,
	link?:ValueTypes["StringCondition"] | null,
	note?:ValueTypes["StringCondition"] | null,
	activeFrom?:ValueTypes["DateTimeCondition"] | null,
	activeUntil?:ValueTypes["DateTimeCondition"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	contentReferences?:ValueTypes["ContentReferenceWhere"] | null,
	and?:(ValueTypes["AdWhere"] | undefined | null)[],
	or?:(ValueTypes["AdWhere"] | undefined | null)[],
	not?:ValueTypes["AdWhere"] | null
};
	["BrandsPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	redirects?:ValueTypes["RedirectWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	draft?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["BrandsPageWhere"] | undefined | null)[],
	or?:(ValueTypes["BrandsPageWhere"] | undefined | null)[],
	not?:ValueTypes["BrandsPageWhere"] | null
};
	["ComparatorPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	redirects?:ValueTypes["RedirectWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["ComparatorPageWhere"] | undefined | null)[],
	or?:(ValueTypes["ComparatorPageWhere"] | undefined | null)[],
	not?:ValueTypes["ComparatorPageWhere"] | null
};
	["HomePageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["HomePageWhere"] | undefined | null)[],
	or?:(ValueTypes["HomePageWhere"] | undefined | null)[],
	not?:ValueTypes["HomePageWhere"] | null
};
	["IngredientsPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	draft?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["IngredientsPageWhere"] | undefined | null)[],
	or?:(ValueTypes["IngredientsPageWhere"] | undefined | null)[],
	not?:ValueTypes["IngredientsPageWhere"] | null
};
	["LoginPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["LoginPageWhere"] | undefined | null)[],
	or?:(ValueTypes["LoginPageWhere"] | undefined | null)[],
	not?:ValueTypes["LoginPageWhere"] | null
};
	["RegisterPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["RegisterPageWhere"] | undefined | null)[],
	or?:(ValueTypes["RegisterPageWhere"] | undefined | null)[],
	not?:ValueTypes["RegisterPageWhere"] | null
};
	["SearchPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["SearchPageWhere"] | undefined | null)[],
	or?:(ValueTypes["SearchPageWhere"] | undefined | null)[],
	not?:ValueTypes["SearchPageWhere"] | null
};
	["WizardPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	redirects?:ValueTypes["RedirectWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["WizardPageWhere"] | undefined | null)[],
	or?:(ValueTypes["WizardPageWhere"] | undefined | null)[],
	not?:ValueTypes["WizardPageWhere"] | null
};
	["ContactPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	redirects?:ValueTypes["RedirectWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	draft?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["ContactPageWhere"] | undefined | null)[],
	or?:(ValueTypes["ContactPageWhere"] | undefined | null)[],
	not?:ValueTypes["ContactPageWhere"] | null
};
	["GroupTypeCondition"]: {
	and?:ValueTypes["GroupTypeCondition"][],
	or?:ValueTypes["GroupTypeCondition"][],
	not?:ValueTypes["GroupTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["GroupType"] | null,
	notEq?:ValueTypes["GroupType"] | null,
	in?:ValueTypes["GroupType"][],
	notIn?:ValueTypes["GroupType"][],
	lt?:ValueTypes["GroupType"] | null,
	lte?:ValueTypes["GroupType"] | null,
	gt?:ValueTypes["GroupType"] | null,
	gte?:ValueTypes["GroupType"] | null
};
	["GroupType"]:GroupType;
	["AgeCategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	labelFor?:ValueTypes["StringCondition"] | null,
	products?:ValueTypes["ProductWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	filterCombos?:ValueTypes["FilterComboWhere"] | null,
	and?:(ValueTypes["AgeCategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["AgeCategoryWhere"] | undefined | null)[],
	not?:ValueTypes["AgeCategoryWhere"] | null
};
	["ProductionMethodWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	brands?:ValueTypes["BrandWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ProductionMethodWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductionMethodWhere"] | undefined | null)[],
	not?:ValueTypes["ProductionMethodWhere"] | null
};
	["BrandDistributorWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	brands?:ValueTypes["BrandWhere"] | null,
	link?:ValueTypes["StringCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["BrandDistributorWhere"] | undefined | null)[],
	or?:(ValueTypes["BrandDistributorWhere"] | undefined | null)[],
	not?:ValueTypes["BrandDistributorWhere"] | null
};
	["BrandAliasWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	brand?:ValueTypes["BrandWhere"] | null,
	and?:(ValueTypes["BrandAliasWhere"] | undefined | null)[],
	or?:(ValueTypes["BrandAliasWhere"] | undefined | null)[],
	not?:ValueTypes["BrandAliasWhere"] | null
};
	["BrandFlavorWhere"]: {
	id?:ValueTypes["StringCondition"] | null,
	brand?:ValueTypes["BrandWhere"] | null,
	itemSubCategory?:ValueTypes["ItemSubCategoryWhere"] | null,
	and?:(ValueTypes["BrandFlavorWhere"] | undefined | null)[],
	or?:(ValueTypes["BrandFlavorWhere"] | undefined | null)[],
	not?:ValueTypes["BrandFlavorWhere"] | null
};
	["TOPXBrandWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	orderType?:ValueTypes["TOPXBrandOrderTypeCondition"] | null,
	brand?:ValueTypes["BrandWhere"] | null,
	category?:ValueTypes["TOPXBrandCategoryWhere"] | null,
	and?:(ValueTypes["TOPXBrandWhere"] | undefined | null)[],
	or?:(ValueTypes["TOPXBrandWhere"] | undefined | null)[],
	not?:ValueTypes["TOPXBrandWhere"] | null
};
	["TOPXBrandOrderTypeCondition"]: {
	and?:ValueTypes["TOPXBrandOrderTypeCondition"][],
	or?:ValueTypes["TOPXBrandOrderTypeCondition"][],
	not?:ValueTypes["TOPXBrandOrderTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["TOPXBrandOrderType"] | null,
	notEq?:ValueTypes["TOPXBrandOrderType"] | null,
	in?:ValueTypes["TOPXBrandOrderType"][],
	notIn?:ValueTypes["TOPXBrandOrderType"][],
	lt?:ValueTypes["TOPXBrandOrderType"] | null,
	lte?:ValueTypes["TOPXBrandOrderType"] | null,
	gt?:ValueTypes["TOPXBrandOrderType"] | null,
	gte?:ValueTypes["TOPXBrandOrderType"] | null
};
	["TOPXBrandOrderType"]:TOPXBrandOrderType;
	["TOPXBrandCategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	brands?:ValueTypes["TOPXBrandWhere"] | null,
	and?:(ValueTypes["TOPXBrandCategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["TOPXBrandCategoryWhere"] | undefined | null)[],
	not?:ValueTypes["TOPXBrandCategoryWhere"] | null
};
	["ProductLineAliasWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	productLines?:ValueTypes["ProductLineWhere"] | null,
	and?:(ValueTypes["ProductLineAliasWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductLineAliasWhere"] | undefined | null)[],
	not?:ValueTypes["ProductLineAliasWhere"] | null
};
	["ProductLineFlavorWhere"]: {
	id?:ValueTypes["StringCondition"] | null,
	itemSubCategory?:ValueTypes["ItemSubCategoryWhere"] | null,
	productLine?:ValueTypes["ProductLineWhere"] | null,
	and?:(ValueTypes["ProductLineFlavorWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductLineFlavorWhere"] | undefined | null)[],
	not?:ValueTypes["ProductLineFlavorWhere"] | null
};
	["DogActivityWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	dogs?:ValueTypes["DogWhere"] | null,
	products?:ValueTypes["ProductWhere"] | null,
	dailyEnergyRequirementCoeficient?:ValueTypes["FloatCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	suitabilityCategory?:ValueTypes["SuitabilityCategoryWhere"] | null,
	and?:(ValueTypes["DogActivityWhere"] | undefined | null)[],
	or?:(ValueTypes["DogActivityWhere"] | undefined | null)[],
	not?:ValueTypes["DogActivityWhere"] | null
};
	["ProductAliasWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	product?:ValueTypes["ProductWhere"] | null,
	and?:(ValueTypes["ProductAliasWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductAliasWhere"] | undefined | null)[],
	not?:ValueTypes["ProductAliasWhere"] | null
};
	["ContentAmountCondition"]: {
	and?:ValueTypes["ContentAmountCondition"][],
	or?:ValueTypes["ContentAmountCondition"][],
	not?:ValueTypes["ContentAmountCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentAmount"] | null,
	notEq?:ValueTypes["ContentAmount"] | null,
	in?:ValueTypes["ContentAmount"][],
	notIn?:ValueTypes["ContentAmount"][],
	lt?:ValueTypes["ContentAmount"] | null,
	lte?:ValueTypes["ContentAmount"] | null,
	gt?:ValueTypes["ContentAmount"] | null,
	gte?:ValueTypes["ContentAmount"] | null
};
	["ContentAmount"]:ContentAmount;
	["ProductEvaluationWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	nazev?:ValueTypes["StringCondition"] | null,
	vetDieta?:ValueTypes["StringCondition"] | null,
	vetDieta1?:ValueTypes["StringCondition"] | null,
	vetDieta2?:ValueTypes["StringCondition"] | null,
	aktivita?:ValueTypes["StringCondition"] | null,
	vek?:ValueTypes["StringCondition"] | null,
	velikostPlemen?:ValueTypes["StringCondition"] | null,
	hmotnostPlemene?:ValueTypes["StringCondition"] | null,
	velikostGranuli?:ValueTypes["StringCondition"] | null,
	velikostGranuliText?:ValueTypes["StringCondition"] | null,
	doporucenaAktivitaDleMe?:ValueTypes["StringCondition"] | null,
	vypocitanaMeVsMeVyrobce?:ValueTypes["StringCondition"] | null,
	vypocitanaMeVsMeVyrobce2?:ValueTypes["StringCondition"] | null,
	masoNaPrvnimMisteText?:ValueTypes["StringCondition"] | null,
	zdrojeZivocisnychBilkovinDle1Vyskytu?:ValueTypes["StringCondition"] | null,
	prichuteSeznam?:ValueTypes["StringCondition"] | null,
	eliminacniDietaTextInterpunkce?:ValueTypes["StringCondition"] | null,
	alergenyZadneNeobsahuje?:ValueTypes["StringCondition"] | null,
	alergenyObsahuje?:ValueTypes["StringCondition"] | null,
	alergenyNejakeNeobsahuje?:ValueTypes["StringCondition"] | null,
	prospesneDruhyInterpunkce?:ValueTypes["StringCondition"] | null,
	nevhodneDruhy?:ValueTypes["StringCondition"] | null,
	kladneUcinkyCeleTelo?:ValueTypes["StringCondition"] | null,
	kladneUcinkyHlava?:ValueTypes["StringCondition"] | null,
	kladneUcinkyHrudnik?:ValueTypes["StringCondition"] | null,
	kladneUcinkyBricho?:ValueTypes["StringCondition"] | null,
	kladneUcinkySpodniCast?:ValueTypes["StringCondition"] | null,
	zaporneUcinkyCeleTelo?:ValueTypes["StringCondition"] | null,
	zaporneUcinkyHlava?:ValueTypes["StringCondition"] | null,
	zaporneUcinkyHrudnik?:ValueTypes["StringCondition"] | null,
	zaporneUcinkyBricho?:ValueTypes["StringCondition"] | null,
	zaporneUcinkySpodniCast?:ValueTypes["StringCondition"] | null,
	dsneuvedeno?:ValueTypes["StringCondition"] | null,
	dsmalo?:ValueTypes["StringCondition"] | null,
	dsprilis?:ValueTypes["StringCondition"] | null,
	dsok?:ValueTypes["StringCondition"] | null,
	d95malo?:ValueTypes["StringCondition"] | null,
	d95prilis?:ValueTypes["StringCondition"] | null,
	d95ok?:ValueTypes["StringCondition"] | null,
	d110malo?:ValueTypes["StringCondition"] | null,
	d110prilis?:ValueTypes["StringCondition"] | null,
	d110ok?:ValueTypes["StringCondition"] | null,
	sdo14reproMalo?:ValueTypes["StringCondition"] | null,
	sdo14reproPrilis?:ValueTypes["StringCondition"] | null,
	sdo14reproOk?:ValueTypes["StringCondition"] | null,
	sdo15malo?:ValueTypes["StringCondition"] | null,
	sdo15prilis?:ValueTypes["StringCondition"] | null,
	sdo15ok?:ValueTypes["StringCondition"] | null,
	s15malo?:ValueTypes["StringCondition"] | null,
	s15prilis?:ValueTypes["StringCondition"] | null,
	s15ok?:ValueTypes["StringCondition"] | null,
	product?:ValueTypes["ProductWhere"] | null,
	masoAnoNe?:ValueTypes["StringCondition"] | null,
	eliminacniDietaAnoNe?:ValueTypes["StringCondition"] | null,
	alergenyAnoNe?:ValueTypes["StringCondition"] | null,
	plodnostKastraceNadpis?:ValueTypes["StringCondition"] | null,
	plodnostKastraceText?:ValueTypes["StringCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	stravitelnostNadpis?:ValueTypes["StringCondition"] | null,
	stravitelnostProcenta?:ValueTypes["StringCondition"] | null,
	stravitelnostSlovne?:ValueTypes["StringCondition"] | null,
	stravitelnostChybiText?:ValueTypes["StringCondition"] | null,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ProductEvaluationWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductEvaluationWhere"] | undefined | null)[],
	not?:ValueTypes["ProductEvaluationWhere"] | null
};
	["ProductItemDeclensionFourthCategoryWhere"]: {
	id?:ValueTypes["StringCondition"] | null,
	declensionFourthCategory?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,
	product?:ValueTypes["ProductWhere"] | null,
	and?:(ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | undefined | null)[],
	not?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null
};
	["ItemDeclensionFourthVariantWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["ItemWhere"] | null,
	label?:ValueTypes["StringCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	declensionSeventh?:ValueTypes["StringCondition"] | null,
	isNegativ?:ValueTypes["BooleanCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	subcategory?:ValueTypes["ItemSubCategoryWhere"] | null,
	category?:ValueTypes["ItemCategoryWhere"] | null,
	element?:ValueTypes["ElementWhere"] | null,
	products?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	draft?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["ItemDeclensionFourthVariantWhere"] | undefined | null)[],
	or?:(ValueTypes["ItemDeclensionFourthVariantWhere"] | undefined | null)[],
	not?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null
};
	["TOPXProductWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	orderType?:ValueTypes["TOPXProductOrderTypeCondition"] | null,
	product?:ValueTypes["ProductWhere"] | null,
	category?:ValueTypes["TOPXProductCategoryWhere"] | null,
	and?:(ValueTypes["TOPXProductWhere"] | undefined | null)[],
	or?:(ValueTypes["TOPXProductWhere"] | undefined | null)[],
	not?:ValueTypes["TOPXProductWhere"] | null
};
	["TOPXProductOrderTypeCondition"]: {
	and?:ValueTypes["TOPXProductOrderTypeCondition"][],
	or?:ValueTypes["TOPXProductOrderTypeCondition"][],
	not?:ValueTypes["TOPXProductOrderTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["TOPXProductOrderType"] | null,
	notEq?:ValueTypes["TOPXProductOrderType"] | null,
	in?:ValueTypes["TOPXProductOrderType"][],
	notIn?:ValueTypes["TOPXProductOrderType"][],
	lt?:ValueTypes["TOPXProductOrderType"] | null,
	lte?:ValueTypes["TOPXProductOrderType"] | null,
	gt?:ValueTypes["TOPXProductOrderType"] | null,
	gte?:ValueTypes["TOPXProductOrderType"] | null
};
	["TOPXProductOrderType"]:TOPXProductOrderType;
	["TOPXProductCategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	products?:ValueTypes["TOPXProductWhere"] | null,
	and?:(ValueTypes["TOPXProductCategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["TOPXProductCategoryWhere"] | undefined | null)[],
	not?:ValueTypes["TOPXProductCategoryWhere"] | null
};
	["SizeTypeCondition"]: {
	and?:ValueTypes["SizeTypeCondition"][],
	or?:ValueTypes["SizeTypeCondition"][],
	not?:ValueTypes["SizeTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["SizeType"] | null,
	notEq?:ValueTypes["SizeType"] | null,
	in?:ValueTypes["SizeType"][],
	notIn?:ValueTypes["SizeType"][],
	lt?:ValueTypes["SizeType"] | null,
	lte?:ValueTypes["SizeType"] | null,
	gt?:ValueTypes["SizeType"] | null,
	gte?:ValueTypes["SizeType"] | null
};
	["SizeType"]:SizeType;
	["DogBodyTypeWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	dogs?:ValueTypes["DogWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	value?:ValueTypes["IntCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	category?:ValueTypes["DogBodyTypeCategoryWhere"] | null,
	imageMain?:ValueTypes["ImageWhere"] | null,
	imageFrom?:ValueTypes["ImageWhere"] | null,
	imageTo?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["DogBodyTypeWhere"] | undefined | null)[],
	or?:(ValueTypes["DogBodyTypeWhere"] | undefined | null)[],
	not?:ValueTypes["DogBodyTypeWhere"] | null
};
	["DogBodyTypeCategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	items?:ValueTypes["DogBodyTypeWhere"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	imageMain?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["DogBodyTypeCategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["DogBodyTypeCategoryWhere"] | undefined | null)[],
	not?:ValueTypes["DogBodyTypeCategoryWhere"] | null
};
	["DogReproductionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["DogReproductionTypeCondition"] | null,
	breastfeedingPuppyCount?:ValueTypes["IntCondition"] | null,
	pregnancy?:ValueTypes["PregnantPeriodTypeCondition"] | null,
	dog?:ValueTypes["DogWhere"] | null,
	breastfeedingCategory?:ValueTypes["BreastfeedingCategoryWhere"] | null,
	and?:(ValueTypes["DogReproductionWhere"] | undefined | null)[],
	or?:(ValueTypes["DogReproductionWhere"] | undefined | null)[],
	not?:ValueTypes["DogReproductionWhere"] | null
};
	["DogReproductionTypeCondition"]: {
	and?:ValueTypes["DogReproductionTypeCondition"][],
	or?:ValueTypes["DogReproductionTypeCondition"][],
	not?:ValueTypes["DogReproductionTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["DogReproductionType"] | null,
	notEq?:ValueTypes["DogReproductionType"] | null,
	in?:ValueTypes["DogReproductionType"][],
	notIn?:ValueTypes["DogReproductionType"][],
	lt?:ValueTypes["DogReproductionType"] | null,
	lte?:ValueTypes["DogReproductionType"] | null,
	gt?:ValueTypes["DogReproductionType"] | null,
	gte?:ValueTypes["DogReproductionType"] | null
};
	["DogReproductionType"]:DogReproductionType;
	["PregnantPeriodTypeCondition"]: {
	and?:ValueTypes["PregnantPeriodTypeCondition"][],
	or?:ValueTypes["PregnantPeriodTypeCondition"][],
	not?:ValueTypes["PregnantPeriodTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["PregnantPeriodType"] | null,
	notEq?:ValueTypes["PregnantPeriodType"] | null,
	in?:ValueTypes["PregnantPeriodType"][],
	notIn?:ValueTypes["PregnantPeriodType"][],
	lt?:ValueTypes["PregnantPeriodType"] | null,
	lte?:ValueTypes["PregnantPeriodType"] | null,
	gt?:ValueTypes["PregnantPeriodType"] | null,
	gte?:ValueTypes["PregnantPeriodType"] | null
};
	["PregnantPeriodType"]:PregnantPeriodType;
	["BreastfeedingCategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	week?:ValueTypes["IntCondition"] | null,
	coeficient?:ValueTypes["FloatCondition"] | null,
	dogs?:ValueTypes["DogReproductionWhere"] | null,
	and?:(ValueTypes["BreastfeedingCategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["BreastfeedingCategoryWhere"] | undefined | null)[],
	not?:ValueTypes["BreastfeedingCategoryWhere"] | null
};
	["VeterinaryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	user?:ValueTypes["UserWhere"] | null,
	and?:(ValueTypes["VeterinaryWhere"] | undefined | null)[],
	or?:(ValueTypes["VeterinaryWhere"] | undefined | null)[],
	not?:ValueTypes["VeterinaryWhere"] | null
};
	["ContactFormMessageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	message?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	receivedAt?:ValueTypes["DateTimeCondition"] | null,
	user?:ValueTypes["UserWhere"] | null,
	isResolved?:ValueTypes["BooleanCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ContactFormMessageWhere"] | undefined | null)[],
	or?:(ValueTypes["ContactFormMessageWhere"] | undefined | null)[],
	not?:ValueTypes["ContactFormMessageWhere"] | null
};
	["BugReportWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	message?:ValueTypes["StringCondition"] | null,
	receivedAt?:ValueTypes["DateTimeCondition"] | null,
	isResolved?:ValueTypes["BooleanCondition"] | null,
	user?:ValueTypes["UserWhere"] | null,
	url?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["BugReportWhere"] | undefined | null)[],
	or?:(ValueTypes["BugReportWhere"] | undefined | null)[],
	not?:ValueTypes["BugReportWhere"] | null
};
	["ProtectedActionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["ProtectedActionTypeCondition"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	usedAt?:ValueTypes["DateTimeCondition"] | null,
	expiresAt?:ValueTypes["DateTimeCondition"] | null,
	publicKey?:ValueTypes["StringCondition"] | null,
	secretHash?:ValueTypes["StringCondition"] | null,
	verifyEmail?:ValueTypes["StringCondition"] | null,
	createdMetadata?:ValueTypes["JsonCondition"] | null,
	usedMetadata?:ValueTypes["JsonCondition"] | null,
	user?:ValueTypes["UserWhere"] | null,
	and?:(ValueTypes["ProtectedActionWhere"] | undefined | null)[],
	or?:(ValueTypes["ProtectedActionWhere"] | undefined | null)[],
	not?:ValueTypes["ProtectedActionWhere"] | null
};
	["ProtectedActionTypeCondition"]: {
	and?:ValueTypes["ProtectedActionTypeCondition"][],
	or?:ValueTypes["ProtectedActionTypeCondition"][],
	not?:ValueTypes["ProtectedActionTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ProtectedActionType"] | null,
	notEq?:ValueTypes["ProtectedActionType"] | null,
	in?:ValueTypes["ProtectedActionType"][],
	notIn?:ValueTypes["ProtectedActionType"][],
	lt?:ValueTypes["ProtectedActionType"] | null,
	lte?:ValueTypes["ProtectedActionType"] | null,
	gt?:ValueTypes["ProtectedActionType"] | null,
	gte?:ValueTypes["ProtectedActionType"] | null
};
	["ProtectedActionType"]:ProtectedActionType;
	["JsonCondition"]: {
	and?:ValueTypes["JsonCondition"][],
	or?:ValueTypes["JsonCondition"][],
	not?:ValueTypes["JsonCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null
};
	["TenantPersonWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	identityId?:ValueTypes["UUIDCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	roles?:ValueTypes["StringCondition"] | null,
	user?:ValueTypes["UserWhere"] | null,
	and?:(ValueTypes["TenantPersonWhere"] | undefined | null)[],
	or?:(ValueTypes["TenantPersonWhere"] | undefined | null)[],
	not?:ValueTypes["TenantPersonWhere"] | null
};
	["BlogPostReviewStatsWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	total?:ValueTypes["IntCondition"] | null,
	positive?:ValueTypes["IntCondition"] | null,
	negative?:ValueTypes["IntCondition"] | null,
	blogPostReview?:ValueTypes["BlogPostReviewWhere"] | null,
	and?:(ValueTypes["BlogPostReviewStatsWhere"] | undefined | null)[],
	or?:(ValueTypes["BlogPostReviewStatsWhere"] | undefined | null)[],
	not?:ValueTypes["BlogPostReviewStatsWhere"] | null
};
	["ReferenceListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	references?:ValueTypes["ReferenceWhere"] | null,
	and?:(ValueTypes["ReferenceListWhere"] | undefined | null)[],
	or?:(ValueTypes["ReferenceListWhere"] | undefined | null)[],
	not?:ValueTypes["ReferenceListWhere"] | null
};
	["ReferenceWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["ReferenceListWhere"] | null,
	and?:(ValueTypes["ReferenceWhere"] | undefined | null)[],
	or?:(ValueTypes["ReferenceWhere"] | undefined | null)[],
	not?:ValueTypes["ReferenceWhere"] | null
};
	["ItemDeclensionSeventhVariantWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["ItemWhere"] | null,
	label?:ValueTypes["StringCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ItemDeclensionSeventhVariantWhere"] | undefined | null)[],
	or?:(ValueTypes["ItemDeclensionSeventhVariantWhere"] | undefined | null)[],
	not?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null
};
	["ItemAliasWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	item?:ValueTypes["ItemWhere"] | null,
	and?:(ValueTypes["ItemAliasWhere"] | undefined | null)[],
	or?:(ValueTypes["ItemAliasWhere"] | undefined | null)[],
	not?:ValueTypes["ItemAliasWhere"] | null
};
	["ItemGroupWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	categories?:ValueTypes["ItemCategoryWhere"] | null,
	and?:(ValueTypes["ItemGroupWhere"] | undefined | null)[],
	or?:(ValueTypes["ItemGroupWhere"] | undefined | null)[],
	not?:ValueTypes["ItemGroupWhere"] | null
};
	["RedirectOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	to?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	from?:ValueTypes["OrderDirection"] | null,
	genericPage?:ValueTypes["GenericPageOrderBy"] | null,
	itemCategory?:ValueTypes["ItemCategoryOrderBy"] | null,
	brandsPage?:ValueTypes["BrandsPageOrderBy"] | null,
	blogPage?:ValueTypes["BlogPageOrderBy"] | null,
	contactPage?:ValueTypes["ContactPageOrderBy"] | null,
	wizardPage?:ValueTypes["WizardPageOrderBy"] | null,
	comparatorPage?:ValueTypes["ComparatorPageOrderBy"] | null,
	blogPost?:ValueTypes["BlogPostOrderBy"] | null
};
	["OrderDirection"]:OrderDirection;
	["GenericPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	draft?:ValueTypes["ContentOrderBy"] | null
};
	["LinkableOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	genericPage?:ValueTypes["GenericPageOrderBy"] | null
};
	["SeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	ogTitle?:ValueTypes["OrderDirection"] | null,
	ogDescription?:ValueTypes["OrderDirection"] | null,
	ogImage?:ValueTypes["ImageOrderBy"] | null,
	blogPage?:ValueTypes["BlogPageOrderBy"] | null,
	brandsPage?:ValueTypes["BrandsPageOrderBy"] | null,
	comparatorPage?:ValueTypes["ComparatorPageOrderBy"] | null,
	genericPage?:ValueTypes["GenericPageOrderBy"] | null,
	homePage?:ValueTypes["HomePageOrderBy"] | null,
	ingredientsPage?:ValueTypes["IngredientsPageOrderBy"] | null,
	loginPage?:ValueTypes["LoginPageOrderBy"] | null,
	registerPage?:ValueTypes["RegisterPageOrderBy"] | null,
	searchPage?:ValueTypes["SearchPageOrderBy"] | null,
	wizardPage?:ValueTypes["WizardPageOrderBy"] | null,
	contactPage?:ValueTypes["ContactPageOrderBy"] | null,
	group?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null
};
	["ImageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	alt?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	hash?:ValueTypes["OrderDirection"] | null
};
	["BlogPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	draft?:ValueTypes["ContentOrderBy"] | null
};
	["ContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["BrandsPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	draft?:ValueTypes["ContentOrderBy"] | null
};
	["ComparatorPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["HomePageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["IngredientsPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	draft?:ValueTypes["ContentOrderBy"] | null
};
	["LoginPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["RegisterPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["SearchPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["WizardPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["ContactPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	draft?:ValueTypes["ContentOrderBy"] | null
};
	["ItemCategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	shortDescription?:ValueTypes["OrderDirection"] | null,
	declensionSixth?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	comparatorGroupId?:ValueTypes["OrderDirection"] | null,
	slug?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	group?:ValueTypes["ItemGroupOrderBy"] | null,
	declensionSeventh?:ValueTypes["OrderDirection"] | null,
	slugWith?:ValueTypes["OrderDirection"] | null,
	slugWithNegative?:ValueTypes["OrderDirection"] | null,
	declensionSeventhNegative?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	draft?:ValueTypes["ContentOrderBy"] | null
};
	["ItemGroupOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null
};
	["BlogPostOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	author?:ValueTypes["OrderDirection"] | null,
	readingTime?:ValueTypes["OrderDirection"] | null,
	publishedAt?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	listedOnHomePage?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	referenceList?:ValueTypes["ReferenceListOrderBy"] | null,
	user?:ValueTypes["UserOrderBy"] | null,
	isComparatorLinked?:ValueTypes["OrderDirection"] | null,
	slug?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null,
	note?:ValueTypes["OrderDirection"] | null,
	isActive?:ValueTypes["OrderDirection"] | null,
	automated?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	draft?:ValueTypes["ContentOrderBy"] | null,
	slugInternal?:ValueTypes["OrderDirection"] | null
};
	["ReferenceListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["UserOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	veterinary?:ValueTypes["VeterinaryOrderBy"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	tenantPersonId?:ValueTypes["OrderDirection"] | null,
	fullName?:ValueTypes["OrderDirection"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null,
	verifiedAt?:ValueTypes["OrderDirection"] | null,
	avatar?:ValueTypes["ImageOrderBy"] | null,
	verifiedEmail?:ValueTypes["OrderDirection"] | null,
	blockedAt?:ValueTypes["OrderDirection"] | null,
	tenantPerson?:ValueTypes["TenantPersonOrderBy"] | null,
	note?:ValueTypes["OrderDirection"] | null
};
	["VeterinaryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	user?:ValueTypes["UserOrderBy"] | null
};
	["TenantPersonOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	identityId?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	roles?:ValueTypes["OrderDirection"] | null,
	user?:ValueTypes["UserOrderBy"] | null
};
	["Seo"]: AliasType<{
	_meta?:ValueTypes["SeoMeta"],
	id?:boolean,
	title?:boolean,
	description?:boolean,
	ogTitle?:boolean,
	ogDescription?:boolean,
ogImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
blogPage?: [{	filter?:ValueTypes["BlogPageWhere"] | null},ValueTypes["BlogPage"]],
brandsPage?: [{	filter?:ValueTypes["BrandsPageWhere"] | null},ValueTypes["BrandsPage"]],
comparatorPage?: [{	filter?:ValueTypes["ComparatorPageWhere"] | null},ValueTypes["ComparatorPage"]],
genericPage?: [{	filter?:ValueTypes["GenericPageWhere"] | null},ValueTypes["GenericPage"]],
homePage?: [{	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
ingredientsPage?: [{	filter?:ValueTypes["IngredientsPageWhere"] | null},ValueTypes["IngredientsPage"]],
loginPage?: [{	filter?:ValueTypes["LoginPageWhere"] | null},ValueTypes["LoginPage"]],
registerPage?: [{	filter?:ValueTypes["RegisterPageWhere"] | null},ValueTypes["RegisterPage"]],
searchPage?: [{	filter?:ValueTypes["SearchPageWhere"] | null},ValueTypes["SearchPage"]],
wizardPage?: [{	filter?:ValueTypes["WizardPageWhere"] | null},ValueTypes["WizardPage"]],
contactPage?: [{	filter?:ValueTypes["ContactPageWhere"] | null},ValueTypes["ContactPage"]],
	group?:boolean,
	url?:boolean,
		__typename?: boolean
}>;
	["SeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
	blogPage?:ValueTypes["FieldMeta"],
	brandsPage?:ValueTypes["FieldMeta"],
	comparatorPage?:ValueTypes["FieldMeta"],
	genericPage?:ValueTypes["FieldMeta"],
	homePage?:ValueTypes["FieldMeta"],
	ingredientsPage?:ValueTypes["FieldMeta"],
	loginPage?:ValueTypes["FieldMeta"],
	registerPage?:ValueTypes["FieldMeta"],
	searchPage?:ValueTypes["FieldMeta"],
	wizardPage?:ValueTypes["FieldMeta"],
	contactPage?:ValueTypes["FieldMeta"],
	group?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Image"]: AliasType<{
	_meta?:ValueTypes["ImageMeta"],
	id?:boolean,
	url?:boolean,
	width?:boolean,
	height?:boolean,
	size?:boolean,
	type?:boolean,
	alt?:boolean,
	remoteId?:boolean,
	hash?:boolean,
		__typename?: boolean
}>;
	["ImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	alt?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	hash?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BrandsPage"]: AliasType<{
	_meta?:ValueTypes["BrandsPageMeta"],
	id?:boolean,
	unique?:boolean,
	title?:boolean,
redirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
draft?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
redirectsByFrom?: [{	by:ValueTypes["BrandsPageRedirectsByFromUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
paginateRedirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
		__typename?: boolean
}>;
	["BrandsPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	redirects?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	draft?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Content"]: AliasType<{
	_meta?:ValueTypes["ContentMeta"],
	id?:boolean,
blocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
blocksByAutomatedContentBlockSlug?: [{	by:ValueTypes["ContentBlocksByAutomatedContentBlockSlugUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
blocksByReferences?: [{	by:ValueTypes["ContentBlocksByReferencesUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
paginateBlocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
		__typename?: boolean
}>;
	["ContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	blocks?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentBlock"]: AliasType<{
	_meta?:ValueTypes["ContentBlockMeta"],
	id?:boolean,
	order?:boolean,
	json?:boolean,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
references?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
	automatedContentBlockSlug?:boolean,
referencesByImages?: [{	by:ValueTypes["ContentBlockReferencesByImagesUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByLink?: [{	by:ValueTypes["ContentBlockReferencesByLinkUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByList?: [{	by:ValueTypes["ContentBlockReferencesByListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByOutline?: [{	by:ValueTypes["ContentBlockReferencesByOutlineUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByVideo?: [{	by:ValueTypes["ContentBlockReferencesByVideoUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByImage?: [{	by:ValueTypes["ContentBlockReferencesByImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
paginateReferences?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
		__typename?: boolean
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	json?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	references?:ValueTypes["FieldMeta"],
	automatedContentBlockSlug?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentReference"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceMeta"],
	id?:boolean,
	type?:boolean,
block?: [{	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
	primaryText?:boolean,
	secondaryText?:boolean,
	fact?:boolean,
images?: [{	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null,	orderBy?:ValueTypes["ContentReferenceGalleryImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReferenceGalleryImage"]],
relatedBlogPost?: [{	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
relatedBrand?: [{	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
relatedProduct?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
relatedIngredient?: [{	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
	badge?:boolean,
	longVersion?:boolean,
relatedBrandFull?: [{	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
relatedProductFull?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
list?: [{	filter?:ValueTypes["ContentReferenceListWhere"] | null,	orderBy?:ValueTypes["ContentReferenceListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReferenceList"]],
outline?: [{	filter?:ValueTypes["ContentLinksWhere"] | null},ValueTypes["ContentLinks"]],
video?: [{	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
image?: [{	filter?:ValueTypes["ContentReferenceImageWhere"] | null},ValueTypes["ContentReferenceImage"]],
	defaultOpen?:boolean,
	badgeColor?:boolean,
	isMain?:boolean,
ad?: [{	filter?:ValueTypes["AdWhere"] | null},ValueTypes["Ad"]],
paginateImages?: [{	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null,	orderBy?:ValueTypes["ContentReferenceGalleryImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceGalleryImageConnection"]],
paginateList?: [{	filter?:ValueTypes["ContentReferenceListWhere"] | null,	orderBy?:ValueTypes["ContentReferenceListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceListConnection"]],
		__typename?: boolean
}>;
	["ContentReferenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	block?:ValueTypes["FieldMeta"],
	primaryText?:ValueTypes["FieldMeta"],
	secondaryText?:ValueTypes["FieldMeta"],
	fact?:ValueTypes["FieldMeta"],
	images?:ValueTypes["FieldMeta"],
	relatedBlogPost?:ValueTypes["FieldMeta"],
	relatedBrand?:ValueTypes["FieldMeta"],
	relatedProduct?:ValueTypes["FieldMeta"],
	relatedIngredient?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	badge?:ValueTypes["FieldMeta"],
	longVersion?:ValueTypes["FieldMeta"],
	relatedBrandFull?:ValueTypes["FieldMeta"],
	relatedProductFull?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	outline?:ValueTypes["FieldMeta"],
	video?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	defaultOpen?:ValueTypes["FieldMeta"],
	badgeColor?:ValueTypes["FieldMeta"],
	isMain?:ValueTypes["FieldMeta"],
	ad?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentReferenceGalleryImage"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceGalleryImageMeta"],
	id?:boolean,
	order?:boolean,
reference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	lead?:boolean,
	alignment?:boolean,
		__typename?: boolean
}>;
	["ContentReferenceGalleryImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	reference?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	alignment?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentReferenceGalleryImageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	reference?:ValueTypes["ContentReferenceOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	alignment?:ValueTypes["OrderDirection"] | null
};
	["ContentReferenceOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	block?:ValueTypes["ContentBlockOrderBy"] | null,
	primaryText?:ValueTypes["OrderDirection"] | null,
	secondaryText?:ValueTypes["OrderDirection"] | null,
	fact?:ValueTypes["OrderDirection"] | null,
	relatedBlogPost?:ValueTypes["BlogPostOrderBy"] | null,
	relatedBrand?:ValueTypes["BrandOrderBy"] | null,
	relatedProduct?:ValueTypes["ProductOrderBy"] | null,
	relatedIngredient?:ValueTypes["ItemOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	badge?:ValueTypes["OrderDirection"] | null,
	longVersion?:ValueTypes["OrderDirection"] | null,
	relatedBrandFull?:ValueTypes["BrandOrderBy"] | null,
	relatedProductFull?:ValueTypes["ProductOrderBy"] | null,
	outline?:ValueTypes["ContentLinksOrderBy"] | null,
	video?:ValueTypes["VideoOrderBy"] | null,
	image?:ValueTypes["ContentReferenceImageOrderBy"] | null,
	defaultOpen?:ValueTypes["OrderDirection"] | null,
	badgeColor?:ValueTypes["OrderDirection"] | null,
	isMain?:ValueTypes["OrderDirection"] | null,
	ad?:ValueTypes["AdOrderBy"] | null
};
	["ContentBlockOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	json?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	automatedContentBlockSlug?:ValueTypes["OrderDirection"] | null
};
	["BrandOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	promotedOnSearchPlace?:ValueTypes["OrderDirection"] | null,
	promotedOnBrandsPagePlace?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null,
	methodOfProduction?:ValueTypes["ProductionMethodOrderBy"] | null,
	distributor?:ValueTypes["BrandDistributorOrderBy"] | null,
	slug?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	customMetaDescription?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	draft?:ValueTypes["ContentOrderBy"] | null
};
	["ProductionMethodOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null
};
	["BrandDistributorOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null
};
	["ProductOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	score?:ValueTypes["OrderDirection"] | null,
	firstFiveItems?:ValueTypes["OrderDirection"] | null,
	detailedComposition?:ValueTypes["OrderDirection"] | null,
	guaranteedAnalysis?:ValueTypes["OrderDirection"] | null,
	isVeterinaryDiet?:ValueTypes["OrderDirection"] | null,
	isSearchVisible?:ValueTypes["OrderDirection"] | null,
	isSuitableForEliminationDiet?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	productLine?:ValueTypes["ProductLineOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	recommendedActivity?:ValueTypes["DogActivityOrderBy"] | null,
	brand?:ValueTypes["BrandOrderBy"] | null,
	metabolizedEnergy?:ValueTypes["OrderDirection"] | null,
	cheapnessValue?:ValueTypes["OrderDirection"] | null,
	slug?:ValueTypes["OrderDirection"] | null,
	animalProteinStatus?:ValueTypes["OrderDirection"] | null,
	carbohydrateStatus?:ValueTypes["OrderDirection"] | null,
	evaluation?:ValueTypes["ProductEvaluationOrderBy"] | null,
	missingComposition?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	czkPerMetabolizedEnergy?:ValueTypes["OrderDirection"] | null,
	customMetaTitle?:ValueTypes["OrderDirection"] | null,
	customMetaDescription?:ValueTypes["OrderDirection"] | null,
	isSuitableForCastrated?:ValueTypes["OrderDirection"] | null,
	heurekaImage?:ValueTypes["ImageOrderBy"] | null
};
	["ProductLineOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	brand?:ValueTypes["BrandOrderBy"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null,
	slug?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	customMetaDescription?:ValueTypes["OrderDirection"] | null
};
	["DogActivityOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	dailyEnergyRequirementCoeficient?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	suitabilityCategory?:ValueTypes["SuitabilityCategoryOrderBy"] | null
};
	["SuitabilityCategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	isPregnant?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	isBreastfeeding?:ValueTypes["OrderDirection"] | null
};
	["ProductEvaluationOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	nazev?:ValueTypes["OrderDirection"] | null,
	vetDieta?:ValueTypes["OrderDirection"] | null,
	vetDieta1?:ValueTypes["OrderDirection"] | null,
	vetDieta2?:ValueTypes["OrderDirection"] | null,
	aktivita?:ValueTypes["OrderDirection"] | null,
	vek?:ValueTypes["OrderDirection"] | null,
	velikostPlemen?:ValueTypes["OrderDirection"] | null,
	hmotnostPlemene?:ValueTypes["OrderDirection"] | null,
	velikostGranuli?:ValueTypes["OrderDirection"] | null,
	velikostGranuliText?:ValueTypes["OrderDirection"] | null,
	doporucenaAktivitaDleMe?:ValueTypes["OrderDirection"] | null,
	vypocitanaMeVsMeVyrobce?:ValueTypes["OrderDirection"] | null,
	vypocitanaMeVsMeVyrobce2?:ValueTypes["OrderDirection"] | null,
	masoNaPrvnimMisteText?:ValueTypes["OrderDirection"] | null,
	zdrojeZivocisnychBilkovinDle1Vyskytu?:ValueTypes["OrderDirection"] | null,
	prichuteSeznam?:ValueTypes["OrderDirection"] | null,
	eliminacniDietaTextInterpunkce?:ValueTypes["OrderDirection"] | null,
	alergenyZadneNeobsahuje?:ValueTypes["OrderDirection"] | null,
	alergenyObsahuje?:ValueTypes["OrderDirection"] | null,
	alergenyNejakeNeobsahuje?:ValueTypes["OrderDirection"] | null,
	prospesneDruhyInterpunkce?:ValueTypes["OrderDirection"] | null,
	nevhodneDruhy?:ValueTypes["OrderDirection"] | null,
	kladneUcinkyCeleTelo?:ValueTypes["OrderDirection"] | null,
	kladneUcinkyHlava?:ValueTypes["OrderDirection"] | null,
	kladneUcinkyHrudnik?:ValueTypes["OrderDirection"] | null,
	kladneUcinkyBricho?:ValueTypes["OrderDirection"] | null,
	kladneUcinkySpodniCast?:ValueTypes["OrderDirection"] | null,
	zaporneUcinkyCeleTelo?:ValueTypes["OrderDirection"] | null,
	zaporneUcinkyHlava?:ValueTypes["OrderDirection"] | null,
	zaporneUcinkyHrudnik?:ValueTypes["OrderDirection"] | null,
	zaporneUcinkyBricho?:ValueTypes["OrderDirection"] | null,
	zaporneUcinkySpodniCast?:ValueTypes["OrderDirection"] | null,
	dsneuvedeno?:ValueTypes["OrderDirection"] | null,
	dsmalo?:ValueTypes["OrderDirection"] | null,
	dsprilis?:ValueTypes["OrderDirection"] | null,
	dsok?:ValueTypes["OrderDirection"] | null,
	d95malo?:ValueTypes["OrderDirection"] | null,
	d95prilis?:ValueTypes["OrderDirection"] | null,
	d95ok?:ValueTypes["OrderDirection"] | null,
	d110malo?:ValueTypes["OrderDirection"] | null,
	d110prilis?:ValueTypes["OrderDirection"] | null,
	d110ok?:ValueTypes["OrderDirection"] | null,
	sdo14reproMalo?:ValueTypes["OrderDirection"] | null,
	sdo14reproPrilis?:ValueTypes["OrderDirection"] | null,
	sdo14reproOk?:ValueTypes["OrderDirection"] | null,
	sdo15malo?:ValueTypes["OrderDirection"] | null,
	sdo15prilis?:ValueTypes["OrderDirection"] | null,
	sdo15ok?:ValueTypes["OrderDirection"] | null,
	s15malo?:ValueTypes["OrderDirection"] | null,
	s15prilis?:ValueTypes["OrderDirection"] | null,
	s15ok?:ValueTypes["OrderDirection"] | null,
	product?:ValueTypes["ProductOrderBy"] | null,
	masoAnoNe?:ValueTypes["OrderDirection"] | null,
	eliminacniDietaAnoNe?:ValueTypes["OrderDirection"] | null,
	alergenyAnoNe?:ValueTypes["OrderDirection"] | null,
	plodnostKastraceNadpis?:ValueTypes["OrderDirection"] | null,
	plodnostKastraceText?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	stravitelnostNadpis?:ValueTypes["OrderDirection"] | null,
	stravitelnostProcenta?:ValueTypes["OrderDirection"] | null,
	stravitelnostSlovne?:ValueTypes["OrderDirection"] | null,
	stravitelnostChybiText?:ValueTypes["OrderDirection"] | null,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?:ValueTypes["OrderDirection"] | null
};
	["ItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	animalProteinStatus?:ValueTypes["OrderDirection"] | null,
	carbohydrateStatus?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	referenceList?:ValueTypes["ReferenceListOrderBy"] | null,
	blogPost?:ValueTypes["BlogPostOrderBy"] | null,
	declensionFourth?:ValueTypes["ItemDeclensionFourthVariantOrderBy"] | null,
	declensionSeventh?:ValueTypes["ItemDeclensionSeventhVariantOrderBy"] | null,
	slug?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	draft?:ValueTypes["ContentOrderBy"] | null
};
	["ItemDeclensionFourthVariantOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	declensionSeventh?:ValueTypes["OrderDirection"] | null,
	isNegativ?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	subcategory?:ValueTypes["ItemSubCategoryOrderBy"] | null,
	category?:ValueTypes["ItemCategoryOrderBy"] | null,
	element?:ValueTypes["ElementOrderBy"] | null,
	slug?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	draft?:ValueTypes["ContentOrderBy"] | null
};
	["ItemSubCategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	isFlavorCategory?:ValueTypes["OrderDirection"] | null,
	isAllergenTag?:ValueTypes["OrderDirection"] | null,
	isMostCommonAllergenTag?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	category?:ValueTypes["ItemCategoryOrderBy"] | null,
	flavorCategory?:ValueTypes["ItemFlavorCategoryOrderBy"] | null,
	iconNegative?:ValueTypes["ImageOrderBy"] | null,
	negativeWording?:ValueTypes["OrderDirection"] | null,
	icon?:ValueTypes["ImageOrderBy"] | null,
	slug?:ValueTypes["OrderDirection"] | null,
	flavorSlug?:ValueTypes["OrderDirection"] | null,
	flavorDeclensionSeventh?:ValueTypes["OrderDirection"] | null,
	isFilterFlavor?:ValueTypes["OrderDirection"] | null
};
	["ItemFlavorCategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	color?:ValueTypes["ColorOrderBy"] | null
};
	["ColorOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	colorHex?:ValueTypes["OrderDirection"] | null,
	bodyTagCategory?:ValueTypes["BodyTagCategoryOrderBy"] | null,
	blogPostTag?:ValueTypes["BlogPostTagOrderBy"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null
};
	["BodyTagCategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	color?:ValueTypes["ColorOrderBy"] | null
};
	["BlogPostTagOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	color?:ValueTypes["ColorOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null
};
	["ElementOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	unit?:ValueTypes["OrderDirection"] | null,
	filterOrder?:ValueTypes["OrderDirection"] | null,
	slug?:ValueTypes["OrderDirection"] | null,
	declensionSeventh?:ValueTypes["OrderDirection"] | null
};
	["ItemDeclensionSeventhVariantOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null
};
	["LinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	externalLink?:ValueTypes["OrderDirection"] | null,
	isTargetBlank?:ValueTypes["OrderDirection"] | null
};
	["ContentLinksOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["VideoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	src?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	duration?:ValueTypes["OrderDirection"] | null,
	poster?:ValueTypes["ImageOrderBy"] | null
};
	["ContentReferenceImageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	alignment?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	link?:ValueTypes["OrderDirection"] | null,
	targetBlank?:ValueTypes["OrderDirection"] | null
};
	["AdOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	isBrandSectionVisible?:ValueTypes["OrderDirection"] | null,
	isBlogPostSectionVisible?:ValueTypes["OrderDirection"] | null,
	isIngredientSectionVisible?:ValueTypes["OrderDirection"] | null,
	isResultsVisible?:ValueTypes["OrderDirection"] | null,
	isSearchVisible?:ValueTypes["OrderDirection"] | null,
	isActive?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["OrderDirection"] | null,
	note?:ValueTypes["OrderDirection"] | null,
	activeFrom?:ValueTypes["OrderDirection"] | null,
	activeUntil?:ValueTypes["OrderDirection"] | null,
	slug?:ValueTypes["OrderDirection"] | null
};
	["BlogPost"]: AliasType<{
	_meta?:ValueTypes["BlogPostMeta"],
	id?:boolean,
	author?:boolean,
	readingTime?:boolean,
	publishedAt?:boolean,
blogPostTags?: [{	filter?:ValueTypes["BlogPostTagWhere"] | null,	orderBy?:ValueTypes["BlogPostTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostTag"]],
tags?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BodyTag"]],
	title?:boolean,
	listedOnHomePage?:boolean,
reviews?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostReview"]],
itemCategories?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemCategory"]],
items?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Item"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
referenceList?: [{	filter?:ValueTypes["ReferenceListWhere"] | null},ValueTypes["ReferenceList"]],
user?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
	isComparatorLinked?:boolean,
ads?: [{	filter?:ValueTypes["AdWhere"] | null,	orderBy?:ValueTypes["AdOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Ad"]],
	slug?:boolean,
	lead?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	createdAt?:boolean,
	note?:boolean,
	isActive?:boolean,
redirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
	automated?:boolean,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
draft?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
	slugInternal?:boolean,
reviewsByBlogPostReviewReactions?: [{	by:ValueTypes["BlogPostReviewsByBlogPostReviewReactionsUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReview"]],
reviewsByStats?: [{	by:ValueTypes["BlogPostReviewsByStatsUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReview"]],
itemsByRemoteId?: [{	by:ValueTypes["BlogPostItemsByRemoteIdUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsBySlug?: [{	by:ValueTypes["BlogPostItemsBySlugUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByFeaturesOfProduct?: [{	by:ValueTypes["BlogPostItemsByFeaturesOfProductUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByImage?: [{	by:ValueTypes["BlogPostItemsByImageUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByReferenceList?: [{	by:ValueTypes["BlogPostItemsByReferenceListUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsBySeo?: [{	by:ValueTypes["BlogPostItemsBySeoUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByAliases?: [{	by:ValueTypes["BlogPostItemsByAliasesUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByContent?: [{	by:ValueTypes["BlogPostItemsByContentUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByDraft?: [{	by:ValueTypes["BlogPostItemsByDraftUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
redirectsByFrom?: [{	by:ValueTypes["BlogPostRedirectsByFromUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
paginateBlogPostTags?: [{	filter?:ValueTypes["BlogPostTagWhere"] | null,	orderBy?:ValueTypes["BlogPostTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostTagConnection"]],
paginateTags?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BodyTagConnection"]],
paginateReviews?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostReviewConnection"]],
paginateItemCategories?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemCategoryConnection"]],
paginateItems?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemConnection"]],
paginateAds?: [{	filter?:ValueTypes["AdWhere"] | null,	orderBy?:ValueTypes["AdOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AdConnection"]],
paginateRedirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
		__typename?: boolean
}>;
	["BlogPostMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	author?:ValueTypes["FieldMeta"],
	readingTime?:ValueTypes["FieldMeta"],
	publishedAt?:ValueTypes["FieldMeta"],
	blogPostTags?:ValueTypes["FieldMeta"],
	tags?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	listedOnHomePage?:ValueTypes["FieldMeta"],
	reviews?:ValueTypes["FieldMeta"],
	itemCategories?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	referenceList?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	isComparatorLinked?:ValueTypes["FieldMeta"],
	ads?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	isActive?:ValueTypes["FieldMeta"],
	redirects?:ValueTypes["FieldMeta"],
	automated?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	draft?:ValueTypes["FieldMeta"],
	slugInternal?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BlogPostTag"]: AliasType<{
	_meta?:ValueTypes["BlogPostTagMeta"],
	id?:boolean,
	name?:boolean,
blogPosts?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPost"]],
	remoteId?:boolean,
color?: [{	filter?:ValueTypes["ColorWhere"] | null},ValueTypes["Color"]],
	order?:boolean,
paginateBlogPosts?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostConnection"]],
		__typename?: boolean
}>;
	["BlogPostTagMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	blogPosts?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Color"]: AliasType<{
	_meta?:ValueTypes["ColorMeta"],
	id?:boolean,
	name?:boolean,
	colorHex?:boolean,
bodyTagCategory?: [{	filter?:ValueTypes["BodyTagCategoryWhere"] | null},ValueTypes["BodyTagCategory"]],
blogPostTag?: [{	filter?:ValueTypes["BlogPostTagWhere"] | null},ValueTypes["BlogPostTag"]],
	remoteId?:boolean,
itemFlavorCategories?: [{	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null,	orderBy?:ValueTypes["ItemFlavorCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemFlavorCategory"]],
itemFlavorCategoriesByRemoteId?: [{	by:ValueTypes["ColorItemFlavorCategoriesByRemoteIdUniqueWhere"],	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null},ValueTypes["ItemFlavorCategory"]],
itemFlavorCategoriesByItems?: [{	by:ValueTypes["ColorItemFlavorCategoriesByItemsUniqueWhere"],	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null},ValueTypes["ItemFlavorCategory"]],
paginateItemFlavorCategories?: [{	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null,	orderBy?:ValueTypes["ItemFlavorCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemFlavorCategoryConnection"]],
		__typename?: boolean
}>;
	["ColorMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	colorHex?:ValueTypes["FieldMeta"],
	bodyTagCategory?:ValueTypes["FieldMeta"],
	blogPostTag?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	itemFlavorCategories?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BodyTagCategory"]: AliasType<{
	_meta?:ValueTypes["BodyTagCategoryMeta"],
	id?:boolean,
	name?:boolean,
tags?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BodyTag"]],
	remoteId?:boolean,
color?: [{	filter?:ValueTypes["ColorWhere"] | null},ValueTypes["Color"]],
tagsByRemoteId?: [{	by:ValueTypes["BodyTagCategoryTagsByRemoteIdUniqueWhere"],	filter?:ValueTypes["BodyTagWhere"] | null},ValueTypes["BodyTag"]],
tagsByFilterCombos?: [{	by:ValueTypes["BodyTagCategoryTagsByFilterCombosUniqueWhere"],	filter?:ValueTypes["BodyTagWhere"] | null},ValueTypes["BodyTag"]],
paginateTags?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BodyTagConnection"]],
		__typename?: boolean
}>;
	["BodyTagCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	tags?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BodyTag"]: AliasType<{
	_meta?:ValueTypes["BodyTagMeta"],
	id?:boolean,
	name?:boolean,
blogPosts?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPost"]],
positiveProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
negativeProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
positiveItems?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Item"]],
negativeItems?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Item"]],
	remoteId?:boolean,
category?: [{	filter?:ValueTypes["BodyTagCategoryWhere"] | null},ValueTypes["BodyTagCategory"]],
icon?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
dogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Dog"]],
	labelFor?:boolean,
	slug?:boolean,
filterCombos?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FilterCombo"]],
filterCombosByRemoteId?: [{	by:ValueTypes["BodyTagFilterCombosByRemoteIdUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
filterCombosBySeo?: [{	by:ValueTypes["BodyTagFilterCombosBySeoUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
paginateBlogPosts?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostConnection"]],
paginatePositiveProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
paginateNegativeProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
paginatePositiveItems?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemConnection"]],
paginateNegativeItems?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemConnection"]],
paginateDogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogConnection"]],
paginateFilterCombos?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilterComboConnection"]],
		__typename?: boolean
}>;
	["BodyTagMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	blogPosts?:ValueTypes["FieldMeta"],
	positiveProducts?:ValueTypes["FieldMeta"],
	negativeProducts?:ValueTypes["FieldMeta"],
	positiveItems?:ValueTypes["FieldMeta"],
	negativeItems?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
	dogs?:ValueTypes["FieldMeta"],
	labelFor?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	filterCombos?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Product"]: AliasType<{
	_meta?:ValueTypes["ProductMeta"],
	id?:boolean,
nutritionalValues?: [{	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null,	orderBy?:ValueTypes["NutritionalValueOfProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NutritionalValueOfProduct"]],
	name?:boolean,
positiveForBodyTags?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BodyTag"]],
negativeForBodyTags?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BodyTag"]],
reviews?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReview"]],
	score?:boolean,
dogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Dog"]],
	firstFiveItems?:boolean,
	detailedComposition?:boolean,
	guaranteedAnalysis?:boolean,
	isVeterinaryDiet?:boolean,
packagings?: [{	filter?:ValueTypes["ProductPackageWhere"] | null,	orderBy?:ValueTypes["ProductPackageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductPackage"]],
itemSubCategories?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemSubCategory"]],
itemCategories?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemCategory"]],
elements?: [{	filter?:ValueTypes["ElementOfProductWhere"] | null,	orderBy?:ValueTypes["ElementOfProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ElementOfProduct"]],
	isSearchVisible?:boolean,
	isSuitableForEliminationDiet?:boolean,
	remoteId?:boolean,
recommendedDogSizes?: [{	filter?:ValueTypes["DogSizeWhere"] | null,	orderBy?:ValueTypes["DogSizeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogSize"]],
granuleSizes?: [{	filter?:ValueTypes["GranuleSizeWhere"] | null,	orderBy?:ValueTypes["GranuleSizeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GranuleSize"]],
productLine?: [{	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLine"]],
flags?: [{	filter?:ValueTypes["ProductFlagOfProductWhere"] | null,	orderBy?:ValueTypes["ProductFlagOfProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFlagOfProduct"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
recommendedActivity?: [{	filter?:ValueTypes["DogActivityWhere"] | null},ValueTypes["DogActivity"]],
brand?: [{	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
	metabolizedEnergy?:boolean,
	cheapnessValue?:boolean,
aliases?: [{	filter?:ValueTypes["ProductAliasWhere"] | null,	orderBy?:ValueTypes["ProductAliasOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductAlias"]],
	slug?:boolean,
	animalProteinStatus?:boolean,
	carbohydrateStatus?:boolean,
evaluation?: [{	filter?:ValueTypes["ProductEvaluationWhere"] | null},ValueTypes["ProductEvaluation"]],
	missingComposition?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	czkPerMetabolizedEnergy?:boolean,
itemDeclensionFourthCategories?: [{	filter?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null,	orderBy?:ValueTypes["ProductItemDeclensionFourthCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductItemDeclensionFourthCategory"]],
ageCategories?: [{	filter?:ValueTypes["AgeCategoryWhere"] | null,	orderBy?:ValueTypes["AgeCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AgeCategory"]],
	customMetaTitle?:boolean,
	customMetaDescription?:boolean,
	isSuitableForCastrated?:boolean,
heurekaImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
topx?: [{	filter?:ValueTypes["TOPXProductWhere"] | null,	orderBy?:ValueTypes["TOPXProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TOPXProduct"]],
nutritionalValuesByRemoteId?: [{	by:ValueTypes["ProductNutritionalValuesByRemoteIdUniqueWhere"],	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null},ValueTypes["NutritionalValueOfProduct"]],
reviewsByProductReviewReactions?: [{	by:ValueTypes["ProductReviewsByProductReviewReactionsUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
reviewsByStats?: [{	by:ValueTypes["ProductReviewsByStatsUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
dogsByReproduction?: [{	by:ValueTypes["ProductDogsByReproductionUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
dogsByAvatar?: [{	by:ValueTypes["ProductDogsByAvatarUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
packagingsByRemoteId?: [{	by:ValueTypes["ProductPackagingsByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductPackageWhere"] | null},ValueTypes["ProductPackage"]],
packagingsByPositionId?: [{	by:ValueTypes["ProductPackagingsByPositionIdUniqueWhere"],	filter?:ValueTypes["ProductPackageWhere"] | null},ValueTypes["ProductPackage"]],
packagingsByExternalId?: [{	by:ValueTypes["ProductPackagingsByExternalIdUniqueWhere"],	filter?:ValueTypes["ProductPackageWhere"] | null},ValueTypes["ProductPackage"]],
elementsByRemoteId?: [{	by:ValueTypes["ProductElementsByRemoteIdUniqueWhere"],	filter?:ValueTypes["ElementOfProductWhere"] | null},ValueTypes["ElementOfProduct"]],
flagsByRemoteId?: [{	by:ValueTypes["ProductFlagsByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductFlagOfProductWhere"] | null},ValueTypes["ProductFlagOfProduct"]],
aliasesByRemoteId?: [{	by:ValueTypes["ProductAliasesByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductAliasWhere"] | null},ValueTypes["ProductAlias"]],
topxByRemoteId?: [{	by:ValueTypes["ProductTopxByRemoteIdUniqueWhere"],	filter?:ValueTypes["TOPXProductWhere"] | null},ValueTypes["TOPXProduct"]],
paginateNutritionalValues?: [{	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null,	orderBy?:ValueTypes["NutritionalValueOfProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NutritionalValueOfProductConnection"]],
paginatePositiveForBodyTags?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BodyTagConnection"]],
paginateNegativeForBodyTags?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BodyTagConnection"]],
paginateReviews?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewConnection"]],
paginateDogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogConnection"]],
paginatePackagings?: [{	filter?:ValueTypes["ProductPackageWhere"] | null,	orderBy?:ValueTypes["ProductPackageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductPackageConnection"]],
paginateItemSubCategories?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemSubCategoryConnection"]],
paginateItemCategories?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemCategoryConnection"]],
paginateElements?: [{	filter?:ValueTypes["ElementOfProductWhere"] | null,	orderBy?:ValueTypes["ElementOfProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ElementOfProductConnection"]],
paginateRecommendedDogSizes?: [{	filter?:ValueTypes["DogSizeWhere"] | null,	orderBy?:ValueTypes["DogSizeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogSizeConnection"]],
paginateGranuleSizes?: [{	filter?:ValueTypes["GranuleSizeWhere"] | null,	orderBy?:ValueTypes["GranuleSizeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GranuleSizeConnection"]],
paginateFlags?: [{	filter?:ValueTypes["ProductFlagOfProductWhere"] | null,	orderBy?:ValueTypes["ProductFlagOfProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFlagOfProductConnection"]],
paginateAliases?: [{	filter?:ValueTypes["ProductAliasWhere"] | null,	orderBy?:ValueTypes["ProductAliasOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductAliasConnection"]],
paginateItemDeclensionFourthCategories?: [{	filter?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null,	orderBy?:ValueTypes["ProductItemDeclensionFourthCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductItemDeclensionFourthCategoryConnection"]],
paginateAgeCategories?: [{	filter?:ValueTypes["AgeCategoryWhere"] | null,	orderBy?:ValueTypes["AgeCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AgeCategoryConnection"]],
paginateTopx?: [{	filter?:ValueTypes["TOPXProductWhere"] | null,	orderBy?:ValueTypes["TOPXProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TOPXProductConnection"]],
		__typename?: boolean
}>;
	["ProductMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	nutritionalValues?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	positiveForBodyTags?:ValueTypes["FieldMeta"],
	negativeForBodyTags?:ValueTypes["FieldMeta"],
	reviews?:ValueTypes["FieldMeta"],
	score?:ValueTypes["FieldMeta"],
	dogs?:ValueTypes["FieldMeta"],
	firstFiveItems?:ValueTypes["FieldMeta"],
	detailedComposition?:ValueTypes["FieldMeta"],
	guaranteedAnalysis?:ValueTypes["FieldMeta"],
	isVeterinaryDiet?:ValueTypes["FieldMeta"],
	packagings?:ValueTypes["FieldMeta"],
	itemSubCategories?:ValueTypes["FieldMeta"],
	itemCategories?:ValueTypes["FieldMeta"],
	elements?:ValueTypes["FieldMeta"],
	isSearchVisible?:ValueTypes["FieldMeta"],
	isSuitableForEliminationDiet?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	recommendedDogSizes?:ValueTypes["FieldMeta"],
	granuleSizes?:ValueTypes["FieldMeta"],
	productLine?:ValueTypes["FieldMeta"],
	flags?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	recommendedActivity?:ValueTypes["FieldMeta"],
	brand?:ValueTypes["FieldMeta"],
	metabolizedEnergy?:ValueTypes["FieldMeta"],
	cheapnessValue?:ValueTypes["FieldMeta"],
	aliases?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	animalProteinStatus?:ValueTypes["FieldMeta"],
	carbohydrateStatus?:ValueTypes["FieldMeta"],
	evaluation?:ValueTypes["FieldMeta"],
	missingComposition?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	czkPerMetabolizedEnergy?:ValueTypes["FieldMeta"],
	itemDeclensionFourthCategories?:ValueTypes["FieldMeta"],
	ageCategories?:ValueTypes["FieldMeta"],
	customMetaTitle?:ValueTypes["FieldMeta"],
	customMetaDescription?:ValueTypes["FieldMeta"],
	isSuitableForCastrated?:ValueTypes["FieldMeta"],
	heurekaImage?:ValueTypes["FieldMeta"],
	topx?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["NutritionalValueOfProduct"]: AliasType<{
	_meta?:ValueTypes["NutritionalValueOfProductMeta"],
	id?:boolean,
	order?:boolean,
product?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
	amount?:boolean,
	remoteId?:boolean,
nutritionalValue?: [{	filter?:ValueTypes["NutritionalValueWhere"] | null},ValueTypes["NutritionalValue"]],
		__typename?: boolean
}>;
	["NutritionalValueOfProductMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	amount?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	nutritionalValue?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["NutritionalValue"]: AliasType<{
	_meta?:ValueTypes["NutritionalValueMeta"],
	id?:boolean,
	name?:boolean,
products?: [{	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null,	orderBy?:ValueTypes["NutritionalValueOfProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NutritionalValueOfProduct"]],
suitabilityNutritionalValues?: [{	filter?:ValueTypes["SuitabilityItemWhere"] | null,	orderBy?:ValueTypes["SuitabilityItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SuitabilityItem"]],
	remoteId?:boolean,
icon?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
productsByRemoteId?: [{	by:ValueTypes["NutritionalValueProductsByRemoteIdUniqueWhere"],	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null},ValueTypes["NutritionalValueOfProduct"]],
suitabilityNutritionalValuesByRemoteId?: [{	by:ValueTypes["NutritionalValueSuitabilityNutritionalValuesByRemoteIdUniqueWhere"],	filter?:ValueTypes["SuitabilityItemWhere"] | null},ValueTypes["SuitabilityItem"]],
paginateProducts?: [{	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null,	orderBy?:ValueTypes["NutritionalValueOfProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NutritionalValueOfProductConnection"]],
paginateSuitabilityNutritionalValues?: [{	filter?:ValueTypes["SuitabilityItemWhere"] | null,	orderBy?:ValueTypes["SuitabilityItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SuitabilityItemConnection"]],
		__typename?: boolean
}>;
	["NutritionalValueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	suitabilityNutritionalValues?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["NutritionalValueOfProductOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	product?:ValueTypes["ProductOrderBy"] | null,
	amount?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	nutritionalValue?:ValueTypes["NutritionalValueOrderBy"] | null
};
	["NutritionalValueOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	icon?:ValueTypes["ImageOrderBy"] | null
};
	["SuitabilityItem"]: AliasType<{
	_meta?:ValueTypes["SuitabilityItemMeta"],
	id?:boolean,
	min?:boolean,
	max?:boolean,
	remoteId?:boolean,
	order?:boolean,
element?: [{	filter?:ValueTypes["ElementWhere"] | null},ValueTypes["Element"]],
nutritionalValue?: [{	filter?:ValueTypes["NutritionalValueWhere"] | null},ValueTypes["NutritionalValue"]],
category?: [{	filter?:ValueTypes["SuitabilityCategoryWhere"] | null},ValueTypes["SuitabilityCategory"]],
		__typename?: boolean
}>;
	["SuitabilityItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	min?:ValueTypes["FieldMeta"],
	max?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	element?:ValueTypes["FieldMeta"],
	nutritionalValue?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Element"]: AliasType<{
	_meta?:ValueTypes["ElementMeta"],
	id?:boolean,
	name?:boolean,
products?: [{	filter?:ValueTypes["ElementOfProductWhere"] | null,	orderBy?:ValueTypes["ElementOfProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ElementOfProduct"]],
featureDependencies?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFeature"]],
suitabilityElements?: [{	filter?:ValueTypes["SuitabilityItemWhere"] | null,	orderBy?:ValueTypes["SuitabilityItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SuitabilityItem"]],
	remoteId?:boolean,
	unit?:boolean,
	filterOrder?:boolean,
	slug?:boolean,
	declensionSeventh?:boolean,
productsByRemoteId?: [{	by:ValueTypes["ElementProductsByRemoteIdUniqueWhere"],	filter?:ValueTypes["ElementOfProductWhere"] | null},ValueTypes["ElementOfProduct"]],
featureDependenciesByRemoteId?: [{	by:ValueTypes["ElementFeatureDependenciesByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null},ValueTypes["ProductFeature"]],
suitabilityElementsByRemoteId?: [{	by:ValueTypes["ElementSuitabilityElementsByRemoteIdUniqueWhere"],	filter?:ValueTypes["SuitabilityItemWhere"] | null},ValueTypes["SuitabilityItem"]],
paginateProducts?: [{	filter?:ValueTypes["ElementOfProductWhere"] | null,	orderBy?:ValueTypes["ElementOfProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ElementOfProductConnection"]],
paginateFeatureDependencies?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFeatureConnection"]],
paginateSuitabilityElements?: [{	filter?:ValueTypes["SuitabilityItemWhere"] | null,	orderBy?:ValueTypes["SuitabilityItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SuitabilityItemConnection"]],
		__typename?: boolean
}>;
	["ElementMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	featureDependencies?:ValueTypes["FieldMeta"],
	suitabilityElements?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	unit?:ValueTypes["FieldMeta"],
	filterOrder?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	declensionSeventh?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ElementOfProduct"]: AliasType<{
	_meta?:ValueTypes["ElementOfProductMeta"],
	id?:boolean,
	order?:boolean,
	amount?:boolean,
product?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
	remoteId?:boolean,
element?: [{	filter?:ValueTypes["ElementWhere"] | null},ValueTypes["Element"]],
		__typename?: boolean
}>;
	["ElementOfProductMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	amount?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	element?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ElementOfProductOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	amount?:ValueTypes["OrderDirection"] | null,
	product?:ValueTypes["ProductOrderBy"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	element?:ValueTypes["ElementOrderBy"] | null
};
	["ProductFeature"]: AliasType<{
	_meta?:ValueTypes["ProductFeatureMeta"],
	id?:boolean,
	text?:boolean,
	category?:boolean,
	value?:boolean,
	remoteId?:boolean,
linkItem?: [{	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
dependentElement?: [{	filter?:ValueTypes["ElementWhere"] | null},ValueTypes["Element"]],
dependentCategory?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
dependentSubCategory?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
dependentFlag?: [{	filter?:ValueTypes["ProductFlagWhere"] | null},ValueTypes["ProductFlag"]],
		__typename?: boolean
}>;
	["ProductFeatureMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	linkItem?:ValueTypes["FieldMeta"],
	dependentElement?:ValueTypes["FieldMeta"],
	dependentCategory?:ValueTypes["FieldMeta"],
	dependentSubCategory?:ValueTypes["FieldMeta"],
	dependentFlag?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Item"]: AliasType<{
	_meta?:ValueTypes["ItemMeta"],
	id?:boolean,
	name?:boolean,
positiveForBodyTags?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BodyTag"]],
negativeForBodyTags?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BodyTag"]],
subCategories?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemSubCategory"]],
categories?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemCategory"]],
	lead?:boolean,
	animalProteinStatus?:boolean,
	carbohydrateStatus?:boolean,
featuresOfProduct?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFeature"]],
	remoteId?:boolean,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
referenceList?: [{	filter?:ValueTypes["ReferenceListWhere"] | null},ValueTypes["ReferenceList"]],
blogPost?: [{	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
declensionFourth?: [{	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
declensionSeventh?: [{	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null},ValueTypes["ItemDeclensionSeventhVariant"]],
	slug?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
aliases?: [{	filter?:ValueTypes["ItemAliasWhere"] | null,	orderBy?:ValueTypes["ItemAliasOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemAlias"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
draft?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
featuresOfProductByRemoteId?: [{	by:ValueTypes["ItemFeaturesOfProductByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null},ValueTypes["ProductFeature"]],
aliasesByRemoteId?: [{	by:ValueTypes["ItemAliasesByRemoteIdUniqueWhere"],	filter?:ValueTypes["ItemAliasWhere"] | null},ValueTypes["ItemAlias"]],
paginatePositiveForBodyTags?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BodyTagConnection"]],
paginateNegativeForBodyTags?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BodyTagConnection"]],
paginateSubCategories?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemSubCategoryConnection"]],
paginateCategories?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemCategoryConnection"]],
paginateFeaturesOfProduct?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFeatureConnection"]],
paginateAliases?: [{	filter?:ValueTypes["ItemAliasWhere"] | null,	orderBy?:ValueTypes["ItemAliasOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemAliasConnection"]],
		__typename?: boolean
}>;
	["ItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	positiveForBodyTags?:ValueTypes["FieldMeta"],
	negativeForBodyTags?:ValueTypes["FieldMeta"],
	subCategories?:ValueTypes["FieldMeta"],
	categories?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	animalProteinStatus?:ValueTypes["FieldMeta"],
	carbohydrateStatus?:ValueTypes["FieldMeta"],
	featuresOfProduct?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	referenceList?:ValueTypes["FieldMeta"],
	blogPost?:ValueTypes["FieldMeta"],
	declensionFourth?:ValueTypes["FieldMeta"],
	declensionSeventh?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	aliases?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	draft?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BodyTagOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	category?:ValueTypes["BodyTagCategoryOrderBy"] | null,
	icon?:ValueTypes["ImageOrderBy"] | null,
	labelFor?:ValueTypes["OrderDirection"] | null,
	slug?:ValueTypes["OrderDirection"] | null
};
	["ItemSubCategory"]: AliasType<{
	_meta?:ValueTypes["ItemSubCategoryMeta"],
	id?:boolean,
	name?:boolean,
items?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Item"]],
	isFlavorCategory?:boolean,
	isAllergenTag?:boolean,
	isMostCommonAllergenTag?:boolean,
products?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
featureDependencies?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFeature"]],
	remoteId?:boolean,
category?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
flavorCategory?: [{	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null},ValueTypes["ItemFlavorCategory"]],
dogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Dog"]],
iconNegative?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	negativeWording?:boolean,
icon?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
brands?: [{	filter?:ValueTypes["BrandFlavorWhere"] | null,	orderBy?:ValueTypes["BrandFlavorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandFlavor"]],
productLines?: [{	filter?:ValueTypes["ProductLineFlavorWhere"] | null,	orderBy?:ValueTypes["ProductLineFlavorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductLineFlavor"]],
	slug?:boolean,
	flavorSlug?:boolean,
	flavorDeclensionSeventh?:boolean,
filterCombosFlavor?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FilterCombo"]],
filterCombosAllergy?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FilterCombo"]],
	isFilterFlavor?:boolean,
featureDependenciesByRemoteId?: [{	by:ValueTypes["ItemSubCategoryFeatureDependenciesByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null},ValueTypes["ProductFeature"]],
filterCombosFlavorByRemoteId?: [{	by:ValueTypes["ItemSubCategoryFilterCombosFlavorByRemoteIdUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
filterCombosFlavorBySeo?: [{	by:ValueTypes["ItemSubCategoryFilterCombosFlavorBySeoUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
filterCombosAllergyByRemoteId?: [{	by:ValueTypes["ItemSubCategoryFilterCombosAllergyByRemoteIdUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
filterCombosAllergyBySeo?: [{	by:ValueTypes["ItemSubCategoryFilterCombosAllergyBySeoUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
paginateItems?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemConnection"]],
paginateProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
paginateFeatureDependencies?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFeatureConnection"]],
paginateDogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogConnection"]],
paginateBrands?: [{	filter?:ValueTypes["BrandFlavorWhere"] | null,	orderBy?:ValueTypes["BrandFlavorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandFlavorConnection"]],
paginateProductLines?: [{	filter?:ValueTypes["ProductLineFlavorWhere"] | null,	orderBy?:ValueTypes["ProductLineFlavorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductLineFlavorConnection"]],
paginateFilterCombosFlavor?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilterComboConnection"]],
paginateFilterCombosAllergy?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilterComboConnection"]],
		__typename?: boolean
}>;
	["ItemSubCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	isFlavorCategory?:ValueTypes["FieldMeta"],
	isAllergenTag?:ValueTypes["FieldMeta"],
	isMostCommonAllergenTag?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	featureDependencies?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
	flavorCategory?:ValueTypes["FieldMeta"],
	dogs?:ValueTypes["FieldMeta"],
	iconNegative?:ValueTypes["FieldMeta"],
	negativeWording?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
	brands?:ValueTypes["FieldMeta"],
	productLines?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	flavorSlug?:ValueTypes["FieldMeta"],
	flavorDeclensionSeventh?:ValueTypes["FieldMeta"],
	filterCombosFlavor?:ValueTypes["FieldMeta"],
	filterCombosAllergy?:ValueTypes["FieldMeta"],
	isFilterFlavor?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductFeatureOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	category?:ValueTypes["OrderDirection"] | null,
	value?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	linkItem?:ValueTypes["ItemOrderBy"] | null,
	dependentElement?:ValueTypes["ElementOrderBy"] | null,
	dependentCategory?:ValueTypes["ItemCategoryOrderBy"] | null,
	dependentSubCategory?:ValueTypes["ItemSubCategoryOrderBy"] | null,
	dependentFlag?:ValueTypes["ProductFlagOrderBy"] | null
};
	["ProductFlagOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null
};
	["ItemCategory"]: AliasType<{
	_meta?:ValueTypes["ItemCategoryMeta"],
	id?:boolean,
	name?:boolean,
	shortDescription?:boolean,
subCategories?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemSubCategory"]],
blogPosts?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPost"]],
items?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Item"]],
products?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
featureDependencies?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFeature"]],
	declensionSixth?:boolean,
	remoteId?:boolean,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	comparatorGroupId?:boolean,
ads?: [{	filter?:ValueTypes["AdWhere"] | null,	orderBy?:ValueTypes["AdOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Ad"]],
	slug?:boolean,
redirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
declensionsFourth?: [{	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,	orderBy?:ValueTypes["ItemDeclensionFourthVariantOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemDeclensionFourthVariant"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
group?: [{	filter?:ValueTypes["ItemGroupWhere"] | null},ValueTypes["ItemGroup"]],
	declensionSeventh?:boolean,
	slugWith?:boolean,
	slugWithNegative?:boolean,
	declensionSeventhNegative?:boolean,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
draft?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
subCategoriesByRemoteId?: [{	by:ValueTypes["ItemCategorySubCategoriesByRemoteIdUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
subCategoriesBySlug?: [{	by:ValueTypes["ItemCategorySubCategoriesBySlugUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
subCategoriesByFeatureDependencies?: [{	by:ValueTypes["ItemCategorySubCategoriesByFeatureDependenciesUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
subCategoriesByBrands?: [{	by:ValueTypes["ItemCategorySubCategoriesByBrandsUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
subCategoriesByProductLines?: [{	by:ValueTypes["ItemCategorySubCategoriesByProductLinesUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
subCategoriesByFilterCombosFlavor?: [{	by:ValueTypes["ItemCategorySubCategoriesByFilterCombosFlavorUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
subCategoriesByFilterCombosAllergy?: [{	by:ValueTypes["ItemCategorySubCategoriesByFilterCombosAllergyUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
featureDependenciesByRemoteId?: [{	by:ValueTypes["ItemCategoryFeatureDependenciesByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null},ValueTypes["ProductFeature"]],
redirectsByFrom?: [{	by:ValueTypes["ItemCategoryRedirectsByFromUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
declensionsFourthByRemoteId?: [{	by:ValueTypes["ItemCategoryDeclensionsFourthByRemoteIdUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
declensionsFourthBySlug?: [{	by:ValueTypes["ItemCategoryDeclensionsFourthBySlugUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
declensionsFourthByItems?: [{	by:ValueTypes["ItemCategoryDeclensionsFourthByItemsUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
declensionsFourthBySeo?: [{	by:ValueTypes["ItemCategoryDeclensionsFourthBySeoUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
declensionsFourthBySubcategory?: [{	by:ValueTypes["ItemCategoryDeclensionsFourthBySubcategoryUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
declensionsFourthByElement?: [{	by:ValueTypes["ItemCategoryDeclensionsFourthByElementUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
declensionsFourthByProducts?: [{	by:ValueTypes["ItemCategoryDeclensionsFourthByProductsUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
declensionsFourthByContent?: [{	by:ValueTypes["ItemCategoryDeclensionsFourthByContentUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
declensionsFourthByDraft?: [{	by:ValueTypes["ItemCategoryDeclensionsFourthByDraftUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
paginateSubCategories?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemSubCategoryConnection"]],
paginateBlogPosts?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostConnection"]],
paginateItems?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemConnection"]],
paginateProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
paginateFeatureDependencies?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFeatureConnection"]],
paginateAds?: [{	filter?:ValueTypes["AdWhere"] | null,	orderBy?:ValueTypes["AdOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AdConnection"]],
paginateRedirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
paginateDeclensionsFourth?: [{	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,	orderBy?:ValueTypes["ItemDeclensionFourthVariantOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemDeclensionFourthVariantConnection"]],
		__typename?: boolean
}>;
	["ItemCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	shortDescription?:ValueTypes["FieldMeta"],
	subCategories?:ValueTypes["FieldMeta"],
	blogPosts?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	featureDependencies?:ValueTypes["FieldMeta"],
	declensionSixth?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	comparatorGroupId?:ValueTypes["FieldMeta"],
	ads?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	redirects?:ValueTypes["FieldMeta"],
	declensionsFourth?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	group?:ValueTypes["FieldMeta"],
	declensionSeventh?:ValueTypes["FieldMeta"],
	slugWith?:ValueTypes["FieldMeta"],
	slugWithNegative?:ValueTypes["FieldMeta"],
	declensionSeventhNegative?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	draft?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Ad"]: AliasType<{
	_meta?:ValueTypes["AdMeta"],
	id?:boolean,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	isBrandSectionVisible?:boolean,
	isBlogPostSectionVisible?:boolean,
	isIngredientSectionVisible?:boolean,
	isResultsVisible?:boolean,
	isSearchVisible?:boolean,
blogPosts?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPost"]],
itemCategories?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemCategory"]],
brands?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Brand"]],
	isActive?:boolean,
	link?:boolean,
	note?:boolean,
	activeFrom?:boolean,
	activeUntil?:boolean,
	slug?:boolean,
contentReferences?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
contentReferencesByImages?: [{	by:ValueTypes["AdContentReferencesByImagesUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByLink?: [{	by:ValueTypes["AdContentReferencesByLinkUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByList?: [{	by:ValueTypes["AdContentReferencesByListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByOutline?: [{	by:ValueTypes["AdContentReferencesByOutlineUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByVideo?: [{	by:ValueTypes["AdContentReferencesByVideoUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByImage?: [{	by:ValueTypes["AdContentReferencesByImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
paginateBlogPosts?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostConnection"]],
paginateItemCategories?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemCategoryConnection"]],
paginateBrands?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandConnection"]],
paginateContentReferences?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
		__typename?: boolean
}>;
	["AdMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	isBrandSectionVisible?:ValueTypes["FieldMeta"],
	isBlogPostSectionVisible?:ValueTypes["FieldMeta"],
	isIngredientSectionVisible?:ValueTypes["FieldMeta"],
	isResultsVisible?:ValueTypes["FieldMeta"],
	isSearchVisible?:ValueTypes["FieldMeta"],
	blogPosts?:ValueTypes["FieldMeta"],
	itemCategories?:ValueTypes["FieldMeta"],
	brands?:ValueTypes["FieldMeta"],
	isActive?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	activeFrom?:ValueTypes["FieldMeta"],
	activeUntil?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	contentReferences?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Brand"]: AliasType<{
	_meta?:ValueTypes["BrandMeta"],
	id?:boolean,
	name?:boolean,
products?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
	link?:boolean,
countriesOfProduction?: [{	filter?:ValueTypes["CountryWhere"] | null,	orderBy?:ValueTypes["CountryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Country"]],
manufacturers?: [{	filter?:ValueTypes["BrandManufacturerWhere"] | null,	orderBy?:ValueTypes["BrandManufacturerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandManufacturer"]],
	remoteId?:boolean,
	promotedOnSearchPlace?:boolean,
	promotedOnBrandsPagePlace?:boolean,
	lead?:boolean,
productLines?: [{	filter?:ValueTypes["ProductLineWhere"] | null,	orderBy?:ValueTypes["ProductLineOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductLine"]],
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
methodOfProduction?: [{	filter?:ValueTypes["ProductionMethodWhere"] | null},ValueTypes["ProductionMethod"]],
distributor?: [{	filter?:ValueTypes["BrandDistributorWhere"] | null},ValueTypes["BrandDistributor"]],
aliases?: [{	filter?:ValueTypes["BrandAliasWhere"] | null,	orderBy?:ValueTypes["BrandAliasOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandAlias"]],
ads?: [{	filter?:ValueTypes["AdWhere"] | null,	orderBy?:ValueTypes["AdOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Ad"]],
	slug?:boolean,
flavors?: [{	filter?:ValueTypes["BrandFlavorWhere"] | null,	orderBy?:ValueTypes["BrandFlavorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandFlavor"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	customMetaDescription?:boolean,
filterCombos?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FilterCombo"]],
topx?: [{	filter?:ValueTypes["TOPXBrandWhere"] | null,	orderBy?:ValueTypes["TOPXBrandOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TOPXBrand"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
draft?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
productsByRemoteId?: [{	by:ValueTypes["BrandProductsByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsBySlug?: [{	by:ValueTypes["BrandProductsBySlugUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByNutritionalValues?: [{	by:ValueTypes["BrandProductsByNutritionalValuesUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByReviews?: [{	by:ValueTypes["BrandProductsByReviewsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByDogs?: [{	by:ValueTypes["BrandProductsByDogsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByPackagings?: [{	by:ValueTypes["BrandProductsByPackagingsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByElements?: [{	by:ValueTypes["BrandProductsByElementsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByFlags?: [{	by:ValueTypes["BrandProductsByFlagsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByImage?: [{	by:ValueTypes["BrandProductsByImageUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByAliases?: [{	by:ValueTypes["BrandProductsByAliasesUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByEvaluation?: [{	by:ValueTypes["BrandProductsByEvaluationUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsBySeo?: [{	by:ValueTypes["BrandProductsBySeoUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByItemDeclensionFourthCategories?: [{	by:ValueTypes["BrandProductsByItemDeclensionFourthCategoriesUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByHeurekaImage?: [{	by:ValueTypes["BrandProductsByHeurekaImageUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByTopx?: [{	by:ValueTypes["BrandProductsByTopxUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productLinesByRemoteId?: [{	by:ValueTypes["BrandProductLinesByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLine"]],
productLinesBySlug?: [{	by:ValueTypes["BrandProductLinesBySlugUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLine"]],
productLinesByProducts?: [{	by:ValueTypes["BrandProductLinesByProductsUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLine"]],
productLinesByLogo?: [{	by:ValueTypes["BrandProductLinesByLogoUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLine"]],
productLinesByFlavors?: [{	by:ValueTypes["BrandProductLinesByFlavorsUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLine"]],
productLinesBySeo?: [{	by:ValueTypes["BrandProductLinesBySeoUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLine"]],
aliasesByRemoteId?: [{	by:ValueTypes["BrandAliasesByRemoteIdUniqueWhere"],	filter?:ValueTypes["BrandAliasWhere"] | null},ValueTypes["BrandAlias"]],
filterCombosByRemoteId?: [{	by:ValueTypes["BrandFilterCombosByRemoteIdUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
filterCombosBySeo?: [{	by:ValueTypes["BrandFilterCombosBySeoUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
topxByRemoteId?: [{	by:ValueTypes["BrandTopxByRemoteIdUniqueWhere"],	filter?:ValueTypes["TOPXBrandWhere"] | null},ValueTypes["TOPXBrand"]],
paginateProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
paginateCountriesOfProduction?: [{	filter?:ValueTypes["CountryWhere"] | null,	orderBy?:ValueTypes["CountryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CountryConnection"]],
paginateManufacturers?: [{	filter?:ValueTypes["BrandManufacturerWhere"] | null,	orderBy?:ValueTypes["BrandManufacturerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandManufacturerConnection"]],
paginateProductLines?: [{	filter?:ValueTypes["ProductLineWhere"] | null,	orderBy?:ValueTypes["ProductLineOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductLineConnection"]],
paginateAliases?: [{	filter?:ValueTypes["BrandAliasWhere"] | null,	orderBy?:ValueTypes["BrandAliasOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandAliasConnection"]],
paginateAds?: [{	filter?:ValueTypes["AdWhere"] | null,	orderBy?:ValueTypes["AdOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AdConnection"]],
paginateFlavors?: [{	filter?:ValueTypes["BrandFlavorWhere"] | null,	orderBy?:ValueTypes["BrandFlavorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandFlavorConnection"]],
paginateFilterCombos?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilterComboConnection"]],
paginateTopx?: [{	filter?:ValueTypes["TOPXBrandWhere"] | null,	orderBy?:ValueTypes["TOPXBrandOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TOPXBrandConnection"]],
		__typename?: boolean
}>;
	["BrandMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	countriesOfProduction?:ValueTypes["FieldMeta"],
	manufacturers?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	promotedOnSearchPlace?:ValueTypes["FieldMeta"],
	promotedOnBrandsPagePlace?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	productLines?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	methodOfProduction?:ValueTypes["FieldMeta"],
	distributor?:ValueTypes["FieldMeta"],
	aliases?:ValueTypes["FieldMeta"],
	ads?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	flavors?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	customMetaDescription?:ValueTypes["FieldMeta"],
	filterCombos?:ValueTypes["FieldMeta"],
	topx?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	draft?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Country"]: AliasType<{
	_meta?:ValueTypes["CountryMeta"],
	id?:boolean,
	name?:boolean,
brands?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Brand"]],
manufacturers?: [{	filter?:ValueTypes["BrandManufacturerWhere"] | null,	orderBy?:ValueTypes["BrandManufacturerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandManufacturer"]],
	remoteId?:boolean,
region?: [{	filter?:ValueTypes["RegionWhere"] | null},ValueTypes["Region"]],
manufacturersByRemoteId?: [{	by:ValueTypes["CountryManufacturersByRemoteIdUniqueWhere"],	filter?:ValueTypes["BrandManufacturerWhere"] | null},ValueTypes["BrandManufacturer"]],
paginateBrands?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandConnection"]],
paginateManufacturers?: [{	filter?:ValueTypes["BrandManufacturerWhere"] | null,	orderBy?:ValueTypes["BrandManufacturerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandManufacturerConnection"]],
		__typename?: boolean
}>;
	["CountryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	brands?:ValueTypes["FieldMeta"],
	manufacturers?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	region?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BrandManufacturer"]: AliasType<{
	_meta?:ValueTypes["BrandManufacturerMeta"],
	id?:boolean,
	name?:boolean,
	link?:boolean,
brands?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Brand"]],
	order?:boolean,
	remoteId?:boolean,
residence?: [{	filter?:ValueTypes["CountryWhere"] | null},ValueTypes["Country"]],
paginateBrands?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandConnection"]],
		__typename?: boolean
}>;
	["BrandManufacturerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	brands?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	residence?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BrandConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BrandEdge"],
		__typename?: boolean
}>;
	["PageInfo"]: AliasType<{
	totalCount?:boolean,
		__typename?: boolean
}>;
	["BrandEdge"]: AliasType<{
	node?:ValueTypes["Brand"],
		__typename?: boolean
}>;
	["BrandManufacturerOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	residence?:ValueTypes["CountryOrderBy"] | null
};
	["CountryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	region?:ValueTypes["RegionOrderBy"] | null
};
	["RegionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	adjective?:ValueTypes["OrderDirection"] | null,
	slug?:ValueTypes["OrderDirection"] | null
};
	["Region"]: AliasType<{
	_meta?:ValueTypes["RegionMeta"],
	id?:boolean,
	name?:boolean,
countries?: [{	filter?:ValueTypes["CountryWhere"] | null,	orderBy?:ValueTypes["CountryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Country"]],
	remoteId?:boolean,
	adjective?:boolean,
	slug?:boolean,
filterCombos?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FilterCombo"]],
countriesByRemoteId?: [{	by:ValueTypes["RegionCountriesByRemoteIdUniqueWhere"],	filter?:ValueTypes["CountryWhere"] | null},ValueTypes["Country"]],
countriesByManufacturers?: [{	by:ValueTypes["RegionCountriesByManufacturersUniqueWhere"],	filter?:ValueTypes["CountryWhere"] | null},ValueTypes["Country"]],
filterCombosByRemoteId?: [{	by:ValueTypes["RegionFilterCombosByRemoteIdUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
filterCombosBySeo?: [{	by:ValueTypes["RegionFilterCombosBySeoUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
paginateCountries?: [{	filter?:ValueTypes["CountryWhere"] | null,	orderBy?:ValueTypes["CountryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CountryConnection"]],
paginateFilterCombos?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilterComboConnection"]],
		__typename?: boolean
}>;
	["RegionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	countries?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	adjective?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	filterCombos?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["FilterCombo"]: AliasType<{
	_meta?:ValueTypes["FilterComboMeta"],
	id?:boolean,
	remoteId?:boolean,
	title?:boolean,
	lead?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
breed?: [{	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
brand?: [{	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
region?: [{	filter?:ValueTypes["RegionWhere"] | null},ValueTypes["Region"]],
ageCategory?: [{	filter?:ValueTypes["AgeCategoryWhere"] | null},ValueTypes["AgeCategory"]],
treatment?: [{	filter?:ValueTypes["BodyTagWhere"] | null},ValueTypes["BodyTag"]],
flavor?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
allergy?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
		__typename?: boolean
}>;
	["FilterComboMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	breed?:ValueTypes["FieldMeta"],
	brand?:ValueTypes["FieldMeta"],
	region?:ValueTypes["FieldMeta"],
	ageCategory?:ValueTypes["FieldMeta"],
	treatment?:ValueTypes["FieldMeta"],
	flavor?:ValueTypes["FieldMeta"],
	allergy?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Breed"]: AliasType<{
	_meta?:ValueTypes["BreedMeta"],
	id?:boolean,
dogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Dog"]],
	litterSize?:boolean,
reviews?: [{	filter?:ValueTypes["ReviewWhere"] | null,	orderBy?:ValueTypes["ReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Review"]],
	name?:boolean,
	dailyEnergyRequirement?:boolean,
ages?: [{	filter?:ValueTypes["AgeWhere"] | null,	orderBy?:ValueTypes["AgeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Age"]],
	remoteId?:boolean,
	averageWeightFemale?:boolean,
	averageWeightMale?:boolean,
suitabilityCategory?: [{	filter?:ValueTypes["SuitabilityCategoryWhere"] | null},ValueTypes["SuitabilityCategory"]],
productReviews?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReview"]],
blogPostReviews?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostReview"]],
	labelFor?:boolean,
size?: [{	filter?:ValueTypes["DogSizeWhere"] | null},ValueTypes["DogSize"]],
	slug?:boolean,
filterCombos?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FilterCombo"]],
dogsByReproduction?: [{	by:ValueTypes["BreedDogsByReproductionUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
dogsByAvatar?: [{	by:ValueTypes["BreedDogsByAvatarUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
productReviewsByProductReviewReactions?: [{	by:ValueTypes["BreedProductReviewsByProductReviewReactionsUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
productReviewsByStats?: [{	by:ValueTypes["BreedProductReviewsByStatsUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
blogPostReviewsByBlogPostReviewReactions?: [{	by:ValueTypes["BreedBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReview"]],
blogPostReviewsByStats?: [{	by:ValueTypes["BreedBlogPostReviewsByStatsUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReview"]],
filterCombosByRemoteId?: [{	by:ValueTypes["BreedFilterCombosByRemoteIdUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
filterCombosBySeo?: [{	by:ValueTypes["BreedFilterCombosBySeoUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
paginateDogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogConnection"]],
paginateReviews?: [{	filter?:ValueTypes["ReviewWhere"] | null,	orderBy?:ValueTypes["ReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ReviewConnection"]],
paginateAges?: [{	filter?:ValueTypes["AgeWhere"] | null,	orderBy?:ValueTypes["AgeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AgeConnection"]],
paginateProductReviews?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewConnection"]],
paginateBlogPostReviews?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostReviewConnection"]],
paginateFilterCombos?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilterComboConnection"]],
		__typename?: boolean
}>;
	["BreedMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	dogs?:ValueTypes["FieldMeta"],
	litterSize?:ValueTypes["FieldMeta"],
	reviews?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	dailyEnergyRequirement?:ValueTypes["FieldMeta"],
	ages?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	averageWeightFemale?:ValueTypes["FieldMeta"],
	averageWeightMale?:ValueTypes["FieldMeta"],
	suitabilityCategory?:ValueTypes["FieldMeta"],
	productReviews?:ValueTypes["FieldMeta"],
	blogPostReviews?:ValueTypes["FieldMeta"],
	labelFor?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	filterCombos?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Dog"]: AliasType<{
	_meta?:ValueTypes["DogMeta"],
	id?:boolean,
	gender?:boolean,
	weight?:boolean,
	customIdealWeight?:boolean,
breed?: [{	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
age?: [{	filter?:ValueTypes["AgeWhere"] | null},ValueTypes["Age"]],
bodyType?: [{	filter?:ValueTypes["DogBodyTypeWhere"] | null},ValueTypes["DogBodyType"]],
owner?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
activity?: [{	filter?:ValueTypes["DogActivityWhere"] | null},ValueTypes["DogActivity"]],
fedProduct?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
reproduction?: [{	filter?:ValueTypes["DogReproductionWhere"] | null},ValueTypes["DogReproduction"]],
allergies?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemSubCategory"]],
illnesses?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BodyTag"]],
	name?:boolean,
avatar?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	createdAt?:boolean,
paginateAllergies?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemSubCategoryConnection"]],
paginateIllnesses?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BodyTagConnection"]],
		__typename?: boolean
}>;
	["DogMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	gender?:ValueTypes["FieldMeta"],
	weight?:ValueTypes["FieldMeta"],
	customIdealWeight?:ValueTypes["FieldMeta"],
	breed?:ValueTypes["FieldMeta"],
	age?:ValueTypes["FieldMeta"],
	bodyType?:ValueTypes["FieldMeta"],
	owner?:ValueTypes["FieldMeta"],
	activity?:ValueTypes["FieldMeta"],
	fedProduct?:ValueTypes["FieldMeta"],
	reproduction?:ValueTypes["FieldMeta"],
	allergies?:ValueTypes["FieldMeta"],
	illnesses?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	avatar?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Age"]: AliasType<{
	_meta?:ValueTypes["AgeMeta"],
	id?:boolean,
dogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Dog"]],
breeds?: [{	filter?:ValueTypes["BreedWhere"] | null,	orderBy?:ValueTypes["BreedOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Breed"]],
	ageRange?:boolean,
	categoryLabel?:boolean,
suitabilityCategories?: [{	filter?:ValueTypes["SuitabilityCategoryWhere"] | null,	orderBy?:ValueTypes["SuitabilityCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SuitabilityCategory"]],
	remoteId?:boolean,
productReviews?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReview"]],
blogPostReviews?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostReview"]],
	label?:boolean,
	categoryOrder?:boolean,
dogsByReproduction?: [{	by:ValueTypes["AgeDogsByReproductionUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
dogsByAvatar?: [{	by:ValueTypes["AgeDogsByAvatarUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
productReviewsByProductReviewReactions?: [{	by:ValueTypes["AgeProductReviewsByProductReviewReactionsUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
productReviewsByStats?: [{	by:ValueTypes["AgeProductReviewsByStatsUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
blogPostReviewsByBlogPostReviewReactions?: [{	by:ValueTypes["AgeBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReview"]],
blogPostReviewsByStats?: [{	by:ValueTypes["AgeBlogPostReviewsByStatsUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReview"]],
paginateDogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogConnection"]],
paginateBreeds?: [{	filter?:ValueTypes["BreedWhere"] | null,	orderBy?:ValueTypes["BreedOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BreedConnection"]],
paginateSuitabilityCategories?: [{	filter?:ValueTypes["SuitabilityCategoryWhere"] | null,	orderBy?:ValueTypes["SuitabilityCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SuitabilityCategoryConnection"]],
paginateProductReviews?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewConnection"]],
paginateBlogPostReviews?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostReviewConnection"]],
		__typename?: boolean
}>;
	["AgeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	dogs?:ValueTypes["FieldMeta"],
	breeds?:ValueTypes["FieldMeta"],
	ageRange?:ValueTypes["FieldMeta"],
	categoryLabel?:ValueTypes["FieldMeta"],
	suitabilityCategories?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	productReviews?:ValueTypes["FieldMeta"],
	blogPostReviews?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	categoryOrder?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["DogOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	gender?:ValueTypes["OrderDirection"] | null,
	weight?:ValueTypes["OrderDirection"] | null,
	customIdealWeight?:ValueTypes["OrderDirection"] | null,
	breed?:ValueTypes["BreedOrderBy"] | null,
	age?:ValueTypes["AgeOrderBy"] | null,
	bodyType?:ValueTypes["DogBodyTypeOrderBy"] | null,
	owner?:ValueTypes["UserOrderBy"] | null,
	activity?:ValueTypes["DogActivityOrderBy"] | null,
	fedProduct?:ValueTypes["ProductOrderBy"] | null,
	reproduction?:ValueTypes["DogReproductionOrderBy"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	avatar?:ValueTypes["ImageOrderBy"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null
};
	["BreedOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	litterSize?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	dailyEnergyRequirement?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	averageWeightFemale?:ValueTypes["OrderDirection"] | null,
	averageWeightMale?:ValueTypes["OrderDirection"] | null,
	suitabilityCategory?:ValueTypes["SuitabilityCategoryOrderBy"] | null,
	labelFor?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["DogSizeOrderBy"] | null,
	slug?:ValueTypes["OrderDirection"] | null
};
	["DogSizeOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	suitabilityCategory?:ValueTypes["SuitabilityCategoryOrderBy"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	isFilterVisible?:ValueTypes["OrderDirection"] | null
};
	["AgeOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	ageRange?:ValueTypes["OrderDirection"] | null,
	categoryLabel?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	categoryOrder?:ValueTypes["OrderDirection"] | null
};
	["DogBodyTypeOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	value?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	category?:ValueTypes["DogBodyTypeCategoryOrderBy"] | null,
	imageMain?:ValueTypes["ImageOrderBy"] | null,
	imageFrom?:ValueTypes["ImageOrderBy"] | null,
	imageTo?:ValueTypes["ImageOrderBy"] | null
};
	["DogBodyTypeCategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	imageMain?:ValueTypes["ImageOrderBy"] | null
};
	["DogReproductionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	breastfeedingPuppyCount?:ValueTypes["OrderDirection"] | null,
	pregnancy?:ValueTypes["OrderDirection"] | null,
	dog?:ValueTypes["DogOrderBy"] | null,
	breastfeedingCategory?:ValueTypes["BreastfeedingCategoryOrderBy"] | null
};
	["BreastfeedingCategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	week?:ValueTypes["OrderDirection"] | null,
	coeficient?:ValueTypes["OrderDirection"] | null
};
	["SuitabilityCategory"]: AliasType<{
	_meta?:ValueTypes["SuitabilityCategoryMeta"],
	id?:boolean,
	name?:boolean,
dogSizes?: [{	filter?:ValueTypes["DogSizeWhere"] | null,	orderBy?:ValueTypes["DogSizeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogSize"]],
dogActivities?: [{	filter?:ValueTypes["DogActivityWhere"] | null,	orderBy?:ValueTypes["DogActivityOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogActivity"]],
breeds?: [{	filter?:ValueTypes["BreedWhere"] | null,	orderBy?:ValueTypes["BreedOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Breed"]],
suitabilityItems?: [{	filter?:ValueTypes["SuitabilityItemWhere"] | null,	orderBy?:ValueTypes["SuitabilityItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SuitabilityItem"]],
dogAges?: [{	filter?:ValueTypes["AgeWhere"] | null,	orderBy?:ValueTypes["AgeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Age"]],
	isPregnant?:boolean,
	remoteId?:boolean,
	isBreastfeeding?:boolean,
dogSizesByRemoteId?: [{	by:ValueTypes["SuitabilityCategoryDogSizesByRemoteIdUniqueWhere"],	filter?:ValueTypes["DogSizeWhere"] | null},ValueTypes["DogSize"]],
dogSizesByBreeds?: [{	by:ValueTypes["SuitabilityCategoryDogSizesByBreedsUniqueWhere"],	filter?:ValueTypes["DogSizeWhere"] | null},ValueTypes["DogSize"]],
dogActivitiesByRemoteId?: [{	by:ValueTypes["SuitabilityCategoryDogActivitiesByRemoteIdUniqueWhere"],	filter?:ValueTypes["DogActivityWhere"] | null},ValueTypes["DogActivity"]],
dogActivitiesByDogs?: [{	by:ValueTypes["SuitabilityCategoryDogActivitiesByDogsUniqueWhere"],	filter?:ValueTypes["DogActivityWhere"] | null},ValueTypes["DogActivity"]],
dogActivitiesByProducts?: [{	by:ValueTypes["SuitabilityCategoryDogActivitiesByProductsUniqueWhere"],	filter?:ValueTypes["DogActivityWhere"] | null},ValueTypes["DogActivity"]],
breedsByRemoteId?: [{	by:ValueTypes["SuitabilityCategoryBreedsByRemoteIdUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
breedsBySlug?: [{	by:ValueTypes["SuitabilityCategoryBreedsBySlugUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
breedsByDogs?: [{	by:ValueTypes["SuitabilityCategoryBreedsByDogsUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
breedsByProductReviews?: [{	by:ValueTypes["SuitabilityCategoryBreedsByProductReviewsUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
breedsByBlogPostReviews?: [{	by:ValueTypes["SuitabilityCategoryBreedsByBlogPostReviewsUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
breedsByFilterCombos?: [{	by:ValueTypes["SuitabilityCategoryBreedsByFilterCombosUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
suitabilityItemsByRemoteId?: [{	by:ValueTypes["SuitabilityCategorySuitabilityItemsByRemoteIdUniqueWhere"],	filter?:ValueTypes["SuitabilityItemWhere"] | null},ValueTypes["SuitabilityItem"]],
paginateDogSizes?: [{	filter?:ValueTypes["DogSizeWhere"] | null,	orderBy?:ValueTypes["DogSizeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogSizeConnection"]],
paginateDogActivities?: [{	filter?:ValueTypes["DogActivityWhere"] | null,	orderBy?:ValueTypes["DogActivityOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogActivityConnection"]],
paginateBreeds?: [{	filter?:ValueTypes["BreedWhere"] | null,	orderBy?:ValueTypes["BreedOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BreedConnection"]],
paginateSuitabilityItems?: [{	filter?:ValueTypes["SuitabilityItemWhere"] | null,	orderBy?:ValueTypes["SuitabilityItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SuitabilityItemConnection"]],
paginateDogAges?: [{	filter?:ValueTypes["AgeWhere"] | null,	orderBy?:ValueTypes["AgeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AgeConnection"]],
		__typename?: boolean
}>;
	["SuitabilityCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	dogSizes?:ValueTypes["FieldMeta"],
	dogActivities?:ValueTypes["FieldMeta"],
	breeds?:ValueTypes["FieldMeta"],
	suitabilityItems?:ValueTypes["FieldMeta"],
	dogAges?:ValueTypes["FieldMeta"],
	isPregnant?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	isBreastfeeding?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["DogSize"]: AliasType<{
	_meta?:ValueTypes["DogSizeMeta"],
	id?:boolean,
breeds?: [{	filter?:ValueTypes["BreedWhere"] | null,	orderBy?:ValueTypes["BreedOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Breed"]],
	remoteId?:boolean,
products?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
suitabilityCategory?: [{	filter?:ValueTypes["SuitabilityCategoryWhere"] | null},ValueTypes["SuitabilityCategory"]],
	name?:boolean,
	label?:boolean,
	order?:boolean,
	isFilterVisible?:boolean,
breedsByRemoteId?: [{	by:ValueTypes["DogSizeBreedsByRemoteIdUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
breedsBySlug?: [{	by:ValueTypes["DogSizeBreedsBySlugUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
breedsByDogs?: [{	by:ValueTypes["DogSizeBreedsByDogsUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
breedsByProductReviews?: [{	by:ValueTypes["DogSizeBreedsByProductReviewsUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
breedsByBlogPostReviews?: [{	by:ValueTypes["DogSizeBreedsByBlogPostReviewsUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
breedsByFilterCombos?: [{	by:ValueTypes["DogSizeBreedsByFilterCombosUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
paginateBreeds?: [{	filter?:ValueTypes["BreedWhere"] | null,	orderBy?:ValueTypes["BreedOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BreedConnection"]],
paginateProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
		__typename?: boolean
}>;
	["DogSizeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	breeds?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	suitabilityCategory?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	isFilterVisible?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["DogSizeBreedsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["DogSizeBreedsBySlugUniqueWhere"]: {
	slug?:string | null
};
	["DogSizeBreedsByDogsUniqueWhere"]: {
	dogs?:ValueTypes["DogUniqueWhere"] | null
};
	["DogUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	reproduction?:ValueTypes["DogReproductionUniqueWhere"] | null,
	avatar?:ValueTypes["ImageUniqueWhere"] | null
};
	["DogReproductionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	dog?:ValueTypes["DogUniqueWhere"] | null
};
	["ImageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["DogSizeBreedsByProductReviewsUniqueWhere"]: {
	productReviews?:ValueTypes["ProductReviewUniqueWhere"] | null
};
	["ProductReviewUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	productReviewReactions?:ValueTypes["ProductReviewReactionUniqueWhere"] | null,
	stats?:ValueTypes["ProductReviewStatsUniqueWhere"] | null
};
	["ProductReviewReactionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	productReview?:ValueTypes["ProductReviewUniqueWhere"] | null,
	user?:ValueTypes["UserUniqueWhere"] | null
};
	["UserUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	email?:string | null,
	tenantPersonId?:ValueTypes["UUID"] | null,
	verifiedEmail?:string | null,
	dogs?:ValueTypes["DogUniqueWhere"] | null,
	veterinary?:ValueTypes["VeterinaryUniqueWhere"] | null,
	blogPostReviews?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	productReviews?:ValueTypes["ProductReviewUniqueWhere"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null,
	productReviewReactions?:ValueTypes["ProductReviewReactionUniqueWhere"] | null,
	blogPosts?:ValueTypes["BlogPostUniqueWhere"] | null,
	avatar?:ValueTypes["ImageUniqueWhere"] | null,
	contactFormMessages?:ValueTypes["ContactFormMessageUniqueWhere"] | null,
	bugReports?:ValueTypes["BugReportUniqueWhere"] | null,
	protectedActions?:ValueTypes["ProtectedActionUniqueWhere"] | null,
	tenantPerson?:ValueTypes["TenantPersonUniqueWhere"] | null
};
	["VeterinaryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	user?:ValueTypes["UserUniqueWhere"] | null
};
	["BlogPostReviewUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null,
	stats?:ValueTypes["BlogPostReviewStatsUniqueWhere"] | null
};
	["BlogPostReviewReactionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	blogPostReview?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	user?:ValueTypes["UserUniqueWhere"] | null
};
	["BlogPostReviewStatsUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	blogPostReview?:ValueTypes["BlogPostReviewUniqueWhere"] | null
};
	["BlogPostUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	slug?:string | null,
	slugInternal?:string | null,
	reviews?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	items?:ValueTypes["ItemUniqueWhere"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	referenceList?:ValueTypes["ReferenceListUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	redirects?:ValueTypes["RedirectUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["ItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	slug?:string | null,
	featuresOfProduct?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	referenceList?:ValueTypes["ReferenceListUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	aliases?:ValueTypes["ItemAliasUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["ProductFeatureUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["ReferenceListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	references?:ValueTypes["ReferenceUniqueWhere"] | null
};
	["ReferenceUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	ogImage?:ValueTypes["ImageUniqueWhere"] | null,
	blogPage?:ValueTypes["BlogPageUniqueWhere"] | null,
	brandsPage?:ValueTypes["BrandsPageUniqueWhere"] | null,
	comparatorPage?:ValueTypes["ComparatorPageUniqueWhere"] | null,
	genericPage?:ValueTypes["GenericPageUniqueWhere"] | null,
	homePage?:ValueTypes["HomePageUniqueWhere"] | null,
	ingredientsPage?:ValueTypes["IngredientsPageUniqueWhere"] | null,
	loginPage?:ValueTypes["LoginPageUniqueWhere"] | null,
	registerPage?:ValueTypes["RegisterPageUniqueWhere"] | null,
	searchPage?:ValueTypes["SearchPageUniqueWhere"] | null,
	wizardPage?:ValueTypes["WizardPageUniqueWhere"] | null,
	contactPage?:ValueTypes["ContactPageUniqueWhere"] | null
};
	["BlogPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["RedirectUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["RedirectUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	from?:string | null
};
	["ContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentBlockUniqueWhere"] | null
};
	["ContentBlockUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	automatedContentBlockSlug?:string | null,
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentReferenceUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	images?:ValueTypes["ContentReferenceGalleryImageUniqueWhere"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null,
	list?:ValueTypes["ContentReferenceListUniqueWhere"] | null,
	outline?:ValueTypes["ContentLinksUniqueWhere"] | null,
	video?:ValueTypes["VideoUniqueWhere"] | null,
	image?:ValueTypes["ContentReferenceImageUniqueWhere"] | null
};
	["ContentReferenceGalleryImageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["LinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ContentReferenceListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ContentLinksUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ContentLinksItemUniqueWhere"] | null
};
	["ContentLinksItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["VideoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ContentReferenceImageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["BrandsPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["RedirectUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["ComparatorPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["RedirectUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["GenericPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	redirects?:ValueTypes["RedirectUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["LinkableUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	genericPage?:ValueTypes["GenericPageUniqueWhere"] | null
};
	["HomePageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["IngredientsPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["LoginPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["RegisterPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["SearchPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["WizardPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["RedirectUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ContactPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["RedirectUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["ItemAliasUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["ContactFormMessageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["BugReportUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ProtectedActionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	publicKey?:string | null
};
	["TenantPersonUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	user?:ValueTypes["UserUniqueWhere"] | null
};
	["ProductReviewStatsUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	productReview?:ValueTypes["ProductReviewUniqueWhere"] | null
};
	["DogSizeBreedsByBlogPostReviewsUniqueWhere"]: {
	blogPostReviews?:ValueTypes["BlogPostReviewUniqueWhere"] | null
};
	["DogSizeBreedsByFilterCombosUniqueWhere"]: {
	filterCombos?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["FilterComboUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["BreedConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BreedEdge"],
		__typename?: boolean
}>;
	["BreedEdge"]: AliasType<{
	node?:ValueTypes["Breed"],
		__typename?: boolean
}>;
	["ProductConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductEdge"],
		__typename?: boolean
}>;
	["ProductEdge"]: AliasType<{
	node?:ValueTypes["Product"],
		__typename?: boolean
}>;
	["DogActivity"]: AliasType<{
	_meta?:ValueTypes["DogActivityMeta"],
	id?:boolean,
	label?:boolean,
dogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Dog"]],
products?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
	dailyEnergyRequirementCoeficient?:boolean,
	remoteId?:boolean,
suitabilityCategory?: [{	filter?:ValueTypes["SuitabilityCategoryWhere"] | null},ValueTypes["SuitabilityCategory"]],
dogsByReproduction?: [{	by:ValueTypes["DogActivityDogsByReproductionUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
dogsByAvatar?: [{	by:ValueTypes["DogActivityDogsByAvatarUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
productsByRemoteId?: [{	by:ValueTypes["DogActivityProductsByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsBySlug?: [{	by:ValueTypes["DogActivityProductsBySlugUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByNutritionalValues?: [{	by:ValueTypes["DogActivityProductsByNutritionalValuesUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByReviews?: [{	by:ValueTypes["DogActivityProductsByReviewsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByDogs?: [{	by:ValueTypes["DogActivityProductsByDogsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByPackagings?: [{	by:ValueTypes["DogActivityProductsByPackagingsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByElements?: [{	by:ValueTypes["DogActivityProductsByElementsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByFlags?: [{	by:ValueTypes["DogActivityProductsByFlagsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByImage?: [{	by:ValueTypes["DogActivityProductsByImageUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByAliases?: [{	by:ValueTypes["DogActivityProductsByAliasesUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByEvaluation?: [{	by:ValueTypes["DogActivityProductsByEvaluationUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsBySeo?: [{	by:ValueTypes["DogActivityProductsBySeoUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByItemDeclensionFourthCategories?: [{	by:ValueTypes["DogActivityProductsByItemDeclensionFourthCategoriesUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByHeurekaImage?: [{	by:ValueTypes["DogActivityProductsByHeurekaImageUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByTopx?: [{	by:ValueTypes["DogActivityProductsByTopxUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
paginateDogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogConnection"]],
paginateProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
		__typename?: boolean
}>;
	["DogActivityMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	dogs?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	dailyEnergyRequirementCoeficient?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	suitabilityCategory?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["DogActivityDogsByReproductionUniqueWhere"]: {
	reproduction?:ValueTypes["DogReproductionUniqueWhere"] | null
};
	["DogActivityDogsByAvatarUniqueWhere"]: {
	avatar?:ValueTypes["ImageUniqueWhere"] | null
};
	["DogActivityProductsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["DogActivityProductsBySlugUniqueWhere"]: {
	slug?:string | null
};
	["DogActivityProductsByNutritionalValuesUniqueWhere"]: {
	nutritionalValues?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null
};
	["NutritionalValueOfProductUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["DogActivityProductsByReviewsUniqueWhere"]: {
	reviews?:ValueTypes["ProductReviewUniqueWhere"] | null
};
	["DogActivityProductsByDogsUniqueWhere"]: {
	dogs?:ValueTypes["DogUniqueWhere"] | null
};
	["DogActivityProductsByPackagingsUniqueWhere"]: {
	packagings?:ValueTypes["ProductPackageUniqueWhere"] | null
};
	["ProductPackageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	positionId?:string | null,
	externalId?:string | null
};
	["DogActivityProductsByElementsUniqueWhere"]: {
	elements?:ValueTypes["ElementOfProductUniqueWhere"] | null
};
	["ElementOfProductUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["DogActivityProductsByFlagsUniqueWhere"]: {
	flags?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null
};
	["ProductFlagOfProductUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["DogActivityProductsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["DogActivityProductsByAliasesUniqueWhere"]: {
	aliases?:ValueTypes["ProductAliasUniqueWhere"] | null
};
	["ProductAliasUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["DogActivityProductsByEvaluationUniqueWhere"]: {
	evaluation?:ValueTypes["ProductEvaluationUniqueWhere"] | null
};
	["ProductEvaluationUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	product?:ValueTypes["ProductUniqueWhere"] | null
};
	["ProductUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	slug?:string | null,
	nutritionalValues?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null,
	reviews?:ValueTypes["ProductReviewUniqueWhere"] | null,
	dogs?:ValueTypes["DogUniqueWhere"] | null,
	packagings?:ValueTypes["ProductPackageUniqueWhere"] | null,
	elements?:ValueTypes["ElementOfProductUniqueWhere"] | null,
	flags?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	aliases?:ValueTypes["ProductAliasUniqueWhere"] | null,
	evaluation?:ValueTypes["ProductEvaluationUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null,
	heurekaImage?:ValueTypes["ImageUniqueWhere"] | null,
	topx?:ValueTypes["TOPXProductUniqueWhere"] | null
};
	["ProductItemDeclensionFourthCategoryUniqueWhere"]: {
	id?:string | null
};
	["TOPXProductUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["DogActivityProductsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["DogActivityProductsByItemDeclensionFourthCategoriesUniqueWhere"]: {
	itemDeclensionFourthCategories?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null
};
	["DogActivityProductsByHeurekaImageUniqueWhere"]: {
	heurekaImage?:ValueTypes["ImageUniqueWhere"] | null
};
	["DogActivityProductsByTopxUniqueWhere"]: {
	topx?:ValueTypes["TOPXProductUniqueWhere"] | null
};
	["DogConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DogEdge"],
		__typename?: boolean
}>;
	["DogEdge"]: AliasType<{
	node?:ValueTypes["Dog"],
		__typename?: boolean
}>;
	["SuitabilityItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	min?:ValueTypes["OrderDirection"] | null,
	max?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	element?:ValueTypes["ElementOrderBy"] | null,
	nutritionalValue?:ValueTypes["NutritionalValueOrderBy"] | null,
	category?:ValueTypes["SuitabilityCategoryOrderBy"] | null
};
	["SuitabilityCategoryDogSizesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["SuitabilityCategoryDogSizesByBreedsUniqueWhere"]: {
	breeds?:ValueTypes["BreedUniqueWhere"] | null
};
	["BreedUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	slug?:string | null,
	dogs?:ValueTypes["DogUniqueWhere"] | null,
	productReviews?:ValueTypes["ProductReviewUniqueWhere"] | null,
	blogPostReviews?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	filterCombos?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["SuitabilityCategoryDogActivitiesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["SuitabilityCategoryDogActivitiesByDogsUniqueWhere"]: {
	dogs?:ValueTypes["DogUniqueWhere"] | null
};
	["SuitabilityCategoryDogActivitiesByProductsUniqueWhere"]: {
	products?:ValueTypes["ProductUniqueWhere"] | null
};
	["SuitabilityCategoryBreedsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["SuitabilityCategoryBreedsBySlugUniqueWhere"]: {
	slug?:string | null
};
	["SuitabilityCategoryBreedsByDogsUniqueWhere"]: {
	dogs?:ValueTypes["DogUniqueWhere"] | null
};
	["SuitabilityCategoryBreedsByProductReviewsUniqueWhere"]: {
	productReviews?:ValueTypes["ProductReviewUniqueWhere"] | null
};
	["SuitabilityCategoryBreedsByBlogPostReviewsUniqueWhere"]: {
	blogPostReviews?:ValueTypes["BlogPostReviewUniqueWhere"] | null
};
	["SuitabilityCategoryBreedsByFilterCombosUniqueWhere"]: {
	filterCombos?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["SuitabilityCategorySuitabilityItemsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["DogSizeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DogSizeEdge"],
		__typename?: boolean
}>;
	["DogSizeEdge"]: AliasType<{
	node?:ValueTypes["DogSize"],
		__typename?: boolean
}>;
	["DogActivityConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DogActivityEdge"],
		__typename?: boolean
}>;
	["DogActivityEdge"]: AliasType<{
	node?:ValueTypes["DogActivity"],
		__typename?: boolean
}>;
	["SuitabilityItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SuitabilityItemEdge"],
		__typename?: boolean
}>;
	["SuitabilityItemEdge"]: AliasType<{
	node?:ValueTypes["SuitabilityItem"],
		__typename?: boolean
}>;
	["AgeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AgeEdge"],
		__typename?: boolean
}>;
	["AgeEdge"]: AliasType<{
	node?:ValueTypes["Age"],
		__typename?: boolean
}>;
	["ProductReview"]: AliasType<{
	_meta?:ValueTypes["ProductReviewMeta"],
	id?:boolean,
	text?:boolean,
	publishedAt?:boolean,
productReviewReactions?: [{	filter?:ValueTypes["ProductReviewReactionWhere"] | null,	orderBy?:ValueTypes["ProductReviewReactionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReviewReaction"]],
score?: [{	filter?:ValueTypes["ScoreWhere"] | null},ValueTypes["Score"]],
product?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
user?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
stats?: [{	filter?:ValueTypes["ProductReviewStatsWhere"] | null},ValueTypes["ProductReviewStats"]],
	fullName?:boolean,
breed?: [{	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
age?: [{	filter?:ValueTypes["AgeWhere"] | null},ValueTypes["Age"]],
	url?:boolean,
	isVisible?:boolean,
	response?:boolean,
productReviewReactionsByUser?: [{	by:ValueTypes["ProductReviewProductReviewReactionsByUserUniqueWhere"],	filter?:ValueTypes["ProductReviewReactionWhere"] | null},ValueTypes["ProductReviewReaction"]],
paginateProductReviewReactions?: [{	filter?:ValueTypes["ProductReviewReactionWhere"] | null,	orderBy?:ValueTypes["ProductReviewReactionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewReactionConnection"]],
		__typename?: boolean
}>;
	["ProductReviewMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	publishedAt?:ValueTypes["FieldMeta"],
	productReviewReactions?:ValueTypes["FieldMeta"],
	score?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	stats?:ValueTypes["FieldMeta"],
	fullName?:ValueTypes["FieldMeta"],
	breed?:ValueTypes["FieldMeta"],
	age?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	isVisible?:ValueTypes["FieldMeta"],
	response?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductReviewReaction"]: AliasType<{
	_meta?:ValueTypes["ProductReviewReactionMeta"],
	id?:boolean,
	sentiment?:boolean,
user?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
productReview?: [{	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
		__typename?: boolean
}>;
	["ProductReviewReactionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	sentiment?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	productReview?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["User"]: AliasType<{
	_meta?:ValueTypes["UserMeta"],
	id?:boolean,
dogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Dog"]],
veterinary?: [{	filter?:ValueTypes["VeterinaryWhere"] | null},ValueTypes["Veterinary"]],
	email?:boolean,
blogPostReviews?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostReview"]],
productReviews?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReview"]],
blogPostReviewReactions?: [{	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewReactionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostReviewReaction"]],
productReviewReactions?: [{	filter?:ValueTypes["ProductReviewReactionWhere"] | null,	orderBy?:ValueTypes["ProductReviewReactionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReviewReaction"]],
	tenantPersonId?:boolean,
	fullName?:boolean,
blogPosts?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPost"]],
	createdAt?:boolean,
	verifiedAt?:boolean,
avatar?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
contactFormMessages?: [{	filter?:ValueTypes["ContactFormMessageWhere"] | null,	orderBy?:ValueTypes["ContactFormMessageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactFormMessage"]],
bugReports?: [{	filter?:ValueTypes["BugReportWhere"] | null,	orderBy?:ValueTypes["BugReportOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BugReport"]],
	verifiedEmail?:boolean,
protectedActions?: [{	filter?:ValueTypes["ProtectedActionWhere"] | null,	orderBy?:ValueTypes["ProtectedActionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProtectedAction"]],
	blockedAt?:boolean,
tenantPerson?: [{	filter?:ValueTypes["TenantPersonWhere"] | null},ValueTypes["TenantPerson"]],
	note?:boolean,
dogsByReproduction?: [{	by:ValueTypes["UserDogsByReproductionUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
dogsByAvatar?: [{	by:ValueTypes["UserDogsByAvatarUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
blogPostReviewsByBlogPostReviewReactions?: [{	by:ValueTypes["UserBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReview"]],
blogPostReviewsByStats?: [{	by:ValueTypes["UserBlogPostReviewsByStatsUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReview"]],
productReviewsByProductReviewReactions?: [{	by:ValueTypes["UserProductReviewsByProductReviewReactionsUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
productReviewsByStats?: [{	by:ValueTypes["UserProductReviewsByStatsUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
blogPostReviewReactionsByBlogPostReview?: [{	by:ValueTypes["UserBlogPostReviewReactionsByBlogPostReviewUniqueWhere"],	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null},ValueTypes["BlogPostReviewReaction"]],
productReviewReactionsByProductReview?: [{	by:ValueTypes["UserProductReviewReactionsByProductReviewUniqueWhere"],	filter?:ValueTypes["ProductReviewReactionWhere"] | null},ValueTypes["ProductReviewReaction"]],
blogPostsBySlug?: [{	by:ValueTypes["UserBlogPostsBySlugUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
blogPostsBySlugInternal?: [{	by:ValueTypes["UserBlogPostsBySlugInternalUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
blogPostsByReviews?: [{	by:ValueTypes["UserBlogPostsByReviewsUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
blogPostsByItems?: [{	by:ValueTypes["UserBlogPostsByItemsUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
blogPostsByImage?: [{	by:ValueTypes["UserBlogPostsByImageUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
blogPostsByReferenceList?: [{	by:ValueTypes["UserBlogPostsByReferenceListUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
blogPostsBySeo?: [{	by:ValueTypes["UserBlogPostsBySeoUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
blogPostsByRedirects?: [{	by:ValueTypes["UserBlogPostsByRedirectsUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
blogPostsByContent?: [{	by:ValueTypes["UserBlogPostsByContentUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
blogPostsByDraft?: [{	by:ValueTypes["UserBlogPostsByDraftUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
protectedActionsByPublicKey?: [{	by:ValueTypes["UserProtectedActionsByPublicKeyUniqueWhere"],	filter?:ValueTypes["ProtectedActionWhere"] | null},ValueTypes["ProtectedAction"]],
paginateDogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogConnection"]],
paginateBlogPostReviews?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostReviewConnection"]],
paginateProductReviews?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewConnection"]],
paginateBlogPostReviewReactions?: [{	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewReactionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostReviewReactionConnection"]],
paginateProductReviewReactions?: [{	filter?:ValueTypes["ProductReviewReactionWhere"] | null,	orderBy?:ValueTypes["ProductReviewReactionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewReactionConnection"]],
paginateBlogPosts?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostConnection"]],
paginateContactFormMessages?: [{	filter?:ValueTypes["ContactFormMessageWhere"] | null,	orderBy?:ValueTypes["ContactFormMessageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactFormMessageConnection"]],
paginateBugReports?: [{	filter?:ValueTypes["BugReportWhere"] | null,	orderBy?:ValueTypes["BugReportOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BugReportConnection"]],
paginateProtectedActions?: [{	filter?:ValueTypes["ProtectedActionWhere"] | null,	orderBy?:ValueTypes["ProtectedActionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProtectedActionConnection"]],
		__typename?: boolean
}>;
	["UserMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	dogs?:ValueTypes["FieldMeta"],
	veterinary?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	blogPostReviews?:ValueTypes["FieldMeta"],
	productReviews?:ValueTypes["FieldMeta"],
	blogPostReviewReactions?:ValueTypes["FieldMeta"],
	productReviewReactions?:ValueTypes["FieldMeta"],
	tenantPersonId?:ValueTypes["FieldMeta"],
	fullName?:ValueTypes["FieldMeta"],
	blogPosts?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	verifiedAt?:ValueTypes["FieldMeta"],
	avatar?:ValueTypes["FieldMeta"],
	contactFormMessages?:ValueTypes["FieldMeta"],
	bugReports?:ValueTypes["FieldMeta"],
	verifiedEmail?:ValueTypes["FieldMeta"],
	protectedActions?:ValueTypes["FieldMeta"],
	blockedAt?:ValueTypes["FieldMeta"],
	tenantPerson?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Veterinary"]: AliasType<{
	_meta?:ValueTypes["VeterinaryMeta"],
	id?:boolean,
user?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
		__typename?: boolean
}>;
	["VeterinaryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BlogPostReview"]: AliasType<{
	_meta?:ValueTypes["BlogPostReviewMeta"],
	id?:boolean,
	title?:boolean,
	text?:boolean,
	publishedAt?:boolean,
blogPostReviewReactions?: [{	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewReactionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostReviewReaction"]],
blogPost?: [{	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
user?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
stats?: [{	filter?:ValueTypes["BlogPostReviewStatsWhere"] | null},ValueTypes["BlogPostReviewStats"]],
	fullName?:boolean,
breed?: [{	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
age?: [{	filter?:ValueTypes["AgeWhere"] | null},ValueTypes["Age"]],
	url?:boolean,
	isVisible?:boolean,
	response?:boolean,
blogPostReviewReactionsByUser?: [{	by:ValueTypes["BlogPostReviewBlogPostReviewReactionsByUserUniqueWhere"],	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null},ValueTypes["BlogPostReviewReaction"]],
paginateBlogPostReviewReactions?: [{	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewReactionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostReviewReactionConnection"]],
		__typename?: boolean
}>;
	["BlogPostReviewMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	publishedAt?:ValueTypes["FieldMeta"],
	blogPostReviewReactions?:ValueTypes["FieldMeta"],
	blogPost?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	stats?:ValueTypes["FieldMeta"],
	fullName?:ValueTypes["FieldMeta"],
	breed?:ValueTypes["FieldMeta"],
	age?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	isVisible?:ValueTypes["FieldMeta"],
	response?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BlogPostReviewReaction"]: AliasType<{
	_meta?:ValueTypes["BlogPostReviewReactionMeta"],
	id?:boolean,
	sentiment?:boolean,
user?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
blogPostReview?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReview"]],
		__typename?: boolean
}>;
	["BlogPostReviewReactionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	sentiment?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	blogPostReview?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BlogPostReviewReactionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	sentiment?:ValueTypes["OrderDirection"] | null,
	user?:ValueTypes["UserOrderBy"] | null,
	blogPostReview?:ValueTypes["BlogPostReviewOrderBy"] | null
};
	["BlogPostReviewOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	publishedAt?:ValueTypes["OrderDirection"] | null,
	blogPost?:ValueTypes["BlogPostOrderBy"] | null,
	user?:ValueTypes["UserOrderBy"] | null,
	stats?:ValueTypes["BlogPostReviewStatsOrderBy"] | null,
	fullName?:ValueTypes["OrderDirection"] | null,
	breed?:ValueTypes["BreedOrderBy"] | null,
	age?:ValueTypes["AgeOrderBy"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	isVisible?:ValueTypes["OrderDirection"] | null,
	response?:ValueTypes["OrderDirection"] | null
};
	["BlogPostReviewStatsOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	total?:ValueTypes["OrderDirection"] | null,
	positive?:ValueTypes["OrderDirection"] | null,
	negative?:ValueTypes["OrderDirection"] | null,
	blogPostReview?:ValueTypes["BlogPostReviewOrderBy"] | null
};
	["BlogPostReviewStats"]: AliasType<{
	_meta?:ValueTypes["BlogPostReviewStatsMeta"],
	id?:boolean,
	total?:boolean,
	positive?:boolean,
	negative?:boolean,
blogPostReview?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReview"]],
		__typename?: boolean
}>;
	["BlogPostReviewStatsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	total?:ValueTypes["FieldMeta"],
	positive?:ValueTypes["FieldMeta"],
	negative?:ValueTypes["FieldMeta"],
	blogPostReview?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BlogPostReviewBlogPostReviewReactionsByUserUniqueWhere"]: {
	user?:ValueTypes["UserUniqueWhere"] | null
};
	["BlogPostReviewReactionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogPostReviewReactionEdge"],
		__typename?: boolean
}>;
	["BlogPostReviewReactionEdge"]: AliasType<{
	node?:ValueTypes["BlogPostReviewReaction"],
		__typename?: boolean
}>;
	["ProductReviewOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	publishedAt?:ValueTypes["OrderDirection"] | null,
	score?:ValueTypes["ScoreOrderBy"] | null,
	product?:ValueTypes["ProductOrderBy"] | null,
	user?:ValueTypes["UserOrderBy"] | null,
	stats?:ValueTypes["ProductReviewStatsOrderBy"] | null,
	fullName?:ValueTypes["OrderDirection"] | null,
	breed?:ValueTypes["BreedOrderBy"] | null,
	age?:ValueTypes["AgeOrderBy"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	isVisible?:ValueTypes["OrderDirection"] | null,
	response?:ValueTypes["OrderDirection"] | null
};
	["ScoreOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	starsAmount?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null
};
	["ProductReviewStatsOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	total?:ValueTypes["OrderDirection"] | null,
	positive?:ValueTypes["OrderDirection"] | null,
	negative?:ValueTypes["OrderDirection"] | null,
	productReview?:ValueTypes["ProductReviewOrderBy"] | null
};
	["ProductReviewReactionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	sentiment?:ValueTypes["OrderDirection"] | null,
	user?:ValueTypes["UserOrderBy"] | null,
	productReview?:ValueTypes["ProductReviewOrderBy"] | null
};
	["ContactFormMessage"]: AliasType<{
	_meta?:ValueTypes["ContactFormMessageMeta"],
	id?:boolean,
	message?:boolean,
	email?:boolean,
	receivedAt?:boolean,
user?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
	isResolved?:boolean,
	url?:boolean,
		__typename?: boolean
}>;
	["ContactFormMessageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	message?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	receivedAt?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	isResolved?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContactFormMessageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	message?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	receivedAt?:ValueTypes["OrderDirection"] | null,
	user?:ValueTypes["UserOrderBy"] | null,
	isResolved?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null
};
	["BugReport"]: AliasType<{
	_meta?:ValueTypes["BugReportMeta"],
	id?:boolean,
	message?:boolean,
	receivedAt?:boolean,
	isResolved?:boolean,
user?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
	url?:boolean,
		__typename?: boolean
}>;
	["BugReportMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	message?:ValueTypes["FieldMeta"],
	receivedAt?:ValueTypes["FieldMeta"],
	isResolved?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BugReportOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	message?:ValueTypes["OrderDirection"] | null,
	receivedAt?:ValueTypes["OrderDirection"] | null,
	isResolved?:ValueTypes["OrderDirection"] | null,
	user?:ValueTypes["UserOrderBy"] | null,
	url?:ValueTypes["OrderDirection"] | null
};
	["ProtectedAction"]: AliasType<{
	_meta?:ValueTypes["ProtectedActionMeta"],
	id?:boolean,
	type?:boolean,
	createdAt?:boolean,
	usedAt?:boolean,
	expiresAt?:boolean,
	publicKey?:boolean,
	secretHash?:boolean,
	verifyEmail?:boolean,
	createdMetadata?:boolean,
	usedMetadata?:boolean,
user?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
		__typename?: boolean
}>;
	["ProtectedActionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	usedAt?:ValueTypes["FieldMeta"],
	expiresAt?:ValueTypes["FieldMeta"],
	publicKey?:ValueTypes["FieldMeta"],
	secretHash?:ValueTypes["FieldMeta"],
	verifyEmail?:ValueTypes["FieldMeta"],
	createdMetadata?:ValueTypes["FieldMeta"],
	usedMetadata?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProtectedActionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null,
	usedAt?:ValueTypes["OrderDirection"] | null,
	expiresAt?:ValueTypes["OrderDirection"] | null,
	publicKey?:ValueTypes["OrderDirection"] | null,
	secretHash?:ValueTypes["OrderDirection"] | null,
	verifyEmail?:ValueTypes["OrderDirection"] | null,
	createdMetadata?:ValueTypes["OrderDirection"] | null,
	usedMetadata?:ValueTypes["OrderDirection"] | null,
	user?:ValueTypes["UserOrderBy"] | null
};
	["TenantPerson"]: AliasType<{
	_meta?:ValueTypes["TenantPersonMeta"],
	id?:boolean,
	identityId?:boolean,
	email?:boolean,
	roles?:boolean,
user?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
		__typename?: boolean
}>;
	["TenantPersonMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	identityId?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	roles?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["UserDogsByReproductionUniqueWhere"]: {
	reproduction?:ValueTypes["DogReproductionUniqueWhere"] | null
};
	["UserDogsByAvatarUniqueWhere"]: {
	avatar?:ValueTypes["ImageUniqueWhere"] | null
};
	["UserBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"]: {
	blogPostReviewReactions?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null
};
	["UserBlogPostReviewsByStatsUniqueWhere"]: {
	stats?:ValueTypes["BlogPostReviewStatsUniqueWhere"] | null
};
	["UserProductReviewsByProductReviewReactionsUniqueWhere"]: {
	productReviewReactions?:ValueTypes["ProductReviewReactionUniqueWhere"] | null
};
	["UserProductReviewsByStatsUniqueWhere"]: {
	stats?:ValueTypes["ProductReviewStatsUniqueWhere"] | null
};
	["UserBlogPostReviewReactionsByBlogPostReviewUniqueWhere"]: {
	blogPostReview?:ValueTypes["BlogPostReviewUniqueWhere"] | null
};
	["UserProductReviewReactionsByProductReviewUniqueWhere"]: {
	productReview?:ValueTypes["ProductReviewUniqueWhere"] | null
};
	["UserBlogPostsBySlugUniqueWhere"]: {
	slug?:string | null
};
	["UserBlogPostsBySlugInternalUniqueWhere"]: {
	slugInternal?:string | null
};
	["UserBlogPostsByReviewsUniqueWhere"]: {
	reviews?:ValueTypes["BlogPostReviewUniqueWhere"] | null
};
	["UserBlogPostsByItemsUniqueWhere"]: {
	items?:ValueTypes["ItemUniqueWhere"] | null
};
	["UserBlogPostsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["UserBlogPostsByReferenceListUniqueWhere"]: {
	referenceList?:ValueTypes["ReferenceListUniqueWhere"] | null
};
	["UserBlogPostsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["UserBlogPostsByRedirectsUniqueWhere"]: {
	redirects?:ValueTypes["RedirectUniqueWhere"] | null
};
	["UserBlogPostsByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["UserBlogPostsByDraftUniqueWhere"]: {
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["UserProtectedActionsByPublicKeyUniqueWhere"]: {
	publicKey?:string | null
};
	["BlogPostReviewConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogPostReviewEdge"],
		__typename?: boolean
}>;
	["BlogPostReviewEdge"]: AliasType<{
	node?:ValueTypes["BlogPostReview"],
		__typename?: boolean
}>;
	["ProductReviewConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductReviewEdge"],
		__typename?: boolean
}>;
	["ProductReviewEdge"]: AliasType<{
	node?:ValueTypes["ProductReview"],
		__typename?: boolean
}>;
	["ProductReviewReactionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductReviewReactionEdge"],
		__typename?: boolean
}>;
	["ProductReviewReactionEdge"]: AliasType<{
	node?:ValueTypes["ProductReviewReaction"],
		__typename?: boolean
}>;
	["BlogPostConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogPostEdge"],
		__typename?: boolean
}>;
	["BlogPostEdge"]: AliasType<{
	node?:ValueTypes["BlogPost"],
		__typename?: boolean
}>;
	["ContactFormMessageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContactFormMessageEdge"],
		__typename?: boolean
}>;
	["ContactFormMessageEdge"]: AliasType<{
	node?:ValueTypes["ContactFormMessage"],
		__typename?: boolean
}>;
	["BugReportConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BugReportEdge"],
		__typename?: boolean
}>;
	["BugReportEdge"]: AliasType<{
	node?:ValueTypes["BugReport"],
		__typename?: boolean
}>;
	["ProtectedActionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProtectedActionEdge"],
		__typename?: boolean
}>;
	["ProtectedActionEdge"]: AliasType<{
	node?:ValueTypes["ProtectedAction"],
		__typename?: boolean
}>;
	["Score"]: AliasType<{
	_meta?:ValueTypes["ScoreMeta"],
	id?:boolean,
	label?:boolean,
productReviews?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReview"]],
	starsAmount?:boolean,
	remoteId?:boolean,
productReviewsByProductReviewReactions?: [{	by:ValueTypes["ScoreProductReviewsByProductReviewReactionsUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
productReviewsByStats?: [{	by:ValueTypes["ScoreProductReviewsByStatsUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
paginateProductReviews?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewConnection"]],
		__typename?: boolean
}>;
	["ScoreMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	productReviews?:ValueTypes["FieldMeta"],
	starsAmount?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ScoreProductReviewsByProductReviewReactionsUniqueWhere"]: {
	productReviewReactions?:ValueTypes["ProductReviewReactionUniqueWhere"] | null
};
	["ScoreProductReviewsByStatsUniqueWhere"]: {
	stats?:ValueTypes["ProductReviewStatsUniqueWhere"] | null
};
	["ProductReviewStats"]: AliasType<{
	_meta?:ValueTypes["ProductReviewStatsMeta"],
	id?:boolean,
	total?:boolean,
	positive?:boolean,
	negative?:boolean,
productReview?: [{	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
		__typename?: boolean
}>;
	["ProductReviewStatsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	total?:ValueTypes["FieldMeta"],
	positive?:ValueTypes["FieldMeta"],
	negative?:ValueTypes["FieldMeta"],
	productReview?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductReviewProductReviewReactionsByUserUniqueWhere"]: {
	user?:ValueTypes["UserUniqueWhere"] | null
};
	["AgeDogsByReproductionUniqueWhere"]: {
	reproduction?:ValueTypes["DogReproductionUniqueWhere"] | null
};
	["AgeDogsByAvatarUniqueWhere"]: {
	avatar?:ValueTypes["ImageUniqueWhere"] | null
};
	["AgeProductReviewsByProductReviewReactionsUniqueWhere"]: {
	productReviewReactions?:ValueTypes["ProductReviewReactionUniqueWhere"] | null
};
	["AgeProductReviewsByStatsUniqueWhere"]: {
	stats?:ValueTypes["ProductReviewStatsUniqueWhere"] | null
};
	["AgeBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"]: {
	blogPostReviewReactions?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null
};
	["AgeBlogPostReviewsByStatsUniqueWhere"]: {
	stats?:ValueTypes["BlogPostReviewStatsUniqueWhere"] | null
};
	["SuitabilityCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SuitabilityCategoryEdge"],
		__typename?: boolean
}>;
	["SuitabilityCategoryEdge"]: AliasType<{
	node?:ValueTypes["SuitabilityCategory"],
		__typename?: boolean
}>;
	["DogBodyType"]: AliasType<{
	_meta?:ValueTypes["DogBodyTypeMeta"],
	id?:boolean,
	name?:boolean,
	lead?:boolean,
dogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Dog"]],
	order?:boolean,
	value?:boolean,
	remoteId?:boolean,
category?: [{	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null},ValueTypes["DogBodyTypeCategory"]],
imageMain?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
imageFrom?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
imageTo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
dogsByReproduction?: [{	by:ValueTypes["DogBodyTypeDogsByReproductionUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
dogsByAvatar?: [{	by:ValueTypes["DogBodyTypeDogsByAvatarUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
paginateDogs?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogConnection"]],
		__typename?: boolean
}>;
	["DogBodyTypeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	dogs?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
	imageMain?:ValueTypes["FieldMeta"],
	imageFrom?:ValueTypes["FieldMeta"],
	imageTo?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["DogBodyTypeCategory"]: AliasType<{
	_meta?:ValueTypes["DogBodyTypeCategoryMeta"],
	id?:boolean,
	name?:boolean,
items?: [{	filter?:ValueTypes["DogBodyTypeWhere"] | null,	orderBy?:ValueTypes["DogBodyTypeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogBodyType"]],
	remoteId?:boolean,
imageMain?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
itemsByRemoteId?: [{	by:ValueTypes["DogBodyTypeCategoryItemsByRemoteIdUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null},ValueTypes["DogBodyType"]],
itemsByDogs?: [{	by:ValueTypes["DogBodyTypeCategoryItemsByDogsUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null},ValueTypes["DogBodyType"]],
itemsByImageMain?: [{	by:ValueTypes["DogBodyTypeCategoryItemsByImageMainUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null},ValueTypes["DogBodyType"]],
itemsByImageFrom?: [{	by:ValueTypes["DogBodyTypeCategoryItemsByImageFromUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null},ValueTypes["DogBodyType"]],
itemsByImageTo?: [{	by:ValueTypes["DogBodyTypeCategoryItemsByImageToUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null},ValueTypes["DogBodyType"]],
paginateItems?: [{	filter?:ValueTypes["DogBodyTypeWhere"] | null,	orderBy?:ValueTypes["DogBodyTypeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogBodyTypeConnection"]],
		__typename?: boolean
}>;
	["DogBodyTypeCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	imageMain?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["DogBodyTypeCategoryItemsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["DogBodyTypeCategoryItemsByDogsUniqueWhere"]: {
	dogs?:ValueTypes["DogUniqueWhere"] | null
};
	["DogBodyTypeCategoryItemsByImageMainUniqueWhere"]: {
	imageMain?:ValueTypes["ImageUniqueWhere"] | null
};
	["DogBodyTypeCategoryItemsByImageFromUniqueWhere"]: {
	imageFrom?:ValueTypes["ImageUniqueWhere"] | null
};
	["DogBodyTypeCategoryItemsByImageToUniqueWhere"]: {
	imageTo?:ValueTypes["ImageUniqueWhere"] | null
};
	["DogBodyTypeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DogBodyTypeEdge"],
		__typename?: boolean
}>;
	["DogBodyTypeEdge"]: AliasType<{
	node?:ValueTypes["DogBodyType"],
		__typename?: boolean
}>;
	["DogBodyTypeDogsByReproductionUniqueWhere"]: {
	reproduction?:ValueTypes["DogReproductionUniqueWhere"] | null
};
	["DogBodyTypeDogsByAvatarUniqueWhere"]: {
	avatar?:ValueTypes["ImageUniqueWhere"] | null
};
	["DogReproduction"]: AliasType<{
	_meta?:ValueTypes["DogReproductionMeta"],
	id?:boolean,
	type?:boolean,
	breastfeedingPuppyCount?:boolean,
	pregnancy?:boolean,
dog?: [{	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
breastfeedingCategory?: [{	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null},ValueTypes["BreastfeedingCategory"]],
		__typename?: boolean
}>;
	["DogReproductionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	breastfeedingPuppyCount?:ValueTypes["FieldMeta"],
	pregnancy?:ValueTypes["FieldMeta"],
	dog?:ValueTypes["FieldMeta"],
	breastfeedingCategory?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BreastfeedingCategory"]: AliasType<{
	_meta?:ValueTypes["BreastfeedingCategoryMeta"],
	id?:boolean,
	week?:boolean,
	coeficient?:boolean,
dogs?: [{	filter?:ValueTypes["DogReproductionWhere"] | null,	orderBy?:ValueTypes["DogReproductionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogReproduction"]],
dogsByDog?: [{	by:ValueTypes["BreastfeedingCategoryDogsByDogUniqueWhere"],	filter?:ValueTypes["DogReproductionWhere"] | null},ValueTypes["DogReproduction"]],
paginateDogs?: [{	filter?:ValueTypes["DogReproductionWhere"] | null,	orderBy?:ValueTypes["DogReproductionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogReproductionConnection"]],
		__typename?: boolean
}>;
	["BreastfeedingCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	week?:ValueTypes["FieldMeta"],
	coeficient?:ValueTypes["FieldMeta"],
	dogs?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BreastfeedingCategoryDogsByDogUniqueWhere"]: {
	dog?:ValueTypes["DogUniqueWhere"] | null
};
	["DogReproductionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DogReproductionEdge"],
		__typename?: boolean
}>;
	["DogReproductionEdge"]: AliasType<{
	node?:ValueTypes["DogReproduction"],
		__typename?: boolean
}>;
	["ItemSubCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ItemSubCategoryEdge"],
		__typename?: boolean
}>;
	["ItemSubCategoryEdge"]: AliasType<{
	node?:ValueTypes["ItemSubCategory"],
		__typename?: boolean
}>;
	["BodyTagConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BodyTagEdge"],
		__typename?: boolean
}>;
	["BodyTagEdge"]: AliasType<{
	node?:ValueTypes["BodyTag"],
		__typename?: boolean
}>;
	["Review"]: AliasType<{
	_meta?:ValueTypes["ReviewMeta"],
	id?:boolean,
dogBreeds?: [{	filter?:ValueTypes["BreedWhere"] | null,	orderBy?:ValueTypes["BreedOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Breed"]],
	text?:boolean,
	remoteId?:boolean,
	author?:boolean,
paginateDogBreeds?: [{	filter?:ValueTypes["BreedWhere"] | null,	orderBy?:ValueTypes["BreedOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BreedConnection"]],
		__typename?: boolean
}>;
	["ReviewMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	dogBreeds?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	author?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ReviewOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	author?:ValueTypes["OrderDirection"] | null
};
	["FilterComboOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	breed?:ValueTypes["BreedOrderBy"] | null,
	brand?:ValueTypes["BrandOrderBy"] | null,
	region?:ValueTypes["RegionOrderBy"] | null,
	ageCategory?:ValueTypes["AgeCategoryOrderBy"] | null,
	treatment?:ValueTypes["BodyTagOrderBy"] | null,
	flavor?:ValueTypes["ItemSubCategoryOrderBy"] | null,
	allergy?:ValueTypes["ItemSubCategoryOrderBy"] | null
};
	["AgeCategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	labelFor?:ValueTypes["OrderDirection"] | null,
	slug?:ValueTypes["OrderDirection"] | null
};
	["BreedDogsByReproductionUniqueWhere"]: {
	reproduction?:ValueTypes["DogReproductionUniqueWhere"] | null
};
	["BreedDogsByAvatarUniqueWhere"]: {
	avatar?:ValueTypes["ImageUniqueWhere"] | null
};
	["BreedProductReviewsByProductReviewReactionsUniqueWhere"]: {
	productReviewReactions?:ValueTypes["ProductReviewReactionUniqueWhere"] | null
};
	["BreedProductReviewsByStatsUniqueWhere"]: {
	stats?:ValueTypes["ProductReviewStatsUniqueWhere"] | null
};
	["BreedBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"]: {
	blogPostReviewReactions?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null
};
	["BreedBlogPostReviewsByStatsUniqueWhere"]: {
	stats?:ValueTypes["BlogPostReviewStatsUniqueWhere"] | null
};
	["BreedFilterCombosByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["BreedFilterCombosBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ReviewConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ReviewEdge"],
		__typename?: boolean
}>;
	["ReviewEdge"]: AliasType<{
	node?:ValueTypes["Review"],
		__typename?: boolean
}>;
	["FilterComboConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FilterComboEdge"],
		__typename?: boolean
}>;
	["FilterComboEdge"]: AliasType<{
	node?:ValueTypes["FilterCombo"],
		__typename?: boolean
}>;
	["AgeCategory"]: AliasType<{
	_meta?:ValueTypes["AgeCategoryMeta"],
	id?:boolean,
	remoteId?:boolean,
	order?:boolean,
	labelFor?:boolean,
products?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
	slug?:boolean,
filterCombos?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FilterCombo"]],
filterCombosByRemoteId?: [{	by:ValueTypes["AgeCategoryFilterCombosByRemoteIdUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
filterCombosBySeo?: [{	by:ValueTypes["AgeCategoryFilterCombosBySeoUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
paginateProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
paginateFilterCombos?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilterComboConnection"]],
		__typename?: boolean
}>;
	["AgeCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	labelFor?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	filterCombos?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["AgeCategoryFilterCombosByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["AgeCategoryFilterCombosBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["RegionCountriesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["RegionCountriesByManufacturersUniqueWhere"]: {
	manufacturers?:ValueTypes["BrandManufacturerUniqueWhere"] | null
};
	["BrandManufacturerUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["RegionFilterCombosByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["RegionFilterCombosBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["CountryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CountryEdge"],
		__typename?: boolean
}>;
	["CountryEdge"]: AliasType<{
	node?:ValueTypes["Country"],
		__typename?: boolean
}>;
	["CountryManufacturersByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["BrandManufacturerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BrandManufacturerEdge"],
		__typename?: boolean
}>;
	["BrandManufacturerEdge"]: AliasType<{
	node?:ValueTypes["BrandManufacturer"],
		__typename?: boolean
}>;
	["ProductLine"]: AliasType<{
	_meta?:ValueTypes["ProductLineMeta"],
	id?:boolean,
	name?:boolean,
products?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
	remoteId?:boolean,
	lead?:boolean,
	order?:boolean,
brand?: [{	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
aliases?: [{	filter?:ValueTypes["ProductLineAliasWhere"] | null,	orderBy?:ValueTypes["ProductLineAliasOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductLineAlias"]],
	slug?:boolean,
flavors?: [{	filter?:ValueTypes["ProductLineFlavorWhere"] | null,	orderBy?:ValueTypes["ProductLineFlavorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductLineFlavor"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	customMetaDescription?:boolean,
productsByRemoteId?: [{	by:ValueTypes["ProductLineProductsByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsBySlug?: [{	by:ValueTypes["ProductLineProductsBySlugUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByNutritionalValues?: [{	by:ValueTypes["ProductLineProductsByNutritionalValuesUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByReviews?: [{	by:ValueTypes["ProductLineProductsByReviewsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByDogs?: [{	by:ValueTypes["ProductLineProductsByDogsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByPackagings?: [{	by:ValueTypes["ProductLineProductsByPackagingsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByElements?: [{	by:ValueTypes["ProductLineProductsByElementsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByFlags?: [{	by:ValueTypes["ProductLineProductsByFlagsUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByImage?: [{	by:ValueTypes["ProductLineProductsByImageUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByAliases?: [{	by:ValueTypes["ProductLineProductsByAliasesUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByEvaluation?: [{	by:ValueTypes["ProductLineProductsByEvaluationUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsBySeo?: [{	by:ValueTypes["ProductLineProductsBySeoUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByItemDeclensionFourthCategories?: [{	by:ValueTypes["ProductLineProductsByItemDeclensionFourthCategoriesUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByHeurekaImage?: [{	by:ValueTypes["ProductLineProductsByHeurekaImageUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
productsByTopx?: [{	by:ValueTypes["ProductLineProductsByTopxUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
paginateProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
paginateAliases?: [{	filter?:ValueTypes["ProductLineAliasWhere"] | null,	orderBy?:ValueTypes["ProductLineAliasOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductLineAliasConnection"]],
paginateFlavors?: [{	filter?:ValueTypes["ProductLineFlavorWhere"] | null,	orderBy?:ValueTypes["ProductLineFlavorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductLineFlavorConnection"]],
		__typename?: boolean
}>;
	["ProductLineMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	brand?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	aliases?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	flavors?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	customMetaDescription?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductLineAlias"]: AliasType<{
	_meta?:ValueTypes["ProductLineAliasMeta"],
	id?:boolean,
	remoteId?:boolean,
	name?:boolean,
productLines?: [{	filter?:ValueTypes["ProductLineWhere"] | null,	orderBy?:ValueTypes["ProductLineOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductLine"]],
paginateProductLines?: [{	filter?:ValueTypes["ProductLineWhere"] | null,	orderBy?:ValueTypes["ProductLineOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductLineConnection"]],
		__typename?: boolean
}>;
	["ProductLineAliasMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	productLines?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductLineConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductLineEdge"],
		__typename?: boolean
}>;
	["ProductLineEdge"]: AliasType<{
	node?:ValueTypes["ProductLine"],
		__typename?: boolean
}>;
	["ProductLineAliasOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null
};
	["ProductLineFlavor"]: AliasType<{
	_meta?:ValueTypes["ProductLineFlavorMeta"],
	id?:boolean,
itemSubCategory?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
productLine?: [{	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLine"]],
		__typename?: boolean
}>;
	["ProductLineFlavorMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	itemSubCategory?:ValueTypes["FieldMeta"],
	productLine?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductLineFlavorOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	itemSubCategory?:ValueTypes["ItemSubCategoryOrderBy"] | null,
	productLine?:ValueTypes["ProductLineOrderBy"] | null
};
	["ProductLineProductsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ProductLineProductsBySlugUniqueWhere"]: {
	slug?:string | null
};
	["ProductLineProductsByNutritionalValuesUniqueWhere"]: {
	nutritionalValues?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null
};
	["ProductLineProductsByReviewsUniqueWhere"]: {
	reviews?:ValueTypes["ProductReviewUniqueWhere"] | null
};
	["ProductLineProductsByDogsUniqueWhere"]: {
	dogs?:ValueTypes["DogUniqueWhere"] | null
};
	["ProductLineProductsByPackagingsUniqueWhere"]: {
	packagings?:ValueTypes["ProductPackageUniqueWhere"] | null
};
	["ProductLineProductsByElementsUniqueWhere"]: {
	elements?:ValueTypes["ElementOfProductUniqueWhere"] | null
};
	["ProductLineProductsByFlagsUniqueWhere"]: {
	flags?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null
};
	["ProductLineProductsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["ProductLineProductsByAliasesUniqueWhere"]: {
	aliases?:ValueTypes["ProductAliasUniqueWhere"] | null
};
	["ProductLineProductsByEvaluationUniqueWhere"]: {
	evaluation?:ValueTypes["ProductEvaluationUniqueWhere"] | null
};
	["ProductLineProductsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ProductLineProductsByItemDeclensionFourthCategoriesUniqueWhere"]: {
	itemDeclensionFourthCategories?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null
};
	["ProductLineProductsByHeurekaImageUniqueWhere"]: {
	heurekaImage?:ValueTypes["ImageUniqueWhere"] | null
};
	["ProductLineProductsByTopxUniqueWhere"]: {
	topx?:ValueTypes["TOPXProductUniqueWhere"] | null
};
	["ProductLineAliasConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductLineAliasEdge"],
		__typename?: boolean
}>;
	["ProductLineAliasEdge"]: AliasType<{
	node?:ValueTypes["ProductLineAlias"],
		__typename?: boolean
}>;
	["ProductLineFlavorConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductLineFlavorEdge"],
		__typename?: boolean
}>;
	["ProductLineFlavorEdge"]: AliasType<{
	node?:ValueTypes["ProductLineFlavor"],
		__typename?: boolean
}>;
	["ProductionMethod"]: AliasType<{
	_meta?:ValueTypes["ProductionMethodMeta"],
	id?:boolean,
	name?:boolean,
brands?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Brand"]],
	remoteId?:boolean,
brandsByRemoteId?: [{	by:ValueTypes["ProductionMethodBrandsByRemoteIdUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsBySlug?: [{	by:ValueTypes["ProductionMethodBrandsBySlugUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByProducts?: [{	by:ValueTypes["ProductionMethodBrandsByProductsUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByProductLines?: [{	by:ValueTypes["ProductionMethodBrandsByProductLinesUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByLogo?: [{	by:ValueTypes["ProductionMethodBrandsByLogoUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByAliases?: [{	by:ValueTypes["ProductionMethodBrandsByAliasesUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByFlavors?: [{	by:ValueTypes["ProductionMethodBrandsByFlavorsUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsBySeo?: [{	by:ValueTypes["ProductionMethodBrandsBySeoUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByFilterCombos?: [{	by:ValueTypes["ProductionMethodBrandsByFilterCombosUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByTopx?: [{	by:ValueTypes["ProductionMethodBrandsByTopxUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByContent?: [{	by:ValueTypes["ProductionMethodBrandsByContentUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByDraft?: [{	by:ValueTypes["ProductionMethodBrandsByDraftUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
paginateBrands?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandConnection"]],
		__typename?: boolean
}>;
	["ProductionMethodMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	brands?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductionMethodBrandsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ProductionMethodBrandsBySlugUniqueWhere"]: {
	slug?:string | null
};
	["ProductionMethodBrandsByProductsUniqueWhere"]: {
	products?:ValueTypes["ProductUniqueWhere"] | null
};
	["ProductionMethodBrandsByProductLinesUniqueWhere"]: {
	productLines?:ValueTypes["ProductLineUniqueWhere"] | null
};
	["ProductLineUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	slug?:string | null,
	products?:ValueTypes["ProductUniqueWhere"] | null,
	logo?:ValueTypes["ImageUniqueWhere"] | null,
	flavors?:ValueTypes["ProductLineFlavorUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ProductLineFlavorUniqueWhere"]: {
	id?:string | null
};
	["ProductionMethodBrandsByLogoUniqueWhere"]: {
	logo?:ValueTypes["ImageUniqueWhere"] | null
};
	["ProductionMethodBrandsByAliasesUniqueWhere"]: {
	aliases?:ValueTypes["BrandAliasUniqueWhere"] | null
};
	["BrandAliasUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["ProductionMethodBrandsByFlavorsUniqueWhere"]: {
	flavors?:ValueTypes["BrandFlavorUniqueWhere"] | null
};
	["BrandFlavorUniqueWhere"]: {
	id?:string | null
};
	["ProductionMethodBrandsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ProductionMethodBrandsByFilterCombosUniqueWhere"]: {
	filterCombos?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["ProductionMethodBrandsByTopxUniqueWhere"]: {
	topx?:ValueTypes["TOPXBrandUniqueWhere"] | null
};
	["TOPXBrandUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["ProductionMethodBrandsByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["ProductionMethodBrandsByDraftUniqueWhere"]: {
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["BrandDistributor"]: AliasType<{
	_meta?:ValueTypes["BrandDistributorMeta"],
	id?:boolean,
	name?:boolean,
brands?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Brand"]],
	link?:boolean,
	remoteId?:boolean,
brandsByRemoteId?: [{	by:ValueTypes["BrandDistributorBrandsByRemoteIdUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsBySlug?: [{	by:ValueTypes["BrandDistributorBrandsBySlugUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByProducts?: [{	by:ValueTypes["BrandDistributorBrandsByProductsUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByProductLines?: [{	by:ValueTypes["BrandDistributorBrandsByProductLinesUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByLogo?: [{	by:ValueTypes["BrandDistributorBrandsByLogoUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByAliases?: [{	by:ValueTypes["BrandDistributorBrandsByAliasesUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByFlavors?: [{	by:ValueTypes["BrandDistributorBrandsByFlavorsUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsBySeo?: [{	by:ValueTypes["BrandDistributorBrandsBySeoUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByFilterCombos?: [{	by:ValueTypes["BrandDistributorBrandsByFilterCombosUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByTopx?: [{	by:ValueTypes["BrandDistributorBrandsByTopxUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByContent?: [{	by:ValueTypes["BrandDistributorBrandsByContentUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
brandsByDraft?: [{	by:ValueTypes["BrandDistributorBrandsByDraftUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
paginateBrands?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandConnection"]],
		__typename?: boolean
}>;
	["BrandDistributorMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	brands?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BrandDistributorBrandsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["BrandDistributorBrandsBySlugUniqueWhere"]: {
	slug?:string | null
};
	["BrandDistributorBrandsByProductsUniqueWhere"]: {
	products?:ValueTypes["ProductUniqueWhere"] | null
};
	["BrandDistributorBrandsByProductLinesUniqueWhere"]: {
	productLines?:ValueTypes["ProductLineUniqueWhere"] | null
};
	["BrandDistributorBrandsByLogoUniqueWhere"]: {
	logo?:ValueTypes["ImageUniqueWhere"] | null
};
	["BrandDistributorBrandsByAliasesUniqueWhere"]: {
	aliases?:ValueTypes["BrandAliasUniqueWhere"] | null
};
	["BrandDistributorBrandsByFlavorsUniqueWhere"]: {
	flavors?:ValueTypes["BrandFlavorUniqueWhere"] | null
};
	["BrandDistributorBrandsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["BrandDistributorBrandsByFilterCombosUniqueWhere"]: {
	filterCombos?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["BrandDistributorBrandsByTopxUniqueWhere"]: {
	topx?:ValueTypes["TOPXBrandUniqueWhere"] | null
};
	["BrandDistributorBrandsByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["BrandDistributorBrandsByDraftUniqueWhere"]: {
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["BrandAlias"]: AliasType<{
	_meta?:ValueTypes["BrandAliasMeta"],
	id?:boolean,
	remoteId?:boolean,
	name?:boolean,
brand?: [{	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
		__typename?: boolean
}>;
	["BrandAliasMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	brand?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BrandAliasOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	brand?:ValueTypes["BrandOrderBy"] | null
};
	["BrandFlavor"]: AliasType<{
	_meta?:ValueTypes["BrandFlavorMeta"],
	id?:boolean,
brand?: [{	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
itemSubCategory?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
		__typename?: boolean
}>;
	["BrandFlavorMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	brand?:ValueTypes["FieldMeta"],
	itemSubCategory?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BrandFlavorOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	brand?:ValueTypes["BrandOrderBy"] | null,
	itemSubCategory?:ValueTypes["ItemSubCategoryOrderBy"] | null
};
	["TOPXBrand"]: AliasType<{
	_meta?:ValueTypes["TOPXBrandMeta"],
	id?:boolean,
	remoteId?:boolean,
	order?:boolean,
	orderType?:boolean,
brand?: [{	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
category?: [{	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null},ValueTypes["TOPXBrandCategory"]],
		__typename?: boolean
}>;
	["TOPXBrandMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	orderType?:ValueTypes["FieldMeta"],
	brand?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TOPXBrandCategory"]: AliasType<{
	_meta?:ValueTypes["TOPXBrandCategoryMeta"],
	id?:boolean,
	remoteId?:boolean,
brands?: [{	filter?:ValueTypes["TOPXBrandWhere"] | null,	orderBy?:ValueTypes["TOPXBrandOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TOPXBrand"]],
brandsByRemoteId?: [{	by:ValueTypes["TOPXBrandCategoryBrandsByRemoteIdUniqueWhere"],	filter?:ValueTypes["TOPXBrandWhere"] | null},ValueTypes["TOPXBrand"]],
paginateBrands?: [{	filter?:ValueTypes["TOPXBrandWhere"] | null,	orderBy?:ValueTypes["TOPXBrandOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TOPXBrandConnection"]],
		__typename?: boolean
}>;
	["TOPXBrandCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	brands?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TOPXBrandOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	orderType?:ValueTypes["OrderDirection"] | null,
	brand?:ValueTypes["BrandOrderBy"] | null,
	category?:ValueTypes["TOPXBrandCategoryOrderBy"] | null
};
	["TOPXBrandCategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null
};
	["TOPXBrandCategoryBrandsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["TOPXBrandConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TOPXBrandEdge"],
		__typename?: boolean
}>;
	["TOPXBrandEdge"]: AliasType<{
	node?:ValueTypes["TOPXBrand"],
		__typename?: boolean
}>;
	["BrandProductsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["BrandProductsBySlugUniqueWhere"]: {
	slug?:string | null
};
	["BrandProductsByNutritionalValuesUniqueWhere"]: {
	nutritionalValues?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null
};
	["BrandProductsByReviewsUniqueWhere"]: {
	reviews?:ValueTypes["ProductReviewUniqueWhere"] | null
};
	["BrandProductsByDogsUniqueWhere"]: {
	dogs?:ValueTypes["DogUniqueWhere"] | null
};
	["BrandProductsByPackagingsUniqueWhere"]: {
	packagings?:ValueTypes["ProductPackageUniqueWhere"] | null
};
	["BrandProductsByElementsUniqueWhere"]: {
	elements?:ValueTypes["ElementOfProductUniqueWhere"] | null
};
	["BrandProductsByFlagsUniqueWhere"]: {
	flags?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null
};
	["BrandProductsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["BrandProductsByAliasesUniqueWhere"]: {
	aliases?:ValueTypes["ProductAliasUniqueWhere"] | null
};
	["BrandProductsByEvaluationUniqueWhere"]: {
	evaluation?:ValueTypes["ProductEvaluationUniqueWhere"] | null
};
	["BrandProductsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["BrandProductsByItemDeclensionFourthCategoriesUniqueWhere"]: {
	itemDeclensionFourthCategories?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null
};
	["BrandProductsByHeurekaImageUniqueWhere"]: {
	heurekaImage?:ValueTypes["ImageUniqueWhere"] | null
};
	["BrandProductsByTopxUniqueWhere"]: {
	topx?:ValueTypes["TOPXProductUniqueWhere"] | null
};
	["BrandProductLinesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["BrandProductLinesBySlugUniqueWhere"]: {
	slug?:string | null
};
	["BrandProductLinesByProductsUniqueWhere"]: {
	products?:ValueTypes["ProductUniqueWhere"] | null
};
	["BrandProductLinesByLogoUniqueWhere"]: {
	logo?:ValueTypes["ImageUniqueWhere"] | null
};
	["BrandProductLinesByFlavorsUniqueWhere"]: {
	flavors?:ValueTypes["ProductLineFlavorUniqueWhere"] | null
};
	["BrandProductLinesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["BrandAliasesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["BrandFilterCombosByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["BrandFilterCombosBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["BrandTopxByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["BrandAliasConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BrandAliasEdge"],
		__typename?: boolean
}>;
	["BrandAliasEdge"]: AliasType<{
	node?:ValueTypes["BrandAlias"],
		__typename?: boolean
}>;
	["AdConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AdEdge"],
		__typename?: boolean
}>;
	["AdEdge"]: AliasType<{
	node?:ValueTypes["Ad"],
		__typename?: boolean
}>;
	["BrandFlavorConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BrandFlavorEdge"],
		__typename?: boolean
}>;
	["BrandFlavorEdge"]: AliasType<{
	node?:ValueTypes["BrandFlavor"],
		__typename?: boolean
}>;
	["AdContentReferencesByImagesUniqueWhere"]: {
	images?:ValueTypes["ContentReferenceGalleryImageUniqueWhere"] | null
};
	["AdContentReferencesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["AdContentReferencesByListUniqueWhere"]: {
	list?:ValueTypes["ContentReferenceListUniqueWhere"] | null
};
	["AdContentReferencesByOutlineUniqueWhere"]: {
	outline?:ValueTypes["ContentLinksUniqueWhere"] | null
};
	["AdContentReferencesByVideoUniqueWhere"]: {
	video?:ValueTypes["VideoUniqueWhere"] | null
};
	["AdContentReferencesByImageUniqueWhere"]: {
	image?:ValueTypes["ContentReferenceImageUniqueWhere"] | null
};
	["ItemCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ItemCategoryEdge"],
		__typename?: boolean
}>;
	["ItemCategoryEdge"]: AliasType<{
	node?:ValueTypes["ItemCategory"],
		__typename?: boolean
}>;
	["ContentReferenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceEdge"],
		__typename?: boolean
}>;
	["ContentReferenceEdge"]: AliasType<{
	node?:ValueTypes["ContentReference"],
		__typename?: boolean
}>;
	["ItemDeclensionFourthVariant"]: AliasType<{
	_meta?:ValueTypes["ItemDeclensionFourthVariantMeta"],
	id?:boolean,
items?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Item"]],
	label?:boolean,
	remoteId?:boolean,
	declensionSeventh?:boolean,
	isNegativ?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
subcategory?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
category?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
element?: [{	filter?:ValueTypes["ElementWhere"] | null},ValueTypes["Element"]],
products?: [{	filter?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null,	orderBy?:ValueTypes["ProductItemDeclensionFourthCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductItemDeclensionFourthCategory"]],
	slug?:boolean,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
draft?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
itemsByRemoteId?: [{	by:ValueTypes["ItemDeclensionFourthVariantItemsByRemoteIdUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsBySlug?: [{	by:ValueTypes["ItemDeclensionFourthVariantItemsBySlugUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByFeaturesOfProduct?: [{	by:ValueTypes["ItemDeclensionFourthVariantItemsByFeaturesOfProductUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByImage?: [{	by:ValueTypes["ItemDeclensionFourthVariantItemsByImageUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByReferenceList?: [{	by:ValueTypes["ItemDeclensionFourthVariantItemsByReferenceListUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsBySeo?: [{	by:ValueTypes["ItemDeclensionFourthVariantItemsBySeoUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByAliases?: [{	by:ValueTypes["ItemDeclensionFourthVariantItemsByAliasesUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByContent?: [{	by:ValueTypes["ItemDeclensionFourthVariantItemsByContentUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByDraft?: [{	by:ValueTypes["ItemDeclensionFourthVariantItemsByDraftUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
paginateItems?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemConnection"]],
paginateProducts?: [{	filter?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null,	orderBy?:ValueTypes["ProductItemDeclensionFourthCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductItemDeclensionFourthCategoryConnection"]],
		__typename?: boolean
}>;
	["ItemDeclensionFourthVariantMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	declensionSeventh?:ValueTypes["FieldMeta"],
	isNegativ?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	subcategory?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
	element?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	draft?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductItemDeclensionFourthCategory"]: AliasType<{
	_meta?:ValueTypes["ProductItemDeclensionFourthCategoryMeta"],
	id?:boolean,
declensionFourthCategory?: [{	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
product?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
		__typename?: boolean
}>;
	["ProductItemDeclensionFourthCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	declensionFourthCategory?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductItemDeclensionFourthCategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	declensionFourthCategory?:ValueTypes["ItemDeclensionFourthVariantOrderBy"] | null,
	product?:ValueTypes["ProductOrderBy"] | null
};
	["ItemDeclensionFourthVariantItemsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ItemDeclensionFourthVariantItemsBySlugUniqueWhere"]: {
	slug?:string | null
};
	["ItemDeclensionFourthVariantItemsByFeaturesOfProductUniqueWhere"]: {
	featuresOfProduct?:ValueTypes["ProductFeatureUniqueWhere"] | null
};
	["ItemDeclensionFourthVariantItemsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["ItemDeclensionFourthVariantItemsByReferenceListUniqueWhere"]: {
	referenceList?:ValueTypes["ReferenceListUniqueWhere"] | null
};
	["ItemDeclensionFourthVariantItemsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ItemDeclensionFourthVariantItemsByAliasesUniqueWhere"]: {
	aliases?:ValueTypes["ItemAliasUniqueWhere"] | null
};
	["ItemDeclensionFourthVariantItemsByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["ItemDeclensionFourthVariantItemsByDraftUniqueWhere"]: {
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["ItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ItemEdge"],
		__typename?: boolean
}>;
	["ItemEdge"]: AliasType<{
	node?:ValueTypes["Item"],
		__typename?: boolean
}>;
	["ProductItemDeclensionFourthCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductItemDeclensionFourthCategoryEdge"],
		__typename?: boolean
}>;
	["ProductItemDeclensionFourthCategoryEdge"]: AliasType<{
	node?:ValueTypes["ProductItemDeclensionFourthCategory"],
		__typename?: boolean
}>;
	["ItemGroup"]: AliasType<{
	_meta?:ValueTypes["ItemGroupMeta"],
	id?:boolean,
	remoteId?:boolean,
	name?:boolean,
categories?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemCategory"]],
categoriesByRemoteId?: [{	by:ValueTypes["ItemGroupCategoriesByRemoteIdUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
categoriesBySlug?: [{	by:ValueTypes["ItemGroupCategoriesBySlugUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
categoriesBySubCategories?: [{	by:ValueTypes["ItemGroupCategoriesBySubCategoriesUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
categoriesByFeatureDependencies?: [{	by:ValueTypes["ItemGroupCategoriesByFeatureDependenciesUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
categoriesByImage?: [{	by:ValueTypes["ItemGroupCategoriesByImageUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
categoriesByRedirects?: [{	by:ValueTypes["ItemGroupCategoriesByRedirectsUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
categoriesByDeclensionsFourth?: [{	by:ValueTypes["ItemGroupCategoriesByDeclensionsFourthUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
categoriesBySeo?: [{	by:ValueTypes["ItemGroupCategoriesBySeoUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
categoriesByContent?: [{	by:ValueTypes["ItemGroupCategoriesByContentUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
categoriesByDraft?: [{	by:ValueTypes["ItemGroupCategoriesByDraftUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
paginateCategories?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemCategoryConnection"]],
		__typename?: boolean
}>;
	["ItemGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	categories?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ItemGroupCategoriesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ItemGroupCategoriesBySlugUniqueWhere"]: {
	slug?:string | null
};
	["ItemGroupCategoriesBySubCategoriesUniqueWhere"]: {
	subCategories?:ValueTypes["ItemSubCategoryUniqueWhere"] | null
};
	["ItemSubCategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	slug?:string | null,
	featureDependencies?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	brands?:ValueTypes["BrandFlavorUniqueWhere"] | null,
	productLines?:ValueTypes["ProductLineFlavorUniqueWhere"] | null,
	filterCombosFlavor?:ValueTypes["FilterComboUniqueWhere"] | null,
	filterCombosAllergy?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["ItemGroupCategoriesByFeatureDependenciesUniqueWhere"]: {
	featureDependencies?:ValueTypes["ProductFeatureUniqueWhere"] | null
};
	["ItemGroupCategoriesByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["ItemGroupCategoriesByRedirectsUniqueWhere"]: {
	redirects?:ValueTypes["RedirectUniqueWhere"] | null
};
	["ItemGroupCategoriesByDeclensionsFourthUniqueWhere"]: {
	declensionsFourth?:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"] | null
};
	["ItemDeclensionFourthVariantUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	slug?:string | null,
	items?:ValueTypes["ItemUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	subcategory?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	element?:ValueTypes["ElementUniqueWhere"] | null,
	products?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["ElementUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	products?:ValueTypes["ElementOfProductUniqueWhere"] | null,
	featureDependencies?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	suitabilityElements?:ValueTypes["SuitabilityItemUniqueWhere"] | null
};
	["SuitabilityItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["ItemGroupCategoriesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ItemGroupCategoriesByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["ItemGroupCategoriesByDraftUniqueWhere"]: {
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["ItemCategorySubCategoriesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ItemCategorySubCategoriesBySlugUniqueWhere"]: {
	slug?:string | null
};
	["ItemCategorySubCategoriesByFeatureDependenciesUniqueWhere"]: {
	featureDependencies?:ValueTypes["ProductFeatureUniqueWhere"] | null
};
	["ItemCategorySubCategoriesByBrandsUniqueWhere"]: {
	brands?:ValueTypes["BrandFlavorUniqueWhere"] | null
};
	["ItemCategorySubCategoriesByProductLinesUniqueWhere"]: {
	productLines?:ValueTypes["ProductLineFlavorUniqueWhere"] | null
};
	["ItemCategorySubCategoriesByFilterCombosFlavorUniqueWhere"]: {
	filterCombosFlavor?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["ItemCategorySubCategoriesByFilterCombosAllergyUniqueWhere"]: {
	filterCombosAllergy?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["ItemCategoryFeatureDependenciesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ItemCategoryRedirectsByFromUniqueWhere"]: {
	from?:string | null
};
	["ItemCategoryDeclensionsFourthByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ItemCategoryDeclensionsFourthBySlugUniqueWhere"]: {
	slug?:string | null
};
	["ItemCategoryDeclensionsFourthByItemsUniqueWhere"]: {
	items?:ValueTypes["ItemUniqueWhere"] | null
};
	["ItemCategoryDeclensionsFourthBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ItemCategoryDeclensionsFourthBySubcategoryUniqueWhere"]: {
	subcategory?:ValueTypes["ItemSubCategoryUniqueWhere"] | null
};
	["ItemCategoryDeclensionsFourthByElementUniqueWhere"]: {
	element?:ValueTypes["ElementUniqueWhere"] | null
};
	["ItemCategoryDeclensionsFourthByProductsUniqueWhere"]: {
	products?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null
};
	["ItemCategoryDeclensionsFourthByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["ItemCategoryDeclensionsFourthByDraftUniqueWhere"]: {
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["ProductFeatureConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductFeatureEdge"],
		__typename?: boolean
}>;
	["ProductFeatureEdge"]: AliasType<{
	node?:ValueTypes["ProductFeature"],
		__typename?: boolean
}>;
	["RedirectConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RedirectEdge"],
		__typename?: boolean
}>;
	["RedirectEdge"]: AliasType<{
	node?:ValueTypes["Redirect"],
		__typename?: boolean
}>;
	["ItemDeclensionFourthVariantConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ItemDeclensionFourthVariantEdge"],
		__typename?: boolean
}>;
	["ItemDeclensionFourthVariantEdge"]: AliasType<{
	node?:ValueTypes["ItemDeclensionFourthVariant"],
		__typename?: boolean
}>;
	["ItemFlavorCategory"]: AliasType<{
	_meta?:ValueTypes["ItemFlavorCategoryMeta"],
	id?:boolean,
	name?:boolean,
items?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemSubCategory"]],
	remoteId?:boolean,
color?: [{	filter?:ValueTypes["ColorWhere"] | null},ValueTypes["Color"]],
itemsByRemoteId?: [{	by:ValueTypes["ItemFlavorCategoryItemsByRemoteIdUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
itemsBySlug?: [{	by:ValueTypes["ItemFlavorCategoryItemsBySlugUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
itemsByFeatureDependencies?: [{	by:ValueTypes["ItemFlavorCategoryItemsByFeatureDependenciesUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
itemsByBrands?: [{	by:ValueTypes["ItemFlavorCategoryItemsByBrandsUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
itemsByProductLines?: [{	by:ValueTypes["ItemFlavorCategoryItemsByProductLinesUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
itemsByFilterCombosFlavor?: [{	by:ValueTypes["ItemFlavorCategoryItemsByFilterCombosFlavorUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
itemsByFilterCombosAllergy?: [{	by:ValueTypes["ItemFlavorCategoryItemsByFilterCombosAllergyUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
paginateItems?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemSubCategoryConnection"]],
		__typename?: boolean
}>;
	["ItemFlavorCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ItemFlavorCategoryItemsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ItemFlavorCategoryItemsBySlugUniqueWhere"]: {
	slug?:string | null
};
	["ItemFlavorCategoryItemsByFeatureDependenciesUniqueWhere"]: {
	featureDependencies?:ValueTypes["ProductFeatureUniqueWhere"] | null
};
	["ItemFlavorCategoryItemsByBrandsUniqueWhere"]: {
	brands?:ValueTypes["BrandFlavorUniqueWhere"] | null
};
	["ItemFlavorCategoryItemsByProductLinesUniqueWhere"]: {
	productLines?:ValueTypes["ProductLineFlavorUniqueWhere"] | null
};
	["ItemFlavorCategoryItemsByFilterCombosFlavorUniqueWhere"]: {
	filterCombosFlavor?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["ItemFlavorCategoryItemsByFilterCombosAllergyUniqueWhere"]: {
	filterCombosAllergy?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["ItemSubCategoryFeatureDependenciesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ItemSubCategoryFilterCombosFlavorByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ItemSubCategoryFilterCombosFlavorBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ItemSubCategoryFilterCombosAllergyByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ItemSubCategoryFilterCombosAllergyBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ReferenceList"]: AliasType<{
	_meta?:ValueTypes["ReferenceListMeta"],
	id?:boolean,
references?: [{	filter?:ValueTypes["ReferenceWhere"] | null,	orderBy?:ValueTypes["ReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Reference"]],
paginateReferences?: [{	filter?:ValueTypes["ReferenceWhere"] | null,	orderBy?:ValueTypes["ReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ReferenceConnection"]],
		__typename?: boolean
}>;
	["ReferenceListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	references?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Reference"]: AliasType<{
	_meta?:ValueTypes["ReferenceMeta"],
	id?:boolean,
	text?:boolean,
	link?:boolean,
	order?:boolean,
list?: [{	filter?:ValueTypes["ReferenceListWhere"] | null},ValueTypes["ReferenceList"]],
		__typename?: boolean
}>;
	["ReferenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ReferenceOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ReferenceListOrderBy"] | null
};
	["ReferenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ReferenceEdge"],
		__typename?: boolean
}>;
	["ReferenceEdge"]: AliasType<{
	node?:ValueTypes["Reference"],
		__typename?: boolean
}>;
	["ItemDeclensionSeventhVariant"]: AliasType<{
	_meta?:ValueTypes["ItemDeclensionSeventhVariantMeta"],
	id?:boolean,
items?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Item"]],
	label?:boolean,
	remoteId?:boolean,
itemsByRemoteId?: [{	by:ValueTypes["ItemDeclensionSeventhVariantItemsByRemoteIdUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsBySlug?: [{	by:ValueTypes["ItemDeclensionSeventhVariantItemsBySlugUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByFeaturesOfProduct?: [{	by:ValueTypes["ItemDeclensionSeventhVariantItemsByFeaturesOfProductUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByImage?: [{	by:ValueTypes["ItemDeclensionSeventhVariantItemsByImageUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByReferenceList?: [{	by:ValueTypes["ItemDeclensionSeventhVariantItemsByReferenceListUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsBySeo?: [{	by:ValueTypes["ItemDeclensionSeventhVariantItemsBySeoUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByAliases?: [{	by:ValueTypes["ItemDeclensionSeventhVariantItemsByAliasesUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByContent?: [{	by:ValueTypes["ItemDeclensionSeventhVariantItemsByContentUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
itemsByDraft?: [{	by:ValueTypes["ItemDeclensionSeventhVariantItemsByDraftUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
paginateItems?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemConnection"]],
		__typename?: boolean
}>;
	["ItemDeclensionSeventhVariantMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ItemDeclensionSeventhVariantItemsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ItemDeclensionSeventhVariantItemsBySlugUniqueWhere"]: {
	slug?:string | null
};
	["ItemDeclensionSeventhVariantItemsByFeaturesOfProductUniqueWhere"]: {
	featuresOfProduct?:ValueTypes["ProductFeatureUniqueWhere"] | null
};
	["ItemDeclensionSeventhVariantItemsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["ItemDeclensionSeventhVariantItemsByReferenceListUniqueWhere"]: {
	referenceList?:ValueTypes["ReferenceListUniqueWhere"] | null
};
	["ItemDeclensionSeventhVariantItemsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ItemDeclensionSeventhVariantItemsByAliasesUniqueWhere"]: {
	aliases?:ValueTypes["ItemAliasUniqueWhere"] | null
};
	["ItemDeclensionSeventhVariantItemsByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["ItemDeclensionSeventhVariantItemsByDraftUniqueWhere"]: {
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["ItemAlias"]: AliasType<{
	_meta?:ValueTypes["ItemAliasMeta"],
	id?:boolean,
	remoteId?:boolean,
	name?:boolean,
item?: [{	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
		__typename?: boolean
}>;
	["ItemAliasMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	item?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ItemAliasOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	item?:ValueTypes["ItemOrderBy"] | null
};
	["ItemFeaturesOfProductByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ItemAliasesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ItemAliasConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ItemAliasEdge"],
		__typename?: boolean
}>;
	["ItemAliasEdge"]: AliasType<{
	node?:ValueTypes["ItemAlias"],
		__typename?: boolean
}>;
	["ProductFlag"]: AliasType<{
	_meta?:ValueTypes["ProductFlagMeta"],
	id?:boolean,
	remoteId?:boolean,
productFeatures?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFeature"]],
products?: [{	filter?:ValueTypes["ProductFlagOfProductWhere"] | null,	orderBy?:ValueTypes["ProductFlagOfProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFlagOfProduct"]],
productFeaturesByRemoteId?: [{	by:ValueTypes["ProductFlagProductFeaturesByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null},ValueTypes["ProductFeature"]],
productsByRemoteId?: [{	by:ValueTypes["ProductFlagProductsByRemoteIdUniqueWhere"],	filter?:ValueTypes["ProductFlagOfProductWhere"] | null},ValueTypes["ProductFlagOfProduct"]],
paginateProductFeatures?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFeatureConnection"]],
paginateProducts?: [{	filter?:ValueTypes["ProductFlagOfProductWhere"] | null,	orderBy?:ValueTypes["ProductFlagOfProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFlagOfProductConnection"]],
		__typename?: boolean
}>;
	["ProductFlagMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	productFeatures?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductFlagOfProduct"]: AliasType<{
	_meta?:ValueTypes["ProductFlagOfProductMeta"],
	id?:boolean,
	remoteId?:boolean,
	value?:boolean,
product?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
flag?: [{	filter?:ValueTypes["ProductFlagWhere"] | null},ValueTypes["ProductFlag"]],
		__typename?: boolean
}>;
	["ProductFlagOfProductMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	flag?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductFlagOfProductOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	value?:ValueTypes["OrderDirection"] | null,
	product?:ValueTypes["ProductOrderBy"] | null,
	flag?:ValueTypes["ProductFlagOrderBy"] | null
};
	["ProductFlagProductFeaturesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ProductFlagProductsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ProductFlagOfProductConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductFlagOfProductEdge"],
		__typename?: boolean
}>;
	["ProductFlagOfProductEdge"]: AliasType<{
	node?:ValueTypes["ProductFlagOfProduct"],
		__typename?: boolean
}>;
	["ElementProductsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ElementFeatureDependenciesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ElementSuitabilityElementsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ElementOfProductConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ElementOfProductEdge"],
		__typename?: boolean
}>;
	["ElementOfProductEdge"]: AliasType<{
	node?:ValueTypes["ElementOfProduct"],
		__typename?: boolean
}>;
	["NutritionalValueProductsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["NutritionalValueSuitabilityNutritionalValuesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["NutritionalValueOfProductConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NutritionalValueOfProductEdge"],
		__typename?: boolean
}>;
	["NutritionalValueOfProductEdge"]: AliasType<{
	node?:ValueTypes["NutritionalValueOfProduct"],
		__typename?: boolean
}>;
	["ProductPackage"]: AliasType<{
	_meta?:ValueTypes["ProductPackageMeta"],
	id?:boolean,
	price?:boolean,
	order?:boolean,
	link?:boolean,
product?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
	amount?:boolean,
	externalId?:boolean,
	remoteId?:boolean,
	label?:boolean,
	positionId?:boolean,
	heurekaPrice?:boolean,
	heurekaLink?:boolean,
		__typename?: boolean
}>;
	["ProductPackageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	price?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	amount?:ValueTypes["FieldMeta"],
	externalId?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	positionId?:ValueTypes["FieldMeta"],
	heurekaPrice?:ValueTypes["FieldMeta"],
	heurekaLink?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductPackageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	price?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["OrderDirection"] | null,
	product?:ValueTypes["ProductOrderBy"] | null,
	amount?:ValueTypes["OrderDirection"] | null,
	externalId?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	positionId?:ValueTypes["OrderDirection"] | null,
	heurekaPrice?:ValueTypes["OrderDirection"] | null,
	heurekaLink?:ValueTypes["OrderDirection"] | null
};
	["GranuleSize"]: AliasType<{
	_meta?:ValueTypes["GranuleSizeMeta"],
	id?:boolean,
	remoteId?:boolean,
products?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
	name?:boolean,
paginateProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
		__typename?: boolean
}>;
	["GranuleSizeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["GranuleSizeOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null
};
	["ProductAlias"]: AliasType<{
	_meta?:ValueTypes["ProductAliasMeta"],
	id?:boolean,
	remoteId?:boolean,
	name?:boolean,
product?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
		__typename?: boolean
}>;
	["ProductAliasMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductAliasOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	product?:ValueTypes["ProductOrderBy"] | null
};
	["ProductEvaluation"]: AliasType<{
	_meta?:ValueTypes["ProductEvaluationMeta"],
	id?:boolean,
	nazev?:boolean,
	vetDieta?:boolean,
	vetDieta1?:boolean,
	vetDieta2?:boolean,
	aktivita?:boolean,
	vek?:boolean,
	velikostPlemen?:boolean,
	hmotnostPlemene?:boolean,
	velikostGranuli?:boolean,
	velikostGranuliText?:boolean,
	doporucenaAktivitaDleMe?:boolean,
	vypocitanaMeVsMeVyrobce?:boolean,
	vypocitanaMeVsMeVyrobce2?:boolean,
	masoNaPrvnimMisteText?:boolean,
	zdrojeZivocisnychBilkovinDle1Vyskytu?:boolean,
	prichuteSeznam?:boolean,
	eliminacniDietaTextInterpunkce?:boolean,
	alergenyZadneNeobsahuje?:boolean,
	alergenyObsahuje?:boolean,
	alergenyNejakeNeobsahuje?:boolean,
	prospesneDruhyInterpunkce?:boolean,
	nevhodneDruhy?:boolean,
	kladneUcinkyCeleTelo?:boolean,
	kladneUcinkyHlava?:boolean,
	kladneUcinkyHrudnik?:boolean,
	kladneUcinkyBricho?:boolean,
	kladneUcinkySpodniCast?:boolean,
	zaporneUcinkyCeleTelo?:boolean,
	zaporneUcinkyHlava?:boolean,
	zaporneUcinkyHrudnik?:boolean,
	zaporneUcinkyBricho?:boolean,
	zaporneUcinkySpodniCast?:boolean,
	dsneuvedeno?:boolean,
	dsmalo?:boolean,
	dsprilis?:boolean,
	dsok?:boolean,
	d95malo?:boolean,
	d95prilis?:boolean,
	d95ok?:boolean,
	d110malo?:boolean,
	d110prilis?:boolean,
	d110ok?:boolean,
	sdo14reproMalo?:boolean,
	sdo14reproPrilis?:boolean,
	sdo14reproOk?:boolean,
	sdo15malo?:boolean,
	sdo15prilis?:boolean,
	sdo15ok?:boolean,
	s15malo?:boolean,
	s15prilis?:boolean,
	s15ok?:boolean,
product?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
	masoAnoNe?:boolean,
	eliminacniDietaAnoNe?:boolean,
	alergenyAnoNe?:boolean,
	plodnostKastraceNadpis?:boolean,
	plodnostKastraceText?:boolean,
	remoteId?:boolean,
	stravitelnostNadpis?:boolean,
	stravitelnostProcenta?:boolean,
	stravitelnostSlovne?:boolean,
	stravitelnostChybiText?:boolean,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?:boolean,
		__typename?: boolean
}>;
	["ProductEvaluationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	nazev?:ValueTypes["FieldMeta"],
	vetDieta?:ValueTypes["FieldMeta"],
	vetDieta1?:ValueTypes["FieldMeta"],
	vetDieta2?:ValueTypes["FieldMeta"],
	aktivita?:ValueTypes["FieldMeta"],
	vek?:ValueTypes["FieldMeta"],
	velikostPlemen?:ValueTypes["FieldMeta"],
	hmotnostPlemene?:ValueTypes["FieldMeta"],
	velikostGranuli?:ValueTypes["FieldMeta"],
	velikostGranuliText?:ValueTypes["FieldMeta"],
	doporucenaAktivitaDleMe?:ValueTypes["FieldMeta"],
	vypocitanaMeVsMeVyrobce?:ValueTypes["FieldMeta"],
	vypocitanaMeVsMeVyrobce2?:ValueTypes["FieldMeta"],
	masoNaPrvnimMisteText?:ValueTypes["FieldMeta"],
	zdrojeZivocisnychBilkovinDle1Vyskytu?:ValueTypes["FieldMeta"],
	prichuteSeznam?:ValueTypes["FieldMeta"],
	eliminacniDietaTextInterpunkce?:ValueTypes["FieldMeta"],
	alergenyZadneNeobsahuje?:ValueTypes["FieldMeta"],
	alergenyObsahuje?:ValueTypes["FieldMeta"],
	alergenyNejakeNeobsahuje?:ValueTypes["FieldMeta"],
	prospesneDruhyInterpunkce?:ValueTypes["FieldMeta"],
	nevhodneDruhy?:ValueTypes["FieldMeta"],
	kladneUcinkyCeleTelo?:ValueTypes["FieldMeta"],
	kladneUcinkyHlava?:ValueTypes["FieldMeta"],
	kladneUcinkyHrudnik?:ValueTypes["FieldMeta"],
	kladneUcinkyBricho?:ValueTypes["FieldMeta"],
	kladneUcinkySpodniCast?:ValueTypes["FieldMeta"],
	zaporneUcinkyCeleTelo?:ValueTypes["FieldMeta"],
	zaporneUcinkyHlava?:ValueTypes["FieldMeta"],
	zaporneUcinkyHrudnik?:ValueTypes["FieldMeta"],
	zaporneUcinkyBricho?:ValueTypes["FieldMeta"],
	zaporneUcinkySpodniCast?:ValueTypes["FieldMeta"],
	dsneuvedeno?:ValueTypes["FieldMeta"],
	dsmalo?:ValueTypes["FieldMeta"],
	dsprilis?:ValueTypes["FieldMeta"],
	dsok?:ValueTypes["FieldMeta"],
	d95malo?:ValueTypes["FieldMeta"],
	d95prilis?:ValueTypes["FieldMeta"],
	d95ok?:ValueTypes["FieldMeta"],
	d110malo?:ValueTypes["FieldMeta"],
	d110prilis?:ValueTypes["FieldMeta"],
	d110ok?:ValueTypes["FieldMeta"],
	sdo14reproMalo?:ValueTypes["FieldMeta"],
	sdo14reproPrilis?:ValueTypes["FieldMeta"],
	sdo14reproOk?:ValueTypes["FieldMeta"],
	sdo15malo?:ValueTypes["FieldMeta"],
	sdo15prilis?:ValueTypes["FieldMeta"],
	sdo15ok?:ValueTypes["FieldMeta"],
	s15malo?:ValueTypes["FieldMeta"],
	s15prilis?:ValueTypes["FieldMeta"],
	s15ok?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	masoAnoNe?:ValueTypes["FieldMeta"],
	eliminacniDietaAnoNe?:ValueTypes["FieldMeta"],
	alergenyAnoNe?:ValueTypes["FieldMeta"],
	plodnostKastraceNadpis?:ValueTypes["FieldMeta"],
	plodnostKastraceText?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	stravitelnostNadpis?:ValueTypes["FieldMeta"],
	stravitelnostProcenta?:ValueTypes["FieldMeta"],
	stravitelnostSlovne?:ValueTypes["FieldMeta"],
	stravitelnostChybiText?:ValueTypes["FieldMeta"],
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TOPXProduct"]: AliasType<{
	_meta?:ValueTypes["TOPXProductMeta"],
	id?:boolean,
	remoteId?:boolean,
	order?:boolean,
	orderType?:boolean,
product?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
category?: [{	filter?:ValueTypes["TOPXProductCategoryWhere"] | null},ValueTypes["TOPXProductCategory"]],
		__typename?: boolean
}>;
	["TOPXProductMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	orderType?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TOPXProductCategory"]: AliasType<{
	_meta?:ValueTypes["TOPXProductCategoryMeta"],
	id?:boolean,
	remoteId?:boolean,
products?: [{	filter?:ValueTypes["TOPXProductWhere"] | null,	orderBy?:ValueTypes["TOPXProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TOPXProduct"]],
productsByRemoteId?: [{	by:ValueTypes["TOPXProductCategoryProductsByRemoteIdUniqueWhere"],	filter?:ValueTypes["TOPXProductWhere"] | null},ValueTypes["TOPXProduct"]],
paginateProducts?: [{	filter?:ValueTypes["TOPXProductWhere"] | null,	orderBy?:ValueTypes["TOPXProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TOPXProductConnection"]],
		__typename?: boolean
}>;
	["TOPXProductCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TOPXProductOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	orderType?:ValueTypes["OrderDirection"] | null,
	product?:ValueTypes["ProductOrderBy"] | null,
	category?:ValueTypes["TOPXProductCategoryOrderBy"] | null
};
	["TOPXProductCategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null
};
	["TOPXProductCategoryProductsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["TOPXProductConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TOPXProductEdge"],
		__typename?: boolean
}>;
	["TOPXProductEdge"]: AliasType<{
	node?:ValueTypes["TOPXProduct"],
		__typename?: boolean
}>;
	["ProductNutritionalValuesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ProductReviewsByProductReviewReactionsUniqueWhere"]: {
	productReviewReactions?:ValueTypes["ProductReviewReactionUniqueWhere"] | null
};
	["ProductReviewsByStatsUniqueWhere"]: {
	stats?:ValueTypes["ProductReviewStatsUniqueWhere"] | null
};
	["ProductDogsByReproductionUniqueWhere"]: {
	reproduction?:ValueTypes["DogReproductionUniqueWhere"] | null
};
	["ProductDogsByAvatarUniqueWhere"]: {
	avatar?:ValueTypes["ImageUniqueWhere"] | null
};
	["ProductPackagingsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ProductPackagingsByPositionIdUniqueWhere"]: {
	positionId?:string | null
};
	["ProductPackagingsByExternalIdUniqueWhere"]: {
	externalId?:string | null
};
	["ProductElementsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ProductFlagsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ProductAliasesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ProductTopxByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ProductPackageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductPackageEdge"],
		__typename?: boolean
}>;
	["ProductPackageEdge"]: AliasType<{
	node?:ValueTypes["ProductPackage"],
		__typename?: boolean
}>;
	["GranuleSizeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GranuleSizeEdge"],
		__typename?: boolean
}>;
	["GranuleSizeEdge"]: AliasType<{
	node?:ValueTypes["GranuleSize"],
		__typename?: boolean
}>;
	["ProductAliasConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductAliasEdge"],
		__typename?: boolean
}>;
	["ProductAliasEdge"]: AliasType<{
	node?:ValueTypes["ProductAlias"],
		__typename?: boolean
}>;
	["AgeCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AgeCategoryEdge"],
		__typename?: boolean
}>;
	["AgeCategoryEdge"]: AliasType<{
	node?:ValueTypes["AgeCategory"],
		__typename?: boolean
}>;
	["BodyTagFilterCombosByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["BodyTagFilterCombosBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["BodyTagCategoryTagsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["BodyTagCategoryTagsByFilterCombosUniqueWhere"]: {
	filterCombos?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["ColorItemFlavorCategoriesByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["ColorItemFlavorCategoriesByItemsUniqueWhere"]: {
	items?:ValueTypes["ItemSubCategoryUniqueWhere"] | null
};
	["ItemFlavorCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ItemFlavorCategoryEdge"],
		__typename?: boolean
}>;
	["ItemFlavorCategoryEdge"]: AliasType<{
	node?:ValueTypes["ItemFlavorCategory"],
		__typename?: boolean
}>;
	["BlogPostReviewsByBlogPostReviewReactionsUniqueWhere"]: {
	blogPostReviewReactions?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null
};
	["BlogPostReviewsByStatsUniqueWhere"]: {
	stats?:ValueTypes["BlogPostReviewStatsUniqueWhere"] | null
};
	["BlogPostItemsByRemoteIdUniqueWhere"]: {
	remoteId?:string | null
};
	["BlogPostItemsBySlugUniqueWhere"]: {
	slug?:string | null
};
	["BlogPostItemsByFeaturesOfProductUniqueWhere"]: {
	featuresOfProduct?:ValueTypes["ProductFeatureUniqueWhere"] | null
};
	["BlogPostItemsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["BlogPostItemsByReferenceListUniqueWhere"]: {
	referenceList?:ValueTypes["ReferenceListUniqueWhere"] | null
};
	["BlogPostItemsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["BlogPostItemsByAliasesUniqueWhere"]: {
	aliases?:ValueTypes["ItemAliasUniqueWhere"] | null
};
	["BlogPostItemsByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["BlogPostItemsByDraftUniqueWhere"]: {
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["BlogPostRedirectsByFromUniqueWhere"]: {
	from?:string | null
};
	["BlogPostTagConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogPostTagEdge"],
		__typename?: boolean
}>;
	["BlogPostTagEdge"]: AliasType<{
	node?:ValueTypes["BlogPostTag"],
		__typename?: boolean
}>;
	["Link"]: AliasType<{
	_meta?:ValueTypes["LinkMeta"],
	id?:boolean,
	externalLink?:boolean,
	isTargetBlank?:boolean,
		__typename?: boolean
}>;
	["LinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	externalLink?:ValueTypes["FieldMeta"],
	isTargetBlank?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentReferenceList"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceListMeta"],
	id?:boolean,
	order?:boolean,
relatedProduct?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
relatedBrand?: [{	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
list?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
	badge?:boolean,
	badgeColor?:boolean,
		__typename?: boolean
}>;
	["ContentReferenceListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	relatedProduct?:ValueTypes["FieldMeta"],
	relatedBrand?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	badge?:ValueTypes["FieldMeta"],
	badgeColor?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentReferenceListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	relatedProduct?:ValueTypes["ProductOrderBy"] | null,
	relatedBrand?:ValueTypes["BrandOrderBy"] | null,
	list?:ValueTypes["ContentReferenceOrderBy"] | null,
	badge?:ValueTypes["OrderDirection"] | null,
	badgeColor?:ValueTypes["OrderDirection"] | null
};
	["ContentLinks"]: AliasType<{
	_meta?:ValueTypes["ContentLinksMeta"],
	id?:boolean,
items?: [{	filter?:ValueTypes["ContentLinksItemWhere"] | null,	orderBy?:ValueTypes["ContentLinksItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentLinksItem"]],
paginateItems?: [{	filter?:ValueTypes["ContentLinksItemWhere"] | null,	orderBy?:ValueTypes["ContentLinksItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentLinksItemConnection"]],
		__typename?: boolean
}>;
	["ContentLinksMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentLinksItem"]: AliasType<{
	_meta?:ValueTypes["ContentLinksItemMeta"],
	id?:boolean,
	order?:boolean,
	title?:boolean,
	target?:boolean,
list?: [{	filter?:ValueTypes["ContentLinksWhere"] | null},ValueTypes["ContentLinks"]],
		__typename?: boolean
}>;
	["ContentLinksItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentLinksItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	target?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ContentLinksOrderBy"] | null
};
	["ContentLinksItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentLinksItemEdge"],
		__typename?: boolean
}>;
	["ContentLinksItemEdge"]: AliasType<{
	node?:ValueTypes["ContentLinksItem"],
		__typename?: boolean
}>;
	["Video"]: AliasType<{
	_meta?:ValueTypes["VideoMeta"],
	id?:boolean,
	src?:boolean,
	width?:boolean,
	height?:boolean,
	size?:boolean,
	type?:boolean,
	duration?:boolean,
poster?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: boolean
}>;
	["VideoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	src?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	duration?:ValueTypes["FieldMeta"],
	poster?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentReferenceImage"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceImageMeta"],
	id?:boolean,
	lead?:boolean,
	alignment?:boolean,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	link?:boolean,
	targetBlank?:boolean,
		__typename?: boolean
}>;
	["ContentReferenceImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	alignment?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	targetBlank?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentReferenceGalleryImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceGalleryImageEdge"],
		__typename?: boolean
}>;
	["ContentReferenceGalleryImageEdge"]: AliasType<{
	node?:ValueTypes["ContentReferenceGalleryImage"],
		__typename?: boolean
}>;
	["ContentReferenceListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceListEdge"],
		__typename?: boolean
}>;
	["ContentReferenceListEdge"]: AliasType<{
	node?:ValueTypes["ContentReferenceList"],
		__typename?: boolean
}>;
	["ContentBlockReferencesByImagesUniqueWhere"]: {
	images?:ValueTypes["ContentReferenceGalleryImageUniqueWhere"] | null
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["ContentBlockReferencesByListUniqueWhere"]: {
	list?:ValueTypes["ContentReferenceListUniqueWhere"] | null
};
	["ContentBlockReferencesByOutlineUniqueWhere"]: {
	outline?:ValueTypes["ContentLinksUniqueWhere"] | null
};
	["ContentBlockReferencesByVideoUniqueWhere"]: {
	video?:ValueTypes["VideoUniqueWhere"] | null
};
	["ContentBlockReferencesByImageUniqueWhere"]: {
	image?:ValueTypes["ContentReferenceImageUniqueWhere"] | null
};
	["ContentBlocksByAutomatedContentBlockSlugUniqueWhere"]: {
	automatedContentBlockSlug?:string | null
};
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentBlockEdge"],
		__typename?: boolean
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ValueTypes["ContentBlock"],
		__typename?: boolean
}>;
	["BrandsPageRedirectsByFromUniqueWhere"]: {
	from?:string | null
};
	["ComparatorPage"]: AliasType<{
	_meta?:ValueTypes["ComparatorPageMeta"],
	id?:boolean,
	unique?:boolean,
redirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
redirectsByFrom?: [{	by:ValueTypes["ComparatorPageRedirectsByFromUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
paginateRedirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
		__typename?: boolean
}>;
	["ComparatorPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	redirects?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ComparatorPageRedirectsByFromUniqueWhere"]: {
	from?:string | null
};
	["HomePage"]: AliasType<{
	_meta?:ValueTypes["HomePageMeta"],
	id?:boolean,
	unique?:boolean,
	title?:boolean,
	lead?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: boolean
}>;
	["HomePageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["IngredientsPage"]: AliasType<{
	_meta?:ValueTypes["IngredientsPageMeta"],
	id?:boolean,
	unique?:boolean,
	title?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
draft?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
		__typename?: boolean
}>;
	["IngredientsPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	draft?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["LoginPage"]: AliasType<{
	_meta?:ValueTypes["LoginPageMeta"],
	id?:boolean,
	unique?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: boolean
}>;
	["LoginPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["RegisterPage"]: AliasType<{
	_meta?:ValueTypes["RegisterPageMeta"],
	id?:boolean,
	unique?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: boolean
}>;
	["RegisterPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SearchPage"]: AliasType<{
	_meta?:ValueTypes["SearchPageMeta"],
	id?:boolean,
	unique?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: boolean
}>;
	["SearchPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["WizardPage"]: AliasType<{
	_meta?:ValueTypes["WizardPageMeta"],
	id?:boolean,
	unique?:boolean,
redirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
redirectsByFrom?: [{	by:ValueTypes["WizardPageRedirectsByFromUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
paginateRedirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
		__typename?: boolean
}>;
	["WizardPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	redirects?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["WizardPageRedirectsByFromUniqueWhere"]: {
	from?:string | null
};
	["ContactPage"]: AliasType<{
	_meta?:ValueTypes["ContactPageMeta"],
	id?:boolean,
	unique?:boolean,
	title?:boolean,
redirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
draft?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
redirectsByFrom?: [{	by:ValueTypes["ContactPageRedirectsByFromUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
paginateRedirects?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
		__typename?: boolean
}>;
	["ContactPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	redirects?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	draft?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContactPageRedirectsByFromUniqueWhere"]: {
	from?:string | null
};
	["GenericPageRedirectsByFromUniqueWhere"]: {
	from?:string | null
};
	["BlogPageRedirectsByFromUniqueWhere"]: {
	from?:string | null
};
	["BlogPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogPageEdge"],
		__typename?: boolean
}>;
	["BlogPageEdge"]: AliasType<{
	node?:ValueTypes["BlogPage"],
		__typename?: boolean
}>;
	["_ValidationResult"]: AliasType<{
	valid?:boolean,
	errors?:ValueTypes["_ValidationError"],
		__typename?: boolean
}>;
	["_ValidationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	message?:ValueTypes["_ValidationMessage"],
		__typename?: boolean
}>;
	["_PathFragment"]: AliasType<{		["...on _FieldPathFragment"] : ValueTypes["_FieldPathFragment"],
		["...on _IndexPathFragment"] : ValueTypes["_IndexPathFragment"]
		__typename?: boolean
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:boolean,
		__typename?: boolean
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:boolean,
	alias?:boolean,
		__typename?: boolean
}>;
	["_ValidationMessage"]: AliasType<{
	text?:boolean,
		__typename?: boolean
}>;
	["BlogPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	redirects?:ValueTypes["BlogPageCreateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["BlogPageCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["BlogPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPageCreateRedirectsEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutBlogPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPageConnectOrCreateRedirectsRelationInput"] | null,
	alias?:string | null
};
	["RedirectWithoutBlogPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectCreateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectCreateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectCreateBrandsPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectCreateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectCreateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectCreateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectCreateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateGenericPageEntityRelationInput"]: {
	connect?:ValueTypes["GenericPageUniqueWhere"] | null,
	create?:ValueTypes["GenericPageWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateGenericPageRelationInput"] | null
};
	["GenericPageWithoutRedirectsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["GenericPageCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["GenericPageCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["GenericPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["GenericPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GenericPageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutGenericPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["GenericPageConnectOrCreateLinkRelationInput"] | null
};
	["LinkableWithoutGenericPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["GenericPageConnectOrCreateLinkRelationInput"]: {
	connect:ValueTypes["LinkableUniqueWhere"],
	create:ValueTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutGenericPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["GenericPageConnectOrCreateSeoRelationInput"] | null
};
	["SeoWithoutGenericPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoCreateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoCreateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoCreateComparatorPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoCreateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoCreateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoCreateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoCreateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoCreateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoCreateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoCreateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateOgImageRelationInput"] | null
};
	["ImageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	remoteId?:string | null,
	hash?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoConnectOrCreateOgImageRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["SeoCreateBlogPageEntityRelationInput"]: {
	connect?:ValueTypes["BlogPageUniqueWhere"] | null,
	create?:ValueTypes["BlogPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateBlogPageRelationInput"] | null
};
	["BlogPageWithoutSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	redirects?:ValueTypes["BlogPageCreateRedirectsEntityRelationInput"][],
	content?:ValueTypes["BlogPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPageCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPageConnectOrCreateContentRelationInput"] | null
};
	["ContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentCreateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentConnectOrCreateBlocksRelationInput"] | null,
	alias?:string | null
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentBlockCreateReferencesEntityRelationInput"][],
	automatedContentBlockSlug?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentBlockConnectOrCreateReferencesRelationInput"] | null,
	alias?:string | null
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fact?:string | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	relatedBlogPost?:ValueTypes["ContentReferenceCreateRelatedBlogPostEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceCreateRelatedBrandEntityRelationInput"] | null,
	relatedProduct?:ValueTypes["ContentReferenceCreateRelatedProductEntityRelationInput"] | null,
	relatedIngredient?:ValueTypes["ContentReferenceCreateRelatedIngredientEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	badge?:string | null,
	longVersion?:boolean | null,
	relatedBrandFull?:ValueTypes["ContentReferenceCreateRelatedBrandFullEntityRelationInput"] | null,
	relatedProductFull?:ValueTypes["ContentReferenceCreateRelatedProductFullEntityRelationInput"] | null,
	list?:ValueTypes["ContentReferenceCreateListEntityRelationInput"][],
	outline?:ValueTypes["ContentReferenceCreateOutlineEntityRelationInput"] | null,
	video?:ValueTypes["ContentReferenceCreateVideoEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	defaultOpen?:boolean | null,
	badgeColor?:string | null,
	isMain?:boolean | null,
	ad?:ValueTypes["ContentReferenceCreateAdEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateImagesEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceGalleryImageUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceGalleryImageWithoutReferenceCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateImagesRelationInput"] | null,
	alias?:string | null
};
	["ContentReferenceGalleryImageWithoutReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["ContentReferenceGalleryImageCreateImageEntityRelationInput"] | null,
	lead?:string | null,
	alignment?:ValueTypes["AlignmentType"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceGalleryImageCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceGalleryImageConnectOrCreateImageRelationInput"] | null
};
	["ContentReferenceGalleryImageConnectOrCreateImageRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["ContentReferenceConnectOrCreateImagesRelationInput"]: {
	connect:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],
	create:ValueTypes["ContentReferenceGalleryImageWithoutReferenceCreateInput"]
};
	["ContentReferenceCreateRelatedBlogPostEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateRelatedBlogPostRelationInput"] | null
};
	["BlogPostCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostCreateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostCreateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostCreateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostCreateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostCreateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostCreateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostCreateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostCreateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostCreateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostCreateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostCreateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostCreateBlogPostTagsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostTagUniqueWhere"] | null,
	create?:ValueTypes["BlogPostTagWithoutBlogPostsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateBlogPostTagsRelationInput"] | null,
	alias?:string | null
};
	["BlogPostTagUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	color?:ValueTypes["ColorUniqueWhere"] | null
};
	["ColorUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	bodyTagCategory?:ValueTypes["BodyTagCategoryUniqueWhere"] | null,
	blogPostTag?:ValueTypes["BlogPostTagUniqueWhere"] | null,
	itemFlavorCategories?:ValueTypes["ItemFlavorCategoryUniqueWhere"] | null
};
	["BodyTagCategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	tags?:ValueTypes["BodyTagUniqueWhere"] | null,
	color?:ValueTypes["ColorUniqueWhere"] | null
};
	["BodyTagUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	filterCombos?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["ItemFlavorCategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	items?:ValueTypes["ItemSubCategoryUniqueWhere"] | null
};
	["BlogPostTagWithoutBlogPostsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	remoteId?:string | null,
	color?:ValueTypes["BlogPostTagCreateColorEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["BlogPostTagCreateColorEntityRelationInput"]: {
	connect?:ValueTypes["ColorUniqueWhere"] | null,
	create?:ValueTypes["ColorWithoutBlogPostTagCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostTagConnectOrCreateColorRelationInput"] | null
};
	["ColorWithoutBlogPostTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	colorHex?:string | null,
	bodyTagCategory?:ValueTypes["ColorCreateBodyTagCategoryEntityRelationInput"] | null,
	remoteId?:string | null,
	itemFlavorCategories?:ValueTypes["ColorCreateItemFlavorCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ColorCreateBodyTagCategoryEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagCategoryUniqueWhere"] | null,
	create?:ValueTypes["BodyTagCategoryWithoutColorCreateInput"] | null,
	connectOrCreate?:ValueTypes["ColorConnectOrCreateBodyTagCategoryRelationInput"] | null
};
	["BodyTagCategoryWithoutColorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	tags?:ValueTypes["BodyTagCategoryCreateTagsEntityRelationInput"][],
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["BodyTagCategoryCreateTagsEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	create?:ValueTypes["BodyTagWithoutCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagCategoryConnectOrCreateTagsRelationInput"] | null,
	alias?:string | null
};
	["BodyTagWithoutCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagCreateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagCreatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagCreateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagCreatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagCreateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	icon?:ValueTypes["BodyTagCreateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagCreateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagCreateBlogPostsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostWithoutTagsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagConnectOrCreateBlogPostsRelationInput"] | null,
	alias?:string | null
};
	["BlogPostWithoutTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostCreateBlogPostTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostCreateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostCreateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostCreateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostCreateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostCreateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostCreateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostCreateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostCreateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostCreateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostCreateReviewsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	create?:ValueTypes["BlogPostReviewWithoutBlogPostCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateReviewsRelationInput"] | null,
	alias?:string | null
};
	["BlogPostReviewWithoutBlogPostCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"][],
	user?:ValueTypes["BlogPostReviewCreateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["BlogPostReviewCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["BlogPostReviewCreateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null,
	create?:ValueTypes["BlogPostReviewReactionWithoutBlogPostReviewCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewConnectOrCreateBlogPostReviewReactionsRelationInput"] | null,
	alias?:string | null
};
	["BlogPostReviewReactionWithoutBlogPostReviewCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	sentiment?:ValueTypes["SentimentType"] | null,
	user?:ValueTypes["BlogPostReviewReactionCreateUserEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewReactionCreateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutBlogPostReviewReactionsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewReactionConnectOrCreateUserRelationInput"] | null
};
	["UserWithoutBlogPostReviewReactionsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["UserCreateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserCreateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserCreateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserCreateProductReviewsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserCreateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserCreateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserCreateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserCreateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserCreateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserCreateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserCreateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserCreateDogsEntityRelationInput"]: {
	connect?:ValueTypes["DogUniqueWhere"] | null,
	create?:ValueTypes["DogWithoutOwnerCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateDogsRelationInput"] | null,
	alias?:string | null
};
	["DogWithoutOwnerCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogCreateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogCreateBodyTypeEntityRelationInput"] | null,
	activity?:ValueTypes["DogCreateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogCreateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogCreateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogCreateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogCreateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogCreateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogCreateBreedEntityRelationInput"]: {
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	create?:ValueTypes["BreedWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateBreedRelationInput"] | null
};
	["BreedWithoutDogsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	litterSize?:number | null,
	reviews?:ValueTypes["BreedCreateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedCreateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedCreateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedCreateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedCreateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedCreateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedCreateReviewsEntityRelationInput"]: {
	connect?:ValueTypes["ReviewUniqueWhere"] | null,
	create?:ValueTypes["ReviewWithoutDogBreedsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BreedConnectOrCreateReviewsRelationInput"] | null,
	alias?:string | null
};
	["ReviewUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["ReviewWithoutDogBreedsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	remoteId?:string | null,
	author?:string | null,
	_dummy_field_?:boolean | null
};
	["BreedConnectOrCreateReviewsRelationInput"]: {
	connect:ValueTypes["ReviewUniqueWhere"],
	create:ValueTypes["ReviewWithoutDogBreedsCreateInput"]
};
	["BreedCreateAgesEntityRelationInput"]: {
	connect?:ValueTypes["AgeUniqueWhere"] | null,
	create?:ValueTypes["AgeWithoutBreedsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BreedConnectOrCreateAgesRelationInput"] | null,
	alias?:string | null
};
	["AgeUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	ageRange?:ValueTypes["AgeRangeType"] | null,
	remoteId?:string | null,
	label?:string | null,
	dogs?:ValueTypes["DogUniqueWhere"] | null,
	productReviews?:ValueTypes["ProductReviewUniqueWhere"] | null,
	blogPostReviews?:ValueTypes["BlogPostReviewUniqueWhere"] | null
};
	["AgeWithoutBreedsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["AgeCreateDogsEntityRelationInput"][],
	ageRange?:ValueTypes["AgeRangeType"] | null,
	categoryLabel?:ValueTypes["AgeLabelType"] | null,
	suitabilityCategories?:ValueTypes["AgeCreateSuitabilityCategoriesEntityRelationInput"][],
	remoteId?:string | null,
	productReviews?:ValueTypes["AgeCreateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["AgeCreateBlogPostReviewsEntityRelationInput"][],
	label?:string | null,
	categoryOrder?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeCreateDogsEntityRelationInput"]: {
	connect?:ValueTypes["DogUniqueWhere"] | null,
	create?:ValueTypes["DogWithoutAgeCreateInput"] | null,
	connectOrCreate?:ValueTypes["AgeConnectOrCreateDogsRelationInput"] | null,
	alias?:string | null
};
	["DogWithoutAgeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogCreateBreedEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogCreateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogCreateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogCreateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogCreateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogCreateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogCreateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogCreateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogCreateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogCreateBodyTypeEntityRelationInput"]: {
	connect?:ValueTypes["DogBodyTypeUniqueWhere"] | null,
	create?:ValueTypes["DogBodyTypeWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateBodyTypeRelationInput"] | null
};
	["DogBodyTypeUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	dogs?:ValueTypes["DogUniqueWhere"] | null,
	imageMain?:ValueTypes["ImageUniqueWhere"] | null,
	imageFrom?:ValueTypes["ImageUniqueWhere"] | null,
	imageTo?:ValueTypes["ImageUniqueWhere"] | null
};
	["DogBodyTypeWithoutDogsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	lead?:string | null,
	order?:number | null,
	value?:number | null,
	remoteId?:string | null,
	category?:ValueTypes["DogBodyTypeCreateCategoryEntityRelationInput"] | null,
	imageMain?:ValueTypes["DogBodyTypeCreateImageMainEntityRelationInput"] | null,
	imageFrom?:ValueTypes["DogBodyTypeCreateImageFromEntityRelationInput"] | null,
	imageTo?:ValueTypes["DogBodyTypeCreateImageToEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogBodyTypeCreateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["DogBodyTypeCategoryUniqueWhere"] | null,
	create?:ValueTypes["DogBodyTypeCategoryWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogBodyTypeConnectOrCreateCategoryRelationInput"] | null
};
	["DogBodyTypeCategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	items?:ValueTypes["DogBodyTypeUniqueWhere"] | null,
	imageMain?:ValueTypes["ImageUniqueWhere"] | null
};
	["DogBodyTypeCategoryWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	remoteId?:string | null,
	imageMain?:ValueTypes["DogBodyTypeCategoryCreateImageMainEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogBodyTypeCategoryCreateImageMainEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogBodyTypeCategoryConnectOrCreateImageMainRelationInput"] | null
};
	["DogBodyTypeCategoryConnectOrCreateImageMainRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["DogBodyTypeConnectOrCreateCategoryRelationInput"]: {
	connect:ValueTypes["DogBodyTypeCategoryUniqueWhere"],
	create:ValueTypes["DogBodyTypeCategoryWithoutItemsCreateInput"]
};
	["DogBodyTypeCreateImageMainEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogBodyTypeConnectOrCreateImageMainRelationInput"] | null
};
	["DogBodyTypeConnectOrCreateImageMainRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["DogBodyTypeCreateImageFromEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogBodyTypeConnectOrCreateImageFromRelationInput"] | null
};
	["DogBodyTypeConnectOrCreateImageFromRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["DogBodyTypeCreateImageToEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogBodyTypeConnectOrCreateImageToRelationInput"] | null
};
	["DogBodyTypeConnectOrCreateImageToRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["DogConnectOrCreateBodyTypeRelationInput"]: {
	connect:ValueTypes["DogBodyTypeUniqueWhere"],
	create:ValueTypes["DogBodyTypeWithoutDogsCreateInput"]
};
	["DogCreateOwnerEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateOwnerRelationInput"] | null
};
	["UserWithoutDogsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	veterinary?:ValueTypes["UserCreateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserCreateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserCreateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserCreateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserCreateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserCreateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserCreateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserCreateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserCreateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserCreateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserCreateVeterinaryEntityRelationInput"]: {
	connect?:ValueTypes["VeterinaryUniqueWhere"] | null,
	create?:ValueTypes["VeterinaryWithoutUserCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateVeterinaryRelationInput"] | null
};
	["VeterinaryWithoutUserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["UserConnectOrCreateVeterinaryRelationInput"]: {
	connect:ValueTypes["VeterinaryUniqueWhere"],
	create:ValueTypes["VeterinaryWithoutUserCreateInput"]
};
	["UserCreateBlogPostReviewsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	create?:ValueTypes["BlogPostReviewWithoutUserCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateBlogPostReviewsRelationInput"] | null,
	alias?:string | null
};
	["BlogPostReviewWithoutUserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"][],
	blogPost?:ValueTypes["BlogPostReviewCreateBlogPostEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["BlogPostReviewCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["BlogPostReviewCreateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewCreateBlogPostEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostWithoutReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewConnectOrCreateBlogPostRelationInput"] | null
};
	["BlogPostWithoutReviewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostCreateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostCreateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	itemCategories?:ValueTypes["BlogPostCreateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostCreateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostCreateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostCreateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostCreateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostCreateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostCreateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostCreateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostCreateTagsEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	create?:ValueTypes["BodyTagWithoutBlogPostsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateTagsRelationInput"] | null,
	alias?:string | null
};
	["BodyTagWithoutBlogPostsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	positiveProducts?:ValueTypes["BodyTagCreatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagCreateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagCreatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagCreateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagCreateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagCreateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagCreateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagCreatePositiveProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutPositiveForBodyTagsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagConnectOrCreatePositiveProductsRelationInput"] | null,
	alias?:string | null
};
	["ProductWithoutPositiveForBodyTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreateNutritionalValuesEntityRelationInput"]: {
	connect?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null,
	create?:ValueTypes["NutritionalValueOfProductWithoutProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateNutritionalValuesRelationInput"] | null,
	alias?:string | null
};
	["NutritionalValueOfProductWithoutProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	amount?:number | null,
	remoteId?:string | null,
	nutritionalValue?:ValueTypes["NutritionalValueOfProductCreateNutritionalValueEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NutritionalValueOfProductCreateNutritionalValueEntityRelationInput"]: {
	connect?:ValueTypes["NutritionalValueUniqueWhere"] | null,
	create?:ValueTypes["NutritionalValueWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["NutritionalValueOfProductConnectOrCreateNutritionalValueRelationInput"] | null
};
	["NutritionalValueUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	products?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null,
	suitabilityNutritionalValues?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	icon?:ValueTypes["ImageUniqueWhere"] | null
};
	["NutritionalValueWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	suitabilityNutritionalValues?:ValueTypes["NutritionalValueCreateSuitabilityNutritionalValuesEntityRelationInput"][],
	remoteId?:string | null,
	icon?:ValueTypes["NutritionalValueCreateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NutritionalValueCreateSuitabilityNutritionalValuesEntityRelationInput"]: {
	connect?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	create?:ValueTypes["SuitabilityItemWithoutNutritionalValueCreateInput"] | null,
	connectOrCreate?:ValueTypes["NutritionalValueConnectOrCreateSuitabilityNutritionalValuesRelationInput"] | null,
	alias?:string | null
};
	["SuitabilityItemWithoutNutritionalValueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	min?:number | null,
	max?:number | null,
	remoteId?:string | null,
	order?:number | null,
	element?:ValueTypes["SuitabilityItemCreateElementEntityRelationInput"] | null,
	category?:ValueTypes["SuitabilityItemCreateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityItemCreateElementEntityRelationInput"]: {
	connect?:ValueTypes["ElementUniqueWhere"] | null,
	create?:ValueTypes["ElementWithoutSuitabilityElementsCreateInput"] | null,
	connectOrCreate?:ValueTypes["SuitabilityItemConnectOrCreateElementRelationInput"] | null
};
	["ElementWithoutSuitabilityElementsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["ElementCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ElementCreateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	unit?:string | null,
	filterOrder?:number | null,
	slug?:string | null,
	declensionSeventh?:string | null,
	_dummy_field_?:boolean | null
};
	["ElementCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ElementOfProductUniqueWhere"] | null,
	create?:ValueTypes["ElementOfProductWithoutElementCreateInput"] | null,
	connectOrCreate?:ValueTypes["ElementConnectOrCreateProductsRelationInput"] | null,
	alias?:string | null
};
	["ElementOfProductWithoutElementCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	amount?:number | null,
	product?:ValueTypes["ElementOfProductCreateProductEntityRelationInput"] | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ElementOfProductCreateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutElementsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ElementOfProductConnectOrCreateProductRelationInput"] | null
};
	["ProductWithoutElementsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreatePositiveForBodyTagsEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	create?:ValueTypes["BodyTagWithoutPositiveProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreatePositiveForBodyTagsRelationInput"] | null,
	alias?:string | null
};
	["BodyTagWithoutPositiveProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagCreateBlogPostsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagCreateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagCreatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagCreateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagCreateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagCreateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagCreateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagCreateNegativeProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutNegativeForBodyTagsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagConnectOrCreateNegativeProductsRelationInput"] | null,
	alias?:string | null
};
	["ProductWithoutNegativeForBodyTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreateReviewsEntityRelationInput"]: {
	connect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	create?:ValueTypes["ProductReviewWithoutProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateReviewsRelationInput"] | null,
	alias?:string | null
};
	["ProductReviewWithoutProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	productReviewReactions?:ValueTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"][],
	score?:ValueTypes["ProductReviewCreateScoreEntityRelationInput"] | null,
	user?:ValueTypes["ProductReviewCreateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["ProductReviewCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["ProductReviewCreateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewCreateProductReviewReactionsEntityRelationInput"]: {
	connect?:ValueTypes["ProductReviewReactionUniqueWhere"] | null,
	create?:ValueTypes["ProductReviewReactionWithoutProductReviewCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewConnectOrCreateProductReviewReactionsRelationInput"] | null,
	alias?:string | null
};
	["ProductReviewReactionWithoutProductReviewCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	sentiment?:ValueTypes["SentimentType"] | null,
	user?:ValueTypes["ProductReviewReactionCreateUserEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewReactionCreateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutProductReviewReactionsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewReactionConnectOrCreateUserRelationInput"] | null
};
	["UserWithoutProductReviewReactionsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["UserCreateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserCreateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserCreateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserCreateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserCreateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserCreateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserCreateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserCreateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserCreateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserCreateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserCreateProductReviewsEntityRelationInput"]: {
	connect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	create?:ValueTypes["ProductReviewWithoutUserCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateProductReviewsRelationInput"] | null,
	alias?:string | null
};
	["ProductReviewWithoutUserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	productReviewReactions?:ValueTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"][],
	score?:ValueTypes["ProductReviewCreateScoreEntityRelationInput"] | null,
	product?:ValueTypes["ProductReviewCreateProductEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["ProductReviewCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["ProductReviewCreateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewCreateScoreEntityRelationInput"]: {
	connect?:ValueTypes["ScoreUniqueWhere"] | null,
	create?:ValueTypes["ScoreWithoutProductReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewConnectOrCreateScoreRelationInput"] | null
};
	["ScoreUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	productReviews?:ValueTypes["ProductReviewUniqueWhere"] | null
};
	["ScoreWithoutProductReviewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:string | null,
	starsAmount?:number | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewConnectOrCreateScoreRelationInput"]: {
	connect:ValueTypes["ScoreUniqueWhere"],
	create:ValueTypes["ScoreWithoutProductReviewsCreateInput"]
};
	["ProductReviewCreateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewConnectOrCreateProductRelationInput"] | null
};
	["ProductWithoutReviewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreateNegativeForBodyTagsEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	create?:ValueTypes["BodyTagWithoutNegativeProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateNegativeForBodyTagsRelationInput"] | null,
	alias?:string | null
};
	["BodyTagWithoutNegativeProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagCreateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagCreatePositiveProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagCreatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagCreateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagCreateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagCreateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagCreateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagCreatePositiveItemsEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemWithoutPositiveForBodyTagsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagConnectOrCreatePositiveItemsRelationInput"] | null,
	alias?:string | null
};
	["ItemWithoutPositiveForBodyTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	negativeForBodyTags?:ValueTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemCreateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemCreateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemCreateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemCreateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemCreateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemCreateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemCreateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemCreateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemCreateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCreateNegativeForBodyTagsEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	create?:ValueTypes["BodyTagWithoutNegativeItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateNegativeForBodyTagsRelationInput"] | null,
	alias?:string | null
};
	["BodyTagWithoutNegativeItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagCreateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagCreatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagCreateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagCreatePositiveItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagCreateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagCreateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagCreateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagCreateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagCategoryUniqueWhere"] | null,
	create?:ValueTypes["BodyTagCategoryWithoutTagsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagConnectOrCreateCategoryRelationInput"] | null
};
	["BodyTagCategoryWithoutTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	remoteId?:string | null,
	color?:ValueTypes["BodyTagCategoryCreateColorEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BodyTagCategoryCreateColorEntityRelationInput"]: {
	connect?:ValueTypes["ColorUniqueWhere"] | null,
	create?:ValueTypes["ColorWithoutBodyTagCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagCategoryConnectOrCreateColorRelationInput"] | null
};
	["ColorWithoutBodyTagCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	colorHex?:string | null,
	blogPostTag?:ValueTypes["ColorCreateBlogPostTagEntityRelationInput"] | null,
	remoteId?:string | null,
	itemFlavorCategories?:ValueTypes["ColorCreateItemFlavorCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ColorCreateBlogPostTagEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostTagUniqueWhere"] | null,
	create?:ValueTypes["BlogPostTagWithoutColorCreateInput"] | null,
	connectOrCreate?:ValueTypes["ColorConnectOrCreateBlogPostTagRelationInput"] | null
};
	["BlogPostTagWithoutColorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	blogPosts?:ValueTypes["BlogPostTagCreateBlogPostsEntityRelationInput"][],
	remoteId?:string | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["BlogPostTagCreateBlogPostsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostWithoutBlogPostTagsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostTagConnectOrCreateBlogPostsRelationInput"] | null,
	alias?:string | null
};
	["BlogPostWithoutBlogPostTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	tags?:ValueTypes["BlogPostCreateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostCreateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostCreateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostCreateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostCreateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostCreateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostCreateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostCreateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostCreateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostCreateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostCreateItemCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutBlogPostsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateItemCategoriesRelationInput"] | null,
	alias?:string | null
};
	["ItemCategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	slug?:string | null,
	subCategories?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	featureDependencies?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	redirects?:ValueTypes["RedirectUniqueWhere"] | null,
	declensionsFourth?:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["ItemCategoryWithoutBlogPostsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryCreateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryCreateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryCreateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryCreateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryCreateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryCreateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryCreateSubCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryWithoutCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateSubCategoriesRelationInput"] | null,
	alias?:string | null
};
	["ItemSubCategoryWithoutCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryCreateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	flavorCategory?:ValueTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryCreateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryCreateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryCreateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemWithoutSubCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateItemsRelationInput"] | null,
	alias?:string | null
};
	["ItemWithoutSubCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"][],
	categories?:ValueTypes["ItemCreateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemCreateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemCreateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemCreateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemCreateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemCreateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemCreateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemCreateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCreatePositiveForBodyTagsEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	create?:ValueTypes["BodyTagWithoutPositiveItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreatePositiveForBodyTagsRelationInput"] | null,
	alias?:string | null
};
	["BodyTagWithoutPositiveItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagCreateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagCreatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagCreateNegativeProductsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagCreateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagCreateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagCreateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagCreateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagCreateNegativeItemsEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemWithoutNegativeForBodyTagsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagConnectOrCreateNegativeItemsRelationInput"] | null,
	alias?:string | null
};
	["ItemWithoutNegativeForBodyTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemCreateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemCreateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemCreateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemCreateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemCreateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemCreateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemCreateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemCreateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemCreateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCreateSubCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateSubCategoriesRelationInput"] | null,
	alias?:string | null
};
	["ItemSubCategoryWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryCreateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryCreateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryCreateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryCreateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutItemSubCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateProductsRelationInput"] | null,
	alias?:string | null
};
	["ProductWithoutItemSubCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreateDogsEntityRelationInput"]: {
	connect?:ValueTypes["DogUniqueWhere"] | null,
	create?:ValueTypes["DogWithoutFedProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateDogsRelationInput"] | null,
	alias?:string | null
};
	["DogWithoutFedProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogCreateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogCreateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogCreateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogCreateActivityEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogCreateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogCreateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogCreateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogCreateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogCreateAgeEntityRelationInput"]: {
	connect?:ValueTypes["AgeUniqueWhere"] | null,
	create?:ValueTypes["AgeWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateAgeRelationInput"] | null
};
	["AgeWithoutDogsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	breeds?:ValueTypes["AgeCreateBreedsEntityRelationInput"][],
	ageRange?:ValueTypes["AgeRangeType"] | null,
	categoryLabel?:ValueTypes["AgeLabelType"] | null,
	suitabilityCategories?:ValueTypes["AgeCreateSuitabilityCategoriesEntityRelationInput"][],
	remoteId?:string | null,
	productReviews?:ValueTypes["AgeCreateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["AgeCreateBlogPostReviewsEntityRelationInput"][],
	label?:string | null,
	categoryOrder?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeCreateBreedsEntityRelationInput"]: {
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	create?:ValueTypes["BreedWithoutAgesCreateInput"] | null,
	connectOrCreate?:ValueTypes["AgeConnectOrCreateBreedsRelationInput"] | null,
	alias?:string | null
};
	["BreedWithoutAgesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["BreedCreateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedCreateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedCreateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedCreateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedCreateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedCreateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedCreateDogsEntityRelationInput"]: {
	connect?:ValueTypes["DogUniqueWhere"] | null,
	create?:ValueTypes["DogWithoutBreedCreateInput"] | null,
	connectOrCreate?:ValueTypes["BreedConnectOrCreateDogsRelationInput"] | null,
	alias?:string | null
};
	["DogWithoutBreedCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	age?:ValueTypes["DogCreateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogCreateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogCreateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogCreateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogCreateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogCreateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogCreateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogCreateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogCreateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogCreateActivityEntityRelationInput"]: {
	connect?:ValueTypes["DogActivityUniqueWhere"] | null,
	create?:ValueTypes["DogActivityWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateActivityRelationInput"] | null
};
	["DogActivityUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	dogs?:ValueTypes["DogUniqueWhere"] | null,
	products?:ValueTypes["ProductUniqueWhere"] | null
};
	["DogActivityWithoutDogsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:string | null,
	products?:ValueTypes["DogActivityCreateProductsEntityRelationInput"][],
	dailyEnergyRequirementCoeficient?:number | null,
	remoteId?:string | null,
	suitabilityCategory?:ValueTypes["DogActivityCreateSuitabilityCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogActivityCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutRecommendedActivityCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogActivityConnectOrCreateProductsRelationInput"] | null,
	alias?:string | null
};
	["ProductWithoutRecommendedActivityCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreatePackagingsEntityRelationInput"]: {
	connect?:ValueTypes["ProductPackageUniqueWhere"] | null,
	create?:ValueTypes["ProductPackageWithoutProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreatePackagingsRelationInput"] | null,
	alias?:string | null
};
	["ProductPackageWithoutProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	price?:number | null,
	order?:number | null,
	link?:string | null,
	amount?:number | null,
	externalId?:string | null,
	remoteId?:string | null,
	label?:string | null,
	positionId?:string | null,
	heurekaPrice?:number | null,
	heurekaLink?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductConnectOrCreatePackagingsRelationInput"]: {
	connect:ValueTypes["ProductPackageUniqueWhere"],
	create:ValueTypes["ProductPackageWithoutProductCreateInput"]
};
	["ProductCreateItemSubCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateItemSubCategoriesRelationInput"] | null,
	alias?:string | null
};
	["ItemSubCategoryWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryCreateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	featureDependencies?:ValueTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryCreateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryCreateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryCreateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryCreateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"]: {
	connect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	create?:ValueTypes["ProductFeatureWithoutDependentSubCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateFeatureDependenciesRelationInput"] | null,
	alias?:string | null
};
	["ProductFeatureWithoutDependentSubCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	category?:ValueTypes["FeatureCategoryType"] | null,
	value?:ValueTypes["FeatureValueType"] | null,
	remoteId?:string | null,
	linkItem?:ValueTypes["ProductFeatureCreateLinkItemEntityRelationInput"] | null,
	dependentElement?:ValueTypes["ProductFeatureCreateDependentElementEntityRelationInput"] | null,
	dependentCategory?:ValueTypes["ProductFeatureCreateDependentCategoryEntityRelationInput"] | null,
	dependentFlag?:ValueTypes["ProductFeatureCreateDependentFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFeatureCreateLinkItemEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemWithoutFeaturesOfProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFeatureConnectOrCreateLinkItemRelationInput"] | null
};
	["ItemWithoutFeaturesOfProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemCreateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemCreateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemCreateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemCreateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemCreateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemCreateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemCreateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemCreateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCreateCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateCategoriesRelationInput"] | null,
	alias?:string | null
};
	["ItemCategoryWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryCreateBlogPostsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryCreateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryCreateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryCreateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryCreateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryCreateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryCreateBlogPostsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostWithoutItemCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateBlogPostsRelationInput"] | null,
	alias?:string | null
};
	["BlogPostWithoutItemCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostCreateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostCreateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostCreateReviewsEntityRelationInput"][],
	items?:ValueTypes["BlogPostCreateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostCreateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostCreateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostCreateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostCreateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostCreateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostCreateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemWithoutBlogPostCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateItemsRelationInput"] | null,
	alias?:string | null
};
	["ItemWithoutBlogPostCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemCreateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemCreateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemCreateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemCreateReferenceListEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemCreateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemCreateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemCreateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemCreateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCreateFeaturesOfProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	create?:ValueTypes["ProductFeatureWithoutLinkItemCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateFeaturesOfProductRelationInput"] | null,
	alias?:string | null
};
	["ProductFeatureWithoutLinkItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	category?:ValueTypes["FeatureCategoryType"] | null,
	value?:ValueTypes["FeatureValueType"] | null,
	remoteId?:string | null,
	dependentElement?:ValueTypes["ProductFeatureCreateDependentElementEntityRelationInput"] | null,
	dependentCategory?:ValueTypes["ProductFeatureCreateDependentCategoryEntityRelationInput"] | null,
	dependentSubCategory?:ValueTypes["ProductFeatureCreateDependentSubCategoryEntityRelationInput"] | null,
	dependentFlag?:ValueTypes["ProductFeatureCreateDependentFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFeatureCreateDependentElementEntityRelationInput"]: {
	connect?:ValueTypes["ElementUniqueWhere"] | null,
	create?:ValueTypes["ElementWithoutFeatureDependenciesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFeatureConnectOrCreateDependentElementRelationInput"] | null
};
	["ElementWithoutFeatureDependenciesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["ElementCreateProductsEntityRelationInput"][],
	suitabilityElements?:ValueTypes["ElementCreateSuitabilityElementsEntityRelationInput"][],
	remoteId?:string | null,
	unit?:string | null,
	filterOrder?:number | null,
	slug?:string | null,
	declensionSeventh?:string | null,
	_dummy_field_?:boolean | null
};
	["ElementCreateSuitabilityElementsEntityRelationInput"]: {
	connect?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	create?:ValueTypes["SuitabilityItemWithoutElementCreateInput"] | null,
	connectOrCreate?:ValueTypes["ElementConnectOrCreateSuitabilityElementsRelationInput"] | null,
	alias?:string | null
};
	["SuitabilityItemWithoutElementCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	min?:number | null,
	max?:number | null,
	remoteId?:string | null,
	order?:number | null,
	nutritionalValue?:ValueTypes["SuitabilityItemCreateNutritionalValueEntityRelationInput"] | null,
	category?:ValueTypes["SuitabilityItemCreateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityItemCreateNutritionalValueEntityRelationInput"]: {
	connect?:ValueTypes["NutritionalValueUniqueWhere"] | null,
	create?:ValueTypes["NutritionalValueWithoutSuitabilityNutritionalValuesCreateInput"] | null,
	connectOrCreate?:ValueTypes["SuitabilityItemConnectOrCreateNutritionalValueRelationInput"] | null
};
	["NutritionalValueWithoutSuitabilityNutritionalValuesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["NutritionalValueCreateProductsEntityRelationInput"][],
	remoteId?:string | null,
	icon?:ValueTypes["NutritionalValueCreateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NutritionalValueCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null,
	create?:ValueTypes["NutritionalValueOfProductWithoutNutritionalValueCreateInput"] | null,
	connectOrCreate?:ValueTypes["NutritionalValueConnectOrCreateProductsRelationInput"] | null,
	alias?:string | null
};
	["NutritionalValueOfProductWithoutNutritionalValueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	product?:ValueTypes["NutritionalValueOfProductCreateProductEntityRelationInput"] | null,
	amount?:number | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["NutritionalValueOfProductCreateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutNutritionalValuesCreateInput"] | null,
	connectOrCreate?:ValueTypes["NutritionalValueOfProductConnectOrCreateProductRelationInput"] | null
};
	["ProductWithoutNutritionalValuesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreateItemCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateItemCategoriesRelationInput"] | null,
	alias?:string | null
};
	["ItemCategoryWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryCreateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryCreateItemsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryCreateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryCreateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryCreateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryCreateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryCreateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemWithoutCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateItemsRelationInput"] | null,
	alias?:string | null
};
	["ItemWithoutCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemCreateSubCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemCreateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemCreateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemCreateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemCreateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemCreateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemCreateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemCreateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateImageRelationInput"] | null
};
	["ItemConnectOrCreateImageRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["ItemCreateReferenceListEntityRelationInput"]: {
	connect?:ValueTypes["ReferenceListUniqueWhere"] | null,
	create?:ValueTypes["ReferenceListCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateReferenceListRelationInput"] | null
};
	["ReferenceListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	references?:ValueTypes["ReferenceListCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ReferenceListCreateReferencesEntityRelationInput"]: {
	connect?:ValueTypes["ReferenceUniqueWhere"] | null,
	create?:ValueTypes["ReferenceWithoutListCreateInput"] | null,
	connectOrCreate?:ValueTypes["ReferenceListConnectOrCreateReferencesRelationInput"] | null,
	alias?:string | null
};
	["ReferenceWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	link?:string | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["ReferenceListConnectOrCreateReferencesRelationInput"]: {
	connect:ValueTypes["ReferenceUniqueWhere"],
	create:ValueTypes["ReferenceWithoutListCreateInput"]
};
	["ItemConnectOrCreateReferenceListRelationInput"]: {
	connect:ValueTypes["ReferenceListUniqueWhere"],
	create:ValueTypes["ReferenceListCreateInput"]
};
	["ItemCreateBlogPostEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateBlogPostRelationInput"] | null
};
	["BlogPostWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostCreateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostCreateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostCreateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostCreateItemCategoriesEntityRelationInput"][],
	image?:ValueTypes["BlogPostCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostCreateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostCreateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostCreateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostCreateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostCreateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostCreateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateImageRelationInput"] | null
};
	["BlogPostConnectOrCreateImageRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["BlogPostCreateReferenceListEntityRelationInput"]: {
	connect?:ValueTypes["ReferenceListUniqueWhere"] | null,
	create?:ValueTypes["ReferenceListCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateReferenceListRelationInput"] | null
};
	["BlogPostConnectOrCreateReferenceListRelationInput"]: {
	connect:ValueTypes["ReferenceListUniqueWhere"],
	create:ValueTypes["ReferenceListCreateInput"]
};
	["BlogPostCreateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutBlogPostsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateUserRelationInput"] | null
};
	["UserWithoutBlogPostsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["UserCreateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserCreateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserCreateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserCreateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserCreateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserCreateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserCreateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserCreateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserCreateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserCreateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserCreateBlogPostReviewReactionsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null,
	create?:ValueTypes["BlogPostReviewReactionWithoutUserCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateBlogPostReviewReactionsRelationInput"] | null,
	alias?:string | null
};
	["BlogPostReviewReactionWithoutUserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	sentiment?:ValueTypes["SentimentType"] | null,
	blogPostReview?:ValueTypes["BlogPostReviewReactionCreateBlogPostReviewEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewReactionCreateBlogPostReviewEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	create?:ValueTypes["BlogPostReviewWithoutBlogPostReviewReactionsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewReactionConnectOrCreateBlogPostReviewRelationInput"] | null
};
	["BlogPostReviewWithoutBlogPostReviewReactionsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPost?:ValueTypes["BlogPostReviewCreateBlogPostEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostReviewCreateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["BlogPostReviewCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["BlogPostReviewCreateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewCreateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutBlogPostReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewConnectOrCreateUserRelationInput"] | null
};
	["UserWithoutBlogPostReviewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["UserCreateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserCreateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	productReviews?:ValueTypes["UserCreateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserCreateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserCreateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserCreateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserCreateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserCreateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserCreateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserCreateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserCreateProductReviewReactionsEntityRelationInput"]: {
	connect?:ValueTypes["ProductReviewReactionUniqueWhere"] | null,
	create?:ValueTypes["ProductReviewReactionWithoutUserCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateProductReviewReactionsRelationInput"] | null,
	alias?:string | null
};
	["ProductReviewReactionWithoutUserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	sentiment?:ValueTypes["SentimentType"] | null,
	productReview?:ValueTypes["ProductReviewReactionCreateProductReviewEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewReactionCreateProductReviewEntityRelationInput"]: {
	connect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	create?:ValueTypes["ProductReviewWithoutProductReviewReactionsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewReactionConnectOrCreateProductReviewRelationInput"] | null
};
	["ProductReviewWithoutProductReviewReactionsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	score?:ValueTypes["ProductReviewCreateScoreEntityRelationInput"] | null,
	product?:ValueTypes["ProductReviewCreateProductEntityRelationInput"] | null,
	user?:ValueTypes["ProductReviewCreateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["ProductReviewCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["ProductReviewCreateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewCreateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutProductReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewConnectOrCreateUserRelationInput"] | null
};
	["UserWithoutProductReviewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["UserCreateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserCreateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserCreateBlogPostReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserCreateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserCreateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserCreateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserCreateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserCreateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserCreateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserCreateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserCreateBlogPostsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostWithoutUserCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateBlogPostsRelationInput"] | null,
	alias?:string | null
};
	["BlogPostWithoutUserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostCreateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostCreateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostCreateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostCreateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostCreateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostCreateReferenceListEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostCreateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostCreateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostCreateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostCreateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostCreateAdsEntityRelationInput"]: {
	connect?:ValueTypes["AdUniqueWhere"] | null,
	create?:ValueTypes["AdWithoutBlogPostsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateAdsRelationInput"] | null,
	alias?:string | null
};
	["AdUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	slug?:string | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	contentReferences?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["AdWithoutBlogPostsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["AdCreateImageEntityRelationInput"] | null,
	isBrandSectionVisible?:boolean | null,
	isBlogPostSectionVisible?:boolean | null,
	isIngredientSectionVisible?:boolean | null,
	isResultsVisible?:boolean | null,
	isSearchVisible?:boolean | null,
	itemCategories?:ValueTypes["AdCreateItemCategoriesEntityRelationInput"][],
	brands?:ValueTypes["AdCreateBrandsEntityRelationInput"][],
	isActive?:boolean | null,
	link?:string | null,
	note?:string | null,
	activeFrom?:ValueTypes["DateTime"] | null,
	activeUntil?:ValueTypes["DateTime"] | null,
	slug?:string | null,
	contentReferences?:ValueTypes["AdCreateContentReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AdCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["AdConnectOrCreateImageRelationInput"] | null
};
	["AdConnectOrCreateImageRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["AdCreateItemCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutAdsCreateInput"] | null,
	connectOrCreate?:ValueTypes["AdConnectOrCreateItemCategoriesRelationInput"] | null,
	alias?:string | null
};
	["ItemCategoryWithoutAdsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryCreateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryCreateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryCreateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryCreateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryCreateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryCreateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutItemCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateProductsRelationInput"] | null,
	alias?:string | null
};
	["ProductWithoutItemCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreateElementsEntityRelationInput"]: {
	connect?:ValueTypes["ElementOfProductUniqueWhere"] | null,
	create?:ValueTypes["ElementOfProductWithoutProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateElementsRelationInput"] | null,
	alias?:string | null
};
	["ElementOfProductWithoutProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	amount?:number | null,
	remoteId?:string | null,
	element?:ValueTypes["ElementOfProductCreateElementEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ElementOfProductCreateElementEntityRelationInput"]: {
	connect?:ValueTypes["ElementUniqueWhere"] | null,
	create?:ValueTypes["ElementWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ElementOfProductConnectOrCreateElementRelationInput"] | null
};
	["ElementWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	featureDependencies?:ValueTypes["ElementCreateFeatureDependenciesEntityRelationInput"][],
	suitabilityElements?:ValueTypes["ElementCreateSuitabilityElementsEntityRelationInput"][],
	remoteId?:string | null,
	unit?:string | null,
	filterOrder?:number | null,
	slug?:string | null,
	declensionSeventh?:string | null,
	_dummy_field_?:boolean | null
};
	["ElementCreateFeatureDependenciesEntityRelationInput"]: {
	connect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	create?:ValueTypes["ProductFeatureWithoutDependentElementCreateInput"] | null,
	connectOrCreate?:ValueTypes["ElementConnectOrCreateFeatureDependenciesRelationInput"] | null,
	alias?:string | null
};
	["ProductFeatureWithoutDependentElementCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	category?:ValueTypes["FeatureCategoryType"] | null,
	value?:ValueTypes["FeatureValueType"] | null,
	remoteId?:string | null,
	linkItem?:ValueTypes["ProductFeatureCreateLinkItemEntityRelationInput"] | null,
	dependentCategory?:ValueTypes["ProductFeatureCreateDependentCategoryEntityRelationInput"] | null,
	dependentSubCategory?:ValueTypes["ProductFeatureCreateDependentSubCategoryEntityRelationInput"] | null,
	dependentFlag?:ValueTypes["ProductFeatureCreateDependentFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFeatureCreateDependentCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutFeatureDependenciesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFeatureConnectOrCreateDependentCategoryRelationInput"] | null
};
	["ItemCategoryWithoutFeatureDependenciesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryCreateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryCreateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryCreateProductsEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryCreateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryCreateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryCreateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryCreateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryCreateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateImageRelationInput"] | null
};
	["ItemCategoryConnectOrCreateImageRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["ItemCategoryCreateAdsEntityRelationInput"]: {
	connect?:ValueTypes["AdUniqueWhere"] | null,
	create?:ValueTypes["AdWithoutItemCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateAdsRelationInput"] | null,
	alias?:string | null
};
	["AdWithoutItemCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["AdCreateImageEntityRelationInput"] | null,
	isBrandSectionVisible?:boolean | null,
	isBlogPostSectionVisible?:boolean | null,
	isIngredientSectionVisible?:boolean | null,
	isResultsVisible?:boolean | null,
	isSearchVisible?:boolean | null,
	blogPosts?:ValueTypes["AdCreateBlogPostsEntityRelationInput"][],
	brands?:ValueTypes["AdCreateBrandsEntityRelationInput"][],
	isActive?:boolean | null,
	link?:string | null,
	note?:string | null,
	activeFrom?:ValueTypes["DateTime"] | null,
	activeUntil?:ValueTypes["DateTime"] | null,
	slug?:string | null,
	contentReferences?:ValueTypes["AdCreateContentReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AdCreateBlogPostsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostWithoutAdsCreateInput"] | null,
	connectOrCreate?:ValueTypes["AdConnectOrCreateBlogPostsRelationInput"] | null,
	alias?:string | null
};
	["BlogPostWithoutAdsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostCreateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostCreateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostCreateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostCreateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostCreateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostCreateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostCreateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostCreateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostCreateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostCreateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateSeoRelationInput"] | null
};
	["SeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoCreateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoCreateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoCreateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoCreateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoCreateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoCreateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoCreateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoCreateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoCreateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoCreateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoCreateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateBrandsPageEntityRelationInput"]: {
	connect?:ValueTypes["BrandsPageUniqueWhere"] | null,
	create?:ValueTypes["BrandsPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateBrandsPageRelationInput"] | null
};
	["BrandsPageWithoutSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	redirects?:ValueTypes["BrandsPageCreateRedirectsEntityRelationInput"][],
	content?:ValueTypes["BrandsPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandsPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandsPageCreateRedirectsEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutBrandsPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandsPageConnectOrCreateRedirectsRelationInput"] | null,
	alias?:string | null
};
	["RedirectWithoutBrandsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectCreateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectCreateItemCategoryEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectCreateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectCreateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectCreateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectCreateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectCreateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateItemCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateItemCategoryRelationInput"] | null
};
	["ItemCategoryWithoutRedirectsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryCreateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryCreateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryCreateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryCreateAdsEntityRelationInput"][],
	slug?:string | null,
	declensionsFourth?:ValueTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryCreateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryCreateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryCreateFeatureDependenciesEntityRelationInput"]: {
	connect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	create?:ValueTypes["ProductFeatureWithoutDependentCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateFeatureDependenciesRelationInput"] | null,
	alias?:string | null
};
	["ProductFeatureWithoutDependentCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	category?:ValueTypes["FeatureCategoryType"] | null,
	value?:ValueTypes["FeatureValueType"] | null,
	remoteId?:string | null,
	linkItem?:ValueTypes["ProductFeatureCreateLinkItemEntityRelationInput"] | null,
	dependentElement?:ValueTypes["ProductFeatureCreateDependentElementEntityRelationInput"] | null,
	dependentSubCategory?:ValueTypes["ProductFeatureCreateDependentSubCategoryEntityRelationInput"] | null,
	dependentFlag?:ValueTypes["ProductFeatureCreateDependentFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFeatureCreateDependentSubCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryWithoutFeatureDependenciesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFeatureConnectOrCreateDependentSubCategoryRelationInput"] | null
};
	["ItemSubCategoryWithoutFeatureDependenciesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryCreateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryCreateProductsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryCreateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryCreateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryCreateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryCreateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryCreateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutSubCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateCategoryRelationInput"] | null
};
	["ItemCategoryWithoutSubCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	shortDescription?:string | null,
	blogPosts?:ValueTypes["ItemCategoryCreateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryCreateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryCreateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryCreateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryCreateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryCreateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryCreateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryCreateRedirectsEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutItemCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateRedirectsRelationInput"] | null,
	alias?:string | null
};
	["RedirectWithoutItemCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectCreateGenericPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectCreateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectCreateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectCreateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectCreateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectCreateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectCreateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateBrandsPageEntityRelationInput"]: {
	connect?:ValueTypes["BrandsPageUniqueWhere"] | null,
	create?:ValueTypes["BrandsPageWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateBrandsPageRelationInput"] | null
};
	["BrandsPageWithoutRedirectsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["BrandsPageCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["BrandsPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandsPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandsPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutBrandsPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandsPageConnectOrCreateSeoRelationInput"] | null
};
	["SeoWithoutBrandsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoCreateBlogPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoCreateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoCreateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoCreateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoCreateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoCreateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoCreateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoCreateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoCreateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoCreateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateComparatorPageEntityRelationInput"]: {
	connect?:ValueTypes["ComparatorPageUniqueWhere"] | null,
	create?:ValueTypes["ComparatorPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateComparatorPageRelationInput"] | null
};
	["ComparatorPageWithoutSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["ComparatorPageCreateRedirectsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ComparatorPageCreateRedirectsEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutComparatorPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ComparatorPageConnectOrCreateRedirectsRelationInput"] | null,
	alias?:string | null
};
	["RedirectWithoutComparatorPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectCreateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectCreateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectCreateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectCreateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectCreateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectCreateWizardPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectCreateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateBlogPageEntityRelationInput"]: {
	connect?:ValueTypes["BlogPageUniqueWhere"] | null,
	create?:ValueTypes["BlogPageWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateBlogPageRelationInput"] | null
};
	["BlogPageWithoutRedirectsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["BlogPageCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["BlogPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutBlogPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPageConnectOrCreateSeoRelationInput"] | null
};
	["SeoWithoutBlogPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoCreateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoCreateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoCreateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoCreateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoCreateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoCreateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoCreateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoCreateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoCreateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoCreateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateGenericPageEntityRelationInput"]: {
	connect?:ValueTypes["GenericPageUniqueWhere"] | null,
	create?:ValueTypes["GenericPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateGenericPageRelationInput"] | null
};
	["GenericPageWithoutSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["GenericPageCreateLinkEntityRelationInput"] | null,
	redirects?:ValueTypes["GenericPageCreateRedirectsEntityRelationInput"][],
	content?:ValueTypes["GenericPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["GenericPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GenericPageCreateRedirectsEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutGenericPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["GenericPageConnectOrCreateRedirectsRelationInput"] | null,
	alias?:string | null
};
	["RedirectWithoutGenericPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	to?:string | null,
	order?:number | null,
	from?:string | null,
	itemCategory?:ValueTypes["RedirectCreateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectCreateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectCreateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectCreateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectCreateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectCreateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectCreateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateContactPageEntityRelationInput"]: {
	connect?:ValueTypes["ContactPageUniqueWhere"] | null,
	create?:ValueTypes["ContactPageWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateContactPageRelationInput"] | null
};
	["ContactPageWithoutRedirectsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["ContactPageCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["ContactPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ContactPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutContactPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContactPageConnectOrCreateSeoRelationInput"] | null
};
	["SeoWithoutContactPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoCreateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoCreateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoCreateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoCreateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoCreateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoCreateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoCreateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoCreateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoCreateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoCreateWizardPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateHomePageEntityRelationInput"]: {
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	create?:ValueTypes["HomePageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateHomePageRelationInput"] | null
};
	["HomePageWithoutSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	lead?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoConnectOrCreateHomePageRelationInput"]: {
	connect:ValueTypes["HomePageUniqueWhere"],
	create:ValueTypes["HomePageWithoutSeoCreateInput"]
};
	["SeoCreateIngredientsPageEntityRelationInput"]: {
	connect?:ValueTypes["IngredientsPageUniqueWhere"] | null,
	create?:ValueTypes["IngredientsPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateIngredientsPageRelationInput"] | null
};
	["IngredientsPageWithoutSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	content?:ValueTypes["IngredientsPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["IngredientsPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["IngredientsPageCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["IngredientsPageConnectOrCreateContentRelationInput"] | null
};
	["IngredientsPageConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["IngredientsPageCreateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["IngredientsPageConnectOrCreateDraftRelationInput"] | null
};
	["IngredientsPageConnectOrCreateDraftRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["SeoConnectOrCreateIngredientsPageRelationInput"]: {
	connect:ValueTypes["IngredientsPageUniqueWhere"],
	create:ValueTypes["IngredientsPageWithoutSeoCreateInput"]
};
	["SeoCreateLoginPageEntityRelationInput"]: {
	connect?:ValueTypes["LoginPageUniqueWhere"] | null,
	create?:ValueTypes["LoginPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateLoginPageRelationInput"] | null
};
	["LoginPageWithoutSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["SeoConnectOrCreateLoginPageRelationInput"]: {
	connect:ValueTypes["LoginPageUniqueWhere"],
	create:ValueTypes["LoginPageWithoutSeoCreateInput"]
};
	["SeoCreateRegisterPageEntityRelationInput"]: {
	connect?:ValueTypes["RegisterPageUniqueWhere"] | null,
	create?:ValueTypes["RegisterPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateRegisterPageRelationInput"] | null
};
	["RegisterPageWithoutSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["SeoConnectOrCreateRegisterPageRelationInput"]: {
	connect:ValueTypes["RegisterPageUniqueWhere"],
	create:ValueTypes["RegisterPageWithoutSeoCreateInput"]
};
	["SeoCreateSearchPageEntityRelationInput"]: {
	connect?:ValueTypes["SearchPageUniqueWhere"] | null,
	create?:ValueTypes["SearchPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateSearchPageRelationInput"] | null
};
	["SearchPageWithoutSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["SeoConnectOrCreateSearchPageRelationInput"]: {
	connect:ValueTypes["SearchPageUniqueWhere"],
	create:ValueTypes["SearchPageWithoutSeoCreateInput"]
};
	["SeoCreateWizardPageEntityRelationInput"]: {
	connect?:ValueTypes["WizardPageUniqueWhere"] | null,
	create?:ValueTypes["WizardPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateWizardPageRelationInput"] | null
};
	["WizardPageWithoutSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["WizardPageCreateRedirectsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["WizardPageCreateRedirectsEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutWizardPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["WizardPageConnectOrCreateRedirectsRelationInput"] | null,
	alias?:string | null
};
	["RedirectWithoutWizardPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectCreateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectCreateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectCreateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectCreateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectCreateContactPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectCreateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectCreateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateComparatorPageEntityRelationInput"]: {
	connect?:ValueTypes["ComparatorPageUniqueWhere"] | null,
	create?:ValueTypes["ComparatorPageWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateComparatorPageRelationInput"] | null
};
	["ComparatorPageWithoutRedirectsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["ComparatorPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ComparatorPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutComparatorPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ComparatorPageConnectOrCreateSeoRelationInput"] | null
};
	["SeoWithoutComparatorPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoCreateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoCreateBrandsPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoCreateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoCreateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoCreateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoCreateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoCreateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoCreateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoCreateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoCreateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateContactPageEntityRelationInput"]: {
	connect?:ValueTypes["ContactPageUniqueWhere"] | null,
	create?:ValueTypes["ContactPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateContactPageRelationInput"] | null
};
	["ContactPageWithoutSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	redirects?:ValueTypes["ContactPageCreateRedirectsEntityRelationInput"][],
	content?:ValueTypes["ContactPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ContactPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactPageCreateRedirectsEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutContactPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContactPageConnectOrCreateRedirectsRelationInput"] | null,
	alias?:string | null
};
	["RedirectWithoutContactPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectCreateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectCreateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectCreateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectCreateBlogPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectCreateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectCreateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectCreateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateWizardPageEntityRelationInput"]: {
	connect?:ValueTypes["WizardPageUniqueWhere"] | null,
	create?:ValueTypes["WizardPageWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateWizardPageRelationInput"] | null
};
	["WizardPageWithoutRedirectsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["WizardPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["WizardPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutWizardPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["WizardPageConnectOrCreateSeoRelationInput"] | null
};
	["SeoWithoutWizardPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoCreateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoCreateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoCreateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoCreateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoCreateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoCreateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoCreateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoCreateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoCreateSearchPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoCreateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["WizardPageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoWithoutWizardPageCreateInput"]
};
	["RedirectConnectOrCreateWizardPageRelationInput"]: {
	connect:ValueTypes["WizardPageUniqueWhere"],
	create:ValueTypes["WizardPageWithoutRedirectsCreateInput"]
};
	["RedirectCreateBlogPostEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateBlogPostRelationInput"] | null
};
	["BlogPostWithoutRedirectsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostCreateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostCreateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostCreateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostCreateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostCreateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostCreateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostCreateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostCreateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostCreateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	automated?:boolean | null,
	content?:ValueTypes["BlogPostCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostCreateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateContentRelationInput"] | null
};
	["BlogPostConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["BlogPostCreateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateDraftRelationInput"] | null
};
	["BlogPostConnectOrCreateDraftRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["RedirectConnectOrCreateBlogPostRelationInput"]: {
	connect:ValueTypes["BlogPostUniqueWhere"],
	create:ValueTypes["BlogPostWithoutRedirectsCreateInput"]
};
	["ContactPageConnectOrCreateRedirectsRelationInput"]: {
	connect:ValueTypes["RedirectUniqueWhere"],
	create:ValueTypes["RedirectWithoutContactPageCreateInput"]
};
	["ContactPageCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContactPageConnectOrCreateContentRelationInput"] | null
};
	["ContactPageConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["ContactPageCreateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContactPageConnectOrCreateDraftRelationInput"] | null
};
	["ContactPageConnectOrCreateDraftRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["SeoConnectOrCreateContactPageRelationInput"]: {
	connect:ValueTypes["ContactPageUniqueWhere"],
	create:ValueTypes["ContactPageWithoutSeoCreateInput"]
};
	["ComparatorPageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoWithoutComparatorPageCreateInput"]
};
	["RedirectConnectOrCreateComparatorPageRelationInput"]: {
	connect:ValueTypes["ComparatorPageUniqueWhere"],
	create:ValueTypes["ComparatorPageWithoutRedirectsCreateInput"]
};
	["WizardPageConnectOrCreateRedirectsRelationInput"]: {
	connect:ValueTypes["RedirectUniqueWhere"],
	create:ValueTypes["RedirectWithoutWizardPageCreateInput"]
};
	["SeoConnectOrCreateWizardPageRelationInput"]: {
	connect:ValueTypes["WizardPageUniqueWhere"],
	create:ValueTypes["WizardPageWithoutSeoCreateInput"]
};
	["ContactPageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoWithoutContactPageCreateInput"]
};
	["RedirectConnectOrCreateContactPageRelationInput"]: {
	connect:ValueTypes["ContactPageUniqueWhere"],
	create:ValueTypes["ContactPageWithoutRedirectsCreateInput"]
};
	["GenericPageConnectOrCreateRedirectsRelationInput"]: {
	connect:ValueTypes["RedirectUniqueWhere"],
	create:ValueTypes["RedirectWithoutGenericPageCreateInput"]
};
	["GenericPageCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["GenericPageConnectOrCreateContentRelationInput"] | null
};
	["GenericPageConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["GenericPageCreateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["GenericPageConnectOrCreateDraftRelationInput"] | null
};
	["GenericPageConnectOrCreateDraftRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["SeoConnectOrCreateGenericPageRelationInput"]: {
	connect:ValueTypes["GenericPageUniqueWhere"],
	create:ValueTypes["GenericPageWithoutSeoCreateInput"]
};
	["BlogPageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoWithoutBlogPageCreateInput"]
};
	["BlogPageCreateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPageConnectOrCreateDraftRelationInput"] | null
};
	["BlogPageConnectOrCreateDraftRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["RedirectConnectOrCreateBlogPageRelationInput"]: {
	connect:ValueTypes["BlogPageUniqueWhere"],
	create:ValueTypes["BlogPageWithoutRedirectsCreateInput"]
};
	["ComparatorPageConnectOrCreateRedirectsRelationInput"]: {
	connect:ValueTypes["RedirectUniqueWhere"],
	create:ValueTypes["RedirectWithoutComparatorPageCreateInput"]
};
	["SeoConnectOrCreateComparatorPageRelationInput"]: {
	connect:ValueTypes["ComparatorPageUniqueWhere"],
	create:ValueTypes["ComparatorPageWithoutSeoCreateInput"]
};
	["BrandsPageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoWithoutBrandsPageCreateInput"]
};
	["BrandsPageCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandsPageConnectOrCreateContentRelationInput"] | null
};
	["BrandsPageConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["BrandsPageCreateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandsPageConnectOrCreateDraftRelationInput"] | null
};
	["BrandsPageConnectOrCreateDraftRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["RedirectConnectOrCreateBrandsPageRelationInput"]: {
	connect:ValueTypes["BrandsPageUniqueWhere"],
	create:ValueTypes["BrandsPageWithoutRedirectsCreateInput"]
};
	["ItemCategoryConnectOrCreateRedirectsRelationInput"]: {
	connect:ValueTypes["RedirectUniqueWhere"],
	create:ValueTypes["RedirectWithoutItemCategoryCreateInput"]
};
	["ItemCategoryCreateDeclensionsFourthEntityRelationInput"]: {
	connect?:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"] | null,
	create?:ValueTypes["ItemDeclensionFourthVariantWithoutCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateDeclensionsFourthRelationInput"] | null,
	alias?:string | null
};
	["ItemDeclensionFourthVariantWithoutCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ItemDeclensionFourthVariantCreateItemsEntityRelationInput"][],
	label?:string | null,
	remoteId?:string | null,
	declensionSeventh?:string | null,
	isNegativ?:boolean | null,
	seo?:ValueTypes["ItemDeclensionFourthVariantCreateSeoEntityRelationInput"] | null,
	subcategory?:ValueTypes["ItemDeclensionFourthVariantCreateSubcategoryEntityRelationInput"] | null,
	element?:ValueTypes["ItemDeclensionFourthVariantCreateElementEntityRelationInput"] | null,
	products?:ValueTypes["ItemDeclensionFourthVariantCreateProductsEntityRelationInput"][],
	slug?:string | null,
	content?:ValueTypes["ItemDeclensionFourthVariantCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemDeclensionFourthVariantCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionFourthVariantCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemWithoutDeclensionFourthCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateItemsRelationInput"] | null,
	alias?:string | null
};
	["ItemWithoutDeclensionFourthCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemCreateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemCreateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemCreateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemCreateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemCreateBlogPostEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemCreateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemCreateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemCreateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCreateDeclensionSeventhEntityRelationInput"]: {
	connect?:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"] | null,
	create?:ValueTypes["ItemDeclensionSeventhVariantWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateDeclensionSeventhRelationInput"] | null
};
	["ItemDeclensionSeventhVariantUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	items?:ValueTypes["ItemUniqueWhere"] | null
};
	["ItemDeclensionSeventhVariantWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:string | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemConnectOrCreateDeclensionSeventhRelationInput"]: {
	connect:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"],
	create:ValueTypes["ItemDeclensionSeventhVariantWithoutItemsCreateInput"]
};
	["ItemCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateSeoRelationInput"] | null
};
	["ItemConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoCreateInput"]
};
	["ItemCreateAliasesEntityRelationInput"]: {
	connect?:ValueTypes["ItemAliasUniqueWhere"] | null,
	create?:ValueTypes["ItemAliasWithoutItemCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateAliasesRelationInput"] | null,
	alias?:string | null
};
	["ItemAliasWithoutItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemConnectOrCreateAliasesRelationInput"]: {
	connect:ValueTypes["ItemAliasUniqueWhere"],
	create:ValueTypes["ItemAliasWithoutItemCreateInput"]
};
	["ItemCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateContentRelationInput"] | null
};
	["ItemConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["ItemCreateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateDraftRelationInput"] | null
};
	["ItemConnectOrCreateDraftRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["ItemDeclensionFourthVariantConnectOrCreateItemsRelationInput"]: {
	connect:ValueTypes["ItemUniqueWhere"],
	create:ValueTypes["ItemWithoutDeclensionFourthCreateInput"]
};
	["ItemDeclensionFourthVariantCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateSeoRelationInput"] | null
};
	["ItemDeclensionFourthVariantConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoCreateInput"]
};
	["ItemDeclensionFourthVariantCreateSubcategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateSubcategoryRelationInput"] | null
};
	["ItemSubCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryCreateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryCreateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryCreateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryCreateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryCreateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemFlavorCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemFlavorCategoryWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateFlavorCategoryRelationInput"] | null
};
	["ItemFlavorCategoryWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	remoteId?:string | null,
	color?:ValueTypes["ItemFlavorCategoryCreateColorEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemFlavorCategoryCreateColorEntityRelationInput"]: {
	connect?:ValueTypes["ColorUniqueWhere"] | null,
	create?:ValueTypes["ColorWithoutItemFlavorCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemFlavorCategoryConnectOrCreateColorRelationInput"] | null
};
	["ColorWithoutItemFlavorCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	colorHex?:string | null,
	bodyTagCategory?:ValueTypes["ColorCreateBodyTagCategoryEntityRelationInput"] | null,
	blogPostTag?:ValueTypes["ColorCreateBlogPostTagEntityRelationInput"] | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemFlavorCategoryConnectOrCreateColorRelationInput"]: {
	connect:ValueTypes["ColorUniqueWhere"],
	create:ValueTypes["ColorWithoutItemFlavorCategoriesCreateInput"]
};
	["ItemSubCategoryConnectOrCreateFlavorCategoryRelationInput"]: {
	connect:ValueTypes["ItemFlavorCategoryUniqueWhere"],
	create:ValueTypes["ItemFlavorCategoryWithoutItemsCreateInput"]
};
	["ItemSubCategoryCreateDogsEntityRelationInput"]: {
	connect?:ValueTypes["DogUniqueWhere"] | null,
	create?:ValueTypes["DogWithoutAllergiesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateDogsRelationInput"] | null,
	alias?:string | null
};
	["DogWithoutAllergiesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogCreateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogCreateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogCreateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogCreateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogCreateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogCreateReproductionEntityRelationInput"] | null,
	illnesses?:ValueTypes["DogCreateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogCreateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogCreateFedProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateFedProductRelationInput"] | null
};
	["ProductWithoutDogsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreateRecommendedDogSizesEntityRelationInput"]: {
	connect?:ValueTypes["DogSizeUniqueWhere"] | null,
	create?:ValueTypes["DogSizeWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateRecommendedDogSizesRelationInput"] | null,
	alias?:string | null
};
	["DogSizeUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	breeds?:ValueTypes["BreedUniqueWhere"] | null
};
	["DogSizeWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	breeds?:ValueTypes["DogSizeCreateBreedsEntityRelationInput"][],
	remoteId?:string | null,
	suitabilityCategory?:ValueTypes["DogSizeCreateSuitabilityCategoryEntityRelationInput"] | null,
	name?:ValueTypes["SizeType"] | null,
	label?:string | null,
	order?:number | null,
	isFilterVisible?:boolean | null,
	_dummy_field_?:boolean | null
};
	["DogSizeCreateBreedsEntityRelationInput"]: {
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	create?:ValueTypes["BreedWithoutSizeCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogSizeConnectOrCreateBreedsRelationInput"] | null,
	alias?:string | null
};
	["BreedWithoutSizeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["BreedCreateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedCreateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedCreateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedCreateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedCreateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedCreateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedCreateSuitabilityCategoryEntityRelationInput"]: {
	connect?:ValueTypes["SuitabilityCategoryUniqueWhere"] | null,
	create?:ValueTypes["SuitabilityCategoryWithoutBreedsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BreedConnectOrCreateSuitabilityCategoryRelationInput"] | null
};
	["SuitabilityCategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	dogSizes?:ValueTypes["DogSizeUniqueWhere"] | null,
	dogActivities?:ValueTypes["DogActivityUniqueWhere"] | null,
	breeds?:ValueTypes["BreedUniqueWhere"] | null,
	suitabilityItems?:ValueTypes["SuitabilityItemUniqueWhere"] | null
};
	["SuitabilityCategoryWithoutBreedsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	dogSizes?:ValueTypes["SuitabilityCategoryCreateDogSizesEntityRelationInput"][],
	dogActivities?:ValueTypes["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"][],
	suitabilityItems?:ValueTypes["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"][],
	dogAges?:ValueTypes["SuitabilityCategoryCreateDogAgesEntityRelationInput"][],
	isPregnant?:boolean | null,
	remoteId?:string | null,
	isBreastfeeding?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityCategoryCreateDogSizesEntityRelationInput"]: {
	connect?:ValueTypes["DogSizeUniqueWhere"] | null,
	create?:ValueTypes["DogSizeWithoutSuitabilityCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["SuitabilityCategoryConnectOrCreateDogSizesRelationInput"] | null,
	alias?:string | null
};
	["DogSizeWithoutSuitabilityCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	breeds?:ValueTypes["DogSizeCreateBreedsEntityRelationInput"][],
	remoteId?:string | null,
	products?:ValueTypes["DogSizeCreateProductsEntityRelationInput"][],
	name?:ValueTypes["SizeType"] | null,
	label?:string | null,
	order?:number | null,
	isFilterVisible?:boolean | null,
	_dummy_field_?:boolean | null
};
	["DogSizeCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutRecommendedDogSizesCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogSizeConnectOrCreateProductsRelationInput"] | null,
	alias?:string | null
};
	["ProductWithoutRecommendedDogSizesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreateGranuleSizesEntityRelationInput"]: {
	connect?:ValueTypes["GranuleSizeUniqueWhere"] | null,
	create?:ValueTypes["GranuleSizeWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateGranuleSizesRelationInput"] | null,
	alias?:string | null
};
	["GranuleSizeUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["GranuleSizeWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	name?:ValueTypes["GranuleSizeType"] | null,
	_dummy_field_?:boolean | null
};
	["ProductConnectOrCreateGranuleSizesRelationInput"]: {
	connect:ValueTypes["GranuleSizeUniqueWhere"],
	create:ValueTypes["GranuleSizeWithoutProductsCreateInput"]
};
	["ProductCreateProductLineEntityRelationInput"]: {
	connect?:ValueTypes["ProductLineUniqueWhere"] | null,
	create?:ValueTypes["ProductLineWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateProductLineRelationInput"] | null
};
	["ProductLineWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	remoteId?:string | null,
	lead?:string | null,
	order?:number | null,
	brand?:ValueTypes["ProductLineCreateBrandEntityRelationInput"] | null,
	logo?:ValueTypes["ProductLineCreateLogoEntityRelationInput"] | null,
	aliases?:ValueTypes["ProductLineCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["ProductLineCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["ProductLineCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductLineCreateBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutProductLinesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductLineConnectOrCreateBrandRelationInput"] | null
};
	["BrandUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	slug?:string | null,
	products?:ValueTypes["ProductUniqueWhere"] | null,
	productLines?:ValueTypes["ProductLineUniqueWhere"] | null,
	logo?:ValueTypes["ImageUniqueWhere"] | null,
	aliases?:ValueTypes["BrandAliasUniqueWhere"] | null,
	flavors?:ValueTypes["BrandFlavorUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	filterCombos?:ValueTypes["FilterComboUniqueWhere"] | null,
	topx?:ValueTypes["TOPXBrandUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["BrandWithoutProductLinesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["BrandCreateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandCreateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	logo?:ValueTypes["BrandCreateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandCreateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandCreateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandCreateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandCreateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandCreateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandCreateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutBrandCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateProductsRelationInput"] | null,
	alias?:string | null
};
	["ProductWithoutBrandCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreateFlagsEntityRelationInput"]: {
	connect?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null,
	create?:ValueTypes["ProductFlagOfProductWithoutProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateFlagsRelationInput"] | null,
	alias?:string | null
};
	["ProductFlagOfProductWithoutProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	value?:ValueTypes["ProductFlagValue"] | null,
	flag?:ValueTypes["ProductFlagOfProductCreateFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFlagOfProductCreateFlagEntityRelationInput"]: {
	connect?:ValueTypes["ProductFlagUniqueWhere"] | null,
	create?:ValueTypes["ProductFlagWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFlagOfProductConnectOrCreateFlagRelationInput"] | null
};
	["ProductFlagUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	productFeatures?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	products?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null
};
	["ProductFlagWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	productFeatures?:ValueTypes["ProductFlagCreateProductFeaturesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductFlagCreateProductFeaturesEntityRelationInput"]: {
	connect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	create?:ValueTypes["ProductFeatureWithoutDependentFlagCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFlagConnectOrCreateProductFeaturesRelationInput"] | null,
	alias?:string | null
};
	["ProductFeatureWithoutDependentFlagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	category?:ValueTypes["FeatureCategoryType"] | null,
	value?:ValueTypes["FeatureValueType"] | null,
	remoteId?:string | null,
	linkItem?:ValueTypes["ProductFeatureCreateLinkItemEntityRelationInput"] | null,
	dependentElement?:ValueTypes["ProductFeatureCreateDependentElementEntityRelationInput"] | null,
	dependentCategory?:ValueTypes["ProductFeatureCreateDependentCategoryEntityRelationInput"] | null,
	dependentSubCategory?:ValueTypes["ProductFeatureCreateDependentSubCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFlagConnectOrCreateProductFeaturesRelationInput"]: {
	connect:ValueTypes["ProductFeatureUniqueWhere"],
	create:ValueTypes["ProductFeatureWithoutDependentFlagCreateInput"]
};
	["ProductFlagOfProductConnectOrCreateFlagRelationInput"]: {
	connect:ValueTypes["ProductFlagUniqueWhere"],
	create:ValueTypes["ProductFlagWithoutProductsCreateInput"]
};
	["ProductConnectOrCreateFlagsRelationInput"]: {
	connect:ValueTypes["ProductFlagOfProductUniqueWhere"],
	create:ValueTypes["ProductFlagOfProductWithoutProductCreateInput"]
};
	["ProductCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateImageRelationInput"] | null
};
	["ProductConnectOrCreateImageRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["ProductCreateRecommendedActivityEntityRelationInput"]: {
	connect?:ValueTypes["DogActivityUniqueWhere"] | null,
	create?:ValueTypes["DogActivityWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateRecommendedActivityRelationInput"] | null
};
	["DogActivityWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:string | null,
	dogs?:ValueTypes["DogActivityCreateDogsEntityRelationInput"][],
	dailyEnergyRequirementCoeficient?:number | null,
	remoteId?:string | null,
	suitabilityCategory?:ValueTypes["DogActivityCreateSuitabilityCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogActivityCreateDogsEntityRelationInput"]: {
	connect?:ValueTypes["DogUniqueWhere"] | null,
	create?:ValueTypes["DogWithoutActivityCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogActivityConnectOrCreateDogsRelationInput"] | null,
	alias?:string | null
};
	["DogWithoutActivityCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogCreateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogCreateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogCreateOwnerEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogCreateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogCreateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogCreateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogCreateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogCreateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogCreateReproductionEntityRelationInput"]: {
	connect?:ValueTypes["DogReproductionUniqueWhere"] | null,
	create?:ValueTypes["DogReproductionWithoutDogCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateReproductionRelationInput"] | null
};
	["DogReproductionWithoutDogCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["DogReproductionType"] | null,
	breastfeedingPuppyCount?:number | null,
	pregnancy?:ValueTypes["PregnantPeriodType"] | null,
	breastfeedingCategory?:ValueTypes["DogReproductionCreateBreastfeedingCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogReproductionCreateBreastfeedingCategoryEntityRelationInput"]: {
	connect?:ValueTypes["BreastfeedingCategoryUniqueWhere"] | null,
	create?:ValueTypes["BreastfeedingCategoryWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogReproductionConnectOrCreateBreastfeedingCategoryRelationInput"] | null
};
	["BreastfeedingCategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["DogReproductionUniqueWhere"] | null
};
	["BreastfeedingCategoryWithoutDogsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	week?:number | null,
	coeficient?:number | null,
	_dummy_field_?:boolean | null
};
	["DogReproductionConnectOrCreateBreastfeedingCategoryRelationInput"]: {
	connect:ValueTypes["BreastfeedingCategoryUniqueWhere"],
	create:ValueTypes["BreastfeedingCategoryWithoutDogsCreateInput"]
};
	["DogConnectOrCreateReproductionRelationInput"]: {
	connect:ValueTypes["DogReproductionUniqueWhere"],
	create:ValueTypes["DogReproductionWithoutDogCreateInput"]
};
	["DogCreateAllergiesEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateAllergiesRelationInput"] | null,
	alias?:string | null
};
	["ItemSubCategoryWithoutDogsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryCreateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryCreateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"] | null,
	iconNegative?:ValueTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryCreateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryCreateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryCreateIconNegativeEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateIconNegativeRelationInput"] | null
};
	["ItemSubCategoryConnectOrCreateIconNegativeRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["ItemSubCategoryCreateIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateIconRelationInput"] | null
};
	["ItemSubCategoryConnectOrCreateIconRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["ItemSubCategoryCreateBrandsEntityRelationInput"]: {
	connect?:ValueTypes["BrandFlavorUniqueWhere"] | null,
	alias?:string | null
};
	["ItemSubCategoryCreateProductLinesEntityRelationInput"]: {
	connect?:ValueTypes["ProductLineFlavorUniqueWhere"] | null,
	alias?:string | null
};
	["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"]: {
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	create?:ValueTypes["FilterComboWithoutFlavorCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateFilterCombosFlavorRelationInput"] | null,
	alias?:string | null
};
	["FilterComboWithoutFlavorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboCreateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboCreateBreedEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboCreateBrandEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboCreateRegionEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboCreateAgeCategoryEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboCreateTreatmentEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboCreateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilterComboCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateSeoRelationInput"] | null
};
	["FilterComboConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoCreateInput"]
};
	["FilterComboCreateBreedEntityRelationInput"]: {
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	create?:ValueTypes["BreedWithoutFilterCombosCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateBreedRelationInput"] | null
};
	["BreedWithoutFilterCombosCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["BreedCreateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedCreateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedCreateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedCreateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedCreateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedCreateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedCreateSizeEntityRelationInput"] | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["BreedCreateProductReviewsEntityRelationInput"]: {
	connect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	create?:ValueTypes["ProductReviewWithoutBreedCreateInput"] | null,
	connectOrCreate?:ValueTypes["BreedConnectOrCreateProductReviewsRelationInput"] | null,
	alias?:string | null
};
	["ProductReviewWithoutBreedCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	productReviewReactions?:ValueTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"][],
	score?:ValueTypes["ProductReviewCreateScoreEntityRelationInput"] | null,
	product?:ValueTypes["ProductReviewCreateProductEntityRelationInput"] | null,
	user?:ValueTypes["ProductReviewCreateUserEntityRelationInput"] | null,
	fullName?:string | null,
	age?:ValueTypes["ProductReviewCreateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewCreateAgeEntityRelationInput"]: {
	connect?:ValueTypes["AgeUniqueWhere"] | null,
	create?:ValueTypes["AgeWithoutProductReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewConnectOrCreateAgeRelationInput"] | null
};
	["AgeWithoutProductReviewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["AgeCreateDogsEntityRelationInput"][],
	breeds?:ValueTypes["AgeCreateBreedsEntityRelationInput"][],
	ageRange?:ValueTypes["AgeRangeType"] | null,
	categoryLabel?:ValueTypes["AgeLabelType"] | null,
	suitabilityCategories?:ValueTypes["AgeCreateSuitabilityCategoriesEntityRelationInput"][],
	remoteId?:string | null,
	blogPostReviews?:ValueTypes["AgeCreateBlogPostReviewsEntityRelationInput"][],
	label?:string | null,
	categoryOrder?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeCreateSuitabilityCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["SuitabilityCategoryUniqueWhere"] | null,
	create?:ValueTypes["SuitabilityCategoryWithoutDogAgesCreateInput"] | null,
	connectOrCreate?:ValueTypes["AgeConnectOrCreateSuitabilityCategoriesRelationInput"] | null,
	alias?:string | null
};
	["SuitabilityCategoryWithoutDogAgesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	dogSizes?:ValueTypes["SuitabilityCategoryCreateDogSizesEntityRelationInput"][],
	dogActivities?:ValueTypes["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"][],
	breeds?:ValueTypes["SuitabilityCategoryCreateBreedsEntityRelationInput"][],
	suitabilityItems?:ValueTypes["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"][],
	isPregnant?:boolean | null,
	remoteId?:string | null,
	isBreastfeeding?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"]: {
	connect?:ValueTypes["DogActivityUniqueWhere"] | null,
	create?:ValueTypes["DogActivityWithoutSuitabilityCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["SuitabilityCategoryConnectOrCreateDogActivitiesRelationInput"] | null,
	alias?:string | null
};
	["DogActivityWithoutSuitabilityCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:string | null,
	dogs?:ValueTypes["DogActivityCreateDogsEntityRelationInput"][],
	products?:ValueTypes["DogActivityCreateProductsEntityRelationInput"][],
	dailyEnergyRequirementCoeficient?:number | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityCategoryConnectOrCreateDogActivitiesRelationInput"]: {
	connect:ValueTypes["DogActivityUniqueWhere"],
	create:ValueTypes["DogActivityWithoutSuitabilityCategoryCreateInput"]
};
	["SuitabilityCategoryCreateBreedsEntityRelationInput"]: {
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	create?:ValueTypes["BreedWithoutSuitabilityCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["SuitabilityCategoryConnectOrCreateBreedsRelationInput"] | null,
	alias?:string | null
};
	["BreedWithoutSuitabilityCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["BreedCreateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedCreateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedCreateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	productReviews?:ValueTypes["BreedCreateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedCreateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedCreateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedCreateBlogPostReviewsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	create?:ValueTypes["BlogPostReviewWithoutBreedCreateInput"] | null,
	connectOrCreate?:ValueTypes["BreedConnectOrCreateBlogPostReviewsRelationInput"] | null,
	alias?:string | null
};
	["BlogPostReviewWithoutBreedCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"][],
	blogPost?:ValueTypes["BlogPostReviewCreateBlogPostEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostReviewCreateUserEntityRelationInput"] | null,
	fullName?:string | null,
	age?:ValueTypes["BlogPostReviewCreateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewCreateAgeEntityRelationInput"]: {
	connect?:ValueTypes["AgeUniqueWhere"] | null,
	create?:ValueTypes["AgeWithoutBlogPostReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewConnectOrCreateAgeRelationInput"] | null
};
	["AgeWithoutBlogPostReviewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["AgeCreateDogsEntityRelationInput"][],
	breeds?:ValueTypes["AgeCreateBreedsEntityRelationInput"][],
	ageRange?:ValueTypes["AgeRangeType"] | null,
	categoryLabel?:ValueTypes["AgeLabelType"] | null,
	suitabilityCategories?:ValueTypes["AgeCreateSuitabilityCategoriesEntityRelationInput"][],
	remoteId?:string | null,
	productReviews?:ValueTypes["AgeCreateProductReviewsEntityRelationInput"][],
	label?:string | null,
	categoryOrder?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeCreateProductReviewsEntityRelationInput"]: {
	connect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	create?:ValueTypes["ProductReviewWithoutAgeCreateInput"] | null,
	connectOrCreate?:ValueTypes["AgeConnectOrCreateProductReviewsRelationInput"] | null,
	alias?:string | null
};
	["ProductReviewWithoutAgeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	productReviewReactions?:ValueTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"][],
	score?:ValueTypes["ProductReviewCreateScoreEntityRelationInput"] | null,
	product?:ValueTypes["ProductReviewCreateProductEntityRelationInput"] | null,
	user?:ValueTypes["ProductReviewCreateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["ProductReviewCreateBreedEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewCreateBreedEntityRelationInput"]: {
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	create?:ValueTypes["BreedWithoutProductReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewConnectOrCreateBreedRelationInput"] | null
};
	["BreedWithoutProductReviewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["BreedCreateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedCreateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedCreateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedCreateSuitabilityCategoryEntityRelationInput"] | null,
	blogPostReviews?:ValueTypes["BreedCreateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedCreateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedCreateSizeEntityRelationInput"]: {
	connect?:ValueTypes["DogSizeUniqueWhere"] | null,
	create?:ValueTypes["DogSizeWithoutBreedsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BreedConnectOrCreateSizeRelationInput"] | null
};
	["DogSizeWithoutBreedsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	products?:ValueTypes["DogSizeCreateProductsEntityRelationInput"][],
	suitabilityCategory?:ValueTypes["DogSizeCreateSuitabilityCategoryEntityRelationInput"] | null,
	name?:ValueTypes["SizeType"] | null,
	label?:string | null,
	order?:number | null,
	isFilterVisible?:boolean | null,
	_dummy_field_?:boolean | null
};
	["DogSizeCreateSuitabilityCategoryEntityRelationInput"]: {
	connect?:ValueTypes["SuitabilityCategoryUniqueWhere"] | null,
	create?:ValueTypes["SuitabilityCategoryWithoutDogSizesCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogSizeConnectOrCreateSuitabilityCategoryRelationInput"] | null
};
	["SuitabilityCategoryWithoutDogSizesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	dogActivities?:ValueTypes["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"][],
	breeds?:ValueTypes["SuitabilityCategoryCreateBreedsEntityRelationInput"][],
	suitabilityItems?:ValueTypes["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"][],
	dogAges?:ValueTypes["SuitabilityCategoryCreateDogAgesEntityRelationInput"][],
	isPregnant?:boolean | null,
	remoteId?:string | null,
	isBreastfeeding?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"]: {
	connect?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	create?:ValueTypes["SuitabilityItemWithoutCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["SuitabilityCategoryConnectOrCreateSuitabilityItemsRelationInput"] | null,
	alias?:string | null
};
	["SuitabilityItemWithoutCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	min?:number | null,
	max?:number | null,
	remoteId?:string | null,
	order?:number | null,
	element?:ValueTypes["SuitabilityItemCreateElementEntityRelationInput"] | null,
	nutritionalValue?:ValueTypes["SuitabilityItemCreateNutritionalValueEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityCategoryConnectOrCreateSuitabilityItemsRelationInput"]: {
	connect:ValueTypes["SuitabilityItemUniqueWhere"],
	create:ValueTypes["SuitabilityItemWithoutCategoryCreateInput"]
};
	["SuitabilityCategoryCreateDogAgesEntityRelationInput"]: {
	connect?:ValueTypes["AgeUniqueWhere"] | null,
	create?:ValueTypes["AgeWithoutSuitabilityCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["SuitabilityCategoryConnectOrCreateDogAgesRelationInput"] | null,
	alias?:string | null
};
	["AgeWithoutSuitabilityCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["AgeCreateDogsEntityRelationInput"][],
	breeds?:ValueTypes["AgeCreateBreedsEntityRelationInput"][],
	ageRange?:ValueTypes["AgeRangeType"] | null,
	categoryLabel?:ValueTypes["AgeLabelType"] | null,
	remoteId?:string | null,
	productReviews?:ValueTypes["AgeCreateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["AgeCreateBlogPostReviewsEntityRelationInput"][],
	label?:string | null,
	categoryOrder?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeCreateBlogPostReviewsEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	create?:ValueTypes["BlogPostReviewWithoutAgeCreateInput"] | null,
	connectOrCreate?:ValueTypes["AgeConnectOrCreateBlogPostReviewsRelationInput"] | null,
	alias?:string | null
};
	["BlogPostReviewWithoutAgeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"][],
	blogPost?:ValueTypes["BlogPostReviewCreateBlogPostEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostReviewCreateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["BlogPostReviewCreateBreedEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewCreateBreedEntityRelationInput"]: {
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	create?:ValueTypes["BreedWithoutBlogPostReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewConnectOrCreateBreedRelationInput"] | null
};
	["BreedWithoutBlogPostReviewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["BreedCreateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedCreateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedCreateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedCreateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedCreateProductReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedCreateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedCreateFilterCombosEntityRelationInput"]: {
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	create?:ValueTypes["FilterComboWithoutBreedCreateInput"] | null,
	connectOrCreate?:ValueTypes["BreedConnectOrCreateFilterCombosRelationInput"] | null,
	alias?:string | null
};
	["FilterComboWithoutBreedCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboCreateSeoEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboCreateBrandEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboCreateRegionEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboCreateAgeCategoryEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboCreateTreatmentEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboCreateFlavorEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboCreateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilterComboCreateBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutFilterCombosCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateBrandRelationInput"] | null
};
	["BrandWithoutFilterCombosCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["BrandCreateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandCreateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandCreateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandCreateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandCreateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandCreateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandCreateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandCreateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	topx?:ValueTypes["BrandCreateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandCreateCountriesOfProductionEntityRelationInput"]: {
	connect?:ValueTypes["CountryUniqueWhere"] | null,
	create?:ValueTypes["CountryWithoutBrandsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateCountriesOfProductionRelationInput"] | null,
	alias?:string | null
};
	["CountryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	manufacturers?:ValueTypes["BrandManufacturerUniqueWhere"] | null
};
	["CountryWithoutBrandsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	manufacturers?:ValueTypes["CountryCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	region?:ValueTypes["CountryCreateRegionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["CountryCreateManufacturersEntityRelationInput"]: {
	connect?:ValueTypes["BrandManufacturerUniqueWhere"] | null,
	create?:ValueTypes["BrandManufacturerWithoutResidenceCreateInput"] | null,
	connectOrCreate?:ValueTypes["CountryConnectOrCreateManufacturersRelationInput"] | null,
	alias?:string | null
};
	["BrandManufacturerWithoutResidenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	link?:string | null,
	brands?:ValueTypes["BrandManufacturerCreateBrandsEntityRelationInput"][],
	order?:number | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["BrandManufacturerCreateBrandsEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutManufacturersCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandManufacturerConnectOrCreateBrandsRelationInput"] | null,
	alias?:string | null
};
	["BrandWithoutManufacturersCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["BrandCreateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandCreateCountriesOfProductionEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandCreateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandCreateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandCreateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandCreateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandCreateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandCreateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandCreateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandCreateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandCreateProductLinesEntityRelationInput"]: {
	connect?:ValueTypes["ProductLineUniqueWhere"] | null,
	create?:ValueTypes["ProductLineWithoutBrandCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateProductLinesRelationInput"] | null,
	alias?:string | null
};
	["ProductLineWithoutBrandCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["ProductLineCreateProductsEntityRelationInput"][],
	remoteId?:string | null,
	lead?:string | null,
	order?:number | null,
	logo?:ValueTypes["ProductLineCreateLogoEntityRelationInput"] | null,
	aliases?:ValueTypes["ProductLineCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["ProductLineCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["ProductLineCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductLineCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutProductLineCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductLineConnectOrCreateProductsRelationInput"] | null,
	alias?:string | null
};
	["ProductWithoutProductLineCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreateBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateBrandRelationInput"] | null
};
	["BrandWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandCreateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandCreateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandCreateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandCreateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandCreateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandCreateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandCreateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandCreateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandCreateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandCreateManufacturersEntityRelationInput"]: {
	connect?:ValueTypes["BrandManufacturerUniqueWhere"] | null,
	create?:ValueTypes["BrandManufacturerWithoutBrandsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateManufacturersRelationInput"] | null,
	alias?:string | null
};
	["BrandManufacturerWithoutBrandsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	link?:string | null,
	order?:number | null,
	remoteId?:string | null,
	residence?:ValueTypes["BrandManufacturerCreateResidenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandManufacturerCreateResidenceEntityRelationInput"]: {
	connect?:ValueTypes["CountryUniqueWhere"] | null,
	create?:ValueTypes["CountryWithoutManufacturersCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandManufacturerConnectOrCreateResidenceRelationInput"] | null
};
	["CountryWithoutManufacturersCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	brands?:ValueTypes["CountryCreateBrandsEntityRelationInput"][],
	remoteId?:string | null,
	region?:ValueTypes["CountryCreateRegionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["CountryCreateBrandsEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutCountriesOfProductionCreateInput"] | null,
	connectOrCreate?:ValueTypes["CountryConnectOrCreateBrandsRelationInput"] | null,
	alias?:string | null
};
	["BrandWithoutCountriesOfProductionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["BrandCreateProductsEntityRelationInput"][],
	link?:string | null,
	manufacturers?:ValueTypes["BrandCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandCreateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandCreateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandCreateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandCreateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandCreateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandCreateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandCreateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandCreateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateLogoRelationInput"] | null
};
	["BrandConnectOrCreateLogoRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["BrandCreateMethodOfProductionEntityRelationInput"]: {
	connect?:ValueTypes["ProductionMethodUniqueWhere"] | null,
	create?:ValueTypes["ProductionMethodWithoutBrandsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateMethodOfProductionRelationInput"] | null
};
	["ProductionMethodUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	brands?:ValueTypes["BrandUniqueWhere"] | null
};
	["ProductionMethodWithoutBrandsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["BrandConnectOrCreateMethodOfProductionRelationInput"]: {
	connect:ValueTypes["ProductionMethodUniqueWhere"],
	create:ValueTypes["ProductionMethodWithoutBrandsCreateInput"]
};
	["BrandCreateDistributorEntityRelationInput"]: {
	connect?:ValueTypes["BrandDistributorUniqueWhere"] | null,
	create?:ValueTypes["BrandDistributorWithoutBrandsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateDistributorRelationInput"] | null
};
	["BrandDistributorUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	brands?:ValueTypes["BrandUniqueWhere"] | null
};
	["BrandDistributorWithoutBrandsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	link?:string | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["BrandConnectOrCreateDistributorRelationInput"]: {
	connect:ValueTypes["BrandDistributorUniqueWhere"],
	create:ValueTypes["BrandDistributorWithoutBrandsCreateInput"]
};
	["BrandCreateAliasesEntityRelationInput"]: {
	connect?:ValueTypes["BrandAliasUniqueWhere"] | null,
	create?:ValueTypes["BrandAliasWithoutBrandCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateAliasesRelationInput"] | null,
	alias?:string | null
};
	["BrandAliasWithoutBrandCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["BrandConnectOrCreateAliasesRelationInput"]: {
	connect:ValueTypes["BrandAliasUniqueWhere"],
	create:ValueTypes["BrandAliasWithoutBrandCreateInput"]
};
	["BrandCreateAdsEntityRelationInput"]: {
	connect?:ValueTypes["AdUniqueWhere"] | null,
	create?:ValueTypes["AdWithoutBrandsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateAdsRelationInput"] | null,
	alias?:string | null
};
	["AdWithoutBrandsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["AdCreateImageEntityRelationInput"] | null,
	isBrandSectionVisible?:boolean | null,
	isBlogPostSectionVisible?:boolean | null,
	isIngredientSectionVisible?:boolean | null,
	isResultsVisible?:boolean | null,
	isSearchVisible?:boolean | null,
	blogPosts?:ValueTypes["AdCreateBlogPostsEntityRelationInput"][],
	itemCategories?:ValueTypes["AdCreateItemCategoriesEntityRelationInput"][],
	isActive?:boolean | null,
	link?:string | null,
	note?:string | null,
	activeFrom?:ValueTypes["DateTime"] | null,
	activeUntil?:ValueTypes["DateTime"] | null,
	slug?:string | null,
	contentReferences?:ValueTypes["AdCreateContentReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AdCreateContentReferencesEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutAdCreateInput"] | null,
	connectOrCreate?:ValueTypes["AdConnectOrCreateContentReferencesRelationInput"] | null,
	alias?:string | null
};
	["ContentReferenceWithoutAdCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fact?:string | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	relatedBlogPost?:ValueTypes["ContentReferenceCreateRelatedBlogPostEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceCreateRelatedBrandEntityRelationInput"] | null,
	relatedProduct?:ValueTypes["ContentReferenceCreateRelatedProductEntityRelationInput"] | null,
	relatedIngredient?:ValueTypes["ContentReferenceCreateRelatedIngredientEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	badge?:string | null,
	longVersion?:boolean | null,
	relatedBrandFull?:ValueTypes["ContentReferenceCreateRelatedBrandFullEntityRelationInput"] | null,
	relatedProductFull?:ValueTypes["ContentReferenceCreateRelatedProductFullEntityRelationInput"] | null,
	list?:ValueTypes["ContentReferenceCreateListEntityRelationInput"][],
	outline?:ValueTypes["ContentReferenceCreateOutlineEntityRelationInput"] | null,
	video?:ValueTypes["ContentReferenceCreateVideoEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	defaultOpen?:boolean | null,
	badgeColor?:string | null,
	isMain?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | null
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockCreateContentEntityRelationInput"] | null,
	automatedContentBlockSlug?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentBlockConnectOrCreateContentRelationInput"] | null
};
	["ContentWithoutBlocksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceConnectOrCreateBlockRelationInput"]: {
	connect:ValueTypes["ContentBlockUniqueWhere"],
	create:ValueTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceCreateRelatedBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateRelatedBrandRelationInput"] | null
};
	["BrandCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["BrandCreateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandCreateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandCreateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandCreateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandCreateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandCreateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandCreateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandCreateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandCreateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandCreateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandCreateFlavorsEntityRelationInput"]: {
	connect?:ValueTypes["BrandFlavorUniqueWhere"] | null,
	alias?:string | null
};
	["BrandCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateSeoRelationInput"] | null
};
	["BrandConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoCreateInput"]
};
	["BrandCreateFilterCombosEntityRelationInput"]: {
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	create?:ValueTypes["FilterComboWithoutBrandCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateFilterCombosRelationInput"] | null,
	alias?:string | null
};
	["FilterComboWithoutBrandCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboCreateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboCreateBreedEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboCreateRegionEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboCreateAgeCategoryEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboCreateTreatmentEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboCreateFlavorEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboCreateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilterComboCreateRegionEntityRelationInput"]: {
	connect?:ValueTypes["RegionUniqueWhere"] | null,
	create?:ValueTypes["RegionWithoutFilterCombosCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateRegionRelationInput"] | null
};
	["RegionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	countries?:ValueTypes["CountryUniqueWhere"] | null,
	filterCombos?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["RegionWithoutFilterCombosCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	countries?:ValueTypes["RegionCreateCountriesEntityRelationInput"][],
	remoteId?:string | null,
	adjective?:string | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["RegionCreateCountriesEntityRelationInput"]: {
	connect?:ValueTypes["CountryUniqueWhere"] | null,
	create?:ValueTypes["CountryWithoutRegionCreateInput"] | null,
	connectOrCreate?:ValueTypes["RegionConnectOrCreateCountriesRelationInput"] | null,
	alias?:string | null
};
	["CountryWithoutRegionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	brands?:ValueTypes["CountryCreateBrandsEntityRelationInput"][],
	manufacturers?:ValueTypes["CountryCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["RegionConnectOrCreateCountriesRelationInput"]: {
	connect:ValueTypes["CountryUniqueWhere"],
	create:ValueTypes["CountryWithoutRegionCreateInput"]
};
	["FilterComboConnectOrCreateRegionRelationInput"]: {
	connect:ValueTypes["RegionUniqueWhere"],
	create:ValueTypes["RegionWithoutFilterCombosCreateInput"]
};
	["FilterComboCreateAgeCategoryEntityRelationInput"]: {
	connect?:ValueTypes["AgeCategoryUniqueWhere"] | null,
	create?:ValueTypes["AgeCategoryWithoutFilterCombosCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateAgeCategoryRelationInput"] | null
};
	["AgeCategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["FilterComboUniqueWhere"] | null
};
	["AgeCategoryWithoutFilterCombosCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	order?:number | null,
	labelFor?:string | null,
	products?:ValueTypes["AgeCategoryCreateProductsEntityRelationInput"][],
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeCategoryCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutAgeCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["AgeCategoryConnectOrCreateProductsRelationInput"] | null,
	alias?:string | null
};
	["ProductWithoutAgeCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreateAliasesEntityRelationInput"]: {
	connect?:ValueTypes["ProductAliasUniqueWhere"] | null,
	create?:ValueTypes["ProductAliasWithoutProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateAliasesRelationInput"] | null,
	alias?:string | null
};
	["ProductAliasWithoutProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductConnectOrCreateAliasesRelationInput"]: {
	connect:ValueTypes["ProductAliasUniqueWhere"],
	create:ValueTypes["ProductAliasWithoutProductCreateInput"]
};
	["ProductCreateEvaluationEntityRelationInput"]: {
	connect?:ValueTypes["ProductEvaluationUniqueWhere"] | null,
	create?:ValueTypes["ProductEvaluationWithoutProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateEvaluationRelationInput"] | null
};
	["ProductEvaluationWithoutProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nazev?:string | null,
	vetDieta?:string | null,
	vetDieta1?:string | null,
	vetDieta2?:string | null,
	aktivita?:string | null,
	vek?:string | null,
	velikostPlemen?:string | null,
	hmotnostPlemene?:string | null,
	velikostGranuli?:string | null,
	velikostGranuliText?:string | null,
	doporucenaAktivitaDleMe?:string | null,
	vypocitanaMeVsMeVyrobce?:string | null,
	vypocitanaMeVsMeVyrobce2?:string | null,
	masoNaPrvnimMisteText?:string | null,
	zdrojeZivocisnychBilkovinDle1Vyskytu?:string | null,
	prichuteSeznam?:string | null,
	eliminacniDietaTextInterpunkce?:string | null,
	alergenyZadneNeobsahuje?:string | null,
	alergenyObsahuje?:string | null,
	alergenyNejakeNeobsahuje?:string | null,
	prospesneDruhyInterpunkce?:string | null,
	nevhodneDruhy?:string | null,
	kladneUcinkyCeleTelo?:string | null,
	kladneUcinkyHlava?:string | null,
	kladneUcinkyHrudnik?:string | null,
	kladneUcinkyBricho?:string | null,
	kladneUcinkySpodniCast?:string | null,
	zaporneUcinkyCeleTelo?:string | null,
	zaporneUcinkyHlava?:string | null,
	zaporneUcinkyHrudnik?:string | null,
	zaporneUcinkyBricho?:string | null,
	zaporneUcinkySpodniCast?:string | null,
	dsneuvedeno?:string | null,
	dsmalo?:string | null,
	dsprilis?:string | null,
	dsok?:string | null,
	d95malo?:string | null,
	d95prilis?:string | null,
	d95ok?:string | null,
	d110malo?:string | null,
	d110prilis?:string | null,
	d110ok?:string | null,
	sdo14reproMalo?:string | null,
	sdo14reproPrilis?:string | null,
	sdo14reproOk?:string | null,
	sdo15malo?:string | null,
	sdo15prilis?:string | null,
	sdo15ok?:string | null,
	s15malo?:string | null,
	s15prilis?:string | null,
	s15ok?:string | null,
	masoAnoNe?:string | null,
	eliminacniDietaAnoNe?:string | null,
	alergenyAnoNe?:string | null,
	plodnostKastraceNadpis?:string | null,
	plodnostKastraceText?:string | null,
	remoteId?:string | null,
	stravitelnostNadpis?:string | null,
	stravitelnostProcenta?:string | null,
	stravitelnostSlovne?:string | null,
	stravitelnostChybiText?:string | null,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductConnectOrCreateEvaluationRelationInput"]: {
	connect:ValueTypes["ProductEvaluationUniqueWhere"],
	create:ValueTypes["ProductEvaluationWithoutProductCreateInput"]
};
	["ProductCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateSeoRelationInput"] | null
};
	["ProductConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoCreateInput"]
};
	["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ProductCreateHeurekaImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateHeurekaImageRelationInput"] | null
};
	["ProductConnectOrCreateHeurekaImageRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["ProductCreateTopxEntityRelationInput"]: {
	connect?:ValueTypes["TOPXProductUniqueWhere"] | null,
	create?:ValueTypes["TOPXProductWithoutProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateTopxRelationInput"] | null,
	alias?:string | null
};
	["TOPXProductWithoutProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	order?:number | null,
	orderType?:ValueTypes["TOPXProductOrderType"] | null,
	category?:ValueTypes["TOPXProductCreateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXProductCreateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["TOPXProductCategoryUniqueWhere"] | null,
	create?:ValueTypes["TOPXProductCategoryWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["TOPXProductConnectOrCreateCategoryRelationInput"] | null
};
	["TOPXProductCategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	products?:ValueTypes["TOPXProductUniqueWhere"] | null
};
	["TOPXProductCategoryWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["TOPXProductConnectOrCreateCategoryRelationInput"]: {
	connect:ValueTypes["TOPXProductCategoryUniqueWhere"],
	create:ValueTypes["TOPXProductCategoryWithoutProductsCreateInput"]
};
	["ProductConnectOrCreateTopxRelationInput"]: {
	connect:ValueTypes["TOPXProductUniqueWhere"],
	create:ValueTypes["TOPXProductWithoutProductCreateInput"]
};
	["AgeCategoryConnectOrCreateProductsRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutAgeCategoriesCreateInput"]
};
	["FilterComboConnectOrCreateAgeCategoryRelationInput"]: {
	connect:ValueTypes["AgeCategoryUniqueWhere"],
	create:ValueTypes["AgeCategoryWithoutFilterCombosCreateInput"]
};
	["FilterComboCreateTreatmentEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	create?:ValueTypes["BodyTagWithoutFilterCombosCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateTreatmentRelationInput"] | null
};
	["BodyTagWithoutFilterCombosCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagCreateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagCreatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagCreateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagCreatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagCreateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagCreateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagCreateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagCreateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["BodyTagCreateIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagConnectOrCreateIconRelationInput"] | null
};
	["BodyTagConnectOrCreateIconRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["BodyTagCreateDogsEntityRelationInput"]: {
	connect?:ValueTypes["DogUniqueWhere"] | null,
	create?:ValueTypes["DogWithoutIllnessesCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagConnectOrCreateDogsRelationInput"] | null,
	alias?:string | null
};
	["DogWithoutIllnessesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogCreateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogCreateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogCreateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogCreateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogCreateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogCreateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogCreateAllergiesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogCreateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogCreateAvatarEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateAvatarRelationInput"] | null
};
	["DogConnectOrCreateAvatarRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["BodyTagConnectOrCreateDogsRelationInput"]: {
	connect:ValueTypes["DogUniqueWhere"],
	create:ValueTypes["DogWithoutIllnessesCreateInput"]
};
	["FilterComboConnectOrCreateTreatmentRelationInput"]: {
	connect:ValueTypes["BodyTagUniqueWhere"],
	create:ValueTypes["BodyTagWithoutFilterCombosCreateInput"]
};
	["FilterComboCreateFlavorEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryWithoutFilterCombosFlavorCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateFlavorRelationInput"] | null
};
	["ItemSubCategoryWithoutFilterCombosFlavorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryCreateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryCreateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryCreateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryCreateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryCreateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosAllergy?:ValueTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"]: {
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	create?:ValueTypes["FilterComboWithoutAllergyCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateFilterCombosAllergyRelationInput"] | null,
	alias?:string | null
};
	["FilterComboWithoutAllergyCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboCreateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboCreateBreedEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboCreateBrandEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboCreateRegionEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboCreateAgeCategoryEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboCreateTreatmentEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboCreateFlavorEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryConnectOrCreateFilterCombosAllergyRelationInput"]: {
	connect:ValueTypes["FilterComboUniqueWhere"],
	create:ValueTypes["FilterComboWithoutAllergyCreateInput"]
};
	["FilterComboConnectOrCreateFlavorRelationInput"]: {
	connect:ValueTypes["ItemSubCategoryUniqueWhere"],
	create:ValueTypes["ItemSubCategoryWithoutFilterCombosFlavorCreateInput"]
};
	["FilterComboCreateAllergyEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryWithoutFilterCombosAllergyCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateAllergyRelationInput"] | null
};
	["ItemSubCategoryWithoutFilterCombosAllergyCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryCreateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryCreateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryCreateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryCreateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryCreateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["FilterComboConnectOrCreateAllergyRelationInput"]: {
	connect:ValueTypes["ItemSubCategoryUniqueWhere"],
	create:ValueTypes["ItemSubCategoryWithoutFilterCombosAllergyCreateInput"]
};
	["BrandConnectOrCreateFilterCombosRelationInput"]: {
	connect:ValueTypes["FilterComboUniqueWhere"],
	create:ValueTypes["FilterComboWithoutBrandCreateInput"]
};
	["BrandCreateTopxEntityRelationInput"]: {
	connect?:ValueTypes["TOPXBrandUniqueWhere"] | null,
	create?:ValueTypes["TOPXBrandWithoutBrandCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateTopxRelationInput"] | null,
	alias?:string | null
};
	["TOPXBrandWithoutBrandCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	order?:number | null,
	orderType?:ValueTypes["TOPXBrandOrderType"] | null,
	category?:ValueTypes["TOPXBrandCreateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXBrandCreateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["TOPXBrandCategoryUniqueWhere"] | null,
	create?:ValueTypes["TOPXBrandCategoryWithoutBrandsCreateInput"] | null,
	connectOrCreate?:ValueTypes["TOPXBrandConnectOrCreateCategoryRelationInput"] | null
};
	["TOPXBrandCategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	brands?:ValueTypes["TOPXBrandUniqueWhere"] | null
};
	["TOPXBrandCategoryWithoutBrandsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["TOPXBrandConnectOrCreateCategoryRelationInput"]: {
	connect:ValueTypes["TOPXBrandCategoryUniqueWhere"],
	create:ValueTypes["TOPXBrandCategoryWithoutBrandsCreateInput"]
};
	["BrandConnectOrCreateTopxRelationInput"]: {
	connect:ValueTypes["TOPXBrandUniqueWhere"],
	create:ValueTypes["TOPXBrandWithoutBrandCreateInput"]
};
	["BrandCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateContentRelationInput"] | null
};
	["BrandConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["BrandCreateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateDraftRelationInput"] | null
};
	["BrandConnectOrCreateDraftRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["ContentReferenceConnectOrCreateRelatedBrandRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandCreateInput"]
};
	["ContentReferenceCreateRelatedProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateRelatedProductRelationInput"] | null
};
	["ProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductCreateAgeCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["AgeCategoryUniqueWhere"] | null,
	create?:ValueTypes["AgeCategoryWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateAgeCategoriesRelationInput"] | null,
	alias?:string | null
};
	["AgeCategoryWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	order?:number | null,
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["AgeCategoryCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AgeCategoryCreateFilterCombosEntityRelationInput"]: {
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	create?:ValueTypes["FilterComboWithoutAgeCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["AgeCategoryConnectOrCreateFilterCombosRelationInput"] | null,
	alias?:string | null
};
	["FilterComboWithoutAgeCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboCreateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboCreateBreedEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboCreateBrandEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboCreateRegionEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboCreateTreatmentEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboCreateFlavorEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboCreateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AgeCategoryConnectOrCreateFilterCombosRelationInput"]: {
	connect:ValueTypes["FilterComboUniqueWhere"],
	create:ValueTypes["FilterComboWithoutAgeCategoryCreateInput"]
};
	["ProductConnectOrCreateAgeCategoriesRelationInput"]: {
	connect:ValueTypes["AgeCategoryUniqueWhere"],
	create:ValueTypes["AgeCategoryWithoutProductsCreateInput"]
};
	["ContentReferenceConnectOrCreateRelatedProductRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductCreateInput"]
};
	["ContentReferenceCreateRelatedIngredientEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateRelatedIngredientRelationInput"] | null
};
	["ItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemCreateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemCreateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemCreateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemCreateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemCreateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemCreateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemCreateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemCreateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemCreateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCreateDeclensionFourthEntityRelationInput"]: {
	connect?:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"] | null,
	create?:ValueTypes["ItemDeclensionFourthVariantWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateDeclensionFourthRelationInput"] | null
};
	["ItemDeclensionFourthVariantWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:string | null,
	remoteId?:string | null,
	declensionSeventh?:string | null,
	isNegativ?:boolean | null,
	seo?:ValueTypes["ItemDeclensionFourthVariantCreateSeoEntityRelationInput"] | null,
	subcategory?:ValueTypes["ItemDeclensionFourthVariantCreateSubcategoryEntityRelationInput"] | null,
	category?:ValueTypes["ItemDeclensionFourthVariantCreateCategoryEntityRelationInput"] | null,
	element?:ValueTypes["ItemDeclensionFourthVariantCreateElementEntityRelationInput"] | null,
	products?:ValueTypes["ItemDeclensionFourthVariantCreateProductsEntityRelationInput"][],
	slug?:string | null,
	content?:ValueTypes["ItemDeclensionFourthVariantCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemDeclensionFourthVariantCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionFourthVariantCreateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutDeclensionsFourthCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateCategoryRelationInput"] | null
};
	["ItemCategoryWithoutDeclensionsFourthCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryCreateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryCreateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryCreateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryCreateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryCreateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryCreateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryCreateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateSeoRelationInput"] | null
};
	["ItemCategoryConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoCreateInput"]
};
	["ItemCategoryCreateGroupEntityRelationInput"]: {
	connect?:ValueTypes["ItemGroupUniqueWhere"] | null,
	create?:ValueTypes["ItemGroupWithoutCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateGroupRelationInput"] | null
};
	["ItemGroupUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	categories?:ValueTypes["ItemCategoryUniqueWhere"] | null
};
	["ItemGroupWithoutCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryConnectOrCreateGroupRelationInput"]: {
	connect:ValueTypes["ItemGroupUniqueWhere"],
	create:ValueTypes["ItemGroupWithoutCategoriesCreateInput"]
};
	["ItemCategoryCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateContentRelationInput"] | null
};
	["ItemCategoryConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["ItemCategoryCreateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateDraftRelationInput"] | null
};
	["ItemCategoryConnectOrCreateDraftRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["ItemDeclensionFourthVariantConnectOrCreateCategoryRelationInput"]: {
	connect:ValueTypes["ItemCategoryUniqueWhere"],
	create:ValueTypes["ItemCategoryWithoutDeclensionsFourthCreateInput"]
};
	["ItemDeclensionFourthVariantCreateElementEntityRelationInput"]: {
	connect?:ValueTypes["ElementUniqueWhere"] | null,
	create?:ValueTypes["ElementCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateElementRelationInput"] | null
};
	["ElementCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["ElementCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ElementCreateFeatureDependenciesEntityRelationInput"][],
	suitabilityElements?:ValueTypes["ElementCreateSuitabilityElementsEntityRelationInput"][],
	remoteId?:string | null,
	unit?:string | null,
	filterOrder?:number | null,
	slug?:string | null,
	declensionSeventh?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionFourthVariantConnectOrCreateElementRelationInput"]: {
	connect:ValueTypes["ElementUniqueWhere"],
	create:ValueTypes["ElementCreateInput"]
};
	["ItemDeclensionFourthVariantCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ItemDeclensionFourthVariantCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateContentRelationInput"] | null
};
	["ItemDeclensionFourthVariantConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["ItemDeclensionFourthVariantCreateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateDraftRelationInput"] | null
};
	["ItemDeclensionFourthVariantConnectOrCreateDraftRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["ItemConnectOrCreateDeclensionFourthRelationInput"]: {
	connect:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],
	create:ValueTypes["ItemDeclensionFourthVariantWithoutItemsCreateInput"]
};
	["ContentReferenceConnectOrCreateRelatedIngredientRelationInput"]: {
	connect:ValueTypes["ItemUniqueWhere"],
	create:ValueTypes["ItemCreateInput"]
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | null
};
	["LinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	externalLink?:string | null,
	isTargetBlank?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceConnectOrCreateLinkRelationInput"]: {
	connect:ValueTypes["LinkUniqueWhere"],
	create:ValueTypes["LinkCreateInput"]
};
	["ContentReferenceCreateRelatedBrandFullEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateRelatedBrandFullRelationInput"] | null
};
	["ContentReferenceConnectOrCreateRelatedBrandFullRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandCreateInput"]
};
	["ContentReferenceCreateRelatedProductFullEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateRelatedProductFullRelationInput"] | null
};
	["ContentReferenceConnectOrCreateRelatedProductFullRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductCreateInput"]
};
	["ContentReferenceCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceListUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceListWithoutListCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateListRelationInput"] | null,
	alias?:string | null
};
	["ContentReferenceListWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	relatedProduct?:ValueTypes["ContentReferenceListCreateRelatedProductEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceListCreateRelatedBrandEntityRelationInput"] | null,
	badge?:string | null,
	badgeColor?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceListCreateRelatedProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceListConnectOrCreateRelatedProductRelationInput"] | null
};
	["ContentReferenceListConnectOrCreateRelatedProductRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductCreateInput"]
};
	["ContentReferenceListCreateRelatedBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceListConnectOrCreateRelatedBrandRelationInput"] | null
};
	["ContentReferenceListConnectOrCreateRelatedBrandRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandCreateInput"]
};
	["ContentReferenceConnectOrCreateListRelationInput"]: {
	connect:ValueTypes["ContentReferenceListUniqueWhere"],
	create:ValueTypes["ContentReferenceListWithoutListCreateInput"]
};
	["ContentReferenceCreateOutlineEntityRelationInput"]: {
	connect?:ValueTypes["ContentLinksUniqueWhere"] | null,
	create?:ValueTypes["ContentLinksCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateOutlineRelationInput"] | null
};
	["ContentLinksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ContentLinksCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentLinksCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ContentLinksItemUniqueWhere"] | null,
	create?:ValueTypes["ContentLinksItemWithoutListCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentLinksConnectOrCreateItemsRelationInput"] | null,
	alias?:string | null
};
	["ContentLinksItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	target?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentLinksConnectOrCreateItemsRelationInput"]: {
	connect:ValueTypes["ContentLinksItemUniqueWhere"],
	create:ValueTypes["ContentLinksItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateOutlineRelationInput"]: {
	connect:ValueTypes["ContentLinksUniqueWhere"],
	create:ValueTypes["ContentLinksCreateInput"]
};
	["ContentReferenceCreateVideoEntityRelationInput"]: {
	connect?:ValueTypes["VideoUniqueWhere"] | null,
	create?:ValueTypes["VideoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | null
};
	["VideoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	src?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	duration?:number | null,
	poster?:ValueTypes["VideoCreatePosterEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["VideoCreatePosterEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["VideoConnectOrCreatePosterRelationInput"] | null
};
	["VideoConnectOrCreatePosterRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["ContentReferenceConnectOrCreateVideoRelationInput"]: {
	connect:ValueTypes["VideoUniqueWhere"],
	create:ValueTypes["VideoCreateInput"]
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceImageUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateImageRelationInput"] | null
};
	["ContentReferenceImageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	lead?:string | null,
	alignment?:ValueTypes["AlignmentType"] | null,
	image?:ValueTypes["ContentReferenceImageCreateImageEntityRelationInput"] | null,
	link?:string | null,
	targetBlank?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceImageCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceImageConnectOrCreateImageRelationInput"] | null
};
	["ContentReferenceImageConnectOrCreateImageRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["ContentReferenceConnectOrCreateImageRelationInput"]: {
	connect:ValueTypes["ContentReferenceImageUniqueWhere"],
	create:ValueTypes["ContentReferenceImageCreateInput"]
};
	["AdConnectOrCreateContentReferencesRelationInput"]: {
	connect:ValueTypes["ContentReferenceUniqueWhere"],
	create:ValueTypes["ContentReferenceWithoutAdCreateInput"]
};
	["BrandConnectOrCreateAdsRelationInput"]: {
	connect:ValueTypes["AdUniqueWhere"],
	create:ValueTypes["AdWithoutBrandsCreateInput"]
};
	["CountryConnectOrCreateBrandsRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandWithoutCountriesOfProductionCreateInput"]
};
	["CountryCreateRegionEntityRelationInput"]: {
	connect?:ValueTypes["RegionUniqueWhere"] | null,
	create?:ValueTypes["RegionWithoutCountriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["CountryConnectOrCreateRegionRelationInput"] | null
};
	["RegionWithoutCountriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	remoteId?:string | null,
	adjective?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["RegionCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RegionCreateFilterCombosEntityRelationInput"]: {
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	create?:ValueTypes["FilterComboWithoutRegionCreateInput"] | null,
	connectOrCreate?:ValueTypes["RegionConnectOrCreateFilterCombosRelationInput"] | null,
	alias?:string | null
};
	["FilterComboWithoutRegionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboCreateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboCreateBreedEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboCreateBrandEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboCreateAgeCategoryEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboCreateTreatmentEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboCreateFlavorEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboCreateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RegionConnectOrCreateFilterCombosRelationInput"]: {
	connect:ValueTypes["FilterComboUniqueWhere"],
	create:ValueTypes["FilterComboWithoutRegionCreateInput"]
};
	["CountryConnectOrCreateRegionRelationInput"]: {
	connect:ValueTypes["RegionUniqueWhere"],
	create:ValueTypes["RegionWithoutCountriesCreateInput"]
};
	["BrandManufacturerConnectOrCreateResidenceRelationInput"]: {
	connect:ValueTypes["CountryUniqueWhere"],
	create:ValueTypes["CountryWithoutManufacturersCreateInput"]
};
	["BrandConnectOrCreateManufacturersRelationInput"]: {
	connect:ValueTypes["BrandManufacturerUniqueWhere"],
	create:ValueTypes["BrandManufacturerWithoutBrandsCreateInput"]
};
	["ProductConnectOrCreateBrandRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandWithoutProductsCreateInput"]
};
	["ProductLineConnectOrCreateProductsRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutProductLineCreateInput"]
};
	["ProductLineCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductLineConnectOrCreateLogoRelationInput"] | null
};
	["ProductLineConnectOrCreateLogoRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["ProductLineCreateAliasesEntityRelationInput"]: {
	connect?:ValueTypes["ProductLineAliasUniqueWhere"] | null,
	create?:ValueTypes["ProductLineAliasWithoutProductLinesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductLineConnectOrCreateAliasesRelationInput"] | null,
	alias?:string | null
};
	["ProductLineAliasUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["ProductLineAliasWithoutProductLinesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductLineConnectOrCreateAliasesRelationInput"]: {
	connect:ValueTypes["ProductLineAliasUniqueWhere"],
	create:ValueTypes["ProductLineAliasWithoutProductLinesCreateInput"]
};
	["ProductLineCreateFlavorsEntityRelationInput"]: {
	connect?:ValueTypes["ProductLineFlavorUniqueWhere"] | null,
	alias?:string | null
};
	["ProductLineCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductLineConnectOrCreateSeoRelationInput"] | null
};
	["ProductLineConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoCreateInput"]
};
	["BrandConnectOrCreateProductLinesRelationInput"]: {
	connect:ValueTypes["ProductLineUniqueWhere"],
	create:ValueTypes["ProductLineWithoutBrandCreateInput"]
};
	["BrandManufacturerConnectOrCreateBrandsRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandWithoutManufacturersCreateInput"]
};
	["CountryConnectOrCreateManufacturersRelationInput"]: {
	connect:ValueTypes["BrandManufacturerUniqueWhere"],
	create:ValueTypes["BrandManufacturerWithoutResidenceCreateInput"]
};
	["BrandConnectOrCreateCountriesOfProductionRelationInput"]: {
	connect:ValueTypes["CountryUniqueWhere"],
	create:ValueTypes["CountryWithoutBrandsCreateInput"]
};
	["FilterComboConnectOrCreateBrandRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandWithoutFilterCombosCreateInput"]
};
	["BreedConnectOrCreateFilterCombosRelationInput"]: {
	connect:ValueTypes["FilterComboUniqueWhere"],
	create:ValueTypes["FilterComboWithoutBreedCreateInput"]
};
	["BlogPostReviewConnectOrCreateBreedRelationInput"]: {
	connect:ValueTypes["BreedUniqueWhere"],
	create:ValueTypes["BreedWithoutBlogPostReviewsCreateInput"]
};
	["AgeConnectOrCreateBlogPostReviewsRelationInput"]: {
	connect:ValueTypes["BlogPostReviewUniqueWhere"],
	create:ValueTypes["BlogPostReviewWithoutAgeCreateInput"]
};
	["SuitabilityCategoryConnectOrCreateDogAgesRelationInput"]: {
	connect:ValueTypes["AgeUniqueWhere"],
	create:ValueTypes["AgeWithoutSuitabilityCategoriesCreateInput"]
};
	["DogSizeConnectOrCreateSuitabilityCategoryRelationInput"]: {
	connect:ValueTypes["SuitabilityCategoryUniqueWhere"],
	create:ValueTypes["SuitabilityCategoryWithoutDogSizesCreateInput"]
};
	["BreedConnectOrCreateSizeRelationInput"]: {
	connect:ValueTypes["DogSizeUniqueWhere"],
	create:ValueTypes["DogSizeWithoutBreedsCreateInput"]
};
	["ProductReviewConnectOrCreateBreedRelationInput"]: {
	connect:ValueTypes["BreedUniqueWhere"],
	create:ValueTypes["BreedWithoutProductReviewsCreateInput"]
};
	["AgeConnectOrCreateProductReviewsRelationInput"]: {
	connect:ValueTypes["ProductReviewUniqueWhere"],
	create:ValueTypes["ProductReviewWithoutAgeCreateInput"]
};
	["BlogPostReviewConnectOrCreateAgeRelationInput"]: {
	connect:ValueTypes["AgeUniqueWhere"],
	create:ValueTypes["AgeWithoutBlogPostReviewsCreateInput"]
};
	["BreedConnectOrCreateBlogPostReviewsRelationInput"]: {
	connect:ValueTypes["BlogPostReviewUniqueWhere"],
	create:ValueTypes["BlogPostReviewWithoutBreedCreateInput"]
};
	["SuitabilityCategoryConnectOrCreateBreedsRelationInput"]: {
	connect:ValueTypes["BreedUniqueWhere"],
	create:ValueTypes["BreedWithoutSuitabilityCategoryCreateInput"]
};
	["AgeConnectOrCreateSuitabilityCategoriesRelationInput"]: {
	connect:ValueTypes["SuitabilityCategoryUniqueWhere"],
	create:ValueTypes["SuitabilityCategoryWithoutDogAgesCreateInput"]
};
	["ProductReviewConnectOrCreateAgeRelationInput"]: {
	connect:ValueTypes["AgeUniqueWhere"],
	create:ValueTypes["AgeWithoutProductReviewsCreateInput"]
};
	["BreedConnectOrCreateProductReviewsRelationInput"]: {
	connect:ValueTypes["ProductReviewUniqueWhere"],
	create:ValueTypes["ProductReviewWithoutBreedCreateInput"]
};
	["FilterComboConnectOrCreateBreedRelationInput"]: {
	connect:ValueTypes["BreedUniqueWhere"],
	create:ValueTypes["BreedWithoutFilterCombosCreateInput"]
};
	["ItemSubCategoryConnectOrCreateFilterCombosFlavorRelationInput"]: {
	connect:ValueTypes["FilterComboUniqueWhere"],
	create:ValueTypes["FilterComboWithoutFlavorCreateInput"]
};
	["DogConnectOrCreateAllergiesRelationInput"]: {
	connect:ValueTypes["ItemSubCategoryUniqueWhere"],
	create:ValueTypes["ItemSubCategoryWithoutDogsCreateInput"]
};
	["DogCreateIllnessesEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	create?:ValueTypes["BodyTagWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateIllnessesRelationInput"] | null,
	alias?:string | null
};
	["BodyTagWithoutDogsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagCreateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagCreatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagCreateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagCreatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagCreateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagCreateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagCreateIconEntityRelationInput"] | null,
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagCreateFilterCombosEntityRelationInput"]: {
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	create?:ValueTypes["FilterComboWithoutTreatmentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagConnectOrCreateFilterCombosRelationInput"] | null,
	alias?:string | null
};
	["FilterComboWithoutTreatmentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboCreateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboCreateBreedEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboCreateBrandEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboCreateRegionEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboCreateAgeCategoryEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboCreateFlavorEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboCreateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BodyTagConnectOrCreateFilterCombosRelationInput"]: {
	connect:ValueTypes["FilterComboUniqueWhere"],
	create:ValueTypes["FilterComboWithoutTreatmentCreateInput"]
};
	["DogConnectOrCreateIllnessesRelationInput"]: {
	connect:ValueTypes["BodyTagUniqueWhere"],
	create:ValueTypes["BodyTagWithoutDogsCreateInput"]
};
	["DogActivityConnectOrCreateDogsRelationInput"]: {
	connect:ValueTypes["DogUniqueWhere"],
	create:ValueTypes["DogWithoutActivityCreateInput"]
};
	["DogActivityCreateSuitabilityCategoryEntityRelationInput"]: {
	connect?:ValueTypes["SuitabilityCategoryUniqueWhere"] | null,
	create?:ValueTypes["SuitabilityCategoryWithoutDogActivitiesCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogActivityConnectOrCreateSuitabilityCategoryRelationInput"] | null
};
	["SuitabilityCategoryWithoutDogActivitiesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	dogSizes?:ValueTypes["SuitabilityCategoryCreateDogSizesEntityRelationInput"][],
	breeds?:ValueTypes["SuitabilityCategoryCreateBreedsEntityRelationInput"][],
	suitabilityItems?:ValueTypes["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"][],
	dogAges?:ValueTypes["SuitabilityCategoryCreateDogAgesEntityRelationInput"][],
	isPregnant?:boolean | null,
	remoteId?:string | null,
	isBreastfeeding?:boolean | null,
	_dummy_field_?:boolean | null
};
	["DogActivityConnectOrCreateSuitabilityCategoryRelationInput"]: {
	connect:ValueTypes["SuitabilityCategoryUniqueWhere"],
	create:ValueTypes["SuitabilityCategoryWithoutDogActivitiesCreateInput"]
};
	["ProductConnectOrCreateRecommendedActivityRelationInput"]: {
	connect:ValueTypes["DogActivityUniqueWhere"],
	create:ValueTypes["DogActivityWithoutProductsCreateInput"]
};
	["BrandConnectOrCreateProductsRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutBrandCreateInput"]
};
	["ProductLineConnectOrCreateBrandRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandWithoutProductLinesCreateInput"]
};
	["ProductConnectOrCreateProductLineRelationInput"]: {
	connect:ValueTypes["ProductLineUniqueWhere"],
	create:ValueTypes["ProductLineWithoutProductsCreateInput"]
};
	["DogSizeConnectOrCreateProductsRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutRecommendedDogSizesCreateInput"]
};
	["SuitabilityCategoryConnectOrCreateDogSizesRelationInput"]: {
	connect:ValueTypes["DogSizeUniqueWhere"],
	create:ValueTypes["DogSizeWithoutSuitabilityCategoryCreateInput"]
};
	["BreedConnectOrCreateSuitabilityCategoryRelationInput"]: {
	connect:ValueTypes["SuitabilityCategoryUniqueWhere"],
	create:ValueTypes["SuitabilityCategoryWithoutBreedsCreateInput"]
};
	["DogSizeConnectOrCreateBreedsRelationInput"]: {
	connect:ValueTypes["BreedUniqueWhere"],
	create:ValueTypes["BreedWithoutSizeCreateInput"]
};
	["ProductConnectOrCreateRecommendedDogSizesRelationInput"]: {
	connect:ValueTypes["DogSizeUniqueWhere"],
	create:ValueTypes["DogSizeWithoutProductsCreateInput"]
};
	["DogConnectOrCreateFedProductRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutDogsCreateInput"]
};
	["ItemSubCategoryConnectOrCreateDogsRelationInput"]: {
	connect:ValueTypes["DogUniqueWhere"],
	create:ValueTypes["DogWithoutAllergiesCreateInput"]
};
	["ItemDeclensionFourthVariantConnectOrCreateSubcategoryRelationInput"]: {
	connect:ValueTypes["ItemSubCategoryUniqueWhere"],
	create:ValueTypes["ItemSubCategoryCreateInput"]
};
	["ItemCategoryConnectOrCreateDeclensionsFourthRelationInput"]: {
	connect:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],
	create:ValueTypes["ItemDeclensionFourthVariantWithoutCategoryCreateInput"]
};
	["ItemSubCategoryConnectOrCreateCategoryRelationInput"]: {
	connect:ValueTypes["ItemCategoryUniqueWhere"],
	create:ValueTypes["ItemCategoryWithoutSubCategoriesCreateInput"]
};
	["ProductFeatureConnectOrCreateDependentSubCategoryRelationInput"]: {
	connect:ValueTypes["ItemSubCategoryUniqueWhere"],
	create:ValueTypes["ItemSubCategoryWithoutFeatureDependenciesCreateInput"]
};
	["ProductFeatureCreateDependentFlagEntityRelationInput"]: {
	connect?:ValueTypes["ProductFlagUniqueWhere"] | null,
	create?:ValueTypes["ProductFlagWithoutProductFeaturesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFeatureConnectOrCreateDependentFlagRelationInput"] | null
};
	["ProductFlagWithoutProductFeaturesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	products?:ValueTypes["ProductFlagCreateProductsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductFlagCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null,
	create?:ValueTypes["ProductFlagOfProductWithoutFlagCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFlagConnectOrCreateProductsRelationInput"] | null,
	alias?:string | null
};
	["ProductFlagOfProductWithoutFlagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	value?:ValueTypes["ProductFlagValue"] | null,
	product?:ValueTypes["ProductFlagOfProductCreateProductEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFlagOfProductCreateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutFlagsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFlagOfProductConnectOrCreateProductRelationInput"] | null
};
	["ProductWithoutFlagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductFlagOfProductConnectOrCreateProductRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutFlagsCreateInput"]
};
	["ProductFlagConnectOrCreateProductsRelationInput"]: {
	connect:ValueTypes["ProductFlagOfProductUniqueWhere"],
	create:ValueTypes["ProductFlagOfProductWithoutFlagCreateInput"]
};
	["ProductFeatureConnectOrCreateDependentFlagRelationInput"]: {
	connect:ValueTypes["ProductFlagUniqueWhere"],
	create:ValueTypes["ProductFlagWithoutProductFeaturesCreateInput"]
};
	["ItemCategoryConnectOrCreateFeatureDependenciesRelationInput"]: {
	connect:ValueTypes["ProductFeatureUniqueWhere"],
	create:ValueTypes["ProductFeatureWithoutDependentCategoryCreateInput"]
};
	["RedirectConnectOrCreateItemCategoryRelationInput"]: {
	connect:ValueTypes["ItemCategoryUniqueWhere"],
	create:ValueTypes["ItemCategoryWithoutRedirectsCreateInput"]
};
	["BrandsPageConnectOrCreateRedirectsRelationInput"]: {
	connect:ValueTypes["RedirectUniqueWhere"],
	create:ValueTypes["RedirectWithoutBrandsPageCreateInput"]
};
	["SeoConnectOrCreateBrandsPageRelationInput"]: {
	connect:ValueTypes["BrandsPageUniqueWhere"],
	create:ValueTypes["BrandsPageWithoutSeoCreateInput"]
};
	["BlogPostConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoCreateInput"]
};
	["BlogPostCreateRedirectsEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutBlogPostCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateRedirectsRelationInput"] | null,
	alias?:string | null
};
	["RedirectWithoutBlogPostCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectCreateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectCreateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectCreateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectCreateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectCreateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectCreateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectCreateComparatorPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostConnectOrCreateRedirectsRelationInput"]: {
	connect:ValueTypes["RedirectUniqueWhere"],
	create:ValueTypes["RedirectWithoutBlogPostCreateInput"]
};
	["AdConnectOrCreateBlogPostsRelationInput"]: {
	connect:ValueTypes["BlogPostUniqueWhere"],
	create:ValueTypes["BlogPostWithoutAdsCreateInput"]
};
	["AdCreateBrandsEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutAdsCreateInput"] | null,
	connectOrCreate?:ValueTypes["AdConnectOrCreateBrandsRelationInput"] | null,
	alias?:string | null
};
	["BrandWithoutAdsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["BrandCreateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandCreateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandCreateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandCreateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandCreateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandCreateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandCreateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandCreateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AdConnectOrCreateBrandsRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandWithoutAdsCreateInput"]
};
	["ItemCategoryConnectOrCreateAdsRelationInput"]: {
	connect:ValueTypes["AdUniqueWhere"],
	create:ValueTypes["AdWithoutItemCategoriesCreateInput"]
};
	["ProductFeatureConnectOrCreateDependentCategoryRelationInput"]: {
	connect:ValueTypes["ItemCategoryUniqueWhere"],
	create:ValueTypes["ItemCategoryWithoutFeatureDependenciesCreateInput"]
};
	["ElementConnectOrCreateFeatureDependenciesRelationInput"]: {
	connect:ValueTypes["ProductFeatureUniqueWhere"],
	create:ValueTypes["ProductFeatureWithoutDependentElementCreateInput"]
};
	["ElementOfProductConnectOrCreateElementRelationInput"]: {
	connect:ValueTypes["ElementUniqueWhere"],
	create:ValueTypes["ElementWithoutProductsCreateInput"]
};
	["ProductConnectOrCreateElementsRelationInput"]: {
	connect:ValueTypes["ElementOfProductUniqueWhere"],
	create:ValueTypes["ElementOfProductWithoutProductCreateInput"]
};
	["ItemCategoryConnectOrCreateProductsRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutItemCategoriesCreateInput"]
};
	["AdConnectOrCreateItemCategoriesRelationInput"]: {
	connect:ValueTypes["ItemCategoryUniqueWhere"],
	create:ValueTypes["ItemCategoryWithoutAdsCreateInput"]
};
	["BlogPostConnectOrCreateAdsRelationInput"]: {
	connect:ValueTypes["AdUniqueWhere"],
	create:ValueTypes["AdWithoutBlogPostsCreateInput"]
};
	["UserConnectOrCreateBlogPostsRelationInput"]: {
	connect:ValueTypes["BlogPostUniqueWhere"],
	create:ValueTypes["BlogPostWithoutUserCreateInput"]
};
	["UserCreateAvatarEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateAvatarRelationInput"] | null
};
	["UserConnectOrCreateAvatarRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["UserCreateContactFormMessagesEntityRelationInput"]: {
	connect?:ValueTypes["ContactFormMessageUniqueWhere"] | null,
	create?:ValueTypes["ContactFormMessageWithoutUserCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateContactFormMessagesRelationInput"] | null,
	alias?:string | null
};
	["ContactFormMessageWithoutUserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	message?:string | null,
	email?:string | null,
	receivedAt?:ValueTypes["DateTime"] | null,
	isResolved?:boolean | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["UserConnectOrCreateContactFormMessagesRelationInput"]: {
	connect:ValueTypes["ContactFormMessageUniqueWhere"],
	create:ValueTypes["ContactFormMessageWithoutUserCreateInput"]
};
	["UserCreateBugReportsEntityRelationInput"]: {
	connect?:ValueTypes["BugReportUniqueWhere"] | null,
	create?:ValueTypes["BugReportWithoutUserCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateBugReportsRelationInput"] | null,
	alias?:string | null
};
	["BugReportWithoutUserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	message?:string | null,
	receivedAt?:ValueTypes["DateTime"] | null,
	isResolved?:boolean | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["UserConnectOrCreateBugReportsRelationInput"]: {
	connect:ValueTypes["BugReportUniqueWhere"],
	create:ValueTypes["BugReportWithoutUserCreateInput"]
};
	["UserCreateProtectedActionsEntityRelationInput"]: {
	connect?:ValueTypes["ProtectedActionUniqueWhere"] | null,
	create?:ValueTypes["ProtectedActionWithoutUserCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateProtectedActionsRelationInput"] | null,
	alias?:string | null
};
	["ProtectedActionWithoutUserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ProtectedActionType"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	usedAt?:ValueTypes["DateTime"] | null,
	expiresAt?:ValueTypes["DateTime"] | null,
	publicKey?:string | null,
	secretHash?:string | null,
	verifyEmail?:string | null,
	createdMetadata?:ValueTypes["Json"] | null,
	usedMetadata?:ValueTypes["Json"] | null,
	_dummy_field_?:boolean | null
};
	["UserConnectOrCreateProtectedActionsRelationInput"]: {
	connect:ValueTypes["ProtectedActionUniqueWhere"],
	create:ValueTypes["ProtectedActionWithoutUserCreateInput"]
};
	["UserCreateTenantPersonEntityRelationInput"]: {
	connect?:ValueTypes["TenantPersonUniqueWhere"] | null
};
	["ProductReviewConnectOrCreateUserRelationInput"]: {
	connect:ValueTypes["UserUniqueWhere"],
	create:ValueTypes["UserWithoutProductReviewsCreateInput"]
};
	["ProductReviewReactionConnectOrCreateProductReviewRelationInput"]: {
	connect:ValueTypes["ProductReviewUniqueWhere"],
	create:ValueTypes["ProductReviewWithoutProductReviewReactionsCreateInput"]
};
	["UserConnectOrCreateProductReviewReactionsRelationInput"]: {
	connect:ValueTypes["ProductReviewReactionUniqueWhere"],
	create:ValueTypes["ProductReviewReactionWithoutUserCreateInput"]
};
	["BlogPostReviewConnectOrCreateUserRelationInput"]: {
	connect:ValueTypes["UserUniqueWhere"],
	create:ValueTypes["UserWithoutBlogPostReviewsCreateInput"]
};
	["BlogPostReviewReactionConnectOrCreateBlogPostReviewRelationInput"]: {
	connect:ValueTypes["BlogPostReviewUniqueWhere"],
	create:ValueTypes["BlogPostReviewWithoutBlogPostReviewReactionsCreateInput"]
};
	["UserConnectOrCreateBlogPostReviewReactionsRelationInput"]: {
	connect:ValueTypes["BlogPostReviewReactionUniqueWhere"],
	create:ValueTypes["BlogPostReviewReactionWithoutUserCreateInput"]
};
	["BlogPostConnectOrCreateUserRelationInput"]: {
	connect:ValueTypes["UserUniqueWhere"],
	create:ValueTypes["UserWithoutBlogPostsCreateInput"]
};
	["ItemConnectOrCreateBlogPostRelationInput"]: {
	connect:ValueTypes["BlogPostUniqueWhere"],
	create:ValueTypes["BlogPostWithoutItemsCreateInput"]
};
	["ItemCategoryConnectOrCreateItemsRelationInput"]: {
	connect:ValueTypes["ItemUniqueWhere"],
	create:ValueTypes["ItemWithoutCategoriesCreateInput"]
};
	["ProductConnectOrCreateItemCategoriesRelationInput"]: {
	connect:ValueTypes["ItemCategoryUniqueWhere"],
	create:ValueTypes["ItemCategoryWithoutProductsCreateInput"]
};
	["NutritionalValueOfProductConnectOrCreateProductRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutNutritionalValuesCreateInput"]
};
	["NutritionalValueConnectOrCreateProductsRelationInput"]: {
	connect:ValueTypes["NutritionalValueOfProductUniqueWhere"],
	create:ValueTypes["NutritionalValueOfProductWithoutNutritionalValueCreateInput"]
};
	["NutritionalValueCreateIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["NutritionalValueConnectOrCreateIconRelationInput"] | null
};
	["NutritionalValueConnectOrCreateIconRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["SuitabilityItemConnectOrCreateNutritionalValueRelationInput"]: {
	connect:ValueTypes["NutritionalValueUniqueWhere"],
	create:ValueTypes["NutritionalValueWithoutSuitabilityNutritionalValuesCreateInput"]
};
	["SuitabilityItemCreateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["SuitabilityCategoryUniqueWhere"] | null,
	create?:ValueTypes["SuitabilityCategoryWithoutSuitabilityItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["SuitabilityItemConnectOrCreateCategoryRelationInput"] | null
};
	["SuitabilityCategoryWithoutSuitabilityItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	dogSizes?:ValueTypes["SuitabilityCategoryCreateDogSizesEntityRelationInput"][],
	dogActivities?:ValueTypes["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"][],
	breeds?:ValueTypes["SuitabilityCategoryCreateBreedsEntityRelationInput"][],
	dogAges?:ValueTypes["SuitabilityCategoryCreateDogAgesEntityRelationInput"][],
	isPregnant?:boolean | null,
	remoteId?:string | null,
	isBreastfeeding?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityItemConnectOrCreateCategoryRelationInput"]: {
	connect:ValueTypes["SuitabilityCategoryUniqueWhere"],
	create:ValueTypes["SuitabilityCategoryWithoutSuitabilityItemsCreateInput"]
};
	["ElementConnectOrCreateSuitabilityElementsRelationInput"]: {
	connect:ValueTypes["SuitabilityItemUniqueWhere"],
	create:ValueTypes["SuitabilityItemWithoutElementCreateInput"]
};
	["ProductFeatureConnectOrCreateDependentElementRelationInput"]: {
	connect:ValueTypes["ElementUniqueWhere"],
	create:ValueTypes["ElementWithoutFeatureDependenciesCreateInput"]
};
	["ItemConnectOrCreateFeaturesOfProductRelationInput"]: {
	connect:ValueTypes["ProductFeatureUniqueWhere"],
	create:ValueTypes["ProductFeatureWithoutLinkItemCreateInput"]
};
	["BlogPostConnectOrCreateItemsRelationInput"]: {
	connect:ValueTypes["ItemUniqueWhere"],
	create:ValueTypes["ItemWithoutBlogPostCreateInput"]
};
	["ItemCategoryConnectOrCreateBlogPostsRelationInput"]: {
	connect:ValueTypes["BlogPostUniqueWhere"],
	create:ValueTypes["BlogPostWithoutItemCategoriesCreateInput"]
};
	["ItemConnectOrCreateCategoriesRelationInput"]: {
	connect:ValueTypes["ItemCategoryUniqueWhere"],
	create:ValueTypes["ItemCategoryWithoutItemsCreateInput"]
};
	["ProductFeatureConnectOrCreateLinkItemRelationInput"]: {
	connect:ValueTypes["ItemUniqueWhere"],
	create:ValueTypes["ItemWithoutFeaturesOfProductCreateInput"]
};
	["ItemSubCategoryConnectOrCreateFeatureDependenciesRelationInput"]: {
	connect:ValueTypes["ProductFeatureUniqueWhere"],
	create:ValueTypes["ProductFeatureWithoutDependentSubCategoryCreateInput"]
};
	["ProductConnectOrCreateItemSubCategoriesRelationInput"]: {
	connect:ValueTypes["ItemSubCategoryUniqueWhere"],
	create:ValueTypes["ItemSubCategoryWithoutProductsCreateInput"]
};
	["DogActivityConnectOrCreateProductsRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutRecommendedActivityCreateInput"]
};
	["DogConnectOrCreateActivityRelationInput"]: {
	connect:ValueTypes["DogActivityUniqueWhere"],
	create:ValueTypes["DogActivityWithoutDogsCreateInput"]
};
	["BreedConnectOrCreateDogsRelationInput"]: {
	connect:ValueTypes["DogUniqueWhere"],
	create:ValueTypes["DogWithoutBreedCreateInput"]
};
	["AgeConnectOrCreateBreedsRelationInput"]: {
	connect:ValueTypes["BreedUniqueWhere"],
	create:ValueTypes["BreedWithoutAgesCreateInput"]
};
	["DogConnectOrCreateAgeRelationInput"]: {
	connect:ValueTypes["AgeUniqueWhere"],
	create:ValueTypes["AgeWithoutDogsCreateInput"]
};
	["ProductConnectOrCreateDogsRelationInput"]: {
	connect:ValueTypes["DogUniqueWhere"],
	create:ValueTypes["DogWithoutFedProductCreateInput"]
};
	["ItemSubCategoryConnectOrCreateProductsRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutItemSubCategoriesCreateInput"]
};
	["ItemConnectOrCreateSubCategoriesRelationInput"]: {
	connect:ValueTypes["ItemSubCategoryUniqueWhere"],
	create:ValueTypes["ItemSubCategoryWithoutItemsCreateInput"]
};
	["BodyTagConnectOrCreateNegativeItemsRelationInput"]: {
	connect:ValueTypes["ItemUniqueWhere"],
	create:ValueTypes["ItemWithoutNegativeForBodyTagsCreateInput"]
};
	["ItemConnectOrCreatePositiveForBodyTagsRelationInput"]: {
	connect:ValueTypes["BodyTagUniqueWhere"],
	create:ValueTypes["BodyTagWithoutPositiveItemsCreateInput"]
};
	["ItemSubCategoryConnectOrCreateItemsRelationInput"]: {
	connect:ValueTypes["ItemUniqueWhere"],
	create:ValueTypes["ItemWithoutSubCategoriesCreateInput"]
};
	["ItemCategoryConnectOrCreateSubCategoriesRelationInput"]: {
	connect:ValueTypes["ItemSubCategoryUniqueWhere"],
	create:ValueTypes["ItemSubCategoryWithoutCategoryCreateInput"]
};
	["BlogPostConnectOrCreateItemCategoriesRelationInput"]: {
	connect:ValueTypes["ItemCategoryUniqueWhere"],
	create:ValueTypes["ItemCategoryWithoutBlogPostsCreateInput"]
};
	["BlogPostTagConnectOrCreateBlogPostsRelationInput"]: {
	connect:ValueTypes["BlogPostUniqueWhere"],
	create:ValueTypes["BlogPostWithoutBlogPostTagsCreateInput"]
};
	["ColorConnectOrCreateBlogPostTagRelationInput"]: {
	connect:ValueTypes["BlogPostTagUniqueWhere"],
	create:ValueTypes["BlogPostTagWithoutColorCreateInput"]
};
	["ColorCreateItemFlavorCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["ItemFlavorCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemFlavorCategoryWithoutColorCreateInput"] | null,
	connectOrCreate?:ValueTypes["ColorConnectOrCreateItemFlavorCategoriesRelationInput"] | null,
	alias?:string | null
};
	["ItemFlavorCategoryWithoutColorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	items?:ValueTypes["ItemFlavorCategoryCreateItemsEntityRelationInput"][],
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemFlavorCategoryCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryWithoutFlavorCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemFlavorCategoryConnectOrCreateItemsRelationInput"] | null,
	alias?:string | null
};
	["ItemSubCategoryWithoutFlavorCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryCreateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryCreateCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryCreateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryCreateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryCreateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemFlavorCategoryConnectOrCreateItemsRelationInput"]: {
	connect:ValueTypes["ItemSubCategoryUniqueWhere"],
	create:ValueTypes["ItemSubCategoryWithoutFlavorCategoryCreateInput"]
};
	["ColorConnectOrCreateItemFlavorCategoriesRelationInput"]: {
	connect:ValueTypes["ItemFlavorCategoryUniqueWhere"],
	create:ValueTypes["ItemFlavorCategoryWithoutColorCreateInput"]
};
	["BodyTagCategoryConnectOrCreateColorRelationInput"]: {
	connect:ValueTypes["ColorUniqueWhere"],
	create:ValueTypes["ColorWithoutBodyTagCategoryCreateInput"]
};
	["BodyTagConnectOrCreateCategoryRelationInput"]: {
	connect:ValueTypes["BodyTagCategoryUniqueWhere"],
	create:ValueTypes["BodyTagCategoryWithoutTagsCreateInput"]
};
	["ItemConnectOrCreateNegativeForBodyTagsRelationInput"]: {
	connect:ValueTypes["BodyTagUniqueWhere"],
	create:ValueTypes["BodyTagWithoutNegativeItemsCreateInput"]
};
	["BodyTagConnectOrCreatePositiveItemsRelationInput"]: {
	connect:ValueTypes["ItemUniqueWhere"],
	create:ValueTypes["ItemWithoutPositiveForBodyTagsCreateInput"]
};
	["ProductConnectOrCreateNegativeForBodyTagsRelationInput"]: {
	connect:ValueTypes["BodyTagUniqueWhere"],
	create:ValueTypes["BodyTagWithoutNegativeProductsCreateInput"]
};
	["ProductReviewConnectOrCreateProductRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutReviewsCreateInput"]
};
	["UserConnectOrCreateProductReviewsRelationInput"]: {
	connect:ValueTypes["ProductReviewUniqueWhere"],
	create:ValueTypes["ProductReviewWithoutUserCreateInput"]
};
	["ProductReviewReactionConnectOrCreateUserRelationInput"]: {
	connect:ValueTypes["UserUniqueWhere"],
	create:ValueTypes["UserWithoutProductReviewReactionsCreateInput"]
};
	["ProductReviewConnectOrCreateProductReviewReactionsRelationInput"]: {
	connect:ValueTypes["ProductReviewReactionUniqueWhere"],
	create:ValueTypes["ProductReviewReactionWithoutProductReviewCreateInput"]
};
	["ProductConnectOrCreateReviewsRelationInput"]: {
	connect:ValueTypes["ProductReviewUniqueWhere"],
	create:ValueTypes["ProductReviewWithoutProductCreateInput"]
};
	["BodyTagConnectOrCreateNegativeProductsRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutNegativeForBodyTagsCreateInput"]
};
	["ProductConnectOrCreatePositiveForBodyTagsRelationInput"]: {
	connect:ValueTypes["BodyTagUniqueWhere"],
	create:ValueTypes["BodyTagWithoutPositiveProductsCreateInput"]
};
	["ElementOfProductConnectOrCreateProductRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutElementsCreateInput"]
};
	["ElementConnectOrCreateProductsRelationInput"]: {
	connect:ValueTypes["ElementOfProductUniqueWhere"],
	create:ValueTypes["ElementOfProductWithoutElementCreateInput"]
};
	["SuitabilityItemConnectOrCreateElementRelationInput"]: {
	connect:ValueTypes["ElementUniqueWhere"],
	create:ValueTypes["ElementWithoutSuitabilityElementsCreateInput"]
};
	["NutritionalValueConnectOrCreateSuitabilityNutritionalValuesRelationInput"]: {
	connect:ValueTypes["SuitabilityItemUniqueWhere"],
	create:ValueTypes["SuitabilityItemWithoutNutritionalValueCreateInput"]
};
	["NutritionalValueOfProductConnectOrCreateNutritionalValueRelationInput"]: {
	connect:ValueTypes["NutritionalValueUniqueWhere"],
	create:ValueTypes["NutritionalValueWithoutProductsCreateInput"]
};
	["ProductConnectOrCreateNutritionalValuesRelationInput"]: {
	connect:ValueTypes["NutritionalValueOfProductUniqueWhere"],
	create:ValueTypes["NutritionalValueOfProductWithoutProductCreateInput"]
};
	["BodyTagConnectOrCreatePositiveProductsRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutPositiveForBodyTagsCreateInput"]
};
	["BlogPostConnectOrCreateTagsRelationInput"]: {
	connect:ValueTypes["BodyTagUniqueWhere"],
	create:ValueTypes["BodyTagWithoutBlogPostsCreateInput"]
};
	["BlogPostReviewConnectOrCreateBlogPostRelationInput"]: {
	connect:ValueTypes["BlogPostUniqueWhere"],
	create:ValueTypes["BlogPostWithoutReviewsCreateInput"]
};
	["UserConnectOrCreateBlogPostReviewsRelationInput"]: {
	connect:ValueTypes["BlogPostReviewUniqueWhere"],
	create:ValueTypes["BlogPostReviewWithoutUserCreateInput"]
};
	["DogConnectOrCreateOwnerRelationInput"]: {
	connect:ValueTypes["UserUniqueWhere"],
	create:ValueTypes["UserWithoutDogsCreateInput"]
};
	["AgeConnectOrCreateDogsRelationInput"]: {
	connect:ValueTypes["DogUniqueWhere"],
	create:ValueTypes["DogWithoutAgeCreateInput"]
};
	["BreedConnectOrCreateAgesRelationInput"]: {
	connect:ValueTypes["AgeUniqueWhere"],
	create:ValueTypes["AgeWithoutBreedsCreateInput"]
};
	["DogConnectOrCreateBreedRelationInput"]: {
	connect:ValueTypes["BreedUniqueWhere"],
	create:ValueTypes["BreedWithoutDogsCreateInput"]
};
	["UserConnectOrCreateDogsRelationInput"]: {
	connect:ValueTypes["DogUniqueWhere"],
	create:ValueTypes["DogWithoutOwnerCreateInput"]
};
	["BlogPostReviewReactionConnectOrCreateUserRelationInput"]: {
	connect:ValueTypes["UserUniqueWhere"],
	create:ValueTypes["UserWithoutBlogPostReviewReactionsCreateInput"]
};
	["BlogPostReviewConnectOrCreateBlogPostReviewReactionsRelationInput"]: {
	connect:ValueTypes["BlogPostReviewReactionUniqueWhere"],
	create:ValueTypes["BlogPostReviewReactionWithoutBlogPostReviewCreateInput"]
};
	["BlogPostConnectOrCreateReviewsRelationInput"]: {
	connect:ValueTypes["BlogPostReviewUniqueWhere"],
	create:ValueTypes["BlogPostReviewWithoutBlogPostCreateInput"]
};
	["BodyTagConnectOrCreateBlogPostsRelationInput"]: {
	connect:ValueTypes["BlogPostUniqueWhere"],
	create:ValueTypes["BlogPostWithoutTagsCreateInput"]
};
	["BodyTagCategoryConnectOrCreateTagsRelationInput"]: {
	connect:ValueTypes["BodyTagUniqueWhere"],
	create:ValueTypes["BodyTagWithoutCategoryCreateInput"]
};
	["ColorConnectOrCreateBodyTagCategoryRelationInput"]: {
	connect:ValueTypes["BodyTagCategoryUniqueWhere"],
	create:ValueTypes["BodyTagCategoryWithoutColorCreateInput"]
};
	["BlogPostTagConnectOrCreateColorRelationInput"]: {
	connect:ValueTypes["ColorUniqueWhere"],
	create:ValueTypes["ColorWithoutBlogPostTagCreateInput"]
};
	["BlogPostConnectOrCreateBlogPostTagsRelationInput"]: {
	connect:ValueTypes["BlogPostTagUniqueWhere"],
	create:ValueTypes["BlogPostTagWithoutBlogPostsCreateInput"]
};
	["ContentReferenceConnectOrCreateRelatedBlogPostRelationInput"]: {
	connect:ValueTypes["BlogPostUniqueWhere"],
	create:ValueTypes["BlogPostCreateInput"]
};
	["ContentReferenceCreateAdEntityRelationInput"]: {
	connect?:ValueTypes["AdUniqueWhere"] | null,
	create?:ValueTypes["AdWithoutContentReferencesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateAdRelationInput"] | null
};
	["AdWithoutContentReferencesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["AdCreateImageEntityRelationInput"] | null,
	isBrandSectionVisible?:boolean | null,
	isBlogPostSectionVisible?:boolean | null,
	isIngredientSectionVisible?:boolean | null,
	isResultsVisible?:boolean | null,
	isSearchVisible?:boolean | null,
	blogPosts?:ValueTypes["AdCreateBlogPostsEntityRelationInput"][],
	itemCategories?:ValueTypes["AdCreateItemCategoriesEntityRelationInput"][],
	brands?:ValueTypes["AdCreateBrandsEntityRelationInput"][],
	isActive?:boolean | null,
	link?:string | null,
	note?:string | null,
	activeFrom?:ValueTypes["DateTime"] | null,
	activeUntil?:ValueTypes["DateTime"] | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceConnectOrCreateAdRelationInput"]: {
	connect:ValueTypes["AdUniqueWhere"],
	create:ValueTypes["AdWithoutContentReferencesCreateInput"]
};
	["ContentBlockConnectOrCreateReferencesRelationInput"]: {
	connect:ValueTypes["ContentReferenceUniqueWhere"],
	create:ValueTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentConnectOrCreateBlocksRelationInput"]: {
	connect:ValueTypes["ContentBlockUniqueWhere"],
	create:ValueTypes["ContentBlockWithoutContentCreateInput"]
};
	["BlogPageConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["SeoConnectOrCreateBlogPageRelationInput"]: {
	connect:ValueTypes["BlogPageUniqueWhere"],
	create:ValueTypes["BlogPageWithoutSeoCreateInput"]
};
	["GenericPageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoWithoutGenericPageCreateInput"]
};
	["RedirectConnectOrCreateGenericPageRelationInput"]: {
	connect:ValueTypes["GenericPageUniqueWhere"],
	create:ValueTypes["GenericPageWithoutRedirectsCreateInput"]
};
	["BlogPageConnectOrCreateRedirectsRelationInput"]: {
	connect:ValueTypes["RedirectUniqueWhere"],
	create:ValueTypes["RedirectWithoutBlogPageCreateInput"]
};
	["BlogPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	redirects?:ValueTypes["BlogPageUpdateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["BlogPageUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["BlogPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPageUpdateRedirectsEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutBlogPageCreateInput"] | null,
	update?:ValueTypes["BlogPageUpdateRedirectsRelationInput"] | null,
	upsert?:ValueTypes["BlogPageUpsertRedirectsRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:ValueTypes["RedirectUniqueWhere"] | null,
	delete?:ValueTypes["RedirectUniqueWhere"] | null,
	alias?:string | null
};
	["BlogPageUpdateRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	data:ValueTypes["RedirectWithoutBlogPageUpdateInput"]
};
	["RedirectWithoutBlogPageUpdateInput"]: {
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectUpdateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectUpdateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectUpdateBrandsPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectUpdateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectUpdateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectUpdateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectUpdateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateGenericPageEntityRelationInput"]: {
	connect?:ValueTypes["GenericPageUniqueWhere"] | null,
	create?:ValueTypes["GenericPageWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateGenericPageRelationInput"] | null,
	update?:ValueTypes["GenericPageWithoutRedirectsUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertGenericPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GenericPageWithoutRedirectsUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["GenericPageUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["GenericPageUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["GenericPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["GenericPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GenericPageUpdateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutGenericPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["GenericPageConnectOrCreateLinkRelationInput"] | null,
	update?:ValueTypes["LinkableWithoutGenericPageUpdateInput"] | null,
	upsert?:ValueTypes["GenericPageUpsertLinkRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutGenericPageUpdateInput"]: {
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["GenericPageUpsertLinkRelationInput"]: {
	update:ValueTypes["LinkableWithoutGenericPageUpdateInput"],
	create:ValueTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutGenericPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["GenericPageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoWithoutGenericPageUpdateInput"] | null,
	upsert?:ValueTypes["GenericPageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoWithoutGenericPageUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoUpdateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoUpdateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoUpdateComparatorPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoUpdateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoUpdateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoUpdateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoUpdateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoUpdateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoUpdateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoUpdateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateOgImageRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertOgImageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageUpdateInput"]: {
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	remoteId?:string | null,
	hash?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoUpsertOgImageRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["SeoUpdateBlogPageEntityRelationInput"]: {
	connect?:ValueTypes["BlogPageUniqueWhere"] | null,
	create?:ValueTypes["BlogPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateBlogPageRelationInput"] | null,
	update?:ValueTypes["BlogPageWithoutSeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertBlogPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPageWithoutSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	redirects?:ValueTypes["BlogPageUpdateRedirectsEntityRelationInput"][],
	content?:ValueTypes["BlogPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPageUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPageConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["BlogPageUpsertContentRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentUpdateInput"]: {
	blocks?:ValueTypes["ContentUpdateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateBlocksRelationInput"] | null,
	upsert?:ValueTypes["ContentUpsertBlocksRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:ValueTypes["ContentBlockUniqueWhere"] | null,
	alias?:string | null
};
	["ContentUpdateBlocksRelationInput"]: {
	by:ValueTypes["ContentBlockUniqueWhere"],
	data:ValueTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"][],
	automatedContentBlockSlug?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null,
	update?:ValueTypes["ContentBlockUpdateReferencesRelationInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertReferencesRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by:ValueTypes["ContentReferenceUniqueWhere"],
	data:ValueTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fact?:string | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	relatedBlogPost?:ValueTypes["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceUpdateRelatedBrandEntityRelationInput"] | null,
	relatedProduct?:ValueTypes["ContentReferenceUpdateRelatedProductEntityRelationInput"] | null,
	relatedIngredient?:ValueTypes["ContentReferenceUpdateRelatedIngredientEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	badge?:string | null,
	longVersion?:boolean | null,
	relatedBrandFull?:ValueTypes["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"] | null,
	relatedProductFull?:ValueTypes["ContentReferenceUpdateRelatedProductFullEntityRelationInput"] | null,
	list?:ValueTypes["ContentReferenceUpdateListEntityRelationInput"][],
	outline?:ValueTypes["ContentReferenceUpdateOutlineEntityRelationInput"] | null,
	video?:ValueTypes["ContentReferenceUpdateVideoEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	defaultOpen?:boolean | null,
	badgeColor?:string | null,
	isMain?:boolean | null,
	ad?:ValueTypes["ContentReferenceUpdateAdEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateImagesEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceGalleryImageWithoutReferenceCreateInput"] | null,
	update?:ValueTypes["ContentReferenceUpdateImagesRelationInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertImagesRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceGalleryImageUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceGalleryImageUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceGalleryImageUniqueWhere"] | null,
	alias?:string | null
};
	["ContentReferenceUpdateImagesRelationInput"]: {
	by:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],
	data:ValueTypes["ContentReferenceGalleryImageWithoutReferenceUpdateInput"]
};
	["ContentReferenceGalleryImageWithoutReferenceUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["ContentReferenceGalleryImageUpdateImageEntityRelationInput"] | null,
	lead?:string | null,
	alignment?:ValueTypes["AlignmentType"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceGalleryImageUpdateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceGalleryImageConnectOrCreateImageRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceGalleryImageUpsertImageRelationInput"] | null,
	delete?:boolean | null
};
	["ContentReferenceGalleryImageUpsertImageRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["ContentReferenceUpsertImagesRelationInput"]: {
	by:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],
	update:ValueTypes["ContentReferenceGalleryImageWithoutReferenceUpdateInput"],
	create:ValueTypes["ContentReferenceGalleryImageWithoutReferenceCreateInput"]
};
	["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateRelatedBlogPostRelationInput"] | null,
	update?:ValueTypes["BlogPostUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertRelatedBlogPostRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPostUpdateInput"]: {
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostUpdateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostUpdateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostUpdateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostUpdateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostUpdateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostUpdateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostUpdateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostUpdateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostUpdateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostUpdateBlogPostTagsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostTagWithoutBlogPostsCreateInput"] | null,
	update?:ValueTypes["BlogPostUpdateBlogPostTagsRelationInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertBlogPostTagsRelationInput"] | null,
	connect?:ValueTypes["BlogPostTagUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostTagUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostTagUniqueWhere"] | null,
	alias?:string | null
};
	["BlogPostUpdateBlogPostTagsRelationInput"]: {
	by:ValueTypes["BlogPostTagUniqueWhere"],
	data:ValueTypes["BlogPostTagWithoutBlogPostsUpdateInput"]
};
	["BlogPostTagWithoutBlogPostsUpdateInput"]: {
	name?:string | null,
	remoteId?:string | null,
	color?:ValueTypes["BlogPostTagUpdateColorEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["BlogPostTagUpdateColorEntityRelationInput"]: {
	connect?:ValueTypes["ColorUniqueWhere"] | null,
	create?:ValueTypes["ColorWithoutBlogPostTagCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostTagConnectOrCreateColorRelationInput"] | null,
	update?:ValueTypes["ColorWithoutBlogPostTagUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostTagUpsertColorRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ColorWithoutBlogPostTagUpdateInput"]: {
	name?:string | null,
	colorHex?:string | null,
	bodyTagCategory?:ValueTypes["ColorUpdateBodyTagCategoryEntityRelationInput"] | null,
	remoteId?:string | null,
	itemFlavorCategories?:ValueTypes["ColorUpdateItemFlavorCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ColorUpdateBodyTagCategoryEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagCategoryUniqueWhere"] | null,
	create?:ValueTypes["BodyTagCategoryWithoutColorCreateInput"] | null,
	connectOrCreate?:ValueTypes["ColorConnectOrCreateBodyTagCategoryRelationInput"] | null,
	update?:ValueTypes["BodyTagCategoryWithoutColorUpdateInput"] | null,
	upsert?:ValueTypes["ColorUpsertBodyTagCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BodyTagCategoryWithoutColorUpdateInput"]: {
	name?:string | null,
	tags?:ValueTypes["BodyTagCategoryUpdateTagsEntityRelationInput"][],
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["BodyTagCategoryUpdateTagsEntityRelationInput"]: {
	create?:ValueTypes["BodyTagWithoutCategoryCreateInput"] | null,
	update?:ValueTypes["BodyTagCategoryUpdateTagsRelationInput"] | null,
	upsert?:ValueTypes["BodyTagCategoryUpsertTagsRelationInput"] | null,
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	disconnect?:ValueTypes["BodyTagUniqueWhere"] | null,
	delete?:ValueTypes["BodyTagUniqueWhere"] | null,
	alias?:string | null
};
	["BodyTagCategoryUpdateTagsRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	data:ValueTypes["BodyTagWithoutCategoryUpdateInput"]
};
	["BodyTagWithoutCategoryUpdateInput"]: {
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagUpdateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagUpdatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagUpdateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagUpdatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagUpdateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	icon?:ValueTypes["BodyTagUpdateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagUpdateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagUpdateBlogPostsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostWithoutTagsCreateInput"] | null,
	update?:ValueTypes["BodyTagUpdateBlogPostsRelationInput"] | null,
	upsert?:ValueTypes["BodyTagUpsertBlogPostsRelationInput"] | null,
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostUniqueWhere"] | null,
	alias?:string | null
};
	["BodyTagUpdateBlogPostsRelationInput"]: {
	by:ValueTypes["BlogPostUniqueWhere"],
	data:ValueTypes["BlogPostWithoutTagsUpdateInput"]
};
	["BlogPostWithoutTagsUpdateInput"]: {
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostUpdateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostUpdateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostUpdateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostUpdateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostUpdateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostUpdateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostUpdateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostUpdateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostUpdateReviewsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostReviewWithoutBlogPostCreateInput"] | null,
	update?:ValueTypes["BlogPostUpdateReviewsRelationInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertReviewsRelationInput"] | null,
	connect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	alias?:string | null
};
	["BlogPostUpdateReviewsRelationInput"]: {
	by:ValueTypes["BlogPostReviewUniqueWhere"],
	data:ValueTypes["BlogPostReviewWithoutBlogPostUpdateInput"]
};
	["BlogPostReviewWithoutBlogPostUpdateInput"]: {
	title?:string | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"][],
	user?:ValueTypes["BlogPostReviewUpdateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["BlogPostReviewUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["BlogPostReviewUpdateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostReviewReactionWithoutBlogPostReviewCreateInput"] | null,
	update?:ValueTypes["BlogPostReviewUpdateBlogPostReviewReactionsRelationInput"] | null,
	upsert?:ValueTypes["BlogPostReviewUpsertBlogPostReviewReactionsRelationInput"] | null,
	connect?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null,
	alias?:string | null
};
	["BlogPostReviewUpdateBlogPostReviewReactionsRelationInput"]: {
	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],
	data:ValueTypes["BlogPostReviewReactionWithoutBlogPostReviewUpdateInput"]
};
	["BlogPostReviewReactionWithoutBlogPostReviewUpdateInput"]: {
	sentiment?:ValueTypes["SentimentType"] | null,
	user?:ValueTypes["BlogPostReviewReactionUpdateUserEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewReactionUpdateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutBlogPostReviewReactionsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewReactionConnectOrCreateUserRelationInput"] | null,
	update?:ValueTypes["UserWithoutBlogPostReviewReactionsUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostReviewReactionUpsertUserRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UserWithoutBlogPostReviewReactionsUpdateInput"]: {
	dogs?:ValueTypes["UserUpdateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserUpdateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserUpdateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserUpdateProductReviewsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserUpdateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserUpdateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserUpdateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserUpdateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserUpdateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserUpdateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserUpdateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserUpdateDogsEntityRelationInput"]: {
	create?:ValueTypes["DogWithoutOwnerCreateInput"] | null,
	update?:ValueTypes["UserUpdateDogsRelationInput"] | null,
	upsert?:ValueTypes["UserUpsertDogsRelationInput"] | null,
	connect?:ValueTypes["DogUniqueWhere"] | null,
	disconnect?:ValueTypes["DogUniqueWhere"] | null,
	delete?:ValueTypes["DogUniqueWhere"] | null,
	alias?:string | null
};
	["UserUpdateDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	data:ValueTypes["DogWithoutOwnerUpdateInput"]
};
	["DogWithoutOwnerUpdateInput"]: {
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogUpdateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogUpdateBodyTypeEntityRelationInput"] | null,
	activity?:ValueTypes["DogUpdateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogUpdateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogUpdateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogUpdateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogUpdateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogUpdateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogUpdateBreedEntityRelationInput"]: {
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	create?:ValueTypes["BreedWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateBreedRelationInput"] | null,
	update?:ValueTypes["BreedWithoutDogsUpdateInput"] | null,
	upsert?:ValueTypes["DogUpsertBreedRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BreedWithoutDogsUpdateInput"]: {
	litterSize?:number | null,
	reviews?:ValueTypes["BreedUpdateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedUpdateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedUpdateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedUpdateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedUpdateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedUpdateReviewsEntityRelationInput"]: {
	create?:ValueTypes["ReviewWithoutDogBreedsCreateInput"] | null,
	update?:ValueTypes["BreedUpdateReviewsRelationInput"] | null,
	upsert?:ValueTypes["BreedUpsertReviewsRelationInput"] | null,
	connect?:ValueTypes["ReviewUniqueWhere"] | null,
	disconnect?:ValueTypes["ReviewUniqueWhere"] | null,
	delete?:ValueTypes["ReviewUniqueWhere"] | null,
	alias?:string | null
};
	["BreedUpdateReviewsRelationInput"]: {
	by:ValueTypes["ReviewUniqueWhere"],
	data:ValueTypes["ReviewWithoutDogBreedsUpdateInput"]
};
	["ReviewWithoutDogBreedsUpdateInput"]: {
	text?:string | null,
	remoteId?:string | null,
	author?:string | null,
	_dummy_field_?:boolean | null
};
	["BreedUpsertReviewsRelationInput"]: {
	by:ValueTypes["ReviewUniqueWhere"],
	update:ValueTypes["ReviewWithoutDogBreedsUpdateInput"],
	create:ValueTypes["ReviewWithoutDogBreedsCreateInput"]
};
	["BreedUpdateAgesEntityRelationInput"]: {
	create?:ValueTypes["AgeWithoutBreedsCreateInput"] | null,
	update?:ValueTypes["BreedUpdateAgesRelationInput"] | null,
	upsert?:ValueTypes["BreedUpsertAgesRelationInput"] | null,
	connect?:ValueTypes["AgeUniqueWhere"] | null,
	disconnect?:ValueTypes["AgeUniqueWhere"] | null,
	delete?:ValueTypes["AgeUniqueWhere"] | null,
	alias?:string | null
};
	["BreedUpdateAgesRelationInput"]: {
	by:ValueTypes["AgeUniqueWhere"],
	data:ValueTypes["AgeWithoutBreedsUpdateInput"]
};
	["AgeWithoutBreedsUpdateInput"]: {
	dogs?:ValueTypes["AgeUpdateDogsEntityRelationInput"][],
	ageRange?:ValueTypes["AgeRangeType"] | null,
	categoryLabel?:ValueTypes["AgeLabelType"] | null,
	suitabilityCategories?:ValueTypes["AgeUpdateSuitabilityCategoriesEntityRelationInput"][],
	remoteId?:string | null,
	productReviews?:ValueTypes["AgeUpdateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["AgeUpdateBlogPostReviewsEntityRelationInput"][],
	label?:string | null,
	categoryOrder?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeUpdateDogsEntityRelationInput"]: {
	create?:ValueTypes["DogWithoutAgeCreateInput"] | null,
	update?:ValueTypes["AgeUpdateDogsRelationInput"] | null,
	upsert?:ValueTypes["AgeUpsertDogsRelationInput"] | null,
	connect?:ValueTypes["DogUniqueWhere"] | null,
	disconnect?:ValueTypes["DogUniqueWhere"] | null,
	delete?:ValueTypes["DogUniqueWhere"] | null,
	alias?:string | null
};
	["AgeUpdateDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	data:ValueTypes["DogWithoutAgeUpdateInput"]
};
	["DogWithoutAgeUpdateInput"]: {
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogUpdateBreedEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogUpdateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogUpdateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogUpdateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogUpdateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogUpdateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogUpdateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogUpdateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogUpdateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogUpdateBodyTypeEntityRelationInput"]: {
	connect?:ValueTypes["DogBodyTypeUniqueWhere"] | null,
	create?:ValueTypes["DogBodyTypeWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateBodyTypeRelationInput"] | null,
	update?:ValueTypes["DogBodyTypeWithoutDogsUpdateInput"] | null,
	upsert?:ValueTypes["DogUpsertBodyTypeRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DogBodyTypeWithoutDogsUpdateInput"]: {
	name?:string | null,
	lead?:string | null,
	order?:number | null,
	value?:number | null,
	remoteId?:string | null,
	category?:ValueTypes["DogBodyTypeUpdateCategoryEntityRelationInput"] | null,
	imageMain?:ValueTypes["DogBodyTypeUpdateImageMainEntityRelationInput"] | null,
	imageFrom?:ValueTypes["DogBodyTypeUpdateImageFromEntityRelationInput"] | null,
	imageTo?:ValueTypes["DogBodyTypeUpdateImageToEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogBodyTypeUpdateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["DogBodyTypeCategoryUniqueWhere"] | null,
	create?:ValueTypes["DogBodyTypeCategoryWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogBodyTypeConnectOrCreateCategoryRelationInput"] | null,
	update?:ValueTypes["DogBodyTypeCategoryWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["DogBodyTypeUpsertCategoryRelationInput"] | null,
	delete?:boolean | null
};
	["DogBodyTypeCategoryWithoutItemsUpdateInput"]: {
	name?:string | null,
	remoteId?:string | null,
	imageMain?:ValueTypes["DogBodyTypeCategoryUpdateImageMainEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogBodyTypeCategoryUpdateImageMainEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogBodyTypeCategoryConnectOrCreateImageMainRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["DogBodyTypeCategoryUpsertImageMainRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DogBodyTypeCategoryUpsertImageMainRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["DogBodyTypeUpsertCategoryRelationInput"]: {
	update:ValueTypes["DogBodyTypeCategoryWithoutItemsUpdateInput"],
	create:ValueTypes["DogBodyTypeCategoryWithoutItemsCreateInput"]
};
	["DogBodyTypeUpdateImageMainEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogBodyTypeConnectOrCreateImageMainRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["DogBodyTypeUpsertImageMainRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DogBodyTypeUpsertImageMainRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["DogBodyTypeUpdateImageFromEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogBodyTypeConnectOrCreateImageFromRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["DogBodyTypeUpsertImageFromRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DogBodyTypeUpsertImageFromRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["DogBodyTypeUpdateImageToEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogBodyTypeConnectOrCreateImageToRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["DogBodyTypeUpsertImageToRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DogBodyTypeUpsertImageToRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["DogUpsertBodyTypeRelationInput"]: {
	update:ValueTypes["DogBodyTypeWithoutDogsUpdateInput"],
	create:ValueTypes["DogBodyTypeWithoutDogsCreateInput"]
};
	["DogUpdateOwnerEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateOwnerRelationInput"] | null,
	update?:ValueTypes["UserWithoutDogsUpdateInput"] | null,
	upsert?:ValueTypes["DogUpsertOwnerRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UserWithoutDogsUpdateInput"]: {
	veterinary?:ValueTypes["UserUpdateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserUpdateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserUpdateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserUpdateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserUpdateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserUpdateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserUpdateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserUpdateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserUpdateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserUpdateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserUpdateVeterinaryEntityRelationInput"]: {
	connect?:ValueTypes["VeterinaryUniqueWhere"] | null,
	create?:ValueTypes["VeterinaryWithoutUserCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateVeterinaryRelationInput"] | null,
	update?:ValueTypes["VeterinaryWithoutUserUpdateInput"] | null,
	upsert?:ValueTypes["UserUpsertVeterinaryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["VeterinaryWithoutUserUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["UserUpsertVeterinaryRelationInput"]: {
	update:ValueTypes["VeterinaryWithoutUserUpdateInput"],
	create:ValueTypes["VeterinaryWithoutUserCreateInput"]
};
	["UserUpdateBlogPostReviewsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostReviewWithoutUserCreateInput"] | null,
	update?:ValueTypes["UserUpdateBlogPostReviewsRelationInput"] | null,
	upsert?:ValueTypes["UserUpsertBlogPostReviewsRelationInput"] | null,
	connect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	alias?:string | null
};
	["UserUpdateBlogPostReviewsRelationInput"]: {
	by:ValueTypes["BlogPostReviewUniqueWhere"],
	data:ValueTypes["BlogPostReviewWithoutUserUpdateInput"]
};
	["BlogPostReviewWithoutUserUpdateInput"]: {
	title?:string | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"][],
	blogPost?:ValueTypes["BlogPostReviewUpdateBlogPostEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["BlogPostReviewUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["BlogPostReviewUpdateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewUpdateBlogPostEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostWithoutReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewConnectOrCreateBlogPostRelationInput"] | null,
	update?:ValueTypes["BlogPostWithoutReviewsUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostReviewUpsertBlogPostRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPostWithoutReviewsUpdateInput"]: {
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostUpdateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	itemCategories?:ValueTypes["BlogPostUpdateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostUpdateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostUpdateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostUpdateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostUpdateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostUpdateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostUpdateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostUpdateTagsEntityRelationInput"]: {
	create?:ValueTypes["BodyTagWithoutBlogPostsCreateInput"] | null,
	update?:ValueTypes["BlogPostUpdateTagsRelationInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertTagsRelationInput"] | null,
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	disconnect?:ValueTypes["BodyTagUniqueWhere"] | null,
	delete?:ValueTypes["BodyTagUniqueWhere"] | null,
	alias?:string | null
};
	["BlogPostUpdateTagsRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	data:ValueTypes["BodyTagWithoutBlogPostsUpdateInput"]
};
	["BodyTagWithoutBlogPostsUpdateInput"]: {
	name?:string | null,
	positiveProducts?:ValueTypes["BodyTagUpdatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagUpdateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagUpdatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagUpdateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagUpdateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagUpdateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagUpdateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagUpdatePositiveProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductWithoutPositiveForBodyTagsCreateInput"] | null,
	update?:ValueTypes["BodyTagUpdatePositiveProductsRelationInput"] | null,
	upsert?:ValueTypes["BodyTagUpsertPositiveProductsRelationInput"] | null,
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductUniqueWhere"] | null,
	alias?:string | null
};
	["BodyTagUpdatePositiveProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	data:ValueTypes["ProductWithoutPositiveForBodyTagsUpdateInput"]
};
	["ProductWithoutPositiveForBodyTagsUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdateNutritionalValuesEntityRelationInput"]: {
	create?:ValueTypes["NutritionalValueOfProductWithoutProductCreateInput"] | null,
	update?:ValueTypes["ProductUpdateNutritionalValuesRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertNutritionalValuesRelationInput"] | null,
	connect?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null,
	disconnect?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null,
	delete?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateNutritionalValuesRelationInput"]: {
	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],
	data:ValueTypes["NutritionalValueOfProductWithoutProductUpdateInput"]
};
	["NutritionalValueOfProductWithoutProductUpdateInput"]: {
	order?:number | null,
	amount?:number | null,
	remoteId?:string | null,
	nutritionalValue?:ValueTypes["NutritionalValueOfProductUpdateNutritionalValueEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NutritionalValueOfProductUpdateNutritionalValueEntityRelationInput"]: {
	connect?:ValueTypes["NutritionalValueUniqueWhere"] | null,
	create?:ValueTypes["NutritionalValueWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["NutritionalValueOfProductConnectOrCreateNutritionalValueRelationInput"] | null,
	update?:ValueTypes["NutritionalValueWithoutProductsUpdateInput"] | null,
	upsert?:ValueTypes["NutritionalValueOfProductUpsertNutritionalValueRelationInput"] | null,
	delete?:boolean | null
};
	["NutritionalValueWithoutProductsUpdateInput"]: {
	name?:string | null,
	suitabilityNutritionalValues?:ValueTypes["NutritionalValueUpdateSuitabilityNutritionalValuesEntityRelationInput"][],
	remoteId?:string | null,
	icon?:ValueTypes["NutritionalValueUpdateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NutritionalValueUpdateSuitabilityNutritionalValuesEntityRelationInput"]: {
	create?:ValueTypes["SuitabilityItemWithoutNutritionalValueCreateInput"] | null,
	update?:ValueTypes["NutritionalValueUpdateSuitabilityNutritionalValuesRelationInput"] | null,
	upsert?:ValueTypes["NutritionalValueUpsertSuitabilityNutritionalValuesRelationInput"] | null,
	connect?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	disconnect?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	delete?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	alias?:string | null
};
	["NutritionalValueUpdateSuitabilityNutritionalValuesRelationInput"]: {
	by:ValueTypes["SuitabilityItemUniqueWhere"],
	data:ValueTypes["SuitabilityItemWithoutNutritionalValueUpdateInput"]
};
	["SuitabilityItemWithoutNutritionalValueUpdateInput"]: {
	min?:number | null,
	max?:number | null,
	remoteId?:string | null,
	order?:number | null,
	element?:ValueTypes["SuitabilityItemUpdateElementEntityRelationInput"] | null,
	category?:ValueTypes["SuitabilityItemUpdateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityItemUpdateElementEntityRelationInput"]: {
	connect?:ValueTypes["ElementUniqueWhere"] | null,
	create?:ValueTypes["ElementWithoutSuitabilityElementsCreateInput"] | null,
	connectOrCreate?:ValueTypes["SuitabilityItemConnectOrCreateElementRelationInput"] | null,
	update?:ValueTypes["ElementWithoutSuitabilityElementsUpdateInput"] | null,
	upsert?:ValueTypes["SuitabilityItemUpsertElementRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ElementWithoutSuitabilityElementsUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["ElementUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ElementUpdateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	unit?:string | null,
	filterOrder?:number | null,
	slug?:string | null,
	declensionSeventh?:string | null,
	_dummy_field_?:boolean | null
};
	["ElementUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["ElementOfProductWithoutElementCreateInput"] | null,
	update?:ValueTypes["ElementUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["ElementUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["ElementOfProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ElementOfProductUniqueWhere"] | null,
	delete?:ValueTypes["ElementOfProductUniqueWhere"] | null,
	alias?:string | null
};
	["ElementUpdateProductsRelationInput"]: {
	by:ValueTypes["ElementOfProductUniqueWhere"],
	data:ValueTypes["ElementOfProductWithoutElementUpdateInput"]
};
	["ElementOfProductWithoutElementUpdateInput"]: {
	order?:number | null,
	amount?:number | null,
	product?:ValueTypes["ElementOfProductUpdateProductEntityRelationInput"] | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ElementOfProductUpdateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutElementsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ElementOfProductConnectOrCreateProductRelationInput"] | null,
	update?:ValueTypes["ProductWithoutElementsUpdateInput"] | null,
	upsert?:ValueTypes["ElementOfProductUpsertProductRelationInput"] | null,
	delete?:boolean | null
};
	["ProductWithoutElementsUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdatePositiveForBodyTagsEntityRelationInput"]: {
	create?:ValueTypes["BodyTagWithoutPositiveProductsCreateInput"] | null,
	update?:ValueTypes["ProductUpdatePositiveForBodyTagsRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertPositiveForBodyTagsRelationInput"] | null,
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	disconnect?:ValueTypes["BodyTagUniqueWhere"] | null,
	delete?:ValueTypes["BodyTagUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdatePositiveForBodyTagsRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	data:ValueTypes["BodyTagWithoutPositiveProductsUpdateInput"]
};
	["BodyTagWithoutPositiveProductsUpdateInput"]: {
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagUpdateBlogPostsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagUpdateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagUpdatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagUpdateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagUpdateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagUpdateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagUpdateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagUpdateNegativeProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductWithoutNegativeForBodyTagsCreateInput"] | null,
	update?:ValueTypes["BodyTagUpdateNegativeProductsRelationInput"] | null,
	upsert?:ValueTypes["BodyTagUpsertNegativeProductsRelationInput"] | null,
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductUniqueWhere"] | null,
	alias?:string | null
};
	["BodyTagUpdateNegativeProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	data:ValueTypes["ProductWithoutNegativeForBodyTagsUpdateInput"]
};
	["ProductWithoutNegativeForBodyTagsUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdateReviewsEntityRelationInput"]: {
	create?:ValueTypes["ProductReviewWithoutProductCreateInput"] | null,
	update?:ValueTypes["ProductUpdateReviewsRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertReviewsRelationInput"] | null,
	connect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	delete?:ValueTypes["ProductReviewUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateReviewsRelationInput"]: {
	by:ValueTypes["ProductReviewUniqueWhere"],
	data:ValueTypes["ProductReviewWithoutProductUpdateInput"]
};
	["ProductReviewWithoutProductUpdateInput"]: {
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	productReviewReactions?:ValueTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"][],
	score?:ValueTypes["ProductReviewUpdateScoreEntityRelationInput"] | null,
	user?:ValueTypes["ProductReviewUpdateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["ProductReviewUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["ProductReviewUpdateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewUpdateProductReviewReactionsEntityRelationInput"]: {
	create?:ValueTypes["ProductReviewReactionWithoutProductReviewCreateInput"] | null,
	update?:ValueTypes["ProductReviewUpdateProductReviewReactionsRelationInput"] | null,
	upsert?:ValueTypes["ProductReviewUpsertProductReviewReactionsRelationInput"] | null,
	connect?:ValueTypes["ProductReviewReactionUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductReviewReactionUniqueWhere"] | null,
	delete?:ValueTypes["ProductReviewReactionUniqueWhere"] | null,
	alias?:string | null
};
	["ProductReviewUpdateProductReviewReactionsRelationInput"]: {
	by:ValueTypes["ProductReviewReactionUniqueWhere"],
	data:ValueTypes["ProductReviewReactionWithoutProductReviewUpdateInput"]
};
	["ProductReviewReactionWithoutProductReviewUpdateInput"]: {
	sentiment?:ValueTypes["SentimentType"] | null,
	user?:ValueTypes["ProductReviewReactionUpdateUserEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewReactionUpdateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutProductReviewReactionsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewReactionConnectOrCreateUserRelationInput"] | null,
	update?:ValueTypes["UserWithoutProductReviewReactionsUpdateInput"] | null,
	upsert?:ValueTypes["ProductReviewReactionUpsertUserRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UserWithoutProductReviewReactionsUpdateInput"]: {
	dogs?:ValueTypes["UserUpdateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserUpdateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserUpdateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserUpdateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserUpdateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserUpdateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserUpdateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserUpdateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserUpdateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserUpdateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserUpdateProductReviewsEntityRelationInput"]: {
	create?:ValueTypes["ProductReviewWithoutUserCreateInput"] | null,
	update?:ValueTypes["UserUpdateProductReviewsRelationInput"] | null,
	upsert?:ValueTypes["UserUpsertProductReviewsRelationInput"] | null,
	connect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	delete?:ValueTypes["ProductReviewUniqueWhere"] | null,
	alias?:string | null
};
	["UserUpdateProductReviewsRelationInput"]: {
	by:ValueTypes["ProductReviewUniqueWhere"],
	data:ValueTypes["ProductReviewWithoutUserUpdateInput"]
};
	["ProductReviewWithoutUserUpdateInput"]: {
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	productReviewReactions?:ValueTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"][],
	score?:ValueTypes["ProductReviewUpdateScoreEntityRelationInput"] | null,
	product?:ValueTypes["ProductReviewUpdateProductEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["ProductReviewUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["ProductReviewUpdateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewUpdateScoreEntityRelationInput"]: {
	connect?:ValueTypes["ScoreUniqueWhere"] | null,
	create?:ValueTypes["ScoreWithoutProductReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewConnectOrCreateScoreRelationInput"] | null,
	update?:ValueTypes["ScoreWithoutProductReviewsUpdateInput"] | null,
	upsert?:ValueTypes["ProductReviewUpsertScoreRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ScoreWithoutProductReviewsUpdateInput"]: {
	label?:string | null,
	starsAmount?:number | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewUpsertScoreRelationInput"]: {
	update:ValueTypes["ScoreWithoutProductReviewsUpdateInput"],
	create:ValueTypes["ScoreWithoutProductReviewsCreateInput"]
};
	["ProductReviewUpdateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewConnectOrCreateProductRelationInput"] | null,
	update?:ValueTypes["ProductWithoutReviewsUpdateInput"] | null,
	upsert?:ValueTypes["ProductReviewUpsertProductRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductWithoutReviewsUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdateNegativeForBodyTagsEntityRelationInput"]: {
	create?:ValueTypes["BodyTagWithoutNegativeProductsCreateInput"] | null,
	update?:ValueTypes["ProductUpdateNegativeForBodyTagsRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertNegativeForBodyTagsRelationInput"] | null,
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	disconnect?:ValueTypes["BodyTagUniqueWhere"] | null,
	delete?:ValueTypes["BodyTagUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateNegativeForBodyTagsRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	data:ValueTypes["BodyTagWithoutNegativeProductsUpdateInput"]
};
	["BodyTagWithoutNegativeProductsUpdateInput"]: {
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagUpdateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagUpdatePositiveProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagUpdatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagUpdateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagUpdateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagUpdateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagUpdateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagUpdatePositiveItemsEntityRelationInput"]: {
	create?:ValueTypes["ItemWithoutPositiveForBodyTagsCreateInput"] | null,
	update?:ValueTypes["BodyTagUpdatePositiveItemsRelationInput"] | null,
	upsert?:ValueTypes["BodyTagUpsertPositiveItemsRelationInput"] | null,
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemUniqueWhere"] | null,
	delete?:ValueTypes["ItemUniqueWhere"] | null,
	alias?:string | null
};
	["BodyTagUpdatePositiveItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	data:ValueTypes["ItemWithoutPositiveForBodyTagsUpdateInput"]
};
	["ItemWithoutPositiveForBodyTagsUpdateInput"]: {
	name?:string | null,
	negativeForBodyTags?:ValueTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemUpdateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemUpdateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemUpdateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemUpdateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemUpdateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemUpdateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemUpdateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemUpdateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemUpdateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemUpdateNegativeForBodyTagsEntityRelationInput"]: {
	create?:ValueTypes["BodyTagWithoutNegativeItemsCreateInput"] | null,
	update?:ValueTypes["ItemUpdateNegativeForBodyTagsRelationInput"] | null,
	upsert?:ValueTypes["ItemUpsertNegativeForBodyTagsRelationInput"] | null,
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	disconnect?:ValueTypes["BodyTagUniqueWhere"] | null,
	delete?:ValueTypes["BodyTagUniqueWhere"] | null,
	alias?:string | null
};
	["ItemUpdateNegativeForBodyTagsRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	data:ValueTypes["BodyTagWithoutNegativeItemsUpdateInput"]
};
	["BodyTagWithoutNegativeItemsUpdateInput"]: {
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagUpdateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagUpdatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagUpdateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagUpdatePositiveItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagUpdateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagUpdateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagUpdateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagUpdateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagCategoryUniqueWhere"] | null,
	create?:ValueTypes["BodyTagCategoryWithoutTagsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagConnectOrCreateCategoryRelationInput"] | null,
	update?:ValueTypes["BodyTagCategoryWithoutTagsUpdateInput"] | null,
	upsert?:ValueTypes["BodyTagUpsertCategoryRelationInput"] | null,
	delete?:boolean | null
};
	["BodyTagCategoryWithoutTagsUpdateInput"]: {
	name?:string | null,
	remoteId?:string | null,
	color?:ValueTypes["BodyTagCategoryUpdateColorEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BodyTagCategoryUpdateColorEntityRelationInput"]: {
	connect?:ValueTypes["ColorUniqueWhere"] | null,
	create?:ValueTypes["ColorWithoutBodyTagCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagCategoryConnectOrCreateColorRelationInput"] | null,
	update?:ValueTypes["ColorWithoutBodyTagCategoryUpdateInput"] | null,
	upsert?:ValueTypes["BodyTagCategoryUpsertColorRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ColorWithoutBodyTagCategoryUpdateInput"]: {
	name?:string | null,
	colorHex?:string | null,
	blogPostTag?:ValueTypes["ColorUpdateBlogPostTagEntityRelationInput"] | null,
	remoteId?:string | null,
	itemFlavorCategories?:ValueTypes["ColorUpdateItemFlavorCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ColorUpdateBlogPostTagEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostTagUniqueWhere"] | null,
	create?:ValueTypes["BlogPostTagWithoutColorCreateInput"] | null,
	connectOrCreate?:ValueTypes["ColorConnectOrCreateBlogPostTagRelationInput"] | null,
	update?:ValueTypes["BlogPostTagWithoutColorUpdateInput"] | null,
	upsert?:ValueTypes["ColorUpsertBlogPostTagRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPostTagWithoutColorUpdateInput"]: {
	name?:string | null,
	blogPosts?:ValueTypes["BlogPostTagUpdateBlogPostsEntityRelationInput"][],
	remoteId?:string | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["BlogPostTagUpdateBlogPostsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostWithoutBlogPostTagsCreateInput"] | null,
	update?:ValueTypes["BlogPostTagUpdateBlogPostsRelationInput"] | null,
	upsert?:ValueTypes["BlogPostTagUpsertBlogPostsRelationInput"] | null,
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostUniqueWhere"] | null,
	alias?:string | null
};
	["BlogPostTagUpdateBlogPostsRelationInput"]: {
	by:ValueTypes["BlogPostUniqueWhere"],
	data:ValueTypes["BlogPostWithoutBlogPostTagsUpdateInput"]
};
	["BlogPostWithoutBlogPostTagsUpdateInput"]: {
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	tags?:ValueTypes["BlogPostUpdateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostUpdateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostUpdateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostUpdateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostUpdateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostUpdateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostUpdateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostUpdateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostUpdateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostUpdateItemCategoriesEntityRelationInput"]: {
	create?:ValueTypes["ItemCategoryWithoutBlogPostsCreateInput"] | null,
	update?:ValueTypes["BlogPostUpdateItemCategoriesRelationInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertItemCategoriesRelationInput"] | null,
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["BlogPostUpdateItemCategoriesRelationInput"]: {
	by:ValueTypes["ItemCategoryUniqueWhere"],
	data:ValueTypes["ItemCategoryWithoutBlogPostsUpdateInput"]
};
	["ItemCategoryWithoutBlogPostsUpdateInput"]: {
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryUpdateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryUpdateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryUpdateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryUpdateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryUpdateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryUpdateSubCategoriesEntityRelationInput"]: {
	create?:ValueTypes["ItemSubCategoryWithoutCategoryCreateInput"] | null,
	update?:ValueTypes["ItemCategoryUpdateSubCategoriesRelationInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertSubCategoriesRelationInput"] | null,
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ItemCategoryUpdateSubCategoriesRelationInput"]: {
	by:ValueTypes["ItemSubCategoryUniqueWhere"],
	data:ValueTypes["ItemSubCategoryWithoutCategoryUpdateInput"]
};
	["ItemSubCategoryWithoutCategoryUpdateInput"]: {
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryUpdateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	flavorCategory?:ValueTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryUpdateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryUpdateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ItemWithoutSubCategoriesCreateInput"] | null,
	update?:ValueTypes["ItemSubCategoryUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ItemSubCategoryUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemUniqueWhere"] | null,
	delete?:ValueTypes["ItemUniqueWhere"] | null,
	alias?:string | null
};
	["ItemSubCategoryUpdateItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	data:ValueTypes["ItemWithoutSubCategoriesUpdateInput"]
};
	["ItemWithoutSubCategoriesUpdateInput"]: {
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"][],
	categories?:ValueTypes["ItemUpdateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemUpdateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemUpdateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemUpdateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemUpdateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemUpdateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemUpdateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemUpdateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemUpdatePositiveForBodyTagsEntityRelationInput"]: {
	create?:ValueTypes["BodyTagWithoutPositiveItemsCreateInput"] | null,
	update?:ValueTypes["ItemUpdatePositiveForBodyTagsRelationInput"] | null,
	upsert?:ValueTypes["ItemUpsertPositiveForBodyTagsRelationInput"] | null,
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	disconnect?:ValueTypes["BodyTagUniqueWhere"] | null,
	delete?:ValueTypes["BodyTagUniqueWhere"] | null,
	alias?:string | null
};
	["ItemUpdatePositiveForBodyTagsRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	data:ValueTypes["BodyTagWithoutPositiveItemsUpdateInput"]
};
	["BodyTagWithoutPositiveItemsUpdateInput"]: {
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagUpdateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagUpdatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagUpdateNegativeProductsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagUpdateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagUpdateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagUpdateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagUpdateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagUpdateNegativeItemsEntityRelationInput"]: {
	create?:ValueTypes["ItemWithoutNegativeForBodyTagsCreateInput"] | null,
	update?:ValueTypes["BodyTagUpdateNegativeItemsRelationInput"] | null,
	upsert?:ValueTypes["BodyTagUpsertNegativeItemsRelationInput"] | null,
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemUniqueWhere"] | null,
	delete?:ValueTypes["ItemUniqueWhere"] | null,
	alias?:string | null
};
	["BodyTagUpdateNegativeItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	data:ValueTypes["ItemWithoutNegativeForBodyTagsUpdateInput"]
};
	["ItemWithoutNegativeForBodyTagsUpdateInput"]: {
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemUpdateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemUpdateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemUpdateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemUpdateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemUpdateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemUpdateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemUpdateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemUpdateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemUpdateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemUpdateSubCategoriesEntityRelationInput"]: {
	create?:ValueTypes["ItemSubCategoryWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ItemUpdateSubCategoriesRelationInput"] | null,
	upsert?:ValueTypes["ItemUpsertSubCategoriesRelationInput"] | null,
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ItemUpdateSubCategoriesRelationInput"]: {
	by:ValueTypes["ItemSubCategoryUniqueWhere"],
	data:ValueTypes["ItemSubCategoryWithoutItemsUpdateInput"]
};
	["ItemSubCategoryWithoutItemsUpdateInput"]: {
	name?:string | null,
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryUpdateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryUpdateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductWithoutItemSubCategoriesCreateInput"] | null,
	update?:ValueTypes["ItemSubCategoryUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["ItemSubCategoryUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductUniqueWhere"] | null,
	alias?:string | null
};
	["ItemSubCategoryUpdateProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	data:ValueTypes["ProductWithoutItemSubCategoriesUpdateInput"]
};
	["ProductWithoutItemSubCategoriesUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdateDogsEntityRelationInput"]: {
	create?:ValueTypes["DogWithoutFedProductCreateInput"] | null,
	update?:ValueTypes["ProductUpdateDogsRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertDogsRelationInput"] | null,
	connect?:ValueTypes["DogUniqueWhere"] | null,
	disconnect?:ValueTypes["DogUniqueWhere"] | null,
	delete?:ValueTypes["DogUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	data:ValueTypes["DogWithoutFedProductUpdateInput"]
};
	["DogWithoutFedProductUpdateInput"]: {
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogUpdateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogUpdateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogUpdateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogUpdateActivityEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogUpdateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogUpdateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogUpdateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogUpdateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogUpdateAgeEntityRelationInput"]: {
	connect?:ValueTypes["AgeUniqueWhere"] | null,
	create?:ValueTypes["AgeWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateAgeRelationInput"] | null,
	update?:ValueTypes["AgeWithoutDogsUpdateInput"] | null,
	upsert?:ValueTypes["DogUpsertAgeRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AgeWithoutDogsUpdateInput"]: {
	breeds?:ValueTypes["AgeUpdateBreedsEntityRelationInput"][],
	ageRange?:ValueTypes["AgeRangeType"] | null,
	categoryLabel?:ValueTypes["AgeLabelType"] | null,
	suitabilityCategories?:ValueTypes["AgeUpdateSuitabilityCategoriesEntityRelationInput"][],
	remoteId?:string | null,
	productReviews?:ValueTypes["AgeUpdateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["AgeUpdateBlogPostReviewsEntityRelationInput"][],
	label?:string | null,
	categoryOrder?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeUpdateBreedsEntityRelationInput"]: {
	create?:ValueTypes["BreedWithoutAgesCreateInput"] | null,
	update?:ValueTypes["AgeUpdateBreedsRelationInput"] | null,
	upsert?:ValueTypes["AgeUpsertBreedsRelationInput"] | null,
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	disconnect?:ValueTypes["BreedUniqueWhere"] | null,
	delete?:ValueTypes["BreedUniqueWhere"] | null,
	alias?:string | null
};
	["AgeUpdateBreedsRelationInput"]: {
	by:ValueTypes["BreedUniqueWhere"],
	data:ValueTypes["BreedWithoutAgesUpdateInput"]
};
	["BreedWithoutAgesUpdateInput"]: {
	dogs?:ValueTypes["BreedUpdateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedUpdateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedUpdateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedUpdateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedUpdateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedUpdateDogsEntityRelationInput"]: {
	create?:ValueTypes["DogWithoutBreedCreateInput"] | null,
	update?:ValueTypes["BreedUpdateDogsRelationInput"] | null,
	upsert?:ValueTypes["BreedUpsertDogsRelationInput"] | null,
	connect?:ValueTypes["DogUniqueWhere"] | null,
	disconnect?:ValueTypes["DogUniqueWhere"] | null,
	delete?:ValueTypes["DogUniqueWhere"] | null,
	alias?:string | null
};
	["BreedUpdateDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	data:ValueTypes["DogWithoutBreedUpdateInput"]
};
	["DogWithoutBreedUpdateInput"]: {
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	age?:ValueTypes["DogUpdateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogUpdateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogUpdateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogUpdateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogUpdateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogUpdateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogUpdateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogUpdateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogUpdateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogUpdateActivityEntityRelationInput"]: {
	connect?:ValueTypes["DogActivityUniqueWhere"] | null,
	create?:ValueTypes["DogActivityWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateActivityRelationInput"] | null,
	update?:ValueTypes["DogActivityWithoutDogsUpdateInput"] | null,
	upsert?:ValueTypes["DogUpsertActivityRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DogActivityWithoutDogsUpdateInput"]: {
	label?:string | null,
	products?:ValueTypes["DogActivityUpdateProductsEntityRelationInput"][],
	dailyEnergyRequirementCoeficient?:number | null,
	remoteId?:string | null,
	suitabilityCategory?:ValueTypes["DogActivityUpdateSuitabilityCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogActivityUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductWithoutRecommendedActivityCreateInput"] | null,
	update?:ValueTypes["DogActivityUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["DogActivityUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductUniqueWhere"] | null,
	alias?:string | null
};
	["DogActivityUpdateProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	data:ValueTypes["ProductWithoutRecommendedActivityUpdateInput"]
};
	["ProductWithoutRecommendedActivityUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdatePackagingsEntityRelationInput"]: {
	create?:ValueTypes["ProductPackageWithoutProductCreateInput"] | null,
	update?:ValueTypes["ProductUpdatePackagingsRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertPackagingsRelationInput"] | null,
	connect?:ValueTypes["ProductPackageUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductPackageUniqueWhere"] | null,
	delete?:ValueTypes["ProductPackageUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdatePackagingsRelationInput"]: {
	by:ValueTypes["ProductPackageUniqueWhere"],
	data:ValueTypes["ProductPackageWithoutProductUpdateInput"]
};
	["ProductPackageWithoutProductUpdateInput"]: {
	price?:number | null,
	order?:number | null,
	link?:string | null,
	amount?:number | null,
	externalId?:string | null,
	remoteId?:string | null,
	label?:string | null,
	positionId?:string | null,
	heurekaPrice?:number | null,
	heurekaLink?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductUpsertPackagingsRelationInput"]: {
	by:ValueTypes["ProductPackageUniqueWhere"],
	update:ValueTypes["ProductPackageWithoutProductUpdateInput"],
	create:ValueTypes["ProductPackageWithoutProductCreateInput"]
};
	["ProductUpdateItemSubCategoriesEntityRelationInput"]: {
	create?:ValueTypes["ItemSubCategoryWithoutProductsCreateInput"] | null,
	update?:ValueTypes["ProductUpdateItemSubCategoriesRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertItemSubCategoriesRelationInput"] | null,
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateItemSubCategoriesRelationInput"]: {
	by:ValueTypes["ItemSubCategoryUniqueWhere"],
	data:ValueTypes["ItemSubCategoryWithoutProductsUpdateInput"]
};
	["ItemSubCategoryWithoutProductsUpdateInput"]: {
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryUpdateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	featureDependencies?:ValueTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryUpdateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryUpdateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"]: {
	create?:ValueTypes["ProductFeatureWithoutDependentSubCategoryCreateInput"] | null,
	update?:ValueTypes["ItemSubCategoryUpdateFeatureDependenciesRelationInput"] | null,
	upsert?:ValueTypes["ItemSubCategoryUpsertFeatureDependenciesRelationInput"] | null,
	connect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	delete?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	alias?:string | null
};
	["ItemSubCategoryUpdateFeatureDependenciesRelationInput"]: {
	by:ValueTypes["ProductFeatureUniqueWhere"],
	data:ValueTypes["ProductFeatureWithoutDependentSubCategoryUpdateInput"]
};
	["ProductFeatureWithoutDependentSubCategoryUpdateInput"]: {
	text?:string | null,
	category?:ValueTypes["FeatureCategoryType"] | null,
	value?:ValueTypes["FeatureValueType"] | null,
	remoteId?:string | null,
	linkItem?:ValueTypes["ProductFeatureUpdateLinkItemEntityRelationInput"] | null,
	dependentElement?:ValueTypes["ProductFeatureUpdateDependentElementEntityRelationInput"] | null,
	dependentCategory?:ValueTypes["ProductFeatureUpdateDependentCategoryEntityRelationInput"] | null,
	dependentFlag?:ValueTypes["ProductFeatureUpdateDependentFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFeatureUpdateLinkItemEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemWithoutFeaturesOfProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFeatureConnectOrCreateLinkItemRelationInput"] | null,
	update?:ValueTypes["ItemWithoutFeaturesOfProductUpdateInput"] | null,
	upsert?:ValueTypes["ProductFeatureUpsertLinkItemRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemWithoutFeaturesOfProductUpdateInput"]: {
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemUpdateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemUpdateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemUpdateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemUpdateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemUpdateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemUpdateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemUpdateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemUpdateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemUpdateCategoriesEntityRelationInput"]: {
	create?:ValueTypes["ItemCategoryWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ItemUpdateCategoriesRelationInput"] | null,
	upsert?:ValueTypes["ItemUpsertCategoriesRelationInput"] | null,
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ItemUpdateCategoriesRelationInput"]: {
	by:ValueTypes["ItemCategoryUniqueWhere"],
	data:ValueTypes["ItemCategoryWithoutItemsUpdateInput"]
};
	["ItemCategoryWithoutItemsUpdateInput"]: {
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryUpdateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryUpdateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryUpdateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryUpdateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryUpdateBlogPostsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostWithoutItemCategoriesCreateInput"] | null,
	update?:ValueTypes["ItemCategoryUpdateBlogPostsRelationInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertBlogPostsRelationInput"] | null,
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostUniqueWhere"] | null,
	alias?:string | null
};
	["ItemCategoryUpdateBlogPostsRelationInput"]: {
	by:ValueTypes["BlogPostUniqueWhere"],
	data:ValueTypes["BlogPostWithoutItemCategoriesUpdateInput"]
};
	["BlogPostWithoutItemCategoriesUpdateInput"]: {
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostUpdateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostUpdateReviewsEntityRelationInput"][],
	items?:ValueTypes["BlogPostUpdateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostUpdateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostUpdateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostUpdateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostUpdateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostUpdateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ItemWithoutBlogPostCreateInput"] | null,
	update?:ValueTypes["BlogPostUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemUniqueWhere"] | null,
	delete?:ValueTypes["ItemUniqueWhere"] | null,
	alias?:string | null
};
	["BlogPostUpdateItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	data:ValueTypes["ItemWithoutBlogPostUpdateInput"]
};
	["ItemWithoutBlogPostUpdateInput"]: {
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemUpdateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemUpdateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemUpdateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemUpdateReferenceListEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemUpdateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemUpdateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemUpdateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemUpdateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemUpdateFeaturesOfProductEntityRelationInput"]: {
	create?:ValueTypes["ProductFeatureWithoutLinkItemCreateInput"] | null,
	update?:ValueTypes["ItemUpdateFeaturesOfProductRelationInput"] | null,
	upsert?:ValueTypes["ItemUpsertFeaturesOfProductRelationInput"] | null,
	connect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	delete?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	alias?:string | null
};
	["ItemUpdateFeaturesOfProductRelationInput"]: {
	by:ValueTypes["ProductFeatureUniqueWhere"],
	data:ValueTypes["ProductFeatureWithoutLinkItemUpdateInput"]
};
	["ProductFeatureWithoutLinkItemUpdateInput"]: {
	text?:string | null,
	category?:ValueTypes["FeatureCategoryType"] | null,
	value?:ValueTypes["FeatureValueType"] | null,
	remoteId?:string | null,
	dependentElement?:ValueTypes["ProductFeatureUpdateDependentElementEntityRelationInput"] | null,
	dependentCategory?:ValueTypes["ProductFeatureUpdateDependentCategoryEntityRelationInput"] | null,
	dependentSubCategory?:ValueTypes["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"] | null,
	dependentFlag?:ValueTypes["ProductFeatureUpdateDependentFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFeatureUpdateDependentElementEntityRelationInput"]: {
	connect?:ValueTypes["ElementUniqueWhere"] | null,
	create?:ValueTypes["ElementWithoutFeatureDependenciesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFeatureConnectOrCreateDependentElementRelationInput"] | null,
	update?:ValueTypes["ElementWithoutFeatureDependenciesUpdateInput"] | null,
	upsert?:ValueTypes["ProductFeatureUpsertDependentElementRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ElementWithoutFeatureDependenciesUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["ElementUpdateProductsEntityRelationInput"][],
	suitabilityElements?:ValueTypes["ElementUpdateSuitabilityElementsEntityRelationInput"][],
	remoteId?:string | null,
	unit?:string | null,
	filterOrder?:number | null,
	slug?:string | null,
	declensionSeventh?:string | null,
	_dummy_field_?:boolean | null
};
	["ElementUpdateSuitabilityElementsEntityRelationInput"]: {
	create?:ValueTypes["SuitabilityItemWithoutElementCreateInput"] | null,
	update?:ValueTypes["ElementUpdateSuitabilityElementsRelationInput"] | null,
	upsert?:ValueTypes["ElementUpsertSuitabilityElementsRelationInput"] | null,
	connect?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	disconnect?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	delete?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	alias?:string | null
};
	["ElementUpdateSuitabilityElementsRelationInput"]: {
	by:ValueTypes["SuitabilityItemUniqueWhere"],
	data:ValueTypes["SuitabilityItemWithoutElementUpdateInput"]
};
	["SuitabilityItemWithoutElementUpdateInput"]: {
	min?:number | null,
	max?:number | null,
	remoteId?:string | null,
	order?:number | null,
	nutritionalValue?:ValueTypes["SuitabilityItemUpdateNutritionalValueEntityRelationInput"] | null,
	category?:ValueTypes["SuitabilityItemUpdateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityItemUpdateNutritionalValueEntityRelationInput"]: {
	connect?:ValueTypes["NutritionalValueUniqueWhere"] | null,
	create?:ValueTypes["NutritionalValueWithoutSuitabilityNutritionalValuesCreateInput"] | null,
	connectOrCreate?:ValueTypes["SuitabilityItemConnectOrCreateNutritionalValueRelationInput"] | null,
	update?:ValueTypes["NutritionalValueWithoutSuitabilityNutritionalValuesUpdateInput"] | null,
	upsert?:ValueTypes["SuitabilityItemUpsertNutritionalValueRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["NutritionalValueWithoutSuitabilityNutritionalValuesUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["NutritionalValueUpdateProductsEntityRelationInput"][],
	remoteId?:string | null,
	icon?:ValueTypes["NutritionalValueUpdateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NutritionalValueUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["NutritionalValueOfProductWithoutNutritionalValueCreateInput"] | null,
	update?:ValueTypes["NutritionalValueUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["NutritionalValueUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null,
	disconnect?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null,
	delete?:ValueTypes["NutritionalValueOfProductUniqueWhere"] | null,
	alias?:string | null
};
	["NutritionalValueUpdateProductsRelationInput"]: {
	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],
	data:ValueTypes["NutritionalValueOfProductWithoutNutritionalValueUpdateInput"]
};
	["NutritionalValueOfProductWithoutNutritionalValueUpdateInput"]: {
	order?:number | null,
	product?:ValueTypes["NutritionalValueOfProductUpdateProductEntityRelationInput"] | null,
	amount?:number | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["NutritionalValueOfProductUpdateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutNutritionalValuesCreateInput"] | null,
	connectOrCreate?:ValueTypes["NutritionalValueOfProductConnectOrCreateProductRelationInput"] | null,
	update?:ValueTypes["ProductWithoutNutritionalValuesUpdateInput"] | null,
	upsert?:ValueTypes["NutritionalValueOfProductUpsertProductRelationInput"] | null,
	delete?:boolean | null
};
	["ProductWithoutNutritionalValuesUpdateInput"]: {
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdateItemCategoriesEntityRelationInput"]: {
	create?:ValueTypes["ItemCategoryWithoutProductsCreateInput"] | null,
	update?:ValueTypes["ProductUpdateItemCategoriesRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertItemCategoriesRelationInput"] | null,
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateItemCategoriesRelationInput"]: {
	by:ValueTypes["ItemCategoryUniqueWhere"],
	data:ValueTypes["ItemCategoryWithoutProductsUpdateInput"]
};
	["ItemCategoryWithoutProductsUpdateInput"]: {
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryUpdateItemsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryUpdateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryUpdateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryUpdateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryUpdateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ItemWithoutCategoriesCreateInput"] | null,
	update?:ValueTypes["ItemCategoryUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemUniqueWhere"] | null,
	delete?:ValueTypes["ItemUniqueWhere"] | null,
	alias?:string | null
};
	["ItemCategoryUpdateItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	data:ValueTypes["ItemWithoutCategoriesUpdateInput"]
};
	["ItemWithoutCategoriesUpdateInput"]: {
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemUpdateSubCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemUpdateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemUpdateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemUpdateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemUpdateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemUpdateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemUpdateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemUpdateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemUpdateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateImageRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ItemUpsertImageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemUpsertImageRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["ItemUpdateReferenceListEntityRelationInput"]: {
	connect?:ValueTypes["ReferenceListUniqueWhere"] | null,
	create?:ValueTypes["ReferenceListCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateReferenceListRelationInput"] | null,
	update?:ValueTypes["ReferenceListUpdateInput"] | null,
	upsert?:ValueTypes["ItemUpsertReferenceListRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ReferenceListUpdateInput"]: {
	references?:ValueTypes["ReferenceListUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ReferenceListUpdateReferencesEntityRelationInput"]: {
	create?:ValueTypes["ReferenceWithoutListCreateInput"] | null,
	update?:ValueTypes["ReferenceListUpdateReferencesRelationInput"] | null,
	upsert?:ValueTypes["ReferenceListUpsertReferencesRelationInput"] | null,
	connect?:ValueTypes["ReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["ReferenceUniqueWhere"] | null,
	delete?:ValueTypes["ReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["ReferenceListUpdateReferencesRelationInput"]: {
	by:ValueTypes["ReferenceUniqueWhere"],
	data:ValueTypes["ReferenceWithoutListUpdateInput"]
};
	["ReferenceWithoutListUpdateInput"]: {
	text?:string | null,
	link?:string | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["ReferenceListUpsertReferencesRelationInput"]: {
	by:ValueTypes["ReferenceUniqueWhere"],
	update:ValueTypes["ReferenceWithoutListUpdateInput"],
	create:ValueTypes["ReferenceWithoutListCreateInput"]
};
	["ItemUpsertReferenceListRelationInput"]: {
	update:ValueTypes["ReferenceListUpdateInput"],
	create:ValueTypes["ReferenceListCreateInput"]
};
	["ItemUpdateBlogPostEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateBlogPostRelationInput"] | null,
	update?:ValueTypes["BlogPostWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ItemUpsertBlogPostRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPostWithoutItemsUpdateInput"]: {
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostUpdateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostUpdateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostUpdateItemCategoriesEntityRelationInput"][],
	image?:ValueTypes["BlogPostUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostUpdateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostUpdateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostUpdateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostUpdateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostUpdateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostUpdateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateImageRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertImageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPostUpsertImageRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["BlogPostUpdateReferenceListEntityRelationInput"]: {
	connect?:ValueTypes["ReferenceListUniqueWhere"] | null,
	create?:ValueTypes["ReferenceListCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateReferenceListRelationInput"] | null,
	update?:ValueTypes["ReferenceListUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertReferenceListRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPostUpsertReferenceListRelationInput"]: {
	update:ValueTypes["ReferenceListUpdateInput"],
	create:ValueTypes["ReferenceListCreateInput"]
};
	["BlogPostUpdateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutBlogPostsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateUserRelationInput"] | null,
	update?:ValueTypes["UserWithoutBlogPostsUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertUserRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UserWithoutBlogPostsUpdateInput"]: {
	dogs?:ValueTypes["UserUpdateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserUpdateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserUpdateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserUpdateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserUpdateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserUpdateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserUpdateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserUpdateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserUpdateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserUpdateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserUpdateBlogPostReviewReactionsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostReviewReactionWithoutUserCreateInput"] | null,
	update?:ValueTypes["UserUpdateBlogPostReviewReactionsRelationInput"] | null,
	upsert?:ValueTypes["UserUpsertBlogPostReviewReactionsRelationInput"] | null,
	connect?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostReviewReactionUniqueWhere"] | null,
	alias?:string | null
};
	["UserUpdateBlogPostReviewReactionsRelationInput"]: {
	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],
	data:ValueTypes["BlogPostReviewReactionWithoutUserUpdateInput"]
};
	["BlogPostReviewReactionWithoutUserUpdateInput"]: {
	sentiment?:ValueTypes["SentimentType"] | null,
	blogPostReview?:ValueTypes["BlogPostReviewReactionUpdateBlogPostReviewEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewReactionUpdateBlogPostReviewEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	create?:ValueTypes["BlogPostReviewWithoutBlogPostReviewReactionsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewReactionConnectOrCreateBlogPostReviewRelationInput"] | null,
	update?:ValueTypes["BlogPostReviewWithoutBlogPostReviewReactionsUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostReviewReactionUpsertBlogPostReviewRelationInput"] | null,
	delete?:boolean | null
};
	["BlogPostReviewWithoutBlogPostReviewReactionsUpdateInput"]: {
	title?:string | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPost?:ValueTypes["BlogPostReviewUpdateBlogPostEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostReviewUpdateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["BlogPostReviewUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["BlogPostReviewUpdateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewUpdateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutBlogPostReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewConnectOrCreateUserRelationInput"] | null,
	update?:ValueTypes["UserWithoutBlogPostReviewsUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostReviewUpsertUserRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UserWithoutBlogPostReviewsUpdateInput"]: {
	dogs?:ValueTypes["UserUpdateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserUpdateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	productReviews?:ValueTypes["UserUpdateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserUpdateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserUpdateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserUpdateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserUpdateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserUpdateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserUpdateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserUpdateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserUpdateProductReviewReactionsEntityRelationInput"]: {
	create?:ValueTypes["ProductReviewReactionWithoutUserCreateInput"] | null,
	update?:ValueTypes["UserUpdateProductReviewReactionsRelationInput"] | null,
	upsert?:ValueTypes["UserUpsertProductReviewReactionsRelationInput"] | null,
	connect?:ValueTypes["ProductReviewReactionUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductReviewReactionUniqueWhere"] | null,
	delete?:ValueTypes["ProductReviewReactionUniqueWhere"] | null,
	alias?:string | null
};
	["UserUpdateProductReviewReactionsRelationInput"]: {
	by:ValueTypes["ProductReviewReactionUniqueWhere"],
	data:ValueTypes["ProductReviewReactionWithoutUserUpdateInput"]
};
	["ProductReviewReactionWithoutUserUpdateInput"]: {
	sentiment?:ValueTypes["SentimentType"] | null,
	productReview?:ValueTypes["ProductReviewReactionUpdateProductReviewEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewReactionUpdateProductReviewEntityRelationInput"]: {
	connect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	create?:ValueTypes["ProductReviewWithoutProductReviewReactionsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewReactionConnectOrCreateProductReviewRelationInput"] | null,
	update?:ValueTypes["ProductReviewWithoutProductReviewReactionsUpdateInput"] | null,
	upsert?:ValueTypes["ProductReviewReactionUpsertProductReviewRelationInput"] | null,
	delete?:boolean | null
};
	["ProductReviewWithoutProductReviewReactionsUpdateInput"]: {
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	score?:ValueTypes["ProductReviewUpdateScoreEntityRelationInput"] | null,
	product?:ValueTypes["ProductReviewUpdateProductEntityRelationInput"] | null,
	user?:ValueTypes["ProductReviewUpdateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["ProductReviewUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["ProductReviewUpdateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewUpdateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutProductReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewConnectOrCreateUserRelationInput"] | null,
	update?:ValueTypes["UserWithoutProductReviewsUpdateInput"] | null,
	upsert?:ValueTypes["ProductReviewUpsertUserRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UserWithoutProductReviewsUpdateInput"]: {
	dogs?:ValueTypes["UserUpdateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserUpdateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserUpdateBlogPostReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserUpdateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserUpdateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserUpdateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserUpdateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserUpdateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserUpdateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserUpdateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserUpdateBlogPostsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostWithoutUserCreateInput"] | null,
	update?:ValueTypes["UserUpdateBlogPostsRelationInput"] | null,
	upsert?:ValueTypes["UserUpsertBlogPostsRelationInput"] | null,
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostUniqueWhere"] | null,
	alias?:string | null
};
	["UserUpdateBlogPostsRelationInput"]: {
	by:ValueTypes["BlogPostUniqueWhere"],
	data:ValueTypes["BlogPostWithoutUserUpdateInput"]
};
	["BlogPostWithoutUserUpdateInput"]: {
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostUpdateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostUpdateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostUpdateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostUpdateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostUpdateReferenceListEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostUpdateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostUpdateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostUpdateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostUpdateAdsEntityRelationInput"]: {
	create?:ValueTypes["AdWithoutBlogPostsCreateInput"] | null,
	update?:ValueTypes["BlogPostUpdateAdsRelationInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertAdsRelationInput"] | null,
	connect?:ValueTypes["AdUniqueWhere"] | null,
	disconnect?:ValueTypes["AdUniqueWhere"] | null,
	delete?:ValueTypes["AdUniqueWhere"] | null,
	alias?:string | null
};
	["BlogPostUpdateAdsRelationInput"]: {
	by:ValueTypes["AdUniqueWhere"],
	data:ValueTypes["AdWithoutBlogPostsUpdateInput"]
};
	["AdWithoutBlogPostsUpdateInput"]: {
	image?:ValueTypes["AdUpdateImageEntityRelationInput"] | null,
	isBrandSectionVisible?:boolean | null,
	isBlogPostSectionVisible?:boolean | null,
	isIngredientSectionVisible?:boolean | null,
	isResultsVisible?:boolean | null,
	isSearchVisible?:boolean | null,
	itemCategories?:ValueTypes["AdUpdateItemCategoriesEntityRelationInput"][],
	brands?:ValueTypes["AdUpdateBrandsEntityRelationInput"][],
	isActive?:boolean | null,
	link?:string | null,
	note?:string | null,
	activeFrom?:ValueTypes["DateTime"] | null,
	activeUntil?:ValueTypes["DateTime"] | null,
	slug?:string | null,
	contentReferences?:ValueTypes["AdUpdateContentReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AdUpdateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["AdConnectOrCreateImageRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["AdUpsertImageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AdUpsertImageRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["AdUpdateItemCategoriesEntityRelationInput"]: {
	create?:ValueTypes["ItemCategoryWithoutAdsCreateInput"] | null,
	update?:ValueTypes["AdUpdateItemCategoriesRelationInput"] | null,
	upsert?:ValueTypes["AdUpsertItemCategoriesRelationInput"] | null,
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["AdUpdateItemCategoriesRelationInput"]: {
	by:ValueTypes["ItemCategoryUniqueWhere"],
	data:ValueTypes["ItemCategoryWithoutAdsUpdateInput"]
};
	["ItemCategoryWithoutAdsUpdateInput"]: {
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryUpdateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryUpdateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryUpdateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryUpdateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryUpdateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductWithoutItemCategoriesCreateInput"] | null,
	update?:ValueTypes["ItemCategoryUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductUniqueWhere"] | null,
	alias?:string | null
};
	["ItemCategoryUpdateProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	data:ValueTypes["ProductWithoutItemCategoriesUpdateInput"]
};
	["ProductWithoutItemCategoriesUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdateElementsEntityRelationInput"]: {
	create?:ValueTypes["ElementOfProductWithoutProductCreateInput"] | null,
	update?:ValueTypes["ProductUpdateElementsRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertElementsRelationInput"] | null,
	connect?:ValueTypes["ElementOfProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ElementOfProductUniqueWhere"] | null,
	delete?:ValueTypes["ElementOfProductUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateElementsRelationInput"]: {
	by:ValueTypes["ElementOfProductUniqueWhere"],
	data:ValueTypes["ElementOfProductWithoutProductUpdateInput"]
};
	["ElementOfProductWithoutProductUpdateInput"]: {
	order?:number | null,
	amount?:number | null,
	remoteId?:string | null,
	element?:ValueTypes["ElementOfProductUpdateElementEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ElementOfProductUpdateElementEntityRelationInput"]: {
	connect?:ValueTypes["ElementUniqueWhere"] | null,
	create?:ValueTypes["ElementWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ElementOfProductConnectOrCreateElementRelationInput"] | null,
	update?:ValueTypes["ElementWithoutProductsUpdateInput"] | null,
	upsert?:ValueTypes["ElementOfProductUpsertElementRelationInput"] | null,
	delete?:boolean | null
};
	["ElementWithoutProductsUpdateInput"]: {
	name?:string | null,
	featureDependencies?:ValueTypes["ElementUpdateFeatureDependenciesEntityRelationInput"][],
	suitabilityElements?:ValueTypes["ElementUpdateSuitabilityElementsEntityRelationInput"][],
	remoteId?:string | null,
	unit?:string | null,
	filterOrder?:number | null,
	slug?:string | null,
	declensionSeventh?:string | null,
	_dummy_field_?:boolean | null
};
	["ElementUpdateFeatureDependenciesEntityRelationInput"]: {
	create?:ValueTypes["ProductFeatureWithoutDependentElementCreateInput"] | null,
	update?:ValueTypes["ElementUpdateFeatureDependenciesRelationInput"] | null,
	upsert?:ValueTypes["ElementUpsertFeatureDependenciesRelationInput"] | null,
	connect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	delete?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	alias?:string | null
};
	["ElementUpdateFeatureDependenciesRelationInput"]: {
	by:ValueTypes["ProductFeatureUniqueWhere"],
	data:ValueTypes["ProductFeatureWithoutDependentElementUpdateInput"]
};
	["ProductFeatureWithoutDependentElementUpdateInput"]: {
	text?:string | null,
	category?:ValueTypes["FeatureCategoryType"] | null,
	value?:ValueTypes["FeatureValueType"] | null,
	remoteId?:string | null,
	linkItem?:ValueTypes["ProductFeatureUpdateLinkItemEntityRelationInput"] | null,
	dependentCategory?:ValueTypes["ProductFeatureUpdateDependentCategoryEntityRelationInput"] | null,
	dependentSubCategory?:ValueTypes["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"] | null,
	dependentFlag?:ValueTypes["ProductFeatureUpdateDependentFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFeatureUpdateDependentCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutFeatureDependenciesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFeatureConnectOrCreateDependentCategoryRelationInput"] | null,
	update?:ValueTypes["ItemCategoryWithoutFeatureDependenciesUpdateInput"] | null,
	upsert?:ValueTypes["ProductFeatureUpsertDependentCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemCategoryWithoutFeatureDependenciesUpdateInput"]: {
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryUpdateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryUpdateProductsEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryUpdateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryUpdateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryUpdateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryUpdateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryUpdateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateImageRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertImageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemCategoryUpsertImageRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["ItemCategoryUpdateAdsEntityRelationInput"]: {
	create?:ValueTypes["AdWithoutItemCategoriesCreateInput"] | null,
	update?:ValueTypes["ItemCategoryUpdateAdsRelationInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertAdsRelationInput"] | null,
	connect?:ValueTypes["AdUniqueWhere"] | null,
	disconnect?:ValueTypes["AdUniqueWhere"] | null,
	delete?:ValueTypes["AdUniqueWhere"] | null,
	alias?:string | null
};
	["ItemCategoryUpdateAdsRelationInput"]: {
	by:ValueTypes["AdUniqueWhere"],
	data:ValueTypes["AdWithoutItemCategoriesUpdateInput"]
};
	["AdWithoutItemCategoriesUpdateInput"]: {
	image?:ValueTypes["AdUpdateImageEntityRelationInput"] | null,
	isBrandSectionVisible?:boolean | null,
	isBlogPostSectionVisible?:boolean | null,
	isIngredientSectionVisible?:boolean | null,
	isResultsVisible?:boolean | null,
	isSearchVisible?:boolean | null,
	blogPosts?:ValueTypes["AdUpdateBlogPostsEntityRelationInput"][],
	brands?:ValueTypes["AdUpdateBrandsEntityRelationInput"][],
	isActive?:boolean | null,
	link?:string | null,
	note?:string | null,
	activeFrom?:ValueTypes["DateTime"] | null,
	activeUntil?:ValueTypes["DateTime"] | null,
	slug?:string | null,
	contentReferences?:ValueTypes["AdUpdateContentReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AdUpdateBlogPostsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostWithoutAdsCreateInput"] | null,
	update?:ValueTypes["AdUpdateBlogPostsRelationInput"] | null,
	upsert?:ValueTypes["AdUpsertBlogPostsRelationInput"] | null,
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostUniqueWhere"] | null,
	alias?:string | null
};
	["AdUpdateBlogPostsRelationInput"]: {
	by:ValueTypes["BlogPostUniqueWhere"],
	data:ValueTypes["BlogPostWithoutAdsUpdateInput"]
};
	["BlogPostWithoutAdsUpdateInput"]: {
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostUpdateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostUpdateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostUpdateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostUpdateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostUpdateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostUpdateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostUpdateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	redirects?:ValueTypes["BlogPostUpdateRedirectsEntityRelationInput"][],
	automated?:boolean | null,
	content?:ValueTypes["BlogPostUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostUpdateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoUpdateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoUpdateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoUpdateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoUpdateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoUpdateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoUpdateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoUpdateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoUpdateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoUpdateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoUpdateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoUpdateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateBrandsPageEntityRelationInput"]: {
	connect?:ValueTypes["BrandsPageUniqueWhere"] | null,
	create?:ValueTypes["BrandsPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateBrandsPageRelationInput"] | null,
	update?:ValueTypes["BrandsPageWithoutSeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertBrandsPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandsPageWithoutSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	redirects?:ValueTypes["BrandsPageUpdateRedirectsEntityRelationInput"][],
	content?:ValueTypes["BrandsPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandsPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandsPageUpdateRedirectsEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutBrandsPageCreateInput"] | null,
	update?:ValueTypes["BrandsPageUpdateRedirectsRelationInput"] | null,
	upsert?:ValueTypes["BrandsPageUpsertRedirectsRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:ValueTypes["RedirectUniqueWhere"] | null,
	delete?:ValueTypes["RedirectUniqueWhere"] | null,
	alias?:string | null
};
	["BrandsPageUpdateRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	data:ValueTypes["RedirectWithoutBrandsPageUpdateInput"]
};
	["RedirectWithoutBrandsPageUpdateInput"]: {
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectUpdateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectUpdateItemCategoryEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectUpdateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectUpdateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectUpdateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectUpdateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectUpdateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateItemCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateItemCategoryRelationInput"] | null,
	update?:ValueTypes["ItemCategoryWithoutRedirectsUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertItemCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemCategoryWithoutRedirectsUpdateInput"]: {
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryUpdateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryUpdateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	declensionsFourth?:ValueTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryUpdateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryUpdateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"]: {
	create?:ValueTypes["ProductFeatureWithoutDependentCategoryCreateInput"] | null,
	update?:ValueTypes["ItemCategoryUpdateFeatureDependenciesRelationInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertFeatureDependenciesRelationInput"] | null,
	connect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	delete?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	alias?:string | null
};
	["ItemCategoryUpdateFeatureDependenciesRelationInput"]: {
	by:ValueTypes["ProductFeatureUniqueWhere"],
	data:ValueTypes["ProductFeatureWithoutDependentCategoryUpdateInput"]
};
	["ProductFeatureWithoutDependentCategoryUpdateInput"]: {
	text?:string | null,
	category?:ValueTypes["FeatureCategoryType"] | null,
	value?:ValueTypes["FeatureValueType"] | null,
	remoteId?:string | null,
	linkItem?:ValueTypes["ProductFeatureUpdateLinkItemEntityRelationInput"] | null,
	dependentElement?:ValueTypes["ProductFeatureUpdateDependentElementEntityRelationInput"] | null,
	dependentSubCategory?:ValueTypes["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"] | null,
	dependentFlag?:ValueTypes["ProductFeatureUpdateDependentFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryWithoutFeatureDependenciesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFeatureConnectOrCreateDependentSubCategoryRelationInput"] | null,
	update?:ValueTypes["ItemSubCategoryWithoutFeatureDependenciesUpdateInput"] | null,
	upsert?:ValueTypes["ProductFeatureUpsertDependentSubCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemSubCategoryWithoutFeatureDependenciesUpdateInput"]: {
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryUpdateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryUpdateProductsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryUpdateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryUpdateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryUpdateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutSubCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateCategoryRelationInput"] | null,
	update?:ValueTypes["ItemCategoryWithoutSubCategoriesUpdateInput"] | null,
	upsert?:ValueTypes["ItemSubCategoryUpsertCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemCategoryWithoutSubCategoriesUpdateInput"]: {
	name?:string | null,
	shortDescription?:string | null,
	blogPosts?:ValueTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryUpdateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryUpdateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryUpdateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryUpdateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryUpdateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryUpdateRedirectsEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutItemCategoryCreateInput"] | null,
	update?:ValueTypes["ItemCategoryUpdateRedirectsRelationInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertRedirectsRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:ValueTypes["RedirectUniqueWhere"] | null,
	delete?:ValueTypes["RedirectUniqueWhere"] | null,
	alias?:string | null
};
	["ItemCategoryUpdateRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	data:ValueTypes["RedirectWithoutItemCategoryUpdateInput"]
};
	["RedirectWithoutItemCategoryUpdateInput"]: {
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectUpdateGenericPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectUpdateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectUpdateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectUpdateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectUpdateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectUpdateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectUpdateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateBrandsPageEntityRelationInput"]: {
	connect?:ValueTypes["BrandsPageUniqueWhere"] | null,
	create?:ValueTypes["BrandsPageWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateBrandsPageRelationInput"] | null,
	update?:ValueTypes["BrandsPageWithoutRedirectsUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertBrandsPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandsPageWithoutRedirectsUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["BrandsPageUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["BrandsPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandsPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandsPageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutBrandsPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandsPageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoWithoutBrandsPageUpdateInput"] | null,
	upsert?:ValueTypes["BrandsPageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoWithoutBrandsPageUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoUpdateBlogPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoUpdateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoUpdateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoUpdateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoUpdateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoUpdateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoUpdateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoUpdateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoUpdateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoUpdateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateComparatorPageEntityRelationInput"]: {
	connect?:ValueTypes["ComparatorPageUniqueWhere"] | null,
	create?:ValueTypes["ComparatorPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateComparatorPageRelationInput"] | null,
	update?:ValueTypes["ComparatorPageWithoutSeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertComparatorPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ComparatorPageWithoutSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["ComparatorPageUpdateRedirectsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ComparatorPageUpdateRedirectsEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutComparatorPageCreateInput"] | null,
	update?:ValueTypes["ComparatorPageUpdateRedirectsRelationInput"] | null,
	upsert?:ValueTypes["ComparatorPageUpsertRedirectsRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:ValueTypes["RedirectUniqueWhere"] | null,
	delete?:ValueTypes["RedirectUniqueWhere"] | null,
	alias?:string | null
};
	["ComparatorPageUpdateRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	data:ValueTypes["RedirectWithoutComparatorPageUpdateInput"]
};
	["RedirectWithoutComparatorPageUpdateInput"]: {
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectUpdateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectUpdateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectUpdateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectUpdateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectUpdateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectUpdateWizardPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectUpdateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateBlogPageEntityRelationInput"]: {
	connect?:ValueTypes["BlogPageUniqueWhere"] | null,
	create?:ValueTypes["BlogPageWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateBlogPageRelationInput"] | null,
	update?:ValueTypes["BlogPageWithoutRedirectsUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertBlogPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPageWithoutRedirectsUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["BlogPageUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["BlogPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutBlogPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoWithoutBlogPageUpdateInput"] | null,
	upsert?:ValueTypes["BlogPageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoWithoutBlogPageUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoUpdateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoUpdateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoUpdateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoUpdateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoUpdateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoUpdateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoUpdateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoUpdateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoUpdateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoUpdateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateGenericPageEntityRelationInput"]: {
	connect?:ValueTypes["GenericPageUniqueWhere"] | null,
	create?:ValueTypes["GenericPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateGenericPageRelationInput"] | null,
	update?:ValueTypes["GenericPageWithoutSeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertGenericPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GenericPageWithoutSeoUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["GenericPageUpdateLinkEntityRelationInput"] | null,
	redirects?:ValueTypes["GenericPageUpdateRedirectsEntityRelationInput"][],
	content?:ValueTypes["GenericPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["GenericPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GenericPageUpdateRedirectsEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutGenericPageCreateInput"] | null,
	update?:ValueTypes["GenericPageUpdateRedirectsRelationInput"] | null,
	upsert?:ValueTypes["GenericPageUpsertRedirectsRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:ValueTypes["RedirectUniqueWhere"] | null,
	delete?:ValueTypes["RedirectUniqueWhere"] | null,
	alias?:string | null
};
	["GenericPageUpdateRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	data:ValueTypes["RedirectWithoutGenericPageUpdateInput"]
};
	["RedirectWithoutGenericPageUpdateInput"]: {
	to?:string | null,
	order?:number | null,
	from?:string | null,
	itemCategory?:ValueTypes["RedirectUpdateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectUpdateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectUpdateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectUpdateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectUpdateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectUpdateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectUpdateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateContactPageEntityRelationInput"]: {
	connect?:ValueTypes["ContactPageUniqueWhere"] | null,
	create?:ValueTypes["ContactPageWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateContactPageRelationInput"] | null,
	update?:ValueTypes["ContactPageWithoutRedirectsUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertContactPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContactPageWithoutRedirectsUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["ContactPageUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["ContactPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ContactPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactPageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutContactPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContactPageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoWithoutContactPageUpdateInput"] | null,
	upsert?:ValueTypes["ContactPageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoWithoutContactPageUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoUpdateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoUpdateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoUpdateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoUpdateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoUpdateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoUpdateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoUpdateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoUpdateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoUpdateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoUpdateWizardPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateHomePageEntityRelationInput"]: {
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	create?:ValueTypes["HomePageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateHomePageRelationInput"] | null,
	update?:ValueTypes["HomePageWithoutSeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertHomePageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageWithoutSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	lead?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoUpsertHomePageRelationInput"]: {
	update:ValueTypes["HomePageWithoutSeoUpdateInput"],
	create:ValueTypes["HomePageWithoutSeoCreateInput"]
};
	["SeoUpdateIngredientsPageEntityRelationInput"]: {
	connect?:ValueTypes["IngredientsPageUniqueWhere"] | null,
	create?:ValueTypes["IngredientsPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateIngredientsPageRelationInput"] | null,
	update?:ValueTypes["IngredientsPageWithoutSeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertIngredientsPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["IngredientsPageWithoutSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	content?:ValueTypes["IngredientsPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["IngredientsPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["IngredientsPageUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["IngredientsPageConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["IngredientsPageUpsertContentRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["IngredientsPageUpsertContentRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["IngredientsPageUpdateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["IngredientsPageConnectOrCreateDraftRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["IngredientsPageUpsertDraftRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["IngredientsPageUpsertDraftRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["SeoUpsertIngredientsPageRelationInput"]: {
	update:ValueTypes["IngredientsPageWithoutSeoUpdateInput"],
	create:ValueTypes["IngredientsPageWithoutSeoCreateInput"]
};
	["SeoUpdateLoginPageEntityRelationInput"]: {
	connect?:ValueTypes["LoginPageUniqueWhere"] | null,
	create?:ValueTypes["LoginPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateLoginPageRelationInput"] | null,
	update?:ValueTypes["LoginPageWithoutSeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertLoginPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LoginPageWithoutSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["SeoUpsertLoginPageRelationInput"]: {
	update:ValueTypes["LoginPageWithoutSeoUpdateInput"],
	create:ValueTypes["LoginPageWithoutSeoCreateInput"]
};
	["SeoUpdateRegisterPageEntityRelationInput"]: {
	connect?:ValueTypes["RegisterPageUniqueWhere"] | null,
	create?:ValueTypes["RegisterPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateRegisterPageRelationInput"] | null,
	update?:ValueTypes["RegisterPageWithoutSeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertRegisterPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RegisterPageWithoutSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["SeoUpsertRegisterPageRelationInput"]: {
	update:ValueTypes["RegisterPageWithoutSeoUpdateInput"],
	create:ValueTypes["RegisterPageWithoutSeoCreateInput"]
};
	["SeoUpdateSearchPageEntityRelationInput"]: {
	connect?:ValueTypes["SearchPageUniqueWhere"] | null,
	create?:ValueTypes["SearchPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateSearchPageRelationInput"] | null,
	update?:ValueTypes["SearchPageWithoutSeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertSearchPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SearchPageWithoutSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["SeoUpsertSearchPageRelationInput"]: {
	update:ValueTypes["SearchPageWithoutSeoUpdateInput"],
	create:ValueTypes["SearchPageWithoutSeoCreateInput"]
};
	["SeoUpdateWizardPageEntityRelationInput"]: {
	connect?:ValueTypes["WizardPageUniqueWhere"] | null,
	create?:ValueTypes["WizardPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateWizardPageRelationInput"] | null,
	update?:ValueTypes["WizardPageWithoutSeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertWizardPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["WizardPageWithoutSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["WizardPageUpdateRedirectsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["WizardPageUpdateRedirectsEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutWizardPageCreateInput"] | null,
	update?:ValueTypes["WizardPageUpdateRedirectsRelationInput"] | null,
	upsert?:ValueTypes["WizardPageUpsertRedirectsRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:ValueTypes["RedirectUniqueWhere"] | null,
	delete?:ValueTypes["RedirectUniqueWhere"] | null,
	alias?:string | null
};
	["WizardPageUpdateRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	data:ValueTypes["RedirectWithoutWizardPageUpdateInput"]
};
	["RedirectWithoutWizardPageUpdateInput"]: {
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectUpdateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectUpdateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectUpdateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectUpdateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectUpdateContactPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectUpdateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectUpdateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateComparatorPageEntityRelationInput"]: {
	connect?:ValueTypes["ComparatorPageUniqueWhere"] | null,
	create?:ValueTypes["ComparatorPageWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateComparatorPageRelationInput"] | null,
	update?:ValueTypes["ComparatorPageWithoutRedirectsUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertComparatorPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ComparatorPageWithoutRedirectsUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["ComparatorPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ComparatorPageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutComparatorPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ComparatorPageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoWithoutComparatorPageUpdateInput"] | null,
	upsert?:ValueTypes["ComparatorPageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoWithoutComparatorPageUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoUpdateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoUpdateBrandsPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoUpdateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoUpdateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoUpdateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoUpdateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoUpdateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoUpdateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoUpdateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoUpdateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateContactPageEntityRelationInput"]: {
	connect?:ValueTypes["ContactPageUniqueWhere"] | null,
	create?:ValueTypes["ContactPageWithoutSeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoConnectOrCreateContactPageRelationInput"] | null,
	update?:ValueTypes["ContactPageWithoutSeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertContactPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContactPageWithoutSeoUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	redirects?:ValueTypes["ContactPageUpdateRedirectsEntityRelationInput"][],
	content?:ValueTypes["ContactPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ContactPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactPageUpdateRedirectsEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutContactPageCreateInput"] | null,
	update?:ValueTypes["ContactPageUpdateRedirectsRelationInput"] | null,
	upsert?:ValueTypes["ContactPageUpsertRedirectsRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:ValueTypes["RedirectUniqueWhere"] | null,
	delete?:ValueTypes["RedirectUniqueWhere"] | null,
	alias?:string | null
};
	["ContactPageUpdateRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	data:ValueTypes["RedirectWithoutContactPageUpdateInput"]
};
	["RedirectWithoutContactPageUpdateInput"]: {
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectUpdateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectUpdateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectUpdateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectUpdateBlogPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectUpdateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectUpdateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectUpdateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateWizardPageEntityRelationInput"]: {
	connect?:ValueTypes["WizardPageUniqueWhere"] | null,
	create?:ValueTypes["WizardPageWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateWizardPageRelationInput"] | null,
	update?:ValueTypes["WizardPageWithoutRedirectsUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertWizardPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["WizardPageWithoutRedirectsUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["WizardPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["WizardPageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutWizardPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["WizardPageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoWithoutWizardPageUpdateInput"] | null,
	upsert?:ValueTypes["WizardPageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoWithoutWizardPageUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoUpdateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoUpdateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoUpdateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoUpdateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoUpdateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoUpdateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoUpdateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoUpdateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoUpdateSearchPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoUpdateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["WizardPageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoWithoutWizardPageUpdateInput"],
	create:ValueTypes["SeoWithoutWizardPageCreateInput"]
};
	["RedirectUpsertWizardPageRelationInput"]: {
	update:ValueTypes["WizardPageWithoutRedirectsUpdateInput"],
	create:ValueTypes["WizardPageWithoutRedirectsCreateInput"]
};
	["RedirectUpdateBlogPostEntityRelationInput"]: {
	connect?:ValueTypes["BlogPostUniqueWhere"] | null,
	create?:ValueTypes["BlogPostWithoutRedirectsCreateInput"] | null,
	connectOrCreate?:ValueTypes["RedirectConnectOrCreateBlogPostRelationInput"] | null,
	update?:ValueTypes["BlogPostWithoutRedirectsUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertBlogPostRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPostWithoutRedirectsUpdateInput"]: {
	author?:string | null,
	readingTime?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostTags?:ValueTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"][],
	tags?:ValueTypes["BlogPostUpdateTagsEntityRelationInput"][],
	title?:string | null,
	listedOnHomePage?:boolean | null,
	reviews?:ValueTypes["BlogPostUpdateReviewsEntityRelationInput"][],
	itemCategories?:ValueTypes["BlogPostUpdateItemCategoriesEntityRelationInput"][],
	items?:ValueTypes["BlogPostUpdateItemsEntityRelationInput"][],
	image?:ValueTypes["BlogPostUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["BlogPostUpdateReferenceListEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostUpdateUserEntityRelationInput"] | null,
	isComparatorLinked?:boolean | null,
	ads?:ValueTypes["BlogPostUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	lead?:string | null,
	seo?:ValueTypes["BlogPostUpdateSeoEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	note?:string | null,
	isActive?:boolean | null,
	automated?:boolean | null,
	content?:ValueTypes["BlogPostUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BlogPostUpdateDraftEntityRelationInput"] | null,
	slugInternal?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertContentRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPostUpsertContentRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["BlogPostUpdateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostConnectOrCreateDraftRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertDraftRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPostUpsertDraftRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["RedirectUpsertBlogPostRelationInput"]: {
	update:ValueTypes["BlogPostWithoutRedirectsUpdateInput"],
	create:ValueTypes["BlogPostWithoutRedirectsCreateInput"]
};
	["ContactPageUpsertRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	update:ValueTypes["RedirectWithoutContactPageUpdateInput"],
	create:ValueTypes["RedirectWithoutContactPageCreateInput"]
};
	["ContactPageUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContactPageConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ContactPageUpsertContentRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContactPageUpsertContentRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["ContactPageUpdateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContactPageConnectOrCreateDraftRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ContactPageUpsertDraftRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContactPageUpsertDraftRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["SeoUpsertContactPageRelationInput"]: {
	update:ValueTypes["ContactPageWithoutSeoUpdateInput"],
	create:ValueTypes["ContactPageWithoutSeoCreateInput"]
};
	["ComparatorPageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoWithoutComparatorPageUpdateInput"],
	create:ValueTypes["SeoWithoutComparatorPageCreateInput"]
};
	["RedirectUpsertComparatorPageRelationInput"]: {
	update:ValueTypes["ComparatorPageWithoutRedirectsUpdateInput"],
	create:ValueTypes["ComparatorPageWithoutRedirectsCreateInput"]
};
	["WizardPageUpsertRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	update:ValueTypes["RedirectWithoutWizardPageUpdateInput"],
	create:ValueTypes["RedirectWithoutWizardPageCreateInput"]
};
	["SeoUpsertWizardPageRelationInput"]: {
	update:ValueTypes["WizardPageWithoutSeoUpdateInput"],
	create:ValueTypes["WizardPageWithoutSeoCreateInput"]
};
	["ContactPageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoWithoutContactPageUpdateInput"],
	create:ValueTypes["SeoWithoutContactPageCreateInput"]
};
	["RedirectUpsertContactPageRelationInput"]: {
	update:ValueTypes["ContactPageWithoutRedirectsUpdateInput"],
	create:ValueTypes["ContactPageWithoutRedirectsCreateInput"]
};
	["GenericPageUpsertRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	update:ValueTypes["RedirectWithoutGenericPageUpdateInput"],
	create:ValueTypes["RedirectWithoutGenericPageCreateInput"]
};
	["GenericPageUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["GenericPageConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["GenericPageUpsertContentRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GenericPageUpsertContentRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["GenericPageUpdateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["GenericPageConnectOrCreateDraftRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["GenericPageUpsertDraftRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GenericPageUpsertDraftRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["SeoUpsertGenericPageRelationInput"]: {
	update:ValueTypes["GenericPageWithoutSeoUpdateInput"],
	create:ValueTypes["GenericPageWithoutSeoCreateInput"]
};
	["BlogPageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoWithoutBlogPageUpdateInput"],
	create:ValueTypes["SeoWithoutBlogPageCreateInput"]
};
	["BlogPageUpdateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPageConnectOrCreateDraftRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["BlogPageUpsertDraftRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BlogPageUpsertDraftRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["RedirectUpsertBlogPageRelationInput"]: {
	update:ValueTypes["BlogPageWithoutRedirectsUpdateInput"],
	create:ValueTypes["BlogPageWithoutRedirectsCreateInput"]
};
	["ComparatorPageUpsertRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	update:ValueTypes["RedirectWithoutComparatorPageUpdateInput"],
	create:ValueTypes["RedirectWithoutComparatorPageCreateInput"]
};
	["SeoUpsertComparatorPageRelationInput"]: {
	update:ValueTypes["ComparatorPageWithoutSeoUpdateInput"],
	create:ValueTypes["ComparatorPageWithoutSeoCreateInput"]
};
	["BrandsPageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoWithoutBrandsPageUpdateInput"],
	create:ValueTypes["SeoWithoutBrandsPageCreateInput"]
};
	["BrandsPageUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandsPageConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["BrandsPageUpsertContentRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandsPageUpsertContentRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["BrandsPageUpdateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandsPageConnectOrCreateDraftRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["BrandsPageUpsertDraftRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandsPageUpsertDraftRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["RedirectUpsertBrandsPageRelationInput"]: {
	update:ValueTypes["BrandsPageWithoutRedirectsUpdateInput"],
	create:ValueTypes["BrandsPageWithoutRedirectsCreateInput"]
};
	["ItemCategoryUpsertRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	update:ValueTypes["RedirectWithoutItemCategoryUpdateInput"],
	create:ValueTypes["RedirectWithoutItemCategoryCreateInput"]
};
	["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"]: {
	create?:ValueTypes["ItemDeclensionFourthVariantWithoutCategoryCreateInput"] | null,
	update?:ValueTypes["ItemCategoryUpdateDeclensionsFourthRelationInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertDeclensionsFourthRelationInput"] | null,
	connect?:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"] | null,
	delete?:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"] | null,
	alias?:string | null
};
	["ItemCategoryUpdateDeclensionsFourthRelationInput"]: {
	by:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],
	data:ValueTypes["ItemDeclensionFourthVariantWithoutCategoryUpdateInput"]
};
	["ItemDeclensionFourthVariantWithoutCategoryUpdateInput"]: {
	items?:ValueTypes["ItemDeclensionFourthVariantUpdateItemsEntityRelationInput"][],
	label?:string | null,
	remoteId?:string | null,
	declensionSeventh?:string | null,
	isNegativ?:boolean | null,
	seo?:ValueTypes["ItemDeclensionFourthVariantUpdateSeoEntityRelationInput"] | null,
	subcategory?:ValueTypes["ItemDeclensionFourthVariantUpdateSubcategoryEntityRelationInput"] | null,
	element?:ValueTypes["ItemDeclensionFourthVariantUpdateElementEntityRelationInput"] | null,
	products?:ValueTypes["ItemDeclensionFourthVariantUpdateProductsEntityRelationInput"][],
	slug?:string | null,
	content?:ValueTypes["ItemDeclensionFourthVariantUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemDeclensionFourthVariantUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionFourthVariantUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ItemWithoutDeclensionFourthCreateInput"] | null,
	update?:ValueTypes["ItemDeclensionFourthVariantUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ItemDeclensionFourthVariantUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemUniqueWhere"] | null,
	delete?:ValueTypes["ItemUniqueWhere"] | null,
	alias?:string | null
};
	["ItemDeclensionFourthVariantUpdateItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	data:ValueTypes["ItemWithoutDeclensionFourthUpdateInput"]
};
	["ItemWithoutDeclensionFourthUpdateInput"]: {
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemUpdateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemUpdateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemUpdateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemUpdateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemUpdateBlogPostEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemUpdateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemUpdateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemUpdateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemUpdateDeclensionSeventhEntityRelationInput"]: {
	connect?:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"] | null,
	create?:ValueTypes["ItemDeclensionSeventhVariantWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateDeclensionSeventhRelationInput"] | null,
	update?:ValueTypes["ItemDeclensionSeventhVariantWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ItemUpsertDeclensionSeventhRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemDeclensionSeventhVariantWithoutItemsUpdateInput"]: {
	label?:string | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemUpsertDeclensionSeventhRelationInput"]: {
	update:ValueTypes["ItemDeclensionSeventhVariantWithoutItemsUpdateInput"],
	create:ValueTypes["ItemDeclensionSeventhVariantWithoutItemsCreateInput"]
};
	["ItemUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ItemUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoUpdateInput"],
	create:ValueTypes["SeoCreateInput"]
};
	["ItemUpdateAliasesEntityRelationInput"]: {
	create?:ValueTypes["ItemAliasWithoutItemCreateInput"] | null,
	update?:ValueTypes["ItemUpdateAliasesRelationInput"] | null,
	upsert?:ValueTypes["ItemUpsertAliasesRelationInput"] | null,
	connect?:ValueTypes["ItemAliasUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemAliasUniqueWhere"] | null,
	delete?:ValueTypes["ItemAliasUniqueWhere"] | null,
	alias?:string | null
};
	["ItemUpdateAliasesRelationInput"]: {
	by:ValueTypes["ItemAliasUniqueWhere"],
	data:ValueTypes["ItemAliasWithoutItemUpdateInput"]
};
	["ItemAliasWithoutItemUpdateInput"]: {
	remoteId?:string | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemUpsertAliasesRelationInput"]: {
	by:ValueTypes["ItemAliasUniqueWhere"],
	update:ValueTypes["ItemAliasWithoutItemUpdateInput"],
	create:ValueTypes["ItemAliasWithoutItemCreateInput"]
};
	["ItemUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ItemUpsertContentRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemUpsertContentRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["ItemUpdateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateDraftRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ItemUpsertDraftRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemUpsertDraftRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["ItemDeclensionFourthVariantUpsertItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	update:ValueTypes["ItemWithoutDeclensionFourthUpdateInput"],
	create:ValueTypes["ItemWithoutDeclensionFourthCreateInput"]
};
	["ItemDeclensionFourthVariantUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ItemDeclensionFourthVariantUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemDeclensionFourthVariantUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoUpdateInput"],
	create:ValueTypes["SeoCreateInput"]
};
	["ItemDeclensionFourthVariantUpdateSubcategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateSubcategoryRelationInput"] | null,
	update?:ValueTypes["ItemSubCategoryUpdateInput"] | null,
	upsert?:ValueTypes["ItemDeclensionFourthVariantUpsertSubcategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemSubCategoryUpdateInput"]: {
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryUpdateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryUpdateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryUpdateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemFlavorCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemFlavorCategoryWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateFlavorCategoryRelationInput"] | null,
	update?:ValueTypes["ItemFlavorCategoryWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ItemSubCategoryUpsertFlavorCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemFlavorCategoryWithoutItemsUpdateInput"]: {
	name?:string | null,
	remoteId?:string | null,
	color?:ValueTypes["ItemFlavorCategoryUpdateColorEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemFlavorCategoryUpdateColorEntityRelationInput"]: {
	connect?:ValueTypes["ColorUniqueWhere"] | null,
	create?:ValueTypes["ColorWithoutItemFlavorCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemFlavorCategoryConnectOrCreateColorRelationInput"] | null,
	update?:ValueTypes["ColorWithoutItemFlavorCategoriesUpdateInput"] | null,
	upsert?:ValueTypes["ItemFlavorCategoryUpsertColorRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ColorWithoutItemFlavorCategoriesUpdateInput"]: {
	name?:string | null,
	colorHex?:string | null,
	bodyTagCategory?:ValueTypes["ColorUpdateBodyTagCategoryEntityRelationInput"] | null,
	blogPostTag?:ValueTypes["ColorUpdateBlogPostTagEntityRelationInput"] | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemFlavorCategoryUpsertColorRelationInput"]: {
	update:ValueTypes["ColorWithoutItemFlavorCategoriesUpdateInput"],
	create:ValueTypes["ColorWithoutItemFlavorCategoriesCreateInput"]
};
	["ItemSubCategoryUpsertFlavorCategoryRelationInput"]: {
	update:ValueTypes["ItemFlavorCategoryWithoutItemsUpdateInput"],
	create:ValueTypes["ItemFlavorCategoryWithoutItemsCreateInput"]
};
	["ItemSubCategoryUpdateDogsEntityRelationInput"]: {
	create?:ValueTypes["DogWithoutAllergiesCreateInput"] | null,
	update?:ValueTypes["ItemSubCategoryUpdateDogsRelationInput"] | null,
	upsert?:ValueTypes["ItemSubCategoryUpsertDogsRelationInput"] | null,
	connect?:ValueTypes["DogUniqueWhere"] | null,
	disconnect?:ValueTypes["DogUniqueWhere"] | null,
	delete?:ValueTypes["DogUniqueWhere"] | null,
	alias?:string | null
};
	["ItemSubCategoryUpdateDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	data:ValueTypes["DogWithoutAllergiesUpdateInput"]
};
	["DogWithoutAllergiesUpdateInput"]: {
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogUpdateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogUpdateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogUpdateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogUpdateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogUpdateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogUpdateReproductionEntityRelationInput"] | null,
	illnesses?:ValueTypes["DogUpdateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogUpdateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogUpdateFedProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateFedProductRelationInput"] | null,
	update?:ValueTypes["ProductWithoutDogsUpdateInput"] | null,
	upsert?:ValueTypes["DogUpsertFedProductRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductWithoutDogsUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdateRecommendedDogSizesEntityRelationInput"]: {
	create?:ValueTypes["DogSizeWithoutProductsCreateInput"] | null,
	update?:ValueTypes["ProductUpdateRecommendedDogSizesRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertRecommendedDogSizesRelationInput"] | null,
	connect?:ValueTypes["DogSizeUniqueWhere"] | null,
	disconnect?:ValueTypes["DogSizeUniqueWhere"] | null,
	delete?:ValueTypes["DogSizeUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateRecommendedDogSizesRelationInput"]: {
	by:ValueTypes["DogSizeUniqueWhere"],
	data:ValueTypes["DogSizeWithoutProductsUpdateInput"]
};
	["DogSizeWithoutProductsUpdateInput"]: {
	breeds?:ValueTypes["DogSizeUpdateBreedsEntityRelationInput"][],
	remoteId?:string | null,
	suitabilityCategory?:ValueTypes["DogSizeUpdateSuitabilityCategoryEntityRelationInput"] | null,
	name?:ValueTypes["SizeType"] | null,
	label?:string | null,
	order?:number | null,
	isFilterVisible?:boolean | null,
	_dummy_field_?:boolean | null
};
	["DogSizeUpdateBreedsEntityRelationInput"]: {
	create?:ValueTypes["BreedWithoutSizeCreateInput"] | null,
	update?:ValueTypes["DogSizeUpdateBreedsRelationInput"] | null,
	upsert?:ValueTypes["DogSizeUpsertBreedsRelationInput"] | null,
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	disconnect?:ValueTypes["BreedUniqueWhere"] | null,
	delete?:ValueTypes["BreedUniqueWhere"] | null,
	alias?:string | null
};
	["DogSizeUpdateBreedsRelationInput"]: {
	by:ValueTypes["BreedUniqueWhere"],
	data:ValueTypes["BreedWithoutSizeUpdateInput"]
};
	["BreedWithoutSizeUpdateInput"]: {
	dogs?:ValueTypes["BreedUpdateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedUpdateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedUpdateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedUpdateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedUpdateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedUpdateSuitabilityCategoryEntityRelationInput"]: {
	connect?:ValueTypes["SuitabilityCategoryUniqueWhere"] | null,
	create?:ValueTypes["SuitabilityCategoryWithoutBreedsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BreedConnectOrCreateSuitabilityCategoryRelationInput"] | null,
	update?:ValueTypes["SuitabilityCategoryWithoutBreedsUpdateInput"] | null,
	upsert?:ValueTypes["BreedUpsertSuitabilityCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SuitabilityCategoryWithoutBreedsUpdateInput"]: {
	name?:string | null,
	dogSizes?:ValueTypes["SuitabilityCategoryUpdateDogSizesEntityRelationInput"][],
	dogActivities?:ValueTypes["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"][],
	suitabilityItems?:ValueTypes["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"][],
	dogAges?:ValueTypes["SuitabilityCategoryUpdateDogAgesEntityRelationInput"][],
	isPregnant?:boolean | null,
	remoteId?:string | null,
	isBreastfeeding?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityCategoryUpdateDogSizesEntityRelationInput"]: {
	create?:ValueTypes["DogSizeWithoutSuitabilityCategoryCreateInput"] | null,
	update?:ValueTypes["SuitabilityCategoryUpdateDogSizesRelationInput"] | null,
	upsert?:ValueTypes["SuitabilityCategoryUpsertDogSizesRelationInput"] | null,
	connect?:ValueTypes["DogSizeUniqueWhere"] | null,
	disconnect?:ValueTypes["DogSizeUniqueWhere"] | null,
	delete?:ValueTypes["DogSizeUniqueWhere"] | null,
	alias?:string | null
};
	["SuitabilityCategoryUpdateDogSizesRelationInput"]: {
	by:ValueTypes["DogSizeUniqueWhere"],
	data:ValueTypes["DogSizeWithoutSuitabilityCategoryUpdateInput"]
};
	["DogSizeWithoutSuitabilityCategoryUpdateInput"]: {
	breeds?:ValueTypes["DogSizeUpdateBreedsEntityRelationInput"][],
	remoteId?:string | null,
	products?:ValueTypes["DogSizeUpdateProductsEntityRelationInput"][],
	name?:ValueTypes["SizeType"] | null,
	label?:string | null,
	order?:number | null,
	isFilterVisible?:boolean | null,
	_dummy_field_?:boolean | null
};
	["DogSizeUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductWithoutRecommendedDogSizesCreateInput"] | null,
	update?:ValueTypes["DogSizeUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["DogSizeUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductUniqueWhere"] | null,
	alias?:string | null
};
	["DogSizeUpdateProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	data:ValueTypes["ProductWithoutRecommendedDogSizesUpdateInput"]
};
	["ProductWithoutRecommendedDogSizesUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdateGranuleSizesEntityRelationInput"]: {
	create?:ValueTypes["GranuleSizeWithoutProductsCreateInput"] | null,
	update?:ValueTypes["ProductUpdateGranuleSizesRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertGranuleSizesRelationInput"] | null,
	connect?:ValueTypes["GranuleSizeUniqueWhere"] | null,
	disconnect?:ValueTypes["GranuleSizeUniqueWhere"] | null,
	delete?:ValueTypes["GranuleSizeUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateGranuleSizesRelationInput"]: {
	by:ValueTypes["GranuleSizeUniqueWhere"],
	data:ValueTypes["GranuleSizeWithoutProductsUpdateInput"]
};
	["GranuleSizeWithoutProductsUpdateInput"]: {
	remoteId?:string | null,
	name?:ValueTypes["GranuleSizeType"] | null,
	_dummy_field_?:boolean | null
};
	["ProductUpsertGranuleSizesRelationInput"]: {
	by:ValueTypes["GranuleSizeUniqueWhere"],
	update:ValueTypes["GranuleSizeWithoutProductsUpdateInput"],
	create:ValueTypes["GranuleSizeWithoutProductsCreateInput"]
};
	["ProductUpdateProductLineEntityRelationInput"]: {
	connect?:ValueTypes["ProductLineUniqueWhere"] | null,
	create?:ValueTypes["ProductLineWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateProductLineRelationInput"] | null,
	update?:ValueTypes["ProductLineWithoutProductsUpdateInput"] | null,
	upsert?:ValueTypes["ProductUpsertProductLineRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductLineWithoutProductsUpdateInput"]: {
	name?:string | null,
	remoteId?:string | null,
	lead?:string | null,
	order?:number | null,
	brand?:ValueTypes["ProductLineUpdateBrandEntityRelationInput"] | null,
	logo?:ValueTypes["ProductLineUpdateLogoEntityRelationInput"] | null,
	aliases?:ValueTypes["ProductLineUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["ProductLineUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["ProductLineUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductLineUpdateBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutProductLinesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductLineConnectOrCreateBrandRelationInput"] | null,
	update?:ValueTypes["BrandWithoutProductLinesUpdateInput"] | null,
	upsert?:ValueTypes["ProductLineUpsertBrandRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandWithoutProductLinesUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["BrandUpdateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandUpdateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	logo?:ValueTypes["BrandUpdateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandUpdateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandUpdateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandUpdateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandUpdateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandUpdateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductWithoutBrandCreateInput"] | null,
	update?:ValueTypes["BrandUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["BrandUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductUniqueWhere"] | null,
	alias?:string | null
};
	["BrandUpdateProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	data:ValueTypes["ProductWithoutBrandUpdateInput"]
};
	["ProductWithoutBrandUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdateFlagsEntityRelationInput"]: {
	create?:ValueTypes["ProductFlagOfProductWithoutProductCreateInput"] | null,
	update?:ValueTypes["ProductUpdateFlagsRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertFlagsRelationInput"] | null,
	connect?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateFlagsRelationInput"]: {
	by:ValueTypes["ProductFlagOfProductUniqueWhere"],
	data:ValueTypes["ProductFlagOfProductWithoutProductUpdateInput"]
};
	["ProductFlagOfProductWithoutProductUpdateInput"]: {
	remoteId?:string | null,
	value?:ValueTypes["ProductFlagValue"] | null,
	flag?:ValueTypes["ProductFlagOfProductUpdateFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFlagOfProductUpdateFlagEntityRelationInput"]: {
	connect?:ValueTypes["ProductFlagUniqueWhere"] | null,
	create?:ValueTypes["ProductFlagWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFlagOfProductConnectOrCreateFlagRelationInput"] | null,
	update?:ValueTypes["ProductFlagWithoutProductsUpdateInput"] | null,
	upsert?:ValueTypes["ProductFlagOfProductUpsertFlagRelationInput"] | null,
	delete?:boolean | null
};
	["ProductFlagWithoutProductsUpdateInput"]: {
	remoteId?:string | null,
	productFeatures?:ValueTypes["ProductFlagUpdateProductFeaturesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductFlagUpdateProductFeaturesEntityRelationInput"]: {
	create?:ValueTypes["ProductFeatureWithoutDependentFlagCreateInput"] | null,
	update?:ValueTypes["ProductFlagUpdateProductFeaturesRelationInput"] | null,
	upsert?:ValueTypes["ProductFlagUpsertProductFeaturesRelationInput"] | null,
	connect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	delete?:ValueTypes["ProductFeatureUniqueWhere"] | null,
	alias?:string | null
};
	["ProductFlagUpdateProductFeaturesRelationInput"]: {
	by:ValueTypes["ProductFeatureUniqueWhere"],
	data:ValueTypes["ProductFeatureWithoutDependentFlagUpdateInput"]
};
	["ProductFeatureWithoutDependentFlagUpdateInput"]: {
	text?:string | null,
	category?:ValueTypes["FeatureCategoryType"] | null,
	value?:ValueTypes["FeatureValueType"] | null,
	remoteId?:string | null,
	linkItem?:ValueTypes["ProductFeatureUpdateLinkItemEntityRelationInput"] | null,
	dependentElement?:ValueTypes["ProductFeatureUpdateDependentElementEntityRelationInput"] | null,
	dependentCategory?:ValueTypes["ProductFeatureUpdateDependentCategoryEntityRelationInput"] | null,
	dependentSubCategory?:ValueTypes["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFlagUpsertProductFeaturesRelationInput"]: {
	by:ValueTypes["ProductFeatureUniqueWhere"],
	update:ValueTypes["ProductFeatureWithoutDependentFlagUpdateInput"],
	create:ValueTypes["ProductFeatureWithoutDependentFlagCreateInput"]
};
	["ProductFlagOfProductUpsertFlagRelationInput"]: {
	update:ValueTypes["ProductFlagWithoutProductsUpdateInput"],
	create:ValueTypes["ProductFlagWithoutProductsCreateInput"]
};
	["ProductUpsertFlagsRelationInput"]: {
	by:ValueTypes["ProductFlagOfProductUniqueWhere"],
	update:ValueTypes["ProductFlagOfProductWithoutProductUpdateInput"],
	create:ValueTypes["ProductFlagOfProductWithoutProductCreateInput"]
};
	["ProductUpdateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateImageRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ProductUpsertImageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductUpsertImageRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["ProductUpdateRecommendedActivityEntityRelationInput"]: {
	connect?:ValueTypes["DogActivityUniqueWhere"] | null,
	create?:ValueTypes["DogActivityWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateRecommendedActivityRelationInput"] | null,
	update?:ValueTypes["DogActivityWithoutProductsUpdateInput"] | null,
	upsert?:ValueTypes["ProductUpsertRecommendedActivityRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DogActivityWithoutProductsUpdateInput"]: {
	label?:string | null,
	dogs?:ValueTypes["DogActivityUpdateDogsEntityRelationInput"][],
	dailyEnergyRequirementCoeficient?:number | null,
	remoteId?:string | null,
	suitabilityCategory?:ValueTypes["DogActivityUpdateSuitabilityCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogActivityUpdateDogsEntityRelationInput"]: {
	create?:ValueTypes["DogWithoutActivityCreateInput"] | null,
	update?:ValueTypes["DogActivityUpdateDogsRelationInput"] | null,
	upsert?:ValueTypes["DogActivityUpsertDogsRelationInput"] | null,
	connect?:ValueTypes["DogUniqueWhere"] | null,
	disconnect?:ValueTypes["DogUniqueWhere"] | null,
	delete?:ValueTypes["DogUniqueWhere"] | null,
	alias?:string | null
};
	["DogActivityUpdateDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	data:ValueTypes["DogWithoutActivityUpdateInput"]
};
	["DogWithoutActivityUpdateInput"]: {
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogUpdateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogUpdateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogUpdateOwnerEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogUpdateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogUpdateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogUpdateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogUpdateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogUpdateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogUpdateReproductionEntityRelationInput"]: {
	connect?:ValueTypes["DogReproductionUniqueWhere"] | null,
	create?:ValueTypes["DogReproductionWithoutDogCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateReproductionRelationInput"] | null,
	update?:ValueTypes["DogReproductionWithoutDogUpdateInput"] | null,
	upsert?:ValueTypes["DogUpsertReproductionRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DogReproductionWithoutDogUpdateInput"]: {
	type?:ValueTypes["DogReproductionType"] | null,
	breastfeedingPuppyCount?:number | null,
	pregnancy?:ValueTypes["PregnantPeriodType"] | null,
	breastfeedingCategory?:ValueTypes["DogReproductionUpdateBreastfeedingCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogReproductionUpdateBreastfeedingCategoryEntityRelationInput"]: {
	connect?:ValueTypes["BreastfeedingCategoryUniqueWhere"] | null,
	create?:ValueTypes["BreastfeedingCategoryWithoutDogsCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogReproductionConnectOrCreateBreastfeedingCategoryRelationInput"] | null,
	update?:ValueTypes["BreastfeedingCategoryWithoutDogsUpdateInput"] | null,
	upsert?:ValueTypes["DogReproductionUpsertBreastfeedingCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BreastfeedingCategoryWithoutDogsUpdateInput"]: {
	week?:number | null,
	coeficient?:number | null,
	_dummy_field_?:boolean | null
};
	["DogReproductionUpsertBreastfeedingCategoryRelationInput"]: {
	update:ValueTypes["BreastfeedingCategoryWithoutDogsUpdateInput"],
	create:ValueTypes["BreastfeedingCategoryWithoutDogsCreateInput"]
};
	["DogUpsertReproductionRelationInput"]: {
	update:ValueTypes["DogReproductionWithoutDogUpdateInput"],
	create:ValueTypes["DogReproductionWithoutDogCreateInput"]
};
	["DogUpdateAllergiesEntityRelationInput"]: {
	create?:ValueTypes["ItemSubCategoryWithoutDogsCreateInput"] | null,
	update?:ValueTypes["DogUpdateAllergiesRelationInput"] | null,
	upsert?:ValueTypes["DogUpsertAllergiesRelationInput"] | null,
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["DogUpdateAllergiesRelationInput"]: {
	by:ValueTypes["ItemSubCategoryUniqueWhere"],
	data:ValueTypes["ItemSubCategoryWithoutDogsUpdateInput"]
};
	["ItemSubCategoryWithoutDogsUpdateInput"]: {
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryUpdateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"] | null,
	iconNegative?:ValueTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryUpdateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryUpdateIconNegativeEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateIconNegativeRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ItemSubCategoryUpsertIconNegativeRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemSubCategoryUpsertIconNegativeRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["ItemSubCategoryUpdateIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemSubCategoryConnectOrCreateIconRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ItemSubCategoryUpsertIconRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemSubCategoryUpsertIconRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["ItemSubCategoryUpdateBrandsEntityRelationInput"]: {
	connect?:ValueTypes["BrandFlavorUniqueWhere"] | null,
	disconnect?:ValueTypes["BrandFlavorUniqueWhere"] | null,
	delete?:ValueTypes["BrandFlavorUniqueWhere"] | null,
	alias?:string | null
};
	["ItemSubCategoryUpdateProductLinesEntityRelationInput"]: {
	connect?:ValueTypes["ProductLineFlavorUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductLineFlavorUniqueWhere"] | null,
	delete?:ValueTypes["ProductLineFlavorUniqueWhere"] | null,
	alias?:string | null
};
	["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"]: {
	create?:ValueTypes["FilterComboWithoutFlavorCreateInput"] | null,
	update?:ValueTypes["ItemSubCategoryUpdateFilterCombosFlavorRelationInput"] | null,
	upsert?:ValueTypes["ItemSubCategoryUpsertFilterCombosFlavorRelationInput"] | null,
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	disconnect?:ValueTypes["FilterComboUniqueWhere"] | null,
	delete?:ValueTypes["FilterComboUniqueWhere"] | null,
	alias?:string | null
};
	["ItemSubCategoryUpdateFilterCombosFlavorRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	data:ValueTypes["FilterComboWithoutFlavorUpdateInput"]
};
	["FilterComboWithoutFlavorUpdateInput"]: {
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboUpdateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboUpdateBreedEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboUpdateBrandEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboUpdateRegionEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboUpdateAgeCategoryEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboUpdateTreatmentEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboUpdateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilterComboUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["FilterComboUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FilterComboUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoUpdateInput"],
	create:ValueTypes["SeoCreateInput"]
};
	["FilterComboUpdateBreedEntityRelationInput"]: {
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	create?:ValueTypes["BreedWithoutFilterCombosCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateBreedRelationInput"] | null,
	update?:ValueTypes["BreedWithoutFilterCombosUpdateInput"] | null,
	upsert?:ValueTypes["FilterComboUpsertBreedRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BreedWithoutFilterCombosUpdateInput"]: {
	dogs?:ValueTypes["BreedUpdateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedUpdateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedUpdateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedUpdateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedUpdateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedUpdateSizeEntityRelationInput"] | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["BreedUpdateProductReviewsEntityRelationInput"]: {
	create?:ValueTypes["ProductReviewWithoutBreedCreateInput"] | null,
	update?:ValueTypes["BreedUpdateProductReviewsRelationInput"] | null,
	upsert?:ValueTypes["BreedUpsertProductReviewsRelationInput"] | null,
	connect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	delete?:ValueTypes["ProductReviewUniqueWhere"] | null,
	alias?:string | null
};
	["BreedUpdateProductReviewsRelationInput"]: {
	by:ValueTypes["ProductReviewUniqueWhere"],
	data:ValueTypes["ProductReviewWithoutBreedUpdateInput"]
};
	["ProductReviewWithoutBreedUpdateInput"]: {
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	productReviewReactions?:ValueTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"][],
	score?:ValueTypes["ProductReviewUpdateScoreEntityRelationInput"] | null,
	product?:ValueTypes["ProductReviewUpdateProductEntityRelationInput"] | null,
	user?:ValueTypes["ProductReviewUpdateUserEntityRelationInput"] | null,
	fullName?:string | null,
	age?:ValueTypes["ProductReviewUpdateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewUpdateAgeEntityRelationInput"]: {
	connect?:ValueTypes["AgeUniqueWhere"] | null,
	create?:ValueTypes["AgeWithoutProductReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewConnectOrCreateAgeRelationInput"] | null,
	update?:ValueTypes["AgeWithoutProductReviewsUpdateInput"] | null,
	upsert?:ValueTypes["ProductReviewUpsertAgeRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AgeWithoutProductReviewsUpdateInput"]: {
	dogs?:ValueTypes["AgeUpdateDogsEntityRelationInput"][],
	breeds?:ValueTypes["AgeUpdateBreedsEntityRelationInput"][],
	ageRange?:ValueTypes["AgeRangeType"] | null,
	categoryLabel?:ValueTypes["AgeLabelType"] | null,
	suitabilityCategories?:ValueTypes["AgeUpdateSuitabilityCategoriesEntityRelationInput"][],
	remoteId?:string | null,
	blogPostReviews?:ValueTypes["AgeUpdateBlogPostReviewsEntityRelationInput"][],
	label?:string | null,
	categoryOrder?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeUpdateSuitabilityCategoriesEntityRelationInput"]: {
	create?:ValueTypes["SuitabilityCategoryWithoutDogAgesCreateInput"] | null,
	update?:ValueTypes["AgeUpdateSuitabilityCategoriesRelationInput"] | null,
	upsert?:ValueTypes["AgeUpsertSuitabilityCategoriesRelationInput"] | null,
	connect?:ValueTypes["SuitabilityCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["SuitabilityCategoryUniqueWhere"] | null,
	delete?:ValueTypes["SuitabilityCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["AgeUpdateSuitabilityCategoriesRelationInput"]: {
	by:ValueTypes["SuitabilityCategoryUniqueWhere"],
	data:ValueTypes["SuitabilityCategoryWithoutDogAgesUpdateInput"]
};
	["SuitabilityCategoryWithoutDogAgesUpdateInput"]: {
	name?:string | null,
	dogSizes?:ValueTypes["SuitabilityCategoryUpdateDogSizesEntityRelationInput"][],
	dogActivities?:ValueTypes["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"][],
	breeds?:ValueTypes["SuitabilityCategoryUpdateBreedsEntityRelationInput"][],
	suitabilityItems?:ValueTypes["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"][],
	isPregnant?:boolean | null,
	remoteId?:string | null,
	isBreastfeeding?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"]: {
	create?:ValueTypes["DogActivityWithoutSuitabilityCategoryCreateInput"] | null,
	update?:ValueTypes["SuitabilityCategoryUpdateDogActivitiesRelationInput"] | null,
	upsert?:ValueTypes["SuitabilityCategoryUpsertDogActivitiesRelationInput"] | null,
	connect?:ValueTypes["DogActivityUniqueWhere"] | null,
	disconnect?:ValueTypes["DogActivityUniqueWhere"] | null,
	delete?:ValueTypes["DogActivityUniqueWhere"] | null,
	alias?:string | null
};
	["SuitabilityCategoryUpdateDogActivitiesRelationInput"]: {
	by:ValueTypes["DogActivityUniqueWhere"],
	data:ValueTypes["DogActivityWithoutSuitabilityCategoryUpdateInput"]
};
	["DogActivityWithoutSuitabilityCategoryUpdateInput"]: {
	label?:string | null,
	dogs?:ValueTypes["DogActivityUpdateDogsEntityRelationInput"][],
	products?:ValueTypes["DogActivityUpdateProductsEntityRelationInput"][],
	dailyEnergyRequirementCoeficient?:number | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityCategoryUpsertDogActivitiesRelationInput"]: {
	by:ValueTypes["DogActivityUniqueWhere"],
	update:ValueTypes["DogActivityWithoutSuitabilityCategoryUpdateInput"],
	create:ValueTypes["DogActivityWithoutSuitabilityCategoryCreateInput"]
};
	["SuitabilityCategoryUpdateBreedsEntityRelationInput"]: {
	create?:ValueTypes["BreedWithoutSuitabilityCategoryCreateInput"] | null,
	update?:ValueTypes["SuitabilityCategoryUpdateBreedsRelationInput"] | null,
	upsert?:ValueTypes["SuitabilityCategoryUpsertBreedsRelationInput"] | null,
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	disconnect?:ValueTypes["BreedUniqueWhere"] | null,
	delete?:ValueTypes["BreedUniqueWhere"] | null,
	alias?:string | null
};
	["SuitabilityCategoryUpdateBreedsRelationInput"]: {
	by:ValueTypes["BreedUniqueWhere"],
	data:ValueTypes["BreedWithoutSuitabilityCategoryUpdateInput"]
};
	["BreedWithoutSuitabilityCategoryUpdateInput"]: {
	dogs?:ValueTypes["BreedUpdateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedUpdateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedUpdateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	productReviews?:ValueTypes["BreedUpdateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedUpdateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedUpdateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedUpdateBlogPostReviewsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostReviewWithoutBreedCreateInput"] | null,
	update?:ValueTypes["BreedUpdateBlogPostReviewsRelationInput"] | null,
	upsert?:ValueTypes["BreedUpsertBlogPostReviewsRelationInput"] | null,
	connect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	alias?:string | null
};
	["BreedUpdateBlogPostReviewsRelationInput"]: {
	by:ValueTypes["BlogPostReviewUniqueWhere"],
	data:ValueTypes["BlogPostReviewWithoutBreedUpdateInput"]
};
	["BlogPostReviewWithoutBreedUpdateInput"]: {
	title?:string | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"][],
	blogPost?:ValueTypes["BlogPostReviewUpdateBlogPostEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostReviewUpdateUserEntityRelationInput"] | null,
	fullName?:string | null,
	age?:ValueTypes["BlogPostReviewUpdateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewUpdateAgeEntityRelationInput"]: {
	connect?:ValueTypes["AgeUniqueWhere"] | null,
	create?:ValueTypes["AgeWithoutBlogPostReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewConnectOrCreateAgeRelationInput"] | null,
	update?:ValueTypes["AgeWithoutBlogPostReviewsUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostReviewUpsertAgeRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AgeWithoutBlogPostReviewsUpdateInput"]: {
	dogs?:ValueTypes["AgeUpdateDogsEntityRelationInput"][],
	breeds?:ValueTypes["AgeUpdateBreedsEntityRelationInput"][],
	ageRange?:ValueTypes["AgeRangeType"] | null,
	categoryLabel?:ValueTypes["AgeLabelType"] | null,
	suitabilityCategories?:ValueTypes["AgeUpdateSuitabilityCategoriesEntityRelationInput"][],
	remoteId?:string | null,
	productReviews?:ValueTypes["AgeUpdateProductReviewsEntityRelationInput"][],
	label?:string | null,
	categoryOrder?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeUpdateProductReviewsEntityRelationInput"]: {
	create?:ValueTypes["ProductReviewWithoutAgeCreateInput"] | null,
	update?:ValueTypes["AgeUpdateProductReviewsRelationInput"] | null,
	upsert?:ValueTypes["AgeUpsertProductReviewsRelationInput"] | null,
	connect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	delete?:ValueTypes["ProductReviewUniqueWhere"] | null,
	alias?:string | null
};
	["AgeUpdateProductReviewsRelationInput"]: {
	by:ValueTypes["ProductReviewUniqueWhere"],
	data:ValueTypes["ProductReviewWithoutAgeUpdateInput"]
};
	["ProductReviewWithoutAgeUpdateInput"]: {
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	productReviewReactions?:ValueTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"][],
	score?:ValueTypes["ProductReviewUpdateScoreEntityRelationInput"] | null,
	product?:ValueTypes["ProductReviewUpdateProductEntityRelationInput"] | null,
	user?:ValueTypes["ProductReviewUpdateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["ProductReviewUpdateBreedEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewUpdateBreedEntityRelationInput"]: {
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	create?:ValueTypes["BreedWithoutProductReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductReviewConnectOrCreateBreedRelationInput"] | null,
	update?:ValueTypes["BreedWithoutProductReviewsUpdateInput"] | null,
	upsert?:ValueTypes["ProductReviewUpsertBreedRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BreedWithoutProductReviewsUpdateInput"]: {
	dogs?:ValueTypes["BreedUpdateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedUpdateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedUpdateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"] | null,
	blogPostReviews?:ValueTypes["BreedUpdateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedUpdateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedUpdateSizeEntityRelationInput"]: {
	connect?:ValueTypes["DogSizeUniqueWhere"] | null,
	create?:ValueTypes["DogSizeWithoutBreedsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BreedConnectOrCreateSizeRelationInput"] | null,
	update?:ValueTypes["DogSizeWithoutBreedsUpdateInput"] | null,
	upsert?:ValueTypes["BreedUpsertSizeRelationInput"] | null
};
	["DogSizeWithoutBreedsUpdateInput"]: {
	remoteId?:string | null,
	products?:ValueTypes["DogSizeUpdateProductsEntityRelationInput"][],
	suitabilityCategory?:ValueTypes["DogSizeUpdateSuitabilityCategoryEntityRelationInput"] | null,
	name?:ValueTypes["SizeType"] | null,
	label?:string | null,
	order?:number | null,
	isFilterVisible?:boolean | null,
	_dummy_field_?:boolean | null
};
	["DogSizeUpdateSuitabilityCategoryEntityRelationInput"]: {
	connect?:ValueTypes["SuitabilityCategoryUniqueWhere"] | null,
	create?:ValueTypes["SuitabilityCategoryWithoutDogSizesCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogSizeConnectOrCreateSuitabilityCategoryRelationInput"] | null,
	update?:ValueTypes["SuitabilityCategoryWithoutDogSizesUpdateInput"] | null,
	upsert?:ValueTypes["DogSizeUpsertSuitabilityCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SuitabilityCategoryWithoutDogSizesUpdateInput"]: {
	name?:string | null,
	dogActivities?:ValueTypes["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"][],
	breeds?:ValueTypes["SuitabilityCategoryUpdateBreedsEntityRelationInput"][],
	suitabilityItems?:ValueTypes["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"][],
	dogAges?:ValueTypes["SuitabilityCategoryUpdateDogAgesEntityRelationInput"][],
	isPregnant?:boolean | null,
	remoteId?:string | null,
	isBreastfeeding?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"]: {
	create?:ValueTypes["SuitabilityItemWithoutCategoryCreateInput"] | null,
	update?:ValueTypes["SuitabilityCategoryUpdateSuitabilityItemsRelationInput"] | null,
	upsert?:ValueTypes["SuitabilityCategoryUpsertSuitabilityItemsRelationInput"] | null,
	connect?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	disconnect?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	delete?:ValueTypes["SuitabilityItemUniqueWhere"] | null,
	alias?:string | null
};
	["SuitabilityCategoryUpdateSuitabilityItemsRelationInput"]: {
	by:ValueTypes["SuitabilityItemUniqueWhere"],
	data:ValueTypes["SuitabilityItemWithoutCategoryUpdateInput"]
};
	["SuitabilityItemWithoutCategoryUpdateInput"]: {
	min?:number | null,
	max?:number | null,
	remoteId?:string | null,
	order?:number | null,
	element?:ValueTypes["SuitabilityItemUpdateElementEntityRelationInput"] | null,
	nutritionalValue?:ValueTypes["SuitabilityItemUpdateNutritionalValueEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityCategoryUpsertSuitabilityItemsRelationInput"]: {
	by:ValueTypes["SuitabilityItemUniqueWhere"],
	update:ValueTypes["SuitabilityItemWithoutCategoryUpdateInput"],
	create:ValueTypes["SuitabilityItemWithoutCategoryCreateInput"]
};
	["SuitabilityCategoryUpdateDogAgesEntityRelationInput"]: {
	create?:ValueTypes["AgeWithoutSuitabilityCategoriesCreateInput"] | null,
	update?:ValueTypes["SuitabilityCategoryUpdateDogAgesRelationInput"] | null,
	upsert?:ValueTypes["SuitabilityCategoryUpsertDogAgesRelationInput"] | null,
	connect?:ValueTypes["AgeUniqueWhere"] | null,
	disconnect?:ValueTypes["AgeUniqueWhere"] | null,
	delete?:ValueTypes["AgeUniqueWhere"] | null,
	alias?:string | null
};
	["SuitabilityCategoryUpdateDogAgesRelationInput"]: {
	by:ValueTypes["AgeUniqueWhere"],
	data:ValueTypes["AgeWithoutSuitabilityCategoriesUpdateInput"]
};
	["AgeWithoutSuitabilityCategoriesUpdateInput"]: {
	dogs?:ValueTypes["AgeUpdateDogsEntityRelationInput"][],
	breeds?:ValueTypes["AgeUpdateBreedsEntityRelationInput"][],
	ageRange?:ValueTypes["AgeRangeType"] | null,
	categoryLabel?:ValueTypes["AgeLabelType"] | null,
	remoteId?:string | null,
	productReviews?:ValueTypes["AgeUpdateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["AgeUpdateBlogPostReviewsEntityRelationInput"][],
	label?:string | null,
	categoryOrder?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeUpdateBlogPostReviewsEntityRelationInput"]: {
	create?:ValueTypes["BlogPostReviewWithoutAgeCreateInput"] | null,
	update?:ValueTypes["AgeUpdateBlogPostReviewsRelationInput"] | null,
	upsert?:ValueTypes["AgeUpsertBlogPostReviewsRelationInput"] | null,
	connect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	disconnect?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	delete?:ValueTypes["BlogPostReviewUniqueWhere"] | null,
	alias?:string | null
};
	["AgeUpdateBlogPostReviewsRelationInput"]: {
	by:ValueTypes["BlogPostReviewUniqueWhere"],
	data:ValueTypes["BlogPostReviewWithoutAgeUpdateInput"]
};
	["BlogPostReviewWithoutAgeUpdateInput"]: {
	title?:string | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"][],
	blogPost?:ValueTypes["BlogPostReviewUpdateBlogPostEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostReviewUpdateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["BlogPostReviewUpdateBreedEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewUpdateBreedEntityRelationInput"]: {
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	create?:ValueTypes["BreedWithoutBlogPostReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BlogPostReviewConnectOrCreateBreedRelationInput"] | null,
	update?:ValueTypes["BreedWithoutBlogPostReviewsUpdateInput"] | null,
	upsert?:ValueTypes["BlogPostReviewUpsertBreedRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BreedWithoutBlogPostReviewsUpdateInput"]: {
	dogs?:ValueTypes["BreedUpdateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedUpdateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedUpdateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedUpdateProductReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedUpdateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedUpdateFilterCombosEntityRelationInput"]: {
	create?:ValueTypes["FilterComboWithoutBreedCreateInput"] | null,
	update?:ValueTypes["BreedUpdateFilterCombosRelationInput"] | null,
	upsert?:ValueTypes["BreedUpsertFilterCombosRelationInput"] | null,
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	disconnect?:ValueTypes["FilterComboUniqueWhere"] | null,
	delete?:ValueTypes["FilterComboUniqueWhere"] | null,
	alias?:string | null
};
	["BreedUpdateFilterCombosRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	data:ValueTypes["FilterComboWithoutBreedUpdateInput"]
};
	["FilterComboWithoutBreedUpdateInput"]: {
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboUpdateSeoEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboUpdateBrandEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboUpdateRegionEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboUpdateAgeCategoryEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboUpdateTreatmentEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboUpdateFlavorEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboUpdateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilterComboUpdateBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutFilterCombosCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateBrandRelationInput"] | null,
	update?:ValueTypes["BrandWithoutFilterCombosUpdateInput"] | null,
	upsert?:ValueTypes["FilterComboUpsertBrandRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandWithoutFilterCombosUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["BrandUpdateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandUpdateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandUpdateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandUpdateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandUpdateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandUpdateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandUpdateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	topx?:ValueTypes["BrandUpdateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandUpdateCountriesOfProductionEntityRelationInput"]: {
	create?:ValueTypes["CountryWithoutBrandsCreateInput"] | null,
	update?:ValueTypes["BrandUpdateCountriesOfProductionRelationInput"] | null,
	upsert?:ValueTypes["BrandUpsertCountriesOfProductionRelationInput"] | null,
	connect?:ValueTypes["CountryUniqueWhere"] | null,
	disconnect?:ValueTypes["CountryUniqueWhere"] | null,
	delete?:ValueTypes["CountryUniqueWhere"] | null,
	alias?:string | null
};
	["BrandUpdateCountriesOfProductionRelationInput"]: {
	by:ValueTypes["CountryUniqueWhere"],
	data:ValueTypes["CountryWithoutBrandsUpdateInput"]
};
	["CountryWithoutBrandsUpdateInput"]: {
	name?:string | null,
	manufacturers?:ValueTypes["CountryUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	region?:ValueTypes["CountryUpdateRegionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["CountryUpdateManufacturersEntityRelationInput"]: {
	create?:ValueTypes["BrandManufacturerWithoutResidenceCreateInput"] | null,
	update?:ValueTypes["CountryUpdateManufacturersRelationInput"] | null,
	upsert?:ValueTypes["CountryUpsertManufacturersRelationInput"] | null,
	connect?:ValueTypes["BrandManufacturerUniqueWhere"] | null,
	disconnect?:ValueTypes["BrandManufacturerUniqueWhere"] | null,
	delete?:ValueTypes["BrandManufacturerUniqueWhere"] | null,
	alias?:string | null
};
	["CountryUpdateManufacturersRelationInput"]: {
	by:ValueTypes["BrandManufacturerUniqueWhere"],
	data:ValueTypes["BrandManufacturerWithoutResidenceUpdateInput"]
};
	["BrandManufacturerWithoutResidenceUpdateInput"]: {
	name?:string | null,
	link?:string | null,
	brands?:ValueTypes["BrandManufacturerUpdateBrandsEntityRelationInput"][],
	order?:number | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["BrandManufacturerUpdateBrandsEntityRelationInput"]: {
	create?:ValueTypes["BrandWithoutManufacturersCreateInput"] | null,
	update?:ValueTypes["BrandManufacturerUpdateBrandsRelationInput"] | null,
	upsert?:ValueTypes["BrandManufacturerUpsertBrandsRelationInput"] | null,
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	disconnect?:ValueTypes["BrandUniqueWhere"] | null,
	delete?:ValueTypes["BrandUniqueWhere"] | null,
	alias?:string | null
};
	["BrandManufacturerUpdateBrandsRelationInput"]: {
	by:ValueTypes["BrandUniqueWhere"],
	data:ValueTypes["BrandWithoutManufacturersUpdateInput"]
};
	["BrandWithoutManufacturersUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["BrandUpdateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandUpdateCountriesOfProductionEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandUpdateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandUpdateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandUpdateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandUpdateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandUpdateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandUpdateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandUpdateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandUpdateProductLinesEntityRelationInput"]: {
	create?:ValueTypes["ProductLineWithoutBrandCreateInput"] | null,
	update?:ValueTypes["BrandUpdateProductLinesRelationInput"] | null,
	upsert?:ValueTypes["BrandUpsertProductLinesRelationInput"] | null,
	connect?:ValueTypes["ProductLineUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductLineUniqueWhere"] | null,
	delete?:ValueTypes["ProductLineUniqueWhere"] | null,
	alias?:string | null
};
	["BrandUpdateProductLinesRelationInput"]: {
	by:ValueTypes["ProductLineUniqueWhere"],
	data:ValueTypes["ProductLineWithoutBrandUpdateInput"]
};
	["ProductLineWithoutBrandUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["ProductLineUpdateProductsEntityRelationInput"][],
	remoteId?:string | null,
	lead?:string | null,
	order?:number | null,
	logo?:ValueTypes["ProductLineUpdateLogoEntityRelationInput"] | null,
	aliases?:ValueTypes["ProductLineUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["ProductLineUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["ProductLineUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductLineUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductWithoutProductLineCreateInput"] | null,
	update?:ValueTypes["ProductLineUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["ProductLineUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductUniqueWhere"] | null,
	alias?:string | null
};
	["ProductLineUpdateProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	data:ValueTypes["ProductWithoutProductLineUpdateInput"]
};
	["ProductWithoutProductLineUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdateBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateBrandRelationInput"] | null,
	update?:ValueTypes["BrandWithoutProductsUpdateInput"] | null,
	upsert?:ValueTypes["ProductUpsertBrandRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandWithoutProductsUpdateInput"]: {
	name?:string | null,
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandUpdateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandUpdateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandUpdateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandUpdateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandUpdateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandUpdateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandUpdateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandUpdateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandUpdateManufacturersEntityRelationInput"]: {
	create?:ValueTypes["BrandManufacturerWithoutBrandsCreateInput"] | null,
	update?:ValueTypes["BrandUpdateManufacturersRelationInput"] | null,
	upsert?:ValueTypes["BrandUpsertManufacturersRelationInput"] | null,
	connect?:ValueTypes["BrandManufacturerUniqueWhere"] | null,
	disconnect?:ValueTypes["BrandManufacturerUniqueWhere"] | null,
	delete?:ValueTypes["BrandManufacturerUniqueWhere"] | null,
	alias?:string | null
};
	["BrandUpdateManufacturersRelationInput"]: {
	by:ValueTypes["BrandManufacturerUniqueWhere"],
	data:ValueTypes["BrandManufacturerWithoutBrandsUpdateInput"]
};
	["BrandManufacturerWithoutBrandsUpdateInput"]: {
	name?:string | null,
	link?:string | null,
	order?:number | null,
	remoteId?:string | null,
	residence?:ValueTypes["BrandManufacturerUpdateResidenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandManufacturerUpdateResidenceEntityRelationInput"]: {
	connect?:ValueTypes["CountryUniqueWhere"] | null,
	create?:ValueTypes["CountryWithoutManufacturersCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandManufacturerConnectOrCreateResidenceRelationInput"] | null,
	update?:ValueTypes["CountryWithoutManufacturersUpdateInput"] | null,
	upsert?:ValueTypes["BrandManufacturerUpsertResidenceRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["CountryWithoutManufacturersUpdateInput"]: {
	name?:string | null,
	brands?:ValueTypes["CountryUpdateBrandsEntityRelationInput"][],
	remoteId?:string | null,
	region?:ValueTypes["CountryUpdateRegionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["CountryUpdateBrandsEntityRelationInput"]: {
	create?:ValueTypes["BrandWithoutCountriesOfProductionCreateInput"] | null,
	update?:ValueTypes["CountryUpdateBrandsRelationInput"] | null,
	upsert?:ValueTypes["CountryUpsertBrandsRelationInput"] | null,
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	disconnect?:ValueTypes["BrandUniqueWhere"] | null,
	delete?:ValueTypes["BrandUniqueWhere"] | null,
	alias?:string | null
};
	["CountryUpdateBrandsRelationInput"]: {
	by:ValueTypes["BrandUniqueWhere"],
	data:ValueTypes["BrandWithoutCountriesOfProductionUpdateInput"]
};
	["BrandWithoutCountriesOfProductionUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["BrandUpdateProductsEntityRelationInput"][],
	link?:string | null,
	manufacturers?:ValueTypes["BrandUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandUpdateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandUpdateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandUpdateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandUpdateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandUpdateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandUpdateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandUpdateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandUpdateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateLogoRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["BrandUpsertLogoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandUpsertLogoRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["BrandUpdateMethodOfProductionEntityRelationInput"]: {
	connect?:ValueTypes["ProductionMethodUniqueWhere"] | null,
	create?:ValueTypes["ProductionMethodWithoutBrandsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateMethodOfProductionRelationInput"] | null,
	update?:ValueTypes["ProductionMethodWithoutBrandsUpdateInput"] | null,
	upsert?:ValueTypes["BrandUpsertMethodOfProductionRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductionMethodWithoutBrandsUpdateInput"]: {
	name?:string | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["BrandUpsertMethodOfProductionRelationInput"]: {
	update:ValueTypes["ProductionMethodWithoutBrandsUpdateInput"],
	create:ValueTypes["ProductionMethodWithoutBrandsCreateInput"]
};
	["BrandUpdateDistributorEntityRelationInput"]: {
	connect?:ValueTypes["BrandDistributorUniqueWhere"] | null,
	create?:ValueTypes["BrandDistributorWithoutBrandsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateDistributorRelationInput"] | null,
	update?:ValueTypes["BrandDistributorWithoutBrandsUpdateInput"] | null,
	upsert?:ValueTypes["BrandUpsertDistributorRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandDistributorWithoutBrandsUpdateInput"]: {
	name?:string | null,
	link?:string | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["BrandUpsertDistributorRelationInput"]: {
	update:ValueTypes["BrandDistributorWithoutBrandsUpdateInput"],
	create:ValueTypes["BrandDistributorWithoutBrandsCreateInput"]
};
	["BrandUpdateAliasesEntityRelationInput"]: {
	create?:ValueTypes["BrandAliasWithoutBrandCreateInput"] | null,
	update?:ValueTypes["BrandUpdateAliasesRelationInput"] | null,
	upsert?:ValueTypes["BrandUpsertAliasesRelationInput"] | null,
	connect?:ValueTypes["BrandAliasUniqueWhere"] | null,
	disconnect?:ValueTypes["BrandAliasUniqueWhere"] | null,
	delete?:ValueTypes["BrandAliasUniqueWhere"] | null,
	alias?:string | null
};
	["BrandUpdateAliasesRelationInput"]: {
	by:ValueTypes["BrandAliasUniqueWhere"],
	data:ValueTypes["BrandAliasWithoutBrandUpdateInput"]
};
	["BrandAliasWithoutBrandUpdateInput"]: {
	remoteId?:string | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["BrandUpsertAliasesRelationInput"]: {
	by:ValueTypes["BrandAliasUniqueWhere"],
	update:ValueTypes["BrandAliasWithoutBrandUpdateInput"],
	create:ValueTypes["BrandAliasWithoutBrandCreateInput"]
};
	["BrandUpdateAdsEntityRelationInput"]: {
	create?:ValueTypes["AdWithoutBrandsCreateInput"] | null,
	update?:ValueTypes["BrandUpdateAdsRelationInput"] | null,
	upsert?:ValueTypes["BrandUpsertAdsRelationInput"] | null,
	connect?:ValueTypes["AdUniqueWhere"] | null,
	disconnect?:ValueTypes["AdUniqueWhere"] | null,
	delete?:ValueTypes["AdUniqueWhere"] | null,
	alias?:string | null
};
	["BrandUpdateAdsRelationInput"]: {
	by:ValueTypes["AdUniqueWhere"],
	data:ValueTypes["AdWithoutBrandsUpdateInput"]
};
	["AdWithoutBrandsUpdateInput"]: {
	image?:ValueTypes["AdUpdateImageEntityRelationInput"] | null,
	isBrandSectionVisible?:boolean | null,
	isBlogPostSectionVisible?:boolean | null,
	isIngredientSectionVisible?:boolean | null,
	isResultsVisible?:boolean | null,
	isSearchVisible?:boolean | null,
	blogPosts?:ValueTypes["AdUpdateBlogPostsEntityRelationInput"][],
	itemCategories?:ValueTypes["AdUpdateItemCategoriesEntityRelationInput"][],
	isActive?:boolean | null,
	link?:string | null,
	note?:string | null,
	activeFrom?:ValueTypes["DateTime"] | null,
	activeUntil?:ValueTypes["DateTime"] | null,
	slug?:string | null,
	contentReferences?:ValueTypes["AdUpdateContentReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AdUpdateContentReferencesEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutAdCreateInput"] | null,
	update?:ValueTypes["AdUpdateContentReferencesRelationInput"] | null,
	upsert?:ValueTypes["AdUpsertContentReferencesRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["AdUpdateContentReferencesRelationInput"]: {
	by:ValueTypes["ContentReferenceUniqueWhere"],
	data:ValueTypes["ContentReferenceWithoutAdUpdateInput"]
};
	["ContentReferenceWithoutAdUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fact?:string | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	relatedBlogPost?:ValueTypes["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceUpdateRelatedBrandEntityRelationInput"] | null,
	relatedProduct?:ValueTypes["ContentReferenceUpdateRelatedProductEntityRelationInput"] | null,
	relatedIngredient?:ValueTypes["ContentReferenceUpdateRelatedIngredientEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	badge?:string | null,
	longVersion?:boolean | null,
	relatedBrandFull?:ValueTypes["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"] | null,
	relatedProductFull?:ValueTypes["ContentReferenceUpdateRelatedProductFullEntityRelationInput"] | null,
	list?:ValueTypes["ContentReferenceUpdateListEntityRelationInput"][],
	outline?:ValueTypes["ContentReferenceUpdateOutlineEntityRelationInput"] | null,
	video?:ValueTypes["ContentReferenceUpdateVideoEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	defaultOpen?:boolean | null,
	badgeColor?:string | null,
	isMain?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateBlockRelationInput"] | null,
	update?:ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertBlockRelationInput"] | null,
	delete?:boolean | null
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | null,
	automatedContentBlockSlug?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentBlockConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentWithoutBlocksUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertContentRelationInput"] | null,
	delete?:boolean | null
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ContentBlockUpsertContentRelationInput"]: {
	update:ValueTypes["ContentWithoutBlocksUpdateInput"],
	create:ValueTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update:ValueTypes["ContentBlockWithoutReferencesUpdateInput"],
	create:ValueTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceUpdateRelatedBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateRelatedBrandRelationInput"] | null,
	update?:ValueTypes["BrandUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertRelatedBrandRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["BrandUpdateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandUpdateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandUpdateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandUpdateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandUpdateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandUpdateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandUpdateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandUpdateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandUpdateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandUpdateFlavorsEntityRelationInput"]: {
	connect?:ValueTypes["BrandFlavorUniqueWhere"] | null,
	disconnect?:ValueTypes["BrandFlavorUniqueWhere"] | null,
	delete?:ValueTypes["BrandFlavorUniqueWhere"] | null,
	alias?:string | null
};
	["BrandUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["BrandUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoUpdateInput"],
	create:ValueTypes["SeoCreateInput"]
};
	["BrandUpdateFilterCombosEntityRelationInput"]: {
	create?:ValueTypes["FilterComboWithoutBrandCreateInput"] | null,
	update?:ValueTypes["BrandUpdateFilterCombosRelationInput"] | null,
	upsert?:ValueTypes["BrandUpsertFilterCombosRelationInput"] | null,
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	disconnect?:ValueTypes["FilterComboUniqueWhere"] | null,
	delete?:ValueTypes["FilterComboUniqueWhere"] | null,
	alias?:string | null
};
	["BrandUpdateFilterCombosRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	data:ValueTypes["FilterComboWithoutBrandUpdateInput"]
};
	["FilterComboWithoutBrandUpdateInput"]: {
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboUpdateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboUpdateBreedEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboUpdateRegionEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboUpdateAgeCategoryEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboUpdateTreatmentEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboUpdateFlavorEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboUpdateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilterComboUpdateRegionEntityRelationInput"]: {
	connect?:ValueTypes["RegionUniqueWhere"] | null,
	create?:ValueTypes["RegionWithoutFilterCombosCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateRegionRelationInput"] | null,
	update?:ValueTypes["RegionWithoutFilterCombosUpdateInput"] | null,
	upsert?:ValueTypes["FilterComboUpsertRegionRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RegionWithoutFilterCombosUpdateInput"]: {
	name?:string | null,
	countries?:ValueTypes["RegionUpdateCountriesEntityRelationInput"][],
	remoteId?:string | null,
	adjective?:string | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["RegionUpdateCountriesEntityRelationInput"]: {
	create?:ValueTypes["CountryWithoutRegionCreateInput"] | null,
	update?:ValueTypes["RegionUpdateCountriesRelationInput"] | null,
	upsert?:ValueTypes["RegionUpsertCountriesRelationInput"] | null,
	connect?:ValueTypes["CountryUniqueWhere"] | null,
	disconnect?:ValueTypes["CountryUniqueWhere"] | null,
	delete?:ValueTypes["CountryUniqueWhere"] | null,
	alias?:string | null
};
	["RegionUpdateCountriesRelationInput"]: {
	by:ValueTypes["CountryUniqueWhere"],
	data:ValueTypes["CountryWithoutRegionUpdateInput"]
};
	["CountryWithoutRegionUpdateInput"]: {
	name?:string | null,
	brands?:ValueTypes["CountryUpdateBrandsEntityRelationInput"][],
	manufacturers?:ValueTypes["CountryUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["RegionUpsertCountriesRelationInput"]: {
	by:ValueTypes["CountryUniqueWhere"],
	update:ValueTypes["CountryWithoutRegionUpdateInput"],
	create:ValueTypes["CountryWithoutRegionCreateInput"]
};
	["FilterComboUpsertRegionRelationInput"]: {
	update:ValueTypes["RegionWithoutFilterCombosUpdateInput"],
	create:ValueTypes["RegionWithoutFilterCombosCreateInput"]
};
	["FilterComboUpdateAgeCategoryEntityRelationInput"]: {
	connect?:ValueTypes["AgeCategoryUniqueWhere"] | null,
	create?:ValueTypes["AgeCategoryWithoutFilterCombosCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateAgeCategoryRelationInput"] | null,
	update?:ValueTypes["AgeCategoryWithoutFilterCombosUpdateInput"] | null,
	upsert?:ValueTypes["FilterComboUpsertAgeCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AgeCategoryWithoutFilterCombosUpdateInput"]: {
	remoteId?:string | null,
	order?:number | null,
	labelFor?:string | null,
	products?:ValueTypes["AgeCategoryUpdateProductsEntityRelationInput"][],
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeCategoryUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductWithoutAgeCategoriesCreateInput"] | null,
	update?:ValueTypes["AgeCategoryUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["AgeCategoryUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductUniqueWhere"] | null,
	alias?:string | null
};
	["AgeCategoryUpdateProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	data:ValueTypes["ProductWithoutAgeCategoriesUpdateInput"]
};
	["ProductWithoutAgeCategoriesUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdateAliasesEntityRelationInput"]: {
	create?:ValueTypes["ProductAliasWithoutProductCreateInput"] | null,
	update?:ValueTypes["ProductUpdateAliasesRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertAliasesRelationInput"] | null,
	connect?:ValueTypes["ProductAliasUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductAliasUniqueWhere"] | null,
	delete?:ValueTypes["ProductAliasUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateAliasesRelationInput"]: {
	by:ValueTypes["ProductAliasUniqueWhere"],
	data:ValueTypes["ProductAliasWithoutProductUpdateInput"]
};
	["ProductAliasWithoutProductUpdateInput"]: {
	remoteId?:string | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductUpsertAliasesRelationInput"]: {
	by:ValueTypes["ProductAliasUniqueWhere"],
	update:ValueTypes["ProductAliasWithoutProductUpdateInput"],
	create:ValueTypes["ProductAliasWithoutProductCreateInput"]
};
	["ProductUpdateEvaluationEntityRelationInput"]: {
	connect?:ValueTypes["ProductEvaluationUniqueWhere"] | null,
	create?:ValueTypes["ProductEvaluationWithoutProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateEvaluationRelationInput"] | null,
	update?:ValueTypes["ProductEvaluationWithoutProductUpdateInput"] | null,
	upsert?:ValueTypes["ProductUpsertEvaluationRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductEvaluationWithoutProductUpdateInput"]: {
	nazev?:string | null,
	vetDieta?:string | null,
	vetDieta1?:string | null,
	vetDieta2?:string | null,
	aktivita?:string | null,
	vek?:string | null,
	velikostPlemen?:string | null,
	hmotnostPlemene?:string | null,
	velikostGranuli?:string | null,
	velikostGranuliText?:string | null,
	doporucenaAktivitaDleMe?:string | null,
	vypocitanaMeVsMeVyrobce?:string | null,
	vypocitanaMeVsMeVyrobce2?:string | null,
	masoNaPrvnimMisteText?:string | null,
	zdrojeZivocisnychBilkovinDle1Vyskytu?:string | null,
	prichuteSeznam?:string | null,
	eliminacniDietaTextInterpunkce?:string | null,
	alergenyZadneNeobsahuje?:string | null,
	alergenyObsahuje?:string | null,
	alergenyNejakeNeobsahuje?:string | null,
	prospesneDruhyInterpunkce?:string | null,
	nevhodneDruhy?:string | null,
	kladneUcinkyCeleTelo?:string | null,
	kladneUcinkyHlava?:string | null,
	kladneUcinkyHrudnik?:string | null,
	kladneUcinkyBricho?:string | null,
	kladneUcinkySpodniCast?:string | null,
	zaporneUcinkyCeleTelo?:string | null,
	zaporneUcinkyHlava?:string | null,
	zaporneUcinkyHrudnik?:string | null,
	zaporneUcinkyBricho?:string | null,
	zaporneUcinkySpodniCast?:string | null,
	dsneuvedeno?:string | null,
	dsmalo?:string | null,
	dsprilis?:string | null,
	dsok?:string | null,
	d95malo?:string | null,
	d95prilis?:string | null,
	d95ok?:string | null,
	d110malo?:string | null,
	d110prilis?:string | null,
	d110ok?:string | null,
	sdo14reproMalo?:string | null,
	sdo14reproPrilis?:string | null,
	sdo14reproOk?:string | null,
	sdo15malo?:string | null,
	sdo15prilis?:string | null,
	sdo15ok?:string | null,
	s15malo?:string | null,
	s15prilis?:string | null,
	s15ok?:string | null,
	masoAnoNe?:string | null,
	eliminacniDietaAnoNe?:string | null,
	alergenyAnoNe?:string | null,
	plodnostKastraceNadpis?:string | null,
	plodnostKastraceText?:string | null,
	remoteId?:string | null,
	stravitelnostNadpis?:string | null,
	stravitelnostProcenta?:string | null,
	stravitelnostSlovne?:string | null,
	stravitelnostChybiText?:string | null,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductUpsertEvaluationRelationInput"]: {
	update:ValueTypes["ProductEvaluationWithoutProductUpdateInput"],
	create:ValueTypes["ProductEvaluationWithoutProductCreateInput"]
};
	["ProductUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ProductUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoUpdateInput"],
	create:ValueTypes["SeoCreateInput"]
};
	["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateHeurekaImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductConnectOrCreateHeurekaImageRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ProductUpsertHeurekaImageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductUpsertHeurekaImageRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["ProductUpdateTopxEntityRelationInput"]: {
	create?:ValueTypes["TOPXProductWithoutProductCreateInput"] | null,
	update?:ValueTypes["ProductUpdateTopxRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertTopxRelationInput"] | null,
	connect?:ValueTypes["TOPXProductUniqueWhere"] | null,
	disconnect?:ValueTypes["TOPXProductUniqueWhere"] | null,
	delete?:ValueTypes["TOPXProductUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateTopxRelationInput"]: {
	by:ValueTypes["TOPXProductUniqueWhere"],
	data:ValueTypes["TOPXProductWithoutProductUpdateInput"]
};
	["TOPXProductWithoutProductUpdateInput"]: {
	remoteId?:string | null,
	order?:number | null,
	orderType?:ValueTypes["TOPXProductOrderType"] | null,
	category?:ValueTypes["TOPXProductUpdateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXProductUpdateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["TOPXProductCategoryUniqueWhere"] | null,
	create?:ValueTypes["TOPXProductCategoryWithoutProductsCreateInput"] | null,
	connectOrCreate?:ValueTypes["TOPXProductConnectOrCreateCategoryRelationInput"] | null,
	update?:ValueTypes["TOPXProductCategoryWithoutProductsUpdateInput"] | null,
	upsert?:ValueTypes["TOPXProductUpsertCategoryRelationInput"] | null,
	delete?:boolean | null
};
	["TOPXProductCategoryWithoutProductsUpdateInput"]: {
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["TOPXProductUpsertCategoryRelationInput"]: {
	update:ValueTypes["TOPXProductCategoryWithoutProductsUpdateInput"],
	create:ValueTypes["TOPXProductCategoryWithoutProductsCreateInput"]
};
	["ProductUpsertTopxRelationInput"]: {
	by:ValueTypes["TOPXProductUniqueWhere"],
	update:ValueTypes["TOPXProductWithoutProductUpdateInput"],
	create:ValueTypes["TOPXProductWithoutProductCreateInput"]
};
	["AgeCategoryUpsertProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	update:ValueTypes["ProductWithoutAgeCategoriesUpdateInput"],
	create:ValueTypes["ProductWithoutAgeCategoriesCreateInput"]
};
	["FilterComboUpsertAgeCategoryRelationInput"]: {
	update:ValueTypes["AgeCategoryWithoutFilterCombosUpdateInput"],
	create:ValueTypes["AgeCategoryWithoutFilterCombosCreateInput"]
};
	["FilterComboUpdateTreatmentEntityRelationInput"]: {
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	create?:ValueTypes["BodyTagWithoutFilterCombosCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateTreatmentRelationInput"] | null,
	update?:ValueTypes["BodyTagWithoutFilterCombosUpdateInput"] | null,
	upsert?:ValueTypes["FilterComboUpsertTreatmentRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BodyTagWithoutFilterCombosUpdateInput"]: {
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagUpdateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagUpdatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagUpdateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagUpdatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagUpdateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagUpdateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagUpdateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagUpdateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["BodyTagUpdateIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["BodyTagConnectOrCreateIconRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["BodyTagUpsertIconRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BodyTagUpsertIconRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["BodyTagUpdateDogsEntityRelationInput"]: {
	create?:ValueTypes["DogWithoutIllnessesCreateInput"] | null,
	update?:ValueTypes["BodyTagUpdateDogsRelationInput"] | null,
	upsert?:ValueTypes["BodyTagUpsertDogsRelationInput"] | null,
	connect?:ValueTypes["DogUniqueWhere"] | null,
	disconnect?:ValueTypes["DogUniqueWhere"] | null,
	delete?:ValueTypes["DogUniqueWhere"] | null,
	alias?:string | null
};
	["BodyTagUpdateDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	data:ValueTypes["DogWithoutIllnessesUpdateInput"]
};
	["DogWithoutIllnessesUpdateInput"]: {
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogUpdateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogUpdateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogUpdateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogUpdateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogUpdateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogUpdateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogUpdateAllergiesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogUpdateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogUpdateAvatarEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogConnectOrCreateAvatarRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["DogUpsertAvatarRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DogUpsertAvatarRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["BodyTagUpsertDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	update:ValueTypes["DogWithoutIllnessesUpdateInput"],
	create:ValueTypes["DogWithoutIllnessesCreateInput"]
};
	["FilterComboUpsertTreatmentRelationInput"]: {
	update:ValueTypes["BodyTagWithoutFilterCombosUpdateInput"],
	create:ValueTypes["BodyTagWithoutFilterCombosCreateInput"]
};
	["FilterComboUpdateFlavorEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryWithoutFilterCombosFlavorCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateFlavorRelationInput"] | null,
	update?:ValueTypes["ItemSubCategoryWithoutFilterCombosFlavorUpdateInput"] | null,
	upsert?:ValueTypes["FilterComboUpsertFlavorRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemSubCategoryWithoutFilterCombosFlavorUpdateInput"]: {
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryUpdateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryUpdateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryUpdateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosAllergy?:ValueTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"]: {
	create?:ValueTypes["FilterComboWithoutAllergyCreateInput"] | null,
	update?:ValueTypes["ItemSubCategoryUpdateFilterCombosAllergyRelationInput"] | null,
	upsert?:ValueTypes["ItemSubCategoryUpsertFilterCombosAllergyRelationInput"] | null,
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	disconnect?:ValueTypes["FilterComboUniqueWhere"] | null,
	delete?:ValueTypes["FilterComboUniqueWhere"] | null,
	alias?:string | null
};
	["ItemSubCategoryUpdateFilterCombosAllergyRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	data:ValueTypes["FilterComboWithoutAllergyUpdateInput"]
};
	["FilterComboWithoutAllergyUpdateInput"]: {
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboUpdateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboUpdateBreedEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboUpdateBrandEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboUpdateRegionEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboUpdateAgeCategoryEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboUpdateTreatmentEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboUpdateFlavorEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemSubCategoryUpsertFilterCombosAllergyRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	update:ValueTypes["FilterComboWithoutAllergyUpdateInput"],
	create:ValueTypes["FilterComboWithoutAllergyCreateInput"]
};
	["FilterComboUpsertFlavorRelationInput"]: {
	update:ValueTypes["ItemSubCategoryWithoutFilterCombosFlavorUpdateInput"],
	create:ValueTypes["ItemSubCategoryWithoutFilterCombosFlavorCreateInput"]
};
	["FilterComboUpdateAllergyEntityRelationInput"]: {
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemSubCategoryWithoutFilterCombosAllergyCreateInput"] | null,
	connectOrCreate?:ValueTypes["FilterComboConnectOrCreateAllergyRelationInput"] | null,
	update?:ValueTypes["ItemSubCategoryWithoutFilterCombosAllergyUpdateInput"] | null,
	upsert?:ValueTypes["FilterComboUpsertAllergyRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemSubCategoryWithoutFilterCombosAllergyUpdateInput"]: {
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryUpdateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"] | null,
	flavorCategory?:ValueTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryUpdateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryUpdateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["FilterComboUpsertAllergyRelationInput"]: {
	update:ValueTypes["ItemSubCategoryWithoutFilterCombosAllergyUpdateInput"],
	create:ValueTypes["ItemSubCategoryWithoutFilterCombosAllergyCreateInput"]
};
	["BrandUpsertFilterCombosRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	update:ValueTypes["FilterComboWithoutBrandUpdateInput"],
	create:ValueTypes["FilterComboWithoutBrandCreateInput"]
};
	["BrandUpdateTopxEntityRelationInput"]: {
	create?:ValueTypes["TOPXBrandWithoutBrandCreateInput"] | null,
	update?:ValueTypes["BrandUpdateTopxRelationInput"] | null,
	upsert?:ValueTypes["BrandUpsertTopxRelationInput"] | null,
	connect?:ValueTypes["TOPXBrandUniqueWhere"] | null,
	disconnect?:ValueTypes["TOPXBrandUniqueWhere"] | null,
	delete?:ValueTypes["TOPXBrandUniqueWhere"] | null,
	alias?:string | null
};
	["BrandUpdateTopxRelationInput"]: {
	by:ValueTypes["TOPXBrandUniqueWhere"],
	data:ValueTypes["TOPXBrandWithoutBrandUpdateInput"]
};
	["TOPXBrandWithoutBrandUpdateInput"]: {
	remoteId?:string | null,
	order?:number | null,
	orderType?:ValueTypes["TOPXBrandOrderType"] | null,
	category?:ValueTypes["TOPXBrandUpdateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXBrandUpdateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["TOPXBrandCategoryUniqueWhere"] | null,
	create?:ValueTypes["TOPXBrandCategoryWithoutBrandsCreateInput"] | null,
	connectOrCreate?:ValueTypes["TOPXBrandConnectOrCreateCategoryRelationInput"] | null,
	update?:ValueTypes["TOPXBrandCategoryWithoutBrandsUpdateInput"] | null,
	upsert?:ValueTypes["TOPXBrandUpsertCategoryRelationInput"] | null,
	delete?:boolean | null
};
	["TOPXBrandCategoryWithoutBrandsUpdateInput"]: {
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["TOPXBrandUpsertCategoryRelationInput"]: {
	update:ValueTypes["TOPXBrandCategoryWithoutBrandsUpdateInput"],
	create:ValueTypes["TOPXBrandCategoryWithoutBrandsCreateInput"]
};
	["BrandUpsertTopxRelationInput"]: {
	by:ValueTypes["TOPXBrandUniqueWhere"],
	update:ValueTypes["TOPXBrandWithoutBrandUpdateInput"],
	create:ValueTypes["TOPXBrandWithoutBrandCreateInput"]
};
	["BrandUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["BrandUpsertContentRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandUpsertContentRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["BrandUpdateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandConnectOrCreateDraftRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["BrandUpsertDraftRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandUpsertDraftRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["ContentReferenceUpsertRelatedBrandRelationInput"]: {
	update:ValueTypes["BrandUpdateInput"],
	create:ValueTypes["BrandCreateInput"]
};
	["ContentReferenceUpdateRelatedProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateRelatedProductRelationInput"] | null,
	update?:ValueTypes["ProductUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertRelatedProductRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductUpdateAgeCategoriesEntityRelationInput"]: {
	create?:ValueTypes["AgeCategoryWithoutProductsCreateInput"] | null,
	update?:ValueTypes["ProductUpdateAgeCategoriesRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertAgeCategoriesRelationInput"] | null,
	connect?:ValueTypes["AgeCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["AgeCategoryUniqueWhere"] | null,
	delete?:ValueTypes["AgeCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateAgeCategoriesRelationInput"]: {
	by:ValueTypes["AgeCategoryUniqueWhere"],
	data:ValueTypes["AgeCategoryWithoutProductsUpdateInput"]
};
	["AgeCategoryWithoutProductsUpdateInput"]: {
	remoteId?:string | null,
	order?:number | null,
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["AgeCategoryUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AgeCategoryUpdateFilterCombosEntityRelationInput"]: {
	create?:ValueTypes["FilterComboWithoutAgeCategoryCreateInput"] | null,
	update?:ValueTypes["AgeCategoryUpdateFilterCombosRelationInput"] | null,
	upsert?:ValueTypes["AgeCategoryUpsertFilterCombosRelationInput"] | null,
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	disconnect?:ValueTypes["FilterComboUniqueWhere"] | null,
	delete?:ValueTypes["FilterComboUniqueWhere"] | null,
	alias?:string | null
};
	["AgeCategoryUpdateFilterCombosRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	data:ValueTypes["FilterComboWithoutAgeCategoryUpdateInput"]
};
	["FilterComboWithoutAgeCategoryUpdateInput"]: {
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboUpdateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboUpdateBreedEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboUpdateBrandEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboUpdateRegionEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboUpdateTreatmentEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboUpdateFlavorEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboUpdateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AgeCategoryUpsertFilterCombosRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	update:ValueTypes["FilterComboWithoutAgeCategoryUpdateInput"],
	create:ValueTypes["FilterComboWithoutAgeCategoryCreateInput"]
};
	["ProductUpsertAgeCategoriesRelationInput"]: {
	by:ValueTypes["AgeCategoryUniqueWhere"],
	update:ValueTypes["AgeCategoryWithoutProductsUpdateInput"],
	create:ValueTypes["AgeCategoryWithoutProductsCreateInput"]
};
	["ContentReferenceUpsertRelatedProductRelationInput"]: {
	update:ValueTypes["ProductUpdateInput"],
	create:ValueTypes["ProductCreateInput"]
};
	["ContentReferenceUpdateRelatedIngredientEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateRelatedIngredientRelationInput"] | null,
	update?:ValueTypes["ItemUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertRelatedIngredientRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemUpdateInput"]: {
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemUpdateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemUpdateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemUpdateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemUpdateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemUpdateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemUpdateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemUpdateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemUpdateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemUpdateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemUpdateDeclensionFourthEntityRelationInput"]: {
	connect?:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"] | null,
	create?:ValueTypes["ItemDeclensionFourthVariantWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemConnectOrCreateDeclensionFourthRelationInput"] | null,
	update?:ValueTypes["ItemDeclensionFourthVariantWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ItemUpsertDeclensionFourthRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemDeclensionFourthVariantWithoutItemsUpdateInput"]: {
	label?:string | null,
	remoteId?:string | null,
	declensionSeventh?:string | null,
	isNegativ?:boolean | null,
	seo?:ValueTypes["ItemDeclensionFourthVariantUpdateSeoEntityRelationInput"] | null,
	subcategory?:ValueTypes["ItemDeclensionFourthVariantUpdateSubcategoryEntityRelationInput"] | null,
	category?:ValueTypes["ItemDeclensionFourthVariantUpdateCategoryEntityRelationInput"] | null,
	element?:ValueTypes["ItemDeclensionFourthVariantUpdateElementEntityRelationInput"] | null,
	products?:ValueTypes["ItemDeclensionFourthVariantUpdateProductsEntityRelationInput"][],
	slug?:string | null,
	content?:ValueTypes["ItemDeclensionFourthVariantUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemDeclensionFourthVariantUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionFourthVariantUpdateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutDeclensionsFourthCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateCategoryRelationInput"] | null,
	update?:ValueTypes["ItemCategoryWithoutDeclensionsFourthUpdateInput"] | null,
	upsert?:ValueTypes["ItemDeclensionFourthVariantUpsertCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemCategoryWithoutDeclensionsFourthUpdateInput"]: {
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryUpdateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryUpdateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryUpdateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryUpdateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryUpdateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemCategoryUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoUpdateInput"],
	create:ValueTypes["SeoCreateInput"]
};
	["ItemCategoryUpdateGroupEntityRelationInput"]: {
	connect?:ValueTypes["ItemGroupUniqueWhere"] | null,
	create?:ValueTypes["ItemGroupWithoutCategoriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateGroupRelationInput"] | null,
	update?:ValueTypes["ItemGroupWithoutCategoriesUpdateInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertGroupRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemGroupWithoutCategoriesUpdateInput"]: {
	remoteId?:string | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryUpsertGroupRelationInput"]: {
	update:ValueTypes["ItemGroupWithoutCategoriesUpdateInput"],
	create:ValueTypes["ItemGroupWithoutCategoriesCreateInput"]
};
	["ItemCategoryUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertContentRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemCategoryUpsertContentRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["ItemCategoryUpdateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemCategoryConnectOrCreateDraftRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ItemCategoryUpsertDraftRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemCategoryUpsertDraftRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["ItemDeclensionFourthVariantUpsertCategoryRelationInput"]: {
	update:ValueTypes["ItemCategoryWithoutDeclensionsFourthUpdateInput"],
	create:ValueTypes["ItemCategoryWithoutDeclensionsFourthCreateInput"]
};
	["ItemDeclensionFourthVariantUpdateElementEntityRelationInput"]: {
	connect?:ValueTypes["ElementUniqueWhere"] | null,
	create?:ValueTypes["ElementCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateElementRelationInput"] | null,
	update?:ValueTypes["ElementUpdateInput"] | null,
	upsert?:ValueTypes["ItemDeclensionFourthVariantUpsertElementRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ElementUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["ElementUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ElementUpdateFeatureDependenciesEntityRelationInput"][],
	suitabilityElements?:ValueTypes["ElementUpdateSuitabilityElementsEntityRelationInput"][],
	remoteId?:string | null,
	unit?:string | null,
	filterOrder?:number | null,
	slug?:string | null,
	declensionSeventh?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionFourthVariantUpsertElementRelationInput"]: {
	update:ValueTypes["ElementUpdateInput"],
	create:ValueTypes["ElementCreateInput"]
};
	["ItemDeclensionFourthVariantUpdateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ItemDeclensionFourthVariantUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ItemDeclensionFourthVariantUpsertContentRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemDeclensionFourthVariantUpsertContentRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["ItemDeclensionFourthVariantUpdateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionFourthVariantConnectOrCreateDraftRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ItemDeclensionFourthVariantUpsertDraftRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemDeclensionFourthVariantUpsertDraftRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["ItemUpsertDeclensionFourthRelationInput"]: {
	update:ValueTypes["ItemDeclensionFourthVariantWithoutItemsUpdateInput"],
	create:ValueTypes["ItemDeclensionFourthVariantWithoutItemsCreateInput"]
};
	["ContentReferenceUpsertRelatedIngredientRelationInput"]: {
	update:ValueTypes["ItemUpdateInput"],
	create:ValueTypes["ItemCreateInput"]
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateLinkRelationInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertLinkRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkUpdateInput"]: {
	externalLink?:string | null,
	isTargetBlank?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update:ValueTypes["LinkUpdateInput"],
	create:ValueTypes["LinkCreateInput"]
};
	["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateRelatedBrandFullRelationInput"] | null,
	update?:ValueTypes["BrandUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertRelatedBrandFullRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertRelatedBrandFullRelationInput"]: {
	update:ValueTypes["BrandUpdateInput"],
	create:ValueTypes["BrandCreateInput"]
};
	["ContentReferenceUpdateRelatedProductFullEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateRelatedProductFullRelationInput"] | null,
	update?:ValueTypes["ProductUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertRelatedProductFullRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertRelatedProductFullRelationInput"]: {
	update:ValueTypes["ProductUpdateInput"],
	create:ValueTypes["ProductCreateInput"]
};
	["ContentReferenceUpdateListEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceListWithoutListCreateInput"] | null,
	update?:ValueTypes["ContentReferenceUpdateListRelationInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertListRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceListUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceListUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceListUniqueWhere"] | null,
	alias?:string | null
};
	["ContentReferenceUpdateListRelationInput"]: {
	by:ValueTypes["ContentReferenceListUniqueWhere"],
	data:ValueTypes["ContentReferenceListWithoutListUpdateInput"]
};
	["ContentReferenceListWithoutListUpdateInput"]: {
	order?:number | null,
	relatedProduct?:ValueTypes["ContentReferenceListUpdateRelatedProductEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceListUpdateRelatedBrandEntityRelationInput"] | null,
	badge?:string | null,
	badgeColor?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceListUpdateRelatedProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceListConnectOrCreateRelatedProductRelationInput"] | null,
	update?:ValueTypes["ProductUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceListUpsertRelatedProductRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceListUpsertRelatedProductRelationInput"]: {
	update:ValueTypes["ProductUpdateInput"],
	create:ValueTypes["ProductCreateInput"]
};
	["ContentReferenceListUpdateRelatedBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceListConnectOrCreateRelatedBrandRelationInput"] | null,
	update?:ValueTypes["BrandUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceListUpsertRelatedBrandRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceListUpsertRelatedBrandRelationInput"]: {
	update:ValueTypes["BrandUpdateInput"],
	create:ValueTypes["BrandCreateInput"]
};
	["ContentReferenceUpsertListRelationInput"]: {
	by:ValueTypes["ContentReferenceListUniqueWhere"],
	update:ValueTypes["ContentReferenceListWithoutListUpdateInput"],
	create:ValueTypes["ContentReferenceListWithoutListCreateInput"]
};
	["ContentReferenceUpdateOutlineEntityRelationInput"]: {
	connect?:ValueTypes["ContentLinksUniqueWhere"] | null,
	create?:ValueTypes["ContentLinksCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateOutlineRelationInput"] | null,
	update?:ValueTypes["ContentLinksUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertOutlineRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentLinksUpdateInput"]: {
	items?:ValueTypes["ContentLinksUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentLinksUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ContentLinksItemWithoutListCreateInput"] | null,
	update?:ValueTypes["ContentLinksUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ContentLinksUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ContentLinksItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentLinksItemUniqueWhere"] | null,
	delete?:ValueTypes["ContentLinksItemUniqueWhere"] | null,
	alias?:string | null
};
	["ContentLinksUpdateItemsRelationInput"]: {
	by:ValueTypes["ContentLinksItemUniqueWhere"],
	data:ValueTypes["ContentLinksItemWithoutListUpdateInput"]
};
	["ContentLinksItemWithoutListUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	target?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentLinksUpsertItemsRelationInput"]: {
	by:ValueTypes["ContentLinksItemUniqueWhere"],
	update:ValueTypes["ContentLinksItemWithoutListUpdateInput"],
	create:ValueTypes["ContentLinksItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertOutlineRelationInput"]: {
	update:ValueTypes["ContentLinksUpdateInput"],
	create:ValueTypes["ContentLinksCreateInput"]
};
	["ContentReferenceUpdateVideoEntityRelationInput"]: {
	connect?:ValueTypes["VideoUniqueWhere"] | null,
	create?:ValueTypes["VideoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateVideoRelationInput"] | null,
	update?:ValueTypes["VideoUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertVideoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["VideoUpdateInput"]: {
	src?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	duration?:number | null,
	poster?:ValueTypes["VideoUpdatePosterEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["VideoUpdatePosterEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["VideoConnectOrCreatePosterRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["VideoUpsertPosterRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["VideoUpsertPosterRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["ContentReferenceUpsertVideoRelationInput"]: {
	update:ValueTypes["VideoUpdateInput"],
	create:ValueTypes["VideoCreateInput"]
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceImageUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateImageRelationInput"] | null,
	update?:ValueTypes["ContentReferenceImageUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertImageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceImageUpdateInput"]: {
	lead?:string | null,
	alignment?:ValueTypes["AlignmentType"] | null,
	image?:ValueTypes["ContentReferenceImageUpdateImageEntityRelationInput"] | null,
	link?:string | null,
	targetBlank?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceImageUpdateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceImageConnectOrCreateImageRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceImageUpsertImageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceImageUpsertImageRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["ContentReferenceUpsertImageRelationInput"]: {
	update:ValueTypes["ContentReferenceImageUpdateInput"],
	create:ValueTypes["ContentReferenceImageCreateInput"]
};
	["AdUpsertContentReferencesRelationInput"]: {
	by:ValueTypes["ContentReferenceUniqueWhere"],
	update:ValueTypes["ContentReferenceWithoutAdUpdateInput"],
	create:ValueTypes["ContentReferenceWithoutAdCreateInput"]
};
	["BrandUpsertAdsRelationInput"]: {
	by:ValueTypes["AdUniqueWhere"],
	update:ValueTypes["AdWithoutBrandsUpdateInput"],
	create:ValueTypes["AdWithoutBrandsCreateInput"]
};
	["CountryUpsertBrandsRelationInput"]: {
	by:ValueTypes["BrandUniqueWhere"],
	update:ValueTypes["BrandWithoutCountriesOfProductionUpdateInput"],
	create:ValueTypes["BrandWithoutCountriesOfProductionCreateInput"]
};
	["CountryUpdateRegionEntityRelationInput"]: {
	connect?:ValueTypes["RegionUniqueWhere"] | null,
	create?:ValueTypes["RegionWithoutCountriesCreateInput"] | null,
	connectOrCreate?:ValueTypes["CountryConnectOrCreateRegionRelationInput"] | null,
	update?:ValueTypes["RegionWithoutCountriesUpdateInput"] | null,
	upsert?:ValueTypes["CountryUpsertRegionRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RegionWithoutCountriesUpdateInput"]: {
	name?:string | null,
	remoteId?:string | null,
	adjective?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["RegionUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RegionUpdateFilterCombosEntityRelationInput"]: {
	create?:ValueTypes["FilterComboWithoutRegionCreateInput"] | null,
	update?:ValueTypes["RegionUpdateFilterCombosRelationInput"] | null,
	upsert?:ValueTypes["RegionUpsertFilterCombosRelationInput"] | null,
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	disconnect?:ValueTypes["FilterComboUniqueWhere"] | null,
	delete?:ValueTypes["FilterComboUniqueWhere"] | null,
	alias?:string | null
};
	["RegionUpdateFilterCombosRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	data:ValueTypes["FilterComboWithoutRegionUpdateInput"]
};
	["FilterComboWithoutRegionUpdateInput"]: {
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboUpdateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboUpdateBreedEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboUpdateBrandEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboUpdateAgeCategoryEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboUpdateTreatmentEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboUpdateFlavorEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboUpdateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RegionUpsertFilterCombosRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	update:ValueTypes["FilterComboWithoutRegionUpdateInput"],
	create:ValueTypes["FilterComboWithoutRegionCreateInput"]
};
	["CountryUpsertRegionRelationInput"]: {
	update:ValueTypes["RegionWithoutCountriesUpdateInput"],
	create:ValueTypes["RegionWithoutCountriesCreateInput"]
};
	["BrandManufacturerUpsertResidenceRelationInput"]: {
	update:ValueTypes["CountryWithoutManufacturersUpdateInput"],
	create:ValueTypes["CountryWithoutManufacturersCreateInput"]
};
	["BrandUpsertManufacturersRelationInput"]: {
	by:ValueTypes["BrandManufacturerUniqueWhere"],
	update:ValueTypes["BrandManufacturerWithoutBrandsUpdateInput"],
	create:ValueTypes["BrandManufacturerWithoutBrandsCreateInput"]
};
	["ProductUpsertBrandRelationInput"]: {
	update:ValueTypes["BrandWithoutProductsUpdateInput"],
	create:ValueTypes["BrandWithoutProductsCreateInput"]
};
	["ProductLineUpsertProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	update:ValueTypes["ProductWithoutProductLineUpdateInput"],
	create:ValueTypes["ProductWithoutProductLineCreateInput"]
};
	["ProductLineUpdateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductLineConnectOrCreateLogoRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ProductLineUpsertLogoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductLineUpsertLogoRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["ProductLineUpdateAliasesEntityRelationInput"]: {
	create?:ValueTypes["ProductLineAliasWithoutProductLinesCreateInput"] | null,
	update?:ValueTypes["ProductLineUpdateAliasesRelationInput"] | null,
	upsert?:ValueTypes["ProductLineUpsertAliasesRelationInput"] | null,
	connect?:ValueTypes["ProductLineAliasUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductLineAliasUniqueWhere"] | null,
	delete?:ValueTypes["ProductLineAliasUniqueWhere"] | null,
	alias?:string | null
};
	["ProductLineUpdateAliasesRelationInput"]: {
	by:ValueTypes["ProductLineAliasUniqueWhere"],
	data:ValueTypes["ProductLineAliasWithoutProductLinesUpdateInput"]
};
	["ProductLineAliasWithoutProductLinesUpdateInput"]: {
	remoteId?:string | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductLineUpsertAliasesRelationInput"]: {
	by:ValueTypes["ProductLineAliasUniqueWhere"],
	update:ValueTypes["ProductLineAliasWithoutProductLinesUpdateInput"],
	create:ValueTypes["ProductLineAliasWithoutProductLinesCreateInput"]
};
	["ProductLineUpdateFlavorsEntityRelationInput"]: {
	connect?:ValueTypes["ProductLineFlavorUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductLineFlavorUniqueWhere"] | null,
	delete?:ValueTypes["ProductLineFlavorUniqueWhere"] | null,
	alias?:string | null
};
	["ProductLineUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductLineConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ProductLineUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductLineUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoUpdateInput"],
	create:ValueTypes["SeoCreateInput"]
};
	["BrandUpsertProductLinesRelationInput"]: {
	by:ValueTypes["ProductLineUniqueWhere"],
	update:ValueTypes["ProductLineWithoutBrandUpdateInput"],
	create:ValueTypes["ProductLineWithoutBrandCreateInput"]
};
	["BrandManufacturerUpsertBrandsRelationInput"]: {
	by:ValueTypes["BrandUniqueWhere"],
	update:ValueTypes["BrandWithoutManufacturersUpdateInput"],
	create:ValueTypes["BrandWithoutManufacturersCreateInput"]
};
	["CountryUpsertManufacturersRelationInput"]: {
	by:ValueTypes["BrandManufacturerUniqueWhere"],
	update:ValueTypes["BrandManufacturerWithoutResidenceUpdateInput"],
	create:ValueTypes["BrandManufacturerWithoutResidenceCreateInput"]
};
	["BrandUpsertCountriesOfProductionRelationInput"]: {
	by:ValueTypes["CountryUniqueWhere"],
	update:ValueTypes["CountryWithoutBrandsUpdateInput"],
	create:ValueTypes["CountryWithoutBrandsCreateInput"]
};
	["FilterComboUpsertBrandRelationInput"]: {
	update:ValueTypes["BrandWithoutFilterCombosUpdateInput"],
	create:ValueTypes["BrandWithoutFilterCombosCreateInput"]
};
	["BreedUpsertFilterCombosRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	update:ValueTypes["FilterComboWithoutBreedUpdateInput"],
	create:ValueTypes["FilterComboWithoutBreedCreateInput"]
};
	["BlogPostReviewUpsertBreedRelationInput"]: {
	update:ValueTypes["BreedWithoutBlogPostReviewsUpdateInput"],
	create:ValueTypes["BreedWithoutBlogPostReviewsCreateInput"]
};
	["AgeUpsertBlogPostReviewsRelationInput"]: {
	by:ValueTypes["BlogPostReviewUniqueWhere"],
	update:ValueTypes["BlogPostReviewWithoutAgeUpdateInput"],
	create:ValueTypes["BlogPostReviewWithoutAgeCreateInput"]
};
	["SuitabilityCategoryUpsertDogAgesRelationInput"]: {
	by:ValueTypes["AgeUniqueWhere"],
	update:ValueTypes["AgeWithoutSuitabilityCategoriesUpdateInput"],
	create:ValueTypes["AgeWithoutSuitabilityCategoriesCreateInput"]
};
	["DogSizeUpsertSuitabilityCategoryRelationInput"]: {
	update:ValueTypes["SuitabilityCategoryWithoutDogSizesUpdateInput"],
	create:ValueTypes["SuitabilityCategoryWithoutDogSizesCreateInput"]
};
	["BreedUpsertSizeRelationInput"]: {
	update:ValueTypes["DogSizeWithoutBreedsUpdateInput"],
	create:ValueTypes["DogSizeWithoutBreedsCreateInput"]
};
	["ProductReviewUpsertBreedRelationInput"]: {
	update:ValueTypes["BreedWithoutProductReviewsUpdateInput"],
	create:ValueTypes["BreedWithoutProductReviewsCreateInput"]
};
	["AgeUpsertProductReviewsRelationInput"]: {
	by:ValueTypes["ProductReviewUniqueWhere"],
	update:ValueTypes["ProductReviewWithoutAgeUpdateInput"],
	create:ValueTypes["ProductReviewWithoutAgeCreateInput"]
};
	["BlogPostReviewUpsertAgeRelationInput"]: {
	update:ValueTypes["AgeWithoutBlogPostReviewsUpdateInput"],
	create:ValueTypes["AgeWithoutBlogPostReviewsCreateInput"]
};
	["BreedUpsertBlogPostReviewsRelationInput"]: {
	by:ValueTypes["BlogPostReviewUniqueWhere"],
	update:ValueTypes["BlogPostReviewWithoutBreedUpdateInput"],
	create:ValueTypes["BlogPostReviewWithoutBreedCreateInput"]
};
	["SuitabilityCategoryUpsertBreedsRelationInput"]: {
	by:ValueTypes["BreedUniqueWhere"],
	update:ValueTypes["BreedWithoutSuitabilityCategoryUpdateInput"],
	create:ValueTypes["BreedWithoutSuitabilityCategoryCreateInput"]
};
	["AgeUpsertSuitabilityCategoriesRelationInput"]: {
	by:ValueTypes["SuitabilityCategoryUniqueWhere"],
	update:ValueTypes["SuitabilityCategoryWithoutDogAgesUpdateInput"],
	create:ValueTypes["SuitabilityCategoryWithoutDogAgesCreateInput"]
};
	["ProductReviewUpsertAgeRelationInput"]: {
	update:ValueTypes["AgeWithoutProductReviewsUpdateInput"],
	create:ValueTypes["AgeWithoutProductReviewsCreateInput"]
};
	["BreedUpsertProductReviewsRelationInput"]: {
	by:ValueTypes["ProductReviewUniqueWhere"],
	update:ValueTypes["ProductReviewWithoutBreedUpdateInput"],
	create:ValueTypes["ProductReviewWithoutBreedCreateInput"]
};
	["FilterComboUpsertBreedRelationInput"]: {
	update:ValueTypes["BreedWithoutFilterCombosUpdateInput"],
	create:ValueTypes["BreedWithoutFilterCombosCreateInput"]
};
	["ItemSubCategoryUpsertFilterCombosFlavorRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	update:ValueTypes["FilterComboWithoutFlavorUpdateInput"],
	create:ValueTypes["FilterComboWithoutFlavorCreateInput"]
};
	["DogUpsertAllergiesRelationInput"]: {
	by:ValueTypes["ItemSubCategoryUniqueWhere"],
	update:ValueTypes["ItemSubCategoryWithoutDogsUpdateInput"],
	create:ValueTypes["ItemSubCategoryWithoutDogsCreateInput"]
};
	["DogUpdateIllnessesEntityRelationInput"]: {
	create?:ValueTypes["BodyTagWithoutDogsCreateInput"] | null,
	update?:ValueTypes["DogUpdateIllnessesRelationInput"] | null,
	upsert?:ValueTypes["DogUpsertIllnessesRelationInput"] | null,
	connect?:ValueTypes["BodyTagUniqueWhere"] | null,
	disconnect?:ValueTypes["BodyTagUniqueWhere"] | null,
	delete?:ValueTypes["BodyTagUniqueWhere"] | null,
	alias?:string | null
};
	["DogUpdateIllnessesRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	data:ValueTypes["BodyTagWithoutDogsUpdateInput"]
};
	["BodyTagWithoutDogsUpdateInput"]: {
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagUpdateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagUpdatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagUpdateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagUpdatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagUpdateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagUpdateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagUpdateIconEntityRelationInput"] | null,
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagUpdateFilterCombosEntityRelationInput"]: {
	create?:ValueTypes["FilterComboWithoutTreatmentCreateInput"] | null,
	update?:ValueTypes["BodyTagUpdateFilterCombosRelationInput"] | null,
	upsert?:ValueTypes["BodyTagUpsertFilterCombosRelationInput"] | null,
	connect?:ValueTypes["FilterComboUniqueWhere"] | null,
	disconnect?:ValueTypes["FilterComboUniqueWhere"] | null,
	delete?:ValueTypes["FilterComboUniqueWhere"] | null,
	alias?:string | null
};
	["BodyTagUpdateFilterCombosRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	data:ValueTypes["FilterComboWithoutTreatmentUpdateInput"]
};
	["FilterComboWithoutTreatmentUpdateInput"]: {
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboUpdateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboUpdateBreedEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboUpdateBrandEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboUpdateRegionEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboUpdateAgeCategoryEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboUpdateFlavorEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboUpdateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BodyTagUpsertFilterCombosRelationInput"]: {
	by:ValueTypes["FilterComboUniqueWhere"],
	update:ValueTypes["FilterComboWithoutTreatmentUpdateInput"],
	create:ValueTypes["FilterComboWithoutTreatmentCreateInput"]
};
	["DogUpsertIllnessesRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	update:ValueTypes["BodyTagWithoutDogsUpdateInput"],
	create:ValueTypes["BodyTagWithoutDogsCreateInput"]
};
	["DogActivityUpsertDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	update:ValueTypes["DogWithoutActivityUpdateInput"],
	create:ValueTypes["DogWithoutActivityCreateInput"]
};
	["DogActivityUpdateSuitabilityCategoryEntityRelationInput"]: {
	connect?:ValueTypes["SuitabilityCategoryUniqueWhere"] | null,
	create?:ValueTypes["SuitabilityCategoryWithoutDogActivitiesCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogActivityConnectOrCreateSuitabilityCategoryRelationInput"] | null,
	update?:ValueTypes["SuitabilityCategoryWithoutDogActivitiesUpdateInput"] | null,
	upsert?:ValueTypes["DogActivityUpsertSuitabilityCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SuitabilityCategoryWithoutDogActivitiesUpdateInput"]: {
	name?:string | null,
	dogSizes?:ValueTypes["SuitabilityCategoryUpdateDogSizesEntityRelationInput"][],
	breeds?:ValueTypes["SuitabilityCategoryUpdateBreedsEntityRelationInput"][],
	suitabilityItems?:ValueTypes["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"][],
	dogAges?:ValueTypes["SuitabilityCategoryUpdateDogAgesEntityRelationInput"][],
	isPregnant?:boolean | null,
	remoteId?:string | null,
	isBreastfeeding?:boolean | null,
	_dummy_field_?:boolean | null
};
	["DogActivityUpsertSuitabilityCategoryRelationInput"]: {
	update:ValueTypes["SuitabilityCategoryWithoutDogActivitiesUpdateInput"],
	create:ValueTypes["SuitabilityCategoryWithoutDogActivitiesCreateInput"]
};
	["ProductUpsertRecommendedActivityRelationInput"]: {
	update:ValueTypes["DogActivityWithoutProductsUpdateInput"],
	create:ValueTypes["DogActivityWithoutProductsCreateInput"]
};
	["BrandUpsertProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	update:ValueTypes["ProductWithoutBrandUpdateInput"],
	create:ValueTypes["ProductWithoutBrandCreateInput"]
};
	["ProductLineUpsertBrandRelationInput"]: {
	update:ValueTypes["BrandWithoutProductLinesUpdateInput"],
	create:ValueTypes["BrandWithoutProductLinesCreateInput"]
};
	["ProductUpsertProductLineRelationInput"]: {
	update:ValueTypes["ProductLineWithoutProductsUpdateInput"],
	create:ValueTypes["ProductLineWithoutProductsCreateInput"]
};
	["DogSizeUpsertProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	update:ValueTypes["ProductWithoutRecommendedDogSizesUpdateInput"],
	create:ValueTypes["ProductWithoutRecommendedDogSizesCreateInput"]
};
	["SuitabilityCategoryUpsertDogSizesRelationInput"]: {
	by:ValueTypes["DogSizeUniqueWhere"],
	update:ValueTypes["DogSizeWithoutSuitabilityCategoryUpdateInput"],
	create:ValueTypes["DogSizeWithoutSuitabilityCategoryCreateInput"]
};
	["BreedUpsertSuitabilityCategoryRelationInput"]: {
	update:ValueTypes["SuitabilityCategoryWithoutBreedsUpdateInput"],
	create:ValueTypes["SuitabilityCategoryWithoutBreedsCreateInput"]
};
	["DogSizeUpsertBreedsRelationInput"]: {
	by:ValueTypes["BreedUniqueWhere"],
	update:ValueTypes["BreedWithoutSizeUpdateInput"],
	create:ValueTypes["BreedWithoutSizeCreateInput"]
};
	["ProductUpsertRecommendedDogSizesRelationInput"]: {
	by:ValueTypes["DogSizeUniqueWhere"],
	update:ValueTypes["DogSizeWithoutProductsUpdateInput"],
	create:ValueTypes["DogSizeWithoutProductsCreateInput"]
};
	["DogUpsertFedProductRelationInput"]: {
	update:ValueTypes["ProductWithoutDogsUpdateInput"],
	create:ValueTypes["ProductWithoutDogsCreateInput"]
};
	["ItemSubCategoryUpsertDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	update:ValueTypes["DogWithoutAllergiesUpdateInput"],
	create:ValueTypes["DogWithoutAllergiesCreateInput"]
};
	["ItemDeclensionFourthVariantUpsertSubcategoryRelationInput"]: {
	update:ValueTypes["ItemSubCategoryUpdateInput"],
	create:ValueTypes["ItemSubCategoryCreateInput"]
};
	["ItemCategoryUpsertDeclensionsFourthRelationInput"]: {
	by:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],
	update:ValueTypes["ItemDeclensionFourthVariantWithoutCategoryUpdateInput"],
	create:ValueTypes["ItemDeclensionFourthVariantWithoutCategoryCreateInput"]
};
	["ItemSubCategoryUpsertCategoryRelationInput"]: {
	update:ValueTypes["ItemCategoryWithoutSubCategoriesUpdateInput"],
	create:ValueTypes["ItemCategoryWithoutSubCategoriesCreateInput"]
};
	["ProductFeatureUpsertDependentSubCategoryRelationInput"]: {
	update:ValueTypes["ItemSubCategoryWithoutFeatureDependenciesUpdateInput"],
	create:ValueTypes["ItemSubCategoryWithoutFeatureDependenciesCreateInput"]
};
	["ProductFeatureUpdateDependentFlagEntityRelationInput"]: {
	connect?:ValueTypes["ProductFlagUniqueWhere"] | null,
	create?:ValueTypes["ProductFlagWithoutProductFeaturesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFeatureConnectOrCreateDependentFlagRelationInput"] | null,
	update?:ValueTypes["ProductFlagWithoutProductFeaturesUpdateInput"] | null,
	upsert?:ValueTypes["ProductFeatureUpsertDependentFlagRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductFlagWithoutProductFeaturesUpdateInput"]: {
	remoteId?:string | null,
	products?:ValueTypes["ProductFlagUpdateProductsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductFlagUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductFlagOfProductWithoutFlagCreateInput"] | null,
	update?:ValueTypes["ProductFlagUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["ProductFlagUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductFlagOfProductUniqueWhere"] | null,
	alias?:string | null
};
	["ProductFlagUpdateProductsRelationInput"]: {
	by:ValueTypes["ProductFlagOfProductUniqueWhere"],
	data:ValueTypes["ProductFlagOfProductWithoutFlagUpdateInput"]
};
	["ProductFlagOfProductWithoutFlagUpdateInput"]: {
	remoteId?:string | null,
	value?:ValueTypes["ProductFlagValue"] | null,
	product?:ValueTypes["ProductFlagOfProductUpdateProductEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFlagOfProductUpdateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutFlagsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductFlagOfProductConnectOrCreateProductRelationInput"] | null,
	update?:ValueTypes["ProductWithoutFlagsUpdateInput"] | null,
	upsert?:ValueTypes["ProductFlagOfProductUpsertProductRelationInput"] | null,
	delete?:boolean | null
};
	["ProductWithoutFlagsUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductFlagOfProductUpsertProductRelationInput"]: {
	update:ValueTypes["ProductWithoutFlagsUpdateInput"],
	create:ValueTypes["ProductWithoutFlagsCreateInput"]
};
	["ProductFlagUpsertProductsRelationInput"]: {
	by:ValueTypes["ProductFlagOfProductUniqueWhere"],
	update:ValueTypes["ProductFlagOfProductWithoutFlagUpdateInput"],
	create:ValueTypes["ProductFlagOfProductWithoutFlagCreateInput"]
};
	["ProductFeatureUpsertDependentFlagRelationInput"]: {
	update:ValueTypes["ProductFlagWithoutProductFeaturesUpdateInput"],
	create:ValueTypes["ProductFlagWithoutProductFeaturesCreateInput"]
};
	["ItemCategoryUpsertFeatureDependenciesRelationInput"]: {
	by:ValueTypes["ProductFeatureUniqueWhere"],
	update:ValueTypes["ProductFeatureWithoutDependentCategoryUpdateInput"],
	create:ValueTypes["ProductFeatureWithoutDependentCategoryCreateInput"]
};
	["RedirectUpsertItemCategoryRelationInput"]: {
	update:ValueTypes["ItemCategoryWithoutRedirectsUpdateInput"],
	create:ValueTypes["ItemCategoryWithoutRedirectsCreateInput"]
};
	["BrandsPageUpsertRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	update:ValueTypes["RedirectWithoutBrandsPageUpdateInput"],
	create:ValueTypes["RedirectWithoutBrandsPageCreateInput"]
};
	["SeoUpsertBrandsPageRelationInput"]: {
	update:ValueTypes["BrandsPageWithoutSeoUpdateInput"],
	create:ValueTypes["BrandsPageWithoutSeoCreateInput"]
};
	["BlogPostUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoUpdateInput"],
	create:ValueTypes["SeoCreateInput"]
};
	["BlogPostUpdateRedirectsEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutBlogPostCreateInput"] | null,
	update?:ValueTypes["BlogPostUpdateRedirectsRelationInput"] | null,
	upsert?:ValueTypes["BlogPostUpsertRedirectsRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:ValueTypes["RedirectUniqueWhere"] | null,
	delete?:ValueTypes["RedirectUniqueWhere"] | null,
	alias?:string | null
};
	["BlogPostUpdateRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	data:ValueTypes["RedirectWithoutBlogPostUpdateInput"]
};
	["RedirectWithoutBlogPostUpdateInput"]: {
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectUpdateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectUpdateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectUpdateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectUpdateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectUpdateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectUpdateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectUpdateComparatorPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostUpsertRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	update:ValueTypes["RedirectWithoutBlogPostUpdateInput"],
	create:ValueTypes["RedirectWithoutBlogPostCreateInput"]
};
	["AdUpsertBlogPostsRelationInput"]: {
	by:ValueTypes["BlogPostUniqueWhere"],
	update:ValueTypes["BlogPostWithoutAdsUpdateInput"],
	create:ValueTypes["BlogPostWithoutAdsCreateInput"]
};
	["AdUpdateBrandsEntityRelationInput"]: {
	create?:ValueTypes["BrandWithoutAdsCreateInput"] | null,
	update?:ValueTypes["AdUpdateBrandsRelationInput"] | null,
	upsert?:ValueTypes["AdUpsertBrandsRelationInput"] | null,
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	disconnect?:ValueTypes["BrandUniqueWhere"] | null,
	delete?:ValueTypes["BrandUniqueWhere"] | null,
	alias?:string | null
};
	["AdUpdateBrandsRelationInput"]: {
	by:ValueTypes["BrandUniqueWhere"],
	data:ValueTypes["BrandWithoutAdsUpdateInput"]
};
	["BrandWithoutAdsUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["BrandUpdateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandUpdateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandUpdateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandUpdateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandUpdateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandUpdateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandUpdateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandUpdateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AdUpsertBrandsRelationInput"]: {
	by:ValueTypes["BrandUniqueWhere"],
	update:ValueTypes["BrandWithoutAdsUpdateInput"],
	create:ValueTypes["BrandWithoutAdsCreateInput"]
};
	["ItemCategoryUpsertAdsRelationInput"]: {
	by:ValueTypes["AdUniqueWhere"],
	update:ValueTypes["AdWithoutItemCategoriesUpdateInput"],
	create:ValueTypes["AdWithoutItemCategoriesCreateInput"]
};
	["ProductFeatureUpsertDependentCategoryRelationInput"]: {
	update:ValueTypes["ItemCategoryWithoutFeatureDependenciesUpdateInput"],
	create:ValueTypes["ItemCategoryWithoutFeatureDependenciesCreateInput"]
};
	["ElementUpsertFeatureDependenciesRelationInput"]: {
	by:ValueTypes["ProductFeatureUniqueWhere"],
	update:ValueTypes["ProductFeatureWithoutDependentElementUpdateInput"],
	create:ValueTypes["ProductFeatureWithoutDependentElementCreateInput"]
};
	["ElementOfProductUpsertElementRelationInput"]: {
	update:ValueTypes["ElementWithoutProductsUpdateInput"],
	create:ValueTypes["ElementWithoutProductsCreateInput"]
};
	["ProductUpsertElementsRelationInput"]: {
	by:ValueTypes["ElementOfProductUniqueWhere"],
	update:ValueTypes["ElementOfProductWithoutProductUpdateInput"],
	create:ValueTypes["ElementOfProductWithoutProductCreateInput"]
};
	["ItemCategoryUpsertProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	update:ValueTypes["ProductWithoutItemCategoriesUpdateInput"],
	create:ValueTypes["ProductWithoutItemCategoriesCreateInput"]
};
	["AdUpsertItemCategoriesRelationInput"]: {
	by:ValueTypes["ItemCategoryUniqueWhere"],
	update:ValueTypes["ItemCategoryWithoutAdsUpdateInput"],
	create:ValueTypes["ItemCategoryWithoutAdsCreateInput"]
};
	["BlogPostUpsertAdsRelationInput"]: {
	by:ValueTypes["AdUniqueWhere"],
	update:ValueTypes["AdWithoutBlogPostsUpdateInput"],
	create:ValueTypes["AdWithoutBlogPostsCreateInput"]
};
	["UserUpsertBlogPostsRelationInput"]: {
	by:ValueTypes["BlogPostUniqueWhere"],
	update:ValueTypes["BlogPostWithoutUserUpdateInput"],
	create:ValueTypes["BlogPostWithoutUserCreateInput"]
};
	["UserUpdateAvatarEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["UserConnectOrCreateAvatarRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["UserUpsertAvatarRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UserUpsertAvatarRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["UserUpdateContactFormMessagesEntityRelationInput"]: {
	create?:ValueTypes["ContactFormMessageWithoutUserCreateInput"] | null,
	update?:ValueTypes["UserUpdateContactFormMessagesRelationInput"] | null,
	upsert?:ValueTypes["UserUpsertContactFormMessagesRelationInput"] | null,
	connect?:ValueTypes["ContactFormMessageUniqueWhere"] | null,
	disconnect?:ValueTypes["ContactFormMessageUniqueWhere"] | null,
	delete?:ValueTypes["ContactFormMessageUniqueWhere"] | null,
	alias?:string | null
};
	["UserUpdateContactFormMessagesRelationInput"]: {
	by:ValueTypes["ContactFormMessageUniqueWhere"],
	data:ValueTypes["ContactFormMessageWithoutUserUpdateInput"]
};
	["ContactFormMessageWithoutUserUpdateInput"]: {
	message?:string | null,
	email?:string | null,
	receivedAt?:ValueTypes["DateTime"] | null,
	isResolved?:boolean | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["UserUpsertContactFormMessagesRelationInput"]: {
	by:ValueTypes["ContactFormMessageUniqueWhere"],
	update:ValueTypes["ContactFormMessageWithoutUserUpdateInput"],
	create:ValueTypes["ContactFormMessageWithoutUserCreateInput"]
};
	["UserUpdateBugReportsEntityRelationInput"]: {
	create?:ValueTypes["BugReportWithoutUserCreateInput"] | null,
	update?:ValueTypes["UserUpdateBugReportsRelationInput"] | null,
	upsert?:ValueTypes["UserUpsertBugReportsRelationInput"] | null,
	connect?:ValueTypes["BugReportUniqueWhere"] | null,
	disconnect?:ValueTypes["BugReportUniqueWhere"] | null,
	delete?:ValueTypes["BugReportUniqueWhere"] | null,
	alias?:string | null
};
	["UserUpdateBugReportsRelationInput"]: {
	by:ValueTypes["BugReportUniqueWhere"],
	data:ValueTypes["BugReportWithoutUserUpdateInput"]
};
	["BugReportWithoutUserUpdateInput"]: {
	message?:string | null,
	receivedAt?:ValueTypes["DateTime"] | null,
	isResolved?:boolean | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["UserUpsertBugReportsRelationInput"]: {
	by:ValueTypes["BugReportUniqueWhere"],
	update:ValueTypes["BugReportWithoutUserUpdateInput"],
	create:ValueTypes["BugReportWithoutUserCreateInput"]
};
	["UserUpdateProtectedActionsEntityRelationInput"]: {
	create?:ValueTypes["ProtectedActionWithoutUserCreateInput"] | null,
	update?:ValueTypes["UserUpdateProtectedActionsRelationInput"] | null,
	upsert?:ValueTypes["UserUpsertProtectedActionsRelationInput"] | null,
	connect?:ValueTypes["ProtectedActionUniqueWhere"] | null,
	disconnect?:ValueTypes["ProtectedActionUniqueWhere"] | null,
	delete?:ValueTypes["ProtectedActionUniqueWhere"] | null,
	alias?:string | null
};
	["UserUpdateProtectedActionsRelationInput"]: {
	by:ValueTypes["ProtectedActionUniqueWhere"],
	data:ValueTypes["ProtectedActionWithoutUserUpdateInput"]
};
	["ProtectedActionWithoutUserUpdateInput"]: {
	type?:ValueTypes["ProtectedActionType"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	usedAt?:ValueTypes["DateTime"] | null,
	expiresAt?:ValueTypes["DateTime"] | null,
	publicKey?:string | null,
	secretHash?:string | null,
	verifyEmail?:string | null,
	createdMetadata?:ValueTypes["Json"] | null,
	usedMetadata?:ValueTypes["Json"] | null,
	_dummy_field_?:boolean | null
};
	["UserUpsertProtectedActionsRelationInput"]: {
	by:ValueTypes["ProtectedActionUniqueWhere"],
	update:ValueTypes["ProtectedActionWithoutUserUpdateInput"],
	create:ValueTypes["ProtectedActionWithoutUserCreateInput"]
};
	["UserUpdateTenantPersonEntityRelationInput"]: {
	connect?:ValueTypes["TenantPersonUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductReviewUpsertUserRelationInput"]: {
	update:ValueTypes["UserWithoutProductReviewsUpdateInput"],
	create:ValueTypes["UserWithoutProductReviewsCreateInput"]
};
	["ProductReviewReactionUpsertProductReviewRelationInput"]: {
	update:ValueTypes["ProductReviewWithoutProductReviewReactionsUpdateInput"],
	create:ValueTypes["ProductReviewWithoutProductReviewReactionsCreateInput"]
};
	["UserUpsertProductReviewReactionsRelationInput"]: {
	by:ValueTypes["ProductReviewReactionUniqueWhere"],
	update:ValueTypes["ProductReviewReactionWithoutUserUpdateInput"],
	create:ValueTypes["ProductReviewReactionWithoutUserCreateInput"]
};
	["BlogPostReviewUpsertUserRelationInput"]: {
	update:ValueTypes["UserWithoutBlogPostReviewsUpdateInput"],
	create:ValueTypes["UserWithoutBlogPostReviewsCreateInput"]
};
	["BlogPostReviewReactionUpsertBlogPostReviewRelationInput"]: {
	update:ValueTypes["BlogPostReviewWithoutBlogPostReviewReactionsUpdateInput"],
	create:ValueTypes["BlogPostReviewWithoutBlogPostReviewReactionsCreateInput"]
};
	["UserUpsertBlogPostReviewReactionsRelationInput"]: {
	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],
	update:ValueTypes["BlogPostReviewReactionWithoutUserUpdateInput"],
	create:ValueTypes["BlogPostReviewReactionWithoutUserCreateInput"]
};
	["BlogPostUpsertUserRelationInput"]: {
	update:ValueTypes["UserWithoutBlogPostsUpdateInput"],
	create:ValueTypes["UserWithoutBlogPostsCreateInput"]
};
	["ItemUpsertBlogPostRelationInput"]: {
	update:ValueTypes["BlogPostWithoutItemsUpdateInput"],
	create:ValueTypes["BlogPostWithoutItemsCreateInput"]
};
	["ItemCategoryUpsertItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	update:ValueTypes["ItemWithoutCategoriesUpdateInput"],
	create:ValueTypes["ItemWithoutCategoriesCreateInput"]
};
	["ProductUpsertItemCategoriesRelationInput"]: {
	by:ValueTypes["ItemCategoryUniqueWhere"],
	update:ValueTypes["ItemCategoryWithoutProductsUpdateInput"],
	create:ValueTypes["ItemCategoryWithoutProductsCreateInput"]
};
	["NutritionalValueOfProductUpsertProductRelationInput"]: {
	update:ValueTypes["ProductWithoutNutritionalValuesUpdateInput"],
	create:ValueTypes["ProductWithoutNutritionalValuesCreateInput"]
};
	["NutritionalValueUpsertProductsRelationInput"]: {
	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],
	update:ValueTypes["NutritionalValueOfProductWithoutNutritionalValueUpdateInput"],
	create:ValueTypes["NutritionalValueOfProductWithoutNutritionalValueCreateInput"]
};
	["NutritionalValueUpdateIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["NutritionalValueConnectOrCreateIconRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["NutritionalValueUpsertIconRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["NutritionalValueUpsertIconRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["SuitabilityItemUpsertNutritionalValueRelationInput"]: {
	update:ValueTypes["NutritionalValueWithoutSuitabilityNutritionalValuesUpdateInput"],
	create:ValueTypes["NutritionalValueWithoutSuitabilityNutritionalValuesCreateInput"]
};
	["SuitabilityItemUpdateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["SuitabilityCategoryUniqueWhere"] | null,
	create?:ValueTypes["SuitabilityCategoryWithoutSuitabilityItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["SuitabilityItemConnectOrCreateCategoryRelationInput"] | null,
	update?:ValueTypes["SuitabilityCategoryWithoutSuitabilityItemsUpdateInput"] | null,
	upsert?:ValueTypes["SuitabilityItemUpsertCategoryRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SuitabilityCategoryWithoutSuitabilityItemsUpdateInput"]: {
	name?:string | null,
	dogSizes?:ValueTypes["SuitabilityCategoryUpdateDogSizesEntityRelationInput"][],
	dogActivities?:ValueTypes["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"][],
	breeds?:ValueTypes["SuitabilityCategoryUpdateBreedsEntityRelationInput"][],
	dogAges?:ValueTypes["SuitabilityCategoryUpdateDogAgesEntityRelationInput"][],
	isPregnant?:boolean | null,
	remoteId?:string | null,
	isBreastfeeding?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityItemUpsertCategoryRelationInput"]: {
	update:ValueTypes["SuitabilityCategoryWithoutSuitabilityItemsUpdateInput"],
	create:ValueTypes["SuitabilityCategoryWithoutSuitabilityItemsCreateInput"]
};
	["ElementUpsertSuitabilityElementsRelationInput"]: {
	by:ValueTypes["SuitabilityItemUniqueWhere"],
	update:ValueTypes["SuitabilityItemWithoutElementUpdateInput"],
	create:ValueTypes["SuitabilityItemWithoutElementCreateInput"]
};
	["ProductFeatureUpsertDependentElementRelationInput"]: {
	update:ValueTypes["ElementWithoutFeatureDependenciesUpdateInput"],
	create:ValueTypes["ElementWithoutFeatureDependenciesCreateInput"]
};
	["ItemUpsertFeaturesOfProductRelationInput"]: {
	by:ValueTypes["ProductFeatureUniqueWhere"],
	update:ValueTypes["ProductFeatureWithoutLinkItemUpdateInput"],
	create:ValueTypes["ProductFeatureWithoutLinkItemCreateInput"]
};
	["BlogPostUpsertItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	update:ValueTypes["ItemWithoutBlogPostUpdateInput"],
	create:ValueTypes["ItemWithoutBlogPostCreateInput"]
};
	["ItemCategoryUpsertBlogPostsRelationInput"]: {
	by:ValueTypes["BlogPostUniqueWhere"],
	update:ValueTypes["BlogPostWithoutItemCategoriesUpdateInput"],
	create:ValueTypes["BlogPostWithoutItemCategoriesCreateInput"]
};
	["ItemUpsertCategoriesRelationInput"]: {
	by:ValueTypes["ItemCategoryUniqueWhere"],
	update:ValueTypes["ItemCategoryWithoutItemsUpdateInput"],
	create:ValueTypes["ItemCategoryWithoutItemsCreateInput"]
};
	["ProductFeatureUpsertLinkItemRelationInput"]: {
	update:ValueTypes["ItemWithoutFeaturesOfProductUpdateInput"],
	create:ValueTypes["ItemWithoutFeaturesOfProductCreateInput"]
};
	["ItemSubCategoryUpsertFeatureDependenciesRelationInput"]: {
	by:ValueTypes["ProductFeatureUniqueWhere"],
	update:ValueTypes["ProductFeatureWithoutDependentSubCategoryUpdateInput"],
	create:ValueTypes["ProductFeatureWithoutDependentSubCategoryCreateInput"]
};
	["ProductUpsertItemSubCategoriesRelationInput"]: {
	by:ValueTypes["ItemSubCategoryUniqueWhere"],
	update:ValueTypes["ItemSubCategoryWithoutProductsUpdateInput"],
	create:ValueTypes["ItemSubCategoryWithoutProductsCreateInput"]
};
	["DogActivityUpsertProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	update:ValueTypes["ProductWithoutRecommendedActivityUpdateInput"],
	create:ValueTypes["ProductWithoutRecommendedActivityCreateInput"]
};
	["DogUpsertActivityRelationInput"]: {
	update:ValueTypes["DogActivityWithoutDogsUpdateInput"],
	create:ValueTypes["DogActivityWithoutDogsCreateInput"]
};
	["BreedUpsertDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	update:ValueTypes["DogWithoutBreedUpdateInput"],
	create:ValueTypes["DogWithoutBreedCreateInput"]
};
	["AgeUpsertBreedsRelationInput"]: {
	by:ValueTypes["BreedUniqueWhere"],
	update:ValueTypes["BreedWithoutAgesUpdateInput"],
	create:ValueTypes["BreedWithoutAgesCreateInput"]
};
	["DogUpsertAgeRelationInput"]: {
	update:ValueTypes["AgeWithoutDogsUpdateInput"],
	create:ValueTypes["AgeWithoutDogsCreateInput"]
};
	["ProductUpsertDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	update:ValueTypes["DogWithoutFedProductUpdateInput"],
	create:ValueTypes["DogWithoutFedProductCreateInput"]
};
	["ItemSubCategoryUpsertProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	update:ValueTypes["ProductWithoutItemSubCategoriesUpdateInput"],
	create:ValueTypes["ProductWithoutItemSubCategoriesCreateInput"]
};
	["ItemUpsertSubCategoriesRelationInput"]: {
	by:ValueTypes["ItemSubCategoryUniqueWhere"],
	update:ValueTypes["ItemSubCategoryWithoutItemsUpdateInput"],
	create:ValueTypes["ItemSubCategoryWithoutItemsCreateInput"]
};
	["BodyTagUpsertNegativeItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	update:ValueTypes["ItemWithoutNegativeForBodyTagsUpdateInput"],
	create:ValueTypes["ItemWithoutNegativeForBodyTagsCreateInput"]
};
	["ItemUpsertPositiveForBodyTagsRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	update:ValueTypes["BodyTagWithoutPositiveItemsUpdateInput"],
	create:ValueTypes["BodyTagWithoutPositiveItemsCreateInput"]
};
	["ItemSubCategoryUpsertItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	update:ValueTypes["ItemWithoutSubCategoriesUpdateInput"],
	create:ValueTypes["ItemWithoutSubCategoriesCreateInput"]
};
	["ItemCategoryUpsertSubCategoriesRelationInput"]: {
	by:ValueTypes["ItemSubCategoryUniqueWhere"],
	update:ValueTypes["ItemSubCategoryWithoutCategoryUpdateInput"],
	create:ValueTypes["ItemSubCategoryWithoutCategoryCreateInput"]
};
	["BlogPostUpsertItemCategoriesRelationInput"]: {
	by:ValueTypes["ItemCategoryUniqueWhere"],
	update:ValueTypes["ItemCategoryWithoutBlogPostsUpdateInput"],
	create:ValueTypes["ItemCategoryWithoutBlogPostsCreateInput"]
};
	["BlogPostTagUpsertBlogPostsRelationInput"]: {
	by:ValueTypes["BlogPostUniqueWhere"],
	update:ValueTypes["BlogPostWithoutBlogPostTagsUpdateInput"],
	create:ValueTypes["BlogPostWithoutBlogPostTagsCreateInput"]
};
	["ColorUpsertBlogPostTagRelationInput"]: {
	update:ValueTypes["BlogPostTagWithoutColorUpdateInput"],
	create:ValueTypes["BlogPostTagWithoutColorCreateInput"]
};
	["ColorUpdateItemFlavorCategoriesEntityRelationInput"]: {
	create?:ValueTypes["ItemFlavorCategoryWithoutColorCreateInput"] | null,
	update?:ValueTypes["ColorUpdateItemFlavorCategoriesRelationInput"] | null,
	upsert?:ValueTypes["ColorUpsertItemFlavorCategoriesRelationInput"] | null,
	connect?:ValueTypes["ItemFlavorCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemFlavorCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ItemFlavorCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ColorUpdateItemFlavorCategoriesRelationInput"]: {
	by:ValueTypes["ItemFlavorCategoryUniqueWhere"],
	data:ValueTypes["ItemFlavorCategoryWithoutColorUpdateInput"]
};
	["ItemFlavorCategoryWithoutColorUpdateInput"]: {
	name?:string | null,
	items?:ValueTypes["ItemFlavorCategoryUpdateItemsEntityRelationInput"][],
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemFlavorCategoryUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ItemSubCategoryWithoutFlavorCategoryCreateInput"] | null,
	update?:ValueTypes["ItemFlavorCategoryUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ItemFlavorCategoryUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ItemSubCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ItemFlavorCategoryUpdateItemsRelationInput"]: {
	by:ValueTypes["ItemSubCategoryUniqueWhere"],
	data:ValueTypes["ItemSubCategoryWithoutFlavorCategoryUpdateInput"]
};
	["ItemSubCategoryWithoutFlavorCategoryUpdateInput"]: {
	name?:string | null,
	items?:ValueTypes["ItemSubCategoryUpdateItemsEntityRelationInput"][],
	isFlavorCategory?:boolean | null,
	isAllergenTag?:boolean | null,
	isMostCommonAllergenTag?:boolean | null,
	products?:ValueTypes["ItemSubCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"] | null,
	dogs?:ValueTypes["ItemSubCategoryUpdateDogsEntityRelationInput"][],
	iconNegative?:ValueTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"] | null,
	negativeWording?:string | null,
	icon?:ValueTypes["ItemSubCategoryUpdateIconEntityRelationInput"] | null,
	brands?:ValueTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"][],
	productLines?:ValueTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"][],
	slug?:string | null,
	flavorSlug?:string | null,
	flavorDeclensionSeventh?:string | null,
	filterCombosFlavor?:ValueTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"][],
	filterCombosAllergy?:ValueTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"][],
	isFilterFlavor?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ItemFlavorCategoryUpsertItemsRelationInput"]: {
	by:ValueTypes["ItemSubCategoryUniqueWhere"],
	update:ValueTypes["ItemSubCategoryWithoutFlavorCategoryUpdateInput"],
	create:ValueTypes["ItemSubCategoryWithoutFlavorCategoryCreateInput"]
};
	["ColorUpsertItemFlavorCategoriesRelationInput"]: {
	by:ValueTypes["ItemFlavorCategoryUniqueWhere"],
	update:ValueTypes["ItemFlavorCategoryWithoutColorUpdateInput"],
	create:ValueTypes["ItemFlavorCategoryWithoutColorCreateInput"]
};
	["BodyTagCategoryUpsertColorRelationInput"]: {
	update:ValueTypes["ColorWithoutBodyTagCategoryUpdateInput"],
	create:ValueTypes["ColorWithoutBodyTagCategoryCreateInput"]
};
	["BodyTagUpsertCategoryRelationInput"]: {
	update:ValueTypes["BodyTagCategoryWithoutTagsUpdateInput"],
	create:ValueTypes["BodyTagCategoryWithoutTagsCreateInput"]
};
	["ItemUpsertNegativeForBodyTagsRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	update:ValueTypes["BodyTagWithoutNegativeItemsUpdateInput"],
	create:ValueTypes["BodyTagWithoutNegativeItemsCreateInput"]
};
	["BodyTagUpsertPositiveItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	update:ValueTypes["ItemWithoutPositiveForBodyTagsUpdateInput"],
	create:ValueTypes["ItemWithoutPositiveForBodyTagsCreateInput"]
};
	["ProductUpsertNegativeForBodyTagsRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	update:ValueTypes["BodyTagWithoutNegativeProductsUpdateInput"],
	create:ValueTypes["BodyTagWithoutNegativeProductsCreateInput"]
};
	["ProductReviewUpsertProductRelationInput"]: {
	update:ValueTypes["ProductWithoutReviewsUpdateInput"],
	create:ValueTypes["ProductWithoutReviewsCreateInput"]
};
	["UserUpsertProductReviewsRelationInput"]: {
	by:ValueTypes["ProductReviewUniqueWhere"],
	update:ValueTypes["ProductReviewWithoutUserUpdateInput"],
	create:ValueTypes["ProductReviewWithoutUserCreateInput"]
};
	["ProductReviewReactionUpsertUserRelationInput"]: {
	update:ValueTypes["UserWithoutProductReviewReactionsUpdateInput"],
	create:ValueTypes["UserWithoutProductReviewReactionsCreateInput"]
};
	["ProductReviewUpsertProductReviewReactionsRelationInput"]: {
	by:ValueTypes["ProductReviewReactionUniqueWhere"],
	update:ValueTypes["ProductReviewReactionWithoutProductReviewUpdateInput"],
	create:ValueTypes["ProductReviewReactionWithoutProductReviewCreateInput"]
};
	["ProductUpsertReviewsRelationInput"]: {
	by:ValueTypes["ProductReviewUniqueWhere"],
	update:ValueTypes["ProductReviewWithoutProductUpdateInput"],
	create:ValueTypes["ProductReviewWithoutProductCreateInput"]
};
	["BodyTagUpsertNegativeProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	update:ValueTypes["ProductWithoutNegativeForBodyTagsUpdateInput"],
	create:ValueTypes["ProductWithoutNegativeForBodyTagsCreateInput"]
};
	["ProductUpsertPositiveForBodyTagsRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	update:ValueTypes["BodyTagWithoutPositiveProductsUpdateInput"],
	create:ValueTypes["BodyTagWithoutPositiveProductsCreateInput"]
};
	["ElementOfProductUpsertProductRelationInput"]: {
	update:ValueTypes["ProductWithoutElementsUpdateInput"],
	create:ValueTypes["ProductWithoutElementsCreateInput"]
};
	["ElementUpsertProductsRelationInput"]: {
	by:ValueTypes["ElementOfProductUniqueWhere"],
	update:ValueTypes["ElementOfProductWithoutElementUpdateInput"],
	create:ValueTypes["ElementOfProductWithoutElementCreateInput"]
};
	["SuitabilityItemUpsertElementRelationInput"]: {
	update:ValueTypes["ElementWithoutSuitabilityElementsUpdateInput"],
	create:ValueTypes["ElementWithoutSuitabilityElementsCreateInput"]
};
	["NutritionalValueUpsertSuitabilityNutritionalValuesRelationInput"]: {
	by:ValueTypes["SuitabilityItemUniqueWhere"],
	update:ValueTypes["SuitabilityItemWithoutNutritionalValueUpdateInput"],
	create:ValueTypes["SuitabilityItemWithoutNutritionalValueCreateInput"]
};
	["NutritionalValueOfProductUpsertNutritionalValueRelationInput"]: {
	update:ValueTypes["NutritionalValueWithoutProductsUpdateInput"],
	create:ValueTypes["NutritionalValueWithoutProductsCreateInput"]
};
	["ProductUpsertNutritionalValuesRelationInput"]: {
	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],
	update:ValueTypes["NutritionalValueOfProductWithoutProductUpdateInput"],
	create:ValueTypes["NutritionalValueOfProductWithoutProductCreateInput"]
};
	["BodyTagUpsertPositiveProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	update:ValueTypes["ProductWithoutPositiveForBodyTagsUpdateInput"],
	create:ValueTypes["ProductWithoutPositiveForBodyTagsCreateInput"]
};
	["BlogPostUpsertTagsRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	update:ValueTypes["BodyTagWithoutBlogPostsUpdateInput"],
	create:ValueTypes["BodyTagWithoutBlogPostsCreateInput"]
};
	["BlogPostReviewUpsertBlogPostRelationInput"]: {
	update:ValueTypes["BlogPostWithoutReviewsUpdateInput"],
	create:ValueTypes["BlogPostWithoutReviewsCreateInput"]
};
	["UserUpsertBlogPostReviewsRelationInput"]: {
	by:ValueTypes["BlogPostReviewUniqueWhere"],
	update:ValueTypes["BlogPostReviewWithoutUserUpdateInput"],
	create:ValueTypes["BlogPostReviewWithoutUserCreateInput"]
};
	["DogUpsertOwnerRelationInput"]: {
	update:ValueTypes["UserWithoutDogsUpdateInput"],
	create:ValueTypes["UserWithoutDogsCreateInput"]
};
	["AgeUpsertDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	update:ValueTypes["DogWithoutAgeUpdateInput"],
	create:ValueTypes["DogWithoutAgeCreateInput"]
};
	["BreedUpsertAgesRelationInput"]: {
	by:ValueTypes["AgeUniqueWhere"],
	update:ValueTypes["AgeWithoutBreedsUpdateInput"],
	create:ValueTypes["AgeWithoutBreedsCreateInput"]
};
	["DogUpsertBreedRelationInput"]: {
	update:ValueTypes["BreedWithoutDogsUpdateInput"],
	create:ValueTypes["BreedWithoutDogsCreateInput"]
};
	["UserUpsertDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	update:ValueTypes["DogWithoutOwnerUpdateInput"],
	create:ValueTypes["DogWithoutOwnerCreateInput"]
};
	["BlogPostReviewReactionUpsertUserRelationInput"]: {
	update:ValueTypes["UserWithoutBlogPostReviewReactionsUpdateInput"],
	create:ValueTypes["UserWithoutBlogPostReviewReactionsCreateInput"]
};
	["BlogPostReviewUpsertBlogPostReviewReactionsRelationInput"]: {
	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],
	update:ValueTypes["BlogPostReviewReactionWithoutBlogPostReviewUpdateInput"],
	create:ValueTypes["BlogPostReviewReactionWithoutBlogPostReviewCreateInput"]
};
	["BlogPostUpsertReviewsRelationInput"]: {
	by:ValueTypes["BlogPostReviewUniqueWhere"],
	update:ValueTypes["BlogPostReviewWithoutBlogPostUpdateInput"],
	create:ValueTypes["BlogPostReviewWithoutBlogPostCreateInput"]
};
	["BodyTagUpsertBlogPostsRelationInput"]: {
	by:ValueTypes["BlogPostUniqueWhere"],
	update:ValueTypes["BlogPostWithoutTagsUpdateInput"],
	create:ValueTypes["BlogPostWithoutTagsCreateInput"]
};
	["BodyTagCategoryUpsertTagsRelationInput"]: {
	by:ValueTypes["BodyTagUniqueWhere"],
	update:ValueTypes["BodyTagWithoutCategoryUpdateInput"],
	create:ValueTypes["BodyTagWithoutCategoryCreateInput"]
};
	["ColorUpsertBodyTagCategoryRelationInput"]: {
	update:ValueTypes["BodyTagCategoryWithoutColorUpdateInput"],
	create:ValueTypes["BodyTagCategoryWithoutColorCreateInput"]
};
	["BlogPostTagUpsertColorRelationInput"]: {
	update:ValueTypes["ColorWithoutBlogPostTagUpdateInput"],
	create:ValueTypes["ColorWithoutBlogPostTagCreateInput"]
};
	["BlogPostUpsertBlogPostTagsRelationInput"]: {
	by:ValueTypes["BlogPostTagUniqueWhere"],
	update:ValueTypes["BlogPostTagWithoutBlogPostsUpdateInput"],
	create:ValueTypes["BlogPostTagWithoutBlogPostsCreateInput"]
};
	["ContentReferenceUpsertRelatedBlogPostRelationInput"]: {
	update:ValueTypes["BlogPostUpdateInput"],
	create:ValueTypes["BlogPostCreateInput"]
};
	["ContentReferenceUpdateAdEntityRelationInput"]: {
	connect?:ValueTypes["AdUniqueWhere"] | null,
	create?:ValueTypes["AdWithoutContentReferencesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceConnectOrCreateAdRelationInput"] | null,
	update?:ValueTypes["AdWithoutContentReferencesUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertAdRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AdWithoutContentReferencesUpdateInput"]: {
	image?:ValueTypes["AdUpdateImageEntityRelationInput"] | null,
	isBrandSectionVisible?:boolean | null,
	isBlogPostSectionVisible?:boolean | null,
	isIngredientSectionVisible?:boolean | null,
	isResultsVisible?:boolean | null,
	isSearchVisible?:boolean | null,
	blogPosts?:ValueTypes["AdUpdateBlogPostsEntityRelationInput"][],
	itemCategories?:ValueTypes["AdUpdateItemCategoriesEntityRelationInput"][],
	brands?:ValueTypes["AdUpdateBrandsEntityRelationInput"][],
	isActive?:boolean | null,
	link?:string | null,
	note?:string | null,
	activeFrom?:ValueTypes["DateTime"] | null,
	activeUntil?:ValueTypes["DateTime"] | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertAdRelationInput"]: {
	update:ValueTypes["AdWithoutContentReferencesUpdateInput"],
	create:ValueTypes["AdWithoutContentReferencesCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by:ValueTypes["ContentReferenceUniqueWhere"],
	update:ValueTypes["ContentReferenceWithoutBlockUpdateInput"],
	create:ValueTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
	by:ValueTypes["ContentBlockUniqueWhere"],
	update:ValueTypes["ContentBlockWithoutContentUpdateInput"],
	create:ValueTypes["ContentBlockWithoutContentCreateInput"]
};
	["BlogPageUpsertContentRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["SeoUpsertBlogPageRelationInput"]: {
	update:ValueTypes["BlogPageWithoutSeoUpdateInput"],
	create:ValueTypes["BlogPageWithoutSeoCreateInput"]
};
	["GenericPageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoWithoutGenericPageUpdateInput"],
	create:ValueTypes["SeoWithoutGenericPageCreateInput"]
};
	["RedirectUpsertGenericPageRelationInput"]: {
	update:ValueTypes["GenericPageWithoutRedirectsUpdateInput"],
	create:ValueTypes["GenericPageWithoutRedirectsCreateInput"]
};
	["BlogPageUpsertRedirectsRelationInput"]: {
	by:ValueTypes["RedirectUniqueWhere"],
	update:ValueTypes["RedirectWithoutBlogPageUpdateInput"],
	create:ValueTypes["RedirectWithoutBlogPageCreateInput"]
};
	["BlogPostTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	blogPosts?:ValueTypes["BlogPostTagCreateBlogPostsEntityRelationInput"][],
	remoteId?:string | null,
	color?:ValueTypes["BlogPostTagCreateColorEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["BlogPostTagUpdateInput"]: {
	name?:string | null,
	blogPosts?:ValueTypes["BlogPostTagUpdateBlogPostsEntityRelationInput"][],
	remoteId?:string | null,
	color?:ValueTypes["BlogPostTagUpdateColorEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["BodyTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagCreateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagCreatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagCreateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagCreatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagCreateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagCreateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagCreateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagCreateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagUpdateInput"]: {
	name?:string | null,
	blogPosts?:ValueTypes["BodyTagUpdateBlogPostsEntityRelationInput"][],
	positiveProducts?:ValueTypes["BodyTagUpdatePositiveProductsEntityRelationInput"][],
	negativeProducts?:ValueTypes["BodyTagUpdateNegativeProductsEntityRelationInput"][],
	positiveItems?:ValueTypes["BodyTagUpdatePositiveItemsEntityRelationInput"][],
	negativeItems?:ValueTypes["BodyTagUpdateNegativeItemsEntityRelationInput"][],
	remoteId?:string | null,
	category?:ValueTypes["BodyTagUpdateCategoryEntityRelationInput"] | null,
	icon?:ValueTypes["BodyTagUpdateIconEntityRelationInput"] | null,
	dogs?:ValueTypes["BodyTagUpdateDogsEntityRelationInput"][],
	labelFor?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BodyTagUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BodyTagCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BodyTagCategoryEdge"],
		__typename?: boolean
}>;
	["BodyTagCategoryEdge"]: AliasType<{
	node?:ValueTypes["BodyTagCategory"],
		__typename?: boolean
}>;
	["BodyTagCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	tags?:ValueTypes["BodyTagCategoryCreateTagsEntityRelationInput"][],
	remoteId?:string | null,
	color?:ValueTypes["BodyTagCategoryCreateColorEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BodyTagCategoryUpdateInput"]: {
	name?:string | null,
	tags?:ValueTypes["BodyTagCategoryUpdateTagsEntityRelationInput"][],
	remoteId?:string | null,
	color?:ValueTypes["BodyTagCategoryUpdateColorEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentEdge"],
		__typename?: boolean
}>;
	["ContentEdge"]: AliasType<{
	node?:ValueTypes["Content"],
		__typename?: boolean
}>;
	["ContentBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockCreateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentBlockCreateReferencesEntityRelationInput"][],
	automatedContentBlockSlug?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"][],
	automatedContentBlockSlug?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fact?:string | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	relatedBlogPost?:ValueTypes["ContentReferenceCreateRelatedBlogPostEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceCreateRelatedBrandEntityRelationInput"] | null,
	relatedProduct?:ValueTypes["ContentReferenceCreateRelatedProductEntityRelationInput"] | null,
	relatedIngredient?:ValueTypes["ContentReferenceCreateRelatedIngredientEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	badge?:string | null,
	longVersion?:boolean | null,
	relatedBrandFull?:ValueTypes["ContentReferenceCreateRelatedBrandFullEntityRelationInput"] | null,
	relatedProductFull?:ValueTypes["ContentReferenceCreateRelatedProductFullEntityRelationInput"] | null,
	list?:ValueTypes["ContentReferenceCreateListEntityRelationInput"][],
	outline?:ValueTypes["ContentReferenceCreateOutlineEntityRelationInput"] | null,
	video?:ValueTypes["ContentReferenceCreateVideoEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	defaultOpen?:boolean | null,
	badgeColor?:string | null,
	isMain?:boolean | null,
	ad?:ValueTypes["ContentReferenceCreateAdEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fact?:string | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	relatedBlogPost?:ValueTypes["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceUpdateRelatedBrandEntityRelationInput"] | null,
	relatedProduct?:ValueTypes["ContentReferenceUpdateRelatedProductEntityRelationInput"] | null,
	relatedIngredient?:ValueTypes["ContentReferenceUpdateRelatedIngredientEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	badge?:string | null,
	longVersion?:boolean | null,
	relatedBrandFull?:ValueTypes["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"] | null,
	relatedProductFull?:ValueTypes["ContentReferenceUpdateRelatedProductFullEntityRelationInput"] | null,
	list?:ValueTypes["ContentReferenceUpdateListEntityRelationInput"][],
	outline?:ValueTypes["ContentReferenceUpdateOutlineEntityRelationInput"] | null,
	video?:ValueTypes["ContentReferenceUpdateVideoEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	defaultOpen?:boolean | null,
	badgeColor?:string | null,
	isMain?:boolean | null,
	ad?:ValueTypes["ContentReferenceUpdateAdEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DidYouKnow"]: AliasType<{
	_meta?:ValueTypes["DidYouKnowMeta"],
	id?:boolean,
	text?:boolean,
	remoteId?:boolean,
		__typename?: boolean
}>;
	["DidYouKnowMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["DidYouKnowUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["DidYouKnowWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["DidYouKnowWhere"] | undefined | null)[],
	or?:(ValueTypes["DidYouKnowWhere"] | undefined | null)[],
	not?:ValueTypes["DidYouKnowWhere"] | null
};
	["DidYouKnowOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null
};
	["DidYouKnowConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DidYouKnowEdge"],
		__typename?: boolean
}>;
	["DidYouKnowEdge"]: AliasType<{
	node?:ValueTypes["DidYouKnow"],
		__typename?: boolean
}>;
	["DidYouKnowCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["DidYouKnowUpdateInput"]: {
	text?:string | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageEdge"],
		__typename?: boolean
}>;
	["ImageEdge"]: AliasType<{
	node?:ValueTypes["Image"],
		__typename?: boolean
}>;
	["Medium"]: AliasType<{
	_meta?:ValueTypes["MediumMeta"],
	id?:boolean,
	type?:boolean,
	colorTheme?:boolean,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
video?: [{	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
		__typename?: boolean
}>;
	["MediumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	colorTheme?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	video?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["MediumType"]:MediumType;
	["ColorTheme"]:ColorTheme;
	["MediumUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["MediumWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["MediumTypeCondition"] | null,
	colorTheme?:ValueTypes["ColorThemeCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	video?:ValueTypes["VideoWhere"] | null,
	and?:(ValueTypes["MediumWhere"] | undefined | null)[],
	or?:(ValueTypes["MediumWhere"] | undefined | null)[],
	not?:ValueTypes["MediumWhere"] | null
};
	["MediumTypeCondition"]: {
	and?:ValueTypes["MediumTypeCondition"][],
	or?:ValueTypes["MediumTypeCondition"][],
	not?:ValueTypes["MediumTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["MediumType"] | null,
	notEq?:ValueTypes["MediumType"] | null,
	in?:ValueTypes["MediumType"][],
	notIn?:ValueTypes["MediumType"][],
	lt?:ValueTypes["MediumType"] | null,
	lte?:ValueTypes["MediumType"] | null,
	gt?:ValueTypes["MediumType"] | null,
	gte?:ValueTypes["MediumType"] | null
};
	["ColorThemeCondition"]: {
	and?:ValueTypes["ColorThemeCondition"][],
	or?:ValueTypes["ColorThemeCondition"][],
	not?:ValueTypes["ColorThemeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ColorTheme"] | null,
	notEq?:ValueTypes["ColorTheme"] | null,
	in?:ValueTypes["ColorTheme"][],
	notIn?:ValueTypes["ColorTheme"][],
	lt?:ValueTypes["ColorTheme"] | null,
	lte?:ValueTypes["ColorTheme"] | null,
	gt?:ValueTypes["ColorTheme"] | null,
	gte?:ValueTypes["ColorTheme"] | null
};
	["MediumOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	colorTheme?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	video?:ValueTypes["VideoOrderBy"] | null
};
	["MediumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumEdge"],
		__typename?: boolean
}>;
	["MediumEdge"]: AliasType<{
	node?:ValueTypes["Medium"],
		__typename?: boolean
}>;
	["MediumCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["MediumType"] | null,
	colorTheme?:ValueTypes["ColorTheme"] | null,
	image?:ValueTypes["MediumCreateImageEntityRelationInput"] | null,
	video?:ValueTypes["MediumCreateVideoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MediumCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["MediumConnectOrCreateImageRelationInput"] | null
};
	["MediumConnectOrCreateImageRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["MediumCreateVideoEntityRelationInput"]: {
	connect?:ValueTypes["VideoUniqueWhere"] | null,
	create?:ValueTypes["VideoCreateInput"] | null,
	connectOrCreate?:ValueTypes["MediumConnectOrCreateVideoRelationInput"] | null
};
	["MediumConnectOrCreateVideoRelationInput"]: {
	connect:ValueTypes["VideoUniqueWhere"],
	create:ValueTypes["VideoCreateInput"]
};
	["MediumUpdateInput"]: {
	type?:ValueTypes["MediumType"] | null,
	colorTheme?:ValueTypes["ColorTheme"] | null,
	image?:ValueTypes["MediumUpdateImageEntityRelationInput"] | null,
	video?:ValueTypes["MediumUpdateVideoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MediumUpdateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["MediumConnectOrCreateImageRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["MediumUpsertImageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MediumUpsertImageRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["MediumUpdateVideoEntityRelationInput"]: {
	connect?:ValueTypes["VideoUniqueWhere"] | null,
	create?:ValueTypes["VideoCreateInput"] | null,
	connectOrCreate?:ValueTypes["MediumConnectOrCreateVideoRelationInput"] | null,
	update?:ValueTypes["VideoUpdateInput"] | null,
	upsert?:ValueTypes["MediumUpsertVideoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MediumUpsertVideoRelationInput"]: {
	update:ValueTypes["VideoUpdateInput"],
	create:ValueTypes["VideoCreateInput"]
};
	["NutritionalValueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NutritionalValueEdge"],
		__typename?: boolean
}>;
	["NutritionalValueEdge"]: AliasType<{
	node?:ValueTypes["NutritionalValue"],
		__typename?: boolean
}>;
	["NutritionalValueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["NutritionalValueCreateProductsEntityRelationInput"][],
	suitabilityNutritionalValues?:ValueTypes["NutritionalValueCreateSuitabilityNutritionalValuesEntityRelationInput"][],
	remoteId?:string | null,
	icon?:ValueTypes["NutritionalValueCreateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NutritionalValueUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["NutritionalValueUpdateProductsEntityRelationInput"][],
	suitabilityNutritionalValues?:ValueTypes["NutritionalValueUpdateSuitabilityNutritionalValuesEntityRelationInput"][],
	remoteId?:string | null,
	icon?:ValueTypes["NutritionalValueUpdateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["Page"]: AliasType<{
	_meta?:ValueTypes["PageMeta"],
	id?:boolean,
	title?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
draft?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
		__typename?: boolean
}>;
	["PageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	draft?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["PageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	draft?:ValueTypes["ContentUniqueWhere"] | null
};
	["PageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	draft?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["PageWhere"] | undefined | null)[],
	or?:(ValueTypes["PageWhere"] | undefined | null)[],
	not?:ValueTypes["PageWhere"] | null
};
	["PageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	draft?:ValueTypes["ContentOrderBy"] | null
};
	["PageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PageEdge"],
		__typename?: boolean
}>;
	["PageEdge"]: AliasType<{
	node?:ValueTypes["Page"],
		__typename?: boolean
}>;
	["PageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	seo?:ValueTypes["PageCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["PageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["PageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["PageConnectOrCreateSeoRelationInput"] | null
};
	["PageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoCreateInput"]
};
	["PageCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["PageConnectOrCreateContentRelationInput"] | null
};
	["PageConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["PageCreateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["PageConnectOrCreateDraftRelationInput"] | null
};
	["PageConnectOrCreateDraftRelationInput"]: {
	connect:ValueTypes["ContentUniqueWhere"],
	create:ValueTypes["ContentCreateInput"]
};
	["PageUpdateInput"]: {
	title?:string | null,
	seo?:ValueTypes["PageUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["PageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["PageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["PageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["PageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoUpdateInput"],
	create:ValueTypes["SeoCreateInput"]
};
	["PageUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["PageConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["PageUpsertContentRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageUpsertContentRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["PageUpdateDraftEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["PageConnectOrCreateDraftRelationInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["PageUpsertDraftRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageUpsertDraftRelationInput"]: {
	update:ValueTypes["ContentUpdateInput"],
	create:ValueTypes["ContentCreateInput"]
};
	["ReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	link?:string | null,
	order?:number | null,
	list?:ValueTypes["ReferenceCreateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ReferenceCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ReferenceListUniqueWhere"] | null,
	create?:ValueTypes["ReferenceListWithoutReferencesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ReferenceConnectOrCreateListRelationInput"] | null
};
	["ReferenceListWithoutReferencesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ReferenceConnectOrCreateListRelationInput"]: {
	connect:ValueTypes["ReferenceListUniqueWhere"],
	create:ValueTypes["ReferenceListWithoutReferencesCreateInput"]
};
	["ReferenceUpdateInput"]: {
	text?:string | null,
	link?:string | null,
	order?:number | null,
	list?:ValueTypes["ReferenceUpdateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ReferenceUpdateListEntityRelationInput"]: {
	connect?:ValueTypes["ReferenceListUniqueWhere"] | null,
	create?:ValueTypes["ReferenceListWithoutReferencesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ReferenceConnectOrCreateListRelationInput"] | null,
	update?:ValueTypes["ReferenceListWithoutReferencesUpdateInput"] | null,
	upsert?:ValueTypes["ReferenceUpsertListRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ReferenceListWithoutReferencesUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ReferenceUpsertListRelationInput"]: {
	update:ValueTypes["ReferenceListWithoutReferencesUpdateInput"],
	create:ValueTypes["ReferenceListWithoutReferencesCreateInput"]
};
	["ReferenceListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ReferenceListEdge"],
		__typename?: boolean
}>;
	["ReferenceListEdge"]: AliasType<{
	node?:ValueTypes["ReferenceList"],
		__typename?: boolean
}>;
	["SeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoEdge"],
		__typename?: boolean
}>;
	["SeoEdge"]: AliasType<{
	node?:ValueTypes["Seo"],
		__typename?: boolean
}>;
	["VideoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VideoEdge"],
		__typename?: boolean
}>;
	["VideoEdge"]: AliasType<{
	node?:ValueTypes["Video"],
		__typename?: boolean
}>;
	["BrandDistributorConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BrandDistributorEdge"],
		__typename?: boolean
}>;
	["BrandDistributorEdge"]: AliasType<{
	node?:ValueTypes["BrandDistributor"],
		__typename?: boolean
}>;
	["BrandDistributorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	brands?:ValueTypes["BrandDistributorCreateBrandsEntityRelationInput"][],
	link?:string | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["BrandDistributorCreateBrandsEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutDistributorCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandDistributorConnectOrCreateBrandsRelationInput"] | null,
	alias?:string | null
};
	["BrandWithoutDistributorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["BrandCreateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandCreateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandCreateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandCreateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandCreateMethodOfProductionEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandCreateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandCreateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandCreateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandCreateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandDistributorConnectOrCreateBrandsRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandWithoutDistributorCreateInput"]
};
	["BrandDistributorUpdateInput"]: {
	name?:string | null,
	brands?:ValueTypes["BrandDistributorUpdateBrandsEntityRelationInput"][],
	link?:string | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["BrandDistributorUpdateBrandsEntityRelationInput"]: {
	create?:ValueTypes["BrandWithoutDistributorCreateInput"] | null,
	update?:ValueTypes["BrandDistributorUpdateBrandsRelationInput"] | null,
	upsert?:ValueTypes["BrandDistributorUpsertBrandsRelationInput"] | null,
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	disconnect?:ValueTypes["BrandUniqueWhere"] | null,
	delete?:ValueTypes["BrandUniqueWhere"] | null,
	alias?:string | null
};
	["BrandDistributorUpdateBrandsRelationInput"]: {
	by:ValueTypes["BrandUniqueWhere"],
	data:ValueTypes["BrandWithoutDistributorUpdateInput"]
};
	["BrandWithoutDistributorUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["BrandUpdateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandUpdateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandUpdateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandUpdateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandUpdateMethodOfProductionEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandUpdateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandUpdateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandUpdateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandDistributorUpsertBrandsRelationInput"]: {
	by:ValueTypes["BrandUniqueWhere"],
	update:ValueTypes["BrandWithoutDistributorUpdateInput"],
	create:ValueTypes["BrandWithoutDistributorCreateInput"]
};
	["DogSizeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	breeds?:ValueTypes["DogSizeCreateBreedsEntityRelationInput"][],
	remoteId?:string | null,
	products?:ValueTypes["DogSizeCreateProductsEntityRelationInput"][],
	suitabilityCategory?:ValueTypes["DogSizeCreateSuitabilityCategoryEntityRelationInput"] | null,
	name?:ValueTypes["SizeType"] | null,
	label?:string | null,
	order?:number | null,
	isFilterVisible?:boolean | null,
	_dummy_field_?:boolean | null
};
	["DogSizeUpdateInput"]: {
	breeds?:ValueTypes["DogSizeUpdateBreedsEntityRelationInput"][],
	remoteId?:string | null,
	products?:ValueTypes["DogSizeUpdateProductsEntityRelationInput"][],
	suitabilityCategory?:ValueTypes["DogSizeUpdateSuitabilityCategoryEntityRelationInput"] | null,
	name?:ValueTypes["SizeType"] | null,
	label?:string | null,
	order?:number | null,
	isFilterVisible?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ProductionMethodConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductionMethodEdge"],
		__typename?: boolean
}>;
	["ProductionMethodEdge"]: AliasType<{
	node?:ValueTypes["ProductionMethod"],
		__typename?: boolean
}>;
	["ProductionMethodCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	brands?:ValueTypes["ProductionMethodCreateBrandsEntityRelationInput"][],
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductionMethodCreateBrandsEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutMethodOfProductionCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductionMethodConnectOrCreateBrandsRelationInput"] | null,
	alias?:string | null
};
	["BrandWithoutMethodOfProductionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["BrandCreateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandCreateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandCreateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandCreateLogoEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandCreateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandCreateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandCreateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandCreateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandCreateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductionMethodConnectOrCreateBrandsRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandWithoutMethodOfProductionCreateInput"]
};
	["ProductionMethodUpdateInput"]: {
	name?:string | null,
	brands?:ValueTypes["ProductionMethodUpdateBrandsEntityRelationInput"][],
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductionMethodUpdateBrandsEntityRelationInput"]: {
	create?:ValueTypes["BrandWithoutMethodOfProductionCreateInput"] | null,
	update?:ValueTypes["ProductionMethodUpdateBrandsRelationInput"] | null,
	upsert?:ValueTypes["ProductionMethodUpsertBrandsRelationInput"] | null,
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	disconnect?:ValueTypes["BrandUniqueWhere"] | null,
	delete?:ValueTypes["BrandUniqueWhere"] | null,
	alias?:string | null
};
	["ProductionMethodUpdateBrandsRelationInput"]: {
	by:ValueTypes["BrandUniqueWhere"],
	data:ValueTypes["BrandWithoutMethodOfProductionUpdateInput"]
};
	["BrandWithoutMethodOfProductionUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["BrandUpdateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandUpdateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandUpdateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandUpdateLogoEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandUpdateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandUpdateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandUpdateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandUpdateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductionMethodUpsertBrandsRelationInput"]: {
	by:ValueTypes["BrandUniqueWhere"],
	update:ValueTypes["BrandWithoutMethodOfProductionUpdateInput"],
	create:ValueTypes["BrandWithoutMethodOfProductionCreateInput"]
};
	["ProductLineCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["ProductLineCreateProductsEntityRelationInput"][],
	remoteId?:string | null,
	lead?:string | null,
	order?:number | null,
	brand?:ValueTypes["ProductLineCreateBrandEntityRelationInput"] | null,
	logo?:ValueTypes["ProductLineCreateLogoEntityRelationInput"] | null,
	aliases?:ValueTypes["ProductLineCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["ProductLineCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["ProductLineCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductLineUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["ProductLineUpdateProductsEntityRelationInput"][],
	remoteId?:string | null,
	lead?:string | null,
	order?:number | null,
	brand?:ValueTypes["ProductLineUpdateBrandEntityRelationInput"] | null,
	logo?:ValueTypes["ProductLineUpdateLogoEntityRelationInput"] | null,
	aliases?:ValueTypes["ProductLineUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["ProductLineUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["ProductLineUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	_dummy_field_?:boolean | null
};
	["BreedCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["BreedCreateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedCreateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedCreateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedCreateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedCreateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedCreateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedCreateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreedUpdateInput"]: {
	dogs?:ValueTypes["BreedUpdateDogsEntityRelationInput"][],
	litterSize?:number | null,
	reviews?:ValueTypes["BreedUpdateReviewsEntityRelationInput"][],
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedUpdateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedUpdateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedUpdateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedUpdateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["DogCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogCreateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogCreateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogCreateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogCreateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogCreateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogCreateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogCreateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogCreateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogCreateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogUpdateInput"]: {
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogUpdateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogUpdateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogUpdateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogUpdateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogUpdateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogUpdateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogUpdateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogUpdateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogUpdateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["UserConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserEdge"],
		__typename?: boolean
}>;
	["UserEdge"]: AliasType<{
	node?:ValueTypes["User"],
		__typename?: boolean
}>;
	["UserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["UserCreateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserCreateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserCreateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserCreateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserCreateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserCreateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserCreateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserCreateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserCreateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserCreateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserCreateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserUpdateInput"]: {
	dogs?:ValueTypes["UserUpdateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserUpdateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserUpdateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserUpdateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserUpdateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserUpdateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserUpdateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserUpdateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserUpdateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserUpdateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserUpdateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["VeterinaryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VeterinaryEdge"],
		__typename?: boolean
}>;
	["VeterinaryEdge"]: AliasType<{
	node?:ValueTypes["Veterinary"],
		__typename?: boolean
}>;
	["VeterinaryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	user?:ValueTypes["VeterinaryCreateUserEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["VeterinaryCreateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutVeterinaryCreateInput"] | null,
	connectOrCreate?:ValueTypes["VeterinaryConnectOrCreateUserRelationInput"] | null
};
	["UserWithoutVeterinaryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["UserCreateDogsEntityRelationInput"][],
	email?:string | null,
	blogPostReviews?:ValueTypes["UserCreateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserCreateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserCreateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserCreateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserCreateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserCreateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserCreateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserCreateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserCreateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["VeterinaryConnectOrCreateUserRelationInput"]: {
	connect:ValueTypes["UserUniqueWhere"],
	create:ValueTypes["UserWithoutVeterinaryCreateInput"]
};
	["VeterinaryUpdateInput"]: {
	user?:ValueTypes["VeterinaryUpdateUserEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["VeterinaryUpdateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutVeterinaryCreateInput"] | null,
	connectOrCreate?:ValueTypes["VeterinaryConnectOrCreateUserRelationInput"] | null,
	update?:ValueTypes["UserWithoutVeterinaryUpdateInput"] | null,
	upsert?:ValueTypes["VeterinaryUpsertUserRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UserWithoutVeterinaryUpdateInput"]: {
	dogs?:ValueTypes["UserUpdateDogsEntityRelationInput"][],
	email?:string | null,
	blogPostReviews?:ValueTypes["UserUpdateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserUpdateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserUpdateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserUpdateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserUpdateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserUpdateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserUpdateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserUpdateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserUpdateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["VeterinaryUpsertUserRelationInput"]: {
	update:ValueTypes["UserWithoutVeterinaryUpdateInput"],
	create:ValueTypes["UserWithoutVeterinaryCreateInput"]
};
	["NutritionalValueOfProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	product?:ValueTypes["NutritionalValueOfProductCreateProductEntityRelationInput"] | null,
	amount?:number | null,
	remoteId?:string | null,
	nutritionalValue?:ValueTypes["NutritionalValueOfProductCreateNutritionalValueEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NutritionalValueOfProductUpdateInput"]: {
	order?:number | null,
	product?:ValueTypes["NutritionalValueOfProductUpdateProductEntityRelationInput"] | null,
	amount?:number | null,
	remoteId?:string | null,
	nutritionalValue?:ValueTypes["NutritionalValueOfProductUpdateNutritionalValueEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ReviewCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogBreeds?:ValueTypes["ReviewCreateDogBreedsEntityRelationInput"][],
	text?:string | null,
	remoteId?:string | null,
	author?:string | null,
	_dummy_field_?:boolean | null
};
	["ReviewCreateDogBreedsEntityRelationInput"]: {
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	create?:ValueTypes["BreedWithoutReviewsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ReviewConnectOrCreateDogBreedsRelationInput"] | null,
	alias?:string | null
};
	["BreedWithoutReviewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["BreedCreateDogsEntityRelationInput"][],
	litterSize?:number | null,
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedCreateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedCreateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedCreateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedCreateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedCreateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ReviewConnectOrCreateDogBreedsRelationInput"]: {
	connect:ValueTypes["BreedUniqueWhere"],
	create:ValueTypes["BreedWithoutReviewsCreateInput"]
};
	["ReviewUpdateInput"]: {
	dogBreeds?:ValueTypes["ReviewUpdateDogBreedsEntityRelationInput"][],
	text?:string | null,
	remoteId?:string | null,
	author?:string | null,
	_dummy_field_?:boolean | null
};
	["ReviewUpdateDogBreedsEntityRelationInput"]: {
	create?:ValueTypes["BreedWithoutReviewsCreateInput"] | null,
	update?:ValueTypes["ReviewUpdateDogBreedsRelationInput"] | null,
	upsert?:ValueTypes["ReviewUpsertDogBreedsRelationInput"] | null,
	connect?:ValueTypes["BreedUniqueWhere"] | null,
	disconnect?:ValueTypes["BreedUniqueWhere"] | null,
	delete?:ValueTypes["BreedUniqueWhere"] | null,
	alias?:string | null
};
	["ReviewUpdateDogBreedsRelationInput"]: {
	by:ValueTypes["BreedUniqueWhere"],
	data:ValueTypes["BreedWithoutReviewsUpdateInput"]
};
	["BreedWithoutReviewsUpdateInput"]: {
	dogs?:ValueTypes["BreedUpdateDogsEntityRelationInput"][],
	litterSize?:number | null,
	name?:string | null,
	dailyEnergyRequirement?:number | null,
	ages?:ValueTypes["BreedUpdateAgesEntityRelationInput"][],
	remoteId?:string | null,
	averageWeightFemale?:number | null,
	averageWeightMale?:number | null,
	suitabilityCategory?:ValueTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"] | null,
	productReviews?:ValueTypes["BreedUpdateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["BreedUpdateBlogPostReviewsEntityRelationInput"][],
	labelFor?:string | null,
	size?:ValueTypes["BreedUpdateSizeEntityRelationInput"] | null,
	slug?:string | null,
	filterCombos?:ValueTypes["BreedUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ReviewUpsertDogBreedsRelationInput"]: {
	by:ValueTypes["BreedUniqueWhere"],
	update:ValueTypes["BreedWithoutReviewsUpdateInput"],
	create:ValueTypes["BreedWithoutReviewsCreateInput"]
};
	["DogBodyTypeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	lead?:string | null,
	dogs?:ValueTypes["DogBodyTypeCreateDogsEntityRelationInput"][],
	order?:number | null,
	value?:number | null,
	remoteId?:string | null,
	category?:ValueTypes["DogBodyTypeCreateCategoryEntityRelationInput"] | null,
	imageMain?:ValueTypes["DogBodyTypeCreateImageMainEntityRelationInput"] | null,
	imageFrom?:ValueTypes["DogBodyTypeCreateImageFromEntityRelationInput"] | null,
	imageTo?:ValueTypes["DogBodyTypeCreateImageToEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogBodyTypeCreateDogsEntityRelationInput"]: {
	connect?:ValueTypes["DogUniqueWhere"] | null,
	create?:ValueTypes["DogWithoutBodyTypeCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogBodyTypeConnectOrCreateDogsRelationInput"] | null,
	alias?:string | null
};
	["DogWithoutBodyTypeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogCreateAgeEntityRelationInput"] | null,
	owner?:ValueTypes["DogCreateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogCreateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogCreateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogCreateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogCreateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogCreateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogCreateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogBodyTypeConnectOrCreateDogsRelationInput"]: {
	connect:ValueTypes["DogUniqueWhere"],
	create:ValueTypes["DogWithoutBodyTypeCreateInput"]
};
	["DogBodyTypeUpdateInput"]: {
	name?:string | null,
	lead?:string | null,
	dogs?:ValueTypes["DogBodyTypeUpdateDogsEntityRelationInput"][],
	order?:number | null,
	value?:number | null,
	remoteId?:string | null,
	category?:ValueTypes["DogBodyTypeUpdateCategoryEntityRelationInput"] | null,
	imageMain?:ValueTypes["DogBodyTypeUpdateImageMainEntityRelationInput"] | null,
	imageFrom?:ValueTypes["DogBodyTypeUpdateImageFromEntityRelationInput"] | null,
	imageTo?:ValueTypes["DogBodyTypeUpdateImageToEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogBodyTypeUpdateDogsEntityRelationInput"]: {
	create?:ValueTypes["DogWithoutBodyTypeCreateInput"] | null,
	update?:ValueTypes["DogBodyTypeUpdateDogsRelationInput"] | null,
	upsert?:ValueTypes["DogBodyTypeUpsertDogsRelationInput"] | null,
	connect?:ValueTypes["DogUniqueWhere"] | null,
	disconnect?:ValueTypes["DogUniqueWhere"] | null,
	delete?:ValueTypes["DogUniqueWhere"] | null,
	alias?:string | null
};
	["DogBodyTypeUpdateDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	data:ValueTypes["DogWithoutBodyTypeUpdateInput"]
};
	["DogWithoutBodyTypeUpdateInput"]: {
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogUpdateAgeEntityRelationInput"] | null,
	owner?:ValueTypes["DogUpdateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogUpdateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogUpdateFedProductEntityRelationInput"] | null,
	reproduction?:ValueTypes["DogUpdateReproductionEntityRelationInput"] | null,
	allergies?:ValueTypes["DogUpdateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogUpdateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogUpdateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogBodyTypeUpsertDogsRelationInput"]: {
	by:ValueTypes["DogUniqueWhere"],
	update:ValueTypes["DogWithoutBodyTypeUpdateInput"],
	create:ValueTypes["DogWithoutBodyTypeCreateInput"]
};
	["DogBodyTypeCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DogBodyTypeCategoryEdge"],
		__typename?: boolean
}>;
	["DogBodyTypeCategoryEdge"]: AliasType<{
	node?:ValueTypes["DogBodyTypeCategory"],
		__typename?: boolean
}>;
	["DogBodyTypeCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	items?:ValueTypes["DogBodyTypeCategoryCreateItemsEntityRelationInput"][],
	remoteId?:string | null,
	imageMain?:ValueTypes["DogBodyTypeCategoryCreateImageMainEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogBodyTypeCategoryCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["DogBodyTypeUniqueWhere"] | null,
	create?:ValueTypes["DogBodyTypeWithoutCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogBodyTypeCategoryConnectOrCreateItemsRelationInput"] | null,
	alias?:string | null
};
	["DogBodyTypeWithoutCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	lead?:string | null,
	dogs?:ValueTypes["DogBodyTypeCreateDogsEntityRelationInput"][],
	order?:number | null,
	value?:number | null,
	remoteId?:string | null,
	imageMain?:ValueTypes["DogBodyTypeCreateImageMainEntityRelationInput"] | null,
	imageFrom?:ValueTypes["DogBodyTypeCreateImageFromEntityRelationInput"] | null,
	imageTo?:ValueTypes["DogBodyTypeCreateImageToEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogBodyTypeCategoryConnectOrCreateItemsRelationInput"]: {
	connect:ValueTypes["DogBodyTypeUniqueWhere"],
	create:ValueTypes["DogBodyTypeWithoutCategoryCreateInput"]
};
	["DogBodyTypeCategoryUpdateInput"]: {
	name?:string | null,
	items?:ValueTypes["DogBodyTypeCategoryUpdateItemsEntityRelationInput"][],
	remoteId?:string | null,
	imageMain?:ValueTypes["DogBodyTypeCategoryUpdateImageMainEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogBodyTypeCategoryUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["DogBodyTypeWithoutCategoryCreateInput"] | null,
	update?:ValueTypes["DogBodyTypeCategoryUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["DogBodyTypeCategoryUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["DogBodyTypeUniqueWhere"] | null,
	disconnect?:ValueTypes["DogBodyTypeUniqueWhere"] | null,
	delete?:ValueTypes["DogBodyTypeUniqueWhere"] | null,
	alias?:string | null
};
	["DogBodyTypeCategoryUpdateItemsRelationInput"]: {
	by:ValueTypes["DogBodyTypeUniqueWhere"],
	data:ValueTypes["DogBodyTypeWithoutCategoryUpdateInput"]
};
	["DogBodyTypeWithoutCategoryUpdateInput"]: {
	name?:string | null,
	lead?:string | null,
	dogs?:ValueTypes["DogBodyTypeUpdateDogsEntityRelationInput"][],
	order?:number | null,
	value?:number | null,
	remoteId?:string | null,
	imageMain?:ValueTypes["DogBodyTypeUpdateImageMainEntityRelationInput"] | null,
	imageFrom?:ValueTypes["DogBodyTypeUpdateImageFromEntityRelationInput"] | null,
	imageTo?:ValueTypes["DogBodyTypeUpdateImageToEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogBodyTypeCategoryUpsertItemsRelationInput"]: {
	by:ValueTypes["DogBodyTypeUniqueWhere"],
	update:ValueTypes["DogBodyTypeWithoutCategoryUpdateInput"],
	create:ValueTypes["DogBodyTypeWithoutCategoryCreateInput"]
};
	["LinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkEdge"],
		__typename?: boolean
}>;
	["LinkEdge"]: AliasType<{
	node?:ValueTypes["Link"],
		__typename?: boolean
}>;
	["Url"]: AliasType<{
	_meta?:ValueTypes["UrlMeta"],
	id?:boolean,
	url?:boolean,
		__typename?: boolean
}>;
	["UrlMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["UrlUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["UrlWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["UrlWhere"] | undefined | null)[],
	or?:(ValueTypes["UrlWhere"] | undefined | null)[],
	not?:ValueTypes["UrlWhere"] | null
};
	["UrlOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null
};
	["UrlConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UrlEdge"],
		__typename?: boolean
}>;
	["UrlEdge"]: AliasType<{
	node?:ValueTypes["Url"],
		__typename?: boolean
}>;
	["UrlCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["UrlUpdateInput"]: {
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["Footer"]: AliasType<{
	_meta?:ValueTypes["FooterMeta"],
	id?:boolean,
	unique?:boolean,
items?: [{	filter?:ValueTypes["FooterLinkWhere"] | null,	orderBy?:ValueTypes["FooterLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLink"]],
	copyright?:boolean,
paginateItems?: [{	filter?:ValueTypes["FooterLinkWhere"] | null,	orderBy?:ValueTypes["FooterLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLinkConnection"]],
		__typename?: boolean
}>;
	["FooterMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	copyright?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["FooterLink"]: AliasType<{
	_meta?:ValueTypes["FooterLinkMeta"],
	id?:boolean,
	label?:boolean,
	order?:boolean,
footer?: [{	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
	link?:boolean,
	targetBlank?:boolean,
		__typename?: boolean
}>;
	["FooterLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	footer?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	targetBlank?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["FooterWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	items?:ValueTypes["FooterLinkWhere"] | null,
	copyright?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["FooterWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterWhere"] | undefined | null)[],
	not?:ValueTypes["FooterWhere"] | null
};
	["FooterLinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	footer?:ValueTypes["FooterWhere"] | null,
	link?:ValueTypes["StringCondition"] | null,
	targetBlank?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["FooterLinkWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterLinkWhere"] | undefined | null)[],
	not?:ValueTypes["FooterLinkWhere"] | null
};
	["FooterLinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	footer?:ValueTypes["FooterOrderBy"] | null,
	link?:ValueTypes["OrderDirection"] | null,
	targetBlank?:ValueTypes["OrderDirection"] | null
};
	["FooterOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	copyright?:ValueTypes["OrderDirection"] | null
};
	["FooterLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterLinkEdge"],
		__typename?: boolean
}>;
	["FooterLinkEdge"]: AliasType<{
	node?:ValueTypes["FooterLink"],
		__typename?: boolean
}>;
	["FooterUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	items?:ValueTypes["FooterLinkUniqueWhere"] | null
};
	["FooterLinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["FooterConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterEdge"],
		__typename?: boolean
}>;
	["FooterEdge"]: AliasType<{
	node?:ValueTypes["Footer"],
		__typename?: boolean
}>;
	["FooterCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	items?:ValueTypes["FooterCreateItemsEntityRelationInput"][],
	copyright?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["FooterLinkUniqueWhere"] | null,
	create?:ValueTypes["FooterLinkWithoutFooterCreateInput"] | null,
	connectOrCreate?:ValueTypes["FooterConnectOrCreateItemsRelationInput"] | null,
	alias?:string | null
};
	["FooterLinkWithoutFooterCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:string | null,
	order?:number | null,
	link?:string | null,
	targetBlank?:boolean | null,
	_dummy_field_?:boolean | null
};
	["FooterConnectOrCreateItemsRelationInput"]: {
	connect:ValueTypes["FooterLinkUniqueWhere"],
	create:ValueTypes["FooterLinkWithoutFooterCreateInput"]
};
	["FooterUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	items?:ValueTypes["FooterUpdateItemsEntityRelationInput"][],
	copyright?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["FooterLinkWithoutFooterCreateInput"] | null,
	update?:ValueTypes["FooterUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["FooterUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["FooterLinkUniqueWhere"] | null,
	disconnect?:ValueTypes["FooterLinkUniqueWhere"] | null,
	delete?:ValueTypes["FooterLinkUniqueWhere"] | null,
	alias?:string | null
};
	["FooterUpdateItemsRelationInput"]: {
	by:ValueTypes["FooterLinkUniqueWhere"],
	data:ValueTypes["FooterLinkWithoutFooterUpdateInput"]
};
	["FooterLinkWithoutFooterUpdateInput"]: {
	label?:string | null,
	order?:number | null,
	link?:string | null,
	targetBlank?:boolean | null,
	_dummy_field_?:boolean | null
};
	["FooterUpsertItemsRelationInput"]: {
	by:ValueTypes["FooterLinkUniqueWhere"],
	update:ValueTypes["FooterLinkWithoutFooterUpdateInput"],
	create:ValueTypes["FooterLinkWithoutFooterCreateInput"]
};
	["FooterLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:string | null,
	order?:number | null,
	footer?:ValueTypes["FooterLinkCreateFooterEntityRelationInput"] | null,
	link?:string | null,
	targetBlank?:boolean | null,
	_dummy_field_?:boolean | null
};
	["FooterLinkCreateFooterEntityRelationInput"]: {
	connect?:ValueTypes["FooterUniqueWhere"] | null,
	create?:ValueTypes["FooterWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["FooterLinkConnectOrCreateFooterRelationInput"] | null
};
	["FooterWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	copyright?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterLinkConnectOrCreateFooterRelationInput"]: {
	connect:ValueTypes["FooterUniqueWhere"],
	create:ValueTypes["FooterWithoutItemsCreateInput"]
};
	["FooterLinkUpdateInput"]: {
	label?:string | null,
	order?:number | null,
	footer?:ValueTypes["FooterLinkUpdateFooterEntityRelationInput"] | null,
	link?:string | null,
	targetBlank?:boolean | null,
	_dummy_field_?:boolean | null
};
	["FooterLinkUpdateFooterEntityRelationInput"]: {
	connect?:ValueTypes["FooterUniqueWhere"] | null,
	create?:ValueTypes["FooterWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["FooterLinkConnectOrCreateFooterRelationInput"] | null,
	update?:ValueTypes["FooterWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["FooterLinkUpsertFooterRelationInput"] | null,
	delete?:boolean | null
};
	["FooterWithoutItemsUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	copyright?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterLinkUpsertFooterRelationInput"]: {
	update:ValueTypes["FooterWithoutItemsUpdateInput"],
	create:ValueTypes["FooterWithoutItemsCreateInput"]
};
	["BrandsPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BrandsPageEdge"],
		__typename?: boolean
}>;
	["BrandsPageEdge"]: AliasType<{
	node?:ValueTypes["BrandsPage"],
		__typename?: boolean
}>;
	["BrandsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	redirects?:ValueTypes["BrandsPageCreateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["BrandsPageCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["BrandsPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandsPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandsPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	redirects?:ValueTypes["BrandsPageUpdateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["BrandsPageUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["BrandsPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandsPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HomePageEdge"],
		__typename?: boolean
}>;
	["HomePageEdge"]: AliasType<{
	node?:ValueTypes["HomePage"],
		__typename?: boolean
}>;
	["HomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["HomePageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutHomePageCreateInput"] | null,
	connectOrCreate?:ValueTypes["HomePageConnectOrCreateSeoRelationInput"] | null
};
	["SeoWithoutHomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoCreateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoCreateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoCreateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoCreateGenericPageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoCreateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoCreateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoCreateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoCreateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoCreateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoCreateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["HomePageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoWithoutHomePageCreateInput"]
};
	["HomePageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["HomePageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutHomePageCreateInput"] | null,
	connectOrCreate?:ValueTypes["HomePageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoWithoutHomePageUpdateInput"] | null,
	upsert?:ValueTypes["HomePageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoWithoutHomePageUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoUpdateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoUpdateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoUpdateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoUpdateGenericPageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoUpdateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoUpdateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoUpdateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoUpdateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoUpdateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoUpdateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoWithoutHomePageUpdateInput"],
	create:ValueTypes["SeoWithoutHomePageCreateInput"]
};
	["IngredientsPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["IngredientsPageEdge"],
		__typename?: boolean
}>;
	["IngredientsPageEdge"]: AliasType<{
	node?:ValueTypes["IngredientsPage"],
		__typename?: boolean
}>;
	["IngredientsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["IngredientsPageCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["IngredientsPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["IngredientsPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["IngredientsPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutIngredientsPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["IngredientsPageConnectOrCreateSeoRelationInput"] | null
};
	["SeoWithoutIngredientsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoCreateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoCreateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoCreateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoCreateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoCreateHomePageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoCreateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoCreateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoCreateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoCreateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoCreateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["IngredientsPageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoWithoutIngredientsPageCreateInput"]
};
	["IngredientsPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	seo?:ValueTypes["IngredientsPageUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["IngredientsPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["IngredientsPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["IngredientsPageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutIngredientsPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["IngredientsPageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoWithoutIngredientsPageUpdateInput"] | null,
	upsert?:ValueTypes["IngredientsPageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoWithoutIngredientsPageUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoUpdateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoUpdateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoUpdateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoUpdateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoUpdateHomePageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoUpdateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoUpdateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoUpdateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoUpdateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoUpdateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["IngredientsPageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoWithoutIngredientsPageUpdateInput"],
	create:ValueTypes["SeoWithoutIngredientsPageCreateInput"]
};
	["ProductReviewCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	productReviewReactions?:ValueTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"][],
	score?:ValueTypes["ProductReviewCreateScoreEntityRelationInput"] | null,
	product?:ValueTypes["ProductReviewCreateProductEntityRelationInput"] | null,
	user?:ValueTypes["ProductReviewCreateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["ProductReviewCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["ProductReviewCreateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewUpdateInput"]: {
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	productReviewReactions?:ValueTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"][],
	score?:ValueTypes["ProductReviewUpdateScoreEntityRelationInput"] | null,
	product?:ValueTypes["ProductReviewUpdateProductEntityRelationInput"] | null,
	user?:ValueTypes["ProductReviewUpdateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["ProductReviewUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["ProductReviewUpdateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ScoreConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ScoreEdge"],
		__typename?: boolean
}>;
	["ScoreEdge"]: AliasType<{
	node?:ValueTypes["Score"],
		__typename?: boolean
}>;
	["ScoreCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:string | null,
	productReviews?:ValueTypes["ScoreCreateProductReviewsEntityRelationInput"][],
	starsAmount?:number | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ScoreCreateProductReviewsEntityRelationInput"]: {
	connect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	create?:ValueTypes["ProductReviewWithoutScoreCreateInput"] | null,
	connectOrCreate?:ValueTypes["ScoreConnectOrCreateProductReviewsRelationInput"] | null,
	alias?:string | null
};
	["ProductReviewWithoutScoreCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	productReviewReactions?:ValueTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"][],
	product?:ValueTypes["ProductReviewCreateProductEntityRelationInput"] | null,
	user?:ValueTypes["ProductReviewCreateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["ProductReviewCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["ProductReviewCreateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ScoreConnectOrCreateProductReviewsRelationInput"]: {
	connect:ValueTypes["ProductReviewUniqueWhere"],
	create:ValueTypes["ProductReviewWithoutScoreCreateInput"]
};
	["ScoreUpdateInput"]: {
	label?:string | null,
	productReviews?:ValueTypes["ScoreUpdateProductReviewsEntityRelationInput"][],
	starsAmount?:number | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ScoreUpdateProductReviewsEntityRelationInput"]: {
	create?:ValueTypes["ProductReviewWithoutScoreCreateInput"] | null,
	update?:ValueTypes["ScoreUpdateProductReviewsRelationInput"] | null,
	upsert?:ValueTypes["ScoreUpsertProductReviewsRelationInput"] | null,
	connect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductReviewUniqueWhere"] | null,
	delete?:ValueTypes["ProductReviewUniqueWhere"] | null,
	alias?:string | null
};
	["ScoreUpdateProductReviewsRelationInput"]: {
	by:ValueTypes["ProductReviewUniqueWhere"],
	data:ValueTypes["ProductReviewWithoutScoreUpdateInput"]
};
	["ProductReviewWithoutScoreUpdateInput"]: {
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	productReviewReactions?:ValueTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"][],
	product?:ValueTypes["ProductReviewUpdateProductEntityRelationInput"] | null,
	user?:ValueTypes["ProductReviewUpdateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["ProductReviewUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["ProductReviewUpdateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["ScoreUpsertProductReviewsRelationInput"]: {
	by:ValueTypes["ProductReviewUniqueWhere"],
	update:ValueTypes["ProductReviewWithoutScoreUpdateInput"],
	create:ValueTypes["ProductReviewWithoutScoreCreateInput"]
};
	["AgeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["AgeCreateDogsEntityRelationInput"][],
	breeds?:ValueTypes["AgeCreateBreedsEntityRelationInput"][],
	ageRange?:ValueTypes["AgeRangeType"] | null,
	categoryLabel?:ValueTypes["AgeLabelType"] | null,
	suitabilityCategories?:ValueTypes["AgeCreateSuitabilityCategoriesEntityRelationInput"][],
	remoteId?:string | null,
	productReviews?:ValueTypes["AgeCreateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["AgeCreateBlogPostReviewsEntityRelationInput"][],
	label?:string | null,
	categoryOrder?:string | null,
	_dummy_field_?:boolean | null
};
	["AgeUpdateInput"]: {
	dogs?:ValueTypes["AgeUpdateDogsEntityRelationInput"][],
	breeds?:ValueTypes["AgeUpdateBreedsEntityRelationInput"][],
	ageRange?:ValueTypes["AgeRangeType"] | null,
	categoryLabel?:ValueTypes["AgeLabelType"] | null,
	suitabilityCategories?:ValueTypes["AgeUpdateSuitabilityCategoriesEntityRelationInput"][],
	remoteId?:string | null,
	productReviews?:ValueTypes["AgeUpdateProductReviewsEntityRelationInput"][],
	blogPostReviews?:ValueTypes["AgeUpdateBlogPostReviewsEntityRelationInput"][],
	label?:string | null,
	categoryOrder?:string | null,
	_dummy_field_?:boolean | null
};
	["CountryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	brands?:ValueTypes["CountryCreateBrandsEntityRelationInput"][],
	manufacturers?:ValueTypes["CountryCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	region?:ValueTypes["CountryCreateRegionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["CountryUpdateInput"]: {
	name?:string | null,
	brands?:ValueTypes["CountryUpdateBrandsEntityRelationInput"][],
	manufacturers?:ValueTypes["CountryUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	region?:ValueTypes["CountryUpdateRegionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"][],
	blogPost?:ValueTypes["BlogPostReviewCreateBlogPostEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostReviewCreateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["BlogPostReviewCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["BlogPostReviewCreateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewUpdateInput"]: {
	title?:string | null,
	text?:string | null,
	publishedAt?:ValueTypes["DateTime"] | null,
	blogPostReviewReactions?:ValueTypes["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"][],
	blogPost?:ValueTypes["BlogPostReviewUpdateBlogPostEntityRelationInput"] | null,
	user?:ValueTypes["BlogPostReviewUpdateUserEntityRelationInput"] | null,
	fullName?:string | null,
	breed?:ValueTypes["BlogPostReviewUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["BlogPostReviewUpdateAgeEntityRelationInput"] | null,
	url?:string | null,
	isVisible?:boolean | null,
	response?:string | null,
	_dummy_field_?:boolean | null
};
	["DogActivityCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:string | null,
	dogs?:ValueTypes["DogActivityCreateDogsEntityRelationInput"][],
	products?:ValueTypes["DogActivityCreateProductsEntityRelationInput"][],
	dailyEnergyRequirementCoeficient?:number | null,
	remoteId?:string | null,
	suitabilityCategory?:ValueTypes["DogActivityCreateSuitabilityCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogActivityUpdateInput"]: {
	label?:string | null,
	dogs?:ValueTypes["DogActivityUpdateDogsEntityRelationInput"][],
	products?:ValueTypes["DogActivityUpdateProductsEntityRelationInput"][],
	dailyEnergyRequirementCoeficient?:number | null,
	remoteId?:string | null,
	suitabilityCategory?:ValueTypes["DogActivityUpdateSuitabilityCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["Social"]: AliasType<{
	_meta?:ValueTypes["SocialMeta"],
	id?:boolean,
	label?:boolean,
	link?:boolean,
		__typename?: boolean
}>;
	["SocialMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SocialType"]:SocialType;
	["SocialUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SocialWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	label?:ValueTypes["SocialTypeCondition"] | null,
	link?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["SocialWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialWhere"] | undefined | null)[],
	not?:ValueTypes["SocialWhere"] | null
};
	["SocialTypeCondition"]: {
	and?:ValueTypes["SocialTypeCondition"][],
	or?:ValueTypes["SocialTypeCondition"][],
	not?:ValueTypes["SocialTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["SocialType"] | null,
	notEq?:ValueTypes["SocialType"] | null,
	in?:ValueTypes["SocialType"][],
	notIn?:ValueTypes["SocialType"][],
	lt?:ValueTypes["SocialType"] | null,
	lte?:ValueTypes["SocialType"] | null,
	gt?:ValueTypes["SocialType"] | null,
	gte?:ValueTypes["SocialType"] | null
};
	["SocialOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["OrderDirection"] | null
};
	["SocialConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialEdge"],
		__typename?: boolean
}>;
	["SocialEdge"]: AliasType<{
	node?:ValueTypes["Social"],
		__typename?: boolean
}>;
	["SocialCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:ValueTypes["SocialType"] | null,
	link?:string | null,
	_dummy_field_?:boolean | null
};
	["SocialUpdateInput"]: {
	label?:ValueTypes["SocialType"] | null,
	link?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceGalleryImageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	reference?:ValueTypes["ContentReferenceGalleryImageCreateReferenceEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceGalleryImageCreateImageEntityRelationInput"] | null,
	lead?:string | null,
	alignment?:ValueTypes["AlignmentType"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceGalleryImageCreateReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutImagesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceGalleryImageConnectOrCreateReferenceRelationInput"] | null
};
	["ContentReferenceWithoutImagesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fact?:string | null,
	relatedBlogPost?:ValueTypes["ContentReferenceCreateRelatedBlogPostEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceCreateRelatedBrandEntityRelationInput"] | null,
	relatedProduct?:ValueTypes["ContentReferenceCreateRelatedProductEntityRelationInput"] | null,
	relatedIngredient?:ValueTypes["ContentReferenceCreateRelatedIngredientEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	badge?:string | null,
	longVersion?:boolean | null,
	relatedBrandFull?:ValueTypes["ContentReferenceCreateRelatedBrandFullEntityRelationInput"] | null,
	relatedProductFull?:ValueTypes["ContentReferenceCreateRelatedProductFullEntityRelationInput"] | null,
	list?:ValueTypes["ContentReferenceCreateListEntityRelationInput"][],
	outline?:ValueTypes["ContentReferenceCreateOutlineEntityRelationInput"] | null,
	video?:ValueTypes["ContentReferenceCreateVideoEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	defaultOpen?:boolean | null,
	badgeColor?:string | null,
	isMain?:boolean | null,
	ad?:ValueTypes["ContentReferenceCreateAdEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceGalleryImageConnectOrCreateReferenceRelationInput"]: {
	connect:ValueTypes["ContentReferenceUniqueWhere"],
	create:ValueTypes["ContentReferenceWithoutImagesCreateInput"]
};
	["ContentReferenceGalleryImageUpdateInput"]: {
	order?:number | null,
	reference?:ValueTypes["ContentReferenceGalleryImageUpdateReferenceEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceGalleryImageUpdateImageEntityRelationInput"] | null,
	lead?:string | null,
	alignment?:ValueTypes["AlignmentType"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceGalleryImageUpdateReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutImagesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceGalleryImageConnectOrCreateReferenceRelationInput"] | null,
	update?:ValueTypes["ContentReferenceWithoutImagesUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceGalleryImageUpsertReferenceRelationInput"] | null,
	delete?:boolean | null
};
	["ContentReferenceWithoutImagesUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fact?:string | null,
	relatedBlogPost?:ValueTypes["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceUpdateRelatedBrandEntityRelationInput"] | null,
	relatedProduct?:ValueTypes["ContentReferenceUpdateRelatedProductEntityRelationInput"] | null,
	relatedIngredient?:ValueTypes["ContentReferenceUpdateRelatedIngredientEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	badge?:string | null,
	longVersion?:boolean | null,
	relatedBrandFull?:ValueTypes["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"] | null,
	relatedProductFull?:ValueTypes["ContentReferenceUpdateRelatedProductFullEntityRelationInput"] | null,
	list?:ValueTypes["ContentReferenceUpdateListEntityRelationInput"][],
	outline?:ValueTypes["ContentReferenceUpdateOutlineEntityRelationInput"] | null,
	video?:ValueTypes["ContentReferenceUpdateVideoEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	defaultOpen?:boolean | null,
	badgeColor?:string | null,
	isMain?:boolean | null,
	ad?:ValueTypes["ContentReferenceUpdateAdEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceGalleryImageUpsertReferenceRelationInput"]: {
	update:ValueTypes["ContentReferenceWithoutImagesUpdateInput"],
	create:ValueTypes["ContentReferenceWithoutImagesCreateInput"]
};
	["ItemCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryCreateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryCreateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryCreateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryCreateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryCreateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryCreateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryCreateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemCategoryUpdateInput"]: {
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryUpdateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryUpdateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryUpdateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryUpdateSeoEntityRelationInput"] | null,
	group?:ValueTypes["ItemCategoryUpdateGroupEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemFlavorCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	items?:ValueTypes["ItemFlavorCategoryCreateItemsEntityRelationInput"][],
	remoteId?:string | null,
	color?:ValueTypes["ItemFlavorCategoryCreateColorEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemFlavorCategoryUpdateInput"]: {
	name?:string | null,
	items?:ValueTypes["ItemFlavorCategoryUpdateItemsEntityRelationInput"][],
	remoteId?:string | null,
	color?:ValueTypes["ItemFlavorCategoryUpdateColorEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionFourthVariantCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ItemDeclensionFourthVariantCreateItemsEntityRelationInput"][],
	label?:string | null,
	remoteId?:string | null,
	declensionSeventh?:string | null,
	isNegativ?:boolean | null,
	seo?:ValueTypes["ItemDeclensionFourthVariantCreateSeoEntityRelationInput"] | null,
	subcategory?:ValueTypes["ItemDeclensionFourthVariantCreateSubcategoryEntityRelationInput"] | null,
	category?:ValueTypes["ItemDeclensionFourthVariantCreateCategoryEntityRelationInput"] | null,
	element?:ValueTypes["ItemDeclensionFourthVariantCreateElementEntityRelationInput"] | null,
	products?:ValueTypes["ItemDeclensionFourthVariantCreateProductsEntityRelationInput"][],
	slug?:string | null,
	content?:ValueTypes["ItemDeclensionFourthVariantCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemDeclensionFourthVariantCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionFourthVariantUpdateInput"]: {
	items?:ValueTypes["ItemDeclensionFourthVariantUpdateItemsEntityRelationInput"][],
	label?:string | null,
	remoteId?:string | null,
	declensionSeventh?:string | null,
	isNegativ?:boolean | null,
	seo?:ValueTypes["ItemDeclensionFourthVariantUpdateSeoEntityRelationInput"] | null,
	subcategory?:ValueTypes["ItemDeclensionFourthVariantUpdateSubcategoryEntityRelationInput"] | null,
	category?:ValueTypes["ItemDeclensionFourthVariantUpdateCategoryEntityRelationInput"] | null,
	element?:ValueTypes["ItemDeclensionFourthVariantUpdateElementEntityRelationInput"] | null,
	products?:ValueTypes["ItemDeclensionFourthVariantUpdateProductsEntityRelationInput"][],
	slug?:string | null,
	content?:ValueTypes["ItemDeclensionFourthVariantUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemDeclensionFourthVariantUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionSeventhVariantConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ItemDeclensionSeventhVariantEdge"],
		__typename?: boolean
}>;
	["ItemDeclensionSeventhVariantEdge"]: AliasType<{
	node?:ValueTypes["ItemDeclensionSeventhVariant"],
		__typename?: boolean
}>;
	["ItemDeclensionSeventhVariantCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ItemDeclensionSeventhVariantCreateItemsEntityRelationInput"][],
	label?:string | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionSeventhVariantCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemWithoutDeclensionSeventhCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemDeclensionSeventhVariantConnectOrCreateItemsRelationInput"] | null,
	alias?:string | null
};
	["ItemWithoutDeclensionSeventhCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemCreateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemCreateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemCreateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemCreateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemCreateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemCreateDeclensionFourthEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemCreateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemCreateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionSeventhVariantConnectOrCreateItemsRelationInput"]: {
	connect:ValueTypes["ItemUniqueWhere"],
	create:ValueTypes["ItemWithoutDeclensionSeventhCreateInput"]
};
	["ItemDeclensionSeventhVariantUpdateInput"]: {
	items?:ValueTypes["ItemDeclensionSeventhVariantUpdateItemsEntityRelationInput"][],
	label?:string | null,
	remoteId?:string | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionSeventhVariantUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ItemWithoutDeclensionSeventhCreateInput"] | null,
	update?:ValueTypes["ItemDeclensionSeventhVariantUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ItemDeclensionSeventhVariantUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemUniqueWhere"] | null,
	delete?:ValueTypes["ItemUniqueWhere"] | null,
	alias?:string | null
};
	["ItemDeclensionSeventhVariantUpdateItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	data:ValueTypes["ItemWithoutDeclensionSeventhUpdateInput"]
};
	["ItemWithoutDeclensionSeventhUpdateInput"]: {
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemUpdateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemUpdateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemUpdateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemUpdateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemUpdateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemUpdateDeclensionFourthEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemUpdateSeoEntityRelationInput"] | null,
	aliases?:ValueTypes["ItemUpdateAliasesEntityRelationInput"][],
	content?:ValueTypes["ItemUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemDeclensionSeventhVariantUpsertItemsRelationInput"]: {
	by:ValueTypes["ItemUniqueWhere"],
	update:ValueTypes["ItemWithoutDeclensionSeventhUpdateInput"],
	create:ValueTypes["ItemWithoutDeclensionSeventhCreateInput"]
};
	["MediaCard"]: AliasType<{
	_meta?:ValueTypes["MediaCardMeta"],
	id?:boolean,
	title?:boolean,
	lead?:boolean,
	buttonLabel?:boolean,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	link?:boolean,
	order?:boolean,
		__typename?: boolean
}>;
	["MediaCardMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	buttonLabel?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["MediaCardUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["MediaCardWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	buttonLabel?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	link?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	and?:(ValueTypes["MediaCardWhere"] | undefined | null)[],
	or?:(ValueTypes["MediaCardWhere"] | undefined | null)[],
	not?:ValueTypes["MediaCardWhere"] | null
};
	["MediaCardOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	buttonLabel?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	link?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null
};
	["MediaCardConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediaCardEdge"],
		__typename?: boolean
}>;
	["MediaCardEdge"]: AliasType<{
	node?:ValueTypes["MediaCard"],
		__typename?: boolean
}>;
	["MediaCardCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	lead?:string | null,
	buttonLabel?:string | null,
	image?:ValueTypes["MediaCardCreateImageEntityRelationInput"] | null,
	link?:string | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["MediaCardCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["MediaCardConnectOrCreateImageRelationInput"] | null
};
	["MediaCardConnectOrCreateImageRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["MediaCardUpdateInput"]: {
	title?:string | null,
	lead?:string | null,
	buttonLabel?:string | null,
	image?:ValueTypes["MediaCardUpdateImageEntityRelationInput"] | null,
	link?:string | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["MediaCardUpdateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["MediaCardConnectOrCreateImageRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["MediaCardUpsertImageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MediaCardUpsertImageRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["InfoCard"]: AliasType<{
	_meta?:ValueTypes["InfoCardMeta"],
	id?:boolean,
	title?:boolean,
	lead?:boolean,
	order?:boolean,
		__typename?: boolean
}>;
	["InfoCardMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["InfoCardUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["InfoCardWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	and?:(ValueTypes["InfoCardWhere"] | undefined | null)[],
	or?:(ValueTypes["InfoCardWhere"] | undefined | null)[],
	not?:ValueTypes["InfoCardWhere"] | null
};
	["InfoCardOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null
};
	["InfoCardConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["InfoCardEdge"],
		__typename?: boolean
}>;
	["InfoCardEdge"]: AliasType<{
	node?:ValueTypes["InfoCard"],
		__typename?: boolean
}>;
	["InfoCardCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	lead?:string | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["InfoCardUpdateInput"]: {
	title?:string | null,
	lead?:string | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["NumberedCard"]: AliasType<{
	_meta?:ValueTypes["NumberedCardMeta"],
	id?:boolean,
	title?:boolean,
	lead?:boolean,
	order?:boolean,
	link?:boolean,
		__typename?: boolean
}>;
	["NumberedCardMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	lead?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["NumberedCardUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["NumberedCardWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	lead?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["NumberedCardWhere"] | undefined | null)[],
	or?:(ValueTypes["NumberedCardWhere"] | undefined | null)[],
	not?:ValueTypes["NumberedCardWhere"] | null
};
	["NumberedCardOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	lead?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["OrderDirection"] | null
};
	["NumberedCardConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NumberedCardEdge"],
		__typename?: boolean
}>;
	["NumberedCardEdge"]: AliasType<{
	node?:ValueTypes["NumberedCard"],
		__typename?: boolean
}>;
	["NumberedCardCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	lead?:string | null,
	order?:number | null,
	link?:string | null,
	_dummy_field_?:boolean | null
};
	["NumberedCardUpdateInput"]: {
	title?:string | null,
	lead?:string | null,
	order?:number | null,
	link?:string | null,
	_dummy_field_?:boolean | null
};
	["RegisterClaim"]: AliasType<{
	_meta?:ValueTypes["RegisterClaimMeta"],
	id?:boolean,
	text?:boolean,
	order?:boolean,
		__typename?: boolean
}>;
	["RegisterClaimMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["RegisterClaimUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["RegisterClaimWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	and?:(ValueTypes["RegisterClaimWhere"] | undefined | null)[],
	or?:(ValueTypes["RegisterClaimWhere"] | undefined | null)[],
	not?:ValueTypes["RegisterClaimWhere"] | null
};
	["RegisterClaimOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null
};
	["RegisterClaimConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RegisterClaimEdge"],
		__typename?: boolean
}>;
	["RegisterClaimEdge"]: AliasType<{
	node?:ValueTypes["RegisterClaim"],
		__typename?: boolean
}>;
	["RegisterClaimCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["RegisterClaimUpdateInput"]: {
	text?:string | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewReactionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	sentiment?:ValueTypes["SentimentType"] | null,
	user?:ValueTypes["BlogPostReviewReactionCreateUserEntityRelationInput"] | null,
	blogPostReview?:ValueTypes["BlogPostReviewReactionCreateBlogPostReviewEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BlogPostReviewReactionUpdateInput"]: {
	sentiment?:ValueTypes["SentimentType"] | null,
	user?:ValueTypes["BlogPostReviewReactionUpdateUserEntityRelationInput"] | null,
	blogPostReview?:ValueTypes["BlogPostReviewReactionUpdateBlogPostReviewEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewReactionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	sentiment?:ValueTypes["SentimentType"] | null,
	user?:ValueTypes["ProductReviewReactionCreateUserEntityRelationInput"] | null,
	productReview?:ValueTypes["ProductReviewReactionCreateProductReviewEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductReviewReactionUpdateInput"]: {
	sentiment?:ValueTypes["SentimentType"] | null,
	user?:ValueTypes["ProductReviewReactionUpdateUserEntityRelationInput"] | null,
	productReview?:ValueTypes["ProductReviewReactionUpdateProductReviewEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductPackageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	price?:number | null,
	order?:number | null,
	link?:string | null,
	product?:ValueTypes["ProductPackageCreateProductEntityRelationInput"] | null,
	amount?:number | null,
	externalId?:string | null,
	remoteId?:string | null,
	label?:string | null,
	positionId?:string | null,
	heurekaPrice?:number | null,
	heurekaLink?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductPackageCreateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutPackagingsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductPackageConnectOrCreateProductRelationInput"] | null
};
	["ProductWithoutPackagingsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductPackageConnectOrCreateProductRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutPackagingsCreateInput"]
};
	["ProductPackageUpdateInput"]: {
	price?:number | null,
	order?:number | null,
	link?:string | null,
	product?:ValueTypes["ProductPackageUpdateProductEntityRelationInput"] | null,
	amount?:number | null,
	externalId?:string | null,
	remoteId?:string | null,
	label?:string | null,
	positionId?:string | null,
	heurekaPrice?:number | null,
	heurekaLink?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductPackageUpdateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutPackagingsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductPackageConnectOrCreateProductRelationInput"] | null,
	update?:ValueTypes["ProductWithoutPackagingsUpdateInput"] | null,
	upsert?:ValueTypes["ProductPackageUpsertProductRelationInput"] | null,
	delete?:boolean | null
};
	["ProductWithoutPackagingsUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductPackageUpsertProductRelationInput"]: {
	update:ValueTypes["ProductWithoutPackagingsUpdateInput"],
	create:ValueTypes["ProductWithoutPackagingsCreateInput"]
};
	["BrandManufacturerCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	link?:string | null,
	brands?:ValueTypes["BrandManufacturerCreateBrandsEntityRelationInput"][],
	order?:number | null,
	remoteId?:string | null,
	residence?:ValueTypes["BrandManufacturerCreateResidenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandManufacturerUpdateInput"]: {
	name?:string | null,
	link?:string | null,
	brands?:ValueTypes["BrandManufacturerUpdateBrandsEntityRelationInput"][],
	order?:number | null,
	remoteId?:string | null,
	residence?:ValueTypes["BrandManufacturerUpdateResidenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ElementConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ElementEdge"],
		__typename?: boolean
}>;
	["ElementEdge"]: AliasType<{
	node?:ValueTypes["Element"],
		__typename?: boolean
}>;
	["ElementOfProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	amount?:number | null,
	product?:ValueTypes["ElementOfProductCreateProductEntityRelationInput"] | null,
	remoteId?:string | null,
	element?:ValueTypes["ElementOfProductCreateElementEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ElementOfProductUpdateInput"]: {
	order?:number | null,
	amount?:number | null,
	product?:ValueTypes["ElementOfProductUpdateProductEntityRelationInput"] | null,
	remoteId?:string | null,
	element?:ValueTypes["ElementOfProductUpdateElementEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	dogSizes?:ValueTypes["SuitabilityCategoryCreateDogSizesEntityRelationInput"][],
	dogActivities?:ValueTypes["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"][],
	breeds?:ValueTypes["SuitabilityCategoryCreateBreedsEntityRelationInput"][],
	suitabilityItems?:ValueTypes["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"][],
	dogAges?:ValueTypes["SuitabilityCategoryCreateDogAgesEntityRelationInput"][],
	isPregnant?:boolean | null,
	remoteId?:string | null,
	isBreastfeeding?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityCategoryUpdateInput"]: {
	name?:string | null,
	dogSizes?:ValueTypes["SuitabilityCategoryUpdateDogSizesEntityRelationInput"][],
	dogActivities?:ValueTypes["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"][],
	breeds?:ValueTypes["SuitabilityCategoryUpdateBreedsEntityRelationInput"][],
	suitabilityItems?:ValueTypes["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"][],
	dogAges?:ValueTypes["SuitabilityCategoryUpdateDogAgesEntityRelationInput"][],
	isPregnant?:boolean | null,
	remoteId?:string | null,
	isBreastfeeding?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ProductFeatureCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	category?:ValueTypes["FeatureCategoryType"] | null,
	value?:ValueTypes["FeatureValueType"] | null,
	remoteId?:string | null,
	linkItem?:ValueTypes["ProductFeatureCreateLinkItemEntityRelationInput"] | null,
	dependentElement?:ValueTypes["ProductFeatureCreateDependentElementEntityRelationInput"] | null,
	dependentCategory?:ValueTypes["ProductFeatureCreateDependentCategoryEntityRelationInput"] | null,
	dependentSubCategory?:ValueTypes["ProductFeatureCreateDependentSubCategoryEntityRelationInput"] | null,
	dependentFlag?:ValueTypes["ProductFeatureCreateDependentFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFeatureUpdateInput"]: {
	text?:string | null,
	category?:ValueTypes["FeatureCategoryType"] | null,
	value?:ValueTypes["FeatureValueType"] | null,
	remoteId?:string | null,
	linkItem?:ValueTypes["ProductFeatureUpdateLinkItemEntityRelationInput"] | null,
	dependentElement?:ValueTypes["ProductFeatureUpdateDependentElementEntityRelationInput"] | null,
	dependentCategory?:ValueTypes["ProductFeatureUpdateDependentCategoryEntityRelationInput"] | null,
	dependentSubCategory?:ValueTypes["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"] | null,
	dependentFlag?:ValueTypes["ProductFeatureUpdateDependentFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	min?:number | null,
	max?:number | null,
	remoteId?:string | null,
	order?:number | null,
	element?:ValueTypes["SuitabilityItemCreateElementEntityRelationInput"] | null,
	nutritionalValue?:ValueTypes["SuitabilityItemCreateNutritionalValueEntityRelationInput"] | null,
	category?:ValueTypes["SuitabilityItemCreateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SuitabilityItemUpdateInput"]: {
	min?:number | null,
	max?:number | null,
	remoteId?:string | null,
	order?:number | null,
	element?:ValueTypes["SuitabilityItemUpdateElementEntityRelationInput"] | null,
	nutritionalValue?:ValueTypes["SuitabilityItemUpdateNutritionalValueEntityRelationInput"] | null,
	category?:ValueTypes["SuitabilityItemUpdateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RegionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RegionEdge"],
		__typename?: boolean
}>;
	["RegionEdge"]: AliasType<{
	node?:ValueTypes["Region"],
		__typename?: boolean
}>;
	["RegionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	countries?:ValueTypes["RegionCreateCountriesEntityRelationInput"][],
	remoteId?:string | null,
	adjective?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["RegionCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RegionUpdateInput"]: {
	name?:string | null,
	countries?:ValueTypes["RegionUpdateCountriesEntityRelationInput"][],
	remoteId?:string | null,
	adjective?:string | null,
	slug?:string | null,
	filterCombos?:ValueTypes["RegionUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["GranuleSizeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	products?:ValueTypes["GranuleSizeCreateProductsEntityRelationInput"][],
	name?:ValueTypes["GranuleSizeType"] | null,
	_dummy_field_?:boolean | null
};
	["GranuleSizeCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutGranuleSizesCreateInput"] | null,
	connectOrCreate?:ValueTypes["GranuleSizeConnectOrCreateProductsRelationInput"] | null,
	alias?:string | null
};
	["ProductWithoutGranuleSizesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["GranuleSizeConnectOrCreateProductsRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutGranuleSizesCreateInput"]
};
	["GranuleSizeUpdateInput"]: {
	remoteId?:string | null,
	products?:ValueTypes["GranuleSizeUpdateProductsEntityRelationInput"][],
	name?:ValueTypes["GranuleSizeType"] | null,
	_dummy_field_?:boolean | null
};
	["GranuleSizeUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductWithoutGranuleSizesCreateInput"] | null,
	update?:ValueTypes["GranuleSizeUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["GranuleSizeUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductUniqueWhere"] | null,
	alias?:string | null
};
	["GranuleSizeUpdateProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	data:ValueTypes["ProductWithoutGranuleSizesUpdateInput"]
};
	["ProductWithoutGranuleSizesUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["GranuleSizeUpsertProductsRelationInput"]: {
	by:ValueTypes["ProductUniqueWhere"],
	update:ValueTypes["ProductWithoutGranuleSizesUpdateInput"],
	create:ValueTypes["ProductWithoutGranuleSizesCreateInput"]
};
	["ItemAliasCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	name?:string | null,
	item?:ValueTypes["ItemAliasCreateItemEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemAliasCreateItemEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemWithoutAliasesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemAliasConnectOrCreateItemRelationInput"] | null
};
	["ItemWithoutAliasesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemCreateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemCreateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemCreateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemCreateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemCreateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemCreateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemCreateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemCreateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["ItemCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemAliasConnectOrCreateItemRelationInput"]: {
	connect:ValueTypes["ItemUniqueWhere"],
	create:ValueTypes["ItemWithoutAliasesCreateInput"]
};
	["ItemAliasUpdateInput"]: {
	remoteId?:string | null,
	name?:string | null,
	item?:ValueTypes["ItemAliasUpdateItemEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemAliasUpdateItemEntityRelationInput"]: {
	connect?:ValueTypes["ItemUniqueWhere"] | null,
	create?:ValueTypes["ItemWithoutAliasesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemAliasConnectOrCreateItemRelationInput"] | null,
	update?:ValueTypes["ItemWithoutAliasesUpdateInput"] | null,
	upsert?:ValueTypes["ItemAliasUpsertItemRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ItemWithoutAliasesUpdateInput"]: {
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"][],
	subCategories?:ValueTypes["ItemUpdateSubCategoriesEntityRelationInput"][],
	categories?:ValueTypes["ItemUpdateCategoriesEntityRelationInput"][],
	lead?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	featuresOfProduct?:ValueTypes["ItemUpdateFeaturesOfProductEntityRelationInput"][],
	remoteId?:string | null,
	image?:ValueTypes["ItemUpdateImageEntityRelationInput"] | null,
	referenceList?:ValueTypes["ItemUpdateReferenceListEntityRelationInput"] | null,
	blogPost?:ValueTypes["ItemUpdateBlogPostEntityRelationInput"] | null,
	declensionFourth?:ValueTypes["ItemUpdateDeclensionFourthEntityRelationInput"] | null,
	declensionSeventh?:ValueTypes["ItemUpdateDeclensionSeventhEntityRelationInput"] | null,
	slug?:string | null,
	seo?:ValueTypes["ItemUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["ItemUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemAliasUpsertItemRelationInput"]: {
	update:ValueTypes["ItemWithoutAliasesUpdateInput"],
	create:ValueTypes["ItemWithoutAliasesCreateInput"]
};
	["SemanticKey"]: AliasType<{
	_meta?:ValueTypes["SemanticKeyMeta"],
	id?:boolean,
	key?:boolean,
	value?:boolean,
		__typename?: boolean
}>;
	["SemanticKeyMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	key?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SemanticKeyUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	key?:string | null
};
	["SemanticKeyWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	key?:ValueTypes["StringCondition"] | null,
	value?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["SemanticKeyWhere"] | undefined | null)[],
	or?:(ValueTypes["SemanticKeyWhere"] | undefined | null)[],
	not?:ValueTypes["SemanticKeyWhere"] | null
};
	["SemanticKeyOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	key?:ValueTypes["OrderDirection"] | null,
	value?:ValueTypes["OrderDirection"] | null
};
	["SemanticKeyConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SemanticKeyEdge"],
		__typename?: boolean
}>;
	["SemanticKeyEdge"]: AliasType<{
	node?:ValueTypes["SemanticKey"],
		__typename?: boolean
}>;
	["SemanticKeyCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	key?:string | null,
	value?:string | null,
	_dummy_field_?:boolean | null
};
	["SemanticKeyUpdateInput"]: {
	key?:string | null,
	value?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductFlagConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductFlagEdge"],
		__typename?: boolean
}>;
	["ProductFlagEdge"]: AliasType<{
	node?:ValueTypes["ProductFlag"],
		__typename?: boolean
}>;
	["ProductFlagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	productFeatures?:ValueTypes["ProductFlagCreateProductFeaturesEntityRelationInput"][],
	products?:ValueTypes["ProductFlagCreateProductsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductFlagUpdateInput"]: {
	remoteId?:string | null,
	productFeatures?:ValueTypes["ProductFlagUpdateProductFeaturesEntityRelationInput"][],
	products?:ValueTypes["ProductFlagUpdateProductsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductFlagOfProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	value?:ValueTypes["ProductFlagValue"] | null,
	product?:ValueTypes["ProductFlagOfProductCreateProductEntityRelationInput"] | null,
	flag?:ValueTypes["ProductFlagOfProductCreateFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductFlagOfProductUpdateInput"]: {
	remoteId?:string | null,
	value?:ValueTypes["ProductFlagValue"] | null,
	product?:ValueTypes["ProductFlagOfProductUpdateProductEntityRelationInput"] | null,
	flag?:ValueTypes["ProductFlagOfProductUpdateFlagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductEvaluationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductEvaluationEdge"],
		__typename?: boolean
}>;
	["ProductEvaluationEdge"]: AliasType<{
	node?:ValueTypes["ProductEvaluation"],
		__typename?: boolean
}>;
	["ProductEvaluationCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nazev?:string | null,
	vetDieta?:string | null,
	vetDieta1?:string | null,
	vetDieta2?:string | null,
	aktivita?:string | null,
	vek?:string | null,
	velikostPlemen?:string | null,
	hmotnostPlemene?:string | null,
	velikostGranuli?:string | null,
	velikostGranuliText?:string | null,
	doporucenaAktivitaDleMe?:string | null,
	vypocitanaMeVsMeVyrobce?:string | null,
	vypocitanaMeVsMeVyrobce2?:string | null,
	masoNaPrvnimMisteText?:string | null,
	zdrojeZivocisnychBilkovinDle1Vyskytu?:string | null,
	prichuteSeznam?:string | null,
	eliminacniDietaTextInterpunkce?:string | null,
	alergenyZadneNeobsahuje?:string | null,
	alergenyObsahuje?:string | null,
	alergenyNejakeNeobsahuje?:string | null,
	prospesneDruhyInterpunkce?:string | null,
	nevhodneDruhy?:string | null,
	kladneUcinkyCeleTelo?:string | null,
	kladneUcinkyHlava?:string | null,
	kladneUcinkyHrudnik?:string | null,
	kladneUcinkyBricho?:string | null,
	kladneUcinkySpodniCast?:string | null,
	zaporneUcinkyCeleTelo?:string | null,
	zaporneUcinkyHlava?:string | null,
	zaporneUcinkyHrudnik?:string | null,
	zaporneUcinkyBricho?:string | null,
	zaporneUcinkySpodniCast?:string | null,
	dsneuvedeno?:string | null,
	dsmalo?:string | null,
	dsprilis?:string | null,
	dsok?:string | null,
	d95malo?:string | null,
	d95prilis?:string | null,
	d95ok?:string | null,
	d110malo?:string | null,
	d110prilis?:string | null,
	d110ok?:string | null,
	sdo14reproMalo?:string | null,
	sdo14reproPrilis?:string | null,
	sdo14reproOk?:string | null,
	sdo15malo?:string | null,
	sdo15prilis?:string | null,
	sdo15ok?:string | null,
	s15malo?:string | null,
	s15prilis?:string | null,
	s15ok?:string | null,
	product?:ValueTypes["ProductEvaluationCreateProductEntityRelationInput"] | null,
	masoAnoNe?:string | null,
	eliminacniDietaAnoNe?:string | null,
	alergenyAnoNe?:string | null,
	plodnostKastraceNadpis?:string | null,
	plodnostKastraceText?:string | null,
	remoteId?:string | null,
	stravitelnostNadpis?:string | null,
	stravitelnostProcenta?:string | null,
	stravitelnostSlovne?:string | null,
	stravitelnostChybiText?:string | null,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductEvaluationCreateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutEvaluationCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductEvaluationConnectOrCreateProductRelationInput"] | null
};
	["ProductWithoutEvaluationCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductEvaluationConnectOrCreateProductRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutEvaluationCreateInput"]
};
	["ProductEvaluationUpdateInput"]: {
	nazev?:string | null,
	vetDieta?:string | null,
	vetDieta1?:string | null,
	vetDieta2?:string | null,
	aktivita?:string | null,
	vek?:string | null,
	velikostPlemen?:string | null,
	hmotnostPlemene?:string | null,
	velikostGranuli?:string | null,
	velikostGranuliText?:string | null,
	doporucenaAktivitaDleMe?:string | null,
	vypocitanaMeVsMeVyrobce?:string | null,
	vypocitanaMeVsMeVyrobce2?:string | null,
	masoNaPrvnimMisteText?:string | null,
	zdrojeZivocisnychBilkovinDle1Vyskytu?:string | null,
	prichuteSeznam?:string | null,
	eliminacniDietaTextInterpunkce?:string | null,
	alergenyZadneNeobsahuje?:string | null,
	alergenyObsahuje?:string | null,
	alergenyNejakeNeobsahuje?:string | null,
	prospesneDruhyInterpunkce?:string | null,
	nevhodneDruhy?:string | null,
	kladneUcinkyCeleTelo?:string | null,
	kladneUcinkyHlava?:string | null,
	kladneUcinkyHrudnik?:string | null,
	kladneUcinkyBricho?:string | null,
	kladneUcinkySpodniCast?:string | null,
	zaporneUcinkyCeleTelo?:string | null,
	zaporneUcinkyHlava?:string | null,
	zaporneUcinkyHrudnik?:string | null,
	zaporneUcinkyBricho?:string | null,
	zaporneUcinkySpodniCast?:string | null,
	dsneuvedeno?:string | null,
	dsmalo?:string | null,
	dsprilis?:string | null,
	dsok?:string | null,
	d95malo?:string | null,
	d95prilis?:string | null,
	d95ok?:string | null,
	d110malo?:string | null,
	d110prilis?:string | null,
	d110ok?:string | null,
	sdo14reproMalo?:string | null,
	sdo14reproPrilis?:string | null,
	sdo14reproOk?:string | null,
	sdo15malo?:string | null,
	sdo15prilis?:string | null,
	sdo15ok?:string | null,
	s15malo?:string | null,
	s15prilis?:string | null,
	s15ok?:string | null,
	product?:ValueTypes["ProductEvaluationUpdateProductEntityRelationInput"] | null,
	masoAnoNe?:string | null,
	eliminacniDietaAnoNe?:string | null,
	alergenyAnoNe?:string | null,
	plodnostKastraceNadpis?:string | null,
	plodnostKastraceText?:string | null,
	remoteId?:string | null,
	stravitelnostNadpis?:string | null,
	stravitelnostProcenta?:string | null,
	stravitelnostSlovne?:string | null,
	stravitelnostChybiText?:string | null,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductEvaluationUpdateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutEvaluationCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductEvaluationConnectOrCreateProductRelationInput"] | null,
	update?:ValueTypes["ProductWithoutEvaluationUpdateInput"] | null,
	upsert?:ValueTypes["ProductEvaluationUpsertProductRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductWithoutEvaluationUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductEvaluationUpsertProductRelationInput"]: {
	update:ValueTypes["ProductWithoutEvaluationUpdateInput"],
	create:ValueTypes["ProductWithoutEvaluationCreateInput"]
};
	["AdCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["AdCreateImageEntityRelationInput"] | null,
	isBrandSectionVisible?:boolean | null,
	isBlogPostSectionVisible?:boolean | null,
	isIngredientSectionVisible?:boolean | null,
	isResultsVisible?:boolean | null,
	isSearchVisible?:boolean | null,
	blogPosts?:ValueTypes["AdCreateBlogPostsEntityRelationInput"][],
	itemCategories?:ValueTypes["AdCreateItemCategoriesEntityRelationInput"][],
	brands?:ValueTypes["AdCreateBrandsEntityRelationInput"][],
	isActive?:boolean | null,
	link?:string | null,
	note?:string | null,
	activeFrom?:ValueTypes["DateTime"] | null,
	activeUntil?:ValueTypes["DateTime"] | null,
	slug?:string | null,
	contentReferences?:ValueTypes["AdCreateContentReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AdUpdateInput"]: {
	image?:ValueTypes["AdUpdateImageEntityRelationInput"] | null,
	isBrandSectionVisible?:boolean | null,
	isBlogPostSectionVisible?:boolean | null,
	isIngredientSectionVisible?:boolean | null,
	isResultsVisible?:boolean | null,
	isSearchVisible?:boolean | null,
	blogPosts?:ValueTypes["AdUpdateBlogPostsEntityRelationInput"][],
	itemCategories?:ValueTypes["AdUpdateItemCategoriesEntityRelationInput"][],
	brands?:ValueTypes["AdUpdateBrandsEntityRelationInput"][],
	isActive?:boolean | null,
	link?:string | null,
	note?:string | null,
	activeFrom?:ValueTypes["DateTime"] | null,
	activeUntil?:ValueTypes["DateTime"] | null,
	slug?:string | null,
	contentReferences?:ValueTypes["AdUpdateContentReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EvaluationInfo"]: AliasType<{
	_meta?:ValueTypes["EvaluationInfoMeta"],
	id?:boolean,
veterinaryDietIcon?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	unique?:boolean,
veterinaryDiet?: [{	filter?:ValueTypes["ContentTextWhere"] | null},ValueTypes["ContentText"]],
disclaimer?: [{	filter?:ValueTypes["ContentTextWhere"] | null},ValueTypes["ContentText"]],
	veterinaryDietTitle?:boolean,
		__typename?: boolean
}>;
	["EvaluationInfoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	veterinaryDietIcon?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	veterinaryDiet?:ValueTypes["FieldMeta"],
	disclaimer?:ValueTypes["FieldMeta"],
	veterinaryDietTitle?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentText"]: AliasType<{
	_meta?:ValueTypes["ContentTextMeta"],
	id?:boolean,
blocks?: [{	filter?:ValueTypes["ContentTextBlockWhere"] | null,	orderBy?:ValueTypes["ContentTextBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentTextBlock"]],
paginateBlocks?: [{	filter?:ValueTypes["ContentTextBlockWhere"] | null,	orderBy?:ValueTypes["ContentTextBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentTextBlockConnection"]],
		__typename?: boolean
}>;
	["ContentTextMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	blocks?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentTextBlock"]: AliasType<{
	_meta?:ValueTypes["ContentTextBlockMeta"],
	id?:boolean,
	order?:boolean,
	json?:boolean,
content?: [{	filter?:ValueTypes["ContentTextWhere"] | null},ValueTypes["ContentText"]],
		__typename?: boolean
}>;
	["ContentTextBlockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	json?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentTextWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	blocks?:ValueTypes["ContentTextBlockWhere"] | null,
	and?:(ValueTypes["ContentTextWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentTextWhere"] | undefined | null)[],
	not?:ValueTypes["ContentTextWhere"] | null
};
	["ContentTextBlockWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	json?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentTextWhere"] | null,
	and?:(ValueTypes["ContentTextBlockWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentTextBlockWhere"] | undefined | null)[],
	not?:ValueTypes["ContentTextBlockWhere"] | null
};
	["ContentTextBlockOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	json?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentTextOrderBy"] | null
};
	["ContentTextOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["ContentTextBlockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentTextBlockEdge"],
		__typename?: boolean
}>;
	["ContentTextBlockEdge"]: AliasType<{
	node?:ValueTypes["ContentTextBlock"],
		__typename?: boolean
}>;
	["EvaluationInfoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	veterinaryDietIcon?:ValueTypes["ImageUniqueWhere"] | null
};
	["EvaluationInfoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	veterinaryDietIcon?:ValueTypes["ImageWhere"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	veterinaryDiet?:ValueTypes["ContentTextWhere"] | null,
	disclaimer?:ValueTypes["ContentTextWhere"] | null,
	veterinaryDietTitle?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["EvaluationInfoWhere"] | undefined | null)[],
	or?:(ValueTypes["EvaluationInfoWhere"] | undefined | null)[],
	not?:ValueTypes["EvaluationInfoWhere"] | null
};
	["EvaluationInfoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	veterinaryDietIcon?:ValueTypes["ImageOrderBy"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	veterinaryDiet?:ValueTypes["ContentTextOrderBy"] | null,
	disclaimer?:ValueTypes["ContentTextOrderBy"] | null,
	veterinaryDietTitle?:ValueTypes["OrderDirection"] | null
};
	["EvaluationInfoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EvaluationInfoEdge"],
		__typename?: boolean
}>;
	["EvaluationInfoEdge"]: AliasType<{
	node?:ValueTypes["EvaluationInfo"],
		__typename?: boolean
}>;
	["EvaluationInfoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	veterinaryDietIcon?:ValueTypes["EvaluationInfoCreateVeterinaryDietIconEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	veterinaryDiet?:ValueTypes["EvaluationInfoCreateVeterinaryDietEntityRelationInput"] | null,
	disclaimer?:ValueTypes["EvaluationInfoCreateDisclaimerEntityRelationInput"] | null,
	veterinaryDietTitle?:string | null,
	_dummy_field_?:boolean | null
};
	["EvaluationInfoCreateVeterinaryDietIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["EvaluationInfoConnectOrCreateVeterinaryDietIconRelationInput"] | null
};
	["EvaluationInfoConnectOrCreateVeterinaryDietIconRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["EvaluationInfoCreateVeterinaryDietEntityRelationInput"]: {
	connect?:ValueTypes["ContentTextUniqueWhere"] | null,
	create?:ValueTypes["ContentTextCreateInput"] | null,
	connectOrCreate?:ValueTypes["EvaluationInfoConnectOrCreateVeterinaryDietRelationInput"] | null
};
	["ContentTextUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentTextBlockUniqueWhere"] | null
};
	["ContentTextBlockUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ContentTextCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentTextCreateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentTextCreateBlocksEntityRelationInput"]: {
	connect?:ValueTypes["ContentTextBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentTextBlockWithoutContentCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentTextConnectOrCreateBlocksRelationInput"] | null,
	alias?:string | null
};
	["ContentTextBlockWithoutContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentTextConnectOrCreateBlocksRelationInput"]: {
	connect:ValueTypes["ContentTextBlockUniqueWhere"],
	create:ValueTypes["ContentTextBlockWithoutContentCreateInput"]
};
	["EvaluationInfoConnectOrCreateVeterinaryDietRelationInput"]: {
	connect:ValueTypes["ContentTextUniqueWhere"],
	create:ValueTypes["ContentTextCreateInput"]
};
	["EvaluationInfoCreateDisclaimerEntityRelationInput"]: {
	connect?:ValueTypes["ContentTextUniqueWhere"] | null,
	create?:ValueTypes["ContentTextCreateInput"] | null,
	connectOrCreate?:ValueTypes["EvaluationInfoConnectOrCreateDisclaimerRelationInput"] | null
};
	["EvaluationInfoConnectOrCreateDisclaimerRelationInput"]: {
	connect:ValueTypes["ContentTextUniqueWhere"],
	create:ValueTypes["ContentTextCreateInput"]
};
	["EvaluationInfoUpdateInput"]: {
	veterinaryDietIcon?:ValueTypes["EvaluationInfoUpdateVeterinaryDietIconEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	veterinaryDiet?:ValueTypes["EvaluationInfoUpdateVeterinaryDietEntityRelationInput"] | null,
	disclaimer?:ValueTypes["EvaluationInfoUpdateDisclaimerEntityRelationInput"] | null,
	veterinaryDietTitle?:string | null,
	_dummy_field_?:boolean | null
};
	["EvaluationInfoUpdateVeterinaryDietIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["EvaluationInfoConnectOrCreateVeterinaryDietIconRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["EvaluationInfoUpsertVeterinaryDietIconRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EvaluationInfoUpsertVeterinaryDietIconRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["EvaluationInfoUpdateVeterinaryDietEntityRelationInput"]: {
	connect?:ValueTypes["ContentTextUniqueWhere"] | null,
	create?:ValueTypes["ContentTextCreateInput"] | null,
	connectOrCreate?:ValueTypes["EvaluationInfoConnectOrCreateVeterinaryDietRelationInput"] | null,
	update?:ValueTypes["ContentTextUpdateInput"] | null,
	upsert?:ValueTypes["EvaluationInfoUpsertVeterinaryDietRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentTextUpdateInput"]: {
	blocks?:ValueTypes["ContentTextUpdateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentTextUpdateBlocksEntityRelationInput"]: {
	create?:ValueTypes["ContentTextBlockWithoutContentCreateInput"] | null,
	update?:ValueTypes["ContentTextUpdateBlocksRelationInput"] | null,
	upsert?:ValueTypes["ContentTextUpsertBlocksRelationInput"] | null,
	connect?:ValueTypes["ContentTextBlockUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentTextBlockUniqueWhere"] | null,
	delete?:ValueTypes["ContentTextBlockUniqueWhere"] | null,
	alias?:string | null
};
	["ContentTextUpdateBlocksRelationInput"]: {
	by:ValueTypes["ContentTextBlockUniqueWhere"],
	data:ValueTypes["ContentTextBlockWithoutContentUpdateInput"]
};
	["ContentTextBlockWithoutContentUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentTextUpsertBlocksRelationInput"]: {
	by:ValueTypes["ContentTextBlockUniqueWhere"],
	update:ValueTypes["ContentTextBlockWithoutContentUpdateInput"],
	create:ValueTypes["ContentTextBlockWithoutContentCreateInput"]
};
	["EvaluationInfoUpsertVeterinaryDietRelationInput"]: {
	update:ValueTypes["ContentTextUpdateInput"],
	create:ValueTypes["ContentTextCreateInput"]
};
	["EvaluationInfoUpdateDisclaimerEntityRelationInput"]: {
	connect?:ValueTypes["ContentTextUniqueWhere"] | null,
	create?:ValueTypes["ContentTextCreateInput"] | null,
	connectOrCreate?:ValueTypes["EvaluationInfoConnectOrCreateDisclaimerRelationInput"] | null,
	update?:ValueTypes["ContentTextUpdateInput"] | null,
	upsert?:ValueTypes["EvaluationInfoUpsertDisclaimerRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EvaluationInfoUpsertDisclaimerRelationInput"]: {
	update:ValueTypes["ContentTextUpdateInput"],
	create:ValueTypes["ContentTextCreateInput"]
};
	["ConsumptionMessage"]: AliasType<{
	_meta?:ValueTypes["ConsumptionMessageMeta"],
	id?:boolean,
	remoteId?:boolean,
	finalWording?:boolean,
	isHighlighted?:boolean,
	numberOfDays?:boolean,
		__typename?: boolean
}>;
	["ConsumptionMessageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	finalWording?:ValueTypes["FieldMeta"],
	isHighlighted?:ValueTypes["FieldMeta"],
	numberOfDays?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ConsumptionMessageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["ConsumptionMessageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	finalWording?:ValueTypes["StringCondition"] | null,
	isHighlighted?:ValueTypes["BooleanCondition"] | null,
	numberOfDays?:ValueTypes["IntCondition"] | null,
	and?:(ValueTypes["ConsumptionMessageWhere"] | undefined | null)[],
	or?:(ValueTypes["ConsumptionMessageWhere"] | undefined | null)[],
	not?:ValueTypes["ConsumptionMessageWhere"] | null
};
	["ConsumptionMessageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	finalWording?:ValueTypes["OrderDirection"] | null,
	isHighlighted?:ValueTypes["OrderDirection"] | null,
	numberOfDays?:ValueTypes["OrderDirection"] | null
};
	["ConsumptionMessageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ConsumptionMessageEdge"],
		__typename?: boolean
}>;
	["ConsumptionMessageEdge"]: AliasType<{
	node?:ValueTypes["ConsumptionMessage"],
		__typename?: boolean
}>;
	["ConsumptionMessageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	finalWording?:string | null,
	isHighlighted?:boolean | null,
	numberOfDays?:number | null,
	_dummy_field_?:boolean | null
};
	["ConsumptionMessageUpdateInput"]: {
	remoteId?:string | null,
	finalWording?:string | null,
	isHighlighted?:boolean | null,
	numberOfDays?:number | null,
	_dummy_field_?:boolean | null
};
	["ContentTextConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentTextEdge"],
		__typename?: boolean
}>;
	["ContentTextEdge"]: AliasType<{
	node?:ValueTypes["ContentText"],
		__typename?: boolean
}>;
	["ContentTextBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentTextBlockCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentTextBlockCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentTextUniqueWhere"] | null,
	create?:ValueTypes["ContentTextWithoutBlocksCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentTextBlockConnectOrCreateContentRelationInput"] | null
};
	["ContentTextWithoutBlocksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ContentTextBlockConnectOrCreateContentRelationInput"]: {
	connect:ValueTypes["ContentTextUniqueWhere"],
	create:ValueTypes["ContentTextWithoutBlocksCreateInput"]
};
	["ContentTextBlockUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentTextBlockUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentTextBlockUpdateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentTextUniqueWhere"] | null,
	create?:ValueTypes["ContentTextWithoutBlocksCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentTextBlockConnectOrCreateContentRelationInput"] | null,
	update?:ValueTypes["ContentTextWithoutBlocksUpdateInput"] | null,
	upsert?:ValueTypes["ContentTextBlockUpsertContentRelationInput"] | null,
	delete?:boolean | null
};
	["ContentTextWithoutBlocksUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ContentTextBlockUpsertContentRelationInput"]: {
	update:ValueTypes["ContentTextWithoutBlocksUpdateInput"],
	create:ValueTypes["ContentTextWithoutBlocksCreateInput"]
};
	["ProductReviewStatsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductReviewStatsEdge"],
		__typename?: boolean
}>;
	["ProductReviewStatsEdge"]: AliasType<{
	node?:ValueTypes["ProductReviewStats"],
		__typename?: boolean
}>;
	["BlogPostReviewStatsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BlogPostReviewStatsEdge"],
		__typename?: boolean
}>;
	["BlogPostReviewStatsEdge"]: AliasType<{
	node?:ValueTypes["BlogPostReviewStats"],
		__typename?: boolean
}>;
	["ComparatorPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ComparatorPageEdge"],
		__typename?: boolean
}>;
	["ComparatorPageEdge"]: AliasType<{
	node?:ValueTypes["ComparatorPage"],
		__typename?: boolean
}>;
	["ComparatorPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["ComparatorPageCreateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["ComparatorPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ComparatorPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["ComparatorPageUpdateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["ComparatorPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LoginPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LoginPageEdge"],
		__typename?: boolean
}>;
	["LoginPageEdge"]: AliasType<{
	node?:ValueTypes["LoginPage"],
		__typename?: boolean
}>;
	["LoginPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["LoginPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LoginPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutLoginPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["LoginPageConnectOrCreateSeoRelationInput"] | null
};
	["SeoWithoutLoginPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoCreateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoCreateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoCreateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoCreateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoCreateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoCreateIngredientsPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoCreateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoCreateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoCreateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoCreateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["LoginPageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoWithoutLoginPageCreateInput"]
};
	["LoginPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["LoginPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LoginPageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutLoginPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["LoginPageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoWithoutLoginPageUpdateInput"] | null,
	upsert?:ValueTypes["LoginPageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoWithoutLoginPageUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoUpdateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoUpdateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoUpdateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoUpdateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoUpdateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoUpdateIngredientsPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoUpdateRegisterPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoUpdateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoUpdateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoUpdateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["LoginPageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoWithoutLoginPageUpdateInput"],
	create:ValueTypes["SeoWithoutLoginPageCreateInput"]
};
	["RegisterPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RegisterPageEdge"],
		__typename?: boolean
}>;
	["RegisterPageEdge"]: AliasType<{
	node?:ValueTypes["RegisterPage"],
		__typename?: boolean
}>;
	["RegisterPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["RegisterPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RegisterPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutRegisterPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["RegisterPageConnectOrCreateSeoRelationInput"] | null
};
	["SeoWithoutRegisterPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoCreateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoCreateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoCreateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoCreateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoCreateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoCreateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoCreateLoginPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoCreateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoCreateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoCreateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["RegisterPageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoWithoutRegisterPageCreateInput"]
};
	["RegisterPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["RegisterPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RegisterPageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutRegisterPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["RegisterPageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoWithoutRegisterPageUpdateInput"] | null,
	upsert?:ValueTypes["RegisterPageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoWithoutRegisterPageUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoUpdateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoUpdateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoUpdateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoUpdateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoUpdateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoUpdateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoUpdateLoginPageEntityRelationInput"] | null,
	searchPage?:ValueTypes["SeoUpdateSearchPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoUpdateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoUpdateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["RegisterPageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoWithoutRegisterPageUpdateInput"],
	create:ValueTypes["SeoWithoutRegisterPageCreateInput"]
};
	["ResultsPage"]: AliasType<{
	_meta?:ValueTypes["ResultsPageMeta"],
	id?:boolean,
	unique?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: boolean
}>;
	["ResultsPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ResultsPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ResultsPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["ResultsPageWhere"] | undefined | null)[],
	or?:(ValueTypes["ResultsPageWhere"] | undefined | null)[],
	not?:ValueTypes["ResultsPageWhere"] | null
};
	["ResultsPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["ResultsPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ResultsPageEdge"],
		__typename?: boolean
}>;
	["ResultsPageEdge"]: AliasType<{
	node?:ValueTypes["ResultsPage"],
		__typename?: boolean
}>;
	["ResultsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["ResultsPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ResultsPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ResultsPageConnectOrCreateSeoRelationInput"] | null
};
	["ResultsPageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoCreateInput"]
};
	["ResultsPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["ResultsPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ResultsPageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["ResultsPageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ResultsPageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ResultsPageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoUpdateInput"],
	create:ValueTypes["SeoCreateInput"]
};
	["SearchPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SearchPageEdge"],
		__typename?: boolean
}>;
	["SearchPageEdge"]: AliasType<{
	node?:ValueTypes["SearchPage"],
		__typename?: boolean
}>;
	["SearchPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SearchPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SearchPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutSearchPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["SearchPageConnectOrCreateSeoRelationInput"] | null
};
	["SeoWithoutSearchPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoCreateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoCreateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoCreateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoCreateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoCreateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoCreateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoCreateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoCreateRegisterPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoCreateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoCreateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SearchPageConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoWithoutSearchPageCreateInput"]
};
	["SearchPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SearchPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SearchPageUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutSearchPageCreateInput"] | null,
	connectOrCreate?:ValueTypes["SearchPageConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoWithoutSearchPageUpdateInput"] | null,
	upsert?:ValueTypes["SearchPageUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoWithoutSearchPageUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	blogPage?:ValueTypes["SeoUpdateBlogPageEntityRelationInput"] | null,
	brandsPage?:ValueTypes["SeoUpdateBrandsPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["SeoUpdateComparatorPageEntityRelationInput"] | null,
	genericPage?:ValueTypes["SeoUpdateGenericPageEntityRelationInput"] | null,
	homePage?:ValueTypes["SeoUpdateHomePageEntityRelationInput"] | null,
	ingredientsPage?:ValueTypes["SeoUpdateIngredientsPageEntityRelationInput"] | null,
	loginPage?:ValueTypes["SeoUpdateLoginPageEntityRelationInput"] | null,
	registerPage?:ValueTypes["SeoUpdateRegisterPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["SeoUpdateWizardPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["SeoUpdateContactPageEntityRelationInput"] | null,
	group?:ValueTypes["GroupType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SearchPageUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoWithoutSearchPageUpdateInput"],
	create:ValueTypes["SeoWithoutSearchPageCreateInput"]
};
	["WizardPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["WizardPageEdge"],
		__typename?: boolean
}>;
	["WizardPageEdge"]: AliasType<{
	node?:ValueTypes["WizardPage"],
		__typename?: boolean
}>;
	["WizardPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["WizardPageCreateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["WizardPageCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["WizardPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	redirects?:ValueTypes["WizardPageUpdateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["WizardPageUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BreastfeedingCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BreastfeedingCategoryEdge"],
		__typename?: boolean
}>;
	["BreastfeedingCategoryEdge"]: AliasType<{
	node?:ValueTypes["BreastfeedingCategory"],
		__typename?: boolean
}>;
	["BreastfeedingCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	week?:number | null,
	coeficient?:number | null,
	dogs?:ValueTypes["BreastfeedingCategoryCreateDogsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreastfeedingCategoryCreateDogsEntityRelationInput"]: {
	connect?:ValueTypes["DogReproductionUniqueWhere"] | null,
	create?:ValueTypes["DogReproductionWithoutBreastfeedingCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["BreastfeedingCategoryConnectOrCreateDogsRelationInput"] | null,
	alias?:string | null
};
	["DogReproductionWithoutBreastfeedingCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["DogReproductionType"] | null,
	breastfeedingPuppyCount?:number | null,
	pregnancy?:ValueTypes["PregnantPeriodType"] | null,
	dog?:ValueTypes["DogReproductionCreateDogEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogReproductionCreateDogEntityRelationInput"]: {
	connect?:ValueTypes["DogUniqueWhere"] | null,
	create?:ValueTypes["DogWithoutReproductionCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogReproductionConnectOrCreateDogRelationInput"] | null
};
	["DogWithoutReproductionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogCreateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogCreateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogCreateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogCreateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogCreateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogCreateFedProductEntityRelationInput"] | null,
	allergies?:ValueTypes["DogCreateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogCreateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogCreateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogReproductionConnectOrCreateDogRelationInput"]: {
	connect:ValueTypes["DogUniqueWhere"],
	create:ValueTypes["DogWithoutReproductionCreateInput"]
};
	["BreastfeedingCategoryConnectOrCreateDogsRelationInput"]: {
	connect:ValueTypes["DogReproductionUniqueWhere"],
	create:ValueTypes["DogReproductionWithoutBreastfeedingCategoryCreateInput"]
};
	["BreastfeedingCategoryUpdateInput"]: {
	week?:number | null,
	coeficient?:number | null,
	dogs?:ValueTypes["BreastfeedingCategoryUpdateDogsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BreastfeedingCategoryUpdateDogsEntityRelationInput"]: {
	create?:ValueTypes["DogReproductionWithoutBreastfeedingCategoryCreateInput"] | null,
	update?:ValueTypes["BreastfeedingCategoryUpdateDogsRelationInput"] | null,
	upsert?:ValueTypes["BreastfeedingCategoryUpsertDogsRelationInput"] | null,
	connect?:ValueTypes["DogReproductionUniqueWhere"] | null,
	disconnect?:ValueTypes["DogReproductionUniqueWhere"] | null,
	delete?:ValueTypes["DogReproductionUniqueWhere"] | null,
	alias?:string | null
};
	["BreastfeedingCategoryUpdateDogsRelationInput"]: {
	by:ValueTypes["DogReproductionUniqueWhere"],
	data:ValueTypes["DogReproductionWithoutBreastfeedingCategoryUpdateInput"]
};
	["DogReproductionWithoutBreastfeedingCategoryUpdateInput"]: {
	type?:ValueTypes["DogReproductionType"] | null,
	breastfeedingPuppyCount?:number | null,
	pregnancy?:ValueTypes["PregnantPeriodType"] | null,
	dog?:ValueTypes["DogReproductionUpdateDogEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogReproductionUpdateDogEntityRelationInput"]: {
	connect?:ValueTypes["DogUniqueWhere"] | null,
	create?:ValueTypes["DogWithoutReproductionCreateInput"] | null,
	connectOrCreate?:ValueTypes["DogReproductionConnectOrCreateDogRelationInput"] | null,
	update?:ValueTypes["DogWithoutReproductionUpdateInput"] | null,
	upsert?:ValueTypes["DogReproductionUpsertDogRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DogWithoutReproductionUpdateInput"]: {
	gender?:ValueTypes["GenderType"] | null,
	weight?:number | null,
	customIdealWeight?:number | null,
	breed?:ValueTypes["DogUpdateBreedEntityRelationInput"] | null,
	age?:ValueTypes["DogUpdateAgeEntityRelationInput"] | null,
	bodyType?:ValueTypes["DogUpdateBodyTypeEntityRelationInput"] | null,
	owner?:ValueTypes["DogUpdateOwnerEntityRelationInput"] | null,
	activity?:ValueTypes["DogUpdateActivityEntityRelationInput"] | null,
	fedProduct?:ValueTypes["DogUpdateFedProductEntityRelationInput"] | null,
	allergies?:ValueTypes["DogUpdateAllergiesEntityRelationInput"][],
	illnesses?:ValueTypes["DogUpdateIllnessesEntityRelationInput"][],
	name?:string | null,
	avatar?:ValueTypes["DogUpdateAvatarEntityRelationInput"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["DogReproductionUpsertDogRelationInput"]: {
	update:ValueTypes["DogWithoutReproductionUpdateInput"],
	create:ValueTypes["DogWithoutReproductionCreateInput"]
};
	["BreastfeedingCategoryUpsertDogsRelationInput"]: {
	by:ValueTypes["DogReproductionUniqueWhere"],
	update:ValueTypes["DogReproductionWithoutBreastfeedingCategoryUpdateInput"],
	create:ValueTypes["DogReproductionWithoutBreastfeedingCategoryCreateInput"]
};
	["DogReproductionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["DogReproductionType"] | null,
	breastfeedingPuppyCount?:number | null,
	pregnancy?:ValueTypes["PregnantPeriodType"] | null,
	dog?:ValueTypes["DogReproductionCreateDogEntityRelationInput"] | null,
	breastfeedingCategory?:ValueTypes["DogReproductionCreateBreastfeedingCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DogReproductionUpdateInput"]: {
	type?:ValueTypes["DogReproductionType"] | null,
	breastfeedingPuppyCount?:number | null,
	pregnancy?:ValueTypes["PregnantPeriodType"] | null,
	dog?:ValueTypes["DogReproductionUpdateDogEntityRelationInput"] | null,
	breastfeedingCategory?:ValueTypes["DogReproductionUpdateBreastfeedingCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactFormMessageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	message?:string | null,
	email?:string | null,
	receivedAt?:ValueTypes["DateTime"] | null,
	user?:ValueTypes["ContactFormMessageCreateUserEntityRelationInput"] | null,
	isResolved?:boolean | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactFormMessageCreateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutContactFormMessagesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContactFormMessageConnectOrCreateUserRelationInput"] | null
};
	["UserWithoutContactFormMessagesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["UserCreateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserCreateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserCreateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserCreateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserCreateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserCreateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserCreateAvatarEntityRelationInput"] | null,
	bugReports?:ValueTypes["UserCreateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserCreateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserCreateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactFormMessageConnectOrCreateUserRelationInput"]: {
	connect:ValueTypes["UserUniqueWhere"],
	create:ValueTypes["UserWithoutContactFormMessagesCreateInput"]
};
	["ContactFormMessageUpdateInput"]: {
	message?:string | null,
	email?:string | null,
	receivedAt?:ValueTypes["DateTime"] | null,
	user?:ValueTypes["ContactFormMessageUpdateUserEntityRelationInput"] | null,
	isResolved?:boolean | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactFormMessageUpdateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutContactFormMessagesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContactFormMessageConnectOrCreateUserRelationInput"] | null,
	update?:ValueTypes["UserWithoutContactFormMessagesUpdateInput"] | null,
	upsert?:ValueTypes["ContactFormMessageUpsertUserRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UserWithoutContactFormMessagesUpdateInput"]: {
	dogs?:ValueTypes["UserUpdateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserUpdateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserUpdateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserUpdateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserUpdateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserUpdateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserUpdateAvatarEntityRelationInput"] | null,
	bugReports?:ValueTypes["UserUpdateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserUpdateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserUpdateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactFormMessageUpsertUserRelationInput"]: {
	update:ValueTypes["UserWithoutContactFormMessagesUpdateInput"],
	create:ValueTypes["UserWithoutContactFormMessagesCreateInput"]
};
	["ContactPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContactPageEdge"],
		__typename?: boolean
}>;
	["ContactPageEdge"]: AliasType<{
	node?:ValueTypes["ContactPage"],
		__typename?: boolean
}>;
	["ContactPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	redirects?:ValueTypes["ContactPageCreateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["ContactPageCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["ContactPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ContactPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	redirects?:ValueTypes["ContactPageUpdateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["ContactPageUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["ContactPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ContactPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BugReportCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	message?:string | null,
	receivedAt?:ValueTypes["DateTime"] | null,
	isResolved?:boolean | null,
	user?:ValueTypes["BugReportCreateUserEntityRelationInput"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["BugReportCreateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutBugReportsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BugReportConnectOrCreateUserRelationInput"] | null
};
	["UserWithoutBugReportsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["UserCreateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserCreateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserCreateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserCreateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserCreateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserCreateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserCreateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserCreateContactFormMessagesEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserCreateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserCreateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["BugReportConnectOrCreateUserRelationInput"]: {
	connect:ValueTypes["UserUniqueWhere"],
	create:ValueTypes["UserWithoutBugReportsCreateInput"]
};
	["BugReportUpdateInput"]: {
	message?:string | null,
	receivedAt?:ValueTypes["DateTime"] | null,
	isResolved?:boolean | null,
	user?:ValueTypes["BugReportUpdateUserEntityRelationInput"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["BugReportUpdateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutBugReportsCreateInput"] | null,
	connectOrCreate?:ValueTypes["BugReportConnectOrCreateUserRelationInput"] | null,
	update?:ValueTypes["UserWithoutBugReportsUpdateInput"] | null,
	upsert?:ValueTypes["BugReportUpsertUserRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UserWithoutBugReportsUpdateInput"]: {
	dogs?:ValueTypes["UserUpdateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserUpdateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserUpdateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserUpdateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserUpdateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserUpdateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserUpdateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserUpdateContactFormMessagesEntityRelationInput"][],
	verifiedEmail?:string | null,
	protectedActions?:ValueTypes["UserUpdateProtectedActionsEntityRelationInput"][],
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserUpdateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["BugReportUpsertUserRelationInput"]: {
	update:ValueTypes["UserWithoutBugReportsUpdateInput"],
	create:ValueTypes["UserWithoutBugReportsCreateInput"]
};
	["ColorConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ColorEdge"],
		__typename?: boolean
}>;
	["ColorEdge"]: AliasType<{
	node?:ValueTypes["Color"],
		__typename?: boolean
}>;
	["ColorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	colorHex?:string | null,
	bodyTagCategory?:ValueTypes["ColorCreateBodyTagCategoryEntityRelationInput"] | null,
	blogPostTag?:ValueTypes["ColorCreateBlogPostTagEntityRelationInput"] | null,
	remoteId?:string | null,
	itemFlavorCategories?:ValueTypes["ColorCreateItemFlavorCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ColorUpdateInput"]: {
	name?:string | null,
	colorHex?:string | null,
	bodyTagCategory?:ValueTypes["ColorUpdateBodyTagCategoryEntityRelationInput"] | null,
	blogPostTag?:ValueTypes["ColorUpdateBlogPostTagEntityRelationInput"] | null,
	remoteId?:string | null,
	itemFlavorCategories?:ValueTypes["ColorUpdateItemFlavorCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ItemGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ItemGroupEdge"],
		__typename?: boolean
}>;
	["ItemGroupEdge"]: AliasType<{
	node?:ValueTypes["ItemGroup"],
		__typename?: boolean
}>;
	["ItemGroupCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	name?:string | null,
	categories?:ValueTypes["ItemGroupCreateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ItemGroupCreateCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	create?:ValueTypes["ItemCategoryWithoutGroupCreateInput"] | null,
	connectOrCreate?:ValueTypes["ItemGroupConnectOrCreateCategoriesRelationInput"] | null,
	alias?:string | null
};
	["ItemCategoryWithoutGroupCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryCreateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryCreateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryCreateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryCreateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryCreateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryCreateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryCreateSeoEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemGroupConnectOrCreateCategoriesRelationInput"]: {
	connect:ValueTypes["ItemCategoryUniqueWhere"],
	create:ValueTypes["ItemCategoryWithoutGroupCreateInput"]
};
	["ItemGroupUpdateInput"]: {
	remoteId?:string | null,
	name?:string | null,
	categories?:ValueTypes["ItemGroupUpdateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ItemGroupUpdateCategoriesEntityRelationInput"]: {
	create?:ValueTypes["ItemCategoryWithoutGroupCreateInput"] | null,
	update?:ValueTypes["ItemGroupUpdateCategoriesRelationInput"] | null,
	upsert?:ValueTypes["ItemGroupUpsertCategoriesRelationInput"] | null,
	connect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ItemCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ItemGroupUpdateCategoriesRelationInput"]: {
	by:ValueTypes["ItemCategoryUniqueWhere"],
	data:ValueTypes["ItemCategoryWithoutGroupUpdateInput"]
};
	["ItemCategoryWithoutGroupUpdateInput"]: {
	name?:string | null,
	shortDescription?:string | null,
	subCategories?:ValueTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"][],
	blogPosts?:ValueTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"][],
	items?:ValueTypes["ItemCategoryUpdateItemsEntityRelationInput"][],
	products?:ValueTypes["ItemCategoryUpdateProductsEntityRelationInput"][],
	featureDependencies?:ValueTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"][],
	declensionSixth?:string | null,
	remoteId?:string | null,
	image?:ValueTypes["ItemCategoryUpdateImageEntityRelationInput"] | null,
	comparatorGroupId?:string | null,
	ads?:ValueTypes["ItemCategoryUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	redirects?:ValueTypes["ItemCategoryUpdateRedirectsEntityRelationInput"][],
	declensionsFourth?:ValueTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"][],
	seo?:ValueTypes["ItemCategoryUpdateSeoEntityRelationInput"] | null,
	declensionSeventh?:string | null,
	slugWith?:string | null,
	slugWithNegative?:string | null,
	declensionSeventhNegative?:string | null,
	content?:ValueTypes["ItemCategoryUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["ItemCategoryUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ItemGroupUpsertCategoriesRelationInput"]: {
	by:ValueTypes["ItemCategoryUniqueWhere"],
	update:ValueTypes["ItemCategoryWithoutGroupUpdateInput"],
	create:ValueTypes["ItemCategoryWithoutGroupCreateInput"]
};
	["SearchResult"]: AliasType<{
	_meta?:ValueTypes["SearchResultMeta"],
	id?:boolean,
brand?: [{	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
	brandName?:boolean,
productLine?: [{	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLine"]],
	productLineName?:boolean,
product?: [{	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
	productName?:boolean,
	searchable?:boolean,
		__typename?: boolean
}>;
	["SearchResultMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	brand?:ValueTypes["FieldMeta"],
	brandName?:ValueTypes["FieldMeta"],
	productLine?:ValueTypes["FieldMeta"],
	productLineName?:ValueTypes["FieldMeta"],
	product?:ValueTypes["FieldMeta"],
	productName?:ValueTypes["FieldMeta"],
	searchable?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SearchResultUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SearchResultWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	brand?:ValueTypes["BrandWhere"] | null,
	brandName?:ValueTypes["StringCondition"] | null,
	productLine?:ValueTypes["ProductLineWhere"] | null,
	productLineName?:ValueTypes["StringCondition"] | null,
	product?:ValueTypes["ProductWhere"] | null,
	productName?:ValueTypes["StringCondition"] | null,
	searchable?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["SearchResultWhere"] | undefined | null)[],
	or?:(ValueTypes["SearchResultWhere"] | undefined | null)[],
	not?:ValueTypes["SearchResultWhere"] | null
};
	["SearchResultOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	brand?:ValueTypes["BrandOrderBy"] | null,
	brandName?:ValueTypes["OrderDirection"] | null,
	productLine?:ValueTypes["ProductLineOrderBy"] | null,
	productLineName?:ValueTypes["OrderDirection"] | null,
	product?:ValueTypes["ProductOrderBy"] | null,
	productName?:ValueTypes["OrderDirection"] | null,
	searchable?:ValueTypes["OrderDirection"] | null
};
	["SearchResultConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SearchResultEdge"],
		__typename?: boolean
}>;
	["SearchResultEdge"]: AliasType<{
	node?:ValueTypes["SearchResult"],
		__typename?: boolean
}>;
	["ProductEvaluationSummary"]: AliasType<{
	_meta?:ValueTypes["ProductEvaluationSummaryMeta"],
	id?:boolean,
	remoteId?:boolean,
	title?:boolean,
icon?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: boolean
}>;
	["ProductEvaluationSummaryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductEvaluationSummaryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null
};
	["ProductEvaluationSummaryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	icon?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["ProductEvaluationSummaryWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductEvaluationSummaryWhere"] | undefined | null)[],
	not?:ValueTypes["ProductEvaluationSummaryWhere"] | null
};
	["ProductEvaluationSummaryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	icon?:ValueTypes["ImageOrderBy"] | null
};
	["ProductEvaluationSummaryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductEvaluationSummaryEdge"],
		__typename?: boolean
}>;
	["ProductEvaluationSummaryEdge"]: AliasType<{
	node?:ValueTypes["ProductEvaluationSummary"],
		__typename?: boolean
}>;
	["ProductEvaluationSummaryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	title?:string | null,
	icon?:ValueTypes["ProductEvaluationSummaryCreateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductEvaluationSummaryCreateIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductEvaluationSummaryConnectOrCreateIconRelationInput"] | null
};
	["ProductEvaluationSummaryConnectOrCreateIconRelationInput"]: {
	connect:ValueTypes["ImageUniqueWhere"],
	create:ValueTypes["ImageCreateInput"]
};
	["ProductEvaluationSummaryUpdateInput"]: {
	remoteId?:string | null,
	title?:string | null,
	icon?:ValueTypes["ProductEvaluationSummaryUpdateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductEvaluationSummaryUpdateIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductEvaluationSummaryConnectOrCreateIconRelationInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ProductEvaluationSummaryUpsertIconRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductEvaluationSummaryUpsertIconRelationInput"]: {
	update:ValueTypes["ImageUpdateInput"],
	create:ValueTypes["ImageCreateInput"]
};
	["ProtectedActionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ProtectedActionType"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	usedAt?:ValueTypes["DateTime"] | null,
	expiresAt?:ValueTypes["DateTime"] | null,
	publicKey?:string | null,
	secretHash?:string | null,
	verifyEmail?:string | null,
	createdMetadata?:ValueTypes["Json"] | null,
	usedMetadata?:ValueTypes["Json"] | null,
	user?:ValueTypes["ProtectedActionCreateUserEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProtectedActionCreateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutProtectedActionsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProtectedActionConnectOrCreateUserRelationInput"] | null
};
	["UserWithoutProtectedActionsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dogs?:ValueTypes["UserCreateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserCreateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserCreateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserCreateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserCreateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserCreateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserCreateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserCreateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserCreateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserCreateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["ProtectedActionConnectOrCreateUserRelationInput"]: {
	connect:ValueTypes["UserUniqueWhere"],
	create:ValueTypes["UserWithoutProtectedActionsCreateInput"]
};
	["ProtectedActionUpdateInput"]: {
	type?:ValueTypes["ProtectedActionType"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	usedAt?:ValueTypes["DateTime"] | null,
	expiresAt?:ValueTypes["DateTime"] | null,
	publicKey?:string | null,
	secretHash?:string | null,
	verifyEmail?:string | null,
	createdMetadata?:ValueTypes["Json"] | null,
	usedMetadata?:ValueTypes["Json"] | null,
	user?:ValueTypes["ProtectedActionUpdateUserEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProtectedActionUpdateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutProtectedActionsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProtectedActionConnectOrCreateUserRelationInput"] | null,
	update?:ValueTypes["UserWithoutProtectedActionsUpdateInput"] | null,
	upsert?:ValueTypes["ProtectedActionUpsertUserRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UserWithoutProtectedActionsUpdateInput"]: {
	dogs?:ValueTypes["UserUpdateDogsEntityRelationInput"][],
	veterinary?:ValueTypes["UserUpdateVeterinaryEntityRelationInput"] | null,
	email?:string | null,
	blogPostReviews?:ValueTypes["UserUpdateBlogPostReviewsEntityRelationInput"][],
	productReviews?:ValueTypes["UserUpdateProductReviewsEntityRelationInput"][],
	blogPostReviewReactions?:ValueTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"][],
	productReviewReactions?:ValueTypes["UserUpdateProductReviewReactionsEntityRelationInput"][],
	tenantPersonId?:ValueTypes["UUID"] | null,
	fullName?:string | null,
	blogPosts?:ValueTypes["UserUpdateBlogPostsEntityRelationInput"][],
	createdAt?:ValueTypes["DateTime"] | null,
	verifiedAt?:ValueTypes["DateTime"] | null,
	avatar?:ValueTypes["UserUpdateAvatarEntityRelationInput"] | null,
	contactFormMessages?:ValueTypes["UserUpdateContactFormMessagesEntityRelationInput"][],
	bugReports?:ValueTypes["UserUpdateBugReportsEntityRelationInput"][],
	verifiedEmail?:string | null,
	blockedAt?:ValueTypes["DateTime"] | null,
	tenantPerson?:ValueTypes["UserUpdateTenantPersonEntityRelationInput"] | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["ProtectedActionUpsertUserRelationInput"]: {
	update:ValueTypes["UserWithoutProtectedActionsUpdateInput"],
	create:ValueTypes["UserWithoutProtectedActionsCreateInput"]
};
	["BrandAliasCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	name?:string | null,
	brand?:ValueTypes["BrandAliasCreateBrandEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandAliasCreateBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutAliasesCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandAliasConnectOrCreateBrandRelationInput"] | null
};
	["BrandWithoutAliasesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["BrandCreateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandCreateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandCreateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandCreateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandCreateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandCreateDistributorEntityRelationInput"] | null,
	ads?:ValueTypes["BrandCreateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandCreateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandCreateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandAliasConnectOrCreateBrandRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandWithoutAliasesCreateInput"]
};
	["BrandAliasUpdateInput"]: {
	remoteId?:string | null,
	name?:string | null,
	brand?:ValueTypes["BrandAliasUpdateBrandEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandAliasUpdateBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutAliasesCreateInput"] | null,
	connectOrCreate?:ValueTypes["BrandAliasConnectOrCreateBrandRelationInput"] | null,
	update?:ValueTypes["BrandWithoutAliasesUpdateInput"] | null,
	upsert?:ValueTypes["BrandAliasUpsertBrandRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BrandWithoutAliasesUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["BrandUpdateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandUpdateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandUpdateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandUpdateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandUpdateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandUpdateDistributorEntityRelationInput"] | null,
	ads?:ValueTypes["BrandUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandUpdateFilterCombosEntityRelationInput"][],
	topx?:ValueTypes["BrandUpdateTopxEntityRelationInput"][],
	content?:ValueTypes["BrandUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BrandAliasUpsertBrandRelationInput"]: {
	update:ValueTypes["BrandWithoutAliasesUpdateInput"],
	create:ValueTypes["BrandWithoutAliasesCreateInput"]
};
	["ProductAliasCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	name?:string | null,
	product?:ValueTypes["ProductAliasCreateProductEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductAliasCreateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutAliasesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductAliasConnectOrCreateProductRelationInput"] | null
};
	["ProductWithoutAliasesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductCreateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductAliasConnectOrCreateProductRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutAliasesCreateInput"]
};
	["ProductAliasUpdateInput"]: {
	remoteId?:string | null,
	name?:string | null,
	product?:ValueTypes["ProductAliasUpdateProductEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ProductAliasUpdateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutAliasesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductAliasConnectOrCreateProductRelationInput"] | null,
	update?:ValueTypes["ProductWithoutAliasesUpdateInput"] | null,
	upsert?:ValueTypes["ProductAliasUpsertProductRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ProductWithoutAliasesUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	topx?:ValueTypes["ProductUpdateTopxEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductAliasUpsertProductRelationInput"]: {
	update:ValueTypes["ProductWithoutAliasesUpdateInput"],
	create:ValueTypes["ProductWithoutAliasesCreateInput"]
};
	["ProductLineAliasCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	name?:string | null,
	productLines?:ValueTypes["ProductLineAliasCreateProductLinesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductLineAliasCreateProductLinesEntityRelationInput"]: {
	connect?:ValueTypes["ProductLineUniqueWhere"] | null,
	create?:ValueTypes["ProductLineWithoutAliasesCreateInput"] | null,
	connectOrCreate?:ValueTypes["ProductLineAliasConnectOrCreateProductLinesRelationInput"] | null,
	alias?:string | null
};
	["ProductLineWithoutAliasesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["ProductLineCreateProductsEntityRelationInput"][],
	remoteId?:string | null,
	lead?:string | null,
	order?:number | null,
	brand?:ValueTypes["ProductLineCreateBrandEntityRelationInput"] | null,
	logo?:ValueTypes["ProductLineCreateLogoEntityRelationInput"] | null,
	slug?:string | null,
	flavors?:ValueTypes["ProductLineCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["ProductLineCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductLineAliasConnectOrCreateProductLinesRelationInput"]: {
	connect:ValueTypes["ProductLineUniqueWhere"],
	create:ValueTypes["ProductLineWithoutAliasesCreateInput"]
};
	["ProductLineAliasUpdateInput"]: {
	remoteId?:string | null,
	name?:string | null,
	productLines?:ValueTypes["ProductLineAliasUpdateProductLinesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ProductLineAliasUpdateProductLinesEntityRelationInput"]: {
	create?:ValueTypes["ProductLineWithoutAliasesCreateInput"] | null,
	update?:ValueTypes["ProductLineAliasUpdateProductLinesRelationInput"] | null,
	upsert?:ValueTypes["ProductLineAliasUpsertProductLinesRelationInput"] | null,
	connect?:ValueTypes["ProductLineUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductLineUniqueWhere"] | null,
	delete?:ValueTypes["ProductLineUniqueWhere"] | null,
	alias?:string | null
};
	["ProductLineAliasUpdateProductLinesRelationInput"]: {
	by:ValueTypes["ProductLineUniqueWhere"],
	data:ValueTypes["ProductLineWithoutAliasesUpdateInput"]
};
	["ProductLineWithoutAliasesUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["ProductLineUpdateProductsEntityRelationInput"][],
	remoteId?:string | null,
	lead?:string | null,
	order?:number | null,
	brand?:ValueTypes["ProductLineUpdateBrandEntityRelationInput"] | null,
	logo?:ValueTypes["ProductLineUpdateLogoEntityRelationInput"] | null,
	slug?:string | null,
	flavors?:ValueTypes["ProductLineUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["ProductLineUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductLineAliasUpsertProductLinesRelationInput"]: {
	by:ValueTypes["ProductLineUniqueWhere"],
	update:ValueTypes["ProductLineWithoutAliasesUpdateInput"],
	create:ValueTypes["ProductLineWithoutAliasesCreateInput"]
};
	["GenericPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GenericPageEdge"],
		__typename?: boolean
}>;
	["GenericPageEdge"]: AliasType<{
	node?:ValueTypes["GenericPage"],
		__typename?: boolean
}>;
	["GenericPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["GenericPageCreateLinkEntityRelationInput"] | null,
	redirects?:ValueTypes["GenericPageCreateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["GenericPageCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["GenericPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["GenericPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GenericPageUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["GenericPageUpdateLinkEntityRelationInput"] | null,
	redirects?:ValueTypes["GenericPageUpdateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["GenericPageUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["GenericPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["GenericPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkableEdge"],
		__typename?: boolean
}>;
	["LinkableEdge"]: AliasType<{
	node?:ValueTypes["Linkable"],
		__typename?: boolean
}>;
	["LinkableCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	genericPage?:ValueTypes["LinkableCreateGenericPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateGenericPageEntityRelationInput"]: {
	connect?:ValueTypes["GenericPageUniqueWhere"] | null,
	create?:ValueTypes["GenericPageWithoutLinkCreateInput"] | null,
	connectOrCreate?:ValueTypes["LinkableConnectOrCreateGenericPageRelationInput"] | null
};
	["GenericPageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	redirects?:ValueTypes["GenericPageCreateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["GenericPageCreateSeoEntityRelationInput"] | null,
	content?:ValueTypes["GenericPageCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["GenericPageCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableConnectOrCreateGenericPageRelationInput"]: {
	connect:ValueTypes["GenericPageUniqueWhere"],
	create:ValueTypes["GenericPageWithoutLinkCreateInput"]
};
	["LinkableUpdateInput"]: {
	url?:string | null,
	genericPage?:ValueTypes["LinkableUpdateGenericPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdateGenericPageEntityRelationInput"]: {
	connect?:ValueTypes["GenericPageUniqueWhere"] | null,
	create?:ValueTypes["GenericPageWithoutLinkCreateInput"] | null,
	connectOrCreate?:ValueTypes["LinkableConnectOrCreateGenericPageRelationInput"] | null,
	update?:ValueTypes["GenericPageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertGenericPageRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GenericPageWithoutLinkUpdateInput"]: {
	title?:string | null,
	redirects?:ValueTypes["GenericPageUpdateRedirectsEntityRelationInput"][],
	seo?:ValueTypes["GenericPageUpdateSeoEntityRelationInput"] | null,
	content?:ValueTypes["GenericPageUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["GenericPageUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpsertGenericPageRelationInput"]: {
	update:ValueTypes["GenericPageWithoutLinkUpdateInput"],
	create:ValueTypes["GenericPageWithoutLinkCreateInput"]
};
	["ContentLinksConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentLinksEdge"],
		__typename?: boolean
}>;
	["ContentLinksEdge"]: AliasType<{
	node?:ValueTypes["ContentLinks"],
		__typename?: boolean
}>;
	["ContentLinksItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	target?:string | null,
	list?:ValueTypes["ContentLinksItemCreateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentLinksItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ContentLinksUniqueWhere"] | null,
	create?:ValueTypes["ContentLinksWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentLinksItemConnectOrCreateListRelationInput"] | null
};
	["ContentLinksWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ContentLinksItemConnectOrCreateListRelationInput"]: {
	connect:ValueTypes["ContentLinksUniqueWhere"],
	create:ValueTypes["ContentLinksWithoutItemsCreateInput"]
};
	["ContentLinksItemUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	target?:string | null,
	list?:ValueTypes["ContentLinksItemUpdateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentLinksItemUpdateListEntityRelationInput"]: {
	connect?:ValueTypes["ContentLinksUniqueWhere"] | null,
	create?:ValueTypes["ContentLinksWithoutItemsCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentLinksItemConnectOrCreateListRelationInput"] | null,
	update?:ValueTypes["ContentLinksWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ContentLinksItemUpsertListRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentLinksWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ContentLinksItemUpsertListRelationInput"]: {
	update:ValueTypes["ContentLinksWithoutItemsUpdateInput"],
	create:ValueTypes["ContentLinksWithoutItemsCreateInput"]
};
	["RedirectCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectCreateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectCreateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectCreateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectCreateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectCreateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectCreateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectCreateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectCreateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateInput"]: {
	to?:string | null,
	order?:number | null,
	from?:string | null,
	genericPage?:ValueTypes["RedirectUpdateGenericPageEntityRelationInput"] | null,
	itemCategory?:ValueTypes["RedirectUpdateItemCategoryEntityRelationInput"] | null,
	brandsPage?:ValueTypes["RedirectUpdateBrandsPageEntityRelationInput"] | null,
	blogPage?:ValueTypes["RedirectUpdateBlogPageEntityRelationInput"] | null,
	contactPage?:ValueTypes["RedirectUpdateContactPageEntityRelationInput"] | null,
	wizardPage?:ValueTypes["RedirectUpdateWizardPageEntityRelationInput"] | null,
	comparatorPage?:ValueTypes["RedirectUpdateComparatorPageEntityRelationInput"] | null,
	blogPost?:ValueTypes["RedirectUpdateBlogPostEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceImageEdge"],
		__typename?: boolean
}>;
	["ContentReferenceImageEdge"]: AliasType<{
	node?:ValueTypes["ContentReferenceImage"],
		__typename?: boolean
}>;
	["SeoData"]: AliasType<{
	_meta?:ValueTypes["SeoDataMeta"],
	id?:boolean,
	remoteId?:boolean,
	url?:boolean,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: boolean
}>;
	["SeoDataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	remoteId?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SeoDataUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	url?:string | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["SeoDataWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	remoteId?:ValueTypes["StringCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["SeoDataWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoDataWhere"] | undefined | null)[],
	not?:ValueTypes["SeoDataWhere"] | null
};
	["SeoDataOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	remoteId?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["SeoDataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoDataEdge"],
		__typename?: boolean
}>;
	["SeoDataEdge"]: AliasType<{
	node?:ValueTypes["SeoData"],
		__typename?: boolean
}>;
	["SeoDataCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	url?:string | null,
	seo?:ValueTypes["SeoDataCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoDataCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoDataConnectOrCreateSeoRelationInput"] | null
};
	["SeoDataConnectOrCreateSeoRelationInput"]: {
	connect:ValueTypes["SeoUniqueWhere"],
	create:ValueTypes["SeoCreateInput"]
};
	["SeoDataUpdateInput"]: {
	remoteId?:string | null,
	url?:string | null,
	seo?:ValueTypes["SeoDataUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoDataUpdateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null,
	connectOrCreate?:ValueTypes["SeoDataConnectOrCreateSeoRelationInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoDataUpsertSeoRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoDataUpsertSeoRelationInput"]: {
	update:ValueTypes["SeoUpdateInput"],
	create:ValueTypes["SeoCreateInput"]
};
	["TenantPersonConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TenantPersonEdge"],
		__typename?: boolean
}>;
	["TenantPersonEdge"]: AliasType<{
	node?:ValueTypes["TenantPerson"],
		__typename?: boolean
}>;
	["AgeCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	order?:number | null,
	labelFor?:string | null,
	products?:ValueTypes["AgeCategoryCreateProductsEntityRelationInput"][],
	slug?:string | null,
	filterCombos?:ValueTypes["AgeCategoryCreateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AgeCategoryUpdateInput"]: {
	remoteId?:string | null,
	order?:number | null,
	labelFor?:string | null,
	products?:ValueTypes["AgeCategoryUpdateProductsEntityRelationInput"][],
	slug?:string | null,
	filterCombos?:ValueTypes["AgeCategoryUpdateFilterCombosEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FilterComboCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboCreateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboCreateBreedEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboCreateBrandEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboCreateRegionEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboCreateAgeCategoryEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboCreateTreatmentEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboCreateFlavorEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboCreateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FilterComboUpdateInput"]: {
	remoteId?:string | null,
	title?:string | null,
	lead?:string | null,
	seo?:ValueTypes["FilterComboUpdateSeoEntityRelationInput"] | null,
	breed?:ValueTypes["FilterComboUpdateBreedEntityRelationInput"] | null,
	brand?:ValueTypes["FilterComboUpdateBrandEntityRelationInput"] | null,
	region?:ValueTypes["FilterComboUpdateRegionEntityRelationInput"] | null,
	ageCategory?:ValueTypes["FilterComboUpdateAgeCategoryEntityRelationInput"] | null,
	treatment?:ValueTypes["FilterComboUpdateTreatmentEntityRelationInput"] | null,
	flavor?:ValueTypes["FilterComboUpdateFlavorEntityRelationInput"] | null,
	allergy?:ValueTypes["FilterComboUpdateAllergyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImportCache"]: AliasType<{
	_meta?:ValueTypes["ImportCacheMeta"],
	id?:boolean,
	unique?:boolean,
	latestImportAt?:boolean,
	latestImportHash?:boolean,
		__typename?: boolean
}>;
	["ImportCacheMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	latestImportAt?:ValueTypes["FieldMeta"],
	latestImportHash?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ImportCacheUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null
};
	["ImportCacheWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	latestImportAt?:ValueTypes["DateTimeCondition"] | null,
	latestImportHash?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ImportCacheWhere"] | undefined | null)[],
	or?:(ValueTypes["ImportCacheWhere"] | undefined | null)[],
	not?:ValueTypes["ImportCacheWhere"] | null
};
	["ImportCacheOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	latestImportAt?:ValueTypes["OrderDirection"] | null,
	latestImportHash?:ValueTypes["OrderDirection"] | null
};
	["ImportCacheConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImportCacheEdge"],
		__typename?: boolean
}>;
	["ImportCacheEdge"]: AliasType<{
	node?:ValueTypes["ImportCache"],
		__typename?: boolean
}>;
	["ImportCacheCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	latestImportAt?:ValueTypes["DateTime"] | null,
	latestImportHash?:string | null,
	_dummy_field_?:boolean | null
};
	["ImportCacheUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	latestImportAt?:ValueTypes["DateTime"] | null,
	latestImportHash?:string | null,
	_dummy_field_?:boolean | null
};
	["Site"]: AliasType<{
	_meta?:ValueTypes["SiteMeta"],
	id?:boolean,
	reindexingAt?:boolean,
	unique?:boolean,
		__typename?: boolean
}>;
	["SiteMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	reindexingAt?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SiteUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null
};
	["SiteWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	reindexingAt?:ValueTypes["DateTimeCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	and?:(ValueTypes["SiteWhere"] | undefined | null)[],
	or?:(ValueTypes["SiteWhere"] | undefined | null)[],
	not?:ValueTypes["SiteWhere"] | null
};
	["SiteOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	reindexingAt?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null
};
	["SiteConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SiteEdge"],
		__typename?: boolean
}>;
	["SiteEdge"]: AliasType<{
	node?:ValueTypes["Site"],
		__typename?: boolean
}>;
	["SiteCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	reindexingAt?:ValueTypes["DateTime"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["SiteUpdateInput"]: {
	reindexingAt?:ValueTypes["DateTime"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["ContactSubmission"]: AliasType<{
	_meta?:ValueTypes["ContactSubmissionMeta"],
	id?:boolean,
	createdAt?:boolean,
	eBookVariant?:boolean,
	email?:boolean,
	newsletterSubscribed?:boolean,
		__typename?: boolean
}>;
	["ContactSubmissionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	eBookVariant?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	newsletterSubscribed?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BookType"]:BookType;
	["ContactSubmissionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ContactSubmissionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	eBookVariant?:ValueTypes["BookTypeCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	newsletterSubscribed?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["ContactSubmissionWhere"] | undefined | null)[],
	or?:(ValueTypes["ContactSubmissionWhere"] | undefined | null)[],
	not?:ValueTypes["ContactSubmissionWhere"] | null
};
	["BookTypeCondition"]: {
	and?:ValueTypes["BookTypeCondition"][],
	or?:ValueTypes["BookTypeCondition"][],
	not?:ValueTypes["BookTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["BookType"] | null,
	notEq?:ValueTypes["BookType"] | null,
	in?:ValueTypes["BookType"][],
	notIn?:ValueTypes["BookType"][],
	lt?:ValueTypes["BookType"] | null,
	lte?:ValueTypes["BookType"] | null,
	gt?:ValueTypes["BookType"] | null,
	gte?:ValueTypes["BookType"] | null
};
	["ContactSubmissionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null,
	eBookVariant?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	newsletterSubscribed?:ValueTypes["OrderDirection"] | null
};
	["ContactSubmissionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContactSubmissionEdge"],
		__typename?: boolean
}>;
	["ContactSubmissionEdge"]: AliasType<{
	node?:ValueTypes["ContactSubmission"],
		__typename?: boolean
}>;
	["ContactSubmissionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	eBookVariant?:ValueTypes["BookType"] | null,
	email?:string | null,
	newsletterSubscribed?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ContactSubmissionUpdateInput"]: {
	createdAt?:ValueTypes["DateTime"] | null,
	eBookVariant?:ValueTypes["BookType"] | null,
	email?:string | null,
	newsletterSubscribed?:boolean | null,
	_dummy_field_?:boolean | null
};
	["TOPXBrandCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	order?:number | null,
	orderType?:ValueTypes["TOPXBrandOrderType"] | null,
	brand?:ValueTypes["TOPXBrandCreateBrandEntityRelationInput"] | null,
	category?:ValueTypes["TOPXBrandCreateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXBrandCreateBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutTopxCreateInput"] | null,
	connectOrCreate?:ValueTypes["TOPXBrandConnectOrCreateBrandRelationInput"] | null
};
	["BrandWithoutTopxCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	products?:ValueTypes["BrandCreateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandCreateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandCreateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandCreateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandCreateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandCreateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandCreateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandCreateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandCreateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandCreateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandCreateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandCreateFilterCombosEntityRelationInput"][],
	content?:ValueTypes["BrandCreateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandCreateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXBrandConnectOrCreateBrandRelationInput"]: {
	connect:ValueTypes["BrandUniqueWhere"],
	create:ValueTypes["BrandWithoutTopxCreateInput"]
};
	["TOPXBrandUpdateInput"]: {
	remoteId?:string | null,
	order?:number | null,
	orderType?:ValueTypes["TOPXBrandOrderType"] | null,
	brand?:ValueTypes["TOPXBrandUpdateBrandEntityRelationInput"] | null,
	category?:ValueTypes["TOPXBrandUpdateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXBrandUpdateBrandEntityRelationInput"]: {
	connect?:ValueTypes["BrandUniqueWhere"] | null,
	create?:ValueTypes["BrandWithoutTopxCreateInput"] | null,
	connectOrCreate?:ValueTypes["TOPXBrandConnectOrCreateBrandRelationInput"] | null,
	update?:ValueTypes["BrandWithoutTopxUpdateInput"] | null,
	upsert?:ValueTypes["TOPXBrandUpsertBrandRelationInput"] | null,
	delete?:boolean | null
};
	["BrandWithoutTopxUpdateInput"]: {
	name?:string | null,
	products?:ValueTypes["BrandUpdateProductsEntityRelationInput"][],
	link?:string | null,
	countriesOfProduction?:ValueTypes["BrandUpdateCountriesOfProductionEntityRelationInput"][],
	manufacturers?:ValueTypes["BrandUpdateManufacturersEntityRelationInput"][],
	remoteId?:string | null,
	promotedOnSearchPlace?:number | null,
	promotedOnBrandsPagePlace?:number | null,
	lead?:string | null,
	productLines?:ValueTypes["BrandUpdateProductLinesEntityRelationInput"][],
	logo?:ValueTypes["BrandUpdateLogoEntityRelationInput"] | null,
	methodOfProduction?:ValueTypes["BrandUpdateMethodOfProductionEntityRelationInput"] | null,
	distributor?:ValueTypes["BrandUpdateDistributorEntityRelationInput"] | null,
	aliases?:ValueTypes["BrandUpdateAliasesEntityRelationInput"][],
	ads?:ValueTypes["BrandUpdateAdsEntityRelationInput"][],
	slug?:string | null,
	flavors?:ValueTypes["BrandUpdateFlavorsEntityRelationInput"][],
	seo?:ValueTypes["BrandUpdateSeoEntityRelationInput"] | null,
	customMetaDescription?:string | null,
	filterCombos?:ValueTypes["BrandUpdateFilterCombosEntityRelationInput"][],
	content?:ValueTypes["BrandUpdateContentEntityRelationInput"] | null,
	draft?:ValueTypes["BrandUpdateDraftEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXBrandUpsertBrandRelationInput"]: {
	update:ValueTypes["BrandWithoutTopxUpdateInput"],
	create:ValueTypes["BrandWithoutTopxCreateInput"]
};
	["TOPXBrandCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TOPXBrandCategoryEdge"],
		__typename?: boolean
}>;
	["TOPXBrandCategoryEdge"]: AliasType<{
	node?:ValueTypes["TOPXBrandCategory"],
		__typename?: boolean
}>;
	["TOPXBrandCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	brands?:ValueTypes["TOPXBrandCategoryCreateBrandsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TOPXBrandCategoryCreateBrandsEntityRelationInput"]: {
	connect?:ValueTypes["TOPXBrandUniqueWhere"] | null,
	create?:ValueTypes["TOPXBrandWithoutCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["TOPXBrandCategoryConnectOrCreateBrandsRelationInput"] | null,
	alias?:string | null
};
	["TOPXBrandWithoutCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	order?:number | null,
	orderType?:ValueTypes["TOPXBrandOrderType"] | null,
	brand?:ValueTypes["TOPXBrandCreateBrandEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXBrandCategoryConnectOrCreateBrandsRelationInput"]: {
	connect:ValueTypes["TOPXBrandUniqueWhere"],
	create:ValueTypes["TOPXBrandWithoutCategoryCreateInput"]
};
	["TOPXBrandCategoryUpdateInput"]: {
	remoteId?:string | null,
	brands?:ValueTypes["TOPXBrandCategoryUpdateBrandsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TOPXBrandCategoryUpdateBrandsEntityRelationInput"]: {
	create?:ValueTypes["TOPXBrandWithoutCategoryCreateInput"] | null,
	update?:ValueTypes["TOPXBrandCategoryUpdateBrandsRelationInput"] | null,
	upsert?:ValueTypes["TOPXBrandCategoryUpsertBrandsRelationInput"] | null,
	connect?:ValueTypes["TOPXBrandUniqueWhere"] | null,
	disconnect?:ValueTypes["TOPXBrandUniqueWhere"] | null,
	delete?:ValueTypes["TOPXBrandUniqueWhere"] | null,
	alias?:string | null
};
	["TOPXBrandCategoryUpdateBrandsRelationInput"]: {
	by:ValueTypes["TOPXBrandUniqueWhere"],
	data:ValueTypes["TOPXBrandWithoutCategoryUpdateInput"]
};
	["TOPXBrandWithoutCategoryUpdateInput"]: {
	remoteId?:string | null,
	order?:number | null,
	orderType?:ValueTypes["TOPXBrandOrderType"] | null,
	brand?:ValueTypes["TOPXBrandUpdateBrandEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXBrandCategoryUpsertBrandsRelationInput"]: {
	by:ValueTypes["TOPXBrandUniqueWhere"],
	update:ValueTypes["TOPXBrandWithoutCategoryUpdateInput"],
	create:ValueTypes["TOPXBrandWithoutCategoryCreateInput"]
};
	["TOPXProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	order?:number | null,
	orderType?:ValueTypes["TOPXProductOrderType"] | null,
	product?:ValueTypes["TOPXProductCreateProductEntityRelationInput"] | null,
	category?:ValueTypes["TOPXProductCreateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXProductCreateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutTopxCreateInput"] | null,
	connectOrCreate?:ValueTypes["TOPXProductConnectOrCreateProductRelationInput"] | null
};
	["ProductWithoutTopxCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	nutritionalValues?:ValueTypes["ProductCreateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductCreateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductCreateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductCreatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductCreateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductCreateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductCreateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductCreateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductCreateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductCreateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductCreateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductCreateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductCreateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductCreateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductCreateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductCreateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductCreateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductCreateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductCreateHeurekaImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXProductConnectOrCreateProductRelationInput"]: {
	connect:ValueTypes["ProductUniqueWhere"],
	create:ValueTypes["ProductWithoutTopxCreateInput"]
};
	["TOPXProductUpdateInput"]: {
	remoteId?:string | null,
	order?:number | null,
	orderType?:ValueTypes["TOPXProductOrderType"] | null,
	product?:ValueTypes["TOPXProductUpdateProductEntityRelationInput"] | null,
	category?:ValueTypes["TOPXProductUpdateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXProductUpdateProductEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutTopxCreateInput"] | null,
	connectOrCreate?:ValueTypes["TOPXProductConnectOrCreateProductRelationInput"] | null,
	update?:ValueTypes["ProductWithoutTopxUpdateInput"] | null,
	upsert?:ValueTypes["TOPXProductUpsertProductRelationInput"] | null,
	delete?:boolean | null
};
	["ProductWithoutTopxUpdateInput"]: {
	nutritionalValues?:ValueTypes["ProductUpdateNutritionalValuesEntityRelationInput"][],
	name?:string | null,
	positiveForBodyTags?:ValueTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"][],
	negativeForBodyTags?:ValueTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"][],
	reviews?:ValueTypes["ProductUpdateReviewsEntityRelationInput"][],
	score?:number | null,
	dogs?:ValueTypes["ProductUpdateDogsEntityRelationInput"][],
	firstFiveItems?:string | null,
	detailedComposition?:string | null,
	guaranteedAnalysis?:string | null,
	isVeterinaryDiet?:boolean | null,
	packagings?:ValueTypes["ProductUpdatePackagingsEntityRelationInput"][],
	itemSubCategories?:ValueTypes["ProductUpdateItemSubCategoriesEntityRelationInput"][],
	itemCategories?:ValueTypes["ProductUpdateItemCategoriesEntityRelationInput"][],
	elements?:ValueTypes["ProductUpdateElementsEntityRelationInput"][],
	isSearchVisible?:boolean | null,
	isSuitableForEliminationDiet?:boolean | null,
	remoteId?:string | null,
	recommendedDogSizes?:ValueTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"][],
	granuleSizes?:ValueTypes["ProductUpdateGranuleSizesEntityRelationInput"][],
	productLine?:ValueTypes["ProductUpdateProductLineEntityRelationInput"] | null,
	flags?:ValueTypes["ProductUpdateFlagsEntityRelationInput"][],
	image?:ValueTypes["ProductUpdateImageEntityRelationInput"] | null,
	recommendedActivity?:ValueTypes["ProductUpdateRecommendedActivityEntityRelationInput"] | null,
	brand?:ValueTypes["ProductUpdateBrandEntityRelationInput"] | null,
	metabolizedEnergy?:number | null,
	cheapnessValue?:number | null,
	aliases?:ValueTypes["ProductUpdateAliasesEntityRelationInput"][],
	slug?:string | null,
	animalProteinStatus?:ValueTypes["ContentAmount"] | null,
	carbohydrateStatus?:ValueTypes["ContentAmount"] | null,
	evaluation?:ValueTypes["ProductUpdateEvaluationEntityRelationInput"] | null,
	missingComposition?:boolean | null,
	seo?:ValueTypes["ProductUpdateSeoEntityRelationInput"] | null,
	czkPerMetabolizedEnergy?:number | null,
	itemDeclensionFourthCategories?:ValueTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"][],
	ageCategories?:ValueTypes["ProductUpdateAgeCategoriesEntityRelationInput"][],
	customMetaTitle?:string | null,
	customMetaDescription?:string | null,
	isSuitableForCastrated?:boolean | null,
	heurekaImage?:ValueTypes["ProductUpdateHeurekaImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXProductUpsertProductRelationInput"]: {
	update:ValueTypes["ProductWithoutTopxUpdateInput"],
	create:ValueTypes["ProductWithoutTopxCreateInput"]
};
	["TOPXProductCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TOPXProductCategoryEdge"],
		__typename?: boolean
}>;
	["TOPXProductCategoryEdge"]: AliasType<{
	node?:ValueTypes["TOPXProductCategory"],
		__typename?: boolean
}>;
	["TOPXProductCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	products?:ValueTypes["TOPXProductCategoryCreateProductsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TOPXProductCategoryCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["TOPXProductUniqueWhere"] | null,
	create?:ValueTypes["TOPXProductWithoutCategoryCreateInput"] | null,
	connectOrCreate?:ValueTypes["TOPXProductCategoryConnectOrCreateProductsRelationInput"] | null,
	alias?:string | null
};
	["TOPXProductWithoutCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	remoteId?:string | null,
	order?:number | null,
	orderType?:ValueTypes["TOPXProductOrderType"] | null,
	product?:ValueTypes["TOPXProductCreateProductEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXProductCategoryConnectOrCreateProductsRelationInput"]: {
	connect:ValueTypes["TOPXProductUniqueWhere"],
	create:ValueTypes["TOPXProductWithoutCategoryCreateInput"]
};
	["TOPXProductCategoryUpdateInput"]: {
	remoteId?:string | null,
	products?:ValueTypes["TOPXProductCategoryUpdateProductsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TOPXProductCategoryUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["TOPXProductWithoutCategoryCreateInput"] | null,
	update?:ValueTypes["TOPXProductCategoryUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["TOPXProductCategoryUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["TOPXProductUniqueWhere"] | null,
	disconnect?:ValueTypes["TOPXProductUniqueWhere"] | null,
	delete?:ValueTypes["TOPXProductUniqueWhere"] | null,
	alias?:string | null
};
	["TOPXProductCategoryUpdateProductsRelationInput"]: {
	by:ValueTypes["TOPXProductUniqueWhere"],
	data:ValueTypes["TOPXProductWithoutCategoryUpdateInput"]
};
	["TOPXProductWithoutCategoryUpdateInput"]: {
	remoteId?:string | null,
	order?:number | null,
	orderType?:ValueTypes["TOPXProductOrderType"] | null,
	product?:ValueTypes["TOPXProductUpdateProductEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TOPXProductCategoryUpsertProductsRelationInput"]: {
	by:ValueTypes["TOPXProductUniqueWhere"],
	update:ValueTypes["TOPXProductWithoutCategoryUpdateInput"],
	create:ValueTypes["TOPXProductWithoutCategoryCreateInput"]
};
	["ContentReferenceListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	relatedProduct?:ValueTypes["ContentReferenceListCreateRelatedProductEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceListCreateRelatedBrandEntityRelationInput"] | null,
	list?:ValueTypes["ContentReferenceListCreateListEntityRelationInput"] | null,
	badge?:string | null,
	badgeColor?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceListCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutListCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceListConnectOrCreateListRelationInput"] | null
};
	["ContentReferenceWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fact?:string | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	relatedBlogPost?:ValueTypes["ContentReferenceCreateRelatedBlogPostEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceCreateRelatedBrandEntityRelationInput"] | null,
	relatedProduct?:ValueTypes["ContentReferenceCreateRelatedProductEntityRelationInput"] | null,
	relatedIngredient?:ValueTypes["ContentReferenceCreateRelatedIngredientEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	badge?:string | null,
	longVersion?:boolean | null,
	relatedBrandFull?:ValueTypes["ContentReferenceCreateRelatedBrandFullEntityRelationInput"] | null,
	relatedProductFull?:ValueTypes["ContentReferenceCreateRelatedProductFullEntityRelationInput"] | null,
	outline?:ValueTypes["ContentReferenceCreateOutlineEntityRelationInput"] | null,
	video?:ValueTypes["ContentReferenceCreateVideoEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	defaultOpen?:boolean | null,
	badgeColor?:string | null,
	isMain?:boolean | null,
	ad?:ValueTypes["ContentReferenceCreateAdEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceListConnectOrCreateListRelationInput"]: {
	connect:ValueTypes["ContentReferenceUniqueWhere"],
	create:ValueTypes["ContentReferenceWithoutListCreateInput"]
};
	["ContentReferenceListUpdateInput"]: {
	order?:number | null,
	relatedProduct?:ValueTypes["ContentReferenceListUpdateRelatedProductEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceListUpdateRelatedBrandEntityRelationInput"] | null,
	list?:ValueTypes["ContentReferenceListUpdateListEntityRelationInput"] | null,
	badge?:string | null,
	badgeColor?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceListUpdateListEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutListCreateInput"] | null,
	connectOrCreate?:ValueTypes["ContentReferenceListConnectOrCreateListRelationInput"] | null,
	update?:ValueTypes["ContentReferenceWithoutListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceListUpsertListRelationInput"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceWithoutListUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	block?:ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	fact?:string | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	relatedBlogPost?:ValueTypes["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"] | null,
	relatedBrand?:ValueTypes["ContentReferenceUpdateRelatedBrandEntityRelationInput"] | null,
	relatedProduct?:ValueTypes["ContentReferenceUpdateRelatedProductEntityRelationInput"] | null,
	relatedIngredient?:ValueTypes["ContentReferenceUpdateRelatedIngredientEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	badge?:string | null,
	longVersion?:boolean | null,
	relatedBrandFull?:ValueTypes["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"] | null,
	relatedProductFull?:ValueTypes["ContentReferenceUpdateRelatedProductFullEntityRelationInput"] | null,
	outline?:ValueTypes["ContentReferenceUpdateOutlineEntityRelationInput"] | null,
	video?:ValueTypes["ContentReferenceUpdateVideoEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	defaultOpen?:boolean | null,
	badgeColor?:string | null,
	isMain?:boolean | null,
	ad?:ValueTypes["ContentReferenceUpdateAdEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceListUpsertListRelationInput"]: {
	update:ValueTypes["ContentReferenceWithoutListUpdateInput"],
	create:ValueTypes["ContentReferenceWithoutListCreateInput"]
};
	["BrandCount"]: AliasType<{
	_meta?:ValueTypes["BrandCountMeta"],
	id?:boolean,
	unique?:boolean,
	count?:boolean,
		__typename?: boolean
}>;
	["BrandCountMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	count?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BrandCountUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null
};
	["BrandCountWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	count?:ValueTypes["IntCondition"] | null,
	and?:(ValueTypes["BrandCountWhere"] | undefined | null)[],
	or?:(ValueTypes["BrandCountWhere"] | undefined | null)[],
	not?:ValueTypes["BrandCountWhere"] | null
};
	["BrandCountOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	count?:ValueTypes["OrderDirection"] | null
};
	["BrandCountConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BrandCountEdge"],
		__typename?: boolean
}>;
	["BrandCountEdge"]: AliasType<{
	node?:ValueTypes["BrandCount"],
		__typename?: boolean
}>;
	["ProductCount"]: AliasType<{
	_meta?:ValueTypes["ProductCountMeta"],
	id?:boolean,
	unique?:boolean,
	count?:boolean,
		__typename?: boolean
}>;
	["ProductCountMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	count?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ProductCountUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null
};
	["ProductCountWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	count?:ValueTypes["IntCondition"] | null,
	and?:(ValueTypes["ProductCountWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductCountWhere"] | undefined | null)[],
	not?:ValueTypes["ProductCountWhere"] | null
};
	["ProductCountOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	count?:ValueTypes["OrderDirection"] | null
};
	["ProductCountConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductCountEdge"],
		__typename?: boolean
}>;
	["ProductCountEdge"]: AliasType<{
	node?:ValueTypes["ProductCount"],
		__typename?: boolean
}>;
	["QueryTransaction"]: AliasType<{
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:boolean,
getBlogPage?: [{	by:ValueTypes["BlogPageUniqueWhere"],	filter?:ValueTypes["BlogPageWhere"] | null},ValueTypes["BlogPage"]],
listBlogPage?: [{	filter?:ValueTypes["BlogPageWhere"] | null,	orderBy?:ValueTypes["BlogPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPage"]],
paginateBlogPage?: [{	filter?:ValueTypes["BlogPageWhere"] | null,	orderBy?:ValueTypes["BlogPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPageConnection"]],
validateCreateBlogPage?: [{	data:ValueTypes["BlogPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPage?: [{	by:ValueTypes["BlogPageUniqueWhere"],	data:ValueTypes["BlogPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPost?: [{	by:ValueTypes["BlogPostUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPost"]],
listBlogPost?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPost"]],
paginateBlogPost?: [{	filter?:ValueTypes["BlogPostWhere"] | null,	orderBy?:ValueTypes["BlogPostOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostConnection"]],
validateCreateBlogPost?: [{	data:ValueTypes["BlogPostCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPost?: [{	by:ValueTypes["BlogPostUniqueWhere"],	data:ValueTypes["BlogPostUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostTag?: [{	by:ValueTypes["BlogPostTagUniqueWhere"],	filter?:ValueTypes["BlogPostTagWhere"] | null},ValueTypes["BlogPostTag"]],
listBlogPostTag?: [{	filter?:ValueTypes["BlogPostTagWhere"] | null,	orderBy?:ValueTypes["BlogPostTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostTag"]],
paginateBlogPostTag?: [{	filter?:ValueTypes["BlogPostTagWhere"] | null,	orderBy?:ValueTypes["BlogPostTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostTagConnection"]],
validateCreateBlogPostTag?: [{	data:ValueTypes["BlogPostTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostTag?: [{	by:ValueTypes["BlogPostTagUniqueWhere"],	data:ValueTypes["BlogPostTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getBodyTag?: [{	by:ValueTypes["BodyTagUniqueWhere"],	filter?:ValueTypes["BodyTagWhere"] | null},ValueTypes["BodyTag"]],
listBodyTag?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BodyTag"]],
paginateBodyTag?: [{	filter?:ValueTypes["BodyTagWhere"] | null,	orderBy?:ValueTypes["BodyTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BodyTagConnection"]],
validateCreateBodyTag?: [{	data:ValueTypes["BodyTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBodyTag?: [{	by:ValueTypes["BodyTagUniqueWhere"],	data:ValueTypes["BodyTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getBodyTagCategory?: [{	by:ValueTypes["BodyTagCategoryUniqueWhere"],	filter?:ValueTypes["BodyTagCategoryWhere"] | null},ValueTypes["BodyTagCategory"]],
listBodyTagCategory?: [{	filter?:ValueTypes["BodyTagCategoryWhere"] | null,	orderBy?:ValueTypes["BodyTagCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BodyTagCategory"]],
paginateBodyTagCategory?: [{	filter?:ValueTypes["BodyTagCategoryWhere"] | null,	orderBy?:ValueTypes["BodyTagCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BodyTagCategoryConnection"]],
validateCreateBodyTagCategory?: [{	data:ValueTypes["BodyTagCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBodyTagCategory?: [{	by:ValueTypes["BodyTagCategoryUniqueWhere"],	data:ValueTypes["BodyTagCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getDidYouKnow?: [{	by:ValueTypes["DidYouKnowUniqueWhere"],	filter?:ValueTypes["DidYouKnowWhere"] | null},ValueTypes["DidYouKnow"]],
listDidYouKnow?: [{	filter?:ValueTypes["DidYouKnowWhere"] | null,	orderBy?:ValueTypes["DidYouKnowOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DidYouKnow"]],
paginateDidYouKnow?: [{	filter?:ValueTypes["DidYouKnowWhere"] | null,	orderBy?:ValueTypes["DidYouKnowOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DidYouKnowConnection"]],
validateCreateDidYouKnow?: [{	data:ValueTypes["DidYouKnowCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDidYouKnow?: [{	by:ValueTypes["DidYouKnowUniqueWhere"],	data:ValueTypes["DidYouKnowUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["Medium"]],
listMedium?: [{	filter?:ValueTypes["MediumWhere"] | null,	orderBy?:ValueTypes["MediumOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Medium"]],
paginateMedium?: [{	filter?:ValueTypes["MediumWhere"] | null,	orderBy?:ValueTypes["MediumOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumConnection"]],
validateCreateMedium?: [{	data:ValueTypes["MediumCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	data:ValueTypes["MediumUpdateInput"]},ValueTypes["_ValidationResult"]],
getNutritionalValue?: [{	by:ValueTypes["NutritionalValueUniqueWhere"],	filter?:ValueTypes["NutritionalValueWhere"] | null},ValueTypes["NutritionalValue"]],
listNutritionalValue?: [{	filter?:ValueTypes["NutritionalValueWhere"] | null,	orderBy?:ValueTypes["NutritionalValueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NutritionalValue"]],
paginateNutritionalValue?: [{	filter?:ValueTypes["NutritionalValueWhere"] | null,	orderBy?:ValueTypes["NutritionalValueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NutritionalValueConnection"]],
validateCreateNutritionalValue?: [{	data:ValueTypes["NutritionalValueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNutritionalValue?: [{	by:ValueTypes["NutritionalValueUniqueWhere"],	data:ValueTypes["NutritionalValueUpdateInput"]},ValueTypes["_ValidationResult"]],
getPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
listPage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Page"]],
paginatePage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageConnection"]],
validateCreatePage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePage?: [{	by:ValueTypes["PageUniqueWhere"],	data:ValueTypes["PageUpdateInput"]},ValueTypes["_ValidationResult"]],
getReference?: [{	by:ValueTypes["ReferenceUniqueWhere"],	filter?:ValueTypes["ReferenceWhere"] | null},ValueTypes["Reference"]],
listReference?: [{	filter?:ValueTypes["ReferenceWhere"] | null,	orderBy?:ValueTypes["ReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Reference"]],
paginateReference?: [{	filter?:ValueTypes["ReferenceWhere"] | null,	orderBy?:ValueTypes["ReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ReferenceConnection"]],
validateCreateReference?: [{	data:ValueTypes["ReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateReference?: [{	by:ValueTypes["ReferenceUniqueWhere"],	data:ValueTypes["ReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getReferenceList?: [{	by:ValueTypes["ReferenceListUniqueWhere"],	filter?:ValueTypes["ReferenceListWhere"] | null},ValueTypes["ReferenceList"]],
listReferenceList?: [{	filter?:ValueTypes["ReferenceListWhere"] | null,	orderBy?:ValueTypes["ReferenceListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ReferenceList"]],
paginateReferenceList?: [{	filter?:ValueTypes["ReferenceListWhere"] | null,	orderBy?:ValueTypes["ReferenceListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ReferenceListConnection"]],
validateCreateReferenceList?: [{	data:ValueTypes["ReferenceListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateReferenceList?: [{	by:ValueTypes["ReferenceListUniqueWhere"],	data:ValueTypes["ReferenceListUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
listVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Video"]],
paginateVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	data:ValueTypes["VideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getBrand?: [{	by:ValueTypes["BrandUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["Brand"]],
listBrand?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Brand"]],
paginateBrand?: [{	filter?:ValueTypes["BrandWhere"] | null,	orderBy?:ValueTypes["BrandOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandConnection"]],
validateCreateBrand?: [{	data:ValueTypes["BrandCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBrand?: [{	by:ValueTypes["BrandUniqueWhere"],	data:ValueTypes["BrandUpdateInput"]},ValueTypes["_ValidationResult"]],
getBrandDistributor?: [{	by:ValueTypes["BrandDistributorUniqueWhere"],	filter?:ValueTypes["BrandDistributorWhere"] | null},ValueTypes["BrandDistributor"]],
listBrandDistributor?: [{	filter?:ValueTypes["BrandDistributorWhere"] | null,	orderBy?:ValueTypes["BrandDistributorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandDistributor"]],
paginateBrandDistributor?: [{	filter?:ValueTypes["BrandDistributorWhere"] | null,	orderBy?:ValueTypes["BrandDistributorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandDistributorConnection"]],
validateCreateBrandDistributor?: [{	data:ValueTypes["BrandDistributorCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBrandDistributor?: [{	by:ValueTypes["BrandDistributorUniqueWhere"],	data:ValueTypes["BrandDistributorUpdateInput"]},ValueTypes["_ValidationResult"]],
getDogSize?: [{	by:ValueTypes["DogSizeUniqueWhere"],	filter?:ValueTypes["DogSizeWhere"] | null},ValueTypes["DogSize"]],
listDogSize?: [{	filter?:ValueTypes["DogSizeWhere"] | null,	orderBy?:ValueTypes["DogSizeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogSize"]],
paginateDogSize?: [{	filter?:ValueTypes["DogSizeWhere"] | null,	orderBy?:ValueTypes["DogSizeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogSizeConnection"]],
validateCreateDogSize?: [{	data:ValueTypes["DogSizeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDogSize?: [{	by:ValueTypes["DogSizeUniqueWhere"],	data:ValueTypes["DogSizeUpdateInput"]},ValueTypes["_ValidationResult"]],
getProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
listProduct?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
paginateProduct?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
validateCreateProduct?: [{	data:ValueTypes["ProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	data:ValueTypes["ProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductionMethod?: [{	by:ValueTypes["ProductionMethodUniqueWhere"],	filter?:ValueTypes["ProductionMethodWhere"] | null},ValueTypes["ProductionMethod"]],
listProductionMethod?: [{	filter?:ValueTypes["ProductionMethodWhere"] | null,	orderBy?:ValueTypes["ProductionMethodOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductionMethod"]],
paginateProductionMethod?: [{	filter?:ValueTypes["ProductionMethodWhere"] | null,	orderBy?:ValueTypes["ProductionMethodOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductionMethodConnection"]],
validateCreateProductionMethod?: [{	data:ValueTypes["ProductionMethodCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductionMethod?: [{	by:ValueTypes["ProductionMethodUniqueWhere"],	data:ValueTypes["ProductionMethodUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductLine?: [{	by:ValueTypes["ProductLineUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLine"]],
listProductLine?: [{	filter?:ValueTypes["ProductLineWhere"] | null,	orderBy?:ValueTypes["ProductLineOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductLine"]],
paginateProductLine?: [{	filter?:ValueTypes["ProductLineWhere"] | null,	orderBy?:ValueTypes["ProductLineOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductLineConnection"]],
validateCreateProductLine?: [{	data:ValueTypes["ProductLineCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductLine?: [{	by:ValueTypes["ProductLineUniqueWhere"],	data:ValueTypes["ProductLineUpdateInput"]},ValueTypes["_ValidationResult"]],
getBreed?: [{	by:ValueTypes["BreedUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["Breed"]],
listBreed?: [{	filter?:ValueTypes["BreedWhere"] | null,	orderBy?:ValueTypes["BreedOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Breed"]],
paginateBreed?: [{	filter?:ValueTypes["BreedWhere"] | null,	orderBy?:ValueTypes["BreedOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BreedConnection"]],
validateCreateBreed?: [{	data:ValueTypes["BreedCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBreed?: [{	by:ValueTypes["BreedUniqueWhere"],	data:ValueTypes["BreedUpdateInput"]},ValueTypes["_ValidationResult"]],
getDog?: [{	by:ValueTypes["DogUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["Dog"]],
listDog?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Dog"]],
paginateDog?: [{	filter?:ValueTypes["DogWhere"] | null,	orderBy?:ValueTypes["DogOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogConnection"]],
validateCreateDog?: [{	data:ValueTypes["DogCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDog?: [{	by:ValueTypes["DogUniqueWhere"],	data:ValueTypes["DogUpdateInput"]},ValueTypes["_ValidationResult"]],
getUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
listUser?: [{	filter?:ValueTypes["UserWhere"] | null,	orderBy?:ValueTypes["UserOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["User"]],
paginateUser?: [{	filter?:ValueTypes["UserWhere"] | null,	orderBy?:ValueTypes["UserOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UserConnection"]],
validateCreateUser?: [{	data:ValueTypes["UserCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUser?: [{	by:ValueTypes["UserUniqueWhere"],	data:ValueTypes["UserUpdateInput"]},ValueTypes["_ValidationResult"]],
getVeterinary?: [{	by:ValueTypes["VeterinaryUniqueWhere"],	filter?:ValueTypes["VeterinaryWhere"] | null},ValueTypes["Veterinary"]],
listVeterinary?: [{	filter?:ValueTypes["VeterinaryWhere"] | null,	orderBy?:ValueTypes["VeterinaryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Veterinary"]],
paginateVeterinary?: [{	filter?:ValueTypes["VeterinaryWhere"] | null,	orderBy?:ValueTypes["VeterinaryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["VeterinaryConnection"]],
validateCreateVeterinary?: [{	data:ValueTypes["VeterinaryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVeterinary?: [{	by:ValueTypes["VeterinaryUniqueWhere"],	data:ValueTypes["VeterinaryUpdateInput"]},ValueTypes["_ValidationResult"]],
getNutritionalValueOfProduct?: [{	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null},ValueTypes["NutritionalValueOfProduct"]],
listNutritionalValueOfProduct?: [{	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null,	orderBy?:ValueTypes["NutritionalValueOfProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NutritionalValueOfProduct"]],
paginateNutritionalValueOfProduct?: [{	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null,	orderBy?:ValueTypes["NutritionalValueOfProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NutritionalValueOfProductConnection"]],
validateCreateNutritionalValueOfProduct?: [{	data:ValueTypes["NutritionalValueOfProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNutritionalValueOfProduct?: [{	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],	data:ValueTypes["NutritionalValueOfProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getReview?: [{	by:ValueTypes["ReviewUniqueWhere"],	filter?:ValueTypes["ReviewWhere"] | null},ValueTypes["Review"]],
listReview?: [{	filter?:ValueTypes["ReviewWhere"] | null,	orderBy?:ValueTypes["ReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Review"]],
paginateReview?: [{	filter?:ValueTypes["ReviewWhere"] | null,	orderBy?:ValueTypes["ReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ReviewConnection"]],
validateCreateReview?: [{	data:ValueTypes["ReviewCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateReview?: [{	by:ValueTypes["ReviewUniqueWhere"],	data:ValueTypes["ReviewUpdateInput"]},ValueTypes["_ValidationResult"]],
getDogBodyType?: [{	by:ValueTypes["DogBodyTypeUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null},ValueTypes["DogBodyType"]],
listDogBodyType?: [{	filter?:ValueTypes["DogBodyTypeWhere"] | null,	orderBy?:ValueTypes["DogBodyTypeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogBodyType"]],
paginateDogBodyType?: [{	filter?:ValueTypes["DogBodyTypeWhere"] | null,	orderBy?:ValueTypes["DogBodyTypeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogBodyTypeConnection"]],
validateCreateDogBodyType?: [{	data:ValueTypes["DogBodyTypeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDogBodyType?: [{	by:ValueTypes["DogBodyTypeUniqueWhere"],	data:ValueTypes["DogBodyTypeUpdateInput"]},ValueTypes["_ValidationResult"]],
getDogBodyTypeCategory?: [{	by:ValueTypes["DogBodyTypeCategoryUniqueWhere"],	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null},ValueTypes["DogBodyTypeCategory"]],
listDogBodyTypeCategory?: [{	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null,	orderBy?:ValueTypes["DogBodyTypeCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogBodyTypeCategory"]],
paginateDogBodyTypeCategory?: [{	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null,	orderBy?:ValueTypes["DogBodyTypeCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogBodyTypeCategoryConnection"]],
validateCreateDogBodyTypeCategory?: [{	data:ValueTypes["DogBodyTypeCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDogBodyTypeCategory?: [{	by:ValueTypes["DogBodyTypeCategoryUniqueWhere"],	data:ValueTypes["DogBodyTypeCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["Url"]],
listUrl?: [{	filter?:ValueTypes["UrlWhere"] | null,	orderBy?:ValueTypes["UrlOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Url"]],
paginateUrl?: [{	filter?:ValueTypes["UrlWhere"] | null,	orderBy?:ValueTypes["UrlOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UrlConnection"]],
validateCreateUrl?: [{	data:ValueTypes["UrlCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	data:ValueTypes["UrlUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null},ValueTypes["FooterLink"]],
listFooterLink?: [{	filter?:ValueTypes["FooterLinkWhere"] | null,	orderBy?:ValueTypes["FooterLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLink"]],
paginateFooterLink?: [{	filter?:ValueTypes["FooterLinkWhere"] | null,	orderBy?:ValueTypes["FooterLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLinkConnection"]],
validateCreateFooterLink?: [{	data:ValueTypes["FooterLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	data:ValueTypes["FooterLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getBrandsPage?: [{	by:ValueTypes["BrandsPageUniqueWhere"],	filter?:ValueTypes["BrandsPageWhere"] | null},ValueTypes["BrandsPage"]],
listBrandsPage?: [{	filter?:ValueTypes["BrandsPageWhere"] | null,	orderBy?:ValueTypes["BrandsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandsPage"]],
paginateBrandsPage?: [{	filter?:ValueTypes["BrandsPageWhere"] | null,	orderBy?:ValueTypes["BrandsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandsPageConnection"]],
validateCreateBrandsPage?: [{	data:ValueTypes["BrandsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBrandsPage?: [{	by:ValueTypes["BrandsPageUniqueWhere"],	data:ValueTypes["BrandsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
listHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePage"]],
paginateHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getIngredientsPage?: [{	by:ValueTypes["IngredientsPageUniqueWhere"],	filter?:ValueTypes["IngredientsPageWhere"] | null},ValueTypes["IngredientsPage"]],
listIngredientsPage?: [{	filter?:ValueTypes["IngredientsPageWhere"] | null,	orderBy?:ValueTypes["IngredientsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["IngredientsPage"]],
paginateIngredientsPage?: [{	filter?:ValueTypes["IngredientsPageWhere"] | null,	orderBy?:ValueTypes["IngredientsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["IngredientsPageConnection"]],
validateCreateIngredientsPage?: [{	data:ValueTypes["IngredientsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIngredientsPage?: [{	by:ValueTypes["IngredientsPageUniqueWhere"],	data:ValueTypes["IngredientsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductReview?: [{	by:ValueTypes["ProductReviewUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReview"]],
listProductReview?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReview"]],
paginateProductReview?: [{	filter?:ValueTypes["ProductReviewWhere"] | null,	orderBy?:ValueTypes["ProductReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewConnection"]],
validateCreateProductReview?: [{	data:ValueTypes["ProductReviewCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductReview?: [{	by:ValueTypes["ProductReviewUniqueWhere"],	data:ValueTypes["ProductReviewUpdateInput"]},ValueTypes["_ValidationResult"]],
getScore?: [{	by:ValueTypes["ScoreUniqueWhere"],	filter?:ValueTypes["ScoreWhere"] | null},ValueTypes["Score"]],
listScore?: [{	filter?:ValueTypes["ScoreWhere"] | null,	orderBy?:ValueTypes["ScoreOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Score"]],
paginateScore?: [{	filter?:ValueTypes["ScoreWhere"] | null,	orderBy?:ValueTypes["ScoreOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ScoreConnection"]],
validateCreateScore?: [{	data:ValueTypes["ScoreCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateScore?: [{	by:ValueTypes["ScoreUniqueWhere"],	data:ValueTypes["ScoreUpdateInput"]},ValueTypes["_ValidationResult"]],
getAge?: [{	by:ValueTypes["AgeUniqueWhere"],	filter?:ValueTypes["AgeWhere"] | null},ValueTypes["Age"]],
listAge?: [{	filter?:ValueTypes["AgeWhere"] | null,	orderBy?:ValueTypes["AgeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Age"]],
paginateAge?: [{	filter?:ValueTypes["AgeWhere"] | null,	orderBy?:ValueTypes["AgeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AgeConnection"]],
validateCreateAge?: [{	data:ValueTypes["AgeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAge?: [{	by:ValueTypes["AgeUniqueWhere"],	data:ValueTypes["AgeUpdateInput"]},ValueTypes["_ValidationResult"]],
getCountry?: [{	by:ValueTypes["CountryUniqueWhere"],	filter?:ValueTypes["CountryWhere"] | null},ValueTypes["Country"]],
listCountry?: [{	filter?:ValueTypes["CountryWhere"] | null,	orderBy?:ValueTypes["CountryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Country"]],
paginateCountry?: [{	filter?:ValueTypes["CountryWhere"] | null,	orderBy?:ValueTypes["CountryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CountryConnection"]],
validateCreateCountry?: [{	data:ValueTypes["CountryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCountry?: [{	by:ValueTypes["CountryUniqueWhere"],	data:ValueTypes["CountryUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostReview?: [{	by:ValueTypes["BlogPostReviewUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReview"]],
listBlogPostReview?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostReview"]],
paginateBlogPostReview?: [{	filter?:ValueTypes["BlogPostReviewWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostReviewConnection"]],
validateCreateBlogPostReview?: [{	data:ValueTypes["BlogPostReviewCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostReview?: [{	by:ValueTypes["BlogPostReviewUniqueWhere"],	data:ValueTypes["BlogPostReviewUpdateInput"]},ValueTypes["_ValidationResult"]],
getDogActivity?: [{	by:ValueTypes["DogActivityUniqueWhere"],	filter?:ValueTypes["DogActivityWhere"] | null},ValueTypes["DogActivity"]],
listDogActivity?: [{	filter?:ValueTypes["DogActivityWhere"] | null,	orderBy?:ValueTypes["DogActivityOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogActivity"]],
paginateDogActivity?: [{	filter?:ValueTypes["DogActivityWhere"] | null,	orderBy?:ValueTypes["DogActivityOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogActivityConnection"]],
validateCreateDogActivity?: [{	data:ValueTypes["DogActivityCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDogActivity?: [{	by:ValueTypes["DogActivityUniqueWhere"],	data:ValueTypes["DogActivityUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocial?: [{	by:ValueTypes["SocialUniqueWhere"],	filter?:ValueTypes["SocialWhere"] | null},ValueTypes["Social"]],
listSocial?: [{	filter?:ValueTypes["SocialWhere"] | null,	orderBy?:ValueTypes["SocialOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Social"]],
paginateSocial?: [{	filter?:ValueTypes["SocialWhere"] | null,	orderBy?:ValueTypes["SocialOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialConnection"]],
validateCreateSocial?: [{	data:ValueTypes["SocialCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocial?: [{	by:ValueTypes["SocialUniqueWhere"],	data:ValueTypes["SocialUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReferenceGalleryImage?: [{	by:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null},ValueTypes["ContentReferenceGalleryImage"]],
listContentReferenceGalleryImage?: [{	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null,	orderBy?:ValueTypes["ContentReferenceGalleryImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReferenceGalleryImage"]],
paginateContentReferenceGalleryImage?: [{	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null,	orderBy?:ValueTypes["ContentReferenceGalleryImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceGalleryImageConnection"]],
validateCreateContentReferenceGalleryImage?: [{	data:ValueTypes["ContentReferenceGalleryImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReferenceGalleryImage?: [{	by:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],	data:ValueTypes["ContentReferenceGalleryImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getItem?: [{	by:ValueTypes["ItemUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["Item"]],
listItem?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Item"]],
paginateItem?: [{	filter?:ValueTypes["ItemWhere"] | null,	orderBy?:ValueTypes["ItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemConnection"]],
validateCreateItem?: [{	data:ValueTypes["ItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItem?: [{	by:ValueTypes["ItemUniqueWhere"],	data:ValueTypes["ItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemSubCategory?: [{	by:ValueTypes["ItemSubCategoryUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategory"]],
listItemSubCategory?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemSubCategory"]],
paginateItemSubCategory?: [{	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	orderBy?:ValueTypes["ItemSubCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemSubCategoryConnection"]],
validateCreateItemSubCategory?: [{	data:ValueTypes["ItemSubCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemSubCategory?: [{	by:ValueTypes["ItemSubCategoryUniqueWhere"],	data:ValueTypes["ItemSubCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemCategory?: [{	by:ValueTypes["ItemCategoryUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategory"]],
listItemCategory?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemCategory"]],
paginateItemCategory?: [{	filter?:ValueTypes["ItemCategoryWhere"] | null,	orderBy?:ValueTypes["ItemCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemCategoryConnection"]],
validateCreateItemCategory?: [{	data:ValueTypes["ItemCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemCategory?: [{	by:ValueTypes["ItemCategoryUniqueWhere"],	data:ValueTypes["ItemCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemFlavorCategory?: [{	by:ValueTypes["ItemFlavorCategoryUniqueWhere"],	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null},ValueTypes["ItemFlavorCategory"]],
listItemFlavorCategory?: [{	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null,	orderBy?:ValueTypes["ItemFlavorCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemFlavorCategory"]],
paginateItemFlavorCategory?: [{	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null,	orderBy?:ValueTypes["ItemFlavorCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemFlavorCategoryConnection"]],
validateCreateItemFlavorCategory?: [{	data:ValueTypes["ItemFlavorCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemFlavorCategory?: [{	by:ValueTypes["ItemFlavorCategoryUniqueWhere"],	data:ValueTypes["ItemFlavorCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemDeclensionFourthVariant?: [{	by:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariant"]],
listItemDeclensionFourthVariant?: [{	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,	orderBy?:ValueTypes["ItemDeclensionFourthVariantOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemDeclensionFourthVariant"]],
paginateItemDeclensionFourthVariant?: [{	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,	orderBy?:ValueTypes["ItemDeclensionFourthVariantOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemDeclensionFourthVariantConnection"]],
validateCreateItemDeclensionFourthVariant?: [{	data:ValueTypes["ItemDeclensionFourthVariantCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemDeclensionFourthVariant?: [{	by:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],	data:ValueTypes["ItemDeclensionFourthVariantUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemDeclensionSeventhVariant?: [{	by:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null},ValueTypes["ItemDeclensionSeventhVariant"]],
listItemDeclensionSeventhVariant?: [{	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null,	orderBy?:ValueTypes["ItemDeclensionSeventhVariantOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemDeclensionSeventhVariant"]],
paginateItemDeclensionSeventhVariant?: [{	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null,	orderBy?:ValueTypes["ItemDeclensionSeventhVariantOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemDeclensionSeventhVariantConnection"]],
validateCreateItemDeclensionSeventhVariant?: [{	data:ValueTypes["ItemDeclensionSeventhVariantCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemDeclensionSeventhVariant?: [{	by:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"],	data:ValueTypes["ItemDeclensionSeventhVariantUpdateInput"]},ValueTypes["_ValidationResult"]],
getMediaCard?: [{	by:ValueTypes["MediaCardUniqueWhere"],	filter?:ValueTypes["MediaCardWhere"] | null},ValueTypes["MediaCard"]],
listMediaCard?: [{	filter?:ValueTypes["MediaCardWhere"] | null,	orderBy?:ValueTypes["MediaCardOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MediaCard"]],
paginateMediaCard?: [{	filter?:ValueTypes["MediaCardWhere"] | null,	orderBy?:ValueTypes["MediaCardOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediaCardConnection"]],
validateCreateMediaCard?: [{	data:ValueTypes["MediaCardCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMediaCard?: [{	by:ValueTypes["MediaCardUniqueWhere"],	data:ValueTypes["MediaCardUpdateInput"]},ValueTypes["_ValidationResult"]],
getInfoCard?: [{	by:ValueTypes["InfoCardUniqueWhere"],	filter?:ValueTypes["InfoCardWhere"] | null},ValueTypes["InfoCard"]],
listInfoCard?: [{	filter?:ValueTypes["InfoCardWhere"] | null,	orderBy?:ValueTypes["InfoCardOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["InfoCard"]],
paginateInfoCard?: [{	filter?:ValueTypes["InfoCardWhere"] | null,	orderBy?:ValueTypes["InfoCardOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["InfoCardConnection"]],
validateCreateInfoCard?: [{	data:ValueTypes["InfoCardCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateInfoCard?: [{	by:ValueTypes["InfoCardUniqueWhere"],	data:ValueTypes["InfoCardUpdateInput"]},ValueTypes["_ValidationResult"]],
getNumberedCard?: [{	by:ValueTypes["NumberedCardUniqueWhere"],	filter?:ValueTypes["NumberedCardWhere"] | null},ValueTypes["NumberedCard"]],
listNumberedCard?: [{	filter?:ValueTypes["NumberedCardWhere"] | null,	orderBy?:ValueTypes["NumberedCardOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NumberedCard"]],
paginateNumberedCard?: [{	filter?:ValueTypes["NumberedCardWhere"] | null,	orderBy?:ValueTypes["NumberedCardOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NumberedCardConnection"]],
validateCreateNumberedCard?: [{	data:ValueTypes["NumberedCardCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNumberedCard?: [{	by:ValueTypes["NumberedCardUniqueWhere"],	data:ValueTypes["NumberedCardUpdateInput"]},ValueTypes["_ValidationResult"]],
getRegisterClaim?: [{	by:ValueTypes["RegisterClaimUniqueWhere"],	filter?:ValueTypes["RegisterClaimWhere"] | null},ValueTypes["RegisterClaim"]],
listRegisterClaim?: [{	filter?:ValueTypes["RegisterClaimWhere"] | null,	orderBy?:ValueTypes["RegisterClaimOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RegisterClaim"]],
paginateRegisterClaim?: [{	filter?:ValueTypes["RegisterClaimWhere"] | null,	orderBy?:ValueTypes["RegisterClaimOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RegisterClaimConnection"]],
validateCreateRegisterClaim?: [{	data:ValueTypes["RegisterClaimCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRegisterClaim?: [{	by:ValueTypes["RegisterClaimUniqueWhere"],	data:ValueTypes["RegisterClaimUpdateInput"]},ValueTypes["_ValidationResult"]],
getBlogPostReviewReaction?: [{	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null},ValueTypes["BlogPostReviewReaction"]],
listBlogPostReviewReaction?: [{	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewReactionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostReviewReaction"]],
paginateBlogPostReviewReaction?: [{	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewReactionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostReviewReactionConnection"]],
validateCreateBlogPostReviewReaction?: [{	data:ValueTypes["BlogPostReviewReactionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBlogPostReviewReaction?: [{	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],	data:ValueTypes["BlogPostReviewReactionUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductReviewReaction?: [{	by:ValueTypes["ProductReviewReactionUniqueWhere"],	filter?:ValueTypes["ProductReviewReactionWhere"] | null},ValueTypes["ProductReviewReaction"]],
listProductReviewReaction?: [{	filter?:ValueTypes["ProductReviewReactionWhere"] | null,	orderBy?:ValueTypes["ProductReviewReactionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReviewReaction"]],
paginateProductReviewReaction?: [{	filter?:ValueTypes["ProductReviewReactionWhere"] | null,	orderBy?:ValueTypes["ProductReviewReactionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewReactionConnection"]],
validateCreateProductReviewReaction?: [{	data:ValueTypes["ProductReviewReactionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductReviewReaction?: [{	by:ValueTypes["ProductReviewReactionUniqueWhere"],	data:ValueTypes["ProductReviewReactionUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductPackage?: [{	by:ValueTypes["ProductPackageUniqueWhere"],	filter?:ValueTypes["ProductPackageWhere"] | null},ValueTypes["ProductPackage"]],
listProductPackage?: [{	filter?:ValueTypes["ProductPackageWhere"] | null,	orderBy?:ValueTypes["ProductPackageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductPackage"]],
paginateProductPackage?: [{	filter?:ValueTypes["ProductPackageWhere"] | null,	orderBy?:ValueTypes["ProductPackageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductPackageConnection"]],
validateCreateProductPackage?: [{	data:ValueTypes["ProductPackageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductPackage?: [{	by:ValueTypes["ProductPackageUniqueWhere"],	data:ValueTypes["ProductPackageUpdateInput"]},ValueTypes["_ValidationResult"]],
getBrandManufacturer?: [{	by:ValueTypes["BrandManufacturerUniqueWhere"],	filter?:ValueTypes["BrandManufacturerWhere"] | null},ValueTypes["BrandManufacturer"]],
listBrandManufacturer?: [{	filter?:ValueTypes["BrandManufacturerWhere"] | null,	orderBy?:ValueTypes["BrandManufacturerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandManufacturer"]],
paginateBrandManufacturer?: [{	filter?:ValueTypes["BrandManufacturerWhere"] | null,	orderBy?:ValueTypes["BrandManufacturerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandManufacturerConnection"]],
validateCreateBrandManufacturer?: [{	data:ValueTypes["BrandManufacturerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBrandManufacturer?: [{	by:ValueTypes["BrandManufacturerUniqueWhere"],	data:ValueTypes["BrandManufacturerUpdateInput"]},ValueTypes["_ValidationResult"]],
getElement?: [{	by:ValueTypes["ElementUniqueWhere"],	filter?:ValueTypes["ElementWhere"] | null},ValueTypes["Element"]],
listElement?: [{	filter?:ValueTypes["ElementWhere"] | null,	orderBy?:ValueTypes["ElementOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Element"]],
paginateElement?: [{	filter?:ValueTypes["ElementWhere"] | null,	orderBy?:ValueTypes["ElementOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ElementConnection"]],
validateCreateElement?: [{	data:ValueTypes["ElementCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateElement?: [{	by:ValueTypes["ElementUniqueWhere"],	data:ValueTypes["ElementUpdateInput"]},ValueTypes["_ValidationResult"]],
getElementOfProduct?: [{	by:ValueTypes["ElementOfProductUniqueWhere"],	filter?:ValueTypes["ElementOfProductWhere"] | null},ValueTypes["ElementOfProduct"]],
listElementOfProduct?: [{	filter?:ValueTypes["ElementOfProductWhere"] | null,	orderBy?:ValueTypes["ElementOfProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ElementOfProduct"]],
paginateElementOfProduct?: [{	filter?:ValueTypes["ElementOfProductWhere"] | null,	orderBy?:ValueTypes["ElementOfProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ElementOfProductConnection"]],
validateCreateElementOfProduct?: [{	data:ValueTypes["ElementOfProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateElementOfProduct?: [{	by:ValueTypes["ElementOfProductUniqueWhere"],	data:ValueTypes["ElementOfProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getSuitabilityCategory?: [{	by:ValueTypes["SuitabilityCategoryUniqueWhere"],	filter?:ValueTypes["SuitabilityCategoryWhere"] | null},ValueTypes["SuitabilityCategory"]],
listSuitabilityCategory?: [{	filter?:ValueTypes["SuitabilityCategoryWhere"] | null,	orderBy?:ValueTypes["SuitabilityCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SuitabilityCategory"]],
paginateSuitabilityCategory?: [{	filter?:ValueTypes["SuitabilityCategoryWhere"] | null,	orderBy?:ValueTypes["SuitabilityCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SuitabilityCategoryConnection"]],
validateCreateSuitabilityCategory?: [{	data:ValueTypes["SuitabilityCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSuitabilityCategory?: [{	by:ValueTypes["SuitabilityCategoryUniqueWhere"],	data:ValueTypes["SuitabilityCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductFeature?: [{	by:ValueTypes["ProductFeatureUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null},ValueTypes["ProductFeature"]],
listProductFeature?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFeature"]],
paginateProductFeature?: [{	filter?:ValueTypes["ProductFeatureWhere"] | null,	orderBy?:ValueTypes["ProductFeatureOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFeatureConnection"]],
validateCreateProductFeature?: [{	data:ValueTypes["ProductFeatureCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductFeature?: [{	by:ValueTypes["ProductFeatureUniqueWhere"],	data:ValueTypes["ProductFeatureUpdateInput"]},ValueTypes["_ValidationResult"]],
getSuitabilityItem?: [{	by:ValueTypes["SuitabilityItemUniqueWhere"],	filter?:ValueTypes["SuitabilityItemWhere"] | null},ValueTypes["SuitabilityItem"]],
listSuitabilityItem?: [{	filter?:ValueTypes["SuitabilityItemWhere"] | null,	orderBy?:ValueTypes["SuitabilityItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SuitabilityItem"]],
paginateSuitabilityItem?: [{	filter?:ValueTypes["SuitabilityItemWhere"] | null,	orderBy?:ValueTypes["SuitabilityItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SuitabilityItemConnection"]],
validateCreateSuitabilityItem?: [{	data:ValueTypes["SuitabilityItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSuitabilityItem?: [{	by:ValueTypes["SuitabilityItemUniqueWhere"],	data:ValueTypes["SuitabilityItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getRegion?: [{	by:ValueTypes["RegionUniqueWhere"],	filter?:ValueTypes["RegionWhere"] | null},ValueTypes["Region"]],
listRegion?: [{	filter?:ValueTypes["RegionWhere"] | null,	orderBy?:ValueTypes["RegionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Region"]],
paginateRegion?: [{	filter?:ValueTypes["RegionWhere"] | null,	orderBy?:ValueTypes["RegionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RegionConnection"]],
validateCreateRegion?: [{	data:ValueTypes["RegionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRegion?: [{	by:ValueTypes["RegionUniqueWhere"],	data:ValueTypes["RegionUpdateInput"]},ValueTypes["_ValidationResult"]],
getGranuleSize?: [{	by:ValueTypes["GranuleSizeUniqueWhere"],	filter?:ValueTypes["GranuleSizeWhere"] | null},ValueTypes["GranuleSize"]],
listGranuleSize?: [{	filter?:ValueTypes["GranuleSizeWhere"] | null,	orderBy?:ValueTypes["GranuleSizeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GranuleSize"]],
paginateGranuleSize?: [{	filter?:ValueTypes["GranuleSizeWhere"] | null,	orderBy?:ValueTypes["GranuleSizeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GranuleSizeConnection"]],
validateCreateGranuleSize?: [{	data:ValueTypes["GranuleSizeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGranuleSize?: [{	by:ValueTypes["GranuleSizeUniqueWhere"],	data:ValueTypes["GranuleSizeUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemAlias?: [{	by:ValueTypes["ItemAliasUniqueWhere"],	filter?:ValueTypes["ItemAliasWhere"] | null},ValueTypes["ItemAlias"]],
listItemAlias?: [{	filter?:ValueTypes["ItemAliasWhere"] | null,	orderBy?:ValueTypes["ItemAliasOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemAlias"]],
paginateItemAlias?: [{	filter?:ValueTypes["ItemAliasWhere"] | null,	orderBy?:ValueTypes["ItemAliasOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemAliasConnection"]],
validateCreateItemAlias?: [{	data:ValueTypes["ItemAliasCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemAlias?: [{	by:ValueTypes["ItemAliasUniqueWhere"],	data:ValueTypes["ItemAliasUpdateInput"]},ValueTypes["_ValidationResult"]],
getSemanticKey?: [{	by:ValueTypes["SemanticKeyUniqueWhere"],	filter?:ValueTypes["SemanticKeyWhere"] | null},ValueTypes["SemanticKey"]],
listSemanticKey?: [{	filter?:ValueTypes["SemanticKeyWhere"] | null,	orderBy?:ValueTypes["SemanticKeyOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SemanticKey"]],
paginateSemanticKey?: [{	filter?:ValueTypes["SemanticKeyWhere"] | null,	orderBy?:ValueTypes["SemanticKeyOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SemanticKeyConnection"]],
validateCreateSemanticKey?: [{	data:ValueTypes["SemanticKeyCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSemanticKey?: [{	by:ValueTypes["SemanticKeyUniqueWhere"],	data:ValueTypes["SemanticKeyUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductFlag?: [{	by:ValueTypes["ProductFlagUniqueWhere"],	filter?:ValueTypes["ProductFlagWhere"] | null},ValueTypes["ProductFlag"]],
listProductFlag?: [{	filter?:ValueTypes["ProductFlagWhere"] | null,	orderBy?:ValueTypes["ProductFlagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFlag"]],
paginateProductFlag?: [{	filter?:ValueTypes["ProductFlagWhere"] | null,	orderBy?:ValueTypes["ProductFlagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFlagConnection"]],
validateCreateProductFlag?: [{	data:ValueTypes["ProductFlagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductFlag?: [{	by:ValueTypes["ProductFlagUniqueWhere"],	data:ValueTypes["ProductFlagUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductFlagOfProduct?: [{	by:ValueTypes["ProductFlagOfProductUniqueWhere"],	filter?:ValueTypes["ProductFlagOfProductWhere"] | null},ValueTypes["ProductFlagOfProduct"]],
listProductFlagOfProduct?: [{	filter?:ValueTypes["ProductFlagOfProductWhere"] | null,	orderBy?:ValueTypes["ProductFlagOfProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductFlagOfProduct"]],
paginateProductFlagOfProduct?: [{	filter?:ValueTypes["ProductFlagOfProductWhere"] | null,	orderBy?:ValueTypes["ProductFlagOfProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductFlagOfProductConnection"]],
validateCreateProductFlagOfProduct?: [{	data:ValueTypes["ProductFlagOfProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductFlagOfProduct?: [{	by:ValueTypes["ProductFlagOfProductUniqueWhere"],	data:ValueTypes["ProductFlagOfProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductEvaluation?: [{	by:ValueTypes["ProductEvaluationUniqueWhere"],	filter?:ValueTypes["ProductEvaluationWhere"] | null},ValueTypes["ProductEvaluation"]],
listProductEvaluation?: [{	filter?:ValueTypes["ProductEvaluationWhere"] | null,	orderBy?:ValueTypes["ProductEvaluationOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductEvaluation"]],
paginateProductEvaluation?: [{	filter?:ValueTypes["ProductEvaluationWhere"] | null,	orderBy?:ValueTypes["ProductEvaluationOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductEvaluationConnection"]],
validateCreateProductEvaluation?: [{	data:ValueTypes["ProductEvaluationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductEvaluation?: [{	by:ValueTypes["ProductEvaluationUniqueWhere"],	data:ValueTypes["ProductEvaluationUpdateInput"]},ValueTypes["_ValidationResult"]],
getAd?: [{	by:ValueTypes["AdUniqueWhere"],	filter?:ValueTypes["AdWhere"] | null},ValueTypes["Ad"]],
listAd?: [{	filter?:ValueTypes["AdWhere"] | null,	orderBy?:ValueTypes["AdOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Ad"]],
paginateAd?: [{	filter?:ValueTypes["AdWhere"] | null,	orderBy?:ValueTypes["AdOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AdConnection"]],
validateCreateAd?: [{	data:ValueTypes["AdCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAd?: [{	by:ValueTypes["AdUniqueWhere"],	data:ValueTypes["AdUpdateInput"]},ValueTypes["_ValidationResult"]],
getEvaluationInfo?: [{	by:ValueTypes["EvaluationInfoUniqueWhere"],	filter?:ValueTypes["EvaluationInfoWhere"] | null},ValueTypes["EvaluationInfo"]],
listEvaluationInfo?: [{	filter?:ValueTypes["EvaluationInfoWhere"] | null,	orderBy?:ValueTypes["EvaluationInfoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EvaluationInfo"]],
paginateEvaluationInfo?: [{	filter?:ValueTypes["EvaluationInfoWhere"] | null,	orderBy?:ValueTypes["EvaluationInfoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EvaluationInfoConnection"]],
validateCreateEvaluationInfo?: [{	data:ValueTypes["EvaluationInfoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEvaluationInfo?: [{	by:ValueTypes["EvaluationInfoUniqueWhere"],	data:ValueTypes["EvaluationInfoUpdateInput"]},ValueTypes["_ValidationResult"]],
getConsumptionMessage?: [{	by:ValueTypes["ConsumptionMessageUniqueWhere"],	filter?:ValueTypes["ConsumptionMessageWhere"] | null},ValueTypes["ConsumptionMessage"]],
listConsumptionMessage?: [{	filter?:ValueTypes["ConsumptionMessageWhere"] | null,	orderBy?:ValueTypes["ConsumptionMessageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ConsumptionMessage"]],
paginateConsumptionMessage?: [{	filter?:ValueTypes["ConsumptionMessageWhere"] | null,	orderBy?:ValueTypes["ConsumptionMessageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ConsumptionMessageConnection"]],
validateCreateConsumptionMessage?: [{	data:ValueTypes["ConsumptionMessageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateConsumptionMessage?: [{	by:ValueTypes["ConsumptionMessageUniqueWhere"],	data:ValueTypes["ConsumptionMessageUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentText?: [{	by:ValueTypes["ContentTextUniqueWhere"],	filter?:ValueTypes["ContentTextWhere"] | null},ValueTypes["ContentText"]],
listContentText?: [{	filter?:ValueTypes["ContentTextWhere"] | null,	orderBy?:ValueTypes["ContentTextOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentText"]],
paginateContentText?: [{	filter?:ValueTypes["ContentTextWhere"] | null,	orderBy?:ValueTypes["ContentTextOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentTextConnection"]],
validateCreateContentText?: [{	data:ValueTypes["ContentTextCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentText?: [{	by:ValueTypes["ContentTextUniqueWhere"],	data:ValueTypes["ContentTextUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentTextBlock?: [{	by:ValueTypes["ContentTextBlockUniqueWhere"],	filter?:ValueTypes["ContentTextBlockWhere"] | null},ValueTypes["ContentTextBlock"]],
listContentTextBlock?: [{	filter?:ValueTypes["ContentTextBlockWhere"] | null,	orderBy?:ValueTypes["ContentTextBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentTextBlock"]],
paginateContentTextBlock?: [{	filter?:ValueTypes["ContentTextBlockWhere"] | null,	orderBy?:ValueTypes["ContentTextBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentTextBlockConnection"]],
validateCreateContentTextBlock?: [{	data:ValueTypes["ContentTextBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentTextBlock?: [{	by:ValueTypes["ContentTextBlockUniqueWhere"],	data:ValueTypes["ContentTextBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductReviewStats?: [{	by:ValueTypes["ProductReviewStatsUniqueWhere"],	filter?:ValueTypes["ProductReviewStatsWhere"] | null},ValueTypes["ProductReviewStats"]],
listProductReviewStats?: [{	filter?:ValueTypes["ProductReviewStatsWhere"] | null,	orderBy?:ValueTypes["ProductReviewStatsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductReviewStats"]],
paginateProductReviewStats?: [{	filter?:ValueTypes["ProductReviewStatsWhere"] | null,	orderBy?:ValueTypes["ProductReviewStatsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductReviewStatsConnection"]],
getBlogPostReviewStats?: [{	by:ValueTypes["BlogPostReviewStatsUniqueWhere"],	filter?:ValueTypes["BlogPostReviewStatsWhere"] | null},ValueTypes["BlogPostReviewStats"]],
listBlogPostReviewStats?: [{	filter?:ValueTypes["BlogPostReviewStatsWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewStatsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BlogPostReviewStats"]],
paginateBlogPostReviewStats?: [{	filter?:ValueTypes["BlogPostReviewStatsWhere"] | null,	orderBy?:ValueTypes["BlogPostReviewStatsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BlogPostReviewStatsConnection"]],
getComparatorPage?: [{	by:ValueTypes["ComparatorPageUniqueWhere"],	filter?:ValueTypes["ComparatorPageWhere"] | null},ValueTypes["ComparatorPage"]],
listComparatorPage?: [{	filter?:ValueTypes["ComparatorPageWhere"] | null,	orderBy?:ValueTypes["ComparatorPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ComparatorPage"]],
paginateComparatorPage?: [{	filter?:ValueTypes["ComparatorPageWhere"] | null,	orderBy?:ValueTypes["ComparatorPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ComparatorPageConnection"]],
validateCreateComparatorPage?: [{	data:ValueTypes["ComparatorPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateComparatorPage?: [{	by:ValueTypes["ComparatorPageUniqueWhere"],	data:ValueTypes["ComparatorPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLoginPage?: [{	by:ValueTypes["LoginPageUniqueWhere"],	filter?:ValueTypes["LoginPageWhere"] | null},ValueTypes["LoginPage"]],
listLoginPage?: [{	filter?:ValueTypes["LoginPageWhere"] | null,	orderBy?:ValueTypes["LoginPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LoginPage"]],
paginateLoginPage?: [{	filter?:ValueTypes["LoginPageWhere"] | null,	orderBy?:ValueTypes["LoginPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LoginPageConnection"]],
validateCreateLoginPage?: [{	data:ValueTypes["LoginPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLoginPage?: [{	by:ValueTypes["LoginPageUniqueWhere"],	data:ValueTypes["LoginPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getRegisterPage?: [{	by:ValueTypes["RegisterPageUniqueWhere"],	filter?:ValueTypes["RegisterPageWhere"] | null},ValueTypes["RegisterPage"]],
listRegisterPage?: [{	filter?:ValueTypes["RegisterPageWhere"] | null,	orderBy?:ValueTypes["RegisterPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RegisterPage"]],
paginateRegisterPage?: [{	filter?:ValueTypes["RegisterPageWhere"] | null,	orderBy?:ValueTypes["RegisterPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RegisterPageConnection"]],
validateCreateRegisterPage?: [{	data:ValueTypes["RegisterPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRegisterPage?: [{	by:ValueTypes["RegisterPageUniqueWhere"],	data:ValueTypes["RegisterPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getResultsPage?: [{	by:ValueTypes["ResultsPageUniqueWhere"],	filter?:ValueTypes["ResultsPageWhere"] | null},ValueTypes["ResultsPage"]],
listResultsPage?: [{	filter?:ValueTypes["ResultsPageWhere"] | null,	orderBy?:ValueTypes["ResultsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ResultsPage"]],
paginateResultsPage?: [{	filter?:ValueTypes["ResultsPageWhere"] | null,	orderBy?:ValueTypes["ResultsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ResultsPageConnection"]],
validateCreateResultsPage?: [{	data:ValueTypes["ResultsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateResultsPage?: [{	by:ValueTypes["ResultsPageUniqueWhere"],	data:ValueTypes["ResultsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getSearchPage?: [{	by:ValueTypes["SearchPageUniqueWhere"],	filter?:ValueTypes["SearchPageWhere"] | null},ValueTypes["SearchPage"]],
listSearchPage?: [{	filter?:ValueTypes["SearchPageWhere"] | null,	orderBy?:ValueTypes["SearchPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SearchPage"]],
paginateSearchPage?: [{	filter?:ValueTypes["SearchPageWhere"] | null,	orderBy?:ValueTypes["SearchPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SearchPageConnection"]],
validateCreateSearchPage?: [{	data:ValueTypes["SearchPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSearchPage?: [{	by:ValueTypes["SearchPageUniqueWhere"],	data:ValueTypes["SearchPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getWizardPage?: [{	by:ValueTypes["WizardPageUniqueWhere"],	filter?:ValueTypes["WizardPageWhere"] | null},ValueTypes["WizardPage"]],
listWizardPage?: [{	filter?:ValueTypes["WizardPageWhere"] | null,	orderBy?:ValueTypes["WizardPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["WizardPage"]],
paginateWizardPage?: [{	filter?:ValueTypes["WizardPageWhere"] | null,	orderBy?:ValueTypes["WizardPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["WizardPageConnection"]],
validateCreateWizardPage?: [{	data:ValueTypes["WizardPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateWizardPage?: [{	by:ValueTypes["WizardPageUniqueWhere"],	data:ValueTypes["WizardPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getBreastfeedingCategory?: [{	by:ValueTypes["BreastfeedingCategoryUniqueWhere"],	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null},ValueTypes["BreastfeedingCategory"]],
listBreastfeedingCategory?: [{	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null,	orderBy?:ValueTypes["BreastfeedingCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BreastfeedingCategory"]],
paginateBreastfeedingCategory?: [{	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null,	orderBy?:ValueTypes["BreastfeedingCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BreastfeedingCategoryConnection"]],
validateCreateBreastfeedingCategory?: [{	data:ValueTypes["BreastfeedingCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBreastfeedingCategory?: [{	by:ValueTypes["BreastfeedingCategoryUniqueWhere"],	data:ValueTypes["BreastfeedingCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getDogReproduction?: [{	by:ValueTypes["DogReproductionUniqueWhere"],	filter?:ValueTypes["DogReproductionWhere"] | null},ValueTypes["DogReproduction"]],
listDogReproduction?: [{	filter?:ValueTypes["DogReproductionWhere"] | null,	orderBy?:ValueTypes["DogReproductionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DogReproduction"]],
paginateDogReproduction?: [{	filter?:ValueTypes["DogReproductionWhere"] | null,	orderBy?:ValueTypes["DogReproductionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DogReproductionConnection"]],
validateCreateDogReproduction?: [{	data:ValueTypes["DogReproductionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDogReproduction?: [{	by:ValueTypes["DogReproductionUniqueWhere"],	data:ValueTypes["DogReproductionUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactFormMessage?: [{	by:ValueTypes["ContactFormMessageUniqueWhere"],	filter?:ValueTypes["ContactFormMessageWhere"] | null},ValueTypes["ContactFormMessage"]],
listContactFormMessage?: [{	filter?:ValueTypes["ContactFormMessageWhere"] | null,	orderBy?:ValueTypes["ContactFormMessageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactFormMessage"]],
paginateContactFormMessage?: [{	filter?:ValueTypes["ContactFormMessageWhere"] | null,	orderBy?:ValueTypes["ContactFormMessageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactFormMessageConnection"]],
validateCreateContactFormMessage?: [{	data:ValueTypes["ContactFormMessageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactFormMessage?: [{	by:ValueTypes["ContactFormMessageUniqueWhere"],	data:ValueTypes["ContactFormMessageUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null},ValueTypes["ContactPage"]],
listContactPage?: [{	filter?:ValueTypes["ContactPageWhere"] | null,	orderBy?:ValueTypes["ContactPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactPage"]],
paginateContactPage?: [{	filter?:ValueTypes["ContactPageWhere"] | null,	orderBy?:ValueTypes["ContactPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactPageConnection"]],
validateCreateContactPage?: [{	data:ValueTypes["ContactPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	data:ValueTypes["ContactPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getBugReport?: [{	by:ValueTypes["BugReportUniqueWhere"],	filter?:ValueTypes["BugReportWhere"] | null},ValueTypes["BugReport"]],
listBugReport?: [{	filter?:ValueTypes["BugReportWhere"] | null,	orderBy?:ValueTypes["BugReportOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BugReport"]],
paginateBugReport?: [{	filter?:ValueTypes["BugReportWhere"] | null,	orderBy?:ValueTypes["BugReportOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BugReportConnection"]],
validateCreateBugReport?: [{	data:ValueTypes["BugReportCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBugReport?: [{	by:ValueTypes["BugReportUniqueWhere"],	data:ValueTypes["BugReportUpdateInput"]},ValueTypes["_ValidationResult"]],
getColor?: [{	by:ValueTypes["ColorUniqueWhere"],	filter?:ValueTypes["ColorWhere"] | null},ValueTypes["Color"]],
listColor?: [{	filter?:ValueTypes["ColorWhere"] | null,	orderBy?:ValueTypes["ColorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Color"]],
paginateColor?: [{	filter?:ValueTypes["ColorWhere"] | null,	orderBy?:ValueTypes["ColorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ColorConnection"]],
validateCreateColor?: [{	data:ValueTypes["ColorCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateColor?: [{	by:ValueTypes["ColorUniqueWhere"],	data:ValueTypes["ColorUpdateInput"]},ValueTypes["_ValidationResult"]],
getItemGroup?: [{	by:ValueTypes["ItemGroupUniqueWhere"],	filter?:ValueTypes["ItemGroupWhere"] | null},ValueTypes["ItemGroup"]],
listItemGroup?: [{	filter?:ValueTypes["ItemGroupWhere"] | null,	orderBy?:ValueTypes["ItemGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ItemGroup"]],
paginateItemGroup?: [{	filter?:ValueTypes["ItemGroupWhere"] | null,	orderBy?:ValueTypes["ItemGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ItemGroupConnection"]],
validateCreateItemGroup?: [{	data:ValueTypes["ItemGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateItemGroup?: [{	by:ValueTypes["ItemGroupUniqueWhere"],	data:ValueTypes["ItemGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getSearchResult?: [{	by:ValueTypes["SearchResultUniqueWhere"],	filter?:ValueTypes["SearchResultWhere"] | null},ValueTypes["SearchResult"]],
listSearchResult?: [{	filter?:ValueTypes["SearchResultWhere"] | null,	orderBy?:ValueTypes["SearchResultOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SearchResult"]],
paginateSearchResult?: [{	filter?:ValueTypes["SearchResultWhere"] | null,	orderBy?:ValueTypes["SearchResultOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SearchResultConnection"]],
getProductEvaluationSummary?: [{	by:ValueTypes["ProductEvaluationSummaryUniqueWhere"],	filter?:ValueTypes["ProductEvaluationSummaryWhere"] | null},ValueTypes["ProductEvaluationSummary"]],
listProductEvaluationSummary?: [{	filter?:ValueTypes["ProductEvaluationSummaryWhere"] | null,	orderBy?:ValueTypes["ProductEvaluationSummaryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductEvaluationSummary"]],
paginateProductEvaluationSummary?: [{	filter?:ValueTypes["ProductEvaluationSummaryWhere"] | null,	orderBy?:ValueTypes["ProductEvaluationSummaryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductEvaluationSummaryConnection"]],
validateCreateProductEvaluationSummary?: [{	data:ValueTypes["ProductEvaluationSummaryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductEvaluationSummary?: [{	by:ValueTypes["ProductEvaluationSummaryUniqueWhere"],	data:ValueTypes["ProductEvaluationSummaryUpdateInput"]},ValueTypes["_ValidationResult"]],
getProtectedAction?: [{	by:ValueTypes["ProtectedActionUniqueWhere"],	filter?:ValueTypes["ProtectedActionWhere"] | null},ValueTypes["ProtectedAction"]],
listProtectedAction?: [{	filter?:ValueTypes["ProtectedActionWhere"] | null,	orderBy?:ValueTypes["ProtectedActionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProtectedAction"]],
paginateProtectedAction?: [{	filter?:ValueTypes["ProtectedActionWhere"] | null,	orderBy?:ValueTypes["ProtectedActionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProtectedActionConnection"]],
validateCreateProtectedAction?: [{	data:ValueTypes["ProtectedActionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProtectedAction?: [{	by:ValueTypes["ProtectedActionUniqueWhere"],	data:ValueTypes["ProtectedActionUpdateInput"]},ValueTypes["_ValidationResult"]],
getBrandAlias?: [{	by:ValueTypes["BrandAliasUniqueWhere"],	filter?:ValueTypes["BrandAliasWhere"] | null},ValueTypes["BrandAlias"]],
listBrandAlias?: [{	filter?:ValueTypes["BrandAliasWhere"] | null,	orderBy?:ValueTypes["BrandAliasOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandAlias"]],
paginateBrandAlias?: [{	filter?:ValueTypes["BrandAliasWhere"] | null,	orderBy?:ValueTypes["BrandAliasOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandAliasConnection"]],
validateCreateBrandAlias?: [{	data:ValueTypes["BrandAliasCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBrandAlias?: [{	by:ValueTypes["BrandAliasUniqueWhere"],	data:ValueTypes["BrandAliasUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductAlias?: [{	by:ValueTypes["ProductAliasUniqueWhere"],	filter?:ValueTypes["ProductAliasWhere"] | null},ValueTypes["ProductAlias"]],
listProductAlias?: [{	filter?:ValueTypes["ProductAliasWhere"] | null,	orderBy?:ValueTypes["ProductAliasOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductAlias"]],
paginateProductAlias?: [{	filter?:ValueTypes["ProductAliasWhere"] | null,	orderBy?:ValueTypes["ProductAliasOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductAliasConnection"]],
validateCreateProductAlias?: [{	data:ValueTypes["ProductAliasCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductAlias?: [{	by:ValueTypes["ProductAliasUniqueWhere"],	data:ValueTypes["ProductAliasUpdateInput"]},ValueTypes["_ValidationResult"]],
getProductLineAlias?: [{	by:ValueTypes["ProductLineAliasUniqueWhere"],	filter?:ValueTypes["ProductLineAliasWhere"] | null},ValueTypes["ProductLineAlias"]],
listProductLineAlias?: [{	filter?:ValueTypes["ProductLineAliasWhere"] | null,	orderBy?:ValueTypes["ProductLineAliasOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductLineAlias"]],
paginateProductLineAlias?: [{	filter?:ValueTypes["ProductLineAliasWhere"] | null,	orderBy?:ValueTypes["ProductLineAliasOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductLineAliasConnection"]],
validateCreateProductLineAlias?: [{	data:ValueTypes["ProductLineAliasCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProductLineAlias?: [{	by:ValueTypes["ProductLineAliasUniqueWhere"],	data:ValueTypes["ProductLineAliasUpdateInput"]},ValueTypes["_ValidationResult"]],
getGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null},ValueTypes["GenericPage"]],
listGenericPage?: [{	filter?:ValueTypes["GenericPageWhere"] | null,	orderBy?:ValueTypes["GenericPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GenericPage"]],
paginateGenericPage?: [{	filter?:ValueTypes["GenericPageWhere"] | null,	orderBy?:ValueTypes["GenericPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GenericPageConnection"]],
validateCreateGenericPage?: [{	data:ValueTypes["GenericPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	data:ValueTypes["GenericPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentLinks?: [{	by:ValueTypes["ContentLinksUniqueWhere"],	filter?:ValueTypes["ContentLinksWhere"] | null},ValueTypes["ContentLinks"]],
listContentLinks?: [{	filter?:ValueTypes["ContentLinksWhere"] | null,	orderBy?:ValueTypes["ContentLinksOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentLinks"]],
paginateContentLinks?: [{	filter?:ValueTypes["ContentLinksWhere"] | null,	orderBy?:ValueTypes["ContentLinksOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentLinksConnection"]],
validateCreateContentLinks?: [{	data:ValueTypes["ContentLinksCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentLinks?: [{	by:ValueTypes["ContentLinksUniqueWhere"],	data:ValueTypes["ContentLinksUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentLinksItem?: [{	by:ValueTypes["ContentLinksItemUniqueWhere"],	filter?:ValueTypes["ContentLinksItemWhere"] | null},ValueTypes["ContentLinksItem"]],
listContentLinksItem?: [{	filter?:ValueTypes["ContentLinksItemWhere"] | null,	orderBy?:ValueTypes["ContentLinksItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentLinksItem"]],
paginateContentLinksItem?: [{	filter?:ValueTypes["ContentLinksItemWhere"] | null,	orderBy?:ValueTypes["ContentLinksItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentLinksItemConnection"]],
validateCreateContentLinksItem?: [{	data:ValueTypes["ContentLinksItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentLinksItem?: [{	by:ValueTypes["ContentLinksItemUniqueWhere"],	data:ValueTypes["ContentLinksItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReferenceImage?: [{	by:ValueTypes["ContentReferenceImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceImageWhere"] | null},ValueTypes["ContentReferenceImage"]],
listContentReferenceImage?: [{	filter?:ValueTypes["ContentReferenceImageWhere"] | null,	orderBy?:ValueTypes["ContentReferenceImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReferenceImage"]],
paginateContentReferenceImage?: [{	filter?:ValueTypes["ContentReferenceImageWhere"] | null,	orderBy?:ValueTypes["ContentReferenceImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceImageConnection"]],
validateCreateContentReferenceImage?: [{	data:ValueTypes["ContentReferenceImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReferenceImage?: [{	by:ValueTypes["ContentReferenceImageUniqueWhere"],	data:ValueTypes["ContentReferenceImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeoData?: [{	by:ValueTypes["SeoDataUniqueWhere"],	filter?:ValueTypes["SeoDataWhere"] | null},ValueTypes["SeoData"]],
listSeoData?: [{	filter?:ValueTypes["SeoDataWhere"] | null,	orderBy?:ValueTypes["SeoDataOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SeoData"]],
paginateSeoData?: [{	filter?:ValueTypes["SeoDataWhere"] | null,	orderBy?:ValueTypes["SeoDataOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoDataConnection"]],
validateCreateSeoData?: [{	data:ValueTypes["SeoDataCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeoData?: [{	by:ValueTypes["SeoDataUniqueWhere"],	data:ValueTypes["SeoDataUpdateInput"]},ValueTypes["_ValidationResult"]],
getTenantPerson?: [{	by:ValueTypes["TenantPersonUniqueWhere"],	filter?:ValueTypes["TenantPersonWhere"] | null},ValueTypes["TenantPerson"]],
listTenantPerson?: [{	filter?:ValueTypes["TenantPersonWhere"] | null,	orderBy?:ValueTypes["TenantPersonOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TenantPerson"]],
paginateTenantPerson?: [{	filter?:ValueTypes["TenantPersonWhere"] | null,	orderBy?:ValueTypes["TenantPersonOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TenantPersonConnection"]],
getBrandFlavor?: [{	by:ValueTypes["BrandFlavorUniqueWhere"],	filter?:ValueTypes["BrandFlavorWhere"] | null},ValueTypes["BrandFlavor"]],
listBrandFlavor?: [{	filter?:ValueTypes["BrandFlavorWhere"] | null,	orderBy?:ValueTypes["BrandFlavorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandFlavor"]],
paginateBrandFlavor?: [{	filter?:ValueTypes["BrandFlavorWhere"] | null,	orderBy?:ValueTypes["BrandFlavorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandFlavorConnection"]],
getProductLineFlavor?: [{	by:ValueTypes["ProductLineFlavorUniqueWhere"],	filter?:ValueTypes["ProductLineFlavorWhere"] | null},ValueTypes["ProductLineFlavor"]],
listProductLineFlavor?: [{	filter?:ValueTypes["ProductLineFlavorWhere"] | null,	orderBy?:ValueTypes["ProductLineFlavorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductLineFlavor"]],
paginateProductLineFlavor?: [{	filter?:ValueTypes["ProductLineFlavorWhere"] | null,	orderBy?:ValueTypes["ProductLineFlavorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductLineFlavorConnection"]],
getProductItemDeclensionFourthCategory?: [{	by:ValueTypes["ProductItemDeclensionFourthCategoryUniqueWhere"],	filter?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null},ValueTypes["ProductItemDeclensionFourthCategory"]],
listProductItemDeclensionFourthCategory?: [{	filter?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null,	orderBy?:ValueTypes["ProductItemDeclensionFourthCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductItemDeclensionFourthCategory"]],
paginateProductItemDeclensionFourthCategory?: [{	filter?:ValueTypes["ProductItemDeclensionFourthCategoryWhere"] | null,	orderBy?:ValueTypes["ProductItemDeclensionFourthCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductItemDeclensionFourthCategoryConnection"]],
getAgeCategory?: [{	by:ValueTypes["AgeCategoryUniqueWhere"],	filter?:ValueTypes["AgeCategoryWhere"] | null},ValueTypes["AgeCategory"]],
listAgeCategory?: [{	filter?:ValueTypes["AgeCategoryWhere"] | null,	orderBy?:ValueTypes["AgeCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AgeCategory"]],
paginateAgeCategory?: [{	filter?:ValueTypes["AgeCategoryWhere"] | null,	orderBy?:ValueTypes["AgeCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AgeCategoryConnection"]],
validateCreateAgeCategory?: [{	data:ValueTypes["AgeCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAgeCategory?: [{	by:ValueTypes["AgeCategoryUniqueWhere"],	data:ValueTypes["AgeCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getFilterCombo?: [{	by:ValueTypes["FilterComboUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterCombo"]],
listFilterCombo?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FilterCombo"]],
paginateFilterCombo?: [{	filter?:ValueTypes["FilterComboWhere"] | null,	orderBy?:ValueTypes["FilterComboOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FilterComboConnection"]],
validateCreateFilterCombo?: [{	data:ValueTypes["FilterComboCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFilterCombo?: [{	by:ValueTypes["FilterComboUniqueWhere"],	data:ValueTypes["FilterComboUpdateInput"]},ValueTypes["_ValidationResult"]],
getImportCache?: [{	by:ValueTypes["ImportCacheUniqueWhere"],	filter?:ValueTypes["ImportCacheWhere"] | null},ValueTypes["ImportCache"]],
listImportCache?: [{	filter?:ValueTypes["ImportCacheWhere"] | null,	orderBy?:ValueTypes["ImportCacheOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImportCache"]],
paginateImportCache?: [{	filter?:ValueTypes["ImportCacheWhere"] | null,	orderBy?:ValueTypes["ImportCacheOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImportCacheConnection"]],
validateCreateImportCache?: [{	data:ValueTypes["ImportCacheCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImportCache?: [{	by:ValueTypes["ImportCacheUniqueWhere"],	data:ValueTypes["ImportCacheUpdateInput"]},ValueTypes["_ValidationResult"]],
getSite?: [{	by:ValueTypes["SiteUniqueWhere"],	filter?:ValueTypes["SiteWhere"] | null},ValueTypes["Site"]],
listSite?: [{	filter?:ValueTypes["SiteWhere"] | null,	orderBy?:ValueTypes["SiteOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Site"]],
paginateSite?: [{	filter?:ValueTypes["SiteWhere"] | null,	orderBy?:ValueTypes["SiteOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SiteConnection"]],
validateCreateSite?: [{	data:ValueTypes["SiteCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSite?: [{	by:ValueTypes["SiteUniqueWhere"],	data:ValueTypes["SiteUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactSubmission?: [{	by:ValueTypes["ContactSubmissionUniqueWhere"],	filter?:ValueTypes["ContactSubmissionWhere"] | null},ValueTypes["ContactSubmission"]],
listContactSubmission?: [{	filter?:ValueTypes["ContactSubmissionWhere"] | null,	orderBy?:ValueTypes["ContactSubmissionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactSubmission"]],
paginateContactSubmission?: [{	filter?:ValueTypes["ContactSubmissionWhere"] | null,	orderBy?:ValueTypes["ContactSubmissionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactSubmissionConnection"]],
validateCreateContactSubmission?: [{	data:ValueTypes["ContactSubmissionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactSubmission?: [{	by:ValueTypes["ContactSubmissionUniqueWhere"],	data:ValueTypes["ContactSubmissionUpdateInput"]},ValueTypes["_ValidationResult"]],
getTOPXBrand?: [{	by:ValueTypes["TOPXBrandUniqueWhere"],	filter?:ValueTypes["TOPXBrandWhere"] | null},ValueTypes["TOPXBrand"]],
listTOPXBrand?: [{	filter?:ValueTypes["TOPXBrandWhere"] | null,	orderBy?:ValueTypes["TOPXBrandOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TOPXBrand"]],
paginateTOPXBrand?: [{	filter?:ValueTypes["TOPXBrandWhere"] | null,	orderBy?:ValueTypes["TOPXBrandOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TOPXBrandConnection"]],
validateCreateTOPXBrand?: [{	data:ValueTypes["TOPXBrandCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTOPXBrand?: [{	by:ValueTypes["TOPXBrandUniqueWhere"],	data:ValueTypes["TOPXBrandUpdateInput"]},ValueTypes["_ValidationResult"]],
getTOPXBrandCategory?: [{	by:ValueTypes["TOPXBrandCategoryUniqueWhere"],	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null},ValueTypes["TOPXBrandCategory"]],
listTOPXBrandCategory?: [{	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null,	orderBy?:ValueTypes["TOPXBrandCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TOPXBrandCategory"]],
paginateTOPXBrandCategory?: [{	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null,	orderBy?:ValueTypes["TOPXBrandCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TOPXBrandCategoryConnection"]],
validateCreateTOPXBrandCategory?: [{	data:ValueTypes["TOPXBrandCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTOPXBrandCategory?: [{	by:ValueTypes["TOPXBrandCategoryUniqueWhere"],	data:ValueTypes["TOPXBrandCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getTOPXProduct?: [{	by:ValueTypes["TOPXProductUniqueWhere"],	filter?:ValueTypes["TOPXProductWhere"] | null},ValueTypes["TOPXProduct"]],
listTOPXProduct?: [{	filter?:ValueTypes["TOPXProductWhere"] | null,	orderBy?:ValueTypes["TOPXProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TOPXProduct"]],
paginateTOPXProduct?: [{	filter?:ValueTypes["TOPXProductWhere"] | null,	orderBy?:ValueTypes["TOPXProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TOPXProductConnection"]],
validateCreateTOPXProduct?: [{	data:ValueTypes["TOPXProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTOPXProduct?: [{	by:ValueTypes["TOPXProductUniqueWhere"],	data:ValueTypes["TOPXProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getTOPXProductCategory?: [{	by:ValueTypes["TOPXProductCategoryUniqueWhere"],	filter?:ValueTypes["TOPXProductCategoryWhere"] | null},ValueTypes["TOPXProductCategory"]],
listTOPXProductCategory?: [{	filter?:ValueTypes["TOPXProductCategoryWhere"] | null,	orderBy?:ValueTypes["TOPXProductCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TOPXProductCategory"]],
paginateTOPXProductCategory?: [{	filter?:ValueTypes["TOPXProductCategoryWhere"] | null,	orderBy?:ValueTypes["TOPXProductCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TOPXProductCategoryConnection"]],
validateCreateTOPXProductCategory?: [{	data:ValueTypes["TOPXProductCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTOPXProductCategory?: [{	by:ValueTypes["TOPXProductCategoryUniqueWhere"],	data:ValueTypes["TOPXProductCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReferenceList?: [{	by:ValueTypes["ContentReferenceListUniqueWhere"],	filter?:ValueTypes["ContentReferenceListWhere"] | null},ValueTypes["ContentReferenceList"]],
listContentReferenceList?: [{	filter?:ValueTypes["ContentReferenceListWhere"] | null,	orderBy?:ValueTypes["ContentReferenceListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReferenceList"]],
paginateContentReferenceList?: [{	filter?:ValueTypes["ContentReferenceListWhere"] | null,	orderBy?:ValueTypes["ContentReferenceListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceListConnection"]],
validateCreateContentReferenceList?: [{	data:ValueTypes["ContentReferenceListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReferenceList?: [{	by:ValueTypes["ContentReferenceListUniqueWhere"],	data:ValueTypes["ContentReferenceListUpdateInput"]},ValueTypes["_ValidationResult"]],
getBrandCount?: [{	by:ValueTypes["BrandCountUniqueWhere"],	filter?:ValueTypes["BrandCountWhere"] | null},ValueTypes["BrandCount"]],
listBrandCount?: [{	filter?:ValueTypes["BrandCountWhere"] | null,	orderBy?:ValueTypes["BrandCountOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BrandCount"]],
paginateBrandCount?: [{	filter?:ValueTypes["BrandCountWhere"] | null,	orderBy?:ValueTypes["BrandCountOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BrandCountConnection"]],
getProductCount?: [{	by:ValueTypes["ProductCountUniqueWhere"],	filter?:ValueTypes["ProductCountWhere"] | null},ValueTypes["ProductCount"]],
listProductCount?: [{	filter?:ValueTypes["ProductCountWhere"] | null,	orderBy?:ValueTypes["ProductCountOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ProductCount"]],
paginateProductCount?: [{	filter?:ValueTypes["ProductCountWhere"] | null,	orderBy?:ValueTypes["ProductCountOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductCountConnection"]],
		__typename?: boolean
}>;
	["Info"]: AliasType<{
	description?:boolean,
		__typename?: boolean
}>;
	["Mutation"]: AliasType<{
generateUploadUrl?: [{	input?:ValueTypes["S3GenerateSignedUploadInput"] | null},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey:string,	expiration?:number | null},ValueTypes["S3SignedRead"]],
createBlogPage?: [{	data:ValueTypes["BlogPageCreateInput"]},ValueTypes["BlogPageCreateResult"]],
deleteBlogPage?: [{	by:ValueTypes["BlogPageUniqueWhere"],	filter?:ValueTypes["BlogPageWhere"] | null},ValueTypes["BlogPageDeleteResult"]],
updateBlogPage?: [{	by:ValueTypes["BlogPageUniqueWhere"],	filter?:ValueTypes["BlogPageWhere"] | null,	data:ValueTypes["BlogPageUpdateInput"]},ValueTypes["BlogPageUpdateResult"]],
upsertBlogPage?: [{	by:ValueTypes["BlogPageUniqueWhere"],	filter?:ValueTypes["BlogPageWhere"] | null,	update:ValueTypes["BlogPageUpdateInput"],	create:ValueTypes["BlogPageCreateInput"]},ValueTypes["BlogPageUpsertResult"]],
createBlogPost?: [{	data:ValueTypes["BlogPostCreateInput"]},ValueTypes["BlogPostCreateResult"]],
deleteBlogPost?: [{	by:ValueTypes["BlogPostUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPostDeleteResult"]],
updateBlogPost?: [{	by:ValueTypes["BlogPostUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null,	data:ValueTypes["BlogPostUpdateInput"]},ValueTypes["BlogPostUpdateResult"]],
upsertBlogPost?: [{	by:ValueTypes["BlogPostUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null,	update:ValueTypes["BlogPostUpdateInput"],	create:ValueTypes["BlogPostCreateInput"]},ValueTypes["BlogPostUpsertResult"]],
createBlogPostTag?: [{	data:ValueTypes["BlogPostTagCreateInput"]},ValueTypes["BlogPostTagCreateResult"]],
deleteBlogPostTag?: [{	by:ValueTypes["BlogPostTagUniqueWhere"],	filter?:ValueTypes["BlogPostTagWhere"] | null},ValueTypes["BlogPostTagDeleteResult"]],
updateBlogPostTag?: [{	by:ValueTypes["BlogPostTagUniqueWhere"],	filter?:ValueTypes["BlogPostTagWhere"] | null,	data:ValueTypes["BlogPostTagUpdateInput"]},ValueTypes["BlogPostTagUpdateResult"]],
upsertBlogPostTag?: [{	by:ValueTypes["BlogPostTagUniqueWhere"],	filter?:ValueTypes["BlogPostTagWhere"] | null,	update:ValueTypes["BlogPostTagUpdateInput"],	create:ValueTypes["BlogPostTagCreateInput"]},ValueTypes["BlogPostTagUpsertResult"]],
createBodyTag?: [{	data:ValueTypes["BodyTagCreateInput"]},ValueTypes["BodyTagCreateResult"]],
deleteBodyTag?: [{	by:ValueTypes["BodyTagUniqueWhere"],	filter?:ValueTypes["BodyTagWhere"] | null},ValueTypes["BodyTagDeleteResult"]],
updateBodyTag?: [{	by:ValueTypes["BodyTagUniqueWhere"],	filter?:ValueTypes["BodyTagWhere"] | null,	data:ValueTypes["BodyTagUpdateInput"]},ValueTypes["BodyTagUpdateResult"]],
upsertBodyTag?: [{	by:ValueTypes["BodyTagUniqueWhere"],	filter?:ValueTypes["BodyTagWhere"] | null,	update:ValueTypes["BodyTagUpdateInput"],	create:ValueTypes["BodyTagCreateInput"]},ValueTypes["BodyTagUpsertResult"]],
createBodyTagCategory?: [{	data:ValueTypes["BodyTagCategoryCreateInput"]},ValueTypes["BodyTagCategoryCreateResult"]],
deleteBodyTagCategory?: [{	by:ValueTypes["BodyTagCategoryUniqueWhere"],	filter?:ValueTypes["BodyTagCategoryWhere"] | null},ValueTypes["BodyTagCategoryDeleteResult"]],
updateBodyTagCategory?: [{	by:ValueTypes["BodyTagCategoryUniqueWhere"],	filter?:ValueTypes["BodyTagCategoryWhere"] | null,	data:ValueTypes["BodyTagCategoryUpdateInput"]},ValueTypes["BodyTagCategoryUpdateResult"]],
upsertBodyTagCategory?: [{	by:ValueTypes["BodyTagCategoryUniqueWhere"],	filter?:ValueTypes["BodyTagCategoryWhere"] | null,	update:ValueTypes["BodyTagCategoryUpdateInput"],	create:ValueTypes["BodyTagCategoryCreateInput"]},ValueTypes["BodyTagCategoryUpsertResult"]],
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createDidYouKnow?: [{	data:ValueTypes["DidYouKnowCreateInput"]},ValueTypes["DidYouKnowCreateResult"]],
deleteDidYouKnow?: [{	by:ValueTypes["DidYouKnowUniqueWhere"],	filter?:ValueTypes["DidYouKnowWhere"] | null},ValueTypes["DidYouKnowDeleteResult"]],
updateDidYouKnow?: [{	by:ValueTypes["DidYouKnowUniqueWhere"],	filter?:ValueTypes["DidYouKnowWhere"] | null,	data:ValueTypes["DidYouKnowUpdateInput"]},ValueTypes["DidYouKnowUpdateResult"]],
upsertDidYouKnow?: [{	by:ValueTypes["DidYouKnowUniqueWhere"],	filter?:ValueTypes["DidYouKnowWhere"] | null,	update:ValueTypes["DidYouKnowUpdateInput"],	create:ValueTypes["DidYouKnowCreateInput"]},ValueTypes["DidYouKnowUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createMedium?: [{	data:ValueTypes["MediumCreateInput"]},ValueTypes["MediumCreateResult"]],
deleteMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["MediumDeleteResult"]],
updateMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null,	data:ValueTypes["MediumUpdateInput"]},ValueTypes["MediumUpdateResult"]],
upsertMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null,	update:ValueTypes["MediumUpdateInput"],	create:ValueTypes["MediumCreateInput"]},ValueTypes["MediumUpsertResult"]],
createNutritionalValue?: [{	data:ValueTypes["NutritionalValueCreateInput"]},ValueTypes["NutritionalValueCreateResult"]],
deleteNutritionalValue?: [{	by:ValueTypes["NutritionalValueUniqueWhere"],	filter?:ValueTypes["NutritionalValueWhere"] | null},ValueTypes["NutritionalValueDeleteResult"]],
updateNutritionalValue?: [{	by:ValueTypes["NutritionalValueUniqueWhere"],	filter?:ValueTypes["NutritionalValueWhere"] | null,	data:ValueTypes["NutritionalValueUpdateInput"]},ValueTypes["NutritionalValueUpdateResult"]],
upsertNutritionalValue?: [{	by:ValueTypes["NutritionalValueUniqueWhere"],	filter?:ValueTypes["NutritionalValueWhere"] | null,	update:ValueTypes["NutritionalValueUpdateInput"],	create:ValueTypes["NutritionalValueCreateInput"]},ValueTypes["NutritionalValueUpsertResult"]],
createPage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["PageCreateResult"]],
deletePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["PageDeleteResult"]],
updatePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	data:ValueTypes["PageUpdateInput"]},ValueTypes["PageUpdateResult"]],
upsertPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	update:ValueTypes["PageUpdateInput"],	create:ValueTypes["PageCreateInput"]},ValueTypes["PageUpsertResult"]],
createReference?: [{	data:ValueTypes["ReferenceCreateInput"]},ValueTypes["ReferenceCreateResult"]],
deleteReference?: [{	by:ValueTypes["ReferenceUniqueWhere"],	filter?:ValueTypes["ReferenceWhere"] | null},ValueTypes["ReferenceDeleteResult"]],
updateReference?: [{	by:ValueTypes["ReferenceUniqueWhere"],	filter?:ValueTypes["ReferenceWhere"] | null,	data:ValueTypes["ReferenceUpdateInput"]},ValueTypes["ReferenceUpdateResult"]],
upsertReference?: [{	by:ValueTypes["ReferenceUniqueWhere"],	filter?:ValueTypes["ReferenceWhere"] | null,	update:ValueTypes["ReferenceUpdateInput"],	create:ValueTypes["ReferenceCreateInput"]},ValueTypes["ReferenceUpsertResult"]],
createReferenceList?: [{	data:ValueTypes["ReferenceListCreateInput"]},ValueTypes["ReferenceListCreateResult"]],
deleteReferenceList?: [{	by:ValueTypes["ReferenceListUniqueWhere"],	filter?:ValueTypes["ReferenceListWhere"] | null},ValueTypes["ReferenceListDeleteResult"]],
updateReferenceList?: [{	by:ValueTypes["ReferenceListUniqueWhere"],	filter?:ValueTypes["ReferenceListWhere"] | null,	data:ValueTypes["ReferenceListUpdateInput"]},ValueTypes["ReferenceListUpdateResult"]],
upsertReferenceList?: [{	by:ValueTypes["ReferenceListUniqueWhere"],	filter?:ValueTypes["ReferenceListWhere"] | null,	update:ValueTypes["ReferenceListUpdateInput"],	create:ValueTypes["ReferenceListCreateInput"]},ValueTypes["ReferenceListUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	data:ValueTypes["VideoUpdateInput"]},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	update:ValueTypes["VideoUpdateInput"],	create:ValueTypes["VideoCreateInput"]},ValueTypes["VideoUpsertResult"]],
createBrand?: [{	data:ValueTypes["BrandCreateInput"]},ValueTypes["BrandCreateResult"]],
deleteBrand?: [{	by:ValueTypes["BrandUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["BrandDeleteResult"]],
updateBrand?: [{	by:ValueTypes["BrandUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null,	data:ValueTypes["BrandUpdateInput"]},ValueTypes["BrandUpdateResult"]],
upsertBrand?: [{	by:ValueTypes["BrandUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null,	update:ValueTypes["BrandUpdateInput"],	create:ValueTypes["BrandCreateInput"]},ValueTypes["BrandUpsertResult"]],
createBrandDistributor?: [{	data:ValueTypes["BrandDistributorCreateInput"]},ValueTypes["BrandDistributorCreateResult"]],
deleteBrandDistributor?: [{	by:ValueTypes["BrandDistributorUniqueWhere"],	filter?:ValueTypes["BrandDistributorWhere"] | null},ValueTypes["BrandDistributorDeleteResult"]],
updateBrandDistributor?: [{	by:ValueTypes["BrandDistributorUniqueWhere"],	filter?:ValueTypes["BrandDistributorWhere"] | null,	data:ValueTypes["BrandDistributorUpdateInput"]},ValueTypes["BrandDistributorUpdateResult"]],
upsertBrandDistributor?: [{	by:ValueTypes["BrandDistributorUniqueWhere"],	filter?:ValueTypes["BrandDistributorWhere"] | null,	update:ValueTypes["BrandDistributorUpdateInput"],	create:ValueTypes["BrandDistributorCreateInput"]},ValueTypes["BrandDistributorUpsertResult"]],
createDogSize?: [{	data:ValueTypes["DogSizeCreateInput"]},ValueTypes["DogSizeCreateResult"]],
deleteDogSize?: [{	by:ValueTypes["DogSizeUniqueWhere"],	filter?:ValueTypes["DogSizeWhere"] | null},ValueTypes["DogSizeDeleteResult"]],
updateDogSize?: [{	by:ValueTypes["DogSizeUniqueWhere"],	filter?:ValueTypes["DogSizeWhere"] | null,	data:ValueTypes["DogSizeUpdateInput"]},ValueTypes["DogSizeUpdateResult"]],
upsertDogSize?: [{	by:ValueTypes["DogSizeUniqueWhere"],	filter?:ValueTypes["DogSizeWhere"] | null,	update:ValueTypes["DogSizeUpdateInput"],	create:ValueTypes["DogSizeCreateInput"]},ValueTypes["DogSizeUpsertResult"]],
createProduct?: [{	data:ValueTypes["ProductCreateInput"]},ValueTypes["ProductCreateResult"]],
deleteProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["ProductDeleteResult"]],
updateProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null,	data:ValueTypes["ProductUpdateInput"]},ValueTypes["ProductUpdateResult"]],
upsertProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null,	update:ValueTypes["ProductUpdateInput"],	create:ValueTypes["ProductCreateInput"]},ValueTypes["ProductUpsertResult"]],
createProductionMethod?: [{	data:ValueTypes["ProductionMethodCreateInput"]},ValueTypes["ProductionMethodCreateResult"]],
deleteProductionMethod?: [{	by:ValueTypes["ProductionMethodUniqueWhere"],	filter?:ValueTypes["ProductionMethodWhere"] | null},ValueTypes["ProductionMethodDeleteResult"]],
updateProductionMethod?: [{	by:ValueTypes["ProductionMethodUniqueWhere"],	filter?:ValueTypes["ProductionMethodWhere"] | null,	data:ValueTypes["ProductionMethodUpdateInput"]},ValueTypes["ProductionMethodUpdateResult"]],
upsertProductionMethod?: [{	by:ValueTypes["ProductionMethodUniqueWhere"],	filter?:ValueTypes["ProductionMethodWhere"] | null,	update:ValueTypes["ProductionMethodUpdateInput"],	create:ValueTypes["ProductionMethodCreateInput"]},ValueTypes["ProductionMethodUpsertResult"]],
createProductLine?: [{	data:ValueTypes["ProductLineCreateInput"]},ValueTypes["ProductLineCreateResult"]],
deleteProductLine?: [{	by:ValueTypes["ProductLineUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLineDeleteResult"]],
updateProductLine?: [{	by:ValueTypes["ProductLineUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null,	data:ValueTypes["ProductLineUpdateInput"]},ValueTypes["ProductLineUpdateResult"]],
upsertProductLine?: [{	by:ValueTypes["ProductLineUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null,	update:ValueTypes["ProductLineUpdateInput"],	create:ValueTypes["ProductLineCreateInput"]},ValueTypes["ProductLineUpsertResult"]],
createBreed?: [{	data:ValueTypes["BreedCreateInput"]},ValueTypes["BreedCreateResult"]],
deleteBreed?: [{	by:ValueTypes["BreedUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["BreedDeleteResult"]],
updateBreed?: [{	by:ValueTypes["BreedUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null,	data:ValueTypes["BreedUpdateInput"]},ValueTypes["BreedUpdateResult"]],
upsertBreed?: [{	by:ValueTypes["BreedUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null,	update:ValueTypes["BreedUpdateInput"],	create:ValueTypes["BreedCreateInput"]},ValueTypes["BreedUpsertResult"]],
createDog?: [{	data:ValueTypes["DogCreateInput"]},ValueTypes["DogCreateResult"]],
deleteDog?: [{	by:ValueTypes["DogUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["DogDeleteResult"]],
updateDog?: [{	by:ValueTypes["DogUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null,	data:ValueTypes["DogUpdateInput"]},ValueTypes["DogUpdateResult"]],
upsertDog?: [{	by:ValueTypes["DogUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null,	update:ValueTypes["DogUpdateInput"],	create:ValueTypes["DogCreateInput"]},ValueTypes["DogUpsertResult"]],
createUser?: [{	data:ValueTypes["UserCreateInput"]},ValueTypes["UserCreateResult"]],
deleteUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null},ValueTypes["UserDeleteResult"]],
updateUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null,	data:ValueTypes["UserUpdateInput"]},ValueTypes["UserUpdateResult"]],
upsertUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null,	update:ValueTypes["UserUpdateInput"],	create:ValueTypes["UserCreateInput"]},ValueTypes["UserUpsertResult"]],
createVeterinary?: [{	data:ValueTypes["VeterinaryCreateInput"]},ValueTypes["VeterinaryCreateResult"]],
deleteVeterinary?: [{	by:ValueTypes["VeterinaryUniqueWhere"],	filter?:ValueTypes["VeterinaryWhere"] | null},ValueTypes["VeterinaryDeleteResult"]],
updateVeterinary?: [{	by:ValueTypes["VeterinaryUniqueWhere"],	filter?:ValueTypes["VeterinaryWhere"] | null,	data:ValueTypes["VeterinaryUpdateInput"]},ValueTypes["VeterinaryUpdateResult"]],
upsertVeterinary?: [{	by:ValueTypes["VeterinaryUniqueWhere"],	filter?:ValueTypes["VeterinaryWhere"] | null,	update:ValueTypes["VeterinaryUpdateInput"],	create:ValueTypes["VeterinaryCreateInput"]},ValueTypes["VeterinaryUpsertResult"]],
createNutritionalValueOfProduct?: [{	data:ValueTypes["NutritionalValueOfProductCreateInput"]},ValueTypes["NutritionalValueOfProductCreateResult"]],
deleteNutritionalValueOfProduct?: [{	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null},ValueTypes["NutritionalValueOfProductDeleteResult"]],
updateNutritionalValueOfProduct?: [{	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null,	data:ValueTypes["NutritionalValueOfProductUpdateInput"]},ValueTypes["NutritionalValueOfProductUpdateResult"]],
upsertNutritionalValueOfProduct?: [{	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null,	update:ValueTypes["NutritionalValueOfProductUpdateInput"],	create:ValueTypes["NutritionalValueOfProductCreateInput"]},ValueTypes["NutritionalValueOfProductUpsertResult"]],
createReview?: [{	data:ValueTypes["ReviewCreateInput"]},ValueTypes["ReviewCreateResult"]],
deleteReview?: [{	by:ValueTypes["ReviewUniqueWhere"],	filter?:ValueTypes["ReviewWhere"] | null},ValueTypes["ReviewDeleteResult"]],
updateReview?: [{	by:ValueTypes["ReviewUniqueWhere"],	filter?:ValueTypes["ReviewWhere"] | null,	data:ValueTypes["ReviewUpdateInput"]},ValueTypes["ReviewUpdateResult"]],
upsertReview?: [{	by:ValueTypes["ReviewUniqueWhere"],	filter?:ValueTypes["ReviewWhere"] | null,	update:ValueTypes["ReviewUpdateInput"],	create:ValueTypes["ReviewCreateInput"]},ValueTypes["ReviewUpsertResult"]],
createDogBodyType?: [{	data:ValueTypes["DogBodyTypeCreateInput"]},ValueTypes["DogBodyTypeCreateResult"]],
deleteDogBodyType?: [{	by:ValueTypes["DogBodyTypeUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null},ValueTypes["DogBodyTypeDeleteResult"]],
updateDogBodyType?: [{	by:ValueTypes["DogBodyTypeUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null,	data:ValueTypes["DogBodyTypeUpdateInput"]},ValueTypes["DogBodyTypeUpdateResult"]],
upsertDogBodyType?: [{	by:ValueTypes["DogBodyTypeUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null,	update:ValueTypes["DogBodyTypeUpdateInput"],	create:ValueTypes["DogBodyTypeCreateInput"]},ValueTypes["DogBodyTypeUpsertResult"]],
createDogBodyTypeCategory?: [{	data:ValueTypes["DogBodyTypeCategoryCreateInput"]},ValueTypes["DogBodyTypeCategoryCreateResult"]],
deleteDogBodyTypeCategory?: [{	by:ValueTypes["DogBodyTypeCategoryUniqueWhere"],	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null},ValueTypes["DogBodyTypeCategoryDeleteResult"]],
updateDogBodyTypeCategory?: [{	by:ValueTypes["DogBodyTypeCategoryUniqueWhere"],	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null,	data:ValueTypes["DogBodyTypeCategoryUpdateInput"]},ValueTypes["DogBodyTypeCategoryUpdateResult"]],
upsertDogBodyTypeCategory?: [{	by:ValueTypes["DogBodyTypeCategoryUniqueWhere"],	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null,	update:ValueTypes["DogBodyTypeCategoryUpdateInput"],	create:ValueTypes["DogBodyTypeCategoryCreateInput"]},ValueTypes["DogBodyTypeCategoryUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createUrl?: [{	data:ValueTypes["UrlCreateInput"]},ValueTypes["UrlCreateResult"]],
deleteUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["UrlDeleteResult"]],
updateUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null,	data:ValueTypes["UrlUpdateInput"]},ValueTypes["UrlUpdateResult"]],
upsertUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null,	update:ValueTypes["UrlUpdateInput"],	create:ValueTypes["UrlCreateInput"]},ValueTypes["UrlUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createFooterLink?: [{	data:ValueTypes["FooterLinkCreateInput"]},ValueTypes["FooterLinkCreateResult"]],
deleteFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null},ValueTypes["FooterLinkDeleteResult"]],
updateFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null,	data:ValueTypes["FooterLinkUpdateInput"]},ValueTypes["FooterLinkUpdateResult"]],
upsertFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null,	update:ValueTypes["FooterLinkUpdateInput"],	create:ValueTypes["FooterLinkCreateInput"]},ValueTypes["FooterLinkUpsertResult"]],
createBrandsPage?: [{	data:ValueTypes["BrandsPageCreateInput"]},ValueTypes["BrandsPageCreateResult"]],
deleteBrandsPage?: [{	by:ValueTypes["BrandsPageUniqueWhere"],	filter?:ValueTypes["BrandsPageWhere"] | null},ValueTypes["BrandsPageDeleteResult"]],
updateBrandsPage?: [{	by:ValueTypes["BrandsPageUniqueWhere"],	filter?:ValueTypes["BrandsPageWhere"] | null,	data:ValueTypes["BrandsPageUpdateInput"]},ValueTypes["BrandsPageUpdateResult"]],
upsertBrandsPage?: [{	by:ValueTypes["BrandsPageUniqueWhere"],	filter?:ValueTypes["BrandsPageWhere"] | null,	update:ValueTypes["BrandsPageUpdateInput"],	create:ValueTypes["BrandsPageCreateInput"]},ValueTypes["BrandsPageUpsertResult"]],
createHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	update:ValueTypes["HomePageUpdateInput"],	create:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageUpsertResult"]],
createIngredientsPage?: [{	data:ValueTypes["IngredientsPageCreateInput"]},ValueTypes["IngredientsPageCreateResult"]],
deleteIngredientsPage?: [{	by:ValueTypes["IngredientsPageUniqueWhere"],	filter?:ValueTypes["IngredientsPageWhere"] | null},ValueTypes["IngredientsPageDeleteResult"]],
updateIngredientsPage?: [{	by:ValueTypes["IngredientsPageUniqueWhere"],	filter?:ValueTypes["IngredientsPageWhere"] | null,	data:ValueTypes["IngredientsPageUpdateInput"]},ValueTypes["IngredientsPageUpdateResult"]],
upsertIngredientsPage?: [{	by:ValueTypes["IngredientsPageUniqueWhere"],	filter?:ValueTypes["IngredientsPageWhere"] | null,	update:ValueTypes["IngredientsPageUpdateInput"],	create:ValueTypes["IngredientsPageCreateInput"]},ValueTypes["IngredientsPageUpsertResult"]],
createProductReview?: [{	data:ValueTypes["ProductReviewCreateInput"]},ValueTypes["ProductReviewCreateResult"]],
deleteProductReview?: [{	by:ValueTypes["ProductReviewUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReviewDeleteResult"]],
updateProductReview?: [{	by:ValueTypes["ProductReviewUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null,	data:ValueTypes["ProductReviewUpdateInput"]},ValueTypes["ProductReviewUpdateResult"]],
upsertProductReview?: [{	by:ValueTypes["ProductReviewUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null,	update:ValueTypes["ProductReviewUpdateInput"],	create:ValueTypes["ProductReviewCreateInput"]},ValueTypes["ProductReviewUpsertResult"]],
createScore?: [{	data:ValueTypes["ScoreCreateInput"]},ValueTypes["ScoreCreateResult"]],
deleteScore?: [{	by:ValueTypes["ScoreUniqueWhere"],	filter?:ValueTypes["ScoreWhere"] | null},ValueTypes["ScoreDeleteResult"]],
updateScore?: [{	by:ValueTypes["ScoreUniqueWhere"],	filter?:ValueTypes["ScoreWhere"] | null,	data:ValueTypes["ScoreUpdateInput"]},ValueTypes["ScoreUpdateResult"]],
upsertScore?: [{	by:ValueTypes["ScoreUniqueWhere"],	filter?:ValueTypes["ScoreWhere"] | null,	update:ValueTypes["ScoreUpdateInput"],	create:ValueTypes["ScoreCreateInput"]},ValueTypes["ScoreUpsertResult"]],
createAge?: [{	data:ValueTypes["AgeCreateInput"]},ValueTypes["AgeCreateResult"]],
deleteAge?: [{	by:ValueTypes["AgeUniqueWhere"],	filter?:ValueTypes["AgeWhere"] | null},ValueTypes["AgeDeleteResult"]],
updateAge?: [{	by:ValueTypes["AgeUniqueWhere"],	filter?:ValueTypes["AgeWhere"] | null,	data:ValueTypes["AgeUpdateInput"]},ValueTypes["AgeUpdateResult"]],
upsertAge?: [{	by:ValueTypes["AgeUniqueWhere"],	filter?:ValueTypes["AgeWhere"] | null,	update:ValueTypes["AgeUpdateInput"],	create:ValueTypes["AgeCreateInput"]},ValueTypes["AgeUpsertResult"]],
createCountry?: [{	data:ValueTypes["CountryCreateInput"]},ValueTypes["CountryCreateResult"]],
deleteCountry?: [{	by:ValueTypes["CountryUniqueWhere"],	filter?:ValueTypes["CountryWhere"] | null},ValueTypes["CountryDeleteResult"]],
updateCountry?: [{	by:ValueTypes["CountryUniqueWhere"],	filter?:ValueTypes["CountryWhere"] | null,	data:ValueTypes["CountryUpdateInput"]},ValueTypes["CountryUpdateResult"]],
upsertCountry?: [{	by:ValueTypes["CountryUniqueWhere"],	filter?:ValueTypes["CountryWhere"] | null,	update:ValueTypes["CountryUpdateInput"],	create:ValueTypes["CountryCreateInput"]},ValueTypes["CountryUpsertResult"]],
createBlogPostReview?: [{	data:ValueTypes["BlogPostReviewCreateInput"]},ValueTypes["BlogPostReviewCreateResult"]],
deleteBlogPostReview?: [{	by:ValueTypes["BlogPostReviewUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReviewDeleteResult"]],
updateBlogPostReview?: [{	by:ValueTypes["BlogPostReviewUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null,	data:ValueTypes["BlogPostReviewUpdateInput"]},ValueTypes["BlogPostReviewUpdateResult"]],
upsertBlogPostReview?: [{	by:ValueTypes["BlogPostReviewUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null,	update:ValueTypes["BlogPostReviewUpdateInput"],	create:ValueTypes["BlogPostReviewCreateInput"]},ValueTypes["BlogPostReviewUpsertResult"]],
createDogActivity?: [{	data:ValueTypes["DogActivityCreateInput"]},ValueTypes["DogActivityCreateResult"]],
deleteDogActivity?: [{	by:ValueTypes["DogActivityUniqueWhere"],	filter?:ValueTypes["DogActivityWhere"] | null},ValueTypes["DogActivityDeleteResult"]],
updateDogActivity?: [{	by:ValueTypes["DogActivityUniqueWhere"],	filter?:ValueTypes["DogActivityWhere"] | null,	data:ValueTypes["DogActivityUpdateInput"]},ValueTypes["DogActivityUpdateResult"]],
upsertDogActivity?: [{	by:ValueTypes["DogActivityUniqueWhere"],	filter?:ValueTypes["DogActivityWhere"] | null,	update:ValueTypes["DogActivityUpdateInput"],	create:ValueTypes["DogActivityCreateInput"]},ValueTypes["DogActivityUpsertResult"]],
createSocial?: [{	data:ValueTypes["SocialCreateInput"]},ValueTypes["SocialCreateResult"]],
deleteSocial?: [{	by:ValueTypes["SocialUniqueWhere"],	filter?:ValueTypes["SocialWhere"] | null},ValueTypes["SocialDeleteResult"]],
updateSocial?: [{	by:ValueTypes["SocialUniqueWhere"],	filter?:ValueTypes["SocialWhere"] | null,	data:ValueTypes["SocialUpdateInput"]},ValueTypes["SocialUpdateResult"]],
upsertSocial?: [{	by:ValueTypes["SocialUniqueWhere"],	filter?:ValueTypes["SocialWhere"] | null,	update:ValueTypes["SocialUpdateInput"],	create:ValueTypes["SocialCreateInput"]},ValueTypes["SocialUpsertResult"]],
createContentReferenceGalleryImage?: [{	data:ValueTypes["ContentReferenceGalleryImageCreateInput"]},ValueTypes["ContentReferenceGalleryImageCreateResult"]],
deleteContentReferenceGalleryImage?: [{	by:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null},ValueTypes["ContentReferenceGalleryImageDeleteResult"]],
updateContentReferenceGalleryImage?: [{	by:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null,	data:ValueTypes["ContentReferenceGalleryImageUpdateInput"]},ValueTypes["ContentReferenceGalleryImageUpdateResult"]],
upsertContentReferenceGalleryImage?: [{	by:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null,	update:ValueTypes["ContentReferenceGalleryImageUpdateInput"],	create:ValueTypes["ContentReferenceGalleryImageCreateInput"]},ValueTypes["ContentReferenceGalleryImageUpsertResult"]],
createItem?: [{	data:ValueTypes["ItemCreateInput"]},ValueTypes["ItemCreateResult"]],
deleteItem?: [{	by:ValueTypes["ItemUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["ItemDeleteResult"]],
updateItem?: [{	by:ValueTypes["ItemUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null,	data:ValueTypes["ItemUpdateInput"]},ValueTypes["ItemUpdateResult"]],
upsertItem?: [{	by:ValueTypes["ItemUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null,	update:ValueTypes["ItemUpdateInput"],	create:ValueTypes["ItemCreateInput"]},ValueTypes["ItemUpsertResult"]],
createItemSubCategory?: [{	data:ValueTypes["ItemSubCategoryCreateInput"]},ValueTypes["ItemSubCategoryCreateResult"]],
deleteItemSubCategory?: [{	by:ValueTypes["ItemSubCategoryUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategoryDeleteResult"]],
updateItemSubCategory?: [{	by:ValueTypes["ItemSubCategoryUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	data:ValueTypes["ItemSubCategoryUpdateInput"]},ValueTypes["ItemSubCategoryUpdateResult"]],
upsertItemSubCategory?: [{	by:ValueTypes["ItemSubCategoryUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	update:ValueTypes["ItemSubCategoryUpdateInput"],	create:ValueTypes["ItemSubCategoryCreateInput"]},ValueTypes["ItemSubCategoryUpsertResult"]],
createItemCategory?: [{	data:ValueTypes["ItemCategoryCreateInput"]},ValueTypes["ItemCategoryCreateResult"]],
deleteItemCategory?: [{	by:ValueTypes["ItemCategoryUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategoryDeleteResult"]],
updateItemCategory?: [{	by:ValueTypes["ItemCategoryUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null,	data:ValueTypes["ItemCategoryUpdateInput"]},ValueTypes["ItemCategoryUpdateResult"]],
upsertItemCategory?: [{	by:ValueTypes["ItemCategoryUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null,	update:ValueTypes["ItemCategoryUpdateInput"],	create:ValueTypes["ItemCategoryCreateInput"]},ValueTypes["ItemCategoryUpsertResult"]],
createItemFlavorCategory?: [{	data:ValueTypes["ItemFlavorCategoryCreateInput"]},ValueTypes["ItemFlavorCategoryCreateResult"]],
deleteItemFlavorCategory?: [{	by:ValueTypes["ItemFlavorCategoryUniqueWhere"],	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null},ValueTypes["ItemFlavorCategoryDeleteResult"]],
updateItemFlavorCategory?: [{	by:ValueTypes["ItemFlavorCategoryUniqueWhere"],	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null,	data:ValueTypes["ItemFlavorCategoryUpdateInput"]},ValueTypes["ItemFlavorCategoryUpdateResult"]],
upsertItemFlavorCategory?: [{	by:ValueTypes["ItemFlavorCategoryUniqueWhere"],	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null,	update:ValueTypes["ItemFlavorCategoryUpdateInput"],	create:ValueTypes["ItemFlavorCategoryCreateInput"]},ValueTypes["ItemFlavorCategoryUpsertResult"]],
createItemDeclensionFourthVariant?: [{	data:ValueTypes["ItemDeclensionFourthVariantCreateInput"]},ValueTypes["ItemDeclensionFourthVariantCreateResult"]],
deleteItemDeclensionFourthVariant?: [{	by:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariantDeleteResult"]],
updateItemDeclensionFourthVariant?: [{	by:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,	data:ValueTypes["ItemDeclensionFourthVariantUpdateInput"]},ValueTypes["ItemDeclensionFourthVariantUpdateResult"]],
upsertItemDeclensionFourthVariant?: [{	by:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,	update:ValueTypes["ItemDeclensionFourthVariantUpdateInput"],	create:ValueTypes["ItemDeclensionFourthVariantCreateInput"]},ValueTypes["ItemDeclensionFourthVariantUpsertResult"]],
createItemDeclensionSeventhVariant?: [{	data:ValueTypes["ItemDeclensionSeventhVariantCreateInput"]},ValueTypes["ItemDeclensionSeventhVariantCreateResult"]],
deleteItemDeclensionSeventhVariant?: [{	by:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null},ValueTypes["ItemDeclensionSeventhVariantDeleteResult"]],
updateItemDeclensionSeventhVariant?: [{	by:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null,	data:ValueTypes["ItemDeclensionSeventhVariantUpdateInput"]},ValueTypes["ItemDeclensionSeventhVariantUpdateResult"]],
upsertItemDeclensionSeventhVariant?: [{	by:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null,	update:ValueTypes["ItemDeclensionSeventhVariantUpdateInput"],	create:ValueTypes["ItemDeclensionSeventhVariantCreateInput"]},ValueTypes["ItemDeclensionSeventhVariantUpsertResult"]],
createMediaCard?: [{	data:ValueTypes["MediaCardCreateInput"]},ValueTypes["MediaCardCreateResult"]],
deleteMediaCard?: [{	by:ValueTypes["MediaCardUniqueWhere"],	filter?:ValueTypes["MediaCardWhere"] | null},ValueTypes["MediaCardDeleteResult"]],
updateMediaCard?: [{	by:ValueTypes["MediaCardUniqueWhere"],	filter?:ValueTypes["MediaCardWhere"] | null,	data:ValueTypes["MediaCardUpdateInput"]},ValueTypes["MediaCardUpdateResult"]],
upsertMediaCard?: [{	by:ValueTypes["MediaCardUniqueWhere"],	filter?:ValueTypes["MediaCardWhere"] | null,	update:ValueTypes["MediaCardUpdateInput"],	create:ValueTypes["MediaCardCreateInput"]},ValueTypes["MediaCardUpsertResult"]],
createInfoCard?: [{	data:ValueTypes["InfoCardCreateInput"]},ValueTypes["InfoCardCreateResult"]],
deleteInfoCard?: [{	by:ValueTypes["InfoCardUniqueWhere"],	filter?:ValueTypes["InfoCardWhere"] | null},ValueTypes["InfoCardDeleteResult"]],
updateInfoCard?: [{	by:ValueTypes["InfoCardUniqueWhere"],	filter?:ValueTypes["InfoCardWhere"] | null,	data:ValueTypes["InfoCardUpdateInput"]},ValueTypes["InfoCardUpdateResult"]],
upsertInfoCard?: [{	by:ValueTypes["InfoCardUniqueWhere"],	filter?:ValueTypes["InfoCardWhere"] | null,	update:ValueTypes["InfoCardUpdateInput"],	create:ValueTypes["InfoCardCreateInput"]},ValueTypes["InfoCardUpsertResult"]],
createNumberedCard?: [{	data:ValueTypes["NumberedCardCreateInput"]},ValueTypes["NumberedCardCreateResult"]],
deleteNumberedCard?: [{	by:ValueTypes["NumberedCardUniqueWhere"],	filter?:ValueTypes["NumberedCardWhere"] | null},ValueTypes["NumberedCardDeleteResult"]],
updateNumberedCard?: [{	by:ValueTypes["NumberedCardUniqueWhere"],	filter?:ValueTypes["NumberedCardWhere"] | null,	data:ValueTypes["NumberedCardUpdateInput"]},ValueTypes["NumberedCardUpdateResult"]],
upsertNumberedCard?: [{	by:ValueTypes["NumberedCardUniqueWhere"],	filter?:ValueTypes["NumberedCardWhere"] | null,	update:ValueTypes["NumberedCardUpdateInput"],	create:ValueTypes["NumberedCardCreateInput"]},ValueTypes["NumberedCardUpsertResult"]],
createRegisterClaim?: [{	data:ValueTypes["RegisterClaimCreateInput"]},ValueTypes["RegisterClaimCreateResult"]],
deleteRegisterClaim?: [{	by:ValueTypes["RegisterClaimUniqueWhere"],	filter?:ValueTypes["RegisterClaimWhere"] | null},ValueTypes["RegisterClaimDeleteResult"]],
updateRegisterClaim?: [{	by:ValueTypes["RegisterClaimUniqueWhere"],	filter?:ValueTypes["RegisterClaimWhere"] | null,	data:ValueTypes["RegisterClaimUpdateInput"]},ValueTypes["RegisterClaimUpdateResult"]],
upsertRegisterClaim?: [{	by:ValueTypes["RegisterClaimUniqueWhere"],	filter?:ValueTypes["RegisterClaimWhere"] | null,	update:ValueTypes["RegisterClaimUpdateInput"],	create:ValueTypes["RegisterClaimCreateInput"]},ValueTypes["RegisterClaimUpsertResult"]],
createBlogPostReviewReaction?: [{	data:ValueTypes["BlogPostReviewReactionCreateInput"]},ValueTypes["BlogPostReviewReactionCreateResult"]],
deleteBlogPostReviewReaction?: [{	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null},ValueTypes["BlogPostReviewReactionDeleteResult"]],
updateBlogPostReviewReaction?: [{	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null,	data:ValueTypes["BlogPostReviewReactionUpdateInput"]},ValueTypes["BlogPostReviewReactionUpdateResult"]],
upsertBlogPostReviewReaction?: [{	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null,	update:ValueTypes["BlogPostReviewReactionUpdateInput"],	create:ValueTypes["BlogPostReviewReactionCreateInput"]},ValueTypes["BlogPostReviewReactionUpsertResult"]],
createProductReviewReaction?: [{	data:ValueTypes["ProductReviewReactionCreateInput"]},ValueTypes["ProductReviewReactionCreateResult"]],
deleteProductReviewReaction?: [{	by:ValueTypes["ProductReviewReactionUniqueWhere"],	filter?:ValueTypes["ProductReviewReactionWhere"] | null},ValueTypes["ProductReviewReactionDeleteResult"]],
updateProductReviewReaction?: [{	by:ValueTypes["ProductReviewReactionUniqueWhere"],	filter?:ValueTypes["ProductReviewReactionWhere"] | null,	data:ValueTypes["ProductReviewReactionUpdateInput"]},ValueTypes["ProductReviewReactionUpdateResult"]],
upsertProductReviewReaction?: [{	by:ValueTypes["ProductReviewReactionUniqueWhere"],	filter?:ValueTypes["ProductReviewReactionWhere"] | null,	update:ValueTypes["ProductReviewReactionUpdateInput"],	create:ValueTypes["ProductReviewReactionCreateInput"]},ValueTypes["ProductReviewReactionUpsertResult"]],
createProductPackage?: [{	data:ValueTypes["ProductPackageCreateInput"]},ValueTypes["ProductPackageCreateResult"]],
deleteProductPackage?: [{	by:ValueTypes["ProductPackageUniqueWhere"],	filter?:ValueTypes["ProductPackageWhere"] | null},ValueTypes["ProductPackageDeleteResult"]],
updateProductPackage?: [{	by:ValueTypes["ProductPackageUniqueWhere"],	filter?:ValueTypes["ProductPackageWhere"] | null,	data:ValueTypes["ProductPackageUpdateInput"]},ValueTypes["ProductPackageUpdateResult"]],
upsertProductPackage?: [{	by:ValueTypes["ProductPackageUniqueWhere"],	filter?:ValueTypes["ProductPackageWhere"] | null,	update:ValueTypes["ProductPackageUpdateInput"],	create:ValueTypes["ProductPackageCreateInput"]},ValueTypes["ProductPackageUpsertResult"]],
createBrandManufacturer?: [{	data:ValueTypes["BrandManufacturerCreateInput"]},ValueTypes["BrandManufacturerCreateResult"]],
deleteBrandManufacturer?: [{	by:ValueTypes["BrandManufacturerUniqueWhere"],	filter?:ValueTypes["BrandManufacturerWhere"] | null},ValueTypes["BrandManufacturerDeleteResult"]],
updateBrandManufacturer?: [{	by:ValueTypes["BrandManufacturerUniqueWhere"],	filter?:ValueTypes["BrandManufacturerWhere"] | null,	data:ValueTypes["BrandManufacturerUpdateInput"]},ValueTypes["BrandManufacturerUpdateResult"]],
upsertBrandManufacturer?: [{	by:ValueTypes["BrandManufacturerUniqueWhere"],	filter?:ValueTypes["BrandManufacturerWhere"] | null,	update:ValueTypes["BrandManufacturerUpdateInput"],	create:ValueTypes["BrandManufacturerCreateInput"]},ValueTypes["BrandManufacturerUpsertResult"]],
createElement?: [{	data:ValueTypes["ElementCreateInput"]},ValueTypes["ElementCreateResult"]],
deleteElement?: [{	by:ValueTypes["ElementUniqueWhere"],	filter?:ValueTypes["ElementWhere"] | null},ValueTypes["ElementDeleteResult"]],
updateElement?: [{	by:ValueTypes["ElementUniqueWhere"],	filter?:ValueTypes["ElementWhere"] | null,	data:ValueTypes["ElementUpdateInput"]},ValueTypes["ElementUpdateResult"]],
upsertElement?: [{	by:ValueTypes["ElementUniqueWhere"],	filter?:ValueTypes["ElementWhere"] | null,	update:ValueTypes["ElementUpdateInput"],	create:ValueTypes["ElementCreateInput"]},ValueTypes["ElementUpsertResult"]],
createElementOfProduct?: [{	data:ValueTypes["ElementOfProductCreateInput"]},ValueTypes["ElementOfProductCreateResult"]],
deleteElementOfProduct?: [{	by:ValueTypes["ElementOfProductUniqueWhere"],	filter?:ValueTypes["ElementOfProductWhere"] | null},ValueTypes["ElementOfProductDeleteResult"]],
updateElementOfProduct?: [{	by:ValueTypes["ElementOfProductUniqueWhere"],	filter?:ValueTypes["ElementOfProductWhere"] | null,	data:ValueTypes["ElementOfProductUpdateInput"]},ValueTypes["ElementOfProductUpdateResult"]],
upsertElementOfProduct?: [{	by:ValueTypes["ElementOfProductUniqueWhere"],	filter?:ValueTypes["ElementOfProductWhere"] | null,	update:ValueTypes["ElementOfProductUpdateInput"],	create:ValueTypes["ElementOfProductCreateInput"]},ValueTypes["ElementOfProductUpsertResult"]],
createSuitabilityCategory?: [{	data:ValueTypes["SuitabilityCategoryCreateInput"]},ValueTypes["SuitabilityCategoryCreateResult"]],
deleteSuitabilityCategory?: [{	by:ValueTypes["SuitabilityCategoryUniqueWhere"],	filter?:ValueTypes["SuitabilityCategoryWhere"] | null},ValueTypes["SuitabilityCategoryDeleteResult"]],
updateSuitabilityCategory?: [{	by:ValueTypes["SuitabilityCategoryUniqueWhere"],	filter?:ValueTypes["SuitabilityCategoryWhere"] | null,	data:ValueTypes["SuitabilityCategoryUpdateInput"]},ValueTypes["SuitabilityCategoryUpdateResult"]],
upsertSuitabilityCategory?: [{	by:ValueTypes["SuitabilityCategoryUniqueWhere"],	filter?:ValueTypes["SuitabilityCategoryWhere"] | null,	update:ValueTypes["SuitabilityCategoryUpdateInput"],	create:ValueTypes["SuitabilityCategoryCreateInput"]},ValueTypes["SuitabilityCategoryUpsertResult"]],
createProductFeature?: [{	data:ValueTypes["ProductFeatureCreateInput"]},ValueTypes["ProductFeatureCreateResult"]],
deleteProductFeature?: [{	by:ValueTypes["ProductFeatureUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null},ValueTypes["ProductFeatureDeleteResult"]],
updateProductFeature?: [{	by:ValueTypes["ProductFeatureUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null,	data:ValueTypes["ProductFeatureUpdateInput"]},ValueTypes["ProductFeatureUpdateResult"]],
upsertProductFeature?: [{	by:ValueTypes["ProductFeatureUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null,	update:ValueTypes["ProductFeatureUpdateInput"],	create:ValueTypes["ProductFeatureCreateInput"]},ValueTypes["ProductFeatureUpsertResult"]],
createSuitabilityItem?: [{	data:ValueTypes["SuitabilityItemCreateInput"]},ValueTypes["SuitabilityItemCreateResult"]],
deleteSuitabilityItem?: [{	by:ValueTypes["SuitabilityItemUniqueWhere"],	filter?:ValueTypes["SuitabilityItemWhere"] | null},ValueTypes["SuitabilityItemDeleteResult"]],
updateSuitabilityItem?: [{	by:ValueTypes["SuitabilityItemUniqueWhere"],	filter?:ValueTypes["SuitabilityItemWhere"] | null,	data:ValueTypes["SuitabilityItemUpdateInput"]},ValueTypes["SuitabilityItemUpdateResult"]],
upsertSuitabilityItem?: [{	by:ValueTypes["SuitabilityItemUniqueWhere"],	filter?:ValueTypes["SuitabilityItemWhere"] | null,	update:ValueTypes["SuitabilityItemUpdateInput"],	create:ValueTypes["SuitabilityItemCreateInput"]},ValueTypes["SuitabilityItemUpsertResult"]],
createRegion?: [{	data:ValueTypes["RegionCreateInput"]},ValueTypes["RegionCreateResult"]],
deleteRegion?: [{	by:ValueTypes["RegionUniqueWhere"],	filter?:ValueTypes["RegionWhere"] | null},ValueTypes["RegionDeleteResult"]],
updateRegion?: [{	by:ValueTypes["RegionUniqueWhere"],	filter?:ValueTypes["RegionWhere"] | null,	data:ValueTypes["RegionUpdateInput"]},ValueTypes["RegionUpdateResult"]],
upsertRegion?: [{	by:ValueTypes["RegionUniqueWhere"],	filter?:ValueTypes["RegionWhere"] | null,	update:ValueTypes["RegionUpdateInput"],	create:ValueTypes["RegionCreateInput"]},ValueTypes["RegionUpsertResult"]],
createGranuleSize?: [{	data:ValueTypes["GranuleSizeCreateInput"]},ValueTypes["GranuleSizeCreateResult"]],
deleteGranuleSize?: [{	by:ValueTypes["GranuleSizeUniqueWhere"],	filter?:ValueTypes["GranuleSizeWhere"] | null},ValueTypes["GranuleSizeDeleteResult"]],
updateGranuleSize?: [{	by:ValueTypes["GranuleSizeUniqueWhere"],	filter?:ValueTypes["GranuleSizeWhere"] | null,	data:ValueTypes["GranuleSizeUpdateInput"]},ValueTypes["GranuleSizeUpdateResult"]],
upsertGranuleSize?: [{	by:ValueTypes["GranuleSizeUniqueWhere"],	filter?:ValueTypes["GranuleSizeWhere"] | null,	update:ValueTypes["GranuleSizeUpdateInput"],	create:ValueTypes["GranuleSizeCreateInput"]},ValueTypes["GranuleSizeUpsertResult"]],
createItemAlias?: [{	data:ValueTypes["ItemAliasCreateInput"]},ValueTypes["ItemAliasCreateResult"]],
deleteItemAlias?: [{	by:ValueTypes["ItemAliasUniqueWhere"],	filter?:ValueTypes["ItemAliasWhere"] | null},ValueTypes["ItemAliasDeleteResult"]],
updateItemAlias?: [{	by:ValueTypes["ItemAliasUniqueWhere"],	filter?:ValueTypes["ItemAliasWhere"] | null,	data:ValueTypes["ItemAliasUpdateInput"]},ValueTypes["ItemAliasUpdateResult"]],
upsertItemAlias?: [{	by:ValueTypes["ItemAliasUniqueWhere"],	filter?:ValueTypes["ItemAliasWhere"] | null,	update:ValueTypes["ItemAliasUpdateInput"],	create:ValueTypes["ItemAliasCreateInput"]},ValueTypes["ItemAliasUpsertResult"]],
createSemanticKey?: [{	data:ValueTypes["SemanticKeyCreateInput"]},ValueTypes["SemanticKeyCreateResult"]],
deleteSemanticKey?: [{	by:ValueTypes["SemanticKeyUniqueWhere"],	filter?:ValueTypes["SemanticKeyWhere"] | null},ValueTypes["SemanticKeyDeleteResult"]],
updateSemanticKey?: [{	by:ValueTypes["SemanticKeyUniqueWhere"],	filter?:ValueTypes["SemanticKeyWhere"] | null,	data:ValueTypes["SemanticKeyUpdateInput"]},ValueTypes["SemanticKeyUpdateResult"]],
upsertSemanticKey?: [{	by:ValueTypes["SemanticKeyUniqueWhere"],	filter?:ValueTypes["SemanticKeyWhere"] | null,	update:ValueTypes["SemanticKeyUpdateInput"],	create:ValueTypes["SemanticKeyCreateInput"]},ValueTypes["SemanticKeyUpsertResult"]],
createProductFlag?: [{	data:ValueTypes["ProductFlagCreateInput"]},ValueTypes["ProductFlagCreateResult"]],
deleteProductFlag?: [{	by:ValueTypes["ProductFlagUniqueWhere"],	filter?:ValueTypes["ProductFlagWhere"] | null},ValueTypes["ProductFlagDeleteResult"]],
updateProductFlag?: [{	by:ValueTypes["ProductFlagUniqueWhere"],	filter?:ValueTypes["ProductFlagWhere"] | null,	data:ValueTypes["ProductFlagUpdateInput"]},ValueTypes["ProductFlagUpdateResult"]],
upsertProductFlag?: [{	by:ValueTypes["ProductFlagUniqueWhere"],	filter?:ValueTypes["ProductFlagWhere"] | null,	update:ValueTypes["ProductFlagUpdateInput"],	create:ValueTypes["ProductFlagCreateInput"]},ValueTypes["ProductFlagUpsertResult"]],
createProductFlagOfProduct?: [{	data:ValueTypes["ProductFlagOfProductCreateInput"]},ValueTypes["ProductFlagOfProductCreateResult"]],
deleteProductFlagOfProduct?: [{	by:ValueTypes["ProductFlagOfProductUniqueWhere"],	filter?:ValueTypes["ProductFlagOfProductWhere"] | null},ValueTypes["ProductFlagOfProductDeleteResult"]],
updateProductFlagOfProduct?: [{	by:ValueTypes["ProductFlagOfProductUniqueWhere"],	filter?:ValueTypes["ProductFlagOfProductWhere"] | null,	data:ValueTypes["ProductFlagOfProductUpdateInput"]},ValueTypes["ProductFlagOfProductUpdateResult"]],
upsertProductFlagOfProduct?: [{	by:ValueTypes["ProductFlagOfProductUniqueWhere"],	filter?:ValueTypes["ProductFlagOfProductWhere"] | null,	update:ValueTypes["ProductFlagOfProductUpdateInput"],	create:ValueTypes["ProductFlagOfProductCreateInput"]},ValueTypes["ProductFlagOfProductUpsertResult"]],
createProductEvaluation?: [{	data:ValueTypes["ProductEvaluationCreateInput"]},ValueTypes["ProductEvaluationCreateResult"]],
deleteProductEvaluation?: [{	by:ValueTypes["ProductEvaluationUniqueWhere"],	filter?:ValueTypes["ProductEvaluationWhere"] | null},ValueTypes["ProductEvaluationDeleteResult"]],
updateProductEvaluation?: [{	by:ValueTypes["ProductEvaluationUniqueWhere"],	filter?:ValueTypes["ProductEvaluationWhere"] | null,	data:ValueTypes["ProductEvaluationUpdateInput"]},ValueTypes["ProductEvaluationUpdateResult"]],
upsertProductEvaluation?: [{	by:ValueTypes["ProductEvaluationUniqueWhere"],	filter?:ValueTypes["ProductEvaluationWhere"] | null,	update:ValueTypes["ProductEvaluationUpdateInput"],	create:ValueTypes["ProductEvaluationCreateInput"]},ValueTypes["ProductEvaluationUpsertResult"]],
createAd?: [{	data:ValueTypes["AdCreateInput"]},ValueTypes["AdCreateResult"]],
deleteAd?: [{	by:ValueTypes["AdUniqueWhere"],	filter?:ValueTypes["AdWhere"] | null},ValueTypes["AdDeleteResult"]],
updateAd?: [{	by:ValueTypes["AdUniqueWhere"],	filter?:ValueTypes["AdWhere"] | null,	data:ValueTypes["AdUpdateInput"]},ValueTypes["AdUpdateResult"]],
upsertAd?: [{	by:ValueTypes["AdUniqueWhere"],	filter?:ValueTypes["AdWhere"] | null,	update:ValueTypes["AdUpdateInput"],	create:ValueTypes["AdCreateInput"]},ValueTypes["AdUpsertResult"]],
createEvaluationInfo?: [{	data:ValueTypes["EvaluationInfoCreateInput"]},ValueTypes["EvaluationInfoCreateResult"]],
deleteEvaluationInfo?: [{	by:ValueTypes["EvaluationInfoUniqueWhere"],	filter?:ValueTypes["EvaluationInfoWhere"] | null},ValueTypes["EvaluationInfoDeleteResult"]],
updateEvaluationInfo?: [{	by:ValueTypes["EvaluationInfoUniqueWhere"],	filter?:ValueTypes["EvaluationInfoWhere"] | null,	data:ValueTypes["EvaluationInfoUpdateInput"]},ValueTypes["EvaluationInfoUpdateResult"]],
upsertEvaluationInfo?: [{	by:ValueTypes["EvaluationInfoUniqueWhere"],	filter?:ValueTypes["EvaluationInfoWhere"] | null,	update:ValueTypes["EvaluationInfoUpdateInput"],	create:ValueTypes["EvaluationInfoCreateInput"]},ValueTypes["EvaluationInfoUpsertResult"]],
createConsumptionMessage?: [{	data:ValueTypes["ConsumptionMessageCreateInput"]},ValueTypes["ConsumptionMessageCreateResult"]],
deleteConsumptionMessage?: [{	by:ValueTypes["ConsumptionMessageUniqueWhere"],	filter?:ValueTypes["ConsumptionMessageWhere"] | null},ValueTypes["ConsumptionMessageDeleteResult"]],
updateConsumptionMessage?: [{	by:ValueTypes["ConsumptionMessageUniqueWhere"],	filter?:ValueTypes["ConsumptionMessageWhere"] | null,	data:ValueTypes["ConsumptionMessageUpdateInput"]},ValueTypes["ConsumptionMessageUpdateResult"]],
upsertConsumptionMessage?: [{	by:ValueTypes["ConsumptionMessageUniqueWhere"],	filter?:ValueTypes["ConsumptionMessageWhere"] | null,	update:ValueTypes["ConsumptionMessageUpdateInput"],	create:ValueTypes["ConsumptionMessageCreateInput"]},ValueTypes["ConsumptionMessageUpsertResult"]],
createContentText?: [{	data:ValueTypes["ContentTextCreateInput"]},ValueTypes["ContentTextCreateResult"]],
deleteContentText?: [{	by:ValueTypes["ContentTextUniqueWhere"],	filter?:ValueTypes["ContentTextWhere"] | null},ValueTypes["ContentTextDeleteResult"]],
updateContentText?: [{	by:ValueTypes["ContentTextUniqueWhere"],	filter?:ValueTypes["ContentTextWhere"] | null,	data:ValueTypes["ContentTextUpdateInput"]},ValueTypes["ContentTextUpdateResult"]],
upsertContentText?: [{	by:ValueTypes["ContentTextUniqueWhere"],	filter?:ValueTypes["ContentTextWhere"] | null,	update:ValueTypes["ContentTextUpdateInput"],	create:ValueTypes["ContentTextCreateInput"]},ValueTypes["ContentTextUpsertResult"]],
createContentTextBlock?: [{	data:ValueTypes["ContentTextBlockCreateInput"]},ValueTypes["ContentTextBlockCreateResult"]],
deleteContentTextBlock?: [{	by:ValueTypes["ContentTextBlockUniqueWhere"],	filter?:ValueTypes["ContentTextBlockWhere"] | null},ValueTypes["ContentTextBlockDeleteResult"]],
updateContentTextBlock?: [{	by:ValueTypes["ContentTextBlockUniqueWhere"],	filter?:ValueTypes["ContentTextBlockWhere"] | null,	data:ValueTypes["ContentTextBlockUpdateInput"]},ValueTypes["ContentTextBlockUpdateResult"]],
upsertContentTextBlock?: [{	by:ValueTypes["ContentTextBlockUniqueWhere"],	filter?:ValueTypes["ContentTextBlockWhere"] | null,	update:ValueTypes["ContentTextBlockUpdateInput"],	create:ValueTypes["ContentTextBlockCreateInput"]},ValueTypes["ContentTextBlockUpsertResult"]],
createComparatorPage?: [{	data:ValueTypes["ComparatorPageCreateInput"]},ValueTypes["ComparatorPageCreateResult"]],
deleteComparatorPage?: [{	by:ValueTypes["ComparatorPageUniqueWhere"],	filter?:ValueTypes["ComparatorPageWhere"] | null},ValueTypes["ComparatorPageDeleteResult"]],
updateComparatorPage?: [{	by:ValueTypes["ComparatorPageUniqueWhere"],	filter?:ValueTypes["ComparatorPageWhere"] | null,	data:ValueTypes["ComparatorPageUpdateInput"]},ValueTypes["ComparatorPageUpdateResult"]],
upsertComparatorPage?: [{	by:ValueTypes["ComparatorPageUniqueWhere"],	filter?:ValueTypes["ComparatorPageWhere"] | null,	update:ValueTypes["ComparatorPageUpdateInput"],	create:ValueTypes["ComparatorPageCreateInput"]},ValueTypes["ComparatorPageUpsertResult"]],
createLoginPage?: [{	data:ValueTypes["LoginPageCreateInput"]},ValueTypes["LoginPageCreateResult"]],
deleteLoginPage?: [{	by:ValueTypes["LoginPageUniqueWhere"],	filter?:ValueTypes["LoginPageWhere"] | null},ValueTypes["LoginPageDeleteResult"]],
updateLoginPage?: [{	by:ValueTypes["LoginPageUniqueWhere"],	filter?:ValueTypes["LoginPageWhere"] | null,	data:ValueTypes["LoginPageUpdateInput"]},ValueTypes["LoginPageUpdateResult"]],
upsertLoginPage?: [{	by:ValueTypes["LoginPageUniqueWhere"],	filter?:ValueTypes["LoginPageWhere"] | null,	update:ValueTypes["LoginPageUpdateInput"],	create:ValueTypes["LoginPageCreateInput"]},ValueTypes["LoginPageUpsertResult"]],
createRegisterPage?: [{	data:ValueTypes["RegisterPageCreateInput"]},ValueTypes["RegisterPageCreateResult"]],
deleteRegisterPage?: [{	by:ValueTypes["RegisterPageUniqueWhere"],	filter?:ValueTypes["RegisterPageWhere"] | null},ValueTypes["RegisterPageDeleteResult"]],
updateRegisterPage?: [{	by:ValueTypes["RegisterPageUniqueWhere"],	filter?:ValueTypes["RegisterPageWhere"] | null,	data:ValueTypes["RegisterPageUpdateInput"]},ValueTypes["RegisterPageUpdateResult"]],
upsertRegisterPage?: [{	by:ValueTypes["RegisterPageUniqueWhere"],	filter?:ValueTypes["RegisterPageWhere"] | null,	update:ValueTypes["RegisterPageUpdateInput"],	create:ValueTypes["RegisterPageCreateInput"]},ValueTypes["RegisterPageUpsertResult"]],
createResultsPage?: [{	data:ValueTypes["ResultsPageCreateInput"]},ValueTypes["ResultsPageCreateResult"]],
deleteResultsPage?: [{	by:ValueTypes["ResultsPageUniqueWhere"],	filter?:ValueTypes["ResultsPageWhere"] | null},ValueTypes["ResultsPageDeleteResult"]],
updateResultsPage?: [{	by:ValueTypes["ResultsPageUniqueWhere"],	filter?:ValueTypes["ResultsPageWhere"] | null,	data:ValueTypes["ResultsPageUpdateInput"]},ValueTypes["ResultsPageUpdateResult"]],
upsertResultsPage?: [{	by:ValueTypes["ResultsPageUniqueWhere"],	filter?:ValueTypes["ResultsPageWhere"] | null,	update:ValueTypes["ResultsPageUpdateInput"],	create:ValueTypes["ResultsPageCreateInput"]},ValueTypes["ResultsPageUpsertResult"]],
createSearchPage?: [{	data:ValueTypes["SearchPageCreateInput"]},ValueTypes["SearchPageCreateResult"]],
deleteSearchPage?: [{	by:ValueTypes["SearchPageUniqueWhere"],	filter?:ValueTypes["SearchPageWhere"] | null},ValueTypes["SearchPageDeleteResult"]],
updateSearchPage?: [{	by:ValueTypes["SearchPageUniqueWhere"],	filter?:ValueTypes["SearchPageWhere"] | null,	data:ValueTypes["SearchPageUpdateInput"]},ValueTypes["SearchPageUpdateResult"]],
upsertSearchPage?: [{	by:ValueTypes["SearchPageUniqueWhere"],	filter?:ValueTypes["SearchPageWhere"] | null,	update:ValueTypes["SearchPageUpdateInput"],	create:ValueTypes["SearchPageCreateInput"]},ValueTypes["SearchPageUpsertResult"]],
createWizardPage?: [{	data:ValueTypes["WizardPageCreateInput"]},ValueTypes["WizardPageCreateResult"]],
deleteWizardPage?: [{	by:ValueTypes["WizardPageUniqueWhere"],	filter?:ValueTypes["WizardPageWhere"] | null},ValueTypes["WizardPageDeleteResult"]],
updateWizardPage?: [{	by:ValueTypes["WizardPageUniqueWhere"],	filter?:ValueTypes["WizardPageWhere"] | null,	data:ValueTypes["WizardPageUpdateInput"]},ValueTypes["WizardPageUpdateResult"]],
upsertWizardPage?: [{	by:ValueTypes["WizardPageUniqueWhere"],	filter?:ValueTypes["WizardPageWhere"] | null,	update:ValueTypes["WizardPageUpdateInput"],	create:ValueTypes["WizardPageCreateInput"]},ValueTypes["WizardPageUpsertResult"]],
createBreastfeedingCategory?: [{	data:ValueTypes["BreastfeedingCategoryCreateInput"]},ValueTypes["BreastfeedingCategoryCreateResult"]],
deleteBreastfeedingCategory?: [{	by:ValueTypes["BreastfeedingCategoryUniqueWhere"],	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null},ValueTypes["BreastfeedingCategoryDeleteResult"]],
updateBreastfeedingCategory?: [{	by:ValueTypes["BreastfeedingCategoryUniqueWhere"],	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null,	data:ValueTypes["BreastfeedingCategoryUpdateInput"]},ValueTypes["BreastfeedingCategoryUpdateResult"]],
upsertBreastfeedingCategory?: [{	by:ValueTypes["BreastfeedingCategoryUniqueWhere"],	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null,	update:ValueTypes["BreastfeedingCategoryUpdateInput"],	create:ValueTypes["BreastfeedingCategoryCreateInput"]},ValueTypes["BreastfeedingCategoryUpsertResult"]],
createDogReproduction?: [{	data:ValueTypes["DogReproductionCreateInput"]},ValueTypes["DogReproductionCreateResult"]],
deleteDogReproduction?: [{	by:ValueTypes["DogReproductionUniqueWhere"],	filter?:ValueTypes["DogReproductionWhere"] | null},ValueTypes["DogReproductionDeleteResult"]],
updateDogReproduction?: [{	by:ValueTypes["DogReproductionUniqueWhere"],	filter?:ValueTypes["DogReproductionWhere"] | null,	data:ValueTypes["DogReproductionUpdateInput"]},ValueTypes["DogReproductionUpdateResult"]],
upsertDogReproduction?: [{	by:ValueTypes["DogReproductionUniqueWhere"],	filter?:ValueTypes["DogReproductionWhere"] | null,	update:ValueTypes["DogReproductionUpdateInput"],	create:ValueTypes["DogReproductionCreateInput"]},ValueTypes["DogReproductionUpsertResult"]],
createContactFormMessage?: [{	data:ValueTypes["ContactFormMessageCreateInput"]},ValueTypes["ContactFormMessageCreateResult"]],
deleteContactFormMessage?: [{	by:ValueTypes["ContactFormMessageUniqueWhere"],	filter?:ValueTypes["ContactFormMessageWhere"] | null},ValueTypes["ContactFormMessageDeleteResult"]],
updateContactFormMessage?: [{	by:ValueTypes["ContactFormMessageUniqueWhere"],	filter?:ValueTypes["ContactFormMessageWhere"] | null,	data:ValueTypes["ContactFormMessageUpdateInput"]},ValueTypes["ContactFormMessageUpdateResult"]],
upsertContactFormMessage?: [{	by:ValueTypes["ContactFormMessageUniqueWhere"],	filter?:ValueTypes["ContactFormMessageWhere"] | null,	update:ValueTypes["ContactFormMessageUpdateInput"],	create:ValueTypes["ContactFormMessageCreateInput"]},ValueTypes["ContactFormMessageUpsertResult"]],
createContactPage?: [{	data:ValueTypes["ContactPageCreateInput"]},ValueTypes["ContactPageCreateResult"]],
deleteContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null},ValueTypes["ContactPageDeleteResult"]],
updateContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null,	data:ValueTypes["ContactPageUpdateInput"]},ValueTypes["ContactPageUpdateResult"]],
upsertContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null,	update:ValueTypes["ContactPageUpdateInput"],	create:ValueTypes["ContactPageCreateInput"]},ValueTypes["ContactPageUpsertResult"]],
createBugReport?: [{	data:ValueTypes["BugReportCreateInput"]},ValueTypes["BugReportCreateResult"]],
deleteBugReport?: [{	by:ValueTypes["BugReportUniqueWhere"],	filter?:ValueTypes["BugReportWhere"] | null},ValueTypes["BugReportDeleteResult"]],
updateBugReport?: [{	by:ValueTypes["BugReportUniqueWhere"],	filter?:ValueTypes["BugReportWhere"] | null,	data:ValueTypes["BugReportUpdateInput"]},ValueTypes["BugReportUpdateResult"]],
upsertBugReport?: [{	by:ValueTypes["BugReportUniqueWhere"],	filter?:ValueTypes["BugReportWhere"] | null,	update:ValueTypes["BugReportUpdateInput"],	create:ValueTypes["BugReportCreateInput"]},ValueTypes["BugReportUpsertResult"]],
createColor?: [{	data:ValueTypes["ColorCreateInput"]},ValueTypes["ColorCreateResult"]],
deleteColor?: [{	by:ValueTypes["ColorUniqueWhere"],	filter?:ValueTypes["ColorWhere"] | null},ValueTypes["ColorDeleteResult"]],
updateColor?: [{	by:ValueTypes["ColorUniqueWhere"],	filter?:ValueTypes["ColorWhere"] | null,	data:ValueTypes["ColorUpdateInput"]},ValueTypes["ColorUpdateResult"]],
upsertColor?: [{	by:ValueTypes["ColorUniqueWhere"],	filter?:ValueTypes["ColorWhere"] | null,	update:ValueTypes["ColorUpdateInput"],	create:ValueTypes["ColorCreateInput"]},ValueTypes["ColorUpsertResult"]],
createItemGroup?: [{	data:ValueTypes["ItemGroupCreateInput"]},ValueTypes["ItemGroupCreateResult"]],
deleteItemGroup?: [{	by:ValueTypes["ItemGroupUniqueWhere"],	filter?:ValueTypes["ItemGroupWhere"] | null},ValueTypes["ItemGroupDeleteResult"]],
updateItemGroup?: [{	by:ValueTypes["ItemGroupUniqueWhere"],	filter?:ValueTypes["ItemGroupWhere"] | null,	data:ValueTypes["ItemGroupUpdateInput"]},ValueTypes["ItemGroupUpdateResult"]],
upsertItemGroup?: [{	by:ValueTypes["ItemGroupUniqueWhere"],	filter?:ValueTypes["ItemGroupWhere"] | null,	update:ValueTypes["ItemGroupUpdateInput"],	create:ValueTypes["ItemGroupCreateInput"]},ValueTypes["ItemGroupUpsertResult"]],
createProductEvaluationSummary?: [{	data:ValueTypes["ProductEvaluationSummaryCreateInput"]},ValueTypes["ProductEvaluationSummaryCreateResult"]],
deleteProductEvaluationSummary?: [{	by:ValueTypes["ProductEvaluationSummaryUniqueWhere"],	filter?:ValueTypes["ProductEvaluationSummaryWhere"] | null},ValueTypes["ProductEvaluationSummaryDeleteResult"]],
updateProductEvaluationSummary?: [{	by:ValueTypes["ProductEvaluationSummaryUniqueWhere"],	filter?:ValueTypes["ProductEvaluationSummaryWhere"] | null,	data:ValueTypes["ProductEvaluationSummaryUpdateInput"]},ValueTypes["ProductEvaluationSummaryUpdateResult"]],
upsertProductEvaluationSummary?: [{	by:ValueTypes["ProductEvaluationSummaryUniqueWhere"],	filter?:ValueTypes["ProductEvaluationSummaryWhere"] | null,	update:ValueTypes["ProductEvaluationSummaryUpdateInput"],	create:ValueTypes["ProductEvaluationSummaryCreateInput"]},ValueTypes["ProductEvaluationSummaryUpsertResult"]],
createProtectedAction?: [{	data:ValueTypes["ProtectedActionCreateInput"]},ValueTypes["ProtectedActionCreateResult"]],
deleteProtectedAction?: [{	by:ValueTypes["ProtectedActionUniqueWhere"],	filter?:ValueTypes["ProtectedActionWhere"] | null},ValueTypes["ProtectedActionDeleteResult"]],
updateProtectedAction?: [{	by:ValueTypes["ProtectedActionUniqueWhere"],	filter?:ValueTypes["ProtectedActionWhere"] | null,	data:ValueTypes["ProtectedActionUpdateInput"]},ValueTypes["ProtectedActionUpdateResult"]],
upsertProtectedAction?: [{	by:ValueTypes["ProtectedActionUniqueWhere"],	filter?:ValueTypes["ProtectedActionWhere"] | null,	update:ValueTypes["ProtectedActionUpdateInput"],	create:ValueTypes["ProtectedActionCreateInput"]},ValueTypes["ProtectedActionUpsertResult"]],
createBrandAlias?: [{	data:ValueTypes["BrandAliasCreateInput"]},ValueTypes["BrandAliasCreateResult"]],
deleteBrandAlias?: [{	by:ValueTypes["BrandAliasUniqueWhere"],	filter?:ValueTypes["BrandAliasWhere"] | null},ValueTypes["BrandAliasDeleteResult"]],
updateBrandAlias?: [{	by:ValueTypes["BrandAliasUniqueWhere"],	filter?:ValueTypes["BrandAliasWhere"] | null,	data:ValueTypes["BrandAliasUpdateInput"]},ValueTypes["BrandAliasUpdateResult"]],
upsertBrandAlias?: [{	by:ValueTypes["BrandAliasUniqueWhere"],	filter?:ValueTypes["BrandAliasWhere"] | null,	update:ValueTypes["BrandAliasUpdateInput"],	create:ValueTypes["BrandAliasCreateInput"]},ValueTypes["BrandAliasUpsertResult"]],
createProductAlias?: [{	data:ValueTypes["ProductAliasCreateInput"]},ValueTypes["ProductAliasCreateResult"]],
deleteProductAlias?: [{	by:ValueTypes["ProductAliasUniqueWhere"],	filter?:ValueTypes["ProductAliasWhere"] | null},ValueTypes["ProductAliasDeleteResult"]],
updateProductAlias?: [{	by:ValueTypes["ProductAliasUniqueWhere"],	filter?:ValueTypes["ProductAliasWhere"] | null,	data:ValueTypes["ProductAliasUpdateInput"]},ValueTypes["ProductAliasUpdateResult"]],
upsertProductAlias?: [{	by:ValueTypes["ProductAliasUniqueWhere"],	filter?:ValueTypes["ProductAliasWhere"] | null,	update:ValueTypes["ProductAliasUpdateInput"],	create:ValueTypes["ProductAliasCreateInput"]},ValueTypes["ProductAliasUpsertResult"]],
createProductLineAlias?: [{	data:ValueTypes["ProductLineAliasCreateInput"]},ValueTypes["ProductLineAliasCreateResult"]],
deleteProductLineAlias?: [{	by:ValueTypes["ProductLineAliasUniqueWhere"],	filter?:ValueTypes["ProductLineAliasWhere"] | null},ValueTypes["ProductLineAliasDeleteResult"]],
updateProductLineAlias?: [{	by:ValueTypes["ProductLineAliasUniqueWhere"],	filter?:ValueTypes["ProductLineAliasWhere"] | null,	data:ValueTypes["ProductLineAliasUpdateInput"]},ValueTypes["ProductLineAliasUpdateResult"]],
upsertProductLineAlias?: [{	by:ValueTypes["ProductLineAliasUniqueWhere"],	filter?:ValueTypes["ProductLineAliasWhere"] | null,	update:ValueTypes["ProductLineAliasUpdateInput"],	create:ValueTypes["ProductLineAliasCreateInput"]},ValueTypes["ProductLineAliasUpsertResult"]],
createGenericPage?: [{	data:ValueTypes["GenericPageCreateInput"]},ValueTypes["GenericPageCreateResult"]],
deleteGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null},ValueTypes["GenericPageDeleteResult"]],
updateGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null,	data:ValueTypes["GenericPageUpdateInput"]},ValueTypes["GenericPageUpdateResult"]],
upsertGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null,	update:ValueTypes["GenericPageUpdateInput"],	create:ValueTypes["GenericPageCreateInput"]},ValueTypes["GenericPageUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createContentLinks?: [{	data:ValueTypes["ContentLinksCreateInput"]},ValueTypes["ContentLinksCreateResult"]],
deleteContentLinks?: [{	by:ValueTypes["ContentLinksUniqueWhere"],	filter?:ValueTypes["ContentLinksWhere"] | null},ValueTypes["ContentLinksDeleteResult"]],
updateContentLinks?: [{	by:ValueTypes["ContentLinksUniqueWhere"],	filter?:ValueTypes["ContentLinksWhere"] | null,	data:ValueTypes["ContentLinksUpdateInput"]},ValueTypes["ContentLinksUpdateResult"]],
upsertContentLinks?: [{	by:ValueTypes["ContentLinksUniqueWhere"],	filter?:ValueTypes["ContentLinksWhere"] | null,	update:ValueTypes["ContentLinksUpdateInput"],	create:ValueTypes["ContentLinksCreateInput"]},ValueTypes["ContentLinksUpsertResult"]],
createContentLinksItem?: [{	data:ValueTypes["ContentLinksItemCreateInput"]},ValueTypes["ContentLinksItemCreateResult"]],
deleteContentLinksItem?: [{	by:ValueTypes["ContentLinksItemUniqueWhere"],	filter?:ValueTypes["ContentLinksItemWhere"] | null},ValueTypes["ContentLinksItemDeleteResult"]],
updateContentLinksItem?: [{	by:ValueTypes["ContentLinksItemUniqueWhere"],	filter?:ValueTypes["ContentLinksItemWhere"] | null,	data:ValueTypes["ContentLinksItemUpdateInput"]},ValueTypes["ContentLinksItemUpdateResult"]],
upsertContentLinksItem?: [{	by:ValueTypes["ContentLinksItemUniqueWhere"],	filter?:ValueTypes["ContentLinksItemWhere"] | null,	update:ValueTypes["ContentLinksItemUpdateInput"],	create:ValueTypes["ContentLinksItemCreateInput"]},ValueTypes["ContentLinksItemUpsertResult"]],
createRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	update:ValueTypes["RedirectUpdateInput"],	create:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
createContentReferenceImage?: [{	data:ValueTypes["ContentReferenceImageCreateInput"]},ValueTypes["ContentReferenceImageCreateResult"]],
deleteContentReferenceImage?: [{	by:ValueTypes["ContentReferenceImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceImageWhere"] | null},ValueTypes["ContentReferenceImageDeleteResult"]],
updateContentReferenceImage?: [{	by:ValueTypes["ContentReferenceImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceImageWhere"] | null,	data:ValueTypes["ContentReferenceImageUpdateInput"]},ValueTypes["ContentReferenceImageUpdateResult"]],
upsertContentReferenceImage?: [{	by:ValueTypes["ContentReferenceImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceImageWhere"] | null,	update:ValueTypes["ContentReferenceImageUpdateInput"],	create:ValueTypes["ContentReferenceImageCreateInput"]},ValueTypes["ContentReferenceImageUpsertResult"]],
createSeoData?: [{	data:ValueTypes["SeoDataCreateInput"]},ValueTypes["SeoDataCreateResult"]],
deleteSeoData?: [{	by:ValueTypes["SeoDataUniqueWhere"],	filter?:ValueTypes["SeoDataWhere"] | null},ValueTypes["SeoDataDeleteResult"]],
updateSeoData?: [{	by:ValueTypes["SeoDataUniqueWhere"],	filter?:ValueTypes["SeoDataWhere"] | null,	data:ValueTypes["SeoDataUpdateInput"]},ValueTypes["SeoDataUpdateResult"]],
upsertSeoData?: [{	by:ValueTypes["SeoDataUniqueWhere"],	filter?:ValueTypes["SeoDataWhere"] | null,	update:ValueTypes["SeoDataUpdateInput"],	create:ValueTypes["SeoDataCreateInput"]},ValueTypes["SeoDataUpsertResult"]],
createAgeCategory?: [{	data:ValueTypes["AgeCategoryCreateInput"]},ValueTypes["AgeCategoryCreateResult"]],
deleteAgeCategory?: [{	by:ValueTypes["AgeCategoryUniqueWhere"],	filter?:ValueTypes["AgeCategoryWhere"] | null},ValueTypes["AgeCategoryDeleteResult"]],
updateAgeCategory?: [{	by:ValueTypes["AgeCategoryUniqueWhere"],	filter?:ValueTypes["AgeCategoryWhere"] | null,	data:ValueTypes["AgeCategoryUpdateInput"]},ValueTypes["AgeCategoryUpdateResult"]],
upsertAgeCategory?: [{	by:ValueTypes["AgeCategoryUniqueWhere"],	filter?:ValueTypes["AgeCategoryWhere"] | null,	update:ValueTypes["AgeCategoryUpdateInput"],	create:ValueTypes["AgeCategoryCreateInput"]},ValueTypes["AgeCategoryUpsertResult"]],
createFilterCombo?: [{	data:ValueTypes["FilterComboCreateInput"]},ValueTypes["FilterComboCreateResult"]],
deleteFilterCombo?: [{	by:ValueTypes["FilterComboUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterComboDeleteResult"]],
updateFilterCombo?: [{	by:ValueTypes["FilterComboUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null,	data:ValueTypes["FilterComboUpdateInput"]},ValueTypes["FilterComboUpdateResult"]],
upsertFilterCombo?: [{	by:ValueTypes["FilterComboUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null,	update:ValueTypes["FilterComboUpdateInput"],	create:ValueTypes["FilterComboCreateInput"]},ValueTypes["FilterComboUpsertResult"]],
createImportCache?: [{	data:ValueTypes["ImportCacheCreateInput"]},ValueTypes["ImportCacheCreateResult"]],
deleteImportCache?: [{	by:ValueTypes["ImportCacheUniqueWhere"],	filter?:ValueTypes["ImportCacheWhere"] | null},ValueTypes["ImportCacheDeleteResult"]],
updateImportCache?: [{	by:ValueTypes["ImportCacheUniqueWhere"],	filter?:ValueTypes["ImportCacheWhere"] | null,	data:ValueTypes["ImportCacheUpdateInput"]},ValueTypes["ImportCacheUpdateResult"]],
upsertImportCache?: [{	by:ValueTypes["ImportCacheUniqueWhere"],	filter?:ValueTypes["ImportCacheWhere"] | null,	update:ValueTypes["ImportCacheUpdateInput"],	create:ValueTypes["ImportCacheCreateInput"]},ValueTypes["ImportCacheUpsertResult"]],
createSite?: [{	data:ValueTypes["SiteCreateInput"]},ValueTypes["SiteCreateResult"]],
deleteSite?: [{	by:ValueTypes["SiteUniqueWhere"],	filter?:ValueTypes["SiteWhere"] | null},ValueTypes["SiteDeleteResult"]],
updateSite?: [{	by:ValueTypes["SiteUniqueWhere"],	filter?:ValueTypes["SiteWhere"] | null,	data:ValueTypes["SiteUpdateInput"]},ValueTypes["SiteUpdateResult"]],
upsertSite?: [{	by:ValueTypes["SiteUniqueWhere"],	filter?:ValueTypes["SiteWhere"] | null,	update:ValueTypes["SiteUpdateInput"],	create:ValueTypes["SiteCreateInput"]},ValueTypes["SiteUpsertResult"]],
createContactSubmission?: [{	data:ValueTypes["ContactSubmissionCreateInput"]},ValueTypes["ContactSubmissionCreateResult"]],
deleteContactSubmission?: [{	by:ValueTypes["ContactSubmissionUniqueWhere"],	filter?:ValueTypes["ContactSubmissionWhere"] | null},ValueTypes["ContactSubmissionDeleteResult"]],
updateContactSubmission?: [{	by:ValueTypes["ContactSubmissionUniqueWhere"],	filter?:ValueTypes["ContactSubmissionWhere"] | null,	data:ValueTypes["ContactSubmissionUpdateInput"]},ValueTypes["ContactSubmissionUpdateResult"]],
upsertContactSubmission?: [{	by:ValueTypes["ContactSubmissionUniqueWhere"],	filter?:ValueTypes["ContactSubmissionWhere"] | null,	update:ValueTypes["ContactSubmissionUpdateInput"],	create:ValueTypes["ContactSubmissionCreateInput"]},ValueTypes["ContactSubmissionUpsertResult"]],
createTOPXBrand?: [{	data:ValueTypes["TOPXBrandCreateInput"]},ValueTypes["TOPXBrandCreateResult"]],
deleteTOPXBrand?: [{	by:ValueTypes["TOPXBrandUniqueWhere"],	filter?:ValueTypes["TOPXBrandWhere"] | null},ValueTypes["TOPXBrandDeleteResult"]],
updateTOPXBrand?: [{	by:ValueTypes["TOPXBrandUniqueWhere"],	filter?:ValueTypes["TOPXBrandWhere"] | null,	data:ValueTypes["TOPXBrandUpdateInput"]},ValueTypes["TOPXBrandUpdateResult"]],
upsertTOPXBrand?: [{	by:ValueTypes["TOPXBrandUniqueWhere"],	filter?:ValueTypes["TOPXBrandWhere"] | null,	update:ValueTypes["TOPXBrandUpdateInput"],	create:ValueTypes["TOPXBrandCreateInput"]},ValueTypes["TOPXBrandUpsertResult"]],
createTOPXBrandCategory?: [{	data:ValueTypes["TOPXBrandCategoryCreateInput"]},ValueTypes["TOPXBrandCategoryCreateResult"]],
deleteTOPXBrandCategory?: [{	by:ValueTypes["TOPXBrandCategoryUniqueWhere"],	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null},ValueTypes["TOPXBrandCategoryDeleteResult"]],
updateTOPXBrandCategory?: [{	by:ValueTypes["TOPXBrandCategoryUniqueWhere"],	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null,	data:ValueTypes["TOPXBrandCategoryUpdateInput"]},ValueTypes["TOPXBrandCategoryUpdateResult"]],
upsertTOPXBrandCategory?: [{	by:ValueTypes["TOPXBrandCategoryUniqueWhere"],	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null,	update:ValueTypes["TOPXBrandCategoryUpdateInput"],	create:ValueTypes["TOPXBrandCategoryCreateInput"]},ValueTypes["TOPXBrandCategoryUpsertResult"]],
createTOPXProduct?: [{	data:ValueTypes["TOPXProductCreateInput"]},ValueTypes["TOPXProductCreateResult"]],
deleteTOPXProduct?: [{	by:ValueTypes["TOPXProductUniqueWhere"],	filter?:ValueTypes["TOPXProductWhere"] | null},ValueTypes["TOPXProductDeleteResult"]],
updateTOPXProduct?: [{	by:ValueTypes["TOPXProductUniqueWhere"],	filter?:ValueTypes["TOPXProductWhere"] | null,	data:ValueTypes["TOPXProductUpdateInput"]},ValueTypes["TOPXProductUpdateResult"]],
upsertTOPXProduct?: [{	by:ValueTypes["TOPXProductUniqueWhere"],	filter?:ValueTypes["TOPXProductWhere"] | null,	update:ValueTypes["TOPXProductUpdateInput"],	create:ValueTypes["TOPXProductCreateInput"]},ValueTypes["TOPXProductUpsertResult"]],
createTOPXProductCategory?: [{	data:ValueTypes["TOPXProductCategoryCreateInput"]},ValueTypes["TOPXProductCategoryCreateResult"]],
deleteTOPXProductCategory?: [{	by:ValueTypes["TOPXProductCategoryUniqueWhere"],	filter?:ValueTypes["TOPXProductCategoryWhere"] | null},ValueTypes["TOPXProductCategoryDeleteResult"]],
updateTOPXProductCategory?: [{	by:ValueTypes["TOPXProductCategoryUniqueWhere"],	filter?:ValueTypes["TOPXProductCategoryWhere"] | null,	data:ValueTypes["TOPXProductCategoryUpdateInput"]},ValueTypes["TOPXProductCategoryUpdateResult"]],
upsertTOPXProductCategory?: [{	by:ValueTypes["TOPXProductCategoryUniqueWhere"],	filter?:ValueTypes["TOPXProductCategoryWhere"] | null,	update:ValueTypes["TOPXProductCategoryUpdateInput"],	create:ValueTypes["TOPXProductCategoryCreateInput"]},ValueTypes["TOPXProductCategoryUpsertResult"]],
createContentReferenceList?: [{	data:ValueTypes["ContentReferenceListCreateInput"]},ValueTypes["ContentReferenceListCreateResult"]],
deleteContentReferenceList?: [{	by:ValueTypes["ContentReferenceListUniqueWhere"],	filter?:ValueTypes["ContentReferenceListWhere"] | null},ValueTypes["ContentReferenceListDeleteResult"]],
updateContentReferenceList?: [{	by:ValueTypes["ContentReferenceListUniqueWhere"],	filter?:ValueTypes["ContentReferenceListWhere"] | null,	data:ValueTypes["ContentReferenceListUpdateInput"]},ValueTypes["ContentReferenceListUpdateResult"]],
upsertContentReferenceList?: [{	by:ValueTypes["ContentReferenceListUniqueWhere"],	filter?:ValueTypes["ContentReferenceListWhere"] | null,	update:ValueTypes["ContentReferenceListUpdateInput"],	create:ValueTypes["ContentReferenceListCreateInput"]},ValueTypes["ContentReferenceListUpsertResult"]],
transaction?: [{	options?:ValueTypes["MutationTransactionOptions"] | null},ValueTypes["MutationTransaction"]],
	query?:ValueTypes["Query"],
		__typename?: boolean
}>;
	["S3SignedUpload"]: AliasType<{
	url?:boolean,
	headers?:ValueTypes["S3Header"],
	method?:boolean,
	objectKey?:boolean,
	bucket?:boolean,
	publicUrl?:boolean,
		__typename?: boolean
}>;
	["S3Header"]: AliasType<{
	key?:boolean,
	value?:boolean,
		__typename?: boolean
}>;
	["S3GenerateSignedUploadInput"]: {
	contentType?:string | null,
	/** If not provided, extension is detected from a content-type. */
	extension?:string | null,
	/** Signed URL expiration. */
	expiration?:number | null,
	/** Uploaded file size. Required when you enable ACL size limits. */
	size?:number | null,
	/** Can be used as a "directory". */
	prefix?:string | null,
	/** Suffix after generated id and before the extension. */
	suffix?:string | null,
	/** This only affects Content-disposition header. Does not affect actual object key. */
	fileName?:string | null,
	contentDisposition?:ValueTypes["S33ContentDisposition"] | null,
	/** If not supported by S3 provider, an error is thrown. */
	acl?:ValueTypes["S3Acl"] | null
};
	["S33ContentDisposition"]:S33ContentDisposition;
	["S3Acl"]:S3Acl;
	["S3SignedRead"]: AliasType<{
	url?:boolean,
	headers?:ValueTypes["S3Header"],
	method?:boolean,
	objectKey?:boolean,
	bucket?:boolean,
		__typename?: boolean
}>;
	["BlogPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["MutationResult"]:AliasType<{
		ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"];
		['...on BlogPageCreateResult']?: Omit<ValueTypes["BlogPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPageDeleteResult']?: Omit<ValueTypes["BlogPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPageUpdateResult']?: Omit<ValueTypes["BlogPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPageUpsertResult']?: Omit<ValueTypes["BlogPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostCreateResult']?: Omit<ValueTypes["BlogPostCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostDeleteResult']?: Omit<ValueTypes["BlogPostDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostUpdateResult']?: Omit<ValueTypes["BlogPostUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostUpsertResult']?: Omit<ValueTypes["BlogPostUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostTagCreateResult']?: Omit<ValueTypes["BlogPostTagCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostTagDeleteResult']?: Omit<ValueTypes["BlogPostTagDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostTagUpdateResult']?: Omit<ValueTypes["BlogPostTagUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostTagUpsertResult']?: Omit<ValueTypes["BlogPostTagUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BodyTagCreateResult']?: Omit<ValueTypes["BodyTagCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BodyTagDeleteResult']?: Omit<ValueTypes["BodyTagDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BodyTagUpdateResult']?: Omit<ValueTypes["BodyTagUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BodyTagUpsertResult']?: Omit<ValueTypes["BodyTagUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BodyTagCategoryCreateResult']?: Omit<ValueTypes["BodyTagCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BodyTagCategoryDeleteResult']?: Omit<ValueTypes["BodyTagCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BodyTagCategoryUpdateResult']?: Omit<ValueTypes["BodyTagCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BodyTagCategoryUpsertResult']?: Omit<ValueTypes["BodyTagCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentCreateResult']?: Omit<ValueTypes["ContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentDeleteResult']?: Omit<ValueTypes["ContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpdateResult']?: Omit<ValueTypes["ContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpsertResult']?: Omit<ValueTypes["ContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockCreateResult']?: Omit<ValueTypes["ContentBlockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ValueTypes["ContentBlockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ValueTypes["ContentBlockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ValueTypes["ContentBlockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceCreateResult']?: Omit<ValueTypes["ContentReferenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceDeleteResult']?: Omit<ValueTypes["ContentReferenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpdateResult']?: Omit<ValueTypes["ContentReferenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpsertResult']?: Omit<ValueTypes["ContentReferenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DidYouKnowCreateResult']?: Omit<ValueTypes["DidYouKnowCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DidYouKnowDeleteResult']?: Omit<ValueTypes["DidYouKnowDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DidYouKnowUpdateResult']?: Omit<ValueTypes["DidYouKnowUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DidYouKnowUpsertResult']?: Omit<ValueTypes["DidYouKnowUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ValueTypes["ImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ValueTypes["ImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ValueTypes["ImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ValueTypes["ImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumCreateResult']?: Omit<ValueTypes["MediumCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumDeleteResult']?: Omit<ValueTypes["MediumDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumUpdateResult']?: Omit<ValueTypes["MediumUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumUpsertResult']?: Omit<ValueTypes["MediumUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NutritionalValueCreateResult']?: Omit<ValueTypes["NutritionalValueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NutritionalValueDeleteResult']?: Omit<ValueTypes["NutritionalValueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NutritionalValueUpdateResult']?: Omit<ValueTypes["NutritionalValueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NutritionalValueUpsertResult']?: Omit<ValueTypes["NutritionalValueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageCreateResult']?: Omit<ValueTypes["PageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageDeleteResult']?: Omit<ValueTypes["PageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageUpdateResult']?: Omit<ValueTypes["PageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageUpsertResult']?: Omit<ValueTypes["PageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReferenceCreateResult']?: Omit<ValueTypes["ReferenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReferenceDeleteResult']?: Omit<ValueTypes["ReferenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReferenceUpdateResult']?: Omit<ValueTypes["ReferenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReferenceUpsertResult']?: Omit<ValueTypes["ReferenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReferenceListCreateResult']?: Omit<ValueTypes["ReferenceListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReferenceListDeleteResult']?: Omit<ValueTypes["ReferenceListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReferenceListUpdateResult']?: Omit<ValueTypes["ReferenceListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReferenceListUpsertResult']?: Omit<ValueTypes["ReferenceListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ValueTypes["SeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ValueTypes["SeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ValueTypes["SeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ValueTypes["SeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoCreateResult']?: Omit<ValueTypes["VideoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoDeleteResult']?: Omit<ValueTypes["VideoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpdateResult']?: Omit<ValueTypes["VideoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpsertResult']?: Omit<ValueTypes["VideoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandCreateResult']?: Omit<ValueTypes["BrandCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandDeleteResult']?: Omit<ValueTypes["BrandDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandUpdateResult']?: Omit<ValueTypes["BrandUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandUpsertResult']?: Omit<ValueTypes["BrandUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandDistributorCreateResult']?: Omit<ValueTypes["BrandDistributorCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandDistributorDeleteResult']?: Omit<ValueTypes["BrandDistributorDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandDistributorUpdateResult']?: Omit<ValueTypes["BrandDistributorUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandDistributorUpsertResult']?: Omit<ValueTypes["BrandDistributorUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogSizeCreateResult']?: Omit<ValueTypes["DogSizeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogSizeDeleteResult']?: Omit<ValueTypes["DogSizeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogSizeUpdateResult']?: Omit<ValueTypes["DogSizeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogSizeUpsertResult']?: Omit<ValueTypes["DogSizeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCreateResult']?: Omit<ValueTypes["ProductCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductDeleteResult']?: Omit<ValueTypes["ProductDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductUpdateResult']?: Omit<ValueTypes["ProductUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductUpsertResult']?: Omit<ValueTypes["ProductUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductionMethodCreateResult']?: Omit<ValueTypes["ProductionMethodCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductionMethodDeleteResult']?: Omit<ValueTypes["ProductionMethodDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductionMethodUpdateResult']?: Omit<ValueTypes["ProductionMethodUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductionMethodUpsertResult']?: Omit<ValueTypes["ProductionMethodUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductLineCreateResult']?: Omit<ValueTypes["ProductLineCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductLineDeleteResult']?: Omit<ValueTypes["ProductLineDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductLineUpdateResult']?: Omit<ValueTypes["ProductLineUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductLineUpsertResult']?: Omit<ValueTypes["ProductLineUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BreedCreateResult']?: Omit<ValueTypes["BreedCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BreedDeleteResult']?: Omit<ValueTypes["BreedDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BreedUpdateResult']?: Omit<ValueTypes["BreedUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BreedUpsertResult']?: Omit<ValueTypes["BreedUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogCreateResult']?: Omit<ValueTypes["DogCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogDeleteResult']?: Omit<ValueTypes["DogDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogUpdateResult']?: Omit<ValueTypes["DogUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogUpsertResult']?: Omit<ValueTypes["DogUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserCreateResult']?: Omit<ValueTypes["UserCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserDeleteResult']?: Omit<ValueTypes["UserDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserUpdateResult']?: Omit<ValueTypes["UserUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserUpsertResult']?: Omit<ValueTypes["UserUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VeterinaryCreateResult']?: Omit<ValueTypes["VeterinaryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VeterinaryDeleteResult']?: Omit<ValueTypes["VeterinaryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VeterinaryUpdateResult']?: Omit<ValueTypes["VeterinaryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VeterinaryUpsertResult']?: Omit<ValueTypes["VeterinaryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NutritionalValueOfProductCreateResult']?: Omit<ValueTypes["NutritionalValueOfProductCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NutritionalValueOfProductDeleteResult']?: Omit<ValueTypes["NutritionalValueOfProductDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NutritionalValueOfProductUpdateResult']?: Omit<ValueTypes["NutritionalValueOfProductUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NutritionalValueOfProductUpsertResult']?: Omit<ValueTypes["NutritionalValueOfProductUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReviewCreateResult']?: Omit<ValueTypes["ReviewCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReviewDeleteResult']?: Omit<ValueTypes["ReviewDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReviewUpdateResult']?: Omit<ValueTypes["ReviewUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReviewUpsertResult']?: Omit<ValueTypes["ReviewUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogBodyTypeCreateResult']?: Omit<ValueTypes["DogBodyTypeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogBodyTypeDeleteResult']?: Omit<ValueTypes["DogBodyTypeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogBodyTypeUpdateResult']?: Omit<ValueTypes["DogBodyTypeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogBodyTypeUpsertResult']?: Omit<ValueTypes["DogBodyTypeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogBodyTypeCategoryCreateResult']?: Omit<ValueTypes["DogBodyTypeCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogBodyTypeCategoryDeleteResult']?: Omit<ValueTypes["DogBodyTypeCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogBodyTypeCategoryUpdateResult']?: Omit<ValueTypes["DogBodyTypeCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogBodyTypeCategoryUpsertResult']?: Omit<ValueTypes["DogBodyTypeCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ValueTypes["LinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ValueTypes["LinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ValueTypes["LinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ValueTypes["LinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UrlCreateResult']?: Omit<ValueTypes["UrlCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UrlDeleteResult']?: Omit<ValueTypes["UrlDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UrlUpdateResult']?: Omit<ValueTypes["UrlUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UrlUpsertResult']?: Omit<ValueTypes["UrlUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterCreateResult']?: Omit<ValueTypes["FooterCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterDeleteResult']?: Omit<ValueTypes["FooterDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpdateResult']?: Omit<ValueTypes["FooterUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpsertResult']?: Omit<ValueTypes["FooterUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkCreateResult']?: Omit<ValueTypes["FooterLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkDeleteResult']?: Omit<ValueTypes["FooterLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkUpdateResult']?: Omit<ValueTypes["FooterLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinkUpsertResult']?: Omit<ValueTypes["FooterLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandsPageCreateResult']?: Omit<ValueTypes["BrandsPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandsPageDeleteResult']?: Omit<ValueTypes["BrandsPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandsPageUpdateResult']?: Omit<ValueTypes["BrandsPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandsPageUpsertResult']?: Omit<ValueTypes["BrandsPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageCreateResult']?: Omit<ValueTypes["HomePageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageDeleteResult']?: Omit<ValueTypes["HomePageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageUpdateResult']?: Omit<ValueTypes["HomePageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageUpsertResult']?: Omit<ValueTypes["HomePageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientsPageCreateResult']?: Omit<ValueTypes["IngredientsPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientsPageDeleteResult']?: Omit<ValueTypes["IngredientsPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientsPageUpdateResult']?: Omit<ValueTypes["IngredientsPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IngredientsPageUpsertResult']?: Omit<ValueTypes["IngredientsPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductReviewCreateResult']?: Omit<ValueTypes["ProductReviewCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductReviewDeleteResult']?: Omit<ValueTypes["ProductReviewDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductReviewUpdateResult']?: Omit<ValueTypes["ProductReviewUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductReviewUpsertResult']?: Omit<ValueTypes["ProductReviewUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ScoreCreateResult']?: Omit<ValueTypes["ScoreCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ScoreDeleteResult']?: Omit<ValueTypes["ScoreDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ScoreUpdateResult']?: Omit<ValueTypes["ScoreUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ScoreUpsertResult']?: Omit<ValueTypes["ScoreUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AgeCreateResult']?: Omit<ValueTypes["AgeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AgeDeleteResult']?: Omit<ValueTypes["AgeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AgeUpdateResult']?: Omit<ValueTypes["AgeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AgeUpsertResult']?: Omit<ValueTypes["AgeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CountryCreateResult']?: Omit<ValueTypes["CountryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CountryDeleteResult']?: Omit<ValueTypes["CountryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CountryUpdateResult']?: Omit<ValueTypes["CountryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CountryUpsertResult']?: Omit<ValueTypes["CountryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostReviewCreateResult']?: Omit<ValueTypes["BlogPostReviewCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostReviewDeleteResult']?: Omit<ValueTypes["BlogPostReviewDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostReviewUpdateResult']?: Omit<ValueTypes["BlogPostReviewUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostReviewUpsertResult']?: Omit<ValueTypes["BlogPostReviewUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogActivityCreateResult']?: Omit<ValueTypes["DogActivityCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogActivityDeleteResult']?: Omit<ValueTypes["DogActivityDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogActivityUpdateResult']?: Omit<ValueTypes["DogActivityUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogActivityUpsertResult']?: Omit<ValueTypes["DogActivityUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialCreateResult']?: Omit<ValueTypes["SocialCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialDeleteResult']?: Omit<ValueTypes["SocialDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialUpdateResult']?: Omit<ValueTypes["SocialUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialUpsertResult']?: Omit<ValueTypes["SocialUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceGalleryImageCreateResult']?: Omit<ValueTypes["ContentReferenceGalleryImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceGalleryImageDeleteResult']?: Omit<ValueTypes["ContentReferenceGalleryImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceGalleryImageUpdateResult']?: Omit<ValueTypes["ContentReferenceGalleryImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceGalleryImageUpsertResult']?: Omit<ValueTypes["ContentReferenceGalleryImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemCreateResult']?: Omit<ValueTypes["ItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemDeleteResult']?: Omit<ValueTypes["ItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemUpdateResult']?: Omit<ValueTypes["ItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemUpsertResult']?: Omit<ValueTypes["ItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemSubCategoryCreateResult']?: Omit<ValueTypes["ItemSubCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemSubCategoryDeleteResult']?: Omit<ValueTypes["ItemSubCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemSubCategoryUpdateResult']?: Omit<ValueTypes["ItemSubCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemSubCategoryUpsertResult']?: Omit<ValueTypes["ItemSubCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemCategoryCreateResult']?: Omit<ValueTypes["ItemCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemCategoryDeleteResult']?: Omit<ValueTypes["ItemCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemCategoryUpdateResult']?: Omit<ValueTypes["ItemCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemCategoryUpsertResult']?: Omit<ValueTypes["ItemCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemFlavorCategoryCreateResult']?: Omit<ValueTypes["ItemFlavorCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemFlavorCategoryDeleteResult']?: Omit<ValueTypes["ItemFlavorCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemFlavorCategoryUpdateResult']?: Omit<ValueTypes["ItemFlavorCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemFlavorCategoryUpsertResult']?: Omit<ValueTypes["ItemFlavorCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemDeclensionFourthVariantCreateResult']?: Omit<ValueTypes["ItemDeclensionFourthVariantCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemDeclensionFourthVariantDeleteResult']?: Omit<ValueTypes["ItemDeclensionFourthVariantDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemDeclensionFourthVariantUpdateResult']?: Omit<ValueTypes["ItemDeclensionFourthVariantUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemDeclensionFourthVariantUpsertResult']?: Omit<ValueTypes["ItemDeclensionFourthVariantUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemDeclensionSeventhVariantCreateResult']?: Omit<ValueTypes["ItemDeclensionSeventhVariantCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemDeclensionSeventhVariantDeleteResult']?: Omit<ValueTypes["ItemDeclensionSeventhVariantDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemDeclensionSeventhVariantUpdateResult']?: Omit<ValueTypes["ItemDeclensionSeventhVariantUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemDeclensionSeventhVariantUpsertResult']?: Omit<ValueTypes["ItemDeclensionSeventhVariantUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediaCardCreateResult']?: Omit<ValueTypes["MediaCardCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediaCardDeleteResult']?: Omit<ValueTypes["MediaCardDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediaCardUpdateResult']?: Omit<ValueTypes["MediaCardUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediaCardUpsertResult']?: Omit<ValueTypes["MediaCardUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCardCreateResult']?: Omit<ValueTypes["InfoCardCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCardDeleteResult']?: Omit<ValueTypes["InfoCardDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCardUpdateResult']?: Omit<ValueTypes["InfoCardUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on InfoCardUpsertResult']?: Omit<ValueTypes["InfoCardUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NumberedCardCreateResult']?: Omit<ValueTypes["NumberedCardCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NumberedCardDeleteResult']?: Omit<ValueTypes["NumberedCardDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NumberedCardUpdateResult']?: Omit<ValueTypes["NumberedCardUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NumberedCardUpsertResult']?: Omit<ValueTypes["NumberedCardUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegisterClaimCreateResult']?: Omit<ValueTypes["RegisterClaimCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegisterClaimDeleteResult']?: Omit<ValueTypes["RegisterClaimDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegisterClaimUpdateResult']?: Omit<ValueTypes["RegisterClaimUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegisterClaimUpsertResult']?: Omit<ValueTypes["RegisterClaimUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostReviewReactionCreateResult']?: Omit<ValueTypes["BlogPostReviewReactionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostReviewReactionDeleteResult']?: Omit<ValueTypes["BlogPostReviewReactionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostReviewReactionUpdateResult']?: Omit<ValueTypes["BlogPostReviewReactionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BlogPostReviewReactionUpsertResult']?: Omit<ValueTypes["BlogPostReviewReactionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductReviewReactionCreateResult']?: Omit<ValueTypes["ProductReviewReactionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductReviewReactionDeleteResult']?: Omit<ValueTypes["ProductReviewReactionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductReviewReactionUpdateResult']?: Omit<ValueTypes["ProductReviewReactionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductReviewReactionUpsertResult']?: Omit<ValueTypes["ProductReviewReactionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductPackageCreateResult']?: Omit<ValueTypes["ProductPackageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductPackageDeleteResult']?: Omit<ValueTypes["ProductPackageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductPackageUpdateResult']?: Omit<ValueTypes["ProductPackageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductPackageUpsertResult']?: Omit<ValueTypes["ProductPackageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandManufacturerCreateResult']?: Omit<ValueTypes["BrandManufacturerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandManufacturerDeleteResult']?: Omit<ValueTypes["BrandManufacturerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandManufacturerUpdateResult']?: Omit<ValueTypes["BrandManufacturerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandManufacturerUpsertResult']?: Omit<ValueTypes["BrandManufacturerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ElementCreateResult']?: Omit<ValueTypes["ElementCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ElementDeleteResult']?: Omit<ValueTypes["ElementDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ElementUpdateResult']?: Omit<ValueTypes["ElementUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ElementUpsertResult']?: Omit<ValueTypes["ElementUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ElementOfProductCreateResult']?: Omit<ValueTypes["ElementOfProductCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ElementOfProductDeleteResult']?: Omit<ValueTypes["ElementOfProductDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ElementOfProductUpdateResult']?: Omit<ValueTypes["ElementOfProductUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ElementOfProductUpsertResult']?: Omit<ValueTypes["ElementOfProductUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuitabilityCategoryCreateResult']?: Omit<ValueTypes["SuitabilityCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuitabilityCategoryDeleteResult']?: Omit<ValueTypes["SuitabilityCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuitabilityCategoryUpdateResult']?: Omit<ValueTypes["SuitabilityCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuitabilityCategoryUpsertResult']?: Omit<ValueTypes["SuitabilityCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductFeatureCreateResult']?: Omit<ValueTypes["ProductFeatureCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductFeatureDeleteResult']?: Omit<ValueTypes["ProductFeatureDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductFeatureUpdateResult']?: Omit<ValueTypes["ProductFeatureUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductFeatureUpsertResult']?: Omit<ValueTypes["ProductFeatureUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuitabilityItemCreateResult']?: Omit<ValueTypes["SuitabilityItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuitabilityItemDeleteResult']?: Omit<ValueTypes["SuitabilityItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuitabilityItemUpdateResult']?: Omit<ValueTypes["SuitabilityItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SuitabilityItemUpsertResult']?: Omit<ValueTypes["SuitabilityItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegionCreateResult']?: Omit<ValueTypes["RegionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegionDeleteResult']?: Omit<ValueTypes["RegionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegionUpdateResult']?: Omit<ValueTypes["RegionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegionUpsertResult']?: Omit<ValueTypes["RegionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GranuleSizeCreateResult']?: Omit<ValueTypes["GranuleSizeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GranuleSizeDeleteResult']?: Omit<ValueTypes["GranuleSizeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GranuleSizeUpdateResult']?: Omit<ValueTypes["GranuleSizeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GranuleSizeUpsertResult']?: Omit<ValueTypes["GranuleSizeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemAliasCreateResult']?: Omit<ValueTypes["ItemAliasCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemAliasDeleteResult']?: Omit<ValueTypes["ItemAliasDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemAliasUpdateResult']?: Omit<ValueTypes["ItemAliasUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemAliasUpsertResult']?: Omit<ValueTypes["ItemAliasUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SemanticKeyCreateResult']?: Omit<ValueTypes["SemanticKeyCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SemanticKeyDeleteResult']?: Omit<ValueTypes["SemanticKeyDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SemanticKeyUpdateResult']?: Omit<ValueTypes["SemanticKeyUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SemanticKeyUpsertResult']?: Omit<ValueTypes["SemanticKeyUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductFlagCreateResult']?: Omit<ValueTypes["ProductFlagCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductFlagDeleteResult']?: Omit<ValueTypes["ProductFlagDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductFlagUpdateResult']?: Omit<ValueTypes["ProductFlagUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductFlagUpsertResult']?: Omit<ValueTypes["ProductFlagUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductFlagOfProductCreateResult']?: Omit<ValueTypes["ProductFlagOfProductCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductFlagOfProductDeleteResult']?: Omit<ValueTypes["ProductFlagOfProductDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductFlagOfProductUpdateResult']?: Omit<ValueTypes["ProductFlagOfProductUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductFlagOfProductUpsertResult']?: Omit<ValueTypes["ProductFlagOfProductUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductEvaluationCreateResult']?: Omit<ValueTypes["ProductEvaluationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductEvaluationDeleteResult']?: Omit<ValueTypes["ProductEvaluationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductEvaluationUpdateResult']?: Omit<ValueTypes["ProductEvaluationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductEvaluationUpsertResult']?: Omit<ValueTypes["ProductEvaluationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AdCreateResult']?: Omit<ValueTypes["AdCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AdDeleteResult']?: Omit<ValueTypes["AdDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AdUpdateResult']?: Omit<ValueTypes["AdUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AdUpsertResult']?: Omit<ValueTypes["AdUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EvaluationInfoCreateResult']?: Omit<ValueTypes["EvaluationInfoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EvaluationInfoDeleteResult']?: Omit<ValueTypes["EvaluationInfoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EvaluationInfoUpdateResult']?: Omit<ValueTypes["EvaluationInfoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EvaluationInfoUpsertResult']?: Omit<ValueTypes["EvaluationInfoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ConsumptionMessageCreateResult']?: Omit<ValueTypes["ConsumptionMessageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ConsumptionMessageDeleteResult']?: Omit<ValueTypes["ConsumptionMessageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ConsumptionMessageUpdateResult']?: Omit<ValueTypes["ConsumptionMessageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ConsumptionMessageUpsertResult']?: Omit<ValueTypes["ConsumptionMessageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentTextCreateResult']?: Omit<ValueTypes["ContentTextCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentTextDeleteResult']?: Omit<ValueTypes["ContentTextDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentTextUpdateResult']?: Omit<ValueTypes["ContentTextUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentTextUpsertResult']?: Omit<ValueTypes["ContentTextUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentTextBlockCreateResult']?: Omit<ValueTypes["ContentTextBlockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentTextBlockDeleteResult']?: Omit<ValueTypes["ContentTextBlockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentTextBlockUpdateResult']?: Omit<ValueTypes["ContentTextBlockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentTextBlockUpsertResult']?: Omit<ValueTypes["ContentTextBlockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ComparatorPageCreateResult']?: Omit<ValueTypes["ComparatorPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ComparatorPageDeleteResult']?: Omit<ValueTypes["ComparatorPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ComparatorPageUpdateResult']?: Omit<ValueTypes["ComparatorPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ComparatorPageUpsertResult']?: Omit<ValueTypes["ComparatorPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LoginPageCreateResult']?: Omit<ValueTypes["LoginPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LoginPageDeleteResult']?: Omit<ValueTypes["LoginPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LoginPageUpdateResult']?: Omit<ValueTypes["LoginPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LoginPageUpsertResult']?: Omit<ValueTypes["LoginPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegisterPageCreateResult']?: Omit<ValueTypes["RegisterPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegisterPageDeleteResult']?: Omit<ValueTypes["RegisterPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegisterPageUpdateResult']?: Omit<ValueTypes["RegisterPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RegisterPageUpsertResult']?: Omit<ValueTypes["RegisterPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ResultsPageCreateResult']?: Omit<ValueTypes["ResultsPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ResultsPageDeleteResult']?: Omit<ValueTypes["ResultsPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ResultsPageUpdateResult']?: Omit<ValueTypes["ResultsPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ResultsPageUpsertResult']?: Omit<ValueTypes["ResultsPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SearchPageCreateResult']?: Omit<ValueTypes["SearchPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SearchPageDeleteResult']?: Omit<ValueTypes["SearchPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SearchPageUpdateResult']?: Omit<ValueTypes["SearchPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SearchPageUpsertResult']?: Omit<ValueTypes["SearchPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on WizardPageCreateResult']?: Omit<ValueTypes["WizardPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on WizardPageDeleteResult']?: Omit<ValueTypes["WizardPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on WizardPageUpdateResult']?: Omit<ValueTypes["WizardPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on WizardPageUpsertResult']?: Omit<ValueTypes["WizardPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BreastfeedingCategoryCreateResult']?: Omit<ValueTypes["BreastfeedingCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BreastfeedingCategoryDeleteResult']?: Omit<ValueTypes["BreastfeedingCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BreastfeedingCategoryUpdateResult']?: Omit<ValueTypes["BreastfeedingCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BreastfeedingCategoryUpsertResult']?: Omit<ValueTypes["BreastfeedingCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogReproductionCreateResult']?: Omit<ValueTypes["DogReproductionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogReproductionDeleteResult']?: Omit<ValueTypes["DogReproductionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogReproductionUpdateResult']?: Omit<ValueTypes["DogReproductionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DogReproductionUpsertResult']?: Omit<ValueTypes["DogReproductionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactFormMessageCreateResult']?: Omit<ValueTypes["ContactFormMessageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactFormMessageDeleteResult']?: Omit<ValueTypes["ContactFormMessageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactFormMessageUpdateResult']?: Omit<ValueTypes["ContactFormMessageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactFormMessageUpsertResult']?: Omit<ValueTypes["ContactFormMessageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactPageCreateResult']?: Omit<ValueTypes["ContactPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactPageDeleteResult']?: Omit<ValueTypes["ContactPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactPageUpdateResult']?: Omit<ValueTypes["ContactPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactPageUpsertResult']?: Omit<ValueTypes["ContactPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BugReportCreateResult']?: Omit<ValueTypes["BugReportCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BugReportDeleteResult']?: Omit<ValueTypes["BugReportDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BugReportUpdateResult']?: Omit<ValueTypes["BugReportUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BugReportUpsertResult']?: Omit<ValueTypes["BugReportUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ColorCreateResult']?: Omit<ValueTypes["ColorCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ColorDeleteResult']?: Omit<ValueTypes["ColorDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ColorUpdateResult']?: Omit<ValueTypes["ColorUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ColorUpsertResult']?: Omit<ValueTypes["ColorUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemGroupCreateResult']?: Omit<ValueTypes["ItemGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemGroupDeleteResult']?: Omit<ValueTypes["ItemGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemGroupUpdateResult']?: Omit<ValueTypes["ItemGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ItemGroupUpsertResult']?: Omit<ValueTypes["ItemGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductEvaluationSummaryCreateResult']?: Omit<ValueTypes["ProductEvaluationSummaryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductEvaluationSummaryDeleteResult']?: Omit<ValueTypes["ProductEvaluationSummaryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductEvaluationSummaryUpdateResult']?: Omit<ValueTypes["ProductEvaluationSummaryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductEvaluationSummaryUpsertResult']?: Omit<ValueTypes["ProductEvaluationSummaryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProtectedActionCreateResult']?: Omit<ValueTypes["ProtectedActionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProtectedActionDeleteResult']?: Omit<ValueTypes["ProtectedActionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProtectedActionUpdateResult']?: Omit<ValueTypes["ProtectedActionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProtectedActionUpsertResult']?: Omit<ValueTypes["ProtectedActionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandAliasCreateResult']?: Omit<ValueTypes["BrandAliasCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandAliasDeleteResult']?: Omit<ValueTypes["BrandAliasDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandAliasUpdateResult']?: Omit<ValueTypes["BrandAliasUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BrandAliasUpsertResult']?: Omit<ValueTypes["BrandAliasUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductAliasCreateResult']?: Omit<ValueTypes["ProductAliasCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductAliasDeleteResult']?: Omit<ValueTypes["ProductAliasDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductAliasUpdateResult']?: Omit<ValueTypes["ProductAliasUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductAliasUpsertResult']?: Omit<ValueTypes["ProductAliasUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductLineAliasCreateResult']?: Omit<ValueTypes["ProductLineAliasCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductLineAliasDeleteResult']?: Omit<ValueTypes["ProductLineAliasDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductLineAliasUpdateResult']?: Omit<ValueTypes["ProductLineAliasUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductLineAliasUpsertResult']?: Omit<ValueTypes["ProductLineAliasUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageCreateResult']?: Omit<ValueTypes["GenericPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageDeleteResult']?: Omit<ValueTypes["GenericPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageUpdateResult']?: Omit<ValueTypes["GenericPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GenericPageUpsertResult']?: Omit<ValueTypes["GenericPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ValueTypes["LinkableCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ValueTypes["LinkableDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ValueTypes["LinkableUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ValueTypes["LinkableUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentLinksCreateResult']?: Omit<ValueTypes["ContentLinksCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentLinksDeleteResult']?: Omit<ValueTypes["ContentLinksDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentLinksUpdateResult']?: Omit<ValueTypes["ContentLinksUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentLinksUpsertResult']?: Omit<ValueTypes["ContentLinksUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentLinksItemCreateResult']?: Omit<ValueTypes["ContentLinksItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentLinksItemDeleteResult']?: Omit<ValueTypes["ContentLinksItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentLinksItemUpdateResult']?: Omit<ValueTypes["ContentLinksItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentLinksItemUpsertResult']?: Omit<ValueTypes["ContentLinksItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectCreateResult']?: Omit<ValueTypes["RedirectCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectDeleteResult']?: Omit<ValueTypes["RedirectDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpdateResult']?: Omit<ValueTypes["RedirectUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpsertResult']?: Omit<ValueTypes["RedirectUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceImageCreateResult']?: Omit<ValueTypes["ContentReferenceImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceImageDeleteResult']?: Omit<ValueTypes["ContentReferenceImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceImageUpdateResult']?: Omit<ValueTypes["ContentReferenceImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceImageUpsertResult']?: Omit<ValueTypes["ContentReferenceImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDataCreateResult']?: Omit<ValueTypes["SeoDataCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDataDeleteResult']?: Omit<ValueTypes["SeoDataDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDataUpdateResult']?: Omit<ValueTypes["SeoDataUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDataUpsertResult']?: Omit<ValueTypes["SeoDataUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AgeCategoryCreateResult']?: Omit<ValueTypes["AgeCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AgeCategoryDeleteResult']?: Omit<ValueTypes["AgeCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AgeCategoryUpdateResult']?: Omit<ValueTypes["AgeCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AgeCategoryUpsertResult']?: Omit<ValueTypes["AgeCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilterComboCreateResult']?: Omit<ValueTypes["FilterComboCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilterComboDeleteResult']?: Omit<ValueTypes["FilterComboDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilterComboUpdateResult']?: Omit<ValueTypes["FilterComboUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FilterComboUpsertResult']?: Omit<ValueTypes["FilterComboUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImportCacheCreateResult']?: Omit<ValueTypes["ImportCacheCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImportCacheDeleteResult']?: Omit<ValueTypes["ImportCacheDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImportCacheUpdateResult']?: Omit<ValueTypes["ImportCacheUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImportCacheUpsertResult']?: Omit<ValueTypes["ImportCacheUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteCreateResult']?: Omit<ValueTypes["SiteCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteDeleteResult']?: Omit<ValueTypes["SiteDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteUpdateResult']?: Omit<ValueTypes["SiteUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SiteUpsertResult']?: Omit<ValueTypes["SiteUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactSubmissionCreateResult']?: Omit<ValueTypes["ContactSubmissionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactSubmissionDeleteResult']?: Omit<ValueTypes["ContactSubmissionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactSubmissionUpdateResult']?: Omit<ValueTypes["ContactSubmissionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactSubmissionUpsertResult']?: Omit<ValueTypes["ContactSubmissionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXBrandCreateResult']?: Omit<ValueTypes["TOPXBrandCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXBrandDeleteResult']?: Omit<ValueTypes["TOPXBrandDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXBrandUpdateResult']?: Omit<ValueTypes["TOPXBrandUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXBrandUpsertResult']?: Omit<ValueTypes["TOPXBrandUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXBrandCategoryCreateResult']?: Omit<ValueTypes["TOPXBrandCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXBrandCategoryDeleteResult']?: Omit<ValueTypes["TOPXBrandCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXBrandCategoryUpdateResult']?: Omit<ValueTypes["TOPXBrandCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXBrandCategoryUpsertResult']?: Omit<ValueTypes["TOPXBrandCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXProductCreateResult']?: Omit<ValueTypes["TOPXProductCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXProductDeleteResult']?: Omit<ValueTypes["TOPXProductDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXProductUpdateResult']?: Omit<ValueTypes["TOPXProductUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXProductUpsertResult']?: Omit<ValueTypes["TOPXProductUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXProductCategoryCreateResult']?: Omit<ValueTypes["TOPXProductCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXProductCategoryDeleteResult']?: Omit<ValueTypes["TOPXProductCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXProductCategoryUpdateResult']?: Omit<ValueTypes["TOPXProductCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TOPXProductCategoryUpsertResult']?: Omit<ValueTypes["TOPXProductCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceListCreateResult']?: Omit<ValueTypes["ContentReferenceListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceListDeleteResult']?: Omit<ValueTypes["ContentReferenceListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceListUpdateResult']?: Omit<ValueTypes["ContentReferenceListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceListUpsertResult']?: Omit<ValueTypes["ContentReferenceListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		__typename?: boolean
}>;
	["_MutationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	paths?:ValueTypes["_PathFragment"],
	type?:boolean,
	message?:boolean,
		__typename?: boolean
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["BlogPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPage"],
		__typename?: boolean
}>;
	["BlogPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPostCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPost"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPostDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPost"],
		__typename?: boolean
}>;
	["BlogPostUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPost"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPostUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPost"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPostTagCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPostTagDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostTag"],
		__typename?: boolean
}>;
	["BlogPostTagUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPostTagUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BodyTagCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BodyTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BodyTagDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BodyTag"],
		__typename?: boolean
}>;
	["BodyTagUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BodyTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BodyTagUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BodyTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BodyTagCategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BodyTagCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BodyTagCategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BodyTagCategory"],
		__typename?: boolean
}>;
	["BodyTagCategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BodyTagCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BodyTagCategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BodyTagCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
		__typename?: boolean
}>;
	["ContentUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
		__typename?: boolean
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
		__typename?: boolean
}>;
	["ContentReferenceUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DidYouKnowCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DidYouKnow"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DidYouKnowDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DidYouKnow"],
		__typename?: boolean
}>;
	["DidYouKnowUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DidYouKnow"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DidYouKnowUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DidYouKnow"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
		__typename?: boolean
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["MediumCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["MediumDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
		__typename?: boolean
}>;
	["MediumUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["MediumUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NutritionalValueCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NutritionalValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NutritionalValueDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NutritionalValue"],
		__typename?: boolean
}>;
	["NutritionalValueUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NutritionalValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NutritionalValueUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NutritionalValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["PageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["PageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
		__typename?: boolean
}>;
	["PageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["PageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ReferenceCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Reference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ReferenceDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Reference"],
		__typename?: boolean
}>;
	["ReferenceUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Reference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ReferenceUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Reference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ReferenceListCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReferenceList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ReferenceListDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReferenceList"],
		__typename?: boolean
}>;
	["ReferenceListUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReferenceList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ReferenceListUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReferenceList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
		__typename?: boolean
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["VideoCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["VideoDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
		__typename?: boolean
}>;
	["VideoUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["VideoUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Brand"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Brand"],
		__typename?: boolean
}>;
	["BrandUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Brand"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Brand"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandDistributorCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandDistributor"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandDistributorDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandDistributor"],
		__typename?: boolean
}>;
	["BrandDistributorUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandDistributor"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandDistributorUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandDistributor"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogSizeCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogSize"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogSizeDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogSize"],
		__typename?: boolean
}>;
	["DogSizeUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogSize"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogSizeUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogSize"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Product"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Product"],
		__typename?: boolean
}>;
	["ProductUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Product"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Product"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductionMethodCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductionMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductionMethodDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductionMethod"],
		__typename?: boolean
}>;
	["ProductionMethodUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductionMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductionMethodUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductionMethod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductLineCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductLine"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductLineDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductLine"],
		__typename?: boolean
}>;
	["ProductLineUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductLine"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductLineUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductLine"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BreedCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Breed"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BreedDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Breed"],
		__typename?: boolean
}>;
	["BreedUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Breed"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BreedUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Breed"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Dog"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Dog"],
		__typename?: boolean
}>;
	["DogUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Dog"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Dog"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UserCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UserDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
		__typename?: boolean
}>;
	["UserUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UserUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["VeterinaryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Veterinary"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["VeterinaryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Veterinary"],
		__typename?: boolean
}>;
	["VeterinaryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Veterinary"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["VeterinaryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Veterinary"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NutritionalValueOfProductCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NutritionalValueOfProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NutritionalValueOfProductDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NutritionalValueOfProduct"],
		__typename?: boolean
}>;
	["NutritionalValueOfProductUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NutritionalValueOfProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NutritionalValueOfProductUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NutritionalValueOfProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ReviewCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Review"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ReviewDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Review"],
		__typename?: boolean
}>;
	["ReviewUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Review"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ReviewUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Review"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogBodyTypeCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogBodyType"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogBodyTypeDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogBodyType"],
		__typename?: boolean
}>;
	["DogBodyTypeUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogBodyType"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogBodyTypeUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogBodyType"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogBodyTypeCategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogBodyTypeCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogBodyTypeCategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogBodyTypeCategory"],
		__typename?: boolean
}>;
	["DogBodyTypeCategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogBodyTypeCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogBodyTypeCategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogBodyTypeCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
		__typename?: boolean
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UrlCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Url"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UrlDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Url"],
		__typename?: boolean
}>;
	["UrlUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Url"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UrlUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Url"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
		__typename?: boolean
}>;
	["FooterUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterLinkCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterLinkDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLink"],
		__typename?: boolean
}>;
	["FooterLinkUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterLinkUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandsPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandsPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandsPage"],
		__typename?: boolean
}>;
	["BrandsPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandsPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HomePageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HomePageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
		__typename?: boolean
}>;
	["HomePageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HomePageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["IngredientsPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["IngredientsPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientsPage"],
		__typename?: boolean
}>;
	["IngredientsPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["IngredientsPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IngredientsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductReviewCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductReview"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductReviewDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductReview"],
		__typename?: boolean
}>;
	["ProductReviewUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductReview"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductReviewUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductReview"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ScoreCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Score"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ScoreDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Score"],
		__typename?: boolean
}>;
	["ScoreUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Score"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ScoreUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Score"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AgeCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Age"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AgeDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Age"],
		__typename?: boolean
}>;
	["AgeUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Age"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AgeUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Age"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["CountryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Country"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["CountryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Country"],
		__typename?: boolean
}>;
	["CountryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Country"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["CountryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Country"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPostReviewCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostReview"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPostReviewDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostReview"],
		__typename?: boolean
}>;
	["BlogPostReviewUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostReview"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPostReviewUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostReview"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogActivityCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogActivity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogActivityDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogActivity"],
		__typename?: boolean
}>;
	["DogActivityUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogActivity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogActivityUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogActivity"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Social"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Social"],
		__typename?: boolean
}>;
	["SocialUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Social"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Social"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceGalleryImageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReferenceGalleryImage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceGalleryImageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReferenceGalleryImage"],
		__typename?: boolean
}>;
	["ContentReferenceGalleryImageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReferenceGalleryImage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceGalleryImageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReferenceGalleryImage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Item"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Item"],
		__typename?: boolean
}>;
	["ItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Item"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Item"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemSubCategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemSubCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemSubCategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemSubCategory"],
		__typename?: boolean
}>;
	["ItemSubCategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemSubCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemSubCategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemSubCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemCategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemCategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemCategory"],
		__typename?: boolean
}>;
	["ItemCategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemCategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemFlavorCategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemFlavorCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemFlavorCategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemFlavorCategory"],
		__typename?: boolean
}>;
	["ItemFlavorCategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemFlavorCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemFlavorCategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemFlavorCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemDeclensionFourthVariantCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemDeclensionFourthVariant"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemDeclensionFourthVariantDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemDeclensionFourthVariant"],
		__typename?: boolean
}>;
	["ItemDeclensionFourthVariantUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemDeclensionFourthVariant"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemDeclensionFourthVariantUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemDeclensionFourthVariant"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemDeclensionSeventhVariantCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemDeclensionSeventhVariant"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemDeclensionSeventhVariantDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemDeclensionSeventhVariant"],
		__typename?: boolean
}>;
	["ItemDeclensionSeventhVariantUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemDeclensionSeventhVariant"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemDeclensionSeventhVariantUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemDeclensionSeventhVariant"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["MediaCardCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediaCard"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["MediaCardDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediaCard"],
		__typename?: boolean
}>;
	["MediaCardUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediaCard"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["MediaCardUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediaCard"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["InfoCardCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCard"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["InfoCardDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCard"],
		__typename?: boolean
}>;
	["InfoCardUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCard"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["InfoCardUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["InfoCard"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NumberedCardCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NumberedCard"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NumberedCardDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NumberedCard"],
		__typename?: boolean
}>;
	["NumberedCardUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NumberedCard"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NumberedCardUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NumberedCard"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RegisterClaimCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RegisterClaim"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RegisterClaimDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RegisterClaim"],
		__typename?: boolean
}>;
	["RegisterClaimUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RegisterClaim"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RegisterClaimUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RegisterClaim"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPostReviewReactionCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostReviewReaction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPostReviewReactionDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostReviewReaction"],
		__typename?: boolean
}>;
	["BlogPostReviewReactionUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostReviewReaction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BlogPostReviewReactionUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BlogPostReviewReaction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductReviewReactionCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductReviewReaction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductReviewReactionDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductReviewReaction"],
		__typename?: boolean
}>;
	["ProductReviewReactionUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductReviewReaction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductReviewReactionUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductReviewReaction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductPackageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductPackage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductPackageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductPackage"],
		__typename?: boolean
}>;
	["ProductPackageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductPackage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductPackageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductPackage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandManufacturerCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandManufacturer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandManufacturerDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandManufacturer"],
		__typename?: boolean
}>;
	["BrandManufacturerUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandManufacturer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandManufacturerUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandManufacturer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ElementCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Element"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ElementDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Element"],
		__typename?: boolean
}>;
	["ElementUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Element"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ElementUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Element"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ElementOfProductCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ElementOfProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ElementOfProductDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ElementOfProduct"],
		__typename?: boolean
}>;
	["ElementOfProductUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ElementOfProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ElementOfProductUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ElementOfProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SuitabilityCategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuitabilityCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SuitabilityCategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuitabilityCategory"],
		__typename?: boolean
}>;
	["SuitabilityCategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuitabilityCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SuitabilityCategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuitabilityCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductFeatureCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductFeature"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductFeatureDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductFeature"],
		__typename?: boolean
}>;
	["ProductFeatureUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductFeature"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductFeatureUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductFeature"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SuitabilityItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuitabilityItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SuitabilityItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuitabilityItem"],
		__typename?: boolean
}>;
	["SuitabilityItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuitabilityItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SuitabilityItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SuitabilityItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RegionCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Region"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RegionDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Region"],
		__typename?: boolean
}>;
	["RegionUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Region"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RegionUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Region"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["GranuleSizeCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GranuleSize"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["GranuleSizeDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GranuleSize"],
		__typename?: boolean
}>;
	["GranuleSizeUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GranuleSize"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["GranuleSizeUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GranuleSize"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemAliasCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemAliasDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemAlias"],
		__typename?: boolean
}>;
	["ItemAliasUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemAliasUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SemanticKeyCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SemanticKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SemanticKeyDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SemanticKey"],
		__typename?: boolean
}>;
	["SemanticKeyUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SemanticKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SemanticKeyUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SemanticKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductFlagCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductFlag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductFlagDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductFlag"],
		__typename?: boolean
}>;
	["ProductFlagUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductFlag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductFlagUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductFlag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductFlagOfProductCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductFlagOfProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductFlagOfProductDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductFlagOfProduct"],
		__typename?: boolean
}>;
	["ProductFlagOfProductUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductFlagOfProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductFlagOfProductUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductFlagOfProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductEvaluationCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductEvaluation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductEvaluationDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductEvaluation"],
		__typename?: boolean
}>;
	["ProductEvaluationUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductEvaluation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductEvaluationUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductEvaluation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AdCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Ad"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AdDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Ad"],
		__typename?: boolean
}>;
	["AdUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Ad"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AdUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Ad"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["EvaluationInfoCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EvaluationInfo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["EvaluationInfoDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EvaluationInfo"],
		__typename?: boolean
}>;
	["EvaluationInfoUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EvaluationInfo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["EvaluationInfoUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EvaluationInfo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ConsumptionMessageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ConsumptionMessage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ConsumptionMessageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ConsumptionMessage"],
		__typename?: boolean
}>;
	["ConsumptionMessageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ConsumptionMessage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ConsumptionMessageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ConsumptionMessage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentTextCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentText"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentTextDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentText"],
		__typename?: boolean
}>;
	["ContentTextUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentText"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentTextUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentText"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentTextBlockCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentTextBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentTextBlockDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentTextBlock"],
		__typename?: boolean
}>;
	["ContentTextBlockUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentTextBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentTextBlockUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentTextBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ComparatorPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ComparatorPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ComparatorPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ComparatorPage"],
		__typename?: boolean
}>;
	["ComparatorPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ComparatorPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ComparatorPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ComparatorPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LoginPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LoginPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LoginPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LoginPage"],
		__typename?: boolean
}>;
	["LoginPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LoginPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LoginPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LoginPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RegisterPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RegisterPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RegisterPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RegisterPage"],
		__typename?: boolean
}>;
	["RegisterPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RegisterPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RegisterPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RegisterPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ResultsPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ResultsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ResultsPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ResultsPage"],
		__typename?: boolean
}>;
	["ResultsPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ResultsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ResultsPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ResultsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SearchPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SearchPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SearchPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SearchPage"],
		__typename?: boolean
}>;
	["SearchPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SearchPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SearchPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SearchPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["WizardPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WizardPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["WizardPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WizardPage"],
		__typename?: boolean
}>;
	["WizardPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WizardPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["WizardPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["WizardPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BreastfeedingCategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BreastfeedingCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BreastfeedingCategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BreastfeedingCategory"],
		__typename?: boolean
}>;
	["BreastfeedingCategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BreastfeedingCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BreastfeedingCategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BreastfeedingCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogReproductionCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogReproduction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogReproductionDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogReproduction"],
		__typename?: boolean
}>;
	["DogReproductionUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogReproduction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["DogReproductionUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DogReproduction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContactFormMessageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactFormMessage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContactFormMessageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactFormMessage"],
		__typename?: boolean
}>;
	["ContactFormMessageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactFormMessage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContactFormMessageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactFormMessage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContactPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContactPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactPage"],
		__typename?: boolean
}>;
	["ContactPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContactPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BugReportCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BugReport"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BugReportDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BugReport"],
		__typename?: boolean
}>;
	["BugReportUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BugReport"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BugReportUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BugReport"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ColorCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Color"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ColorDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Color"],
		__typename?: boolean
}>;
	["ColorUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Color"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ColorUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Color"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemGroupCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemGroupDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemGroup"],
		__typename?: boolean
}>;
	["ItemGroupUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ItemGroupUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ItemGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductEvaluationSummaryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductEvaluationSummary"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductEvaluationSummaryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductEvaluationSummary"],
		__typename?: boolean
}>;
	["ProductEvaluationSummaryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductEvaluationSummary"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductEvaluationSummaryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductEvaluationSummary"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProtectedActionCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProtectedAction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProtectedActionDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProtectedAction"],
		__typename?: boolean
}>;
	["ProtectedActionUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProtectedAction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProtectedActionUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProtectedAction"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandAliasCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandAliasDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandAlias"],
		__typename?: boolean
}>;
	["BrandAliasUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BrandAliasUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BrandAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductAliasCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductAliasDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductAlias"],
		__typename?: boolean
}>;
	["ProductAliasUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductAliasUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductLineAliasCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductLineAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductLineAliasDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductLineAlias"],
		__typename?: boolean
}>;
	["ProductLineAliasUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductLineAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductLineAliasUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ProductLineAlias"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["GenericPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["GenericPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
		__typename?: boolean
}>;
	["GenericPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["GenericPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GenericPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
		__typename?: boolean
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentLinksCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentLinks"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentLinksDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentLinks"],
		__typename?: boolean
}>;
	["ContentLinksUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentLinks"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentLinksUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentLinks"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentLinksItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentLinksItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentLinksItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentLinksItem"],
		__typename?: boolean
}>;
	["ContentLinksItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentLinksItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentLinksItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentLinksItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RedirectCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RedirectDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
		__typename?: boolean
}>;
	["RedirectUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RedirectUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceImageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReferenceImage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceImageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReferenceImage"],
		__typename?: boolean
}>;
	["ContentReferenceImageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReferenceImage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceImageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReferenceImage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SeoDataCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoData"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SeoDataDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoData"],
		__typename?: boolean
}>;
	["SeoDataUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoData"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SeoDataUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoData"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AgeCategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AgeCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AgeCategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AgeCategory"],
		__typename?: boolean
}>;
	["AgeCategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AgeCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AgeCategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AgeCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FilterComboCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilterCombo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FilterComboDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilterCombo"],
		__typename?: boolean
}>;
	["FilterComboUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilterCombo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FilterComboUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FilterCombo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImportCacheCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImportCache"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImportCacheDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImportCache"],
		__typename?: boolean
}>;
	["ImportCacheUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImportCache"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImportCacheUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImportCache"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SiteCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Site"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SiteDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Site"],
		__typename?: boolean
}>;
	["SiteUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Site"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SiteUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Site"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContactSubmissionCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactSubmission"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContactSubmissionDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactSubmission"],
		__typename?: boolean
}>;
	["ContactSubmissionUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactSubmission"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContactSubmissionUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactSubmission"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TOPXBrandCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXBrand"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TOPXBrandDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXBrand"],
		__typename?: boolean
}>;
	["TOPXBrandUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXBrand"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TOPXBrandUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXBrand"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TOPXBrandCategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXBrandCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TOPXBrandCategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXBrandCategory"],
		__typename?: boolean
}>;
	["TOPXBrandCategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXBrandCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TOPXBrandCategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXBrandCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TOPXProductCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TOPXProductDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXProduct"],
		__typename?: boolean
}>;
	["TOPXProductUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TOPXProductUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXProduct"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TOPXProductCategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXProductCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TOPXProductCategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXProductCategory"],
		__typename?: boolean
}>;
	["TOPXProductCategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXProductCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TOPXProductCategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TOPXProductCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceListCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReferenceList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceListDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReferenceList"],
		__typename?: boolean
}>;
	["ContentReferenceListUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReferenceList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceListUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReferenceList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["MutationTransaction"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	validation?:ValueTypes["_ValidationResult"],
generateUploadUrl?: [{	input?:ValueTypes["S3GenerateSignedUploadInput"] | null},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey:string,	expiration?:number | null},ValueTypes["S3SignedRead"]],
createBlogPage?: [{	data:ValueTypes["BlogPageCreateInput"]},ValueTypes["BlogPageCreateResult"]],
deleteBlogPage?: [{	by:ValueTypes["BlogPageUniqueWhere"],	filter?:ValueTypes["BlogPageWhere"] | null},ValueTypes["BlogPageDeleteResult"]],
updateBlogPage?: [{	by:ValueTypes["BlogPageUniqueWhere"],	filter?:ValueTypes["BlogPageWhere"] | null,	data:ValueTypes["BlogPageUpdateInput"]},ValueTypes["BlogPageUpdateResult"]],
upsertBlogPage?: [{	by:ValueTypes["BlogPageUniqueWhere"],	filter?:ValueTypes["BlogPageWhere"] | null,	update:ValueTypes["BlogPageUpdateInput"],	create:ValueTypes["BlogPageCreateInput"]},ValueTypes["BlogPageUpsertResult"]],
createBlogPost?: [{	data:ValueTypes["BlogPostCreateInput"]},ValueTypes["BlogPostCreateResult"]],
deleteBlogPost?: [{	by:ValueTypes["BlogPostUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null},ValueTypes["BlogPostDeleteResult"]],
updateBlogPost?: [{	by:ValueTypes["BlogPostUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null,	data:ValueTypes["BlogPostUpdateInput"]},ValueTypes["BlogPostUpdateResult"]],
upsertBlogPost?: [{	by:ValueTypes["BlogPostUniqueWhere"],	filter?:ValueTypes["BlogPostWhere"] | null,	update:ValueTypes["BlogPostUpdateInput"],	create:ValueTypes["BlogPostCreateInput"]},ValueTypes["BlogPostUpsertResult"]],
createBlogPostTag?: [{	data:ValueTypes["BlogPostTagCreateInput"]},ValueTypes["BlogPostTagCreateResult"]],
deleteBlogPostTag?: [{	by:ValueTypes["BlogPostTagUniqueWhere"],	filter?:ValueTypes["BlogPostTagWhere"] | null},ValueTypes["BlogPostTagDeleteResult"]],
updateBlogPostTag?: [{	by:ValueTypes["BlogPostTagUniqueWhere"],	filter?:ValueTypes["BlogPostTagWhere"] | null,	data:ValueTypes["BlogPostTagUpdateInput"]},ValueTypes["BlogPostTagUpdateResult"]],
upsertBlogPostTag?: [{	by:ValueTypes["BlogPostTagUniqueWhere"],	filter?:ValueTypes["BlogPostTagWhere"] | null,	update:ValueTypes["BlogPostTagUpdateInput"],	create:ValueTypes["BlogPostTagCreateInput"]},ValueTypes["BlogPostTagUpsertResult"]],
createBodyTag?: [{	data:ValueTypes["BodyTagCreateInput"]},ValueTypes["BodyTagCreateResult"]],
deleteBodyTag?: [{	by:ValueTypes["BodyTagUniqueWhere"],	filter?:ValueTypes["BodyTagWhere"] | null},ValueTypes["BodyTagDeleteResult"]],
updateBodyTag?: [{	by:ValueTypes["BodyTagUniqueWhere"],	filter?:ValueTypes["BodyTagWhere"] | null,	data:ValueTypes["BodyTagUpdateInput"]},ValueTypes["BodyTagUpdateResult"]],
upsertBodyTag?: [{	by:ValueTypes["BodyTagUniqueWhere"],	filter?:ValueTypes["BodyTagWhere"] | null,	update:ValueTypes["BodyTagUpdateInput"],	create:ValueTypes["BodyTagCreateInput"]},ValueTypes["BodyTagUpsertResult"]],
createBodyTagCategory?: [{	data:ValueTypes["BodyTagCategoryCreateInput"]},ValueTypes["BodyTagCategoryCreateResult"]],
deleteBodyTagCategory?: [{	by:ValueTypes["BodyTagCategoryUniqueWhere"],	filter?:ValueTypes["BodyTagCategoryWhere"] | null},ValueTypes["BodyTagCategoryDeleteResult"]],
updateBodyTagCategory?: [{	by:ValueTypes["BodyTagCategoryUniqueWhere"],	filter?:ValueTypes["BodyTagCategoryWhere"] | null,	data:ValueTypes["BodyTagCategoryUpdateInput"]},ValueTypes["BodyTagCategoryUpdateResult"]],
upsertBodyTagCategory?: [{	by:ValueTypes["BodyTagCategoryUniqueWhere"],	filter?:ValueTypes["BodyTagCategoryWhere"] | null,	update:ValueTypes["BodyTagCategoryUpdateInput"],	create:ValueTypes["BodyTagCategoryCreateInput"]},ValueTypes["BodyTagCategoryUpsertResult"]],
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createDidYouKnow?: [{	data:ValueTypes["DidYouKnowCreateInput"]},ValueTypes["DidYouKnowCreateResult"]],
deleteDidYouKnow?: [{	by:ValueTypes["DidYouKnowUniqueWhere"],	filter?:ValueTypes["DidYouKnowWhere"] | null},ValueTypes["DidYouKnowDeleteResult"]],
updateDidYouKnow?: [{	by:ValueTypes["DidYouKnowUniqueWhere"],	filter?:ValueTypes["DidYouKnowWhere"] | null,	data:ValueTypes["DidYouKnowUpdateInput"]},ValueTypes["DidYouKnowUpdateResult"]],
upsertDidYouKnow?: [{	by:ValueTypes["DidYouKnowUniqueWhere"],	filter?:ValueTypes["DidYouKnowWhere"] | null,	update:ValueTypes["DidYouKnowUpdateInput"],	create:ValueTypes["DidYouKnowCreateInput"]},ValueTypes["DidYouKnowUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createMedium?: [{	data:ValueTypes["MediumCreateInput"]},ValueTypes["MediumCreateResult"]],
deleteMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["MediumDeleteResult"]],
updateMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null,	data:ValueTypes["MediumUpdateInput"]},ValueTypes["MediumUpdateResult"]],
upsertMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null,	update:ValueTypes["MediumUpdateInput"],	create:ValueTypes["MediumCreateInput"]},ValueTypes["MediumUpsertResult"]],
createNutritionalValue?: [{	data:ValueTypes["NutritionalValueCreateInput"]},ValueTypes["NutritionalValueCreateResult"]],
deleteNutritionalValue?: [{	by:ValueTypes["NutritionalValueUniqueWhere"],	filter?:ValueTypes["NutritionalValueWhere"] | null},ValueTypes["NutritionalValueDeleteResult"]],
updateNutritionalValue?: [{	by:ValueTypes["NutritionalValueUniqueWhere"],	filter?:ValueTypes["NutritionalValueWhere"] | null,	data:ValueTypes["NutritionalValueUpdateInput"]},ValueTypes["NutritionalValueUpdateResult"]],
upsertNutritionalValue?: [{	by:ValueTypes["NutritionalValueUniqueWhere"],	filter?:ValueTypes["NutritionalValueWhere"] | null,	update:ValueTypes["NutritionalValueUpdateInput"],	create:ValueTypes["NutritionalValueCreateInput"]},ValueTypes["NutritionalValueUpsertResult"]],
createPage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["PageCreateResult"]],
deletePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["PageDeleteResult"]],
updatePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	data:ValueTypes["PageUpdateInput"]},ValueTypes["PageUpdateResult"]],
upsertPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	update:ValueTypes["PageUpdateInput"],	create:ValueTypes["PageCreateInput"]},ValueTypes["PageUpsertResult"]],
createReference?: [{	data:ValueTypes["ReferenceCreateInput"]},ValueTypes["ReferenceCreateResult"]],
deleteReference?: [{	by:ValueTypes["ReferenceUniqueWhere"],	filter?:ValueTypes["ReferenceWhere"] | null},ValueTypes["ReferenceDeleteResult"]],
updateReference?: [{	by:ValueTypes["ReferenceUniqueWhere"],	filter?:ValueTypes["ReferenceWhere"] | null,	data:ValueTypes["ReferenceUpdateInput"]},ValueTypes["ReferenceUpdateResult"]],
upsertReference?: [{	by:ValueTypes["ReferenceUniqueWhere"],	filter?:ValueTypes["ReferenceWhere"] | null,	update:ValueTypes["ReferenceUpdateInput"],	create:ValueTypes["ReferenceCreateInput"]},ValueTypes["ReferenceUpsertResult"]],
createReferenceList?: [{	data:ValueTypes["ReferenceListCreateInput"]},ValueTypes["ReferenceListCreateResult"]],
deleteReferenceList?: [{	by:ValueTypes["ReferenceListUniqueWhere"],	filter?:ValueTypes["ReferenceListWhere"] | null},ValueTypes["ReferenceListDeleteResult"]],
updateReferenceList?: [{	by:ValueTypes["ReferenceListUniqueWhere"],	filter?:ValueTypes["ReferenceListWhere"] | null,	data:ValueTypes["ReferenceListUpdateInput"]},ValueTypes["ReferenceListUpdateResult"]],
upsertReferenceList?: [{	by:ValueTypes["ReferenceListUniqueWhere"],	filter?:ValueTypes["ReferenceListWhere"] | null,	update:ValueTypes["ReferenceListUpdateInput"],	create:ValueTypes["ReferenceListCreateInput"]},ValueTypes["ReferenceListUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	data:ValueTypes["VideoUpdateInput"]},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	update:ValueTypes["VideoUpdateInput"],	create:ValueTypes["VideoCreateInput"]},ValueTypes["VideoUpsertResult"]],
createBrand?: [{	data:ValueTypes["BrandCreateInput"]},ValueTypes["BrandCreateResult"]],
deleteBrand?: [{	by:ValueTypes["BrandUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null},ValueTypes["BrandDeleteResult"]],
updateBrand?: [{	by:ValueTypes["BrandUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null,	data:ValueTypes["BrandUpdateInput"]},ValueTypes["BrandUpdateResult"]],
upsertBrand?: [{	by:ValueTypes["BrandUniqueWhere"],	filter?:ValueTypes["BrandWhere"] | null,	update:ValueTypes["BrandUpdateInput"],	create:ValueTypes["BrandCreateInput"]},ValueTypes["BrandUpsertResult"]],
createBrandDistributor?: [{	data:ValueTypes["BrandDistributorCreateInput"]},ValueTypes["BrandDistributorCreateResult"]],
deleteBrandDistributor?: [{	by:ValueTypes["BrandDistributorUniqueWhere"],	filter?:ValueTypes["BrandDistributorWhere"] | null},ValueTypes["BrandDistributorDeleteResult"]],
updateBrandDistributor?: [{	by:ValueTypes["BrandDistributorUniqueWhere"],	filter?:ValueTypes["BrandDistributorWhere"] | null,	data:ValueTypes["BrandDistributorUpdateInput"]},ValueTypes["BrandDistributorUpdateResult"]],
upsertBrandDistributor?: [{	by:ValueTypes["BrandDistributorUniqueWhere"],	filter?:ValueTypes["BrandDistributorWhere"] | null,	update:ValueTypes["BrandDistributorUpdateInput"],	create:ValueTypes["BrandDistributorCreateInput"]},ValueTypes["BrandDistributorUpsertResult"]],
createDogSize?: [{	data:ValueTypes["DogSizeCreateInput"]},ValueTypes["DogSizeCreateResult"]],
deleteDogSize?: [{	by:ValueTypes["DogSizeUniqueWhere"],	filter?:ValueTypes["DogSizeWhere"] | null},ValueTypes["DogSizeDeleteResult"]],
updateDogSize?: [{	by:ValueTypes["DogSizeUniqueWhere"],	filter?:ValueTypes["DogSizeWhere"] | null,	data:ValueTypes["DogSizeUpdateInput"]},ValueTypes["DogSizeUpdateResult"]],
upsertDogSize?: [{	by:ValueTypes["DogSizeUniqueWhere"],	filter?:ValueTypes["DogSizeWhere"] | null,	update:ValueTypes["DogSizeUpdateInput"],	create:ValueTypes["DogSizeCreateInput"]},ValueTypes["DogSizeUpsertResult"]],
createProduct?: [{	data:ValueTypes["ProductCreateInput"]},ValueTypes["ProductCreateResult"]],
deleteProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["ProductDeleteResult"]],
updateProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null,	data:ValueTypes["ProductUpdateInput"]},ValueTypes["ProductUpdateResult"]],
upsertProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null,	update:ValueTypes["ProductUpdateInput"],	create:ValueTypes["ProductCreateInput"]},ValueTypes["ProductUpsertResult"]],
createProductionMethod?: [{	data:ValueTypes["ProductionMethodCreateInput"]},ValueTypes["ProductionMethodCreateResult"]],
deleteProductionMethod?: [{	by:ValueTypes["ProductionMethodUniqueWhere"],	filter?:ValueTypes["ProductionMethodWhere"] | null},ValueTypes["ProductionMethodDeleteResult"]],
updateProductionMethod?: [{	by:ValueTypes["ProductionMethodUniqueWhere"],	filter?:ValueTypes["ProductionMethodWhere"] | null,	data:ValueTypes["ProductionMethodUpdateInput"]},ValueTypes["ProductionMethodUpdateResult"]],
upsertProductionMethod?: [{	by:ValueTypes["ProductionMethodUniqueWhere"],	filter?:ValueTypes["ProductionMethodWhere"] | null,	update:ValueTypes["ProductionMethodUpdateInput"],	create:ValueTypes["ProductionMethodCreateInput"]},ValueTypes["ProductionMethodUpsertResult"]],
createProductLine?: [{	data:ValueTypes["ProductLineCreateInput"]},ValueTypes["ProductLineCreateResult"]],
deleteProductLine?: [{	by:ValueTypes["ProductLineUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null},ValueTypes["ProductLineDeleteResult"]],
updateProductLine?: [{	by:ValueTypes["ProductLineUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null,	data:ValueTypes["ProductLineUpdateInput"]},ValueTypes["ProductLineUpdateResult"]],
upsertProductLine?: [{	by:ValueTypes["ProductLineUniqueWhere"],	filter?:ValueTypes["ProductLineWhere"] | null,	update:ValueTypes["ProductLineUpdateInput"],	create:ValueTypes["ProductLineCreateInput"]},ValueTypes["ProductLineUpsertResult"]],
createBreed?: [{	data:ValueTypes["BreedCreateInput"]},ValueTypes["BreedCreateResult"]],
deleteBreed?: [{	by:ValueTypes["BreedUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null},ValueTypes["BreedDeleteResult"]],
updateBreed?: [{	by:ValueTypes["BreedUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null,	data:ValueTypes["BreedUpdateInput"]},ValueTypes["BreedUpdateResult"]],
upsertBreed?: [{	by:ValueTypes["BreedUniqueWhere"],	filter?:ValueTypes["BreedWhere"] | null,	update:ValueTypes["BreedUpdateInput"],	create:ValueTypes["BreedCreateInput"]},ValueTypes["BreedUpsertResult"]],
createDog?: [{	data:ValueTypes["DogCreateInput"]},ValueTypes["DogCreateResult"]],
deleteDog?: [{	by:ValueTypes["DogUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null},ValueTypes["DogDeleteResult"]],
updateDog?: [{	by:ValueTypes["DogUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null,	data:ValueTypes["DogUpdateInput"]},ValueTypes["DogUpdateResult"]],
upsertDog?: [{	by:ValueTypes["DogUniqueWhere"],	filter?:ValueTypes["DogWhere"] | null,	update:ValueTypes["DogUpdateInput"],	create:ValueTypes["DogCreateInput"]},ValueTypes["DogUpsertResult"]],
createUser?: [{	data:ValueTypes["UserCreateInput"]},ValueTypes["UserCreateResult"]],
deleteUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null},ValueTypes["UserDeleteResult"]],
updateUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null,	data:ValueTypes["UserUpdateInput"]},ValueTypes["UserUpdateResult"]],
upsertUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null,	update:ValueTypes["UserUpdateInput"],	create:ValueTypes["UserCreateInput"]},ValueTypes["UserUpsertResult"]],
createVeterinary?: [{	data:ValueTypes["VeterinaryCreateInput"]},ValueTypes["VeterinaryCreateResult"]],
deleteVeterinary?: [{	by:ValueTypes["VeterinaryUniqueWhere"],	filter?:ValueTypes["VeterinaryWhere"] | null},ValueTypes["VeterinaryDeleteResult"]],
updateVeterinary?: [{	by:ValueTypes["VeterinaryUniqueWhere"],	filter?:ValueTypes["VeterinaryWhere"] | null,	data:ValueTypes["VeterinaryUpdateInput"]},ValueTypes["VeterinaryUpdateResult"]],
upsertVeterinary?: [{	by:ValueTypes["VeterinaryUniqueWhere"],	filter?:ValueTypes["VeterinaryWhere"] | null,	update:ValueTypes["VeterinaryUpdateInput"],	create:ValueTypes["VeterinaryCreateInput"]},ValueTypes["VeterinaryUpsertResult"]],
createNutritionalValueOfProduct?: [{	data:ValueTypes["NutritionalValueOfProductCreateInput"]},ValueTypes["NutritionalValueOfProductCreateResult"]],
deleteNutritionalValueOfProduct?: [{	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null},ValueTypes["NutritionalValueOfProductDeleteResult"]],
updateNutritionalValueOfProduct?: [{	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null,	data:ValueTypes["NutritionalValueOfProductUpdateInput"]},ValueTypes["NutritionalValueOfProductUpdateResult"]],
upsertNutritionalValueOfProduct?: [{	by:ValueTypes["NutritionalValueOfProductUniqueWhere"],	filter?:ValueTypes["NutritionalValueOfProductWhere"] | null,	update:ValueTypes["NutritionalValueOfProductUpdateInput"],	create:ValueTypes["NutritionalValueOfProductCreateInput"]},ValueTypes["NutritionalValueOfProductUpsertResult"]],
createReview?: [{	data:ValueTypes["ReviewCreateInput"]},ValueTypes["ReviewCreateResult"]],
deleteReview?: [{	by:ValueTypes["ReviewUniqueWhere"],	filter?:ValueTypes["ReviewWhere"] | null},ValueTypes["ReviewDeleteResult"]],
updateReview?: [{	by:ValueTypes["ReviewUniqueWhere"],	filter?:ValueTypes["ReviewWhere"] | null,	data:ValueTypes["ReviewUpdateInput"]},ValueTypes["ReviewUpdateResult"]],
upsertReview?: [{	by:ValueTypes["ReviewUniqueWhere"],	filter?:ValueTypes["ReviewWhere"] | null,	update:ValueTypes["ReviewUpdateInput"],	create:ValueTypes["ReviewCreateInput"]},ValueTypes["ReviewUpsertResult"]],
createDogBodyType?: [{	data:ValueTypes["DogBodyTypeCreateInput"]},ValueTypes["DogBodyTypeCreateResult"]],
deleteDogBodyType?: [{	by:ValueTypes["DogBodyTypeUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null},ValueTypes["DogBodyTypeDeleteResult"]],
updateDogBodyType?: [{	by:ValueTypes["DogBodyTypeUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null,	data:ValueTypes["DogBodyTypeUpdateInput"]},ValueTypes["DogBodyTypeUpdateResult"]],
upsertDogBodyType?: [{	by:ValueTypes["DogBodyTypeUniqueWhere"],	filter?:ValueTypes["DogBodyTypeWhere"] | null,	update:ValueTypes["DogBodyTypeUpdateInput"],	create:ValueTypes["DogBodyTypeCreateInput"]},ValueTypes["DogBodyTypeUpsertResult"]],
createDogBodyTypeCategory?: [{	data:ValueTypes["DogBodyTypeCategoryCreateInput"]},ValueTypes["DogBodyTypeCategoryCreateResult"]],
deleteDogBodyTypeCategory?: [{	by:ValueTypes["DogBodyTypeCategoryUniqueWhere"],	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null},ValueTypes["DogBodyTypeCategoryDeleteResult"]],
updateDogBodyTypeCategory?: [{	by:ValueTypes["DogBodyTypeCategoryUniqueWhere"],	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null,	data:ValueTypes["DogBodyTypeCategoryUpdateInput"]},ValueTypes["DogBodyTypeCategoryUpdateResult"]],
upsertDogBodyTypeCategory?: [{	by:ValueTypes["DogBodyTypeCategoryUniqueWhere"],	filter?:ValueTypes["DogBodyTypeCategoryWhere"] | null,	update:ValueTypes["DogBodyTypeCategoryUpdateInput"],	create:ValueTypes["DogBodyTypeCategoryCreateInput"]},ValueTypes["DogBodyTypeCategoryUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createUrl?: [{	data:ValueTypes["UrlCreateInput"]},ValueTypes["UrlCreateResult"]],
deleteUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["UrlDeleteResult"]],
updateUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null,	data:ValueTypes["UrlUpdateInput"]},ValueTypes["UrlUpdateResult"]],
upsertUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null,	update:ValueTypes["UrlUpdateInput"],	create:ValueTypes["UrlCreateInput"]},ValueTypes["UrlUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createFooterLink?: [{	data:ValueTypes["FooterLinkCreateInput"]},ValueTypes["FooterLinkCreateResult"]],
deleteFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null},ValueTypes["FooterLinkDeleteResult"]],
updateFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null,	data:ValueTypes["FooterLinkUpdateInput"]},ValueTypes["FooterLinkUpdateResult"]],
upsertFooterLink?: [{	by:ValueTypes["FooterLinkUniqueWhere"],	filter?:ValueTypes["FooterLinkWhere"] | null,	update:ValueTypes["FooterLinkUpdateInput"],	create:ValueTypes["FooterLinkCreateInput"]},ValueTypes["FooterLinkUpsertResult"]],
createBrandsPage?: [{	data:ValueTypes["BrandsPageCreateInput"]},ValueTypes["BrandsPageCreateResult"]],
deleteBrandsPage?: [{	by:ValueTypes["BrandsPageUniqueWhere"],	filter?:ValueTypes["BrandsPageWhere"] | null},ValueTypes["BrandsPageDeleteResult"]],
updateBrandsPage?: [{	by:ValueTypes["BrandsPageUniqueWhere"],	filter?:ValueTypes["BrandsPageWhere"] | null,	data:ValueTypes["BrandsPageUpdateInput"]},ValueTypes["BrandsPageUpdateResult"]],
upsertBrandsPage?: [{	by:ValueTypes["BrandsPageUniqueWhere"],	filter?:ValueTypes["BrandsPageWhere"] | null,	update:ValueTypes["BrandsPageUpdateInput"],	create:ValueTypes["BrandsPageCreateInput"]},ValueTypes["BrandsPageUpsertResult"]],
createHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	update:ValueTypes["HomePageUpdateInput"],	create:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageUpsertResult"]],
createIngredientsPage?: [{	data:ValueTypes["IngredientsPageCreateInput"]},ValueTypes["IngredientsPageCreateResult"]],
deleteIngredientsPage?: [{	by:ValueTypes["IngredientsPageUniqueWhere"],	filter?:ValueTypes["IngredientsPageWhere"] | null},ValueTypes["IngredientsPageDeleteResult"]],
updateIngredientsPage?: [{	by:ValueTypes["IngredientsPageUniqueWhere"],	filter?:ValueTypes["IngredientsPageWhere"] | null,	data:ValueTypes["IngredientsPageUpdateInput"]},ValueTypes["IngredientsPageUpdateResult"]],
upsertIngredientsPage?: [{	by:ValueTypes["IngredientsPageUniqueWhere"],	filter?:ValueTypes["IngredientsPageWhere"] | null,	update:ValueTypes["IngredientsPageUpdateInput"],	create:ValueTypes["IngredientsPageCreateInput"]},ValueTypes["IngredientsPageUpsertResult"]],
createProductReview?: [{	data:ValueTypes["ProductReviewCreateInput"]},ValueTypes["ProductReviewCreateResult"]],
deleteProductReview?: [{	by:ValueTypes["ProductReviewUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null},ValueTypes["ProductReviewDeleteResult"]],
updateProductReview?: [{	by:ValueTypes["ProductReviewUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null,	data:ValueTypes["ProductReviewUpdateInput"]},ValueTypes["ProductReviewUpdateResult"]],
upsertProductReview?: [{	by:ValueTypes["ProductReviewUniqueWhere"],	filter?:ValueTypes["ProductReviewWhere"] | null,	update:ValueTypes["ProductReviewUpdateInput"],	create:ValueTypes["ProductReviewCreateInput"]},ValueTypes["ProductReviewUpsertResult"]],
createScore?: [{	data:ValueTypes["ScoreCreateInput"]},ValueTypes["ScoreCreateResult"]],
deleteScore?: [{	by:ValueTypes["ScoreUniqueWhere"],	filter?:ValueTypes["ScoreWhere"] | null},ValueTypes["ScoreDeleteResult"]],
updateScore?: [{	by:ValueTypes["ScoreUniqueWhere"],	filter?:ValueTypes["ScoreWhere"] | null,	data:ValueTypes["ScoreUpdateInput"]},ValueTypes["ScoreUpdateResult"]],
upsertScore?: [{	by:ValueTypes["ScoreUniqueWhere"],	filter?:ValueTypes["ScoreWhere"] | null,	update:ValueTypes["ScoreUpdateInput"],	create:ValueTypes["ScoreCreateInput"]},ValueTypes["ScoreUpsertResult"]],
createAge?: [{	data:ValueTypes["AgeCreateInput"]},ValueTypes["AgeCreateResult"]],
deleteAge?: [{	by:ValueTypes["AgeUniqueWhere"],	filter?:ValueTypes["AgeWhere"] | null},ValueTypes["AgeDeleteResult"]],
updateAge?: [{	by:ValueTypes["AgeUniqueWhere"],	filter?:ValueTypes["AgeWhere"] | null,	data:ValueTypes["AgeUpdateInput"]},ValueTypes["AgeUpdateResult"]],
upsertAge?: [{	by:ValueTypes["AgeUniqueWhere"],	filter?:ValueTypes["AgeWhere"] | null,	update:ValueTypes["AgeUpdateInput"],	create:ValueTypes["AgeCreateInput"]},ValueTypes["AgeUpsertResult"]],
createCountry?: [{	data:ValueTypes["CountryCreateInput"]},ValueTypes["CountryCreateResult"]],
deleteCountry?: [{	by:ValueTypes["CountryUniqueWhere"],	filter?:ValueTypes["CountryWhere"] | null},ValueTypes["CountryDeleteResult"]],
updateCountry?: [{	by:ValueTypes["CountryUniqueWhere"],	filter?:ValueTypes["CountryWhere"] | null,	data:ValueTypes["CountryUpdateInput"]},ValueTypes["CountryUpdateResult"]],
upsertCountry?: [{	by:ValueTypes["CountryUniqueWhere"],	filter?:ValueTypes["CountryWhere"] | null,	update:ValueTypes["CountryUpdateInput"],	create:ValueTypes["CountryCreateInput"]},ValueTypes["CountryUpsertResult"]],
createBlogPostReview?: [{	data:ValueTypes["BlogPostReviewCreateInput"]},ValueTypes["BlogPostReviewCreateResult"]],
deleteBlogPostReview?: [{	by:ValueTypes["BlogPostReviewUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null},ValueTypes["BlogPostReviewDeleteResult"]],
updateBlogPostReview?: [{	by:ValueTypes["BlogPostReviewUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null,	data:ValueTypes["BlogPostReviewUpdateInput"]},ValueTypes["BlogPostReviewUpdateResult"]],
upsertBlogPostReview?: [{	by:ValueTypes["BlogPostReviewUniqueWhere"],	filter?:ValueTypes["BlogPostReviewWhere"] | null,	update:ValueTypes["BlogPostReviewUpdateInput"],	create:ValueTypes["BlogPostReviewCreateInput"]},ValueTypes["BlogPostReviewUpsertResult"]],
createDogActivity?: [{	data:ValueTypes["DogActivityCreateInput"]},ValueTypes["DogActivityCreateResult"]],
deleteDogActivity?: [{	by:ValueTypes["DogActivityUniqueWhere"],	filter?:ValueTypes["DogActivityWhere"] | null},ValueTypes["DogActivityDeleteResult"]],
updateDogActivity?: [{	by:ValueTypes["DogActivityUniqueWhere"],	filter?:ValueTypes["DogActivityWhere"] | null,	data:ValueTypes["DogActivityUpdateInput"]},ValueTypes["DogActivityUpdateResult"]],
upsertDogActivity?: [{	by:ValueTypes["DogActivityUniqueWhere"],	filter?:ValueTypes["DogActivityWhere"] | null,	update:ValueTypes["DogActivityUpdateInput"],	create:ValueTypes["DogActivityCreateInput"]},ValueTypes["DogActivityUpsertResult"]],
createSocial?: [{	data:ValueTypes["SocialCreateInput"]},ValueTypes["SocialCreateResult"]],
deleteSocial?: [{	by:ValueTypes["SocialUniqueWhere"],	filter?:ValueTypes["SocialWhere"] | null},ValueTypes["SocialDeleteResult"]],
updateSocial?: [{	by:ValueTypes["SocialUniqueWhere"],	filter?:ValueTypes["SocialWhere"] | null,	data:ValueTypes["SocialUpdateInput"]},ValueTypes["SocialUpdateResult"]],
upsertSocial?: [{	by:ValueTypes["SocialUniqueWhere"],	filter?:ValueTypes["SocialWhere"] | null,	update:ValueTypes["SocialUpdateInput"],	create:ValueTypes["SocialCreateInput"]},ValueTypes["SocialUpsertResult"]],
createContentReferenceGalleryImage?: [{	data:ValueTypes["ContentReferenceGalleryImageCreateInput"]},ValueTypes["ContentReferenceGalleryImageCreateResult"]],
deleteContentReferenceGalleryImage?: [{	by:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null},ValueTypes["ContentReferenceGalleryImageDeleteResult"]],
updateContentReferenceGalleryImage?: [{	by:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null,	data:ValueTypes["ContentReferenceGalleryImageUpdateInput"]},ValueTypes["ContentReferenceGalleryImageUpdateResult"]],
upsertContentReferenceGalleryImage?: [{	by:ValueTypes["ContentReferenceGalleryImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceGalleryImageWhere"] | null,	update:ValueTypes["ContentReferenceGalleryImageUpdateInput"],	create:ValueTypes["ContentReferenceGalleryImageCreateInput"]},ValueTypes["ContentReferenceGalleryImageUpsertResult"]],
createItem?: [{	data:ValueTypes["ItemCreateInput"]},ValueTypes["ItemCreateResult"]],
deleteItem?: [{	by:ValueTypes["ItemUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null},ValueTypes["ItemDeleteResult"]],
updateItem?: [{	by:ValueTypes["ItemUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null,	data:ValueTypes["ItemUpdateInput"]},ValueTypes["ItemUpdateResult"]],
upsertItem?: [{	by:ValueTypes["ItemUniqueWhere"],	filter?:ValueTypes["ItemWhere"] | null,	update:ValueTypes["ItemUpdateInput"],	create:ValueTypes["ItemCreateInput"]},ValueTypes["ItemUpsertResult"]],
createItemSubCategory?: [{	data:ValueTypes["ItemSubCategoryCreateInput"]},ValueTypes["ItemSubCategoryCreateResult"]],
deleteItemSubCategory?: [{	by:ValueTypes["ItemSubCategoryUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null},ValueTypes["ItemSubCategoryDeleteResult"]],
updateItemSubCategory?: [{	by:ValueTypes["ItemSubCategoryUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	data:ValueTypes["ItemSubCategoryUpdateInput"]},ValueTypes["ItemSubCategoryUpdateResult"]],
upsertItemSubCategory?: [{	by:ValueTypes["ItemSubCategoryUniqueWhere"],	filter?:ValueTypes["ItemSubCategoryWhere"] | null,	update:ValueTypes["ItemSubCategoryUpdateInput"],	create:ValueTypes["ItemSubCategoryCreateInput"]},ValueTypes["ItemSubCategoryUpsertResult"]],
createItemCategory?: [{	data:ValueTypes["ItemCategoryCreateInput"]},ValueTypes["ItemCategoryCreateResult"]],
deleteItemCategory?: [{	by:ValueTypes["ItemCategoryUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null},ValueTypes["ItemCategoryDeleteResult"]],
updateItemCategory?: [{	by:ValueTypes["ItemCategoryUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null,	data:ValueTypes["ItemCategoryUpdateInput"]},ValueTypes["ItemCategoryUpdateResult"]],
upsertItemCategory?: [{	by:ValueTypes["ItemCategoryUniqueWhere"],	filter?:ValueTypes["ItemCategoryWhere"] | null,	update:ValueTypes["ItemCategoryUpdateInput"],	create:ValueTypes["ItemCategoryCreateInput"]},ValueTypes["ItemCategoryUpsertResult"]],
createItemFlavorCategory?: [{	data:ValueTypes["ItemFlavorCategoryCreateInput"]},ValueTypes["ItemFlavorCategoryCreateResult"]],
deleteItemFlavorCategory?: [{	by:ValueTypes["ItemFlavorCategoryUniqueWhere"],	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null},ValueTypes["ItemFlavorCategoryDeleteResult"]],
updateItemFlavorCategory?: [{	by:ValueTypes["ItemFlavorCategoryUniqueWhere"],	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null,	data:ValueTypes["ItemFlavorCategoryUpdateInput"]},ValueTypes["ItemFlavorCategoryUpdateResult"]],
upsertItemFlavorCategory?: [{	by:ValueTypes["ItemFlavorCategoryUniqueWhere"],	filter?:ValueTypes["ItemFlavorCategoryWhere"] | null,	update:ValueTypes["ItemFlavorCategoryUpdateInput"],	create:ValueTypes["ItemFlavorCategoryCreateInput"]},ValueTypes["ItemFlavorCategoryUpsertResult"]],
createItemDeclensionFourthVariant?: [{	data:ValueTypes["ItemDeclensionFourthVariantCreateInput"]},ValueTypes["ItemDeclensionFourthVariantCreateResult"]],
deleteItemDeclensionFourthVariant?: [{	by:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null},ValueTypes["ItemDeclensionFourthVariantDeleteResult"]],
updateItemDeclensionFourthVariant?: [{	by:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,	data:ValueTypes["ItemDeclensionFourthVariantUpdateInput"]},ValueTypes["ItemDeclensionFourthVariantUpdateResult"]],
upsertItemDeclensionFourthVariant?: [{	by:ValueTypes["ItemDeclensionFourthVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionFourthVariantWhere"] | null,	update:ValueTypes["ItemDeclensionFourthVariantUpdateInput"],	create:ValueTypes["ItemDeclensionFourthVariantCreateInput"]},ValueTypes["ItemDeclensionFourthVariantUpsertResult"]],
createItemDeclensionSeventhVariant?: [{	data:ValueTypes["ItemDeclensionSeventhVariantCreateInput"]},ValueTypes["ItemDeclensionSeventhVariantCreateResult"]],
deleteItemDeclensionSeventhVariant?: [{	by:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null},ValueTypes["ItemDeclensionSeventhVariantDeleteResult"]],
updateItemDeclensionSeventhVariant?: [{	by:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null,	data:ValueTypes["ItemDeclensionSeventhVariantUpdateInput"]},ValueTypes["ItemDeclensionSeventhVariantUpdateResult"]],
upsertItemDeclensionSeventhVariant?: [{	by:ValueTypes["ItemDeclensionSeventhVariantUniqueWhere"],	filter?:ValueTypes["ItemDeclensionSeventhVariantWhere"] | null,	update:ValueTypes["ItemDeclensionSeventhVariantUpdateInput"],	create:ValueTypes["ItemDeclensionSeventhVariantCreateInput"]},ValueTypes["ItemDeclensionSeventhVariantUpsertResult"]],
createMediaCard?: [{	data:ValueTypes["MediaCardCreateInput"]},ValueTypes["MediaCardCreateResult"]],
deleteMediaCard?: [{	by:ValueTypes["MediaCardUniqueWhere"],	filter?:ValueTypes["MediaCardWhere"] | null},ValueTypes["MediaCardDeleteResult"]],
updateMediaCard?: [{	by:ValueTypes["MediaCardUniqueWhere"],	filter?:ValueTypes["MediaCardWhere"] | null,	data:ValueTypes["MediaCardUpdateInput"]},ValueTypes["MediaCardUpdateResult"]],
upsertMediaCard?: [{	by:ValueTypes["MediaCardUniqueWhere"],	filter?:ValueTypes["MediaCardWhere"] | null,	update:ValueTypes["MediaCardUpdateInput"],	create:ValueTypes["MediaCardCreateInput"]},ValueTypes["MediaCardUpsertResult"]],
createInfoCard?: [{	data:ValueTypes["InfoCardCreateInput"]},ValueTypes["InfoCardCreateResult"]],
deleteInfoCard?: [{	by:ValueTypes["InfoCardUniqueWhere"],	filter?:ValueTypes["InfoCardWhere"] | null},ValueTypes["InfoCardDeleteResult"]],
updateInfoCard?: [{	by:ValueTypes["InfoCardUniqueWhere"],	filter?:ValueTypes["InfoCardWhere"] | null,	data:ValueTypes["InfoCardUpdateInput"]},ValueTypes["InfoCardUpdateResult"]],
upsertInfoCard?: [{	by:ValueTypes["InfoCardUniqueWhere"],	filter?:ValueTypes["InfoCardWhere"] | null,	update:ValueTypes["InfoCardUpdateInput"],	create:ValueTypes["InfoCardCreateInput"]},ValueTypes["InfoCardUpsertResult"]],
createNumberedCard?: [{	data:ValueTypes["NumberedCardCreateInput"]},ValueTypes["NumberedCardCreateResult"]],
deleteNumberedCard?: [{	by:ValueTypes["NumberedCardUniqueWhere"],	filter?:ValueTypes["NumberedCardWhere"] | null},ValueTypes["NumberedCardDeleteResult"]],
updateNumberedCard?: [{	by:ValueTypes["NumberedCardUniqueWhere"],	filter?:ValueTypes["NumberedCardWhere"] | null,	data:ValueTypes["NumberedCardUpdateInput"]},ValueTypes["NumberedCardUpdateResult"]],
upsertNumberedCard?: [{	by:ValueTypes["NumberedCardUniqueWhere"],	filter?:ValueTypes["NumberedCardWhere"] | null,	update:ValueTypes["NumberedCardUpdateInput"],	create:ValueTypes["NumberedCardCreateInput"]},ValueTypes["NumberedCardUpsertResult"]],
createRegisterClaim?: [{	data:ValueTypes["RegisterClaimCreateInput"]},ValueTypes["RegisterClaimCreateResult"]],
deleteRegisterClaim?: [{	by:ValueTypes["RegisterClaimUniqueWhere"],	filter?:ValueTypes["RegisterClaimWhere"] | null},ValueTypes["RegisterClaimDeleteResult"]],
updateRegisterClaim?: [{	by:ValueTypes["RegisterClaimUniqueWhere"],	filter?:ValueTypes["RegisterClaimWhere"] | null,	data:ValueTypes["RegisterClaimUpdateInput"]},ValueTypes["RegisterClaimUpdateResult"]],
upsertRegisterClaim?: [{	by:ValueTypes["RegisterClaimUniqueWhere"],	filter?:ValueTypes["RegisterClaimWhere"] | null,	update:ValueTypes["RegisterClaimUpdateInput"],	create:ValueTypes["RegisterClaimCreateInput"]},ValueTypes["RegisterClaimUpsertResult"]],
createBlogPostReviewReaction?: [{	data:ValueTypes["BlogPostReviewReactionCreateInput"]},ValueTypes["BlogPostReviewReactionCreateResult"]],
deleteBlogPostReviewReaction?: [{	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null},ValueTypes["BlogPostReviewReactionDeleteResult"]],
updateBlogPostReviewReaction?: [{	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null,	data:ValueTypes["BlogPostReviewReactionUpdateInput"]},ValueTypes["BlogPostReviewReactionUpdateResult"]],
upsertBlogPostReviewReaction?: [{	by:ValueTypes["BlogPostReviewReactionUniqueWhere"],	filter?:ValueTypes["BlogPostReviewReactionWhere"] | null,	update:ValueTypes["BlogPostReviewReactionUpdateInput"],	create:ValueTypes["BlogPostReviewReactionCreateInput"]},ValueTypes["BlogPostReviewReactionUpsertResult"]],
createProductReviewReaction?: [{	data:ValueTypes["ProductReviewReactionCreateInput"]},ValueTypes["ProductReviewReactionCreateResult"]],
deleteProductReviewReaction?: [{	by:ValueTypes["ProductReviewReactionUniqueWhere"],	filter?:ValueTypes["ProductReviewReactionWhere"] | null},ValueTypes["ProductReviewReactionDeleteResult"]],
updateProductReviewReaction?: [{	by:ValueTypes["ProductReviewReactionUniqueWhere"],	filter?:ValueTypes["ProductReviewReactionWhere"] | null,	data:ValueTypes["ProductReviewReactionUpdateInput"]},ValueTypes["ProductReviewReactionUpdateResult"]],
upsertProductReviewReaction?: [{	by:ValueTypes["ProductReviewReactionUniqueWhere"],	filter?:ValueTypes["ProductReviewReactionWhere"] | null,	update:ValueTypes["ProductReviewReactionUpdateInput"],	create:ValueTypes["ProductReviewReactionCreateInput"]},ValueTypes["ProductReviewReactionUpsertResult"]],
createProductPackage?: [{	data:ValueTypes["ProductPackageCreateInput"]},ValueTypes["ProductPackageCreateResult"]],
deleteProductPackage?: [{	by:ValueTypes["ProductPackageUniqueWhere"],	filter?:ValueTypes["ProductPackageWhere"] | null},ValueTypes["ProductPackageDeleteResult"]],
updateProductPackage?: [{	by:ValueTypes["ProductPackageUniqueWhere"],	filter?:ValueTypes["ProductPackageWhere"] | null,	data:ValueTypes["ProductPackageUpdateInput"]},ValueTypes["ProductPackageUpdateResult"]],
upsertProductPackage?: [{	by:ValueTypes["ProductPackageUniqueWhere"],	filter?:ValueTypes["ProductPackageWhere"] | null,	update:ValueTypes["ProductPackageUpdateInput"],	create:ValueTypes["ProductPackageCreateInput"]},ValueTypes["ProductPackageUpsertResult"]],
createBrandManufacturer?: [{	data:ValueTypes["BrandManufacturerCreateInput"]},ValueTypes["BrandManufacturerCreateResult"]],
deleteBrandManufacturer?: [{	by:ValueTypes["BrandManufacturerUniqueWhere"],	filter?:ValueTypes["BrandManufacturerWhere"] | null},ValueTypes["BrandManufacturerDeleteResult"]],
updateBrandManufacturer?: [{	by:ValueTypes["BrandManufacturerUniqueWhere"],	filter?:ValueTypes["BrandManufacturerWhere"] | null,	data:ValueTypes["BrandManufacturerUpdateInput"]},ValueTypes["BrandManufacturerUpdateResult"]],
upsertBrandManufacturer?: [{	by:ValueTypes["BrandManufacturerUniqueWhere"],	filter?:ValueTypes["BrandManufacturerWhere"] | null,	update:ValueTypes["BrandManufacturerUpdateInput"],	create:ValueTypes["BrandManufacturerCreateInput"]},ValueTypes["BrandManufacturerUpsertResult"]],
createElement?: [{	data:ValueTypes["ElementCreateInput"]},ValueTypes["ElementCreateResult"]],
deleteElement?: [{	by:ValueTypes["ElementUniqueWhere"],	filter?:ValueTypes["ElementWhere"] | null},ValueTypes["ElementDeleteResult"]],
updateElement?: [{	by:ValueTypes["ElementUniqueWhere"],	filter?:ValueTypes["ElementWhere"] | null,	data:ValueTypes["ElementUpdateInput"]},ValueTypes["ElementUpdateResult"]],
upsertElement?: [{	by:ValueTypes["ElementUniqueWhere"],	filter?:ValueTypes["ElementWhere"] | null,	update:ValueTypes["ElementUpdateInput"],	create:ValueTypes["ElementCreateInput"]},ValueTypes["ElementUpsertResult"]],
createElementOfProduct?: [{	data:ValueTypes["ElementOfProductCreateInput"]},ValueTypes["ElementOfProductCreateResult"]],
deleteElementOfProduct?: [{	by:ValueTypes["ElementOfProductUniqueWhere"],	filter?:ValueTypes["ElementOfProductWhere"] | null},ValueTypes["ElementOfProductDeleteResult"]],
updateElementOfProduct?: [{	by:ValueTypes["ElementOfProductUniqueWhere"],	filter?:ValueTypes["ElementOfProductWhere"] | null,	data:ValueTypes["ElementOfProductUpdateInput"]},ValueTypes["ElementOfProductUpdateResult"]],
upsertElementOfProduct?: [{	by:ValueTypes["ElementOfProductUniqueWhere"],	filter?:ValueTypes["ElementOfProductWhere"] | null,	update:ValueTypes["ElementOfProductUpdateInput"],	create:ValueTypes["ElementOfProductCreateInput"]},ValueTypes["ElementOfProductUpsertResult"]],
createSuitabilityCategory?: [{	data:ValueTypes["SuitabilityCategoryCreateInput"]},ValueTypes["SuitabilityCategoryCreateResult"]],
deleteSuitabilityCategory?: [{	by:ValueTypes["SuitabilityCategoryUniqueWhere"],	filter?:ValueTypes["SuitabilityCategoryWhere"] | null},ValueTypes["SuitabilityCategoryDeleteResult"]],
updateSuitabilityCategory?: [{	by:ValueTypes["SuitabilityCategoryUniqueWhere"],	filter?:ValueTypes["SuitabilityCategoryWhere"] | null,	data:ValueTypes["SuitabilityCategoryUpdateInput"]},ValueTypes["SuitabilityCategoryUpdateResult"]],
upsertSuitabilityCategory?: [{	by:ValueTypes["SuitabilityCategoryUniqueWhere"],	filter?:ValueTypes["SuitabilityCategoryWhere"] | null,	update:ValueTypes["SuitabilityCategoryUpdateInput"],	create:ValueTypes["SuitabilityCategoryCreateInput"]},ValueTypes["SuitabilityCategoryUpsertResult"]],
createProductFeature?: [{	data:ValueTypes["ProductFeatureCreateInput"]},ValueTypes["ProductFeatureCreateResult"]],
deleteProductFeature?: [{	by:ValueTypes["ProductFeatureUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null},ValueTypes["ProductFeatureDeleteResult"]],
updateProductFeature?: [{	by:ValueTypes["ProductFeatureUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null,	data:ValueTypes["ProductFeatureUpdateInput"]},ValueTypes["ProductFeatureUpdateResult"]],
upsertProductFeature?: [{	by:ValueTypes["ProductFeatureUniqueWhere"],	filter?:ValueTypes["ProductFeatureWhere"] | null,	update:ValueTypes["ProductFeatureUpdateInput"],	create:ValueTypes["ProductFeatureCreateInput"]},ValueTypes["ProductFeatureUpsertResult"]],
createSuitabilityItem?: [{	data:ValueTypes["SuitabilityItemCreateInput"]},ValueTypes["SuitabilityItemCreateResult"]],
deleteSuitabilityItem?: [{	by:ValueTypes["SuitabilityItemUniqueWhere"],	filter?:ValueTypes["SuitabilityItemWhere"] | null},ValueTypes["SuitabilityItemDeleteResult"]],
updateSuitabilityItem?: [{	by:ValueTypes["SuitabilityItemUniqueWhere"],	filter?:ValueTypes["SuitabilityItemWhere"] | null,	data:ValueTypes["SuitabilityItemUpdateInput"]},ValueTypes["SuitabilityItemUpdateResult"]],
upsertSuitabilityItem?: [{	by:ValueTypes["SuitabilityItemUniqueWhere"],	filter?:ValueTypes["SuitabilityItemWhere"] | null,	update:ValueTypes["SuitabilityItemUpdateInput"],	create:ValueTypes["SuitabilityItemCreateInput"]},ValueTypes["SuitabilityItemUpsertResult"]],
createRegion?: [{	data:ValueTypes["RegionCreateInput"]},ValueTypes["RegionCreateResult"]],
deleteRegion?: [{	by:ValueTypes["RegionUniqueWhere"],	filter?:ValueTypes["RegionWhere"] | null},ValueTypes["RegionDeleteResult"]],
updateRegion?: [{	by:ValueTypes["RegionUniqueWhere"],	filter?:ValueTypes["RegionWhere"] | null,	data:ValueTypes["RegionUpdateInput"]},ValueTypes["RegionUpdateResult"]],
upsertRegion?: [{	by:ValueTypes["RegionUniqueWhere"],	filter?:ValueTypes["RegionWhere"] | null,	update:ValueTypes["RegionUpdateInput"],	create:ValueTypes["RegionCreateInput"]},ValueTypes["RegionUpsertResult"]],
createGranuleSize?: [{	data:ValueTypes["GranuleSizeCreateInput"]},ValueTypes["GranuleSizeCreateResult"]],
deleteGranuleSize?: [{	by:ValueTypes["GranuleSizeUniqueWhere"],	filter?:ValueTypes["GranuleSizeWhere"] | null},ValueTypes["GranuleSizeDeleteResult"]],
updateGranuleSize?: [{	by:ValueTypes["GranuleSizeUniqueWhere"],	filter?:ValueTypes["GranuleSizeWhere"] | null,	data:ValueTypes["GranuleSizeUpdateInput"]},ValueTypes["GranuleSizeUpdateResult"]],
upsertGranuleSize?: [{	by:ValueTypes["GranuleSizeUniqueWhere"],	filter?:ValueTypes["GranuleSizeWhere"] | null,	update:ValueTypes["GranuleSizeUpdateInput"],	create:ValueTypes["GranuleSizeCreateInput"]},ValueTypes["GranuleSizeUpsertResult"]],
createItemAlias?: [{	data:ValueTypes["ItemAliasCreateInput"]},ValueTypes["ItemAliasCreateResult"]],
deleteItemAlias?: [{	by:ValueTypes["ItemAliasUniqueWhere"],	filter?:ValueTypes["ItemAliasWhere"] | null},ValueTypes["ItemAliasDeleteResult"]],
updateItemAlias?: [{	by:ValueTypes["ItemAliasUniqueWhere"],	filter?:ValueTypes["ItemAliasWhere"] | null,	data:ValueTypes["ItemAliasUpdateInput"]},ValueTypes["ItemAliasUpdateResult"]],
upsertItemAlias?: [{	by:ValueTypes["ItemAliasUniqueWhere"],	filter?:ValueTypes["ItemAliasWhere"] | null,	update:ValueTypes["ItemAliasUpdateInput"],	create:ValueTypes["ItemAliasCreateInput"]},ValueTypes["ItemAliasUpsertResult"]],
createSemanticKey?: [{	data:ValueTypes["SemanticKeyCreateInput"]},ValueTypes["SemanticKeyCreateResult"]],
deleteSemanticKey?: [{	by:ValueTypes["SemanticKeyUniqueWhere"],	filter?:ValueTypes["SemanticKeyWhere"] | null},ValueTypes["SemanticKeyDeleteResult"]],
updateSemanticKey?: [{	by:ValueTypes["SemanticKeyUniqueWhere"],	filter?:ValueTypes["SemanticKeyWhere"] | null,	data:ValueTypes["SemanticKeyUpdateInput"]},ValueTypes["SemanticKeyUpdateResult"]],
upsertSemanticKey?: [{	by:ValueTypes["SemanticKeyUniqueWhere"],	filter?:ValueTypes["SemanticKeyWhere"] | null,	update:ValueTypes["SemanticKeyUpdateInput"],	create:ValueTypes["SemanticKeyCreateInput"]},ValueTypes["SemanticKeyUpsertResult"]],
createProductFlag?: [{	data:ValueTypes["ProductFlagCreateInput"]},ValueTypes["ProductFlagCreateResult"]],
deleteProductFlag?: [{	by:ValueTypes["ProductFlagUniqueWhere"],	filter?:ValueTypes["ProductFlagWhere"] | null},ValueTypes["ProductFlagDeleteResult"]],
updateProductFlag?: [{	by:ValueTypes["ProductFlagUniqueWhere"],	filter?:ValueTypes["ProductFlagWhere"] | null,	data:ValueTypes["ProductFlagUpdateInput"]},ValueTypes["ProductFlagUpdateResult"]],
upsertProductFlag?: [{	by:ValueTypes["ProductFlagUniqueWhere"],	filter?:ValueTypes["ProductFlagWhere"] | null,	update:ValueTypes["ProductFlagUpdateInput"],	create:ValueTypes["ProductFlagCreateInput"]},ValueTypes["ProductFlagUpsertResult"]],
createProductFlagOfProduct?: [{	data:ValueTypes["ProductFlagOfProductCreateInput"]},ValueTypes["ProductFlagOfProductCreateResult"]],
deleteProductFlagOfProduct?: [{	by:ValueTypes["ProductFlagOfProductUniqueWhere"],	filter?:ValueTypes["ProductFlagOfProductWhere"] | null},ValueTypes["ProductFlagOfProductDeleteResult"]],
updateProductFlagOfProduct?: [{	by:ValueTypes["ProductFlagOfProductUniqueWhere"],	filter?:ValueTypes["ProductFlagOfProductWhere"] | null,	data:ValueTypes["ProductFlagOfProductUpdateInput"]},ValueTypes["ProductFlagOfProductUpdateResult"]],
upsertProductFlagOfProduct?: [{	by:ValueTypes["ProductFlagOfProductUniqueWhere"],	filter?:ValueTypes["ProductFlagOfProductWhere"] | null,	update:ValueTypes["ProductFlagOfProductUpdateInput"],	create:ValueTypes["ProductFlagOfProductCreateInput"]},ValueTypes["ProductFlagOfProductUpsertResult"]],
createProductEvaluation?: [{	data:ValueTypes["ProductEvaluationCreateInput"]},ValueTypes["ProductEvaluationCreateResult"]],
deleteProductEvaluation?: [{	by:ValueTypes["ProductEvaluationUniqueWhere"],	filter?:ValueTypes["ProductEvaluationWhere"] | null},ValueTypes["ProductEvaluationDeleteResult"]],
updateProductEvaluation?: [{	by:ValueTypes["ProductEvaluationUniqueWhere"],	filter?:ValueTypes["ProductEvaluationWhere"] | null,	data:ValueTypes["ProductEvaluationUpdateInput"]},ValueTypes["ProductEvaluationUpdateResult"]],
upsertProductEvaluation?: [{	by:ValueTypes["ProductEvaluationUniqueWhere"],	filter?:ValueTypes["ProductEvaluationWhere"] | null,	update:ValueTypes["ProductEvaluationUpdateInput"],	create:ValueTypes["ProductEvaluationCreateInput"]},ValueTypes["ProductEvaluationUpsertResult"]],
createAd?: [{	data:ValueTypes["AdCreateInput"]},ValueTypes["AdCreateResult"]],
deleteAd?: [{	by:ValueTypes["AdUniqueWhere"],	filter?:ValueTypes["AdWhere"] | null},ValueTypes["AdDeleteResult"]],
updateAd?: [{	by:ValueTypes["AdUniqueWhere"],	filter?:ValueTypes["AdWhere"] | null,	data:ValueTypes["AdUpdateInput"]},ValueTypes["AdUpdateResult"]],
upsertAd?: [{	by:ValueTypes["AdUniqueWhere"],	filter?:ValueTypes["AdWhere"] | null,	update:ValueTypes["AdUpdateInput"],	create:ValueTypes["AdCreateInput"]},ValueTypes["AdUpsertResult"]],
createEvaluationInfo?: [{	data:ValueTypes["EvaluationInfoCreateInput"]},ValueTypes["EvaluationInfoCreateResult"]],
deleteEvaluationInfo?: [{	by:ValueTypes["EvaluationInfoUniqueWhere"],	filter?:ValueTypes["EvaluationInfoWhere"] | null},ValueTypes["EvaluationInfoDeleteResult"]],
updateEvaluationInfo?: [{	by:ValueTypes["EvaluationInfoUniqueWhere"],	filter?:ValueTypes["EvaluationInfoWhere"] | null,	data:ValueTypes["EvaluationInfoUpdateInput"]},ValueTypes["EvaluationInfoUpdateResult"]],
upsertEvaluationInfo?: [{	by:ValueTypes["EvaluationInfoUniqueWhere"],	filter?:ValueTypes["EvaluationInfoWhere"] | null,	update:ValueTypes["EvaluationInfoUpdateInput"],	create:ValueTypes["EvaluationInfoCreateInput"]},ValueTypes["EvaluationInfoUpsertResult"]],
createConsumptionMessage?: [{	data:ValueTypes["ConsumptionMessageCreateInput"]},ValueTypes["ConsumptionMessageCreateResult"]],
deleteConsumptionMessage?: [{	by:ValueTypes["ConsumptionMessageUniqueWhere"],	filter?:ValueTypes["ConsumptionMessageWhere"] | null},ValueTypes["ConsumptionMessageDeleteResult"]],
updateConsumptionMessage?: [{	by:ValueTypes["ConsumptionMessageUniqueWhere"],	filter?:ValueTypes["ConsumptionMessageWhere"] | null,	data:ValueTypes["ConsumptionMessageUpdateInput"]},ValueTypes["ConsumptionMessageUpdateResult"]],
upsertConsumptionMessage?: [{	by:ValueTypes["ConsumptionMessageUniqueWhere"],	filter?:ValueTypes["ConsumptionMessageWhere"] | null,	update:ValueTypes["ConsumptionMessageUpdateInput"],	create:ValueTypes["ConsumptionMessageCreateInput"]},ValueTypes["ConsumptionMessageUpsertResult"]],
createContentText?: [{	data:ValueTypes["ContentTextCreateInput"]},ValueTypes["ContentTextCreateResult"]],
deleteContentText?: [{	by:ValueTypes["ContentTextUniqueWhere"],	filter?:ValueTypes["ContentTextWhere"] | null},ValueTypes["ContentTextDeleteResult"]],
updateContentText?: [{	by:ValueTypes["ContentTextUniqueWhere"],	filter?:ValueTypes["ContentTextWhere"] | null,	data:ValueTypes["ContentTextUpdateInput"]},ValueTypes["ContentTextUpdateResult"]],
upsertContentText?: [{	by:ValueTypes["ContentTextUniqueWhere"],	filter?:ValueTypes["ContentTextWhere"] | null,	update:ValueTypes["ContentTextUpdateInput"],	create:ValueTypes["ContentTextCreateInput"]},ValueTypes["ContentTextUpsertResult"]],
createContentTextBlock?: [{	data:ValueTypes["ContentTextBlockCreateInput"]},ValueTypes["ContentTextBlockCreateResult"]],
deleteContentTextBlock?: [{	by:ValueTypes["ContentTextBlockUniqueWhere"],	filter?:ValueTypes["ContentTextBlockWhere"] | null},ValueTypes["ContentTextBlockDeleteResult"]],
updateContentTextBlock?: [{	by:ValueTypes["ContentTextBlockUniqueWhere"],	filter?:ValueTypes["ContentTextBlockWhere"] | null,	data:ValueTypes["ContentTextBlockUpdateInput"]},ValueTypes["ContentTextBlockUpdateResult"]],
upsertContentTextBlock?: [{	by:ValueTypes["ContentTextBlockUniqueWhere"],	filter?:ValueTypes["ContentTextBlockWhere"] | null,	update:ValueTypes["ContentTextBlockUpdateInput"],	create:ValueTypes["ContentTextBlockCreateInput"]},ValueTypes["ContentTextBlockUpsertResult"]],
createComparatorPage?: [{	data:ValueTypes["ComparatorPageCreateInput"]},ValueTypes["ComparatorPageCreateResult"]],
deleteComparatorPage?: [{	by:ValueTypes["ComparatorPageUniqueWhere"],	filter?:ValueTypes["ComparatorPageWhere"] | null},ValueTypes["ComparatorPageDeleteResult"]],
updateComparatorPage?: [{	by:ValueTypes["ComparatorPageUniqueWhere"],	filter?:ValueTypes["ComparatorPageWhere"] | null,	data:ValueTypes["ComparatorPageUpdateInput"]},ValueTypes["ComparatorPageUpdateResult"]],
upsertComparatorPage?: [{	by:ValueTypes["ComparatorPageUniqueWhere"],	filter?:ValueTypes["ComparatorPageWhere"] | null,	update:ValueTypes["ComparatorPageUpdateInput"],	create:ValueTypes["ComparatorPageCreateInput"]},ValueTypes["ComparatorPageUpsertResult"]],
createLoginPage?: [{	data:ValueTypes["LoginPageCreateInput"]},ValueTypes["LoginPageCreateResult"]],
deleteLoginPage?: [{	by:ValueTypes["LoginPageUniqueWhere"],	filter?:ValueTypes["LoginPageWhere"] | null},ValueTypes["LoginPageDeleteResult"]],
updateLoginPage?: [{	by:ValueTypes["LoginPageUniqueWhere"],	filter?:ValueTypes["LoginPageWhere"] | null,	data:ValueTypes["LoginPageUpdateInput"]},ValueTypes["LoginPageUpdateResult"]],
upsertLoginPage?: [{	by:ValueTypes["LoginPageUniqueWhere"],	filter?:ValueTypes["LoginPageWhere"] | null,	update:ValueTypes["LoginPageUpdateInput"],	create:ValueTypes["LoginPageCreateInput"]},ValueTypes["LoginPageUpsertResult"]],
createRegisterPage?: [{	data:ValueTypes["RegisterPageCreateInput"]},ValueTypes["RegisterPageCreateResult"]],
deleteRegisterPage?: [{	by:ValueTypes["RegisterPageUniqueWhere"],	filter?:ValueTypes["RegisterPageWhere"] | null},ValueTypes["RegisterPageDeleteResult"]],
updateRegisterPage?: [{	by:ValueTypes["RegisterPageUniqueWhere"],	filter?:ValueTypes["RegisterPageWhere"] | null,	data:ValueTypes["RegisterPageUpdateInput"]},ValueTypes["RegisterPageUpdateResult"]],
upsertRegisterPage?: [{	by:ValueTypes["RegisterPageUniqueWhere"],	filter?:ValueTypes["RegisterPageWhere"] | null,	update:ValueTypes["RegisterPageUpdateInput"],	create:ValueTypes["RegisterPageCreateInput"]},ValueTypes["RegisterPageUpsertResult"]],
createResultsPage?: [{	data:ValueTypes["ResultsPageCreateInput"]},ValueTypes["ResultsPageCreateResult"]],
deleteResultsPage?: [{	by:ValueTypes["ResultsPageUniqueWhere"],	filter?:ValueTypes["ResultsPageWhere"] | null},ValueTypes["ResultsPageDeleteResult"]],
updateResultsPage?: [{	by:ValueTypes["ResultsPageUniqueWhere"],	filter?:ValueTypes["ResultsPageWhere"] | null,	data:ValueTypes["ResultsPageUpdateInput"]},ValueTypes["ResultsPageUpdateResult"]],
upsertResultsPage?: [{	by:ValueTypes["ResultsPageUniqueWhere"],	filter?:ValueTypes["ResultsPageWhere"] | null,	update:ValueTypes["ResultsPageUpdateInput"],	create:ValueTypes["ResultsPageCreateInput"]},ValueTypes["ResultsPageUpsertResult"]],
createSearchPage?: [{	data:ValueTypes["SearchPageCreateInput"]},ValueTypes["SearchPageCreateResult"]],
deleteSearchPage?: [{	by:ValueTypes["SearchPageUniqueWhere"],	filter?:ValueTypes["SearchPageWhere"] | null},ValueTypes["SearchPageDeleteResult"]],
updateSearchPage?: [{	by:ValueTypes["SearchPageUniqueWhere"],	filter?:ValueTypes["SearchPageWhere"] | null,	data:ValueTypes["SearchPageUpdateInput"]},ValueTypes["SearchPageUpdateResult"]],
upsertSearchPage?: [{	by:ValueTypes["SearchPageUniqueWhere"],	filter?:ValueTypes["SearchPageWhere"] | null,	update:ValueTypes["SearchPageUpdateInput"],	create:ValueTypes["SearchPageCreateInput"]},ValueTypes["SearchPageUpsertResult"]],
createWizardPage?: [{	data:ValueTypes["WizardPageCreateInput"]},ValueTypes["WizardPageCreateResult"]],
deleteWizardPage?: [{	by:ValueTypes["WizardPageUniqueWhere"],	filter?:ValueTypes["WizardPageWhere"] | null},ValueTypes["WizardPageDeleteResult"]],
updateWizardPage?: [{	by:ValueTypes["WizardPageUniqueWhere"],	filter?:ValueTypes["WizardPageWhere"] | null,	data:ValueTypes["WizardPageUpdateInput"]},ValueTypes["WizardPageUpdateResult"]],
upsertWizardPage?: [{	by:ValueTypes["WizardPageUniqueWhere"],	filter?:ValueTypes["WizardPageWhere"] | null,	update:ValueTypes["WizardPageUpdateInput"],	create:ValueTypes["WizardPageCreateInput"]},ValueTypes["WizardPageUpsertResult"]],
createBreastfeedingCategory?: [{	data:ValueTypes["BreastfeedingCategoryCreateInput"]},ValueTypes["BreastfeedingCategoryCreateResult"]],
deleteBreastfeedingCategory?: [{	by:ValueTypes["BreastfeedingCategoryUniqueWhere"],	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null},ValueTypes["BreastfeedingCategoryDeleteResult"]],
updateBreastfeedingCategory?: [{	by:ValueTypes["BreastfeedingCategoryUniqueWhere"],	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null,	data:ValueTypes["BreastfeedingCategoryUpdateInput"]},ValueTypes["BreastfeedingCategoryUpdateResult"]],
upsertBreastfeedingCategory?: [{	by:ValueTypes["BreastfeedingCategoryUniqueWhere"],	filter?:ValueTypes["BreastfeedingCategoryWhere"] | null,	update:ValueTypes["BreastfeedingCategoryUpdateInput"],	create:ValueTypes["BreastfeedingCategoryCreateInput"]},ValueTypes["BreastfeedingCategoryUpsertResult"]],
createDogReproduction?: [{	data:ValueTypes["DogReproductionCreateInput"]},ValueTypes["DogReproductionCreateResult"]],
deleteDogReproduction?: [{	by:ValueTypes["DogReproductionUniqueWhere"],	filter?:ValueTypes["DogReproductionWhere"] | null},ValueTypes["DogReproductionDeleteResult"]],
updateDogReproduction?: [{	by:ValueTypes["DogReproductionUniqueWhere"],	filter?:ValueTypes["DogReproductionWhere"] | null,	data:ValueTypes["DogReproductionUpdateInput"]},ValueTypes["DogReproductionUpdateResult"]],
upsertDogReproduction?: [{	by:ValueTypes["DogReproductionUniqueWhere"],	filter?:ValueTypes["DogReproductionWhere"] | null,	update:ValueTypes["DogReproductionUpdateInput"],	create:ValueTypes["DogReproductionCreateInput"]},ValueTypes["DogReproductionUpsertResult"]],
createContactFormMessage?: [{	data:ValueTypes["ContactFormMessageCreateInput"]},ValueTypes["ContactFormMessageCreateResult"]],
deleteContactFormMessage?: [{	by:ValueTypes["ContactFormMessageUniqueWhere"],	filter?:ValueTypes["ContactFormMessageWhere"] | null},ValueTypes["ContactFormMessageDeleteResult"]],
updateContactFormMessage?: [{	by:ValueTypes["ContactFormMessageUniqueWhere"],	filter?:ValueTypes["ContactFormMessageWhere"] | null,	data:ValueTypes["ContactFormMessageUpdateInput"]},ValueTypes["ContactFormMessageUpdateResult"]],
upsertContactFormMessage?: [{	by:ValueTypes["ContactFormMessageUniqueWhere"],	filter?:ValueTypes["ContactFormMessageWhere"] | null,	update:ValueTypes["ContactFormMessageUpdateInput"],	create:ValueTypes["ContactFormMessageCreateInput"]},ValueTypes["ContactFormMessageUpsertResult"]],
createContactPage?: [{	data:ValueTypes["ContactPageCreateInput"]},ValueTypes["ContactPageCreateResult"]],
deleteContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null},ValueTypes["ContactPageDeleteResult"]],
updateContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null,	data:ValueTypes["ContactPageUpdateInput"]},ValueTypes["ContactPageUpdateResult"]],
upsertContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null,	update:ValueTypes["ContactPageUpdateInput"],	create:ValueTypes["ContactPageCreateInput"]},ValueTypes["ContactPageUpsertResult"]],
createBugReport?: [{	data:ValueTypes["BugReportCreateInput"]},ValueTypes["BugReportCreateResult"]],
deleteBugReport?: [{	by:ValueTypes["BugReportUniqueWhere"],	filter?:ValueTypes["BugReportWhere"] | null},ValueTypes["BugReportDeleteResult"]],
updateBugReport?: [{	by:ValueTypes["BugReportUniqueWhere"],	filter?:ValueTypes["BugReportWhere"] | null,	data:ValueTypes["BugReportUpdateInput"]},ValueTypes["BugReportUpdateResult"]],
upsertBugReport?: [{	by:ValueTypes["BugReportUniqueWhere"],	filter?:ValueTypes["BugReportWhere"] | null,	update:ValueTypes["BugReportUpdateInput"],	create:ValueTypes["BugReportCreateInput"]},ValueTypes["BugReportUpsertResult"]],
createColor?: [{	data:ValueTypes["ColorCreateInput"]},ValueTypes["ColorCreateResult"]],
deleteColor?: [{	by:ValueTypes["ColorUniqueWhere"],	filter?:ValueTypes["ColorWhere"] | null},ValueTypes["ColorDeleteResult"]],
updateColor?: [{	by:ValueTypes["ColorUniqueWhere"],	filter?:ValueTypes["ColorWhere"] | null,	data:ValueTypes["ColorUpdateInput"]},ValueTypes["ColorUpdateResult"]],
upsertColor?: [{	by:ValueTypes["ColorUniqueWhere"],	filter?:ValueTypes["ColorWhere"] | null,	update:ValueTypes["ColorUpdateInput"],	create:ValueTypes["ColorCreateInput"]},ValueTypes["ColorUpsertResult"]],
createItemGroup?: [{	data:ValueTypes["ItemGroupCreateInput"]},ValueTypes["ItemGroupCreateResult"]],
deleteItemGroup?: [{	by:ValueTypes["ItemGroupUniqueWhere"],	filter?:ValueTypes["ItemGroupWhere"] | null},ValueTypes["ItemGroupDeleteResult"]],
updateItemGroup?: [{	by:ValueTypes["ItemGroupUniqueWhere"],	filter?:ValueTypes["ItemGroupWhere"] | null,	data:ValueTypes["ItemGroupUpdateInput"]},ValueTypes["ItemGroupUpdateResult"]],
upsertItemGroup?: [{	by:ValueTypes["ItemGroupUniqueWhere"],	filter?:ValueTypes["ItemGroupWhere"] | null,	update:ValueTypes["ItemGroupUpdateInput"],	create:ValueTypes["ItemGroupCreateInput"]},ValueTypes["ItemGroupUpsertResult"]],
createProductEvaluationSummary?: [{	data:ValueTypes["ProductEvaluationSummaryCreateInput"]},ValueTypes["ProductEvaluationSummaryCreateResult"]],
deleteProductEvaluationSummary?: [{	by:ValueTypes["ProductEvaluationSummaryUniqueWhere"],	filter?:ValueTypes["ProductEvaluationSummaryWhere"] | null},ValueTypes["ProductEvaluationSummaryDeleteResult"]],
updateProductEvaluationSummary?: [{	by:ValueTypes["ProductEvaluationSummaryUniqueWhere"],	filter?:ValueTypes["ProductEvaluationSummaryWhere"] | null,	data:ValueTypes["ProductEvaluationSummaryUpdateInput"]},ValueTypes["ProductEvaluationSummaryUpdateResult"]],
upsertProductEvaluationSummary?: [{	by:ValueTypes["ProductEvaluationSummaryUniqueWhere"],	filter?:ValueTypes["ProductEvaluationSummaryWhere"] | null,	update:ValueTypes["ProductEvaluationSummaryUpdateInput"],	create:ValueTypes["ProductEvaluationSummaryCreateInput"]},ValueTypes["ProductEvaluationSummaryUpsertResult"]],
createProtectedAction?: [{	data:ValueTypes["ProtectedActionCreateInput"]},ValueTypes["ProtectedActionCreateResult"]],
deleteProtectedAction?: [{	by:ValueTypes["ProtectedActionUniqueWhere"],	filter?:ValueTypes["ProtectedActionWhere"] | null},ValueTypes["ProtectedActionDeleteResult"]],
updateProtectedAction?: [{	by:ValueTypes["ProtectedActionUniqueWhere"],	filter?:ValueTypes["ProtectedActionWhere"] | null,	data:ValueTypes["ProtectedActionUpdateInput"]},ValueTypes["ProtectedActionUpdateResult"]],
upsertProtectedAction?: [{	by:ValueTypes["ProtectedActionUniqueWhere"],	filter?:ValueTypes["ProtectedActionWhere"] | null,	update:ValueTypes["ProtectedActionUpdateInput"],	create:ValueTypes["ProtectedActionCreateInput"]},ValueTypes["ProtectedActionUpsertResult"]],
createBrandAlias?: [{	data:ValueTypes["BrandAliasCreateInput"]},ValueTypes["BrandAliasCreateResult"]],
deleteBrandAlias?: [{	by:ValueTypes["BrandAliasUniqueWhere"],	filter?:ValueTypes["BrandAliasWhere"] | null},ValueTypes["BrandAliasDeleteResult"]],
updateBrandAlias?: [{	by:ValueTypes["BrandAliasUniqueWhere"],	filter?:ValueTypes["BrandAliasWhere"] | null,	data:ValueTypes["BrandAliasUpdateInput"]},ValueTypes["BrandAliasUpdateResult"]],
upsertBrandAlias?: [{	by:ValueTypes["BrandAliasUniqueWhere"],	filter?:ValueTypes["BrandAliasWhere"] | null,	update:ValueTypes["BrandAliasUpdateInput"],	create:ValueTypes["BrandAliasCreateInput"]},ValueTypes["BrandAliasUpsertResult"]],
createProductAlias?: [{	data:ValueTypes["ProductAliasCreateInput"]},ValueTypes["ProductAliasCreateResult"]],
deleteProductAlias?: [{	by:ValueTypes["ProductAliasUniqueWhere"],	filter?:ValueTypes["ProductAliasWhere"] | null},ValueTypes["ProductAliasDeleteResult"]],
updateProductAlias?: [{	by:ValueTypes["ProductAliasUniqueWhere"],	filter?:ValueTypes["ProductAliasWhere"] | null,	data:ValueTypes["ProductAliasUpdateInput"]},ValueTypes["ProductAliasUpdateResult"]],
upsertProductAlias?: [{	by:ValueTypes["ProductAliasUniqueWhere"],	filter?:ValueTypes["ProductAliasWhere"] | null,	update:ValueTypes["ProductAliasUpdateInput"],	create:ValueTypes["ProductAliasCreateInput"]},ValueTypes["ProductAliasUpsertResult"]],
createProductLineAlias?: [{	data:ValueTypes["ProductLineAliasCreateInput"]},ValueTypes["ProductLineAliasCreateResult"]],
deleteProductLineAlias?: [{	by:ValueTypes["ProductLineAliasUniqueWhere"],	filter?:ValueTypes["ProductLineAliasWhere"] | null},ValueTypes["ProductLineAliasDeleteResult"]],
updateProductLineAlias?: [{	by:ValueTypes["ProductLineAliasUniqueWhere"],	filter?:ValueTypes["ProductLineAliasWhere"] | null,	data:ValueTypes["ProductLineAliasUpdateInput"]},ValueTypes["ProductLineAliasUpdateResult"]],
upsertProductLineAlias?: [{	by:ValueTypes["ProductLineAliasUniqueWhere"],	filter?:ValueTypes["ProductLineAliasWhere"] | null,	update:ValueTypes["ProductLineAliasUpdateInput"],	create:ValueTypes["ProductLineAliasCreateInput"]},ValueTypes["ProductLineAliasUpsertResult"]],
createGenericPage?: [{	data:ValueTypes["GenericPageCreateInput"]},ValueTypes["GenericPageCreateResult"]],
deleteGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null},ValueTypes["GenericPageDeleteResult"]],
updateGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null,	data:ValueTypes["GenericPageUpdateInput"]},ValueTypes["GenericPageUpdateResult"]],
upsertGenericPage?: [{	by:ValueTypes["GenericPageUniqueWhere"],	filter?:ValueTypes["GenericPageWhere"] | null,	update:ValueTypes["GenericPageUpdateInput"],	create:ValueTypes["GenericPageCreateInput"]},ValueTypes["GenericPageUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createContentLinks?: [{	data:ValueTypes["ContentLinksCreateInput"]},ValueTypes["ContentLinksCreateResult"]],
deleteContentLinks?: [{	by:ValueTypes["ContentLinksUniqueWhere"],	filter?:ValueTypes["ContentLinksWhere"] | null},ValueTypes["ContentLinksDeleteResult"]],
updateContentLinks?: [{	by:ValueTypes["ContentLinksUniqueWhere"],	filter?:ValueTypes["ContentLinksWhere"] | null,	data:ValueTypes["ContentLinksUpdateInput"]},ValueTypes["ContentLinksUpdateResult"]],
upsertContentLinks?: [{	by:ValueTypes["ContentLinksUniqueWhere"],	filter?:ValueTypes["ContentLinksWhere"] | null,	update:ValueTypes["ContentLinksUpdateInput"],	create:ValueTypes["ContentLinksCreateInput"]},ValueTypes["ContentLinksUpsertResult"]],
createContentLinksItem?: [{	data:ValueTypes["ContentLinksItemCreateInput"]},ValueTypes["ContentLinksItemCreateResult"]],
deleteContentLinksItem?: [{	by:ValueTypes["ContentLinksItemUniqueWhere"],	filter?:ValueTypes["ContentLinksItemWhere"] | null},ValueTypes["ContentLinksItemDeleteResult"]],
updateContentLinksItem?: [{	by:ValueTypes["ContentLinksItemUniqueWhere"],	filter?:ValueTypes["ContentLinksItemWhere"] | null,	data:ValueTypes["ContentLinksItemUpdateInput"]},ValueTypes["ContentLinksItemUpdateResult"]],
upsertContentLinksItem?: [{	by:ValueTypes["ContentLinksItemUniqueWhere"],	filter?:ValueTypes["ContentLinksItemWhere"] | null,	update:ValueTypes["ContentLinksItemUpdateInput"],	create:ValueTypes["ContentLinksItemCreateInput"]},ValueTypes["ContentLinksItemUpsertResult"]],
createRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	update:ValueTypes["RedirectUpdateInput"],	create:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
createContentReferenceImage?: [{	data:ValueTypes["ContentReferenceImageCreateInput"]},ValueTypes["ContentReferenceImageCreateResult"]],
deleteContentReferenceImage?: [{	by:ValueTypes["ContentReferenceImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceImageWhere"] | null},ValueTypes["ContentReferenceImageDeleteResult"]],
updateContentReferenceImage?: [{	by:ValueTypes["ContentReferenceImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceImageWhere"] | null,	data:ValueTypes["ContentReferenceImageUpdateInput"]},ValueTypes["ContentReferenceImageUpdateResult"]],
upsertContentReferenceImage?: [{	by:ValueTypes["ContentReferenceImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceImageWhere"] | null,	update:ValueTypes["ContentReferenceImageUpdateInput"],	create:ValueTypes["ContentReferenceImageCreateInput"]},ValueTypes["ContentReferenceImageUpsertResult"]],
createSeoData?: [{	data:ValueTypes["SeoDataCreateInput"]},ValueTypes["SeoDataCreateResult"]],
deleteSeoData?: [{	by:ValueTypes["SeoDataUniqueWhere"],	filter?:ValueTypes["SeoDataWhere"] | null},ValueTypes["SeoDataDeleteResult"]],
updateSeoData?: [{	by:ValueTypes["SeoDataUniqueWhere"],	filter?:ValueTypes["SeoDataWhere"] | null,	data:ValueTypes["SeoDataUpdateInput"]},ValueTypes["SeoDataUpdateResult"]],
upsertSeoData?: [{	by:ValueTypes["SeoDataUniqueWhere"],	filter?:ValueTypes["SeoDataWhere"] | null,	update:ValueTypes["SeoDataUpdateInput"],	create:ValueTypes["SeoDataCreateInput"]},ValueTypes["SeoDataUpsertResult"]],
createAgeCategory?: [{	data:ValueTypes["AgeCategoryCreateInput"]},ValueTypes["AgeCategoryCreateResult"]],
deleteAgeCategory?: [{	by:ValueTypes["AgeCategoryUniqueWhere"],	filter?:ValueTypes["AgeCategoryWhere"] | null},ValueTypes["AgeCategoryDeleteResult"]],
updateAgeCategory?: [{	by:ValueTypes["AgeCategoryUniqueWhere"],	filter?:ValueTypes["AgeCategoryWhere"] | null,	data:ValueTypes["AgeCategoryUpdateInput"]},ValueTypes["AgeCategoryUpdateResult"]],
upsertAgeCategory?: [{	by:ValueTypes["AgeCategoryUniqueWhere"],	filter?:ValueTypes["AgeCategoryWhere"] | null,	update:ValueTypes["AgeCategoryUpdateInput"],	create:ValueTypes["AgeCategoryCreateInput"]},ValueTypes["AgeCategoryUpsertResult"]],
createFilterCombo?: [{	data:ValueTypes["FilterComboCreateInput"]},ValueTypes["FilterComboCreateResult"]],
deleteFilterCombo?: [{	by:ValueTypes["FilterComboUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null},ValueTypes["FilterComboDeleteResult"]],
updateFilterCombo?: [{	by:ValueTypes["FilterComboUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null,	data:ValueTypes["FilterComboUpdateInput"]},ValueTypes["FilterComboUpdateResult"]],
upsertFilterCombo?: [{	by:ValueTypes["FilterComboUniqueWhere"],	filter?:ValueTypes["FilterComboWhere"] | null,	update:ValueTypes["FilterComboUpdateInput"],	create:ValueTypes["FilterComboCreateInput"]},ValueTypes["FilterComboUpsertResult"]],
createImportCache?: [{	data:ValueTypes["ImportCacheCreateInput"]},ValueTypes["ImportCacheCreateResult"]],
deleteImportCache?: [{	by:ValueTypes["ImportCacheUniqueWhere"],	filter?:ValueTypes["ImportCacheWhere"] | null},ValueTypes["ImportCacheDeleteResult"]],
updateImportCache?: [{	by:ValueTypes["ImportCacheUniqueWhere"],	filter?:ValueTypes["ImportCacheWhere"] | null,	data:ValueTypes["ImportCacheUpdateInput"]},ValueTypes["ImportCacheUpdateResult"]],
upsertImportCache?: [{	by:ValueTypes["ImportCacheUniqueWhere"],	filter?:ValueTypes["ImportCacheWhere"] | null,	update:ValueTypes["ImportCacheUpdateInput"],	create:ValueTypes["ImportCacheCreateInput"]},ValueTypes["ImportCacheUpsertResult"]],
createSite?: [{	data:ValueTypes["SiteCreateInput"]},ValueTypes["SiteCreateResult"]],
deleteSite?: [{	by:ValueTypes["SiteUniqueWhere"],	filter?:ValueTypes["SiteWhere"] | null},ValueTypes["SiteDeleteResult"]],
updateSite?: [{	by:ValueTypes["SiteUniqueWhere"],	filter?:ValueTypes["SiteWhere"] | null,	data:ValueTypes["SiteUpdateInput"]},ValueTypes["SiteUpdateResult"]],
upsertSite?: [{	by:ValueTypes["SiteUniqueWhere"],	filter?:ValueTypes["SiteWhere"] | null,	update:ValueTypes["SiteUpdateInput"],	create:ValueTypes["SiteCreateInput"]},ValueTypes["SiteUpsertResult"]],
createContactSubmission?: [{	data:ValueTypes["ContactSubmissionCreateInput"]},ValueTypes["ContactSubmissionCreateResult"]],
deleteContactSubmission?: [{	by:ValueTypes["ContactSubmissionUniqueWhere"],	filter?:ValueTypes["ContactSubmissionWhere"] | null},ValueTypes["ContactSubmissionDeleteResult"]],
updateContactSubmission?: [{	by:ValueTypes["ContactSubmissionUniqueWhere"],	filter?:ValueTypes["ContactSubmissionWhere"] | null,	data:ValueTypes["ContactSubmissionUpdateInput"]},ValueTypes["ContactSubmissionUpdateResult"]],
upsertContactSubmission?: [{	by:ValueTypes["ContactSubmissionUniqueWhere"],	filter?:ValueTypes["ContactSubmissionWhere"] | null,	update:ValueTypes["ContactSubmissionUpdateInput"],	create:ValueTypes["ContactSubmissionCreateInput"]},ValueTypes["ContactSubmissionUpsertResult"]],
createTOPXBrand?: [{	data:ValueTypes["TOPXBrandCreateInput"]},ValueTypes["TOPXBrandCreateResult"]],
deleteTOPXBrand?: [{	by:ValueTypes["TOPXBrandUniqueWhere"],	filter?:ValueTypes["TOPXBrandWhere"] | null},ValueTypes["TOPXBrandDeleteResult"]],
updateTOPXBrand?: [{	by:ValueTypes["TOPXBrandUniqueWhere"],	filter?:ValueTypes["TOPXBrandWhere"] | null,	data:ValueTypes["TOPXBrandUpdateInput"]},ValueTypes["TOPXBrandUpdateResult"]],
upsertTOPXBrand?: [{	by:ValueTypes["TOPXBrandUniqueWhere"],	filter?:ValueTypes["TOPXBrandWhere"] | null,	update:ValueTypes["TOPXBrandUpdateInput"],	create:ValueTypes["TOPXBrandCreateInput"]},ValueTypes["TOPXBrandUpsertResult"]],
createTOPXBrandCategory?: [{	data:ValueTypes["TOPXBrandCategoryCreateInput"]},ValueTypes["TOPXBrandCategoryCreateResult"]],
deleteTOPXBrandCategory?: [{	by:ValueTypes["TOPXBrandCategoryUniqueWhere"],	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null},ValueTypes["TOPXBrandCategoryDeleteResult"]],
updateTOPXBrandCategory?: [{	by:ValueTypes["TOPXBrandCategoryUniqueWhere"],	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null,	data:ValueTypes["TOPXBrandCategoryUpdateInput"]},ValueTypes["TOPXBrandCategoryUpdateResult"]],
upsertTOPXBrandCategory?: [{	by:ValueTypes["TOPXBrandCategoryUniqueWhere"],	filter?:ValueTypes["TOPXBrandCategoryWhere"] | null,	update:ValueTypes["TOPXBrandCategoryUpdateInput"],	create:ValueTypes["TOPXBrandCategoryCreateInput"]},ValueTypes["TOPXBrandCategoryUpsertResult"]],
createTOPXProduct?: [{	data:ValueTypes["TOPXProductCreateInput"]},ValueTypes["TOPXProductCreateResult"]],
deleteTOPXProduct?: [{	by:ValueTypes["TOPXProductUniqueWhere"],	filter?:ValueTypes["TOPXProductWhere"] | null},ValueTypes["TOPXProductDeleteResult"]],
updateTOPXProduct?: [{	by:ValueTypes["TOPXProductUniqueWhere"],	filter?:ValueTypes["TOPXProductWhere"] | null,	data:ValueTypes["TOPXProductUpdateInput"]},ValueTypes["TOPXProductUpdateResult"]],
upsertTOPXProduct?: [{	by:ValueTypes["TOPXProductUniqueWhere"],	filter?:ValueTypes["TOPXProductWhere"] | null,	update:ValueTypes["TOPXProductUpdateInput"],	create:ValueTypes["TOPXProductCreateInput"]},ValueTypes["TOPXProductUpsertResult"]],
createTOPXProductCategory?: [{	data:ValueTypes["TOPXProductCategoryCreateInput"]},ValueTypes["TOPXProductCategoryCreateResult"]],
deleteTOPXProductCategory?: [{	by:ValueTypes["TOPXProductCategoryUniqueWhere"],	filter?:ValueTypes["TOPXProductCategoryWhere"] | null},ValueTypes["TOPXProductCategoryDeleteResult"]],
updateTOPXProductCategory?: [{	by:ValueTypes["TOPXProductCategoryUniqueWhere"],	filter?:ValueTypes["TOPXProductCategoryWhere"] | null,	data:ValueTypes["TOPXProductCategoryUpdateInput"]},ValueTypes["TOPXProductCategoryUpdateResult"]],
upsertTOPXProductCategory?: [{	by:ValueTypes["TOPXProductCategoryUniqueWhere"],	filter?:ValueTypes["TOPXProductCategoryWhere"] | null,	update:ValueTypes["TOPXProductCategoryUpdateInput"],	create:ValueTypes["TOPXProductCategoryCreateInput"]},ValueTypes["TOPXProductCategoryUpsertResult"]],
createContentReferenceList?: [{	data:ValueTypes["ContentReferenceListCreateInput"]},ValueTypes["ContentReferenceListCreateResult"]],
deleteContentReferenceList?: [{	by:ValueTypes["ContentReferenceListUniqueWhere"],	filter?:ValueTypes["ContentReferenceListWhere"] | null},ValueTypes["ContentReferenceListDeleteResult"]],
updateContentReferenceList?: [{	by:ValueTypes["ContentReferenceListUniqueWhere"],	filter?:ValueTypes["ContentReferenceListWhere"] | null,	data:ValueTypes["ContentReferenceListUpdateInput"]},ValueTypes["ContentReferenceListUpdateResult"]],
upsertContentReferenceList?: [{	by:ValueTypes["ContentReferenceListUniqueWhere"],	filter?:ValueTypes["ContentReferenceListWhere"] | null,	update:ValueTypes["ContentReferenceListUpdateInput"],	create:ValueTypes["ContentReferenceListCreateInput"]},ValueTypes["ContentReferenceListUpsertResult"]],
	query?:ValueTypes["Query"],
		__typename?: boolean
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?:boolean | null,
	deferUniqueConstraints?:boolean | null
}
  }

export type ModelTypes = {
    ["_Column"]: {
		name:string,
	type:string,
	enumName?:string,
	defaultValue?:ModelTypes["Json"],
	nullable:boolean,
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_Field"]: ModelTypes["_Column"] | ModelTypes["_Relation"];
	["_Rule"]: {
		message?:ModelTypes["_RuleMessage"],
	validator:number
};
	["_RuleMessage"]: {
		text?:string
};
	["_Validator"]: {
		operation:string,
	arguments:ModelTypes["_Argument"][]
};
	["_Argument"]:ModelTypes["_ValidatorArgument"] | ModelTypes["_PathArgument"] | ModelTypes["_LiteralArgument"];
	["_ValidatorArgument"]: {
		validator:number
};
	["_PathArgument"]: {
		path:string[]
};
	["_LiteralArgument"]: {
		value?:ModelTypes["Json"]
};
	/** Json custom scalar type */
["Json"]:any;
	["_Relation"]: {
		name:string,
	type:string,
	side:ModelTypes["_RelationSide"],
	targetEntity:string,
	ownedBy?:string,
	inversedBy?:string,
	nullable?:boolean,
	onDelete?:ModelTypes["_OnDeleteBehaviour"],
	orphanRemoval?:boolean,
	orderBy?:ModelTypes["_OrderBy"][],
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_RelationSide"]: GraphQLTypes["_RelationSide"];
	["_OnDeleteBehaviour"]: GraphQLTypes["_OnDeleteBehaviour"];
	["_OrderBy"]: {
		path:string[],
	direction:ModelTypes["_OrderByDirection"]
};
	["_OrderByDirection"]: GraphQLTypes["_OrderByDirection"];
	["Query"]: {
		schema?:ModelTypes["_Schema"],
	s3DummyQuery?:string,
	getBlogPage?:ModelTypes["BlogPage"],
	listBlogPage:ModelTypes["BlogPage"][],
	paginateBlogPage:ModelTypes["BlogPageConnection"],
	validateCreateBlogPage:ModelTypes["_ValidationResult"],
	validateUpdateBlogPage:ModelTypes["_ValidationResult"],
	getBlogPost?:ModelTypes["BlogPost"],
	listBlogPost:ModelTypes["BlogPost"][],
	paginateBlogPost:ModelTypes["BlogPostConnection"],
	validateCreateBlogPost:ModelTypes["_ValidationResult"],
	validateUpdateBlogPost:ModelTypes["_ValidationResult"],
	getBlogPostTag?:ModelTypes["BlogPostTag"],
	listBlogPostTag:ModelTypes["BlogPostTag"][],
	paginateBlogPostTag:ModelTypes["BlogPostTagConnection"],
	validateCreateBlogPostTag:ModelTypes["_ValidationResult"],
	validateUpdateBlogPostTag:ModelTypes["_ValidationResult"],
	getBodyTag?:ModelTypes["BodyTag"],
	listBodyTag:ModelTypes["BodyTag"][],
	paginateBodyTag:ModelTypes["BodyTagConnection"],
	validateCreateBodyTag:ModelTypes["_ValidationResult"],
	validateUpdateBodyTag:ModelTypes["_ValidationResult"],
	getBodyTagCategory?:ModelTypes["BodyTagCategory"],
	listBodyTagCategory:ModelTypes["BodyTagCategory"][],
	paginateBodyTagCategory:ModelTypes["BodyTagCategoryConnection"],
	validateCreateBodyTagCategory:ModelTypes["_ValidationResult"],
	validateUpdateBodyTagCategory:ModelTypes["_ValidationResult"],
	getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getDidYouKnow?:ModelTypes["DidYouKnow"],
	listDidYouKnow:ModelTypes["DidYouKnow"][],
	paginateDidYouKnow:ModelTypes["DidYouKnowConnection"],
	validateCreateDidYouKnow:ModelTypes["_ValidationResult"],
	validateUpdateDidYouKnow:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getMedium?:ModelTypes["Medium"],
	listMedium:ModelTypes["Medium"][],
	paginateMedium:ModelTypes["MediumConnection"],
	validateCreateMedium:ModelTypes["_ValidationResult"],
	validateUpdateMedium:ModelTypes["_ValidationResult"],
	getNutritionalValue?:ModelTypes["NutritionalValue"],
	listNutritionalValue:ModelTypes["NutritionalValue"][],
	paginateNutritionalValue:ModelTypes["NutritionalValueConnection"],
	validateCreateNutritionalValue:ModelTypes["_ValidationResult"],
	validateUpdateNutritionalValue:ModelTypes["_ValidationResult"],
	getPage?:ModelTypes["Page"],
	listPage:ModelTypes["Page"][],
	paginatePage:ModelTypes["PageConnection"],
	validateCreatePage:ModelTypes["_ValidationResult"],
	validateUpdatePage:ModelTypes["_ValidationResult"],
	getReference?:ModelTypes["Reference"],
	listReference:ModelTypes["Reference"][],
	paginateReference:ModelTypes["ReferenceConnection"],
	validateCreateReference:ModelTypes["_ValidationResult"],
	validateUpdateReference:ModelTypes["_ValidationResult"],
	getReferenceList?:ModelTypes["ReferenceList"],
	listReferenceList:ModelTypes["ReferenceList"][],
	paginateReferenceList:ModelTypes["ReferenceListConnection"],
	validateCreateReferenceList:ModelTypes["_ValidationResult"],
	validateUpdateReferenceList:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getVideo?:ModelTypes["Video"],
	listVideo:ModelTypes["Video"][],
	paginateVideo:ModelTypes["VideoConnection"],
	validateCreateVideo:ModelTypes["_ValidationResult"],
	validateUpdateVideo:ModelTypes["_ValidationResult"],
	getBrand?:ModelTypes["Brand"],
	listBrand:ModelTypes["Brand"][],
	paginateBrand:ModelTypes["BrandConnection"],
	validateCreateBrand:ModelTypes["_ValidationResult"],
	validateUpdateBrand:ModelTypes["_ValidationResult"],
	getBrandDistributor?:ModelTypes["BrandDistributor"],
	listBrandDistributor:ModelTypes["BrandDistributor"][],
	paginateBrandDistributor:ModelTypes["BrandDistributorConnection"],
	validateCreateBrandDistributor:ModelTypes["_ValidationResult"],
	validateUpdateBrandDistributor:ModelTypes["_ValidationResult"],
	getDogSize?:ModelTypes["DogSize"],
	listDogSize:ModelTypes["DogSize"][],
	paginateDogSize:ModelTypes["DogSizeConnection"],
	validateCreateDogSize:ModelTypes["_ValidationResult"],
	validateUpdateDogSize:ModelTypes["_ValidationResult"],
	getProduct?:ModelTypes["Product"],
	listProduct:ModelTypes["Product"][],
	paginateProduct:ModelTypes["ProductConnection"],
	validateCreateProduct:ModelTypes["_ValidationResult"],
	validateUpdateProduct:ModelTypes["_ValidationResult"],
	getProductionMethod?:ModelTypes["ProductionMethod"],
	listProductionMethod:ModelTypes["ProductionMethod"][],
	paginateProductionMethod:ModelTypes["ProductionMethodConnection"],
	validateCreateProductionMethod:ModelTypes["_ValidationResult"],
	validateUpdateProductionMethod:ModelTypes["_ValidationResult"],
	getProductLine?:ModelTypes["ProductLine"],
	listProductLine:ModelTypes["ProductLine"][],
	paginateProductLine:ModelTypes["ProductLineConnection"],
	validateCreateProductLine:ModelTypes["_ValidationResult"],
	validateUpdateProductLine:ModelTypes["_ValidationResult"],
	getBreed?:ModelTypes["Breed"],
	listBreed:ModelTypes["Breed"][],
	paginateBreed:ModelTypes["BreedConnection"],
	validateCreateBreed:ModelTypes["_ValidationResult"],
	validateUpdateBreed:ModelTypes["_ValidationResult"],
	getDog?:ModelTypes["Dog"],
	listDog:ModelTypes["Dog"][],
	paginateDog:ModelTypes["DogConnection"],
	validateCreateDog:ModelTypes["_ValidationResult"],
	validateUpdateDog:ModelTypes["_ValidationResult"],
	getUser?:ModelTypes["User"],
	listUser:ModelTypes["User"][],
	paginateUser:ModelTypes["UserConnection"],
	validateCreateUser:ModelTypes["_ValidationResult"],
	validateUpdateUser:ModelTypes["_ValidationResult"],
	getVeterinary?:ModelTypes["Veterinary"],
	listVeterinary:ModelTypes["Veterinary"][],
	paginateVeterinary:ModelTypes["VeterinaryConnection"],
	validateCreateVeterinary:ModelTypes["_ValidationResult"],
	validateUpdateVeterinary:ModelTypes["_ValidationResult"],
	getNutritionalValueOfProduct?:ModelTypes["NutritionalValueOfProduct"],
	listNutritionalValueOfProduct:ModelTypes["NutritionalValueOfProduct"][],
	paginateNutritionalValueOfProduct:ModelTypes["NutritionalValueOfProductConnection"],
	validateCreateNutritionalValueOfProduct:ModelTypes["_ValidationResult"],
	validateUpdateNutritionalValueOfProduct:ModelTypes["_ValidationResult"],
	getReview?:ModelTypes["Review"],
	listReview:ModelTypes["Review"][],
	paginateReview:ModelTypes["ReviewConnection"],
	validateCreateReview:ModelTypes["_ValidationResult"],
	validateUpdateReview:ModelTypes["_ValidationResult"],
	getDogBodyType?:ModelTypes["DogBodyType"],
	listDogBodyType:ModelTypes["DogBodyType"][],
	paginateDogBodyType:ModelTypes["DogBodyTypeConnection"],
	validateCreateDogBodyType:ModelTypes["_ValidationResult"],
	validateUpdateDogBodyType:ModelTypes["_ValidationResult"],
	getDogBodyTypeCategory?:ModelTypes["DogBodyTypeCategory"],
	listDogBodyTypeCategory:ModelTypes["DogBodyTypeCategory"][],
	paginateDogBodyTypeCategory:ModelTypes["DogBodyTypeCategoryConnection"],
	validateCreateDogBodyTypeCategory:ModelTypes["_ValidationResult"],
	validateUpdateDogBodyTypeCategory:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getUrl?:ModelTypes["Url"],
	listUrl:ModelTypes["Url"][],
	paginateUrl:ModelTypes["UrlConnection"],
	validateCreateUrl:ModelTypes["_ValidationResult"],
	validateUpdateUrl:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getFooterLink?:ModelTypes["FooterLink"],
	listFooterLink:ModelTypes["FooterLink"][],
	paginateFooterLink:ModelTypes["FooterLinkConnection"],
	validateCreateFooterLink:ModelTypes["_ValidationResult"],
	validateUpdateFooterLink:ModelTypes["_ValidationResult"],
	getBrandsPage?:ModelTypes["BrandsPage"],
	listBrandsPage:ModelTypes["BrandsPage"][],
	paginateBrandsPage:ModelTypes["BrandsPageConnection"],
	validateCreateBrandsPage:ModelTypes["_ValidationResult"],
	validateUpdateBrandsPage:ModelTypes["_ValidationResult"],
	getHomePage?:ModelTypes["HomePage"],
	listHomePage:ModelTypes["HomePage"][],
	paginateHomePage:ModelTypes["HomePageConnection"],
	validateCreateHomePage:ModelTypes["_ValidationResult"],
	validateUpdateHomePage:ModelTypes["_ValidationResult"],
	getIngredientsPage?:ModelTypes["IngredientsPage"],
	listIngredientsPage:ModelTypes["IngredientsPage"][],
	paginateIngredientsPage:ModelTypes["IngredientsPageConnection"],
	validateCreateIngredientsPage:ModelTypes["_ValidationResult"],
	validateUpdateIngredientsPage:ModelTypes["_ValidationResult"],
	getProductReview?:ModelTypes["ProductReview"],
	listProductReview:ModelTypes["ProductReview"][],
	paginateProductReview:ModelTypes["ProductReviewConnection"],
	validateCreateProductReview:ModelTypes["_ValidationResult"],
	validateUpdateProductReview:ModelTypes["_ValidationResult"],
	getScore?:ModelTypes["Score"],
	listScore:ModelTypes["Score"][],
	paginateScore:ModelTypes["ScoreConnection"],
	validateCreateScore:ModelTypes["_ValidationResult"],
	validateUpdateScore:ModelTypes["_ValidationResult"],
	getAge?:ModelTypes["Age"],
	listAge:ModelTypes["Age"][],
	paginateAge:ModelTypes["AgeConnection"],
	validateCreateAge:ModelTypes["_ValidationResult"],
	validateUpdateAge:ModelTypes["_ValidationResult"],
	getCountry?:ModelTypes["Country"],
	listCountry:ModelTypes["Country"][],
	paginateCountry:ModelTypes["CountryConnection"],
	validateCreateCountry:ModelTypes["_ValidationResult"],
	validateUpdateCountry:ModelTypes["_ValidationResult"],
	getBlogPostReview?:ModelTypes["BlogPostReview"],
	listBlogPostReview:ModelTypes["BlogPostReview"][],
	paginateBlogPostReview:ModelTypes["BlogPostReviewConnection"],
	validateCreateBlogPostReview:ModelTypes["_ValidationResult"],
	validateUpdateBlogPostReview:ModelTypes["_ValidationResult"],
	getDogActivity?:ModelTypes["DogActivity"],
	listDogActivity:ModelTypes["DogActivity"][],
	paginateDogActivity:ModelTypes["DogActivityConnection"],
	validateCreateDogActivity:ModelTypes["_ValidationResult"],
	validateUpdateDogActivity:ModelTypes["_ValidationResult"],
	getSocial?:ModelTypes["Social"],
	listSocial:ModelTypes["Social"][],
	paginateSocial:ModelTypes["SocialConnection"],
	validateCreateSocial:ModelTypes["_ValidationResult"],
	validateUpdateSocial:ModelTypes["_ValidationResult"],
	getContentReferenceGalleryImage?:ModelTypes["ContentReferenceGalleryImage"],
	listContentReferenceGalleryImage:ModelTypes["ContentReferenceGalleryImage"][],
	paginateContentReferenceGalleryImage:ModelTypes["ContentReferenceGalleryImageConnection"],
	validateCreateContentReferenceGalleryImage:ModelTypes["_ValidationResult"],
	validateUpdateContentReferenceGalleryImage:ModelTypes["_ValidationResult"],
	getItem?:ModelTypes["Item"],
	listItem:ModelTypes["Item"][],
	paginateItem:ModelTypes["ItemConnection"],
	validateCreateItem:ModelTypes["_ValidationResult"],
	validateUpdateItem:ModelTypes["_ValidationResult"],
	getItemSubCategory?:ModelTypes["ItemSubCategory"],
	listItemSubCategory:ModelTypes["ItemSubCategory"][],
	paginateItemSubCategory:ModelTypes["ItemSubCategoryConnection"],
	validateCreateItemSubCategory:ModelTypes["_ValidationResult"],
	validateUpdateItemSubCategory:ModelTypes["_ValidationResult"],
	getItemCategory?:ModelTypes["ItemCategory"],
	listItemCategory:ModelTypes["ItemCategory"][],
	paginateItemCategory:ModelTypes["ItemCategoryConnection"],
	validateCreateItemCategory:ModelTypes["_ValidationResult"],
	validateUpdateItemCategory:ModelTypes["_ValidationResult"],
	getItemFlavorCategory?:ModelTypes["ItemFlavorCategory"],
	listItemFlavorCategory:ModelTypes["ItemFlavorCategory"][],
	paginateItemFlavorCategory:ModelTypes["ItemFlavorCategoryConnection"],
	validateCreateItemFlavorCategory:ModelTypes["_ValidationResult"],
	validateUpdateItemFlavorCategory:ModelTypes["_ValidationResult"],
	getItemDeclensionFourthVariant?:ModelTypes["ItemDeclensionFourthVariant"],
	listItemDeclensionFourthVariant:ModelTypes["ItemDeclensionFourthVariant"][],
	paginateItemDeclensionFourthVariant:ModelTypes["ItemDeclensionFourthVariantConnection"],
	validateCreateItemDeclensionFourthVariant:ModelTypes["_ValidationResult"],
	validateUpdateItemDeclensionFourthVariant:ModelTypes["_ValidationResult"],
	getItemDeclensionSeventhVariant?:ModelTypes["ItemDeclensionSeventhVariant"],
	listItemDeclensionSeventhVariant:ModelTypes["ItemDeclensionSeventhVariant"][],
	paginateItemDeclensionSeventhVariant:ModelTypes["ItemDeclensionSeventhVariantConnection"],
	validateCreateItemDeclensionSeventhVariant:ModelTypes["_ValidationResult"],
	validateUpdateItemDeclensionSeventhVariant:ModelTypes["_ValidationResult"],
	getMediaCard?:ModelTypes["MediaCard"],
	listMediaCard:ModelTypes["MediaCard"][],
	paginateMediaCard:ModelTypes["MediaCardConnection"],
	validateCreateMediaCard:ModelTypes["_ValidationResult"],
	validateUpdateMediaCard:ModelTypes["_ValidationResult"],
	getInfoCard?:ModelTypes["InfoCard"],
	listInfoCard:ModelTypes["InfoCard"][],
	paginateInfoCard:ModelTypes["InfoCardConnection"],
	validateCreateInfoCard:ModelTypes["_ValidationResult"],
	validateUpdateInfoCard:ModelTypes["_ValidationResult"],
	getNumberedCard?:ModelTypes["NumberedCard"],
	listNumberedCard:ModelTypes["NumberedCard"][],
	paginateNumberedCard:ModelTypes["NumberedCardConnection"],
	validateCreateNumberedCard:ModelTypes["_ValidationResult"],
	validateUpdateNumberedCard:ModelTypes["_ValidationResult"],
	getRegisterClaim?:ModelTypes["RegisterClaim"],
	listRegisterClaim:ModelTypes["RegisterClaim"][],
	paginateRegisterClaim:ModelTypes["RegisterClaimConnection"],
	validateCreateRegisterClaim:ModelTypes["_ValidationResult"],
	validateUpdateRegisterClaim:ModelTypes["_ValidationResult"],
	getBlogPostReviewReaction?:ModelTypes["BlogPostReviewReaction"],
	listBlogPostReviewReaction:ModelTypes["BlogPostReviewReaction"][],
	paginateBlogPostReviewReaction:ModelTypes["BlogPostReviewReactionConnection"],
	validateCreateBlogPostReviewReaction:ModelTypes["_ValidationResult"],
	validateUpdateBlogPostReviewReaction:ModelTypes["_ValidationResult"],
	getProductReviewReaction?:ModelTypes["ProductReviewReaction"],
	listProductReviewReaction:ModelTypes["ProductReviewReaction"][],
	paginateProductReviewReaction:ModelTypes["ProductReviewReactionConnection"],
	validateCreateProductReviewReaction:ModelTypes["_ValidationResult"],
	validateUpdateProductReviewReaction:ModelTypes["_ValidationResult"],
	getProductPackage?:ModelTypes["ProductPackage"],
	listProductPackage:ModelTypes["ProductPackage"][],
	paginateProductPackage:ModelTypes["ProductPackageConnection"],
	validateCreateProductPackage:ModelTypes["_ValidationResult"],
	validateUpdateProductPackage:ModelTypes["_ValidationResult"],
	getBrandManufacturer?:ModelTypes["BrandManufacturer"],
	listBrandManufacturer:ModelTypes["BrandManufacturer"][],
	paginateBrandManufacturer:ModelTypes["BrandManufacturerConnection"],
	validateCreateBrandManufacturer:ModelTypes["_ValidationResult"],
	validateUpdateBrandManufacturer:ModelTypes["_ValidationResult"],
	getElement?:ModelTypes["Element"],
	listElement:ModelTypes["Element"][],
	paginateElement:ModelTypes["ElementConnection"],
	validateCreateElement:ModelTypes["_ValidationResult"],
	validateUpdateElement:ModelTypes["_ValidationResult"],
	getElementOfProduct?:ModelTypes["ElementOfProduct"],
	listElementOfProduct:ModelTypes["ElementOfProduct"][],
	paginateElementOfProduct:ModelTypes["ElementOfProductConnection"],
	validateCreateElementOfProduct:ModelTypes["_ValidationResult"],
	validateUpdateElementOfProduct:ModelTypes["_ValidationResult"],
	getSuitabilityCategory?:ModelTypes["SuitabilityCategory"],
	listSuitabilityCategory:ModelTypes["SuitabilityCategory"][],
	paginateSuitabilityCategory:ModelTypes["SuitabilityCategoryConnection"],
	validateCreateSuitabilityCategory:ModelTypes["_ValidationResult"],
	validateUpdateSuitabilityCategory:ModelTypes["_ValidationResult"],
	getProductFeature?:ModelTypes["ProductFeature"],
	listProductFeature:ModelTypes["ProductFeature"][],
	paginateProductFeature:ModelTypes["ProductFeatureConnection"],
	validateCreateProductFeature:ModelTypes["_ValidationResult"],
	validateUpdateProductFeature:ModelTypes["_ValidationResult"],
	getSuitabilityItem?:ModelTypes["SuitabilityItem"],
	listSuitabilityItem:ModelTypes["SuitabilityItem"][],
	paginateSuitabilityItem:ModelTypes["SuitabilityItemConnection"],
	validateCreateSuitabilityItem:ModelTypes["_ValidationResult"],
	validateUpdateSuitabilityItem:ModelTypes["_ValidationResult"],
	getRegion?:ModelTypes["Region"],
	listRegion:ModelTypes["Region"][],
	paginateRegion:ModelTypes["RegionConnection"],
	validateCreateRegion:ModelTypes["_ValidationResult"],
	validateUpdateRegion:ModelTypes["_ValidationResult"],
	getGranuleSize?:ModelTypes["GranuleSize"],
	listGranuleSize:ModelTypes["GranuleSize"][],
	paginateGranuleSize:ModelTypes["GranuleSizeConnection"],
	validateCreateGranuleSize:ModelTypes["_ValidationResult"],
	validateUpdateGranuleSize:ModelTypes["_ValidationResult"],
	getItemAlias?:ModelTypes["ItemAlias"],
	listItemAlias:ModelTypes["ItemAlias"][],
	paginateItemAlias:ModelTypes["ItemAliasConnection"],
	validateCreateItemAlias:ModelTypes["_ValidationResult"],
	validateUpdateItemAlias:ModelTypes["_ValidationResult"],
	getSemanticKey?:ModelTypes["SemanticKey"],
	listSemanticKey:ModelTypes["SemanticKey"][],
	paginateSemanticKey:ModelTypes["SemanticKeyConnection"],
	validateCreateSemanticKey:ModelTypes["_ValidationResult"],
	validateUpdateSemanticKey:ModelTypes["_ValidationResult"],
	getProductFlag?:ModelTypes["ProductFlag"],
	listProductFlag:ModelTypes["ProductFlag"][],
	paginateProductFlag:ModelTypes["ProductFlagConnection"],
	validateCreateProductFlag:ModelTypes["_ValidationResult"],
	validateUpdateProductFlag:ModelTypes["_ValidationResult"],
	getProductFlagOfProduct?:ModelTypes["ProductFlagOfProduct"],
	listProductFlagOfProduct:ModelTypes["ProductFlagOfProduct"][],
	paginateProductFlagOfProduct:ModelTypes["ProductFlagOfProductConnection"],
	validateCreateProductFlagOfProduct:ModelTypes["_ValidationResult"],
	validateUpdateProductFlagOfProduct:ModelTypes["_ValidationResult"],
	getProductEvaluation?:ModelTypes["ProductEvaluation"],
	listProductEvaluation:ModelTypes["ProductEvaluation"][],
	paginateProductEvaluation:ModelTypes["ProductEvaluationConnection"],
	validateCreateProductEvaluation:ModelTypes["_ValidationResult"],
	validateUpdateProductEvaluation:ModelTypes["_ValidationResult"],
	getAd?:ModelTypes["Ad"],
	listAd:ModelTypes["Ad"][],
	paginateAd:ModelTypes["AdConnection"],
	validateCreateAd:ModelTypes["_ValidationResult"],
	validateUpdateAd:ModelTypes["_ValidationResult"],
	getEvaluationInfo?:ModelTypes["EvaluationInfo"],
	listEvaluationInfo:ModelTypes["EvaluationInfo"][],
	paginateEvaluationInfo:ModelTypes["EvaluationInfoConnection"],
	validateCreateEvaluationInfo:ModelTypes["_ValidationResult"],
	validateUpdateEvaluationInfo:ModelTypes["_ValidationResult"],
	getConsumptionMessage?:ModelTypes["ConsumptionMessage"],
	listConsumptionMessage:ModelTypes["ConsumptionMessage"][],
	paginateConsumptionMessage:ModelTypes["ConsumptionMessageConnection"],
	validateCreateConsumptionMessage:ModelTypes["_ValidationResult"],
	validateUpdateConsumptionMessage:ModelTypes["_ValidationResult"],
	getContentText?:ModelTypes["ContentText"],
	listContentText:ModelTypes["ContentText"][],
	paginateContentText:ModelTypes["ContentTextConnection"],
	validateCreateContentText:ModelTypes["_ValidationResult"],
	validateUpdateContentText:ModelTypes["_ValidationResult"],
	getContentTextBlock?:ModelTypes["ContentTextBlock"],
	listContentTextBlock:ModelTypes["ContentTextBlock"][],
	paginateContentTextBlock:ModelTypes["ContentTextBlockConnection"],
	validateCreateContentTextBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentTextBlock:ModelTypes["_ValidationResult"],
	getProductReviewStats?:ModelTypes["ProductReviewStats"],
	listProductReviewStats:ModelTypes["ProductReviewStats"][],
	paginateProductReviewStats:ModelTypes["ProductReviewStatsConnection"],
	getBlogPostReviewStats?:ModelTypes["BlogPostReviewStats"],
	listBlogPostReviewStats:ModelTypes["BlogPostReviewStats"][],
	paginateBlogPostReviewStats:ModelTypes["BlogPostReviewStatsConnection"],
	getComparatorPage?:ModelTypes["ComparatorPage"],
	listComparatorPage:ModelTypes["ComparatorPage"][],
	paginateComparatorPage:ModelTypes["ComparatorPageConnection"],
	validateCreateComparatorPage:ModelTypes["_ValidationResult"],
	validateUpdateComparatorPage:ModelTypes["_ValidationResult"],
	getLoginPage?:ModelTypes["LoginPage"],
	listLoginPage:ModelTypes["LoginPage"][],
	paginateLoginPage:ModelTypes["LoginPageConnection"],
	validateCreateLoginPage:ModelTypes["_ValidationResult"],
	validateUpdateLoginPage:ModelTypes["_ValidationResult"],
	getRegisterPage?:ModelTypes["RegisterPage"],
	listRegisterPage:ModelTypes["RegisterPage"][],
	paginateRegisterPage:ModelTypes["RegisterPageConnection"],
	validateCreateRegisterPage:ModelTypes["_ValidationResult"],
	validateUpdateRegisterPage:ModelTypes["_ValidationResult"],
	getResultsPage?:ModelTypes["ResultsPage"],
	listResultsPage:ModelTypes["ResultsPage"][],
	paginateResultsPage:ModelTypes["ResultsPageConnection"],
	validateCreateResultsPage:ModelTypes["_ValidationResult"],
	validateUpdateResultsPage:ModelTypes["_ValidationResult"],
	getSearchPage?:ModelTypes["SearchPage"],
	listSearchPage:ModelTypes["SearchPage"][],
	paginateSearchPage:ModelTypes["SearchPageConnection"],
	validateCreateSearchPage:ModelTypes["_ValidationResult"],
	validateUpdateSearchPage:ModelTypes["_ValidationResult"],
	getWizardPage?:ModelTypes["WizardPage"],
	listWizardPage:ModelTypes["WizardPage"][],
	paginateWizardPage:ModelTypes["WizardPageConnection"],
	validateCreateWizardPage:ModelTypes["_ValidationResult"],
	validateUpdateWizardPage:ModelTypes["_ValidationResult"],
	getBreastfeedingCategory?:ModelTypes["BreastfeedingCategory"],
	listBreastfeedingCategory:ModelTypes["BreastfeedingCategory"][],
	paginateBreastfeedingCategory:ModelTypes["BreastfeedingCategoryConnection"],
	validateCreateBreastfeedingCategory:ModelTypes["_ValidationResult"],
	validateUpdateBreastfeedingCategory:ModelTypes["_ValidationResult"],
	getDogReproduction?:ModelTypes["DogReproduction"],
	listDogReproduction:ModelTypes["DogReproduction"][],
	paginateDogReproduction:ModelTypes["DogReproductionConnection"],
	validateCreateDogReproduction:ModelTypes["_ValidationResult"],
	validateUpdateDogReproduction:ModelTypes["_ValidationResult"],
	getContactFormMessage?:ModelTypes["ContactFormMessage"],
	listContactFormMessage:ModelTypes["ContactFormMessage"][],
	paginateContactFormMessage:ModelTypes["ContactFormMessageConnection"],
	validateCreateContactFormMessage:ModelTypes["_ValidationResult"],
	validateUpdateContactFormMessage:ModelTypes["_ValidationResult"],
	getContactPage?:ModelTypes["ContactPage"],
	listContactPage:ModelTypes["ContactPage"][],
	paginateContactPage:ModelTypes["ContactPageConnection"],
	validateCreateContactPage:ModelTypes["_ValidationResult"],
	validateUpdateContactPage:ModelTypes["_ValidationResult"],
	getBugReport?:ModelTypes["BugReport"],
	listBugReport:ModelTypes["BugReport"][],
	paginateBugReport:ModelTypes["BugReportConnection"],
	validateCreateBugReport:ModelTypes["_ValidationResult"],
	validateUpdateBugReport:ModelTypes["_ValidationResult"],
	getColor?:ModelTypes["Color"],
	listColor:ModelTypes["Color"][],
	paginateColor:ModelTypes["ColorConnection"],
	validateCreateColor:ModelTypes["_ValidationResult"],
	validateUpdateColor:ModelTypes["_ValidationResult"],
	getItemGroup?:ModelTypes["ItemGroup"],
	listItemGroup:ModelTypes["ItemGroup"][],
	paginateItemGroup:ModelTypes["ItemGroupConnection"],
	validateCreateItemGroup:ModelTypes["_ValidationResult"],
	validateUpdateItemGroup:ModelTypes["_ValidationResult"],
	getSearchResult?:ModelTypes["SearchResult"],
	listSearchResult:ModelTypes["SearchResult"][],
	paginateSearchResult:ModelTypes["SearchResultConnection"],
	getProductEvaluationSummary?:ModelTypes["ProductEvaluationSummary"],
	listProductEvaluationSummary:ModelTypes["ProductEvaluationSummary"][],
	paginateProductEvaluationSummary:ModelTypes["ProductEvaluationSummaryConnection"],
	validateCreateProductEvaluationSummary:ModelTypes["_ValidationResult"],
	validateUpdateProductEvaluationSummary:ModelTypes["_ValidationResult"],
	getProtectedAction?:ModelTypes["ProtectedAction"],
	listProtectedAction:ModelTypes["ProtectedAction"][],
	paginateProtectedAction:ModelTypes["ProtectedActionConnection"],
	validateCreateProtectedAction:ModelTypes["_ValidationResult"],
	validateUpdateProtectedAction:ModelTypes["_ValidationResult"],
	getBrandAlias?:ModelTypes["BrandAlias"],
	listBrandAlias:ModelTypes["BrandAlias"][],
	paginateBrandAlias:ModelTypes["BrandAliasConnection"],
	validateCreateBrandAlias:ModelTypes["_ValidationResult"],
	validateUpdateBrandAlias:ModelTypes["_ValidationResult"],
	getProductAlias?:ModelTypes["ProductAlias"],
	listProductAlias:ModelTypes["ProductAlias"][],
	paginateProductAlias:ModelTypes["ProductAliasConnection"],
	validateCreateProductAlias:ModelTypes["_ValidationResult"],
	validateUpdateProductAlias:ModelTypes["_ValidationResult"],
	getProductLineAlias?:ModelTypes["ProductLineAlias"],
	listProductLineAlias:ModelTypes["ProductLineAlias"][],
	paginateProductLineAlias:ModelTypes["ProductLineAliasConnection"],
	validateCreateProductLineAlias:ModelTypes["_ValidationResult"],
	validateUpdateProductLineAlias:ModelTypes["_ValidationResult"],
	getGenericPage?:ModelTypes["GenericPage"],
	listGenericPage:ModelTypes["GenericPage"][],
	paginateGenericPage:ModelTypes["GenericPageConnection"],
	validateCreateGenericPage:ModelTypes["_ValidationResult"],
	validateUpdateGenericPage:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getContentLinks?:ModelTypes["ContentLinks"],
	listContentLinks:ModelTypes["ContentLinks"][],
	paginateContentLinks:ModelTypes["ContentLinksConnection"],
	validateCreateContentLinks:ModelTypes["_ValidationResult"],
	validateUpdateContentLinks:ModelTypes["_ValidationResult"],
	getContentLinksItem?:ModelTypes["ContentLinksItem"],
	listContentLinksItem:ModelTypes["ContentLinksItem"][],
	paginateContentLinksItem:ModelTypes["ContentLinksItemConnection"],
	validateCreateContentLinksItem:ModelTypes["_ValidationResult"],
	validateUpdateContentLinksItem:ModelTypes["_ValidationResult"],
	getRedirect?:ModelTypes["Redirect"],
	listRedirect:ModelTypes["Redirect"][],
	paginateRedirect:ModelTypes["RedirectConnection"],
	validateCreateRedirect:ModelTypes["_ValidationResult"],
	validateUpdateRedirect:ModelTypes["_ValidationResult"],
	getContentReferenceImage?:ModelTypes["ContentReferenceImage"],
	listContentReferenceImage:ModelTypes["ContentReferenceImage"][],
	paginateContentReferenceImage:ModelTypes["ContentReferenceImageConnection"],
	validateCreateContentReferenceImage:ModelTypes["_ValidationResult"],
	validateUpdateContentReferenceImage:ModelTypes["_ValidationResult"],
	getSeoData?:ModelTypes["SeoData"],
	listSeoData:ModelTypes["SeoData"][],
	paginateSeoData:ModelTypes["SeoDataConnection"],
	validateCreateSeoData:ModelTypes["_ValidationResult"],
	validateUpdateSeoData:ModelTypes["_ValidationResult"],
	getTenantPerson?:ModelTypes["TenantPerson"],
	listTenantPerson:ModelTypes["TenantPerson"][],
	paginateTenantPerson:ModelTypes["TenantPersonConnection"],
	getBrandFlavor?:ModelTypes["BrandFlavor"],
	listBrandFlavor:ModelTypes["BrandFlavor"][],
	paginateBrandFlavor:ModelTypes["BrandFlavorConnection"],
	getProductLineFlavor?:ModelTypes["ProductLineFlavor"],
	listProductLineFlavor:ModelTypes["ProductLineFlavor"][],
	paginateProductLineFlavor:ModelTypes["ProductLineFlavorConnection"],
	getProductItemDeclensionFourthCategory?:ModelTypes["ProductItemDeclensionFourthCategory"],
	listProductItemDeclensionFourthCategory:ModelTypes["ProductItemDeclensionFourthCategory"][],
	paginateProductItemDeclensionFourthCategory:ModelTypes["ProductItemDeclensionFourthCategoryConnection"],
	getAgeCategory?:ModelTypes["AgeCategory"],
	listAgeCategory:ModelTypes["AgeCategory"][],
	paginateAgeCategory:ModelTypes["AgeCategoryConnection"],
	validateCreateAgeCategory:ModelTypes["_ValidationResult"],
	validateUpdateAgeCategory:ModelTypes["_ValidationResult"],
	getFilterCombo?:ModelTypes["FilterCombo"],
	listFilterCombo:ModelTypes["FilterCombo"][],
	paginateFilterCombo:ModelTypes["FilterComboConnection"],
	validateCreateFilterCombo:ModelTypes["_ValidationResult"],
	validateUpdateFilterCombo:ModelTypes["_ValidationResult"],
	getImportCache?:ModelTypes["ImportCache"],
	listImportCache:ModelTypes["ImportCache"][],
	paginateImportCache:ModelTypes["ImportCacheConnection"],
	validateCreateImportCache:ModelTypes["_ValidationResult"],
	validateUpdateImportCache:ModelTypes["_ValidationResult"],
	getSite?:ModelTypes["Site"],
	listSite:ModelTypes["Site"][],
	paginateSite:ModelTypes["SiteConnection"],
	validateCreateSite:ModelTypes["_ValidationResult"],
	validateUpdateSite:ModelTypes["_ValidationResult"],
	getContactSubmission?:ModelTypes["ContactSubmission"],
	listContactSubmission:ModelTypes["ContactSubmission"][],
	paginateContactSubmission:ModelTypes["ContactSubmissionConnection"],
	validateCreateContactSubmission:ModelTypes["_ValidationResult"],
	validateUpdateContactSubmission:ModelTypes["_ValidationResult"],
	getTOPXBrand?:ModelTypes["TOPXBrand"],
	listTOPXBrand:ModelTypes["TOPXBrand"][],
	paginateTOPXBrand:ModelTypes["TOPXBrandConnection"],
	validateCreateTOPXBrand:ModelTypes["_ValidationResult"],
	validateUpdateTOPXBrand:ModelTypes["_ValidationResult"],
	getTOPXBrandCategory?:ModelTypes["TOPXBrandCategory"],
	listTOPXBrandCategory:ModelTypes["TOPXBrandCategory"][],
	paginateTOPXBrandCategory:ModelTypes["TOPXBrandCategoryConnection"],
	validateCreateTOPXBrandCategory:ModelTypes["_ValidationResult"],
	validateUpdateTOPXBrandCategory:ModelTypes["_ValidationResult"],
	getTOPXProduct?:ModelTypes["TOPXProduct"],
	listTOPXProduct:ModelTypes["TOPXProduct"][],
	paginateTOPXProduct:ModelTypes["TOPXProductConnection"],
	validateCreateTOPXProduct:ModelTypes["_ValidationResult"],
	validateUpdateTOPXProduct:ModelTypes["_ValidationResult"],
	getTOPXProductCategory?:ModelTypes["TOPXProductCategory"],
	listTOPXProductCategory:ModelTypes["TOPXProductCategory"][],
	paginateTOPXProductCategory:ModelTypes["TOPXProductCategoryConnection"],
	validateCreateTOPXProductCategory:ModelTypes["_ValidationResult"],
	validateUpdateTOPXProductCategory:ModelTypes["_ValidationResult"],
	getContentReferenceList?:ModelTypes["ContentReferenceList"],
	listContentReferenceList:ModelTypes["ContentReferenceList"][],
	paginateContentReferenceList:ModelTypes["ContentReferenceListConnection"],
	validateCreateContentReferenceList:ModelTypes["_ValidationResult"],
	validateUpdateContentReferenceList:ModelTypes["_ValidationResult"],
	getBrandCount?:ModelTypes["BrandCount"],
	listBrandCount:ModelTypes["BrandCount"][],
	paginateBrandCount:ModelTypes["BrandCountConnection"],
	getProductCount?:ModelTypes["ProductCount"],
	listProductCount:ModelTypes["ProductCount"][],
	paginateProductCount:ModelTypes["ProductCountConnection"],
	transaction?:ModelTypes["QueryTransaction"],
	_info?:ModelTypes["Info"]
};
	["_Schema"]: {
		enums:ModelTypes["_Enum"][],
	entities:ModelTypes["_Entity"][]
};
	["_Enum"]: {
		name:string,
	values:string[]
};
	["_Entity"]: {
		name:string,
	customPrimaryAllowed:boolean,
	fields:ModelTypes["_Field"][],
	unique:ModelTypes["_UniqueConstraint"][]
};
	["_UniqueConstraint"]: {
		fields:string[]
};
	["BlogPage"]: {
		_meta?:ModelTypes["BlogPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	title?:string,
	redirects:ModelTypes["Redirect"][],
	seo?:ModelTypes["Seo"],
	content?:ModelTypes["Content"],
	draft?:ModelTypes["Content"],
	redirectsByFrom?:ModelTypes["Redirect"],
	paginateRedirects:ModelTypes["RedirectConnection"]
};
	["BlogPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	redirects?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	draft?:ModelTypes["FieldMeta"]
};
	["FieldMeta"]: {
		readable?:boolean,
	updatable?:boolean
};
	["UUID"]:any;
	["One"]: GraphQLTypes["One"];
	["Redirect"]: {
		_meta?:ModelTypes["RedirectMeta"],
	id:ModelTypes["UUID"],
	to?:string,
	order?:number,
	from:string,
	genericPage?:ModelTypes["GenericPage"],
	itemCategory?:ModelTypes["ItemCategory"],
	brandsPage?:ModelTypes["BrandsPage"],
	blogPage?:ModelTypes["BlogPage"],
	contactPage?:ModelTypes["ContactPage"],
	wizardPage?:ModelTypes["WizardPage"],
	comparatorPage?:ModelTypes["ComparatorPage"],
	blogPost?:ModelTypes["BlogPost"]
};
	["RedirectMeta"]: {
		id?:ModelTypes["FieldMeta"],
	to?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	from?:ModelTypes["FieldMeta"],
	genericPage?:ModelTypes["FieldMeta"],
	itemCategory?:ModelTypes["FieldMeta"],
	brandsPage?:ModelTypes["FieldMeta"],
	blogPage?:ModelTypes["FieldMeta"],
	contactPage?:ModelTypes["FieldMeta"],
	wizardPage?:ModelTypes["FieldMeta"],
	comparatorPage?:ModelTypes["FieldMeta"],
	blogPost?:ModelTypes["FieldMeta"]
};
	["GenericPage"]: {
		_meta?:ModelTypes["GenericPageMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	link?:ModelTypes["Linkable"],
	redirects:ModelTypes["Redirect"][],
	seo?:ModelTypes["Seo"],
	content?:ModelTypes["Content"],
	draft?:ModelTypes["Content"],
	redirectsByFrom?:ModelTypes["Redirect"],
	paginateRedirects:ModelTypes["RedirectConnection"]
};
	["GenericPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	redirects?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	draft?:ModelTypes["FieldMeta"]
};
	["Linkable"]: {
		_meta?:ModelTypes["LinkableMeta"],
	id:ModelTypes["UUID"],
	url:string,
	genericPage?:ModelTypes["GenericPage"]
};
	["LinkableMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	genericPage?:ModelTypes["FieldMeta"]
};
	["GenericPageWhere"]: GraphQLTypes["GenericPageWhere"];
	["UUIDCondition"]: GraphQLTypes["UUIDCondition"];
	["StringCondition"]: GraphQLTypes["StringCondition"];
	["LinkableWhere"]: GraphQLTypes["LinkableWhere"];
	["RedirectWhere"]: GraphQLTypes["RedirectWhere"];
	["IntCondition"]: GraphQLTypes["IntCondition"];
	["ItemCategoryWhere"]: GraphQLTypes["ItemCategoryWhere"];
	["ItemSubCategoryWhere"]: GraphQLTypes["ItemSubCategoryWhere"];
	["ItemWhere"]: GraphQLTypes["ItemWhere"];
	["BodyTagWhere"]: GraphQLTypes["BodyTagWhere"];
	["BlogPostWhere"]: GraphQLTypes["BlogPostWhere"];
	["DateTimeCondition"]: GraphQLTypes["DateTimeCondition"];
	["DateTime"]:any;
	["BlogPostTagWhere"]: GraphQLTypes["BlogPostTagWhere"];
	["ColorWhere"]: GraphQLTypes["ColorWhere"];
	["BodyTagCategoryWhere"]: GraphQLTypes["BodyTagCategoryWhere"];
	["ItemFlavorCategoryWhere"]: GraphQLTypes["ItemFlavorCategoryWhere"];
	["BooleanCondition"]: GraphQLTypes["BooleanCondition"];
	["BlogPostReviewWhere"]: GraphQLTypes["BlogPostReviewWhere"];
	["BlogPostReviewReactionWhere"]: GraphQLTypes["BlogPostReviewReactionWhere"];
	["SentimentTypeCondition"]: GraphQLTypes["SentimentTypeCondition"];
	["SentimentType"]: GraphQLTypes["SentimentType"];
	["UserWhere"]: GraphQLTypes["UserWhere"];
	["DogWhere"]: GraphQLTypes["DogWhere"];
	["GenderTypeCondition"]: GraphQLTypes["GenderTypeCondition"];
	["GenderType"]: GraphQLTypes["GenderType"];
	["FloatCondition"]: GraphQLTypes["FloatCondition"];
	["BreedWhere"]: GraphQLTypes["BreedWhere"];
	["ReviewWhere"]: GraphQLTypes["ReviewWhere"];
	["AgeWhere"]: GraphQLTypes["AgeWhere"];
	["AgeRangeTypeCondition"]: GraphQLTypes["AgeRangeTypeCondition"];
	["AgeRangeType"]: GraphQLTypes["AgeRangeType"];
	["AgeLabelTypeCondition"]: GraphQLTypes["AgeLabelTypeCondition"];
	["AgeLabelType"]: GraphQLTypes["AgeLabelType"];
	["SuitabilityCategoryWhere"]: GraphQLTypes["SuitabilityCategoryWhere"];
	["DogSizeWhere"]: GraphQLTypes["DogSizeWhere"];
	["ProductWhere"]: GraphQLTypes["ProductWhere"];
	["NutritionalValueOfProductWhere"]: GraphQLTypes["NutritionalValueOfProductWhere"];
	["NutritionalValueWhere"]: GraphQLTypes["NutritionalValueWhere"];
	["SuitabilityItemWhere"]: GraphQLTypes["SuitabilityItemWhere"];
	["ElementWhere"]: GraphQLTypes["ElementWhere"];
	["ElementOfProductWhere"]: GraphQLTypes["ElementOfProductWhere"];
	["ProductFeatureWhere"]: GraphQLTypes["ProductFeatureWhere"];
	["FeatureCategoryTypeCondition"]: GraphQLTypes["FeatureCategoryTypeCondition"];
	["FeatureCategoryType"]: GraphQLTypes["FeatureCategoryType"];
	["FeatureValueTypeCondition"]: GraphQLTypes["FeatureValueTypeCondition"];
	["FeatureValueType"]: GraphQLTypes["FeatureValueType"];
	["ProductFlagWhere"]: GraphQLTypes["ProductFlagWhere"];
	["ProductFlagOfProductWhere"]: GraphQLTypes["ProductFlagOfProductWhere"];
	["ProductFlagValueCondition"]: GraphQLTypes["ProductFlagValueCondition"];
	["ProductFlagValue"]: GraphQLTypes["ProductFlagValue"];
	["ImageWhere"]: GraphQLTypes["ImageWhere"];
	["ProductReviewWhere"]: GraphQLTypes["ProductReviewWhere"];
	["ProductReviewReactionWhere"]: GraphQLTypes["ProductReviewReactionWhere"];
	["ScoreWhere"]: GraphQLTypes["ScoreWhere"];
	["ProductReviewStatsWhere"]: GraphQLTypes["ProductReviewStatsWhere"];
	["ProductPackageWhere"]: GraphQLTypes["ProductPackageWhere"];
	["GranuleSizeWhere"]: GraphQLTypes["GranuleSizeWhere"];
	["GranuleSizeTypeCondition"]: GraphQLTypes["GranuleSizeTypeCondition"];
	["GranuleSizeType"]: GraphQLTypes["GranuleSizeType"];
	["ProductLineWhere"]: GraphQLTypes["ProductLineWhere"];
	["BrandWhere"]: GraphQLTypes["BrandWhere"];
	["CountryWhere"]: GraphQLTypes["CountryWhere"];
	["BrandManufacturerWhere"]: GraphQLTypes["BrandManufacturerWhere"];
	["RegionWhere"]: GraphQLTypes["RegionWhere"];
	["FilterComboWhere"]: GraphQLTypes["FilterComboWhere"];
	["SeoWhere"]: GraphQLTypes["SeoWhere"];
	["BlogPageWhere"]: GraphQLTypes["BlogPageWhere"];
	["OneCondition"]: GraphQLTypes["OneCondition"];
	["ContentWhere"]: GraphQLTypes["ContentWhere"];
	["ContentBlockWhere"]: GraphQLTypes["ContentBlockWhere"];
	["ContentReferenceWhere"]: GraphQLTypes["ContentReferenceWhere"];
	["ContentReferenceTypeCondition"]: GraphQLTypes["ContentReferenceTypeCondition"];
	["ContentReferenceType"]: GraphQLTypes["ContentReferenceType"];
	["ContentReferenceGalleryImageWhere"]: GraphQLTypes["ContentReferenceGalleryImageWhere"];
	["AlignmentTypeCondition"]: GraphQLTypes["AlignmentTypeCondition"];
	["AlignmentType"]: GraphQLTypes["AlignmentType"];
	["LinkWhere"]: GraphQLTypes["LinkWhere"];
	["ContentReferenceListWhere"]: GraphQLTypes["ContentReferenceListWhere"];
	["ContentLinksWhere"]: GraphQLTypes["ContentLinksWhere"];
	["ContentLinksItemWhere"]: GraphQLTypes["ContentLinksItemWhere"];
	["VideoWhere"]: GraphQLTypes["VideoWhere"];
	["ContentReferenceImageWhere"]: GraphQLTypes["ContentReferenceImageWhere"];
	["AdWhere"]: GraphQLTypes["AdWhere"];
	["BrandsPageWhere"]: GraphQLTypes["BrandsPageWhere"];
	["ComparatorPageWhere"]: GraphQLTypes["ComparatorPageWhere"];
	["HomePageWhere"]: GraphQLTypes["HomePageWhere"];
	["IngredientsPageWhere"]: GraphQLTypes["IngredientsPageWhere"];
	["LoginPageWhere"]: GraphQLTypes["LoginPageWhere"];
	["RegisterPageWhere"]: GraphQLTypes["RegisterPageWhere"];
	["SearchPageWhere"]: GraphQLTypes["SearchPageWhere"];
	["WizardPageWhere"]: GraphQLTypes["WizardPageWhere"];
	["ContactPageWhere"]: GraphQLTypes["ContactPageWhere"];
	["GroupTypeCondition"]: GraphQLTypes["GroupTypeCondition"];
	["GroupType"]: GraphQLTypes["GroupType"];
	["AgeCategoryWhere"]: GraphQLTypes["AgeCategoryWhere"];
	["ProductionMethodWhere"]: GraphQLTypes["ProductionMethodWhere"];
	["BrandDistributorWhere"]: GraphQLTypes["BrandDistributorWhere"];
	["BrandAliasWhere"]: GraphQLTypes["BrandAliasWhere"];
	["BrandFlavorWhere"]: GraphQLTypes["BrandFlavorWhere"];
	["TOPXBrandWhere"]: GraphQLTypes["TOPXBrandWhere"];
	["TOPXBrandOrderTypeCondition"]: GraphQLTypes["TOPXBrandOrderTypeCondition"];
	["TOPXBrandOrderType"]: GraphQLTypes["TOPXBrandOrderType"];
	["TOPXBrandCategoryWhere"]: GraphQLTypes["TOPXBrandCategoryWhere"];
	["ProductLineAliasWhere"]: GraphQLTypes["ProductLineAliasWhere"];
	["ProductLineFlavorWhere"]: GraphQLTypes["ProductLineFlavorWhere"];
	["DogActivityWhere"]: GraphQLTypes["DogActivityWhere"];
	["ProductAliasWhere"]: GraphQLTypes["ProductAliasWhere"];
	["ContentAmountCondition"]: GraphQLTypes["ContentAmountCondition"];
	["ContentAmount"]: GraphQLTypes["ContentAmount"];
	["ProductEvaluationWhere"]: GraphQLTypes["ProductEvaluationWhere"];
	["ProductItemDeclensionFourthCategoryWhere"]: GraphQLTypes["ProductItemDeclensionFourthCategoryWhere"];
	["ItemDeclensionFourthVariantWhere"]: GraphQLTypes["ItemDeclensionFourthVariantWhere"];
	["TOPXProductWhere"]: GraphQLTypes["TOPXProductWhere"];
	["TOPXProductOrderTypeCondition"]: GraphQLTypes["TOPXProductOrderTypeCondition"];
	["TOPXProductOrderType"]: GraphQLTypes["TOPXProductOrderType"];
	["TOPXProductCategoryWhere"]: GraphQLTypes["TOPXProductCategoryWhere"];
	["SizeTypeCondition"]: GraphQLTypes["SizeTypeCondition"];
	["SizeType"]: GraphQLTypes["SizeType"];
	["DogBodyTypeWhere"]: GraphQLTypes["DogBodyTypeWhere"];
	["DogBodyTypeCategoryWhere"]: GraphQLTypes["DogBodyTypeCategoryWhere"];
	["DogReproductionWhere"]: GraphQLTypes["DogReproductionWhere"];
	["DogReproductionTypeCondition"]: GraphQLTypes["DogReproductionTypeCondition"];
	["DogReproductionType"]: GraphQLTypes["DogReproductionType"];
	["PregnantPeriodTypeCondition"]: GraphQLTypes["PregnantPeriodTypeCondition"];
	["PregnantPeriodType"]: GraphQLTypes["PregnantPeriodType"];
	["BreastfeedingCategoryWhere"]: GraphQLTypes["BreastfeedingCategoryWhere"];
	["VeterinaryWhere"]: GraphQLTypes["VeterinaryWhere"];
	["ContactFormMessageWhere"]: GraphQLTypes["ContactFormMessageWhere"];
	["BugReportWhere"]: GraphQLTypes["BugReportWhere"];
	["ProtectedActionWhere"]: GraphQLTypes["ProtectedActionWhere"];
	["ProtectedActionTypeCondition"]: GraphQLTypes["ProtectedActionTypeCondition"];
	["ProtectedActionType"]: GraphQLTypes["ProtectedActionType"];
	["JsonCondition"]: GraphQLTypes["JsonCondition"];
	["TenantPersonWhere"]: GraphQLTypes["TenantPersonWhere"];
	["BlogPostReviewStatsWhere"]: GraphQLTypes["BlogPostReviewStatsWhere"];
	["ReferenceListWhere"]: GraphQLTypes["ReferenceListWhere"];
	["ReferenceWhere"]: GraphQLTypes["ReferenceWhere"];
	["ItemDeclensionSeventhVariantWhere"]: GraphQLTypes["ItemDeclensionSeventhVariantWhere"];
	["ItemAliasWhere"]: GraphQLTypes["ItemAliasWhere"];
	["ItemGroupWhere"]: GraphQLTypes["ItemGroupWhere"];
	["RedirectOrderBy"]: GraphQLTypes["RedirectOrderBy"];
	["OrderDirection"]: GraphQLTypes["OrderDirection"];
	["GenericPageOrderBy"]: GraphQLTypes["GenericPageOrderBy"];
	["LinkableOrderBy"]: GraphQLTypes["LinkableOrderBy"];
	["SeoOrderBy"]: GraphQLTypes["SeoOrderBy"];
	["ImageOrderBy"]: GraphQLTypes["ImageOrderBy"];
	["BlogPageOrderBy"]: GraphQLTypes["BlogPageOrderBy"];
	["ContentOrderBy"]: GraphQLTypes["ContentOrderBy"];
	["BrandsPageOrderBy"]: GraphQLTypes["BrandsPageOrderBy"];
	["ComparatorPageOrderBy"]: GraphQLTypes["ComparatorPageOrderBy"];
	["HomePageOrderBy"]: GraphQLTypes["HomePageOrderBy"];
	["IngredientsPageOrderBy"]: GraphQLTypes["IngredientsPageOrderBy"];
	["LoginPageOrderBy"]: GraphQLTypes["LoginPageOrderBy"];
	["RegisterPageOrderBy"]: GraphQLTypes["RegisterPageOrderBy"];
	["SearchPageOrderBy"]: GraphQLTypes["SearchPageOrderBy"];
	["WizardPageOrderBy"]: GraphQLTypes["WizardPageOrderBy"];
	["ContactPageOrderBy"]: GraphQLTypes["ContactPageOrderBy"];
	["ItemCategoryOrderBy"]: GraphQLTypes["ItemCategoryOrderBy"];
	["ItemGroupOrderBy"]: GraphQLTypes["ItemGroupOrderBy"];
	["BlogPostOrderBy"]: GraphQLTypes["BlogPostOrderBy"];
	["ReferenceListOrderBy"]: GraphQLTypes["ReferenceListOrderBy"];
	["UserOrderBy"]: GraphQLTypes["UserOrderBy"];
	["VeterinaryOrderBy"]: GraphQLTypes["VeterinaryOrderBy"];
	["TenantPersonOrderBy"]: GraphQLTypes["TenantPersonOrderBy"];
	["Seo"]: {
		_meta?:ModelTypes["SeoMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	description?:string,
	ogTitle?:string,
	ogDescription?:string,
	ogImage?:ModelTypes["Image"],
	blogPage?:ModelTypes["BlogPage"],
	brandsPage?:ModelTypes["BrandsPage"],
	comparatorPage?:ModelTypes["ComparatorPage"],
	genericPage?:ModelTypes["GenericPage"],
	homePage?:ModelTypes["HomePage"],
	ingredientsPage?:ModelTypes["IngredientsPage"],
	loginPage?:ModelTypes["LoginPage"],
	registerPage?:ModelTypes["RegisterPage"],
	searchPage?:ModelTypes["SearchPage"],
	wizardPage?:ModelTypes["WizardPage"],
	contactPage?:ModelTypes["ContactPage"],
	group:ModelTypes["GroupType"],
	url?:string
};
	["SeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	ogTitle?:ModelTypes["FieldMeta"],
	ogDescription?:ModelTypes["FieldMeta"],
	ogImage?:ModelTypes["FieldMeta"],
	blogPage?:ModelTypes["FieldMeta"],
	brandsPage?:ModelTypes["FieldMeta"],
	comparatorPage?:ModelTypes["FieldMeta"],
	genericPage?:ModelTypes["FieldMeta"],
	homePage?:ModelTypes["FieldMeta"],
	ingredientsPage?:ModelTypes["FieldMeta"],
	loginPage?:ModelTypes["FieldMeta"],
	registerPage?:ModelTypes["FieldMeta"],
	searchPage?:ModelTypes["FieldMeta"],
	wizardPage?:ModelTypes["FieldMeta"],
	contactPage?:ModelTypes["FieldMeta"],
	group?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"]
};
	["Image"]: {
		_meta?:ModelTypes["ImageMeta"],
	id:ModelTypes["UUID"],
	url:string,
	width?:number,
	height?:number,
	size?:number,
	type?:string,
	alt?:string,
	remoteId?:string,
	hash?:string
};
	["ImageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	alt?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	hash?:ModelTypes["FieldMeta"]
};
	["BrandsPage"]: {
		_meta?:ModelTypes["BrandsPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	title?:string,
	redirects:ModelTypes["Redirect"][],
	seo?:ModelTypes["Seo"],
	content?:ModelTypes["Content"],
	draft?:ModelTypes["Content"],
	redirectsByFrom?:ModelTypes["Redirect"],
	paginateRedirects:ModelTypes["RedirectConnection"]
};
	["BrandsPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	redirects?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	draft?:ModelTypes["FieldMeta"]
};
	["Content"]: {
		_meta?:ModelTypes["ContentMeta"],
	id:ModelTypes["UUID"],
	blocks:ModelTypes["ContentBlock"][],
	blocksByAutomatedContentBlockSlug?:ModelTypes["ContentBlock"],
	blocksByReferences?:ModelTypes["ContentBlock"],
	paginateBlocks:ModelTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	blocks?:ModelTypes["FieldMeta"]
};
	["ContentBlock"]: {
		_meta?:ModelTypes["ContentBlockMeta"],
	id:ModelTypes["UUID"],
	order:number,
	json:string,
	content?:ModelTypes["Content"],
	references:ModelTypes["ContentReference"][],
	automatedContentBlockSlug?:string,
	referencesByImages?:ModelTypes["ContentReference"],
	referencesByLink?:ModelTypes["ContentReference"],
	referencesByList?:ModelTypes["ContentReference"],
	referencesByOutline?:ModelTypes["ContentReference"],
	referencesByVideo?:ModelTypes["ContentReference"],
	referencesByImage?:ModelTypes["ContentReference"],
	paginateReferences:ModelTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	json?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	references?:ModelTypes["FieldMeta"],
	automatedContentBlockSlug?:ModelTypes["FieldMeta"]
};
	["ContentReference"]: {
		_meta?:ModelTypes["ContentReferenceMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["ContentReferenceType"],
	block?:ModelTypes["ContentBlock"],
	primaryText?:string,
	secondaryText?:string,
	fact?:string,
	images:ModelTypes["ContentReferenceGalleryImage"][],
	relatedBlogPost?:ModelTypes["BlogPost"],
	relatedBrand?:ModelTypes["Brand"],
	relatedProduct?:ModelTypes["Product"],
	relatedIngredient?:ModelTypes["Item"],
	link?:ModelTypes["Link"],
	badge?:string,
	longVersion?:boolean,
	relatedBrandFull?:ModelTypes["Brand"],
	relatedProductFull?:ModelTypes["Product"],
	list:ModelTypes["ContentReferenceList"][],
	outline?:ModelTypes["ContentLinks"],
	video?:ModelTypes["Video"],
	image?:ModelTypes["ContentReferenceImage"],
	defaultOpen?:boolean,
	badgeColor?:string,
	isMain?:boolean,
	ad?:ModelTypes["Ad"],
	paginateImages:ModelTypes["ContentReferenceGalleryImageConnection"],
	paginateList:ModelTypes["ContentReferenceListConnection"]
};
	["ContentReferenceMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	block?:ModelTypes["FieldMeta"],
	primaryText?:ModelTypes["FieldMeta"],
	secondaryText?:ModelTypes["FieldMeta"],
	fact?:ModelTypes["FieldMeta"],
	images?:ModelTypes["FieldMeta"],
	relatedBlogPost?:ModelTypes["FieldMeta"],
	relatedBrand?:ModelTypes["FieldMeta"],
	relatedProduct?:ModelTypes["FieldMeta"],
	relatedIngredient?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	badge?:ModelTypes["FieldMeta"],
	longVersion?:ModelTypes["FieldMeta"],
	relatedBrandFull?:ModelTypes["FieldMeta"],
	relatedProductFull?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	outline?:ModelTypes["FieldMeta"],
	video?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	defaultOpen?:ModelTypes["FieldMeta"],
	badgeColor?:ModelTypes["FieldMeta"],
	isMain?:ModelTypes["FieldMeta"],
	ad?:ModelTypes["FieldMeta"]
};
	["ContentReferenceGalleryImage"]: {
		_meta?:ModelTypes["ContentReferenceGalleryImageMeta"],
	id:ModelTypes["UUID"],
	order:number,
	reference?:ModelTypes["ContentReference"],
	image?:ModelTypes["Image"],
	lead?:string,
	alignment?:ModelTypes["AlignmentType"]
};
	["ContentReferenceGalleryImageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	reference?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	alignment?:ModelTypes["FieldMeta"]
};
	["ContentReferenceGalleryImageOrderBy"]: GraphQLTypes["ContentReferenceGalleryImageOrderBy"];
	["ContentReferenceOrderBy"]: GraphQLTypes["ContentReferenceOrderBy"];
	["ContentBlockOrderBy"]: GraphQLTypes["ContentBlockOrderBy"];
	["BrandOrderBy"]: GraphQLTypes["BrandOrderBy"];
	["ProductionMethodOrderBy"]: GraphQLTypes["ProductionMethodOrderBy"];
	["BrandDistributorOrderBy"]: GraphQLTypes["BrandDistributorOrderBy"];
	["ProductOrderBy"]: GraphQLTypes["ProductOrderBy"];
	["ProductLineOrderBy"]: GraphQLTypes["ProductLineOrderBy"];
	["DogActivityOrderBy"]: GraphQLTypes["DogActivityOrderBy"];
	["SuitabilityCategoryOrderBy"]: GraphQLTypes["SuitabilityCategoryOrderBy"];
	["ProductEvaluationOrderBy"]: GraphQLTypes["ProductEvaluationOrderBy"];
	["ItemOrderBy"]: GraphQLTypes["ItemOrderBy"];
	["ItemDeclensionFourthVariantOrderBy"]: GraphQLTypes["ItemDeclensionFourthVariantOrderBy"];
	["ItemSubCategoryOrderBy"]: GraphQLTypes["ItemSubCategoryOrderBy"];
	["ItemFlavorCategoryOrderBy"]: GraphQLTypes["ItemFlavorCategoryOrderBy"];
	["ColorOrderBy"]: GraphQLTypes["ColorOrderBy"];
	["BodyTagCategoryOrderBy"]: GraphQLTypes["BodyTagCategoryOrderBy"];
	["BlogPostTagOrderBy"]: GraphQLTypes["BlogPostTagOrderBy"];
	["ElementOrderBy"]: GraphQLTypes["ElementOrderBy"];
	["ItemDeclensionSeventhVariantOrderBy"]: GraphQLTypes["ItemDeclensionSeventhVariantOrderBy"];
	["LinkOrderBy"]: GraphQLTypes["LinkOrderBy"];
	["ContentLinksOrderBy"]: GraphQLTypes["ContentLinksOrderBy"];
	["VideoOrderBy"]: GraphQLTypes["VideoOrderBy"];
	["ContentReferenceImageOrderBy"]: GraphQLTypes["ContentReferenceImageOrderBy"];
	["AdOrderBy"]: GraphQLTypes["AdOrderBy"];
	["BlogPost"]: {
		_meta?:ModelTypes["BlogPostMeta"],
	id:ModelTypes["UUID"],
	author?:string,
	readingTime?:string,
	publishedAt?:ModelTypes["DateTime"],
	blogPostTags:ModelTypes["BlogPostTag"][],
	tags:ModelTypes["BodyTag"][],
	title:string,
	listedOnHomePage:boolean,
	reviews:ModelTypes["BlogPostReview"][],
	itemCategories:ModelTypes["ItemCategory"][],
	items:ModelTypes["Item"][],
	image?:ModelTypes["Image"],
	referenceList?:ModelTypes["ReferenceList"],
	user?:ModelTypes["User"],
	isComparatorLinked?:boolean,
	ads:ModelTypes["Ad"][],
	slug?:string,
	lead?:string,
	seo?:ModelTypes["Seo"],
	createdAt?:ModelTypes["DateTime"],
	note?:string,
	isActive:boolean,
	redirects:ModelTypes["Redirect"][],
	automated:boolean,
	content?:ModelTypes["Content"],
	draft?:ModelTypes["Content"],
	slugInternal?:string,
	reviewsByBlogPostReviewReactions?:ModelTypes["BlogPostReview"],
	reviewsByStats?:ModelTypes["BlogPostReview"],
	itemsByRemoteId?:ModelTypes["Item"],
	itemsBySlug?:ModelTypes["Item"],
	itemsByFeaturesOfProduct?:ModelTypes["Item"],
	itemsByImage?:ModelTypes["Item"],
	itemsByReferenceList?:ModelTypes["Item"],
	itemsBySeo?:ModelTypes["Item"],
	itemsByAliases?:ModelTypes["Item"],
	itemsByContent?:ModelTypes["Item"],
	itemsByDraft?:ModelTypes["Item"],
	redirectsByFrom?:ModelTypes["Redirect"],
	paginateBlogPostTags:ModelTypes["BlogPostTagConnection"],
	paginateTags:ModelTypes["BodyTagConnection"],
	paginateReviews:ModelTypes["BlogPostReviewConnection"],
	paginateItemCategories:ModelTypes["ItemCategoryConnection"],
	paginateItems:ModelTypes["ItemConnection"],
	paginateAds:ModelTypes["AdConnection"],
	paginateRedirects:ModelTypes["RedirectConnection"]
};
	["BlogPostMeta"]: {
		id?:ModelTypes["FieldMeta"],
	author?:ModelTypes["FieldMeta"],
	readingTime?:ModelTypes["FieldMeta"],
	publishedAt?:ModelTypes["FieldMeta"],
	blogPostTags?:ModelTypes["FieldMeta"],
	tags?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	listedOnHomePage?:ModelTypes["FieldMeta"],
	reviews?:ModelTypes["FieldMeta"],
	itemCategories?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	referenceList?:ModelTypes["FieldMeta"],
	user?:ModelTypes["FieldMeta"],
	isComparatorLinked?:ModelTypes["FieldMeta"],
	ads?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"],
	note?:ModelTypes["FieldMeta"],
	isActive?:ModelTypes["FieldMeta"],
	redirects?:ModelTypes["FieldMeta"],
	automated?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	draft?:ModelTypes["FieldMeta"],
	slugInternal?:ModelTypes["FieldMeta"]
};
	["BlogPostTag"]: {
		_meta?:ModelTypes["BlogPostTagMeta"],
	id:ModelTypes["UUID"],
	name:string,
	blogPosts:ModelTypes["BlogPost"][],
	remoteId:string,
	color?:ModelTypes["Color"],
	order?:number,
	paginateBlogPosts:ModelTypes["BlogPostConnection"]
};
	["BlogPostTagMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	blogPosts?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	color?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"]
};
	["Color"]: {
		_meta?:ModelTypes["ColorMeta"],
	id:ModelTypes["UUID"],
	name?:string,
	colorHex?:string,
	bodyTagCategory?:ModelTypes["BodyTagCategory"],
	blogPostTag?:ModelTypes["BlogPostTag"],
	remoteId?:string,
	itemFlavorCategories:ModelTypes["ItemFlavorCategory"][],
	itemFlavorCategoriesByRemoteId?:ModelTypes["ItemFlavorCategory"],
	itemFlavorCategoriesByItems?:ModelTypes["ItemFlavorCategory"],
	paginateItemFlavorCategories:ModelTypes["ItemFlavorCategoryConnection"]
};
	["ColorMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	colorHex?:ModelTypes["FieldMeta"],
	bodyTagCategory?:ModelTypes["FieldMeta"],
	blogPostTag?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	itemFlavorCategories?:ModelTypes["FieldMeta"]
};
	["BodyTagCategory"]: {
		_meta?:ModelTypes["BodyTagCategoryMeta"],
	id:ModelTypes["UUID"],
	name:string,
	tags:ModelTypes["BodyTag"][],
	remoteId:string,
	color?:ModelTypes["Color"],
	tagsByRemoteId?:ModelTypes["BodyTag"],
	tagsByFilterCombos?:ModelTypes["BodyTag"],
	paginateTags:ModelTypes["BodyTagConnection"]
};
	["BodyTagCategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	tags?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	color?:ModelTypes["FieldMeta"]
};
	["BodyTag"]: {
		_meta?:ModelTypes["BodyTagMeta"],
	id:ModelTypes["UUID"],
	name:string,
	blogPosts:ModelTypes["BlogPost"][],
	positiveProducts:ModelTypes["Product"][],
	negativeProducts:ModelTypes["Product"][],
	positiveItems:ModelTypes["Item"][],
	negativeItems:ModelTypes["Item"][],
	remoteId:string,
	category?:ModelTypes["BodyTagCategory"],
	icon?:ModelTypes["Image"],
	dogs:ModelTypes["Dog"][],
	labelFor?:string,
	slug?:string,
	filterCombos:ModelTypes["FilterCombo"][],
	filterCombosByRemoteId?:ModelTypes["FilterCombo"],
	filterCombosBySeo?:ModelTypes["FilterCombo"],
	paginateBlogPosts:ModelTypes["BlogPostConnection"],
	paginatePositiveProducts:ModelTypes["ProductConnection"],
	paginateNegativeProducts:ModelTypes["ProductConnection"],
	paginatePositiveItems:ModelTypes["ItemConnection"],
	paginateNegativeItems:ModelTypes["ItemConnection"],
	paginateDogs:ModelTypes["DogConnection"],
	paginateFilterCombos:ModelTypes["FilterComboConnection"]
};
	["BodyTagMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	blogPosts?:ModelTypes["FieldMeta"],
	positiveProducts?:ModelTypes["FieldMeta"],
	negativeProducts?:ModelTypes["FieldMeta"],
	positiveItems?:ModelTypes["FieldMeta"],
	negativeItems?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	category?:ModelTypes["FieldMeta"],
	icon?:ModelTypes["FieldMeta"],
	dogs?:ModelTypes["FieldMeta"],
	labelFor?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	filterCombos?:ModelTypes["FieldMeta"]
};
	["Product"]: {
		_meta?:ModelTypes["ProductMeta"],
	id:ModelTypes["UUID"],
	nutritionalValues:ModelTypes["NutritionalValueOfProduct"][],
	name:string,
	positiveForBodyTags:ModelTypes["BodyTag"][],
	negativeForBodyTags:ModelTypes["BodyTag"][],
	reviews:ModelTypes["ProductReview"][],
	score?:number,
	dogs:ModelTypes["Dog"][],
	firstFiveItems?:string,
	detailedComposition?:string,
	guaranteedAnalysis?:string,
	isVeterinaryDiet:boolean,
	packagings:ModelTypes["ProductPackage"][],
	itemSubCategories:ModelTypes["ItemSubCategory"][],
	itemCategories:ModelTypes["ItemCategory"][],
	elements:ModelTypes["ElementOfProduct"][],
	isSearchVisible:boolean,
	isSuitableForEliminationDiet:boolean,
	remoteId:string,
	recommendedDogSizes:ModelTypes["DogSize"][],
	granuleSizes:ModelTypes["GranuleSize"][],
	productLine?:ModelTypes["ProductLine"],
	flags:ModelTypes["ProductFlagOfProduct"][],
	image?:ModelTypes["Image"],
	recommendedActivity?:ModelTypes["DogActivity"],
	brand?:ModelTypes["Brand"],
	metabolizedEnergy?:number,
	cheapnessValue?:number,
	aliases:ModelTypes["ProductAlias"][],
	slug?:string,
	animalProteinStatus?:ModelTypes["ContentAmount"],
	carbohydrateStatus?:ModelTypes["ContentAmount"],
	evaluation?:ModelTypes["ProductEvaluation"],
	missingComposition:boolean,
	seo?:ModelTypes["Seo"],
	czkPerMetabolizedEnergy?:number,
	itemDeclensionFourthCategories:ModelTypes["ProductItemDeclensionFourthCategory"][],
	ageCategories:ModelTypes["AgeCategory"][],
	customMetaTitle?:string,
	customMetaDescription?:string,
	isSuitableForCastrated:boolean,
	heurekaImage?:ModelTypes["Image"],
	topx:ModelTypes["TOPXProduct"][],
	nutritionalValuesByRemoteId?:ModelTypes["NutritionalValueOfProduct"],
	reviewsByProductReviewReactions?:ModelTypes["ProductReview"],
	reviewsByStats?:ModelTypes["ProductReview"],
	dogsByReproduction?:ModelTypes["Dog"],
	dogsByAvatar?:ModelTypes["Dog"],
	packagingsByRemoteId?:ModelTypes["ProductPackage"],
	packagingsByPositionId?:ModelTypes["ProductPackage"],
	packagingsByExternalId?:ModelTypes["ProductPackage"],
	elementsByRemoteId?:ModelTypes["ElementOfProduct"],
	flagsByRemoteId?:ModelTypes["ProductFlagOfProduct"],
	aliasesByRemoteId?:ModelTypes["ProductAlias"],
	topxByRemoteId?:ModelTypes["TOPXProduct"],
	paginateNutritionalValues:ModelTypes["NutritionalValueOfProductConnection"],
	paginatePositiveForBodyTags:ModelTypes["BodyTagConnection"],
	paginateNegativeForBodyTags:ModelTypes["BodyTagConnection"],
	paginateReviews:ModelTypes["ProductReviewConnection"],
	paginateDogs:ModelTypes["DogConnection"],
	paginatePackagings:ModelTypes["ProductPackageConnection"],
	paginateItemSubCategories:ModelTypes["ItemSubCategoryConnection"],
	paginateItemCategories:ModelTypes["ItemCategoryConnection"],
	paginateElements:ModelTypes["ElementOfProductConnection"],
	paginateRecommendedDogSizes:ModelTypes["DogSizeConnection"],
	paginateGranuleSizes:ModelTypes["GranuleSizeConnection"],
	paginateFlags:ModelTypes["ProductFlagOfProductConnection"],
	paginateAliases:ModelTypes["ProductAliasConnection"],
	paginateItemDeclensionFourthCategories:ModelTypes["ProductItemDeclensionFourthCategoryConnection"],
	paginateAgeCategories:ModelTypes["AgeCategoryConnection"],
	paginateTopx:ModelTypes["TOPXProductConnection"]
};
	["ProductMeta"]: {
		id?:ModelTypes["FieldMeta"],
	nutritionalValues?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	positiveForBodyTags?:ModelTypes["FieldMeta"],
	negativeForBodyTags?:ModelTypes["FieldMeta"],
	reviews?:ModelTypes["FieldMeta"],
	score?:ModelTypes["FieldMeta"],
	dogs?:ModelTypes["FieldMeta"],
	firstFiveItems?:ModelTypes["FieldMeta"],
	detailedComposition?:ModelTypes["FieldMeta"],
	guaranteedAnalysis?:ModelTypes["FieldMeta"],
	isVeterinaryDiet?:ModelTypes["FieldMeta"],
	packagings?:ModelTypes["FieldMeta"],
	itemSubCategories?:ModelTypes["FieldMeta"],
	itemCategories?:ModelTypes["FieldMeta"],
	elements?:ModelTypes["FieldMeta"],
	isSearchVisible?:ModelTypes["FieldMeta"],
	isSuitableForEliminationDiet?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	recommendedDogSizes?:ModelTypes["FieldMeta"],
	granuleSizes?:ModelTypes["FieldMeta"],
	productLine?:ModelTypes["FieldMeta"],
	flags?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	recommendedActivity?:ModelTypes["FieldMeta"],
	brand?:ModelTypes["FieldMeta"],
	metabolizedEnergy?:ModelTypes["FieldMeta"],
	cheapnessValue?:ModelTypes["FieldMeta"],
	aliases?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	animalProteinStatus?:ModelTypes["FieldMeta"],
	carbohydrateStatus?:ModelTypes["FieldMeta"],
	evaluation?:ModelTypes["FieldMeta"],
	missingComposition?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	czkPerMetabolizedEnergy?:ModelTypes["FieldMeta"],
	itemDeclensionFourthCategories?:ModelTypes["FieldMeta"],
	ageCategories?:ModelTypes["FieldMeta"],
	customMetaTitle?:ModelTypes["FieldMeta"],
	customMetaDescription?:ModelTypes["FieldMeta"],
	isSuitableForCastrated?:ModelTypes["FieldMeta"],
	heurekaImage?:ModelTypes["FieldMeta"],
	topx?:ModelTypes["FieldMeta"]
};
	["NutritionalValueOfProduct"]: {
		_meta?:ModelTypes["NutritionalValueOfProductMeta"],
	id:ModelTypes["UUID"],
	order:number,
	product?:ModelTypes["Product"],
	amount?:number,
	remoteId:string,
	nutritionalValue?:ModelTypes["NutritionalValue"]
};
	["NutritionalValueOfProductMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	product?:ModelTypes["FieldMeta"],
	amount?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	nutritionalValue?:ModelTypes["FieldMeta"]
};
	["NutritionalValue"]: {
		_meta?:ModelTypes["NutritionalValueMeta"],
	id:ModelTypes["UUID"],
	name:string,
	products:ModelTypes["NutritionalValueOfProduct"][],
	suitabilityNutritionalValues:ModelTypes["SuitabilityItem"][],
	remoteId:string,
	icon?:ModelTypes["Image"],
	productsByRemoteId?:ModelTypes["NutritionalValueOfProduct"],
	suitabilityNutritionalValuesByRemoteId?:ModelTypes["SuitabilityItem"],
	paginateProducts:ModelTypes["NutritionalValueOfProductConnection"],
	paginateSuitabilityNutritionalValues:ModelTypes["SuitabilityItemConnection"]
};
	["NutritionalValueMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	suitabilityNutritionalValues?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	icon?:ModelTypes["FieldMeta"]
};
	["NutritionalValueOfProductOrderBy"]: GraphQLTypes["NutritionalValueOfProductOrderBy"];
	["NutritionalValueOrderBy"]: GraphQLTypes["NutritionalValueOrderBy"];
	["SuitabilityItem"]: {
		_meta?:ModelTypes["SuitabilityItemMeta"],
	id:ModelTypes["UUID"],
	min?:number,
	max?:number,
	remoteId:string,
	order?:number,
	element?:ModelTypes["Element"],
	nutritionalValue?:ModelTypes["NutritionalValue"],
	category?:ModelTypes["SuitabilityCategory"]
};
	["SuitabilityItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	min?:ModelTypes["FieldMeta"],
	max?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	element?:ModelTypes["FieldMeta"],
	nutritionalValue?:ModelTypes["FieldMeta"],
	category?:ModelTypes["FieldMeta"]
};
	["Element"]: {
		_meta?:ModelTypes["ElementMeta"],
	id:ModelTypes["UUID"],
	name:string,
	products:ModelTypes["ElementOfProduct"][],
	featureDependencies:ModelTypes["ProductFeature"][],
	suitabilityElements:ModelTypes["SuitabilityItem"][],
	remoteId:string,
	unit?:string,
	filterOrder?:number,
	slug?:string,
	declensionSeventh?:string,
	productsByRemoteId?:ModelTypes["ElementOfProduct"],
	featureDependenciesByRemoteId?:ModelTypes["ProductFeature"],
	suitabilityElementsByRemoteId?:ModelTypes["SuitabilityItem"],
	paginateProducts:ModelTypes["ElementOfProductConnection"],
	paginateFeatureDependencies:ModelTypes["ProductFeatureConnection"],
	paginateSuitabilityElements:ModelTypes["SuitabilityItemConnection"]
};
	["ElementMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	featureDependencies?:ModelTypes["FieldMeta"],
	suitabilityElements?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	unit?:ModelTypes["FieldMeta"],
	filterOrder?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	declensionSeventh?:ModelTypes["FieldMeta"]
};
	["ElementOfProduct"]: {
		_meta?:ModelTypes["ElementOfProductMeta"],
	id:ModelTypes["UUID"],
	order:number,
	amount?:number,
	product?:ModelTypes["Product"],
	remoteId:string,
	element?:ModelTypes["Element"]
};
	["ElementOfProductMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	amount?:ModelTypes["FieldMeta"],
	product?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	element?:ModelTypes["FieldMeta"]
};
	["ElementOfProductOrderBy"]: GraphQLTypes["ElementOfProductOrderBy"];
	["ProductFeature"]: {
		_meta?:ModelTypes["ProductFeatureMeta"],
	id:ModelTypes["UUID"],
	text:string,
	category?:ModelTypes["FeatureCategoryType"],
	value?:ModelTypes["FeatureValueType"],
	remoteId:string,
	linkItem?:ModelTypes["Item"],
	dependentElement?:ModelTypes["Element"],
	dependentCategory?:ModelTypes["ItemCategory"],
	dependentSubCategory?:ModelTypes["ItemSubCategory"],
	dependentFlag?:ModelTypes["ProductFlag"]
};
	["ProductFeatureMeta"]: {
		id?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	category?:ModelTypes["FieldMeta"],
	value?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	linkItem?:ModelTypes["FieldMeta"],
	dependentElement?:ModelTypes["FieldMeta"],
	dependentCategory?:ModelTypes["FieldMeta"],
	dependentSubCategory?:ModelTypes["FieldMeta"],
	dependentFlag?:ModelTypes["FieldMeta"]
};
	["Item"]: {
		_meta?:ModelTypes["ItemMeta"],
	id:ModelTypes["UUID"],
	name:string,
	positiveForBodyTags:ModelTypes["BodyTag"][],
	negativeForBodyTags:ModelTypes["BodyTag"][],
	subCategories:ModelTypes["ItemSubCategory"][],
	categories:ModelTypes["ItemCategory"][],
	lead?:string,
	animalProteinStatus?:ModelTypes["ContentAmount"],
	carbohydrateStatus?:ModelTypes["ContentAmount"],
	featuresOfProduct:ModelTypes["ProductFeature"][],
	remoteId:string,
	image?:ModelTypes["Image"],
	referenceList?:ModelTypes["ReferenceList"],
	blogPost?:ModelTypes["BlogPost"],
	declensionFourth?:ModelTypes["ItemDeclensionFourthVariant"],
	declensionSeventh?:ModelTypes["ItemDeclensionSeventhVariant"],
	slug?:string,
	seo?:ModelTypes["Seo"],
	aliases:ModelTypes["ItemAlias"][],
	content?:ModelTypes["Content"],
	draft?:ModelTypes["Content"],
	featuresOfProductByRemoteId?:ModelTypes["ProductFeature"],
	aliasesByRemoteId?:ModelTypes["ItemAlias"],
	paginatePositiveForBodyTags:ModelTypes["BodyTagConnection"],
	paginateNegativeForBodyTags:ModelTypes["BodyTagConnection"],
	paginateSubCategories:ModelTypes["ItemSubCategoryConnection"],
	paginateCategories:ModelTypes["ItemCategoryConnection"],
	paginateFeaturesOfProduct:ModelTypes["ProductFeatureConnection"],
	paginateAliases:ModelTypes["ItemAliasConnection"]
};
	["ItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	positiveForBodyTags?:ModelTypes["FieldMeta"],
	negativeForBodyTags?:ModelTypes["FieldMeta"],
	subCategories?:ModelTypes["FieldMeta"],
	categories?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	animalProteinStatus?:ModelTypes["FieldMeta"],
	carbohydrateStatus?:ModelTypes["FieldMeta"],
	featuresOfProduct?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	referenceList?:ModelTypes["FieldMeta"],
	blogPost?:ModelTypes["FieldMeta"],
	declensionFourth?:ModelTypes["FieldMeta"],
	declensionSeventh?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	aliases?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	draft?:ModelTypes["FieldMeta"]
};
	["BodyTagOrderBy"]: GraphQLTypes["BodyTagOrderBy"];
	["ItemSubCategory"]: {
		_meta?:ModelTypes["ItemSubCategoryMeta"],
	id:ModelTypes["UUID"],
	name:string,
	items:ModelTypes["Item"][],
	isFlavorCategory:boolean,
	isAllergenTag:boolean,
	isMostCommonAllergenTag:boolean,
	products:ModelTypes["Product"][],
	featureDependencies:ModelTypes["ProductFeature"][],
	remoteId:string,
	category?:ModelTypes["ItemCategory"],
	flavorCategory?:ModelTypes["ItemFlavorCategory"],
	dogs:ModelTypes["Dog"][],
	iconNegative?:ModelTypes["Image"],
	negativeWording?:string,
	icon?:ModelTypes["Image"],
	brands:ModelTypes["BrandFlavor"][],
	productLines:ModelTypes["ProductLineFlavor"][],
	slug?:string,
	flavorSlug?:string,
	flavorDeclensionSeventh?:string,
	filterCombosFlavor:ModelTypes["FilterCombo"][],
	filterCombosAllergy:ModelTypes["FilterCombo"][],
	isFilterFlavor:boolean,
	featureDependenciesByRemoteId?:ModelTypes["ProductFeature"],
	filterCombosFlavorByRemoteId?:ModelTypes["FilterCombo"],
	filterCombosFlavorBySeo?:ModelTypes["FilterCombo"],
	filterCombosAllergyByRemoteId?:ModelTypes["FilterCombo"],
	filterCombosAllergyBySeo?:ModelTypes["FilterCombo"],
	paginateItems:ModelTypes["ItemConnection"],
	paginateProducts:ModelTypes["ProductConnection"],
	paginateFeatureDependencies:ModelTypes["ProductFeatureConnection"],
	paginateDogs:ModelTypes["DogConnection"],
	paginateBrands:ModelTypes["BrandFlavorConnection"],
	paginateProductLines:ModelTypes["ProductLineFlavorConnection"],
	paginateFilterCombosFlavor:ModelTypes["FilterComboConnection"],
	paginateFilterCombosAllergy:ModelTypes["FilterComboConnection"]
};
	["ItemSubCategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	isFlavorCategory?:ModelTypes["FieldMeta"],
	isAllergenTag?:ModelTypes["FieldMeta"],
	isMostCommonAllergenTag?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	featureDependencies?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	category?:ModelTypes["FieldMeta"],
	flavorCategory?:ModelTypes["FieldMeta"],
	dogs?:ModelTypes["FieldMeta"],
	iconNegative?:ModelTypes["FieldMeta"],
	negativeWording?:ModelTypes["FieldMeta"],
	icon?:ModelTypes["FieldMeta"],
	brands?:ModelTypes["FieldMeta"],
	productLines?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	flavorSlug?:ModelTypes["FieldMeta"],
	flavorDeclensionSeventh?:ModelTypes["FieldMeta"],
	filterCombosFlavor?:ModelTypes["FieldMeta"],
	filterCombosAllergy?:ModelTypes["FieldMeta"],
	isFilterFlavor?:ModelTypes["FieldMeta"]
};
	["ProductFeatureOrderBy"]: GraphQLTypes["ProductFeatureOrderBy"];
	["ProductFlagOrderBy"]: GraphQLTypes["ProductFlagOrderBy"];
	["ItemCategory"]: {
		_meta?:ModelTypes["ItemCategoryMeta"],
	id:ModelTypes["UUID"],
	name:string,
	shortDescription?:string,
	subCategories:ModelTypes["ItemSubCategory"][],
	blogPosts:ModelTypes["BlogPost"][],
	items:ModelTypes["Item"][],
	products:ModelTypes["Product"][],
	featureDependencies:ModelTypes["ProductFeature"][],
	declensionSixth?:string,
	remoteId:string,
	image?:ModelTypes["Image"],
	comparatorGroupId?:string,
	ads:ModelTypes["Ad"][],
	slug?:string,
	redirects:ModelTypes["Redirect"][],
	declensionsFourth:ModelTypes["ItemDeclensionFourthVariant"][],
	seo?:ModelTypes["Seo"],
	group?:ModelTypes["ItemGroup"],
	declensionSeventh?:string,
	slugWith?:string,
	slugWithNegative?:string,
	declensionSeventhNegative?:string,
	content?:ModelTypes["Content"],
	draft?:ModelTypes["Content"],
	subCategoriesByRemoteId?:ModelTypes["ItemSubCategory"],
	subCategoriesBySlug?:ModelTypes["ItemSubCategory"],
	subCategoriesByFeatureDependencies?:ModelTypes["ItemSubCategory"],
	subCategoriesByBrands?:ModelTypes["ItemSubCategory"],
	subCategoriesByProductLines?:ModelTypes["ItemSubCategory"],
	subCategoriesByFilterCombosFlavor?:ModelTypes["ItemSubCategory"],
	subCategoriesByFilterCombosAllergy?:ModelTypes["ItemSubCategory"],
	featureDependenciesByRemoteId?:ModelTypes["ProductFeature"],
	redirectsByFrom?:ModelTypes["Redirect"],
	declensionsFourthByRemoteId?:ModelTypes["ItemDeclensionFourthVariant"],
	declensionsFourthBySlug?:ModelTypes["ItemDeclensionFourthVariant"],
	declensionsFourthByItems?:ModelTypes["ItemDeclensionFourthVariant"],
	declensionsFourthBySeo?:ModelTypes["ItemDeclensionFourthVariant"],
	declensionsFourthBySubcategory?:ModelTypes["ItemDeclensionFourthVariant"],
	declensionsFourthByElement?:ModelTypes["ItemDeclensionFourthVariant"],
	declensionsFourthByProducts?:ModelTypes["ItemDeclensionFourthVariant"],
	declensionsFourthByContent?:ModelTypes["ItemDeclensionFourthVariant"],
	declensionsFourthByDraft?:ModelTypes["ItemDeclensionFourthVariant"],
	paginateSubCategories:ModelTypes["ItemSubCategoryConnection"],
	paginateBlogPosts:ModelTypes["BlogPostConnection"],
	paginateItems:ModelTypes["ItemConnection"],
	paginateProducts:ModelTypes["ProductConnection"],
	paginateFeatureDependencies:ModelTypes["ProductFeatureConnection"],
	paginateAds:ModelTypes["AdConnection"],
	paginateRedirects:ModelTypes["RedirectConnection"],
	paginateDeclensionsFourth:ModelTypes["ItemDeclensionFourthVariantConnection"]
};
	["ItemCategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	shortDescription?:ModelTypes["FieldMeta"],
	subCategories?:ModelTypes["FieldMeta"],
	blogPosts?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	featureDependencies?:ModelTypes["FieldMeta"],
	declensionSixth?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	comparatorGroupId?:ModelTypes["FieldMeta"],
	ads?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	redirects?:ModelTypes["FieldMeta"],
	declensionsFourth?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	group?:ModelTypes["FieldMeta"],
	declensionSeventh?:ModelTypes["FieldMeta"],
	slugWith?:ModelTypes["FieldMeta"],
	slugWithNegative?:ModelTypes["FieldMeta"],
	declensionSeventhNegative?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	draft?:ModelTypes["FieldMeta"]
};
	["Ad"]: {
		_meta?:ModelTypes["AdMeta"],
	id:ModelTypes["UUID"],
	image?:ModelTypes["Image"],
	isBrandSectionVisible?:boolean,
	isBlogPostSectionVisible?:boolean,
	isIngredientSectionVisible?:boolean,
	isResultsVisible?:boolean,
	isSearchVisible?:boolean,
	blogPosts:ModelTypes["BlogPost"][],
	itemCategories:ModelTypes["ItemCategory"][],
	brands:ModelTypes["Brand"][],
	isActive:boolean,
	link:string,
	note?:string,
	activeFrom?:ModelTypes["DateTime"],
	activeUntil?:ModelTypes["DateTime"],
	slug?:string,
	contentReferences:ModelTypes["ContentReference"][],
	contentReferencesByImages?:ModelTypes["ContentReference"],
	contentReferencesByLink?:ModelTypes["ContentReference"],
	contentReferencesByList?:ModelTypes["ContentReference"],
	contentReferencesByOutline?:ModelTypes["ContentReference"],
	contentReferencesByVideo?:ModelTypes["ContentReference"],
	contentReferencesByImage?:ModelTypes["ContentReference"],
	paginateBlogPosts:ModelTypes["BlogPostConnection"],
	paginateItemCategories:ModelTypes["ItemCategoryConnection"],
	paginateBrands:ModelTypes["BrandConnection"],
	paginateContentReferences:ModelTypes["ContentReferenceConnection"]
};
	["AdMeta"]: {
		id?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	isBrandSectionVisible?:ModelTypes["FieldMeta"],
	isBlogPostSectionVisible?:ModelTypes["FieldMeta"],
	isIngredientSectionVisible?:ModelTypes["FieldMeta"],
	isResultsVisible?:ModelTypes["FieldMeta"],
	isSearchVisible?:ModelTypes["FieldMeta"],
	blogPosts?:ModelTypes["FieldMeta"],
	itemCategories?:ModelTypes["FieldMeta"],
	brands?:ModelTypes["FieldMeta"],
	isActive?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	note?:ModelTypes["FieldMeta"],
	activeFrom?:ModelTypes["FieldMeta"],
	activeUntil?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	contentReferences?:ModelTypes["FieldMeta"]
};
	["Brand"]: {
		_meta?:ModelTypes["BrandMeta"],
	id:ModelTypes["UUID"],
	name:string,
	products:ModelTypes["Product"][],
	link?:string,
	countriesOfProduction:ModelTypes["Country"][],
	manufacturers:ModelTypes["BrandManufacturer"][],
	remoteId:string,
	promotedOnSearchPlace?:number,
	promotedOnBrandsPagePlace?:number,
	lead?:string,
	productLines:ModelTypes["ProductLine"][],
	logo?:ModelTypes["Image"],
	methodOfProduction?:ModelTypes["ProductionMethod"],
	distributor?:ModelTypes["BrandDistributor"],
	aliases:ModelTypes["BrandAlias"][],
	ads:ModelTypes["Ad"][],
	slug?:string,
	flavors:ModelTypes["BrandFlavor"][],
	seo?:ModelTypes["Seo"],
	customMetaDescription?:string,
	filterCombos:ModelTypes["FilterCombo"][],
	topx:ModelTypes["TOPXBrand"][],
	content?:ModelTypes["Content"],
	draft?:ModelTypes["Content"],
	productsByRemoteId?:ModelTypes["Product"],
	productsBySlug?:ModelTypes["Product"],
	productsByNutritionalValues?:ModelTypes["Product"],
	productsByReviews?:ModelTypes["Product"],
	productsByDogs?:ModelTypes["Product"],
	productsByPackagings?:ModelTypes["Product"],
	productsByElements?:ModelTypes["Product"],
	productsByFlags?:ModelTypes["Product"],
	productsByImage?:ModelTypes["Product"],
	productsByAliases?:ModelTypes["Product"],
	productsByEvaluation?:ModelTypes["Product"],
	productsBySeo?:ModelTypes["Product"],
	productsByItemDeclensionFourthCategories?:ModelTypes["Product"],
	productsByHeurekaImage?:ModelTypes["Product"],
	productsByTopx?:ModelTypes["Product"],
	productLinesByRemoteId?:ModelTypes["ProductLine"],
	productLinesBySlug?:ModelTypes["ProductLine"],
	productLinesByProducts?:ModelTypes["ProductLine"],
	productLinesByLogo?:ModelTypes["ProductLine"],
	productLinesByFlavors?:ModelTypes["ProductLine"],
	productLinesBySeo?:ModelTypes["ProductLine"],
	aliasesByRemoteId?:ModelTypes["BrandAlias"],
	filterCombosByRemoteId?:ModelTypes["FilterCombo"],
	filterCombosBySeo?:ModelTypes["FilterCombo"],
	topxByRemoteId?:ModelTypes["TOPXBrand"],
	paginateProducts:ModelTypes["ProductConnection"],
	paginateCountriesOfProduction:ModelTypes["CountryConnection"],
	paginateManufacturers:ModelTypes["BrandManufacturerConnection"],
	paginateProductLines:ModelTypes["ProductLineConnection"],
	paginateAliases:ModelTypes["BrandAliasConnection"],
	paginateAds:ModelTypes["AdConnection"],
	paginateFlavors:ModelTypes["BrandFlavorConnection"],
	paginateFilterCombos:ModelTypes["FilterComboConnection"],
	paginateTopx:ModelTypes["TOPXBrandConnection"]
};
	["BrandMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	countriesOfProduction?:ModelTypes["FieldMeta"],
	manufacturers?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	promotedOnSearchPlace?:ModelTypes["FieldMeta"],
	promotedOnBrandsPagePlace?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	productLines?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	methodOfProduction?:ModelTypes["FieldMeta"],
	distributor?:ModelTypes["FieldMeta"],
	aliases?:ModelTypes["FieldMeta"],
	ads?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	flavors?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	customMetaDescription?:ModelTypes["FieldMeta"],
	filterCombos?:ModelTypes["FieldMeta"],
	topx?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	draft?:ModelTypes["FieldMeta"]
};
	["Country"]: {
		_meta?:ModelTypes["CountryMeta"],
	id:ModelTypes["UUID"],
	name:string,
	brands:ModelTypes["Brand"][],
	manufacturers:ModelTypes["BrandManufacturer"][],
	remoteId:string,
	region?:ModelTypes["Region"],
	manufacturersByRemoteId?:ModelTypes["BrandManufacturer"],
	paginateBrands:ModelTypes["BrandConnection"],
	paginateManufacturers:ModelTypes["BrandManufacturerConnection"]
};
	["CountryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	brands?:ModelTypes["FieldMeta"],
	manufacturers?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	region?:ModelTypes["FieldMeta"]
};
	["BrandManufacturer"]: {
		_meta?:ModelTypes["BrandManufacturerMeta"],
	id:ModelTypes["UUID"],
	name:string,
	link?:string,
	brands:ModelTypes["Brand"][],
	order?:number,
	remoteId:string,
	residence?:ModelTypes["Country"],
	paginateBrands:ModelTypes["BrandConnection"]
};
	["BrandManufacturerMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	brands?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	residence?:ModelTypes["FieldMeta"]
};
	["BrandConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BrandEdge"][]
};
	["PageInfo"]: {
		totalCount:number
};
	["BrandEdge"]: {
		node:ModelTypes["Brand"]
};
	["BrandManufacturerOrderBy"]: GraphQLTypes["BrandManufacturerOrderBy"];
	["CountryOrderBy"]: GraphQLTypes["CountryOrderBy"];
	["RegionOrderBy"]: GraphQLTypes["RegionOrderBy"];
	["Region"]: {
		_meta?:ModelTypes["RegionMeta"],
	id:ModelTypes["UUID"],
	name:string,
	countries:ModelTypes["Country"][],
	remoteId:string,
	adjective?:string,
	slug?:string,
	filterCombos:ModelTypes["FilterCombo"][],
	countriesByRemoteId?:ModelTypes["Country"],
	countriesByManufacturers?:ModelTypes["Country"],
	filterCombosByRemoteId?:ModelTypes["FilterCombo"],
	filterCombosBySeo?:ModelTypes["FilterCombo"],
	paginateCountries:ModelTypes["CountryConnection"],
	paginateFilterCombos:ModelTypes["FilterComboConnection"]
};
	["RegionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	countries?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	adjective?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	filterCombos?:ModelTypes["FieldMeta"]
};
	["FilterCombo"]: {
		_meta?:ModelTypes["FilterComboMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	title?:string,
	lead?:string,
	seo?:ModelTypes["Seo"],
	breed?:ModelTypes["Breed"],
	brand?:ModelTypes["Brand"],
	region?:ModelTypes["Region"],
	ageCategory?:ModelTypes["AgeCategory"],
	treatment?:ModelTypes["BodyTag"],
	flavor?:ModelTypes["ItemSubCategory"],
	allergy?:ModelTypes["ItemSubCategory"]
};
	["FilterComboMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	breed?:ModelTypes["FieldMeta"],
	brand?:ModelTypes["FieldMeta"],
	region?:ModelTypes["FieldMeta"],
	ageCategory?:ModelTypes["FieldMeta"],
	treatment?:ModelTypes["FieldMeta"],
	flavor?:ModelTypes["FieldMeta"],
	allergy?:ModelTypes["FieldMeta"]
};
	["Breed"]: {
		_meta?:ModelTypes["BreedMeta"],
	id:ModelTypes["UUID"],
	dogs:ModelTypes["Dog"][],
	litterSize?:number,
	reviews:ModelTypes["Review"][],
	name:string,
	dailyEnergyRequirement?:number,
	ages:ModelTypes["Age"][],
	remoteId:string,
	averageWeightFemale?:number,
	averageWeightMale?:number,
	suitabilityCategory?:ModelTypes["SuitabilityCategory"],
	productReviews:ModelTypes["ProductReview"][],
	blogPostReviews:ModelTypes["BlogPostReview"][],
	labelFor?:string,
	size?:ModelTypes["DogSize"],
	slug?:string,
	filterCombos:ModelTypes["FilterCombo"][],
	dogsByReproduction?:ModelTypes["Dog"],
	dogsByAvatar?:ModelTypes["Dog"],
	productReviewsByProductReviewReactions?:ModelTypes["ProductReview"],
	productReviewsByStats?:ModelTypes["ProductReview"],
	blogPostReviewsByBlogPostReviewReactions?:ModelTypes["BlogPostReview"],
	blogPostReviewsByStats?:ModelTypes["BlogPostReview"],
	filterCombosByRemoteId?:ModelTypes["FilterCombo"],
	filterCombosBySeo?:ModelTypes["FilterCombo"],
	paginateDogs:ModelTypes["DogConnection"],
	paginateReviews:ModelTypes["ReviewConnection"],
	paginateAges:ModelTypes["AgeConnection"],
	paginateProductReviews:ModelTypes["ProductReviewConnection"],
	paginateBlogPostReviews:ModelTypes["BlogPostReviewConnection"],
	paginateFilterCombos:ModelTypes["FilterComboConnection"]
};
	["BreedMeta"]: {
		id?:ModelTypes["FieldMeta"],
	dogs?:ModelTypes["FieldMeta"],
	litterSize?:ModelTypes["FieldMeta"],
	reviews?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	dailyEnergyRequirement?:ModelTypes["FieldMeta"],
	ages?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	averageWeightFemale?:ModelTypes["FieldMeta"],
	averageWeightMale?:ModelTypes["FieldMeta"],
	suitabilityCategory?:ModelTypes["FieldMeta"],
	productReviews?:ModelTypes["FieldMeta"],
	blogPostReviews?:ModelTypes["FieldMeta"],
	labelFor?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	filterCombos?:ModelTypes["FieldMeta"]
};
	["Dog"]: {
		_meta?:ModelTypes["DogMeta"],
	id:ModelTypes["UUID"],
	gender?:ModelTypes["GenderType"],
	weight:number,
	customIdealWeight?:number,
	breed?:ModelTypes["Breed"],
	age?:ModelTypes["Age"],
	bodyType?:ModelTypes["DogBodyType"],
	owner?:ModelTypes["User"],
	activity?:ModelTypes["DogActivity"],
	fedProduct?:ModelTypes["Product"],
	reproduction?:ModelTypes["DogReproduction"],
	allergies:ModelTypes["ItemSubCategory"][],
	illnesses:ModelTypes["BodyTag"][],
	name?:string,
	avatar?:ModelTypes["Image"],
	createdAt?:ModelTypes["DateTime"],
	paginateAllergies:ModelTypes["ItemSubCategoryConnection"],
	paginateIllnesses:ModelTypes["BodyTagConnection"]
};
	["DogMeta"]: {
		id?:ModelTypes["FieldMeta"],
	gender?:ModelTypes["FieldMeta"],
	weight?:ModelTypes["FieldMeta"],
	customIdealWeight?:ModelTypes["FieldMeta"],
	breed?:ModelTypes["FieldMeta"],
	age?:ModelTypes["FieldMeta"],
	bodyType?:ModelTypes["FieldMeta"],
	owner?:ModelTypes["FieldMeta"],
	activity?:ModelTypes["FieldMeta"],
	fedProduct?:ModelTypes["FieldMeta"],
	reproduction?:ModelTypes["FieldMeta"],
	allergies?:ModelTypes["FieldMeta"],
	illnesses?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	avatar?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"]
};
	["Age"]: {
		_meta?:ModelTypes["AgeMeta"],
	id:ModelTypes["UUID"],
	dogs:ModelTypes["Dog"][],
	breeds:ModelTypes["Breed"][],
	ageRange?:ModelTypes["AgeRangeType"],
	categoryLabel?:ModelTypes["AgeLabelType"],
	suitabilityCategories:ModelTypes["SuitabilityCategory"][],
	remoteId:string,
	productReviews:ModelTypes["ProductReview"][],
	blogPostReviews:ModelTypes["BlogPostReview"][],
	label?:string,
	categoryOrder?:string,
	dogsByReproduction?:ModelTypes["Dog"],
	dogsByAvatar?:ModelTypes["Dog"],
	productReviewsByProductReviewReactions?:ModelTypes["ProductReview"],
	productReviewsByStats?:ModelTypes["ProductReview"],
	blogPostReviewsByBlogPostReviewReactions?:ModelTypes["BlogPostReview"],
	blogPostReviewsByStats?:ModelTypes["BlogPostReview"],
	paginateDogs:ModelTypes["DogConnection"],
	paginateBreeds:ModelTypes["BreedConnection"],
	paginateSuitabilityCategories:ModelTypes["SuitabilityCategoryConnection"],
	paginateProductReviews:ModelTypes["ProductReviewConnection"],
	paginateBlogPostReviews:ModelTypes["BlogPostReviewConnection"]
};
	["AgeMeta"]: {
		id?:ModelTypes["FieldMeta"],
	dogs?:ModelTypes["FieldMeta"],
	breeds?:ModelTypes["FieldMeta"],
	ageRange?:ModelTypes["FieldMeta"],
	categoryLabel?:ModelTypes["FieldMeta"],
	suitabilityCategories?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	productReviews?:ModelTypes["FieldMeta"],
	blogPostReviews?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	categoryOrder?:ModelTypes["FieldMeta"]
};
	["DogOrderBy"]: GraphQLTypes["DogOrderBy"];
	["BreedOrderBy"]: GraphQLTypes["BreedOrderBy"];
	["DogSizeOrderBy"]: GraphQLTypes["DogSizeOrderBy"];
	["AgeOrderBy"]: GraphQLTypes["AgeOrderBy"];
	["DogBodyTypeOrderBy"]: GraphQLTypes["DogBodyTypeOrderBy"];
	["DogBodyTypeCategoryOrderBy"]: GraphQLTypes["DogBodyTypeCategoryOrderBy"];
	["DogReproductionOrderBy"]: GraphQLTypes["DogReproductionOrderBy"];
	["BreastfeedingCategoryOrderBy"]: GraphQLTypes["BreastfeedingCategoryOrderBy"];
	["SuitabilityCategory"]: {
		_meta?:ModelTypes["SuitabilityCategoryMeta"],
	id:ModelTypes["UUID"],
	name:string,
	dogSizes:ModelTypes["DogSize"][],
	dogActivities:ModelTypes["DogActivity"][],
	breeds:ModelTypes["Breed"][],
	suitabilityItems:ModelTypes["SuitabilityItem"][],
	dogAges:ModelTypes["Age"][],
	isPregnant:boolean,
	remoteId:string,
	isBreastfeeding:boolean,
	dogSizesByRemoteId?:ModelTypes["DogSize"],
	dogSizesByBreeds?:ModelTypes["DogSize"],
	dogActivitiesByRemoteId?:ModelTypes["DogActivity"],
	dogActivitiesByDogs?:ModelTypes["DogActivity"],
	dogActivitiesByProducts?:ModelTypes["DogActivity"],
	breedsByRemoteId?:ModelTypes["Breed"],
	breedsBySlug?:ModelTypes["Breed"],
	breedsByDogs?:ModelTypes["Breed"],
	breedsByProductReviews?:ModelTypes["Breed"],
	breedsByBlogPostReviews?:ModelTypes["Breed"],
	breedsByFilterCombos?:ModelTypes["Breed"],
	suitabilityItemsByRemoteId?:ModelTypes["SuitabilityItem"],
	paginateDogSizes:ModelTypes["DogSizeConnection"],
	paginateDogActivities:ModelTypes["DogActivityConnection"],
	paginateBreeds:ModelTypes["BreedConnection"],
	paginateSuitabilityItems:ModelTypes["SuitabilityItemConnection"],
	paginateDogAges:ModelTypes["AgeConnection"]
};
	["SuitabilityCategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	dogSizes?:ModelTypes["FieldMeta"],
	dogActivities?:ModelTypes["FieldMeta"],
	breeds?:ModelTypes["FieldMeta"],
	suitabilityItems?:ModelTypes["FieldMeta"],
	dogAges?:ModelTypes["FieldMeta"],
	isPregnant?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	isBreastfeeding?:ModelTypes["FieldMeta"]
};
	["DogSize"]: {
		_meta?:ModelTypes["DogSizeMeta"],
	id:ModelTypes["UUID"],
	breeds:ModelTypes["Breed"][],
	remoteId:string,
	products:ModelTypes["Product"][],
	suitabilityCategory?:ModelTypes["SuitabilityCategory"],
	name:ModelTypes["SizeType"],
	label?:string,
	order?:number,
	isFilterVisible?:boolean,
	breedsByRemoteId?:ModelTypes["Breed"],
	breedsBySlug?:ModelTypes["Breed"],
	breedsByDogs?:ModelTypes["Breed"],
	breedsByProductReviews?:ModelTypes["Breed"],
	breedsByBlogPostReviews?:ModelTypes["Breed"],
	breedsByFilterCombos?:ModelTypes["Breed"],
	paginateBreeds:ModelTypes["BreedConnection"],
	paginateProducts:ModelTypes["ProductConnection"]
};
	["DogSizeMeta"]: {
		id?:ModelTypes["FieldMeta"],
	breeds?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	suitabilityCategory?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	isFilterVisible?:ModelTypes["FieldMeta"]
};
	["DogSizeBreedsByRemoteIdUniqueWhere"]: GraphQLTypes["DogSizeBreedsByRemoteIdUniqueWhere"];
	["DogSizeBreedsBySlugUniqueWhere"]: GraphQLTypes["DogSizeBreedsBySlugUniqueWhere"];
	["DogSizeBreedsByDogsUniqueWhere"]: GraphQLTypes["DogSizeBreedsByDogsUniqueWhere"];
	["DogUniqueWhere"]: GraphQLTypes["DogUniqueWhere"];
	["DogReproductionUniqueWhere"]: GraphQLTypes["DogReproductionUniqueWhere"];
	["ImageUniqueWhere"]: GraphQLTypes["ImageUniqueWhere"];
	["DogSizeBreedsByProductReviewsUniqueWhere"]: GraphQLTypes["DogSizeBreedsByProductReviewsUniqueWhere"];
	["ProductReviewUniqueWhere"]: GraphQLTypes["ProductReviewUniqueWhere"];
	["ProductReviewReactionUniqueWhere"]: GraphQLTypes["ProductReviewReactionUniqueWhere"];
	["UserUniqueWhere"]: GraphQLTypes["UserUniqueWhere"];
	["VeterinaryUniqueWhere"]: GraphQLTypes["VeterinaryUniqueWhere"];
	["BlogPostReviewUniqueWhere"]: GraphQLTypes["BlogPostReviewUniqueWhere"];
	["BlogPostReviewReactionUniqueWhere"]: GraphQLTypes["BlogPostReviewReactionUniqueWhere"];
	["BlogPostReviewStatsUniqueWhere"]: GraphQLTypes["BlogPostReviewStatsUniqueWhere"];
	["BlogPostUniqueWhere"]: GraphQLTypes["BlogPostUniqueWhere"];
	["ItemUniqueWhere"]: GraphQLTypes["ItemUniqueWhere"];
	["ProductFeatureUniqueWhere"]: GraphQLTypes["ProductFeatureUniqueWhere"];
	["ReferenceListUniqueWhere"]: GraphQLTypes["ReferenceListUniqueWhere"];
	["ReferenceUniqueWhere"]: GraphQLTypes["ReferenceUniqueWhere"];
	["SeoUniqueWhere"]: GraphQLTypes["SeoUniqueWhere"];
	["BlogPageUniqueWhere"]: GraphQLTypes["BlogPageUniqueWhere"];
	["RedirectUniqueWhere"]: GraphQLTypes["RedirectUniqueWhere"];
	["ContentUniqueWhere"]: GraphQLTypes["ContentUniqueWhere"];
	["ContentBlockUniqueWhere"]: GraphQLTypes["ContentBlockUniqueWhere"];
	["ContentReferenceUniqueWhere"]: GraphQLTypes["ContentReferenceUniqueWhere"];
	["ContentReferenceGalleryImageUniqueWhere"]: GraphQLTypes["ContentReferenceGalleryImageUniqueWhere"];
	["LinkUniqueWhere"]: GraphQLTypes["LinkUniqueWhere"];
	["ContentReferenceListUniqueWhere"]: GraphQLTypes["ContentReferenceListUniqueWhere"];
	["ContentLinksUniqueWhere"]: GraphQLTypes["ContentLinksUniqueWhere"];
	["ContentLinksItemUniqueWhere"]: GraphQLTypes["ContentLinksItemUniqueWhere"];
	["VideoUniqueWhere"]: GraphQLTypes["VideoUniqueWhere"];
	["ContentReferenceImageUniqueWhere"]: GraphQLTypes["ContentReferenceImageUniqueWhere"];
	["BrandsPageUniqueWhere"]: GraphQLTypes["BrandsPageUniqueWhere"];
	["ComparatorPageUniqueWhere"]: GraphQLTypes["ComparatorPageUniqueWhere"];
	["GenericPageUniqueWhere"]: GraphQLTypes["GenericPageUniqueWhere"];
	["LinkableUniqueWhere"]: GraphQLTypes["LinkableUniqueWhere"];
	["HomePageUniqueWhere"]: GraphQLTypes["HomePageUniqueWhere"];
	["IngredientsPageUniqueWhere"]: GraphQLTypes["IngredientsPageUniqueWhere"];
	["LoginPageUniqueWhere"]: GraphQLTypes["LoginPageUniqueWhere"];
	["RegisterPageUniqueWhere"]: GraphQLTypes["RegisterPageUniqueWhere"];
	["SearchPageUniqueWhere"]: GraphQLTypes["SearchPageUniqueWhere"];
	["WizardPageUniqueWhere"]: GraphQLTypes["WizardPageUniqueWhere"];
	["ContactPageUniqueWhere"]: GraphQLTypes["ContactPageUniqueWhere"];
	["ItemAliasUniqueWhere"]: GraphQLTypes["ItemAliasUniqueWhere"];
	["ContactFormMessageUniqueWhere"]: GraphQLTypes["ContactFormMessageUniqueWhere"];
	["BugReportUniqueWhere"]: GraphQLTypes["BugReportUniqueWhere"];
	["ProtectedActionUniqueWhere"]: GraphQLTypes["ProtectedActionUniqueWhere"];
	["TenantPersonUniqueWhere"]: GraphQLTypes["TenantPersonUniqueWhere"];
	["ProductReviewStatsUniqueWhere"]: GraphQLTypes["ProductReviewStatsUniqueWhere"];
	["DogSizeBreedsByBlogPostReviewsUniqueWhere"]: GraphQLTypes["DogSizeBreedsByBlogPostReviewsUniqueWhere"];
	["DogSizeBreedsByFilterCombosUniqueWhere"]: GraphQLTypes["DogSizeBreedsByFilterCombosUniqueWhere"];
	["FilterComboUniqueWhere"]: GraphQLTypes["FilterComboUniqueWhere"];
	["BreedConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BreedEdge"][]
};
	["BreedEdge"]: {
		node:ModelTypes["Breed"]
};
	["ProductConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductEdge"][]
};
	["ProductEdge"]: {
		node:ModelTypes["Product"]
};
	["DogActivity"]: {
		_meta?:ModelTypes["DogActivityMeta"],
	id:ModelTypes["UUID"],
	label:string,
	dogs:ModelTypes["Dog"][],
	products:ModelTypes["Product"][],
	dailyEnergyRequirementCoeficient?:number,
	remoteId:string,
	suitabilityCategory?:ModelTypes["SuitabilityCategory"],
	dogsByReproduction?:ModelTypes["Dog"],
	dogsByAvatar?:ModelTypes["Dog"],
	productsByRemoteId?:ModelTypes["Product"],
	productsBySlug?:ModelTypes["Product"],
	productsByNutritionalValues?:ModelTypes["Product"],
	productsByReviews?:ModelTypes["Product"],
	productsByDogs?:ModelTypes["Product"],
	productsByPackagings?:ModelTypes["Product"],
	productsByElements?:ModelTypes["Product"],
	productsByFlags?:ModelTypes["Product"],
	productsByImage?:ModelTypes["Product"],
	productsByAliases?:ModelTypes["Product"],
	productsByEvaluation?:ModelTypes["Product"],
	productsBySeo?:ModelTypes["Product"],
	productsByItemDeclensionFourthCategories?:ModelTypes["Product"],
	productsByHeurekaImage?:ModelTypes["Product"],
	productsByTopx?:ModelTypes["Product"],
	paginateDogs:ModelTypes["DogConnection"],
	paginateProducts:ModelTypes["ProductConnection"]
};
	["DogActivityMeta"]: {
		id?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	dogs?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	dailyEnergyRequirementCoeficient?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	suitabilityCategory?:ModelTypes["FieldMeta"]
};
	["DogActivityDogsByReproductionUniqueWhere"]: GraphQLTypes["DogActivityDogsByReproductionUniqueWhere"];
	["DogActivityDogsByAvatarUniqueWhere"]: GraphQLTypes["DogActivityDogsByAvatarUniqueWhere"];
	["DogActivityProductsByRemoteIdUniqueWhere"]: GraphQLTypes["DogActivityProductsByRemoteIdUniqueWhere"];
	["DogActivityProductsBySlugUniqueWhere"]: GraphQLTypes["DogActivityProductsBySlugUniqueWhere"];
	["DogActivityProductsByNutritionalValuesUniqueWhere"]: GraphQLTypes["DogActivityProductsByNutritionalValuesUniqueWhere"];
	["NutritionalValueOfProductUniqueWhere"]: GraphQLTypes["NutritionalValueOfProductUniqueWhere"];
	["DogActivityProductsByReviewsUniqueWhere"]: GraphQLTypes["DogActivityProductsByReviewsUniqueWhere"];
	["DogActivityProductsByDogsUniqueWhere"]: GraphQLTypes["DogActivityProductsByDogsUniqueWhere"];
	["DogActivityProductsByPackagingsUniqueWhere"]: GraphQLTypes["DogActivityProductsByPackagingsUniqueWhere"];
	["ProductPackageUniqueWhere"]: GraphQLTypes["ProductPackageUniqueWhere"];
	["DogActivityProductsByElementsUniqueWhere"]: GraphQLTypes["DogActivityProductsByElementsUniqueWhere"];
	["ElementOfProductUniqueWhere"]: GraphQLTypes["ElementOfProductUniqueWhere"];
	["DogActivityProductsByFlagsUniqueWhere"]: GraphQLTypes["DogActivityProductsByFlagsUniqueWhere"];
	["ProductFlagOfProductUniqueWhere"]: GraphQLTypes["ProductFlagOfProductUniqueWhere"];
	["DogActivityProductsByImageUniqueWhere"]: GraphQLTypes["DogActivityProductsByImageUniqueWhere"];
	["DogActivityProductsByAliasesUniqueWhere"]: GraphQLTypes["DogActivityProductsByAliasesUniqueWhere"];
	["ProductAliasUniqueWhere"]: GraphQLTypes["ProductAliasUniqueWhere"];
	["DogActivityProductsByEvaluationUniqueWhere"]: GraphQLTypes["DogActivityProductsByEvaluationUniqueWhere"];
	["ProductEvaluationUniqueWhere"]: GraphQLTypes["ProductEvaluationUniqueWhere"];
	["ProductUniqueWhere"]: GraphQLTypes["ProductUniqueWhere"];
	["ProductItemDeclensionFourthCategoryUniqueWhere"]: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"];
	["TOPXProductUniqueWhere"]: GraphQLTypes["TOPXProductUniqueWhere"];
	["DogActivityProductsBySeoUniqueWhere"]: GraphQLTypes["DogActivityProductsBySeoUniqueWhere"];
	["DogActivityProductsByItemDeclensionFourthCategoriesUniqueWhere"]: GraphQLTypes["DogActivityProductsByItemDeclensionFourthCategoriesUniqueWhere"];
	["DogActivityProductsByHeurekaImageUniqueWhere"]: GraphQLTypes["DogActivityProductsByHeurekaImageUniqueWhere"];
	["DogActivityProductsByTopxUniqueWhere"]: GraphQLTypes["DogActivityProductsByTopxUniqueWhere"];
	["DogConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DogEdge"][]
};
	["DogEdge"]: {
		node:ModelTypes["Dog"]
};
	["SuitabilityItemOrderBy"]: GraphQLTypes["SuitabilityItemOrderBy"];
	["SuitabilityCategoryDogSizesByRemoteIdUniqueWhere"]: GraphQLTypes["SuitabilityCategoryDogSizesByRemoteIdUniqueWhere"];
	["SuitabilityCategoryDogSizesByBreedsUniqueWhere"]: GraphQLTypes["SuitabilityCategoryDogSizesByBreedsUniqueWhere"];
	["BreedUniqueWhere"]: GraphQLTypes["BreedUniqueWhere"];
	["SuitabilityCategoryDogActivitiesByRemoteIdUniqueWhere"]: GraphQLTypes["SuitabilityCategoryDogActivitiesByRemoteIdUniqueWhere"];
	["SuitabilityCategoryDogActivitiesByDogsUniqueWhere"]: GraphQLTypes["SuitabilityCategoryDogActivitiesByDogsUniqueWhere"];
	["SuitabilityCategoryDogActivitiesByProductsUniqueWhere"]: GraphQLTypes["SuitabilityCategoryDogActivitiesByProductsUniqueWhere"];
	["SuitabilityCategoryBreedsByRemoteIdUniqueWhere"]: GraphQLTypes["SuitabilityCategoryBreedsByRemoteIdUniqueWhere"];
	["SuitabilityCategoryBreedsBySlugUniqueWhere"]: GraphQLTypes["SuitabilityCategoryBreedsBySlugUniqueWhere"];
	["SuitabilityCategoryBreedsByDogsUniqueWhere"]: GraphQLTypes["SuitabilityCategoryBreedsByDogsUniqueWhere"];
	["SuitabilityCategoryBreedsByProductReviewsUniqueWhere"]: GraphQLTypes["SuitabilityCategoryBreedsByProductReviewsUniqueWhere"];
	["SuitabilityCategoryBreedsByBlogPostReviewsUniqueWhere"]: GraphQLTypes["SuitabilityCategoryBreedsByBlogPostReviewsUniqueWhere"];
	["SuitabilityCategoryBreedsByFilterCombosUniqueWhere"]: GraphQLTypes["SuitabilityCategoryBreedsByFilterCombosUniqueWhere"];
	["SuitabilityCategorySuitabilityItemsByRemoteIdUniqueWhere"]: GraphQLTypes["SuitabilityCategorySuitabilityItemsByRemoteIdUniqueWhere"];
	["DogSizeConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DogSizeEdge"][]
};
	["DogSizeEdge"]: {
		node:ModelTypes["DogSize"]
};
	["DogActivityConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DogActivityEdge"][]
};
	["DogActivityEdge"]: {
		node:ModelTypes["DogActivity"]
};
	["SuitabilityItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SuitabilityItemEdge"][]
};
	["SuitabilityItemEdge"]: {
		node:ModelTypes["SuitabilityItem"]
};
	["AgeConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["AgeEdge"][]
};
	["AgeEdge"]: {
		node:ModelTypes["Age"]
};
	["ProductReview"]: {
		_meta?:ModelTypes["ProductReviewMeta"],
	id:ModelTypes["UUID"],
	text:string,
	publishedAt?:ModelTypes["DateTime"],
	productReviewReactions:ModelTypes["ProductReviewReaction"][],
	score?:ModelTypes["Score"],
	product?:ModelTypes["Product"],
	user?:ModelTypes["User"],
	stats?:ModelTypes["ProductReviewStats"],
	fullName?:string,
	breed?:ModelTypes["Breed"],
	age?:ModelTypes["Age"],
	url?:string,
	isVisible?:boolean,
	response?:string,
	productReviewReactionsByUser?:ModelTypes["ProductReviewReaction"],
	paginateProductReviewReactions:ModelTypes["ProductReviewReactionConnection"]
};
	["ProductReviewMeta"]: {
		id?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	publishedAt?:ModelTypes["FieldMeta"],
	productReviewReactions?:ModelTypes["FieldMeta"],
	score?:ModelTypes["FieldMeta"],
	product?:ModelTypes["FieldMeta"],
	user?:ModelTypes["FieldMeta"],
	stats?:ModelTypes["FieldMeta"],
	fullName?:ModelTypes["FieldMeta"],
	breed?:ModelTypes["FieldMeta"],
	age?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	isVisible?:ModelTypes["FieldMeta"],
	response?:ModelTypes["FieldMeta"]
};
	["ProductReviewReaction"]: {
		_meta?:ModelTypes["ProductReviewReactionMeta"],
	id:ModelTypes["UUID"],
	sentiment:ModelTypes["SentimentType"],
	user?:ModelTypes["User"],
	productReview?:ModelTypes["ProductReview"]
};
	["ProductReviewReactionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	sentiment?:ModelTypes["FieldMeta"],
	user?:ModelTypes["FieldMeta"],
	productReview?:ModelTypes["FieldMeta"]
};
	["User"]: {
		_meta?:ModelTypes["UserMeta"],
	id:ModelTypes["UUID"],
	dogs:ModelTypes["Dog"][],
	veterinary?:ModelTypes["Veterinary"],
	email:string,
	blogPostReviews:ModelTypes["BlogPostReview"][],
	productReviews:ModelTypes["ProductReview"][],
	blogPostReviewReactions:ModelTypes["BlogPostReviewReaction"][],
	productReviewReactions:ModelTypes["ProductReviewReaction"][],
	tenantPersonId?:ModelTypes["UUID"],
	fullName?:string,
	blogPosts:ModelTypes["BlogPost"][],
	createdAt:ModelTypes["DateTime"],
	verifiedAt?:ModelTypes["DateTime"],
	avatar?:ModelTypes["Image"],
	contactFormMessages:ModelTypes["ContactFormMessage"][],
	bugReports:ModelTypes["BugReport"][],
	verifiedEmail?:string,
	protectedActions:ModelTypes["ProtectedAction"][],
	blockedAt?:ModelTypes["DateTime"],
	tenantPerson?:ModelTypes["TenantPerson"],
	note?:string,
	dogsByReproduction?:ModelTypes["Dog"],
	dogsByAvatar?:ModelTypes["Dog"],
	blogPostReviewsByBlogPostReviewReactions?:ModelTypes["BlogPostReview"],
	blogPostReviewsByStats?:ModelTypes["BlogPostReview"],
	productReviewsByProductReviewReactions?:ModelTypes["ProductReview"],
	productReviewsByStats?:ModelTypes["ProductReview"],
	blogPostReviewReactionsByBlogPostReview?:ModelTypes["BlogPostReviewReaction"],
	productReviewReactionsByProductReview?:ModelTypes["ProductReviewReaction"],
	blogPostsBySlug?:ModelTypes["BlogPost"],
	blogPostsBySlugInternal?:ModelTypes["BlogPost"],
	blogPostsByReviews?:ModelTypes["BlogPost"],
	blogPostsByItems?:ModelTypes["BlogPost"],
	blogPostsByImage?:ModelTypes["BlogPost"],
	blogPostsByReferenceList?:ModelTypes["BlogPost"],
	blogPostsBySeo?:ModelTypes["BlogPost"],
	blogPostsByRedirects?:ModelTypes["BlogPost"],
	blogPostsByContent?:ModelTypes["BlogPost"],
	blogPostsByDraft?:ModelTypes["BlogPost"],
	protectedActionsByPublicKey?:ModelTypes["ProtectedAction"],
	paginateDogs:ModelTypes["DogConnection"],
	paginateBlogPostReviews:ModelTypes["BlogPostReviewConnection"],
	paginateProductReviews:ModelTypes["ProductReviewConnection"],
	paginateBlogPostReviewReactions:ModelTypes["BlogPostReviewReactionConnection"],
	paginateProductReviewReactions:ModelTypes["ProductReviewReactionConnection"],
	paginateBlogPosts:ModelTypes["BlogPostConnection"],
	paginateContactFormMessages:ModelTypes["ContactFormMessageConnection"],
	paginateBugReports:ModelTypes["BugReportConnection"],
	paginateProtectedActions:ModelTypes["ProtectedActionConnection"]
};
	["UserMeta"]: {
		id?:ModelTypes["FieldMeta"],
	dogs?:ModelTypes["FieldMeta"],
	veterinary?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	blogPostReviews?:ModelTypes["FieldMeta"],
	productReviews?:ModelTypes["FieldMeta"],
	blogPostReviewReactions?:ModelTypes["FieldMeta"],
	productReviewReactions?:ModelTypes["FieldMeta"],
	tenantPersonId?:ModelTypes["FieldMeta"],
	fullName?:ModelTypes["FieldMeta"],
	blogPosts?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"],
	verifiedAt?:ModelTypes["FieldMeta"],
	avatar?:ModelTypes["FieldMeta"],
	contactFormMessages?:ModelTypes["FieldMeta"],
	bugReports?:ModelTypes["FieldMeta"],
	verifiedEmail?:ModelTypes["FieldMeta"],
	protectedActions?:ModelTypes["FieldMeta"],
	blockedAt?:ModelTypes["FieldMeta"],
	tenantPerson?:ModelTypes["FieldMeta"],
	note?:ModelTypes["FieldMeta"]
};
	["Veterinary"]: {
		_meta?:ModelTypes["VeterinaryMeta"],
	id:ModelTypes["UUID"],
	user?:ModelTypes["User"]
};
	["VeterinaryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	user?:ModelTypes["FieldMeta"]
};
	["BlogPostReview"]: {
		_meta?:ModelTypes["BlogPostReviewMeta"],
	id:ModelTypes["UUID"],
	title:string,
	text:string,
	publishedAt?:ModelTypes["DateTime"],
	blogPostReviewReactions:ModelTypes["BlogPostReviewReaction"][],
	blogPost?:ModelTypes["BlogPost"],
	user?:ModelTypes["User"],
	stats?:ModelTypes["BlogPostReviewStats"],
	fullName?:string,
	breed?:ModelTypes["Breed"],
	age?:ModelTypes["Age"],
	url?:string,
	isVisible?:boolean,
	response?:string,
	blogPostReviewReactionsByUser?:ModelTypes["BlogPostReviewReaction"],
	paginateBlogPostReviewReactions:ModelTypes["BlogPostReviewReactionConnection"]
};
	["BlogPostReviewMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	publishedAt?:ModelTypes["FieldMeta"],
	blogPostReviewReactions?:ModelTypes["FieldMeta"],
	blogPost?:ModelTypes["FieldMeta"],
	user?:ModelTypes["FieldMeta"],
	stats?:ModelTypes["FieldMeta"],
	fullName?:ModelTypes["FieldMeta"],
	breed?:ModelTypes["FieldMeta"],
	age?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	isVisible?:ModelTypes["FieldMeta"],
	response?:ModelTypes["FieldMeta"]
};
	["BlogPostReviewReaction"]: {
		_meta?:ModelTypes["BlogPostReviewReactionMeta"],
	id:ModelTypes["UUID"],
	sentiment:ModelTypes["SentimentType"],
	user?:ModelTypes["User"],
	blogPostReview?:ModelTypes["BlogPostReview"]
};
	["BlogPostReviewReactionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	sentiment?:ModelTypes["FieldMeta"],
	user?:ModelTypes["FieldMeta"],
	blogPostReview?:ModelTypes["FieldMeta"]
};
	["BlogPostReviewReactionOrderBy"]: GraphQLTypes["BlogPostReviewReactionOrderBy"];
	["BlogPostReviewOrderBy"]: GraphQLTypes["BlogPostReviewOrderBy"];
	["BlogPostReviewStatsOrderBy"]: GraphQLTypes["BlogPostReviewStatsOrderBy"];
	["BlogPostReviewStats"]: {
		_meta?:ModelTypes["BlogPostReviewStatsMeta"],
	id:ModelTypes["UUID"],
	total:number,
	positive:number,
	negative:number,
	blogPostReview?:ModelTypes["BlogPostReview"]
};
	["BlogPostReviewStatsMeta"]: {
		id?:ModelTypes["FieldMeta"],
	total?:ModelTypes["FieldMeta"],
	positive?:ModelTypes["FieldMeta"],
	negative?:ModelTypes["FieldMeta"],
	blogPostReview?:ModelTypes["FieldMeta"]
};
	["BlogPostReviewBlogPostReviewReactionsByUserUniqueWhere"]: GraphQLTypes["BlogPostReviewBlogPostReviewReactionsByUserUniqueWhere"];
	["BlogPostReviewReactionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BlogPostReviewReactionEdge"][]
};
	["BlogPostReviewReactionEdge"]: {
		node:ModelTypes["BlogPostReviewReaction"]
};
	["ProductReviewOrderBy"]: GraphQLTypes["ProductReviewOrderBy"];
	["ScoreOrderBy"]: GraphQLTypes["ScoreOrderBy"];
	["ProductReviewStatsOrderBy"]: GraphQLTypes["ProductReviewStatsOrderBy"];
	["ProductReviewReactionOrderBy"]: GraphQLTypes["ProductReviewReactionOrderBy"];
	["ContactFormMessage"]: {
		_meta?:ModelTypes["ContactFormMessageMeta"],
	id:ModelTypes["UUID"],
	message?:string,
	email?:string,
	receivedAt?:ModelTypes["DateTime"],
	user?:ModelTypes["User"],
	isResolved?:boolean,
	url?:string
};
	["ContactFormMessageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	message?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	receivedAt?:ModelTypes["FieldMeta"],
	user?:ModelTypes["FieldMeta"],
	isResolved?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"]
};
	["ContactFormMessageOrderBy"]: GraphQLTypes["ContactFormMessageOrderBy"];
	["BugReport"]: {
		_meta?:ModelTypes["BugReportMeta"],
	id:ModelTypes["UUID"],
	message?:string,
	receivedAt?:ModelTypes["DateTime"],
	isResolved?:boolean,
	user?:ModelTypes["User"],
	url?:string
};
	["BugReportMeta"]: {
		id?:ModelTypes["FieldMeta"],
	message?:ModelTypes["FieldMeta"],
	receivedAt?:ModelTypes["FieldMeta"],
	isResolved?:ModelTypes["FieldMeta"],
	user?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"]
};
	["BugReportOrderBy"]: GraphQLTypes["BugReportOrderBy"];
	["ProtectedAction"]: {
		_meta?:ModelTypes["ProtectedActionMeta"],
	id:ModelTypes["UUID"],
	type?:ModelTypes["ProtectedActionType"],
	createdAt:ModelTypes["DateTime"],
	usedAt?:ModelTypes["DateTime"],
	expiresAt?:ModelTypes["DateTime"],
	publicKey:string,
	secretHash:string,
	verifyEmail?:string,
	createdMetadata?:ModelTypes["Json"],
	usedMetadata?:ModelTypes["Json"],
	user?:ModelTypes["User"]
};
	["ProtectedActionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"],
	usedAt?:ModelTypes["FieldMeta"],
	expiresAt?:ModelTypes["FieldMeta"],
	publicKey?:ModelTypes["FieldMeta"],
	secretHash?:ModelTypes["FieldMeta"],
	verifyEmail?:ModelTypes["FieldMeta"],
	createdMetadata?:ModelTypes["FieldMeta"],
	usedMetadata?:ModelTypes["FieldMeta"],
	user?:ModelTypes["FieldMeta"]
};
	["ProtectedActionOrderBy"]: GraphQLTypes["ProtectedActionOrderBy"];
	["TenantPerson"]: {
		_meta?:ModelTypes["TenantPersonMeta"],
	id:ModelTypes["UUID"],
	identityId?:ModelTypes["UUID"],
	email?:string,
	roles?:string,
	user?:ModelTypes["User"]
};
	["TenantPersonMeta"]: {
		id?:ModelTypes["FieldMeta"],
	identityId?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	roles?:ModelTypes["FieldMeta"],
	user?:ModelTypes["FieldMeta"]
};
	["UserDogsByReproductionUniqueWhere"]: GraphQLTypes["UserDogsByReproductionUniqueWhere"];
	["UserDogsByAvatarUniqueWhere"]: GraphQLTypes["UserDogsByAvatarUniqueWhere"];
	["UserBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"]: GraphQLTypes["UserBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"];
	["UserBlogPostReviewsByStatsUniqueWhere"]: GraphQLTypes["UserBlogPostReviewsByStatsUniqueWhere"];
	["UserProductReviewsByProductReviewReactionsUniqueWhere"]: GraphQLTypes["UserProductReviewsByProductReviewReactionsUniqueWhere"];
	["UserProductReviewsByStatsUniqueWhere"]: GraphQLTypes["UserProductReviewsByStatsUniqueWhere"];
	["UserBlogPostReviewReactionsByBlogPostReviewUniqueWhere"]: GraphQLTypes["UserBlogPostReviewReactionsByBlogPostReviewUniqueWhere"];
	["UserProductReviewReactionsByProductReviewUniqueWhere"]: GraphQLTypes["UserProductReviewReactionsByProductReviewUniqueWhere"];
	["UserBlogPostsBySlugUniqueWhere"]: GraphQLTypes["UserBlogPostsBySlugUniqueWhere"];
	["UserBlogPostsBySlugInternalUniqueWhere"]: GraphQLTypes["UserBlogPostsBySlugInternalUniqueWhere"];
	["UserBlogPostsByReviewsUniqueWhere"]: GraphQLTypes["UserBlogPostsByReviewsUniqueWhere"];
	["UserBlogPostsByItemsUniqueWhere"]: GraphQLTypes["UserBlogPostsByItemsUniqueWhere"];
	["UserBlogPostsByImageUniqueWhere"]: GraphQLTypes["UserBlogPostsByImageUniqueWhere"];
	["UserBlogPostsByReferenceListUniqueWhere"]: GraphQLTypes["UserBlogPostsByReferenceListUniqueWhere"];
	["UserBlogPostsBySeoUniqueWhere"]: GraphQLTypes["UserBlogPostsBySeoUniqueWhere"];
	["UserBlogPostsByRedirectsUniqueWhere"]: GraphQLTypes["UserBlogPostsByRedirectsUniqueWhere"];
	["UserBlogPostsByContentUniqueWhere"]: GraphQLTypes["UserBlogPostsByContentUniqueWhere"];
	["UserBlogPostsByDraftUniqueWhere"]: GraphQLTypes["UserBlogPostsByDraftUniqueWhere"];
	["UserProtectedActionsByPublicKeyUniqueWhere"]: GraphQLTypes["UserProtectedActionsByPublicKeyUniqueWhere"];
	["BlogPostReviewConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BlogPostReviewEdge"][]
};
	["BlogPostReviewEdge"]: {
		node:ModelTypes["BlogPostReview"]
};
	["ProductReviewConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductReviewEdge"][]
};
	["ProductReviewEdge"]: {
		node:ModelTypes["ProductReview"]
};
	["ProductReviewReactionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductReviewReactionEdge"][]
};
	["ProductReviewReactionEdge"]: {
		node:ModelTypes["ProductReviewReaction"]
};
	["BlogPostConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BlogPostEdge"][]
};
	["BlogPostEdge"]: {
		node:ModelTypes["BlogPost"]
};
	["ContactFormMessageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContactFormMessageEdge"][]
};
	["ContactFormMessageEdge"]: {
		node:ModelTypes["ContactFormMessage"]
};
	["BugReportConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BugReportEdge"][]
};
	["BugReportEdge"]: {
		node:ModelTypes["BugReport"]
};
	["ProtectedActionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProtectedActionEdge"][]
};
	["ProtectedActionEdge"]: {
		node:ModelTypes["ProtectedAction"]
};
	["Score"]: {
		_meta?:ModelTypes["ScoreMeta"],
	id:ModelTypes["UUID"],
	label?:string,
	productReviews:ModelTypes["ProductReview"][],
	starsAmount?:number,
	remoteId:string,
	productReviewsByProductReviewReactions?:ModelTypes["ProductReview"],
	productReviewsByStats?:ModelTypes["ProductReview"],
	paginateProductReviews:ModelTypes["ProductReviewConnection"]
};
	["ScoreMeta"]: {
		id?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	productReviews?:ModelTypes["FieldMeta"],
	starsAmount?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"]
};
	["ScoreProductReviewsByProductReviewReactionsUniqueWhere"]: GraphQLTypes["ScoreProductReviewsByProductReviewReactionsUniqueWhere"];
	["ScoreProductReviewsByStatsUniqueWhere"]: GraphQLTypes["ScoreProductReviewsByStatsUniqueWhere"];
	["ProductReviewStats"]: {
		_meta?:ModelTypes["ProductReviewStatsMeta"],
	id:ModelTypes["UUID"],
	total:number,
	positive:number,
	negative:number,
	productReview?:ModelTypes["ProductReview"]
};
	["ProductReviewStatsMeta"]: {
		id?:ModelTypes["FieldMeta"],
	total?:ModelTypes["FieldMeta"],
	positive?:ModelTypes["FieldMeta"],
	negative?:ModelTypes["FieldMeta"],
	productReview?:ModelTypes["FieldMeta"]
};
	["ProductReviewProductReviewReactionsByUserUniqueWhere"]: GraphQLTypes["ProductReviewProductReviewReactionsByUserUniqueWhere"];
	["AgeDogsByReproductionUniqueWhere"]: GraphQLTypes["AgeDogsByReproductionUniqueWhere"];
	["AgeDogsByAvatarUniqueWhere"]: GraphQLTypes["AgeDogsByAvatarUniqueWhere"];
	["AgeProductReviewsByProductReviewReactionsUniqueWhere"]: GraphQLTypes["AgeProductReviewsByProductReviewReactionsUniqueWhere"];
	["AgeProductReviewsByStatsUniqueWhere"]: GraphQLTypes["AgeProductReviewsByStatsUniqueWhere"];
	["AgeBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"]: GraphQLTypes["AgeBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"];
	["AgeBlogPostReviewsByStatsUniqueWhere"]: GraphQLTypes["AgeBlogPostReviewsByStatsUniqueWhere"];
	["SuitabilityCategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SuitabilityCategoryEdge"][]
};
	["SuitabilityCategoryEdge"]: {
		node:ModelTypes["SuitabilityCategory"]
};
	["DogBodyType"]: {
		_meta?:ModelTypes["DogBodyTypeMeta"],
	id:ModelTypes["UUID"],
	name?:string,
	lead?:string,
	dogs:ModelTypes["Dog"][],
	order:number,
	value:number,
	remoteId:string,
	category?:ModelTypes["DogBodyTypeCategory"],
	imageMain?:ModelTypes["Image"],
	imageFrom?:ModelTypes["Image"],
	imageTo?:ModelTypes["Image"],
	dogsByReproduction?:ModelTypes["Dog"],
	dogsByAvatar?:ModelTypes["Dog"],
	paginateDogs:ModelTypes["DogConnection"]
};
	["DogBodyTypeMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	dogs?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	value?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	category?:ModelTypes["FieldMeta"],
	imageMain?:ModelTypes["FieldMeta"],
	imageFrom?:ModelTypes["FieldMeta"],
	imageTo?:ModelTypes["FieldMeta"]
};
	["DogBodyTypeCategory"]: {
		_meta?:ModelTypes["DogBodyTypeCategoryMeta"],
	id:ModelTypes["UUID"],
	name:string,
	items:ModelTypes["DogBodyType"][],
	remoteId:string,
	imageMain?:ModelTypes["Image"],
	itemsByRemoteId?:ModelTypes["DogBodyType"],
	itemsByDogs?:ModelTypes["DogBodyType"],
	itemsByImageMain?:ModelTypes["DogBodyType"],
	itemsByImageFrom?:ModelTypes["DogBodyType"],
	itemsByImageTo?:ModelTypes["DogBodyType"],
	paginateItems:ModelTypes["DogBodyTypeConnection"]
};
	["DogBodyTypeCategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	imageMain?:ModelTypes["FieldMeta"]
};
	["DogBodyTypeCategoryItemsByRemoteIdUniqueWhere"]: GraphQLTypes["DogBodyTypeCategoryItemsByRemoteIdUniqueWhere"];
	["DogBodyTypeCategoryItemsByDogsUniqueWhere"]: GraphQLTypes["DogBodyTypeCategoryItemsByDogsUniqueWhere"];
	["DogBodyTypeCategoryItemsByImageMainUniqueWhere"]: GraphQLTypes["DogBodyTypeCategoryItemsByImageMainUniqueWhere"];
	["DogBodyTypeCategoryItemsByImageFromUniqueWhere"]: GraphQLTypes["DogBodyTypeCategoryItemsByImageFromUniqueWhere"];
	["DogBodyTypeCategoryItemsByImageToUniqueWhere"]: GraphQLTypes["DogBodyTypeCategoryItemsByImageToUniqueWhere"];
	["DogBodyTypeConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DogBodyTypeEdge"][]
};
	["DogBodyTypeEdge"]: {
		node:ModelTypes["DogBodyType"]
};
	["DogBodyTypeDogsByReproductionUniqueWhere"]: GraphQLTypes["DogBodyTypeDogsByReproductionUniqueWhere"];
	["DogBodyTypeDogsByAvatarUniqueWhere"]: GraphQLTypes["DogBodyTypeDogsByAvatarUniqueWhere"];
	["DogReproduction"]: {
		_meta?:ModelTypes["DogReproductionMeta"],
	id:ModelTypes["UUID"],
	type?:ModelTypes["DogReproductionType"],
	breastfeedingPuppyCount?:number,
	pregnancy?:ModelTypes["PregnantPeriodType"],
	dog?:ModelTypes["Dog"],
	breastfeedingCategory?:ModelTypes["BreastfeedingCategory"]
};
	["DogReproductionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	breastfeedingPuppyCount?:ModelTypes["FieldMeta"],
	pregnancy?:ModelTypes["FieldMeta"],
	dog?:ModelTypes["FieldMeta"],
	breastfeedingCategory?:ModelTypes["FieldMeta"]
};
	["BreastfeedingCategory"]: {
		_meta?:ModelTypes["BreastfeedingCategoryMeta"],
	id:ModelTypes["UUID"],
	week:number,
	coeficient:number,
	dogs:ModelTypes["DogReproduction"][],
	dogsByDog?:ModelTypes["DogReproduction"],
	paginateDogs:ModelTypes["DogReproductionConnection"]
};
	["BreastfeedingCategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	week?:ModelTypes["FieldMeta"],
	coeficient?:ModelTypes["FieldMeta"],
	dogs?:ModelTypes["FieldMeta"]
};
	["BreastfeedingCategoryDogsByDogUniqueWhere"]: GraphQLTypes["BreastfeedingCategoryDogsByDogUniqueWhere"];
	["DogReproductionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DogReproductionEdge"][]
};
	["DogReproductionEdge"]: {
		node:ModelTypes["DogReproduction"]
};
	["ItemSubCategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ItemSubCategoryEdge"][]
};
	["ItemSubCategoryEdge"]: {
		node:ModelTypes["ItemSubCategory"]
};
	["BodyTagConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BodyTagEdge"][]
};
	["BodyTagEdge"]: {
		node:ModelTypes["BodyTag"]
};
	["Review"]: {
		_meta?:ModelTypes["ReviewMeta"],
	id:ModelTypes["UUID"],
	dogBreeds:ModelTypes["Breed"][],
	text:string,
	remoteId:string,
	author?:string,
	paginateDogBreeds:ModelTypes["BreedConnection"]
};
	["ReviewMeta"]: {
		id?:ModelTypes["FieldMeta"],
	dogBreeds?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	author?:ModelTypes["FieldMeta"]
};
	["ReviewOrderBy"]: GraphQLTypes["ReviewOrderBy"];
	["FilterComboOrderBy"]: GraphQLTypes["FilterComboOrderBy"];
	["AgeCategoryOrderBy"]: GraphQLTypes["AgeCategoryOrderBy"];
	["BreedDogsByReproductionUniqueWhere"]: GraphQLTypes["BreedDogsByReproductionUniqueWhere"];
	["BreedDogsByAvatarUniqueWhere"]: GraphQLTypes["BreedDogsByAvatarUniqueWhere"];
	["BreedProductReviewsByProductReviewReactionsUniqueWhere"]: GraphQLTypes["BreedProductReviewsByProductReviewReactionsUniqueWhere"];
	["BreedProductReviewsByStatsUniqueWhere"]: GraphQLTypes["BreedProductReviewsByStatsUniqueWhere"];
	["BreedBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"]: GraphQLTypes["BreedBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"];
	["BreedBlogPostReviewsByStatsUniqueWhere"]: GraphQLTypes["BreedBlogPostReviewsByStatsUniqueWhere"];
	["BreedFilterCombosByRemoteIdUniqueWhere"]: GraphQLTypes["BreedFilterCombosByRemoteIdUniqueWhere"];
	["BreedFilterCombosBySeoUniqueWhere"]: GraphQLTypes["BreedFilterCombosBySeoUniqueWhere"];
	["ReviewConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ReviewEdge"][]
};
	["ReviewEdge"]: {
		node:ModelTypes["Review"]
};
	["FilterComboConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FilterComboEdge"][]
};
	["FilterComboEdge"]: {
		node:ModelTypes["FilterCombo"]
};
	["AgeCategory"]: {
		_meta?:ModelTypes["AgeCategoryMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	order?:number,
	labelFor:string,
	products:ModelTypes["Product"][],
	slug?:string,
	filterCombos:ModelTypes["FilterCombo"][],
	filterCombosByRemoteId?:ModelTypes["FilterCombo"],
	filterCombosBySeo?:ModelTypes["FilterCombo"],
	paginateProducts:ModelTypes["ProductConnection"],
	paginateFilterCombos:ModelTypes["FilterComboConnection"]
};
	["AgeCategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	labelFor?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	filterCombos?:ModelTypes["FieldMeta"]
};
	["AgeCategoryFilterCombosByRemoteIdUniqueWhere"]: GraphQLTypes["AgeCategoryFilterCombosByRemoteIdUniqueWhere"];
	["AgeCategoryFilterCombosBySeoUniqueWhere"]: GraphQLTypes["AgeCategoryFilterCombosBySeoUniqueWhere"];
	["RegionCountriesByRemoteIdUniqueWhere"]: GraphQLTypes["RegionCountriesByRemoteIdUniqueWhere"];
	["RegionCountriesByManufacturersUniqueWhere"]: GraphQLTypes["RegionCountriesByManufacturersUniqueWhere"];
	["BrandManufacturerUniqueWhere"]: GraphQLTypes["BrandManufacturerUniqueWhere"];
	["RegionFilterCombosByRemoteIdUniqueWhere"]: GraphQLTypes["RegionFilterCombosByRemoteIdUniqueWhere"];
	["RegionFilterCombosBySeoUniqueWhere"]: GraphQLTypes["RegionFilterCombosBySeoUniqueWhere"];
	["CountryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["CountryEdge"][]
};
	["CountryEdge"]: {
		node:ModelTypes["Country"]
};
	["CountryManufacturersByRemoteIdUniqueWhere"]: GraphQLTypes["CountryManufacturersByRemoteIdUniqueWhere"];
	["BrandManufacturerConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BrandManufacturerEdge"][]
};
	["BrandManufacturerEdge"]: {
		node:ModelTypes["BrandManufacturer"]
};
	["ProductLine"]: {
		_meta?:ModelTypes["ProductLineMeta"],
	id:ModelTypes["UUID"],
	name:string,
	products:ModelTypes["Product"][],
	remoteId:string,
	lead?:string,
	order?:number,
	brand?:ModelTypes["Brand"],
	logo?:ModelTypes["Image"],
	aliases:ModelTypes["ProductLineAlias"][],
	slug?:string,
	flavors:ModelTypes["ProductLineFlavor"][],
	seo?:ModelTypes["Seo"],
	customMetaDescription?:string,
	productsByRemoteId?:ModelTypes["Product"],
	productsBySlug?:ModelTypes["Product"],
	productsByNutritionalValues?:ModelTypes["Product"],
	productsByReviews?:ModelTypes["Product"],
	productsByDogs?:ModelTypes["Product"],
	productsByPackagings?:ModelTypes["Product"],
	productsByElements?:ModelTypes["Product"],
	productsByFlags?:ModelTypes["Product"],
	productsByImage?:ModelTypes["Product"],
	productsByAliases?:ModelTypes["Product"],
	productsByEvaluation?:ModelTypes["Product"],
	productsBySeo?:ModelTypes["Product"],
	productsByItemDeclensionFourthCategories?:ModelTypes["Product"],
	productsByHeurekaImage?:ModelTypes["Product"],
	productsByTopx?:ModelTypes["Product"],
	paginateProducts:ModelTypes["ProductConnection"],
	paginateAliases:ModelTypes["ProductLineAliasConnection"],
	paginateFlavors:ModelTypes["ProductLineFlavorConnection"]
};
	["ProductLineMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	brand?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	aliases?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	flavors?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	customMetaDescription?:ModelTypes["FieldMeta"]
};
	["ProductLineAlias"]: {
		_meta?:ModelTypes["ProductLineAliasMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	name:string,
	productLines:ModelTypes["ProductLine"][],
	paginateProductLines:ModelTypes["ProductLineConnection"]
};
	["ProductLineAliasMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	productLines?:ModelTypes["FieldMeta"]
};
	["ProductLineConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductLineEdge"][]
};
	["ProductLineEdge"]: {
		node:ModelTypes["ProductLine"]
};
	["ProductLineAliasOrderBy"]: GraphQLTypes["ProductLineAliasOrderBy"];
	["ProductLineFlavor"]: {
		_meta?:ModelTypes["ProductLineFlavorMeta"],
	id?:string,
	itemSubCategory?:ModelTypes["ItemSubCategory"],
	productLine?:ModelTypes["ProductLine"]
};
	["ProductLineFlavorMeta"]: {
		id?:ModelTypes["FieldMeta"],
	itemSubCategory?:ModelTypes["FieldMeta"],
	productLine?:ModelTypes["FieldMeta"]
};
	["ProductLineFlavorOrderBy"]: GraphQLTypes["ProductLineFlavorOrderBy"];
	["ProductLineProductsByRemoteIdUniqueWhere"]: GraphQLTypes["ProductLineProductsByRemoteIdUniqueWhere"];
	["ProductLineProductsBySlugUniqueWhere"]: GraphQLTypes["ProductLineProductsBySlugUniqueWhere"];
	["ProductLineProductsByNutritionalValuesUniqueWhere"]: GraphQLTypes["ProductLineProductsByNutritionalValuesUniqueWhere"];
	["ProductLineProductsByReviewsUniqueWhere"]: GraphQLTypes["ProductLineProductsByReviewsUniqueWhere"];
	["ProductLineProductsByDogsUniqueWhere"]: GraphQLTypes["ProductLineProductsByDogsUniqueWhere"];
	["ProductLineProductsByPackagingsUniqueWhere"]: GraphQLTypes["ProductLineProductsByPackagingsUniqueWhere"];
	["ProductLineProductsByElementsUniqueWhere"]: GraphQLTypes["ProductLineProductsByElementsUniqueWhere"];
	["ProductLineProductsByFlagsUniqueWhere"]: GraphQLTypes["ProductLineProductsByFlagsUniqueWhere"];
	["ProductLineProductsByImageUniqueWhere"]: GraphQLTypes["ProductLineProductsByImageUniqueWhere"];
	["ProductLineProductsByAliasesUniqueWhere"]: GraphQLTypes["ProductLineProductsByAliasesUniqueWhere"];
	["ProductLineProductsByEvaluationUniqueWhere"]: GraphQLTypes["ProductLineProductsByEvaluationUniqueWhere"];
	["ProductLineProductsBySeoUniqueWhere"]: GraphQLTypes["ProductLineProductsBySeoUniqueWhere"];
	["ProductLineProductsByItemDeclensionFourthCategoriesUniqueWhere"]: GraphQLTypes["ProductLineProductsByItemDeclensionFourthCategoriesUniqueWhere"];
	["ProductLineProductsByHeurekaImageUniqueWhere"]: GraphQLTypes["ProductLineProductsByHeurekaImageUniqueWhere"];
	["ProductLineProductsByTopxUniqueWhere"]: GraphQLTypes["ProductLineProductsByTopxUniqueWhere"];
	["ProductLineAliasConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductLineAliasEdge"][]
};
	["ProductLineAliasEdge"]: {
		node:ModelTypes["ProductLineAlias"]
};
	["ProductLineFlavorConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductLineFlavorEdge"][]
};
	["ProductLineFlavorEdge"]: {
		node:ModelTypes["ProductLineFlavor"]
};
	["ProductionMethod"]: {
		_meta?:ModelTypes["ProductionMethodMeta"],
	id:ModelTypes["UUID"],
	name:string,
	brands:ModelTypes["Brand"][],
	remoteId:string,
	brandsByRemoteId?:ModelTypes["Brand"],
	brandsBySlug?:ModelTypes["Brand"],
	brandsByProducts?:ModelTypes["Brand"],
	brandsByProductLines?:ModelTypes["Brand"],
	brandsByLogo?:ModelTypes["Brand"],
	brandsByAliases?:ModelTypes["Brand"],
	brandsByFlavors?:ModelTypes["Brand"],
	brandsBySeo?:ModelTypes["Brand"],
	brandsByFilterCombos?:ModelTypes["Brand"],
	brandsByTopx?:ModelTypes["Brand"],
	brandsByContent?:ModelTypes["Brand"],
	brandsByDraft?:ModelTypes["Brand"],
	paginateBrands:ModelTypes["BrandConnection"]
};
	["ProductionMethodMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	brands?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"]
};
	["ProductionMethodBrandsByRemoteIdUniqueWhere"]: GraphQLTypes["ProductionMethodBrandsByRemoteIdUniqueWhere"];
	["ProductionMethodBrandsBySlugUniqueWhere"]: GraphQLTypes["ProductionMethodBrandsBySlugUniqueWhere"];
	["ProductionMethodBrandsByProductsUniqueWhere"]: GraphQLTypes["ProductionMethodBrandsByProductsUniqueWhere"];
	["ProductionMethodBrandsByProductLinesUniqueWhere"]: GraphQLTypes["ProductionMethodBrandsByProductLinesUniqueWhere"];
	["ProductLineUniqueWhere"]: GraphQLTypes["ProductLineUniqueWhere"];
	["ProductLineFlavorUniqueWhere"]: GraphQLTypes["ProductLineFlavorUniqueWhere"];
	["ProductionMethodBrandsByLogoUniqueWhere"]: GraphQLTypes["ProductionMethodBrandsByLogoUniqueWhere"];
	["ProductionMethodBrandsByAliasesUniqueWhere"]: GraphQLTypes["ProductionMethodBrandsByAliasesUniqueWhere"];
	["BrandAliasUniqueWhere"]: GraphQLTypes["BrandAliasUniqueWhere"];
	["ProductionMethodBrandsByFlavorsUniqueWhere"]: GraphQLTypes["ProductionMethodBrandsByFlavorsUniqueWhere"];
	["BrandFlavorUniqueWhere"]: GraphQLTypes["BrandFlavorUniqueWhere"];
	["ProductionMethodBrandsBySeoUniqueWhere"]: GraphQLTypes["ProductionMethodBrandsBySeoUniqueWhere"];
	["ProductionMethodBrandsByFilterCombosUniqueWhere"]: GraphQLTypes["ProductionMethodBrandsByFilterCombosUniqueWhere"];
	["ProductionMethodBrandsByTopxUniqueWhere"]: GraphQLTypes["ProductionMethodBrandsByTopxUniqueWhere"];
	["TOPXBrandUniqueWhere"]: GraphQLTypes["TOPXBrandUniqueWhere"];
	["ProductionMethodBrandsByContentUniqueWhere"]: GraphQLTypes["ProductionMethodBrandsByContentUniqueWhere"];
	["ProductionMethodBrandsByDraftUniqueWhere"]: GraphQLTypes["ProductionMethodBrandsByDraftUniqueWhere"];
	["BrandDistributor"]: {
		_meta?:ModelTypes["BrandDistributorMeta"],
	id:ModelTypes["UUID"],
	name:string,
	brands:ModelTypes["Brand"][],
	link?:string,
	remoteId:string,
	brandsByRemoteId?:ModelTypes["Brand"],
	brandsBySlug?:ModelTypes["Brand"],
	brandsByProducts?:ModelTypes["Brand"],
	brandsByProductLines?:ModelTypes["Brand"],
	brandsByLogo?:ModelTypes["Brand"],
	brandsByAliases?:ModelTypes["Brand"],
	brandsByFlavors?:ModelTypes["Brand"],
	brandsBySeo?:ModelTypes["Brand"],
	brandsByFilterCombos?:ModelTypes["Brand"],
	brandsByTopx?:ModelTypes["Brand"],
	brandsByContent?:ModelTypes["Brand"],
	brandsByDraft?:ModelTypes["Brand"],
	paginateBrands:ModelTypes["BrandConnection"]
};
	["BrandDistributorMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	brands?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"]
};
	["BrandDistributorBrandsByRemoteIdUniqueWhere"]: GraphQLTypes["BrandDistributorBrandsByRemoteIdUniqueWhere"];
	["BrandDistributorBrandsBySlugUniqueWhere"]: GraphQLTypes["BrandDistributorBrandsBySlugUniqueWhere"];
	["BrandDistributorBrandsByProductsUniqueWhere"]: GraphQLTypes["BrandDistributorBrandsByProductsUniqueWhere"];
	["BrandDistributorBrandsByProductLinesUniqueWhere"]: GraphQLTypes["BrandDistributorBrandsByProductLinesUniqueWhere"];
	["BrandDistributorBrandsByLogoUniqueWhere"]: GraphQLTypes["BrandDistributorBrandsByLogoUniqueWhere"];
	["BrandDistributorBrandsByAliasesUniqueWhere"]: GraphQLTypes["BrandDistributorBrandsByAliasesUniqueWhere"];
	["BrandDistributorBrandsByFlavorsUniqueWhere"]: GraphQLTypes["BrandDistributorBrandsByFlavorsUniqueWhere"];
	["BrandDistributorBrandsBySeoUniqueWhere"]: GraphQLTypes["BrandDistributorBrandsBySeoUniqueWhere"];
	["BrandDistributorBrandsByFilterCombosUniqueWhere"]: GraphQLTypes["BrandDistributorBrandsByFilterCombosUniqueWhere"];
	["BrandDistributorBrandsByTopxUniqueWhere"]: GraphQLTypes["BrandDistributorBrandsByTopxUniqueWhere"];
	["BrandDistributorBrandsByContentUniqueWhere"]: GraphQLTypes["BrandDistributorBrandsByContentUniqueWhere"];
	["BrandDistributorBrandsByDraftUniqueWhere"]: GraphQLTypes["BrandDistributorBrandsByDraftUniqueWhere"];
	["BrandAlias"]: {
		_meta?:ModelTypes["BrandAliasMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	name:string,
	brand?:ModelTypes["Brand"]
};
	["BrandAliasMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	brand?:ModelTypes["FieldMeta"]
};
	["BrandAliasOrderBy"]: GraphQLTypes["BrandAliasOrderBy"];
	["BrandFlavor"]: {
		_meta?:ModelTypes["BrandFlavorMeta"],
	id?:string,
	brand?:ModelTypes["Brand"],
	itemSubCategory?:ModelTypes["ItemSubCategory"]
};
	["BrandFlavorMeta"]: {
		id?:ModelTypes["FieldMeta"],
	brand?:ModelTypes["FieldMeta"],
	itemSubCategory?:ModelTypes["FieldMeta"]
};
	["BrandFlavorOrderBy"]: GraphQLTypes["BrandFlavorOrderBy"];
	["TOPXBrand"]: {
		_meta?:ModelTypes["TOPXBrandMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	order:number,
	orderType:ModelTypes["TOPXBrandOrderType"],
	brand?:ModelTypes["Brand"],
	category?:ModelTypes["TOPXBrandCategory"]
};
	["TOPXBrandMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	orderType?:ModelTypes["FieldMeta"],
	brand?:ModelTypes["FieldMeta"],
	category?:ModelTypes["FieldMeta"]
};
	["TOPXBrandCategory"]: {
		_meta?:ModelTypes["TOPXBrandCategoryMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	brands:ModelTypes["TOPXBrand"][],
	brandsByRemoteId?:ModelTypes["TOPXBrand"],
	paginateBrands:ModelTypes["TOPXBrandConnection"]
};
	["TOPXBrandCategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	brands?:ModelTypes["FieldMeta"]
};
	["TOPXBrandOrderBy"]: GraphQLTypes["TOPXBrandOrderBy"];
	["TOPXBrandCategoryOrderBy"]: GraphQLTypes["TOPXBrandCategoryOrderBy"];
	["TOPXBrandCategoryBrandsByRemoteIdUniqueWhere"]: GraphQLTypes["TOPXBrandCategoryBrandsByRemoteIdUniqueWhere"];
	["TOPXBrandConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TOPXBrandEdge"][]
};
	["TOPXBrandEdge"]: {
		node:ModelTypes["TOPXBrand"]
};
	["BrandProductsByRemoteIdUniqueWhere"]: GraphQLTypes["BrandProductsByRemoteIdUniqueWhere"];
	["BrandProductsBySlugUniqueWhere"]: GraphQLTypes["BrandProductsBySlugUniqueWhere"];
	["BrandProductsByNutritionalValuesUniqueWhere"]: GraphQLTypes["BrandProductsByNutritionalValuesUniqueWhere"];
	["BrandProductsByReviewsUniqueWhere"]: GraphQLTypes["BrandProductsByReviewsUniqueWhere"];
	["BrandProductsByDogsUniqueWhere"]: GraphQLTypes["BrandProductsByDogsUniqueWhere"];
	["BrandProductsByPackagingsUniqueWhere"]: GraphQLTypes["BrandProductsByPackagingsUniqueWhere"];
	["BrandProductsByElementsUniqueWhere"]: GraphQLTypes["BrandProductsByElementsUniqueWhere"];
	["BrandProductsByFlagsUniqueWhere"]: GraphQLTypes["BrandProductsByFlagsUniqueWhere"];
	["BrandProductsByImageUniqueWhere"]: GraphQLTypes["BrandProductsByImageUniqueWhere"];
	["BrandProductsByAliasesUniqueWhere"]: GraphQLTypes["BrandProductsByAliasesUniqueWhere"];
	["BrandProductsByEvaluationUniqueWhere"]: GraphQLTypes["BrandProductsByEvaluationUniqueWhere"];
	["BrandProductsBySeoUniqueWhere"]: GraphQLTypes["BrandProductsBySeoUniqueWhere"];
	["BrandProductsByItemDeclensionFourthCategoriesUniqueWhere"]: GraphQLTypes["BrandProductsByItemDeclensionFourthCategoriesUniqueWhere"];
	["BrandProductsByHeurekaImageUniqueWhere"]: GraphQLTypes["BrandProductsByHeurekaImageUniqueWhere"];
	["BrandProductsByTopxUniqueWhere"]: GraphQLTypes["BrandProductsByTopxUniqueWhere"];
	["BrandProductLinesByRemoteIdUniqueWhere"]: GraphQLTypes["BrandProductLinesByRemoteIdUniqueWhere"];
	["BrandProductLinesBySlugUniqueWhere"]: GraphQLTypes["BrandProductLinesBySlugUniqueWhere"];
	["BrandProductLinesByProductsUniqueWhere"]: GraphQLTypes["BrandProductLinesByProductsUniqueWhere"];
	["BrandProductLinesByLogoUniqueWhere"]: GraphQLTypes["BrandProductLinesByLogoUniqueWhere"];
	["BrandProductLinesByFlavorsUniqueWhere"]: GraphQLTypes["BrandProductLinesByFlavorsUniqueWhere"];
	["BrandProductLinesBySeoUniqueWhere"]: GraphQLTypes["BrandProductLinesBySeoUniqueWhere"];
	["BrandAliasesByRemoteIdUniqueWhere"]: GraphQLTypes["BrandAliasesByRemoteIdUniqueWhere"];
	["BrandFilterCombosByRemoteIdUniqueWhere"]: GraphQLTypes["BrandFilterCombosByRemoteIdUniqueWhere"];
	["BrandFilterCombosBySeoUniqueWhere"]: GraphQLTypes["BrandFilterCombosBySeoUniqueWhere"];
	["BrandTopxByRemoteIdUniqueWhere"]: GraphQLTypes["BrandTopxByRemoteIdUniqueWhere"];
	["BrandAliasConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BrandAliasEdge"][]
};
	["BrandAliasEdge"]: {
		node:ModelTypes["BrandAlias"]
};
	["AdConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["AdEdge"][]
};
	["AdEdge"]: {
		node:ModelTypes["Ad"]
};
	["BrandFlavorConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BrandFlavorEdge"][]
};
	["BrandFlavorEdge"]: {
		node:ModelTypes["BrandFlavor"]
};
	["AdContentReferencesByImagesUniqueWhere"]: GraphQLTypes["AdContentReferencesByImagesUniqueWhere"];
	["AdContentReferencesByLinkUniqueWhere"]: GraphQLTypes["AdContentReferencesByLinkUniqueWhere"];
	["AdContentReferencesByListUniqueWhere"]: GraphQLTypes["AdContentReferencesByListUniqueWhere"];
	["AdContentReferencesByOutlineUniqueWhere"]: GraphQLTypes["AdContentReferencesByOutlineUniqueWhere"];
	["AdContentReferencesByVideoUniqueWhere"]: GraphQLTypes["AdContentReferencesByVideoUniqueWhere"];
	["AdContentReferencesByImageUniqueWhere"]: GraphQLTypes["AdContentReferencesByImageUniqueWhere"];
	["ItemCategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ItemCategoryEdge"][]
};
	["ItemCategoryEdge"]: {
		node:ModelTypes["ItemCategory"]
};
	["ContentReferenceConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentReferenceEdge"][]
};
	["ContentReferenceEdge"]: {
		node:ModelTypes["ContentReference"]
};
	["ItemDeclensionFourthVariant"]: {
		_meta?:ModelTypes["ItemDeclensionFourthVariantMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["Item"][],
	label:string,
	remoteId:string,
	declensionSeventh?:string,
	isNegativ?:boolean,
	seo?:ModelTypes["Seo"],
	subcategory?:ModelTypes["ItemSubCategory"],
	category?:ModelTypes["ItemCategory"],
	element?:ModelTypes["Element"],
	products:ModelTypes["ProductItemDeclensionFourthCategory"][],
	slug:string,
	content?:ModelTypes["Content"],
	draft?:ModelTypes["Content"],
	itemsByRemoteId?:ModelTypes["Item"],
	itemsBySlug?:ModelTypes["Item"],
	itemsByFeaturesOfProduct?:ModelTypes["Item"],
	itemsByImage?:ModelTypes["Item"],
	itemsByReferenceList?:ModelTypes["Item"],
	itemsBySeo?:ModelTypes["Item"],
	itemsByAliases?:ModelTypes["Item"],
	itemsByContent?:ModelTypes["Item"],
	itemsByDraft?:ModelTypes["Item"],
	paginateItems:ModelTypes["ItemConnection"],
	paginateProducts:ModelTypes["ProductItemDeclensionFourthCategoryConnection"]
};
	["ItemDeclensionFourthVariantMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	declensionSeventh?:ModelTypes["FieldMeta"],
	isNegativ?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	subcategory?:ModelTypes["FieldMeta"],
	category?:ModelTypes["FieldMeta"],
	element?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	draft?:ModelTypes["FieldMeta"]
};
	["ProductItemDeclensionFourthCategory"]: {
		_meta?:ModelTypes["ProductItemDeclensionFourthCategoryMeta"],
	id?:string,
	declensionFourthCategory?:ModelTypes["ItemDeclensionFourthVariant"],
	product?:ModelTypes["Product"]
};
	["ProductItemDeclensionFourthCategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	declensionFourthCategory?:ModelTypes["FieldMeta"],
	product?:ModelTypes["FieldMeta"]
};
	["ProductItemDeclensionFourthCategoryOrderBy"]: GraphQLTypes["ProductItemDeclensionFourthCategoryOrderBy"];
	["ItemDeclensionFourthVariantItemsByRemoteIdUniqueWhere"]: GraphQLTypes["ItemDeclensionFourthVariantItemsByRemoteIdUniqueWhere"];
	["ItemDeclensionFourthVariantItemsBySlugUniqueWhere"]: GraphQLTypes["ItemDeclensionFourthVariantItemsBySlugUniqueWhere"];
	["ItemDeclensionFourthVariantItemsByFeaturesOfProductUniqueWhere"]: GraphQLTypes["ItemDeclensionFourthVariantItemsByFeaturesOfProductUniqueWhere"];
	["ItemDeclensionFourthVariantItemsByImageUniqueWhere"]: GraphQLTypes["ItemDeclensionFourthVariantItemsByImageUniqueWhere"];
	["ItemDeclensionFourthVariantItemsByReferenceListUniqueWhere"]: GraphQLTypes["ItemDeclensionFourthVariantItemsByReferenceListUniqueWhere"];
	["ItemDeclensionFourthVariantItemsBySeoUniqueWhere"]: GraphQLTypes["ItemDeclensionFourthVariantItemsBySeoUniqueWhere"];
	["ItemDeclensionFourthVariantItemsByAliasesUniqueWhere"]: GraphQLTypes["ItemDeclensionFourthVariantItemsByAliasesUniqueWhere"];
	["ItemDeclensionFourthVariantItemsByContentUniqueWhere"]: GraphQLTypes["ItemDeclensionFourthVariantItemsByContentUniqueWhere"];
	["ItemDeclensionFourthVariantItemsByDraftUniqueWhere"]: GraphQLTypes["ItemDeclensionFourthVariantItemsByDraftUniqueWhere"];
	["ItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ItemEdge"][]
};
	["ItemEdge"]: {
		node:ModelTypes["Item"]
};
	["ProductItemDeclensionFourthCategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductItemDeclensionFourthCategoryEdge"][]
};
	["ProductItemDeclensionFourthCategoryEdge"]: {
		node:ModelTypes["ProductItemDeclensionFourthCategory"]
};
	["ItemGroup"]: {
		_meta?:ModelTypes["ItemGroupMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	name:string,
	categories:ModelTypes["ItemCategory"][],
	categoriesByRemoteId?:ModelTypes["ItemCategory"],
	categoriesBySlug?:ModelTypes["ItemCategory"],
	categoriesBySubCategories?:ModelTypes["ItemCategory"],
	categoriesByFeatureDependencies?:ModelTypes["ItemCategory"],
	categoriesByImage?:ModelTypes["ItemCategory"],
	categoriesByRedirects?:ModelTypes["ItemCategory"],
	categoriesByDeclensionsFourth?:ModelTypes["ItemCategory"],
	categoriesBySeo?:ModelTypes["ItemCategory"],
	categoriesByContent?:ModelTypes["ItemCategory"],
	categoriesByDraft?:ModelTypes["ItemCategory"],
	paginateCategories:ModelTypes["ItemCategoryConnection"]
};
	["ItemGroupMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	categories?:ModelTypes["FieldMeta"]
};
	["ItemGroupCategoriesByRemoteIdUniqueWhere"]: GraphQLTypes["ItemGroupCategoriesByRemoteIdUniqueWhere"];
	["ItemGroupCategoriesBySlugUniqueWhere"]: GraphQLTypes["ItemGroupCategoriesBySlugUniqueWhere"];
	["ItemGroupCategoriesBySubCategoriesUniqueWhere"]: GraphQLTypes["ItemGroupCategoriesBySubCategoriesUniqueWhere"];
	["ItemSubCategoryUniqueWhere"]: GraphQLTypes["ItemSubCategoryUniqueWhere"];
	["ItemGroupCategoriesByFeatureDependenciesUniqueWhere"]: GraphQLTypes["ItemGroupCategoriesByFeatureDependenciesUniqueWhere"];
	["ItemGroupCategoriesByImageUniqueWhere"]: GraphQLTypes["ItemGroupCategoriesByImageUniqueWhere"];
	["ItemGroupCategoriesByRedirectsUniqueWhere"]: GraphQLTypes["ItemGroupCategoriesByRedirectsUniqueWhere"];
	["ItemGroupCategoriesByDeclensionsFourthUniqueWhere"]: GraphQLTypes["ItemGroupCategoriesByDeclensionsFourthUniqueWhere"];
	["ItemDeclensionFourthVariantUniqueWhere"]: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"];
	["ElementUniqueWhere"]: GraphQLTypes["ElementUniqueWhere"];
	["SuitabilityItemUniqueWhere"]: GraphQLTypes["SuitabilityItemUniqueWhere"];
	["ItemGroupCategoriesBySeoUniqueWhere"]: GraphQLTypes["ItemGroupCategoriesBySeoUniqueWhere"];
	["ItemGroupCategoriesByContentUniqueWhere"]: GraphQLTypes["ItemGroupCategoriesByContentUniqueWhere"];
	["ItemGroupCategoriesByDraftUniqueWhere"]: GraphQLTypes["ItemGroupCategoriesByDraftUniqueWhere"];
	["ItemCategorySubCategoriesByRemoteIdUniqueWhere"]: GraphQLTypes["ItemCategorySubCategoriesByRemoteIdUniqueWhere"];
	["ItemCategorySubCategoriesBySlugUniqueWhere"]: GraphQLTypes["ItemCategorySubCategoriesBySlugUniqueWhere"];
	["ItemCategorySubCategoriesByFeatureDependenciesUniqueWhere"]: GraphQLTypes["ItemCategorySubCategoriesByFeatureDependenciesUniqueWhere"];
	["ItemCategorySubCategoriesByBrandsUniqueWhere"]: GraphQLTypes["ItemCategorySubCategoriesByBrandsUniqueWhere"];
	["ItemCategorySubCategoriesByProductLinesUniqueWhere"]: GraphQLTypes["ItemCategorySubCategoriesByProductLinesUniqueWhere"];
	["ItemCategorySubCategoriesByFilterCombosFlavorUniqueWhere"]: GraphQLTypes["ItemCategorySubCategoriesByFilterCombosFlavorUniqueWhere"];
	["ItemCategorySubCategoriesByFilterCombosAllergyUniqueWhere"]: GraphQLTypes["ItemCategorySubCategoriesByFilterCombosAllergyUniqueWhere"];
	["ItemCategoryFeatureDependenciesByRemoteIdUniqueWhere"]: GraphQLTypes["ItemCategoryFeatureDependenciesByRemoteIdUniqueWhere"];
	["ItemCategoryRedirectsByFromUniqueWhere"]: GraphQLTypes["ItemCategoryRedirectsByFromUniqueWhere"];
	["ItemCategoryDeclensionsFourthByRemoteIdUniqueWhere"]: GraphQLTypes["ItemCategoryDeclensionsFourthByRemoteIdUniqueWhere"];
	["ItemCategoryDeclensionsFourthBySlugUniqueWhere"]: GraphQLTypes["ItemCategoryDeclensionsFourthBySlugUniqueWhere"];
	["ItemCategoryDeclensionsFourthByItemsUniqueWhere"]: GraphQLTypes["ItemCategoryDeclensionsFourthByItemsUniqueWhere"];
	["ItemCategoryDeclensionsFourthBySeoUniqueWhere"]: GraphQLTypes["ItemCategoryDeclensionsFourthBySeoUniqueWhere"];
	["ItemCategoryDeclensionsFourthBySubcategoryUniqueWhere"]: GraphQLTypes["ItemCategoryDeclensionsFourthBySubcategoryUniqueWhere"];
	["ItemCategoryDeclensionsFourthByElementUniqueWhere"]: GraphQLTypes["ItemCategoryDeclensionsFourthByElementUniqueWhere"];
	["ItemCategoryDeclensionsFourthByProductsUniqueWhere"]: GraphQLTypes["ItemCategoryDeclensionsFourthByProductsUniqueWhere"];
	["ItemCategoryDeclensionsFourthByContentUniqueWhere"]: GraphQLTypes["ItemCategoryDeclensionsFourthByContentUniqueWhere"];
	["ItemCategoryDeclensionsFourthByDraftUniqueWhere"]: GraphQLTypes["ItemCategoryDeclensionsFourthByDraftUniqueWhere"];
	["ProductFeatureConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductFeatureEdge"][]
};
	["ProductFeatureEdge"]: {
		node:ModelTypes["ProductFeature"]
};
	["RedirectConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RedirectEdge"][]
};
	["RedirectEdge"]: {
		node:ModelTypes["Redirect"]
};
	["ItemDeclensionFourthVariantConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ItemDeclensionFourthVariantEdge"][]
};
	["ItemDeclensionFourthVariantEdge"]: {
		node:ModelTypes["ItemDeclensionFourthVariant"]
};
	["ItemFlavorCategory"]: {
		_meta?:ModelTypes["ItemFlavorCategoryMeta"],
	id:ModelTypes["UUID"],
	name?:string,
	items:ModelTypes["ItemSubCategory"][],
	remoteId:string,
	color?:ModelTypes["Color"],
	itemsByRemoteId?:ModelTypes["ItemSubCategory"],
	itemsBySlug?:ModelTypes["ItemSubCategory"],
	itemsByFeatureDependencies?:ModelTypes["ItemSubCategory"],
	itemsByBrands?:ModelTypes["ItemSubCategory"],
	itemsByProductLines?:ModelTypes["ItemSubCategory"],
	itemsByFilterCombosFlavor?:ModelTypes["ItemSubCategory"],
	itemsByFilterCombosAllergy?:ModelTypes["ItemSubCategory"],
	paginateItems:ModelTypes["ItemSubCategoryConnection"]
};
	["ItemFlavorCategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	color?:ModelTypes["FieldMeta"]
};
	["ItemFlavorCategoryItemsByRemoteIdUniqueWhere"]: GraphQLTypes["ItemFlavorCategoryItemsByRemoteIdUniqueWhere"];
	["ItemFlavorCategoryItemsBySlugUniqueWhere"]: GraphQLTypes["ItemFlavorCategoryItemsBySlugUniqueWhere"];
	["ItemFlavorCategoryItemsByFeatureDependenciesUniqueWhere"]: GraphQLTypes["ItemFlavorCategoryItemsByFeatureDependenciesUniqueWhere"];
	["ItemFlavorCategoryItemsByBrandsUniqueWhere"]: GraphQLTypes["ItemFlavorCategoryItemsByBrandsUniqueWhere"];
	["ItemFlavorCategoryItemsByProductLinesUniqueWhere"]: GraphQLTypes["ItemFlavorCategoryItemsByProductLinesUniqueWhere"];
	["ItemFlavorCategoryItemsByFilterCombosFlavorUniqueWhere"]: GraphQLTypes["ItemFlavorCategoryItemsByFilterCombosFlavorUniqueWhere"];
	["ItemFlavorCategoryItemsByFilterCombosAllergyUniqueWhere"]: GraphQLTypes["ItemFlavorCategoryItemsByFilterCombosAllergyUniqueWhere"];
	["ItemSubCategoryFeatureDependenciesByRemoteIdUniqueWhere"]: GraphQLTypes["ItemSubCategoryFeatureDependenciesByRemoteIdUniqueWhere"];
	["ItemSubCategoryFilterCombosFlavorByRemoteIdUniqueWhere"]: GraphQLTypes["ItemSubCategoryFilterCombosFlavorByRemoteIdUniqueWhere"];
	["ItemSubCategoryFilterCombosFlavorBySeoUniqueWhere"]: GraphQLTypes["ItemSubCategoryFilterCombosFlavorBySeoUniqueWhere"];
	["ItemSubCategoryFilterCombosAllergyByRemoteIdUniqueWhere"]: GraphQLTypes["ItemSubCategoryFilterCombosAllergyByRemoteIdUniqueWhere"];
	["ItemSubCategoryFilterCombosAllergyBySeoUniqueWhere"]: GraphQLTypes["ItemSubCategoryFilterCombosAllergyBySeoUniqueWhere"];
	["ReferenceList"]: {
		_meta?:ModelTypes["ReferenceListMeta"],
	id:ModelTypes["UUID"],
	references:ModelTypes["Reference"][],
	paginateReferences:ModelTypes["ReferenceConnection"]
};
	["ReferenceListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	references?:ModelTypes["FieldMeta"]
};
	["Reference"]: {
		_meta?:ModelTypes["ReferenceMeta"],
	id:ModelTypes["UUID"],
	text?:string,
	link?:string,
	order?:number,
	list?:ModelTypes["ReferenceList"]
};
	["ReferenceMeta"]: {
		id?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"]
};
	["ReferenceOrderBy"]: GraphQLTypes["ReferenceOrderBy"];
	["ReferenceConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ReferenceEdge"][]
};
	["ReferenceEdge"]: {
		node:ModelTypes["Reference"]
};
	["ItemDeclensionSeventhVariant"]: {
		_meta?:ModelTypes["ItemDeclensionSeventhVariantMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["Item"][],
	label:string,
	remoteId:string,
	itemsByRemoteId?:ModelTypes["Item"],
	itemsBySlug?:ModelTypes["Item"],
	itemsByFeaturesOfProduct?:ModelTypes["Item"],
	itemsByImage?:ModelTypes["Item"],
	itemsByReferenceList?:ModelTypes["Item"],
	itemsBySeo?:ModelTypes["Item"],
	itemsByAliases?:ModelTypes["Item"],
	itemsByContent?:ModelTypes["Item"],
	itemsByDraft?:ModelTypes["Item"],
	paginateItems:ModelTypes["ItemConnection"]
};
	["ItemDeclensionSeventhVariantMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"]
};
	["ItemDeclensionSeventhVariantItemsByRemoteIdUniqueWhere"]: GraphQLTypes["ItemDeclensionSeventhVariantItemsByRemoteIdUniqueWhere"];
	["ItemDeclensionSeventhVariantItemsBySlugUniqueWhere"]: GraphQLTypes["ItemDeclensionSeventhVariantItemsBySlugUniqueWhere"];
	["ItemDeclensionSeventhVariantItemsByFeaturesOfProductUniqueWhere"]: GraphQLTypes["ItemDeclensionSeventhVariantItemsByFeaturesOfProductUniqueWhere"];
	["ItemDeclensionSeventhVariantItemsByImageUniqueWhere"]: GraphQLTypes["ItemDeclensionSeventhVariantItemsByImageUniqueWhere"];
	["ItemDeclensionSeventhVariantItemsByReferenceListUniqueWhere"]: GraphQLTypes["ItemDeclensionSeventhVariantItemsByReferenceListUniqueWhere"];
	["ItemDeclensionSeventhVariantItemsBySeoUniqueWhere"]: GraphQLTypes["ItemDeclensionSeventhVariantItemsBySeoUniqueWhere"];
	["ItemDeclensionSeventhVariantItemsByAliasesUniqueWhere"]: GraphQLTypes["ItemDeclensionSeventhVariantItemsByAliasesUniqueWhere"];
	["ItemDeclensionSeventhVariantItemsByContentUniqueWhere"]: GraphQLTypes["ItemDeclensionSeventhVariantItemsByContentUniqueWhere"];
	["ItemDeclensionSeventhVariantItemsByDraftUniqueWhere"]: GraphQLTypes["ItemDeclensionSeventhVariantItemsByDraftUniqueWhere"];
	["ItemAlias"]: {
		_meta?:ModelTypes["ItemAliasMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	name:string,
	item?:ModelTypes["Item"]
};
	["ItemAliasMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	item?:ModelTypes["FieldMeta"]
};
	["ItemAliasOrderBy"]: GraphQLTypes["ItemAliasOrderBy"];
	["ItemFeaturesOfProductByRemoteIdUniqueWhere"]: GraphQLTypes["ItemFeaturesOfProductByRemoteIdUniqueWhere"];
	["ItemAliasesByRemoteIdUniqueWhere"]: GraphQLTypes["ItemAliasesByRemoteIdUniqueWhere"];
	["ItemAliasConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ItemAliasEdge"][]
};
	["ItemAliasEdge"]: {
		node:ModelTypes["ItemAlias"]
};
	["ProductFlag"]: {
		_meta?:ModelTypes["ProductFlagMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	productFeatures:ModelTypes["ProductFeature"][],
	products:ModelTypes["ProductFlagOfProduct"][],
	productFeaturesByRemoteId?:ModelTypes["ProductFeature"],
	productsByRemoteId?:ModelTypes["ProductFlagOfProduct"],
	paginateProductFeatures:ModelTypes["ProductFeatureConnection"],
	paginateProducts:ModelTypes["ProductFlagOfProductConnection"]
};
	["ProductFlagMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	productFeatures?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"]
};
	["ProductFlagOfProduct"]: {
		_meta?:ModelTypes["ProductFlagOfProductMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	value?:ModelTypes["ProductFlagValue"],
	product?:ModelTypes["Product"],
	flag?:ModelTypes["ProductFlag"]
};
	["ProductFlagOfProductMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	value?:ModelTypes["FieldMeta"],
	product?:ModelTypes["FieldMeta"],
	flag?:ModelTypes["FieldMeta"]
};
	["ProductFlagOfProductOrderBy"]: GraphQLTypes["ProductFlagOfProductOrderBy"];
	["ProductFlagProductFeaturesByRemoteIdUniqueWhere"]: GraphQLTypes["ProductFlagProductFeaturesByRemoteIdUniqueWhere"];
	["ProductFlagProductsByRemoteIdUniqueWhere"]: GraphQLTypes["ProductFlagProductsByRemoteIdUniqueWhere"];
	["ProductFlagOfProductConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductFlagOfProductEdge"][]
};
	["ProductFlagOfProductEdge"]: {
		node:ModelTypes["ProductFlagOfProduct"]
};
	["ElementProductsByRemoteIdUniqueWhere"]: GraphQLTypes["ElementProductsByRemoteIdUniqueWhere"];
	["ElementFeatureDependenciesByRemoteIdUniqueWhere"]: GraphQLTypes["ElementFeatureDependenciesByRemoteIdUniqueWhere"];
	["ElementSuitabilityElementsByRemoteIdUniqueWhere"]: GraphQLTypes["ElementSuitabilityElementsByRemoteIdUniqueWhere"];
	["ElementOfProductConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ElementOfProductEdge"][]
};
	["ElementOfProductEdge"]: {
		node:ModelTypes["ElementOfProduct"]
};
	["NutritionalValueProductsByRemoteIdUniqueWhere"]: GraphQLTypes["NutritionalValueProductsByRemoteIdUniqueWhere"];
	["NutritionalValueSuitabilityNutritionalValuesByRemoteIdUniqueWhere"]: GraphQLTypes["NutritionalValueSuitabilityNutritionalValuesByRemoteIdUniqueWhere"];
	["NutritionalValueOfProductConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["NutritionalValueOfProductEdge"][]
};
	["NutritionalValueOfProductEdge"]: {
		node:ModelTypes["NutritionalValueOfProduct"]
};
	["ProductPackage"]: {
		_meta?:ModelTypes["ProductPackageMeta"],
	id:ModelTypes["UUID"],
	price?:number,
	order:number,
	link?:string,
	product?:ModelTypes["Product"],
	amount:number,
	externalId?:string,
	remoteId:string,
	label?:string,
	positionId?:string,
	heurekaPrice?:number,
	heurekaLink?:string
};
	["ProductPackageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	price?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	product?:ModelTypes["FieldMeta"],
	amount?:ModelTypes["FieldMeta"],
	externalId?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	positionId?:ModelTypes["FieldMeta"],
	heurekaPrice?:ModelTypes["FieldMeta"],
	heurekaLink?:ModelTypes["FieldMeta"]
};
	["ProductPackageOrderBy"]: GraphQLTypes["ProductPackageOrderBy"];
	["GranuleSize"]: {
		_meta?:ModelTypes["GranuleSizeMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	products:ModelTypes["Product"][],
	name:ModelTypes["GranuleSizeType"],
	paginateProducts:ModelTypes["ProductConnection"]
};
	["GranuleSizeMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"]
};
	["GranuleSizeOrderBy"]: GraphQLTypes["GranuleSizeOrderBy"];
	["ProductAlias"]: {
		_meta?:ModelTypes["ProductAliasMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	name:string,
	product?:ModelTypes["Product"]
};
	["ProductAliasMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	product?:ModelTypes["FieldMeta"]
};
	["ProductAliasOrderBy"]: GraphQLTypes["ProductAliasOrderBy"];
	["ProductEvaluation"]: {
		_meta?:ModelTypes["ProductEvaluationMeta"],
	id:ModelTypes["UUID"],
	nazev?:string,
	vetDieta?:string,
	vetDieta1?:string,
	vetDieta2?:string,
	aktivita?:string,
	vek?:string,
	velikostPlemen?:string,
	hmotnostPlemene?:string,
	velikostGranuli?:string,
	velikostGranuliText?:string,
	doporucenaAktivitaDleMe?:string,
	vypocitanaMeVsMeVyrobce?:string,
	vypocitanaMeVsMeVyrobce2?:string,
	masoNaPrvnimMisteText?:string,
	zdrojeZivocisnychBilkovinDle1Vyskytu?:string,
	prichuteSeznam?:string,
	eliminacniDietaTextInterpunkce?:string,
	alergenyZadneNeobsahuje?:string,
	alergenyObsahuje?:string,
	alergenyNejakeNeobsahuje?:string,
	prospesneDruhyInterpunkce?:string,
	nevhodneDruhy?:string,
	kladneUcinkyCeleTelo?:string,
	kladneUcinkyHlava?:string,
	kladneUcinkyHrudnik?:string,
	kladneUcinkyBricho?:string,
	kladneUcinkySpodniCast?:string,
	zaporneUcinkyCeleTelo?:string,
	zaporneUcinkyHlava?:string,
	zaporneUcinkyHrudnik?:string,
	zaporneUcinkyBricho?:string,
	zaporneUcinkySpodniCast?:string,
	dsneuvedeno?:string,
	dsmalo?:string,
	dsprilis?:string,
	dsok?:string,
	d95malo?:string,
	d95prilis?:string,
	d95ok?:string,
	d110malo?:string,
	d110prilis?:string,
	d110ok?:string,
	sdo14reproMalo?:string,
	sdo14reproPrilis?:string,
	sdo14reproOk?:string,
	sdo15malo?:string,
	sdo15prilis?:string,
	sdo15ok?:string,
	s15malo?:string,
	s15prilis?:string,
	s15ok?:string,
	product?:ModelTypes["Product"],
	masoAnoNe?:string,
	eliminacniDietaAnoNe?:string,
	alergenyAnoNe?:string,
	plodnostKastraceNadpis?:string,
	plodnostKastraceText?:string,
	remoteId:string,
	stravitelnostNadpis?:string,
	stravitelnostProcenta?:string,
	stravitelnostSlovne?:string,
	stravitelnostChybiText?:string,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?:string
};
	["ProductEvaluationMeta"]: {
		id?:ModelTypes["FieldMeta"],
	nazev?:ModelTypes["FieldMeta"],
	vetDieta?:ModelTypes["FieldMeta"],
	vetDieta1?:ModelTypes["FieldMeta"],
	vetDieta2?:ModelTypes["FieldMeta"],
	aktivita?:ModelTypes["FieldMeta"],
	vek?:ModelTypes["FieldMeta"],
	velikostPlemen?:ModelTypes["FieldMeta"],
	hmotnostPlemene?:ModelTypes["FieldMeta"],
	velikostGranuli?:ModelTypes["FieldMeta"],
	velikostGranuliText?:ModelTypes["FieldMeta"],
	doporucenaAktivitaDleMe?:ModelTypes["FieldMeta"],
	vypocitanaMeVsMeVyrobce?:ModelTypes["FieldMeta"],
	vypocitanaMeVsMeVyrobce2?:ModelTypes["FieldMeta"],
	masoNaPrvnimMisteText?:ModelTypes["FieldMeta"],
	zdrojeZivocisnychBilkovinDle1Vyskytu?:ModelTypes["FieldMeta"],
	prichuteSeznam?:ModelTypes["FieldMeta"],
	eliminacniDietaTextInterpunkce?:ModelTypes["FieldMeta"],
	alergenyZadneNeobsahuje?:ModelTypes["FieldMeta"],
	alergenyObsahuje?:ModelTypes["FieldMeta"],
	alergenyNejakeNeobsahuje?:ModelTypes["FieldMeta"],
	prospesneDruhyInterpunkce?:ModelTypes["FieldMeta"],
	nevhodneDruhy?:ModelTypes["FieldMeta"],
	kladneUcinkyCeleTelo?:ModelTypes["FieldMeta"],
	kladneUcinkyHlava?:ModelTypes["FieldMeta"],
	kladneUcinkyHrudnik?:ModelTypes["FieldMeta"],
	kladneUcinkyBricho?:ModelTypes["FieldMeta"],
	kladneUcinkySpodniCast?:ModelTypes["FieldMeta"],
	zaporneUcinkyCeleTelo?:ModelTypes["FieldMeta"],
	zaporneUcinkyHlava?:ModelTypes["FieldMeta"],
	zaporneUcinkyHrudnik?:ModelTypes["FieldMeta"],
	zaporneUcinkyBricho?:ModelTypes["FieldMeta"],
	zaporneUcinkySpodniCast?:ModelTypes["FieldMeta"],
	dsneuvedeno?:ModelTypes["FieldMeta"],
	dsmalo?:ModelTypes["FieldMeta"],
	dsprilis?:ModelTypes["FieldMeta"],
	dsok?:ModelTypes["FieldMeta"],
	d95malo?:ModelTypes["FieldMeta"],
	d95prilis?:ModelTypes["FieldMeta"],
	d95ok?:ModelTypes["FieldMeta"],
	d110malo?:ModelTypes["FieldMeta"],
	d110prilis?:ModelTypes["FieldMeta"],
	d110ok?:ModelTypes["FieldMeta"],
	sdo14reproMalo?:ModelTypes["FieldMeta"],
	sdo14reproPrilis?:ModelTypes["FieldMeta"],
	sdo14reproOk?:ModelTypes["FieldMeta"],
	sdo15malo?:ModelTypes["FieldMeta"],
	sdo15prilis?:ModelTypes["FieldMeta"],
	sdo15ok?:ModelTypes["FieldMeta"],
	s15malo?:ModelTypes["FieldMeta"],
	s15prilis?:ModelTypes["FieldMeta"],
	s15ok?:ModelTypes["FieldMeta"],
	product?:ModelTypes["FieldMeta"],
	masoAnoNe?:ModelTypes["FieldMeta"],
	eliminacniDietaAnoNe?:ModelTypes["FieldMeta"],
	alergenyAnoNe?:ModelTypes["FieldMeta"],
	plodnostKastraceNadpis?:ModelTypes["FieldMeta"],
	plodnostKastraceText?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	stravitelnostNadpis?:ModelTypes["FieldMeta"],
	stravitelnostProcenta?:ModelTypes["FieldMeta"],
	stravitelnostSlovne?:ModelTypes["FieldMeta"],
	stravitelnostChybiText?:ModelTypes["FieldMeta"],
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?:ModelTypes["FieldMeta"]
};
	["TOPXProduct"]: {
		_meta?:ModelTypes["TOPXProductMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	order:number,
	orderType:ModelTypes["TOPXProductOrderType"],
	product?:ModelTypes["Product"],
	category?:ModelTypes["TOPXProductCategory"]
};
	["TOPXProductMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	orderType?:ModelTypes["FieldMeta"],
	product?:ModelTypes["FieldMeta"],
	category?:ModelTypes["FieldMeta"]
};
	["TOPXProductCategory"]: {
		_meta?:ModelTypes["TOPXProductCategoryMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	products:ModelTypes["TOPXProduct"][],
	productsByRemoteId?:ModelTypes["TOPXProduct"],
	paginateProducts:ModelTypes["TOPXProductConnection"]
};
	["TOPXProductCategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"]
};
	["TOPXProductOrderBy"]: GraphQLTypes["TOPXProductOrderBy"];
	["TOPXProductCategoryOrderBy"]: GraphQLTypes["TOPXProductCategoryOrderBy"];
	["TOPXProductCategoryProductsByRemoteIdUniqueWhere"]: GraphQLTypes["TOPXProductCategoryProductsByRemoteIdUniqueWhere"];
	["TOPXProductConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TOPXProductEdge"][]
};
	["TOPXProductEdge"]: {
		node:ModelTypes["TOPXProduct"]
};
	["ProductNutritionalValuesByRemoteIdUniqueWhere"]: GraphQLTypes["ProductNutritionalValuesByRemoteIdUniqueWhere"];
	["ProductReviewsByProductReviewReactionsUniqueWhere"]: GraphQLTypes["ProductReviewsByProductReviewReactionsUniqueWhere"];
	["ProductReviewsByStatsUniqueWhere"]: GraphQLTypes["ProductReviewsByStatsUniqueWhere"];
	["ProductDogsByReproductionUniqueWhere"]: GraphQLTypes["ProductDogsByReproductionUniqueWhere"];
	["ProductDogsByAvatarUniqueWhere"]: GraphQLTypes["ProductDogsByAvatarUniqueWhere"];
	["ProductPackagingsByRemoteIdUniqueWhere"]: GraphQLTypes["ProductPackagingsByRemoteIdUniqueWhere"];
	["ProductPackagingsByPositionIdUniqueWhere"]: GraphQLTypes["ProductPackagingsByPositionIdUniqueWhere"];
	["ProductPackagingsByExternalIdUniqueWhere"]: GraphQLTypes["ProductPackagingsByExternalIdUniqueWhere"];
	["ProductElementsByRemoteIdUniqueWhere"]: GraphQLTypes["ProductElementsByRemoteIdUniqueWhere"];
	["ProductFlagsByRemoteIdUniqueWhere"]: GraphQLTypes["ProductFlagsByRemoteIdUniqueWhere"];
	["ProductAliasesByRemoteIdUniqueWhere"]: GraphQLTypes["ProductAliasesByRemoteIdUniqueWhere"];
	["ProductTopxByRemoteIdUniqueWhere"]: GraphQLTypes["ProductTopxByRemoteIdUniqueWhere"];
	["ProductPackageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductPackageEdge"][]
};
	["ProductPackageEdge"]: {
		node:ModelTypes["ProductPackage"]
};
	["GranuleSizeConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["GranuleSizeEdge"][]
};
	["GranuleSizeEdge"]: {
		node:ModelTypes["GranuleSize"]
};
	["ProductAliasConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductAliasEdge"][]
};
	["ProductAliasEdge"]: {
		node:ModelTypes["ProductAlias"]
};
	["AgeCategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["AgeCategoryEdge"][]
};
	["AgeCategoryEdge"]: {
		node:ModelTypes["AgeCategory"]
};
	["BodyTagFilterCombosByRemoteIdUniqueWhere"]: GraphQLTypes["BodyTagFilterCombosByRemoteIdUniqueWhere"];
	["BodyTagFilterCombosBySeoUniqueWhere"]: GraphQLTypes["BodyTagFilterCombosBySeoUniqueWhere"];
	["BodyTagCategoryTagsByRemoteIdUniqueWhere"]: GraphQLTypes["BodyTagCategoryTagsByRemoteIdUniqueWhere"];
	["BodyTagCategoryTagsByFilterCombosUniqueWhere"]: GraphQLTypes["BodyTagCategoryTagsByFilterCombosUniqueWhere"];
	["ColorItemFlavorCategoriesByRemoteIdUniqueWhere"]: GraphQLTypes["ColorItemFlavorCategoriesByRemoteIdUniqueWhere"];
	["ColorItemFlavorCategoriesByItemsUniqueWhere"]: GraphQLTypes["ColorItemFlavorCategoriesByItemsUniqueWhere"];
	["ItemFlavorCategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ItemFlavorCategoryEdge"][]
};
	["ItemFlavorCategoryEdge"]: {
		node:ModelTypes["ItemFlavorCategory"]
};
	["BlogPostReviewsByBlogPostReviewReactionsUniqueWhere"]: GraphQLTypes["BlogPostReviewsByBlogPostReviewReactionsUniqueWhere"];
	["BlogPostReviewsByStatsUniqueWhere"]: GraphQLTypes["BlogPostReviewsByStatsUniqueWhere"];
	["BlogPostItemsByRemoteIdUniqueWhere"]: GraphQLTypes["BlogPostItemsByRemoteIdUniqueWhere"];
	["BlogPostItemsBySlugUniqueWhere"]: GraphQLTypes["BlogPostItemsBySlugUniqueWhere"];
	["BlogPostItemsByFeaturesOfProductUniqueWhere"]: GraphQLTypes["BlogPostItemsByFeaturesOfProductUniqueWhere"];
	["BlogPostItemsByImageUniqueWhere"]: GraphQLTypes["BlogPostItemsByImageUniqueWhere"];
	["BlogPostItemsByReferenceListUniqueWhere"]: GraphQLTypes["BlogPostItemsByReferenceListUniqueWhere"];
	["BlogPostItemsBySeoUniqueWhere"]: GraphQLTypes["BlogPostItemsBySeoUniqueWhere"];
	["BlogPostItemsByAliasesUniqueWhere"]: GraphQLTypes["BlogPostItemsByAliasesUniqueWhere"];
	["BlogPostItemsByContentUniqueWhere"]: GraphQLTypes["BlogPostItemsByContentUniqueWhere"];
	["BlogPostItemsByDraftUniqueWhere"]: GraphQLTypes["BlogPostItemsByDraftUniqueWhere"];
	["BlogPostRedirectsByFromUniqueWhere"]: GraphQLTypes["BlogPostRedirectsByFromUniqueWhere"];
	["BlogPostTagConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BlogPostTagEdge"][]
};
	["BlogPostTagEdge"]: {
		node:ModelTypes["BlogPostTag"]
};
	["Link"]: {
		_meta?:ModelTypes["LinkMeta"],
	id:ModelTypes["UUID"],
	externalLink?:string,
	isTargetBlank:boolean
};
	["LinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	externalLink?:ModelTypes["FieldMeta"],
	isTargetBlank?:ModelTypes["FieldMeta"]
};
	["ContentReferenceList"]: {
		_meta?:ModelTypes["ContentReferenceListMeta"],
	id:ModelTypes["UUID"],
	order?:number,
	relatedProduct?:ModelTypes["Product"],
	relatedBrand?:ModelTypes["Brand"],
	list?:ModelTypes["ContentReference"],
	badge?:string,
	badgeColor?:string
};
	["ContentReferenceListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	relatedProduct?:ModelTypes["FieldMeta"],
	relatedBrand?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	badge?:ModelTypes["FieldMeta"],
	badgeColor?:ModelTypes["FieldMeta"]
};
	["ContentReferenceListOrderBy"]: GraphQLTypes["ContentReferenceListOrderBy"];
	["ContentLinks"]: {
		_meta?:ModelTypes["ContentLinksMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["ContentLinksItem"][],
	paginateItems:ModelTypes["ContentLinksItemConnection"]
};
	["ContentLinksMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["ContentLinksItem"]: {
		_meta?:ModelTypes["ContentLinksItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	title?:string,
	target?:string,
	list?:ModelTypes["ContentLinks"]
};
	["ContentLinksItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"]
};
	["ContentLinksItemOrderBy"]: GraphQLTypes["ContentLinksItemOrderBy"];
	["ContentLinksItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentLinksItemEdge"][]
};
	["ContentLinksItemEdge"]: {
		node:ModelTypes["ContentLinksItem"]
};
	["Video"]: {
		_meta?:ModelTypes["VideoMeta"],
	id:ModelTypes["UUID"],
	src?:string,
	width?:number,
	height?:number,
	size?:number,
	type?:string,
	duration?:number,
	poster?:ModelTypes["Image"]
};
	["VideoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	src?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	duration?:ModelTypes["FieldMeta"],
	poster?:ModelTypes["FieldMeta"]
};
	["ContentReferenceImage"]: {
		_meta?:ModelTypes["ContentReferenceImageMeta"],
	id:ModelTypes["UUID"],
	lead?:string,
	alignment?:ModelTypes["AlignmentType"],
	image?:ModelTypes["Image"],
	link?:string,
	targetBlank?:boolean
};
	["ContentReferenceImageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	alignment?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	targetBlank?:ModelTypes["FieldMeta"]
};
	["ContentReferenceGalleryImageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentReferenceGalleryImageEdge"][]
};
	["ContentReferenceGalleryImageEdge"]: {
		node:ModelTypes["ContentReferenceGalleryImage"]
};
	["ContentReferenceListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentReferenceListEdge"][]
};
	["ContentReferenceListEdge"]: {
		node:ModelTypes["ContentReferenceList"]
};
	["ContentBlockReferencesByImagesUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByImagesUniqueWhere"];
	["ContentBlockReferencesByLinkUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByLinkUniqueWhere"];
	["ContentBlockReferencesByListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByListUniqueWhere"];
	["ContentBlockReferencesByOutlineUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByOutlineUniqueWhere"];
	["ContentBlockReferencesByVideoUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByVideoUniqueWhere"];
	["ContentBlockReferencesByImageUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByImageUniqueWhere"];
	["ContentBlocksByAutomatedContentBlockSlugUniqueWhere"]: GraphQLTypes["ContentBlocksByAutomatedContentBlockSlugUniqueWhere"];
	["ContentBlocksByReferencesUniqueWhere"]: GraphQLTypes["ContentBlocksByReferencesUniqueWhere"];
	["ContentBlockConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentBlockEdge"][]
};
	["ContentBlockEdge"]: {
		node:ModelTypes["ContentBlock"]
};
	["BrandsPageRedirectsByFromUniqueWhere"]: GraphQLTypes["BrandsPageRedirectsByFromUniqueWhere"];
	["ComparatorPage"]: {
		_meta?:ModelTypes["ComparatorPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	redirects:ModelTypes["Redirect"][],
	seo?:ModelTypes["Seo"],
	redirectsByFrom?:ModelTypes["Redirect"],
	paginateRedirects:ModelTypes["RedirectConnection"]
};
	["ComparatorPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	redirects?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["ComparatorPageRedirectsByFromUniqueWhere"]: GraphQLTypes["ComparatorPageRedirectsByFromUniqueWhere"];
	["HomePage"]: {
		_meta?:ModelTypes["HomePageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	title:string,
	lead:string,
	seo?:ModelTypes["Seo"]
};
	["HomePageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["IngredientsPage"]: {
		_meta?:ModelTypes["IngredientsPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	title?:string,
	seo?:ModelTypes["Seo"],
	content?:ModelTypes["Content"],
	draft?:ModelTypes["Content"]
};
	["IngredientsPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	draft?:ModelTypes["FieldMeta"]
};
	["LoginPage"]: {
		_meta?:ModelTypes["LoginPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	seo?:ModelTypes["Seo"]
};
	["LoginPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["RegisterPage"]: {
		_meta?:ModelTypes["RegisterPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	seo?:ModelTypes["Seo"]
};
	["RegisterPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["SearchPage"]: {
		_meta?:ModelTypes["SearchPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	seo?:ModelTypes["Seo"]
};
	["SearchPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["WizardPage"]: {
		_meta?:ModelTypes["WizardPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	redirects:ModelTypes["Redirect"][],
	seo?:ModelTypes["Seo"],
	redirectsByFrom?:ModelTypes["Redirect"],
	paginateRedirects:ModelTypes["RedirectConnection"]
};
	["WizardPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	redirects?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["WizardPageRedirectsByFromUniqueWhere"]: GraphQLTypes["WizardPageRedirectsByFromUniqueWhere"];
	["ContactPage"]: {
		_meta?:ModelTypes["ContactPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	title?:string,
	redirects:ModelTypes["Redirect"][],
	seo?:ModelTypes["Seo"],
	content?:ModelTypes["Content"],
	draft?:ModelTypes["Content"],
	redirectsByFrom?:ModelTypes["Redirect"],
	paginateRedirects:ModelTypes["RedirectConnection"]
};
	["ContactPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	redirects?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	draft?:ModelTypes["FieldMeta"]
};
	["ContactPageRedirectsByFromUniqueWhere"]: GraphQLTypes["ContactPageRedirectsByFromUniqueWhere"];
	["GenericPageRedirectsByFromUniqueWhere"]: GraphQLTypes["GenericPageRedirectsByFromUniqueWhere"];
	["BlogPageRedirectsByFromUniqueWhere"]: GraphQLTypes["BlogPageRedirectsByFromUniqueWhere"];
	["BlogPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BlogPageEdge"][]
};
	["BlogPageEdge"]: {
		node:ModelTypes["BlogPage"]
};
	["_ValidationResult"]: {
		valid:boolean,
	errors:ModelTypes["_ValidationError"][]
};
	["_ValidationError"]: {
		path:ModelTypes["_PathFragment"][],
	message:ModelTypes["_ValidationMessage"]
};
	["_PathFragment"]:ModelTypes["_FieldPathFragment"] | ModelTypes["_IndexPathFragment"];
	["_FieldPathFragment"]: {
		field:string
};
	["_IndexPathFragment"]: {
		index:number,
	alias?:string
};
	["_ValidationMessage"]: {
		text:string
};
	["BlogPageCreateInput"]: GraphQLTypes["BlogPageCreateInput"];
	["BlogPageCreateRedirectsEntityRelationInput"]: GraphQLTypes["BlogPageCreateRedirectsEntityRelationInput"];
	["RedirectWithoutBlogPageCreateInput"]: GraphQLTypes["RedirectWithoutBlogPageCreateInput"];
	["RedirectCreateGenericPageEntityRelationInput"]: GraphQLTypes["RedirectCreateGenericPageEntityRelationInput"];
	["GenericPageWithoutRedirectsCreateInput"]: GraphQLTypes["GenericPageWithoutRedirectsCreateInput"];
	["GenericPageCreateLinkEntityRelationInput"]: GraphQLTypes["GenericPageCreateLinkEntityRelationInput"];
	["LinkableWithoutGenericPageCreateInput"]: GraphQLTypes["LinkableWithoutGenericPageCreateInput"];
	["GenericPageConnectOrCreateLinkRelationInput"]: GraphQLTypes["GenericPageConnectOrCreateLinkRelationInput"];
	["GenericPageCreateSeoEntityRelationInput"]: GraphQLTypes["GenericPageCreateSeoEntityRelationInput"];
	["SeoWithoutGenericPageCreateInput"]: GraphQLTypes["SeoWithoutGenericPageCreateInput"];
	["SeoCreateOgImageEntityRelationInput"]: GraphQLTypes["SeoCreateOgImageEntityRelationInput"];
	["ImageCreateInput"]: GraphQLTypes["ImageCreateInput"];
	["SeoConnectOrCreateOgImageRelationInput"]: GraphQLTypes["SeoConnectOrCreateOgImageRelationInput"];
	["SeoCreateBlogPageEntityRelationInput"]: GraphQLTypes["SeoCreateBlogPageEntityRelationInput"];
	["BlogPageWithoutSeoCreateInput"]: GraphQLTypes["BlogPageWithoutSeoCreateInput"];
	["BlogPageCreateContentEntityRelationInput"]: GraphQLTypes["BlogPageCreateContentEntityRelationInput"];
	["ContentCreateInput"]: GraphQLTypes["ContentCreateInput"];
	["ContentCreateBlocksEntityRelationInput"]: GraphQLTypes["ContentCreateBlocksEntityRelationInput"];
	["ContentBlockWithoutContentCreateInput"]: GraphQLTypes["ContentBlockWithoutContentCreateInput"];
	["ContentBlockCreateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"];
	["ContentReferenceWithoutBlockCreateInput"]: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"];
	["ContentReferenceCreateImagesEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"];
	["ContentReferenceGalleryImageWithoutReferenceCreateInput"]: GraphQLTypes["ContentReferenceGalleryImageWithoutReferenceCreateInput"];
	["ContentReferenceGalleryImageCreateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceGalleryImageCreateImageEntityRelationInput"];
	["ContentReferenceGalleryImageConnectOrCreateImageRelationInput"]: GraphQLTypes["ContentReferenceGalleryImageConnectOrCreateImageRelationInput"];
	["ContentReferenceConnectOrCreateImagesRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateImagesRelationInput"];
	["ContentReferenceCreateRelatedBlogPostEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateRelatedBlogPostEntityRelationInput"];
	["BlogPostCreateInput"]: GraphQLTypes["BlogPostCreateInput"];
	["BlogPostCreateBlogPostTagsEntityRelationInput"]: GraphQLTypes["BlogPostCreateBlogPostTagsEntityRelationInput"];
	["BlogPostTagUniqueWhere"]: GraphQLTypes["BlogPostTagUniqueWhere"];
	["ColorUniqueWhere"]: GraphQLTypes["ColorUniqueWhere"];
	["BodyTagCategoryUniqueWhere"]: GraphQLTypes["BodyTagCategoryUniqueWhere"];
	["BodyTagUniqueWhere"]: GraphQLTypes["BodyTagUniqueWhere"];
	["ItemFlavorCategoryUniqueWhere"]: GraphQLTypes["ItemFlavorCategoryUniqueWhere"];
	["BlogPostTagWithoutBlogPostsCreateInput"]: GraphQLTypes["BlogPostTagWithoutBlogPostsCreateInput"];
	["BlogPostTagCreateColorEntityRelationInput"]: GraphQLTypes["BlogPostTagCreateColorEntityRelationInput"];
	["ColorWithoutBlogPostTagCreateInput"]: GraphQLTypes["ColorWithoutBlogPostTagCreateInput"];
	["ColorCreateBodyTagCategoryEntityRelationInput"]: GraphQLTypes["ColorCreateBodyTagCategoryEntityRelationInput"];
	["BodyTagCategoryWithoutColorCreateInput"]: GraphQLTypes["BodyTagCategoryWithoutColorCreateInput"];
	["BodyTagCategoryCreateTagsEntityRelationInput"]: GraphQLTypes["BodyTagCategoryCreateTagsEntityRelationInput"];
	["BodyTagWithoutCategoryCreateInput"]: GraphQLTypes["BodyTagWithoutCategoryCreateInput"];
	["BodyTagCreateBlogPostsEntityRelationInput"]: GraphQLTypes["BodyTagCreateBlogPostsEntityRelationInput"];
	["BlogPostWithoutTagsCreateInput"]: GraphQLTypes["BlogPostWithoutTagsCreateInput"];
	["BlogPostCreateReviewsEntityRelationInput"]: GraphQLTypes["BlogPostCreateReviewsEntityRelationInput"];
	["BlogPostReviewWithoutBlogPostCreateInput"]: GraphQLTypes["BlogPostReviewWithoutBlogPostCreateInput"];
	["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"]: GraphQLTypes["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"];
	["BlogPostReviewReactionWithoutBlogPostReviewCreateInput"]: GraphQLTypes["BlogPostReviewReactionWithoutBlogPostReviewCreateInput"];
	["BlogPostReviewReactionCreateUserEntityRelationInput"]: GraphQLTypes["BlogPostReviewReactionCreateUserEntityRelationInput"];
	["UserWithoutBlogPostReviewReactionsCreateInput"]: GraphQLTypes["UserWithoutBlogPostReviewReactionsCreateInput"];
	["UserCreateDogsEntityRelationInput"]: GraphQLTypes["UserCreateDogsEntityRelationInput"];
	["DogWithoutOwnerCreateInput"]: GraphQLTypes["DogWithoutOwnerCreateInput"];
	["DogCreateBreedEntityRelationInput"]: GraphQLTypes["DogCreateBreedEntityRelationInput"];
	["BreedWithoutDogsCreateInput"]: GraphQLTypes["BreedWithoutDogsCreateInput"];
	["BreedCreateReviewsEntityRelationInput"]: GraphQLTypes["BreedCreateReviewsEntityRelationInput"];
	["ReviewUniqueWhere"]: GraphQLTypes["ReviewUniqueWhere"];
	["ReviewWithoutDogBreedsCreateInput"]: GraphQLTypes["ReviewWithoutDogBreedsCreateInput"];
	["BreedConnectOrCreateReviewsRelationInput"]: GraphQLTypes["BreedConnectOrCreateReviewsRelationInput"];
	["BreedCreateAgesEntityRelationInput"]: GraphQLTypes["BreedCreateAgesEntityRelationInput"];
	["AgeUniqueWhere"]: GraphQLTypes["AgeUniqueWhere"];
	["AgeWithoutBreedsCreateInput"]: GraphQLTypes["AgeWithoutBreedsCreateInput"];
	["AgeCreateDogsEntityRelationInput"]: GraphQLTypes["AgeCreateDogsEntityRelationInput"];
	["DogWithoutAgeCreateInput"]: GraphQLTypes["DogWithoutAgeCreateInput"];
	["DogCreateBodyTypeEntityRelationInput"]: GraphQLTypes["DogCreateBodyTypeEntityRelationInput"];
	["DogBodyTypeUniqueWhere"]: GraphQLTypes["DogBodyTypeUniqueWhere"];
	["DogBodyTypeWithoutDogsCreateInput"]: GraphQLTypes["DogBodyTypeWithoutDogsCreateInput"];
	["DogBodyTypeCreateCategoryEntityRelationInput"]: GraphQLTypes["DogBodyTypeCreateCategoryEntityRelationInput"];
	["DogBodyTypeCategoryUniqueWhere"]: GraphQLTypes["DogBodyTypeCategoryUniqueWhere"];
	["DogBodyTypeCategoryWithoutItemsCreateInput"]: GraphQLTypes["DogBodyTypeCategoryWithoutItemsCreateInput"];
	["DogBodyTypeCategoryCreateImageMainEntityRelationInput"]: GraphQLTypes["DogBodyTypeCategoryCreateImageMainEntityRelationInput"];
	["DogBodyTypeCategoryConnectOrCreateImageMainRelationInput"]: GraphQLTypes["DogBodyTypeCategoryConnectOrCreateImageMainRelationInput"];
	["DogBodyTypeConnectOrCreateCategoryRelationInput"]: GraphQLTypes["DogBodyTypeConnectOrCreateCategoryRelationInput"];
	["DogBodyTypeCreateImageMainEntityRelationInput"]: GraphQLTypes["DogBodyTypeCreateImageMainEntityRelationInput"];
	["DogBodyTypeConnectOrCreateImageMainRelationInput"]: GraphQLTypes["DogBodyTypeConnectOrCreateImageMainRelationInput"];
	["DogBodyTypeCreateImageFromEntityRelationInput"]: GraphQLTypes["DogBodyTypeCreateImageFromEntityRelationInput"];
	["DogBodyTypeConnectOrCreateImageFromRelationInput"]: GraphQLTypes["DogBodyTypeConnectOrCreateImageFromRelationInput"];
	["DogBodyTypeCreateImageToEntityRelationInput"]: GraphQLTypes["DogBodyTypeCreateImageToEntityRelationInput"];
	["DogBodyTypeConnectOrCreateImageToRelationInput"]: GraphQLTypes["DogBodyTypeConnectOrCreateImageToRelationInput"];
	["DogConnectOrCreateBodyTypeRelationInput"]: GraphQLTypes["DogConnectOrCreateBodyTypeRelationInput"];
	["DogCreateOwnerEntityRelationInput"]: GraphQLTypes["DogCreateOwnerEntityRelationInput"];
	["UserWithoutDogsCreateInput"]: GraphQLTypes["UserWithoutDogsCreateInput"];
	["UserCreateVeterinaryEntityRelationInput"]: GraphQLTypes["UserCreateVeterinaryEntityRelationInput"];
	["VeterinaryWithoutUserCreateInput"]: GraphQLTypes["VeterinaryWithoutUserCreateInput"];
	["UserConnectOrCreateVeterinaryRelationInput"]: GraphQLTypes["UserConnectOrCreateVeterinaryRelationInput"];
	["UserCreateBlogPostReviewsEntityRelationInput"]: GraphQLTypes["UserCreateBlogPostReviewsEntityRelationInput"];
	["BlogPostReviewWithoutUserCreateInput"]: GraphQLTypes["BlogPostReviewWithoutUserCreateInput"];
	["BlogPostReviewCreateBlogPostEntityRelationInput"]: GraphQLTypes["BlogPostReviewCreateBlogPostEntityRelationInput"];
	["BlogPostWithoutReviewsCreateInput"]: GraphQLTypes["BlogPostWithoutReviewsCreateInput"];
	["BlogPostCreateTagsEntityRelationInput"]: GraphQLTypes["BlogPostCreateTagsEntityRelationInput"];
	["BodyTagWithoutBlogPostsCreateInput"]: GraphQLTypes["BodyTagWithoutBlogPostsCreateInput"];
	["BodyTagCreatePositiveProductsEntityRelationInput"]: GraphQLTypes["BodyTagCreatePositiveProductsEntityRelationInput"];
	["ProductWithoutPositiveForBodyTagsCreateInput"]: GraphQLTypes["ProductWithoutPositiveForBodyTagsCreateInput"];
	["ProductCreateNutritionalValuesEntityRelationInput"]: GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"];
	["NutritionalValueOfProductWithoutProductCreateInput"]: GraphQLTypes["NutritionalValueOfProductWithoutProductCreateInput"];
	["NutritionalValueOfProductCreateNutritionalValueEntityRelationInput"]: GraphQLTypes["NutritionalValueOfProductCreateNutritionalValueEntityRelationInput"];
	["NutritionalValueUniqueWhere"]: GraphQLTypes["NutritionalValueUniqueWhere"];
	["NutritionalValueWithoutProductsCreateInput"]: GraphQLTypes["NutritionalValueWithoutProductsCreateInput"];
	["NutritionalValueCreateSuitabilityNutritionalValuesEntityRelationInput"]: GraphQLTypes["NutritionalValueCreateSuitabilityNutritionalValuesEntityRelationInput"];
	["SuitabilityItemWithoutNutritionalValueCreateInput"]: GraphQLTypes["SuitabilityItemWithoutNutritionalValueCreateInput"];
	["SuitabilityItemCreateElementEntityRelationInput"]: GraphQLTypes["SuitabilityItemCreateElementEntityRelationInput"];
	["ElementWithoutSuitabilityElementsCreateInput"]: GraphQLTypes["ElementWithoutSuitabilityElementsCreateInput"];
	["ElementCreateProductsEntityRelationInput"]: GraphQLTypes["ElementCreateProductsEntityRelationInput"];
	["ElementOfProductWithoutElementCreateInput"]: GraphQLTypes["ElementOfProductWithoutElementCreateInput"];
	["ElementOfProductCreateProductEntityRelationInput"]: GraphQLTypes["ElementOfProductCreateProductEntityRelationInput"];
	["ProductWithoutElementsCreateInput"]: GraphQLTypes["ProductWithoutElementsCreateInput"];
	["ProductCreatePositiveForBodyTagsEntityRelationInput"]: GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"];
	["BodyTagWithoutPositiveProductsCreateInput"]: GraphQLTypes["BodyTagWithoutPositiveProductsCreateInput"];
	["BodyTagCreateNegativeProductsEntityRelationInput"]: GraphQLTypes["BodyTagCreateNegativeProductsEntityRelationInput"];
	["ProductWithoutNegativeForBodyTagsCreateInput"]: GraphQLTypes["ProductWithoutNegativeForBodyTagsCreateInput"];
	["ProductCreateReviewsEntityRelationInput"]: GraphQLTypes["ProductCreateReviewsEntityRelationInput"];
	["ProductReviewWithoutProductCreateInput"]: GraphQLTypes["ProductReviewWithoutProductCreateInput"];
	["ProductReviewCreateProductReviewReactionsEntityRelationInput"]: GraphQLTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"];
	["ProductReviewReactionWithoutProductReviewCreateInput"]: GraphQLTypes["ProductReviewReactionWithoutProductReviewCreateInput"];
	["ProductReviewReactionCreateUserEntityRelationInput"]: GraphQLTypes["ProductReviewReactionCreateUserEntityRelationInput"];
	["UserWithoutProductReviewReactionsCreateInput"]: GraphQLTypes["UserWithoutProductReviewReactionsCreateInput"];
	["UserCreateProductReviewsEntityRelationInput"]: GraphQLTypes["UserCreateProductReviewsEntityRelationInput"];
	["ProductReviewWithoutUserCreateInput"]: GraphQLTypes["ProductReviewWithoutUserCreateInput"];
	["ProductReviewCreateScoreEntityRelationInput"]: GraphQLTypes["ProductReviewCreateScoreEntityRelationInput"];
	["ScoreUniqueWhere"]: GraphQLTypes["ScoreUniqueWhere"];
	["ScoreWithoutProductReviewsCreateInput"]: GraphQLTypes["ScoreWithoutProductReviewsCreateInput"];
	["ProductReviewConnectOrCreateScoreRelationInput"]: GraphQLTypes["ProductReviewConnectOrCreateScoreRelationInput"];
	["ProductReviewCreateProductEntityRelationInput"]: GraphQLTypes["ProductReviewCreateProductEntityRelationInput"];
	["ProductWithoutReviewsCreateInput"]: GraphQLTypes["ProductWithoutReviewsCreateInput"];
	["ProductCreateNegativeForBodyTagsEntityRelationInput"]: GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"];
	["BodyTagWithoutNegativeProductsCreateInput"]: GraphQLTypes["BodyTagWithoutNegativeProductsCreateInput"];
	["BodyTagCreatePositiveItemsEntityRelationInput"]: GraphQLTypes["BodyTagCreatePositiveItemsEntityRelationInput"];
	["ItemWithoutPositiveForBodyTagsCreateInput"]: GraphQLTypes["ItemWithoutPositiveForBodyTagsCreateInput"];
	["ItemCreateNegativeForBodyTagsEntityRelationInput"]: GraphQLTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"];
	["BodyTagWithoutNegativeItemsCreateInput"]: GraphQLTypes["BodyTagWithoutNegativeItemsCreateInput"];
	["BodyTagCreateCategoryEntityRelationInput"]: GraphQLTypes["BodyTagCreateCategoryEntityRelationInput"];
	["BodyTagCategoryWithoutTagsCreateInput"]: GraphQLTypes["BodyTagCategoryWithoutTagsCreateInput"];
	["BodyTagCategoryCreateColorEntityRelationInput"]: GraphQLTypes["BodyTagCategoryCreateColorEntityRelationInput"];
	["ColorWithoutBodyTagCategoryCreateInput"]: GraphQLTypes["ColorWithoutBodyTagCategoryCreateInput"];
	["ColorCreateBlogPostTagEntityRelationInput"]: GraphQLTypes["ColorCreateBlogPostTagEntityRelationInput"];
	["BlogPostTagWithoutColorCreateInput"]: GraphQLTypes["BlogPostTagWithoutColorCreateInput"];
	["BlogPostTagCreateBlogPostsEntityRelationInput"]: GraphQLTypes["BlogPostTagCreateBlogPostsEntityRelationInput"];
	["BlogPostWithoutBlogPostTagsCreateInput"]: GraphQLTypes["BlogPostWithoutBlogPostTagsCreateInput"];
	["BlogPostCreateItemCategoriesEntityRelationInput"]: GraphQLTypes["BlogPostCreateItemCategoriesEntityRelationInput"];
	["ItemCategoryUniqueWhere"]: GraphQLTypes["ItemCategoryUniqueWhere"];
	["ItemCategoryWithoutBlogPostsCreateInput"]: GraphQLTypes["ItemCategoryWithoutBlogPostsCreateInput"];
	["ItemCategoryCreateSubCategoriesEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"];
	["ItemSubCategoryWithoutCategoryCreateInput"]: GraphQLTypes["ItemSubCategoryWithoutCategoryCreateInput"];
	["ItemSubCategoryCreateItemsEntityRelationInput"]: GraphQLTypes["ItemSubCategoryCreateItemsEntityRelationInput"];
	["ItemWithoutSubCategoriesCreateInput"]: GraphQLTypes["ItemWithoutSubCategoriesCreateInput"];
	["ItemCreatePositiveForBodyTagsEntityRelationInput"]: GraphQLTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"];
	["BodyTagWithoutPositiveItemsCreateInput"]: GraphQLTypes["BodyTagWithoutPositiveItemsCreateInput"];
	["BodyTagCreateNegativeItemsEntityRelationInput"]: GraphQLTypes["BodyTagCreateNegativeItemsEntityRelationInput"];
	["ItemWithoutNegativeForBodyTagsCreateInput"]: GraphQLTypes["ItemWithoutNegativeForBodyTagsCreateInput"];
	["ItemCreateSubCategoriesEntityRelationInput"]: GraphQLTypes["ItemCreateSubCategoriesEntityRelationInput"];
	["ItemSubCategoryWithoutItemsCreateInput"]: GraphQLTypes["ItemSubCategoryWithoutItemsCreateInput"];
	["ItemSubCategoryCreateProductsEntityRelationInput"]: GraphQLTypes["ItemSubCategoryCreateProductsEntityRelationInput"];
	["ProductWithoutItemSubCategoriesCreateInput"]: GraphQLTypes["ProductWithoutItemSubCategoriesCreateInput"];
	["ProductCreateDogsEntityRelationInput"]: GraphQLTypes["ProductCreateDogsEntityRelationInput"];
	["DogWithoutFedProductCreateInput"]: GraphQLTypes["DogWithoutFedProductCreateInput"];
	["DogCreateAgeEntityRelationInput"]: GraphQLTypes["DogCreateAgeEntityRelationInput"];
	["AgeWithoutDogsCreateInput"]: GraphQLTypes["AgeWithoutDogsCreateInput"];
	["AgeCreateBreedsEntityRelationInput"]: GraphQLTypes["AgeCreateBreedsEntityRelationInput"];
	["BreedWithoutAgesCreateInput"]: GraphQLTypes["BreedWithoutAgesCreateInput"];
	["BreedCreateDogsEntityRelationInput"]: GraphQLTypes["BreedCreateDogsEntityRelationInput"];
	["DogWithoutBreedCreateInput"]: GraphQLTypes["DogWithoutBreedCreateInput"];
	["DogCreateActivityEntityRelationInput"]: GraphQLTypes["DogCreateActivityEntityRelationInput"];
	["DogActivityUniqueWhere"]: GraphQLTypes["DogActivityUniqueWhere"];
	["DogActivityWithoutDogsCreateInput"]: GraphQLTypes["DogActivityWithoutDogsCreateInput"];
	["DogActivityCreateProductsEntityRelationInput"]: GraphQLTypes["DogActivityCreateProductsEntityRelationInput"];
	["ProductWithoutRecommendedActivityCreateInput"]: GraphQLTypes["ProductWithoutRecommendedActivityCreateInput"];
	["ProductCreatePackagingsEntityRelationInput"]: GraphQLTypes["ProductCreatePackagingsEntityRelationInput"];
	["ProductPackageWithoutProductCreateInput"]: GraphQLTypes["ProductPackageWithoutProductCreateInput"];
	["ProductConnectOrCreatePackagingsRelationInput"]: GraphQLTypes["ProductConnectOrCreatePackagingsRelationInput"];
	["ProductCreateItemSubCategoriesEntityRelationInput"]: GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"];
	["ItemSubCategoryWithoutProductsCreateInput"]: GraphQLTypes["ItemSubCategoryWithoutProductsCreateInput"];
	["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"]: GraphQLTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"];
	["ProductFeatureWithoutDependentSubCategoryCreateInput"]: GraphQLTypes["ProductFeatureWithoutDependentSubCategoryCreateInput"];
	["ProductFeatureCreateLinkItemEntityRelationInput"]: GraphQLTypes["ProductFeatureCreateLinkItemEntityRelationInput"];
	["ItemWithoutFeaturesOfProductCreateInput"]: GraphQLTypes["ItemWithoutFeaturesOfProductCreateInput"];
	["ItemCreateCategoriesEntityRelationInput"]: GraphQLTypes["ItemCreateCategoriesEntityRelationInput"];
	["ItemCategoryWithoutItemsCreateInput"]: GraphQLTypes["ItemCategoryWithoutItemsCreateInput"];
	["ItemCategoryCreateBlogPostsEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateBlogPostsEntityRelationInput"];
	["BlogPostWithoutItemCategoriesCreateInput"]: GraphQLTypes["BlogPostWithoutItemCategoriesCreateInput"];
	["BlogPostCreateItemsEntityRelationInput"]: GraphQLTypes["BlogPostCreateItemsEntityRelationInput"];
	["ItemWithoutBlogPostCreateInput"]: GraphQLTypes["ItemWithoutBlogPostCreateInput"];
	["ItemCreateFeaturesOfProductEntityRelationInput"]: GraphQLTypes["ItemCreateFeaturesOfProductEntityRelationInput"];
	["ProductFeatureWithoutLinkItemCreateInput"]: GraphQLTypes["ProductFeatureWithoutLinkItemCreateInput"];
	["ProductFeatureCreateDependentElementEntityRelationInput"]: GraphQLTypes["ProductFeatureCreateDependentElementEntityRelationInput"];
	["ElementWithoutFeatureDependenciesCreateInput"]: GraphQLTypes["ElementWithoutFeatureDependenciesCreateInput"];
	["ElementCreateSuitabilityElementsEntityRelationInput"]: GraphQLTypes["ElementCreateSuitabilityElementsEntityRelationInput"];
	["SuitabilityItemWithoutElementCreateInput"]: GraphQLTypes["SuitabilityItemWithoutElementCreateInput"];
	["SuitabilityItemCreateNutritionalValueEntityRelationInput"]: GraphQLTypes["SuitabilityItemCreateNutritionalValueEntityRelationInput"];
	["NutritionalValueWithoutSuitabilityNutritionalValuesCreateInput"]: GraphQLTypes["NutritionalValueWithoutSuitabilityNutritionalValuesCreateInput"];
	["NutritionalValueCreateProductsEntityRelationInput"]: GraphQLTypes["NutritionalValueCreateProductsEntityRelationInput"];
	["NutritionalValueOfProductWithoutNutritionalValueCreateInput"]: GraphQLTypes["NutritionalValueOfProductWithoutNutritionalValueCreateInput"];
	["NutritionalValueOfProductCreateProductEntityRelationInput"]: GraphQLTypes["NutritionalValueOfProductCreateProductEntityRelationInput"];
	["ProductWithoutNutritionalValuesCreateInput"]: GraphQLTypes["ProductWithoutNutritionalValuesCreateInput"];
	["ProductCreateItemCategoriesEntityRelationInput"]: GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"];
	["ItemCategoryWithoutProductsCreateInput"]: GraphQLTypes["ItemCategoryWithoutProductsCreateInput"];
	["ItemCategoryCreateItemsEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateItemsEntityRelationInput"];
	["ItemWithoutCategoriesCreateInput"]: GraphQLTypes["ItemWithoutCategoriesCreateInput"];
	["ItemCreateImageEntityRelationInput"]: GraphQLTypes["ItemCreateImageEntityRelationInput"];
	["ItemConnectOrCreateImageRelationInput"]: GraphQLTypes["ItemConnectOrCreateImageRelationInput"];
	["ItemCreateReferenceListEntityRelationInput"]: GraphQLTypes["ItemCreateReferenceListEntityRelationInput"];
	["ReferenceListCreateInput"]: GraphQLTypes["ReferenceListCreateInput"];
	["ReferenceListCreateReferencesEntityRelationInput"]: GraphQLTypes["ReferenceListCreateReferencesEntityRelationInput"];
	["ReferenceWithoutListCreateInput"]: GraphQLTypes["ReferenceWithoutListCreateInput"];
	["ReferenceListConnectOrCreateReferencesRelationInput"]: GraphQLTypes["ReferenceListConnectOrCreateReferencesRelationInput"];
	["ItemConnectOrCreateReferenceListRelationInput"]: GraphQLTypes["ItemConnectOrCreateReferenceListRelationInput"];
	["ItemCreateBlogPostEntityRelationInput"]: GraphQLTypes["ItemCreateBlogPostEntityRelationInput"];
	["BlogPostWithoutItemsCreateInput"]: GraphQLTypes["BlogPostWithoutItemsCreateInput"];
	["BlogPostCreateImageEntityRelationInput"]: GraphQLTypes["BlogPostCreateImageEntityRelationInput"];
	["BlogPostConnectOrCreateImageRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateImageRelationInput"];
	["BlogPostCreateReferenceListEntityRelationInput"]: GraphQLTypes["BlogPostCreateReferenceListEntityRelationInput"];
	["BlogPostConnectOrCreateReferenceListRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateReferenceListRelationInput"];
	["BlogPostCreateUserEntityRelationInput"]: GraphQLTypes["BlogPostCreateUserEntityRelationInput"];
	["UserWithoutBlogPostsCreateInput"]: GraphQLTypes["UserWithoutBlogPostsCreateInput"];
	["UserCreateBlogPostReviewReactionsEntityRelationInput"]: GraphQLTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"];
	["BlogPostReviewReactionWithoutUserCreateInput"]: GraphQLTypes["BlogPostReviewReactionWithoutUserCreateInput"];
	["BlogPostReviewReactionCreateBlogPostReviewEntityRelationInput"]: GraphQLTypes["BlogPostReviewReactionCreateBlogPostReviewEntityRelationInput"];
	["BlogPostReviewWithoutBlogPostReviewReactionsCreateInput"]: GraphQLTypes["BlogPostReviewWithoutBlogPostReviewReactionsCreateInput"];
	["BlogPostReviewCreateUserEntityRelationInput"]: GraphQLTypes["BlogPostReviewCreateUserEntityRelationInput"];
	["UserWithoutBlogPostReviewsCreateInput"]: GraphQLTypes["UserWithoutBlogPostReviewsCreateInput"];
	["UserCreateProductReviewReactionsEntityRelationInput"]: GraphQLTypes["UserCreateProductReviewReactionsEntityRelationInput"];
	["ProductReviewReactionWithoutUserCreateInput"]: GraphQLTypes["ProductReviewReactionWithoutUserCreateInput"];
	["ProductReviewReactionCreateProductReviewEntityRelationInput"]: GraphQLTypes["ProductReviewReactionCreateProductReviewEntityRelationInput"];
	["ProductReviewWithoutProductReviewReactionsCreateInput"]: GraphQLTypes["ProductReviewWithoutProductReviewReactionsCreateInput"];
	["ProductReviewCreateUserEntityRelationInput"]: GraphQLTypes["ProductReviewCreateUserEntityRelationInput"];
	["UserWithoutProductReviewsCreateInput"]: GraphQLTypes["UserWithoutProductReviewsCreateInput"];
	["UserCreateBlogPostsEntityRelationInput"]: GraphQLTypes["UserCreateBlogPostsEntityRelationInput"];
	["BlogPostWithoutUserCreateInput"]: GraphQLTypes["BlogPostWithoutUserCreateInput"];
	["BlogPostCreateAdsEntityRelationInput"]: GraphQLTypes["BlogPostCreateAdsEntityRelationInput"];
	["AdUniqueWhere"]: GraphQLTypes["AdUniqueWhere"];
	["AdWithoutBlogPostsCreateInput"]: GraphQLTypes["AdWithoutBlogPostsCreateInput"];
	["AdCreateImageEntityRelationInput"]: GraphQLTypes["AdCreateImageEntityRelationInput"];
	["AdConnectOrCreateImageRelationInput"]: GraphQLTypes["AdConnectOrCreateImageRelationInput"];
	["AdCreateItemCategoriesEntityRelationInput"]: GraphQLTypes["AdCreateItemCategoriesEntityRelationInput"];
	["ItemCategoryWithoutAdsCreateInput"]: GraphQLTypes["ItemCategoryWithoutAdsCreateInput"];
	["ItemCategoryCreateProductsEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateProductsEntityRelationInput"];
	["ProductWithoutItemCategoriesCreateInput"]: GraphQLTypes["ProductWithoutItemCategoriesCreateInput"];
	["ProductCreateElementsEntityRelationInput"]: GraphQLTypes["ProductCreateElementsEntityRelationInput"];
	["ElementOfProductWithoutProductCreateInput"]: GraphQLTypes["ElementOfProductWithoutProductCreateInput"];
	["ElementOfProductCreateElementEntityRelationInput"]: GraphQLTypes["ElementOfProductCreateElementEntityRelationInput"];
	["ElementWithoutProductsCreateInput"]: GraphQLTypes["ElementWithoutProductsCreateInput"];
	["ElementCreateFeatureDependenciesEntityRelationInput"]: GraphQLTypes["ElementCreateFeatureDependenciesEntityRelationInput"];
	["ProductFeatureWithoutDependentElementCreateInput"]: GraphQLTypes["ProductFeatureWithoutDependentElementCreateInput"];
	["ProductFeatureCreateDependentCategoryEntityRelationInput"]: GraphQLTypes["ProductFeatureCreateDependentCategoryEntityRelationInput"];
	["ItemCategoryWithoutFeatureDependenciesCreateInput"]: GraphQLTypes["ItemCategoryWithoutFeatureDependenciesCreateInput"];
	["ItemCategoryCreateImageEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateImageEntityRelationInput"];
	["ItemCategoryConnectOrCreateImageRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateImageRelationInput"];
	["ItemCategoryCreateAdsEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateAdsEntityRelationInput"];
	["AdWithoutItemCategoriesCreateInput"]: GraphQLTypes["AdWithoutItemCategoriesCreateInput"];
	["AdCreateBlogPostsEntityRelationInput"]: GraphQLTypes["AdCreateBlogPostsEntityRelationInput"];
	["BlogPostWithoutAdsCreateInput"]: GraphQLTypes["BlogPostWithoutAdsCreateInput"];
	["BlogPostCreateSeoEntityRelationInput"]: GraphQLTypes["BlogPostCreateSeoEntityRelationInput"];
	["SeoCreateInput"]: GraphQLTypes["SeoCreateInput"];
	["SeoCreateBrandsPageEntityRelationInput"]: GraphQLTypes["SeoCreateBrandsPageEntityRelationInput"];
	["BrandsPageWithoutSeoCreateInput"]: GraphQLTypes["BrandsPageWithoutSeoCreateInput"];
	["BrandsPageCreateRedirectsEntityRelationInput"]: GraphQLTypes["BrandsPageCreateRedirectsEntityRelationInput"];
	["RedirectWithoutBrandsPageCreateInput"]: GraphQLTypes["RedirectWithoutBrandsPageCreateInput"];
	["RedirectCreateItemCategoryEntityRelationInput"]: GraphQLTypes["RedirectCreateItemCategoryEntityRelationInput"];
	["ItemCategoryWithoutRedirectsCreateInput"]: GraphQLTypes["ItemCategoryWithoutRedirectsCreateInput"];
	["ItemCategoryCreateFeatureDependenciesEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"];
	["ProductFeatureWithoutDependentCategoryCreateInput"]: GraphQLTypes["ProductFeatureWithoutDependentCategoryCreateInput"];
	["ProductFeatureCreateDependentSubCategoryEntityRelationInput"]: GraphQLTypes["ProductFeatureCreateDependentSubCategoryEntityRelationInput"];
	["ItemSubCategoryWithoutFeatureDependenciesCreateInput"]: GraphQLTypes["ItemSubCategoryWithoutFeatureDependenciesCreateInput"];
	["ItemSubCategoryCreateCategoryEntityRelationInput"]: GraphQLTypes["ItemSubCategoryCreateCategoryEntityRelationInput"];
	["ItemCategoryWithoutSubCategoriesCreateInput"]: GraphQLTypes["ItemCategoryWithoutSubCategoriesCreateInput"];
	["ItemCategoryCreateRedirectsEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateRedirectsEntityRelationInput"];
	["RedirectWithoutItemCategoryCreateInput"]: GraphQLTypes["RedirectWithoutItemCategoryCreateInput"];
	["RedirectCreateBrandsPageEntityRelationInput"]: GraphQLTypes["RedirectCreateBrandsPageEntityRelationInput"];
	["BrandsPageWithoutRedirectsCreateInput"]: GraphQLTypes["BrandsPageWithoutRedirectsCreateInput"];
	["BrandsPageCreateSeoEntityRelationInput"]: GraphQLTypes["BrandsPageCreateSeoEntityRelationInput"];
	["SeoWithoutBrandsPageCreateInput"]: GraphQLTypes["SeoWithoutBrandsPageCreateInput"];
	["SeoCreateComparatorPageEntityRelationInput"]: GraphQLTypes["SeoCreateComparatorPageEntityRelationInput"];
	["ComparatorPageWithoutSeoCreateInput"]: GraphQLTypes["ComparatorPageWithoutSeoCreateInput"];
	["ComparatorPageCreateRedirectsEntityRelationInput"]: GraphQLTypes["ComparatorPageCreateRedirectsEntityRelationInput"];
	["RedirectWithoutComparatorPageCreateInput"]: GraphQLTypes["RedirectWithoutComparatorPageCreateInput"];
	["RedirectCreateBlogPageEntityRelationInput"]: GraphQLTypes["RedirectCreateBlogPageEntityRelationInput"];
	["BlogPageWithoutRedirectsCreateInput"]: GraphQLTypes["BlogPageWithoutRedirectsCreateInput"];
	["BlogPageCreateSeoEntityRelationInput"]: GraphQLTypes["BlogPageCreateSeoEntityRelationInput"];
	["SeoWithoutBlogPageCreateInput"]: GraphQLTypes["SeoWithoutBlogPageCreateInput"];
	["SeoCreateGenericPageEntityRelationInput"]: GraphQLTypes["SeoCreateGenericPageEntityRelationInput"];
	["GenericPageWithoutSeoCreateInput"]: GraphQLTypes["GenericPageWithoutSeoCreateInput"];
	["GenericPageCreateRedirectsEntityRelationInput"]: GraphQLTypes["GenericPageCreateRedirectsEntityRelationInput"];
	["RedirectWithoutGenericPageCreateInput"]: GraphQLTypes["RedirectWithoutGenericPageCreateInput"];
	["RedirectCreateContactPageEntityRelationInput"]: GraphQLTypes["RedirectCreateContactPageEntityRelationInput"];
	["ContactPageWithoutRedirectsCreateInput"]: GraphQLTypes["ContactPageWithoutRedirectsCreateInput"];
	["ContactPageCreateSeoEntityRelationInput"]: GraphQLTypes["ContactPageCreateSeoEntityRelationInput"];
	["SeoWithoutContactPageCreateInput"]: GraphQLTypes["SeoWithoutContactPageCreateInput"];
	["SeoCreateHomePageEntityRelationInput"]: GraphQLTypes["SeoCreateHomePageEntityRelationInput"];
	["HomePageWithoutSeoCreateInput"]: GraphQLTypes["HomePageWithoutSeoCreateInput"];
	["SeoConnectOrCreateHomePageRelationInput"]: GraphQLTypes["SeoConnectOrCreateHomePageRelationInput"];
	["SeoCreateIngredientsPageEntityRelationInput"]: GraphQLTypes["SeoCreateIngredientsPageEntityRelationInput"];
	["IngredientsPageWithoutSeoCreateInput"]: GraphQLTypes["IngredientsPageWithoutSeoCreateInput"];
	["IngredientsPageCreateContentEntityRelationInput"]: GraphQLTypes["IngredientsPageCreateContentEntityRelationInput"];
	["IngredientsPageConnectOrCreateContentRelationInput"]: GraphQLTypes["IngredientsPageConnectOrCreateContentRelationInput"];
	["IngredientsPageCreateDraftEntityRelationInput"]: GraphQLTypes["IngredientsPageCreateDraftEntityRelationInput"];
	["IngredientsPageConnectOrCreateDraftRelationInput"]: GraphQLTypes["IngredientsPageConnectOrCreateDraftRelationInput"];
	["SeoConnectOrCreateIngredientsPageRelationInput"]: GraphQLTypes["SeoConnectOrCreateIngredientsPageRelationInput"];
	["SeoCreateLoginPageEntityRelationInput"]: GraphQLTypes["SeoCreateLoginPageEntityRelationInput"];
	["LoginPageWithoutSeoCreateInput"]: GraphQLTypes["LoginPageWithoutSeoCreateInput"];
	["SeoConnectOrCreateLoginPageRelationInput"]: GraphQLTypes["SeoConnectOrCreateLoginPageRelationInput"];
	["SeoCreateRegisterPageEntityRelationInput"]: GraphQLTypes["SeoCreateRegisterPageEntityRelationInput"];
	["RegisterPageWithoutSeoCreateInput"]: GraphQLTypes["RegisterPageWithoutSeoCreateInput"];
	["SeoConnectOrCreateRegisterPageRelationInput"]: GraphQLTypes["SeoConnectOrCreateRegisterPageRelationInput"];
	["SeoCreateSearchPageEntityRelationInput"]: GraphQLTypes["SeoCreateSearchPageEntityRelationInput"];
	["SearchPageWithoutSeoCreateInput"]: GraphQLTypes["SearchPageWithoutSeoCreateInput"];
	["SeoConnectOrCreateSearchPageRelationInput"]: GraphQLTypes["SeoConnectOrCreateSearchPageRelationInput"];
	["SeoCreateWizardPageEntityRelationInput"]: GraphQLTypes["SeoCreateWizardPageEntityRelationInput"];
	["WizardPageWithoutSeoCreateInput"]: GraphQLTypes["WizardPageWithoutSeoCreateInput"];
	["WizardPageCreateRedirectsEntityRelationInput"]: GraphQLTypes["WizardPageCreateRedirectsEntityRelationInput"];
	["RedirectWithoutWizardPageCreateInput"]: GraphQLTypes["RedirectWithoutWizardPageCreateInput"];
	["RedirectCreateComparatorPageEntityRelationInput"]: GraphQLTypes["RedirectCreateComparatorPageEntityRelationInput"];
	["ComparatorPageWithoutRedirectsCreateInput"]: GraphQLTypes["ComparatorPageWithoutRedirectsCreateInput"];
	["ComparatorPageCreateSeoEntityRelationInput"]: GraphQLTypes["ComparatorPageCreateSeoEntityRelationInput"];
	["SeoWithoutComparatorPageCreateInput"]: GraphQLTypes["SeoWithoutComparatorPageCreateInput"];
	["SeoCreateContactPageEntityRelationInput"]: GraphQLTypes["SeoCreateContactPageEntityRelationInput"];
	["ContactPageWithoutSeoCreateInput"]: GraphQLTypes["ContactPageWithoutSeoCreateInput"];
	["ContactPageCreateRedirectsEntityRelationInput"]: GraphQLTypes["ContactPageCreateRedirectsEntityRelationInput"];
	["RedirectWithoutContactPageCreateInput"]: GraphQLTypes["RedirectWithoutContactPageCreateInput"];
	["RedirectCreateWizardPageEntityRelationInput"]: GraphQLTypes["RedirectCreateWizardPageEntityRelationInput"];
	["WizardPageWithoutRedirectsCreateInput"]: GraphQLTypes["WizardPageWithoutRedirectsCreateInput"];
	["WizardPageCreateSeoEntityRelationInput"]: GraphQLTypes["WizardPageCreateSeoEntityRelationInput"];
	["SeoWithoutWizardPageCreateInput"]: GraphQLTypes["SeoWithoutWizardPageCreateInput"];
	["WizardPageConnectOrCreateSeoRelationInput"]: GraphQLTypes["WizardPageConnectOrCreateSeoRelationInput"];
	["RedirectConnectOrCreateWizardPageRelationInput"]: GraphQLTypes["RedirectConnectOrCreateWizardPageRelationInput"];
	["RedirectCreateBlogPostEntityRelationInput"]: GraphQLTypes["RedirectCreateBlogPostEntityRelationInput"];
	["BlogPostWithoutRedirectsCreateInput"]: GraphQLTypes["BlogPostWithoutRedirectsCreateInput"];
	["BlogPostCreateContentEntityRelationInput"]: GraphQLTypes["BlogPostCreateContentEntityRelationInput"];
	["BlogPostConnectOrCreateContentRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateContentRelationInput"];
	["BlogPostCreateDraftEntityRelationInput"]: GraphQLTypes["BlogPostCreateDraftEntityRelationInput"];
	["BlogPostConnectOrCreateDraftRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateDraftRelationInput"];
	["RedirectConnectOrCreateBlogPostRelationInput"]: GraphQLTypes["RedirectConnectOrCreateBlogPostRelationInput"];
	["ContactPageConnectOrCreateRedirectsRelationInput"]: GraphQLTypes["ContactPageConnectOrCreateRedirectsRelationInput"];
	["ContactPageCreateContentEntityRelationInput"]: GraphQLTypes["ContactPageCreateContentEntityRelationInput"];
	["ContactPageConnectOrCreateContentRelationInput"]: GraphQLTypes["ContactPageConnectOrCreateContentRelationInput"];
	["ContactPageCreateDraftEntityRelationInput"]: GraphQLTypes["ContactPageCreateDraftEntityRelationInput"];
	["ContactPageConnectOrCreateDraftRelationInput"]: GraphQLTypes["ContactPageConnectOrCreateDraftRelationInput"];
	["SeoConnectOrCreateContactPageRelationInput"]: GraphQLTypes["SeoConnectOrCreateContactPageRelationInput"];
	["ComparatorPageConnectOrCreateSeoRelationInput"]: GraphQLTypes["ComparatorPageConnectOrCreateSeoRelationInput"];
	["RedirectConnectOrCreateComparatorPageRelationInput"]: GraphQLTypes["RedirectConnectOrCreateComparatorPageRelationInput"];
	["WizardPageConnectOrCreateRedirectsRelationInput"]: GraphQLTypes["WizardPageConnectOrCreateRedirectsRelationInput"];
	["SeoConnectOrCreateWizardPageRelationInput"]: GraphQLTypes["SeoConnectOrCreateWizardPageRelationInput"];
	["ContactPageConnectOrCreateSeoRelationInput"]: GraphQLTypes["ContactPageConnectOrCreateSeoRelationInput"];
	["RedirectConnectOrCreateContactPageRelationInput"]: GraphQLTypes["RedirectConnectOrCreateContactPageRelationInput"];
	["GenericPageConnectOrCreateRedirectsRelationInput"]: GraphQLTypes["GenericPageConnectOrCreateRedirectsRelationInput"];
	["GenericPageCreateContentEntityRelationInput"]: GraphQLTypes["GenericPageCreateContentEntityRelationInput"];
	["GenericPageConnectOrCreateContentRelationInput"]: GraphQLTypes["GenericPageConnectOrCreateContentRelationInput"];
	["GenericPageCreateDraftEntityRelationInput"]: GraphQLTypes["GenericPageCreateDraftEntityRelationInput"];
	["GenericPageConnectOrCreateDraftRelationInput"]: GraphQLTypes["GenericPageConnectOrCreateDraftRelationInput"];
	["SeoConnectOrCreateGenericPageRelationInput"]: GraphQLTypes["SeoConnectOrCreateGenericPageRelationInput"];
	["BlogPageConnectOrCreateSeoRelationInput"]: GraphQLTypes["BlogPageConnectOrCreateSeoRelationInput"];
	["BlogPageCreateDraftEntityRelationInput"]: GraphQLTypes["BlogPageCreateDraftEntityRelationInput"];
	["BlogPageConnectOrCreateDraftRelationInput"]: GraphQLTypes["BlogPageConnectOrCreateDraftRelationInput"];
	["RedirectConnectOrCreateBlogPageRelationInput"]: GraphQLTypes["RedirectConnectOrCreateBlogPageRelationInput"];
	["ComparatorPageConnectOrCreateRedirectsRelationInput"]: GraphQLTypes["ComparatorPageConnectOrCreateRedirectsRelationInput"];
	["SeoConnectOrCreateComparatorPageRelationInput"]: GraphQLTypes["SeoConnectOrCreateComparatorPageRelationInput"];
	["BrandsPageConnectOrCreateSeoRelationInput"]: GraphQLTypes["BrandsPageConnectOrCreateSeoRelationInput"];
	["BrandsPageCreateContentEntityRelationInput"]: GraphQLTypes["BrandsPageCreateContentEntityRelationInput"];
	["BrandsPageConnectOrCreateContentRelationInput"]: GraphQLTypes["BrandsPageConnectOrCreateContentRelationInput"];
	["BrandsPageCreateDraftEntityRelationInput"]: GraphQLTypes["BrandsPageCreateDraftEntityRelationInput"];
	["BrandsPageConnectOrCreateDraftRelationInput"]: GraphQLTypes["BrandsPageConnectOrCreateDraftRelationInput"];
	["RedirectConnectOrCreateBrandsPageRelationInput"]: GraphQLTypes["RedirectConnectOrCreateBrandsPageRelationInput"];
	["ItemCategoryConnectOrCreateRedirectsRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateRedirectsRelationInput"];
	["ItemCategoryCreateDeclensionsFourthEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"];
	["ItemDeclensionFourthVariantWithoutCategoryCreateInput"]: GraphQLTypes["ItemDeclensionFourthVariantWithoutCategoryCreateInput"];
	["ItemDeclensionFourthVariantCreateItemsEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantCreateItemsEntityRelationInput"];
	["ItemWithoutDeclensionFourthCreateInput"]: GraphQLTypes["ItemWithoutDeclensionFourthCreateInput"];
	["ItemCreateDeclensionSeventhEntityRelationInput"]: GraphQLTypes["ItemCreateDeclensionSeventhEntityRelationInput"];
	["ItemDeclensionSeventhVariantUniqueWhere"]: GraphQLTypes["ItemDeclensionSeventhVariantUniqueWhere"];
	["ItemDeclensionSeventhVariantWithoutItemsCreateInput"]: GraphQLTypes["ItemDeclensionSeventhVariantWithoutItemsCreateInput"];
	["ItemConnectOrCreateDeclensionSeventhRelationInput"]: GraphQLTypes["ItemConnectOrCreateDeclensionSeventhRelationInput"];
	["ItemCreateSeoEntityRelationInput"]: GraphQLTypes["ItemCreateSeoEntityRelationInput"];
	["ItemConnectOrCreateSeoRelationInput"]: GraphQLTypes["ItemConnectOrCreateSeoRelationInput"];
	["ItemCreateAliasesEntityRelationInput"]: GraphQLTypes["ItemCreateAliasesEntityRelationInput"];
	["ItemAliasWithoutItemCreateInput"]: GraphQLTypes["ItemAliasWithoutItemCreateInput"];
	["ItemConnectOrCreateAliasesRelationInput"]: GraphQLTypes["ItemConnectOrCreateAliasesRelationInput"];
	["ItemCreateContentEntityRelationInput"]: GraphQLTypes["ItemCreateContentEntityRelationInput"];
	["ItemConnectOrCreateContentRelationInput"]: GraphQLTypes["ItemConnectOrCreateContentRelationInput"];
	["ItemCreateDraftEntityRelationInput"]: GraphQLTypes["ItemCreateDraftEntityRelationInput"];
	["ItemConnectOrCreateDraftRelationInput"]: GraphQLTypes["ItemConnectOrCreateDraftRelationInput"];
	["ItemDeclensionFourthVariantConnectOrCreateItemsRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateItemsRelationInput"];
	["ItemDeclensionFourthVariantCreateSeoEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantCreateSeoEntityRelationInput"];
	["ItemDeclensionFourthVariantConnectOrCreateSeoRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateSeoRelationInput"];
	["ItemDeclensionFourthVariantCreateSubcategoryEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantCreateSubcategoryEntityRelationInput"];
	["ItemSubCategoryCreateInput"]: GraphQLTypes["ItemSubCategoryCreateInput"];
	["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"]: GraphQLTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"];
	["ItemFlavorCategoryWithoutItemsCreateInput"]: GraphQLTypes["ItemFlavorCategoryWithoutItemsCreateInput"];
	["ItemFlavorCategoryCreateColorEntityRelationInput"]: GraphQLTypes["ItemFlavorCategoryCreateColorEntityRelationInput"];
	["ColorWithoutItemFlavorCategoriesCreateInput"]: GraphQLTypes["ColorWithoutItemFlavorCategoriesCreateInput"];
	["ItemFlavorCategoryConnectOrCreateColorRelationInput"]: GraphQLTypes["ItemFlavorCategoryConnectOrCreateColorRelationInput"];
	["ItemSubCategoryConnectOrCreateFlavorCategoryRelationInput"]: GraphQLTypes["ItemSubCategoryConnectOrCreateFlavorCategoryRelationInput"];
	["ItemSubCategoryCreateDogsEntityRelationInput"]: GraphQLTypes["ItemSubCategoryCreateDogsEntityRelationInput"];
	["DogWithoutAllergiesCreateInput"]: GraphQLTypes["DogWithoutAllergiesCreateInput"];
	["DogCreateFedProductEntityRelationInput"]: GraphQLTypes["DogCreateFedProductEntityRelationInput"];
	["ProductWithoutDogsCreateInput"]: GraphQLTypes["ProductWithoutDogsCreateInput"];
	["ProductCreateRecommendedDogSizesEntityRelationInput"]: GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"];
	["DogSizeUniqueWhere"]: GraphQLTypes["DogSizeUniqueWhere"];
	["DogSizeWithoutProductsCreateInput"]: GraphQLTypes["DogSizeWithoutProductsCreateInput"];
	["DogSizeCreateBreedsEntityRelationInput"]: GraphQLTypes["DogSizeCreateBreedsEntityRelationInput"];
	["BreedWithoutSizeCreateInput"]: GraphQLTypes["BreedWithoutSizeCreateInput"];
	["BreedCreateSuitabilityCategoryEntityRelationInput"]: GraphQLTypes["BreedCreateSuitabilityCategoryEntityRelationInput"];
	["SuitabilityCategoryUniqueWhere"]: GraphQLTypes["SuitabilityCategoryUniqueWhere"];
	["SuitabilityCategoryWithoutBreedsCreateInput"]: GraphQLTypes["SuitabilityCategoryWithoutBreedsCreateInput"];
	["SuitabilityCategoryCreateDogSizesEntityRelationInput"]: GraphQLTypes["SuitabilityCategoryCreateDogSizesEntityRelationInput"];
	["DogSizeWithoutSuitabilityCategoryCreateInput"]: GraphQLTypes["DogSizeWithoutSuitabilityCategoryCreateInput"];
	["DogSizeCreateProductsEntityRelationInput"]: GraphQLTypes["DogSizeCreateProductsEntityRelationInput"];
	["ProductWithoutRecommendedDogSizesCreateInput"]: GraphQLTypes["ProductWithoutRecommendedDogSizesCreateInput"];
	["ProductCreateGranuleSizesEntityRelationInput"]: GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"];
	["GranuleSizeUniqueWhere"]: GraphQLTypes["GranuleSizeUniqueWhere"];
	["GranuleSizeWithoutProductsCreateInput"]: GraphQLTypes["GranuleSizeWithoutProductsCreateInput"];
	["ProductConnectOrCreateGranuleSizesRelationInput"]: GraphQLTypes["ProductConnectOrCreateGranuleSizesRelationInput"];
	["ProductCreateProductLineEntityRelationInput"]: GraphQLTypes["ProductCreateProductLineEntityRelationInput"];
	["ProductLineWithoutProductsCreateInput"]: GraphQLTypes["ProductLineWithoutProductsCreateInput"];
	["ProductLineCreateBrandEntityRelationInput"]: GraphQLTypes["ProductLineCreateBrandEntityRelationInput"];
	["BrandUniqueWhere"]: GraphQLTypes["BrandUniqueWhere"];
	["BrandWithoutProductLinesCreateInput"]: GraphQLTypes["BrandWithoutProductLinesCreateInput"];
	["BrandCreateProductsEntityRelationInput"]: GraphQLTypes["BrandCreateProductsEntityRelationInput"];
	["ProductWithoutBrandCreateInput"]: GraphQLTypes["ProductWithoutBrandCreateInput"];
	["ProductCreateFlagsEntityRelationInput"]: GraphQLTypes["ProductCreateFlagsEntityRelationInput"];
	["ProductFlagOfProductWithoutProductCreateInput"]: GraphQLTypes["ProductFlagOfProductWithoutProductCreateInput"];
	["ProductFlagOfProductCreateFlagEntityRelationInput"]: GraphQLTypes["ProductFlagOfProductCreateFlagEntityRelationInput"];
	["ProductFlagUniqueWhere"]: GraphQLTypes["ProductFlagUniqueWhere"];
	["ProductFlagWithoutProductsCreateInput"]: GraphQLTypes["ProductFlagWithoutProductsCreateInput"];
	["ProductFlagCreateProductFeaturesEntityRelationInput"]: GraphQLTypes["ProductFlagCreateProductFeaturesEntityRelationInput"];
	["ProductFeatureWithoutDependentFlagCreateInput"]: GraphQLTypes["ProductFeatureWithoutDependentFlagCreateInput"];
	["ProductFlagConnectOrCreateProductFeaturesRelationInput"]: GraphQLTypes["ProductFlagConnectOrCreateProductFeaturesRelationInput"];
	["ProductFlagOfProductConnectOrCreateFlagRelationInput"]: GraphQLTypes["ProductFlagOfProductConnectOrCreateFlagRelationInput"];
	["ProductConnectOrCreateFlagsRelationInput"]: GraphQLTypes["ProductConnectOrCreateFlagsRelationInput"];
	["ProductCreateImageEntityRelationInput"]: GraphQLTypes["ProductCreateImageEntityRelationInput"];
	["ProductConnectOrCreateImageRelationInput"]: GraphQLTypes["ProductConnectOrCreateImageRelationInput"];
	["ProductCreateRecommendedActivityEntityRelationInput"]: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"];
	["DogActivityWithoutProductsCreateInput"]: GraphQLTypes["DogActivityWithoutProductsCreateInput"];
	["DogActivityCreateDogsEntityRelationInput"]: GraphQLTypes["DogActivityCreateDogsEntityRelationInput"];
	["DogWithoutActivityCreateInput"]: GraphQLTypes["DogWithoutActivityCreateInput"];
	["DogCreateReproductionEntityRelationInput"]: GraphQLTypes["DogCreateReproductionEntityRelationInput"];
	["DogReproductionWithoutDogCreateInput"]: GraphQLTypes["DogReproductionWithoutDogCreateInput"];
	["DogReproductionCreateBreastfeedingCategoryEntityRelationInput"]: GraphQLTypes["DogReproductionCreateBreastfeedingCategoryEntityRelationInput"];
	["BreastfeedingCategoryUniqueWhere"]: GraphQLTypes["BreastfeedingCategoryUniqueWhere"];
	["BreastfeedingCategoryWithoutDogsCreateInput"]: GraphQLTypes["BreastfeedingCategoryWithoutDogsCreateInput"];
	["DogReproductionConnectOrCreateBreastfeedingCategoryRelationInput"]: GraphQLTypes["DogReproductionConnectOrCreateBreastfeedingCategoryRelationInput"];
	["DogConnectOrCreateReproductionRelationInput"]: GraphQLTypes["DogConnectOrCreateReproductionRelationInput"];
	["DogCreateAllergiesEntityRelationInput"]: GraphQLTypes["DogCreateAllergiesEntityRelationInput"];
	["ItemSubCategoryWithoutDogsCreateInput"]: GraphQLTypes["ItemSubCategoryWithoutDogsCreateInput"];
	["ItemSubCategoryCreateIconNegativeEntityRelationInput"]: GraphQLTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"];
	["ItemSubCategoryConnectOrCreateIconNegativeRelationInput"]: GraphQLTypes["ItemSubCategoryConnectOrCreateIconNegativeRelationInput"];
	["ItemSubCategoryCreateIconEntityRelationInput"]: GraphQLTypes["ItemSubCategoryCreateIconEntityRelationInput"];
	["ItemSubCategoryConnectOrCreateIconRelationInput"]: GraphQLTypes["ItemSubCategoryConnectOrCreateIconRelationInput"];
	["ItemSubCategoryCreateBrandsEntityRelationInput"]: GraphQLTypes["ItemSubCategoryCreateBrandsEntityRelationInput"];
	["ItemSubCategoryCreateProductLinesEntityRelationInput"]: GraphQLTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"];
	["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"]: GraphQLTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"];
	["FilterComboWithoutFlavorCreateInput"]: GraphQLTypes["FilterComboWithoutFlavorCreateInput"];
	["FilterComboCreateSeoEntityRelationInput"]: GraphQLTypes["FilterComboCreateSeoEntityRelationInput"];
	["FilterComboConnectOrCreateSeoRelationInput"]: GraphQLTypes["FilterComboConnectOrCreateSeoRelationInput"];
	["FilterComboCreateBreedEntityRelationInput"]: GraphQLTypes["FilterComboCreateBreedEntityRelationInput"];
	["BreedWithoutFilterCombosCreateInput"]: GraphQLTypes["BreedWithoutFilterCombosCreateInput"];
	["BreedCreateProductReviewsEntityRelationInput"]: GraphQLTypes["BreedCreateProductReviewsEntityRelationInput"];
	["ProductReviewWithoutBreedCreateInput"]: GraphQLTypes["ProductReviewWithoutBreedCreateInput"];
	["ProductReviewCreateAgeEntityRelationInput"]: GraphQLTypes["ProductReviewCreateAgeEntityRelationInput"];
	["AgeWithoutProductReviewsCreateInput"]: GraphQLTypes["AgeWithoutProductReviewsCreateInput"];
	["AgeCreateSuitabilityCategoriesEntityRelationInput"]: GraphQLTypes["AgeCreateSuitabilityCategoriesEntityRelationInput"];
	["SuitabilityCategoryWithoutDogAgesCreateInput"]: GraphQLTypes["SuitabilityCategoryWithoutDogAgesCreateInput"];
	["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"]: GraphQLTypes["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"];
	["DogActivityWithoutSuitabilityCategoryCreateInput"]: GraphQLTypes["DogActivityWithoutSuitabilityCategoryCreateInput"];
	["SuitabilityCategoryConnectOrCreateDogActivitiesRelationInput"]: GraphQLTypes["SuitabilityCategoryConnectOrCreateDogActivitiesRelationInput"];
	["SuitabilityCategoryCreateBreedsEntityRelationInput"]: GraphQLTypes["SuitabilityCategoryCreateBreedsEntityRelationInput"];
	["BreedWithoutSuitabilityCategoryCreateInput"]: GraphQLTypes["BreedWithoutSuitabilityCategoryCreateInput"];
	["BreedCreateBlogPostReviewsEntityRelationInput"]: GraphQLTypes["BreedCreateBlogPostReviewsEntityRelationInput"];
	["BlogPostReviewWithoutBreedCreateInput"]: GraphQLTypes["BlogPostReviewWithoutBreedCreateInput"];
	["BlogPostReviewCreateAgeEntityRelationInput"]: GraphQLTypes["BlogPostReviewCreateAgeEntityRelationInput"];
	["AgeWithoutBlogPostReviewsCreateInput"]: GraphQLTypes["AgeWithoutBlogPostReviewsCreateInput"];
	["AgeCreateProductReviewsEntityRelationInput"]: GraphQLTypes["AgeCreateProductReviewsEntityRelationInput"];
	["ProductReviewWithoutAgeCreateInput"]: GraphQLTypes["ProductReviewWithoutAgeCreateInput"];
	["ProductReviewCreateBreedEntityRelationInput"]: GraphQLTypes["ProductReviewCreateBreedEntityRelationInput"];
	["BreedWithoutProductReviewsCreateInput"]: GraphQLTypes["BreedWithoutProductReviewsCreateInput"];
	["BreedCreateSizeEntityRelationInput"]: GraphQLTypes["BreedCreateSizeEntityRelationInput"];
	["DogSizeWithoutBreedsCreateInput"]: GraphQLTypes["DogSizeWithoutBreedsCreateInput"];
	["DogSizeCreateSuitabilityCategoryEntityRelationInput"]: GraphQLTypes["DogSizeCreateSuitabilityCategoryEntityRelationInput"];
	["SuitabilityCategoryWithoutDogSizesCreateInput"]: GraphQLTypes["SuitabilityCategoryWithoutDogSizesCreateInput"];
	["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"]: GraphQLTypes["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"];
	["SuitabilityItemWithoutCategoryCreateInput"]: GraphQLTypes["SuitabilityItemWithoutCategoryCreateInput"];
	["SuitabilityCategoryConnectOrCreateSuitabilityItemsRelationInput"]: GraphQLTypes["SuitabilityCategoryConnectOrCreateSuitabilityItemsRelationInput"];
	["SuitabilityCategoryCreateDogAgesEntityRelationInput"]: GraphQLTypes["SuitabilityCategoryCreateDogAgesEntityRelationInput"];
	["AgeWithoutSuitabilityCategoriesCreateInput"]: GraphQLTypes["AgeWithoutSuitabilityCategoriesCreateInput"];
	["AgeCreateBlogPostReviewsEntityRelationInput"]: GraphQLTypes["AgeCreateBlogPostReviewsEntityRelationInput"];
	["BlogPostReviewWithoutAgeCreateInput"]: GraphQLTypes["BlogPostReviewWithoutAgeCreateInput"];
	["BlogPostReviewCreateBreedEntityRelationInput"]: GraphQLTypes["BlogPostReviewCreateBreedEntityRelationInput"];
	["BreedWithoutBlogPostReviewsCreateInput"]: GraphQLTypes["BreedWithoutBlogPostReviewsCreateInput"];
	["BreedCreateFilterCombosEntityRelationInput"]: GraphQLTypes["BreedCreateFilterCombosEntityRelationInput"];
	["FilterComboWithoutBreedCreateInput"]: GraphQLTypes["FilterComboWithoutBreedCreateInput"];
	["FilterComboCreateBrandEntityRelationInput"]: GraphQLTypes["FilterComboCreateBrandEntityRelationInput"];
	["BrandWithoutFilterCombosCreateInput"]: GraphQLTypes["BrandWithoutFilterCombosCreateInput"];
	["BrandCreateCountriesOfProductionEntityRelationInput"]: GraphQLTypes["BrandCreateCountriesOfProductionEntityRelationInput"];
	["CountryUniqueWhere"]: GraphQLTypes["CountryUniqueWhere"];
	["CountryWithoutBrandsCreateInput"]: GraphQLTypes["CountryWithoutBrandsCreateInput"];
	["CountryCreateManufacturersEntityRelationInput"]: GraphQLTypes["CountryCreateManufacturersEntityRelationInput"];
	["BrandManufacturerWithoutResidenceCreateInput"]: GraphQLTypes["BrandManufacturerWithoutResidenceCreateInput"];
	["BrandManufacturerCreateBrandsEntityRelationInput"]: GraphQLTypes["BrandManufacturerCreateBrandsEntityRelationInput"];
	["BrandWithoutManufacturersCreateInput"]: GraphQLTypes["BrandWithoutManufacturersCreateInput"];
	["BrandCreateProductLinesEntityRelationInput"]: GraphQLTypes["BrandCreateProductLinesEntityRelationInput"];
	["ProductLineWithoutBrandCreateInput"]: GraphQLTypes["ProductLineWithoutBrandCreateInput"];
	["ProductLineCreateProductsEntityRelationInput"]: GraphQLTypes["ProductLineCreateProductsEntityRelationInput"];
	["ProductWithoutProductLineCreateInput"]: GraphQLTypes["ProductWithoutProductLineCreateInput"];
	["ProductCreateBrandEntityRelationInput"]: GraphQLTypes["ProductCreateBrandEntityRelationInput"];
	["BrandWithoutProductsCreateInput"]: GraphQLTypes["BrandWithoutProductsCreateInput"];
	["BrandCreateManufacturersEntityRelationInput"]: GraphQLTypes["BrandCreateManufacturersEntityRelationInput"];
	["BrandManufacturerWithoutBrandsCreateInput"]: GraphQLTypes["BrandManufacturerWithoutBrandsCreateInput"];
	["BrandManufacturerCreateResidenceEntityRelationInput"]: GraphQLTypes["BrandManufacturerCreateResidenceEntityRelationInput"];
	["CountryWithoutManufacturersCreateInput"]: GraphQLTypes["CountryWithoutManufacturersCreateInput"];
	["CountryCreateBrandsEntityRelationInput"]: GraphQLTypes["CountryCreateBrandsEntityRelationInput"];
	["BrandWithoutCountriesOfProductionCreateInput"]: GraphQLTypes["BrandWithoutCountriesOfProductionCreateInput"];
	["BrandCreateLogoEntityRelationInput"]: GraphQLTypes["BrandCreateLogoEntityRelationInput"];
	["BrandConnectOrCreateLogoRelationInput"]: GraphQLTypes["BrandConnectOrCreateLogoRelationInput"];
	["BrandCreateMethodOfProductionEntityRelationInput"]: GraphQLTypes["BrandCreateMethodOfProductionEntityRelationInput"];
	["ProductionMethodUniqueWhere"]: GraphQLTypes["ProductionMethodUniqueWhere"];
	["ProductionMethodWithoutBrandsCreateInput"]: GraphQLTypes["ProductionMethodWithoutBrandsCreateInput"];
	["BrandConnectOrCreateMethodOfProductionRelationInput"]: GraphQLTypes["BrandConnectOrCreateMethodOfProductionRelationInput"];
	["BrandCreateDistributorEntityRelationInput"]: GraphQLTypes["BrandCreateDistributorEntityRelationInput"];
	["BrandDistributorUniqueWhere"]: GraphQLTypes["BrandDistributorUniqueWhere"];
	["BrandDistributorWithoutBrandsCreateInput"]: GraphQLTypes["BrandDistributorWithoutBrandsCreateInput"];
	["BrandConnectOrCreateDistributorRelationInput"]: GraphQLTypes["BrandConnectOrCreateDistributorRelationInput"];
	["BrandCreateAliasesEntityRelationInput"]: GraphQLTypes["BrandCreateAliasesEntityRelationInput"];
	["BrandAliasWithoutBrandCreateInput"]: GraphQLTypes["BrandAliasWithoutBrandCreateInput"];
	["BrandConnectOrCreateAliasesRelationInput"]: GraphQLTypes["BrandConnectOrCreateAliasesRelationInput"];
	["BrandCreateAdsEntityRelationInput"]: GraphQLTypes["BrandCreateAdsEntityRelationInput"];
	["AdWithoutBrandsCreateInput"]: GraphQLTypes["AdWithoutBrandsCreateInput"];
	["AdCreateContentReferencesEntityRelationInput"]: GraphQLTypes["AdCreateContentReferencesEntityRelationInput"];
	["ContentReferenceWithoutAdCreateInput"]: GraphQLTypes["ContentReferenceWithoutAdCreateInput"];
	["ContentReferenceCreateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesCreateInput"]: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"];
	["ContentBlockCreateContentEntityRelationInput"]: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"];
	["ContentWithoutBlocksCreateInput"]: GraphQLTypes["ContentWithoutBlocksCreateInput"];
	["ContentBlockConnectOrCreateContentRelationInput"]: GraphQLTypes["ContentBlockConnectOrCreateContentRelationInput"];
	["ContentReferenceConnectOrCreateBlockRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateBlockRelationInput"];
	["ContentReferenceCreateRelatedBrandEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateRelatedBrandEntityRelationInput"];
	["BrandCreateInput"]: GraphQLTypes["BrandCreateInput"];
	["BrandCreateFlavorsEntityRelationInput"]: GraphQLTypes["BrandCreateFlavorsEntityRelationInput"];
	["BrandCreateSeoEntityRelationInput"]: GraphQLTypes["BrandCreateSeoEntityRelationInput"];
	["BrandConnectOrCreateSeoRelationInput"]: GraphQLTypes["BrandConnectOrCreateSeoRelationInput"];
	["BrandCreateFilterCombosEntityRelationInput"]: GraphQLTypes["BrandCreateFilterCombosEntityRelationInput"];
	["FilterComboWithoutBrandCreateInput"]: GraphQLTypes["FilterComboWithoutBrandCreateInput"];
	["FilterComboCreateRegionEntityRelationInput"]: GraphQLTypes["FilterComboCreateRegionEntityRelationInput"];
	["RegionUniqueWhere"]: GraphQLTypes["RegionUniqueWhere"];
	["RegionWithoutFilterCombosCreateInput"]: GraphQLTypes["RegionWithoutFilterCombosCreateInput"];
	["RegionCreateCountriesEntityRelationInput"]: GraphQLTypes["RegionCreateCountriesEntityRelationInput"];
	["CountryWithoutRegionCreateInput"]: GraphQLTypes["CountryWithoutRegionCreateInput"];
	["RegionConnectOrCreateCountriesRelationInput"]: GraphQLTypes["RegionConnectOrCreateCountriesRelationInput"];
	["FilterComboConnectOrCreateRegionRelationInput"]: GraphQLTypes["FilterComboConnectOrCreateRegionRelationInput"];
	["FilterComboCreateAgeCategoryEntityRelationInput"]: GraphQLTypes["FilterComboCreateAgeCategoryEntityRelationInput"];
	["AgeCategoryUniqueWhere"]: GraphQLTypes["AgeCategoryUniqueWhere"];
	["AgeCategoryWithoutFilterCombosCreateInput"]: GraphQLTypes["AgeCategoryWithoutFilterCombosCreateInput"];
	["AgeCategoryCreateProductsEntityRelationInput"]: GraphQLTypes["AgeCategoryCreateProductsEntityRelationInput"];
	["ProductWithoutAgeCategoriesCreateInput"]: GraphQLTypes["ProductWithoutAgeCategoriesCreateInput"];
	["ProductCreateAliasesEntityRelationInput"]: GraphQLTypes["ProductCreateAliasesEntityRelationInput"];
	["ProductAliasWithoutProductCreateInput"]: GraphQLTypes["ProductAliasWithoutProductCreateInput"];
	["ProductConnectOrCreateAliasesRelationInput"]: GraphQLTypes["ProductConnectOrCreateAliasesRelationInput"];
	["ProductCreateEvaluationEntityRelationInput"]: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"];
	["ProductEvaluationWithoutProductCreateInput"]: GraphQLTypes["ProductEvaluationWithoutProductCreateInput"];
	["ProductConnectOrCreateEvaluationRelationInput"]: GraphQLTypes["ProductConnectOrCreateEvaluationRelationInput"];
	["ProductCreateSeoEntityRelationInput"]: GraphQLTypes["ProductCreateSeoEntityRelationInput"];
	["ProductConnectOrCreateSeoRelationInput"]: GraphQLTypes["ProductConnectOrCreateSeoRelationInput"];
	["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]: GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"];
	["ProductCreateHeurekaImageEntityRelationInput"]: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"];
	["ProductConnectOrCreateHeurekaImageRelationInput"]: GraphQLTypes["ProductConnectOrCreateHeurekaImageRelationInput"];
	["ProductCreateTopxEntityRelationInput"]: GraphQLTypes["ProductCreateTopxEntityRelationInput"];
	["TOPXProductWithoutProductCreateInput"]: GraphQLTypes["TOPXProductWithoutProductCreateInput"];
	["TOPXProductCreateCategoryEntityRelationInput"]: GraphQLTypes["TOPXProductCreateCategoryEntityRelationInput"];
	["TOPXProductCategoryUniqueWhere"]: GraphQLTypes["TOPXProductCategoryUniqueWhere"];
	["TOPXProductCategoryWithoutProductsCreateInput"]: GraphQLTypes["TOPXProductCategoryWithoutProductsCreateInput"];
	["TOPXProductConnectOrCreateCategoryRelationInput"]: GraphQLTypes["TOPXProductConnectOrCreateCategoryRelationInput"];
	["ProductConnectOrCreateTopxRelationInput"]: GraphQLTypes["ProductConnectOrCreateTopxRelationInput"];
	["AgeCategoryConnectOrCreateProductsRelationInput"]: GraphQLTypes["AgeCategoryConnectOrCreateProductsRelationInput"];
	["FilterComboConnectOrCreateAgeCategoryRelationInput"]: GraphQLTypes["FilterComboConnectOrCreateAgeCategoryRelationInput"];
	["FilterComboCreateTreatmentEntityRelationInput"]: GraphQLTypes["FilterComboCreateTreatmentEntityRelationInput"];
	["BodyTagWithoutFilterCombosCreateInput"]: GraphQLTypes["BodyTagWithoutFilterCombosCreateInput"];
	["BodyTagCreateIconEntityRelationInput"]: GraphQLTypes["BodyTagCreateIconEntityRelationInput"];
	["BodyTagConnectOrCreateIconRelationInput"]: GraphQLTypes["BodyTagConnectOrCreateIconRelationInput"];
	["BodyTagCreateDogsEntityRelationInput"]: GraphQLTypes["BodyTagCreateDogsEntityRelationInput"];
	["DogWithoutIllnessesCreateInput"]: GraphQLTypes["DogWithoutIllnessesCreateInput"];
	["DogCreateAvatarEntityRelationInput"]: GraphQLTypes["DogCreateAvatarEntityRelationInput"];
	["DogConnectOrCreateAvatarRelationInput"]: GraphQLTypes["DogConnectOrCreateAvatarRelationInput"];
	["BodyTagConnectOrCreateDogsRelationInput"]: GraphQLTypes["BodyTagConnectOrCreateDogsRelationInput"];
	["FilterComboConnectOrCreateTreatmentRelationInput"]: GraphQLTypes["FilterComboConnectOrCreateTreatmentRelationInput"];
	["FilterComboCreateFlavorEntityRelationInput"]: GraphQLTypes["FilterComboCreateFlavorEntityRelationInput"];
	["ItemSubCategoryWithoutFilterCombosFlavorCreateInput"]: GraphQLTypes["ItemSubCategoryWithoutFilterCombosFlavorCreateInput"];
	["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"]: GraphQLTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"];
	["FilterComboWithoutAllergyCreateInput"]: GraphQLTypes["FilterComboWithoutAllergyCreateInput"];
	["ItemSubCategoryConnectOrCreateFilterCombosAllergyRelationInput"]: GraphQLTypes["ItemSubCategoryConnectOrCreateFilterCombosAllergyRelationInput"];
	["FilterComboConnectOrCreateFlavorRelationInput"]: GraphQLTypes["FilterComboConnectOrCreateFlavorRelationInput"];
	["FilterComboCreateAllergyEntityRelationInput"]: GraphQLTypes["FilterComboCreateAllergyEntityRelationInput"];
	["ItemSubCategoryWithoutFilterCombosAllergyCreateInput"]: GraphQLTypes["ItemSubCategoryWithoutFilterCombosAllergyCreateInput"];
	["FilterComboConnectOrCreateAllergyRelationInput"]: GraphQLTypes["FilterComboConnectOrCreateAllergyRelationInput"];
	["BrandConnectOrCreateFilterCombosRelationInput"]: GraphQLTypes["BrandConnectOrCreateFilterCombosRelationInput"];
	["BrandCreateTopxEntityRelationInput"]: GraphQLTypes["BrandCreateTopxEntityRelationInput"];
	["TOPXBrandWithoutBrandCreateInput"]: GraphQLTypes["TOPXBrandWithoutBrandCreateInput"];
	["TOPXBrandCreateCategoryEntityRelationInput"]: GraphQLTypes["TOPXBrandCreateCategoryEntityRelationInput"];
	["TOPXBrandCategoryUniqueWhere"]: GraphQLTypes["TOPXBrandCategoryUniqueWhere"];
	["TOPXBrandCategoryWithoutBrandsCreateInput"]: GraphQLTypes["TOPXBrandCategoryWithoutBrandsCreateInput"];
	["TOPXBrandConnectOrCreateCategoryRelationInput"]: GraphQLTypes["TOPXBrandConnectOrCreateCategoryRelationInput"];
	["BrandConnectOrCreateTopxRelationInput"]: GraphQLTypes["BrandConnectOrCreateTopxRelationInput"];
	["BrandCreateContentEntityRelationInput"]: GraphQLTypes["BrandCreateContentEntityRelationInput"];
	["BrandConnectOrCreateContentRelationInput"]: GraphQLTypes["BrandConnectOrCreateContentRelationInput"];
	["BrandCreateDraftEntityRelationInput"]: GraphQLTypes["BrandCreateDraftEntityRelationInput"];
	["BrandConnectOrCreateDraftRelationInput"]: GraphQLTypes["BrandConnectOrCreateDraftRelationInput"];
	["ContentReferenceConnectOrCreateRelatedBrandRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateRelatedBrandRelationInput"];
	["ContentReferenceCreateRelatedProductEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateRelatedProductEntityRelationInput"];
	["ProductCreateInput"]: GraphQLTypes["ProductCreateInput"];
	["ProductCreateAgeCategoriesEntityRelationInput"]: GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"];
	["AgeCategoryWithoutProductsCreateInput"]: GraphQLTypes["AgeCategoryWithoutProductsCreateInput"];
	["AgeCategoryCreateFilterCombosEntityRelationInput"]: GraphQLTypes["AgeCategoryCreateFilterCombosEntityRelationInput"];
	["FilterComboWithoutAgeCategoryCreateInput"]: GraphQLTypes["FilterComboWithoutAgeCategoryCreateInput"];
	["AgeCategoryConnectOrCreateFilterCombosRelationInput"]: GraphQLTypes["AgeCategoryConnectOrCreateFilterCombosRelationInput"];
	["ProductConnectOrCreateAgeCategoriesRelationInput"]: GraphQLTypes["ProductConnectOrCreateAgeCategoriesRelationInput"];
	["ContentReferenceConnectOrCreateRelatedProductRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateRelatedProductRelationInput"];
	["ContentReferenceCreateRelatedIngredientEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateRelatedIngredientEntityRelationInput"];
	["ItemCreateInput"]: GraphQLTypes["ItemCreateInput"];
	["ItemCreateDeclensionFourthEntityRelationInput"]: GraphQLTypes["ItemCreateDeclensionFourthEntityRelationInput"];
	["ItemDeclensionFourthVariantWithoutItemsCreateInput"]: GraphQLTypes["ItemDeclensionFourthVariantWithoutItemsCreateInput"];
	["ItemDeclensionFourthVariantCreateCategoryEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantCreateCategoryEntityRelationInput"];
	["ItemCategoryWithoutDeclensionsFourthCreateInput"]: GraphQLTypes["ItemCategoryWithoutDeclensionsFourthCreateInput"];
	["ItemCategoryCreateSeoEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateSeoEntityRelationInput"];
	["ItemCategoryConnectOrCreateSeoRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateSeoRelationInput"];
	["ItemCategoryCreateGroupEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateGroupEntityRelationInput"];
	["ItemGroupUniqueWhere"]: GraphQLTypes["ItemGroupUniqueWhere"];
	["ItemGroupWithoutCategoriesCreateInput"]: GraphQLTypes["ItemGroupWithoutCategoriesCreateInput"];
	["ItemCategoryConnectOrCreateGroupRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateGroupRelationInput"];
	["ItemCategoryCreateContentEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateContentEntityRelationInput"];
	["ItemCategoryConnectOrCreateContentRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateContentRelationInput"];
	["ItemCategoryCreateDraftEntityRelationInput"]: GraphQLTypes["ItemCategoryCreateDraftEntityRelationInput"];
	["ItemCategoryConnectOrCreateDraftRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateDraftRelationInput"];
	["ItemDeclensionFourthVariantConnectOrCreateCategoryRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateCategoryRelationInput"];
	["ItemDeclensionFourthVariantCreateElementEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantCreateElementEntityRelationInput"];
	["ElementCreateInput"]: GraphQLTypes["ElementCreateInput"];
	["ItemDeclensionFourthVariantConnectOrCreateElementRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateElementRelationInput"];
	["ItemDeclensionFourthVariantCreateProductsEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantCreateProductsEntityRelationInput"];
	["ItemDeclensionFourthVariantCreateContentEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantCreateContentEntityRelationInput"];
	["ItemDeclensionFourthVariantConnectOrCreateContentRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateContentRelationInput"];
	["ItemDeclensionFourthVariantCreateDraftEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantCreateDraftEntityRelationInput"];
	["ItemDeclensionFourthVariantConnectOrCreateDraftRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateDraftRelationInput"];
	["ItemConnectOrCreateDeclensionFourthRelationInput"]: GraphQLTypes["ItemConnectOrCreateDeclensionFourthRelationInput"];
	["ContentReferenceConnectOrCreateRelatedIngredientRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateRelatedIngredientRelationInput"];
	["ContentReferenceCreateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"];
	["LinkCreateInput"]: GraphQLTypes["LinkCreateInput"];
	["ContentReferenceConnectOrCreateLinkRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateLinkRelationInput"];
	["ContentReferenceCreateRelatedBrandFullEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateRelatedBrandFullEntityRelationInput"];
	["ContentReferenceConnectOrCreateRelatedBrandFullRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateRelatedBrandFullRelationInput"];
	["ContentReferenceCreateRelatedProductFullEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateRelatedProductFullEntityRelationInput"];
	["ContentReferenceConnectOrCreateRelatedProductFullRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateRelatedProductFullRelationInput"];
	["ContentReferenceCreateListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateListEntityRelationInput"];
	["ContentReferenceListWithoutListCreateInput"]: GraphQLTypes["ContentReferenceListWithoutListCreateInput"];
	["ContentReferenceListCreateRelatedProductEntityRelationInput"]: GraphQLTypes["ContentReferenceListCreateRelatedProductEntityRelationInput"];
	["ContentReferenceListConnectOrCreateRelatedProductRelationInput"]: GraphQLTypes["ContentReferenceListConnectOrCreateRelatedProductRelationInput"];
	["ContentReferenceListCreateRelatedBrandEntityRelationInput"]: GraphQLTypes["ContentReferenceListCreateRelatedBrandEntityRelationInput"];
	["ContentReferenceListConnectOrCreateRelatedBrandRelationInput"]: GraphQLTypes["ContentReferenceListConnectOrCreateRelatedBrandRelationInput"];
	["ContentReferenceConnectOrCreateListRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateListRelationInput"];
	["ContentReferenceCreateOutlineEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateOutlineEntityRelationInput"];
	["ContentLinksCreateInput"]: GraphQLTypes["ContentLinksCreateInput"];
	["ContentLinksCreateItemsEntityRelationInput"]: GraphQLTypes["ContentLinksCreateItemsEntityRelationInput"];
	["ContentLinksItemWithoutListCreateInput"]: GraphQLTypes["ContentLinksItemWithoutListCreateInput"];
	["ContentLinksConnectOrCreateItemsRelationInput"]: GraphQLTypes["ContentLinksConnectOrCreateItemsRelationInput"];
	["ContentReferenceConnectOrCreateOutlineRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateOutlineRelationInput"];
	["ContentReferenceCreateVideoEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateVideoEntityRelationInput"];
	["VideoCreateInput"]: GraphQLTypes["VideoCreateInput"];
	["VideoCreatePosterEntityRelationInput"]: GraphQLTypes["VideoCreatePosterEntityRelationInput"];
	["VideoConnectOrCreatePosterRelationInput"]: GraphQLTypes["VideoConnectOrCreatePosterRelationInput"];
	["ContentReferenceConnectOrCreateVideoRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateVideoRelationInput"];
	["ContentReferenceCreateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"];
	["ContentReferenceImageCreateInput"]: GraphQLTypes["ContentReferenceImageCreateInput"];
	["ContentReferenceImageCreateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceImageCreateImageEntityRelationInput"];
	["ContentReferenceImageConnectOrCreateImageRelationInput"]: GraphQLTypes["ContentReferenceImageConnectOrCreateImageRelationInput"];
	["ContentReferenceConnectOrCreateImageRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateImageRelationInput"];
	["AdConnectOrCreateContentReferencesRelationInput"]: GraphQLTypes["AdConnectOrCreateContentReferencesRelationInput"];
	["BrandConnectOrCreateAdsRelationInput"]: GraphQLTypes["BrandConnectOrCreateAdsRelationInput"];
	["CountryConnectOrCreateBrandsRelationInput"]: GraphQLTypes["CountryConnectOrCreateBrandsRelationInput"];
	["CountryCreateRegionEntityRelationInput"]: GraphQLTypes["CountryCreateRegionEntityRelationInput"];
	["RegionWithoutCountriesCreateInput"]: GraphQLTypes["RegionWithoutCountriesCreateInput"];
	["RegionCreateFilterCombosEntityRelationInput"]: GraphQLTypes["RegionCreateFilterCombosEntityRelationInput"];
	["FilterComboWithoutRegionCreateInput"]: GraphQLTypes["FilterComboWithoutRegionCreateInput"];
	["RegionConnectOrCreateFilterCombosRelationInput"]: GraphQLTypes["RegionConnectOrCreateFilterCombosRelationInput"];
	["CountryConnectOrCreateRegionRelationInput"]: GraphQLTypes["CountryConnectOrCreateRegionRelationInput"];
	["BrandManufacturerConnectOrCreateResidenceRelationInput"]: GraphQLTypes["BrandManufacturerConnectOrCreateResidenceRelationInput"];
	["BrandConnectOrCreateManufacturersRelationInput"]: GraphQLTypes["BrandConnectOrCreateManufacturersRelationInput"];
	["ProductConnectOrCreateBrandRelationInput"]: GraphQLTypes["ProductConnectOrCreateBrandRelationInput"];
	["ProductLineConnectOrCreateProductsRelationInput"]: GraphQLTypes["ProductLineConnectOrCreateProductsRelationInput"];
	["ProductLineCreateLogoEntityRelationInput"]: GraphQLTypes["ProductLineCreateLogoEntityRelationInput"];
	["ProductLineConnectOrCreateLogoRelationInput"]: GraphQLTypes["ProductLineConnectOrCreateLogoRelationInput"];
	["ProductLineCreateAliasesEntityRelationInput"]: GraphQLTypes["ProductLineCreateAliasesEntityRelationInput"];
	["ProductLineAliasUniqueWhere"]: GraphQLTypes["ProductLineAliasUniqueWhere"];
	["ProductLineAliasWithoutProductLinesCreateInput"]: GraphQLTypes["ProductLineAliasWithoutProductLinesCreateInput"];
	["ProductLineConnectOrCreateAliasesRelationInput"]: GraphQLTypes["ProductLineConnectOrCreateAliasesRelationInput"];
	["ProductLineCreateFlavorsEntityRelationInput"]: GraphQLTypes["ProductLineCreateFlavorsEntityRelationInput"];
	["ProductLineCreateSeoEntityRelationInput"]: GraphQLTypes["ProductLineCreateSeoEntityRelationInput"];
	["ProductLineConnectOrCreateSeoRelationInput"]: GraphQLTypes["ProductLineConnectOrCreateSeoRelationInput"];
	["BrandConnectOrCreateProductLinesRelationInput"]: GraphQLTypes["BrandConnectOrCreateProductLinesRelationInput"];
	["BrandManufacturerConnectOrCreateBrandsRelationInput"]: GraphQLTypes["BrandManufacturerConnectOrCreateBrandsRelationInput"];
	["CountryConnectOrCreateManufacturersRelationInput"]: GraphQLTypes["CountryConnectOrCreateManufacturersRelationInput"];
	["BrandConnectOrCreateCountriesOfProductionRelationInput"]: GraphQLTypes["BrandConnectOrCreateCountriesOfProductionRelationInput"];
	["FilterComboConnectOrCreateBrandRelationInput"]: GraphQLTypes["FilterComboConnectOrCreateBrandRelationInput"];
	["BreedConnectOrCreateFilterCombosRelationInput"]: GraphQLTypes["BreedConnectOrCreateFilterCombosRelationInput"];
	["BlogPostReviewConnectOrCreateBreedRelationInput"]: GraphQLTypes["BlogPostReviewConnectOrCreateBreedRelationInput"];
	["AgeConnectOrCreateBlogPostReviewsRelationInput"]: GraphQLTypes["AgeConnectOrCreateBlogPostReviewsRelationInput"];
	["SuitabilityCategoryConnectOrCreateDogAgesRelationInput"]: GraphQLTypes["SuitabilityCategoryConnectOrCreateDogAgesRelationInput"];
	["DogSizeConnectOrCreateSuitabilityCategoryRelationInput"]: GraphQLTypes["DogSizeConnectOrCreateSuitabilityCategoryRelationInput"];
	["BreedConnectOrCreateSizeRelationInput"]: GraphQLTypes["BreedConnectOrCreateSizeRelationInput"];
	["ProductReviewConnectOrCreateBreedRelationInput"]: GraphQLTypes["ProductReviewConnectOrCreateBreedRelationInput"];
	["AgeConnectOrCreateProductReviewsRelationInput"]: GraphQLTypes["AgeConnectOrCreateProductReviewsRelationInput"];
	["BlogPostReviewConnectOrCreateAgeRelationInput"]: GraphQLTypes["BlogPostReviewConnectOrCreateAgeRelationInput"];
	["BreedConnectOrCreateBlogPostReviewsRelationInput"]: GraphQLTypes["BreedConnectOrCreateBlogPostReviewsRelationInput"];
	["SuitabilityCategoryConnectOrCreateBreedsRelationInput"]: GraphQLTypes["SuitabilityCategoryConnectOrCreateBreedsRelationInput"];
	["AgeConnectOrCreateSuitabilityCategoriesRelationInput"]: GraphQLTypes["AgeConnectOrCreateSuitabilityCategoriesRelationInput"];
	["ProductReviewConnectOrCreateAgeRelationInput"]: GraphQLTypes["ProductReviewConnectOrCreateAgeRelationInput"];
	["BreedConnectOrCreateProductReviewsRelationInput"]: GraphQLTypes["BreedConnectOrCreateProductReviewsRelationInput"];
	["FilterComboConnectOrCreateBreedRelationInput"]: GraphQLTypes["FilterComboConnectOrCreateBreedRelationInput"];
	["ItemSubCategoryConnectOrCreateFilterCombosFlavorRelationInput"]: GraphQLTypes["ItemSubCategoryConnectOrCreateFilterCombosFlavorRelationInput"];
	["DogConnectOrCreateAllergiesRelationInput"]: GraphQLTypes["DogConnectOrCreateAllergiesRelationInput"];
	["DogCreateIllnessesEntityRelationInput"]: GraphQLTypes["DogCreateIllnessesEntityRelationInput"];
	["BodyTagWithoutDogsCreateInput"]: GraphQLTypes["BodyTagWithoutDogsCreateInput"];
	["BodyTagCreateFilterCombosEntityRelationInput"]: GraphQLTypes["BodyTagCreateFilterCombosEntityRelationInput"];
	["FilterComboWithoutTreatmentCreateInput"]: GraphQLTypes["FilterComboWithoutTreatmentCreateInput"];
	["BodyTagConnectOrCreateFilterCombosRelationInput"]: GraphQLTypes["BodyTagConnectOrCreateFilterCombosRelationInput"];
	["DogConnectOrCreateIllnessesRelationInput"]: GraphQLTypes["DogConnectOrCreateIllnessesRelationInput"];
	["DogActivityConnectOrCreateDogsRelationInput"]: GraphQLTypes["DogActivityConnectOrCreateDogsRelationInput"];
	["DogActivityCreateSuitabilityCategoryEntityRelationInput"]: GraphQLTypes["DogActivityCreateSuitabilityCategoryEntityRelationInput"];
	["SuitabilityCategoryWithoutDogActivitiesCreateInput"]: GraphQLTypes["SuitabilityCategoryWithoutDogActivitiesCreateInput"];
	["DogActivityConnectOrCreateSuitabilityCategoryRelationInput"]: GraphQLTypes["DogActivityConnectOrCreateSuitabilityCategoryRelationInput"];
	["ProductConnectOrCreateRecommendedActivityRelationInput"]: GraphQLTypes["ProductConnectOrCreateRecommendedActivityRelationInput"];
	["BrandConnectOrCreateProductsRelationInput"]: GraphQLTypes["BrandConnectOrCreateProductsRelationInput"];
	["ProductLineConnectOrCreateBrandRelationInput"]: GraphQLTypes["ProductLineConnectOrCreateBrandRelationInput"];
	["ProductConnectOrCreateProductLineRelationInput"]: GraphQLTypes["ProductConnectOrCreateProductLineRelationInput"];
	["DogSizeConnectOrCreateProductsRelationInput"]: GraphQLTypes["DogSizeConnectOrCreateProductsRelationInput"];
	["SuitabilityCategoryConnectOrCreateDogSizesRelationInput"]: GraphQLTypes["SuitabilityCategoryConnectOrCreateDogSizesRelationInput"];
	["BreedConnectOrCreateSuitabilityCategoryRelationInput"]: GraphQLTypes["BreedConnectOrCreateSuitabilityCategoryRelationInput"];
	["DogSizeConnectOrCreateBreedsRelationInput"]: GraphQLTypes["DogSizeConnectOrCreateBreedsRelationInput"];
	["ProductConnectOrCreateRecommendedDogSizesRelationInput"]: GraphQLTypes["ProductConnectOrCreateRecommendedDogSizesRelationInput"];
	["DogConnectOrCreateFedProductRelationInput"]: GraphQLTypes["DogConnectOrCreateFedProductRelationInput"];
	["ItemSubCategoryConnectOrCreateDogsRelationInput"]: GraphQLTypes["ItemSubCategoryConnectOrCreateDogsRelationInput"];
	["ItemDeclensionFourthVariantConnectOrCreateSubcategoryRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateSubcategoryRelationInput"];
	["ItemCategoryConnectOrCreateDeclensionsFourthRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateDeclensionsFourthRelationInput"];
	["ItemSubCategoryConnectOrCreateCategoryRelationInput"]: GraphQLTypes["ItemSubCategoryConnectOrCreateCategoryRelationInput"];
	["ProductFeatureConnectOrCreateDependentSubCategoryRelationInput"]: GraphQLTypes["ProductFeatureConnectOrCreateDependentSubCategoryRelationInput"];
	["ProductFeatureCreateDependentFlagEntityRelationInput"]: GraphQLTypes["ProductFeatureCreateDependentFlagEntityRelationInput"];
	["ProductFlagWithoutProductFeaturesCreateInput"]: GraphQLTypes["ProductFlagWithoutProductFeaturesCreateInput"];
	["ProductFlagCreateProductsEntityRelationInput"]: GraphQLTypes["ProductFlagCreateProductsEntityRelationInput"];
	["ProductFlagOfProductWithoutFlagCreateInput"]: GraphQLTypes["ProductFlagOfProductWithoutFlagCreateInput"];
	["ProductFlagOfProductCreateProductEntityRelationInput"]: GraphQLTypes["ProductFlagOfProductCreateProductEntityRelationInput"];
	["ProductWithoutFlagsCreateInput"]: GraphQLTypes["ProductWithoutFlagsCreateInput"];
	["ProductFlagOfProductConnectOrCreateProductRelationInput"]: GraphQLTypes["ProductFlagOfProductConnectOrCreateProductRelationInput"];
	["ProductFlagConnectOrCreateProductsRelationInput"]: GraphQLTypes["ProductFlagConnectOrCreateProductsRelationInput"];
	["ProductFeatureConnectOrCreateDependentFlagRelationInput"]: GraphQLTypes["ProductFeatureConnectOrCreateDependentFlagRelationInput"];
	["ItemCategoryConnectOrCreateFeatureDependenciesRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateFeatureDependenciesRelationInput"];
	["RedirectConnectOrCreateItemCategoryRelationInput"]: GraphQLTypes["RedirectConnectOrCreateItemCategoryRelationInput"];
	["BrandsPageConnectOrCreateRedirectsRelationInput"]: GraphQLTypes["BrandsPageConnectOrCreateRedirectsRelationInput"];
	["SeoConnectOrCreateBrandsPageRelationInput"]: GraphQLTypes["SeoConnectOrCreateBrandsPageRelationInput"];
	["BlogPostConnectOrCreateSeoRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateSeoRelationInput"];
	["BlogPostCreateRedirectsEntityRelationInput"]: GraphQLTypes["BlogPostCreateRedirectsEntityRelationInput"];
	["RedirectWithoutBlogPostCreateInput"]: GraphQLTypes["RedirectWithoutBlogPostCreateInput"];
	["BlogPostConnectOrCreateRedirectsRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateRedirectsRelationInput"];
	["AdConnectOrCreateBlogPostsRelationInput"]: GraphQLTypes["AdConnectOrCreateBlogPostsRelationInput"];
	["AdCreateBrandsEntityRelationInput"]: GraphQLTypes["AdCreateBrandsEntityRelationInput"];
	["BrandWithoutAdsCreateInput"]: GraphQLTypes["BrandWithoutAdsCreateInput"];
	["AdConnectOrCreateBrandsRelationInput"]: GraphQLTypes["AdConnectOrCreateBrandsRelationInput"];
	["ItemCategoryConnectOrCreateAdsRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateAdsRelationInput"];
	["ProductFeatureConnectOrCreateDependentCategoryRelationInput"]: GraphQLTypes["ProductFeatureConnectOrCreateDependentCategoryRelationInput"];
	["ElementConnectOrCreateFeatureDependenciesRelationInput"]: GraphQLTypes["ElementConnectOrCreateFeatureDependenciesRelationInput"];
	["ElementOfProductConnectOrCreateElementRelationInput"]: GraphQLTypes["ElementOfProductConnectOrCreateElementRelationInput"];
	["ProductConnectOrCreateElementsRelationInput"]: GraphQLTypes["ProductConnectOrCreateElementsRelationInput"];
	["ItemCategoryConnectOrCreateProductsRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateProductsRelationInput"];
	["AdConnectOrCreateItemCategoriesRelationInput"]: GraphQLTypes["AdConnectOrCreateItemCategoriesRelationInput"];
	["BlogPostConnectOrCreateAdsRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateAdsRelationInput"];
	["UserConnectOrCreateBlogPostsRelationInput"]: GraphQLTypes["UserConnectOrCreateBlogPostsRelationInput"];
	["UserCreateAvatarEntityRelationInput"]: GraphQLTypes["UserCreateAvatarEntityRelationInput"];
	["UserConnectOrCreateAvatarRelationInput"]: GraphQLTypes["UserConnectOrCreateAvatarRelationInput"];
	["UserCreateContactFormMessagesEntityRelationInput"]: GraphQLTypes["UserCreateContactFormMessagesEntityRelationInput"];
	["ContactFormMessageWithoutUserCreateInput"]: GraphQLTypes["ContactFormMessageWithoutUserCreateInput"];
	["UserConnectOrCreateContactFormMessagesRelationInput"]: GraphQLTypes["UserConnectOrCreateContactFormMessagesRelationInput"];
	["UserCreateBugReportsEntityRelationInput"]: GraphQLTypes["UserCreateBugReportsEntityRelationInput"];
	["BugReportWithoutUserCreateInput"]: GraphQLTypes["BugReportWithoutUserCreateInput"];
	["UserConnectOrCreateBugReportsRelationInput"]: GraphQLTypes["UserConnectOrCreateBugReportsRelationInput"];
	["UserCreateProtectedActionsEntityRelationInput"]: GraphQLTypes["UserCreateProtectedActionsEntityRelationInput"];
	["ProtectedActionWithoutUserCreateInput"]: GraphQLTypes["ProtectedActionWithoutUserCreateInput"];
	["UserConnectOrCreateProtectedActionsRelationInput"]: GraphQLTypes["UserConnectOrCreateProtectedActionsRelationInput"];
	["UserCreateTenantPersonEntityRelationInput"]: GraphQLTypes["UserCreateTenantPersonEntityRelationInput"];
	["ProductReviewConnectOrCreateUserRelationInput"]: GraphQLTypes["ProductReviewConnectOrCreateUserRelationInput"];
	["ProductReviewReactionConnectOrCreateProductReviewRelationInput"]: GraphQLTypes["ProductReviewReactionConnectOrCreateProductReviewRelationInput"];
	["UserConnectOrCreateProductReviewReactionsRelationInput"]: GraphQLTypes["UserConnectOrCreateProductReviewReactionsRelationInput"];
	["BlogPostReviewConnectOrCreateUserRelationInput"]: GraphQLTypes["BlogPostReviewConnectOrCreateUserRelationInput"];
	["BlogPostReviewReactionConnectOrCreateBlogPostReviewRelationInput"]: GraphQLTypes["BlogPostReviewReactionConnectOrCreateBlogPostReviewRelationInput"];
	["UserConnectOrCreateBlogPostReviewReactionsRelationInput"]: GraphQLTypes["UserConnectOrCreateBlogPostReviewReactionsRelationInput"];
	["BlogPostConnectOrCreateUserRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateUserRelationInput"];
	["ItemConnectOrCreateBlogPostRelationInput"]: GraphQLTypes["ItemConnectOrCreateBlogPostRelationInput"];
	["ItemCategoryConnectOrCreateItemsRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateItemsRelationInput"];
	["ProductConnectOrCreateItemCategoriesRelationInput"]: GraphQLTypes["ProductConnectOrCreateItemCategoriesRelationInput"];
	["NutritionalValueOfProductConnectOrCreateProductRelationInput"]: GraphQLTypes["NutritionalValueOfProductConnectOrCreateProductRelationInput"];
	["NutritionalValueConnectOrCreateProductsRelationInput"]: GraphQLTypes["NutritionalValueConnectOrCreateProductsRelationInput"];
	["NutritionalValueCreateIconEntityRelationInput"]: GraphQLTypes["NutritionalValueCreateIconEntityRelationInput"];
	["NutritionalValueConnectOrCreateIconRelationInput"]: GraphQLTypes["NutritionalValueConnectOrCreateIconRelationInput"];
	["SuitabilityItemConnectOrCreateNutritionalValueRelationInput"]: GraphQLTypes["SuitabilityItemConnectOrCreateNutritionalValueRelationInput"];
	["SuitabilityItemCreateCategoryEntityRelationInput"]: GraphQLTypes["SuitabilityItemCreateCategoryEntityRelationInput"];
	["SuitabilityCategoryWithoutSuitabilityItemsCreateInput"]: GraphQLTypes["SuitabilityCategoryWithoutSuitabilityItemsCreateInput"];
	["SuitabilityItemConnectOrCreateCategoryRelationInput"]: GraphQLTypes["SuitabilityItemConnectOrCreateCategoryRelationInput"];
	["ElementConnectOrCreateSuitabilityElementsRelationInput"]: GraphQLTypes["ElementConnectOrCreateSuitabilityElementsRelationInput"];
	["ProductFeatureConnectOrCreateDependentElementRelationInput"]: GraphQLTypes["ProductFeatureConnectOrCreateDependentElementRelationInput"];
	["ItemConnectOrCreateFeaturesOfProductRelationInput"]: GraphQLTypes["ItemConnectOrCreateFeaturesOfProductRelationInput"];
	["BlogPostConnectOrCreateItemsRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateItemsRelationInput"];
	["ItemCategoryConnectOrCreateBlogPostsRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateBlogPostsRelationInput"];
	["ItemConnectOrCreateCategoriesRelationInput"]: GraphQLTypes["ItemConnectOrCreateCategoriesRelationInput"];
	["ProductFeatureConnectOrCreateLinkItemRelationInput"]: GraphQLTypes["ProductFeatureConnectOrCreateLinkItemRelationInput"];
	["ItemSubCategoryConnectOrCreateFeatureDependenciesRelationInput"]: GraphQLTypes["ItemSubCategoryConnectOrCreateFeatureDependenciesRelationInput"];
	["ProductConnectOrCreateItemSubCategoriesRelationInput"]: GraphQLTypes["ProductConnectOrCreateItemSubCategoriesRelationInput"];
	["DogActivityConnectOrCreateProductsRelationInput"]: GraphQLTypes["DogActivityConnectOrCreateProductsRelationInput"];
	["DogConnectOrCreateActivityRelationInput"]: GraphQLTypes["DogConnectOrCreateActivityRelationInput"];
	["BreedConnectOrCreateDogsRelationInput"]: GraphQLTypes["BreedConnectOrCreateDogsRelationInput"];
	["AgeConnectOrCreateBreedsRelationInput"]: GraphQLTypes["AgeConnectOrCreateBreedsRelationInput"];
	["DogConnectOrCreateAgeRelationInput"]: GraphQLTypes["DogConnectOrCreateAgeRelationInput"];
	["ProductConnectOrCreateDogsRelationInput"]: GraphQLTypes["ProductConnectOrCreateDogsRelationInput"];
	["ItemSubCategoryConnectOrCreateProductsRelationInput"]: GraphQLTypes["ItemSubCategoryConnectOrCreateProductsRelationInput"];
	["ItemConnectOrCreateSubCategoriesRelationInput"]: GraphQLTypes["ItemConnectOrCreateSubCategoriesRelationInput"];
	["BodyTagConnectOrCreateNegativeItemsRelationInput"]: GraphQLTypes["BodyTagConnectOrCreateNegativeItemsRelationInput"];
	["ItemConnectOrCreatePositiveForBodyTagsRelationInput"]: GraphQLTypes["ItemConnectOrCreatePositiveForBodyTagsRelationInput"];
	["ItemSubCategoryConnectOrCreateItemsRelationInput"]: GraphQLTypes["ItemSubCategoryConnectOrCreateItemsRelationInput"];
	["ItemCategoryConnectOrCreateSubCategoriesRelationInput"]: GraphQLTypes["ItemCategoryConnectOrCreateSubCategoriesRelationInput"];
	["BlogPostConnectOrCreateItemCategoriesRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateItemCategoriesRelationInput"];
	["BlogPostTagConnectOrCreateBlogPostsRelationInput"]: GraphQLTypes["BlogPostTagConnectOrCreateBlogPostsRelationInput"];
	["ColorConnectOrCreateBlogPostTagRelationInput"]: GraphQLTypes["ColorConnectOrCreateBlogPostTagRelationInput"];
	["ColorCreateItemFlavorCategoriesEntityRelationInput"]: GraphQLTypes["ColorCreateItemFlavorCategoriesEntityRelationInput"];
	["ItemFlavorCategoryWithoutColorCreateInput"]: GraphQLTypes["ItemFlavorCategoryWithoutColorCreateInput"];
	["ItemFlavorCategoryCreateItemsEntityRelationInput"]: GraphQLTypes["ItemFlavorCategoryCreateItemsEntityRelationInput"];
	["ItemSubCategoryWithoutFlavorCategoryCreateInput"]: GraphQLTypes["ItemSubCategoryWithoutFlavorCategoryCreateInput"];
	["ItemFlavorCategoryConnectOrCreateItemsRelationInput"]: GraphQLTypes["ItemFlavorCategoryConnectOrCreateItemsRelationInput"];
	["ColorConnectOrCreateItemFlavorCategoriesRelationInput"]: GraphQLTypes["ColorConnectOrCreateItemFlavorCategoriesRelationInput"];
	["BodyTagCategoryConnectOrCreateColorRelationInput"]: GraphQLTypes["BodyTagCategoryConnectOrCreateColorRelationInput"];
	["BodyTagConnectOrCreateCategoryRelationInput"]: GraphQLTypes["BodyTagConnectOrCreateCategoryRelationInput"];
	["ItemConnectOrCreateNegativeForBodyTagsRelationInput"]: GraphQLTypes["ItemConnectOrCreateNegativeForBodyTagsRelationInput"];
	["BodyTagConnectOrCreatePositiveItemsRelationInput"]: GraphQLTypes["BodyTagConnectOrCreatePositiveItemsRelationInput"];
	["ProductConnectOrCreateNegativeForBodyTagsRelationInput"]: GraphQLTypes["ProductConnectOrCreateNegativeForBodyTagsRelationInput"];
	["ProductReviewConnectOrCreateProductRelationInput"]: GraphQLTypes["ProductReviewConnectOrCreateProductRelationInput"];
	["UserConnectOrCreateProductReviewsRelationInput"]: GraphQLTypes["UserConnectOrCreateProductReviewsRelationInput"];
	["ProductReviewReactionConnectOrCreateUserRelationInput"]: GraphQLTypes["ProductReviewReactionConnectOrCreateUserRelationInput"];
	["ProductReviewConnectOrCreateProductReviewReactionsRelationInput"]: GraphQLTypes["ProductReviewConnectOrCreateProductReviewReactionsRelationInput"];
	["ProductConnectOrCreateReviewsRelationInput"]: GraphQLTypes["ProductConnectOrCreateReviewsRelationInput"];
	["BodyTagConnectOrCreateNegativeProductsRelationInput"]: GraphQLTypes["BodyTagConnectOrCreateNegativeProductsRelationInput"];
	["ProductConnectOrCreatePositiveForBodyTagsRelationInput"]: GraphQLTypes["ProductConnectOrCreatePositiveForBodyTagsRelationInput"];
	["ElementOfProductConnectOrCreateProductRelationInput"]: GraphQLTypes["ElementOfProductConnectOrCreateProductRelationInput"];
	["ElementConnectOrCreateProductsRelationInput"]: GraphQLTypes["ElementConnectOrCreateProductsRelationInput"];
	["SuitabilityItemConnectOrCreateElementRelationInput"]: GraphQLTypes["SuitabilityItemConnectOrCreateElementRelationInput"];
	["NutritionalValueConnectOrCreateSuitabilityNutritionalValuesRelationInput"]: GraphQLTypes["NutritionalValueConnectOrCreateSuitabilityNutritionalValuesRelationInput"];
	["NutritionalValueOfProductConnectOrCreateNutritionalValueRelationInput"]: GraphQLTypes["NutritionalValueOfProductConnectOrCreateNutritionalValueRelationInput"];
	["ProductConnectOrCreateNutritionalValuesRelationInput"]: GraphQLTypes["ProductConnectOrCreateNutritionalValuesRelationInput"];
	["BodyTagConnectOrCreatePositiveProductsRelationInput"]: GraphQLTypes["BodyTagConnectOrCreatePositiveProductsRelationInput"];
	["BlogPostConnectOrCreateTagsRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateTagsRelationInput"];
	["BlogPostReviewConnectOrCreateBlogPostRelationInput"]: GraphQLTypes["BlogPostReviewConnectOrCreateBlogPostRelationInput"];
	["UserConnectOrCreateBlogPostReviewsRelationInput"]: GraphQLTypes["UserConnectOrCreateBlogPostReviewsRelationInput"];
	["DogConnectOrCreateOwnerRelationInput"]: GraphQLTypes["DogConnectOrCreateOwnerRelationInput"];
	["AgeConnectOrCreateDogsRelationInput"]: GraphQLTypes["AgeConnectOrCreateDogsRelationInput"];
	["BreedConnectOrCreateAgesRelationInput"]: GraphQLTypes["BreedConnectOrCreateAgesRelationInput"];
	["DogConnectOrCreateBreedRelationInput"]: GraphQLTypes["DogConnectOrCreateBreedRelationInput"];
	["UserConnectOrCreateDogsRelationInput"]: GraphQLTypes["UserConnectOrCreateDogsRelationInput"];
	["BlogPostReviewReactionConnectOrCreateUserRelationInput"]: GraphQLTypes["BlogPostReviewReactionConnectOrCreateUserRelationInput"];
	["BlogPostReviewConnectOrCreateBlogPostReviewReactionsRelationInput"]: GraphQLTypes["BlogPostReviewConnectOrCreateBlogPostReviewReactionsRelationInput"];
	["BlogPostConnectOrCreateReviewsRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateReviewsRelationInput"];
	["BodyTagConnectOrCreateBlogPostsRelationInput"]: GraphQLTypes["BodyTagConnectOrCreateBlogPostsRelationInput"];
	["BodyTagCategoryConnectOrCreateTagsRelationInput"]: GraphQLTypes["BodyTagCategoryConnectOrCreateTagsRelationInput"];
	["ColorConnectOrCreateBodyTagCategoryRelationInput"]: GraphQLTypes["ColorConnectOrCreateBodyTagCategoryRelationInput"];
	["BlogPostTagConnectOrCreateColorRelationInput"]: GraphQLTypes["BlogPostTagConnectOrCreateColorRelationInput"];
	["BlogPostConnectOrCreateBlogPostTagsRelationInput"]: GraphQLTypes["BlogPostConnectOrCreateBlogPostTagsRelationInput"];
	["ContentReferenceConnectOrCreateRelatedBlogPostRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateRelatedBlogPostRelationInput"];
	["ContentReferenceCreateAdEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateAdEntityRelationInput"];
	["AdWithoutContentReferencesCreateInput"]: GraphQLTypes["AdWithoutContentReferencesCreateInput"];
	["ContentReferenceConnectOrCreateAdRelationInput"]: GraphQLTypes["ContentReferenceConnectOrCreateAdRelationInput"];
	["ContentBlockConnectOrCreateReferencesRelationInput"]: GraphQLTypes["ContentBlockConnectOrCreateReferencesRelationInput"];
	["ContentConnectOrCreateBlocksRelationInput"]: GraphQLTypes["ContentConnectOrCreateBlocksRelationInput"];
	["BlogPageConnectOrCreateContentRelationInput"]: GraphQLTypes["BlogPageConnectOrCreateContentRelationInput"];
	["SeoConnectOrCreateBlogPageRelationInput"]: GraphQLTypes["SeoConnectOrCreateBlogPageRelationInput"];
	["GenericPageConnectOrCreateSeoRelationInput"]: GraphQLTypes["GenericPageConnectOrCreateSeoRelationInput"];
	["RedirectConnectOrCreateGenericPageRelationInput"]: GraphQLTypes["RedirectConnectOrCreateGenericPageRelationInput"];
	["BlogPageConnectOrCreateRedirectsRelationInput"]: GraphQLTypes["BlogPageConnectOrCreateRedirectsRelationInput"];
	["BlogPageUpdateInput"]: GraphQLTypes["BlogPageUpdateInput"];
	["BlogPageUpdateRedirectsEntityRelationInput"]: GraphQLTypes["BlogPageUpdateRedirectsEntityRelationInput"];
	["BlogPageUpdateRedirectsRelationInput"]: GraphQLTypes["BlogPageUpdateRedirectsRelationInput"];
	["RedirectWithoutBlogPageUpdateInput"]: GraphQLTypes["RedirectWithoutBlogPageUpdateInput"];
	["RedirectUpdateGenericPageEntityRelationInput"]: GraphQLTypes["RedirectUpdateGenericPageEntityRelationInput"];
	["GenericPageWithoutRedirectsUpdateInput"]: GraphQLTypes["GenericPageWithoutRedirectsUpdateInput"];
	["GenericPageUpdateLinkEntityRelationInput"]: GraphQLTypes["GenericPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutGenericPageUpdateInput"]: GraphQLTypes["LinkableWithoutGenericPageUpdateInput"];
	["GenericPageUpsertLinkRelationInput"]: GraphQLTypes["GenericPageUpsertLinkRelationInput"];
	["GenericPageUpdateSeoEntityRelationInput"]: GraphQLTypes["GenericPageUpdateSeoEntityRelationInput"];
	["SeoWithoutGenericPageUpdateInput"]: GraphQLTypes["SeoWithoutGenericPageUpdateInput"];
	["SeoUpdateOgImageEntityRelationInput"]: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"];
	["ImageUpdateInput"]: GraphQLTypes["ImageUpdateInput"];
	["SeoUpsertOgImageRelationInput"]: GraphQLTypes["SeoUpsertOgImageRelationInput"];
	["SeoUpdateBlogPageEntityRelationInput"]: GraphQLTypes["SeoUpdateBlogPageEntityRelationInput"];
	["BlogPageWithoutSeoUpdateInput"]: GraphQLTypes["BlogPageWithoutSeoUpdateInput"];
	["BlogPageUpdateContentEntityRelationInput"]: GraphQLTypes["BlogPageUpdateContentEntityRelationInput"];
	["ContentUpdateInput"]: GraphQLTypes["ContentUpdateInput"];
	["ContentUpdateBlocksEntityRelationInput"]: GraphQLTypes["ContentUpdateBlocksEntityRelationInput"];
	["ContentUpdateBlocksRelationInput"]: GraphQLTypes["ContentUpdateBlocksRelationInput"];
	["ContentBlockWithoutContentUpdateInput"]: GraphQLTypes["ContentBlockWithoutContentUpdateInput"];
	["ContentBlockUpdateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"];
	["ContentBlockUpdateReferencesRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"];
	["ContentReferenceWithoutBlockUpdateInput"]: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"];
	["ContentReferenceUpdateImagesEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"];
	["ContentReferenceUpdateImagesRelationInput"]: GraphQLTypes["ContentReferenceUpdateImagesRelationInput"];
	["ContentReferenceGalleryImageWithoutReferenceUpdateInput"]: GraphQLTypes["ContentReferenceGalleryImageWithoutReferenceUpdateInput"];
	["ContentReferenceGalleryImageUpdateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceGalleryImageUpdateImageEntityRelationInput"];
	["ContentReferenceGalleryImageUpsertImageRelationInput"]: GraphQLTypes["ContentReferenceGalleryImageUpsertImageRelationInput"];
	["ContentReferenceUpsertImagesRelationInput"]: GraphQLTypes["ContentReferenceUpsertImagesRelationInput"];
	["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"];
	["BlogPostUpdateInput"]: GraphQLTypes["BlogPostUpdateInput"];
	["BlogPostUpdateBlogPostTagsEntityRelationInput"]: GraphQLTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"];
	["BlogPostUpdateBlogPostTagsRelationInput"]: GraphQLTypes["BlogPostUpdateBlogPostTagsRelationInput"];
	["BlogPostTagWithoutBlogPostsUpdateInput"]: GraphQLTypes["BlogPostTagWithoutBlogPostsUpdateInput"];
	["BlogPostTagUpdateColorEntityRelationInput"]: GraphQLTypes["BlogPostTagUpdateColorEntityRelationInput"];
	["ColorWithoutBlogPostTagUpdateInput"]: GraphQLTypes["ColorWithoutBlogPostTagUpdateInput"];
	["ColorUpdateBodyTagCategoryEntityRelationInput"]: GraphQLTypes["ColorUpdateBodyTagCategoryEntityRelationInput"];
	["BodyTagCategoryWithoutColorUpdateInput"]: GraphQLTypes["BodyTagCategoryWithoutColorUpdateInput"];
	["BodyTagCategoryUpdateTagsEntityRelationInput"]: GraphQLTypes["BodyTagCategoryUpdateTagsEntityRelationInput"];
	["BodyTagCategoryUpdateTagsRelationInput"]: GraphQLTypes["BodyTagCategoryUpdateTagsRelationInput"];
	["BodyTagWithoutCategoryUpdateInput"]: GraphQLTypes["BodyTagWithoutCategoryUpdateInput"];
	["BodyTagUpdateBlogPostsEntityRelationInput"]: GraphQLTypes["BodyTagUpdateBlogPostsEntityRelationInput"];
	["BodyTagUpdateBlogPostsRelationInput"]: GraphQLTypes["BodyTagUpdateBlogPostsRelationInput"];
	["BlogPostWithoutTagsUpdateInput"]: GraphQLTypes["BlogPostWithoutTagsUpdateInput"];
	["BlogPostUpdateReviewsEntityRelationInput"]: GraphQLTypes["BlogPostUpdateReviewsEntityRelationInput"];
	["BlogPostUpdateReviewsRelationInput"]: GraphQLTypes["BlogPostUpdateReviewsRelationInput"];
	["BlogPostReviewWithoutBlogPostUpdateInput"]: GraphQLTypes["BlogPostReviewWithoutBlogPostUpdateInput"];
	["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"]: GraphQLTypes["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"];
	["BlogPostReviewUpdateBlogPostReviewReactionsRelationInput"]: GraphQLTypes["BlogPostReviewUpdateBlogPostReviewReactionsRelationInput"];
	["BlogPostReviewReactionWithoutBlogPostReviewUpdateInput"]: GraphQLTypes["BlogPostReviewReactionWithoutBlogPostReviewUpdateInput"];
	["BlogPostReviewReactionUpdateUserEntityRelationInput"]: GraphQLTypes["BlogPostReviewReactionUpdateUserEntityRelationInput"];
	["UserWithoutBlogPostReviewReactionsUpdateInput"]: GraphQLTypes["UserWithoutBlogPostReviewReactionsUpdateInput"];
	["UserUpdateDogsEntityRelationInput"]: GraphQLTypes["UserUpdateDogsEntityRelationInput"];
	["UserUpdateDogsRelationInput"]: GraphQLTypes["UserUpdateDogsRelationInput"];
	["DogWithoutOwnerUpdateInput"]: GraphQLTypes["DogWithoutOwnerUpdateInput"];
	["DogUpdateBreedEntityRelationInput"]: GraphQLTypes["DogUpdateBreedEntityRelationInput"];
	["BreedWithoutDogsUpdateInput"]: GraphQLTypes["BreedWithoutDogsUpdateInput"];
	["BreedUpdateReviewsEntityRelationInput"]: GraphQLTypes["BreedUpdateReviewsEntityRelationInput"];
	["BreedUpdateReviewsRelationInput"]: GraphQLTypes["BreedUpdateReviewsRelationInput"];
	["ReviewWithoutDogBreedsUpdateInput"]: GraphQLTypes["ReviewWithoutDogBreedsUpdateInput"];
	["BreedUpsertReviewsRelationInput"]: GraphQLTypes["BreedUpsertReviewsRelationInput"];
	["BreedUpdateAgesEntityRelationInput"]: GraphQLTypes["BreedUpdateAgesEntityRelationInput"];
	["BreedUpdateAgesRelationInput"]: GraphQLTypes["BreedUpdateAgesRelationInput"];
	["AgeWithoutBreedsUpdateInput"]: GraphQLTypes["AgeWithoutBreedsUpdateInput"];
	["AgeUpdateDogsEntityRelationInput"]: GraphQLTypes["AgeUpdateDogsEntityRelationInput"];
	["AgeUpdateDogsRelationInput"]: GraphQLTypes["AgeUpdateDogsRelationInput"];
	["DogWithoutAgeUpdateInput"]: GraphQLTypes["DogWithoutAgeUpdateInput"];
	["DogUpdateBodyTypeEntityRelationInput"]: GraphQLTypes["DogUpdateBodyTypeEntityRelationInput"];
	["DogBodyTypeWithoutDogsUpdateInput"]: GraphQLTypes["DogBodyTypeWithoutDogsUpdateInput"];
	["DogBodyTypeUpdateCategoryEntityRelationInput"]: GraphQLTypes["DogBodyTypeUpdateCategoryEntityRelationInput"];
	["DogBodyTypeCategoryWithoutItemsUpdateInput"]: GraphQLTypes["DogBodyTypeCategoryWithoutItemsUpdateInput"];
	["DogBodyTypeCategoryUpdateImageMainEntityRelationInput"]: GraphQLTypes["DogBodyTypeCategoryUpdateImageMainEntityRelationInput"];
	["DogBodyTypeCategoryUpsertImageMainRelationInput"]: GraphQLTypes["DogBodyTypeCategoryUpsertImageMainRelationInput"];
	["DogBodyTypeUpsertCategoryRelationInput"]: GraphQLTypes["DogBodyTypeUpsertCategoryRelationInput"];
	["DogBodyTypeUpdateImageMainEntityRelationInput"]: GraphQLTypes["DogBodyTypeUpdateImageMainEntityRelationInput"];
	["DogBodyTypeUpsertImageMainRelationInput"]: GraphQLTypes["DogBodyTypeUpsertImageMainRelationInput"];
	["DogBodyTypeUpdateImageFromEntityRelationInput"]: GraphQLTypes["DogBodyTypeUpdateImageFromEntityRelationInput"];
	["DogBodyTypeUpsertImageFromRelationInput"]: GraphQLTypes["DogBodyTypeUpsertImageFromRelationInput"];
	["DogBodyTypeUpdateImageToEntityRelationInput"]: GraphQLTypes["DogBodyTypeUpdateImageToEntityRelationInput"];
	["DogBodyTypeUpsertImageToRelationInput"]: GraphQLTypes["DogBodyTypeUpsertImageToRelationInput"];
	["DogUpsertBodyTypeRelationInput"]: GraphQLTypes["DogUpsertBodyTypeRelationInput"];
	["DogUpdateOwnerEntityRelationInput"]: GraphQLTypes["DogUpdateOwnerEntityRelationInput"];
	["UserWithoutDogsUpdateInput"]: GraphQLTypes["UserWithoutDogsUpdateInput"];
	["UserUpdateVeterinaryEntityRelationInput"]: GraphQLTypes["UserUpdateVeterinaryEntityRelationInput"];
	["VeterinaryWithoutUserUpdateInput"]: GraphQLTypes["VeterinaryWithoutUserUpdateInput"];
	["UserUpsertVeterinaryRelationInput"]: GraphQLTypes["UserUpsertVeterinaryRelationInput"];
	["UserUpdateBlogPostReviewsEntityRelationInput"]: GraphQLTypes["UserUpdateBlogPostReviewsEntityRelationInput"];
	["UserUpdateBlogPostReviewsRelationInput"]: GraphQLTypes["UserUpdateBlogPostReviewsRelationInput"];
	["BlogPostReviewWithoutUserUpdateInput"]: GraphQLTypes["BlogPostReviewWithoutUserUpdateInput"];
	["BlogPostReviewUpdateBlogPostEntityRelationInput"]: GraphQLTypes["BlogPostReviewUpdateBlogPostEntityRelationInput"];
	["BlogPostWithoutReviewsUpdateInput"]: GraphQLTypes["BlogPostWithoutReviewsUpdateInput"];
	["BlogPostUpdateTagsEntityRelationInput"]: GraphQLTypes["BlogPostUpdateTagsEntityRelationInput"];
	["BlogPostUpdateTagsRelationInput"]: GraphQLTypes["BlogPostUpdateTagsRelationInput"];
	["BodyTagWithoutBlogPostsUpdateInput"]: GraphQLTypes["BodyTagWithoutBlogPostsUpdateInput"];
	["BodyTagUpdatePositiveProductsEntityRelationInput"]: GraphQLTypes["BodyTagUpdatePositiveProductsEntityRelationInput"];
	["BodyTagUpdatePositiveProductsRelationInput"]: GraphQLTypes["BodyTagUpdatePositiveProductsRelationInput"];
	["ProductWithoutPositiveForBodyTagsUpdateInput"]: GraphQLTypes["ProductWithoutPositiveForBodyTagsUpdateInput"];
	["ProductUpdateNutritionalValuesEntityRelationInput"]: GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"];
	["ProductUpdateNutritionalValuesRelationInput"]: GraphQLTypes["ProductUpdateNutritionalValuesRelationInput"];
	["NutritionalValueOfProductWithoutProductUpdateInput"]: GraphQLTypes["NutritionalValueOfProductWithoutProductUpdateInput"];
	["NutritionalValueOfProductUpdateNutritionalValueEntityRelationInput"]: GraphQLTypes["NutritionalValueOfProductUpdateNutritionalValueEntityRelationInput"];
	["NutritionalValueWithoutProductsUpdateInput"]: GraphQLTypes["NutritionalValueWithoutProductsUpdateInput"];
	["NutritionalValueUpdateSuitabilityNutritionalValuesEntityRelationInput"]: GraphQLTypes["NutritionalValueUpdateSuitabilityNutritionalValuesEntityRelationInput"];
	["NutritionalValueUpdateSuitabilityNutritionalValuesRelationInput"]: GraphQLTypes["NutritionalValueUpdateSuitabilityNutritionalValuesRelationInput"];
	["SuitabilityItemWithoutNutritionalValueUpdateInput"]: GraphQLTypes["SuitabilityItemWithoutNutritionalValueUpdateInput"];
	["SuitabilityItemUpdateElementEntityRelationInput"]: GraphQLTypes["SuitabilityItemUpdateElementEntityRelationInput"];
	["ElementWithoutSuitabilityElementsUpdateInput"]: GraphQLTypes["ElementWithoutSuitabilityElementsUpdateInput"];
	["ElementUpdateProductsEntityRelationInput"]: GraphQLTypes["ElementUpdateProductsEntityRelationInput"];
	["ElementUpdateProductsRelationInput"]: GraphQLTypes["ElementUpdateProductsRelationInput"];
	["ElementOfProductWithoutElementUpdateInput"]: GraphQLTypes["ElementOfProductWithoutElementUpdateInput"];
	["ElementOfProductUpdateProductEntityRelationInput"]: GraphQLTypes["ElementOfProductUpdateProductEntityRelationInput"];
	["ProductWithoutElementsUpdateInput"]: GraphQLTypes["ProductWithoutElementsUpdateInput"];
	["ProductUpdatePositiveForBodyTagsEntityRelationInput"]: GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"];
	["ProductUpdatePositiveForBodyTagsRelationInput"]: GraphQLTypes["ProductUpdatePositiveForBodyTagsRelationInput"];
	["BodyTagWithoutPositiveProductsUpdateInput"]: GraphQLTypes["BodyTagWithoutPositiveProductsUpdateInput"];
	["BodyTagUpdateNegativeProductsEntityRelationInput"]: GraphQLTypes["BodyTagUpdateNegativeProductsEntityRelationInput"];
	["BodyTagUpdateNegativeProductsRelationInput"]: GraphQLTypes["BodyTagUpdateNegativeProductsRelationInput"];
	["ProductWithoutNegativeForBodyTagsUpdateInput"]: GraphQLTypes["ProductWithoutNegativeForBodyTagsUpdateInput"];
	["ProductUpdateReviewsEntityRelationInput"]: GraphQLTypes["ProductUpdateReviewsEntityRelationInput"];
	["ProductUpdateReviewsRelationInput"]: GraphQLTypes["ProductUpdateReviewsRelationInput"];
	["ProductReviewWithoutProductUpdateInput"]: GraphQLTypes["ProductReviewWithoutProductUpdateInput"];
	["ProductReviewUpdateProductReviewReactionsEntityRelationInput"]: GraphQLTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"];
	["ProductReviewUpdateProductReviewReactionsRelationInput"]: GraphQLTypes["ProductReviewUpdateProductReviewReactionsRelationInput"];
	["ProductReviewReactionWithoutProductReviewUpdateInput"]: GraphQLTypes["ProductReviewReactionWithoutProductReviewUpdateInput"];
	["ProductReviewReactionUpdateUserEntityRelationInput"]: GraphQLTypes["ProductReviewReactionUpdateUserEntityRelationInput"];
	["UserWithoutProductReviewReactionsUpdateInput"]: GraphQLTypes["UserWithoutProductReviewReactionsUpdateInput"];
	["UserUpdateProductReviewsEntityRelationInput"]: GraphQLTypes["UserUpdateProductReviewsEntityRelationInput"];
	["UserUpdateProductReviewsRelationInput"]: GraphQLTypes["UserUpdateProductReviewsRelationInput"];
	["ProductReviewWithoutUserUpdateInput"]: GraphQLTypes["ProductReviewWithoutUserUpdateInput"];
	["ProductReviewUpdateScoreEntityRelationInput"]: GraphQLTypes["ProductReviewUpdateScoreEntityRelationInput"];
	["ScoreWithoutProductReviewsUpdateInput"]: GraphQLTypes["ScoreWithoutProductReviewsUpdateInput"];
	["ProductReviewUpsertScoreRelationInput"]: GraphQLTypes["ProductReviewUpsertScoreRelationInput"];
	["ProductReviewUpdateProductEntityRelationInput"]: GraphQLTypes["ProductReviewUpdateProductEntityRelationInput"];
	["ProductWithoutReviewsUpdateInput"]: GraphQLTypes["ProductWithoutReviewsUpdateInput"];
	["ProductUpdateNegativeForBodyTagsEntityRelationInput"]: GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"];
	["ProductUpdateNegativeForBodyTagsRelationInput"]: GraphQLTypes["ProductUpdateNegativeForBodyTagsRelationInput"];
	["BodyTagWithoutNegativeProductsUpdateInput"]: GraphQLTypes["BodyTagWithoutNegativeProductsUpdateInput"];
	["BodyTagUpdatePositiveItemsEntityRelationInput"]: GraphQLTypes["BodyTagUpdatePositiveItemsEntityRelationInput"];
	["BodyTagUpdatePositiveItemsRelationInput"]: GraphQLTypes["BodyTagUpdatePositiveItemsRelationInput"];
	["ItemWithoutPositiveForBodyTagsUpdateInput"]: GraphQLTypes["ItemWithoutPositiveForBodyTagsUpdateInput"];
	["ItemUpdateNegativeForBodyTagsEntityRelationInput"]: GraphQLTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"];
	["ItemUpdateNegativeForBodyTagsRelationInput"]: GraphQLTypes["ItemUpdateNegativeForBodyTagsRelationInput"];
	["BodyTagWithoutNegativeItemsUpdateInput"]: GraphQLTypes["BodyTagWithoutNegativeItemsUpdateInput"];
	["BodyTagUpdateCategoryEntityRelationInput"]: GraphQLTypes["BodyTagUpdateCategoryEntityRelationInput"];
	["BodyTagCategoryWithoutTagsUpdateInput"]: GraphQLTypes["BodyTagCategoryWithoutTagsUpdateInput"];
	["BodyTagCategoryUpdateColorEntityRelationInput"]: GraphQLTypes["BodyTagCategoryUpdateColorEntityRelationInput"];
	["ColorWithoutBodyTagCategoryUpdateInput"]: GraphQLTypes["ColorWithoutBodyTagCategoryUpdateInput"];
	["ColorUpdateBlogPostTagEntityRelationInput"]: GraphQLTypes["ColorUpdateBlogPostTagEntityRelationInput"];
	["BlogPostTagWithoutColorUpdateInput"]: GraphQLTypes["BlogPostTagWithoutColorUpdateInput"];
	["BlogPostTagUpdateBlogPostsEntityRelationInput"]: GraphQLTypes["BlogPostTagUpdateBlogPostsEntityRelationInput"];
	["BlogPostTagUpdateBlogPostsRelationInput"]: GraphQLTypes["BlogPostTagUpdateBlogPostsRelationInput"];
	["BlogPostWithoutBlogPostTagsUpdateInput"]: GraphQLTypes["BlogPostWithoutBlogPostTagsUpdateInput"];
	["BlogPostUpdateItemCategoriesEntityRelationInput"]: GraphQLTypes["BlogPostUpdateItemCategoriesEntityRelationInput"];
	["BlogPostUpdateItemCategoriesRelationInput"]: GraphQLTypes["BlogPostUpdateItemCategoriesRelationInput"];
	["ItemCategoryWithoutBlogPostsUpdateInput"]: GraphQLTypes["ItemCategoryWithoutBlogPostsUpdateInput"];
	["ItemCategoryUpdateSubCategoriesEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"];
	["ItemCategoryUpdateSubCategoriesRelationInput"]: GraphQLTypes["ItemCategoryUpdateSubCategoriesRelationInput"];
	["ItemSubCategoryWithoutCategoryUpdateInput"]: GraphQLTypes["ItemSubCategoryWithoutCategoryUpdateInput"];
	["ItemSubCategoryUpdateItemsEntityRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateItemsEntityRelationInput"];
	["ItemSubCategoryUpdateItemsRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateItemsRelationInput"];
	["ItemWithoutSubCategoriesUpdateInput"]: GraphQLTypes["ItemWithoutSubCategoriesUpdateInput"];
	["ItemUpdatePositiveForBodyTagsEntityRelationInput"]: GraphQLTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"];
	["ItemUpdatePositiveForBodyTagsRelationInput"]: GraphQLTypes["ItemUpdatePositiveForBodyTagsRelationInput"];
	["BodyTagWithoutPositiveItemsUpdateInput"]: GraphQLTypes["BodyTagWithoutPositiveItemsUpdateInput"];
	["BodyTagUpdateNegativeItemsEntityRelationInput"]: GraphQLTypes["BodyTagUpdateNegativeItemsEntityRelationInput"];
	["BodyTagUpdateNegativeItemsRelationInput"]: GraphQLTypes["BodyTagUpdateNegativeItemsRelationInput"];
	["ItemWithoutNegativeForBodyTagsUpdateInput"]: GraphQLTypes["ItemWithoutNegativeForBodyTagsUpdateInput"];
	["ItemUpdateSubCategoriesEntityRelationInput"]: GraphQLTypes["ItemUpdateSubCategoriesEntityRelationInput"];
	["ItemUpdateSubCategoriesRelationInput"]: GraphQLTypes["ItemUpdateSubCategoriesRelationInput"];
	["ItemSubCategoryWithoutItemsUpdateInput"]: GraphQLTypes["ItemSubCategoryWithoutItemsUpdateInput"];
	["ItemSubCategoryUpdateProductsEntityRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateProductsEntityRelationInput"];
	["ItemSubCategoryUpdateProductsRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateProductsRelationInput"];
	["ProductWithoutItemSubCategoriesUpdateInput"]: GraphQLTypes["ProductWithoutItemSubCategoriesUpdateInput"];
	["ProductUpdateDogsEntityRelationInput"]: GraphQLTypes["ProductUpdateDogsEntityRelationInput"];
	["ProductUpdateDogsRelationInput"]: GraphQLTypes["ProductUpdateDogsRelationInput"];
	["DogWithoutFedProductUpdateInput"]: GraphQLTypes["DogWithoutFedProductUpdateInput"];
	["DogUpdateAgeEntityRelationInput"]: GraphQLTypes["DogUpdateAgeEntityRelationInput"];
	["AgeWithoutDogsUpdateInput"]: GraphQLTypes["AgeWithoutDogsUpdateInput"];
	["AgeUpdateBreedsEntityRelationInput"]: GraphQLTypes["AgeUpdateBreedsEntityRelationInput"];
	["AgeUpdateBreedsRelationInput"]: GraphQLTypes["AgeUpdateBreedsRelationInput"];
	["BreedWithoutAgesUpdateInput"]: GraphQLTypes["BreedWithoutAgesUpdateInput"];
	["BreedUpdateDogsEntityRelationInput"]: GraphQLTypes["BreedUpdateDogsEntityRelationInput"];
	["BreedUpdateDogsRelationInput"]: GraphQLTypes["BreedUpdateDogsRelationInput"];
	["DogWithoutBreedUpdateInput"]: GraphQLTypes["DogWithoutBreedUpdateInput"];
	["DogUpdateActivityEntityRelationInput"]: GraphQLTypes["DogUpdateActivityEntityRelationInput"];
	["DogActivityWithoutDogsUpdateInput"]: GraphQLTypes["DogActivityWithoutDogsUpdateInput"];
	["DogActivityUpdateProductsEntityRelationInput"]: GraphQLTypes["DogActivityUpdateProductsEntityRelationInput"];
	["DogActivityUpdateProductsRelationInput"]: GraphQLTypes["DogActivityUpdateProductsRelationInput"];
	["ProductWithoutRecommendedActivityUpdateInput"]: GraphQLTypes["ProductWithoutRecommendedActivityUpdateInput"];
	["ProductUpdatePackagingsEntityRelationInput"]: GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"];
	["ProductUpdatePackagingsRelationInput"]: GraphQLTypes["ProductUpdatePackagingsRelationInput"];
	["ProductPackageWithoutProductUpdateInput"]: GraphQLTypes["ProductPackageWithoutProductUpdateInput"];
	["ProductUpsertPackagingsRelationInput"]: GraphQLTypes["ProductUpsertPackagingsRelationInput"];
	["ProductUpdateItemSubCategoriesEntityRelationInput"]: GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"];
	["ProductUpdateItemSubCategoriesRelationInput"]: GraphQLTypes["ProductUpdateItemSubCategoriesRelationInput"];
	["ItemSubCategoryWithoutProductsUpdateInput"]: GraphQLTypes["ItemSubCategoryWithoutProductsUpdateInput"];
	["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"];
	["ItemSubCategoryUpdateFeatureDependenciesRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateFeatureDependenciesRelationInput"];
	["ProductFeatureWithoutDependentSubCategoryUpdateInput"]: GraphQLTypes["ProductFeatureWithoutDependentSubCategoryUpdateInput"];
	["ProductFeatureUpdateLinkItemEntityRelationInput"]: GraphQLTypes["ProductFeatureUpdateLinkItemEntityRelationInput"];
	["ItemWithoutFeaturesOfProductUpdateInput"]: GraphQLTypes["ItemWithoutFeaturesOfProductUpdateInput"];
	["ItemUpdateCategoriesEntityRelationInput"]: GraphQLTypes["ItemUpdateCategoriesEntityRelationInput"];
	["ItemUpdateCategoriesRelationInput"]: GraphQLTypes["ItemUpdateCategoriesRelationInput"];
	["ItemCategoryWithoutItemsUpdateInput"]: GraphQLTypes["ItemCategoryWithoutItemsUpdateInput"];
	["ItemCategoryUpdateBlogPostsEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"];
	["ItemCategoryUpdateBlogPostsRelationInput"]: GraphQLTypes["ItemCategoryUpdateBlogPostsRelationInput"];
	["BlogPostWithoutItemCategoriesUpdateInput"]: GraphQLTypes["BlogPostWithoutItemCategoriesUpdateInput"];
	["BlogPostUpdateItemsEntityRelationInput"]: GraphQLTypes["BlogPostUpdateItemsEntityRelationInput"];
	["BlogPostUpdateItemsRelationInput"]: GraphQLTypes["BlogPostUpdateItemsRelationInput"];
	["ItemWithoutBlogPostUpdateInput"]: GraphQLTypes["ItemWithoutBlogPostUpdateInput"];
	["ItemUpdateFeaturesOfProductEntityRelationInput"]: GraphQLTypes["ItemUpdateFeaturesOfProductEntityRelationInput"];
	["ItemUpdateFeaturesOfProductRelationInput"]: GraphQLTypes["ItemUpdateFeaturesOfProductRelationInput"];
	["ProductFeatureWithoutLinkItemUpdateInput"]: GraphQLTypes["ProductFeatureWithoutLinkItemUpdateInput"];
	["ProductFeatureUpdateDependentElementEntityRelationInput"]: GraphQLTypes["ProductFeatureUpdateDependentElementEntityRelationInput"];
	["ElementWithoutFeatureDependenciesUpdateInput"]: GraphQLTypes["ElementWithoutFeatureDependenciesUpdateInput"];
	["ElementUpdateSuitabilityElementsEntityRelationInput"]: GraphQLTypes["ElementUpdateSuitabilityElementsEntityRelationInput"];
	["ElementUpdateSuitabilityElementsRelationInput"]: GraphQLTypes["ElementUpdateSuitabilityElementsRelationInput"];
	["SuitabilityItemWithoutElementUpdateInput"]: GraphQLTypes["SuitabilityItemWithoutElementUpdateInput"];
	["SuitabilityItemUpdateNutritionalValueEntityRelationInput"]: GraphQLTypes["SuitabilityItemUpdateNutritionalValueEntityRelationInput"];
	["NutritionalValueWithoutSuitabilityNutritionalValuesUpdateInput"]: GraphQLTypes["NutritionalValueWithoutSuitabilityNutritionalValuesUpdateInput"];
	["NutritionalValueUpdateProductsEntityRelationInput"]: GraphQLTypes["NutritionalValueUpdateProductsEntityRelationInput"];
	["NutritionalValueUpdateProductsRelationInput"]: GraphQLTypes["NutritionalValueUpdateProductsRelationInput"];
	["NutritionalValueOfProductWithoutNutritionalValueUpdateInput"]: GraphQLTypes["NutritionalValueOfProductWithoutNutritionalValueUpdateInput"];
	["NutritionalValueOfProductUpdateProductEntityRelationInput"]: GraphQLTypes["NutritionalValueOfProductUpdateProductEntityRelationInput"];
	["ProductWithoutNutritionalValuesUpdateInput"]: GraphQLTypes["ProductWithoutNutritionalValuesUpdateInput"];
	["ProductUpdateItemCategoriesEntityRelationInput"]: GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"];
	["ProductUpdateItemCategoriesRelationInput"]: GraphQLTypes["ProductUpdateItemCategoriesRelationInput"];
	["ItemCategoryWithoutProductsUpdateInput"]: GraphQLTypes["ItemCategoryWithoutProductsUpdateInput"];
	["ItemCategoryUpdateItemsEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateItemsEntityRelationInput"];
	["ItemCategoryUpdateItemsRelationInput"]: GraphQLTypes["ItemCategoryUpdateItemsRelationInput"];
	["ItemWithoutCategoriesUpdateInput"]: GraphQLTypes["ItemWithoutCategoriesUpdateInput"];
	["ItemUpdateImageEntityRelationInput"]: GraphQLTypes["ItemUpdateImageEntityRelationInput"];
	["ItemUpsertImageRelationInput"]: GraphQLTypes["ItemUpsertImageRelationInput"];
	["ItemUpdateReferenceListEntityRelationInput"]: GraphQLTypes["ItemUpdateReferenceListEntityRelationInput"];
	["ReferenceListUpdateInput"]: GraphQLTypes["ReferenceListUpdateInput"];
	["ReferenceListUpdateReferencesEntityRelationInput"]: GraphQLTypes["ReferenceListUpdateReferencesEntityRelationInput"];
	["ReferenceListUpdateReferencesRelationInput"]: GraphQLTypes["ReferenceListUpdateReferencesRelationInput"];
	["ReferenceWithoutListUpdateInput"]: GraphQLTypes["ReferenceWithoutListUpdateInput"];
	["ReferenceListUpsertReferencesRelationInput"]: GraphQLTypes["ReferenceListUpsertReferencesRelationInput"];
	["ItemUpsertReferenceListRelationInput"]: GraphQLTypes["ItemUpsertReferenceListRelationInput"];
	["ItemUpdateBlogPostEntityRelationInput"]: GraphQLTypes["ItemUpdateBlogPostEntityRelationInput"];
	["BlogPostWithoutItemsUpdateInput"]: GraphQLTypes["BlogPostWithoutItemsUpdateInput"];
	["BlogPostUpdateImageEntityRelationInput"]: GraphQLTypes["BlogPostUpdateImageEntityRelationInput"];
	["BlogPostUpsertImageRelationInput"]: GraphQLTypes["BlogPostUpsertImageRelationInput"];
	["BlogPostUpdateReferenceListEntityRelationInput"]: GraphQLTypes["BlogPostUpdateReferenceListEntityRelationInput"];
	["BlogPostUpsertReferenceListRelationInput"]: GraphQLTypes["BlogPostUpsertReferenceListRelationInput"];
	["BlogPostUpdateUserEntityRelationInput"]: GraphQLTypes["BlogPostUpdateUserEntityRelationInput"];
	["UserWithoutBlogPostsUpdateInput"]: GraphQLTypes["UserWithoutBlogPostsUpdateInput"];
	["UserUpdateBlogPostReviewReactionsEntityRelationInput"]: GraphQLTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"];
	["UserUpdateBlogPostReviewReactionsRelationInput"]: GraphQLTypes["UserUpdateBlogPostReviewReactionsRelationInput"];
	["BlogPostReviewReactionWithoutUserUpdateInput"]: GraphQLTypes["BlogPostReviewReactionWithoutUserUpdateInput"];
	["BlogPostReviewReactionUpdateBlogPostReviewEntityRelationInput"]: GraphQLTypes["BlogPostReviewReactionUpdateBlogPostReviewEntityRelationInput"];
	["BlogPostReviewWithoutBlogPostReviewReactionsUpdateInput"]: GraphQLTypes["BlogPostReviewWithoutBlogPostReviewReactionsUpdateInput"];
	["BlogPostReviewUpdateUserEntityRelationInput"]: GraphQLTypes["BlogPostReviewUpdateUserEntityRelationInput"];
	["UserWithoutBlogPostReviewsUpdateInput"]: GraphQLTypes["UserWithoutBlogPostReviewsUpdateInput"];
	["UserUpdateProductReviewReactionsEntityRelationInput"]: GraphQLTypes["UserUpdateProductReviewReactionsEntityRelationInput"];
	["UserUpdateProductReviewReactionsRelationInput"]: GraphQLTypes["UserUpdateProductReviewReactionsRelationInput"];
	["ProductReviewReactionWithoutUserUpdateInput"]: GraphQLTypes["ProductReviewReactionWithoutUserUpdateInput"];
	["ProductReviewReactionUpdateProductReviewEntityRelationInput"]: GraphQLTypes["ProductReviewReactionUpdateProductReviewEntityRelationInput"];
	["ProductReviewWithoutProductReviewReactionsUpdateInput"]: GraphQLTypes["ProductReviewWithoutProductReviewReactionsUpdateInput"];
	["ProductReviewUpdateUserEntityRelationInput"]: GraphQLTypes["ProductReviewUpdateUserEntityRelationInput"];
	["UserWithoutProductReviewsUpdateInput"]: GraphQLTypes["UserWithoutProductReviewsUpdateInput"];
	["UserUpdateBlogPostsEntityRelationInput"]: GraphQLTypes["UserUpdateBlogPostsEntityRelationInput"];
	["UserUpdateBlogPostsRelationInput"]: GraphQLTypes["UserUpdateBlogPostsRelationInput"];
	["BlogPostWithoutUserUpdateInput"]: GraphQLTypes["BlogPostWithoutUserUpdateInput"];
	["BlogPostUpdateAdsEntityRelationInput"]: GraphQLTypes["BlogPostUpdateAdsEntityRelationInput"];
	["BlogPostUpdateAdsRelationInput"]: GraphQLTypes["BlogPostUpdateAdsRelationInput"];
	["AdWithoutBlogPostsUpdateInput"]: GraphQLTypes["AdWithoutBlogPostsUpdateInput"];
	["AdUpdateImageEntityRelationInput"]: GraphQLTypes["AdUpdateImageEntityRelationInput"];
	["AdUpsertImageRelationInput"]: GraphQLTypes["AdUpsertImageRelationInput"];
	["AdUpdateItemCategoriesEntityRelationInput"]: GraphQLTypes["AdUpdateItemCategoriesEntityRelationInput"];
	["AdUpdateItemCategoriesRelationInput"]: GraphQLTypes["AdUpdateItemCategoriesRelationInput"];
	["ItemCategoryWithoutAdsUpdateInput"]: GraphQLTypes["ItemCategoryWithoutAdsUpdateInput"];
	["ItemCategoryUpdateProductsEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateProductsEntityRelationInput"];
	["ItemCategoryUpdateProductsRelationInput"]: GraphQLTypes["ItemCategoryUpdateProductsRelationInput"];
	["ProductWithoutItemCategoriesUpdateInput"]: GraphQLTypes["ProductWithoutItemCategoriesUpdateInput"];
	["ProductUpdateElementsEntityRelationInput"]: GraphQLTypes["ProductUpdateElementsEntityRelationInput"];
	["ProductUpdateElementsRelationInput"]: GraphQLTypes["ProductUpdateElementsRelationInput"];
	["ElementOfProductWithoutProductUpdateInput"]: GraphQLTypes["ElementOfProductWithoutProductUpdateInput"];
	["ElementOfProductUpdateElementEntityRelationInput"]: GraphQLTypes["ElementOfProductUpdateElementEntityRelationInput"];
	["ElementWithoutProductsUpdateInput"]: GraphQLTypes["ElementWithoutProductsUpdateInput"];
	["ElementUpdateFeatureDependenciesEntityRelationInput"]: GraphQLTypes["ElementUpdateFeatureDependenciesEntityRelationInput"];
	["ElementUpdateFeatureDependenciesRelationInput"]: GraphQLTypes["ElementUpdateFeatureDependenciesRelationInput"];
	["ProductFeatureWithoutDependentElementUpdateInput"]: GraphQLTypes["ProductFeatureWithoutDependentElementUpdateInput"];
	["ProductFeatureUpdateDependentCategoryEntityRelationInput"]: GraphQLTypes["ProductFeatureUpdateDependentCategoryEntityRelationInput"];
	["ItemCategoryWithoutFeatureDependenciesUpdateInput"]: GraphQLTypes["ItemCategoryWithoutFeatureDependenciesUpdateInput"];
	["ItemCategoryUpdateImageEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateImageEntityRelationInput"];
	["ItemCategoryUpsertImageRelationInput"]: GraphQLTypes["ItemCategoryUpsertImageRelationInput"];
	["ItemCategoryUpdateAdsEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateAdsEntityRelationInput"];
	["ItemCategoryUpdateAdsRelationInput"]: GraphQLTypes["ItemCategoryUpdateAdsRelationInput"];
	["AdWithoutItemCategoriesUpdateInput"]: GraphQLTypes["AdWithoutItemCategoriesUpdateInput"];
	["AdUpdateBlogPostsEntityRelationInput"]: GraphQLTypes["AdUpdateBlogPostsEntityRelationInput"];
	["AdUpdateBlogPostsRelationInput"]: GraphQLTypes["AdUpdateBlogPostsRelationInput"];
	["BlogPostWithoutAdsUpdateInput"]: GraphQLTypes["BlogPostWithoutAdsUpdateInput"];
	["BlogPostUpdateSeoEntityRelationInput"]: GraphQLTypes["BlogPostUpdateSeoEntityRelationInput"];
	["SeoUpdateInput"]: GraphQLTypes["SeoUpdateInput"];
	["SeoUpdateBrandsPageEntityRelationInput"]: GraphQLTypes["SeoUpdateBrandsPageEntityRelationInput"];
	["BrandsPageWithoutSeoUpdateInput"]: GraphQLTypes["BrandsPageWithoutSeoUpdateInput"];
	["BrandsPageUpdateRedirectsEntityRelationInput"]: GraphQLTypes["BrandsPageUpdateRedirectsEntityRelationInput"];
	["BrandsPageUpdateRedirectsRelationInput"]: GraphQLTypes["BrandsPageUpdateRedirectsRelationInput"];
	["RedirectWithoutBrandsPageUpdateInput"]: GraphQLTypes["RedirectWithoutBrandsPageUpdateInput"];
	["RedirectUpdateItemCategoryEntityRelationInput"]: GraphQLTypes["RedirectUpdateItemCategoryEntityRelationInput"];
	["ItemCategoryWithoutRedirectsUpdateInput"]: GraphQLTypes["ItemCategoryWithoutRedirectsUpdateInput"];
	["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"];
	["ItemCategoryUpdateFeatureDependenciesRelationInput"]: GraphQLTypes["ItemCategoryUpdateFeatureDependenciesRelationInput"];
	["ProductFeatureWithoutDependentCategoryUpdateInput"]: GraphQLTypes["ProductFeatureWithoutDependentCategoryUpdateInput"];
	["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"]: GraphQLTypes["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"];
	["ItemSubCategoryWithoutFeatureDependenciesUpdateInput"]: GraphQLTypes["ItemSubCategoryWithoutFeatureDependenciesUpdateInput"];
	["ItemSubCategoryUpdateCategoryEntityRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"];
	["ItemCategoryWithoutSubCategoriesUpdateInput"]: GraphQLTypes["ItemCategoryWithoutSubCategoriesUpdateInput"];
	["ItemCategoryUpdateRedirectsEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateRedirectsEntityRelationInput"];
	["ItemCategoryUpdateRedirectsRelationInput"]: GraphQLTypes["ItemCategoryUpdateRedirectsRelationInput"];
	["RedirectWithoutItemCategoryUpdateInput"]: GraphQLTypes["RedirectWithoutItemCategoryUpdateInput"];
	["RedirectUpdateBrandsPageEntityRelationInput"]: GraphQLTypes["RedirectUpdateBrandsPageEntityRelationInput"];
	["BrandsPageWithoutRedirectsUpdateInput"]: GraphQLTypes["BrandsPageWithoutRedirectsUpdateInput"];
	["BrandsPageUpdateSeoEntityRelationInput"]: GraphQLTypes["BrandsPageUpdateSeoEntityRelationInput"];
	["SeoWithoutBrandsPageUpdateInput"]: GraphQLTypes["SeoWithoutBrandsPageUpdateInput"];
	["SeoUpdateComparatorPageEntityRelationInput"]: GraphQLTypes["SeoUpdateComparatorPageEntityRelationInput"];
	["ComparatorPageWithoutSeoUpdateInput"]: GraphQLTypes["ComparatorPageWithoutSeoUpdateInput"];
	["ComparatorPageUpdateRedirectsEntityRelationInput"]: GraphQLTypes["ComparatorPageUpdateRedirectsEntityRelationInput"];
	["ComparatorPageUpdateRedirectsRelationInput"]: GraphQLTypes["ComparatorPageUpdateRedirectsRelationInput"];
	["RedirectWithoutComparatorPageUpdateInput"]: GraphQLTypes["RedirectWithoutComparatorPageUpdateInput"];
	["RedirectUpdateBlogPageEntityRelationInput"]: GraphQLTypes["RedirectUpdateBlogPageEntityRelationInput"];
	["BlogPageWithoutRedirectsUpdateInput"]: GraphQLTypes["BlogPageWithoutRedirectsUpdateInput"];
	["BlogPageUpdateSeoEntityRelationInput"]: GraphQLTypes["BlogPageUpdateSeoEntityRelationInput"];
	["SeoWithoutBlogPageUpdateInput"]: GraphQLTypes["SeoWithoutBlogPageUpdateInput"];
	["SeoUpdateGenericPageEntityRelationInput"]: GraphQLTypes["SeoUpdateGenericPageEntityRelationInput"];
	["GenericPageWithoutSeoUpdateInput"]: GraphQLTypes["GenericPageWithoutSeoUpdateInput"];
	["GenericPageUpdateRedirectsEntityRelationInput"]: GraphQLTypes["GenericPageUpdateRedirectsEntityRelationInput"];
	["GenericPageUpdateRedirectsRelationInput"]: GraphQLTypes["GenericPageUpdateRedirectsRelationInput"];
	["RedirectWithoutGenericPageUpdateInput"]: GraphQLTypes["RedirectWithoutGenericPageUpdateInput"];
	["RedirectUpdateContactPageEntityRelationInput"]: GraphQLTypes["RedirectUpdateContactPageEntityRelationInput"];
	["ContactPageWithoutRedirectsUpdateInput"]: GraphQLTypes["ContactPageWithoutRedirectsUpdateInput"];
	["ContactPageUpdateSeoEntityRelationInput"]: GraphQLTypes["ContactPageUpdateSeoEntityRelationInput"];
	["SeoWithoutContactPageUpdateInput"]: GraphQLTypes["SeoWithoutContactPageUpdateInput"];
	["SeoUpdateHomePageEntityRelationInput"]: GraphQLTypes["SeoUpdateHomePageEntityRelationInput"];
	["HomePageWithoutSeoUpdateInput"]: GraphQLTypes["HomePageWithoutSeoUpdateInput"];
	["SeoUpsertHomePageRelationInput"]: GraphQLTypes["SeoUpsertHomePageRelationInput"];
	["SeoUpdateIngredientsPageEntityRelationInput"]: GraphQLTypes["SeoUpdateIngredientsPageEntityRelationInput"];
	["IngredientsPageWithoutSeoUpdateInput"]: GraphQLTypes["IngredientsPageWithoutSeoUpdateInput"];
	["IngredientsPageUpdateContentEntityRelationInput"]: GraphQLTypes["IngredientsPageUpdateContentEntityRelationInput"];
	["IngredientsPageUpsertContentRelationInput"]: GraphQLTypes["IngredientsPageUpsertContentRelationInput"];
	["IngredientsPageUpdateDraftEntityRelationInput"]: GraphQLTypes["IngredientsPageUpdateDraftEntityRelationInput"];
	["IngredientsPageUpsertDraftRelationInput"]: GraphQLTypes["IngredientsPageUpsertDraftRelationInput"];
	["SeoUpsertIngredientsPageRelationInput"]: GraphQLTypes["SeoUpsertIngredientsPageRelationInput"];
	["SeoUpdateLoginPageEntityRelationInput"]: GraphQLTypes["SeoUpdateLoginPageEntityRelationInput"];
	["LoginPageWithoutSeoUpdateInput"]: GraphQLTypes["LoginPageWithoutSeoUpdateInput"];
	["SeoUpsertLoginPageRelationInput"]: GraphQLTypes["SeoUpsertLoginPageRelationInput"];
	["SeoUpdateRegisterPageEntityRelationInput"]: GraphQLTypes["SeoUpdateRegisterPageEntityRelationInput"];
	["RegisterPageWithoutSeoUpdateInput"]: GraphQLTypes["RegisterPageWithoutSeoUpdateInput"];
	["SeoUpsertRegisterPageRelationInput"]: GraphQLTypes["SeoUpsertRegisterPageRelationInput"];
	["SeoUpdateSearchPageEntityRelationInput"]: GraphQLTypes["SeoUpdateSearchPageEntityRelationInput"];
	["SearchPageWithoutSeoUpdateInput"]: GraphQLTypes["SearchPageWithoutSeoUpdateInput"];
	["SeoUpsertSearchPageRelationInput"]: GraphQLTypes["SeoUpsertSearchPageRelationInput"];
	["SeoUpdateWizardPageEntityRelationInput"]: GraphQLTypes["SeoUpdateWizardPageEntityRelationInput"];
	["WizardPageWithoutSeoUpdateInput"]: GraphQLTypes["WizardPageWithoutSeoUpdateInput"];
	["WizardPageUpdateRedirectsEntityRelationInput"]: GraphQLTypes["WizardPageUpdateRedirectsEntityRelationInput"];
	["WizardPageUpdateRedirectsRelationInput"]: GraphQLTypes["WizardPageUpdateRedirectsRelationInput"];
	["RedirectWithoutWizardPageUpdateInput"]: GraphQLTypes["RedirectWithoutWizardPageUpdateInput"];
	["RedirectUpdateComparatorPageEntityRelationInput"]: GraphQLTypes["RedirectUpdateComparatorPageEntityRelationInput"];
	["ComparatorPageWithoutRedirectsUpdateInput"]: GraphQLTypes["ComparatorPageWithoutRedirectsUpdateInput"];
	["ComparatorPageUpdateSeoEntityRelationInput"]: GraphQLTypes["ComparatorPageUpdateSeoEntityRelationInput"];
	["SeoWithoutComparatorPageUpdateInput"]: GraphQLTypes["SeoWithoutComparatorPageUpdateInput"];
	["SeoUpdateContactPageEntityRelationInput"]: GraphQLTypes["SeoUpdateContactPageEntityRelationInput"];
	["ContactPageWithoutSeoUpdateInput"]: GraphQLTypes["ContactPageWithoutSeoUpdateInput"];
	["ContactPageUpdateRedirectsEntityRelationInput"]: GraphQLTypes["ContactPageUpdateRedirectsEntityRelationInput"];
	["ContactPageUpdateRedirectsRelationInput"]: GraphQLTypes["ContactPageUpdateRedirectsRelationInput"];
	["RedirectWithoutContactPageUpdateInput"]: GraphQLTypes["RedirectWithoutContactPageUpdateInput"];
	["RedirectUpdateWizardPageEntityRelationInput"]: GraphQLTypes["RedirectUpdateWizardPageEntityRelationInput"];
	["WizardPageWithoutRedirectsUpdateInput"]: GraphQLTypes["WizardPageWithoutRedirectsUpdateInput"];
	["WizardPageUpdateSeoEntityRelationInput"]: GraphQLTypes["WizardPageUpdateSeoEntityRelationInput"];
	["SeoWithoutWizardPageUpdateInput"]: GraphQLTypes["SeoWithoutWizardPageUpdateInput"];
	["WizardPageUpsertSeoRelationInput"]: GraphQLTypes["WizardPageUpsertSeoRelationInput"];
	["RedirectUpsertWizardPageRelationInput"]: GraphQLTypes["RedirectUpsertWizardPageRelationInput"];
	["RedirectUpdateBlogPostEntityRelationInput"]: GraphQLTypes["RedirectUpdateBlogPostEntityRelationInput"];
	["BlogPostWithoutRedirectsUpdateInput"]: GraphQLTypes["BlogPostWithoutRedirectsUpdateInput"];
	["BlogPostUpdateContentEntityRelationInput"]: GraphQLTypes["BlogPostUpdateContentEntityRelationInput"];
	["BlogPostUpsertContentRelationInput"]: GraphQLTypes["BlogPostUpsertContentRelationInput"];
	["BlogPostUpdateDraftEntityRelationInput"]: GraphQLTypes["BlogPostUpdateDraftEntityRelationInput"];
	["BlogPostUpsertDraftRelationInput"]: GraphQLTypes["BlogPostUpsertDraftRelationInput"];
	["RedirectUpsertBlogPostRelationInput"]: GraphQLTypes["RedirectUpsertBlogPostRelationInput"];
	["ContactPageUpsertRedirectsRelationInput"]: GraphQLTypes["ContactPageUpsertRedirectsRelationInput"];
	["ContactPageUpdateContentEntityRelationInput"]: GraphQLTypes["ContactPageUpdateContentEntityRelationInput"];
	["ContactPageUpsertContentRelationInput"]: GraphQLTypes["ContactPageUpsertContentRelationInput"];
	["ContactPageUpdateDraftEntityRelationInput"]: GraphQLTypes["ContactPageUpdateDraftEntityRelationInput"];
	["ContactPageUpsertDraftRelationInput"]: GraphQLTypes["ContactPageUpsertDraftRelationInput"];
	["SeoUpsertContactPageRelationInput"]: GraphQLTypes["SeoUpsertContactPageRelationInput"];
	["ComparatorPageUpsertSeoRelationInput"]: GraphQLTypes["ComparatorPageUpsertSeoRelationInput"];
	["RedirectUpsertComparatorPageRelationInput"]: GraphQLTypes["RedirectUpsertComparatorPageRelationInput"];
	["WizardPageUpsertRedirectsRelationInput"]: GraphQLTypes["WizardPageUpsertRedirectsRelationInput"];
	["SeoUpsertWizardPageRelationInput"]: GraphQLTypes["SeoUpsertWizardPageRelationInput"];
	["ContactPageUpsertSeoRelationInput"]: GraphQLTypes["ContactPageUpsertSeoRelationInput"];
	["RedirectUpsertContactPageRelationInput"]: GraphQLTypes["RedirectUpsertContactPageRelationInput"];
	["GenericPageUpsertRedirectsRelationInput"]: GraphQLTypes["GenericPageUpsertRedirectsRelationInput"];
	["GenericPageUpdateContentEntityRelationInput"]: GraphQLTypes["GenericPageUpdateContentEntityRelationInput"];
	["GenericPageUpsertContentRelationInput"]: GraphQLTypes["GenericPageUpsertContentRelationInput"];
	["GenericPageUpdateDraftEntityRelationInput"]: GraphQLTypes["GenericPageUpdateDraftEntityRelationInput"];
	["GenericPageUpsertDraftRelationInput"]: GraphQLTypes["GenericPageUpsertDraftRelationInput"];
	["SeoUpsertGenericPageRelationInput"]: GraphQLTypes["SeoUpsertGenericPageRelationInput"];
	["BlogPageUpsertSeoRelationInput"]: GraphQLTypes["BlogPageUpsertSeoRelationInput"];
	["BlogPageUpdateDraftEntityRelationInput"]: GraphQLTypes["BlogPageUpdateDraftEntityRelationInput"];
	["BlogPageUpsertDraftRelationInput"]: GraphQLTypes["BlogPageUpsertDraftRelationInput"];
	["RedirectUpsertBlogPageRelationInput"]: GraphQLTypes["RedirectUpsertBlogPageRelationInput"];
	["ComparatorPageUpsertRedirectsRelationInput"]: GraphQLTypes["ComparatorPageUpsertRedirectsRelationInput"];
	["SeoUpsertComparatorPageRelationInput"]: GraphQLTypes["SeoUpsertComparatorPageRelationInput"];
	["BrandsPageUpsertSeoRelationInput"]: GraphQLTypes["BrandsPageUpsertSeoRelationInput"];
	["BrandsPageUpdateContentEntityRelationInput"]: GraphQLTypes["BrandsPageUpdateContentEntityRelationInput"];
	["BrandsPageUpsertContentRelationInput"]: GraphQLTypes["BrandsPageUpsertContentRelationInput"];
	["BrandsPageUpdateDraftEntityRelationInput"]: GraphQLTypes["BrandsPageUpdateDraftEntityRelationInput"];
	["BrandsPageUpsertDraftRelationInput"]: GraphQLTypes["BrandsPageUpsertDraftRelationInput"];
	["RedirectUpsertBrandsPageRelationInput"]: GraphQLTypes["RedirectUpsertBrandsPageRelationInput"];
	["ItemCategoryUpsertRedirectsRelationInput"]: GraphQLTypes["ItemCategoryUpsertRedirectsRelationInput"];
	["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"];
	["ItemCategoryUpdateDeclensionsFourthRelationInput"]: GraphQLTypes["ItemCategoryUpdateDeclensionsFourthRelationInput"];
	["ItemDeclensionFourthVariantWithoutCategoryUpdateInput"]: GraphQLTypes["ItemDeclensionFourthVariantWithoutCategoryUpdateInput"];
	["ItemDeclensionFourthVariantUpdateItemsEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpdateItemsEntityRelationInput"];
	["ItemDeclensionFourthVariantUpdateItemsRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpdateItemsRelationInput"];
	["ItemWithoutDeclensionFourthUpdateInput"]: GraphQLTypes["ItemWithoutDeclensionFourthUpdateInput"];
	["ItemUpdateDeclensionSeventhEntityRelationInput"]: GraphQLTypes["ItemUpdateDeclensionSeventhEntityRelationInput"];
	["ItemDeclensionSeventhVariantWithoutItemsUpdateInput"]: GraphQLTypes["ItemDeclensionSeventhVariantWithoutItemsUpdateInput"];
	["ItemUpsertDeclensionSeventhRelationInput"]: GraphQLTypes["ItemUpsertDeclensionSeventhRelationInput"];
	["ItemUpdateSeoEntityRelationInput"]: GraphQLTypes["ItemUpdateSeoEntityRelationInput"];
	["ItemUpsertSeoRelationInput"]: GraphQLTypes["ItemUpsertSeoRelationInput"];
	["ItemUpdateAliasesEntityRelationInput"]: GraphQLTypes["ItemUpdateAliasesEntityRelationInput"];
	["ItemUpdateAliasesRelationInput"]: GraphQLTypes["ItemUpdateAliasesRelationInput"];
	["ItemAliasWithoutItemUpdateInput"]: GraphQLTypes["ItemAliasWithoutItemUpdateInput"];
	["ItemUpsertAliasesRelationInput"]: GraphQLTypes["ItemUpsertAliasesRelationInput"];
	["ItemUpdateContentEntityRelationInput"]: GraphQLTypes["ItemUpdateContentEntityRelationInput"];
	["ItemUpsertContentRelationInput"]: GraphQLTypes["ItemUpsertContentRelationInput"];
	["ItemUpdateDraftEntityRelationInput"]: GraphQLTypes["ItemUpdateDraftEntityRelationInput"];
	["ItemUpsertDraftRelationInput"]: GraphQLTypes["ItemUpsertDraftRelationInput"];
	["ItemDeclensionFourthVariantUpsertItemsRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpsertItemsRelationInput"];
	["ItemDeclensionFourthVariantUpdateSeoEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpdateSeoEntityRelationInput"];
	["ItemDeclensionFourthVariantUpsertSeoRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpsertSeoRelationInput"];
	["ItemDeclensionFourthVariantUpdateSubcategoryEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpdateSubcategoryEntityRelationInput"];
	["ItemSubCategoryUpdateInput"]: GraphQLTypes["ItemSubCategoryUpdateInput"];
	["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"];
	["ItemFlavorCategoryWithoutItemsUpdateInput"]: GraphQLTypes["ItemFlavorCategoryWithoutItemsUpdateInput"];
	["ItemFlavorCategoryUpdateColorEntityRelationInput"]: GraphQLTypes["ItemFlavorCategoryUpdateColorEntityRelationInput"];
	["ColorWithoutItemFlavorCategoriesUpdateInput"]: GraphQLTypes["ColorWithoutItemFlavorCategoriesUpdateInput"];
	["ItemFlavorCategoryUpsertColorRelationInput"]: GraphQLTypes["ItemFlavorCategoryUpsertColorRelationInput"];
	["ItemSubCategoryUpsertFlavorCategoryRelationInput"]: GraphQLTypes["ItemSubCategoryUpsertFlavorCategoryRelationInput"];
	["ItemSubCategoryUpdateDogsEntityRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateDogsEntityRelationInput"];
	["ItemSubCategoryUpdateDogsRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateDogsRelationInput"];
	["DogWithoutAllergiesUpdateInput"]: GraphQLTypes["DogWithoutAllergiesUpdateInput"];
	["DogUpdateFedProductEntityRelationInput"]: GraphQLTypes["DogUpdateFedProductEntityRelationInput"];
	["ProductWithoutDogsUpdateInput"]: GraphQLTypes["ProductWithoutDogsUpdateInput"];
	["ProductUpdateRecommendedDogSizesEntityRelationInput"]: GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"];
	["ProductUpdateRecommendedDogSizesRelationInput"]: GraphQLTypes["ProductUpdateRecommendedDogSizesRelationInput"];
	["DogSizeWithoutProductsUpdateInput"]: GraphQLTypes["DogSizeWithoutProductsUpdateInput"];
	["DogSizeUpdateBreedsEntityRelationInput"]: GraphQLTypes["DogSizeUpdateBreedsEntityRelationInput"];
	["DogSizeUpdateBreedsRelationInput"]: GraphQLTypes["DogSizeUpdateBreedsRelationInput"];
	["BreedWithoutSizeUpdateInput"]: GraphQLTypes["BreedWithoutSizeUpdateInput"];
	["BreedUpdateSuitabilityCategoryEntityRelationInput"]: GraphQLTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"];
	["SuitabilityCategoryWithoutBreedsUpdateInput"]: GraphQLTypes["SuitabilityCategoryWithoutBreedsUpdateInput"];
	["SuitabilityCategoryUpdateDogSizesEntityRelationInput"]: GraphQLTypes["SuitabilityCategoryUpdateDogSizesEntityRelationInput"];
	["SuitabilityCategoryUpdateDogSizesRelationInput"]: GraphQLTypes["SuitabilityCategoryUpdateDogSizesRelationInput"];
	["DogSizeWithoutSuitabilityCategoryUpdateInput"]: GraphQLTypes["DogSizeWithoutSuitabilityCategoryUpdateInput"];
	["DogSizeUpdateProductsEntityRelationInput"]: GraphQLTypes["DogSizeUpdateProductsEntityRelationInput"];
	["DogSizeUpdateProductsRelationInput"]: GraphQLTypes["DogSizeUpdateProductsRelationInput"];
	["ProductWithoutRecommendedDogSizesUpdateInput"]: GraphQLTypes["ProductWithoutRecommendedDogSizesUpdateInput"];
	["ProductUpdateGranuleSizesEntityRelationInput"]: GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"];
	["ProductUpdateGranuleSizesRelationInput"]: GraphQLTypes["ProductUpdateGranuleSizesRelationInput"];
	["GranuleSizeWithoutProductsUpdateInput"]: GraphQLTypes["GranuleSizeWithoutProductsUpdateInput"];
	["ProductUpsertGranuleSizesRelationInput"]: GraphQLTypes["ProductUpsertGranuleSizesRelationInput"];
	["ProductUpdateProductLineEntityRelationInput"]: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"];
	["ProductLineWithoutProductsUpdateInput"]: GraphQLTypes["ProductLineWithoutProductsUpdateInput"];
	["ProductLineUpdateBrandEntityRelationInput"]: GraphQLTypes["ProductLineUpdateBrandEntityRelationInput"];
	["BrandWithoutProductLinesUpdateInput"]: GraphQLTypes["BrandWithoutProductLinesUpdateInput"];
	["BrandUpdateProductsEntityRelationInput"]: GraphQLTypes["BrandUpdateProductsEntityRelationInput"];
	["BrandUpdateProductsRelationInput"]: GraphQLTypes["BrandUpdateProductsRelationInput"];
	["ProductWithoutBrandUpdateInput"]: GraphQLTypes["ProductWithoutBrandUpdateInput"];
	["ProductUpdateFlagsEntityRelationInput"]: GraphQLTypes["ProductUpdateFlagsEntityRelationInput"];
	["ProductUpdateFlagsRelationInput"]: GraphQLTypes["ProductUpdateFlagsRelationInput"];
	["ProductFlagOfProductWithoutProductUpdateInput"]: GraphQLTypes["ProductFlagOfProductWithoutProductUpdateInput"];
	["ProductFlagOfProductUpdateFlagEntityRelationInput"]: GraphQLTypes["ProductFlagOfProductUpdateFlagEntityRelationInput"];
	["ProductFlagWithoutProductsUpdateInput"]: GraphQLTypes["ProductFlagWithoutProductsUpdateInput"];
	["ProductFlagUpdateProductFeaturesEntityRelationInput"]: GraphQLTypes["ProductFlagUpdateProductFeaturesEntityRelationInput"];
	["ProductFlagUpdateProductFeaturesRelationInput"]: GraphQLTypes["ProductFlagUpdateProductFeaturesRelationInput"];
	["ProductFeatureWithoutDependentFlagUpdateInput"]: GraphQLTypes["ProductFeatureWithoutDependentFlagUpdateInput"];
	["ProductFlagUpsertProductFeaturesRelationInput"]: GraphQLTypes["ProductFlagUpsertProductFeaturesRelationInput"];
	["ProductFlagOfProductUpsertFlagRelationInput"]: GraphQLTypes["ProductFlagOfProductUpsertFlagRelationInput"];
	["ProductUpsertFlagsRelationInput"]: GraphQLTypes["ProductUpsertFlagsRelationInput"];
	["ProductUpdateImageEntityRelationInput"]: GraphQLTypes["ProductUpdateImageEntityRelationInput"];
	["ProductUpsertImageRelationInput"]: GraphQLTypes["ProductUpsertImageRelationInput"];
	["ProductUpdateRecommendedActivityEntityRelationInput"]: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"];
	["DogActivityWithoutProductsUpdateInput"]: GraphQLTypes["DogActivityWithoutProductsUpdateInput"];
	["DogActivityUpdateDogsEntityRelationInput"]: GraphQLTypes["DogActivityUpdateDogsEntityRelationInput"];
	["DogActivityUpdateDogsRelationInput"]: GraphQLTypes["DogActivityUpdateDogsRelationInput"];
	["DogWithoutActivityUpdateInput"]: GraphQLTypes["DogWithoutActivityUpdateInput"];
	["DogUpdateReproductionEntityRelationInput"]: GraphQLTypes["DogUpdateReproductionEntityRelationInput"];
	["DogReproductionWithoutDogUpdateInput"]: GraphQLTypes["DogReproductionWithoutDogUpdateInput"];
	["DogReproductionUpdateBreastfeedingCategoryEntityRelationInput"]: GraphQLTypes["DogReproductionUpdateBreastfeedingCategoryEntityRelationInput"];
	["BreastfeedingCategoryWithoutDogsUpdateInput"]: GraphQLTypes["BreastfeedingCategoryWithoutDogsUpdateInput"];
	["DogReproductionUpsertBreastfeedingCategoryRelationInput"]: GraphQLTypes["DogReproductionUpsertBreastfeedingCategoryRelationInput"];
	["DogUpsertReproductionRelationInput"]: GraphQLTypes["DogUpsertReproductionRelationInput"];
	["DogUpdateAllergiesEntityRelationInput"]: GraphQLTypes["DogUpdateAllergiesEntityRelationInput"];
	["DogUpdateAllergiesRelationInput"]: GraphQLTypes["DogUpdateAllergiesRelationInput"];
	["ItemSubCategoryWithoutDogsUpdateInput"]: GraphQLTypes["ItemSubCategoryWithoutDogsUpdateInput"];
	["ItemSubCategoryUpdateIconNegativeEntityRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"];
	["ItemSubCategoryUpsertIconNegativeRelationInput"]: GraphQLTypes["ItemSubCategoryUpsertIconNegativeRelationInput"];
	["ItemSubCategoryUpdateIconEntityRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateIconEntityRelationInput"];
	["ItemSubCategoryUpsertIconRelationInput"]: GraphQLTypes["ItemSubCategoryUpsertIconRelationInput"];
	["ItemSubCategoryUpdateBrandsEntityRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"];
	["ItemSubCategoryUpdateProductLinesEntityRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"];
	["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"];
	["ItemSubCategoryUpdateFilterCombosFlavorRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateFilterCombosFlavorRelationInput"];
	["FilterComboWithoutFlavorUpdateInput"]: GraphQLTypes["FilterComboWithoutFlavorUpdateInput"];
	["FilterComboUpdateSeoEntityRelationInput"]: GraphQLTypes["FilterComboUpdateSeoEntityRelationInput"];
	["FilterComboUpsertSeoRelationInput"]: GraphQLTypes["FilterComboUpsertSeoRelationInput"];
	["FilterComboUpdateBreedEntityRelationInput"]: GraphQLTypes["FilterComboUpdateBreedEntityRelationInput"];
	["BreedWithoutFilterCombosUpdateInput"]: GraphQLTypes["BreedWithoutFilterCombosUpdateInput"];
	["BreedUpdateProductReviewsEntityRelationInput"]: GraphQLTypes["BreedUpdateProductReviewsEntityRelationInput"];
	["BreedUpdateProductReviewsRelationInput"]: GraphQLTypes["BreedUpdateProductReviewsRelationInput"];
	["ProductReviewWithoutBreedUpdateInput"]: GraphQLTypes["ProductReviewWithoutBreedUpdateInput"];
	["ProductReviewUpdateAgeEntityRelationInput"]: GraphQLTypes["ProductReviewUpdateAgeEntityRelationInput"];
	["AgeWithoutProductReviewsUpdateInput"]: GraphQLTypes["AgeWithoutProductReviewsUpdateInput"];
	["AgeUpdateSuitabilityCategoriesEntityRelationInput"]: GraphQLTypes["AgeUpdateSuitabilityCategoriesEntityRelationInput"];
	["AgeUpdateSuitabilityCategoriesRelationInput"]: GraphQLTypes["AgeUpdateSuitabilityCategoriesRelationInput"];
	["SuitabilityCategoryWithoutDogAgesUpdateInput"]: GraphQLTypes["SuitabilityCategoryWithoutDogAgesUpdateInput"];
	["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"]: GraphQLTypes["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"];
	["SuitabilityCategoryUpdateDogActivitiesRelationInput"]: GraphQLTypes["SuitabilityCategoryUpdateDogActivitiesRelationInput"];
	["DogActivityWithoutSuitabilityCategoryUpdateInput"]: GraphQLTypes["DogActivityWithoutSuitabilityCategoryUpdateInput"];
	["SuitabilityCategoryUpsertDogActivitiesRelationInput"]: GraphQLTypes["SuitabilityCategoryUpsertDogActivitiesRelationInput"];
	["SuitabilityCategoryUpdateBreedsEntityRelationInput"]: GraphQLTypes["SuitabilityCategoryUpdateBreedsEntityRelationInput"];
	["SuitabilityCategoryUpdateBreedsRelationInput"]: GraphQLTypes["SuitabilityCategoryUpdateBreedsRelationInput"];
	["BreedWithoutSuitabilityCategoryUpdateInput"]: GraphQLTypes["BreedWithoutSuitabilityCategoryUpdateInput"];
	["BreedUpdateBlogPostReviewsEntityRelationInput"]: GraphQLTypes["BreedUpdateBlogPostReviewsEntityRelationInput"];
	["BreedUpdateBlogPostReviewsRelationInput"]: GraphQLTypes["BreedUpdateBlogPostReviewsRelationInput"];
	["BlogPostReviewWithoutBreedUpdateInput"]: GraphQLTypes["BlogPostReviewWithoutBreedUpdateInput"];
	["BlogPostReviewUpdateAgeEntityRelationInput"]: GraphQLTypes["BlogPostReviewUpdateAgeEntityRelationInput"];
	["AgeWithoutBlogPostReviewsUpdateInput"]: GraphQLTypes["AgeWithoutBlogPostReviewsUpdateInput"];
	["AgeUpdateProductReviewsEntityRelationInput"]: GraphQLTypes["AgeUpdateProductReviewsEntityRelationInput"];
	["AgeUpdateProductReviewsRelationInput"]: GraphQLTypes["AgeUpdateProductReviewsRelationInput"];
	["ProductReviewWithoutAgeUpdateInput"]: GraphQLTypes["ProductReviewWithoutAgeUpdateInput"];
	["ProductReviewUpdateBreedEntityRelationInput"]: GraphQLTypes["ProductReviewUpdateBreedEntityRelationInput"];
	["BreedWithoutProductReviewsUpdateInput"]: GraphQLTypes["BreedWithoutProductReviewsUpdateInput"];
	["BreedUpdateSizeEntityRelationInput"]: GraphQLTypes["BreedUpdateSizeEntityRelationInput"];
	["DogSizeWithoutBreedsUpdateInput"]: GraphQLTypes["DogSizeWithoutBreedsUpdateInput"];
	["DogSizeUpdateSuitabilityCategoryEntityRelationInput"]: GraphQLTypes["DogSizeUpdateSuitabilityCategoryEntityRelationInput"];
	["SuitabilityCategoryWithoutDogSizesUpdateInput"]: GraphQLTypes["SuitabilityCategoryWithoutDogSizesUpdateInput"];
	["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"]: GraphQLTypes["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"];
	["SuitabilityCategoryUpdateSuitabilityItemsRelationInput"]: GraphQLTypes["SuitabilityCategoryUpdateSuitabilityItemsRelationInput"];
	["SuitabilityItemWithoutCategoryUpdateInput"]: GraphQLTypes["SuitabilityItemWithoutCategoryUpdateInput"];
	["SuitabilityCategoryUpsertSuitabilityItemsRelationInput"]: GraphQLTypes["SuitabilityCategoryUpsertSuitabilityItemsRelationInput"];
	["SuitabilityCategoryUpdateDogAgesEntityRelationInput"]: GraphQLTypes["SuitabilityCategoryUpdateDogAgesEntityRelationInput"];
	["SuitabilityCategoryUpdateDogAgesRelationInput"]: GraphQLTypes["SuitabilityCategoryUpdateDogAgesRelationInput"];
	["AgeWithoutSuitabilityCategoriesUpdateInput"]: GraphQLTypes["AgeWithoutSuitabilityCategoriesUpdateInput"];
	["AgeUpdateBlogPostReviewsEntityRelationInput"]: GraphQLTypes["AgeUpdateBlogPostReviewsEntityRelationInput"];
	["AgeUpdateBlogPostReviewsRelationInput"]: GraphQLTypes["AgeUpdateBlogPostReviewsRelationInput"];
	["BlogPostReviewWithoutAgeUpdateInput"]: GraphQLTypes["BlogPostReviewWithoutAgeUpdateInput"];
	["BlogPostReviewUpdateBreedEntityRelationInput"]: GraphQLTypes["BlogPostReviewUpdateBreedEntityRelationInput"];
	["BreedWithoutBlogPostReviewsUpdateInput"]: GraphQLTypes["BreedWithoutBlogPostReviewsUpdateInput"];
	["BreedUpdateFilterCombosEntityRelationInput"]: GraphQLTypes["BreedUpdateFilterCombosEntityRelationInput"];
	["BreedUpdateFilterCombosRelationInput"]: GraphQLTypes["BreedUpdateFilterCombosRelationInput"];
	["FilterComboWithoutBreedUpdateInput"]: GraphQLTypes["FilterComboWithoutBreedUpdateInput"];
	["FilterComboUpdateBrandEntityRelationInput"]: GraphQLTypes["FilterComboUpdateBrandEntityRelationInput"];
	["BrandWithoutFilterCombosUpdateInput"]: GraphQLTypes["BrandWithoutFilterCombosUpdateInput"];
	["BrandUpdateCountriesOfProductionEntityRelationInput"]: GraphQLTypes["BrandUpdateCountriesOfProductionEntityRelationInput"];
	["BrandUpdateCountriesOfProductionRelationInput"]: GraphQLTypes["BrandUpdateCountriesOfProductionRelationInput"];
	["CountryWithoutBrandsUpdateInput"]: GraphQLTypes["CountryWithoutBrandsUpdateInput"];
	["CountryUpdateManufacturersEntityRelationInput"]: GraphQLTypes["CountryUpdateManufacturersEntityRelationInput"];
	["CountryUpdateManufacturersRelationInput"]: GraphQLTypes["CountryUpdateManufacturersRelationInput"];
	["BrandManufacturerWithoutResidenceUpdateInput"]: GraphQLTypes["BrandManufacturerWithoutResidenceUpdateInput"];
	["BrandManufacturerUpdateBrandsEntityRelationInput"]: GraphQLTypes["BrandManufacturerUpdateBrandsEntityRelationInput"];
	["BrandManufacturerUpdateBrandsRelationInput"]: GraphQLTypes["BrandManufacturerUpdateBrandsRelationInput"];
	["BrandWithoutManufacturersUpdateInput"]: GraphQLTypes["BrandWithoutManufacturersUpdateInput"];
	["BrandUpdateProductLinesEntityRelationInput"]: GraphQLTypes["BrandUpdateProductLinesEntityRelationInput"];
	["BrandUpdateProductLinesRelationInput"]: GraphQLTypes["BrandUpdateProductLinesRelationInput"];
	["ProductLineWithoutBrandUpdateInput"]: GraphQLTypes["ProductLineWithoutBrandUpdateInput"];
	["ProductLineUpdateProductsEntityRelationInput"]: GraphQLTypes["ProductLineUpdateProductsEntityRelationInput"];
	["ProductLineUpdateProductsRelationInput"]: GraphQLTypes["ProductLineUpdateProductsRelationInput"];
	["ProductWithoutProductLineUpdateInput"]: GraphQLTypes["ProductWithoutProductLineUpdateInput"];
	["ProductUpdateBrandEntityRelationInput"]: GraphQLTypes["ProductUpdateBrandEntityRelationInput"];
	["BrandWithoutProductsUpdateInput"]: GraphQLTypes["BrandWithoutProductsUpdateInput"];
	["BrandUpdateManufacturersEntityRelationInput"]: GraphQLTypes["BrandUpdateManufacturersEntityRelationInput"];
	["BrandUpdateManufacturersRelationInput"]: GraphQLTypes["BrandUpdateManufacturersRelationInput"];
	["BrandManufacturerWithoutBrandsUpdateInput"]: GraphQLTypes["BrandManufacturerWithoutBrandsUpdateInput"];
	["BrandManufacturerUpdateResidenceEntityRelationInput"]: GraphQLTypes["BrandManufacturerUpdateResidenceEntityRelationInput"];
	["CountryWithoutManufacturersUpdateInput"]: GraphQLTypes["CountryWithoutManufacturersUpdateInput"];
	["CountryUpdateBrandsEntityRelationInput"]: GraphQLTypes["CountryUpdateBrandsEntityRelationInput"];
	["CountryUpdateBrandsRelationInput"]: GraphQLTypes["CountryUpdateBrandsRelationInput"];
	["BrandWithoutCountriesOfProductionUpdateInput"]: GraphQLTypes["BrandWithoutCountriesOfProductionUpdateInput"];
	["BrandUpdateLogoEntityRelationInput"]: GraphQLTypes["BrandUpdateLogoEntityRelationInput"];
	["BrandUpsertLogoRelationInput"]: GraphQLTypes["BrandUpsertLogoRelationInput"];
	["BrandUpdateMethodOfProductionEntityRelationInput"]: GraphQLTypes["BrandUpdateMethodOfProductionEntityRelationInput"];
	["ProductionMethodWithoutBrandsUpdateInput"]: GraphQLTypes["ProductionMethodWithoutBrandsUpdateInput"];
	["BrandUpsertMethodOfProductionRelationInput"]: GraphQLTypes["BrandUpsertMethodOfProductionRelationInput"];
	["BrandUpdateDistributorEntityRelationInput"]: GraphQLTypes["BrandUpdateDistributorEntityRelationInput"];
	["BrandDistributorWithoutBrandsUpdateInput"]: GraphQLTypes["BrandDistributorWithoutBrandsUpdateInput"];
	["BrandUpsertDistributorRelationInput"]: GraphQLTypes["BrandUpsertDistributorRelationInput"];
	["BrandUpdateAliasesEntityRelationInput"]: GraphQLTypes["BrandUpdateAliasesEntityRelationInput"];
	["BrandUpdateAliasesRelationInput"]: GraphQLTypes["BrandUpdateAliasesRelationInput"];
	["BrandAliasWithoutBrandUpdateInput"]: GraphQLTypes["BrandAliasWithoutBrandUpdateInput"];
	["BrandUpsertAliasesRelationInput"]: GraphQLTypes["BrandUpsertAliasesRelationInput"];
	["BrandUpdateAdsEntityRelationInput"]: GraphQLTypes["BrandUpdateAdsEntityRelationInput"];
	["BrandUpdateAdsRelationInput"]: GraphQLTypes["BrandUpdateAdsRelationInput"];
	["AdWithoutBrandsUpdateInput"]: GraphQLTypes["AdWithoutBrandsUpdateInput"];
	["AdUpdateContentReferencesEntityRelationInput"]: GraphQLTypes["AdUpdateContentReferencesEntityRelationInput"];
	["AdUpdateContentReferencesRelationInput"]: GraphQLTypes["AdUpdateContentReferencesRelationInput"];
	["ContentReferenceWithoutAdUpdateInput"]: GraphQLTypes["ContentReferenceWithoutAdUpdateInput"];
	["ContentReferenceUpdateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesUpdateInput"]: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"];
	["ContentBlockUpdateContentEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"];
	["ContentWithoutBlocksUpdateInput"]: GraphQLTypes["ContentWithoutBlocksUpdateInput"];
	["ContentBlockUpsertContentRelationInput"]: GraphQLTypes["ContentBlockUpsertContentRelationInput"];
	["ContentReferenceUpsertBlockRelationInput"]: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"];
	["ContentReferenceUpdateRelatedBrandEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateRelatedBrandEntityRelationInput"];
	["BrandUpdateInput"]: GraphQLTypes["BrandUpdateInput"];
	["BrandUpdateFlavorsEntityRelationInput"]: GraphQLTypes["BrandUpdateFlavorsEntityRelationInput"];
	["BrandUpdateSeoEntityRelationInput"]: GraphQLTypes["BrandUpdateSeoEntityRelationInput"];
	["BrandUpsertSeoRelationInput"]: GraphQLTypes["BrandUpsertSeoRelationInput"];
	["BrandUpdateFilterCombosEntityRelationInput"]: GraphQLTypes["BrandUpdateFilterCombosEntityRelationInput"];
	["BrandUpdateFilterCombosRelationInput"]: GraphQLTypes["BrandUpdateFilterCombosRelationInput"];
	["FilterComboWithoutBrandUpdateInput"]: GraphQLTypes["FilterComboWithoutBrandUpdateInput"];
	["FilterComboUpdateRegionEntityRelationInput"]: GraphQLTypes["FilterComboUpdateRegionEntityRelationInput"];
	["RegionWithoutFilterCombosUpdateInput"]: GraphQLTypes["RegionWithoutFilterCombosUpdateInput"];
	["RegionUpdateCountriesEntityRelationInput"]: GraphQLTypes["RegionUpdateCountriesEntityRelationInput"];
	["RegionUpdateCountriesRelationInput"]: GraphQLTypes["RegionUpdateCountriesRelationInput"];
	["CountryWithoutRegionUpdateInput"]: GraphQLTypes["CountryWithoutRegionUpdateInput"];
	["RegionUpsertCountriesRelationInput"]: GraphQLTypes["RegionUpsertCountriesRelationInput"];
	["FilterComboUpsertRegionRelationInput"]: GraphQLTypes["FilterComboUpsertRegionRelationInput"];
	["FilterComboUpdateAgeCategoryEntityRelationInput"]: GraphQLTypes["FilterComboUpdateAgeCategoryEntityRelationInput"];
	["AgeCategoryWithoutFilterCombosUpdateInput"]: GraphQLTypes["AgeCategoryWithoutFilterCombosUpdateInput"];
	["AgeCategoryUpdateProductsEntityRelationInput"]: GraphQLTypes["AgeCategoryUpdateProductsEntityRelationInput"];
	["AgeCategoryUpdateProductsRelationInput"]: GraphQLTypes["AgeCategoryUpdateProductsRelationInput"];
	["ProductWithoutAgeCategoriesUpdateInput"]: GraphQLTypes["ProductWithoutAgeCategoriesUpdateInput"];
	["ProductUpdateAliasesEntityRelationInput"]: GraphQLTypes["ProductUpdateAliasesEntityRelationInput"];
	["ProductUpdateAliasesRelationInput"]: GraphQLTypes["ProductUpdateAliasesRelationInput"];
	["ProductAliasWithoutProductUpdateInput"]: GraphQLTypes["ProductAliasWithoutProductUpdateInput"];
	["ProductUpsertAliasesRelationInput"]: GraphQLTypes["ProductUpsertAliasesRelationInput"];
	["ProductUpdateEvaluationEntityRelationInput"]: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"];
	["ProductEvaluationWithoutProductUpdateInput"]: GraphQLTypes["ProductEvaluationWithoutProductUpdateInput"];
	["ProductUpsertEvaluationRelationInput"]: GraphQLTypes["ProductUpsertEvaluationRelationInput"];
	["ProductUpdateSeoEntityRelationInput"]: GraphQLTypes["ProductUpdateSeoEntityRelationInput"];
	["ProductUpsertSeoRelationInput"]: GraphQLTypes["ProductUpsertSeoRelationInput"];
	["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]: GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"];
	["ProductUpdateHeurekaImageEntityRelationInput"]: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"];
	["ProductUpsertHeurekaImageRelationInput"]: GraphQLTypes["ProductUpsertHeurekaImageRelationInput"];
	["ProductUpdateTopxEntityRelationInput"]: GraphQLTypes["ProductUpdateTopxEntityRelationInput"];
	["ProductUpdateTopxRelationInput"]: GraphQLTypes["ProductUpdateTopxRelationInput"];
	["TOPXProductWithoutProductUpdateInput"]: GraphQLTypes["TOPXProductWithoutProductUpdateInput"];
	["TOPXProductUpdateCategoryEntityRelationInput"]: GraphQLTypes["TOPXProductUpdateCategoryEntityRelationInput"];
	["TOPXProductCategoryWithoutProductsUpdateInput"]: GraphQLTypes["TOPXProductCategoryWithoutProductsUpdateInput"];
	["TOPXProductUpsertCategoryRelationInput"]: GraphQLTypes["TOPXProductUpsertCategoryRelationInput"];
	["ProductUpsertTopxRelationInput"]: GraphQLTypes["ProductUpsertTopxRelationInput"];
	["AgeCategoryUpsertProductsRelationInput"]: GraphQLTypes["AgeCategoryUpsertProductsRelationInput"];
	["FilterComboUpsertAgeCategoryRelationInput"]: GraphQLTypes["FilterComboUpsertAgeCategoryRelationInput"];
	["FilterComboUpdateTreatmentEntityRelationInput"]: GraphQLTypes["FilterComboUpdateTreatmentEntityRelationInput"];
	["BodyTagWithoutFilterCombosUpdateInput"]: GraphQLTypes["BodyTagWithoutFilterCombosUpdateInput"];
	["BodyTagUpdateIconEntityRelationInput"]: GraphQLTypes["BodyTagUpdateIconEntityRelationInput"];
	["BodyTagUpsertIconRelationInput"]: GraphQLTypes["BodyTagUpsertIconRelationInput"];
	["BodyTagUpdateDogsEntityRelationInput"]: GraphQLTypes["BodyTagUpdateDogsEntityRelationInput"];
	["BodyTagUpdateDogsRelationInput"]: GraphQLTypes["BodyTagUpdateDogsRelationInput"];
	["DogWithoutIllnessesUpdateInput"]: GraphQLTypes["DogWithoutIllnessesUpdateInput"];
	["DogUpdateAvatarEntityRelationInput"]: GraphQLTypes["DogUpdateAvatarEntityRelationInput"];
	["DogUpsertAvatarRelationInput"]: GraphQLTypes["DogUpsertAvatarRelationInput"];
	["BodyTagUpsertDogsRelationInput"]: GraphQLTypes["BodyTagUpsertDogsRelationInput"];
	["FilterComboUpsertTreatmentRelationInput"]: GraphQLTypes["FilterComboUpsertTreatmentRelationInput"];
	["FilterComboUpdateFlavorEntityRelationInput"]: GraphQLTypes["FilterComboUpdateFlavorEntityRelationInput"];
	["ItemSubCategoryWithoutFilterCombosFlavorUpdateInput"]: GraphQLTypes["ItemSubCategoryWithoutFilterCombosFlavorUpdateInput"];
	["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"];
	["ItemSubCategoryUpdateFilterCombosAllergyRelationInput"]: GraphQLTypes["ItemSubCategoryUpdateFilterCombosAllergyRelationInput"];
	["FilterComboWithoutAllergyUpdateInput"]: GraphQLTypes["FilterComboWithoutAllergyUpdateInput"];
	["ItemSubCategoryUpsertFilterCombosAllergyRelationInput"]: GraphQLTypes["ItemSubCategoryUpsertFilterCombosAllergyRelationInput"];
	["FilterComboUpsertFlavorRelationInput"]: GraphQLTypes["FilterComboUpsertFlavorRelationInput"];
	["FilterComboUpdateAllergyEntityRelationInput"]: GraphQLTypes["FilterComboUpdateAllergyEntityRelationInput"];
	["ItemSubCategoryWithoutFilterCombosAllergyUpdateInput"]: GraphQLTypes["ItemSubCategoryWithoutFilterCombosAllergyUpdateInput"];
	["FilterComboUpsertAllergyRelationInput"]: GraphQLTypes["FilterComboUpsertAllergyRelationInput"];
	["BrandUpsertFilterCombosRelationInput"]: GraphQLTypes["BrandUpsertFilterCombosRelationInput"];
	["BrandUpdateTopxEntityRelationInput"]: GraphQLTypes["BrandUpdateTopxEntityRelationInput"];
	["BrandUpdateTopxRelationInput"]: GraphQLTypes["BrandUpdateTopxRelationInput"];
	["TOPXBrandWithoutBrandUpdateInput"]: GraphQLTypes["TOPXBrandWithoutBrandUpdateInput"];
	["TOPXBrandUpdateCategoryEntityRelationInput"]: GraphQLTypes["TOPXBrandUpdateCategoryEntityRelationInput"];
	["TOPXBrandCategoryWithoutBrandsUpdateInput"]: GraphQLTypes["TOPXBrandCategoryWithoutBrandsUpdateInput"];
	["TOPXBrandUpsertCategoryRelationInput"]: GraphQLTypes["TOPXBrandUpsertCategoryRelationInput"];
	["BrandUpsertTopxRelationInput"]: GraphQLTypes["BrandUpsertTopxRelationInput"];
	["BrandUpdateContentEntityRelationInput"]: GraphQLTypes["BrandUpdateContentEntityRelationInput"];
	["BrandUpsertContentRelationInput"]: GraphQLTypes["BrandUpsertContentRelationInput"];
	["BrandUpdateDraftEntityRelationInput"]: GraphQLTypes["BrandUpdateDraftEntityRelationInput"];
	["BrandUpsertDraftRelationInput"]: GraphQLTypes["BrandUpsertDraftRelationInput"];
	["ContentReferenceUpsertRelatedBrandRelationInput"]: GraphQLTypes["ContentReferenceUpsertRelatedBrandRelationInput"];
	["ContentReferenceUpdateRelatedProductEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateRelatedProductEntityRelationInput"];
	["ProductUpdateInput"]: GraphQLTypes["ProductUpdateInput"];
	["ProductUpdateAgeCategoriesEntityRelationInput"]: GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"];
	["ProductUpdateAgeCategoriesRelationInput"]: GraphQLTypes["ProductUpdateAgeCategoriesRelationInput"];
	["AgeCategoryWithoutProductsUpdateInput"]: GraphQLTypes["AgeCategoryWithoutProductsUpdateInput"];
	["AgeCategoryUpdateFilterCombosEntityRelationInput"]: GraphQLTypes["AgeCategoryUpdateFilterCombosEntityRelationInput"];
	["AgeCategoryUpdateFilterCombosRelationInput"]: GraphQLTypes["AgeCategoryUpdateFilterCombosRelationInput"];
	["FilterComboWithoutAgeCategoryUpdateInput"]: GraphQLTypes["FilterComboWithoutAgeCategoryUpdateInput"];
	["AgeCategoryUpsertFilterCombosRelationInput"]: GraphQLTypes["AgeCategoryUpsertFilterCombosRelationInput"];
	["ProductUpsertAgeCategoriesRelationInput"]: GraphQLTypes["ProductUpsertAgeCategoriesRelationInput"];
	["ContentReferenceUpsertRelatedProductRelationInput"]: GraphQLTypes["ContentReferenceUpsertRelatedProductRelationInput"];
	["ContentReferenceUpdateRelatedIngredientEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateRelatedIngredientEntityRelationInput"];
	["ItemUpdateInput"]: GraphQLTypes["ItemUpdateInput"];
	["ItemUpdateDeclensionFourthEntityRelationInput"]: GraphQLTypes["ItemUpdateDeclensionFourthEntityRelationInput"];
	["ItemDeclensionFourthVariantWithoutItemsUpdateInput"]: GraphQLTypes["ItemDeclensionFourthVariantWithoutItemsUpdateInput"];
	["ItemDeclensionFourthVariantUpdateCategoryEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpdateCategoryEntityRelationInput"];
	["ItemCategoryWithoutDeclensionsFourthUpdateInput"]: GraphQLTypes["ItemCategoryWithoutDeclensionsFourthUpdateInput"];
	["ItemCategoryUpdateSeoEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateSeoEntityRelationInput"];
	["ItemCategoryUpsertSeoRelationInput"]: GraphQLTypes["ItemCategoryUpsertSeoRelationInput"];
	["ItemCategoryUpdateGroupEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateGroupEntityRelationInput"];
	["ItemGroupWithoutCategoriesUpdateInput"]: GraphQLTypes["ItemGroupWithoutCategoriesUpdateInput"];
	["ItemCategoryUpsertGroupRelationInput"]: GraphQLTypes["ItemCategoryUpsertGroupRelationInput"];
	["ItemCategoryUpdateContentEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateContentEntityRelationInput"];
	["ItemCategoryUpsertContentRelationInput"]: GraphQLTypes["ItemCategoryUpsertContentRelationInput"];
	["ItemCategoryUpdateDraftEntityRelationInput"]: GraphQLTypes["ItemCategoryUpdateDraftEntityRelationInput"];
	["ItemCategoryUpsertDraftRelationInput"]: GraphQLTypes["ItemCategoryUpsertDraftRelationInput"];
	["ItemDeclensionFourthVariantUpsertCategoryRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpsertCategoryRelationInput"];
	["ItemDeclensionFourthVariantUpdateElementEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpdateElementEntityRelationInput"];
	["ElementUpdateInput"]: GraphQLTypes["ElementUpdateInput"];
	["ItemDeclensionFourthVariantUpsertElementRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpsertElementRelationInput"];
	["ItemDeclensionFourthVariantUpdateProductsEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpdateProductsEntityRelationInput"];
	["ItemDeclensionFourthVariantUpdateContentEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpdateContentEntityRelationInput"];
	["ItemDeclensionFourthVariantUpsertContentRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpsertContentRelationInput"];
	["ItemDeclensionFourthVariantUpdateDraftEntityRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpdateDraftEntityRelationInput"];
	["ItemDeclensionFourthVariantUpsertDraftRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpsertDraftRelationInput"];
	["ItemUpsertDeclensionFourthRelationInput"]: GraphQLTypes["ItemUpsertDeclensionFourthRelationInput"];
	["ContentReferenceUpsertRelatedIngredientRelationInput"]: GraphQLTypes["ContentReferenceUpsertRelatedIngredientRelationInput"];
	["ContentReferenceUpdateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"];
	["LinkUpdateInput"]: GraphQLTypes["LinkUpdateInput"];
	["ContentReferenceUpsertLinkRelationInput"]: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"];
	["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"];
	["ContentReferenceUpsertRelatedBrandFullRelationInput"]: GraphQLTypes["ContentReferenceUpsertRelatedBrandFullRelationInput"];
	["ContentReferenceUpdateRelatedProductFullEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateRelatedProductFullEntityRelationInput"];
	["ContentReferenceUpsertRelatedProductFullRelationInput"]: GraphQLTypes["ContentReferenceUpsertRelatedProductFullRelationInput"];
	["ContentReferenceUpdateListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateListEntityRelationInput"];
	["ContentReferenceUpdateListRelationInput"]: GraphQLTypes["ContentReferenceUpdateListRelationInput"];
	["ContentReferenceListWithoutListUpdateInput"]: GraphQLTypes["ContentReferenceListWithoutListUpdateInput"];
	["ContentReferenceListUpdateRelatedProductEntityRelationInput"]: GraphQLTypes["ContentReferenceListUpdateRelatedProductEntityRelationInput"];
	["ContentReferenceListUpsertRelatedProductRelationInput"]: GraphQLTypes["ContentReferenceListUpsertRelatedProductRelationInput"];
	["ContentReferenceListUpdateRelatedBrandEntityRelationInput"]: GraphQLTypes["ContentReferenceListUpdateRelatedBrandEntityRelationInput"];
	["ContentReferenceListUpsertRelatedBrandRelationInput"]: GraphQLTypes["ContentReferenceListUpsertRelatedBrandRelationInput"];
	["ContentReferenceUpsertListRelationInput"]: GraphQLTypes["ContentReferenceUpsertListRelationInput"];
	["ContentReferenceUpdateOutlineEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateOutlineEntityRelationInput"];
	["ContentLinksUpdateInput"]: GraphQLTypes["ContentLinksUpdateInput"];
	["ContentLinksUpdateItemsEntityRelationInput"]: GraphQLTypes["ContentLinksUpdateItemsEntityRelationInput"];
	["ContentLinksUpdateItemsRelationInput"]: GraphQLTypes["ContentLinksUpdateItemsRelationInput"];
	["ContentLinksItemWithoutListUpdateInput"]: GraphQLTypes["ContentLinksItemWithoutListUpdateInput"];
	["ContentLinksUpsertItemsRelationInput"]: GraphQLTypes["ContentLinksUpsertItemsRelationInput"];
	["ContentReferenceUpsertOutlineRelationInput"]: GraphQLTypes["ContentReferenceUpsertOutlineRelationInput"];
	["ContentReferenceUpdateVideoEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateVideoEntityRelationInput"];
	["VideoUpdateInput"]: GraphQLTypes["VideoUpdateInput"];
	["VideoUpdatePosterEntityRelationInput"]: GraphQLTypes["VideoUpdatePosterEntityRelationInput"];
	["VideoUpsertPosterRelationInput"]: GraphQLTypes["VideoUpsertPosterRelationInput"];
	["ContentReferenceUpsertVideoRelationInput"]: GraphQLTypes["ContentReferenceUpsertVideoRelationInput"];
	["ContentReferenceUpdateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"];
	["ContentReferenceImageUpdateInput"]: GraphQLTypes["ContentReferenceImageUpdateInput"];
	["ContentReferenceImageUpdateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceImageUpdateImageEntityRelationInput"];
	["ContentReferenceImageUpsertImageRelationInput"]: GraphQLTypes["ContentReferenceImageUpsertImageRelationInput"];
	["ContentReferenceUpsertImageRelationInput"]: GraphQLTypes["ContentReferenceUpsertImageRelationInput"];
	["AdUpsertContentReferencesRelationInput"]: GraphQLTypes["AdUpsertContentReferencesRelationInput"];
	["BrandUpsertAdsRelationInput"]: GraphQLTypes["BrandUpsertAdsRelationInput"];
	["CountryUpsertBrandsRelationInput"]: GraphQLTypes["CountryUpsertBrandsRelationInput"];
	["CountryUpdateRegionEntityRelationInput"]: GraphQLTypes["CountryUpdateRegionEntityRelationInput"];
	["RegionWithoutCountriesUpdateInput"]: GraphQLTypes["RegionWithoutCountriesUpdateInput"];
	["RegionUpdateFilterCombosEntityRelationInput"]: GraphQLTypes["RegionUpdateFilterCombosEntityRelationInput"];
	["RegionUpdateFilterCombosRelationInput"]: GraphQLTypes["RegionUpdateFilterCombosRelationInput"];
	["FilterComboWithoutRegionUpdateInput"]: GraphQLTypes["FilterComboWithoutRegionUpdateInput"];
	["RegionUpsertFilterCombosRelationInput"]: GraphQLTypes["RegionUpsertFilterCombosRelationInput"];
	["CountryUpsertRegionRelationInput"]: GraphQLTypes["CountryUpsertRegionRelationInput"];
	["BrandManufacturerUpsertResidenceRelationInput"]: GraphQLTypes["BrandManufacturerUpsertResidenceRelationInput"];
	["BrandUpsertManufacturersRelationInput"]: GraphQLTypes["BrandUpsertManufacturersRelationInput"];
	["ProductUpsertBrandRelationInput"]: GraphQLTypes["ProductUpsertBrandRelationInput"];
	["ProductLineUpsertProductsRelationInput"]: GraphQLTypes["ProductLineUpsertProductsRelationInput"];
	["ProductLineUpdateLogoEntityRelationInput"]: GraphQLTypes["ProductLineUpdateLogoEntityRelationInput"];
	["ProductLineUpsertLogoRelationInput"]: GraphQLTypes["ProductLineUpsertLogoRelationInput"];
	["ProductLineUpdateAliasesEntityRelationInput"]: GraphQLTypes["ProductLineUpdateAliasesEntityRelationInput"];
	["ProductLineUpdateAliasesRelationInput"]: GraphQLTypes["ProductLineUpdateAliasesRelationInput"];
	["ProductLineAliasWithoutProductLinesUpdateInput"]: GraphQLTypes["ProductLineAliasWithoutProductLinesUpdateInput"];
	["ProductLineUpsertAliasesRelationInput"]: GraphQLTypes["ProductLineUpsertAliasesRelationInput"];
	["ProductLineUpdateFlavorsEntityRelationInput"]: GraphQLTypes["ProductLineUpdateFlavorsEntityRelationInput"];
	["ProductLineUpdateSeoEntityRelationInput"]: GraphQLTypes["ProductLineUpdateSeoEntityRelationInput"];
	["ProductLineUpsertSeoRelationInput"]: GraphQLTypes["ProductLineUpsertSeoRelationInput"];
	["BrandUpsertProductLinesRelationInput"]: GraphQLTypes["BrandUpsertProductLinesRelationInput"];
	["BrandManufacturerUpsertBrandsRelationInput"]: GraphQLTypes["BrandManufacturerUpsertBrandsRelationInput"];
	["CountryUpsertManufacturersRelationInput"]: GraphQLTypes["CountryUpsertManufacturersRelationInput"];
	["BrandUpsertCountriesOfProductionRelationInput"]: GraphQLTypes["BrandUpsertCountriesOfProductionRelationInput"];
	["FilterComboUpsertBrandRelationInput"]: GraphQLTypes["FilterComboUpsertBrandRelationInput"];
	["BreedUpsertFilterCombosRelationInput"]: GraphQLTypes["BreedUpsertFilterCombosRelationInput"];
	["BlogPostReviewUpsertBreedRelationInput"]: GraphQLTypes["BlogPostReviewUpsertBreedRelationInput"];
	["AgeUpsertBlogPostReviewsRelationInput"]: GraphQLTypes["AgeUpsertBlogPostReviewsRelationInput"];
	["SuitabilityCategoryUpsertDogAgesRelationInput"]: GraphQLTypes["SuitabilityCategoryUpsertDogAgesRelationInput"];
	["DogSizeUpsertSuitabilityCategoryRelationInput"]: GraphQLTypes["DogSizeUpsertSuitabilityCategoryRelationInput"];
	["BreedUpsertSizeRelationInput"]: GraphQLTypes["BreedUpsertSizeRelationInput"];
	["ProductReviewUpsertBreedRelationInput"]: GraphQLTypes["ProductReviewUpsertBreedRelationInput"];
	["AgeUpsertProductReviewsRelationInput"]: GraphQLTypes["AgeUpsertProductReviewsRelationInput"];
	["BlogPostReviewUpsertAgeRelationInput"]: GraphQLTypes["BlogPostReviewUpsertAgeRelationInput"];
	["BreedUpsertBlogPostReviewsRelationInput"]: GraphQLTypes["BreedUpsertBlogPostReviewsRelationInput"];
	["SuitabilityCategoryUpsertBreedsRelationInput"]: GraphQLTypes["SuitabilityCategoryUpsertBreedsRelationInput"];
	["AgeUpsertSuitabilityCategoriesRelationInput"]: GraphQLTypes["AgeUpsertSuitabilityCategoriesRelationInput"];
	["ProductReviewUpsertAgeRelationInput"]: GraphQLTypes["ProductReviewUpsertAgeRelationInput"];
	["BreedUpsertProductReviewsRelationInput"]: GraphQLTypes["BreedUpsertProductReviewsRelationInput"];
	["FilterComboUpsertBreedRelationInput"]: GraphQLTypes["FilterComboUpsertBreedRelationInput"];
	["ItemSubCategoryUpsertFilterCombosFlavorRelationInput"]: GraphQLTypes["ItemSubCategoryUpsertFilterCombosFlavorRelationInput"];
	["DogUpsertAllergiesRelationInput"]: GraphQLTypes["DogUpsertAllergiesRelationInput"];
	["DogUpdateIllnessesEntityRelationInput"]: GraphQLTypes["DogUpdateIllnessesEntityRelationInput"];
	["DogUpdateIllnessesRelationInput"]: GraphQLTypes["DogUpdateIllnessesRelationInput"];
	["BodyTagWithoutDogsUpdateInput"]: GraphQLTypes["BodyTagWithoutDogsUpdateInput"];
	["BodyTagUpdateFilterCombosEntityRelationInput"]: GraphQLTypes["BodyTagUpdateFilterCombosEntityRelationInput"];
	["BodyTagUpdateFilterCombosRelationInput"]: GraphQLTypes["BodyTagUpdateFilterCombosRelationInput"];
	["FilterComboWithoutTreatmentUpdateInput"]: GraphQLTypes["FilterComboWithoutTreatmentUpdateInput"];
	["BodyTagUpsertFilterCombosRelationInput"]: GraphQLTypes["BodyTagUpsertFilterCombosRelationInput"];
	["DogUpsertIllnessesRelationInput"]: GraphQLTypes["DogUpsertIllnessesRelationInput"];
	["DogActivityUpsertDogsRelationInput"]: GraphQLTypes["DogActivityUpsertDogsRelationInput"];
	["DogActivityUpdateSuitabilityCategoryEntityRelationInput"]: GraphQLTypes["DogActivityUpdateSuitabilityCategoryEntityRelationInput"];
	["SuitabilityCategoryWithoutDogActivitiesUpdateInput"]: GraphQLTypes["SuitabilityCategoryWithoutDogActivitiesUpdateInput"];
	["DogActivityUpsertSuitabilityCategoryRelationInput"]: GraphQLTypes["DogActivityUpsertSuitabilityCategoryRelationInput"];
	["ProductUpsertRecommendedActivityRelationInput"]: GraphQLTypes["ProductUpsertRecommendedActivityRelationInput"];
	["BrandUpsertProductsRelationInput"]: GraphQLTypes["BrandUpsertProductsRelationInput"];
	["ProductLineUpsertBrandRelationInput"]: GraphQLTypes["ProductLineUpsertBrandRelationInput"];
	["ProductUpsertProductLineRelationInput"]: GraphQLTypes["ProductUpsertProductLineRelationInput"];
	["DogSizeUpsertProductsRelationInput"]: GraphQLTypes["DogSizeUpsertProductsRelationInput"];
	["SuitabilityCategoryUpsertDogSizesRelationInput"]: GraphQLTypes["SuitabilityCategoryUpsertDogSizesRelationInput"];
	["BreedUpsertSuitabilityCategoryRelationInput"]: GraphQLTypes["BreedUpsertSuitabilityCategoryRelationInput"];
	["DogSizeUpsertBreedsRelationInput"]: GraphQLTypes["DogSizeUpsertBreedsRelationInput"];
	["ProductUpsertRecommendedDogSizesRelationInput"]: GraphQLTypes["ProductUpsertRecommendedDogSizesRelationInput"];
	["DogUpsertFedProductRelationInput"]: GraphQLTypes["DogUpsertFedProductRelationInput"];
	["ItemSubCategoryUpsertDogsRelationInput"]: GraphQLTypes["ItemSubCategoryUpsertDogsRelationInput"];
	["ItemDeclensionFourthVariantUpsertSubcategoryRelationInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpsertSubcategoryRelationInput"];
	["ItemCategoryUpsertDeclensionsFourthRelationInput"]: GraphQLTypes["ItemCategoryUpsertDeclensionsFourthRelationInput"];
	["ItemSubCategoryUpsertCategoryRelationInput"]: GraphQLTypes["ItemSubCategoryUpsertCategoryRelationInput"];
	["ProductFeatureUpsertDependentSubCategoryRelationInput"]: GraphQLTypes["ProductFeatureUpsertDependentSubCategoryRelationInput"];
	["ProductFeatureUpdateDependentFlagEntityRelationInput"]: GraphQLTypes["ProductFeatureUpdateDependentFlagEntityRelationInput"];
	["ProductFlagWithoutProductFeaturesUpdateInput"]: GraphQLTypes["ProductFlagWithoutProductFeaturesUpdateInput"];
	["ProductFlagUpdateProductsEntityRelationInput"]: GraphQLTypes["ProductFlagUpdateProductsEntityRelationInput"];
	["ProductFlagUpdateProductsRelationInput"]: GraphQLTypes["ProductFlagUpdateProductsRelationInput"];
	["ProductFlagOfProductWithoutFlagUpdateInput"]: GraphQLTypes["ProductFlagOfProductWithoutFlagUpdateInput"];
	["ProductFlagOfProductUpdateProductEntityRelationInput"]: GraphQLTypes["ProductFlagOfProductUpdateProductEntityRelationInput"];
	["ProductWithoutFlagsUpdateInput"]: GraphQLTypes["ProductWithoutFlagsUpdateInput"];
	["ProductFlagOfProductUpsertProductRelationInput"]: GraphQLTypes["ProductFlagOfProductUpsertProductRelationInput"];
	["ProductFlagUpsertProductsRelationInput"]: GraphQLTypes["ProductFlagUpsertProductsRelationInput"];
	["ProductFeatureUpsertDependentFlagRelationInput"]: GraphQLTypes["ProductFeatureUpsertDependentFlagRelationInput"];
	["ItemCategoryUpsertFeatureDependenciesRelationInput"]: GraphQLTypes["ItemCategoryUpsertFeatureDependenciesRelationInput"];
	["RedirectUpsertItemCategoryRelationInput"]: GraphQLTypes["RedirectUpsertItemCategoryRelationInput"];
	["BrandsPageUpsertRedirectsRelationInput"]: GraphQLTypes["BrandsPageUpsertRedirectsRelationInput"];
	["SeoUpsertBrandsPageRelationInput"]: GraphQLTypes["SeoUpsertBrandsPageRelationInput"];
	["BlogPostUpsertSeoRelationInput"]: GraphQLTypes["BlogPostUpsertSeoRelationInput"];
	["BlogPostUpdateRedirectsEntityRelationInput"]: GraphQLTypes["BlogPostUpdateRedirectsEntityRelationInput"];
	["BlogPostUpdateRedirectsRelationInput"]: GraphQLTypes["BlogPostUpdateRedirectsRelationInput"];
	["RedirectWithoutBlogPostUpdateInput"]: GraphQLTypes["RedirectWithoutBlogPostUpdateInput"];
	["BlogPostUpsertRedirectsRelationInput"]: GraphQLTypes["BlogPostUpsertRedirectsRelationInput"];
	["AdUpsertBlogPostsRelationInput"]: GraphQLTypes["AdUpsertBlogPostsRelationInput"];
	["AdUpdateBrandsEntityRelationInput"]: GraphQLTypes["AdUpdateBrandsEntityRelationInput"];
	["AdUpdateBrandsRelationInput"]: GraphQLTypes["AdUpdateBrandsRelationInput"];
	["BrandWithoutAdsUpdateInput"]: GraphQLTypes["BrandWithoutAdsUpdateInput"];
	["AdUpsertBrandsRelationInput"]: GraphQLTypes["AdUpsertBrandsRelationInput"];
	["ItemCategoryUpsertAdsRelationInput"]: GraphQLTypes["ItemCategoryUpsertAdsRelationInput"];
	["ProductFeatureUpsertDependentCategoryRelationInput"]: GraphQLTypes["ProductFeatureUpsertDependentCategoryRelationInput"];
	["ElementUpsertFeatureDependenciesRelationInput"]: GraphQLTypes["ElementUpsertFeatureDependenciesRelationInput"];
	["ElementOfProductUpsertElementRelationInput"]: GraphQLTypes["ElementOfProductUpsertElementRelationInput"];
	["ProductUpsertElementsRelationInput"]: GraphQLTypes["ProductUpsertElementsRelationInput"];
	["ItemCategoryUpsertProductsRelationInput"]: GraphQLTypes["ItemCategoryUpsertProductsRelationInput"];
	["AdUpsertItemCategoriesRelationInput"]: GraphQLTypes["AdUpsertItemCategoriesRelationInput"];
	["BlogPostUpsertAdsRelationInput"]: GraphQLTypes["BlogPostUpsertAdsRelationInput"];
	["UserUpsertBlogPostsRelationInput"]: GraphQLTypes["UserUpsertBlogPostsRelationInput"];
	["UserUpdateAvatarEntityRelationInput"]: GraphQLTypes["UserUpdateAvatarEntityRelationInput"];
	["UserUpsertAvatarRelationInput"]: GraphQLTypes["UserUpsertAvatarRelationInput"];
	["UserUpdateContactFormMessagesEntityRelationInput"]: GraphQLTypes["UserUpdateContactFormMessagesEntityRelationInput"];
	["UserUpdateContactFormMessagesRelationInput"]: GraphQLTypes["UserUpdateContactFormMessagesRelationInput"];
	["ContactFormMessageWithoutUserUpdateInput"]: GraphQLTypes["ContactFormMessageWithoutUserUpdateInput"];
	["UserUpsertContactFormMessagesRelationInput"]: GraphQLTypes["UserUpsertContactFormMessagesRelationInput"];
	["UserUpdateBugReportsEntityRelationInput"]: GraphQLTypes["UserUpdateBugReportsEntityRelationInput"];
	["UserUpdateBugReportsRelationInput"]: GraphQLTypes["UserUpdateBugReportsRelationInput"];
	["BugReportWithoutUserUpdateInput"]: GraphQLTypes["BugReportWithoutUserUpdateInput"];
	["UserUpsertBugReportsRelationInput"]: GraphQLTypes["UserUpsertBugReportsRelationInput"];
	["UserUpdateProtectedActionsEntityRelationInput"]: GraphQLTypes["UserUpdateProtectedActionsEntityRelationInput"];
	["UserUpdateProtectedActionsRelationInput"]: GraphQLTypes["UserUpdateProtectedActionsRelationInput"];
	["ProtectedActionWithoutUserUpdateInput"]: GraphQLTypes["ProtectedActionWithoutUserUpdateInput"];
	["UserUpsertProtectedActionsRelationInput"]: GraphQLTypes["UserUpsertProtectedActionsRelationInput"];
	["UserUpdateTenantPersonEntityRelationInput"]: GraphQLTypes["UserUpdateTenantPersonEntityRelationInput"];
	["ProductReviewUpsertUserRelationInput"]: GraphQLTypes["ProductReviewUpsertUserRelationInput"];
	["ProductReviewReactionUpsertProductReviewRelationInput"]: GraphQLTypes["ProductReviewReactionUpsertProductReviewRelationInput"];
	["UserUpsertProductReviewReactionsRelationInput"]: GraphQLTypes["UserUpsertProductReviewReactionsRelationInput"];
	["BlogPostReviewUpsertUserRelationInput"]: GraphQLTypes["BlogPostReviewUpsertUserRelationInput"];
	["BlogPostReviewReactionUpsertBlogPostReviewRelationInput"]: GraphQLTypes["BlogPostReviewReactionUpsertBlogPostReviewRelationInput"];
	["UserUpsertBlogPostReviewReactionsRelationInput"]: GraphQLTypes["UserUpsertBlogPostReviewReactionsRelationInput"];
	["BlogPostUpsertUserRelationInput"]: GraphQLTypes["BlogPostUpsertUserRelationInput"];
	["ItemUpsertBlogPostRelationInput"]: GraphQLTypes["ItemUpsertBlogPostRelationInput"];
	["ItemCategoryUpsertItemsRelationInput"]: GraphQLTypes["ItemCategoryUpsertItemsRelationInput"];
	["ProductUpsertItemCategoriesRelationInput"]: GraphQLTypes["ProductUpsertItemCategoriesRelationInput"];
	["NutritionalValueOfProductUpsertProductRelationInput"]: GraphQLTypes["NutritionalValueOfProductUpsertProductRelationInput"];
	["NutritionalValueUpsertProductsRelationInput"]: GraphQLTypes["NutritionalValueUpsertProductsRelationInput"];
	["NutritionalValueUpdateIconEntityRelationInput"]: GraphQLTypes["NutritionalValueUpdateIconEntityRelationInput"];
	["NutritionalValueUpsertIconRelationInput"]: GraphQLTypes["NutritionalValueUpsertIconRelationInput"];
	["SuitabilityItemUpsertNutritionalValueRelationInput"]: GraphQLTypes["SuitabilityItemUpsertNutritionalValueRelationInput"];
	["SuitabilityItemUpdateCategoryEntityRelationInput"]: GraphQLTypes["SuitabilityItemUpdateCategoryEntityRelationInput"];
	["SuitabilityCategoryWithoutSuitabilityItemsUpdateInput"]: GraphQLTypes["SuitabilityCategoryWithoutSuitabilityItemsUpdateInput"];
	["SuitabilityItemUpsertCategoryRelationInput"]: GraphQLTypes["SuitabilityItemUpsertCategoryRelationInput"];
	["ElementUpsertSuitabilityElementsRelationInput"]: GraphQLTypes["ElementUpsertSuitabilityElementsRelationInput"];
	["ProductFeatureUpsertDependentElementRelationInput"]: GraphQLTypes["ProductFeatureUpsertDependentElementRelationInput"];
	["ItemUpsertFeaturesOfProductRelationInput"]: GraphQLTypes["ItemUpsertFeaturesOfProductRelationInput"];
	["BlogPostUpsertItemsRelationInput"]: GraphQLTypes["BlogPostUpsertItemsRelationInput"];
	["ItemCategoryUpsertBlogPostsRelationInput"]: GraphQLTypes["ItemCategoryUpsertBlogPostsRelationInput"];
	["ItemUpsertCategoriesRelationInput"]: GraphQLTypes["ItemUpsertCategoriesRelationInput"];
	["ProductFeatureUpsertLinkItemRelationInput"]: GraphQLTypes["ProductFeatureUpsertLinkItemRelationInput"];
	["ItemSubCategoryUpsertFeatureDependenciesRelationInput"]: GraphQLTypes["ItemSubCategoryUpsertFeatureDependenciesRelationInput"];
	["ProductUpsertItemSubCategoriesRelationInput"]: GraphQLTypes["ProductUpsertItemSubCategoriesRelationInput"];
	["DogActivityUpsertProductsRelationInput"]: GraphQLTypes["DogActivityUpsertProductsRelationInput"];
	["DogUpsertActivityRelationInput"]: GraphQLTypes["DogUpsertActivityRelationInput"];
	["BreedUpsertDogsRelationInput"]: GraphQLTypes["BreedUpsertDogsRelationInput"];
	["AgeUpsertBreedsRelationInput"]: GraphQLTypes["AgeUpsertBreedsRelationInput"];
	["DogUpsertAgeRelationInput"]: GraphQLTypes["DogUpsertAgeRelationInput"];
	["ProductUpsertDogsRelationInput"]: GraphQLTypes["ProductUpsertDogsRelationInput"];
	["ItemSubCategoryUpsertProductsRelationInput"]: GraphQLTypes["ItemSubCategoryUpsertProductsRelationInput"];
	["ItemUpsertSubCategoriesRelationInput"]: GraphQLTypes["ItemUpsertSubCategoriesRelationInput"];
	["BodyTagUpsertNegativeItemsRelationInput"]: GraphQLTypes["BodyTagUpsertNegativeItemsRelationInput"];
	["ItemUpsertPositiveForBodyTagsRelationInput"]: GraphQLTypes["ItemUpsertPositiveForBodyTagsRelationInput"];
	["ItemSubCategoryUpsertItemsRelationInput"]: GraphQLTypes["ItemSubCategoryUpsertItemsRelationInput"];
	["ItemCategoryUpsertSubCategoriesRelationInput"]: GraphQLTypes["ItemCategoryUpsertSubCategoriesRelationInput"];
	["BlogPostUpsertItemCategoriesRelationInput"]: GraphQLTypes["BlogPostUpsertItemCategoriesRelationInput"];
	["BlogPostTagUpsertBlogPostsRelationInput"]: GraphQLTypes["BlogPostTagUpsertBlogPostsRelationInput"];
	["ColorUpsertBlogPostTagRelationInput"]: GraphQLTypes["ColorUpsertBlogPostTagRelationInput"];
	["ColorUpdateItemFlavorCategoriesEntityRelationInput"]: GraphQLTypes["ColorUpdateItemFlavorCategoriesEntityRelationInput"];
	["ColorUpdateItemFlavorCategoriesRelationInput"]: GraphQLTypes["ColorUpdateItemFlavorCategoriesRelationInput"];
	["ItemFlavorCategoryWithoutColorUpdateInput"]: GraphQLTypes["ItemFlavorCategoryWithoutColorUpdateInput"];
	["ItemFlavorCategoryUpdateItemsEntityRelationInput"]: GraphQLTypes["ItemFlavorCategoryUpdateItemsEntityRelationInput"];
	["ItemFlavorCategoryUpdateItemsRelationInput"]: GraphQLTypes["ItemFlavorCategoryUpdateItemsRelationInput"];
	["ItemSubCategoryWithoutFlavorCategoryUpdateInput"]: GraphQLTypes["ItemSubCategoryWithoutFlavorCategoryUpdateInput"];
	["ItemFlavorCategoryUpsertItemsRelationInput"]: GraphQLTypes["ItemFlavorCategoryUpsertItemsRelationInput"];
	["ColorUpsertItemFlavorCategoriesRelationInput"]: GraphQLTypes["ColorUpsertItemFlavorCategoriesRelationInput"];
	["BodyTagCategoryUpsertColorRelationInput"]: GraphQLTypes["BodyTagCategoryUpsertColorRelationInput"];
	["BodyTagUpsertCategoryRelationInput"]: GraphQLTypes["BodyTagUpsertCategoryRelationInput"];
	["ItemUpsertNegativeForBodyTagsRelationInput"]: GraphQLTypes["ItemUpsertNegativeForBodyTagsRelationInput"];
	["BodyTagUpsertPositiveItemsRelationInput"]: GraphQLTypes["BodyTagUpsertPositiveItemsRelationInput"];
	["ProductUpsertNegativeForBodyTagsRelationInput"]: GraphQLTypes["ProductUpsertNegativeForBodyTagsRelationInput"];
	["ProductReviewUpsertProductRelationInput"]: GraphQLTypes["ProductReviewUpsertProductRelationInput"];
	["UserUpsertProductReviewsRelationInput"]: GraphQLTypes["UserUpsertProductReviewsRelationInput"];
	["ProductReviewReactionUpsertUserRelationInput"]: GraphQLTypes["ProductReviewReactionUpsertUserRelationInput"];
	["ProductReviewUpsertProductReviewReactionsRelationInput"]: GraphQLTypes["ProductReviewUpsertProductReviewReactionsRelationInput"];
	["ProductUpsertReviewsRelationInput"]: GraphQLTypes["ProductUpsertReviewsRelationInput"];
	["BodyTagUpsertNegativeProductsRelationInput"]: GraphQLTypes["BodyTagUpsertNegativeProductsRelationInput"];
	["ProductUpsertPositiveForBodyTagsRelationInput"]: GraphQLTypes["ProductUpsertPositiveForBodyTagsRelationInput"];
	["ElementOfProductUpsertProductRelationInput"]: GraphQLTypes["ElementOfProductUpsertProductRelationInput"];
	["ElementUpsertProductsRelationInput"]: GraphQLTypes["ElementUpsertProductsRelationInput"];
	["SuitabilityItemUpsertElementRelationInput"]: GraphQLTypes["SuitabilityItemUpsertElementRelationInput"];
	["NutritionalValueUpsertSuitabilityNutritionalValuesRelationInput"]: GraphQLTypes["NutritionalValueUpsertSuitabilityNutritionalValuesRelationInput"];
	["NutritionalValueOfProductUpsertNutritionalValueRelationInput"]: GraphQLTypes["NutritionalValueOfProductUpsertNutritionalValueRelationInput"];
	["ProductUpsertNutritionalValuesRelationInput"]: GraphQLTypes["ProductUpsertNutritionalValuesRelationInput"];
	["BodyTagUpsertPositiveProductsRelationInput"]: GraphQLTypes["BodyTagUpsertPositiveProductsRelationInput"];
	["BlogPostUpsertTagsRelationInput"]: GraphQLTypes["BlogPostUpsertTagsRelationInput"];
	["BlogPostReviewUpsertBlogPostRelationInput"]: GraphQLTypes["BlogPostReviewUpsertBlogPostRelationInput"];
	["UserUpsertBlogPostReviewsRelationInput"]: GraphQLTypes["UserUpsertBlogPostReviewsRelationInput"];
	["DogUpsertOwnerRelationInput"]: GraphQLTypes["DogUpsertOwnerRelationInput"];
	["AgeUpsertDogsRelationInput"]: GraphQLTypes["AgeUpsertDogsRelationInput"];
	["BreedUpsertAgesRelationInput"]: GraphQLTypes["BreedUpsertAgesRelationInput"];
	["DogUpsertBreedRelationInput"]: GraphQLTypes["DogUpsertBreedRelationInput"];
	["UserUpsertDogsRelationInput"]: GraphQLTypes["UserUpsertDogsRelationInput"];
	["BlogPostReviewReactionUpsertUserRelationInput"]: GraphQLTypes["BlogPostReviewReactionUpsertUserRelationInput"];
	["BlogPostReviewUpsertBlogPostReviewReactionsRelationInput"]: GraphQLTypes["BlogPostReviewUpsertBlogPostReviewReactionsRelationInput"];
	["BlogPostUpsertReviewsRelationInput"]: GraphQLTypes["BlogPostUpsertReviewsRelationInput"];
	["BodyTagUpsertBlogPostsRelationInput"]: GraphQLTypes["BodyTagUpsertBlogPostsRelationInput"];
	["BodyTagCategoryUpsertTagsRelationInput"]: GraphQLTypes["BodyTagCategoryUpsertTagsRelationInput"];
	["ColorUpsertBodyTagCategoryRelationInput"]: GraphQLTypes["ColorUpsertBodyTagCategoryRelationInput"];
	["BlogPostTagUpsertColorRelationInput"]: GraphQLTypes["BlogPostTagUpsertColorRelationInput"];
	["BlogPostUpsertBlogPostTagsRelationInput"]: GraphQLTypes["BlogPostUpsertBlogPostTagsRelationInput"];
	["ContentReferenceUpsertRelatedBlogPostRelationInput"]: GraphQLTypes["ContentReferenceUpsertRelatedBlogPostRelationInput"];
	["ContentReferenceUpdateAdEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateAdEntityRelationInput"];
	["AdWithoutContentReferencesUpdateInput"]: GraphQLTypes["AdWithoutContentReferencesUpdateInput"];
	["ContentReferenceUpsertAdRelationInput"]: GraphQLTypes["ContentReferenceUpsertAdRelationInput"];
	["ContentBlockUpsertReferencesRelationInput"]: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"];
	["ContentUpsertBlocksRelationInput"]: GraphQLTypes["ContentUpsertBlocksRelationInput"];
	["BlogPageUpsertContentRelationInput"]: GraphQLTypes["BlogPageUpsertContentRelationInput"];
	["SeoUpsertBlogPageRelationInput"]: GraphQLTypes["SeoUpsertBlogPageRelationInput"];
	["GenericPageUpsertSeoRelationInput"]: GraphQLTypes["GenericPageUpsertSeoRelationInput"];
	["RedirectUpsertGenericPageRelationInput"]: GraphQLTypes["RedirectUpsertGenericPageRelationInput"];
	["BlogPageUpsertRedirectsRelationInput"]: GraphQLTypes["BlogPageUpsertRedirectsRelationInput"];
	["BlogPostTagCreateInput"]: GraphQLTypes["BlogPostTagCreateInput"];
	["BlogPostTagUpdateInput"]: GraphQLTypes["BlogPostTagUpdateInput"];
	["BodyTagCreateInput"]: GraphQLTypes["BodyTagCreateInput"];
	["BodyTagUpdateInput"]: GraphQLTypes["BodyTagUpdateInput"];
	["BodyTagCategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BodyTagCategoryEdge"][]
};
	["BodyTagCategoryEdge"]: {
		node:ModelTypes["BodyTagCategory"]
};
	["BodyTagCategoryCreateInput"]: GraphQLTypes["BodyTagCategoryCreateInput"];
	["BodyTagCategoryUpdateInput"]: GraphQLTypes["BodyTagCategoryUpdateInput"];
	["ContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentEdge"][]
};
	["ContentEdge"]: {
		node:ModelTypes["Content"]
};
	["ContentBlockCreateInput"]: GraphQLTypes["ContentBlockCreateInput"];
	["ContentBlockUpdateInput"]: GraphQLTypes["ContentBlockUpdateInput"];
	["ContentReferenceCreateInput"]: GraphQLTypes["ContentReferenceCreateInput"];
	["ContentReferenceUpdateInput"]: GraphQLTypes["ContentReferenceUpdateInput"];
	["DidYouKnow"]: {
		_meta?:ModelTypes["DidYouKnowMeta"],
	id:ModelTypes["UUID"],
	text:string,
	remoteId:string
};
	["DidYouKnowMeta"]: {
		id?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"]
};
	["DidYouKnowUniqueWhere"]: GraphQLTypes["DidYouKnowUniqueWhere"];
	["DidYouKnowWhere"]: GraphQLTypes["DidYouKnowWhere"];
	["DidYouKnowOrderBy"]: GraphQLTypes["DidYouKnowOrderBy"];
	["DidYouKnowConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DidYouKnowEdge"][]
};
	["DidYouKnowEdge"]: {
		node:ModelTypes["DidYouKnow"]
};
	["DidYouKnowCreateInput"]: GraphQLTypes["DidYouKnowCreateInput"];
	["DidYouKnowUpdateInput"]: GraphQLTypes["DidYouKnowUpdateInput"];
	["ImageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageEdge"][]
};
	["ImageEdge"]: {
		node:ModelTypes["Image"]
};
	["Medium"]: {
		_meta?:ModelTypes["MediumMeta"],
	id:ModelTypes["UUID"],
	type?:ModelTypes["MediumType"],
	colorTheme?:ModelTypes["ColorTheme"],
	image?:ModelTypes["Image"],
	video?:ModelTypes["Video"]
};
	["MediumMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	colorTheme?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	video?:ModelTypes["FieldMeta"]
};
	["MediumType"]: GraphQLTypes["MediumType"];
	["ColorTheme"]: GraphQLTypes["ColorTheme"];
	["MediumUniqueWhere"]: GraphQLTypes["MediumUniqueWhere"];
	["MediumWhere"]: GraphQLTypes["MediumWhere"];
	["MediumTypeCondition"]: GraphQLTypes["MediumTypeCondition"];
	["ColorThemeCondition"]: GraphQLTypes["ColorThemeCondition"];
	["MediumOrderBy"]: GraphQLTypes["MediumOrderBy"];
	["MediumConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MediumEdge"][]
};
	["MediumEdge"]: {
		node:ModelTypes["Medium"]
};
	["MediumCreateInput"]: GraphQLTypes["MediumCreateInput"];
	["MediumCreateImageEntityRelationInput"]: GraphQLTypes["MediumCreateImageEntityRelationInput"];
	["MediumConnectOrCreateImageRelationInput"]: GraphQLTypes["MediumConnectOrCreateImageRelationInput"];
	["MediumCreateVideoEntityRelationInput"]: GraphQLTypes["MediumCreateVideoEntityRelationInput"];
	["MediumConnectOrCreateVideoRelationInput"]: GraphQLTypes["MediumConnectOrCreateVideoRelationInput"];
	["MediumUpdateInput"]: GraphQLTypes["MediumUpdateInput"];
	["MediumUpdateImageEntityRelationInput"]: GraphQLTypes["MediumUpdateImageEntityRelationInput"];
	["MediumUpsertImageRelationInput"]: GraphQLTypes["MediumUpsertImageRelationInput"];
	["MediumUpdateVideoEntityRelationInput"]: GraphQLTypes["MediumUpdateVideoEntityRelationInput"];
	["MediumUpsertVideoRelationInput"]: GraphQLTypes["MediumUpsertVideoRelationInput"];
	["NutritionalValueConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["NutritionalValueEdge"][]
};
	["NutritionalValueEdge"]: {
		node:ModelTypes["NutritionalValue"]
};
	["NutritionalValueCreateInput"]: GraphQLTypes["NutritionalValueCreateInput"];
	["NutritionalValueUpdateInput"]: GraphQLTypes["NutritionalValueUpdateInput"];
	["Page"]: {
		_meta?:ModelTypes["PageMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	seo?:ModelTypes["Seo"],
	content?:ModelTypes["Content"],
	draft?:ModelTypes["Content"]
};
	["PageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	draft?:ModelTypes["FieldMeta"]
};
	["PageUniqueWhere"]: GraphQLTypes["PageUniqueWhere"];
	["PageWhere"]: GraphQLTypes["PageWhere"];
	["PageOrderBy"]: GraphQLTypes["PageOrderBy"];
	["PageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PageEdge"][]
};
	["PageEdge"]: {
		node:ModelTypes["Page"]
};
	["PageCreateInput"]: GraphQLTypes["PageCreateInput"];
	["PageCreateSeoEntityRelationInput"]: GraphQLTypes["PageCreateSeoEntityRelationInput"];
	["PageConnectOrCreateSeoRelationInput"]: GraphQLTypes["PageConnectOrCreateSeoRelationInput"];
	["PageCreateContentEntityRelationInput"]: GraphQLTypes["PageCreateContentEntityRelationInput"];
	["PageConnectOrCreateContentRelationInput"]: GraphQLTypes["PageConnectOrCreateContentRelationInput"];
	["PageCreateDraftEntityRelationInput"]: GraphQLTypes["PageCreateDraftEntityRelationInput"];
	["PageConnectOrCreateDraftRelationInput"]: GraphQLTypes["PageConnectOrCreateDraftRelationInput"];
	["PageUpdateInput"]: GraphQLTypes["PageUpdateInput"];
	["PageUpdateSeoEntityRelationInput"]: GraphQLTypes["PageUpdateSeoEntityRelationInput"];
	["PageUpsertSeoRelationInput"]: GraphQLTypes["PageUpsertSeoRelationInput"];
	["PageUpdateContentEntityRelationInput"]: GraphQLTypes["PageUpdateContentEntityRelationInput"];
	["PageUpsertContentRelationInput"]: GraphQLTypes["PageUpsertContentRelationInput"];
	["PageUpdateDraftEntityRelationInput"]: GraphQLTypes["PageUpdateDraftEntityRelationInput"];
	["PageUpsertDraftRelationInput"]: GraphQLTypes["PageUpsertDraftRelationInput"];
	["ReferenceCreateInput"]: GraphQLTypes["ReferenceCreateInput"];
	["ReferenceCreateListEntityRelationInput"]: GraphQLTypes["ReferenceCreateListEntityRelationInput"];
	["ReferenceListWithoutReferencesCreateInput"]: GraphQLTypes["ReferenceListWithoutReferencesCreateInput"];
	["ReferenceConnectOrCreateListRelationInput"]: GraphQLTypes["ReferenceConnectOrCreateListRelationInput"];
	["ReferenceUpdateInput"]: GraphQLTypes["ReferenceUpdateInput"];
	["ReferenceUpdateListEntityRelationInput"]: GraphQLTypes["ReferenceUpdateListEntityRelationInput"];
	["ReferenceListWithoutReferencesUpdateInput"]: GraphQLTypes["ReferenceListWithoutReferencesUpdateInput"];
	["ReferenceUpsertListRelationInput"]: GraphQLTypes["ReferenceUpsertListRelationInput"];
	["ReferenceListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ReferenceListEdge"][]
};
	["ReferenceListEdge"]: {
		node:ModelTypes["ReferenceList"]
};
	["SeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoEdge"][]
};
	["SeoEdge"]: {
		node:ModelTypes["Seo"]
};
	["VideoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["VideoEdge"][]
};
	["VideoEdge"]: {
		node:ModelTypes["Video"]
};
	["BrandDistributorConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BrandDistributorEdge"][]
};
	["BrandDistributorEdge"]: {
		node:ModelTypes["BrandDistributor"]
};
	["BrandDistributorCreateInput"]: GraphQLTypes["BrandDistributorCreateInput"];
	["BrandDistributorCreateBrandsEntityRelationInput"]: GraphQLTypes["BrandDistributorCreateBrandsEntityRelationInput"];
	["BrandWithoutDistributorCreateInput"]: GraphQLTypes["BrandWithoutDistributorCreateInput"];
	["BrandDistributorConnectOrCreateBrandsRelationInput"]: GraphQLTypes["BrandDistributorConnectOrCreateBrandsRelationInput"];
	["BrandDistributorUpdateInput"]: GraphQLTypes["BrandDistributorUpdateInput"];
	["BrandDistributorUpdateBrandsEntityRelationInput"]: GraphQLTypes["BrandDistributorUpdateBrandsEntityRelationInput"];
	["BrandDistributorUpdateBrandsRelationInput"]: GraphQLTypes["BrandDistributorUpdateBrandsRelationInput"];
	["BrandWithoutDistributorUpdateInput"]: GraphQLTypes["BrandWithoutDistributorUpdateInput"];
	["BrandDistributorUpsertBrandsRelationInput"]: GraphQLTypes["BrandDistributorUpsertBrandsRelationInput"];
	["DogSizeCreateInput"]: GraphQLTypes["DogSizeCreateInput"];
	["DogSizeUpdateInput"]: GraphQLTypes["DogSizeUpdateInput"];
	["ProductionMethodConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductionMethodEdge"][]
};
	["ProductionMethodEdge"]: {
		node:ModelTypes["ProductionMethod"]
};
	["ProductionMethodCreateInput"]: GraphQLTypes["ProductionMethodCreateInput"];
	["ProductionMethodCreateBrandsEntityRelationInput"]: GraphQLTypes["ProductionMethodCreateBrandsEntityRelationInput"];
	["BrandWithoutMethodOfProductionCreateInput"]: GraphQLTypes["BrandWithoutMethodOfProductionCreateInput"];
	["ProductionMethodConnectOrCreateBrandsRelationInput"]: GraphQLTypes["ProductionMethodConnectOrCreateBrandsRelationInput"];
	["ProductionMethodUpdateInput"]: GraphQLTypes["ProductionMethodUpdateInput"];
	["ProductionMethodUpdateBrandsEntityRelationInput"]: GraphQLTypes["ProductionMethodUpdateBrandsEntityRelationInput"];
	["ProductionMethodUpdateBrandsRelationInput"]: GraphQLTypes["ProductionMethodUpdateBrandsRelationInput"];
	["BrandWithoutMethodOfProductionUpdateInput"]: GraphQLTypes["BrandWithoutMethodOfProductionUpdateInput"];
	["ProductionMethodUpsertBrandsRelationInput"]: GraphQLTypes["ProductionMethodUpsertBrandsRelationInput"];
	["ProductLineCreateInput"]: GraphQLTypes["ProductLineCreateInput"];
	["ProductLineUpdateInput"]: GraphQLTypes["ProductLineUpdateInput"];
	["BreedCreateInput"]: GraphQLTypes["BreedCreateInput"];
	["BreedUpdateInput"]: GraphQLTypes["BreedUpdateInput"];
	["DogCreateInput"]: GraphQLTypes["DogCreateInput"];
	["DogUpdateInput"]: GraphQLTypes["DogUpdateInput"];
	["UserConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["UserEdge"][]
};
	["UserEdge"]: {
		node:ModelTypes["User"]
};
	["UserCreateInput"]: GraphQLTypes["UserCreateInput"];
	["UserUpdateInput"]: GraphQLTypes["UserUpdateInput"];
	["VeterinaryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["VeterinaryEdge"][]
};
	["VeterinaryEdge"]: {
		node:ModelTypes["Veterinary"]
};
	["VeterinaryCreateInput"]: GraphQLTypes["VeterinaryCreateInput"];
	["VeterinaryCreateUserEntityRelationInput"]: GraphQLTypes["VeterinaryCreateUserEntityRelationInput"];
	["UserWithoutVeterinaryCreateInput"]: GraphQLTypes["UserWithoutVeterinaryCreateInput"];
	["VeterinaryConnectOrCreateUserRelationInput"]: GraphQLTypes["VeterinaryConnectOrCreateUserRelationInput"];
	["VeterinaryUpdateInput"]: GraphQLTypes["VeterinaryUpdateInput"];
	["VeterinaryUpdateUserEntityRelationInput"]: GraphQLTypes["VeterinaryUpdateUserEntityRelationInput"];
	["UserWithoutVeterinaryUpdateInput"]: GraphQLTypes["UserWithoutVeterinaryUpdateInput"];
	["VeterinaryUpsertUserRelationInput"]: GraphQLTypes["VeterinaryUpsertUserRelationInput"];
	["NutritionalValueOfProductCreateInput"]: GraphQLTypes["NutritionalValueOfProductCreateInput"];
	["NutritionalValueOfProductUpdateInput"]: GraphQLTypes["NutritionalValueOfProductUpdateInput"];
	["ReviewCreateInput"]: GraphQLTypes["ReviewCreateInput"];
	["ReviewCreateDogBreedsEntityRelationInput"]: GraphQLTypes["ReviewCreateDogBreedsEntityRelationInput"];
	["BreedWithoutReviewsCreateInput"]: GraphQLTypes["BreedWithoutReviewsCreateInput"];
	["ReviewConnectOrCreateDogBreedsRelationInput"]: GraphQLTypes["ReviewConnectOrCreateDogBreedsRelationInput"];
	["ReviewUpdateInput"]: GraphQLTypes["ReviewUpdateInput"];
	["ReviewUpdateDogBreedsEntityRelationInput"]: GraphQLTypes["ReviewUpdateDogBreedsEntityRelationInput"];
	["ReviewUpdateDogBreedsRelationInput"]: GraphQLTypes["ReviewUpdateDogBreedsRelationInput"];
	["BreedWithoutReviewsUpdateInput"]: GraphQLTypes["BreedWithoutReviewsUpdateInput"];
	["ReviewUpsertDogBreedsRelationInput"]: GraphQLTypes["ReviewUpsertDogBreedsRelationInput"];
	["DogBodyTypeCreateInput"]: GraphQLTypes["DogBodyTypeCreateInput"];
	["DogBodyTypeCreateDogsEntityRelationInput"]: GraphQLTypes["DogBodyTypeCreateDogsEntityRelationInput"];
	["DogWithoutBodyTypeCreateInput"]: GraphQLTypes["DogWithoutBodyTypeCreateInput"];
	["DogBodyTypeConnectOrCreateDogsRelationInput"]: GraphQLTypes["DogBodyTypeConnectOrCreateDogsRelationInput"];
	["DogBodyTypeUpdateInput"]: GraphQLTypes["DogBodyTypeUpdateInput"];
	["DogBodyTypeUpdateDogsEntityRelationInput"]: GraphQLTypes["DogBodyTypeUpdateDogsEntityRelationInput"];
	["DogBodyTypeUpdateDogsRelationInput"]: GraphQLTypes["DogBodyTypeUpdateDogsRelationInput"];
	["DogWithoutBodyTypeUpdateInput"]: GraphQLTypes["DogWithoutBodyTypeUpdateInput"];
	["DogBodyTypeUpsertDogsRelationInput"]: GraphQLTypes["DogBodyTypeUpsertDogsRelationInput"];
	["DogBodyTypeCategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DogBodyTypeCategoryEdge"][]
};
	["DogBodyTypeCategoryEdge"]: {
		node:ModelTypes["DogBodyTypeCategory"]
};
	["DogBodyTypeCategoryCreateInput"]: GraphQLTypes["DogBodyTypeCategoryCreateInput"];
	["DogBodyTypeCategoryCreateItemsEntityRelationInput"]: GraphQLTypes["DogBodyTypeCategoryCreateItemsEntityRelationInput"];
	["DogBodyTypeWithoutCategoryCreateInput"]: GraphQLTypes["DogBodyTypeWithoutCategoryCreateInput"];
	["DogBodyTypeCategoryConnectOrCreateItemsRelationInput"]: GraphQLTypes["DogBodyTypeCategoryConnectOrCreateItemsRelationInput"];
	["DogBodyTypeCategoryUpdateInput"]: GraphQLTypes["DogBodyTypeCategoryUpdateInput"];
	["DogBodyTypeCategoryUpdateItemsEntityRelationInput"]: GraphQLTypes["DogBodyTypeCategoryUpdateItemsEntityRelationInput"];
	["DogBodyTypeCategoryUpdateItemsRelationInput"]: GraphQLTypes["DogBodyTypeCategoryUpdateItemsRelationInput"];
	["DogBodyTypeWithoutCategoryUpdateInput"]: GraphQLTypes["DogBodyTypeWithoutCategoryUpdateInput"];
	["DogBodyTypeCategoryUpsertItemsRelationInput"]: GraphQLTypes["DogBodyTypeCategoryUpsertItemsRelationInput"];
	["LinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkEdge"][]
};
	["LinkEdge"]: {
		node:ModelTypes["Link"]
};
	["Url"]: {
		_meta?:ModelTypes["UrlMeta"],
	id:ModelTypes["UUID"],
	url:string
};
	["UrlMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"]
};
	["UrlUniqueWhere"]: GraphQLTypes["UrlUniqueWhere"];
	["UrlWhere"]: GraphQLTypes["UrlWhere"];
	["UrlOrderBy"]: GraphQLTypes["UrlOrderBy"];
	["UrlConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["UrlEdge"][]
};
	["UrlEdge"]: {
		node:ModelTypes["Url"]
};
	["UrlCreateInput"]: GraphQLTypes["UrlCreateInput"];
	["UrlUpdateInput"]: GraphQLTypes["UrlUpdateInput"];
	["Footer"]: {
		_meta?:ModelTypes["FooterMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	items:ModelTypes["FooterLink"][],
	copyright?:string,
	paginateItems:ModelTypes["FooterLinkConnection"]
};
	["FooterMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	copyright?:ModelTypes["FieldMeta"]
};
	["FooterLink"]: {
		_meta?:ModelTypes["FooterLinkMeta"],
	id:ModelTypes["UUID"],
	label:string,
	order:number,
	footer?:ModelTypes["Footer"],
	link?:string,
	targetBlank?:boolean
};
	["FooterLinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	footer?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	targetBlank?:ModelTypes["FieldMeta"]
};
	["FooterWhere"]: GraphQLTypes["FooterWhere"];
	["FooterLinkWhere"]: GraphQLTypes["FooterLinkWhere"];
	["FooterLinkOrderBy"]: GraphQLTypes["FooterLinkOrderBy"];
	["FooterOrderBy"]: GraphQLTypes["FooterOrderBy"];
	["FooterLinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterLinkEdge"][]
};
	["FooterLinkEdge"]: {
		node:ModelTypes["FooterLink"]
};
	["FooterUniqueWhere"]: GraphQLTypes["FooterUniqueWhere"];
	["FooterLinkUniqueWhere"]: GraphQLTypes["FooterLinkUniqueWhere"];
	["FooterConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterEdge"][]
};
	["FooterEdge"]: {
		node:ModelTypes["Footer"]
};
	["FooterCreateInput"]: GraphQLTypes["FooterCreateInput"];
	["FooterCreateItemsEntityRelationInput"]: GraphQLTypes["FooterCreateItemsEntityRelationInput"];
	["FooterLinkWithoutFooterCreateInput"]: GraphQLTypes["FooterLinkWithoutFooterCreateInput"];
	["FooterConnectOrCreateItemsRelationInput"]: GraphQLTypes["FooterConnectOrCreateItemsRelationInput"];
	["FooterUpdateInput"]: GraphQLTypes["FooterUpdateInput"];
	["FooterUpdateItemsEntityRelationInput"]: GraphQLTypes["FooterUpdateItemsEntityRelationInput"];
	["FooterUpdateItemsRelationInput"]: GraphQLTypes["FooterUpdateItemsRelationInput"];
	["FooterLinkWithoutFooterUpdateInput"]: GraphQLTypes["FooterLinkWithoutFooterUpdateInput"];
	["FooterUpsertItemsRelationInput"]: GraphQLTypes["FooterUpsertItemsRelationInput"];
	["FooterLinkCreateInput"]: GraphQLTypes["FooterLinkCreateInput"];
	["FooterLinkCreateFooterEntityRelationInput"]: GraphQLTypes["FooterLinkCreateFooterEntityRelationInput"];
	["FooterWithoutItemsCreateInput"]: GraphQLTypes["FooterWithoutItemsCreateInput"];
	["FooterLinkConnectOrCreateFooterRelationInput"]: GraphQLTypes["FooterLinkConnectOrCreateFooterRelationInput"];
	["FooterLinkUpdateInput"]: GraphQLTypes["FooterLinkUpdateInput"];
	["FooterLinkUpdateFooterEntityRelationInput"]: GraphQLTypes["FooterLinkUpdateFooterEntityRelationInput"];
	["FooterWithoutItemsUpdateInput"]: GraphQLTypes["FooterWithoutItemsUpdateInput"];
	["FooterLinkUpsertFooterRelationInput"]: GraphQLTypes["FooterLinkUpsertFooterRelationInput"];
	["BrandsPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BrandsPageEdge"][]
};
	["BrandsPageEdge"]: {
		node:ModelTypes["BrandsPage"]
};
	["BrandsPageCreateInput"]: GraphQLTypes["BrandsPageCreateInput"];
	["BrandsPageUpdateInput"]: GraphQLTypes["BrandsPageUpdateInput"];
	["HomePageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HomePageEdge"][]
};
	["HomePageEdge"]: {
		node:ModelTypes["HomePage"]
};
	["HomePageCreateInput"]: GraphQLTypes["HomePageCreateInput"];
	["HomePageCreateSeoEntityRelationInput"]: GraphQLTypes["HomePageCreateSeoEntityRelationInput"];
	["SeoWithoutHomePageCreateInput"]: GraphQLTypes["SeoWithoutHomePageCreateInput"];
	["HomePageConnectOrCreateSeoRelationInput"]: GraphQLTypes["HomePageConnectOrCreateSeoRelationInput"];
	["HomePageUpdateInput"]: GraphQLTypes["HomePageUpdateInput"];
	["HomePageUpdateSeoEntityRelationInput"]: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"];
	["SeoWithoutHomePageUpdateInput"]: GraphQLTypes["SeoWithoutHomePageUpdateInput"];
	["HomePageUpsertSeoRelationInput"]: GraphQLTypes["HomePageUpsertSeoRelationInput"];
	["IngredientsPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["IngredientsPageEdge"][]
};
	["IngredientsPageEdge"]: {
		node:ModelTypes["IngredientsPage"]
};
	["IngredientsPageCreateInput"]: GraphQLTypes["IngredientsPageCreateInput"];
	["IngredientsPageCreateSeoEntityRelationInput"]: GraphQLTypes["IngredientsPageCreateSeoEntityRelationInput"];
	["SeoWithoutIngredientsPageCreateInput"]: GraphQLTypes["SeoWithoutIngredientsPageCreateInput"];
	["IngredientsPageConnectOrCreateSeoRelationInput"]: GraphQLTypes["IngredientsPageConnectOrCreateSeoRelationInput"];
	["IngredientsPageUpdateInput"]: GraphQLTypes["IngredientsPageUpdateInput"];
	["IngredientsPageUpdateSeoEntityRelationInput"]: GraphQLTypes["IngredientsPageUpdateSeoEntityRelationInput"];
	["SeoWithoutIngredientsPageUpdateInput"]: GraphQLTypes["SeoWithoutIngredientsPageUpdateInput"];
	["IngredientsPageUpsertSeoRelationInput"]: GraphQLTypes["IngredientsPageUpsertSeoRelationInput"];
	["ProductReviewCreateInput"]: GraphQLTypes["ProductReviewCreateInput"];
	["ProductReviewUpdateInput"]: GraphQLTypes["ProductReviewUpdateInput"];
	["ScoreConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ScoreEdge"][]
};
	["ScoreEdge"]: {
		node:ModelTypes["Score"]
};
	["ScoreCreateInput"]: GraphQLTypes["ScoreCreateInput"];
	["ScoreCreateProductReviewsEntityRelationInput"]: GraphQLTypes["ScoreCreateProductReviewsEntityRelationInput"];
	["ProductReviewWithoutScoreCreateInput"]: GraphQLTypes["ProductReviewWithoutScoreCreateInput"];
	["ScoreConnectOrCreateProductReviewsRelationInput"]: GraphQLTypes["ScoreConnectOrCreateProductReviewsRelationInput"];
	["ScoreUpdateInput"]: GraphQLTypes["ScoreUpdateInput"];
	["ScoreUpdateProductReviewsEntityRelationInput"]: GraphQLTypes["ScoreUpdateProductReviewsEntityRelationInput"];
	["ScoreUpdateProductReviewsRelationInput"]: GraphQLTypes["ScoreUpdateProductReviewsRelationInput"];
	["ProductReviewWithoutScoreUpdateInput"]: GraphQLTypes["ProductReviewWithoutScoreUpdateInput"];
	["ScoreUpsertProductReviewsRelationInput"]: GraphQLTypes["ScoreUpsertProductReviewsRelationInput"];
	["AgeCreateInput"]: GraphQLTypes["AgeCreateInput"];
	["AgeUpdateInput"]: GraphQLTypes["AgeUpdateInput"];
	["CountryCreateInput"]: GraphQLTypes["CountryCreateInput"];
	["CountryUpdateInput"]: GraphQLTypes["CountryUpdateInput"];
	["BlogPostReviewCreateInput"]: GraphQLTypes["BlogPostReviewCreateInput"];
	["BlogPostReviewUpdateInput"]: GraphQLTypes["BlogPostReviewUpdateInput"];
	["DogActivityCreateInput"]: GraphQLTypes["DogActivityCreateInput"];
	["DogActivityUpdateInput"]: GraphQLTypes["DogActivityUpdateInput"];
	["Social"]: {
		_meta?:ModelTypes["SocialMeta"],
	id:ModelTypes["UUID"],
	label:ModelTypes["SocialType"],
	link?:string
};
	["SocialMeta"]: {
		id?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["SocialType"]: GraphQLTypes["SocialType"];
	["SocialUniqueWhere"]: GraphQLTypes["SocialUniqueWhere"];
	["SocialWhere"]: GraphQLTypes["SocialWhere"];
	["SocialTypeCondition"]: GraphQLTypes["SocialTypeCondition"];
	["SocialOrderBy"]: GraphQLTypes["SocialOrderBy"];
	["SocialConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialEdge"][]
};
	["SocialEdge"]: {
		node:ModelTypes["Social"]
};
	["SocialCreateInput"]: GraphQLTypes["SocialCreateInput"];
	["SocialUpdateInput"]: GraphQLTypes["SocialUpdateInput"];
	["ContentReferenceGalleryImageCreateInput"]: GraphQLTypes["ContentReferenceGalleryImageCreateInput"];
	["ContentReferenceGalleryImageCreateReferenceEntityRelationInput"]: GraphQLTypes["ContentReferenceGalleryImageCreateReferenceEntityRelationInput"];
	["ContentReferenceWithoutImagesCreateInput"]: GraphQLTypes["ContentReferenceWithoutImagesCreateInput"];
	["ContentReferenceGalleryImageConnectOrCreateReferenceRelationInput"]: GraphQLTypes["ContentReferenceGalleryImageConnectOrCreateReferenceRelationInput"];
	["ContentReferenceGalleryImageUpdateInput"]: GraphQLTypes["ContentReferenceGalleryImageUpdateInput"];
	["ContentReferenceGalleryImageUpdateReferenceEntityRelationInput"]: GraphQLTypes["ContentReferenceGalleryImageUpdateReferenceEntityRelationInput"];
	["ContentReferenceWithoutImagesUpdateInput"]: GraphQLTypes["ContentReferenceWithoutImagesUpdateInput"];
	["ContentReferenceGalleryImageUpsertReferenceRelationInput"]: GraphQLTypes["ContentReferenceGalleryImageUpsertReferenceRelationInput"];
	["ItemCategoryCreateInput"]: GraphQLTypes["ItemCategoryCreateInput"];
	["ItemCategoryUpdateInput"]: GraphQLTypes["ItemCategoryUpdateInput"];
	["ItemFlavorCategoryCreateInput"]: GraphQLTypes["ItemFlavorCategoryCreateInput"];
	["ItemFlavorCategoryUpdateInput"]: GraphQLTypes["ItemFlavorCategoryUpdateInput"];
	["ItemDeclensionFourthVariantCreateInput"]: GraphQLTypes["ItemDeclensionFourthVariantCreateInput"];
	["ItemDeclensionFourthVariantUpdateInput"]: GraphQLTypes["ItemDeclensionFourthVariantUpdateInput"];
	["ItemDeclensionSeventhVariantConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ItemDeclensionSeventhVariantEdge"][]
};
	["ItemDeclensionSeventhVariantEdge"]: {
		node:ModelTypes["ItemDeclensionSeventhVariant"]
};
	["ItemDeclensionSeventhVariantCreateInput"]: GraphQLTypes["ItemDeclensionSeventhVariantCreateInput"];
	["ItemDeclensionSeventhVariantCreateItemsEntityRelationInput"]: GraphQLTypes["ItemDeclensionSeventhVariantCreateItemsEntityRelationInput"];
	["ItemWithoutDeclensionSeventhCreateInput"]: GraphQLTypes["ItemWithoutDeclensionSeventhCreateInput"];
	["ItemDeclensionSeventhVariantConnectOrCreateItemsRelationInput"]: GraphQLTypes["ItemDeclensionSeventhVariantConnectOrCreateItemsRelationInput"];
	["ItemDeclensionSeventhVariantUpdateInput"]: GraphQLTypes["ItemDeclensionSeventhVariantUpdateInput"];
	["ItemDeclensionSeventhVariantUpdateItemsEntityRelationInput"]: GraphQLTypes["ItemDeclensionSeventhVariantUpdateItemsEntityRelationInput"];
	["ItemDeclensionSeventhVariantUpdateItemsRelationInput"]: GraphQLTypes["ItemDeclensionSeventhVariantUpdateItemsRelationInput"];
	["ItemWithoutDeclensionSeventhUpdateInput"]: GraphQLTypes["ItemWithoutDeclensionSeventhUpdateInput"];
	["ItemDeclensionSeventhVariantUpsertItemsRelationInput"]: GraphQLTypes["ItemDeclensionSeventhVariantUpsertItemsRelationInput"];
	["MediaCard"]: {
		_meta?:ModelTypes["MediaCardMeta"],
	id:ModelTypes["UUID"],
	title:string,
	lead:string,
	buttonLabel:string,
	image?:ModelTypes["Image"],
	link?:string,
	order?:number
};
	["MediaCardMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	buttonLabel?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"]
};
	["MediaCardUniqueWhere"]: GraphQLTypes["MediaCardUniqueWhere"];
	["MediaCardWhere"]: GraphQLTypes["MediaCardWhere"];
	["MediaCardOrderBy"]: GraphQLTypes["MediaCardOrderBy"];
	["MediaCardConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MediaCardEdge"][]
};
	["MediaCardEdge"]: {
		node:ModelTypes["MediaCard"]
};
	["MediaCardCreateInput"]: GraphQLTypes["MediaCardCreateInput"];
	["MediaCardCreateImageEntityRelationInput"]: GraphQLTypes["MediaCardCreateImageEntityRelationInput"];
	["MediaCardConnectOrCreateImageRelationInput"]: GraphQLTypes["MediaCardConnectOrCreateImageRelationInput"];
	["MediaCardUpdateInput"]: GraphQLTypes["MediaCardUpdateInput"];
	["MediaCardUpdateImageEntityRelationInput"]: GraphQLTypes["MediaCardUpdateImageEntityRelationInput"];
	["MediaCardUpsertImageRelationInput"]: GraphQLTypes["MediaCardUpsertImageRelationInput"];
	["InfoCard"]: {
		_meta?:ModelTypes["InfoCardMeta"],
	id:ModelTypes["UUID"],
	title:string,
	lead:string,
	order?:number
};
	["InfoCardMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"]
};
	["InfoCardUniqueWhere"]: GraphQLTypes["InfoCardUniqueWhere"];
	["InfoCardWhere"]: GraphQLTypes["InfoCardWhere"];
	["InfoCardOrderBy"]: GraphQLTypes["InfoCardOrderBy"];
	["InfoCardConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["InfoCardEdge"][]
};
	["InfoCardEdge"]: {
		node:ModelTypes["InfoCard"]
};
	["InfoCardCreateInput"]: GraphQLTypes["InfoCardCreateInput"];
	["InfoCardUpdateInput"]: GraphQLTypes["InfoCardUpdateInput"];
	["NumberedCard"]: {
		_meta?:ModelTypes["NumberedCardMeta"],
	id:ModelTypes["UUID"],
	title:string,
	lead:string,
	order?:number,
	link?:string
};
	["NumberedCardMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	lead?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["NumberedCardUniqueWhere"]: GraphQLTypes["NumberedCardUniqueWhere"];
	["NumberedCardWhere"]: GraphQLTypes["NumberedCardWhere"];
	["NumberedCardOrderBy"]: GraphQLTypes["NumberedCardOrderBy"];
	["NumberedCardConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["NumberedCardEdge"][]
};
	["NumberedCardEdge"]: {
		node:ModelTypes["NumberedCard"]
};
	["NumberedCardCreateInput"]: GraphQLTypes["NumberedCardCreateInput"];
	["NumberedCardUpdateInput"]: GraphQLTypes["NumberedCardUpdateInput"];
	["RegisterClaim"]: {
		_meta?:ModelTypes["RegisterClaimMeta"],
	id:ModelTypes["UUID"],
	text:string,
	order?:number
};
	["RegisterClaimMeta"]: {
		id?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"]
};
	["RegisterClaimUniqueWhere"]: GraphQLTypes["RegisterClaimUniqueWhere"];
	["RegisterClaimWhere"]: GraphQLTypes["RegisterClaimWhere"];
	["RegisterClaimOrderBy"]: GraphQLTypes["RegisterClaimOrderBy"];
	["RegisterClaimConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RegisterClaimEdge"][]
};
	["RegisterClaimEdge"]: {
		node:ModelTypes["RegisterClaim"]
};
	["RegisterClaimCreateInput"]: GraphQLTypes["RegisterClaimCreateInput"];
	["RegisterClaimUpdateInput"]: GraphQLTypes["RegisterClaimUpdateInput"];
	["BlogPostReviewReactionCreateInput"]: GraphQLTypes["BlogPostReviewReactionCreateInput"];
	["BlogPostReviewReactionUpdateInput"]: GraphQLTypes["BlogPostReviewReactionUpdateInput"];
	["ProductReviewReactionCreateInput"]: GraphQLTypes["ProductReviewReactionCreateInput"];
	["ProductReviewReactionUpdateInput"]: GraphQLTypes["ProductReviewReactionUpdateInput"];
	["ProductPackageCreateInput"]: GraphQLTypes["ProductPackageCreateInput"];
	["ProductPackageCreateProductEntityRelationInput"]: GraphQLTypes["ProductPackageCreateProductEntityRelationInput"];
	["ProductWithoutPackagingsCreateInput"]: GraphQLTypes["ProductWithoutPackagingsCreateInput"];
	["ProductPackageConnectOrCreateProductRelationInput"]: GraphQLTypes["ProductPackageConnectOrCreateProductRelationInput"];
	["ProductPackageUpdateInput"]: GraphQLTypes["ProductPackageUpdateInput"];
	["ProductPackageUpdateProductEntityRelationInput"]: GraphQLTypes["ProductPackageUpdateProductEntityRelationInput"];
	["ProductWithoutPackagingsUpdateInput"]: GraphQLTypes["ProductWithoutPackagingsUpdateInput"];
	["ProductPackageUpsertProductRelationInput"]: GraphQLTypes["ProductPackageUpsertProductRelationInput"];
	["BrandManufacturerCreateInput"]: GraphQLTypes["BrandManufacturerCreateInput"];
	["BrandManufacturerUpdateInput"]: GraphQLTypes["BrandManufacturerUpdateInput"];
	["ElementConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ElementEdge"][]
};
	["ElementEdge"]: {
		node:ModelTypes["Element"]
};
	["ElementOfProductCreateInput"]: GraphQLTypes["ElementOfProductCreateInput"];
	["ElementOfProductUpdateInput"]: GraphQLTypes["ElementOfProductUpdateInput"];
	["SuitabilityCategoryCreateInput"]: GraphQLTypes["SuitabilityCategoryCreateInput"];
	["SuitabilityCategoryUpdateInput"]: GraphQLTypes["SuitabilityCategoryUpdateInput"];
	["ProductFeatureCreateInput"]: GraphQLTypes["ProductFeatureCreateInput"];
	["ProductFeatureUpdateInput"]: GraphQLTypes["ProductFeatureUpdateInput"];
	["SuitabilityItemCreateInput"]: GraphQLTypes["SuitabilityItemCreateInput"];
	["SuitabilityItemUpdateInput"]: GraphQLTypes["SuitabilityItemUpdateInput"];
	["RegionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RegionEdge"][]
};
	["RegionEdge"]: {
		node:ModelTypes["Region"]
};
	["RegionCreateInput"]: GraphQLTypes["RegionCreateInput"];
	["RegionUpdateInput"]: GraphQLTypes["RegionUpdateInput"];
	["GranuleSizeCreateInput"]: GraphQLTypes["GranuleSizeCreateInput"];
	["GranuleSizeCreateProductsEntityRelationInput"]: GraphQLTypes["GranuleSizeCreateProductsEntityRelationInput"];
	["ProductWithoutGranuleSizesCreateInput"]: GraphQLTypes["ProductWithoutGranuleSizesCreateInput"];
	["GranuleSizeConnectOrCreateProductsRelationInput"]: GraphQLTypes["GranuleSizeConnectOrCreateProductsRelationInput"];
	["GranuleSizeUpdateInput"]: GraphQLTypes["GranuleSizeUpdateInput"];
	["GranuleSizeUpdateProductsEntityRelationInput"]: GraphQLTypes["GranuleSizeUpdateProductsEntityRelationInput"];
	["GranuleSizeUpdateProductsRelationInput"]: GraphQLTypes["GranuleSizeUpdateProductsRelationInput"];
	["ProductWithoutGranuleSizesUpdateInput"]: GraphQLTypes["ProductWithoutGranuleSizesUpdateInput"];
	["GranuleSizeUpsertProductsRelationInput"]: GraphQLTypes["GranuleSizeUpsertProductsRelationInput"];
	["ItemAliasCreateInput"]: GraphQLTypes["ItemAliasCreateInput"];
	["ItemAliasCreateItemEntityRelationInput"]: GraphQLTypes["ItemAliasCreateItemEntityRelationInput"];
	["ItemWithoutAliasesCreateInput"]: GraphQLTypes["ItemWithoutAliasesCreateInput"];
	["ItemAliasConnectOrCreateItemRelationInput"]: GraphQLTypes["ItemAliasConnectOrCreateItemRelationInput"];
	["ItemAliasUpdateInput"]: GraphQLTypes["ItemAliasUpdateInput"];
	["ItemAliasUpdateItemEntityRelationInput"]: GraphQLTypes["ItemAliasUpdateItemEntityRelationInput"];
	["ItemWithoutAliasesUpdateInput"]: GraphQLTypes["ItemWithoutAliasesUpdateInput"];
	["ItemAliasUpsertItemRelationInput"]: GraphQLTypes["ItemAliasUpsertItemRelationInput"];
	["SemanticKey"]: {
		_meta?:ModelTypes["SemanticKeyMeta"],
	id:ModelTypes["UUID"],
	key:string,
	value?:string
};
	["SemanticKeyMeta"]: {
		id?:ModelTypes["FieldMeta"],
	key?:ModelTypes["FieldMeta"],
	value?:ModelTypes["FieldMeta"]
};
	["SemanticKeyUniqueWhere"]: GraphQLTypes["SemanticKeyUniqueWhere"];
	["SemanticKeyWhere"]: GraphQLTypes["SemanticKeyWhere"];
	["SemanticKeyOrderBy"]: GraphQLTypes["SemanticKeyOrderBy"];
	["SemanticKeyConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SemanticKeyEdge"][]
};
	["SemanticKeyEdge"]: {
		node:ModelTypes["SemanticKey"]
};
	["SemanticKeyCreateInput"]: GraphQLTypes["SemanticKeyCreateInput"];
	["SemanticKeyUpdateInput"]: GraphQLTypes["SemanticKeyUpdateInput"];
	["ProductFlagConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductFlagEdge"][]
};
	["ProductFlagEdge"]: {
		node:ModelTypes["ProductFlag"]
};
	["ProductFlagCreateInput"]: GraphQLTypes["ProductFlagCreateInput"];
	["ProductFlagUpdateInput"]: GraphQLTypes["ProductFlagUpdateInput"];
	["ProductFlagOfProductCreateInput"]: GraphQLTypes["ProductFlagOfProductCreateInput"];
	["ProductFlagOfProductUpdateInput"]: GraphQLTypes["ProductFlagOfProductUpdateInput"];
	["ProductEvaluationConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductEvaluationEdge"][]
};
	["ProductEvaluationEdge"]: {
		node:ModelTypes["ProductEvaluation"]
};
	["ProductEvaluationCreateInput"]: GraphQLTypes["ProductEvaluationCreateInput"];
	["ProductEvaluationCreateProductEntityRelationInput"]: GraphQLTypes["ProductEvaluationCreateProductEntityRelationInput"];
	["ProductWithoutEvaluationCreateInput"]: GraphQLTypes["ProductWithoutEvaluationCreateInput"];
	["ProductEvaluationConnectOrCreateProductRelationInput"]: GraphQLTypes["ProductEvaluationConnectOrCreateProductRelationInput"];
	["ProductEvaluationUpdateInput"]: GraphQLTypes["ProductEvaluationUpdateInput"];
	["ProductEvaluationUpdateProductEntityRelationInput"]: GraphQLTypes["ProductEvaluationUpdateProductEntityRelationInput"];
	["ProductWithoutEvaluationUpdateInput"]: GraphQLTypes["ProductWithoutEvaluationUpdateInput"];
	["ProductEvaluationUpsertProductRelationInput"]: GraphQLTypes["ProductEvaluationUpsertProductRelationInput"];
	["AdCreateInput"]: GraphQLTypes["AdCreateInput"];
	["AdUpdateInput"]: GraphQLTypes["AdUpdateInput"];
	["EvaluationInfo"]: {
		_meta?:ModelTypes["EvaluationInfoMeta"],
	id:ModelTypes["UUID"],
	veterinaryDietIcon?:ModelTypes["Image"],
	unique:ModelTypes["One"],
	veterinaryDiet?:ModelTypes["ContentText"],
	disclaimer?:ModelTypes["ContentText"],
	veterinaryDietTitle?:string
};
	["EvaluationInfoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	veterinaryDietIcon?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	veterinaryDiet?:ModelTypes["FieldMeta"],
	disclaimer?:ModelTypes["FieldMeta"],
	veterinaryDietTitle?:ModelTypes["FieldMeta"]
};
	["ContentText"]: {
		_meta?:ModelTypes["ContentTextMeta"],
	id:ModelTypes["UUID"],
	blocks:ModelTypes["ContentTextBlock"][],
	paginateBlocks:ModelTypes["ContentTextBlockConnection"]
};
	["ContentTextMeta"]: {
		id?:ModelTypes["FieldMeta"],
	blocks?:ModelTypes["FieldMeta"]
};
	["ContentTextBlock"]: {
		_meta?:ModelTypes["ContentTextBlockMeta"],
	id:ModelTypes["UUID"],
	order:number,
	json:string,
	content?:ModelTypes["ContentText"]
};
	["ContentTextBlockMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	json?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"]
};
	["ContentTextWhere"]: GraphQLTypes["ContentTextWhere"];
	["ContentTextBlockWhere"]: GraphQLTypes["ContentTextBlockWhere"];
	["ContentTextBlockOrderBy"]: GraphQLTypes["ContentTextBlockOrderBy"];
	["ContentTextOrderBy"]: GraphQLTypes["ContentTextOrderBy"];
	["ContentTextBlockConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentTextBlockEdge"][]
};
	["ContentTextBlockEdge"]: {
		node:ModelTypes["ContentTextBlock"]
};
	["EvaluationInfoUniqueWhere"]: GraphQLTypes["EvaluationInfoUniqueWhere"];
	["EvaluationInfoWhere"]: GraphQLTypes["EvaluationInfoWhere"];
	["EvaluationInfoOrderBy"]: GraphQLTypes["EvaluationInfoOrderBy"];
	["EvaluationInfoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EvaluationInfoEdge"][]
};
	["EvaluationInfoEdge"]: {
		node:ModelTypes["EvaluationInfo"]
};
	["EvaluationInfoCreateInput"]: GraphQLTypes["EvaluationInfoCreateInput"];
	["EvaluationInfoCreateVeterinaryDietIconEntityRelationInput"]: GraphQLTypes["EvaluationInfoCreateVeterinaryDietIconEntityRelationInput"];
	["EvaluationInfoConnectOrCreateVeterinaryDietIconRelationInput"]: GraphQLTypes["EvaluationInfoConnectOrCreateVeterinaryDietIconRelationInput"];
	["EvaluationInfoCreateVeterinaryDietEntityRelationInput"]: GraphQLTypes["EvaluationInfoCreateVeterinaryDietEntityRelationInput"];
	["ContentTextUniqueWhere"]: GraphQLTypes["ContentTextUniqueWhere"];
	["ContentTextBlockUniqueWhere"]: GraphQLTypes["ContentTextBlockUniqueWhere"];
	["ContentTextCreateInput"]: GraphQLTypes["ContentTextCreateInput"];
	["ContentTextCreateBlocksEntityRelationInput"]: GraphQLTypes["ContentTextCreateBlocksEntityRelationInput"];
	["ContentTextBlockWithoutContentCreateInput"]: GraphQLTypes["ContentTextBlockWithoutContentCreateInput"];
	["ContentTextConnectOrCreateBlocksRelationInput"]: GraphQLTypes["ContentTextConnectOrCreateBlocksRelationInput"];
	["EvaluationInfoConnectOrCreateVeterinaryDietRelationInput"]: GraphQLTypes["EvaluationInfoConnectOrCreateVeterinaryDietRelationInput"];
	["EvaluationInfoCreateDisclaimerEntityRelationInput"]: GraphQLTypes["EvaluationInfoCreateDisclaimerEntityRelationInput"];
	["EvaluationInfoConnectOrCreateDisclaimerRelationInput"]: GraphQLTypes["EvaluationInfoConnectOrCreateDisclaimerRelationInput"];
	["EvaluationInfoUpdateInput"]: GraphQLTypes["EvaluationInfoUpdateInput"];
	["EvaluationInfoUpdateVeterinaryDietIconEntityRelationInput"]: GraphQLTypes["EvaluationInfoUpdateVeterinaryDietIconEntityRelationInput"];
	["EvaluationInfoUpsertVeterinaryDietIconRelationInput"]: GraphQLTypes["EvaluationInfoUpsertVeterinaryDietIconRelationInput"];
	["EvaluationInfoUpdateVeterinaryDietEntityRelationInput"]: GraphQLTypes["EvaluationInfoUpdateVeterinaryDietEntityRelationInput"];
	["ContentTextUpdateInput"]: GraphQLTypes["ContentTextUpdateInput"];
	["ContentTextUpdateBlocksEntityRelationInput"]: GraphQLTypes["ContentTextUpdateBlocksEntityRelationInput"];
	["ContentTextUpdateBlocksRelationInput"]: GraphQLTypes["ContentTextUpdateBlocksRelationInput"];
	["ContentTextBlockWithoutContentUpdateInput"]: GraphQLTypes["ContentTextBlockWithoutContentUpdateInput"];
	["ContentTextUpsertBlocksRelationInput"]: GraphQLTypes["ContentTextUpsertBlocksRelationInput"];
	["EvaluationInfoUpsertVeterinaryDietRelationInput"]: GraphQLTypes["EvaluationInfoUpsertVeterinaryDietRelationInput"];
	["EvaluationInfoUpdateDisclaimerEntityRelationInput"]: GraphQLTypes["EvaluationInfoUpdateDisclaimerEntityRelationInput"];
	["EvaluationInfoUpsertDisclaimerRelationInput"]: GraphQLTypes["EvaluationInfoUpsertDisclaimerRelationInput"];
	["ConsumptionMessage"]: {
		_meta?:ModelTypes["ConsumptionMessageMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	finalWording?:string,
	isHighlighted:boolean,
	numberOfDays?:number
};
	["ConsumptionMessageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	finalWording?:ModelTypes["FieldMeta"],
	isHighlighted?:ModelTypes["FieldMeta"],
	numberOfDays?:ModelTypes["FieldMeta"]
};
	["ConsumptionMessageUniqueWhere"]: GraphQLTypes["ConsumptionMessageUniqueWhere"];
	["ConsumptionMessageWhere"]: GraphQLTypes["ConsumptionMessageWhere"];
	["ConsumptionMessageOrderBy"]: GraphQLTypes["ConsumptionMessageOrderBy"];
	["ConsumptionMessageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ConsumptionMessageEdge"][]
};
	["ConsumptionMessageEdge"]: {
		node:ModelTypes["ConsumptionMessage"]
};
	["ConsumptionMessageCreateInput"]: GraphQLTypes["ConsumptionMessageCreateInput"];
	["ConsumptionMessageUpdateInput"]: GraphQLTypes["ConsumptionMessageUpdateInput"];
	["ContentTextConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentTextEdge"][]
};
	["ContentTextEdge"]: {
		node:ModelTypes["ContentText"]
};
	["ContentTextBlockCreateInput"]: GraphQLTypes["ContentTextBlockCreateInput"];
	["ContentTextBlockCreateContentEntityRelationInput"]: GraphQLTypes["ContentTextBlockCreateContentEntityRelationInput"];
	["ContentTextWithoutBlocksCreateInput"]: GraphQLTypes["ContentTextWithoutBlocksCreateInput"];
	["ContentTextBlockConnectOrCreateContentRelationInput"]: GraphQLTypes["ContentTextBlockConnectOrCreateContentRelationInput"];
	["ContentTextBlockUpdateInput"]: GraphQLTypes["ContentTextBlockUpdateInput"];
	["ContentTextBlockUpdateContentEntityRelationInput"]: GraphQLTypes["ContentTextBlockUpdateContentEntityRelationInput"];
	["ContentTextWithoutBlocksUpdateInput"]: GraphQLTypes["ContentTextWithoutBlocksUpdateInput"];
	["ContentTextBlockUpsertContentRelationInput"]: GraphQLTypes["ContentTextBlockUpsertContentRelationInput"];
	["ProductReviewStatsConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductReviewStatsEdge"][]
};
	["ProductReviewStatsEdge"]: {
		node:ModelTypes["ProductReviewStats"]
};
	["BlogPostReviewStatsConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BlogPostReviewStatsEdge"][]
};
	["BlogPostReviewStatsEdge"]: {
		node:ModelTypes["BlogPostReviewStats"]
};
	["ComparatorPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ComparatorPageEdge"][]
};
	["ComparatorPageEdge"]: {
		node:ModelTypes["ComparatorPage"]
};
	["ComparatorPageCreateInput"]: GraphQLTypes["ComparatorPageCreateInput"];
	["ComparatorPageUpdateInput"]: GraphQLTypes["ComparatorPageUpdateInput"];
	["LoginPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LoginPageEdge"][]
};
	["LoginPageEdge"]: {
		node:ModelTypes["LoginPage"]
};
	["LoginPageCreateInput"]: GraphQLTypes["LoginPageCreateInput"];
	["LoginPageCreateSeoEntityRelationInput"]: GraphQLTypes["LoginPageCreateSeoEntityRelationInput"];
	["SeoWithoutLoginPageCreateInput"]: GraphQLTypes["SeoWithoutLoginPageCreateInput"];
	["LoginPageConnectOrCreateSeoRelationInput"]: GraphQLTypes["LoginPageConnectOrCreateSeoRelationInput"];
	["LoginPageUpdateInput"]: GraphQLTypes["LoginPageUpdateInput"];
	["LoginPageUpdateSeoEntityRelationInput"]: GraphQLTypes["LoginPageUpdateSeoEntityRelationInput"];
	["SeoWithoutLoginPageUpdateInput"]: GraphQLTypes["SeoWithoutLoginPageUpdateInput"];
	["LoginPageUpsertSeoRelationInput"]: GraphQLTypes["LoginPageUpsertSeoRelationInput"];
	["RegisterPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RegisterPageEdge"][]
};
	["RegisterPageEdge"]: {
		node:ModelTypes["RegisterPage"]
};
	["RegisterPageCreateInput"]: GraphQLTypes["RegisterPageCreateInput"];
	["RegisterPageCreateSeoEntityRelationInput"]: GraphQLTypes["RegisterPageCreateSeoEntityRelationInput"];
	["SeoWithoutRegisterPageCreateInput"]: GraphQLTypes["SeoWithoutRegisterPageCreateInput"];
	["RegisterPageConnectOrCreateSeoRelationInput"]: GraphQLTypes["RegisterPageConnectOrCreateSeoRelationInput"];
	["RegisterPageUpdateInput"]: GraphQLTypes["RegisterPageUpdateInput"];
	["RegisterPageUpdateSeoEntityRelationInput"]: GraphQLTypes["RegisterPageUpdateSeoEntityRelationInput"];
	["SeoWithoutRegisterPageUpdateInput"]: GraphQLTypes["SeoWithoutRegisterPageUpdateInput"];
	["RegisterPageUpsertSeoRelationInput"]: GraphQLTypes["RegisterPageUpsertSeoRelationInput"];
	["ResultsPage"]: {
		_meta?:ModelTypes["ResultsPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	seo?:ModelTypes["Seo"]
};
	["ResultsPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["ResultsPageUniqueWhere"]: GraphQLTypes["ResultsPageUniqueWhere"];
	["ResultsPageWhere"]: GraphQLTypes["ResultsPageWhere"];
	["ResultsPageOrderBy"]: GraphQLTypes["ResultsPageOrderBy"];
	["ResultsPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ResultsPageEdge"][]
};
	["ResultsPageEdge"]: {
		node:ModelTypes["ResultsPage"]
};
	["ResultsPageCreateInput"]: GraphQLTypes["ResultsPageCreateInput"];
	["ResultsPageCreateSeoEntityRelationInput"]: GraphQLTypes["ResultsPageCreateSeoEntityRelationInput"];
	["ResultsPageConnectOrCreateSeoRelationInput"]: GraphQLTypes["ResultsPageConnectOrCreateSeoRelationInput"];
	["ResultsPageUpdateInput"]: GraphQLTypes["ResultsPageUpdateInput"];
	["ResultsPageUpdateSeoEntityRelationInput"]: GraphQLTypes["ResultsPageUpdateSeoEntityRelationInput"];
	["ResultsPageUpsertSeoRelationInput"]: GraphQLTypes["ResultsPageUpsertSeoRelationInput"];
	["SearchPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SearchPageEdge"][]
};
	["SearchPageEdge"]: {
		node:ModelTypes["SearchPage"]
};
	["SearchPageCreateInput"]: GraphQLTypes["SearchPageCreateInput"];
	["SearchPageCreateSeoEntityRelationInput"]: GraphQLTypes["SearchPageCreateSeoEntityRelationInput"];
	["SeoWithoutSearchPageCreateInput"]: GraphQLTypes["SeoWithoutSearchPageCreateInput"];
	["SearchPageConnectOrCreateSeoRelationInput"]: GraphQLTypes["SearchPageConnectOrCreateSeoRelationInput"];
	["SearchPageUpdateInput"]: GraphQLTypes["SearchPageUpdateInput"];
	["SearchPageUpdateSeoEntityRelationInput"]: GraphQLTypes["SearchPageUpdateSeoEntityRelationInput"];
	["SeoWithoutSearchPageUpdateInput"]: GraphQLTypes["SeoWithoutSearchPageUpdateInput"];
	["SearchPageUpsertSeoRelationInput"]: GraphQLTypes["SearchPageUpsertSeoRelationInput"];
	["WizardPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["WizardPageEdge"][]
};
	["WizardPageEdge"]: {
		node:ModelTypes["WizardPage"]
};
	["WizardPageCreateInput"]: GraphQLTypes["WizardPageCreateInput"];
	["WizardPageUpdateInput"]: GraphQLTypes["WizardPageUpdateInput"];
	["BreastfeedingCategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BreastfeedingCategoryEdge"][]
};
	["BreastfeedingCategoryEdge"]: {
		node:ModelTypes["BreastfeedingCategory"]
};
	["BreastfeedingCategoryCreateInput"]: GraphQLTypes["BreastfeedingCategoryCreateInput"];
	["BreastfeedingCategoryCreateDogsEntityRelationInput"]: GraphQLTypes["BreastfeedingCategoryCreateDogsEntityRelationInput"];
	["DogReproductionWithoutBreastfeedingCategoryCreateInput"]: GraphQLTypes["DogReproductionWithoutBreastfeedingCategoryCreateInput"];
	["DogReproductionCreateDogEntityRelationInput"]: GraphQLTypes["DogReproductionCreateDogEntityRelationInput"];
	["DogWithoutReproductionCreateInput"]: GraphQLTypes["DogWithoutReproductionCreateInput"];
	["DogReproductionConnectOrCreateDogRelationInput"]: GraphQLTypes["DogReproductionConnectOrCreateDogRelationInput"];
	["BreastfeedingCategoryConnectOrCreateDogsRelationInput"]: GraphQLTypes["BreastfeedingCategoryConnectOrCreateDogsRelationInput"];
	["BreastfeedingCategoryUpdateInput"]: GraphQLTypes["BreastfeedingCategoryUpdateInput"];
	["BreastfeedingCategoryUpdateDogsEntityRelationInput"]: GraphQLTypes["BreastfeedingCategoryUpdateDogsEntityRelationInput"];
	["BreastfeedingCategoryUpdateDogsRelationInput"]: GraphQLTypes["BreastfeedingCategoryUpdateDogsRelationInput"];
	["DogReproductionWithoutBreastfeedingCategoryUpdateInput"]: GraphQLTypes["DogReproductionWithoutBreastfeedingCategoryUpdateInput"];
	["DogReproductionUpdateDogEntityRelationInput"]: GraphQLTypes["DogReproductionUpdateDogEntityRelationInput"];
	["DogWithoutReproductionUpdateInput"]: GraphQLTypes["DogWithoutReproductionUpdateInput"];
	["DogReproductionUpsertDogRelationInput"]: GraphQLTypes["DogReproductionUpsertDogRelationInput"];
	["BreastfeedingCategoryUpsertDogsRelationInput"]: GraphQLTypes["BreastfeedingCategoryUpsertDogsRelationInput"];
	["DogReproductionCreateInput"]: GraphQLTypes["DogReproductionCreateInput"];
	["DogReproductionUpdateInput"]: GraphQLTypes["DogReproductionUpdateInput"];
	["ContactFormMessageCreateInput"]: GraphQLTypes["ContactFormMessageCreateInput"];
	["ContactFormMessageCreateUserEntityRelationInput"]: GraphQLTypes["ContactFormMessageCreateUserEntityRelationInput"];
	["UserWithoutContactFormMessagesCreateInput"]: GraphQLTypes["UserWithoutContactFormMessagesCreateInput"];
	["ContactFormMessageConnectOrCreateUserRelationInput"]: GraphQLTypes["ContactFormMessageConnectOrCreateUserRelationInput"];
	["ContactFormMessageUpdateInput"]: GraphQLTypes["ContactFormMessageUpdateInput"];
	["ContactFormMessageUpdateUserEntityRelationInput"]: GraphQLTypes["ContactFormMessageUpdateUserEntityRelationInput"];
	["UserWithoutContactFormMessagesUpdateInput"]: GraphQLTypes["UserWithoutContactFormMessagesUpdateInput"];
	["ContactFormMessageUpsertUserRelationInput"]: GraphQLTypes["ContactFormMessageUpsertUserRelationInput"];
	["ContactPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContactPageEdge"][]
};
	["ContactPageEdge"]: {
		node:ModelTypes["ContactPage"]
};
	["ContactPageCreateInput"]: GraphQLTypes["ContactPageCreateInput"];
	["ContactPageUpdateInput"]: GraphQLTypes["ContactPageUpdateInput"];
	["BugReportCreateInput"]: GraphQLTypes["BugReportCreateInput"];
	["BugReportCreateUserEntityRelationInput"]: GraphQLTypes["BugReportCreateUserEntityRelationInput"];
	["UserWithoutBugReportsCreateInput"]: GraphQLTypes["UserWithoutBugReportsCreateInput"];
	["BugReportConnectOrCreateUserRelationInput"]: GraphQLTypes["BugReportConnectOrCreateUserRelationInput"];
	["BugReportUpdateInput"]: GraphQLTypes["BugReportUpdateInput"];
	["BugReportUpdateUserEntityRelationInput"]: GraphQLTypes["BugReportUpdateUserEntityRelationInput"];
	["UserWithoutBugReportsUpdateInput"]: GraphQLTypes["UserWithoutBugReportsUpdateInput"];
	["BugReportUpsertUserRelationInput"]: GraphQLTypes["BugReportUpsertUserRelationInput"];
	["ColorConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ColorEdge"][]
};
	["ColorEdge"]: {
		node:ModelTypes["Color"]
};
	["ColorCreateInput"]: GraphQLTypes["ColorCreateInput"];
	["ColorUpdateInput"]: GraphQLTypes["ColorUpdateInput"];
	["ItemGroupConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ItemGroupEdge"][]
};
	["ItemGroupEdge"]: {
		node:ModelTypes["ItemGroup"]
};
	["ItemGroupCreateInput"]: GraphQLTypes["ItemGroupCreateInput"];
	["ItemGroupCreateCategoriesEntityRelationInput"]: GraphQLTypes["ItemGroupCreateCategoriesEntityRelationInput"];
	["ItemCategoryWithoutGroupCreateInput"]: GraphQLTypes["ItemCategoryWithoutGroupCreateInput"];
	["ItemGroupConnectOrCreateCategoriesRelationInput"]: GraphQLTypes["ItemGroupConnectOrCreateCategoriesRelationInput"];
	["ItemGroupUpdateInput"]: GraphQLTypes["ItemGroupUpdateInput"];
	["ItemGroupUpdateCategoriesEntityRelationInput"]: GraphQLTypes["ItemGroupUpdateCategoriesEntityRelationInput"];
	["ItemGroupUpdateCategoriesRelationInput"]: GraphQLTypes["ItemGroupUpdateCategoriesRelationInput"];
	["ItemCategoryWithoutGroupUpdateInput"]: GraphQLTypes["ItemCategoryWithoutGroupUpdateInput"];
	["ItemGroupUpsertCategoriesRelationInput"]: GraphQLTypes["ItemGroupUpsertCategoriesRelationInput"];
	["SearchResult"]: {
		_meta?:ModelTypes["SearchResultMeta"],
	id:ModelTypes["UUID"],
	brand?:ModelTypes["Brand"],
	brandName?:string,
	productLine?:ModelTypes["ProductLine"],
	productLineName?:string,
	product?:ModelTypes["Product"],
	productName?:string,
	searchable:string
};
	["SearchResultMeta"]: {
		id?:ModelTypes["FieldMeta"],
	brand?:ModelTypes["FieldMeta"],
	brandName?:ModelTypes["FieldMeta"],
	productLine?:ModelTypes["FieldMeta"],
	productLineName?:ModelTypes["FieldMeta"],
	product?:ModelTypes["FieldMeta"],
	productName?:ModelTypes["FieldMeta"],
	searchable?:ModelTypes["FieldMeta"]
};
	["SearchResultUniqueWhere"]: GraphQLTypes["SearchResultUniqueWhere"];
	["SearchResultWhere"]: GraphQLTypes["SearchResultWhere"];
	["SearchResultOrderBy"]: GraphQLTypes["SearchResultOrderBy"];
	["SearchResultConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SearchResultEdge"][]
};
	["SearchResultEdge"]: {
		node:ModelTypes["SearchResult"]
};
	["ProductEvaluationSummary"]: {
		_meta?:ModelTypes["ProductEvaluationSummaryMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	title:string,
	icon?:ModelTypes["Image"]
};
	["ProductEvaluationSummaryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	icon?:ModelTypes["FieldMeta"]
};
	["ProductEvaluationSummaryUniqueWhere"]: GraphQLTypes["ProductEvaluationSummaryUniqueWhere"];
	["ProductEvaluationSummaryWhere"]: GraphQLTypes["ProductEvaluationSummaryWhere"];
	["ProductEvaluationSummaryOrderBy"]: GraphQLTypes["ProductEvaluationSummaryOrderBy"];
	["ProductEvaluationSummaryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductEvaluationSummaryEdge"][]
};
	["ProductEvaluationSummaryEdge"]: {
		node:ModelTypes["ProductEvaluationSummary"]
};
	["ProductEvaluationSummaryCreateInput"]: GraphQLTypes["ProductEvaluationSummaryCreateInput"];
	["ProductEvaluationSummaryCreateIconEntityRelationInput"]: GraphQLTypes["ProductEvaluationSummaryCreateIconEntityRelationInput"];
	["ProductEvaluationSummaryConnectOrCreateIconRelationInput"]: GraphQLTypes["ProductEvaluationSummaryConnectOrCreateIconRelationInput"];
	["ProductEvaluationSummaryUpdateInput"]: GraphQLTypes["ProductEvaluationSummaryUpdateInput"];
	["ProductEvaluationSummaryUpdateIconEntityRelationInput"]: GraphQLTypes["ProductEvaluationSummaryUpdateIconEntityRelationInput"];
	["ProductEvaluationSummaryUpsertIconRelationInput"]: GraphQLTypes["ProductEvaluationSummaryUpsertIconRelationInput"];
	["ProtectedActionCreateInput"]: GraphQLTypes["ProtectedActionCreateInput"];
	["ProtectedActionCreateUserEntityRelationInput"]: GraphQLTypes["ProtectedActionCreateUserEntityRelationInput"];
	["UserWithoutProtectedActionsCreateInput"]: GraphQLTypes["UserWithoutProtectedActionsCreateInput"];
	["ProtectedActionConnectOrCreateUserRelationInput"]: GraphQLTypes["ProtectedActionConnectOrCreateUserRelationInput"];
	["ProtectedActionUpdateInput"]: GraphQLTypes["ProtectedActionUpdateInput"];
	["ProtectedActionUpdateUserEntityRelationInput"]: GraphQLTypes["ProtectedActionUpdateUserEntityRelationInput"];
	["UserWithoutProtectedActionsUpdateInput"]: GraphQLTypes["UserWithoutProtectedActionsUpdateInput"];
	["ProtectedActionUpsertUserRelationInput"]: GraphQLTypes["ProtectedActionUpsertUserRelationInput"];
	["BrandAliasCreateInput"]: GraphQLTypes["BrandAliasCreateInput"];
	["BrandAliasCreateBrandEntityRelationInput"]: GraphQLTypes["BrandAliasCreateBrandEntityRelationInput"];
	["BrandWithoutAliasesCreateInput"]: GraphQLTypes["BrandWithoutAliasesCreateInput"];
	["BrandAliasConnectOrCreateBrandRelationInput"]: GraphQLTypes["BrandAliasConnectOrCreateBrandRelationInput"];
	["BrandAliasUpdateInput"]: GraphQLTypes["BrandAliasUpdateInput"];
	["BrandAliasUpdateBrandEntityRelationInput"]: GraphQLTypes["BrandAliasUpdateBrandEntityRelationInput"];
	["BrandWithoutAliasesUpdateInput"]: GraphQLTypes["BrandWithoutAliasesUpdateInput"];
	["BrandAliasUpsertBrandRelationInput"]: GraphQLTypes["BrandAliasUpsertBrandRelationInput"];
	["ProductAliasCreateInput"]: GraphQLTypes["ProductAliasCreateInput"];
	["ProductAliasCreateProductEntityRelationInput"]: GraphQLTypes["ProductAliasCreateProductEntityRelationInput"];
	["ProductWithoutAliasesCreateInput"]: GraphQLTypes["ProductWithoutAliasesCreateInput"];
	["ProductAliasConnectOrCreateProductRelationInput"]: GraphQLTypes["ProductAliasConnectOrCreateProductRelationInput"];
	["ProductAliasUpdateInput"]: GraphQLTypes["ProductAliasUpdateInput"];
	["ProductAliasUpdateProductEntityRelationInput"]: GraphQLTypes["ProductAliasUpdateProductEntityRelationInput"];
	["ProductWithoutAliasesUpdateInput"]: GraphQLTypes["ProductWithoutAliasesUpdateInput"];
	["ProductAliasUpsertProductRelationInput"]: GraphQLTypes["ProductAliasUpsertProductRelationInput"];
	["ProductLineAliasCreateInput"]: GraphQLTypes["ProductLineAliasCreateInput"];
	["ProductLineAliasCreateProductLinesEntityRelationInput"]: GraphQLTypes["ProductLineAliasCreateProductLinesEntityRelationInput"];
	["ProductLineWithoutAliasesCreateInput"]: GraphQLTypes["ProductLineWithoutAliasesCreateInput"];
	["ProductLineAliasConnectOrCreateProductLinesRelationInput"]: GraphQLTypes["ProductLineAliasConnectOrCreateProductLinesRelationInput"];
	["ProductLineAliasUpdateInput"]: GraphQLTypes["ProductLineAliasUpdateInput"];
	["ProductLineAliasUpdateProductLinesEntityRelationInput"]: GraphQLTypes["ProductLineAliasUpdateProductLinesEntityRelationInput"];
	["ProductLineAliasUpdateProductLinesRelationInput"]: GraphQLTypes["ProductLineAliasUpdateProductLinesRelationInput"];
	["ProductLineWithoutAliasesUpdateInput"]: GraphQLTypes["ProductLineWithoutAliasesUpdateInput"];
	["ProductLineAliasUpsertProductLinesRelationInput"]: GraphQLTypes["ProductLineAliasUpsertProductLinesRelationInput"];
	["GenericPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["GenericPageEdge"][]
};
	["GenericPageEdge"]: {
		node:ModelTypes["GenericPage"]
};
	["GenericPageCreateInput"]: GraphQLTypes["GenericPageCreateInput"];
	["GenericPageUpdateInput"]: GraphQLTypes["GenericPageUpdateInput"];
	["LinkableConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkableEdge"][]
};
	["LinkableEdge"]: {
		node:ModelTypes["Linkable"]
};
	["LinkableCreateInput"]: GraphQLTypes["LinkableCreateInput"];
	["LinkableCreateGenericPageEntityRelationInput"]: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"];
	["GenericPageWithoutLinkCreateInput"]: GraphQLTypes["GenericPageWithoutLinkCreateInput"];
	["LinkableConnectOrCreateGenericPageRelationInput"]: GraphQLTypes["LinkableConnectOrCreateGenericPageRelationInput"];
	["LinkableUpdateInput"]: GraphQLTypes["LinkableUpdateInput"];
	["LinkableUpdateGenericPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"];
	["GenericPageWithoutLinkUpdateInput"]: GraphQLTypes["GenericPageWithoutLinkUpdateInput"];
	["LinkableUpsertGenericPageRelationInput"]: GraphQLTypes["LinkableUpsertGenericPageRelationInput"];
	["ContentLinksConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentLinksEdge"][]
};
	["ContentLinksEdge"]: {
		node:ModelTypes["ContentLinks"]
};
	["ContentLinksItemCreateInput"]: GraphQLTypes["ContentLinksItemCreateInput"];
	["ContentLinksItemCreateListEntityRelationInput"]: GraphQLTypes["ContentLinksItemCreateListEntityRelationInput"];
	["ContentLinksWithoutItemsCreateInput"]: GraphQLTypes["ContentLinksWithoutItemsCreateInput"];
	["ContentLinksItemConnectOrCreateListRelationInput"]: GraphQLTypes["ContentLinksItemConnectOrCreateListRelationInput"];
	["ContentLinksItemUpdateInput"]: GraphQLTypes["ContentLinksItemUpdateInput"];
	["ContentLinksItemUpdateListEntityRelationInput"]: GraphQLTypes["ContentLinksItemUpdateListEntityRelationInput"];
	["ContentLinksWithoutItemsUpdateInput"]: GraphQLTypes["ContentLinksWithoutItemsUpdateInput"];
	["ContentLinksItemUpsertListRelationInput"]: GraphQLTypes["ContentLinksItemUpsertListRelationInput"];
	["RedirectCreateInput"]: GraphQLTypes["RedirectCreateInput"];
	["RedirectUpdateInput"]: GraphQLTypes["RedirectUpdateInput"];
	["ContentReferenceImageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentReferenceImageEdge"][]
};
	["ContentReferenceImageEdge"]: {
		node:ModelTypes["ContentReferenceImage"]
};
	["SeoData"]: {
		_meta?:ModelTypes["SeoDataMeta"],
	id:ModelTypes["UUID"],
	remoteId:string,
	url:string,
	seo?:ModelTypes["Seo"]
};
	["SeoDataMeta"]: {
		id?:ModelTypes["FieldMeta"],
	remoteId?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["SeoDataUniqueWhere"]: GraphQLTypes["SeoDataUniqueWhere"];
	["SeoDataWhere"]: GraphQLTypes["SeoDataWhere"];
	["SeoDataOrderBy"]: GraphQLTypes["SeoDataOrderBy"];
	["SeoDataConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoDataEdge"][]
};
	["SeoDataEdge"]: {
		node:ModelTypes["SeoData"]
};
	["SeoDataCreateInput"]: GraphQLTypes["SeoDataCreateInput"];
	["SeoDataCreateSeoEntityRelationInput"]: GraphQLTypes["SeoDataCreateSeoEntityRelationInput"];
	["SeoDataConnectOrCreateSeoRelationInput"]: GraphQLTypes["SeoDataConnectOrCreateSeoRelationInput"];
	["SeoDataUpdateInput"]: GraphQLTypes["SeoDataUpdateInput"];
	["SeoDataUpdateSeoEntityRelationInput"]: GraphQLTypes["SeoDataUpdateSeoEntityRelationInput"];
	["SeoDataUpsertSeoRelationInput"]: GraphQLTypes["SeoDataUpsertSeoRelationInput"];
	["TenantPersonConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TenantPersonEdge"][]
};
	["TenantPersonEdge"]: {
		node:ModelTypes["TenantPerson"]
};
	["AgeCategoryCreateInput"]: GraphQLTypes["AgeCategoryCreateInput"];
	["AgeCategoryUpdateInput"]: GraphQLTypes["AgeCategoryUpdateInput"];
	["FilterComboCreateInput"]: GraphQLTypes["FilterComboCreateInput"];
	["FilterComboUpdateInput"]: GraphQLTypes["FilterComboUpdateInput"];
	["ImportCache"]: {
		_meta?:ModelTypes["ImportCacheMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	latestImportAt?:ModelTypes["DateTime"],
	latestImportHash?:string
};
	["ImportCacheMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	latestImportAt?:ModelTypes["FieldMeta"],
	latestImportHash?:ModelTypes["FieldMeta"]
};
	["ImportCacheUniqueWhere"]: GraphQLTypes["ImportCacheUniqueWhere"];
	["ImportCacheWhere"]: GraphQLTypes["ImportCacheWhere"];
	["ImportCacheOrderBy"]: GraphQLTypes["ImportCacheOrderBy"];
	["ImportCacheConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImportCacheEdge"][]
};
	["ImportCacheEdge"]: {
		node:ModelTypes["ImportCache"]
};
	["ImportCacheCreateInput"]: GraphQLTypes["ImportCacheCreateInput"];
	["ImportCacheUpdateInput"]: GraphQLTypes["ImportCacheUpdateInput"];
	["Site"]: {
		_meta?:ModelTypes["SiteMeta"],
	id:ModelTypes["UUID"],
	reindexingAt?:ModelTypes["DateTime"],
	unique:ModelTypes["One"]
};
	["SiteMeta"]: {
		id?:ModelTypes["FieldMeta"],
	reindexingAt?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"]
};
	["SiteUniqueWhere"]: GraphQLTypes["SiteUniqueWhere"];
	["SiteWhere"]: GraphQLTypes["SiteWhere"];
	["SiteOrderBy"]: GraphQLTypes["SiteOrderBy"];
	["SiteConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SiteEdge"][]
};
	["SiteEdge"]: {
		node:ModelTypes["Site"]
};
	["SiteCreateInput"]: GraphQLTypes["SiteCreateInput"];
	["SiteUpdateInput"]: GraphQLTypes["SiteUpdateInput"];
	["ContactSubmission"]: {
		_meta?:ModelTypes["ContactSubmissionMeta"],
	id:ModelTypes["UUID"],
	createdAt:ModelTypes["DateTime"],
	eBookVariant?:ModelTypes["BookType"],
	email?:string,
	newsletterSubscribed:boolean
};
	["ContactSubmissionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"],
	eBookVariant?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	newsletterSubscribed?:ModelTypes["FieldMeta"]
};
	["BookType"]: GraphQLTypes["BookType"];
	["ContactSubmissionUniqueWhere"]: GraphQLTypes["ContactSubmissionUniqueWhere"];
	["ContactSubmissionWhere"]: GraphQLTypes["ContactSubmissionWhere"];
	["BookTypeCondition"]: GraphQLTypes["BookTypeCondition"];
	["ContactSubmissionOrderBy"]: GraphQLTypes["ContactSubmissionOrderBy"];
	["ContactSubmissionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContactSubmissionEdge"][]
};
	["ContactSubmissionEdge"]: {
		node:ModelTypes["ContactSubmission"]
};
	["ContactSubmissionCreateInput"]: GraphQLTypes["ContactSubmissionCreateInput"];
	["ContactSubmissionUpdateInput"]: GraphQLTypes["ContactSubmissionUpdateInput"];
	["TOPXBrandCreateInput"]: GraphQLTypes["TOPXBrandCreateInput"];
	["TOPXBrandCreateBrandEntityRelationInput"]: GraphQLTypes["TOPXBrandCreateBrandEntityRelationInput"];
	["BrandWithoutTopxCreateInput"]: GraphQLTypes["BrandWithoutTopxCreateInput"];
	["TOPXBrandConnectOrCreateBrandRelationInput"]: GraphQLTypes["TOPXBrandConnectOrCreateBrandRelationInput"];
	["TOPXBrandUpdateInput"]: GraphQLTypes["TOPXBrandUpdateInput"];
	["TOPXBrandUpdateBrandEntityRelationInput"]: GraphQLTypes["TOPXBrandUpdateBrandEntityRelationInput"];
	["BrandWithoutTopxUpdateInput"]: GraphQLTypes["BrandWithoutTopxUpdateInput"];
	["TOPXBrandUpsertBrandRelationInput"]: GraphQLTypes["TOPXBrandUpsertBrandRelationInput"];
	["TOPXBrandCategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TOPXBrandCategoryEdge"][]
};
	["TOPXBrandCategoryEdge"]: {
		node:ModelTypes["TOPXBrandCategory"]
};
	["TOPXBrandCategoryCreateInput"]: GraphQLTypes["TOPXBrandCategoryCreateInput"];
	["TOPXBrandCategoryCreateBrandsEntityRelationInput"]: GraphQLTypes["TOPXBrandCategoryCreateBrandsEntityRelationInput"];
	["TOPXBrandWithoutCategoryCreateInput"]: GraphQLTypes["TOPXBrandWithoutCategoryCreateInput"];
	["TOPXBrandCategoryConnectOrCreateBrandsRelationInput"]: GraphQLTypes["TOPXBrandCategoryConnectOrCreateBrandsRelationInput"];
	["TOPXBrandCategoryUpdateInput"]: GraphQLTypes["TOPXBrandCategoryUpdateInput"];
	["TOPXBrandCategoryUpdateBrandsEntityRelationInput"]: GraphQLTypes["TOPXBrandCategoryUpdateBrandsEntityRelationInput"];
	["TOPXBrandCategoryUpdateBrandsRelationInput"]: GraphQLTypes["TOPXBrandCategoryUpdateBrandsRelationInput"];
	["TOPXBrandWithoutCategoryUpdateInput"]: GraphQLTypes["TOPXBrandWithoutCategoryUpdateInput"];
	["TOPXBrandCategoryUpsertBrandsRelationInput"]: GraphQLTypes["TOPXBrandCategoryUpsertBrandsRelationInput"];
	["TOPXProductCreateInput"]: GraphQLTypes["TOPXProductCreateInput"];
	["TOPXProductCreateProductEntityRelationInput"]: GraphQLTypes["TOPXProductCreateProductEntityRelationInput"];
	["ProductWithoutTopxCreateInput"]: GraphQLTypes["ProductWithoutTopxCreateInput"];
	["TOPXProductConnectOrCreateProductRelationInput"]: GraphQLTypes["TOPXProductConnectOrCreateProductRelationInput"];
	["TOPXProductUpdateInput"]: GraphQLTypes["TOPXProductUpdateInput"];
	["TOPXProductUpdateProductEntityRelationInput"]: GraphQLTypes["TOPXProductUpdateProductEntityRelationInput"];
	["ProductWithoutTopxUpdateInput"]: GraphQLTypes["ProductWithoutTopxUpdateInput"];
	["TOPXProductUpsertProductRelationInput"]: GraphQLTypes["TOPXProductUpsertProductRelationInput"];
	["TOPXProductCategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TOPXProductCategoryEdge"][]
};
	["TOPXProductCategoryEdge"]: {
		node:ModelTypes["TOPXProductCategory"]
};
	["TOPXProductCategoryCreateInput"]: GraphQLTypes["TOPXProductCategoryCreateInput"];
	["TOPXProductCategoryCreateProductsEntityRelationInput"]: GraphQLTypes["TOPXProductCategoryCreateProductsEntityRelationInput"];
	["TOPXProductWithoutCategoryCreateInput"]: GraphQLTypes["TOPXProductWithoutCategoryCreateInput"];
	["TOPXProductCategoryConnectOrCreateProductsRelationInput"]: GraphQLTypes["TOPXProductCategoryConnectOrCreateProductsRelationInput"];
	["TOPXProductCategoryUpdateInput"]: GraphQLTypes["TOPXProductCategoryUpdateInput"];
	["TOPXProductCategoryUpdateProductsEntityRelationInput"]: GraphQLTypes["TOPXProductCategoryUpdateProductsEntityRelationInput"];
	["TOPXProductCategoryUpdateProductsRelationInput"]: GraphQLTypes["TOPXProductCategoryUpdateProductsRelationInput"];
	["TOPXProductWithoutCategoryUpdateInput"]: GraphQLTypes["TOPXProductWithoutCategoryUpdateInput"];
	["TOPXProductCategoryUpsertProductsRelationInput"]: GraphQLTypes["TOPXProductCategoryUpsertProductsRelationInput"];
	["ContentReferenceListCreateInput"]: GraphQLTypes["ContentReferenceListCreateInput"];
	["ContentReferenceListCreateListEntityRelationInput"]: GraphQLTypes["ContentReferenceListCreateListEntityRelationInput"];
	["ContentReferenceWithoutListCreateInput"]: GraphQLTypes["ContentReferenceWithoutListCreateInput"];
	["ContentReferenceListConnectOrCreateListRelationInput"]: GraphQLTypes["ContentReferenceListConnectOrCreateListRelationInput"];
	["ContentReferenceListUpdateInput"]: GraphQLTypes["ContentReferenceListUpdateInput"];
	["ContentReferenceListUpdateListEntityRelationInput"]: GraphQLTypes["ContentReferenceListUpdateListEntityRelationInput"];
	["ContentReferenceWithoutListUpdateInput"]: GraphQLTypes["ContentReferenceWithoutListUpdateInput"];
	["ContentReferenceListUpsertListRelationInput"]: GraphQLTypes["ContentReferenceListUpsertListRelationInput"];
	["BrandCount"]: {
		_meta?:ModelTypes["BrandCountMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	count:number
};
	["BrandCountMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	count?:ModelTypes["FieldMeta"]
};
	["BrandCountUniqueWhere"]: GraphQLTypes["BrandCountUniqueWhere"];
	["BrandCountWhere"]: GraphQLTypes["BrandCountWhere"];
	["BrandCountOrderBy"]: GraphQLTypes["BrandCountOrderBy"];
	["BrandCountConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BrandCountEdge"][]
};
	["BrandCountEdge"]: {
		node:ModelTypes["BrandCount"]
};
	["ProductCount"]: {
		_meta?:ModelTypes["ProductCountMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	count:number
};
	["ProductCountMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	count?:ModelTypes["FieldMeta"]
};
	["ProductCountUniqueWhere"]: GraphQLTypes["ProductCountUniqueWhere"];
	["ProductCountWhere"]: GraphQLTypes["ProductCountWhere"];
	["ProductCountOrderBy"]: GraphQLTypes["ProductCountOrderBy"];
	["ProductCountConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductCountEdge"][]
};
	["ProductCountEdge"]: {
		node:ModelTypes["ProductCount"]
};
	["QueryTransaction"]: {
		schema?:ModelTypes["_Schema"],
	s3DummyQuery?:string,
	getBlogPage?:ModelTypes["BlogPage"],
	listBlogPage:ModelTypes["BlogPage"][],
	paginateBlogPage:ModelTypes["BlogPageConnection"],
	validateCreateBlogPage:ModelTypes["_ValidationResult"],
	validateUpdateBlogPage:ModelTypes["_ValidationResult"],
	getBlogPost?:ModelTypes["BlogPost"],
	listBlogPost:ModelTypes["BlogPost"][],
	paginateBlogPost:ModelTypes["BlogPostConnection"],
	validateCreateBlogPost:ModelTypes["_ValidationResult"],
	validateUpdateBlogPost:ModelTypes["_ValidationResult"],
	getBlogPostTag?:ModelTypes["BlogPostTag"],
	listBlogPostTag:ModelTypes["BlogPostTag"][],
	paginateBlogPostTag:ModelTypes["BlogPostTagConnection"],
	validateCreateBlogPostTag:ModelTypes["_ValidationResult"],
	validateUpdateBlogPostTag:ModelTypes["_ValidationResult"],
	getBodyTag?:ModelTypes["BodyTag"],
	listBodyTag:ModelTypes["BodyTag"][],
	paginateBodyTag:ModelTypes["BodyTagConnection"],
	validateCreateBodyTag:ModelTypes["_ValidationResult"],
	validateUpdateBodyTag:ModelTypes["_ValidationResult"],
	getBodyTagCategory?:ModelTypes["BodyTagCategory"],
	listBodyTagCategory:ModelTypes["BodyTagCategory"][],
	paginateBodyTagCategory:ModelTypes["BodyTagCategoryConnection"],
	validateCreateBodyTagCategory:ModelTypes["_ValidationResult"],
	validateUpdateBodyTagCategory:ModelTypes["_ValidationResult"],
	getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getDidYouKnow?:ModelTypes["DidYouKnow"],
	listDidYouKnow:ModelTypes["DidYouKnow"][],
	paginateDidYouKnow:ModelTypes["DidYouKnowConnection"],
	validateCreateDidYouKnow:ModelTypes["_ValidationResult"],
	validateUpdateDidYouKnow:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getMedium?:ModelTypes["Medium"],
	listMedium:ModelTypes["Medium"][],
	paginateMedium:ModelTypes["MediumConnection"],
	validateCreateMedium:ModelTypes["_ValidationResult"],
	validateUpdateMedium:ModelTypes["_ValidationResult"],
	getNutritionalValue?:ModelTypes["NutritionalValue"],
	listNutritionalValue:ModelTypes["NutritionalValue"][],
	paginateNutritionalValue:ModelTypes["NutritionalValueConnection"],
	validateCreateNutritionalValue:ModelTypes["_ValidationResult"],
	validateUpdateNutritionalValue:ModelTypes["_ValidationResult"],
	getPage?:ModelTypes["Page"],
	listPage:ModelTypes["Page"][],
	paginatePage:ModelTypes["PageConnection"],
	validateCreatePage:ModelTypes["_ValidationResult"],
	validateUpdatePage:ModelTypes["_ValidationResult"],
	getReference?:ModelTypes["Reference"],
	listReference:ModelTypes["Reference"][],
	paginateReference:ModelTypes["ReferenceConnection"],
	validateCreateReference:ModelTypes["_ValidationResult"],
	validateUpdateReference:ModelTypes["_ValidationResult"],
	getReferenceList?:ModelTypes["ReferenceList"],
	listReferenceList:ModelTypes["ReferenceList"][],
	paginateReferenceList:ModelTypes["ReferenceListConnection"],
	validateCreateReferenceList:ModelTypes["_ValidationResult"],
	validateUpdateReferenceList:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getVideo?:ModelTypes["Video"],
	listVideo:ModelTypes["Video"][],
	paginateVideo:ModelTypes["VideoConnection"],
	validateCreateVideo:ModelTypes["_ValidationResult"],
	validateUpdateVideo:ModelTypes["_ValidationResult"],
	getBrand?:ModelTypes["Brand"],
	listBrand:ModelTypes["Brand"][],
	paginateBrand:ModelTypes["BrandConnection"],
	validateCreateBrand:ModelTypes["_ValidationResult"],
	validateUpdateBrand:ModelTypes["_ValidationResult"],
	getBrandDistributor?:ModelTypes["BrandDistributor"],
	listBrandDistributor:ModelTypes["BrandDistributor"][],
	paginateBrandDistributor:ModelTypes["BrandDistributorConnection"],
	validateCreateBrandDistributor:ModelTypes["_ValidationResult"],
	validateUpdateBrandDistributor:ModelTypes["_ValidationResult"],
	getDogSize?:ModelTypes["DogSize"],
	listDogSize:ModelTypes["DogSize"][],
	paginateDogSize:ModelTypes["DogSizeConnection"],
	validateCreateDogSize:ModelTypes["_ValidationResult"],
	validateUpdateDogSize:ModelTypes["_ValidationResult"],
	getProduct?:ModelTypes["Product"],
	listProduct:ModelTypes["Product"][],
	paginateProduct:ModelTypes["ProductConnection"],
	validateCreateProduct:ModelTypes["_ValidationResult"],
	validateUpdateProduct:ModelTypes["_ValidationResult"],
	getProductionMethod?:ModelTypes["ProductionMethod"],
	listProductionMethod:ModelTypes["ProductionMethod"][],
	paginateProductionMethod:ModelTypes["ProductionMethodConnection"],
	validateCreateProductionMethod:ModelTypes["_ValidationResult"],
	validateUpdateProductionMethod:ModelTypes["_ValidationResult"],
	getProductLine?:ModelTypes["ProductLine"],
	listProductLine:ModelTypes["ProductLine"][],
	paginateProductLine:ModelTypes["ProductLineConnection"],
	validateCreateProductLine:ModelTypes["_ValidationResult"],
	validateUpdateProductLine:ModelTypes["_ValidationResult"],
	getBreed?:ModelTypes["Breed"],
	listBreed:ModelTypes["Breed"][],
	paginateBreed:ModelTypes["BreedConnection"],
	validateCreateBreed:ModelTypes["_ValidationResult"],
	validateUpdateBreed:ModelTypes["_ValidationResult"],
	getDog?:ModelTypes["Dog"],
	listDog:ModelTypes["Dog"][],
	paginateDog:ModelTypes["DogConnection"],
	validateCreateDog:ModelTypes["_ValidationResult"],
	validateUpdateDog:ModelTypes["_ValidationResult"],
	getUser?:ModelTypes["User"],
	listUser:ModelTypes["User"][],
	paginateUser:ModelTypes["UserConnection"],
	validateCreateUser:ModelTypes["_ValidationResult"],
	validateUpdateUser:ModelTypes["_ValidationResult"],
	getVeterinary?:ModelTypes["Veterinary"],
	listVeterinary:ModelTypes["Veterinary"][],
	paginateVeterinary:ModelTypes["VeterinaryConnection"],
	validateCreateVeterinary:ModelTypes["_ValidationResult"],
	validateUpdateVeterinary:ModelTypes["_ValidationResult"],
	getNutritionalValueOfProduct?:ModelTypes["NutritionalValueOfProduct"],
	listNutritionalValueOfProduct:ModelTypes["NutritionalValueOfProduct"][],
	paginateNutritionalValueOfProduct:ModelTypes["NutritionalValueOfProductConnection"],
	validateCreateNutritionalValueOfProduct:ModelTypes["_ValidationResult"],
	validateUpdateNutritionalValueOfProduct:ModelTypes["_ValidationResult"],
	getReview?:ModelTypes["Review"],
	listReview:ModelTypes["Review"][],
	paginateReview:ModelTypes["ReviewConnection"],
	validateCreateReview:ModelTypes["_ValidationResult"],
	validateUpdateReview:ModelTypes["_ValidationResult"],
	getDogBodyType?:ModelTypes["DogBodyType"],
	listDogBodyType:ModelTypes["DogBodyType"][],
	paginateDogBodyType:ModelTypes["DogBodyTypeConnection"],
	validateCreateDogBodyType:ModelTypes["_ValidationResult"],
	validateUpdateDogBodyType:ModelTypes["_ValidationResult"],
	getDogBodyTypeCategory?:ModelTypes["DogBodyTypeCategory"],
	listDogBodyTypeCategory:ModelTypes["DogBodyTypeCategory"][],
	paginateDogBodyTypeCategory:ModelTypes["DogBodyTypeCategoryConnection"],
	validateCreateDogBodyTypeCategory:ModelTypes["_ValidationResult"],
	validateUpdateDogBodyTypeCategory:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getUrl?:ModelTypes["Url"],
	listUrl:ModelTypes["Url"][],
	paginateUrl:ModelTypes["UrlConnection"],
	validateCreateUrl:ModelTypes["_ValidationResult"],
	validateUpdateUrl:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getFooterLink?:ModelTypes["FooterLink"],
	listFooterLink:ModelTypes["FooterLink"][],
	paginateFooterLink:ModelTypes["FooterLinkConnection"],
	validateCreateFooterLink:ModelTypes["_ValidationResult"],
	validateUpdateFooterLink:ModelTypes["_ValidationResult"],
	getBrandsPage?:ModelTypes["BrandsPage"],
	listBrandsPage:ModelTypes["BrandsPage"][],
	paginateBrandsPage:ModelTypes["BrandsPageConnection"],
	validateCreateBrandsPage:ModelTypes["_ValidationResult"],
	validateUpdateBrandsPage:ModelTypes["_ValidationResult"],
	getHomePage?:ModelTypes["HomePage"],
	listHomePage:ModelTypes["HomePage"][],
	paginateHomePage:ModelTypes["HomePageConnection"],
	validateCreateHomePage:ModelTypes["_ValidationResult"],
	validateUpdateHomePage:ModelTypes["_ValidationResult"],
	getIngredientsPage?:ModelTypes["IngredientsPage"],
	listIngredientsPage:ModelTypes["IngredientsPage"][],
	paginateIngredientsPage:ModelTypes["IngredientsPageConnection"],
	validateCreateIngredientsPage:ModelTypes["_ValidationResult"],
	validateUpdateIngredientsPage:ModelTypes["_ValidationResult"],
	getProductReview?:ModelTypes["ProductReview"],
	listProductReview:ModelTypes["ProductReview"][],
	paginateProductReview:ModelTypes["ProductReviewConnection"],
	validateCreateProductReview:ModelTypes["_ValidationResult"],
	validateUpdateProductReview:ModelTypes["_ValidationResult"],
	getScore?:ModelTypes["Score"],
	listScore:ModelTypes["Score"][],
	paginateScore:ModelTypes["ScoreConnection"],
	validateCreateScore:ModelTypes["_ValidationResult"],
	validateUpdateScore:ModelTypes["_ValidationResult"],
	getAge?:ModelTypes["Age"],
	listAge:ModelTypes["Age"][],
	paginateAge:ModelTypes["AgeConnection"],
	validateCreateAge:ModelTypes["_ValidationResult"],
	validateUpdateAge:ModelTypes["_ValidationResult"],
	getCountry?:ModelTypes["Country"],
	listCountry:ModelTypes["Country"][],
	paginateCountry:ModelTypes["CountryConnection"],
	validateCreateCountry:ModelTypes["_ValidationResult"],
	validateUpdateCountry:ModelTypes["_ValidationResult"],
	getBlogPostReview?:ModelTypes["BlogPostReview"],
	listBlogPostReview:ModelTypes["BlogPostReview"][],
	paginateBlogPostReview:ModelTypes["BlogPostReviewConnection"],
	validateCreateBlogPostReview:ModelTypes["_ValidationResult"],
	validateUpdateBlogPostReview:ModelTypes["_ValidationResult"],
	getDogActivity?:ModelTypes["DogActivity"],
	listDogActivity:ModelTypes["DogActivity"][],
	paginateDogActivity:ModelTypes["DogActivityConnection"],
	validateCreateDogActivity:ModelTypes["_ValidationResult"],
	validateUpdateDogActivity:ModelTypes["_ValidationResult"],
	getSocial?:ModelTypes["Social"],
	listSocial:ModelTypes["Social"][],
	paginateSocial:ModelTypes["SocialConnection"],
	validateCreateSocial:ModelTypes["_ValidationResult"],
	validateUpdateSocial:ModelTypes["_ValidationResult"],
	getContentReferenceGalleryImage?:ModelTypes["ContentReferenceGalleryImage"],
	listContentReferenceGalleryImage:ModelTypes["ContentReferenceGalleryImage"][],
	paginateContentReferenceGalleryImage:ModelTypes["ContentReferenceGalleryImageConnection"],
	validateCreateContentReferenceGalleryImage:ModelTypes["_ValidationResult"],
	validateUpdateContentReferenceGalleryImage:ModelTypes["_ValidationResult"],
	getItem?:ModelTypes["Item"],
	listItem:ModelTypes["Item"][],
	paginateItem:ModelTypes["ItemConnection"],
	validateCreateItem:ModelTypes["_ValidationResult"],
	validateUpdateItem:ModelTypes["_ValidationResult"],
	getItemSubCategory?:ModelTypes["ItemSubCategory"],
	listItemSubCategory:ModelTypes["ItemSubCategory"][],
	paginateItemSubCategory:ModelTypes["ItemSubCategoryConnection"],
	validateCreateItemSubCategory:ModelTypes["_ValidationResult"],
	validateUpdateItemSubCategory:ModelTypes["_ValidationResult"],
	getItemCategory?:ModelTypes["ItemCategory"],
	listItemCategory:ModelTypes["ItemCategory"][],
	paginateItemCategory:ModelTypes["ItemCategoryConnection"],
	validateCreateItemCategory:ModelTypes["_ValidationResult"],
	validateUpdateItemCategory:ModelTypes["_ValidationResult"],
	getItemFlavorCategory?:ModelTypes["ItemFlavorCategory"],
	listItemFlavorCategory:ModelTypes["ItemFlavorCategory"][],
	paginateItemFlavorCategory:ModelTypes["ItemFlavorCategoryConnection"],
	validateCreateItemFlavorCategory:ModelTypes["_ValidationResult"],
	validateUpdateItemFlavorCategory:ModelTypes["_ValidationResult"],
	getItemDeclensionFourthVariant?:ModelTypes["ItemDeclensionFourthVariant"],
	listItemDeclensionFourthVariant:ModelTypes["ItemDeclensionFourthVariant"][],
	paginateItemDeclensionFourthVariant:ModelTypes["ItemDeclensionFourthVariantConnection"],
	validateCreateItemDeclensionFourthVariant:ModelTypes["_ValidationResult"],
	validateUpdateItemDeclensionFourthVariant:ModelTypes["_ValidationResult"],
	getItemDeclensionSeventhVariant?:ModelTypes["ItemDeclensionSeventhVariant"],
	listItemDeclensionSeventhVariant:ModelTypes["ItemDeclensionSeventhVariant"][],
	paginateItemDeclensionSeventhVariant:ModelTypes["ItemDeclensionSeventhVariantConnection"],
	validateCreateItemDeclensionSeventhVariant:ModelTypes["_ValidationResult"],
	validateUpdateItemDeclensionSeventhVariant:ModelTypes["_ValidationResult"],
	getMediaCard?:ModelTypes["MediaCard"],
	listMediaCard:ModelTypes["MediaCard"][],
	paginateMediaCard:ModelTypes["MediaCardConnection"],
	validateCreateMediaCard:ModelTypes["_ValidationResult"],
	validateUpdateMediaCard:ModelTypes["_ValidationResult"],
	getInfoCard?:ModelTypes["InfoCard"],
	listInfoCard:ModelTypes["InfoCard"][],
	paginateInfoCard:ModelTypes["InfoCardConnection"],
	validateCreateInfoCard:ModelTypes["_ValidationResult"],
	validateUpdateInfoCard:ModelTypes["_ValidationResult"],
	getNumberedCard?:ModelTypes["NumberedCard"],
	listNumberedCard:ModelTypes["NumberedCard"][],
	paginateNumberedCard:ModelTypes["NumberedCardConnection"],
	validateCreateNumberedCard:ModelTypes["_ValidationResult"],
	validateUpdateNumberedCard:ModelTypes["_ValidationResult"],
	getRegisterClaim?:ModelTypes["RegisterClaim"],
	listRegisterClaim:ModelTypes["RegisterClaim"][],
	paginateRegisterClaim:ModelTypes["RegisterClaimConnection"],
	validateCreateRegisterClaim:ModelTypes["_ValidationResult"],
	validateUpdateRegisterClaim:ModelTypes["_ValidationResult"],
	getBlogPostReviewReaction?:ModelTypes["BlogPostReviewReaction"],
	listBlogPostReviewReaction:ModelTypes["BlogPostReviewReaction"][],
	paginateBlogPostReviewReaction:ModelTypes["BlogPostReviewReactionConnection"],
	validateCreateBlogPostReviewReaction:ModelTypes["_ValidationResult"],
	validateUpdateBlogPostReviewReaction:ModelTypes["_ValidationResult"],
	getProductReviewReaction?:ModelTypes["ProductReviewReaction"],
	listProductReviewReaction:ModelTypes["ProductReviewReaction"][],
	paginateProductReviewReaction:ModelTypes["ProductReviewReactionConnection"],
	validateCreateProductReviewReaction:ModelTypes["_ValidationResult"],
	validateUpdateProductReviewReaction:ModelTypes["_ValidationResult"],
	getProductPackage?:ModelTypes["ProductPackage"],
	listProductPackage:ModelTypes["ProductPackage"][],
	paginateProductPackage:ModelTypes["ProductPackageConnection"],
	validateCreateProductPackage:ModelTypes["_ValidationResult"],
	validateUpdateProductPackage:ModelTypes["_ValidationResult"],
	getBrandManufacturer?:ModelTypes["BrandManufacturer"],
	listBrandManufacturer:ModelTypes["BrandManufacturer"][],
	paginateBrandManufacturer:ModelTypes["BrandManufacturerConnection"],
	validateCreateBrandManufacturer:ModelTypes["_ValidationResult"],
	validateUpdateBrandManufacturer:ModelTypes["_ValidationResult"],
	getElement?:ModelTypes["Element"],
	listElement:ModelTypes["Element"][],
	paginateElement:ModelTypes["ElementConnection"],
	validateCreateElement:ModelTypes["_ValidationResult"],
	validateUpdateElement:ModelTypes["_ValidationResult"],
	getElementOfProduct?:ModelTypes["ElementOfProduct"],
	listElementOfProduct:ModelTypes["ElementOfProduct"][],
	paginateElementOfProduct:ModelTypes["ElementOfProductConnection"],
	validateCreateElementOfProduct:ModelTypes["_ValidationResult"],
	validateUpdateElementOfProduct:ModelTypes["_ValidationResult"],
	getSuitabilityCategory?:ModelTypes["SuitabilityCategory"],
	listSuitabilityCategory:ModelTypes["SuitabilityCategory"][],
	paginateSuitabilityCategory:ModelTypes["SuitabilityCategoryConnection"],
	validateCreateSuitabilityCategory:ModelTypes["_ValidationResult"],
	validateUpdateSuitabilityCategory:ModelTypes["_ValidationResult"],
	getProductFeature?:ModelTypes["ProductFeature"],
	listProductFeature:ModelTypes["ProductFeature"][],
	paginateProductFeature:ModelTypes["ProductFeatureConnection"],
	validateCreateProductFeature:ModelTypes["_ValidationResult"],
	validateUpdateProductFeature:ModelTypes["_ValidationResult"],
	getSuitabilityItem?:ModelTypes["SuitabilityItem"],
	listSuitabilityItem:ModelTypes["SuitabilityItem"][],
	paginateSuitabilityItem:ModelTypes["SuitabilityItemConnection"],
	validateCreateSuitabilityItem:ModelTypes["_ValidationResult"],
	validateUpdateSuitabilityItem:ModelTypes["_ValidationResult"],
	getRegion?:ModelTypes["Region"],
	listRegion:ModelTypes["Region"][],
	paginateRegion:ModelTypes["RegionConnection"],
	validateCreateRegion:ModelTypes["_ValidationResult"],
	validateUpdateRegion:ModelTypes["_ValidationResult"],
	getGranuleSize?:ModelTypes["GranuleSize"],
	listGranuleSize:ModelTypes["GranuleSize"][],
	paginateGranuleSize:ModelTypes["GranuleSizeConnection"],
	validateCreateGranuleSize:ModelTypes["_ValidationResult"],
	validateUpdateGranuleSize:ModelTypes["_ValidationResult"],
	getItemAlias?:ModelTypes["ItemAlias"],
	listItemAlias:ModelTypes["ItemAlias"][],
	paginateItemAlias:ModelTypes["ItemAliasConnection"],
	validateCreateItemAlias:ModelTypes["_ValidationResult"],
	validateUpdateItemAlias:ModelTypes["_ValidationResult"],
	getSemanticKey?:ModelTypes["SemanticKey"],
	listSemanticKey:ModelTypes["SemanticKey"][],
	paginateSemanticKey:ModelTypes["SemanticKeyConnection"],
	validateCreateSemanticKey:ModelTypes["_ValidationResult"],
	validateUpdateSemanticKey:ModelTypes["_ValidationResult"],
	getProductFlag?:ModelTypes["ProductFlag"],
	listProductFlag:ModelTypes["ProductFlag"][],
	paginateProductFlag:ModelTypes["ProductFlagConnection"],
	validateCreateProductFlag:ModelTypes["_ValidationResult"],
	validateUpdateProductFlag:ModelTypes["_ValidationResult"],
	getProductFlagOfProduct?:ModelTypes["ProductFlagOfProduct"],
	listProductFlagOfProduct:ModelTypes["ProductFlagOfProduct"][],
	paginateProductFlagOfProduct:ModelTypes["ProductFlagOfProductConnection"],
	validateCreateProductFlagOfProduct:ModelTypes["_ValidationResult"],
	validateUpdateProductFlagOfProduct:ModelTypes["_ValidationResult"],
	getProductEvaluation?:ModelTypes["ProductEvaluation"],
	listProductEvaluation:ModelTypes["ProductEvaluation"][],
	paginateProductEvaluation:ModelTypes["ProductEvaluationConnection"],
	validateCreateProductEvaluation:ModelTypes["_ValidationResult"],
	validateUpdateProductEvaluation:ModelTypes["_ValidationResult"],
	getAd?:ModelTypes["Ad"],
	listAd:ModelTypes["Ad"][],
	paginateAd:ModelTypes["AdConnection"],
	validateCreateAd:ModelTypes["_ValidationResult"],
	validateUpdateAd:ModelTypes["_ValidationResult"],
	getEvaluationInfo?:ModelTypes["EvaluationInfo"],
	listEvaluationInfo:ModelTypes["EvaluationInfo"][],
	paginateEvaluationInfo:ModelTypes["EvaluationInfoConnection"],
	validateCreateEvaluationInfo:ModelTypes["_ValidationResult"],
	validateUpdateEvaluationInfo:ModelTypes["_ValidationResult"],
	getConsumptionMessage?:ModelTypes["ConsumptionMessage"],
	listConsumptionMessage:ModelTypes["ConsumptionMessage"][],
	paginateConsumptionMessage:ModelTypes["ConsumptionMessageConnection"],
	validateCreateConsumptionMessage:ModelTypes["_ValidationResult"],
	validateUpdateConsumptionMessage:ModelTypes["_ValidationResult"],
	getContentText?:ModelTypes["ContentText"],
	listContentText:ModelTypes["ContentText"][],
	paginateContentText:ModelTypes["ContentTextConnection"],
	validateCreateContentText:ModelTypes["_ValidationResult"],
	validateUpdateContentText:ModelTypes["_ValidationResult"],
	getContentTextBlock?:ModelTypes["ContentTextBlock"],
	listContentTextBlock:ModelTypes["ContentTextBlock"][],
	paginateContentTextBlock:ModelTypes["ContentTextBlockConnection"],
	validateCreateContentTextBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentTextBlock:ModelTypes["_ValidationResult"],
	getProductReviewStats?:ModelTypes["ProductReviewStats"],
	listProductReviewStats:ModelTypes["ProductReviewStats"][],
	paginateProductReviewStats:ModelTypes["ProductReviewStatsConnection"],
	getBlogPostReviewStats?:ModelTypes["BlogPostReviewStats"],
	listBlogPostReviewStats:ModelTypes["BlogPostReviewStats"][],
	paginateBlogPostReviewStats:ModelTypes["BlogPostReviewStatsConnection"],
	getComparatorPage?:ModelTypes["ComparatorPage"],
	listComparatorPage:ModelTypes["ComparatorPage"][],
	paginateComparatorPage:ModelTypes["ComparatorPageConnection"],
	validateCreateComparatorPage:ModelTypes["_ValidationResult"],
	validateUpdateComparatorPage:ModelTypes["_ValidationResult"],
	getLoginPage?:ModelTypes["LoginPage"],
	listLoginPage:ModelTypes["LoginPage"][],
	paginateLoginPage:ModelTypes["LoginPageConnection"],
	validateCreateLoginPage:ModelTypes["_ValidationResult"],
	validateUpdateLoginPage:ModelTypes["_ValidationResult"],
	getRegisterPage?:ModelTypes["RegisterPage"],
	listRegisterPage:ModelTypes["RegisterPage"][],
	paginateRegisterPage:ModelTypes["RegisterPageConnection"],
	validateCreateRegisterPage:ModelTypes["_ValidationResult"],
	validateUpdateRegisterPage:ModelTypes["_ValidationResult"],
	getResultsPage?:ModelTypes["ResultsPage"],
	listResultsPage:ModelTypes["ResultsPage"][],
	paginateResultsPage:ModelTypes["ResultsPageConnection"],
	validateCreateResultsPage:ModelTypes["_ValidationResult"],
	validateUpdateResultsPage:ModelTypes["_ValidationResult"],
	getSearchPage?:ModelTypes["SearchPage"],
	listSearchPage:ModelTypes["SearchPage"][],
	paginateSearchPage:ModelTypes["SearchPageConnection"],
	validateCreateSearchPage:ModelTypes["_ValidationResult"],
	validateUpdateSearchPage:ModelTypes["_ValidationResult"],
	getWizardPage?:ModelTypes["WizardPage"],
	listWizardPage:ModelTypes["WizardPage"][],
	paginateWizardPage:ModelTypes["WizardPageConnection"],
	validateCreateWizardPage:ModelTypes["_ValidationResult"],
	validateUpdateWizardPage:ModelTypes["_ValidationResult"],
	getBreastfeedingCategory?:ModelTypes["BreastfeedingCategory"],
	listBreastfeedingCategory:ModelTypes["BreastfeedingCategory"][],
	paginateBreastfeedingCategory:ModelTypes["BreastfeedingCategoryConnection"],
	validateCreateBreastfeedingCategory:ModelTypes["_ValidationResult"],
	validateUpdateBreastfeedingCategory:ModelTypes["_ValidationResult"],
	getDogReproduction?:ModelTypes["DogReproduction"],
	listDogReproduction:ModelTypes["DogReproduction"][],
	paginateDogReproduction:ModelTypes["DogReproductionConnection"],
	validateCreateDogReproduction:ModelTypes["_ValidationResult"],
	validateUpdateDogReproduction:ModelTypes["_ValidationResult"],
	getContactFormMessage?:ModelTypes["ContactFormMessage"],
	listContactFormMessage:ModelTypes["ContactFormMessage"][],
	paginateContactFormMessage:ModelTypes["ContactFormMessageConnection"],
	validateCreateContactFormMessage:ModelTypes["_ValidationResult"],
	validateUpdateContactFormMessage:ModelTypes["_ValidationResult"],
	getContactPage?:ModelTypes["ContactPage"],
	listContactPage:ModelTypes["ContactPage"][],
	paginateContactPage:ModelTypes["ContactPageConnection"],
	validateCreateContactPage:ModelTypes["_ValidationResult"],
	validateUpdateContactPage:ModelTypes["_ValidationResult"],
	getBugReport?:ModelTypes["BugReport"],
	listBugReport:ModelTypes["BugReport"][],
	paginateBugReport:ModelTypes["BugReportConnection"],
	validateCreateBugReport:ModelTypes["_ValidationResult"],
	validateUpdateBugReport:ModelTypes["_ValidationResult"],
	getColor?:ModelTypes["Color"],
	listColor:ModelTypes["Color"][],
	paginateColor:ModelTypes["ColorConnection"],
	validateCreateColor:ModelTypes["_ValidationResult"],
	validateUpdateColor:ModelTypes["_ValidationResult"],
	getItemGroup?:ModelTypes["ItemGroup"],
	listItemGroup:ModelTypes["ItemGroup"][],
	paginateItemGroup:ModelTypes["ItemGroupConnection"],
	validateCreateItemGroup:ModelTypes["_ValidationResult"],
	validateUpdateItemGroup:ModelTypes["_ValidationResult"],
	getSearchResult?:ModelTypes["SearchResult"],
	listSearchResult:ModelTypes["SearchResult"][],
	paginateSearchResult:ModelTypes["SearchResultConnection"],
	getProductEvaluationSummary?:ModelTypes["ProductEvaluationSummary"],
	listProductEvaluationSummary:ModelTypes["ProductEvaluationSummary"][],
	paginateProductEvaluationSummary:ModelTypes["ProductEvaluationSummaryConnection"],
	validateCreateProductEvaluationSummary:ModelTypes["_ValidationResult"],
	validateUpdateProductEvaluationSummary:ModelTypes["_ValidationResult"],
	getProtectedAction?:ModelTypes["ProtectedAction"],
	listProtectedAction:ModelTypes["ProtectedAction"][],
	paginateProtectedAction:ModelTypes["ProtectedActionConnection"],
	validateCreateProtectedAction:ModelTypes["_ValidationResult"],
	validateUpdateProtectedAction:ModelTypes["_ValidationResult"],
	getBrandAlias?:ModelTypes["BrandAlias"],
	listBrandAlias:ModelTypes["BrandAlias"][],
	paginateBrandAlias:ModelTypes["BrandAliasConnection"],
	validateCreateBrandAlias:ModelTypes["_ValidationResult"],
	validateUpdateBrandAlias:ModelTypes["_ValidationResult"],
	getProductAlias?:ModelTypes["ProductAlias"],
	listProductAlias:ModelTypes["ProductAlias"][],
	paginateProductAlias:ModelTypes["ProductAliasConnection"],
	validateCreateProductAlias:ModelTypes["_ValidationResult"],
	validateUpdateProductAlias:ModelTypes["_ValidationResult"],
	getProductLineAlias?:ModelTypes["ProductLineAlias"],
	listProductLineAlias:ModelTypes["ProductLineAlias"][],
	paginateProductLineAlias:ModelTypes["ProductLineAliasConnection"],
	validateCreateProductLineAlias:ModelTypes["_ValidationResult"],
	validateUpdateProductLineAlias:ModelTypes["_ValidationResult"],
	getGenericPage?:ModelTypes["GenericPage"],
	listGenericPage:ModelTypes["GenericPage"][],
	paginateGenericPage:ModelTypes["GenericPageConnection"],
	validateCreateGenericPage:ModelTypes["_ValidationResult"],
	validateUpdateGenericPage:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getContentLinks?:ModelTypes["ContentLinks"],
	listContentLinks:ModelTypes["ContentLinks"][],
	paginateContentLinks:ModelTypes["ContentLinksConnection"],
	validateCreateContentLinks:ModelTypes["_ValidationResult"],
	validateUpdateContentLinks:ModelTypes["_ValidationResult"],
	getContentLinksItem?:ModelTypes["ContentLinksItem"],
	listContentLinksItem:ModelTypes["ContentLinksItem"][],
	paginateContentLinksItem:ModelTypes["ContentLinksItemConnection"],
	validateCreateContentLinksItem:ModelTypes["_ValidationResult"],
	validateUpdateContentLinksItem:ModelTypes["_ValidationResult"],
	getRedirect?:ModelTypes["Redirect"],
	listRedirect:ModelTypes["Redirect"][],
	paginateRedirect:ModelTypes["RedirectConnection"],
	validateCreateRedirect:ModelTypes["_ValidationResult"],
	validateUpdateRedirect:ModelTypes["_ValidationResult"],
	getContentReferenceImage?:ModelTypes["ContentReferenceImage"],
	listContentReferenceImage:ModelTypes["ContentReferenceImage"][],
	paginateContentReferenceImage:ModelTypes["ContentReferenceImageConnection"],
	validateCreateContentReferenceImage:ModelTypes["_ValidationResult"],
	validateUpdateContentReferenceImage:ModelTypes["_ValidationResult"],
	getSeoData?:ModelTypes["SeoData"],
	listSeoData:ModelTypes["SeoData"][],
	paginateSeoData:ModelTypes["SeoDataConnection"],
	validateCreateSeoData:ModelTypes["_ValidationResult"],
	validateUpdateSeoData:ModelTypes["_ValidationResult"],
	getTenantPerson?:ModelTypes["TenantPerson"],
	listTenantPerson:ModelTypes["TenantPerson"][],
	paginateTenantPerson:ModelTypes["TenantPersonConnection"],
	getBrandFlavor?:ModelTypes["BrandFlavor"],
	listBrandFlavor:ModelTypes["BrandFlavor"][],
	paginateBrandFlavor:ModelTypes["BrandFlavorConnection"],
	getProductLineFlavor?:ModelTypes["ProductLineFlavor"],
	listProductLineFlavor:ModelTypes["ProductLineFlavor"][],
	paginateProductLineFlavor:ModelTypes["ProductLineFlavorConnection"],
	getProductItemDeclensionFourthCategory?:ModelTypes["ProductItemDeclensionFourthCategory"],
	listProductItemDeclensionFourthCategory:ModelTypes["ProductItemDeclensionFourthCategory"][],
	paginateProductItemDeclensionFourthCategory:ModelTypes["ProductItemDeclensionFourthCategoryConnection"],
	getAgeCategory?:ModelTypes["AgeCategory"],
	listAgeCategory:ModelTypes["AgeCategory"][],
	paginateAgeCategory:ModelTypes["AgeCategoryConnection"],
	validateCreateAgeCategory:ModelTypes["_ValidationResult"],
	validateUpdateAgeCategory:ModelTypes["_ValidationResult"],
	getFilterCombo?:ModelTypes["FilterCombo"],
	listFilterCombo:ModelTypes["FilterCombo"][],
	paginateFilterCombo:ModelTypes["FilterComboConnection"],
	validateCreateFilterCombo:ModelTypes["_ValidationResult"],
	validateUpdateFilterCombo:ModelTypes["_ValidationResult"],
	getImportCache?:ModelTypes["ImportCache"],
	listImportCache:ModelTypes["ImportCache"][],
	paginateImportCache:ModelTypes["ImportCacheConnection"],
	validateCreateImportCache:ModelTypes["_ValidationResult"],
	validateUpdateImportCache:ModelTypes["_ValidationResult"],
	getSite?:ModelTypes["Site"],
	listSite:ModelTypes["Site"][],
	paginateSite:ModelTypes["SiteConnection"],
	validateCreateSite:ModelTypes["_ValidationResult"],
	validateUpdateSite:ModelTypes["_ValidationResult"],
	getContactSubmission?:ModelTypes["ContactSubmission"],
	listContactSubmission:ModelTypes["ContactSubmission"][],
	paginateContactSubmission:ModelTypes["ContactSubmissionConnection"],
	validateCreateContactSubmission:ModelTypes["_ValidationResult"],
	validateUpdateContactSubmission:ModelTypes["_ValidationResult"],
	getTOPXBrand?:ModelTypes["TOPXBrand"],
	listTOPXBrand:ModelTypes["TOPXBrand"][],
	paginateTOPXBrand:ModelTypes["TOPXBrandConnection"],
	validateCreateTOPXBrand:ModelTypes["_ValidationResult"],
	validateUpdateTOPXBrand:ModelTypes["_ValidationResult"],
	getTOPXBrandCategory?:ModelTypes["TOPXBrandCategory"],
	listTOPXBrandCategory:ModelTypes["TOPXBrandCategory"][],
	paginateTOPXBrandCategory:ModelTypes["TOPXBrandCategoryConnection"],
	validateCreateTOPXBrandCategory:ModelTypes["_ValidationResult"],
	validateUpdateTOPXBrandCategory:ModelTypes["_ValidationResult"],
	getTOPXProduct?:ModelTypes["TOPXProduct"],
	listTOPXProduct:ModelTypes["TOPXProduct"][],
	paginateTOPXProduct:ModelTypes["TOPXProductConnection"],
	validateCreateTOPXProduct:ModelTypes["_ValidationResult"],
	validateUpdateTOPXProduct:ModelTypes["_ValidationResult"],
	getTOPXProductCategory?:ModelTypes["TOPXProductCategory"],
	listTOPXProductCategory:ModelTypes["TOPXProductCategory"][],
	paginateTOPXProductCategory:ModelTypes["TOPXProductCategoryConnection"],
	validateCreateTOPXProductCategory:ModelTypes["_ValidationResult"],
	validateUpdateTOPXProductCategory:ModelTypes["_ValidationResult"],
	getContentReferenceList?:ModelTypes["ContentReferenceList"],
	listContentReferenceList:ModelTypes["ContentReferenceList"][],
	paginateContentReferenceList:ModelTypes["ContentReferenceListConnection"],
	validateCreateContentReferenceList:ModelTypes["_ValidationResult"],
	validateUpdateContentReferenceList:ModelTypes["_ValidationResult"],
	getBrandCount?:ModelTypes["BrandCount"],
	listBrandCount:ModelTypes["BrandCount"][],
	paginateBrandCount:ModelTypes["BrandCountConnection"],
	getProductCount?:ModelTypes["ProductCount"],
	listProductCount:ModelTypes["ProductCount"][],
	paginateProductCount:ModelTypes["ProductCountConnection"]
};
	["Info"]: {
		description?:string
};
	["Mutation"]: {
		generateUploadUrl:ModelTypes["S3SignedUpload"],
	generateReadUrl:ModelTypes["S3SignedRead"],
	createBlogPage:ModelTypes["BlogPageCreateResult"],
	deleteBlogPage:ModelTypes["BlogPageDeleteResult"],
	updateBlogPage:ModelTypes["BlogPageUpdateResult"],
	upsertBlogPage:ModelTypes["BlogPageUpsertResult"],
	createBlogPost:ModelTypes["BlogPostCreateResult"],
	deleteBlogPost:ModelTypes["BlogPostDeleteResult"],
	updateBlogPost:ModelTypes["BlogPostUpdateResult"],
	upsertBlogPost:ModelTypes["BlogPostUpsertResult"],
	createBlogPostTag:ModelTypes["BlogPostTagCreateResult"],
	deleteBlogPostTag:ModelTypes["BlogPostTagDeleteResult"],
	updateBlogPostTag:ModelTypes["BlogPostTagUpdateResult"],
	upsertBlogPostTag:ModelTypes["BlogPostTagUpsertResult"],
	createBodyTag:ModelTypes["BodyTagCreateResult"],
	deleteBodyTag:ModelTypes["BodyTagDeleteResult"],
	updateBodyTag:ModelTypes["BodyTagUpdateResult"],
	upsertBodyTag:ModelTypes["BodyTagUpsertResult"],
	createBodyTagCategory:ModelTypes["BodyTagCategoryCreateResult"],
	deleteBodyTagCategory:ModelTypes["BodyTagCategoryDeleteResult"],
	updateBodyTagCategory:ModelTypes["BodyTagCategoryUpdateResult"],
	upsertBodyTagCategory:ModelTypes["BodyTagCategoryUpsertResult"],
	createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createDidYouKnow:ModelTypes["DidYouKnowCreateResult"],
	deleteDidYouKnow:ModelTypes["DidYouKnowDeleteResult"],
	updateDidYouKnow:ModelTypes["DidYouKnowUpdateResult"],
	upsertDidYouKnow:ModelTypes["DidYouKnowUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createMedium:ModelTypes["MediumCreateResult"],
	deleteMedium:ModelTypes["MediumDeleteResult"],
	updateMedium:ModelTypes["MediumUpdateResult"],
	upsertMedium:ModelTypes["MediumUpsertResult"],
	createNutritionalValue:ModelTypes["NutritionalValueCreateResult"],
	deleteNutritionalValue:ModelTypes["NutritionalValueDeleteResult"],
	updateNutritionalValue:ModelTypes["NutritionalValueUpdateResult"],
	upsertNutritionalValue:ModelTypes["NutritionalValueUpsertResult"],
	createPage:ModelTypes["PageCreateResult"],
	deletePage:ModelTypes["PageDeleteResult"],
	updatePage:ModelTypes["PageUpdateResult"],
	upsertPage:ModelTypes["PageUpsertResult"],
	createReference:ModelTypes["ReferenceCreateResult"],
	deleteReference:ModelTypes["ReferenceDeleteResult"],
	updateReference:ModelTypes["ReferenceUpdateResult"],
	upsertReference:ModelTypes["ReferenceUpsertResult"],
	createReferenceList:ModelTypes["ReferenceListCreateResult"],
	deleteReferenceList:ModelTypes["ReferenceListDeleteResult"],
	updateReferenceList:ModelTypes["ReferenceListUpdateResult"],
	upsertReferenceList:ModelTypes["ReferenceListUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createVideo:ModelTypes["VideoCreateResult"],
	deleteVideo:ModelTypes["VideoDeleteResult"],
	updateVideo:ModelTypes["VideoUpdateResult"],
	upsertVideo:ModelTypes["VideoUpsertResult"],
	createBrand:ModelTypes["BrandCreateResult"],
	deleteBrand:ModelTypes["BrandDeleteResult"],
	updateBrand:ModelTypes["BrandUpdateResult"],
	upsertBrand:ModelTypes["BrandUpsertResult"],
	createBrandDistributor:ModelTypes["BrandDistributorCreateResult"],
	deleteBrandDistributor:ModelTypes["BrandDistributorDeleteResult"],
	updateBrandDistributor:ModelTypes["BrandDistributorUpdateResult"],
	upsertBrandDistributor:ModelTypes["BrandDistributorUpsertResult"],
	createDogSize:ModelTypes["DogSizeCreateResult"],
	deleteDogSize:ModelTypes["DogSizeDeleteResult"],
	updateDogSize:ModelTypes["DogSizeUpdateResult"],
	upsertDogSize:ModelTypes["DogSizeUpsertResult"],
	createProduct:ModelTypes["ProductCreateResult"],
	deleteProduct:ModelTypes["ProductDeleteResult"],
	updateProduct:ModelTypes["ProductUpdateResult"],
	upsertProduct:ModelTypes["ProductUpsertResult"],
	createProductionMethod:ModelTypes["ProductionMethodCreateResult"],
	deleteProductionMethod:ModelTypes["ProductionMethodDeleteResult"],
	updateProductionMethod:ModelTypes["ProductionMethodUpdateResult"],
	upsertProductionMethod:ModelTypes["ProductionMethodUpsertResult"],
	createProductLine:ModelTypes["ProductLineCreateResult"],
	deleteProductLine:ModelTypes["ProductLineDeleteResult"],
	updateProductLine:ModelTypes["ProductLineUpdateResult"],
	upsertProductLine:ModelTypes["ProductLineUpsertResult"],
	createBreed:ModelTypes["BreedCreateResult"],
	deleteBreed:ModelTypes["BreedDeleteResult"],
	updateBreed:ModelTypes["BreedUpdateResult"],
	upsertBreed:ModelTypes["BreedUpsertResult"],
	createDog:ModelTypes["DogCreateResult"],
	deleteDog:ModelTypes["DogDeleteResult"],
	updateDog:ModelTypes["DogUpdateResult"],
	upsertDog:ModelTypes["DogUpsertResult"],
	createUser:ModelTypes["UserCreateResult"],
	deleteUser:ModelTypes["UserDeleteResult"],
	updateUser:ModelTypes["UserUpdateResult"],
	upsertUser:ModelTypes["UserUpsertResult"],
	createVeterinary:ModelTypes["VeterinaryCreateResult"],
	deleteVeterinary:ModelTypes["VeterinaryDeleteResult"],
	updateVeterinary:ModelTypes["VeterinaryUpdateResult"],
	upsertVeterinary:ModelTypes["VeterinaryUpsertResult"],
	createNutritionalValueOfProduct:ModelTypes["NutritionalValueOfProductCreateResult"],
	deleteNutritionalValueOfProduct:ModelTypes["NutritionalValueOfProductDeleteResult"],
	updateNutritionalValueOfProduct:ModelTypes["NutritionalValueOfProductUpdateResult"],
	upsertNutritionalValueOfProduct:ModelTypes["NutritionalValueOfProductUpsertResult"],
	createReview:ModelTypes["ReviewCreateResult"],
	deleteReview:ModelTypes["ReviewDeleteResult"],
	updateReview:ModelTypes["ReviewUpdateResult"],
	upsertReview:ModelTypes["ReviewUpsertResult"],
	createDogBodyType:ModelTypes["DogBodyTypeCreateResult"],
	deleteDogBodyType:ModelTypes["DogBodyTypeDeleteResult"],
	updateDogBodyType:ModelTypes["DogBodyTypeUpdateResult"],
	upsertDogBodyType:ModelTypes["DogBodyTypeUpsertResult"],
	createDogBodyTypeCategory:ModelTypes["DogBodyTypeCategoryCreateResult"],
	deleteDogBodyTypeCategory:ModelTypes["DogBodyTypeCategoryDeleteResult"],
	updateDogBodyTypeCategory:ModelTypes["DogBodyTypeCategoryUpdateResult"],
	upsertDogBodyTypeCategory:ModelTypes["DogBodyTypeCategoryUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createUrl:ModelTypes["UrlCreateResult"],
	deleteUrl:ModelTypes["UrlDeleteResult"],
	updateUrl:ModelTypes["UrlUpdateResult"],
	upsertUrl:ModelTypes["UrlUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createFooterLink:ModelTypes["FooterLinkCreateResult"],
	deleteFooterLink:ModelTypes["FooterLinkDeleteResult"],
	updateFooterLink:ModelTypes["FooterLinkUpdateResult"],
	upsertFooterLink:ModelTypes["FooterLinkUpsertResult"],
	createBrandsPage:ModelTypes["BrandsPageCreateResult"],
	deleteBrandsPage:ModelTypes["BrandsPageDeleteResult"],
	updateBrandsPage:ModelTypes["BrandsPageUpdateResult"],
	upsertBrandsPage:ModelTypes["BrandsPageUpsertResult"],
	createHomePage:ModelTypes["HomePageCreateResult"],
	deleteHomePage:ModelTypes["HomePageDeleteResult"],
	updateHomePage:ModelTypes["HomePageUpdateResult"],
	upsertHomePage:ModelTypes["HomePageUpsertResult"],
	createIngredientsPage:ModelTypes["IngredientsPageCreateResult"],
	deleteIngredientsPage:ModelTypes["IngredientsPageDeleteResult"],
	updateIngredientsPage:ModelTypes["IngredientsPageUpdateResult"],
	upsertIngredientsPage:ModelTypes["IngredientsPageUpsertResult"],
	createProductReview:ModelTypes["ProductReviewCreateResult"],
	deleteProductReview:ModelTypes["ProductReviewDeleteResult"],
	updateProductReview:ModelTypes["ProductReviewUpdateResult"],
	upsertProductReview:ModelTypes["ProductReviewUpsertResult"],
	createScore:ModelTypes["ScoreCreateResult"],
	deleteScore:ModelTypes["ScoreDeleteResult"],
	updateScore:ModelTypes["ScoreUpdateResult"],
	upsertScore:ModelTypes["ScoreUpsertResult"],
	createAge:ModelTypes["AgeCreateResult"],
	deleteAge:ModelTypes["AgeDeleteResult"],
	updateAge:ModelTypes["AgeUpdateResult"],
	upsertAge:ModelTypes["AgeUpsertResult"],
	createCountry:ModelTypes["CountryCreateResult"],
	deleteCountry:ModelTypes["CountryDeleteResult"],
	updateCountry:ModelTypes["CountryUpdateResult"],
	upsertCountry:ModelTypes["CountryUpsertResult"],
	createBlogPostReview:ModelTypes["BlogPostReviewCreateResult"],
	deleteBlogPostReview:ModelTypes["BlogPostReviewDeleteResult"],
	updateBlogPostReview:ModelTypes["BlogPostReviewUpdateResult"],
	upsertBlogPostReview:ModelTypes["BlogPostReviewUpsertResult"],
	createDogActivity:ModelTypes["DogActivityCreateResult"],
	deleteDogActivity:ModelTypes["DogActivityDeleteResult"],
	updateDogActivity:ModelTypes["DogActivityUpdateResult"],
	upsertDogActivity:ModelTypes["DogActivityUpsertResult"],
	createSocial:ModelTypes["SocialCreateResult"],
	deleteSocial:ModelTypes["SocialDeleteResult"],
	updateSocial:ModelTypes["SocialUpdateResult"],
	upsertSocial:ModelTypes["SocialUpsertResult"],
	createContentReferenceGalleryImage:ModelTypes["ContentReferenceGalleryImageCreateResult"],
	deleteContentReferenceGalleryImage:ModelTypes["ContentReferenceGalleryImageDeleteResult"],
	updateContentReferenceGalleryImage:ModelTypes["ContentReferenceGalleryImageUpdateResult"],
	upsertContentReferenceGalleryImage:ModelTypes["ContentReferenceGalleryImageUpsertResult"],
	createItem:ModelTypes["ItemCreateResult"],
	deleteItem:ModelTypes["ItemDeleteResult"],
	updateItem:ModelTypes["ItemUpdateResult"],
	upsertItem:ModelTypes["ItemUpsertResult"],
	createItemSubCategory:ModelTypes["ItemSubCategoryCreateResult"],
	deleteItemSubCategory:ModelTypes["ItemSubCategoryDeleteResult"],
	updateItemSubCategory:ModelTypes["ItemSubCategoryUpdateResult"],
	upsertItemSubCategory:ModelTypes["ItemSubCategoryUpsertResult"],
	createItemCategory:ModelTypes["ItemCategoryCreateResult"],
	deleteItemCategory:ModelTypes["ItemCategoryDeleteResult"],
	updateItemCategory:ModelTypes["ItemCategoryUpdateResult"],
	upsertItemCategory:ModelTypes["ItemCategoryUpsertResult"],
	createItemFlavorCategory:ModelTypes["ItemFlavorCategoryCreateResult"],
	deleteItemFlavorCategory:ModelTypes["ItemFlavorCategoryDeleteResult"],
	updateItemFlavorCategory:ModelTypes["ItemFlavorCategoryUpdateResult"],
	upsertItemFlavorCategory:ModelTypes["ItemFlavorCategoryUpsertResult"],
	createItemDeclensionFourthVariant:ModelTypes["ItemDeclensionFourthVariantCreateResult"],
	deleteItemDeclensionFourthVariant:ModelTypes["ItemDeclensionFourthVariantDeleteResult"],
	updateItemDeclensionFourthVariant:ModelTypes["ItemDeclensionFourthVariantUpdateResult"],
	upsertItemDeclensionFourthVariant:ModelTypes["ItemDeclensionFourthVariantUpsertResult"],
	createItemDeclensionSeventhVariant:ModelTypes["ItemDeclensionSeventhVariantCreateResult"],
	deleteItemDeclensionSeventhVariant:ModelTypes["ItemDeclensionSeventhVariantDeleteResult"],
	updateItemDeclensionSeventhVariant:ModelTypes["ItemDeclensionSeventhVariantUpdateResult"],
	upsertItemDeclensionSeventhVariant:ModelTypes["ItemDeclensionSeventhVariantUpsertResult"],
	createMediaCard:ModelTypes["MediaCardCreateResult"],
	deleteMediaCard:ModelTypes["MediaCardDeleteResult"],
	updateMediaCard:ModelTypes["MediaCardUpdateResult"],
	upsertMediaCard:ModelTypes["MediaCardUpsertResult"],
	createInfoCard:ModelTypes["InfoCardCreateResult"],
	deleteInfoCard:ModelTypes["InfoCardDeleteResult"],
	updateInfoCard:ModelTypes["InfoCardUpdateResult"],
	upsertInfoCard:ModelTypes["InfoCardUpsertResult"],
	createNumberedCard:ModelTypes["NumberedCardCreateResult"],
	deleteNumberedCard:ModelTypes["NumberedCardDeleteResult"],
	updateNumberedCard:ModelTypes["NumberedCardUpdateResult"],
	upsertNumberedCard:ModelTypes["NumberedCardUpsertResult"],
	createRegisterClaim:ModelTypes["RegisterClaimCreateResult"],
	deleteRegisterClaim:ModelTypes["RegisterClaimDeleteResult"],
	updateRegisterClaim:ModelTypes["RegisterClaimUpdateResult"],
	upsertRegisterClaim:ModelTypes["RegisterClaimUpsertResult"],
	createBlogPostReviewReaction:ModelTypes["BlogPostReviewReactionCreateResult"],
	deleteBlogPostReviewReaction:ModelTypes["BlogPostReviewReactionDeleteResult"],
	updateBlogPostReviewReaction:ModelTypes["BlogPostReviewReactionUpdateResult"],
	upsertBlogPostReviewReaction:ModelTypes["BlogPostReviewReactionUpsertResult"],
	createProductReviewReaction:ModelTypes["ProductReviewReactionCreateResult"],
	deleteProductReviewReaction:ModelTypes["ProductReviewReactionDeleteResult"],
	updateProductReviewReaction:ModelTypes["ProductReviewReactionUpdateResult"],
	upsertProductReviewReaction:ModelTypes["ProductReviewReactionUpsertResult"],
	createProductPackage:ModelTypes["ProductPackageCreateResult"],
	deleteProductPackage:ModelTypes["ProductPackageDeleteResult"],
	updateProductPackage:ModelTypes["ProductPackageUpdateResult"],
	upsertProductPackage:ModelTypes["ProductPackageUpsertResult"],
	createBrandManufacturer:ModelTypes["BrandManufacturerCreateResult"],
	deleteBrandManufacturer:ModelTypes["BrandManufacturerDeleteResult"],
	updateBrandManufacturer:ModelTypes["BrandManufacturerUpdateResult"],
	upsertBrandManufacturer:ModelTypes["BrandManufacturerUpsertResult"],
	createElement:ModelTypes["ElementCreateResult"],
	deleteElement:ModelTypes["ElementDeleteResult"],
	updateElement:ModelTypes["ElementUpdateResult"],
	upsertElement:ModelTypes["ElementUpsertResult"],
	createElementOfProduct:ModelTypes["ElementOfProductCreateResult"],
	deleteElementOfProduct:ModelTypes["ElementOfProductDeleteResult"],
	updateElementOfProduct:ModelTypes["ElementOfProductUpdateResult"],
	upsertElementOfProduct:ModelTypes["ElementOfProductUpsertResult"],
	createSuitabilityCategory:ModelTypes["SuitabilityCategoryCreateResult"],
	deleteSuitabilityCategory:ModelTypes["SuitabilityCategoryDeleteResult"],
	updateSuitabilityCategory:ModelTypes["SuitabilityCategoryUpdateResult"],
	upsertSuitabilityCategory:ModelTypes["SuitabilityCategoryUpsertResult"],
	createProductFeature:ModelTypes["ProductFeatureCreateResult"],
	deleteProductFeature:ModelTypes["ProductFeatureDeleteResult"],
	updateProductFeature:ModelTypes["ProductFeatureUpdateResult"],
	upsertProductFeature:ModelTypes["ProductFeatureUpsertResult"],
	createSuitabilityItem:ModelTypes["SuitabilityItemCreateResult"],
	deleteSuitabilityItem:ModelTypes["SuitabilityItemDeleteResult"],
	updateSuitabilityItem:ModelTypes["SuitabilityItemUpdateResult"],
	upsertSuitabilityItem:ModelTypes["SuitabilityItemUpsertResult"],
	createRegion:ModelTypes["RegionCreateResult"],
	deleteRegion:ModelTypes["RegionDeleteResult"],
	updateRegion:ModelTypes["RegionUpdateResult"],
	upsertRegion:ModelTypes["RegionUpsertResult"],
	createGranuleSize:ModelTypes["GranuleSizeCreateResult"],
	deleteGranuleSize:ModelTypes["GranuleSizeDeleteResult"],
	updateGranuleSize:ModelTypes["GranuleSizeUpdateResult"],
	upsertGranuleSize:ModelTypes["GranuleSizeUpsertResult"],
	createItemAlias:ModelTypes["ItemAliasCreateResult"],
	deleteItemAlias:ModelTypes["ItemAliasDeleteResult"],
	updateItemAlias:ModelTypes["ItemAliasUpdateResult"],
	upsertItemAlias:ModelTypes["ItemAliasUpsertResult"],
	createSemanticKey:ModelTypes["SemanticKeyCreateResult"],
	deleteSemanticKey:ModelTypes["SemanticKeyDeleteResult"],
	updateSemanticKey:ModelTypes["SemanticKeyUpdateResult"],
	upsertSemanticKey:ModelTypes["SemanticKeyUpsertResult"],
	createProductFlag:ModelTypes["ProductFlagCreateResult"],
	deleteProductFlag:ModelTypes["ProductFlagDeleteResult"],
	updateProductFlag:ModelTypes["ProductFlagUpdateResult"],
	upsertProductFlag:ModelTypes["ProductFlagUpsertResult"],
	createProductFlagOfProduct:ModelTypes["ProductFlagOfProductCreateResult"],
	deleteProductFlagOfProduct:ModelTypes["ProductFlagOfProductDeleteResult"],
	updateProductFlagOfProduct:ModelTypes["ProductFlagOfProductUpdateResult"],
	upsertProductFlagOfProduct:ModelTypes["ProductFlagOfProductUpsertResult"],
	createProductEvaluation:ModelTypes["ProductEvaluationCreateResult"],
	deleteProductEvaluation:ModelTypes["ProductEvaluationDeleteResult"],
	updateProductEvaluation:ModelTypes["ProductEvaluationUpdateResult"],
	upsertProductEvaluation:ModelTypes["ProductEvaluationUpsertResult"],
	createAd:ModelTypes["AdCreateResult"],
	deleteAd:ModelTypes["AdDeleteResult"],
	updateAd:ModelTypes["AdUpdateResult"],
	upsertAd:ModelTypes["AdUpsertResult"],
	createEvaluationInfo:ModelTypes["EvaluationInfoCreateResult"],
	deleteEvaluationInfo:ModelTypes["EvaluationInfoDeleteResult"],
	updateEvaluationInfo:ModelTypes["EvaluationInfoUpdateResult"],
	upsertEvaluationInfo:ModelTypes["EvaluationInfoUpsertResult"],
	createConsumptionMessage:ModelTypes["ConsumptionMessageCreateResult"],
	deleteConsumptionMessage:ModelTypes["ConsumptionMessageDeleteResult"],
	updateConsumptionMessage:ModelTypes["ConsumptionMessageUpdateResult"],
	upsertConsumptionMessage:ModelTypes["ConsumptionMessageUpsertResult"],
	createContentText:ModelTypes["ContentTextCreateResult"],
	deleteContentText:ModelTypes["ContentTextDeleteResult"],
	updateContentText:ModelTypes["ContentTextUpdateResult"],
	upsertContentText:ModelTypes["ContentTextUpsertResult"],
	createContentTextBlock:ModelTypes["ContentTextBlockCreateResult"],
	deleteContentTextBlock:ModelTypes["ContentTextBlockDeleteResult"],
	updateContentTextBlock:ModelTypes["ContentTextBlockUpdateResult"],
	upsertContentTextBlock:ModelTypes["ContentTextBlockUpsertResult"],
	createComparatorPage:ModelTypes["ComparatorPageCreateResult"],
	deleteComparatorPage:ModelTypes["ComparatorPageDeleteResult"],
	updateComparatorPage:ModelTypes["ComparatorPageUpdateResult"],
	upsertComparatorPage:ModelTypes["ComparatorPageUpsertResult"],
	createLoginPage:ModelTypes["LoginPageCreateResult"],
	deleteLoginPage:ModelTypes["LoginPageDeleteResult"],
	updateLoginPage:ModelTypes["LoginPageUpdateResult"],
	upsertLoginPage:ModelTypes["LoginPageUpsertResult"],
	createRegisterPage:ModelTypes["RegisterPageCreateResult"],
	deleteRegisterPage:ModelTypes["RegisterPageDeleteResult"],
	updateRegisterPage:ModelTypes["RegisterPageUpdateResult"],
	upsertRegisterPage:ModelTypes["RegisterPageUpsertResult"],
	createResultsPage:ModelTypes["ResultsPageCreateResult"],
	deleteResultsPage:ModelTypes["ResultsPageDeleteResult"],
	updateResultsPage:ModelTypes["ResultsPageUpdateResult"],
	upsertResultsPage:ModelTypes["ResultsPageUpsertResult"],
	createSearchPage:ModelTypes["SearchPageCreateResult"],
	deleteSearchPage:ModelTypes["SearchPageDeleteResult"],
	updateSearchPage:ModelTypes["SearchPageUpdateResult"],
	upsertSearchPage:ModelTypes["SearchPageUpsertResult"],
	createWizardPage:ModelTypes["WizardPageCreateResult"],
	deleteWizardPage:ModelTypes["WizardPageDeleteResult"],
	updateWizardPage:ModelTypes["WizardPageUpdateResult"],
	upsertWizardPage:ModelTypes["WizardPageUpsertResult"],
	createBreastfeedingCategory:ModelTypes["BreastfeedingCategoryCreateResult"],
	deleteBreastfeedingCategory:ModelTypes["BreastfeedingCategoryDeleteResult"],
	updateBreastfeedingCategory:ModelTypes["BreastfeedingCategoryUpdateResult"],
	upsertBreastfeedingCategory:ModelTypes["BreastfeedingCategoryUpsertResult"],
	createDogReproduction:ModelTypes["DogReproductionCreateResult"],
	deleteDogReproduction:ModelTypes["DogReproductionDeleteResult"],
	updateDogReproduction:ModelTypes["DogReproductionUpdateResult"],
	upsertDogReproduction:ModelTypes["DogReproductionUpsertResult"],
	createContactFormMessage:ModelTypes["ContactFormMessageCreateResult"],
	deleteContactFormMessage:ModelTypes["ContactFormMessageDeleteResult"],
	updateContactFormMessage:ModelTypes["ContactFormMessageUpdateResult"],
	upsertContactFormMessage:ModelTypes["ContactFormMessageUpsertResult"],
	createContactPage:ModelTypes["ContactPageCreateResult"],
	deleteContactPage:ModelTypes["ContactPageDeleteResult"],
	updateContactPage:ModelTypes["ContactPageUpdateResult"],
	upsertContactPage:ModelTypes["ContactPageUpsertResult"],
	createBugReport:ModelTypes["BugReportCreateResult"],
	deleteBugReport:ModelTypes["BugReportDeleteResult"],
	updateBugReport:ModelTypes["BugReportUpdateResult"],
	upsertBugReport:ModelTypes["BugReportUpsertResult"],
	createColor:ModelTypes["ColorCreateResult"],
	deleteColor:ModelTypes["ColorDeleteResult"],
	updateColor:ModelTypes["ColorUpdateResult"],
	upsertColor:ModelTypes["ColorUpsertResult"],
	createItemGroup:ModelTypes["ItemGroupCreateResult"],
	deleteItemGroup:ModelTypes["ItemGroupDeleteResult"],
	updateItemGroup:ModelTypes["ItemGroupUpdateResult"],
	upsertItemGroup:ModelTypes["ItemGroupUpsertResult"],
	createProductEvaluationSummary:ModelTypes["ProductEvaluationSummaryCreateResult"],
	deleteProductEvaluationSummary:ModelTypes["ProductEvaluationSummaryDeleteResult"],
	updateProductEvaluationSummary:ModelTypes["ProductEvaluationSummaryUpdateResult"],
	upsertProductEvaluationSummary:ModelTypes["ProductEvaluationSummaryUpsertResult"],
	createProtectedAction:ModelTypes["ProtectedActionCreateResult"],
	deleteProtectedAction:ModelTypes["ProtectedActionDeleteResult"],
	updateProtectedAction:ModelTypes["ProtectedActionUpdateResult"],
	upsertProtectedAction:ModelTypes["ProtectedActionUpsertResult"],
	createBrandAlias:ModelTypes["BrandAliasCreateResult"],
	deleteBrandAlias:ModelTypes["BrandAliasDeleteResult"],
	updateBrandAlias:ModelTypes["BrandAliasUpdateResult"],
	upsertBrandAlias:ModelTypes["BrandAliasUpsertResult"],
	createProductAlias:ModelTypes["ProductAliasCreateResult"],
	deleteProductAlias:ModelTypes["ProductAliasDeleteResult"],
	updateProductAlias:ModelTypes["ProductAliasUpdateResult"],
	upsertProductAlias:ModelTypes["ProductAliasUpsertResult"],
	createProductLineAlias:ModelTypes["ProductLineAliasCreateResult"],
	deleteProductLineAlias:ModelTypes["ProductLineAliasDeleteResult"],
	updateProductLineAlias:ModelTypes["ProductLineAliasUpdateResult"],
	upsertProductLineAlias:ModelTypes["ProductLineAliasUpsertResult"],
	createGenericPage:ModelTypes["GenericPageCreateResult"],
	deleteGenericPage:ModelTypes["GenericPageDeleteResult"],
	updateGenericPage:ModelTypes["GenericPageUpdateResult"],
	upsertGenericPage:ModelTypes["GenericPageUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createContentLinks:ModelTypes["ContentLinksCreateResult"],
	deleteContentLinks:ModelTypes["ContentLinksDeleteResult"],
	updateContentLinks:ModelTypes["ContentLinksUpdateResult"],
	upsertContentLinks:ModelTypes["ContentLinksUpsertResult"],
	createContentLinksItem:ModelTypes["ContentLinksItemCreateResult"],
	deleteContentLinksItem:ModelTypes["ContentLinksItemDeleteResult"],
	updateContentLinksItem:ModelTypes["ContentLinksItemUpdateResult"],
	upsertContentLinksItem:ModelTypes["ContentLinksItemUpsertResult"],
	createRedirect:ModelTypes["RedirectCreateResult"],
	deleteRedirect:ModelTypes["RedirectDeleteResult"],
	updateRedirect:ModelTypes["RedirectUpdateResult"],
	upsertRedirect:ModelTypes["RedirectUpsertResult"],
	createContentReferenceImage:ModelTypes["ContentReferenceImageCreateResult"],
	deleteContentReferenceImage:ModelTypes["ContentReferenceImageDeleteResult"],
	updateContentReferenceImage:ModelTypes["ContentReferenceImageUpdateResult"],
	upsertContentReferenceImage:ModelTypes["ContentReferenceImageUpsertResult"],
	createSeoData:ModelTypes["SeoDataCreateResult"],
	deleteSeoData:ModelTypes["SeoDataDeleteResult"],
	updateSeoData:ModelTypes["SeoDataUpdateResult"],
	upsertSeoData:ModelTypes["SeoDataUpsertResult"],
	createAgeCategory:ModelTypes["AgeCategoryCreateResult"],
	deleteAgeCategory:ModelTypes["AgeCategoryDeleteResult"],
	updateAgeCategory:ModelTypes["AgeCategoryUpdateResult"],
	upsertAgeCategory:ModelTypes["AgeCategoryUpsertResult"],
	createFilterCombo:ModelTypes["FilterComboCreateResult"],
	deleteFilterCombo:ModelTypes["FilterComboDeleteResult"],
	updateFilterCombo:ModelTypes["FilterComboUpdateResult"],
	upsertFilterCombo:ModelTypes["FilterComboUpsertResult"],
	createImportCache:ModelTypes["ImportCacheCreateResult"],
	deleteImportCache:ModelTypes["ImportCacheDeleteResult"],
	updateImportCache:ModelTypes["ImportCacheUpdateResult"],
	upsertImportCache:ModelTypes["ImportCacheUpsertResult"],
	createSite:ModelTypes["SiteCreateResult"],
	deleteSite:ModelTypes["SiteDeleteResult"],
	updateSite:ModelTypes["SiteUpdateResult"],
	upsertSite:ModelTypes["SiteUpsertResult"],
	createContactSubmission:ModelTypes["ContactSubmissionCreateResult"],
	deleteContactSubmission:ModelTypes["ContactSubmissionDeleteResult"],
	updateContactSubmission:ModelTypes["ContactSubmissionUpdateResult"],
	upsertContactSubmission:ModelTypes["ContactSubmissionUpsertResult"],
	createTOPXBrand:ModelTypes["TOPXBrandCreateResult"],
	deleteTOPXBrand:ModelTypes["TOPXBrandDeleteResult"],
	updateTOPXBrand:ModelTypes["TOPXBrandUpdateResult"],
	upsertTOPXBrand:ModelTypes["TOPXBrandUpsertResult"],
	createTOPXBrandCategory:ModelTypes["TOPXBrandCategoryCreateResult"],
	deleteTOPXBrandCategory:ModelTypes["TOPXBrandCategoryDeleteResult"],
	updateTOPXBrandCategory:ModelTypes["TOPXBrandCategoryUpdateResult"],
	upsertTOPXBrandCategory:ModelTypes["TOPXBrandCategoryUpsertResult"],
	createTOPXProduct:ModelTypes["TOPXProductCreateResult"],
	deleteTOPXProduct:ModelTypes["TOPXProductDeleteResult"],
	updateTOPXProduct:ModelTypes["TOPXProductUpdateResult"],
	upsertTOPXProduct:ModelTypes["TOPXProductUpsertResult"],
	createTOPXProductCategory:ModelTypes["TOPXProductCategoryCreateResult"],
	deleteTOPXProductCategory:ModelTypes["TOPXProductCategoryDeleteResult"],
	updateTOPXProductCategory:ModelTypes["TOPXProductCategoryUpdateResult"],
	upsertTOPXProductCategory:ModelTypes["TOPXProductCategoryUpsertResult"],
	createContentReferenceList:ModelTypes["ContentReferenceListCreateResult"],
	deleteContentReferenceList:ModelTypes["ContentReferenceListDeleteResult"],
	updateContentReferenceList:ModelTypes["ContentReferenceListUpdateResult"],
	upsertContentReferenceList:ModelTypes["ContentReferenceListUpsertResult"],
	transaction:ModelTypes["MutationTransaction"],
	query:ModelTypes["Query"]
};
	["S3SignedUpload"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	objectKey:string,
	bucket:string,
	publicUrl:string
};
	["S3Header"]: {
		key:string,
	value:string
};
	["S3GenerateSignedUploadInput"]: GraphQLTypes["S3GenerateSignedUploadInput"];
	["S33ContentDisposition"]: GraphQLTypes["S33ContentDisposition"];
	["S3Acl"]: GraphQLTypes["S3Acl"];
	["S3SignedRead"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	objectKey:string,
	bucket:string
};
	["BlogPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationResult"]: ModelTypes["BlogPageCreateResult"] | ModelTypes["BlogPageDeleteResult"] | ModelTypes["BlogPageUpdateResult"] | ModelTypes["BlogPageUpsertResult"] | ModelTypes["BlogPostCreateResult"] | ModelTypes["BlogPostDeleteResult"] | ModelTypes["BlogPostUpdateResult"] | ModelTypes["BlogPostUpsertResult"] | ModelTypes["BlogPostTagCreateResult"] | ModelTypes["BlogPostTagDeleteResult"] | ModelTypes["BlogPostTagUpdateResult"] | ModelTypes["BlogPostTagUpsertResult"] | ModelTypes["BodyTagCreateResult"] | ModelTypes["BodyTagDeleteResult"] | ModelTypes["BodyTagUpdateResult"] | ModelTypes["BodyTagUpsertResult"] | ModelTypes["BodyTagCategoryCreateResult"] | ModelTypes["BodyTagCategoryDeleteResult"] | ModelTypes["BodyTagCategoryUpdateResult"] | ModelTypes["BodyTagCategoryUpsertResult"] | ModelTypes["ContentCreateResult"] | ModelTypes["ContentDeleteResult"] | ModelTypes["ContentUpdateResult"] | ModelTypes["ContentUpsertResult"] | ModelTypes["ContentBlockCreateResult"] | ModelTypes["ContentBlockDeleteResult"] | ModelTypes["ContentBlockUpdateResult"] | ModelTypes["ContentBlockUpsertResult"] | ModelTypes["ContentReferenceCreateResult"] | ModelTypes["ContentReferenceDeleteResult"] | ModelTypes["ContentReferenceUpdateResult"] | ModelTypes["ContentReferenceUpsertResult"] | ModelTypes["DidYouKnowCreateResult"] | ModelTypes["DidYouKnowDeleteResult"] | ModelTypes["DidYouKnowUpdateResult"] | ModelTypes["DidYouKnowUpsertResult"] | ModelTypes["ImageCreateResult"] | ModelTypes["ImageDeleteResult"] | ModelTypes["ImageUpdateResult"] | ModelTypes["ImageUpsertResult"] | ModelTypes["MediumCreateResult"] | ModelTypes["MediumDeleteResult"] | ModelTypes["MediumUpdateResult"] | ModelTypes["MediumUpsertResult"] | ModelTypes["NutritionalValueCreateResult"] | ModelTypes["NutritionalValueDeleteResult"] | ModelTypes["NutritionalValueUpdateResult"] | ModelTypes["NutritionalValueUpsertResult"] | ModelTypes["PageCreateResult"] | ModelTypes["PageDeleteResult"] | ModelTypes["PageUpdateResult"] | ModelTypes["PageUpsertResult"] | ModelTypes["ReferenceCreateResult"] | ModelTypes["ReferenceDeleteResult"] | ModelTypes["ReferenceUpdateResult"] | ModelTypes["ReferenceUpsertResult"] | ModelTypes["ReferenceListCreateResult"] | ModelTypes["ReferenceListDeleteResult"] | ModelTypes["ReferenceListUpdateResult"] | ModelTypes["ReferenceListUpsertResult"] | ModelTypes["SeoCreateResult"] | ModelTypes["SeoDeleteResult"] | ModelTypes["SeoUpdateResult"] | ModelTypes["SeoUpsertResult"] | ModelTypes["VideoCreateResult"] | ModelTypes["VideoDeleteResult"] | ModelTypes["VideoUpdateResult"] | ModelTypes["VideoUpsertResult"] | ModelTypes["BrandCreateResult"] | ModelTypes["BrandDeleteResult"] | ModelTypes["BrandUpdateResult"] | ModelTypes["BrandUpsertResult"] | ModelTypes["BrandDistributorCreateResult"] | ModelTypes["BrandDistributorDeleteResult"] | ModelTypes["BrandDistributorUpdateResult"] | ModelTypes["BrandDistributorUpsertResult"] | ModelTypes["DogSizeCreateResult"] | ModelTypes["DogSizeDeleteResult"] | ModelTypes["DogSizeUpdateResult"] | ModelTypes["DogSizeUpsertResult"] | ModelTypes["ProductCreateResult"] | ModelTypes["ProductDeleteResult"] | ModelTypes["ProductUpdateResult"] | ModelTypes["ProductUpsertResult"] | ModelTypes["ProductionMethodCreateResult"] | ModelTypes["ProductionMethodDeleteResult"] | ModelTypes["ProductionMethodUpdateResult"] | ModelTypes["ProductionMethodUpsertResult"] | ModelTypes["ProductLineCreateResult"] | ModelTypes["ProductLineDeleteResult"] | ModelTypes["ProductLineUpdateResult"] | ModelTypes["ProductLineUpsertResult"] | ModelTypes["BreedCreateResult"] | ModelTypes["BreedDeleteResult"] | ModelTypes["BreedUpdateResult"] | ModelTypes["BreedUpsertResult"] | ModelTypes["DogCreateResult"] | ModelTypes["DogDeleteResult"] | ModelTypes["DogUpdateResult"] | ModelTypes["DogUpsertResult"] | ModelTypes["UserCreateResult"] | ModelTypes["UserDeleteResult"] | ModelTypes["UserUpdateResult"] | ModelTypes["UserUpsertResult"] | ModelTypes["VeterinaryCreateResult"] | ModelTypes["VeterinaryDeleteResult"] | ModelTypes["VeterinaryUpdateResult"] | ModelTypes["VeterinaryUpsertResult"] | ModelTypes["NutritionalValueOfProductCreateResult"] | ModelTypes["NutritionalValueOfProductDeleteResult"] | ModelTypes["NutritionalValueOfProductUpdateResult"] | ModelTypes["NutritionalValueOfProductUpsertResult"] | ModelTypes["ReviewCreateResult"] | ModelTypes["ReviewDeleteResult"] | ModelTypes["ReviewUpdateResult"] | ModelTypes["ReviewUpsertResult"] | ModelTypes["DogBodyTypeCreateResult"] | ModelTypes["DogBodyTypeDeleteResult"] | ModelTypes["DogBodyTypeUpdateResult"] | ModelTypes["DogBodyTypeUpsertResult"] | ModelTypes["DogBodyTypeCategoryCreateResult"] | ModelTypes["DogBodyTypeCategoryDeleteResult"] | ModelTypes["DogBodyTypeCategoryUpdateResult"] | ModelTypes["DogBodyTypeCategoryUpsertResult"] | ModelTypes["LinkCreateResult"] | ModelTypes["LinkDeleteResult"] | ModelTypes["LinkUpdateResult"] | ModelTypes["LinkUpsertResult"] | ModelTypes["UrlCreateResult"] | ModelTypes["UrlDeleteResult"] | ModelTypes["UrlUpdateResult"] | ModelTypes["UrlUpsertResult"] | ModelTypes["FooterCreateResult"] | ModelTypes["FooterDeleteResult"] | ModelTypes["FooterUpdateResult"] | ModelTypes["FooterUpsertResult"] | ModelTypes["FooterLinkCreateResult"] | ModelTypes["FooterLinkDeleteResult"] | ModelTypes["FooterLinkUpdateResult"] | ModelTypes["FooterLinkUpsertResult"] | ModelTypes["BrandsPageCreateResult"] | ModelTypes["BrandsPageDeleteResult"] | ModelTypes["BrandsPageUpdateResult"] | ModelTypes["BrandsPageUpsertResult"] | ModelTypes["HomePageCreateResult"] | ModelTypes["HomePageDeleteResult"] | ModelTypes["HomePageUpdateResult"] | ModelTypes["HomePageUpsertResult"] | ModelTypes["IngredientsPageCreateResult"] | ModelTypes["IngredientsPageDeleteResult"] | ModelTypes["IngredientsPageUpdateResult"] | ModelTypes["IngredientsPageUpsertResult"] | ModelTypes["ProductReviewCreateResult"] | ModelTypes["ProductReviewDeleteResult"] | ModelTypes["ProductReviewUpdateResult"] | ModelTypes["ProductReviewUpsertResult"] | ModelTypes["ScoreCreateResult"] | ModelTypes["ScoreDeleteResult"] | ModelTypes["ScoreUpdateResult"] | ModelTypes["ScoreUpsertResult"] | ModelTypes["AgeCreateResult"] | ModelTypes["AgeDeleteResult"] | ModelTypes["AgeUpdateResult"] | ModelTypes["AgeUpsertResult"] | ModelTypes["CountryCreateResult"] | ModelTypes["CountryDeleteResult"] | ModelTypes["CountryUpdateResult"] | ModelTypes["CountryUpsertResult"] | ModelTypes["BlogPostReviewCreateResult"] | ModelTypes["BlogPostReviewDeleteResult"] | ModelTypes["BlogPostReviewUpdateResult"] | ModelTypes["BlogPostReviewUpsertResult"] | ModelTypes["DogActivityCreateResult"] | ModelTypes["DogActivityDeleteResult"] | ModelTypes["DogActivityUpdateResult"] | ModelTypes["DogActivityUpsertResult"] | ModelTypes["SocialCreateResult"] | ModelTypes["SocialDeleteResult"] | ModelTypes["SocialUpdateResult"] | ModelTypes["SocialUpsertResult"] | ModelTypes["ContentReferenceGalleryImageCreateResult"] | ModelTypes["ContentReferenceGalleryImageDeleteResult"] | ModelTypes["ContentReferenceGalleryImageUpdateResult"] | ModelTypes["ContentReferenceGalleryImageUpsertResult"] | ModelTypes["ItemCreateResult"] | ModelTypes["ItemDeleteResult"] | ModelTypes["ItemUpdateResult"] | ModelTypes["ItemUpsertResult"] | ModelTypes["ItemSubCategoryCreateResult"] | ModelTypes["ItemSubCategoryDeleteResult"] | ModelTypes["ItemSubCategoryUpdateResult"] | ModelTypes["ItemSubCategoryUpsertResult"] | ModelTypes["ItemCategoryCreateResult"] | ModelTypes["ItemCategoryDeleteResult"] | ModelTypes["ItemCategoryUpdateResult"] | ModelTypes["ItemCategoryUpsertResult"] | ModelTypes["ItemFlavorCategoryCreateResult"] | ModelTypes["ItemFlavorCategoryDeleteResult"] | ModelTypes["ItemFlavorCategoryUpdateResult"] | ModelTypes["ItemFlavorCategoryUpsertResult"] | ModelTypes["ItemDeclensionFourthVariantCreateResult"] | ModelTypes["ItemDeclensionFourthVariantDeleteResult"] | ModelTypes["ItemDeclensionFourthVariantUpdateResult"] | ModelTypes["ItemDeclensionFourthVariantUpsertResult"] | ModelTypes["ItemDeclensionSeventhVariantCreateResult"] | ModelTypes["ItemDeclensionSeventhVariantDeleteResult"] | ModelTypes["ItemDeclensionSeventhVariantUpdateResult"] | ModelTypes["ItemDeclensionSeventhVariantUpsertResult"] | ModelTypes["MediaCardCreateResult"] | ModelTypes["MediaCardDeleteResult"] | ModelTypes["MediaCardUpdateResult"] | ModelTypes["MediaCardUpsertResult"] | ModelTypes["InfoCardCreateResult"] | ModelTypes["InfoCardDeleteResult"] | ModelTypes["InfoCardUpdateResult"] | ModelTypes["InfoCardUpsertResult"] | ModelTypes["NumberedCardCreateResult"] | ModelTypes["NumberedCardDeleteResult"] | ModelTypes["NumberedCardUpdateResult"] | ModelTypes["NumberedCardUpsertResult"] | ModelTypes["RegisterClaimCreateResult"] | ModelTypes["RegisterClaimDeleteResult"] | ModelTypes["RegisterClaimUpdateResult"] | ModelTypes["RegisterClaimUpsertResult"] | ModelTypes["BlogPostReviewReactionCreateResult"] | ModelTypes["BlogPostReviewReactionDeleteResult"] | ModelTypes["BlogPostReviewReactionUpdateResult"] | ModelTypes["BlogPostReviewReactionUpsertResult"] | ModelTypes["ProductReviewReactionCreateResult"] | ModelTypes["ProductReviewReactionDeleteResult"] | ModelTypes["ProductReviewReactionUpdateResult"] | ModelTypes["ProductReviewReactionUpsertResult"] | ModelTypes["ProductPackageCreateResult"] | ModelTypes["ProductPackageDeleteResult"] | ModelTypes["ProductPackageUpdateResult"] | ModelTypes["ProductPackageUpsertResult"] | ModelTypes["BrandManufacturerCreateResult"] | ModelTypes["BrandManufacturerDeleteResult"] | ModelTypes["BrandManufacturerUpdateResult"] | ModelTypes["BrandManufacturerUpsertResult"] | ModelTypes["ElementCreateResult"] | ModelTypes["ElementDeleteResult"] | ModelTypes["ElementUpdateResult"] | ModelTypes["ElementUpsertResult"] | ModelTypes["ElementOfProductCreateResult"] | ModelTypes["ElementOfProductDeleteResult"] | ModelTypes["ElementOfProductUpdateResult"] | ModelTypes["ElementOfProductUpsertResult"] | ModelTypes["SuitabilityCategoryCreateResult"] | ModelTypes["SuitabilityCategoryDeleteResult"] | ModelTypes["SuitabilityCategoryUpdateResult"] | ModelTypes["SuitabilityCategoryUpsertResult"] | ModelTypes["ProductFeatureCreateResult"] | ModelTypes["ProductFeatureDeleteResult"] | ModelTypes["ProductFeatureUpdateResult"] | ModelTypes["ProductFeatureUpsertResult"] | ModelTypes["SuitabilityItemCreateResult"] | ModelTypes["SuitabilityItemDeleteResult"] | ModelTypes["SuitabilityItemUpdateResult"] | ModelTypes["SuitabilityItemUpsertResult"] | ModelTypes["RegionCreateResult"] | ModelTypes["RegionDeleteResult"] | ModelTypes["RegionUpdateResult"] | ModelTypes["RegionUpsertResult"] | ModelTypes["GranuleSizeCreateResult"] | ModelTypes["GranuleSizeDeleteResult"] | ModelTypes["GranuleSizeUpdateResult"] | ModelTypes["GranuleSizeUpsertResult"] | ModelTypes["ItemAliasCreateResult"] | ModelTypes["ItemAliasDeleteResult"] | ModelTypes["ItemAliasUpdateResult"] | ModelTypes["ItemAliasUpsertResult"] | ModelTypes["SemanticKeyCreateResult"] | ModelTypes["SemanticKeyDeleteResult"] | ModelTypes["SemanticKeyUpdateResult"] | ModelTypes["SemanticKeyUpsertResult"] | ModelTypes["ProductFlagCreateResult"] | ModelTypes["ProductFlagDeleteResult"] | ModelTypes["ProductFlagUpdateResult"] | ModelTypes["ProductFlagUpsertResult"] | ModelTypes["ProductFlagOfProductCreateResult"] | ModelTypes["ProductFlagOfProductDeleteResult"] | ModelTypes["ProductFlagOfProductUpdateResult"] | ModelTypes["ProductFlagOfProductUpsertResult"] | ModelTypes["ProductEvaluationCreateResult"] | ModelTypes["ProductEvaluationDeleteResult"] | ModelTypes["ProductEvaluationUpdateResult"] | ModelTypes["ProductEvaluationUpsertResult"] | ModelTypes["AdCreateResult"] | ModelTypes["AdDeleteResult"] | ModelTypes["AdUpdateResult"] | ModelTypes["AdUpsertResult"] | ModelTypes["EvaluationInfoCreateResult"] | ModelTypes["EvaluationInfoDeleteResult"] | ModelTypes["EvaluationInfoUpdateResult"] | ModelTypes["EvaluationInfoUpsertResult"] | ModelTypes["ConsumptionMessageCreateResult"] | ModelTypes["ConsumptionMessageDeleteResult"] | ModelTypes["ConsumptionMessageUpdateResult"] | ModelTypes["ConsumptionMessageUpsertResult"] | ModelTypes["ContentTextCreateResult"] | ModelTypes["ContentTextDeleteResult"] | ModelTypes["ContentTextUpdateResult"] | ModelTypes["ContentTextUpsertResult"] | ModelTypes["ContentTextBlockCreateResult"] | ModelTypes["ContentTextBlockDeleteResult"] | ModelTypes["ContentTextBlockUpdateResult"] | ModelTypes["ContentTextBlockUpsertResult"] | ModelTypes["ComparatorPageCreateResult"] | ModelTypes["ComparatorPageDeleteResult"] | ModelTypes["ComparatorPageUpdateResult"] | ModelTypes["ComparatorPageUpsertResult"] | ModelTypes["LoginPageCreateResult"] | ModelTypes["LoginPageDeleteResult"] | ModelTypes["LoginPageUpdateResult"] | ModelTypes["LoginPageUpsertResult"] | ModelTypes["RegisterPageCreateResult"] | ModelTypes["RegisterPageDeleteResult"] | ModelTypes["RegisterPageUpdateResult"] | ModelTypes["RegisterPageUpsertResult"] | ModelTypes["ResultsPageCreateResult"] | ModelTypes["ResultsPageDeleteResult"] | ModelTypes["ResultsPageUpdateResult"] | ModelTypes["ResultsPageUpsertResult"] | ModelTypes["SearchPageCreateResult"] | ModelTypes["SearchPageDeleteResult"] | ModelTypes["SearchPageUpdateResult"] | ModelTypes["SearchPageUpsertResult"] | ModelTypes["WizardPageCreateResult"] | ModelTypes["WizardPageDeleteResult"] | ModelTypes["WizardPageUpdateResult"] | ModelTypes["WizardPageUpsertResult"] | ModelTypes["BreastfeedingCategoryCreateResult"] | ModelTypes["BreastfeedingCategoryDeleteResult"] | ModelTypes["BreastfeedingCategoryUpdateResult"] | ModelTypes["BreastfeedingCategoryUpsertResult"] | ModelTypes["DogReproductionCreateResult"] | ModelTypes["DogReproductionDeleteResult"] | ModelTypes["DogReproductionUpdateResult"] | ModelTypes["DogReproductionUpsertResult"] | ModelTypes["ContactFormMessageCreateResult"] | ModelTypes["ContactFormMessageDeleteResult"] | ModelTypes["ContactFormMessageUpdateResult"] | ModelTypes["ContactFormMessageUpsertResult"] | ModelTypes["ContactPageCreateResult"] | ModelTypes["ContactPageDeleteResult"] | ModelTypes["ContactPageUpdateResult"] | ModelTypes["ContactPageUpsertResult"] | ModelTypes["BugReportCreateResult"] | ModelTypes["BugReportDeleteResult"] | ModelTypes["BugReportUpdateResult"] | ModelTypes["BugReportUpsertResult"] | ModelTypes["ColorCreateResult"] | ModelTypes["ColorDeleteResult"] | ModelTypes["ColorUpdateResult"] | ModelTypes["ColorUpsertResult"] | ModelTypes["ItemGroupCreateResult"] | ModelTypes["ItemGroupDeleteResult"] | ModelTypes["ItemGroupUpdateResult"] | ModelTypes["ItemGroupUpsertResult"] | ModelTypes["ProductEvaluationSummaryCreateResult"] | ModelTypes["ProductEvaluationSummaryDeleteResult"] | ModelTypes["ProductEvaluationSummaryUpdateResult"] | ModelTypes["ProductEvaluationSummaryUpsertResult"] | ModelTypes["ProtectedActionCreateResult"] | ModelTypes["ProtectedActionDeleteResult"] | ModelTypes["ProtectedActionUpdateResult"] | ModelTypes["ProtectedActionUpsertResult"] | ModelTypes["BrandAliasCreateResult"] | ModelTypes["BrandAliasDeleteResult"] | ModelTypes["BrandAliasUpdateResult"] | ModelTypes["BrandAliasUpsertResult"] | ModelTypes["ProductAliasCreateResult"] | ModelTypes["ProductAliasDeleteResult"] | ModelTypes["ProductAliasUpdateResult"] | ModelTypes["ProductAliasUpsertResult"] | ModelTypes["ProductLineAliasCreateResult"] | ModelTypes["ProductLineAliasDeleteResult"] | ModelTypes["ProductLineAliasUpdateResult"] | ModelTypes["ProductLineAliasUpsertResult"] | ModelTypes["GenericPageCreateResult"] | ModelTypes["GenericPageDeleteResult"] | ModelTypes["GenericPageUpdateResult"] | ModelTypes["GenericPageUpsertResult"] | ModelTypes["LinkableCreateResult"] | ModelTypes["LinkableDeleteResult"] | ModelTypes["LinkableUpdateResult"] | ModelTypes["LinkableUpsertResult"] | ModelTypes["ContentLinksCreateResult"] | ModelTypes["ContentLinksDeleteResult"] | ModelTypes["ContentLinksUpdateResult"] | ModelTypes["ContentLinksUpsertResult"] | ModelTypes["ContentLinksItemCreateResult"] | ModelTypes["ContentLinksItemDeleteResult"] | ModelTypes["ContentLinksItemUpdateResult"] | ModelTypes["ContentLinksItemUpsertResult"] | ModelTypes["RedirectCreateResult"] | ModelTypes["RedirectDeleteResult"] | ModelTypes["RedirectUpdateResult"] | ModelTypes["RedirectUpsertResult"] | ModelTypes["ContentReferenceImageCreateResult"] | ModelTypes["ContentReferenceImageDeleteResult"] | ModelTypes["ContentReferenceImageUpdateResult"] | ModelTypes["ContentReferenceImageUpsertResult"] | ModelTypes["SeoDataCreateResult"] | ModelTypes["SeoDataDeleteResult"] | ModelTypes["SeoDataUpdateResult"] | ModelTypes["SeoDataUpsertResult"] | ModelTypes["AgeCategoryCreateResult"] | ModelTypes["AgeCategoryDeleteResult"] | ModelTypes["AgeCategoryUpdateResult"] | ModelTypes["AgeCategoryUpsertResult"] | ModelTypes["FilterComboCreateResult"] | ModelTypes["FilterComboDeleteResult"] | ModelTypes["FilterComboUpdateResult"] | ModelTypes["FilterComboUpsertResult"] | ModelTypes["ImportCacheCreateResult"] | ModelTypes["ImportCacheDeleteResult"] | ModelTypes["ImportCacheUpdateResult"] | ModelTypes["ImportCacheUpsertResult"] | ModelTypes["SiteCreateResult"] | ModelTypes["SiteDeleteResult"] | ModelTypes["SiteUpdateResult"] | ModelTypes["SiteUpsertResult"] | ModelTypes["ContactSubmissionCreateResult"] | ModelTypes["ContactSubmissionDeleteResult"] | ModelTypes["ContactSubmissionUpdateResult"] | ModelTypes["ContactSubmissionUpsertResult"] | ModelTypes["TOPXBrandCreateResult"] | ModelTypes["TOPXBrandDeleteResult"] | ModelTypes["TOPXBrandUpdateResult"] | ModelTypes["TOPXBrandUpsertResult"] | ModelTypes["TOPXBrandCategoryCreateResult"] | ModelTypes["TOPXBrandCategoryDeleteResult"] | ModelTypes["TOPXBrandCategoryUpdateResult"] | ModelTypes["TOPXBrandCategoryUpsertResult"] | ModelTypes["TOPXProductCreateResult"] | ModelTypes["TOPXProductDeleteResult"] | ModelTypes["TOPXProductUpdateResult"] | ModelTypes["TOPXProductUpsertResult"] | ModelTypes["TOPXProductCategoryCreateResult"] | ModelTypes["TOPXProductCategoryDeleteResult"] | ModelTypes["TOPXProductCategoryUpdateResult"] | ModelTypes["TOPXProductCategoryUpsertResult"] | ModelTypes["ContentReferenceListCreateResult"] | ModelTypes["ContentReferenceListDeleteResult"] | ModelTypes["ContentReferenceListUpdateResult"] | ModelTypes["ContentReferenceListUpsertResult"];
	["_MutationError"]: {
		path:ModelTypes["_PathFragment"][],
	paths:ModelTypes["_PathFragment"][],
	type:ModelTypes["_MutationErrorType"],
	message?:string
};
	["_MutationErrorType"]: GraphQLTypes["_MutationErrorType"];
	["BlogPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPage"]
};
	["BlogPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPost"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPost"]
};
	["BlogPostUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPost"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPost"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostTagCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostTagDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostTag"]
};
	["BlogPostTagUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostTagUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["BodyTagCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BodyTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["BodyTagDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BodyTag"]
};
	["BodyTagUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BodyTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["BodyTagUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BodyTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["BodyTagCategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BodyTagCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["BodyTagCategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BodyTagCategory"]
};
	["BodyTagCategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BodyTagCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["BodyTagCategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BodyTagCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"]
};
	["ContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["DidYouKnowCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DidYouKnow"],
	validation:ModelTypes["_ValidationResult"]
};
	["DidYouKnowDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DidYouKnow"]
};
	["DidYouKnowUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DidYouKnow"],
	validation:ModelTypes["_ValidationResult"]
};
	["DidYouKnowUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DidYouKnow"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"]
};
	["ImageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Medium"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Medium"]
};
	["MediumUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Medium"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Medium"],
	validation:ModelTypes["_ValidationResult"]
};
	["NutritionalValueCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NutritionalValue"],
	validation:ModelTypes["_ValidationResult"]
};
	["NutritionalValueDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NutritionalValue"]
};
	["NutritionalValueUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NutritionalValue"],
	validation:ModelTypes["_ValidationResult"]
};
	["NutritionalValueUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NutritionalValue"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"]
};
	["PageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["ReferenceCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Reference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ReferenceDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Reference"]
};
	["ReferenceUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Reference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ReferenceUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Reference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ReferenceListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ReferenceList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ReferenceListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ReferenceList"]
};
	["ReferenceListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ReferenceList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ReferenceListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ReferenceList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"]
};
	["SeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"],
	validation:ModelTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"]
};
	["VideoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"],
	validation:ModelTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Brand"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Brand"]
};
	["BrandUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Brand"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Brand"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandDistributorCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandDistributor"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandDistributorDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandDistributor"]
};
	["BrandDistributorUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandDistributor"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandDistributorUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandDistributor"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogSizeCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogSize"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogSizeDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogSize"]
};
	["DogSizeUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogSize"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogSizeUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogSize"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Product"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Product"]
};
	["ProductUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Product"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Product"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductionMethodCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductionMethod"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductionMethodDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductionMethod"]
};
	["ProductionMethodUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductionMethod"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductionMethodUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductionMethod"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductLineCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductLine"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductLineDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductLine"]
};
	["ProductLineUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductLine"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductLineUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductLine"],
	validation:ModelTypes["_ValidationResult"]
};
	["BreedCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Breed"],
	validation:ModelTypes["_ValidationResult"]
};
	["BreedDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Breed"]
};
	["BreedUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Breed"],
	validation:ModelTypes["_ValidationResult"]
};
	["BreedUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Breed"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Dog"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Dog"]
};
	["DogUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Dog"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Dog"],
	validation:ModelTypes["_ValidationResult"]
};
	["UserCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["User"],
	validation:ModelTypes["_ValidationResult"]
};
	["UserDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["User"]
};
	["UserUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["User"],
	validation:ModelTypes["_ValidationResult"]
};
	["UserUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["User"],
	validation:ModelTypes["_ValidationResult"]
};
	["VeterinaryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Veterinary"],
	validation:ModelTypes["_ValidationResult"]
};
	["VeterinaryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Veterinary"]
};
	["VeterinaryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Veterinary"],
	validation:ModelTypes["_ValidationResult"]
};
	["VeterinaryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Veterinary"],
	validation:ModelTypes["_ValidationResult"]
};
	["NutritionalValueOfProductCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NutritionalValueOfProduct"],
	validation:ModelTypes["_ValidationResult"]
};
	["NutritionalValueOfProductDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NutritionalValueOfProduct"]
};
	["NutritionalValueOfProductUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NutritionalValueOfProduct"],
	validation:ModelTypes["_ValidationResult"]
};
	["NutritionalValueOfProductUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NutritionalValueOfProduct"],
	validation:ModelTypes["_ValidationResult"]
};
	["ReviewCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Review"],
	validation:ModelTypes["_ValidationResult"]
};
	["ReviewDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Review"]
};
	["ReviewUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Review"],
	validation:ModelTypes["_ValidationResult"]
};
	["ReviewUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Review"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogBodyTypeCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogBodyType"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogBodyTypeDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogBodyType"]
};
	["DogBodyTypeUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogBodyType"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogBodyTypeUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogBodyType"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogBodyTypeCategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogBodyTypeCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogBodyTypeCategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogBodyTypeCategory"]
};
	["DogBodyTypeCategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogBodyTypeCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogBodyTypeCategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogBodyTypeCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"]
};
	["LinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["UrlCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Url"],
	validation:ModelTypes["_ValidationResult"]
};
	["UrlDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Url"]
};
	["UrlUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Url"],
	validation:ModelTypes["_ValidationResult"]
};
	["UrlUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Url"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"]
};
	["FooterUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLink"]
};
	["FooterLinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandsPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandsPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandsPage"]
};
	["BrandsPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandsPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"]
};
	["HomePageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["IngredientsPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["IngredientsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["IngredientsPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["IngredientsPage"]
};
	["IngredientsPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["IngredientsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["IngredientsPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["IngredientsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductReviewCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductReview"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductReviewDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductReview"]
};
	["ProductReviewUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductReview"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductReviewUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductReview"],
	validation:ModelTypes["_ValidationResult"]
};
	["ScoreCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Score"],
	validation:ModelTypes["_ValidationResult"]
};
	["ScoreDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Score"]
};
	["ScoreUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Score"],
	validation:ModelTypes["_ValidationResult"]
};
	["ScoreUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Score"],
	validation:ModelTypes["_ValidationResult"]
};
	["AgeCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Age"],
	validation:ModelTypes["_ValidationResult"]
};
	["AgeDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Age"]
};
	["AgeUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Age"],
	validation:ModelTypes["_ValidationResult"]
};
	["AgeUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Age"],
	validation:ModelTypes["_ValidationResult"]
};
	["CountryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Country"],
	validation:ModelTypes["_ValidationResult"]
};
	["CountryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Country"]
};
	["CountryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Country"],
	validation:ModelTypes["_ValidationResult"]
};
	["CountryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Country"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostReviewCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostReview"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostReviewDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostReview"]
};
	["BlogPostReviewUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostReview"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostReviewUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostReview"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogActivityCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogActivity"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogActivityDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogActivity"]
};
	["DogActivityUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogActivity"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogActivityUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogActivity"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Social"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Social"]
};
	["SocialUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Social"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Social"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceGalleryImageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReferenceGalleryImage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceGalleryImageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReferenceGalleryImage"]
};
	["ContentReferenceGalleryImageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReferenceGalleryImage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceGalleryImageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReferenceGalleryImage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Item"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Item"]
};
	["ItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Item"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Item"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemSubCategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemSubCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemSubCategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemSubCategory"]
};
	["ItemSubCategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemSubCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemSubCategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemSubCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemCategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemCategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemCategory"]
};
	["ItemCategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemCategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemFlavorCategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemFlavorCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemFlavorCategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemFlavorCategory"]
};
	["ItemFlavorCategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemFlavorCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemFlavorCategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemFlavorCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemDeclensionFourthVariantCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemDeclensionFourthVariant"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemDeclensionFourthVariantDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemDeclensionFourthVariant"]
};
	["ItemDeclensionFourthVariantUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemDeclensionFourthVariant"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemDeclensionFourthVariantUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemDeclensionFourthVariant"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemDeclensionSeventhVariantCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemDeclensionSeventhVariant"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemDeclensionSeventhVariantDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemDeclensionSeventhVariant"]
};
	["ItemDeclensionSeventhVariantUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemDeclensionSeventhVariant"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemDeclensionSeventhVariantUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemDeclensionSeventhVariant"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediaCardCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediaCard"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediaCardDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediaCard"]
};
	["MediaCardUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediaCard"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediaCardUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediaCard"],
	validation:ModelTypes["_ValidationResult"]
};
	["InfoCardCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["InfoCard"],
	validation:ModelTypes["_ValidationResult"]
};
	["InfoCardDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["InfoCard"]
};
	["InfoCardUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["InfoCard"],
	validation:ModelTypes["_ValidationResult"]
};
	["InfoCardUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["InfoCard"],
	validation:ModelTypes["_ValidationResult"]
};
	["NumberedCardCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NumberedCard"],
	validation:ModelTypes["_ValidationResult"]
};
	["NumberedCardDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NumberedCard"]
};
	["NumberedCardUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NumberedCard"],
	validation:ModelTypes["_ValidationResult"]
};
	["NumberedCardUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NumberedCard"],
	validation:ModelTypes["_ValidationResult"]
};
	["RegisterClaimCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RegisterClaim"],
	validation:ModelTypes["_ValidationResult"]
};
	["RegisterClaimDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RegisterClaim"]
};
	["RegisterClaimUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RegisterClaim"],
	validation:ModelTypes["_ValidationResult"]
};
	["RegisterClaimUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RegisterClaim"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostReviewReactionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostReviewReaction"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostReviewReactionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostReviewReaction"]
};
	["BlogPostReviewReactionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostReviewReaction"],
	validation:ModelTypes["_ValidationResult"]
};
	["BlogPostReviewReactionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BlogPostReviewReaction"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductReviewReactionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductReviewReaction"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductReviewReactionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductReviewReaction"]
};
	["ProductReviewReactionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductReviewReaction"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductReviewReactionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductReviewReaction"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductPackageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductPackage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductPackageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductPackage"]
};
	["ProductPackageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductPackage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductPackageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductPackage"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandManufacturerCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandManufacturer"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandManufacturerDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandManufacturer"]
};
	["BrandManufacturerUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandManufacturer"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandManufacturerUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandManufacturer"],
	validation:ModelTypes["_ValidationResult"]
};
	["ElementCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Element"],
	validation:ModelTypes["_ValidationResult"]
};
	["ElementDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Element"]
};
	["ElementUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Element"],
	validation:ModelTypes["_ValidationResult"]
};
	["ElementUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Element"],
	validation:ModelTypes["_ValidationResult"]
};
	["ElementOfProductCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ElementOfProduct"],
	validation:ModelTypes["_ValidationResult"]
};
	["ElementOfProductDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ElementOfProduct"]
};
	["ElementOfProductUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ElementOfProduct"],
	validation:ModelTypes["_ValidationResult"]
};
	["ElementOfProductUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ElementOfProduct"],
	validation:ModelTypes["_ValidationResult"]
};
	["SuitabilityCategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SuitabilityCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["SuitabilityCategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SuitabilityCategory"]
};
	["SuitabilityCategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SuitabilityCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["SuitabilityCategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SuitabilityCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductFeatureCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductFeature"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductFeatureDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductFeature"]
};
	["ProductFeatureUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductFeature"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductFeatureUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductFeature"],
	validation:ModelTypes["_ValidationResult"]
};
	["SuitabilityItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SuitabilityItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SuitabilityItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SuitabilityItem"]
};
	["SuitabilityItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SuitabilityItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SuitabilityItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SuitabilityItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["RegionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Region"],
	validation:ModelTypes["_ValidationResult"]
};
	["RegionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Region"]
};
	["RegionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Region"],
	validation:ModelTypes["_ValidationResult"]
};
	["RegionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Region"],
	validation:ModelTypes["_ValidationResult"]
};
	["GranuleSizeCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GranuleSize"],
	validation:ModelTypes["_ValidationResult"]
};
	["GranuleSizeDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GranuleSize"]
};
	["GranuleSizeUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GranuleSize"],
	validation:ModelTypes["_ValidationResult"]
};
	["GranuleSizeUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GranuleSize"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemAliasCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemAlias"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemAliasDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemAlias"]
};
	["ItemAliasUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemAlias"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemAliasUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemAlias"],
	validation:ModelTypes["_ValidationResult"]
};
	["SemanticKeyCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SemanticKey"],
	validation:ModelTypes["_ValidationResult"]
};
	["SemanticKeyDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SemanticKey"]
};
	["SemanticKeyUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SemanticKey"],
	validation:ModelTypes["_ValidationResult"]
};
	["SemanticKeyUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SemanticKey"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductFlagCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductFlag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductFlagDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductFlag"]
};
	["ProductFlagUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductFlag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductFlagUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductFlag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductFlagOfProductCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductFlagOfProduct"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductFlagOfProductDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductFlagOfProduct"]
};
	["ProductFlagOfProductUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductFlagOfProduct"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductFlagOfProductUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductFlagOfProduct"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductEvaluationCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductEvaluation"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductEvaluationDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductEvaluation"]
};
	["ProductEvaluationUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductEvaluation"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductEvaluationUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductEvaluation"],
	validation:ModelTypes["_ValidationResult"]
};
	["AdCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Ad"],
	validation:ModelTypes["_ValidationResult"]
};
	["AdDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Ad"]
};
	["AdUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Ad"],
	validation:ModelTypes["_ValidationResult"]
};
	["AdUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Ad"],
	validation:ModelTypes["_ValidationResult"]
};
	["EvaluationInfoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EvaluationInfo"],
	validation:ModelTypes["_ValidationResult"]
};
	["EvaluationInfoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EvaluationInfo"]
};
	["EvaluationInfoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EvaluationInfo"],
	validation:ModelTypes["_ValidationResult"]
};
	["EvaluationInfoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EvaluationInfo"],
	validation:ModelTypes["_ValidationResult"]
};
	["ConsumptionMessageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ConsumptionMessage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ConsumptionMessageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ConsumptionMessage"]
};
	["ConsumptionMessageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ConsumptionMessage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ConsumptionMessageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ConsumptionMessage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentTextCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentText"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentTextDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentText"]
};
	["ContentTextUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentText"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentTextUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentText"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentTextBlockCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentTextBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentTextBlockDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentTextBlock"]
};
	["ContentTextBlockUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentTextBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentTextBlockUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentTextBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ComparatorPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ComparatorPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ComparatorPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ComparatorPage"]
};
	["ComparatorPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ComparatorPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ComparatorPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ComparatorPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["LoginPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LoginPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["LoginPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LoginPage"]
};
	["LoginPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LoginPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["LoginPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LoginPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["RegisterPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RegisterPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["RegisterPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RegisterPage"]
};
	["RegisterPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RegisterPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["RegisterPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RegisterPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ResultsPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ResultsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ResultsPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ResultsPage"]
};
	["ResultsPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ResultsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ResultsPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ResultsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["SearchPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SearchPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["SearchPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SearchPage"]
};
	["SearchPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SearchPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["SearchPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SearchPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["WizardPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["WizardPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["WizardPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["WizardPage"]
};
	["WizardPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["WizardPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["WizardPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["WizardPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["BreastfeedingCategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BreastfeedingCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["BreastfeedingCategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BreastfeedingCategory"]
};
	["BreastfeedingCategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BreastfeedingCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["BreastfeedingCategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BreastfeedingCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogReproductionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogReproduction"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogReproductionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogReproduction"]
};
	["DogReproductionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogReproduction"],
	validation:ModelTypes["_ValidationResult"]
};
	["DogReproductionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DogReproduction"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactFormMessageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactFormMessage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactFormMessageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactFormMessage"]
};
	["ContactFormMessageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactFormMessage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactFormMessageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactFormMessage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactPage"]
};
	["ContactPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["BugReportCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BugReport"],
	validation:ModelTypes["_ValidationResult"]
};
	["BugReportDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BugReport"]
};
	["BugReportUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BugReport"],
	validation:ModelTypes["_ValidationResult"]
};
	["BugReportUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BugReport"],
	validation:ModelTypes["_ValidationResult"]
};
	["ColorCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Color"],
	validation:ModelTypes["_ValidationResult"]
};
	["ColorDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Color"]
};
	["ColorUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Color"],
	validation:ModelTypes["_ValidationResult"]
};
	["ColorUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Color"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemGroupCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemGroupDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemGroup"]
};
	["ItemGroupUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["ItemGroupUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ItemGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductEvaluationSummaryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductEvaluationSummary"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductEvaluationSummaryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductEvaluationSummary"]
};
	["ProductEvaluationSummaryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductEvaluationSummary"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductEvaluationSummaryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductEvaluationSummary"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProtectedActionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProtectedAction"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProtectedActionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProtectedAction"]
};
	["ProtectedActionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProtectedAction"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProtectedActionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProtectedAction"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandAliasCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandAlias"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandAliasDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandAlias"]
};
	["BrandAliasUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandAlias"],
	validation:ModelTypes["_ValidationResult"]
};
	["BrandAliasUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BrandAlias"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductAliasCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductAlias"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductAliasDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductAlias"]
};
	["ProductAliasUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductAlias"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductAliasUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductAlias"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductLineAliasCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductLineAlias"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductLineAliasDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductLineAlias"]
};
	["ProductLineAliasUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductLineAlias"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductLineAliasUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ProductLineAlias"],
	validation:ModelTypes["_ValidationResult"]
};
	["GenericPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GenericPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["GenericPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GenericPage"]
};
	["GenericPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GenericPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["GenericPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GenericPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentLinksCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentLinks"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentLinksDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentLinks"]
};
	["ContentLinksUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentLinks"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentLinksUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentLinks"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentLinksItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentLinksItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentLinksItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentLinksItem"]
};
	["ContentLinksItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentLinksItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentLinksItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentLinksItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"]
};
	["RedirectUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceImageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReferenceImage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceImageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReferenceImage"]
};
	["ContentReferenceImageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReferenceImage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceImageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReferenceImage"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDataCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoData"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDataDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoData"]
};
	["SeoDataUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoData"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDataUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoData"],
	validation:ModelTypes["_ValidationResult"]
};
	["AgeCategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AgeCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["AgeCategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AgeCategory"]
};
	["AgeCategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AgeCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["AgeCategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AgeCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["FilterComboCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FilterCombo"],
	validation:ModelTypes["_ValidationResult"]
};
	["FilterComboDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FilterCombo"]
};
	["FilterComboUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FilterCombo"],
	validation:ModelTypes["_ValidationResult"]
};
	["FilterComboUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FilterCombo"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImportCacheCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImportCache"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImportCacheDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImportCache"]
};
	["ImportCacheUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImportCache"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImportCacheUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImportCache"],
	validation:ModelTypes["_ValidationResult"]
};
	["SiteCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Site"],
	validation:ModelTypes["_ValidationResult"]
};
	["SiteDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Site"]
};
	["SiteUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Site"],
	validation:ModelTypes["_ValidationResult"]
};
	["SiteUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Site"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactSubmissionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactSubmission"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactSubmissionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactSubmission"]
};
	["ContactSubmissionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactSubmission"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactSubmissionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactSubmission"],
	validation:ModelTypes["_ValidationResult"]
};
	["TOPXBrandCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXBrand"],
	validation:ModelTypes["_ValidationResult"]
};
	["TOPXBrandDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXBrand"]
};
	["TOPXBrandUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXBrand"],
	validation:ModelTypes["_ValidationResult"]
};
	["TOPXBrandUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXBrand"],
	validation:ModelTypes["_ValidationResult"]
};
	["TOPXBrandCategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXBrandCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["TOPXBrandCategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXBrandCategory"]
};
	["TOPXBrandCategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXBrandCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["TOPXBrandCategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXBrandCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["TOPXProductCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXProduct"],
	validation:ModelTypes["_ValidationResult"]
};
	["TOPXProductDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXProduct"]
};
	["TOPXProductUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXProduct"],
	validation:ModelTypes["_ValidationResult"]
};
	["TOPXProductUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXProduct"],
	validation:ModelTypes["_ValidationResult"]
};
	["TOPXProductCategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXProductCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["TOPXProductCategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXProductCategory"]
};
	["TOPXProductCategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXProductCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["TOPXProductCategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TOPXProductCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReferenceList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReferenceList"]
};
	["ContentReferenceListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReferenceList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReferenceList"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	validation:ModelTypes["_ValidationResult"],
	generateUploadUrl:ModelTypes["S3SignedUpload"],
	generateReadUrl:ModelTypes["S3SignedRead"],
	createBlogPage:ModelTypes["BlogPageCreateResult"],
	deleteBlogPage:ModelTypes["BlogPageDeleteResult"],
	updateBlogPage:ModelTypes["BlogPageUpdateResult"],
	upsertBlogPage:ModelTypes["BlogPageUpsertResult"],
	createBlogPost:ModelTypes["BlogPostCreateResult"],
	deleteBlogPost:ModelTypes["BlogPostDeleteResult"],
	updateBlogPost:ModelTypes["BlogPostUpdateResult"],
	upsertBlogPost:ModelTypes["BlogPostUpsertResult"],
	createBlogPostTag:ModelTypes["BlogPostTagCreateResult"],
	deleteBlogPostTag:ModelTypes["BlogPostTagDeleteResult"],
	updateBlogPostTag:ModelTypes["BlogPostTagUpdateResult"],
	upsertBlogPostTag:ModelTypes["BlogPostTagUpsertResult"],
	createBodyTag:ModelTypes["BodyTagCreateResult"],
	deleteBodyTag:ModelTypes["BodyTagDeleteResult"],
	updateBodyTag:ModelTypes["BodyTagUpdateResult"],
	upsertBodyTag:ModelTypes["BodyTagUpsertResult"],
	createBodyTagCategory:ModelTypes["BodyTagCategoryCreateResult"],
	deleteBodyTagCategory:ModelTypes["BodyTagCategoryDeleteResult"],
	updateBodyTagCategory:ModelTypes["BodyTagCategoryUpdateResult"],
	upsertBodyTagCategory:ModelTypes["BodyTagCategoryUpsertResult"],
	createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createDidYouKnow:ModelTypes["DidYouKnowCreateResult"],
	deleteDidYouKnow:ModelTypes["DidYouKnowDeleteResult"],
	updateDidYouKnow:ModelTypes["DidYouKnowUpdateResult"],
	upsertDidYouKnow:ModelTypes["DidYouKnowUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createMedium:ModelTypes["MediumCreateResult"],
	deleteMedium:ModelTypes["MediumDeleteResult"],
	updateMedium:ModelTypes["MediumUpdateResult"],
	upsertMedium:ModelTypes["MediumUpsertResult"],
	createNutritionalValue:ModelTypes["NutritionalValueCreateResult"],
	deleteNutritionalValue:ModelTypes["NutritionalValueDeleteResult"],
	updateNutritionalValue:ModelTypes["NutritionalValueUpdateResult"],
	upsertNutritionalValue:ModelTypes["NutritionalValueUpsertResult"],
	createPage:ModelTypes["PageCreateResult"],
	deletePage:ModelTypes["PageDeleteResult"],
	updatePage:ModelTypes["PageUpdateResult"],
	upsertPage:ModelTypes["PageUpsertResult"],
	createReference:ModelTypes["ReferenceCreateResult"],
	deleteReference:ModelTypes["ReferenceDeleteResult"],
	updateReference:ModelTypes["ReferenceUpdateResult"],
	upsertReference:ModelTypes["ReferenceUpsertResult"],
	createReferenceList:ModelTypes["ReferenceListCreateResult"],
	deleteReferenceList:ModelTypes["ReferenceListDeleteResult"],
	updateReferenceList:ModelTypes["ReferenceListUpdateResult"],
	upsertReferenceList:ModelTypes["ReferenceListUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createVideo:ModelTypes["VideoCreateResult"],
	deleteVideo:ModelTypes["VideoDeleteResult"],
	updateVideo:ModelTypes["VideoUpdateResult"],
	upsertVideo:ModelTypes["VideoUpsertResult"],
	createBrand:ModelTypes["BrandCreateResult"],
	deleteBrand:ModelTypes["BrandDeleteResult"],
	updateBrand:ModelTypes["BrandUpdateResult"],
	upsertBrand:ModelTypes["BrandUpsertResult"],
	createBrandDistributor:ModelTypes["BrandDistributorCreateResult"],
	deleteBrandDistributor:ModelTypes["BrandDistributorDeleteResult"],
	updateBrandDistributor:ModelTypes["BrandDistributorUpdateResult"],
	upsertBrandDistributor:ModelTypes["BrandDistributorUpsertResult"],
	createDogSize:ModelTypes["DogSizeCreateResult"],
	deleteDogSize:ModelTypes["DogSizeDeleteResult"],
	updateDogSize:ModelTypes["DogSizeUpdateResult"],
	upsertDogSize:ModelTypes["DogSizeUpsertResult"],
	createProduct:ModelTypes["ProductCreateResult"],
	deleteProduct:ModelTypes["ProductDeleteResult"],
	updateProduct:ModelTypes["ProductUpdateResult"],
	upsertProduct:ModelTypes["ProductUpsertResult"],
	createProductionMethod:ModelTypes["ProductionMethodCreateResult"],
	deleteProductionMethod:ModelTypes["ProductionMethodDeleteResult"],
	updateProductionMethod:ModelTypes["ProductionMethodUpdateResult"],
	upsertProductionMethod:ModelTypes["ProductionMethodUpsertResult"],
	createProductLine:ModelTypes["ProductLineCreateResult"],
	deleteProductLine:ModelTypes["ProductLineDeleteResult"],
	updateProductLine:ModelTypes["ProductLineUpdateResult"],
	upsertProductLine:ModelTypes["ProductLineUpsertResult"],
	createBreed:ModelTypes["BreedCreateResult"],
	deleteBreed:ModelTypes["BreedDeleteResult"],
	updateBreed:ModelTypes["BreedUpdateResult"],
	upsertBreed:ModelTypes["BreedUpsertResult"],
	createDog:ModelTypes["DogCreateResult"],
	deleteDog:ModelTypes["DogDeleteResult"],
	updateDog:ModelTypes["DogUpdateResult"],
	upsertDog:ModelTypes["DogUpsertResult"],
	createUser:ModelTypes["UserCreateResult"],
	deleteUser:ModelTypes["UserDeleteResult"],
	updateUser:ModelTypes["UserUpdateResult"],
	upsertUser:ModelTypes["UserUpsertResult"],
	createVeterinary:ModelTypes["VeterinaryCreateResult"],
	deleteVeterinary:ModelTypes["VeterinaryDeleteResult"],
	updateVeterinary:ModelTypes["VeterinaryUpdateResult"],
	upsertVeterinary:ModelTypes["VeterinaryUpsertResult"],
	createNutritionalValueOfProduct:ModelTypes["NutritionalValueOfProductCreateResult"],
	deleteNutritionalValueOfProduct:ModelTypes["NutritionalValueOfProductDeleteResult"],
	updateNutritionalValueOfProduct:ModelTypes["NutritionalValueOfProductUpdateResult"],
	upsertNutritionalValueOfProduct:ModelTypes["NutritionalValueOfProductUpsertResult"],
	createReview:ModelTypes["ReviewCreateResult"],
	deleteReview:ModelTypes["ReviewDeleteResult"],
	updateReview:ModelTypes["ReviewUpdateResult"],
	upsertReview:ModelTypes["ReviewUpsertResult"],
	createDogBodyType:ModelTypes["DogBodyTypeCreateResult"],
	deleteDogBodyType:ModelTypes["DogBodyTypeDeleteResult"],
	updateDogBodyType:ModelTypes["DogBodyTypeUpdateResult"],
	upsertDogBodyType:ModelTypes["DogBodyTypeUpsertResult"],
	createDogBodyTypeCategory:ModelTypes["DogBodyTypeCategoryCreateResult"],
	deleteDogBodyTypeCategory:ModelTypes["DogBodyTypeCategoryDeleteResult"],
	updateDogBodyTypeCategory:ModelTypes["DogBodyTypeCategoryUpdateResult"],
	upsertDogBodyTypeCategory:ModelTypes["DogBodyTypeCategoryUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createUrl:ModelTypes["UrlCreateResult"],
	deleteUrl:ModelTypes["UrlDeleteResult"],
	updateUrl:ModelTypes["UrlUpdateResult"],
	upsertUrl:ModelTypes["UrlUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createFooterLink:ModelTypes["FooterLinkCreateResult"],
	deleteFooterLink:ModelTypes["FooterLinkDeleteResult"],
	updateFooterLink:ModelTypes["FooterLinkUpdateResult"],
	upsertFooterLink:ModelTypes["FooterLinkUpsertResult"],
	createBrandsPage:ModelTypes["BrandsPageCreateResult"],
	deleteBrandsPage:ModelTypes["BrandsPageDeleteResult"],
	updateBrandsPage:ModelTypes["BrandsPageUpdateResult"],
	upsertBrandsPage:ModelTypes["BrandsPageUpsertResult"],
	createHomePage:ModelTypes["HomePageCreateResult"],
	deleteHomePage:ModelTypes["HomePageDeleteResult"],
	updateHomePage:ModelTypes["HomePageUpdateResult"],
	upsertHomePage:ModelTypes["HomePageUpsertResult"],
	createIngredientsPage:ModelTypes["IngredientsPageCreateResult"],
	deleteIngredientsPage:ModelTypes["IngredientsPageDeleteResult"],
	updateIngredientsPage:ModelTypes["IngredientsPageUpdateResult"],
	upsertIngredientsPage:ModelTypes["IngredientsPageUpsertResult"],
	createProductReview:ModelTypes["ProductReviewCreateResult"],
	deleteProductReview:ModelTypes["ProductReviewDeleteResult"],
	updateProductReview:ModelTypes["ProductReviewUpdateResult"],
	upsertProductReview:ModelTypes["ProductReviewUpsertResult"],
	createScore:ModelTypes["ScoreCreateResult"],
	deleteScore:ModelTypes["ScoreDeleteResult"],
	updateScore:ModelTypes["ScoreUpdateResult"],
	upsertScore:ModelTypes["ScoreUpsertResult"],
	createAge:ModelTypes["AgeCreateResult"],
	deleteAge:ModelTypes["AgeDeleteResult"],
	updateAge:ModelTypes["AgeUpdateResult"],
	upsertAge:ModelTypes["AgeUpsertResult"],
	createCountry:ModelTypes["CountryCreateResult"],
	deleteCountry:ModelTypes["CountryDeleteResult"],
	updateCountry:ModelTypes["CountryUpdateResult"],
	upsertCountry:ModelTypes["CountryUpsertResult"],
	createBlogPostReview:ModelTypes["BlogPostReviewCreateResult"],
	deleteBlogPostReview:ModelTypes["BlogPostReviewDeleteResult"],
	updateBlogPostReview:ModelTypes["BlogPostReviewUpdateResult"],
	upsertBlogPostReview:ModelTypes["BlogPostReviewUpsertResult"],
	createDogActivity:ModelTypes["DogActivityCreateResult"],
	deleteDogActivity:ModelTypes["DogActivityDeleteResult"],
	updateDogActivity:ModelTypes["DogActivityUpdateResult"],
	upsertDogActivity:ModelTypes["DogActivityUpsertResult"],
	createSocial:ModelTypes["SocialCreateResult"],
	deleteSocial:ModelTypes["SocialDeleteResult"],
	updateSocial:ModelTypes["SocialUpdateResult"],
	upsertSocial:ModelTypes["SocialUpsertResult"],
	createContentReferenceGalleryImage:ModelTypes["ContentReferenceGalleryImageCreateResult"],
	deleteContentReferenceGalleryImage:ModelTypes["ContentReferenceGalleryImageDeleteResult"],
	updateContentReferenceGalleryImage:ModelTypes["ContentReferenceGalleryImageUpdateResult"],
	upsertContentReferenceGalleryImage:ModelTypes["ContentReferenceGalleryImageUpsertResult"],
	createItem:ModelTypes["ItemCreateResult"],
	deleteItem:ModelTypes["ItemDeleteResult"],
	updateItem:ModelTypes["ItemUpdateResult"],
	upsertItem:ModelTypes["ItemUpsertResult"],
	createItemSubCategory:ModelTypes["ItemSubCategoryCreateResult"],
	deleteItemSubCategory:ModelTypes["ItemSubCategoryDeleteResult"],
	updateItemSubCategory:ModelTypes["ItemSubCategoryUpdateResult"],
	upsertItemSubCategory:ModelTypes["ItemSubCategoryUpsertResult"],
	createItemCategory:ModelTypes["ItemCategoryCreateResult"],
	deleteItemCategory:ModelTypes["ItemCategoryDeleteResult"],
	updateItemCategory:ModelTypes["ItemCategoryUpdateResult"],
	upsertItemCategory:ModelTypes["ItemCategoryUpsertResult"],
	createItemFlavorCategory:ModelTypes["ItemFlavorCategoryCreateResult"],
	deleteItemFlavorCategory:ModelTypes["ItemFlavorCategoryDeleteResult"],
	updateItemFlavorCategory:ModelTypes["ItemFlavorCategoryUpdateResult"],
	upsertItemFlavorCategory:ModelTypes["ItemFlavorCategoryUpsertResult"],
	createItemDeclensionFourthVariant:ModelTypes["ItemDeclensionFourthVariantCreateResult"],
	deleteItemDeclensionFourthVariant:ModelTypes["ItemDeclensionFourthVariantDeleteResult"],
	updateItemDeclensionFourthVariant:ModelTypes["ItemDeclensionFourthVariantUpdateResult"],
	upsertItemDeclensionFourthVariant:ModelTypes["ItemDeclensionFourthVariantUpsertResult"],
	createItemDeclensionSeventhVariant:ModelTypes["ItemDeclensionSeventhVariantCreateResult"],
	deleteItemDeclensionSeventhVariant:ModelTypes["ItemDeclensionSeventhVariantDeleteResult"],
	updateItemDeclensionSeventhVariant:ModelTypes["ItemDeclensionSeventhVariantUpdateResult"],
	upsertItemDeclensionSeventhVariant:ModelTypes["ItemDeclensionSeventhVariantUpsertResult"],
	createMediaCard:ModelTypes["MediaCardCreateResult"],
	deleteMediaCard:ModelTypes["MediaCardDeleteResult"],
	updateMediaCard:ModelTypes["MediaCardUpdateResult"],
	upsertMediaCard:ModelTypes["MediaCardUpsertResult"],
	createInfoCard:ModelTypes["InfoCardCreateResult"],
	deleteInfoCard:ModelTypes["InfoCardDeleteResult"],
	updateInfoCard:ModelTypes["InfoCardUpdateResult"],
	upsertInfoCard:ModelTypes["InfoCardUpsertResult"],
	createNumberedCard:ModelTypes["NumberedCardCreateResult"],
	deleteNumberedCard:ModelTypes["NumberedCardDeleteResult"],
	updateNumberedCard:ModelTypes["NumberedCardUpdateResult"],
	upsertNumberedCard:ModelTypes["NumberedCardUpsertResult"],
	createRegisterClaim:ModelTypes["RegisterClaimCreateResult"],
	deleteRegisterClaim:ModelTypes["RegisterClaimDeleteResult"],
	updateRegisterClaim:ModelTypes["RegisterClaimUpdateResult"],
	upsertRegisterClaim:ModelTypes["RegisterClaimUpsertResult"],
	createBlogPostReviewReaction:ModelTypes["BlogPostReviewReactionCreateResult"],
	deleteBlogPostReviewReaction:ModelTypes["BlogPostReviewReactionDeleteResult"],
	updateBlogPostReviewReaction:ModelTypes["BlogPostReviewReactionUpdateResult"],
	upsertBlogPostReviewReaction:ModelTypes["BlogPostReviewReactionUpsertResult"],
	createProductReviewReaction:ModelTypes["ProductReviewReactionCreateResult"],
	deleteProductReviewReaction:ModelTypes["ProductReviewReactionDeleteResult"],
	updateProductReviewReaction:ModelTypes["ProductReviewReactionUpdateResult"],
	upsertProductReviewReaction:ModelTypes["ProductReviewReactionUpsertResult"],
	createProductPackage:ModelTypes["ProductPackageCreateResult"],
	deleteProductPackage:ModelTypes["ProductPackageDeleteResult"],
	updateProductPackage:ModelTypes["ProductPackageUpdateResult"],
	upsertProductPackage:ModelTypes["ProductPackageUpsertResult"],
	createBrandManufacturer:ModelTypes["BrandManufacturerCreateResult"],
	deleteBrandManufacturer:ModelTypes["BrandManufacturerDeleteResult"],
	updateBrandManufacturer:ModelTypes["BrandManufacturerUpdateResult"],
	upsertBrandManufacturer:ModelTypes["BrandManufacturerUpsertResult"],
	createElement:ModelTypes["ElementCreateResult"],
	deleteElement:ModelTypes["ElementDeleteResult"],
	updateElement:ModelTypes["ElementUpdateResult"],
	upsertElement:ModelTypes["ElementUpsertResult"],
	createElementOfProduct:ModelTypes["ElementOfProductCreateResult"],
	deleteElementOfProduct:ModelTypes["ElementOfProductDeleteResult"],
	updateElementOfProduct:ModelTypes["ElementOfProductUpdateResult"],
	upsertElementOfProduct:ModelTypes["ElementOfProductUpsertResult"],
	createSuitabilityCategory:ModelTypes["SuitabilityCategoryCreateResult"],
	deleteSuitabilityCategory:ModelTypes["SuitabilityCategoryDeleteResult"],
	updateSuitabilityCategory:ModelTypes["SuitabilityCategoryUpdateResult"],
	upsertSuitabilityCategory:ModelTypes["SuitabilityCategoryUpsertResult"],
	createProductFeature:ModelTypes["ProductFeatureCreateResult"],
	deleteProductFeature:ModelTypes["ProductFeatureDeleteResult"],
	updateProductFeature:ModelTypes["ProductFeatureUpdateResult"],
	upsertProductFeature:ModelTypes["ProductFeatureUpsertResult"],
	createSuitabilityItem:ModelTypes["SuitabilityItemCreateResult"],
	deleteSuitabilityItem:ModelTypes["SuitabilityItemDeleteResult"],
	updateSuitabilityItem:ModelTypes["SuitabilityItemUpdateResult"],
	upsertSuitabilityItem:ModelTypes["SuitabilityItemUpsertResult"],
	createRegion:ModelTypes["RegionCreateResult"],
	deleteRegion:ModelTypes["RegionDeleteResult"],
	updateRegion:ModelTypes["RegionUpdateResult"],
	upsertRegion:ModelTypes["RegionUpsertResult"],
	createGranuleSize:ModelTypes["GranuleSizeCreateResult"],
	deleteGranuleSize:ModelTypes["GranuleSizeDeleteResult"],
	updateGranuleSize:ModelTypes["GranuleSizeUpdateResult"],
	upsertGranuleSize:ModelTypes["GranuleSizeUpsertResult"],
	createItemAlias:ModelTypes["ItemAliasCreateResult"],
	deleteItemAlias:ModelTypes["ItemAliasDeleteResult"],
	updateItemAlias:ModelTypes["ItemAliasUpdateResult"],
	upsertItemAlias:ModelTypes["ItemAliasUpsertResult"],
	createSemanticKey:ModelTypes["SemanticKeyCreateResult"],
	deleteSemanticKey:ModelTypes["SemanticKeyDeleteResult"],
	updateSemanticKey:ModelTypes["SemanticKeyUpdateResult"],
	upsertSemanticKey:ModelTypes["SemanticKeyUpsertResult"],
	createProductFlag:ModelTypes["ProductFlagCreateResult"],
	deleteProductFlag:ModelTypes["ProductFlagDeleteResult"],
	updateProductFlag:ModelTypes["ProductFlagUpdateResult"],
	upsertProductFlag:ModelTypes["ProductFlagUpsertResult"],
	createProductFlagOfProduct:ModelTypes["ProductFlagOfProductCreateResult"],
	deleteProductFlagOfProduct:ModelTypes["ProductFlagOfProductDeleteResult"],
	updateProductFlagOfProduct:ModelTypes["ProductFlagOfProductUpdateResult"],
	upsertProductFlagOfProduct:ModelTypes["ProductFlagOfProductUpsertResult"],
	createProductEvaluation:ModelTypes["ProductEvaluationCreateResult"],
	deleteProductEvaluation:ModelTypes["ProductEvaluationDeleteResult"],
	updateProductEvaluation:ModelTypes["ProductEvaluationUpdateResult"],
	upsertProductEvaluation:ModelTypes["ProductEvaluationUpsertResult"],
	createAd:ModelTypes["AdCreateResult"],
	deleteAd:ModelTypes["AdDeleteResult"],
	updateAd:ModelTypes["AdUpdateResult"],
	upsertAd:ModelTypes["AdUpsertResult"],
	createEvaluationInfo:ModelTypes["EvaluationInfoCreateResult"],
	deleteEvaluationInfo:ModelTypes["EvaluationInfoDeleteResult"],
	updateEvaluationInfo:ModelTypes["EvaluationInfoUpdateResult"],
	upsertEvaluationInfo:ModelTypes["EvaluationInfoUpsertResult"],
	createConsumptionMessage:ModelTypes["ConsumptionMessageCreateResult"],
	deleteConsumptionMessage:ModelTypes["ConsumptionMessageDeleteResult"],
	updateConsumptionMessage:ModelTypes["ConsumptionMessageUpdateResult"],
	upsertConsumptionMessage:ModelTypes["ConsumptionMessageUpsertResult"],
	createContentText:ModelTypes["ContentTextCreateResult"],
	deleteContentText:ModelTypes["ContentTextDeleteResult"],
	updateContentText:ModelTypes["ContentTextUpdateResult"],
	upsertContentText:ModelTypes["ContentTextUpsertResult"],
	createContentTextBlock:ModelTypes["ContentTextBlockCreateResult"],
	deleteContentTextBlock:ModelTypes["ContentTextBlockDeleteResult"],
	updateContentTextBlock:ModelTypes["ContentTextBlockUpdateResult"],
	upsertContentTextBlock:ModelTypes["ContentTextBlockUpsertResult"],
	createComparatorPage:ModelTypes["ComparatorPageCreateResult"],
	deleteComparatorPage:ModelTypes["ComparatorPageDeleteResult"],
	updateComparatorPage:ModelTypes["ComparatorPageUpdateResult"],
	upsertComparatorPage:ModelTypes["ComparatorPageUpsertResult"],
	createLoginPage:ModelTypes["LoginPageCreateResult"],
	deleteLoginPage:ModelTypes["LoginPageDeleteResult"],
	updateLoginPage:ModelTypes["LoginPageUpdateResult"],
	upsertLoginPage:ModelTypes["LoginPageUpsertResult"],
	createRegisterPage:ModelTypes["RegisterPageCreateResult"],
	deleteRegisterPage:ModelTypes["RegisterPageDeleteResult"],
	updateRegisterPage:ModelTypes["RegisterPageUpdateResult"],
	upsertRegisterPage:ModelTypes["RegisterPageUpsertResult"],
	createResultsPage:ModelTypes["ResultsPageCreateResult"],
	deleteResultsPage:ModelTypes["ResultsPageDeleteResult"],
	updateResultsPage:ModelTypes["ResultsPageUpdateResult"],
	upsertResultsPage:ModelTypes["ResultsPageUpsertResult"],
	createSearchPage:ModelTypes["SearchPageCreateResult"],
	deleteSearchPage:ModelTypes["SearchPageDeleteResult"],
	updateSearchPage:ModelTypes["SearchPageUpdateResult"],
	upsertSearchPage:ModelTypes["SearchPageUpsertResult"],
	createWizardPage:ModelTypes["WizardPageCreateResult"],
	deleteWizardPage:ModelTypes["WizardPageDeleteResult"],
	updateWizardPage:ModelTypes["WizardPageUpdateResult"],
	upsertWizardPage:ModelTypes["WizardPageUpsertResult"],
	createBreastfeedingCategory:ModelTypes["BreastfeedingCategoryCreateResult"],
	deleteBreastfeedingCategory:ModelTypes["BreastfeedingCategoryDeleteResult"],
	updateBreastfeedingCategory:ModelTypes["BreastfeedingCategoryUpdateResult"],
	upsertBreastfeedingCategory:ModelTypes["BreastfeedingCategoryUpsertResult"],
	createDogReproduction:ModelTypes["DogReproductionCreateResult"],
	deleteDogReproduction:ModelTypes["DogReproductionDeleteResult"],
	updateDogReproduction:ModelTypes["DogReproductionUpdateResult"],
	upsertDogReproduction:ModelTypes["DogReproductionUpsertResult"],
	createContactFormMessage:ModelTypes["ContactFormMessageCreateResult"],
	deleteContactFormMessage:ModelTypes["ContactFormMessageDeleteResult"],
	updateContactFormMessage:ModelTypes["ContactFormMessageUpdateResult"],
	upsertContactFormMessage:ModelTypes["ContactFormMessageUpsertResult"],
	createContactPage:ModelTypes["ContactPageCreateResult"],
	deleteContactPage:ModelTypes["ContactPageDeleteResult"],
	updateContactPage:ModelTypes["ContactPageUpdateResult"],
	upsertContactPage:ModelTypes["ContactPageUpsertResult"],
	createBugReport:ModelTypes["BugReportCreateResult"],
	deleteBugReport:ModelTypes["BugReportDeleteResult"],
	updateBugReport:ModelTypes["BugReportUpdateResult"],
	upsertBugReport:ModelTypes["BugReportUpsertResult"],
	createColor:ModelTypes["ColorCreateResult"],
	deleteColor:ModelTypes["ColorDeleteResult"],
	updateColor:ModelTypes["ColorUpdateResult"],
	upsertColor:ModelTypes["ColorUpsertResult"],
	createItemGroup:ModelTypes["ItemGroupCreateResult"],
	deleteItemGroup:ModelTypes["ItemGroupDeleteResult"],
	updateItemGroup:ModelTypes["ItemGroupUpdateResult"],
	upsertItemGroup:ModelTypes["ItemGroupUpsertResult"],
	createProductEvaluationSummary:ModelTypes["ProductEvaluationSummaryCreateResult"],
	deleteProductEvaluationSummary:ModelTypes["ProductEvaluationSummaryDeleteResult"],
	updateProductEvaluationSummary:ModelTypes["ProductEvaluationSummaryUpdateResult"],
	upsertProductEvaluationSummary:ModelTypes["ProductEvaluationSummaryUpsertResult"],
	createProtectedAction:ModelTypes["ProtectedActionCreateResult"],
	deleteProtectedAction:ModelTypes["ProtectedActionDeleteResult"],
	updateProtectedAction:ModelTypes["ProtectedActionUpdateResult"],
	upsertProtectedAction:ModelTypes["ProtectedActionUpsertResult"],
	createBrandAlias:ModelTypes["BrandAliasCreateResult"],
	deleteBrandAlias:ModelTypes["BrandAliasDeleteResult"],
	updateBrandAlias:ModelTypes["BrandAliasUpdateResult"],
	upsertBrandAlias:ModelTypes["BrandAliasUpsertResult"],
	createProductAlias:ModelTypes["ProductAliasCreateResult"],
	deleteProductAlias:ModelTypes["ProductAliasDeleteResult"],
	updateProductAlias:ModelTypes["ProductAliasUpdateResult"],
	upsertProductAlias:ModelTypes["ProductAliasUpsertResult"],
	createProductLineAlias:ModelTypes["ProductLineAliasCreateResult"],
	deleteProductLineAlias:ModelTypes["ProductLineAliasDeleteResult"],
	updateProductLineAlias:ModelTypes["ProductLineAliasUpdateResult"],
	upsertProductLineAlias:ModelTypes["ProductLineAliasUpsertResult"],
	createGenericPage:ModelTypes["GenericPageCreateResult"],
	deleteGenericPage:ModelTypes["GenericPageDeleteResult"],
	updateGenericPage:ModelTypes["GenericPageUpdateResult"],
	upsertGenericPage:ModelTypes["GenericPageUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createContentLinks:ModelTypes["ContentLinksCreateResult"],
	deleteContentLinks:ModelTypes["ContentLinksDeleteResult"],
	updateContentLinks:ModelTypes["ContentLinksUpdateResult"],
	upsertContentLinks:ModelTypes["ContentLinksUpsertResult"],
	createContentLinksItem:ModelTypes["ContentLinksItemCreateResult"],
	deleteContentLinksItem:ModelTypes["ContentLinksItemDeleteResult"],
	updateContentLinksItem:ModelTypes["ContentLinksItemUpdateResult"],
	upsertContentLinksItem:ModelTypes["ContentLinksItemUpsertResult"],
	createRedirect:ModelTypes["RedirectCreateResult"],
	deleteRedirect:ModelTypes["RedirectDeleteResult"],
	updateRedirect:ModelTypes["RedirectUpdateResult"],
	upsertRedirect:ModelTypes["RedirectUpsertResult"],
	createContentReferenceImage:ModelTypes["ContentReferenceImageCreateResult"],
	deleteContentReferenceImage:ModelTypes["ContentReferenceImageDeleteResult"],
	updateContentReferenceImage:ModelTypes["ContentReferenceImageUpdateResult"],
	upsertContentReferenceImage:ModelTypes["ContentReferenceImageUpsertResult"],
	createSeoData:ModelTypes["SeoDataCreateResult"],
	deleteSeoData:ModelTypes["SeoDataDeleteResult"],
	updateSeoData:ModelTypes["SeoDataUpdateResult"],
	upsertSeoData:ModelTypes["SeoDataUpsertResult"],
	createAgeCategory:ModelTypes["AgeCategoryCreateResult"],
	deleteAgeCategory:ModelTypes["AgeCategoryDeleteResult"],
	updateAgeCategory:ModelTypes["AgeCategoryUpdateResult"],
	upsertAgeCategory:ModelTypes["AgeCategoryUpsertResult"],
	createFilterCombo:ModelTypes["FilterComboCreateResult"],
	deleteFilterCombo:ModelTypes["FilterComboDeleteResult"],
	updateFilterCombo:ModelTypes["FilterComboUpdateResult"],
	upsertFilterCombo:ModelTypes["FilterComboUpsertResult"],
	createImportCache:ModelTypes["ImportCacheCreateResult"],
	deleteImportCache:ModelTypes["ImportCacheDeleteResult"],
	updateImportCache:ModelTypes["ImportCacheUpdateResult"],
	upsertImportCache:ModelTypes["ImportCacheUpsertResult"],
	createSite:ModelTypes["SiteCreateResult"],
	deleteSite:ModelTypes["SiteDeleteResult"],
	updateSite:ModelTypes["SiteUpdateResult"],
	upsertSite:ModelTypes["SiteUpsertResult"],
	createContactSubmission:ModelTypes["ContactSubmissionCreateResult"],
	deleteContactSubmission:ModelTypes["ContactSubmissionDeleteResult"],
	updateContactSubmission:ModelTypes["ContactSubmissionUpdateResult"],
	upsertContactSubmission:ModelTypes["ContactSubmissionUpsertResult"],
	createTOPXBrand:ModelTypes["TOPXBrandCreateResult"],
	deleteTOPXBrand:ModelTypes["TOPXBrandDeleteResult"],
	updateTOPXBrand:ModelTypes["TOPXBrandUpdateResult"],
	upsertTOPXBrand:ModelTypes["TOPXBrandUpsertResult"],
	createTOPXBrandCategory:ModelTypes["TOPXBrandCategoryCreateResult"],
	deleteTOPXBrandCategory:ModelTypes["TOPXBrandCategoryDeleteResult"],
	updateTOPXBrandCategory:ModelTypes["TOPXBrandCategoryUpdateResult"],
	upsertTOPXBrandCategory:ModelTypes["TOPXBrandCategoryUpsertResult"],
	createTOPXProduct:ModelTypes["TOPXProductCreateResult"],
	deleteTOPXProduct:ModelTypes["TOPXProductDeleteResult"],
	updateTOPXProduct:ModelTypes["TOPXProductUpdateResult"],
	upsertTOPXProduct:ModelTypes["TOPXProductUpsertResult"],
	createTOPXProductCategory:ModelTypes["TOPXProductCategoryCreateResult"],
	deleteTOPXProductCategory:ModelTypes["TOPXProductCategoryDeleteResult"],
	updateTOPXProductCategory:ModelTypes["TOPXProductCategoryUpdateResult"],
	upsertTOPXProductCategory:ModelTypes["TOPXProductCategoryUpsertResult"],
	createContentReferenceList:ModelTypes["ContentReferenceListCreateResult"],
	deleteContentReferenceList:ModelTypes["ContentReferenceListDeleteResult"],
	updateContentReferenceList:ModelTypes["ContentReferenceListUpdateResult"],
	upsertContentReferenceList:ModelTypes["ContentReferenceListUpsertResult"],
	query?:ModelTypes["Query"]
};
	["MutationTransactionOptions"]: GraphQLTypes["MutationTransactionOptions"]
    }

export type GraphQLTypes = {
    ["_Column"]: {
	__typename: "_Column",
	name: string,
	type: string,
	enumName?: string,
	defaultValue?: GraphQLTypes["Json"],
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Field"]: {
	__typename:"_Column" | "_Relation",
	name: string,
	type: string,
	nullable?: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
	['...on _Column']: '__union' & GraphQLTypes["_Column"];
	['...on _Relation']: '__union' & GraphQLTypes["_Relation"];
};
	["_Rule"]: {
	__typename: "_Rule",
	message?: GraphQLTypes["_RuleMessage"],
	validator: number
};
	["_RuleMessage"]: {
	__typename: "_RuleMessage",
	text?: string
};
	["_Validator"]: {
	__typename: "_Validator",
	operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:{
	__typename:"_ValidatorArgument" | "_PathArgument" | "_LiteralArgument"
	['...on _ValidatorArgument']: '__union' & GraphQLTypes["_ValidatorArgument"];
	['...on _PathArgument']: '__union' & GraphQLTypes["_PathArgument"];
	['...on _LiteralArgument']: '__union' & GraphQLTypes["_LiteralArgument"];
};
	["_ValidatorArgument"]: {
	__typename: "_ValidatorArgument",
	validator: number
};
	["_PathArgument"]: {
	__typename: "_PathArgument",
	path: Array<string>
};
	["_LiteralArgument"]: {
	__typename: "_LiteralArgument",
	value?: GraphQLTypes["Json"]
};
	/** Json custom scalar type */
["Json"]:any;
	["_Relation"]: {
	__typename: "_Relation",
	name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string,
	inversedBy?: string,
	nullable?: boolean,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"],
	orphanRemoval?: boolean,
	orderBy?: Array<GraphQLTypes["_OrderBy"]>,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_RelationSide"]: _RelationSide;
	["_OnDeleteBehaviour"]: _OnDeleteBehaviour;
	["_OrderBy"]: {
	__typename: "_OrderBy",
	path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_OrderByDirection"]: _OrderByDirection;
	["Query"]: {
	__typename: "Query",
	schema?: GraphQLTypes["_Schema"],
	s3DummyQuery?: string,
	getBlogPage?: GraphQLTypes["BlogPage"],
	listBlogPage: Array<GraphQLTypes["BlogPage"]>,
	paginateBlogPage: GraphQLTypes["BlogPageConnection"],
	validateCreateBlogPage: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPage: GraphQLTypes["_ValidationResult"],
	getBlogPost?: GraphQLTypes["BlogPost"],
	listBlogPost: Array<GraphQLTypes["BlogPost"]>,
	paginateBlogPost: GraphQLTypes["BlogPostConnection"],
	validateCreateBlogPost: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPost: GraphQLTypes["_ValidationResult"],
	getBlogPostTag?: GraphQLTypes["BlogPostTag"],
	listBlogPostTag: Array<GraphQLTypes["BlogPostTag"]>,
	paginateBlogPostTag: GraphQLTypes["BlogPostTagConnection"],
	validateCreateBlogPostTag: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostTag: GraphQLTypes["_ValidationResult"],
	getBodyTag?: GraphQLTypes["BodyTag"],
	listBodyTag: Array<GraphQLTypes["BodyTag"]>,
	paginateBodyTag: GraphQLTypes["BodyTagConnection"],
	validateCreateBodyTag: GraphQLTypes["_ValidationResult"],
	validateUpdateBodyTag: GraphQLTypes["_ValidationResult"],
	getBodyTagCategory?: GraphQLTypes["BodyTagCategory"],
	listBodyTagCategory: Array<GraphQLTypes["BodyTagCategory"]>,
	paginateBodyTagCategory: GraphQLTypes["BodyTagCategoryConnection"],
	validateCreateBodyTagCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateBodyTagCategory: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getDidYouKnow?: GraphQLTypes["DidYouKnow"],
	listDidYouKnow: Array<GraphQLTypes["DidYouKnow"]>,
	paginateDidYouKnow: GraphQLTypes["DidYouKnowConnection"],
	validateCreateDidYouKnow: GraphQLTypes["_ValidationResult"],
	validateUpdateDidYouKnow: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"],
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getNutritionalValue?: GraphQLTypes["NutritionalValue"],
	listNutritionalValue: Array<GraphQLTypes["NutritionalValue"]>,
	paginateNutritionalValue: GraphQLTypes["NutritionalValueConnection"],
	validateCreateNutritionalValue: GraphQLTypes["_ValidationResult"],
	validateUpdateNutritionalValue: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"],
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	getReference?: GraphQLTypes["Reference"],
	listReference: Array<GraphQLTypes["Reference"]>,
	paginateReference: GraphQLTypes["ReferenceConnection"],
	validateCreateReference: GraphQLTypes["_ValidationResult"],
	validateUpdateReference: GraphQLTypes["_ValidationResult"],
	getReferenceList?: GraphQLTypes["ReferenceList"],
	listReferenceList: Array<GraphQLTypes["ReferenceList"]>,
	paginateReferenceList: GraphQLTypes["ReferenceListConnection"],
	validateCreateReferenceList: GraphQLTypes["_ValidationResult"],
	validateUpdateReferenceList: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"],
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getBrand?: GraphQLTypes["Brand"],
	listBrand: Array<GraphQLTypes["Brand"]>,
	paginateBrand: GraphQLTypes["BrandConnection"],
	validateCreateBrand: GraphQLTypes["_ValidationResult"],
	validateUpdateBrand: GraphQLTypes["_ValidationResult"],
	getBrandDistributor?: GraphQLTypes["BrandDistributor"],
	listBrandDistributor: Array<GraphQLTypes["BrandDistributor"]>,
	paginateBrandDistributor: GraphQLTypes["BrandDistributorConnection"],
	validateCreateBrandDistributor: GraphQLTypes["_ValidationResult"],
	validateUpdateBrandDistributor: GraphQLTypes["_ValidationResult"],
	getDogSize?: GraphQLTypes["DogSize"],
	listDogSize: Array<GraphQLTypes["DogSize"]>,
	paginateDogSize: GraphQLTypes["DogSizeConnection"],
	validateCreateDogSize: GraphQLTypes["_ValidationResult"],
	validateUpdateDogSize: GraphQLTypes["_ValidationResult"],
	getProduct?: GraphQLTypes["Product"],
	listProduct: Array<GraphQLTypes["Product"]>,
	paginateProduct: GraphQLTypes["ProductConnection"],
	validateCreateProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateProduct: GraphQLTypes["_ValidationResult"],
	getProductionMethod?: GraphQLTypes["ProductionMethod"],
	listProductionMethod: Array<GraphQLTypes["ProductionMethod"]>,
	paginateProductionMethod: GraphQLTypes["ProductionMethodConnection"],
	validateCreateProductionMethod: GraphQLTypes["_ValidationResult"],
	validateUpdateProductionMethod: GraphQLTypes["_ValidationResult"],
	getProductLine?: GraphQLTypes["ProductLine"],
	listProductLine: Array<GraphQLTypes["ProductLine"]>,
	paginateProductLine: GraphQLTypes["ProductLineConnection"],
	validateCreateProductLine: GraphQLTypes["_ValidationResult"],
	validateUpdateProductLine: GraphQLTypes["_ValidationResult"],
	getBreed?: GraphQLTypes["Breed"],
	listBreed: Array<GraphQLTypes["Breed"]>,
	paginateBreed: GraphQLTypes["BreedConnection"],
	validateCreateBreed: GraphQLTypes["_ValidationResult"],
	validateUpdateBreed: GraphQLTypes["_ValidationResult"],
	getDog?: GraphQLTypes["Dog"],
	listDog: Array<GraphQLTypes["Dog"]>,
	paginateDog: GraphQLTypes["DogConnection"],
	validateCreateDog: GraphQLTypes["_ValidationResult"],
	validateUpdateDog: GraphQLTypes["_ValidationResult"],
	getUser?: GraphQLTypes["User"],
	listUser: Array<GraphQLTypes["User"]>,
	paginateUser: GraphQLTypes["UserConnection"],
	validateCreateUser: GraphQLTypes["_ValidationResult"],
	validateUpdateUser: GraphQLTypes["_ValidationResult"],
	getVeterinary?: GraphQLTypes["Veterinary"],
	listVeterinary: Array<GraphQLTypes["Veterinary"]>,
	paginateVeterinary: GraphQLTypes["VeterinaryConnection"],
	validateCreateVeterinary: GraphQLTypes["_ValidationResult"],
	validateUpdateVeterinary: GraphQLTypes["_ValidationResult"],
	getNutritionalValueOfProduct?: GraphQLTypes["NutritionalValueOfProduct"],
	listNutritionalValueOfProduct: Array<GraphQLTypes["NutritionalValueOfProduct"]>,
	paginateNutritionalValueOfProduct: GraphQLTypes["NutritionalValueOfProductConnection"],
	validateCreateNutritionalValueOfProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateNutritionalValueOfProduct: GraphQLTypes["_ValidationResult"],
	getReview?: GraphQLTypes["Review"],
	listReview: Array<GraphQLTypes["Review"]>,
	paginateReview: GraphQLTypes["ReviewConnection"],
	validateCreateReview: GraphQLTypes["_ValidationResult"],
	validateUpdateReview: GraphQLTypes["_ValidationResult"],
	getDogBodyType?: GraphQLTypes["DogBodyType"],
	listDogBodyType: Array<GraphQLTypes["DogBodyType"]>,
	paginateDogBodyType: GraphQLTypes["DogBodyTypeConnection"],
	validateCreateDogBodyType: GraphQLTypes["_ValidationResult"],
	validateUpdateDogBodyType: GraphQLTypes["_ValidationResult"],
	getDogBodyTypeCategory?: GraphQLTypes["DogBodyTypeCategory"],
	listDogBodyTypeCategory: Array<GraphQLTypes["DogBodyTypeCategory"]>,
	paginateDogBodyTypeCategory: GraphQLTypes["DogBodyTypeCategoryConnection"],
	validateCreateDogBodyTypeCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateDogBodyTypeCategory: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getUrl?: GraphQLTypes["Url"],
	listUrl: Array<GraphQLTypes["Url"]>,
	paginateUrl: GraphQLTypes["UrlConnection"],
	validateCreateUrl: GraphQLTypes["_ValidationResult"],
	validateUpdateUrl: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getFooterLink?: GraphQLTypes["FooterLink"],
	listFooterLink: Array<GraphQLTypes["FooterLink"]>,
	paginateFooterLink: GraphQLTypes["FooterLinkConnection"],
	validateCreateFooterLink: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLink: GraphQLTypes["_ValidationResult"],
	getBrandsPage?: GraphQLTypes["BrandsPage"],
	listBrandsPage: Array<GraphQLTypes["BrandsPage"]>,
	paginateBrandsPage: GraphQLTypes["BrandsPageConnection"],
	validateCreateBrandsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateBrandsPage: GraphQLTypes["_ValidationResult"],
	getHomePage?: GraphQLTypes["HomePage"],
	listHomePage: Array<GraphQLTypes["HomePage"]>,
	paginateHomePage: GraphQLTypes["HomePageConnection"],
	validateCreateHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePage: GraphQLTypes["_ValidationResult"],
	getIngredientsPage?: GraphQLTypes["IngredientsPage"],
	listIngredientsPage: Array<GraphQLTypes["IngredientsPage"]>,
	paginateIngredientsPage: GraphQLTypes["IngredientsPageConnection"],
	validateCreateIngredientsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientsPage: GraphQLTypes["_ValidationResult"],
	getProductReview?: GraphQLTypes["ProductReview"],
	listProductReview: Array<GraphQLTypes["ProductReview"]>,
	paginateProductReview: GraphQLTypes["ProductReviewConnection"],
	validateCreateProductReview: GraphQLTypes["_ValidationResult"],
	validateUpdateProductReview: GraphQLTypes["_ValidationResult"],
	getScore?: GraphQLTypes["Score"],
	listScore: Array<GraphQLTypes["Score"]>,
	paginateScore: GraphQLTypes["ScoreConnection"],
	validateCreateScore: GraphQLTypes["_ValidationResult"],
	validateUpdateScore: GraphQLTypes["_ValidationResult"],
	getAge?: GraphQLTypes["Age"],
	listAge: Array<GraphQLTypes["Age"]>,
	paginateAge: GraphQLTypes["AgeConnection"],
	validateCreateAge: GraphQLTypes["_ValidationResult"],
	validateUpdateAge: GraphQLTypes["_ValidationResult"],
	getCountry?: GraphQLTypes["Country"],
	listCountry: Array<GraphQLTypes["Country"]>,
	paginateCountry: GraphQLTypes["CountryConnection"],
	validateCreateCountry: GraphQLTypes["_ValidationResult"],
	validateUpdateCountry: GraphQLTypes["_ValidationResult"],
	getBlogPostReview?: GraphQLTypes["BlogPostReview"],
	listBlogPostReview: Array<GraphQLTypes["BlogPostReview"]>,
	paginateBlogPostReview: GraphQLTypes["BlogPostReviewConnection"],
	validateCreateBlogPostReview: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostReview: GraphQLTypes["_ValidationResult"],
	getDogActivity?: GraphQLTypes["DogActivity"],
	listDogActivity: Array<GraphQLTypes["DogActivity"]>,
	paginateDogActivity: GraphQLTypes["DogActivityConnection"],
	validateCreateDogActivity: GraphQLTypes["_ValidationResult"],
	validateUpdateDogActivity: GraphQLTypes["_ValidationResult"],
	getSocial?: GraphQLTypes["Social"],
	listSocial: Array<GraphQLTypes["Social"]>,
	paginateSocial: GraphQLTypes["SocialConnection"],
	validateCreateSocial: GraphQLTypes["_ValidationResult"],
	validateUpdateSocial: GraphQLTypes["_ValidationResult"],
	getContentReferenceGalleryImage?: GraphQLTypes["ContentReferenceGalleryImage"],
	listContentReferenceGalleryImage: Array<GraphQLTypes["ContentReferenceGalleryImage"]>,
	paginateContentReferenceGalleryImage: GraphQLTypes["ContentReferenceGalleryImageConnection"],
	validateCreateContentReferenceGalleryImage: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReferenceGalleryImage: GraphQLTypes["_ValidationResult"],
	getItem?: GraphQLTypes["Item"],
	listItem: Array<GraphQLTypes["Item"]>,
	paginateItem: GraphQLTypes["ItemConnection"],
	validateCreateItem: GraphQLTypes["_ValidationResult"],
	validateUpdateItem: GraphQLTypes["_ValidationResult"],
	getItemSubCategory?: GraphQLTypes["ItemSubCategory"],
	listItemSubCategory: Array<GraphQLTypes["ItemSubCategory"]>,
	paginateItemSubCategory: GraphQLTypes["ItemSubCategoryConnection"],
	validateCreateItemSubCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateItemSubCategory: GraphQLTypes["_ValidationResult"],
	getItemCategory?: GraphQLTypes["ItemCategory"],
	listItemCategory: Array<GraphQLTypes["ItemCategory"]>,
	paginateItemCategory: GraphQLTypes["ItemCategoryConnection"],
	validateCreateItemCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateItemCategory: GraphQLTypes["_ValidationResult"],
	getItemFlavorCategory?: GraphQLTypes["ItemFlavorCategory"],
	listItemFlavorCategory: Array<GraphQLTypes["ItemFlavorCategory"]>,
	paginateItemFlavorCategory: GraphQLTypes["ItemFlavorCategoryConnection"],
	validateCreateItemFlavorCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateItemFlavorCategory: GraphQLTypes["_ValidationResult"],
	getItemDeclensionFourthVariant?: GraphQLTypes["ItemDeclensionFourthVariant"],
	listItemDeclensionFourthVariant: Array<GraphQLTypes["ItemDeclensionFourthVariant"]>,
	paginateItemDeclensionFourthVariant: GraphQLTypes["ItemDeclensionFourthVariantConnection"],
	validateCreateItemDeclensionFourthVariant: GraphQLTypes["_ValidationResult"],
	validateUpdateItemDeclensionFourthVariant: GraphQLTypes["_ValidationResult"],
	getItemDeclensionSeventhVariant?: GraphQLTypes["ItemDeclensionSeventhVariant"],
	listItemDeclensionSeventhVariant: Array<GraphQLTypes["ItemDeclensionSeventhVariant"]>,
	paginateItemDeclensionSeventhVariant: GraphQLTypes["ItemDeclensionSeventhVariantConnection"],
	validateCreateItemDeclensionSeventhVariant: GraphQLTypes["_ValidationResult"],
	validateUpdateItemDeclensionSeventhVariant: GraphQLTypes["_ValidationResult"],
	getMediaCard?: GraphQLTypes["MediaCard"],
	listMediaCard: Array<GraphQLTypes["MediaCard"]>,
	paginateMediaCard: GraphQLTypes["MediaCardConnection"],
	validateCreateMediaCard: GraphQLTypes["_ValidationResult"],
	validateUpdateMediaCard: GraphQLTypes["_ValidationResult"],
	getInfoCard?: GraphQLTypes["InfoCard"],
	listInfoCard: Array<GraphQLTypes["InfoCard"]>,
	paginateInfoCard: GraphQLTypes["InfoCardConnection"],
	validateCreateInfoCard: GraphQLTypes["_ValidationResult"],
	validateUpdateInfoCard: GraphQLTypes["_ValidationResult"],
	getNumberedCard?: GraphQLTypes["NumberedCard"],
	listNumberedCard: Array<GraphQLTypes["NumberedCard"]>,
	paginateNumberedCard: GraphQLTypes["NumberedCardConnection"],
	validateCreateNumberedCard: GraphQLTypes["_ValidationResult"],
	validateUpdateNumberedCard: GraphQLTypes["_ValidationResult"],
	getRegisterClaim?: GraphQLTypes["RegisterClaim"],
	listRegisterClaim: Array<GraphQLTypes["RegisterClaim"]>,
	paginateRegisterClaim: GraphQLTypes["RegisterClaimConnection"],
	validateCreateRegisterClaim: GraphQLTypes["_ValidationResult"],
	validateUpdateRegisterClaim: GraphQLTypes["_ValidationResult"],
	getBlogPostReviewReaction?: GraphQLTypes["BlogPostReviewReaction"],
	listBlogPostReviewReaction: Array<GraphQLTypes["BlogPostReviewReaction"]>,
	paginateBlogPostReviewReaction: GraphQLTypes["BlogPostReviewReactionConnection"],
	validateCreateBlogPostReviewReaction: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostReviewReaction: GraphQLTypes["_ValidationResult"],
	getProductReviewReaction?: GraphQLTypes["ProductReviewReaction"],
	listProductReviewReaction: Array<GraphQLTypes["ProductReviewReaction"]>,
	paginateProductReviewReaction: GraphQLTypes["ProductReviewReactionConnection"],
	validateCreateProductReviewReaction: GraphQLTypes["_ValidationResult"],
	validateUpdateProductReviewReaction: GraphQLTypes["_ValidationResult"],
	getProductPackage?: GraphQLTypes["ProductPackage"],
	listProductPackage: Array<GraphQLTypes["ProductPackage"]>,
	paginateProductPackage: GraphQLTypes["ProductPackageConnection"],
	validateCreateProductPackage: GraphQLTypes["_ValidationResult"],
	validateUpdateProductPackage: GraphQLTypes["_ValidationResult"],
	getBrandManufacturer?: GraphQLTypes["BrandManufacturer"],
	listBrandManufacturer: Array<GraphQLTypes["BrandManufacturer"]>,
	paginateBrandManufacturer: GraphQLTypes["BrandManufacturerConnection"],
	validateCreateBrandManufacturer: GraphQLTypes["_ValidationResult"],
	validateUpdateBrandManufacturer: GraphQLTypes["_ValidationResult"],
	getElement?: GraphQLTypes["Element"],
	listElement: Array<GraphQLTypes["Element"]>,
	paginateElement: GraphQLTypes["ElementConnection"],
	validateCreateElement: GraphQLTypes["_ValidationResult"],
	validateUpdateElement: GraphQLTypes["_ValidationResult"],
	getElementOfProduct?: GraphQLTypes["ElementOfProduct"],
	listElementOfProduct: Array<GraphQLTypes["ElementOfProduct"]>,
	paginateElementOfProduct: GraphQLTypes["ElementOfProductConnection"],
	validateCreateElementOfProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateElementOfProduct: GraphQLTypes["_ValidationResult"],
	getSuitabilityCategory?: GraphQLTypes["SuitabilityCategory"],
	listSuitabilityCategory: Array<GraphQLTypes["SuitabilityCategory"]>,
	paginateSuitabilityCategory: GraphQLTypes["SuitabilityCategoryConnection"],
	validateCreateSuitabilityCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateSuitabilityCategory: GraphQLTypes["_ValidationResult"],
	getProductFeature?: GraphQLTypes["ProductFeature"],
	listProductFeature: Array<GraphQLTypes["ProductFeature"]>,
	paginateProductFeature: GraphQLTypes["ProductFeatureConnection"],
	validateCreateProductFeature: GraphQLTypes["_ValidationResult"],
	validateUpdateProductFeature: GraphQLTypes["_ValidationResult"],
	getSuitabilityItem?: GraphQLTypes["SuitabilityItem"],
	listSuitabilityItem: Array<GraphQLTypes["SuitabilityItem"]>,
	paginateSuitabilityItem: GraphQLTypes["SuitabilityItemConnection"],
	validateCreateSuitabilityItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSuitabilityItem: GraphQLTypes["_ValidationResult"],
	getRegion?: GraphQLTypes["Region"],
	listRegion: Array<GraphQLTypes["Region"]>,
	paginateRegion: GraphQLTypes["RegionConnection"],
	validateCreateRegion: GraphQLTypes["_ValidationResult"],
	validateUpdateRegion: GraphQLTypes["_ValidationResult"],
	getGranuleSize?: GraphQLTypes["GranuleSize"],
	listGranuleSize: Array<GraphQLTypes["GranuleSize"]>,
	paginateGranuleSize: GraphQLTypes["GranuleSizeConnection"],
	validateCreateGranuleSize: GraphQLTypes["_ValidationResult"],
	validateUpdateGranuleSize: GraphQLTypes["_ValidationResult"],
	getItemAlias?: GraphQLTypes["ItemAlias"],
	listItemAlias: Array<GraphQLTypes["ItemAlias"]>,
	paginateItemAlias: GraphQLTypes["ItemAliasConnection"],
	validateCreateItemAlias: GraphQLTypes["_ValidationResult"],
	validateUpdateItemAlias: GraphQLTypes["_ValidationResult"],
	getSemanticKey?: GraphQLTypes["SemanticKey"],
	listSemanticKey: Array<GraphQLTypes["SemanticKey"]>,
	paginateSemanticKey: GraphQLTypes["SemanticKeyConnection"],
	validateCreateSemanticKey: GraphQLTypes["_ValidationResult"],
	validateUpdateSemanticKey: GraphQLTypes["_ValidationResult"],
	getProductFlag?: GraphQLTypes["ProductFlag"],
	listProductFlag: Array<GraphQLTypes["ProductFlag"]>,
	paginateProductFlag: GraphQLTypes["ProductFlagConnection"],
	validateCreateProductFlag: GraphQLTypes["_ValidationResult"],
	validateUpdateProductFlag: GraphQLTypes["_ValidationResult"],
	getProductFlagOfProduct?: GraphQLTypes["ProductFlagOfProduct"],
	listProductFlagOfProduct: Array<GraphQLTypes["ProductFlagOfProduct"]>,
	paginateProductFlagOfProduct: GraphQLTypes["ProductFlagOfProductConnection"],
	validateCreateProductFlagOfProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateProductFlagOfProduct: GraphQLTypes["_ValidationResult"],
	getProductEvaluation?: GraphQLTypes["ProductEvaluation"],
	listProductEvaluation: Array<GraphQLTypes["ProductEvaluation"]>,
	paginateProductEvaluation: GraphQLTypes["ProductEvaluationConnection"],
	validateCreateProductEvaluation: GraphQLTypes["_ValidationResult"],
	validateUpdateProductEvaluation: GraphQLTypes["_ValidationResult"],
	getAd?: GraphQLTypes["Ad"],
	listAd: Array<GraphQLTypes["Ad"]>,
	paginateAd: GraphQLTypes["AdConnection"],
	validateCreateAd: GraphQLTypes["_ValidationResult"],
	validateUpdateAd: GraphQLTypes["_ValidationResult"],
	getEvaluationInfo?: GraphQLTypes["EvaluationInfo"],
	listEvaluationInfo: Array<GraphQLTypes["EvaluationInfo"]>,
	paginateEvaluationInfo: GraphQLTypes["EvaluationInfoConnection"],
	validateCreateEvaluationInfo: GraphQLTypes["_ValidationResult"],
	validateUpdateEvaluationInfo: GraphQLTypes["_ValidationResult"],
	getConsumptionMessage?: GraphQLTypes["ConsumptionMessage"],
	listConsumptionMessage: Array<GraphQLTypes["ConsumptionMessage"]>,
	paginateConsumptionMessage: GraphQLTypes["ConsumptionMessageConnection"],
	validateCreateConsumptionMessage: GraphQLTypes["_ValidationResult"],
	validateUpdateConsumptionMessage: GraphQLTypes["_ValidationResult"],
	getContentText?: GraphQLTypes["ContentText"],
	listContentText: Array<GraphQLTypes["ContentText"]>,
	paginateContentText: GraphQLTypes["ContentTextConnection"],
	validateCreateContentText: GraphQLTypes["_ValidationResult"],
	validateUpdateContentText: GraphQLTypes["_ValidationResult"],
	getContentTextBlock?: GraphQLTypes["ContentTextBlock"],
	listContentTextBlock: Array<GraphQLTypes["ContentTextBlock"]>,
	paginateContentTextBlock: GraphQLTypes["ContentTextBlockConnection"],
	validateCreateContentTextBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentTextBlock: GraphQLTypes["_ValidationResult"],
	getProductReviewStats?: GraphQLTypes["ProductReviewStats"],
	listProductReviewStats: Array<GraphQLTypes["ProductReviewStats"]>,
	paginateProductReviewStats: GraphQLTypes["ProductReviewStatsConnection"],
	getBlogPostReviewStats?: GraphQLTypes["BlogPostReviewStats"],
	listBlogPostReviewStats: Array<GraphQLTypes["BlogPostReviewStats"]>,
	paginateBlogPostReviewStats: GraphQLTypes["BlogPostReviewStatsConnection"],
	getComparatorPage?: GraphQLTypes["ComparatorPage"],
	listComparatorPage: Array<GraphQLTypes["ComparatorPage"]>,
	paginateComparatorPage: GraphQLTypes["ComparatorPageConnection"],
	validateCreateComparatorPage: GraphQLTypes["_ValidationResult"],
	validateUpdateComparatorPage: GraphQLTypes["_ValidationResult"],
	getLoginPage?: GraphQLTypes["LoginPage"],
	listLoginPage: Array<GraphQLTypes["LoginPage"]>,
	paginateLoginPage: GraphQLTypes["LoginPageConnection"],
	validateCreateLoginPage: GraphQLTypes["_ValidationResult"],
	validateUpdateLoginPage: GraphQLTypes["_ValidationResult"],
	getRegisterPage?: GraphQLTypes["RegisterPage"],
	listRegisterPage: Array<GraphQLTypes["RegisterPage"]>,
	paginateRegisterPage: GraphQLTypes["RegisterPageConnection"],
	validateCreateRegisterPage: GraphQLTypes["_ValidationResult"],
	validateUpdateRegisterPage: GraphQLTypes["_ValidationResult"],
	getResultsPage?: GraphQLTypes["ResultsPage"],
	listResultsPage: Array<GraphQLTypes["ResultsPage"]>,
	paginateResultsPage: GraphQLTypes["ResultsPageConnection"],
	validateCreateResultsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateResultsPage: GraphQLTypes["_ValidationResult"],
	getSearchPage?: GraphQLTypes["SearchPage"],
	listSearchPage: Array<GraphQLTypes["SearchPage"]>,
	paginateSearchPage: GraphQLTypes["SearchPageConnection"],
	validateCreateSearchPage: GraphQLTypes["_ValidationResult"],
	validateUpdateSearchPage: GraphQLTypes["_ValidationResult"],
	getWizardPage?: GraphQLTypes["WizardPage"],
	listWizardPage: Array<GraphQLTypes["WizardPage"]>,
	paginateWizardPage: GraphQLTypes["WizardPageConnection"],
	validateCreateWizardPage: GraphQLTypes["_ValidationResult"],
	validateUpdateWizardPage: GraphQLTypes["_ValidationResult"],
	getBreastfeedingCategory?: GraphQLTypes["BreastfeedingCategory"],
	listBreastfeedingCategory: Array<GraphQLTypes["BreastfeedingCategory"]>,
	paginateBreastfeedingCategory: GraphQLTypes["BreastfeedingCategoryConnection"],
	validateCreateBreastfeedingCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateBreastfeedingCategory: GraphQLTypes["_ValidationResult"],
	getDogReproduction?: GraphQLTypes["DogReproduction"],
	listDogReproduction: Array<GraphQLTypes["DogReproduction"]>,
	paginateDogReproduction: GraphQLTypes["DogReproductionConnection"],
	validateCreateDogReproduction: GraphQLTypes["_ValidationResult"],
	validateUpdateDogReproduction: GraphQLTypes["_ValidationResult"],
	getContactFormMessage?: GraphQLTypes["ContactFormMessage"],
	listContactFormMessage: Array<GraphQLTypes["ContactFormMessage"]>,
	paginateContactFormMessage: GraphQLTypes["ContactFormMessageConnection"],
	validateCreateContactFormMessage: GraphQLTypes["_ValidationResult"],
	validateUpdateContactFormMessage: GraphQLTypes["_ValidationResult"],
	getContactPage?: GraphQLTypes["ContactPage"],
	listContactPage: Array<GraphQLTypes["ContactPage"]>,
	paginateContactPage: GraphQLTypes["ContactPageConnection"],
	validateCreateContactPage: GraphQLTypes["_ValidationResult"],
	validateUpdateContactPage: GraphQLTypes["_ValidationResult"],
	getBugReport?: GraphQLTypes["BugReport"],
	listBugReport: Array<GraphQLTypes["BugReport"]>,
	paginateBugReport: GraphQLTypes["BugReportConnection"],
	validateCreateBugReport: GraphQLTypes["_ValidationResult"],
	validateUpdateBugReport: GraphQLTypes["_ValidationResult"],
	getColor?: GraphQLTypes["Color"],
	listColor: Array<GraphQLTypes["Color"]>,
	paginateColor: GraphQLTypes["ColorConnection"],
	validateCreateColor: GraphQLTypes["_ValidationResult"],
	validateUpdateColor: GraphQLTypes["_ValidationResult"],
	getItemGroup?: GraphQLTypes["ItemGroup"],
	listItemGroup: Array<GraphQLTypes["ItemGroup"]>,
	paginateItemGroup: GraphQLTypes["ItemGroupConnection"],
	validateCreateItemGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateItemGroup: GraphQLTypes["_ValidationResult"],
	getSearchResult?: GraphQLTypes["SearchResult"],
	listSearchResult: Array<GraphQLTypes["SearchResult"]>,
	paginateSearchResult: GraphQLTypes["SearchResultConnection"],
	getProductEvaluationSummary?: GraphQLTypes["ProductEvaluationSummary"],
	listProductEvaluationSummary: Array<GraphQLTypes["ProductEvaluationSummary"]>,
	paginateProductEvaluationSummary: GraphQLTypes["ProductEvaluationSummaryConnection"],
	validateCreateProductEvaluationSummary: GraphQLTypes["_ValidationResult"],
	validateUpdateProductEvaluationSummary: GraphQLTypes["_ValidationResult"],
	getProtectedAction?: GraphQLTypes["ProtectedAction"],
	listProtectedAction: Array<GraphQLTypes["ProtectedAction"]>,
	paginateProtectedAction: GraphQLTypes["ProtectedActionConnection"],
	validateCreateProtectedAction: GraphQLTypes["_ValidationResult"],
	validateUpdateProtectedAction: GraphQLTypes["_ValidationResult"],
	getBrandAlias?: GraphQLTypes["BrandAlias"],
	listBrandAlias: Array<GraphQLTypes["BrandAlias"]>,
	paginateBrandAlias: GraphQLTypes["BrandAliasConnection"],
	validateCreateBrandAlias: GraphQLTypes["_ValidationResult"],
	validateUpdateBrandAlias: GraphQLTypes["_ValidationResult"],
	getProductAlias?: GraphQLTypes["ProductAlias"],
	listProductAlias: Array<GraphQLTypes["ProductAlias"]>,
	paginateProductAlias: GraphQLTypes["ProductAliasConnection"],
	validateCreateProductAlias: GraphQLTypes["_ValidationResult"],
	validateUpdateProductAlias: GraphQLTypes["_ValidationResult"],
	getProductLineAlias?: GraphQLTypes["ProductLineAlias"],
	listProductLineAlias: Array<GraphQLTypes["ProductLineAlias"]>,
	paginateProductLineAlias: GraphQLTypes["ProductLineAliasConnection"],
	validateCreateProductLineAlias: GraphQLTypes["_ValidationResult"],
	validateUpdateProductLineAlias: GraphQLTypes["_ValidationResult"],
	getGenericPage?: GraphQLTypes["GenericPage"],
	listGenericPage: Array<GraphQLTypes["GenericPage"]>,
	paginateGenericPage: GraphQLTypes["GenericPageConnection"],
	validateCreateGenericPage: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPage: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getContentLinks?: GraphQLTypes["ContentLinks"],
	listContentLinks: Array<GraphQLTypes["ContentLinks"]>,
	paginateContentLinks: GraphQLTypes["ContentLinksConnection"],
	validateCreateContentLinks: GraphQLTypes["_ValidationResult"],
	validateUpdateContentLinks: GraphQLTypes["_ValidationResult"],
	getContentLinksItem?: GraphQLTypes["ContentLinksItem"],
	listContentLinksItem: Array<GraphQLTypes["ContentLinksItem"]>,
	paginateContentLinksItem: GraphQLTypes["ContentLinksItemConnection"],
	validateCreateContentLinksItem: GraphQLTypes["_ValidationResult"],
	validateUpdateContentLinksItem: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"],
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getContentReferenceImage?: GraphQLTypes["ContentReferenceImage"],
	listContentReferenceImage: Array<GraphQLTypes["ContentReferenceImage"]>,
	paginateContentReferenceImage: GraphQLTypes["ContentReferenceImageConnection"],
	validateCreateContentReferenceImage: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReferenceImage: GraphQLTypes["_ValidationResult"],
	getSeoData?: GraphQLTypes["SeoData"],
	listSeoData: Array<GraphQLTypes["SeoData"]>,
	paginateSeoData: GraphQLTypes["SeoDataConnection"],
	validateCreateSeoData: GraphQLTypes["_ValidationResult"],
	validateUpdateSeoData: GraphQLTypes["_ValidationResult"],
	getTenantPerson?: GraphQLTypes["TenantPerson"],
	listTenantPerson: Array<GraphQLTypes["TenantPerson"]>,
	paginateTenantPerson: GraphQLTypes["TenantPersonConnection"],
	getBrandFlavor?: GraphQLTypes["BrandFlavor"],
	listBrandFlavor: Array<GraphQLTypes["BrandFlavor"]>,
	paginateBrandFlavor: GraphQLTypes["BrandFlavorConnection"],
	getProductLineFlavor?: GraphQLTypes["ProductLineFlavor"],
	listProductLineFlavor: Array<GraphQLTypes["ProductLineFlavor"]>,
	paginateProductLineFlavor: GraphQLTypes["ProductLineFlavorConnection"],
	getProductItemDeclensionFourthCategory?: GraphQLTypes["ProductItemDeclensionFourthCategory"],
	listProductItemDeclensionFourthCategory: Array<GraphQLTypes["ProductItemDeclensionFourthCategory"]>,
	paginateProductItemDeclensionFourthCategory: GraphQLTypes["ProductItemDeclensionFourthCategoryConnection"],
	getAgeCategory?: GraphQLTypes["AgeCategory"],
	listAgeCategory: Array<GraphQLTypes["AgeCategory"]>,
	paginateAgeCategory: GraphQLTypes["AgeCategoryConnection"],
	validateCreateAgeCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateAgeCategory: GraphQLTypes["_ValidationResult"],
	getFilterCombo?: GraphQLTypes["FilterCombo"],
	listFilterCombo: Array<GraphQLTypes["FilterCombo"]>,
	paginateFilterCombo: GraphQLTypes["FilterComboConnection"],
	validateCreateFilterCombo: GraphQLTypes["_ValidationResult"],
	validateUpdateFilterCombo: GraphQLTypes["_ValidationResult"],
	getImportCache?: GraphQLTypes["ImportCache"],
	listImportCache: Array<GraphQLTypes["ImportCache"]>,
	paginateImportCache: GraphQLTypes["ImportCacheConnection"],
	validateCreateImportCache: GraphQLTypes["_ValidationResult"],
	validateUpdateImportCache: GraphQLTypes["_ValidationResult"],
	getSite?: GraphQLTypes["Site"],
	listSite: Array<GraphQLTypes["Site"]>,
	paginateSite: GraphQLTypes["SiteConnection"],
	validateCreateSite: GraphQLTypes["_ValidationResult"],
	validateUpdateSite: GraphQLTypes["_ValidationResult"],
	getContactSubmission?: GraphQLTypes["ContactSubmission"],
	listContactSubmission: Array<GraphQLTypes["ContactSubmission"]>,
	paginateContactSubmission: GraphQLTypes["ContactSubmissionConnection"],
	validateCreateContactSubmission: GraphQLTypes["_ValidationResult"],
	validateUpdateContactSubmission: GraphQLTypes["_ValidationResult"],
	getTOPXBrand?: GraphQLTypes["TOPXBrand"],
	listTOPXBrand: Array<GraphQLTypes["TOPXBrand"]>,
	paginateTOPXBrand: GraphQLTypes["TOPXBrandConnection"],
	validateCreateTOPXBrand: GraphQLTypes["_ValidationResult"],
	validateUpdateTOPXBrand: GraphQLTypes["_ValidationResult"],
	getTOPXBrandCategory?: GraphQLTypes["TOPXBrandCategory"],
	listTOPXBrandCategory: Array<GraphQLTypes["TOPXBrandCategory"]>,
	paginateTOPXBrandCategory: GraphQLTypes["TOPXBrandCategoryConnection"],
	validateCreateTOPXBrandCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateTOPXBrandCategory: GraphQLTypes["_ValidationResult"],
	getTOPXProduct?: GraphQLTypes["TOPXProduct"],
	listTOPXProduct: Array<GraphQLTypes["TOPXProduct"]>,
	paginateTOPXProduct: GraphQLTypes["TOPXProductConnection"],
	validateCreateTOPXProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateTOPXProduct: GraphQLTypes["_ValidationResult"],
	getTOPXProductCategory?: GraphQLTypes["TOPXProductCategory"],
	listTOPXProductCategory: Array<GraphQLTypes["TOPXProductCategory"]>,
	paginateTOPXProductCategory: GraphQLTypes["TOPXProductCategoryConnection"],
	validateCreateTOPXProductCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateTOPXProductCategory: GraphQLTypes["_ValidationResult"],
	getContentReferenceList?: GraphQLTypes["ContentReferenceList"],
	listContentReferenceList: Array<GraphQLTypes["ContentReferenceList"]>,
	paginateContentReferenceList: GraphQLTypes["ContentReferenceListConnection"],
	validateCreateContentReferenceList: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReferenceList: GraphQLTypes["_ValidationResult"],
	getBrandCount?: GraphQLTypes["BrandCount"],
	listBrandCount: Array<GraphQLTypes["BrandCount"]>,
	paginateBrandCount: GraphQLTypes["BrandCountConnection"],
	getProductCount?: GraphQLTypes["ProductCount"],
	listProductCount: Array<GraphQLTypes["ProductCount"]>,
	paginateProductCount: GraphQLTypes["ProductCountConnection"],
	transaction?: GraphQLTypes["QueryTransaction"],
	_info?: GraphQLTypes["Info"]
};
	["_Schema"]: {
	__typename: "_Schema",
	enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Enum"]: {
	__typename: "_Enum",
	name: string,
	values: Array<string>
};
	["_Entity"]: {
	__typename: "_Entity",
	name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
	__typename: "_UniqueConstraint",
	fields: Array<string>
};
	["BlogPage"]: {
	__typename: "BlogPage",
	_meta?: GraphQLTypes["BlogPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	title?: string,
	redirects: Array<GraphQLTypes["Redirect"]>,
	seo?: GraphQLTypes["Seo"],
	content?: GraphQLTypes["Content"],
	draft?: GraphQLTypes["Content"],
	redirectsByFrom?: GraphQLTypes["Redirect"],
	paginateRedirects: GraphQLTypes["RedirectConnection"]
};
	["BlogPageMeta"]: {
	__typename: "BlogPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	redirects?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	draft?: GraphQLTypes["FieldMeta"]
};
	["FieldMeta"]: {
	__typename: "FieldMeta",
	readable?: boolean,
	updatable?: boolean
};
	["UUID"]:any;
	["One"]: One;
	["Redirect"]: {
	__typename: "Redirect",
	_meta?: GraphQLTypes["RedirectMeta"],
	id: GraphQLTypes["UUID"],
	to?: string,
	order?: number,
	from: string,
	genericPage?: GraphQLTypes["GenericPage"],
	itemCategory?: GraphQLTypes["ItemCategory"],
	brandsPage?: GraphQLTypes["BrandsPage"],
	blogPage?: GraphQLTypes["BlogPage"],
	contactPage?: GraphQLTypes["ContactPage"],
	wizardPage?: GraphQLTypes["WizardPage"],
	comparatorPage?: GraphQLTypes["ComparatorPage"],
	blogPost?: GraphQLTypes["BlogPost"]
};
	["RedirectMeta"]: {
	__typename: "RedirectMeta",
	id?: GraphQLTypes["FieldMeta"],
	to?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	from?: GraphQLTypes["FieldMeta"],
	genericPage?: GraphQLTypes["FieldMeta"],
	itemCategory?: GraphQLTypes["FieldMeta"],
	brandsPage?: GraphQLTypes["FieldMeta"],
	blogPage?: GraphQLTypes["FieldMeta"],
	contactPage?: GraphQLTypes["FieldMeta"],
	wizardPage?: GraphQLTypes["FieldMeta"],
	comparatorPage?: GraphQLTypes["FieldMeta"],
	blogPost?: GraphQLTypes["FieldMeta"]
};
	["GenericPage"]: {
	__typename: "GenericPage",
	_meta?: GraphQLTypes["GenericPageMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["Linkable"],
	redirects: Array<GraphQLTypes["Redirect"]>,
	seo?: GraphQLTypes["Seo"],
	content?: GraphQLTypes["Content"],
	draft?: GraphQLTypes["Content"],
	redirectsByFrom?: GraphQLTypes["Redirect"],
	paginateRedirects: GraphQLTypes["RedirectConnection"]
};
	["GenericPageMeta"]: {
	__typename: "GenericPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	redirects?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	draft?: GraphQLTypes["FieldMeta"]
};
	["Linkable"]: {
	__typename: "Linkable",
	_meta?: GraphQLTypes["LinkableMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	genericPage?: GraphQLTypes["GenericPage"]
};
	["LinkableMeta"]: {
	__typename: "LinkableMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	genericPage?: GraphQLTypes["FieldMeta"]
};
	["GenericPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	redirects?: GraphQLTypes["RedirectWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	content?: GraphQLTypes["ContentWhere"],
	draft?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["GenericPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["GenericPageWhere"] | undefined>,
	not?: GraphQLTypes["GenericPageWhere"]
};
	["UUIDCondition"]: {
		and?: Array<GraphQLTypes["UUIDCondition"]>,
	or?: Array<GraphQLTypes["UUIDCondition"]>,
	not?: GraphQLTypes["UUIDCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["UUID"],
	notEq?: GraphQLTypes["UUID"],
	in?: Array<GraphQLTypes["UUID"]>,
	notIn?: Array<GraphQLTypes["UUID"]>,
	lt?: GraphQLTypes["UUID"],
	lte?: GraphQLTypes["UUID"],
	gt?: GraphQLTypes["UUID"],
	gte?: GraphQLTypes["UUID"]
};
	["StringCondition"]: {
		and?: Array<GraphQLTypes["StringCondition"]>,
	or?: Array<GraphQLTypes["StringCondition"]>,
	not?: GraphQLTypes["StringCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: string,
	notEq?: string,
	in?: Array<string>,
	notIn?: Array<string>,
	lt?: string,
	lte?: string,
	gt?: string,
	gte?: string,
	contains?: string,
	startsWith?: string,
	endsWith?: string,
	containsCI?: string,
	startsWithCI?: string,
	endsWithCI?: string
};
	["LinkableWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	genericPage?: GraphQLTypes["GenericPageWhere"],
	and?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	not?: GraphQLTypes["LinkableWhere"]
};
	["RedirectWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	to?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	from?: GraphQLTypes["StringCondition"],
	genericPage?: GraphQLTypes["GenericPageWhere"],
	itemCategory?: GraphQLTypes["ItemCategoryWhere"],
	brandsPage?: GraphQLTypes["BrandsPageWhere"],
	blogPage?: GraphQLTypes["BlogPageWhere"],
	contactPage?: GraphQLTypes["ContactPageWhere"],
	wizardPage?: GraphQLTypes["WizardPageWhere"],
	comparatorPage?: GraphQLTypes["ComparatorPageWhere"],
	blogPost?: GraphQLTypes["BlogPostWhere"],
	and?: Array<GraphQLTypes["RedirectWhere"] | undefined>,
	or?: Array<GraphQLTypes["RedirectWhere"] | undefined>,
	not?: GraphQLTypes["RedirectWhere"]
};
	["IntCondition"]: {
		and?: Array<GraphQLTypes["IntCondition"]>,
	or?: Array<GraphQLTypes["IntCondition"]>,
	not?: GraphQLTypes["IntCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["ItemCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	shortDescription?: GraphQLTypes["StringCondition"],
	subCategories?: GraphQLTypes["ItemSubCategoryWhere"],
	blogPosts?: GraphQLTypes["BlogPostWhere"],
	items?: GraphQLTypes["ItemWhere"],
	products?: GraphQLTypes["ProductWhere"],
	featureDependencies?: GraphQLTypes["ProductFeatureWhere"],
	declensionSixth?: GraphQLTypes["StringCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	comparatorGroupId?: GraphQLTypes["StringCondition"],
	ads?: GraphQLTypes["AdWhere"],
	slug?: GraphQLTypes["StringCondition"],
	redirects?: GraphQLTypes["RedirectWhere"],
	declensionsFourth?: GraphQLTypes["ItemDeclensionFourthVariantWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	group?: GraphQLTypes["ItemGroupWhere"],
	declensionSeventh?: GraphQLTypes["StringCondition"],
	slugWith?: GraphQLTypes["StringCondition"],
	slugWithNegative?: GraphQLTypes["StringCondition"],
	declensionSeventhNegative?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentWhere"],
	draft?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["ItemCategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["ItemCategoryWhere"] | undefined>,
	not?: GraphQLTypes["ItemCategoryWhere"]
};
	["ItemSubCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	items?: GraphQLTypes["ItemWhere"],
	isFlavorCategory?: GraphQLTypes["BooleanCondition"],
	isAllergenTag?: GraphQLTypes["BooleanCondition"],
	isMostCommonAllergenTag?: GraphQLTypes["BooleanCondition"],
	products?: GraphQLTypes["ProductWhere"],
	featureDependencies?: GraphQLTypes["ProductFeatureWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	category?: GraphQLTypes["ItemCategoryWhere"],
	flavorCategory?: GraphQLTypes["ItemFlavorCategoryWhere"],
	dogs?: GraphQLTypes["DogWhere"],
	iconNegative?: GraphQLTypes["ImageWhere"],
	negativeWording?: GraphQLTypes["StringCondition"],
	icon?: GraphQLTypes["ImageWhere"],
	brands?: GraphQLTypes["BrandFlavorWhere"],
	productLines?: GraphQLTypes["ProductLineFlavorWhere"],
	slug?: GraphQLTypes["StringCondition"],
	flavorSlug?: GraphQLTypes["StringCondition"],
	flavorDeclensionSeventh?: GraphQLTypes["StringCondition"],
	filterCombosFlavor?: GraphQLTypes["FilterComboWhere"],
	filterCombosAllergy?: GraphQLTypes["FilterComboWhere"],
	isFilterFlavor?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["ItemSubCategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["ItemSubCategoryWhere"] | undefined>,
	not?: GraphQLTypes["ItemSubCategoryWhere"]
};
	["ItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	positiveForBodyTags?: GraphQLTypes["BodyTagWhere"],
	negativeForBodyTags?: GraphQLTypes["BodyTagWhere"],
	subCategories?: GraphQLTypes["ItemSubCategoryWhere"],
	categories?: GraphQLTypes["ItemCategoryWhere"],
	lead?: GraphQLTypes["StringCondition"],
	animalProteinStatus?: GraphQLTypes["ContentAmountCondition"],
	carbohydrateStatus?: GraphQLTypes["ContentAmountCondition"],
	featuresOfProduct?: GraphQLTypes["ProductFeatureWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	referenceList?: GraphQLTypes["ReferenceListWhere"],
	blogPost?: GraphQLTypes["BlogPostWhere"],
	declensionFourth?: GraphQLTypes["ItemDeclensionFourthVariantWhere"],
	declensionSeventh?: GraphQLTypes["ItemDeclensionSeventhVariantWhere"],
	slug?: GraphQLTypes["StringCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	aliases?: GraphQLTypes["ItemAliasWhere"],
	content?: GraphQLTypes["ContentWhere"],
	draft?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["ItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ItemWhere"] | undefined>,
	not?: GraphQLTypes["ItemWhere"]
};
	["BodyTagWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	blogPosts?: GraphQLTypes["BlogPostWhere"],
	positiveProducts?: GraphQLTypes["ProductWhere"],
	negativeProducts?: GraphQLTypes["ProductWhere"],
	positiveItems?: GraphQLTypes["ItemWhere"],
	negativeItems?: GraphQLTypes["ItemWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	category?: GraphQLTypes["BodyTagCategoryWhere"],
	icon?: GraphQLTypes["ImageWhere"],
	dogs?: GraphQLTypes["DogWhere"],
	labelFor?: GraphQLTypes["StringCondition"],
	slug?: GraphQLTypes["StringCondition"],
	filterCombos?: GraphQLTypes["FilterComboWhere"],
	and?: Array<GraphQLTypes["BodyTagWhere"] | undefined>,
	or?: Array<GraphQLTypes["BodyTagWhere"] | undefined>,
	not?: GraphQLTypes["BodyTagWhere"]
};
	["BlogPostWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	author?: GraphQLTypes["StringCondition"],
	readingTime?: GraphQLTypes["StringCondition"],
	publishedAt?: GraphQLTypes["DateTimeCondition"],
	blogPostTags?: GraphQLTypes["BlogPostTagWhere"],
	tags?: GraphQLTypes["BodyTagWhere"],
	title?: GraphQLTypes["StringCondition"],
	listedOnHomePage?: GraphQLTypes["BooleanCondition"],
	reviews?: GraphQLTypes["BlogPostReviewWhere"],
	itemCategories?: GraphQLTypes["ItemCategoryWhere"],
	items?: GraphQLTypes["ItemWhere"],
	image?: GraphQLTypes["ImageWhere"],
	referenceList?: GraphQLTypes["ReferenceListWhere"],
	user?: GraphQLTypes["UserWhere"],
	isComparatorLinked?: GraphQLTypes["BooleanCondition"],
	ads?: GraphQLTypes["AdWhere"],
	slug?: GraphQLTypes["StringCondition"],
	lead?: GraphQLTypes["StringCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	note?: GraphQLTypes["StringCondition"],
	isActive?: GraphQLTypes["BooleanCondition"],
	redirects?: GraphQLTypes["RedirectWhere"],
	automated?: GraphQLTypes["BooleanCondition"],
	content?: GraphQLTypes["ContentWhere"],
	draft?: GraphQLTypes["ContentWhere"],
	slugInternal?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["BlogPostWhere"] | undefined>,
	or?: Array<GraphQLTypes["BlogPostWhere"] | undefined>,
	not?: GraphQLTypes["BlogPostWhere"]
};
	["DateTimeCondition"]: {
		and?: Array<GraphQLTypes["DateTimeCondition"]>,
	or?: Array<GraphQLTypes["DateTimeCondition"]>,
	not?: GraphQLTypes["DateTimeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["DateTime"],
	notEq?: GraphQLTypes["DateTime"],
	in?: Array<GraphQLTypes["DateTime"]>,
	notIn?: Array<GraphQLTypes["DateTime"]>,
	lt?: GraphQLTypes["DateTime"],
	lte?: GraphQLTypes["DateTime"],
	gt?: GraphQLTypes["DateTime"],
	gte?: GraphQLTypes["DateTime"]
};
	["DateTime"]:any;
	["BlogPostTagWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	blogPosts?: GraphQLTypes["BlogPostWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	color?: GraphQLTypes["ColorWhere"],
	order?: GraphQLTypes["IntCondition"],
	and?: Array<GraphQLTypes["BlogPostTagWhere"] | undefined>,
	or?: Array<GraphQLTypes["BlogPostTagWhere"] | undefined>,
	not?: GraphQLTypes["BlogPostTagWhere"]
};
	["ColorWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	colorHex?: GraphQLTypes["StringCondition"],
	bodyTagCategory?: GraphQLTypes["BodyTagCategoryWhere"],
	blogPostTag?: GraphQLTypes["BlogPostTagWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	itemFlavorCategories?: GraphQLTypes["ItemFlavorCategoryWhere"],
	and?: Array<GraphQLTypes["ColorWhere"] | undefined>,
	or?: Array<GraphQLTypes["ColorWhere"] | undefined>,
	not?: GraphQLTypes["ColorWhere"]
};
	["BodyTagCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	tags?: GraphQLTypes["BodyTagWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	color?: GraphQLTypes["ColorWhere"],
	and?: Array<GraphQLTypes["BodyTagCategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["BodyTagCategoryWhere"] | undefined>,
	not?: GraphQLTypes["BodyTagCategoryWhere"]
};
	["ItemFlavorCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	items?: GraphQLTypes["ItemSubCategoryWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	color?: GraphQLTypes["ColorWhere"],
	and?: Array<GraphQLTypes["ItemFlavorCategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["ItemFlavorCategoryWhere"] | undefined>,
	not?: GraphQLTypes["ItemFlavorCategoryWhere"]
};
	["BooleanCondition"]: {
		and?: Array<GraphQLTypes["BooleanCondition"]>,
	or?: Array<GraphQLTypes["BooleanCondition"]>,
	not?: GraphQLTypes["BooleanCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: boolean,
	notEq?: boolean,
	in?: Array<boolean>,
	notIn?: Array<boolean>,
	lt?: boolean,
	lte?: boolean,
	gt?: boolean,
	gte?: boolean
};
	["BlogPostReviewWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	publishedAt?: GraphQLTypes["DateTimeCondition"],
	blogPostReviewReactions?: GraphQLTypes["BlogPostReviewReactionWhere"],
	blogPost?: GraphQLTypes["BlogPostWhere"],
	user?: GraphQLTypes["UserWhere"],
	stats?: GraphQLTypes["BlogPostReviewStatsWhere"],
	fullName?: GraphQLTypes["StringCondition"],
	breed?: GraphQLTypes["BreedWhere"],
	age?: GraphQLTypes["AgeWhere"],
	url?: GraphQLTypes["StringCondition"],
	isVisible?: GraphQLTypes["BooleanCondition"],
	response?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["BlogPostReviewWhere"] | undefined>,
	or?: Array<GraphQLTypes["BlogPostReviewWhere"] | undefined>,
	not?: GraphQLTypes["BlogPostReviewWhere"]
};
	["BlogPostReviewReactionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	sentiment?: GraphQLTypes["SentimentTypeCondition"],
	user?: GraphQLTypes["UserWhere"],
	blogPostReview?: GraphQLTypes["BlogPostReviewWhere"],
	and?: Array<GraphQLTypes["BlogPostReviewReactionWhere"] | undefined>,
	or?: Array<GraphQLTypes["BlogPostReviewReactionWhere"] | undefined>,
	not?: GraphQLTypes["BlogPostReviewReactionWhere"]
};
	["SentimentTypeCondition"]: {
		and?: Array<GraphQLTypes["SentimentTypeCondition"]>,
	or?: Array<GraphQLTypes["SentimentTypeCondition"]>,
	not?: GraphQLTypes["SentimentTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["SentimentType"],
	notEq?: GraphQLTypes["SentimentType"],
	in?: Array<GraphQLTypes["SentimentType"]>,
	notIn?: Array<GraphQLTypes["SentimentType"]>,
	lt?: GraphQLTypes["SentimentType"],
	lte?: GraphQLTypes["SentimentType"],
	gt?: GraphQLTypes["SentimentType"],
	gte?: GraphQLTypes["SentimentType"]
};
	["SentimentType"]: SentimentType;
	["UserWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	dogs?: GraphQLTypes["DogWhere"],
	veterinary?: GraphQLTypes["VeterinaryWhere"],
	email?: GraphQLTypes["StringCondition"],
	blogPostReviews?: GraphQLTypes["BlogPostReviewWhere"],
	productReviews?: GraphQLTypes["ProductReviewWhere"],
	blogPostReviewReactions?: GraphQLTypes["BlogPostReviewReactionWhere"],
	productReviewReactions?: GraphQLTypes["ProductReviewReactionWhere"],
	tenantPersonId?: GraphQLTypes["UUIDCondition"],
	fullName?: GraphQLTypes["StringCondition"],
	blogPosts?: GraphQLTypes["BlogPostWhere"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	verifiedAt?: GraphQLTypes["DateTimeCondition"],
	avatar?: GraphQLTypes["ImageWhere"],
	contactFormMessages?: GraphQLTypes["ContactFormMessageWhere"],
	bugReports?: GraphQLTypes["BugReportWhere"],
	verifiedEmail?: GraphQLTypes["StringCondition"],
	protectedActions?: GraphQLTypes["ProtectedActionWhere"],
	blockedAt?: GraphQLTypes["DateTimeCondition"],
	tenantPerson?: GraphQLTypes["TenantPersonWhere"],
	note?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["UserWhere"] | undefined>,
	or?: Array<GraphQLTypes["UserWhere"] | undefined>,
	not?: GraphQLTypes["UserWhere"]
};
	["DogWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	gender?: GraphQLTypes["GenderTypeCondition"],
	weight?: GraphQLTypes["FloatCondition"],
	customIdealWeight?: GraphQLTypes["FloatCondition"],
	breed?: GraphQLTypes["BreedWhere"],
	age?: GraphQLTypes["AgeWhere"],
	bodyType?: GraphQLTypes["DogBodyTypeWhere"],
	owner?: GraphQLTypes["UserWhere"],
	activity?: GraphQLTypes["DogActivityWhere"],
	fedProduct?: GraphQLTypes["ProductWhere"],
	reproduction?: GraphQLTypes["DogReproductionWhere"],
	allergies?: GraphQLTypes["ItemSubCategoryWhere"],
	illnesses?: GraphQLTypes["BodyTagWhere"],
	name?: GraphQLTypes["StringCondition"],
	avatar?: GraphQLTypes["ImageWhere"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	and?: Array<GraphQLTypes["DogWhere"] | undefined>,
	or?: Array<GraphQLTypes["DogWhere"] | undefined>,
	not?: GraphQLTypes["DogWhere"]
};
	["GenderTypeCondition"]: {
		and?: Array<GraphQLTypes["GenderTypeCondition"]>,
	or?: Array<GraphQLTypes["GenderTypeCondition"]>,
	not?: GraphQLTypes["GenderTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["GenderType"],
	notEq?: GraphQLTypes["GenderType"],
	in?: Array<GraphQLTypes["GenderType"]>,
	notIn?: Array<GraphQLTypes["GenderType"]>,
	lt?: GraphQLTypes["GenderType"],
	lte?: GraphQLTypes["GenderType"],
	gt?: GraphQLTypes["GenderType"],
	gte?: GraphQLTypes["GenderType"]
};
	["GenderType"]: GenderType;
	["FloatCondition"]: {
		and?: Array<GraphQLTypes["FloatCondition"]>,
	or?: Array<GraphQLTypes["FloatCondition"]>,
	not?: GraphQLTypes["FloatCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["BreedWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	dogs?: GraphQLTypes["DogWhere"],
	litterSize?: GraphQLTypes["IntCondition"],
	reviews?: GraphQLTypes["ReviewWhere"],
	name?: GraphQLTypes["StringCondition"],
	dailyEnergyRequirement?: GraphQLTypes["IntCondition"],
	ages?: GraphQLTypes["AgeWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	averageWeightFemale?: GraphQLTypes["FloatCondition"],
	averageWeightMale?: GraphQLTypes["FloatCondition"],
	suitabilityCategory?: GraphQLTypes["SuitabilityCategoryWhere"],
	productReviews?: GraphQLTypes["ProductReviewWhere"],
	blogPostReviews?: GraphQLTypes["BlogPostReviewWhere"],
	labelFor?: GraphQLTypes["StringCondition"],
	size?: GraphQLTypes["DogSizeWhere"],
	slug?: GraphQLTypes["StringCondition"],
	filterCombos?: GraphQLTypes["FilterComboWhere"],
	and?: Array<GraphQLTypes["BreedWhere"] | undefined>,
	or?: Array<GraphQLTypes["BreedWhere"] | undefined>,
	not?: GraphQLTypes["BreedWhere"]
};
	["ReviewWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	dogBreeds?: GraphQLTypes["BreedWhere"],
	text?: GraphQLTypes["StringCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	author?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ReviewWhere"] | undefined>,
	or?: Array<GraphQLTypes["ReviewWhere"] | undefined>,
	not?: GraphQLTypes["ReviewWhere"]
};
	["AgeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	dogs?: GraphQLTypes["DogWhere"],
	breeds?: GraphQLTypes["BreedWhere"],
	ageRange?: GraphQLTypes["AgeRangeTypeCondition"],
	categoryLabel?: GraphQLTypes["AgeLabelTypeCondition"],
	suitabilityCategories?: GraphQLTypes["SuitabilityCategoryWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	productReviews?: GraphQLTypes["ProductReviewWhere"],
	blogPostReviews?: GraphQLTypes["BlogPostReviewWhere"],
	label?: GraphQLTypes["StringCondition"],
	categoryOrder?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["AgeWhere"] | undefined>,
	or?: Array<GraphQLTypes["AgeWhere"] | undefined>,
	not?: GraphQLTypes["AgeWhere"]
};
	["AgeRangeTypeCondition"]: {
		and?: Array<GraphQLTypes["AgeRangeTypeCondition"]>,
	or?: Array<GraphQLTypes["AgeRangeTypeCondition"]>,
	not?: GraphQLTypes["AgeRangeTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["AgeRangeType"],
	notEq?: GraphQLTypes["AgeRangeType"],
	in?: Array<GraphQLTypes["AgeRangeType"]>,
	notIn?: Array<GraphQLTypes["AgeRangeType"]>,
	lt?: GraphQLTypes["AgeRangeType"],
	lte?: GraphQLTypes["AgeRangeType"],
	gt?: GraphQLTypes["AgeRangeType"],
	gte?: GraphQLTypes["AgeRangeType"]
};
	["AgeRangeType"]: AgeRangeType;
	["AgeLabelTypeCondition"]: {
		and?: Array<GraphQLTypes["AgeLabelTypeCondition"]>,
	or?: Array<GraphQLTypes["AgeLabelTypeCondition"]>,
	not?: GraphQLTypes["AgeLabelTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["AgeLabelType"],
	notEq?: GraphQLTypes["AgeLabelType"],
	in?: Array<GraphQLTypes["AgeLabelType"]>,
	notIn?: Array<GraphQLTypes["AgeLabelType"]>,
	lt?: GraphQLTypes["AgeLabelType"],
	lte?: GraphQLTypes["AgeLabelType"],
	gt?: GraphQLTypes["AgeLabelType"],
	gte?: GraphQLTypes["AgeLabelType"]
};
	["AgeLabelType"]: AgeLabelType;
	["SuitabilityCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	dogSizes?: GraphQLTypes["DogSizeWhere"],
	dogActivities?: GraphQLTypes["DogActivityWhere"],
	breeds?: GraphQLTypes["BreedWhere"],
	suitabilityItems?: GraphQLTypes["SuitabilityItemWhere"],
	dogAges?: GraphQLTypes["AgeWhere"],
	isPregnant?: GraphQLTypes["BooleanCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	isBreastfeeding?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["SuitabilityCategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["SuitabilityCategoryWhere"] | undefined>,
	not?: GraphQLTypes["SuitabilityCategoryWhere"]
};
	["DogSizeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	breeds?: GraphQLTypes["BreedWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	products?: GraphQLTypes["ProductWhere"],
	suitabilityCategory?: GraphQLTypes["SuitabilityCategoryWhere"],
	name?: GraphQLTypes["SizeTypeCondition"],
	label?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	isFilterVisible?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["DogSizeWhere"] | undefined>,
	or?: Array<GraphQLTypes["DogSizeWhere"] | undefined>,
	not?: GraphQLTypes["DogSizeWhere"]
};
	["ProductWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	nutritionalValues?: GraphQLTypes["NutritionalValueOfProductWhere"],
	name?: GraphQLTypes["StringCondition"],
	positiveForBodyTags?: GraphQLTypes["BodyTagWhere"],
	negativeForBodyTags?: GraphQLTypes["BodyTagWhere"],
	reviews?: GraphQLTypes["ProductReviewWhere"],
	score?: GraphQLTypes["IntCondition"],
	dogs?: GraphQLTypes["DogWhere"],
	firstFiveItems?: GraphQLTypes["StringCondition"],
	detailedComposition?: GraphQLTypes["StringCondition"],
	guaranteedAnalysis?: GraphQLTypes["StringCondition"],
	isVeterinaryDiet?: GraphQLTypes["BooleanCondition"],
	packagings?: GraphQLTypes["ProductPackageWhere"],
	itemSubCategories?: GraphQLTypes["ItemSubCategoryWhere"],
	itemCategories?: GraphQLTypes["ItemCategoryWhere"],
	elements?: GraphQLTypes["ElementOfProductWhere"],
	isSearchVisible?: GraphQLTypes["BooleanCondition"],
	isSuitableForEliminationDiet?: GraphQLTypes["BooleanCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	recommendedDogSizes?: GraphQLTypes["DogSizeWhere"],
	granuleSizes?: GraphQLTypes["GranuleSizeWhere"],
	productLine?: GraphQLTypes["ProductLineWhere"],
	flags?: GraphQLTypes["ProductFlagOfProductWhere"],
	image?: GraphQLTypes["ImageWhere"],
	recommendedActivity?: GraphQLTypes["DogActivityWhere"],
	brand?: GraphQLTypes["BrandWhere"],
	metabolizedEnergy?: GraphQLTypes["FloatCondition"],
	cheapnessValue?: GraphQLTypes["FloatCondition"],
	aliases?: GraphQLTypes["ProductAliasWhere"],
	slug?: GraphQLTypes["StringCondition"],
	animalProteinStatus?: GraphQLTypes["ContentAmountCondition"],
	carbohydrateStatus?: GraphQLTypes["ContentAmountCondition"],
	evaluation?: GraphQLTypes["ProductEvaluationWhere"],
	missingComposition?: GraphQLTypes["BooleanCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	czkPerMetabolizedEnergy?: GraphQLTypes["FloatCondition"],
	itemDeclensionFourthCategories?: GraphQLTypes["ProductItemDeclensionFourthCategoryWhere"],
	ageCategories?: GraphQLTypes["AgeCategoryWhere"],
	customMetaTitle?: GraphQLTypes["StringCondition"],
	customMetaDescription?: GraphQLTypes["StringCondition"],
	isSuitableForCastrated?: GraphQLTypes["BooleanCondition"],
	heurekaImage?: GraphQLTypes["ImageWhere"],
	topx?: GraphQLTypes["TOPXProductWhere"],
	and?: Array<GraphQLTypes["ProductWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductWhere"] | undefined>,
	not?: GraphQLTypes["ProductWhere"]
};
	["NutritionalValueOfProductWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	product?: GraphQLTypes["ProductWhere"],
	amount?: GraphQLTypes["FloatCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	nutritionalValue?: GraphQLTypes["NutritionalValueWhere"],
	and?: Array<GraphQLTypes["NutritionalValueOfProductWhere"] | undefined>,
	or?: Array<GraphQLTypes["NutritionalValueOfProductWhere"] | undefined>,
	not?: GraphQLTypes["NutritionalValueOfProductWhere"]
};
	["NutritionalValueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	products?: GraphQLTypes["NutritionalValueOfProductWhere"],
	suitabilityNutritionalValues?: GraphQLTypes["SuitabilityItemWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	icon?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["NutritionalValueWhere"] | undefined>,
	or?: Array<GraphQLTypes["NutritionalValueWhere"] | undefined>,
	not?: GraphQLTypes["NutritionalValueWhere"]
};
	["SuitabilityItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	min?: GraphQLTypes["FloatCondition"],
	max?: GraphQLTypes["FloatCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	element?: GraphQLTypes["ElementWhere"],
	nutritionalValue?: GraphQLTypes["NutritionalValueWhere"],
	category?: GraphQLTypes["SuitabilityCategoryWhere"],
	and?: Array<GraphQLTypes["SuitabilityItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["SuitabilityItemWhere"] | undefined>,
	not?: GraphQLTypes["SuitabilityItemWhere"]
};
	["ElementWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	products?: GraphQLTypes["ElementOfProductWhere"],
	featureDependencies?: GraphQLTypes["ProductFeatureWhere"],
	suitabilityElements?: GraphQLTypes["SuitabilityItemWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	unit?: GraphQLTypes["StringCondition"],
	filterOrder?: GraphQLTypes["IntCondition"],
	slug?: GraphQLTypes["StringCondition"],
	declensionSeventh?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ElementWhere"] | undefined>,
	or?: Array<GraphQLTypes["ElementWhere"] | undefined>,
	not?: GraphQLTypes["ElementWhere"]
};
	["ElementOfProductWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	amount?: GraphQLTypes["FloatCondition"],
	product?: GraphQLTypes["ProductWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	element?: GraphQLTypes["ElementWhere"],
	and?: Array<GraphQLTypes["ElementOfProductWhere"] | undefined>,
	or?: Array<GraphQLTypes["ElementOfProductWhere"] | undefined>,
	not?: GraphQLTypes["ElementOfProductWhere"]
};
	["ProductFeatureWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	text?: GraphQLTypes["StringCondition"],
	category?: GraphQLTypes["FeatureCategoryTypeCondition"],
	value?: GraphQLTypes["FeatureValueTypeCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	linkItem?: GraphQLTypes["ItemWhere"],
	dependentElement?: GraphQLTypes["ElementWhere"],
	dependentCategory?: GraphQLTypes["ItemCategoryWhere"],
	dependentSubCategory?: GraphQLTypes["ItemSubCategoryWhere"],
	dependentFlag?: GraphQLTypes["ProductFlagWhere"],
	and?: Array<GraphQLTypes["ProductFeatureWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductFeatureWhere"] | undefined>,
	not?: GraphQLTypes["ProductFeatureWhere"]
};
	["FeatureCategoryTypeCondition"]: {
		and?: Array<GraphQLTypes["FeatureCategoryTypeCondition"]>,
	or?: Array<GraphQLTypes["FeatureCategoryTypeCondition"]>,
	not?: GraphQLTypes["FeatureCategoryTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["FeatureCategoryType"],
	notEq?: GraphQLTypes["FeatureCategoryType"],
	in?: Array<GraphQLTypes["FeatureCategoryType"]>,
	notIn?: Array<GraphQLTypes["FeatureCategoryType"]>,
	lt?: GraphQLTypes["FeatureCategoryType"],
	lte?: GraphQLTypes["FeatureCategoryType"],
	gt?: GraphQLTypes["FeatureCategoryType"],
	gte?: GraphQLTypes["FeatureCategoryType"]
};
	["FeatureCategoryType"]: FeatureCategoryType;
	["FeatureValueTypeCondition"]: {
		and?: Array<GraphQLTypes["FeatureValueTypeCondition"]>,
	or?: Array<GraphQLTypes["FeatureValueTypeCondition"]>,
	not?: GraphQLTypes["FeatureValueTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["FeatureValueType"],
	notEq?: GraphQLTypes["FeatureValueType"],
	in?: Array<GraphQLTypes["FeatureValueType"]>,
	notIn?: Array<GraphQLTypes["FeatureValueType"]>,
	lt?: GraphQLTypes["FeatureValueType"],
	lte?: GraphQLTypes["FeatureValueType"],
	gt?: GraphQLTypes["FeatureValueType"],
	gte?: GraphQLTypes["FeatureValueType"]
};
	["FeatureValueType"]: FeatureValueType;
	["ProductFlagWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	productFeatures?: GraphQLTypes["ProductFeatureWhere"],
	products?: GraphQLTypes["ProductFlagOfProductWhere"],
	and?: Array<GraphQLTypes["ProductFlagWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductFlagWhere"] | undefined>,
	not?: GraphQLTypes["ProductFlagWhere"]
};
	["ProductFlagOfProductWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	value?: GraphQLTypes["ProductFlagValueCondition"],
	product?: GraphQLTypes["ProductWhere"],
	flag?: GraphQLTypes["ProductFlagWhere"],
	and?: Array<GraphQLTypes["ProductFlagOfProductWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductFlagOfProductWhere"] | undefined>,
	not?: GraphQLTypes["ProductFlagOfProductWhere"]
};
	["ProductFlagValueCondition"]: {
		and?: Array<GraphQLTypes["ProductFlagValueCondition"]>,
	or?: Array<GraphQLTypes["ProductFlagValueCondition"]>,
	not?: GraphQLTypes["ProductFlagValueCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ProductFlagValue"],
	notEq?: GraphQLTypes["ProductFlagValue"],
	in?: Array<GraphQLTypes["ProductFlagValue"]>,
	notIn?: Array<GraphQLTypes["ProductFlagValue"]>,
	lt?: GraphQLTypes["ProductFlagValue"],
	lte?: GraphQLTypes["ProductFlagValue"],
	gt?: GraphQLTypes["ProductFlagValue"],
	gte?: GraphQLTypes["ProductFlagValue"]
};
	["ProductFlagValue"]: ProductFlagValue;
	["ImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	alt?: GraphQLTypes["StringCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	hash?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	not?: GraphQLTypes["ImageWhere"]
};
	["ProductReviewWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	text?: GraphQLTypes["StringCondition"],
	publishedAt?: GraphQLTypes["DateTimeCondition"],
	productReviewReactions?: GraphQLTypes["ProductReviewReactionWhere"],
	score?: GraphQLTypes["ScoreWhere"],
	product?: GraphQLTypes["ProductWhere"],
	user?: GraphQLTypes["UserWhere"],
	stats?: GraphQLTypes["ProductReviewStatsWhere"],
	fullName?: GraphQLTypes["StringCondition"],
	breed?: GraphQLTypes["BreedWhere"],
	age?: GraphQLTypes["AgeWhere"],
	url?: GraphQLTypes["StringCondition"],
	isVisible?: GraphQLTypes["BooleanCondition"],
	response?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ProductReviewWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductReviewWhere"] | undefined>,
	not?: GraphQLTypes["ProductReviewWhere"]
};
	["ProductReviewReactionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	sentiment?: GraphQLTypes["SentimentTypeCondition"],
	user?: GraphQLTypes["UserWhere"],
	productReview?: GraphQLTypes["ProductReviewWhere"],
	and?: Array<GraphQLTypes["ProductReviewReactionWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductReviewReactionWhere"] | undefined>,
	not?: GraphQLTypes["ProductReviewReactionWhere"]
};
	["ScoreWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	label?: GraphQLTypes["StringCondition"],
	productReviews?: GraphQLTypes["ProductReviewWhere"],
	starsAmount?: GraphQLTypes["IntCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ScoreWhere"] | undefined>,
	or?: Array<GraphQLTypes["ScoreWhere"] | undefined>,
	not?: GraphQLTypes["ScoreWhere"]
};
	["ProductReviewStatsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	total?: GraphQLTypes["IntCondition"],
	positive?: GraphQLTypes["IntCondition"],
	negative?: GraphQLTypes["IntCondition"],
	productReview?: GraphQLTypes["ProductReviewWhere"],
	and?: Array<GraphQLTypes["ProductReviewStatsWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductReviewStatsWhere"] | undefined>,
	not?: GraphQLTypes["ProductReviewStatsWhere"]
};
	["ProductPackageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	price?: GraphQLTypes["IntCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["StringCondition"],
	product?: GraphQLTypes["ProductWhere"],
	amount?: GraphQLTypes["FloatCondition"],
	externalId?: GraphQLTypes["StringCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	label?: GraphQLTypes["StringCondition"],
	positionId?: GraphQLTypes["StringCondition"],
	heurekaPrice?: GraphQLTypes["IntCondition"],
	heurekaLink?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ProductPackageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductPackageWhere"] | undefined>,
	not?: GraphQLTypes["ProductPackageWhere"]
};
	["GranuleSizeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	products?: GraphQLTypes["ProductWhere"],
	name?: GraphQLTypes["GranuleSizeTypeCondition"],
	and?: Array<GraphQLTypes["GranuleSizeWhere"] | undefined>,
	or?: Array<GraphQLTypes["GranuleSizeWhere"] | undefined>,
	not?: GraphQLTypes["GranuleSizeWhere"]
};
	["GranuleSizeTypeCondition"]: {
		and?: Array<GraphQLTypes["GranuleSizeTypeCondition"]>,
	or?: Array<GraphQLTypes["GranuleSizeTypeCondition"]>,
	not?: GraphQLTypes["GranuleSizeTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["GranuleSizeType"],
	notEq?: GraphQLTypes["GranuleSizeType"],
	in?: Array<GraphQLTypes["GranuleSizeType"]>,
	notIn?: Array<GraphQLTypes["GranuleSizeType"]>,
	lt?: GraphQLTypes["GranuleSizeType"],
	lte?: GraphQLTypes["GranuleSizeType"],
	gt?: GraphQLTypes["GranuleSizeType"],
	gte?: GraphQLTypes["GranuleSizeType"]
};
	["GranuleSizeType"]: GranuleSizeType;
	["ProductLineWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	products?: GraphQLTypes["ProductWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	lead?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	brand?: GraphQLTypes["BrandWhere"],
	logo?: GraphQLTypes["ImageWhere"],
	aliases?: GraphQLTypes["ProductLineAliasWhere"],
	slug?: GraphQLTypes["StringCondition"],
	flavors?: GraphQLTypes["ProductLineFlavorWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	customMetaDescription?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ProductLineWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductLineWhere"] | undefined>,
	not?: GraphQLTypes["ProductLineWhere"]
};
	["BrandWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	products?: GraphQLTypes["ProductWhere"],
	link?: GraphQLTypes["StringCondition"],
	countriesOfProduction?: GraphQLTypes["CountryWhere"],
	manufacturers?: GraphQLTypes["BrandManufacturerWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	promotedOnSearchPlace?: GraphQLTypes["IntCondition"],
	promotedOnBrandsPagePlace?: GraphQLTypes["IntCondition"],
	lead?: GraphQLTypes["StringCondition"],
	productLines?: GraphQLTypes["ProductLineWhere"],
	logo?: GraphQLTypes["ImageWhere"],
	methodOfProduction?: GraphQLTypes["ProductionMethodWhere"],
	distributor?: GraphQLTypes["BrandDistributorWhere"],
	aliases?: GraphQLTypes["BrandAliasWhere"],
	ads?: GraphQLTypes["AdWhere"],
	slug?: GraphQLTypes["StringCondition"],
	flavors?: GraphQLTypes["BrandFlavorWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	customMetaDescription?: GraphQLTypes["StringCondition"],
	filterCombos?: GraphQLTypes["FilterComboWhere"],
	topx?: GraphQLTypes["TOPXBrandWhere"],
	content?: GraphQLTypes["ContentWhere"],
	draft?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["BrandWhere"] | undefined>,
	or?: Array<GraphQLTypes["BrandWhere"] | undefined>,
	not?: GraphQLTypes["BrandWhere"]
};
	["CountryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	brands?: GraphQLTypes["BrandWhere"],
	manufacturers?: GraphQLTypes["BrandManufacturerWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	region?: GraphQLTypes["RegionWhere"],
	and?: Array<GraphQLTypes["CountryWhere"] | undefined>,
	or?: Array<GraphQLTypes["CountryWhere"] | undefined>,
	not?: GraphQLTypes["CountryWhere"]
};
	["BrandManufacturerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["StringCondition"],
	brands?: GraphQLTypes["BrandWhere"],
	order?: GraphQLTypes["IntCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	residence?: GraphQLTypes["CountryWhere"],
	and?: Array<GraphQLTypes["BrandManufacturerWhere"] | undefined>,
	or?: Array<GraphQLTypes["BrandManufacturerWhere"] | undefined>,
	not?: GraphQLTypes["BrandManufacturerWhere"]
};
	["RegionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	countries?: GraphQLTypes["CountryWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	adjective?: GraphQLTypes["StringCondition"],
	slug?: GraphQLTypes["StringCondition"],
	filterCombos?: GraphQLTypes["FilterComboWhere"],
	and?: Array<GraphQLTypes["RegionWhere"] | undefined>,
	or?: Array<GraphQLTypes["RegionWhere"] | undefined>,
	not?: GraphQLTypes["RegionWhere"]
};
	["FilterComboWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	title?: GraphQLTypes["StringCondition"],
	lead?: GraphQLTypes["StringCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	breed?: GraphQLTypes["BreedWhere"],
	brand?: GraphQLTypes["BrandWhere"],
	region?: GraphQLTypes["RegionWhere"],
	ageCategory?: GraphQLTypes["AgeCategoryWhere"],
	treatment?: GraphQLTypes["BodyTagWhere"],
	flavor?: GraphQLTypes["ItemSubCategoryWhere"],
	allergy?: GraphQLTypes["ItemSubCategoryWhere"],
	and?: Array<GraphQLTypes["FilterComboWhere"] | undefined>,
	or?: Array<GraphQLTypes["FilterComboWhere"] | undefined>,
	not?: GraphQLTypes["FilterComboWhere"]
};
	["SeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	description?: GraphQLTypes["StringCondition"],
	ogTitle?: GraphQLTypes["StringCondition"],
	ogDescription?: GraphQLTypes["StringCondition"],
	ogImage?: GraphQLTypes["ImageWhere"],
	blogPage?: GraphQLTypes["BlogPageWhere"],
	brandsPage?: GraphQLTypes["BrandsPageWhere"],
	comparatorPage?: GraphQLTypes["ComparatorPageWhere"],
	genericPage?: GraphQLTypes["GenericPageWhere"],
	homePage?: GraphQLTypes["HomePageWhere"],
	ingredientsPage?: GraphQLTypes["IngredientsPageWhere"],
	loginPage?: GraphQLTypes["LoginPageWhere"],
	registerPage?: GraphQLTypes["RegisterPageWhere"],
	searchPage?: GraphQLTypes["SearchPageWhere"],
	wizardPage?: GraphQLTypes["WizardPageWhere"],
	contactPage?: GraphQLTypes["ContactPageWhere"],
	group?: GraphQLTypes["GroupTypeCondition"],
	url?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	not?: GraphQLTypes["SeoWhere"]
};
	["BlogPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	redirects?: GraphQLTypes["RedirectWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	content?: GraphQLTypes["ContentWhere"],
	draft?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["BlogPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["BlogPageWhere"] | undefined>,
	not?: GraphQLTypes["BlogPageWhere"]
};
	["OneCondition"]: {
		and?: Array<GraphQLTypes["OneCondition"]>,
	or?: Array<GraphQLTypes["OneCondition"]>,
	not?: GraphQLTypes["OneCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["One"],
	notEq?: GraphQLTypes["One"],
	in?: Array<GraphQLTypes["One"]>,
	notIn?: Array<GraphQLTypes["One"]>,
	lt?: GraphQLTypes["One"],
	lte?: GraphQLTypes["One"],
	gt?: GraphQLTypes["One"],
	gte?: GraphQLTypes["One"]
};
	["ContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	blocks?: GraphQLTypes["ContentBlockWhere"],
	and?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	not?: GraphQLTypes["ContentWhere"]
};
	["ContentBlockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	json?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentWhere"],
	references?: GraphQLTypes["ContentReferenceWhere"],
	automatedContentBlockSlug?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	not?: GraphQLTypes["ContentBlockWhere"]
};
	["ContentReferenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["ContentReferenceTypeCondition"],
	block?: GraphQLTypes["ContentBlockWhere"],
	primaryText?: GraphQLTypes["StringCondition"],
	secondaryText?: GraphQLTypes["StringCondition"],
	fact?: GraphQLTypes["StringCondition"],
	images?: GraphQLTypes["ContentReferenceGalleryImageWhere"],
	relatedBlogPost?: GraphQLTypes["BlogPostWhere"],
	relatedBrand?: GraphQLTypes["BrandWhere"],
	relatedProduct?: GraphQLTypes["ProductWhere"],
	relatedIngredient?: GraphQLTypes["ItemWhere"],
	link?: GraphQLTypes["LinkWhere"],
	badge?: GraphQLTypes["StringCondition"],
	longVersion?: GraphQLTypes["BooleanCondition"],
	relatedBrandFull?: GraphQLTypes["BrandWhere"],
	relatedProductFull?: GraphQLTypes["ProductWhere"],
	list?: GraphQLTypes["ContentReferenceListWhere"],
	outline?: GraphQLTypes["ContentLinksWhere"],
	video?: GraphQLTypes["VideoWhere"],
	image?: GraphQLTypes["ContentReferenceImageWhere"],
	defaultOpen?: GraphQLTypes["BooleanCondition"],
	badgeColor?: GraphQLTypes["StringCondition"],
	isMain?: GraphQLTypes["BooleanCondition"],
	ad?: GraphQLTypes["AdWhere"],
	and?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	not?: GraphQLTypes["ContentReferenceWhere"]
};
	["ContentReferenceTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	or?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	not?: GraphQLTypes["ContentReferenceTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentReferenceType"],
	notEq?: GraphQLTypes["ContentReferenceType"],
	in?: Array<GraphQLTypes["ContentReferenceType"]>,
	notIn?: Array<GraphQLTypes["ContentReferenceType"]>,
	lt?: GraphQLTypes["ContentReferenceType"],
	lte?: GraphQLTypes["ContentReferenceType"],
	gt?: GraphQLTypes["ContentReferenceType"],
	gte?: GraphQLTypes["ContentReferenceType"]
};
	["ContentReferenceType"]: ContentReferenceType;
	["ContentReferenceGalleryImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	reference?: GraphQLTypes["ContentReferenceWhere"],
	image?: GraphQLTypes["ImageWhere"],
	lead?: GraphQLTypes["StringCondition"],
	alignment?: GraphQLTypes["AlignmentTypeCondition"],
	and?: Array<GraphQLTypes["ContentReferenceGalleryImageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentReferenceGalleryImageWhere"] | undefined>,
	not?: GraphQLTypes["ContentReferenceGalleryImageWhere"]
};
	["AlignmentTypeCondition"]: {
		and?: Array<GraphQLTypes["AlignmentTypeCondition"]>,
	or?: Array<GraphQLTypes["AlignmentTypeCondition"]>,
	not?: GraphQLTypes["AlignmentTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["AlignmentType"],
	notEq?: GraphQLTypes["AlignmentType"],
	in?: Array<GraphQLTypes["AlignmentType"]>,
	notIn?: Array<GraphQLTypes["AlignmentType"]>,
	lt?: GraphQLTypes["AlignmentType"],
	lte?: GraphQLTypes["AlignmentType"],
	gt?: GraphQLTypes["AlignmentType"],
	gte?: GraphQLTypes["AlignmentType"]
};
	["AlignmentType"]: AlignmentType;
	["LinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	externalLink?: GraphQLTypes["StringCondition"],
	isTargetBlank?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	not?: GraphQLTypes["LinkWhere"]
};
	["ContentReferenceListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	relatedProduct?: GraphQLTypes["ProductWhere"],
	relatedBrand?: GraphQLTypes["BrandWhere"],
	list?: GraphQLTypes["ContentReferenceWhere"],
	badge?: GraphQLTypes["StringCondition"],
	badgeColor?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ContentReferenceListWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentReferenceListWhere"] | undefined>,
	not?: GraphQLTypes["ContentReferenceListWhere"]
};
	["ContentLinksWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["ContentLinksItemWhere"],
	and?: Array<GraphQLTypes["ContentLinksWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentLinksWhere"] | undefined>,
	not?: GraphQLTypes["ContentLinksWhere"]
};
	["ContentLinksItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	title?: GraphQLTypes["StringCondition"],
	target?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["ContentLinksWhere"],
	and?: Array<GraphQLTypes["ContentLinksItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentLinksItemWhere"] | undefined>,
	not?: GraphQLTypes["ContentLinksItemWhere"]
};
	["VideoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	src?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	duration?: GraphQLTypes["FloatCondition"],
	poster?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["VideoWhere"] | undefined>,
	or?: Array<GraphQLTypes["VideoWhere"] | undefined>,
	not?: GraphQLTypes["VideoWhere"]
};
	["ContentReferenceImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	lead?: GraphQLTypes["StringCondition"],
	alignment?: GraphQLTypes["AlignmentTypeCondition"],
	image?: GraphQLTypes["ImageWhere"],
	link?: GraphQLTypes["StringCondition"],
	targetBlank?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["ContentReferenceImageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentReferenceImageWhere"] | undefined>,
	not?: GraphQLTypes["ContentReferenceImageWhere"]
};
	["AdWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	image?: GraphQLTypes["ImageWhere"],
	isBrandSectionVisible?: GraphQLTypes["BooleanCondition"],
	isBlogPostSectionVisible?: GraphQLTypes["BooleanCondition"],
	isIngredientSectionVisible?: GraphQLTypes["BooleanCondition"],
	isResultsVisible?: GraphQLTypes["BooleanCondition"],
	isSearchVisible?: GraphQLTypes["BooleanCondition"],
	blogPosts?: GraphQLTypes["BlogPostWhere"],
	itemCategories?: GraphQLTypes["ItemCategoryWhere"],
	brands?: GraphQLTypes["BrandWhere"],
	isActive?: GraphQLTypes["BooleanCondition"],
	link?: GraphQLTypes["StringCondition"],
	note?: GraphQLTypes["StringCondition"],
	activeFrom?: GraphQLTypes["DateTimeCondition"],
	activeUntil?: GraphQLTypes["DateTimeCondition"],
	slug?: GraphQLTypes["StringCondition"],
	contentReferences?: GraphQLTypes["ContentReferenceWhere"],
	and?: Array<GraphQLTypes["AdWhere"] | undefined>,
	or?: Array<GraphQLTypes["AdWhere"] | undefined>,
	not?: GraphQLTypes["AdWhere"]
};
	["BrandsPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	redirects?: GraphQLTypes["RedirectWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	content?: GraphQLTypes["ContentWhere"],
	draft?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["BrandsPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["BrandsPageWhere"] | undefined>,
	not?: GraphQLTypes["BrandsPageWhere"]
};
	["ComparatorPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	redirects?: GraphQLTypes["RedirectWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["ComparatorPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ComparatorPageWhere"] | undefined>,
	not?: GraphQLTypes["ComparatorPageWhere"]
};
	["HomePageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	lead?: GraphQLTypes["StringCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["HomePageWhere"] | undefined>,
	or?: Array<GraphQLTypes["HomePageWhere"] | undefined>,
	not?: GraphQLTypes["HomePageWhere"]
};
	["IngredientsPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	content?: GraphQLTypes["ContentWhere"],
	draft?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["IngredientsPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["IngredientsPageWhere"] | undefined>,
	not?: GraphQLTypes["IngredientsPageWhere"]
};
	["LoginPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["LoginPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["LoginPageWhere"] | undefined>,
	not?: GraphQLTypes["LoginPageWhere"]
};
	["RegisterPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["RegisterPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["RegisterPageWhere"] | undefined>,
	not?: GraphQLTypes["RegisterPageWhere"]
};
	["SearchPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["SearchPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["SearchPageWhere"] | undefined>,
	not?: GraphQLTypes["SearchPageWhere"]
};
	["WizardPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	redirects?: GraphQLTypes["RedirectWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["WizardPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["WizardPageWhere"] | undefined>,
	not?: GraphQLTypes["WizardPageWhere"]
};
	["ContactPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	redirects?: GraphQLTypes["RedirectWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	content?: GraphQLTypes["ContentWhere"],
	draft?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["ContactPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContactPageWhere"] | undefined>,
	not?: GraphQLTypes["ContactPageWhere"]
};
	["GroupTypeCondition"]: {
		and?: Array<GraphQLTypes["GroupTypeCondition"]>,
	or?: Array<GraphQLTypes["GroupTypeCondition"]>,
	not?: GraphQLTypes["GroupTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["GroupType"],
	notEq?: GraphQLTypes["GroupType"],
	in?: Array<GraphQLTypes["GroupType"]>,
	notIn?: Array<GraphQLTypes["GroupType"]>,
	lt?: GraphQLTypes["GroupType"],
	lte?: GraphQLTypes["GroupType"],
	gt?: GraphQLTypes["GroupType"],
	gte?: GraphQLTypes["GroupType"]
};
	["GroupType"]: GroupType;
	["AgeCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	labelFor?: GraphQLTypes["StringCondition"],
	products?: GraphQLTypes["ProductWhere"],
	slug?: GraphQLTypes["StringCondition"],
	filterCombos?: GraphQLTypes["FilterComboWhere"],
	and?: Array<GraphQLTypes["AgeCategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["AgeCategoryWhere"] | undefined>,
	not?: GraphQLTypes["AgeCategoryWhere"]
};
	["ProductionMethodWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	brands?: GraphQLTypes["BrandWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ProductionMethodWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductionMethodWhere"] | undefined>,
	not?: GraphQLTypes["ProductionMethodWhere"]
};
	["BrandDistributorWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	brands?: GraphQLTypes["BrandWhere"],
	link?: GraphQLTypes["StringCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["BrandDistributorWhere"] | undefined>,
	or?: Array<GraphQLTypes["BrandDistributorWhere"] | undefined>,
	not?: GraphQLTypes["BrandDistributorWhere"]
};
	["BrandAliasWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	name?: GraphQLTypes["StringCondition"],
	brand?: GraphQLTypes["BrandWhere"],
	and?: Array<GraphQLTypes["BrandAliasWhere"] | undefined>,
	or?: Array<GraphQLTypes["BrandAliasWhere"] | undefined>,
	not?: GraphQLTypes["BrandAliasWhere"]
};
	["BrandFlavorWhere"]: {
		id?: GraphQLTypes["StringCondition"],
	brand?: GraphQLTypes["BrandWhere"],
	itemSubCategory?: GraphQLTypes["ItemSubCategoryWhere"],
	and?: Array<GraphQLTypes["BrandFlavorWhere"] | undefined>,
	or?: Array<GraphQLTypes["BrandFlavorWhere"] | undefined>,
	not?: GraphQLTypes["BrandFlavorWhere"]
};
	["TOPXBrandWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	orderType?: GraphQLTypes["TOPXBrandOrderTypeCondition"],
	brand?: GraphQLTypes["BrandWhere"],
	category?: GraphQLTypes["TOPXBrandCategoryWhere"],
	and?: Array<GraphQLTypes["TOPXBrandWhere"] | undefined>,
	or?: Array<GraphQLTypes["TOPXBrandWhere"] | undefined>,
	not?: GraphQLTypes["TOPXBrandWhere"]
};
	["TOPXBrandOrderTypeCondition"]: {
		and?: Array<GraphQLTypes["TOPXBrandOrderTypeCondition"]>,
	or?: Array<GraphQLTypes["TOPXBrandOrderTypeCondition"]>,
	not?: GraphQLTypes["TOPXBrandOrderTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["TOPXBrandOrderType"],
	notEq?: GraphQLTypes["TOPXBrandOrderType"],
	in?: Array<GraphQLTypes["TOPXBrandOrderType"]>,
	notIn?: Array<GraphQLTypes["TOPXBrandOrderType"]>,
	lt?: GraphQLTypes["TOPXBrandOrderType"],
	lte?: GraphQLTypes["TOPXBrandOrderType"],
	gt?: GraphQLTypes["TOPXBrandOrderType"],
	gte?: GraphQLTypes["TOPXBrandOrderType"]
};
	["TOPXBrandOrderType"]: TOPXBrandOrderType;
	["TOPXBrandCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	brands?: GraphQLTypes["TOPXBrandWhere"],
	and?: Array<GraphQLTypes["TOPXBrandCategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["TOPXBrandCategoryWhere"] | undefined>,
	not?: GraphQLTypes["TOPXBrandCategoryWhere"]
};
	["ProductLineAliasWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	name?: GraphQLTypes["StringCondition"],
	productLines?: GraphQLTypes["ProductLineWhere"],
	and?: Array<GraphQLTypes["ProductLineAliasWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductLineAliasWhere"] | undefined>,
	not?: GraphQLTypes["ProductLineAliasWhere"]
};
	["ProductLineFlavorWhere"]: {
		id?: GraphQLTypes["StringCondition"],
	itemSubCategory?: GraphQLTypes["ItemSubCategoryWhere"],
	productLine?: GraphQLTypes["ProductLineWhere"],
	and?: Array<GraphQLTypes["ProductLineFlavorWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductLineFlavorWhere"] | undefined>,
	not?: GraphQLTypes["ProductLineFlavorWhere"]
};
	["DogActivityWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	label?: GraphQLTypes["StringCondition"],
	dogs?: GraphQLTypes["DogWhere"],
	products?: GraphQLTypes["ProductWhere"],
	dailyEnergyRequirementCoeficient?: GraphQLTypes["FloatCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	suitabilityCategory?: GraphQLTypes["SuitabilityCategoryWhere"],
	and?: Array<GraphQLTypes["DogActivityWhere"] | undefined>,
	or?: Array<GraphQLTypes["DogActivityWhere"] | undefined>,
	not?: GraphQLTypes["DogActivityWhere"]
};
	["ProductAliasWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	name?: GraphQLTypes["StringCondition"],
	product?: GraphQLTypes["ProductWhere"],
	and?: Array<GraphQLTypes["ProductAliasWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductAliasWhere"] | undefined>,
	not?: GraphQLTypes["ProductAliasWhere"]
};
	["ContentAmountCondition"]: {
		and?: Array<GraphQLTypes["ContentAmountCondition"]>,
	or?: Array<GraphQLTypes["ContentAmountCondition"]>,
	not?: GraphQLTypes["ContentAmountCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentAmount"],
	notEq?: GraphQLTypes["ContentAmount"],
	in?: Array<GraphQLTypes["ContentAmount"]>,
	notIn?: Array<GraphQLTypes["ContentAmount"]>,
	lt?: GraphQLTypes["ContentAmount"],
	lte?: GraphQLTypes["ContentAmount"],
	gt?: GraphQLTypes["ContentAmount"],
	gte?: GraphQLTypes["ContentAmount"]
};
	["ContentAmount"]: ContentAmount;
	["ProductEvaluationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	nazev?: GraphQLTypes["StringCondition"],
	vetDieta?: GraphQLTypes["StringCondition"],
	vetDieta1?: GraphQLTypes["StringCondition"],
	vetDieta2?: GraphQLTypes["StringCondition"],
	aktivita?: GraphQLTypes["StringCondition"],
	vek?: GraphQLTypes["StringCondition"],
	velikostPlemen?: GraphQLTypes["StringCondition"],
	hmotnostPlemene?: GraphQLTypes["StringCondition"],
	velikostGranuli?: GraphQLTypes["StringCondition"],
	velikostGranuliText?: GraphQLTypes["StringCondition"],
	doporucenaAktivitaDleMe?: GraphQLTypes["StringCondition"],
	vypocitanaMeVsMeVyrobce?: GraphQLTypes["StringCondition"],
	vypocitanaMeVsMeVyrobce2?: GraphQLTypes["StringCondition"],
	masoNaPrvnimMisteText?: GraphQLTypes["StringCondition"],
	zdrojeZivocisnychBilkovinDle1Vyskytu?: GraphQLTypes["StringCondition"],
	prichuteSeznam?: GraphQLTypes["StringCondition"],
	eliminacniDietaTextInterpunkce?: GraphQLTypes["StringCondition"],
	alergenyZadneNeobsahuje?: GraphQLTypes["StringCondition"],
	alergenyObsahuje?: GraphQLTypes["StringCondition"],
	alergenyNejakeNeobsahuje?: GraphQLTypes["StringCondition"],
	prospesneDruhyInterpunkce?: GraphQLTypes["StringCondition"],
	nevhodneDruhy?: GraphQLTypes["StringCondition"],
	kladneUcinkyCeleTelo?: GraphQLTypes["StringCondition"],
	kladneUcinkyHlava?: GraphQLTypes["StringCondition"],
	kladneUcinkyHrudnik?: GraphQLTypes["StringCondition"],
	kladneUcinkyBricho?: GraphQLTypes["StringCondition"],
	kladneUcinkySpodniCast?: GraphQLTypes["StringCondition"],
	zaporneUcinkyCeleTelo?: GraphQLTypes["StringCondition"],
	zaporneUcinkyHlava?: GraphQLTypes["StringCondition"],
	zaporneUcinkyHrudnik?: GraphQLTypes["StringCondition"],
	zaporneUcinkyBricho?: GraphQLTypes["StringCondition"],
	zaporneUcinkySpodniCast?: GraphQLTypes["StringCondition"],
	dsneuvedeno?: GraphQLTypes["StringCondition"],
	dsmalo?: GraphQLTypes["StringCondition"],
	dsprilis?: GraphQLTypes["StringCondition"],
	dsok?: GraphQLTypes["StringCondition"],
	d95malo?: GraphQLTypes["StringCondition"],
	d95prilis?: GraphQLTypes["StringCondition"],
	d95ok?: GraphQLTypes["StringCondition"],
	d110malo?: GraphQLTypes["StringCondition"],
	d110prilis?: GraphQLTypes["StringCondition"],
	d110ok?: GraphQLTypes["StringCondition"],
	sdo14reproMalo?: GraphQLTypes["StringCondition"],
	sdo14reproPrilis?: GraphQLTypes["StringCondition"],
	sdo14reproOk?: GraphQLTypes["StringCondition"],
	sdo15malo?: GraphQLTypes["StringCondition"],
	sdo15prilis?: GraphQLTypes["StringCondition"],
	sdo15ok?: GraphQLTypes["StringCondition"],
	s15malo?: GraphQLTypes["StringCondition"],
	s15prilis?: GraphQLTypes["StringCondition"],
	s15ok?: GraphQLTypes["StringCondition"],
	product?: GraphQLTypes["ProductWhere"],
	masoAnoNe?: GraphQLTypes["StringCondition"],
	eliminacniDietaAnoNe?: GraphQLTypes["StringCondition"],
	alergenyAnoNe?: GraphQLTypes["StringCondition"],
	plodnostKastraceNadpis?: GraphQLTypes["StringCondition"],
	plodnostKastraceText?: GraphQLTypes["StringCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	stravitelnostNadpis?: GraphQLTypes["StringCondition"],
	stravitelnostProcenta?: GraphQLTypes["StringCondition"],
	stravitelnostSlovne?: GraphQLTypes["StringCondition"],
	stravitelnostChybiText?: GraphQLTypes["StringCondition"],
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ProductEvaluationWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductEvaluationWhere"] | undefined>,
	not?: GraphQLTypes["ProductEvaluationWhere"]
};
	["ProductItemDeclensionFourthCategoryWhere"]: {
		id?: GraphQLTypes["StringCondition"],
	declensionFourthCategory?: GraphQLTypes["ItemDeclensionFourthVariantWhere"],
	product?: GraphQLTypes["ProductWhere"],
	and?: Array<GraphQLTypes["ProductItemDeclensionFourthCategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductItemDeclensionFourthCategoryWhere"] | undefined>,
	not?: GraphQLTypes["ProductItemDeclensionFourthCategoryWhere"]
};
	["ItemDeclensionFourthVariantWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["ItemWhere"],
	label?: GraphQLTypes["StringCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	declensionSeventh?: GraphQLTypes["StringCondition"],
	isNegativ?: GraphQLTypes["BooleanCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	subcategory?: GraphQLTypes["ItemSubCategoryWhere"],
	category?: GraphQLTypes["ItemCategoryWhere"],
	element?: GraphQLTypes["ElementWhere"],
	products?: GraphQLTypes["ProductItemDeclensionFourthCategoryWhere"],
	slug?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentWhere"],
	draft?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["ItemDeclensionFourthVariantWhere"] | undefined>,
	or?: Array<GraphQLTypes["ItemDeclensionFourthVariantWhere"] | undefined>,
	not?: GraphQLTypes["ItemDeclensionFourthVariantWhere"]
};
	["TOPXProductWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	orderType?: GraphQLTypes["TOPXProductOrderTypeCondition"],
	product?: GraphQLTypes["ProductWhere"],
	category?: GraphQLTypes["TOPXProductCategoryWhere"],
	and?: Array<GraphQLTypes["TOPXProductWhere"] | undefined>,
	or?: Array<GraphQLTypes["TOPXProductWhere"] | undefined>,
	not?: GraphQLTypes["TOPXProductWhere"]
};
	["TOPXProductOrderTypeCondition"]: {
		and?: Array<GraphQLTypes["TOPXProductOrderTypeCondition"]>,
	or?: Array<GraphQLTypes["TOPXProductOrderTypeCondition"]>,
	not?: GraphQLTypes["TOPXProductOrderTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["TOPXProductOrderType"],
	notEq?: GraphQLTypes["TOPXProductOrderType"],
	in?: Array<GraphQLTypes["TOPXProductOrderType"]>,
	notIn?: Array<GraphQLTypes["TOPXProductOrderType"]>,
	lt?: GraphQLTypes["TOPXProductOrderType"],
	lte?: GraphQLTypes["TOPXProductOrderType"],
	gt?: GraphQLTypes["TOPXProductOrderType"],
	gte?: GraphQLTypes["TOPXProductOrderType"]
};
	["TOPXProductOrderType"]: TOPXProductOrderType;
	["TOPXProductCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	products?: GraphQLTypes["TOPXProductWhere"],
	and?: Array<GraphQLTypes["TOPXProductCategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["TOPXProductCategoryWhere"] | undefined>,
	not?: GraphQLTypes["TOPXProductCategoryWhere"]
};
	["SizeTypeCondition"]: {
		and?: Array<GraphQLTypes["SizeTypeCondition"]>,
	or?: Array<GraphQLTypes["SizeTypeCondition"]>,
	not?: GraphQLTypes["SizeTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["SizeType"],
	notEq?: GraphQLTypes["SizeType"],
	in?: Array<GraphQLTypes["SizeType"]>,
	notIn?: Array<GraphQLTypes["SizeType"]>,
	lt?: GraphQLTypes["SizeType"],
	lte?: GraphQLTypes["SizeType"],
	gt?: GraphQLTypes["SizeType"],
	gte?: GraphQLTypes["SizeType"]
};
	["SizeType"]: SizeType;
	["DogBodyTypeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	lead?: GraphQLTypes["StringCondition"],
	dogs?: GraphQLTypes["DogWhere"],
	order?: GraphQLTypes["IntCondition"],
	value?: GraphQLTypes["IntCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	category?: GraphQLTypes["DogBodyTypeCategoryWhere"],
	imageMain?: GraphQLTypes["ImageWhere"],
	imageFrom?: GraphQLTypes["ImageWhere"],
	imageTo?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["DogBodyTypeWhere"] | undefined>,
	or?: Array<GraphQLTypes["DogBodyTypeWhere"] | undefined>,
	not?: GraphQLTypes["DogBodyTypeWhere"]
};
	["DogBodyTypeCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	items?: GraphQLTypes["DogBodyTypeWhere"],
	remoteId?: GraphQLTypes["StringCondition"],
	imageMain?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["DogBodyTypeCategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["DogBodyTypeCategoryWhere"] | undefined>,
	not?: GraphQLTypes["DogBodyTypeCategoryWhere"]
};
	["DogReproductionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["DogReproductionTypeCondition"],
	breastfeedingPuppyCount?: GraphQLTypes["IntCondition"],
	pregnancy?: GraphQLTypes["PregnantPeriodTypeCondition"],
	dog?: GraphQLTypes["DogWhere"],
	breastfeedingCategory?: GraphQLTypes["BreastfeedingCategoryWhere"],
	and?: Array<GraphQLTypes["DogReproductionWhere"] | undefined>,
	or?: Array<GraphQLTypes["DogReproductionWhere"] | undefined>,
	not?: GraphQLTypes["DogReproductionWhere"]
};
	["DogReproductionTypeCondition"]: {
		and?: Array<GraphQLTypes["DogReproductionTypeCondition"]>,
	or?: Array<GraphQLTypes["DogReproductionTypeCondition"]>,
	not?: GraphQLTypes["DogReproductionTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["DogReproductionType"],
	notEq?: GraphQLTypes["DogReproductionType"],
	in?: Array<GraphQLTypes["DogReproductionType"]>,
	notIn?: Array<GraphQLTypes["DogReproductionType"]>,
	lt?: GraphQLTypes["DogReproductionType"],
	lte?: GraphQLTypes["DogReproductionType"],
	gt?: GraphQLTypes["DogReproductionType"],
	gte?: GraphQLTypes["DogReproductionType"]
};
	["DogReproductionType"]: DogReproductionType;
	["PregnantPeriodTypeCondition"]: {
		and?: Array<GraphQLTypes["PregnantPeriodTypeCondition"]>,
	or?: Array<GraphQLTypes["PregnantPeriodTypeCondition"]>,
	not?: GraphQLTypes["PregnantPeriodTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["PregnantPeriodType"],
	notEq?: GraphQLTypes["PregnantPeriodType"],
	in?: Array<GraphQLTypes["PregnantPeriodType"]>,
	notIn?: Array<GraphQLTypes["PregnantPeriodType"]>,
	lt?: GraphQLTypes["PregnantPeriodType"],
	lte?: GraphQLTypes["PregnantPeriodType"],
	gt?: GraphQLTypes["PregnantPeriodType"],
	gte?: GraphQLTypes["PregnantPeriodType"]
};
	["PregnantPeriodType"]: PregnantPeriodType;
	["BreastfeedingCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	week?: GraphQLTypes["IntCondition"],
	coeficient?: GraphQLTypes["FloatCondition"],
	dogs?: GraphQLTypes["DogReproductionWhere"],
	and?: Array<GraphQLTypes["BreastfeedingCategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["BreastfeedingCategoryWhere"] | undefined>,
	not?: GraphQLTypes["BreastfeedingCategoryWhere"]
};
	["VeterinaryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	user?: GraphQLTypes["UserWhere"],
	and?: Array<GraphQLTypes["VeterinaryWhere"] | undefined>,
	or?: Array<GraphQLTypes["VeterinaryWhere"] | undefined>,
	not?: GraphQLTypes["VeterinaryWhere"]
};
	["ContactFormMessageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	message?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	receivedAt?: GraphQLTypes["DateTimeCondition"],
	user?: GraphQLTypes["UserWhere"],
	isResolved?: GraphQLTypes["BooleanCondition"],
	url?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ContactFormMessageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContactFormMessageWhere"] | undefined>,
	not?: GraphQLTypes["ContactFormMessageWhere"]
};
	["BugReportWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	message?: GraphQLTypes["StringCondition"],
	receivedAt?: GraphQLTypes["DateTimeCondition"],
	isResolved?: GraphQLTypes["BooleanCondition"],
	user?: GraphQLTypes["UserWhere"],
	url?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["BugReportWhere"] | undefined>,
	or?: Array<GraphQLTypes["BugReportWhere"] | undefined>,
	not?: GraphQLTypes["BugReportWhere"]
};
	["ProtectedActionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["ProtectedActionTypeCondition"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	usedAt?: GraphQLTypes["DateTimeCondition"],
	expiresAt?: GraphQLTypes["DateTimeCondition"],
	publicKey?: GraphQLTypes["StringCondition"],
	secretHash?: GraphQLTypes["StringCondition"],
	verifyEmail?: GraphQLTypes["StringCondition"],
	createdMetadata?: GraphQLTypes["JsonCondition"],
	usedMetadata?: GraphQLTypes["JsonCondition"],
	user?: GraphQLTypes["UserWhere"],
	and?: Array<GraphQLTypes["ProtectedActionWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProtectedActionWhere"] | undefined>,
	not?: GraphQLTypes["ProtectedActionWhere"]
};
	["ProtectedActionTypeCondition"]: {
		and?: Array<GraphQLTypes["ProtectedActionTypeCondition"]>,
	or?: Array<GraphQLTypes["ProtectedActionTypeCondition"]>,
	not?: GraphQLTypes["ProtectedActionTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ProtectedActionType"],
	notEq?: GraphQLTypes["ProtectedActionType"],
	in?: Array<GraphQLTypes["ProtectedActionType"]>,
	notIn?: Array<GraphQLTypes["ProtectedActionType"]>,
	lt?: GraphQLTypes["ProtectedActionType"],
	lte?: GraphQLTypes["ProtectedActionType"],
	gt?: GraphQLTypes["ProtectedActionType"],
	gte?: GraphQLTypes["ProtectedActionType"]
};
	["ProtectedActionType"]: ProtectedActionType;
	["JsonCondition"]: {
		and?: Array<GraphQLTypes["JsonCondition"]>,
	or?: Array<GraphQLTypes["JsonCondition"]>,
	not?: GraphQLTypes["JsonCondition"],
	null?: boolean,
	isNull?: boolean
};
	["TenantPersonWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	identityId?: GraphQLTypes["UUIDCondition"],
	email?: GraphQLTypes["StringCondition"],
	roles?: GraphQLTypes["StringCondition"],
	user?: GraphQLTypes["UserWhere"],
	and?: Array<GraphQLTypes["TenantPersonWhere"] | undefined>,
	or?: Array<GraphQLTypes["TenantPersonWhere"] | undefined>,
	not?: GraphQLTypes["TenantPersonWhere"]
};
	["BlogPostReviewStatsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	total?: GraphQLTypes["IntCondition"],
	positive?: GraphQLTypes["IntCondition"],
	negative?: GraphQLTypes["IntCondition"],
	blogPostReview?: GraphQLTypes["BlogPostReviewWhere"],
	and?: Array<GraphQLTypes["BlogPostReviewStatsWhere"] | undefined>,
	or?: Array<GraphQLTypes["BlogPostReviewStatsWhere"] | undefined>,
	not?: GraphQLTypes["BlogPostReviewStatsWhere"]
};
	["ReferenceListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	references?: GraphQLTypes["ReferenceWhere"],
	and?: Array<GraphQLTypes["ReferenceListWhere"] | undefined>,
	or?: Array<GraphQLTypes["ReferenceListWhere"] | undefined>,
	not?: GraphQLTypes["ReferenceListWhere"]
};
	["ReferenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	text?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["ReferenceListWhere"],
	and?: Array<GraphQLTypes["ReferenceWhere"] | undefined>,
	or?: Array<GraphQLTypes["ReferenceWhere"] | undefined>,
	not?: GraphQLTypes["ReferenceWhere"]
};
	["ItemDeclensionSeventhVariantWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["ItemWhere"],
	label?: GraphQLTypes["StringCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ItemDeclensionSeventhVariantWhere"] | undefined>,
	or?: Array<GraphQLTypes["ItemDeclensionSeventhVariantWhere"] | undefined>,
	not?: GraphQLTypes["ItemDeclensionSeventhVariantWhere"]
};
	["ItemAliasWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	name?: GraphQLTypes["StringCondition"],
	item?: GraphQLTypes["ItemWhere"],
	and?: Array<GraphQLTypes["ItemAliasWhere"] | undefined>,
	or?: Array<GraphQLTypes["ItemAliasWhere"] | undefined>,
	not?: GraphQLTypes["ItemAliasWhere"]
};
	["ItemGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	name?: GraphQLTypes["StringCondition"],
	categories?: GraphQLTypes["ItemCategoryWhere"],
	and?: Array<GraphQLTypes["ItemGroupWhere"] | undefined>,
	or?: Array<GraphQLTypes["ItemGroupWhere"] | undefined>,
	not?: GraphQLTypes["ItemGroupWhere"]
};
	["RedirectOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	to?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	from?: GraphQLTypes["OrderDirection"],
	genericPage?: GraphQLTypes["GenericPageOrderBy"],
	itemCategory?: GraphQLTypes["ItemCategoryOrderBy"],
	brandsPage?: GraphQLTypes["BrandsPageOrderBy"],
	blogPage?: GraphQLTypes["BlogPageOrderBy"],
	contactPage?: GraphQLTypes["ContactPageOrderBy"],
	wizardPage?: GraphQLTypes["WizardPageOrderBy"],
	comparatorPage?: GraphQLTypes["ComparatorPageOrderBy"],
	blogPost?: GraphQLTypes["BlogPostOrderBy"]
};
	["OrderDirection"]: OrderDirection;
	["GenericPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	draft?: GraphQLTypes["ContentOrderBy"]
};
	["LinkableOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	genericPage?: GraphQLTypes["GenericPageOrderBy"]
};
	["SeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	description?: GraphQLTypes["OrderDirection"],
	ogTitle?: GraphQLTypes["OrderDirection"],
	ogDescription?: GraphQLTypes["OrderDirection"],
	ogImage?: GraphQLTypes["ImageOrderBy"],
	blogPage?: GraphQLTypes["BlogPageOrderBy"],
	brandsPage?: GraphQLTypes["BrandsPageOrderBy"],
	comparatorPage?: GraphQLTypes["ComparatorPageOrderBy"],
	genericPage?: GraphQLTypes["GenericPageOrderBy"],
	homePage?: GraphQLTypes["HomePageOrderBy"],
	ingredientsPage?: GraphQLTypes["IngredientsPageOrderBy"],
	loginPage?: GraphQLTypes["LoginPageOrderBy"],
	registerPage?: GraphQLTypes["RegisterPageOrderBy"],
	searchPage?: GraphQLTypes["SearchPageOrderBy"],
	wizardPage?: GraphQLTypes["WizardPageOrderBy"],
	contactPage?: GraphQLTypes["ContactPageOrderBy"],
	group?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"]
};
	["ImageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	alt?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	hash?: GraphQLTypes["OrderDirection"]
};
	["BlogPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	draft?: GraphQLTypes["ContentOrderBy"]
};
	["ContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["BrandsPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	draft?: GraphQLTypes["ContentOrderBy"]
};
	["ComparatorPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["HomePageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["IngredientsPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	draft?: GraphQLTypes["ContentOrderBy"]
};
	["LoginPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["RegisterPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["SearchPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["WizardPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["ContactPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	draft?: GraphQLTypes["ContentOrderBy"]
};
	["ItemCategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	shortDescription?: GraphQLTypes["OrderDirection"],
	declensionSixth?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	comparatorGroupId?: GraphQLTypes["OrderDirection"],
	slug?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	group?: GraphQLTypes["ItemGroupOrderBy"],
	declensionSeventh?: GraphQLTypes["OrderDirection"],
	slugWith?: GraphQLTypes["OrderDirection"],
	slugWithNegative?: GraphQLTypes["OrderDirection"],
	declensionSeventhNegative?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"],
	draft?: GraphQLTypes["ContentOrderBy"]
};
	["ItemGroupOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"]
};
	["BlogPostOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	author?: GraphQLTypes["OrderDirection"],
	readingTime?: GraphQLTypes["OrderDirection"],
	publishedAt?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	listedOnHomePage?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	referenceList?: GraphQLTypes["ReferenceListOrderBy"],
	user?: GraphQLTypes["UserOrderBy"],
	isComparatorLinked?: GraphQLTypes["OrderDirection"],
	slug?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	createdAt?: GraphQLTypes["OrderDirection"],
	note?: GraphQLTypes["OrderDirection"],
	isActive?: GraphQLTypes["OrderDirection"],
	automated?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"],
	draft?: GraphQLTypes["ContentOrderBy"],
	slugInternal?: GraphQLTypes["OrderDirection"]
};
	["ReferenceListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["UserOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	veterinary?: GraphQLTypes["VeterinaryOrderBy"],
	email?: GraphQLTypes["OrderDirection"],
	tenantPersonId?: GraphQLTypes["OrderDirection"],
	fullName?: GraphQLTypes["OrderDirection"],
	createdAt?: GraphQLTypes["OrderDirection"],
	verifiedAt?: GraphQLTypes["OrderDirection"],
	avatar?: GraphQLTypes["ImageOrderBy"],
	verifiedEmail?: GraphQLTypes["OrderDirection"],
	blockedAt?: GraphQLTypes["OrderDirection"],
	tenantPerson?: GraphQLTypes["TenantPersonOrderBy"],
	note?: GraphQLTypes["OrderDirection"]
};
	["VeterinaryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	user?: GraphQLTypes["UserOrderBy"]
};
	["TenantPersonOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	identityId?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	roles?: GraphQLTypes["OrderDirection"],
	user?: GraphQLTypes["UserOrderBy"]
};
	["Seo"]: {
	__typename: "Seo",
	_meta?: GraphQLTypes["SeoMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["Image"],
	blogPage?: GraphQLTypes["BlogPage"],
	brandsPage?: GraphQLTypes["BrandsPage"],
	comparatorPage?: GraphQLTypes["ComparatorPage"],
	genericPage?: GraphQLTypes["GenericPage"],
	homePage?: GraphQLTypes["HomePage"],
	ingredientsPage?: GraphQLTypes["IngredientsPage"],
	loginPage?: GraphQLTypes["LoginPage"],
	registerPage?: GraphQLTypes["RegisterPage"],
	searchPage?: GraphQLTypes["SearchPage"],
	wizardPage?: GraphQLTypes["WizardPage"],
	contactPage?: GraphQLTypes["ContactPage"],
	group: GraphQLTypes["GroupType"],
	url?: string
};
	["SeoMeta"]: {
	__typename: "SeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	ogTitle?: GraphQLTypes["FieldMeta"],
	ogDescription?: GraphQLTypes["FieldMeta"],
	ogImage?: GraphQLTypes["FieldMeta"],
	blogPage?: GraphQLTypes["FieldMeta"],
	brandsPage?: GraphQLTypes["FieldMeta"],
	comparatorPage?: GraphQLTypes["FieldMeta"],
	genericPage?: GraphQLTypes["FieldMeta"],
	homePage?: GraphQLTypes["FieldMeta"],
	ingredientsPage?: GraphQLTypes["FieldMeta"],
	loginPage?: GraphQLTypes["FieldMeta"],
	registerPage?: GraphQLTypes["FieldMeta"],
	searchPage?: GraphQLTypes["FieldMeta"],
	wizardPage?: GraphQLTypes["FieldMeta"],
	contactPage?: GraphQLTypes["FieldMeta"],
	group?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"]
};
	["Image"]: {
	__typename: "Image",
	_meta?: GraphQLTypes["ImageMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	remoteId?: string,
	hash?: string
};
	["ImageMeta"]: {
	__typename: "ImageMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	alt?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	hash?: GraphQLTypes["FieldMeta"]
};
	["BrandsPage"]: {
	__typename: "BrandsPage",
	_meta?: GraphQLTypes["BrandsPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	title?: string,
	redirects: Array<GraphQLTypes["Redirect"]>,
	seo?: GraphQLTypes["Seo"],
	content?: GraphQLTypes["Content"],
	draft?: GraphQLTypes["Content"],
	redirectsByFrom?: GraphQLTypes["Redirect"],
	paginateRedirects: GraphQLTypes["RedirectConnection"]
};
	["BrandsPageMeta"]: {
	__typename: "BrandsPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	redirects?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	draft?: GraphQLTypes["FieldMeta"]
};
	["Content"]: {
	__typename: "Content",
	_meta?: GraphQLTypes["ContentMeta"],
	id: GraphQLTypes["UUID"],
	blocks: Array<GraphQLTypes["ContentBlock"]>,
	blocksByAutomatedContentBlockSlug?: GraphQLTypes["ContentBlock"],
	blocksByReferences?: GraphQLTypes["ContentBlock"],
	paginateBlocks: GraphQLTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
	__typename: "ContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	blocks?: GraphQLTypes["FieldMeta"]
};
	["ContentBlock"]: {
	__typename: "ContentBlock",
	_meta?: GraphQLTypes["ContentBlockMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["Content"],
	references: Array<GraphQLTypes["ContentReference"]>,
	automatedContentBlockSlug?: string,
	referencesByImages?: GraphQLTypes["ContentReference"],
	referencesByLink?: GraphQLTypes["ContentReference"],
	referencesByList?: GraphQLTypes["ContentReference"],
	referencesByOutline?: GraphQLTypes["ContentReference"],
	referencesByVideo?: GraphQLTypes["ContentReference"],
	referencesByImage?: GraphQLTypes["ContentReference"],
	paginateReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
	__typename: "ContentBlockMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	json?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	references?: GraphQLTypes["FieldMeta"],
	automatedContentBlockSlug?: GraphQLTypes["FieldMeta"]
};
	["ContentReference"]: {
	__typename: "ContentReference",
	_meta?: GraphQLTypes["ContentReferenceMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentBlock"],
	primaryText?: string,
	secondaryText?: string,
	fact?: string,
	images: Array<GraphQLTypes["ContentReferenceGalleryImage"]>,
	relatedBlogPost?: GraphQLTypes["BlogPost"],
	relatedBrand?: GraphQLTypes["Brand"],
	relatedProduct?: GraphQLTypes["Product"],
	relatedIngredient?: GraphQLTypes["Item"],
	link?: GraphQLTypes["Link"],
	badge?: string,
	longVersion?: boolean,
	relatedBrandFull?: GraphQLTypes["Brand"],
	relatedProductFull?: GraphQLTypes["Product"],
	list: Array<GraphQLTypes["ContentReferenceList"]>,
	outline?: GraphQLTypes["ContentLinks"],
	video?: GraphQLTypes["Video"],
	image?: GraphQLTypes["ContentReferenceImage"],
	defaultOpen?: boolean,
	badgeColor?: string,
	isMain?: boolean,
	ad?: GraphQLTypes["Ad"],
	paginateImages: GraphQLTypes["ContentReferenceGalleryImageConnection"],
	paginateList: GraphQLTypes["ContentReferenceListConnection"]
};
	["ContentReferenceMeta"]: {
	__typename: "ContentReferenceMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	block?: GraphQLTypes["FieldMeta"],
	primaryText?: GraphQLTypes["FieldMeta"],
	secondaryText?: GraphQLTypes["FieldMeta"],
	fact?: GraphQLTypes["FieldMeta"],
	images?: GraphQLTypes["FieldMeta"],
	relatedBlogPost?: GraphQLTypes["FieldMeta"],
	relatedBrand?: GraphQLTypes["FieldMeta"],
	relatedProduct?: GraphQLTypes["FieldMeta"],
	relatedIngredient?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	badge?: GraphQLTypes["FieldMeta"],
	longVersion?: GraphQLTypes["FieldMeta"],
	relatedBrandFull?: GraphQLTypes["FieldMeta"],
	relatedProductFull?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	outline?: GraphQLTypes["FieldMeta"],
	video?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	defaultOpen?: GraphQLTypes["FieldMeta"],
	badgeColor?: GraphQLTypes["FieldMeta"],
	isMain?: GraphQLTypes["FieldMeta"],
	ad?: GraphQLTypes["FieldMeta"]
};
	["ContentReferenceGalleryImage"]: {
	__typename: "ContentReferenceGalleryImage",
	_meta?: GraphQLTypes["ContentReferenceGalleryImageMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	reference?: GraphQLTypes["ContentReference"],
	image?: GraphQLTypes["Image"],
	lead?: string,
	alignment?: GraphQLTypes["AlignmentType"]
};
	["ContentReferenceGalleryImageMeta"]: {
	__typename: "ContentReferenceGalleryImageMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	reference?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	alignment?: GraphQLTypes["FieldMeta"]
};
	["ContentReferenceGalleryImageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	reference?: GraphQLTypes["ContentReferenceOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"],
	lead?: GraphQLTypes["OrderDirection"],
	alignment?: GraphQLTypes["OrderDirection"]
};
	["ContentReferenceOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	block?: GraphQLTypes["ContentBlockOrderBy"],
	primaryText?: GraphQLTypes["OrderDirection"],
	secondaryText?: GraphQLTypes["OrderDirection"],
	fact?: GraphQLTypes["OrderDirection"],
	relatedBlogPost?: GraphQLTypes["BlogPostOrderBy"],
	relatedBrand?: GraphQLTypes["BrandOrderBy"],
	relatedProduct?: GraphQLTypes["ProductOrderBy"],
	relatedIngredient?: GraphQLTypes["ItemOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"],
	badge?: GraphQLTypes["OrderDirection"],
	longVersion?: GraphQLTypes["OrderDirection"],
	relatedBrandFull?: GraphQLTypes["BrandOrderBy"],
	relatedProductFull?: GraphQLTypes["ProductOrderBy"],
	outline?: GraphQLTypes["ContentLinksOrderBy"],
	video?: GraphQLTypes["VideoOrderBy"],
	image?: GraphQLTypes["ContentReferenceImageOrderBy"],
	defaultOpen?: GraphQLTypes["OrderDirection"],
	badgeColor?: GraphQLTypes["OrderDirection"],
	isMain?: GraphQLTypes["OrderDirection"],
	ad?: GraphQLTypes["AdOrderBy"]
};
	["ContentBlockOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	json?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"],
	automatedContentBlockSlug?: GraphQLTypes["OrderDirection"]
};
	["BrandOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	promotedOnSearchPlace?: GraphQLTypes["OrderDirection"],
	promotedOnBrandsPagePlace?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	logo?: GraphQLTypes["ImageOrderBy"],
	methodOfProduction?: GraphQLTypes["ProductionMethodOrderBy"],
	distributor?: GraphQLTypes["BrandDistributorOrderBy"],
	slug?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	customMetaDescription?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"],
	draft?: GraphQLTypes["ContentOrderBy"]
};
	["ProductionMethodOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"]
};
	["BrandDistributorOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"]
};
	["ProductOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	score?: GraphQLTypes["OrderDirection"],
	firstFiveItems?: GraphQLTypes["OrderDirection"],
	detailedComposition?: GraphQLTypes["OrderDirection"],
	guaranteedAnalysis?: GraphQLTypes["OrderDirection"],
	isVeterinaryDiet?: GraphQLTypes["OrderDirection"],
	isSearchVisible?: GraphQLTypes["OrderDirection"],
	isSuitableForEliminationDiet?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	productLine?: GraphQLTypes["ProductLineOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"],
	recommendedActivity?: GraphQLTypes["DogActivityOrderBy"],
	brand?: GraphQLTypes["BrandOrderBy"],
	metabolizedEnergy?: GraphQLTypes["OrderDirection"],
	cheapnessValue?: GraphQLTypes["OrderDirection"],
	slug?: GraphQLTypes["OrderDirection"],
	animalProteinStatus?: GraphQLTypes["OrderDirection"],
	carbohydrateStatus?: GraphQLTypes["OrderDirection"],
	evaluation?: GraphQLTypes["ProductEvaluationOrderBy"],
	missingComposition?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	czkPerMetabolizedEnergy?: GraphQLTypes["OrderDirection"],
	customMetaTitle?: GraphQLTypes["OrderDirection"],
	customMetaDescription?: GraphQLTypes["OrderDirection"],
	isSuitableForCastrated?: GraphQLTypes["OrderDirection"],
	heurekaImage?: GraphQLTypes["ImageOrderBy"]
};
	["ProductLineOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	brand?: GraphQLTypes["BrandOrderBy"],
	logo?: GraphQLTypes["ImageOrderBy"],
	slug?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	customMetaDescription?: GraphQLTypes["OrderDirection"]
};
	["DogActivityOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	dailyEnergyRequirementCoeficient?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	suitabilityCategory?: GraphQLTypes["SuitabilityCategoryOrderBy"]
};
	["SuitabilityCategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	isPregnant?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	isBreastfeeding?: GraphQLTypes["OrderDirection"]
};
	["ProductEvaluationOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	nazev?: GraphQLTypes["OrderDirection"],
	vetDieta?: GraphQLTypes["OrderDirection"],
	vetDieta1?: GraphQLTypes["OrderDirection"],
	vetDieta2?: GraphQLTypes["OrderDirection"],
	aktivita?: GraphQLTypes["OrderDirection"],
	vek?: GraphQLTypes["OrderDirection"],
	velikostPlemen?: GraphQLTypes["OrderDirection"],
	hmotnostPlemene?: GraphQLTypes["OrderDirection"],
	velikostGranuli?: GraphQLTypes["OrderDirection"],
	velikostGranuliText?: GraphQLTypes["OrderDirection"],
	doporucenaAktivitaDleMe?: GraphQLTypes["OrderDirection"],
	vypocitanaMeVsMeVyrobce?: GraphQLTypes["OrderDirection"],
	vypocitanaMeVsMeVyrobce2?: GraphQLTypes["OrderDirection"],
	masoNaPrvnimMisteText?: GraphQLTypes["OrderDirection"],
	zdrojeZivocisnychBilkovinDle1Vyskytu?: GraphQLTypes["OrderDirection"],
	prichuteSeznam?: GraphQLTypes["OrderDirection"],
	eliminacniDietaTextInterpunkce?: GraphQLTypes["OrderDirection"],
	alergenyZadneNeobsahuje?: GraphQLTypes["OrderDirection"],
	alergenyObsahuje?: GraphQLTypes["OrderDirection"],
	alergenyNejakeNeobsahuje?: GraphQLTypes["OrderDirection"],
	prospesneDruhyInterpunkce?: GraphQLTypes["OrderDirection"],
	nevhodneDruhy?: GraphQLTypes["OrderDirection"],
	kladneUcinkyCeleTelo?: GraphQLTypes["OrderDirection"],
	kladneUcinkyHlava?: GraphQLTypes["OrderDirection"],
	kladneUcinkyHrudnik?: GraphQLTypes["OrderDirection"],
	kladneUcinkyBricho?: GraphQLTypes["OrderDirection"],
	kladneUcinkySpodniCast?: GraphQLTypes["OrderDirection"],
	zaporneUcinkyCeleTelo?: GraphQLTypes["OrderDirection"],
	zaporneUcinkyHlava?: GraphQLTypes["OrderDirection"],
	zaporneUcinkyHrudnik?: GraphQLTypes["OrderDirection"],
	zaporneUcinkyBricho?: GraphQLTypes["OrderDirection"],
	zaporneUcinkySpodniCast?: GraphQLTypes["OrderDirection"],
	dsneuvedeno?: GraphQLTypes["OrderDirection"],
	dsmalo?: GraphQLTypes["OrderDirection"],
	dsprilis?: GraphQLTypes["OrderDirection"],
	dsok?: GraphQLTypes["OrderDirection"],
	d95malo?: GraphQLTypes["OrderDirection"],
	d95prilis?: GraphQLTypes["OrderDirection"],
	d95ok?: GraphQLTypes["OrderDirection"],
	d110malo?: GraphQLTypes["OrderDirection"],
	d110prilis?: GraphQLTypes["OrderDirection"],
	d110ok?: GraphQLTypes["OrderDirection"],
	sdo14reproMalo?: GraphQLTypes["OrderDirection"],
	sdo14reproPrilis?: GraphQLTypes["OrderDirection"],
	sdo14reproOk?: GraphQLTypes["OrderDirection"],
	sdo15malo?: GraphQLTypes["OrderDirection"],
	sdo15prilis?: GraphQLTypes["OrderDirection"],
	sdo15ok?: GraphQLTypes["OrderDirection"],
	s15malo?: GraphQLTypes["OrderDirection"],
	s15prilis?: GraphQLTypes["OrderDirection"],
	s15ok?: GraphQLTypes["OrderDirection"],
	product?: GraphQLTypes["ProductOrderBy"],
	masoAnoNe?: GraphQLTypes["OrderDirection"],
	eliminacniDietaAnoNe?: GraphQLTypes["OrderDirection"],
	alergenyAnoNe?: GraphQLTypes["OrderDirection"],
	plodnostKastraceNadpis?: GraphQLTypes["OrderDirection"],
	plodnostKastraceText?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	stravitelnostNadpis?: GraphQLTypes["OrderDirection"],
	stravitelnostProcenta?: GraphQLTypes["OrderDirection"],
	stravitelnostSlovne?: GraphQLTypes["OrderDirection"],
	stravitelnostChybiText?: GraphQLTypes["OrderDirection"],
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?: GraphQLTypes["OrderDirection"]
};
	["ItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	animalProteinStatus?: GraphQLTypes["OrderDirection"],
	carbohydrateStatus?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	referenceList?: GraphQLTypes["ReferenceListOrderBy"],
	blogPost?: GraphQLTypes["BlogPostOrderBy"],
	declensionFourth?: GraphQLTypes["ItemDeclensionFourthVariantOrderBy"],
	declensionSeventh?: GraphQLTypes["ItemDeclensionSeventhVariantOrderBy"],
	slug?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	draft?: GraphQLTypes["ContentOrderBy"]
};
	["ItemDeclensionFourthVariantOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	declensionSeventh?: GraphQLTypes["OrderDirection"],
	isNegativ?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	subcategory?: GraphQLTypes["ItemSubCategoryOrderBy"],
	category?: GraphQLTypes["ItemCategoryOrderBy"],
	element?: GraphQLTypes["ElementOrderBy"],
	slug?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"],
	draft?: GraphQLTypes["ContentOrderBy"]
};
	["ItemSubCategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	isFlavorCategory?: GraphQLTypes["OrderDirection"],
	isAllergenTag?: GraphQLTypes["OrderDirection"],
	isMostCommonAllergenTag?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	category?: GraphQLTypes["ItemCategoryOrderBy"],
	flavorCategory?: GraphQLTypes["ItemFlavorCategoryOrderBy"],
	iconNegative?: GraphQLTypes["ImageOrderBy"],
	negativeWording?: GraphQLTypes["OrderDirection"],
	icon?: GraphQLTypes["ImageOrderBy"],
	slug?: GraphQLTypes["OrderDirection"],
	flavorSlug?: GraphQLTypes["OrderDirection"],
	flavorDeclensionSeventh?: GraphQLTypes["OrderDirection"],
	isFilterFlavor?: GraphQLTypes["OrderDirection"]
};
	["ItemFlavorCategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	color?: GraphQLTypes["ColorOrderBy"]
};
	["ColorOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	colorHex?: GraphQLTypes["OrderDirection"],
	bodyTagCategory?: GraphQLTypes["BodyTagCategoryOrderBy"],
	blogPostTag?: GraphQLTypes["BlogPostTagOrderBy"],
	remoteId?: GraphQLTypes["OrderDirection"]
};
	["BodyTagCategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	color?: GraphQLTypes["ColorOrderBy"]
};
	["BlogPostTagOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	color?: GraphQLTypes["ColorOrderBy"],
	order?: GraphQLTypes["OrderDirection"]
};
	["ElementOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	unit?: GraphQLTypes["OrderDirection"],
	filterOrder?: GraphQLTypes["OrderDirection"],
	slug?: GraphQLTypes["OrderDirection"],
	declensionSeventh?: GraphQLTypes["OrderDirection"]
};
	["ItemDeclensionSeventhVariantOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"]
};
	["LinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	externalLink?: GraphQLTypes["OrderDirection"],
	isTargetBlank?: GraphQLTypes["OrderDirection"]
};
	["ContentLinksOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["VideoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	src?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	duration?: GraphQLTypes["OrderDirection"],
	poster?: GraphQLTypes["ImageOrderBy"]
};
	["ContentReferenceImageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	alignment?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	link?: GraphQLTypes["OrderDirection"],
	targetBlank?: GraphQLTypes["OrderDirection"]
};
	["AdOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	isBrandSectionVisible?: GraphQLTypes["OrderDirection"],
	isBlogPostSectionVisible?: GraphQLTypes["OrderDirection"],
	isIngredientSectionVisible?: GraphQLTypes["OrderDirection"],
	isResultsVisible?: GraphQLTypes["OrderDirection"],
	isSearchVisible?: GraphQLTypes["OrderDirection"],
	isActive?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["OrderDirection"],
	note?: GraphQLTypes["OrderDirection"],
	activeFrom?: GraphQLTypes["OrderDirection"],
	activeUntil?: GraphQLTypes["OrderDirection"],
	slug?: GraphQLTypes["OrderDirection"]
};
	["BlogPost"]: {
	__typename: "BlogPost",
	_meta?: GraphQLTypes["BlogPostMeta"],
	id: GraphQLTypes["UUID"],
	author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags: Array<GraphQLTypes["BlogPostTag"]>,
	tags: Array<GraphQLTypes["BodyTag"]>,
	title: string,
	listedOnHomePage: boolean,
	reviews: Array<GraphQLTypes["BlogPostReview"]>,
	itemCategories: Array<GraphQLTypes["ItemCategory"]>,
	items: Array<GraphQLTypes["Item"]>,
	image?: GraphQLTypes["Image"],
	referenceList?: GraphQLTypes["ReferenceList"],
	user?: GraphQLTypes["User"],
	isComparatorLinked?: boolean,
	ads: Array<GraphQLTypes["Ad"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["Seo"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive: boolean,
	redirects: Array<GraphQLTypes["Redirect"]>,
	automated: boolean,
	content?: GraphQLTypes["Content"],
	draft?: GraphQLTypes["Content"],
	slugInternal?: string,
	reviewsByBlogPostReviewReactions?: GraphQLTypes["BlogPostReview"],
	reviewsByStats?: GraphQLTypes["BlogPostReview"],
	itemsByRemoteId?: GraphQLTypes["Item"],
	itemsBySlug?: GraphQLTypes["Item"],
	itemsByFeaturesOfProduct?: GraphQLTypes["Item"],
	itemsByImage?: GraphQLTypes["Item"],
	itemsByReferenceList?: GraphQLTypes["Item"],
	itemsBySeo?: GraphQLTypes["Item"],
	itemsByAliases?: GraphQLTypes["Item"],
	itemsByContent?: GraphQLTypes["Item"],
	itemsByDraft?: GraphQLTypes["Item"],
	redirectsByFrom?: GraphQLTypes["Redirect"],
	paginateBlogPostTags: GraphQLTypes["BlogPostTagConnection"],
	paginateTags: GraphQLTypes["BodyTagConnection"],
	paginateReviews: GraphQLTypes["BlogPostReviewConnection"],
	paginateItemCategories: GraphQLTypes["ItemCategoryConnection"],
	paginateItems: GraphQLTypes["ItemConnection"],
	paginateAds: GraphQLTypes["AdConnection"],
	paginateRedirects: GraphQLTypes["RedirectConnection"]
};
	["BlogPostMeta"]: {
	__typename: "BlogPostMeta",
	id?: GraphQLTypes["FieldMeta"],
	author?: GraphQLTypes["FieldMeta"],
	readingTime?: GraphQLTypes["FieldMeta"],
	publishedAt?: GraphQLTypes["FieldMeta"],
	blogPostTags?: GraphQLTypes["FieldMeta"],
	tags?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	listedOnHomePage?: GraphQLTypes["FieldMeta"],
	reviews?: GraphQLTypes["FieldMeta"],
	itemCategories?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	referenceList?: GraphQLTypes["FieldMeta"],
	user?: GraphQLTypes["FieldMeta"],
	isComparatorLinked?: GraphQLTypes["FieldMeta"],
	ads?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"],
	note?: GraphQLTypes["FieldMeta"],
	isActive?: GraphQLTypes["FieldMeta"],
	redirects?: GraphQLTypes["FieldMeta"],
	automated?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	draft?: GraphQLTypes["FieldMeta"],
	slugInternal?: GraphQLTypes["FieldMeta"]
};
	["BlogPostTag"]: {
	__typename: "BlogPostTag",
	_meta?: GraphQLTypes["BlogPostTagMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	blogPosts: Array<GraphQLTypes["BlogPost"]>,
	remoteId: string,
	color?: GraphQLTypes["Color"],
	order?: number,
	paginateBlogPosts: GraphQLTypes["BlogPostConnection"]
};
	["BlogPostTagMeta"]: {
	__typename: "BlogPostTagMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	blogPosts?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	color?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"]
};
	["Color"]: {
	__typename: "Color",
	_meta?: GraphQLTypes["ColorMeta"],
	id: GraphQLTypes["UUID"],
	name?: string,
	colorHex?: string,
	bodyTagCategory?: GraphQLTypes["BodyTagCategory"],
	blogPostTag?: GraphQLTypes["BlogPostTag"],
	remoteId?: string,
	itemFlavorCategories: Array<GraphQLTypes["ItemFlavorCategory"]>,
	itemFlavorCategoriesByRemoteId?: GraphQLTypes["ItemFlavorCategory"],
	itemFlavorCategoriesByItems?: GraphQLTypes["ItemFlavorCategory"],
	paginateItemFlavorCategories: GraphQLTypes["ItemFlavorCategoryConnection"]
};
	["ColorMeta"]: {
	__typename: "ColorMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	colorHex?: GraphQLTypes["FieldMeta"],
	bodyTagCategory?: GraphQLTypes["FieldMeta"],
	blogPostTag?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	itemFlavorCategories?: GraphQLTypes["FieldMeta"]
};
	["BodyTagCategory"]: {
	__typename: "BodyTagCategory",
	_meta?: GraphQLTypes["BodyTagCategoryMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	tags: Array<GraphQLTypes["BodyTag"]>,
	remoteId: string,
	color?: GraphQLTypes["Color"],
	tagsByRemoteId?: GraphQLTypes["BodyTag"],
	tagsByFilterCombos?: GraphQLTypes["BodyTag"],
	paginateTags: GraphQLTypes["BodyTagConnection"]
};
	["BodyTagCategoryMeta"]: {
	__typename: "BodyTagCategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	tags?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	color?: GraphQLTypes["FieldMeta"]
};
	["BodyTag"]: {
	__typename: "BodyTag",
	_meta?: GraphQLTypes["BodyTagMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	blogPosts: Array<GraphQLTypes["BlogPost"]>,
	positiveProducts: Array<GraphQLTypes["Product"]>,
	negativeProducts: Array<GraphQLTypes["Product"]>,
	positiveItems: Array<GraphQLTypes["Item"]>,
	negativeItems: Array<GraphQLTypes["Item"]>,
	remoteId: string,
	category?: GraphQLTypes["BodyTagCategory"],
	icon?: GraphQLTypes["Image"],
	dogs: Array<GraphQLTypes["Dog"]>,
	labelFor?: string,
	slug?: string,
	filterCombos: Array<GraphQLTypes["FilterCombo"]>,
	filterCombosByRemoteId?: GraphQLTypes["FilterCombo"],
	filterCombosBySeo?: GraphQLTypes["FilterCombo"],
	paginateBlogPosts: GraphQLTypes["BlogPostConnection"],
	paginatePositiveProducts: GraphQLTypes["ProductConnection"],
	paginateNegativeProducts: GraphQLTypes["ProductConnection"],
	paginatePositiveItems: GraphQLTypes["ItemConnection"],
	paginateNegativeItems: GraphQLTypes["ItemConnection"],
	paginateDogs: GraphQLTypes["DogConnection"],
	paginateFilterCombos: GraphQLTypes["FilterComboConnection"]
};
	["BodyTagMeta"]: {
	__typename: "BodyTagMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	blogPosts?: GraphQLTypes["FieldMeta"],
	positiveProducts?: GraphQLTypes["FieldMeta"],
	negativeProducts?: GraphQLTypes["FieldMeta"],
	positiveItems?: GraphQLTypes["FieldMeta"],
	negativeItems?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	category?: GraphQLTypes["FieldMeta"],
	icon?: GraphQLTypes["FieldMeta"],
	dogs?: GraphQLTypes["FieldMeta"],
	labelFor?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	filterCombos?: GraphQLTypes["FieldMeta"]
};
	["Product"]: {
	__typename: "Product",
	_meta?: GraphQLTypes["ProductMeta"],
	id: GraphQLTypes["UUID"],
	nutritionalValues: Array<GraphQLTypes["NutritionalValueOfProduct"]>,
	name: string,
	positiveForBodyTags: Array<GraphQLTypes["BodyTag"]>,
	negativeForBodyTags: Array<GraphQLTypes["BodyTag"]>,
	reviews: Array<GraphQLTypes["ProductReview"]>,
	score?: number,
	dogs: Array<GraphQLTypes["Dog"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet: boolean,
	packagings: Array<GraphQLTypes["ProductPackage"]>,
	itemSubCategories: Array<GraphQLTypes["ItemSubCategory"]>,
	itemCategories: Array<GraphQLTypes["ItemCategory"]>,
	elements: Array<GraphQLTypes["ElementOfProduct"]>,
	isSearchVisible: boolean,
	isSuitableForEliminationDiet: boolean,
	remoteId: string,
	recommendedDogSizes: Array<GraphQLTypes["DogSize"]>,
	granuleSizes: Array<GraphQLTypes["GranuleSize"]>,
	productLine?: GraphQLTypes["ProductLine"],
	flags: Array<GraphQLTypes["ProductFlagOfProduct"]>,
	image?: GraphQLTypes["Image"],
	recommendedActivity?: GraphQLTypes["DogActivity"],
	brand?: GraphQLTypes["Brand"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases: Array<GraphQLTypes["ProductAlias"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductEvaluation"],
	missingComposition: boolean,
	seo?: GraphQLTypes["Seo"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories: Array<GraphQLTypes["ProductItemDeclensionFourthCategory"]>,
	ageCategories: Array<GraphQLTypes["AgeCategory"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated: boolean,
	heurekaImage?: GraphQLTypes["Image"],
	topx: Array<GraphQLTypes["TOPXProduct"]>,
	nutritionalValuesByRemoteId?: GraphQLTypes["NutritionalValueOfProduct"],
	reviewsByProductReviewReactions?: GraphQLTypes["ProductReview"],
	reviewsByStats?: GraphQLTypes["ProductReview"],
	dogsByReproduction?: GraphQLTypes["Dog"],
	dogsByAvatar?: GraphQLTypes["Dog"],
	packagingsByRemoteId?: GraphQLTypes["ProductPackage"],
	packagingsByPositionId?: GraphQLTypes["ProductPackage"],
	packagingsByExternalId?: GraphQLTypes["ProductPackage"],
	elementsByRemoteId?: GraphQLTypes["ElementOfProduct"],
	flagsByRemoteId?: GraphQLTypes["ProductFlagOfProduct"],
	aliasesByRemoteId?: GraphQLTypes["ProductAlias"],
	topxByRemoteId?: GraphQLTypes["TOPXProduct"],
	paginateNutritionalValues: GraphQLTypes["NutritionalValueOfProductConnection"],
	paginatePositiveForBodyTags: GraphQLTypes["BodyTagConnection"],
	paginateNegativeForBodyTags: GraphQLTypes["BodyTagConnection"],
	paginateReviews: GraphQLTypes["ProductReviewConnection"],
	paginateDogs: GraphQLTypes["DogConnection"],
	paginatePackagings: GraphQLTypes["ProductPackageConnection"],
	paginateItemSubCategories: GraphQLTypes["ItemSubCategoryConnection"],
	paginateItemCategories: GraphQLTypes["ItemCategoryConnection"],
	paginateElements: GraphQLTypes["ElementOfProductConnection"],
	paginateRecommendedDogSizes: GraphQLTypes["DogSizeConnection"],
	paginateGranuleSizes: GraphQLTypes["GranuleSizeConnection"],
	paginateFlags: GraphQLTypes["ProductFlagOfProductConnection"],
	paginateAliases: GraphQLTypes["ProductAliasConnection"],
	paginateItemDeclensionFourthCategories: GraphQLTypes["ProductItemDeclensionFourthCategoryConnection"],
	paginateAgeCategories: GraphQLTypes["AgeCategoryConnection"],
	paginateTopx: GraphQLTypes["TOPXProductConnection"]
};
	["ProductMeta"]: {
	__typename: "ProductMeta",
	id?: GraphQLTypes["FieldMeta"],
	nutritionalValues?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	positiveForBodyTags?: GraphQLTypes["FieldMeta"],
	negativeForBodyTags?: GraphQLTypes["FieldMeta"],
	reviews?: GraphQLTypes["FieldMeta"],
	score?: GraphQLTypes["FieldMeta"],
	dogs?: GraphQLTypes["FieldMeta"],
	firstFiveItems?: GraphQLTypes["FieldMeta"],
	detailedComposition?: GraphQLTypes["FieldMeta"],
	guaranteedAnalysis?: GraphQLTypes["FieldMeta"],
	isVeterinaryDiet?: GraphQLTypes["FieldMeta"],
	packagings?: GraphQLTypes["FieldMeta"],
	itemSubCategories?: GraphQLTypes["FieldMeta"],
	itemCategories?: GraphQLTypes["FieldMeta"],
	elements?: GraphQLTypes["FieldMeta"],
	isSearchVisible?: GraphQLTypes["FieldMeta"],
	isSuitableForEliminationDiet?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	recommendedDogSizes?: GraphQLTypes["FieldMeta"],
	granuleSizes?: GraphQLTypes["FieldMeta"],
	productLine?: GraphQLTypes["FieldMeta"],
	flags?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	recommendedActivity?: GraphQLTypes["FieldMeta"],
	brand?: GraphQLTypes["FieldMeta"],
	metabolizedEnergy?: GraphQLTypes["FieldMeta"],
	cheapnessValue?: GraphQLTypes["FieldMeta"],
	aliases?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	animalProteinStatus?: GraphQLTypes["FieldMeta"],
	carbohydrateStatus?: GraphQLTypes["FieldMeta"],
	evaluation?: GraphQLTypes["FieldMeta"],
	missingComposition?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	czkPerMetabolizedEnergy?: GraphQLTypes["FieldMeta"],
	itemDeclensionFourthCategories?: GraphQLTypes["FieldMeta"],
	ageCategories?: GraphQLTypes["FieldMeta"],
	customMetaTitle?: GraphQLTypes["FieldMeta"],
	customMetaDescription?: GraphQLTypes["FieldMeta"],
	isSuitableForCastrated?: GraphQLTypes["FieldMeta"],
	heurekaImage?: GraphQLTypes["FieldMeta"],
	topx?: GraphQLTypes["FieldMeta"]
};
	["NutritionalValueOfProduct"]: {
	__typename: "NutritionalValueOfProduct",
	_meta?: GraphQLTypes["NutritionalValueOfProductMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	product?: GraphQLTypes["Product"],
	amount?: number,
	remoteId: string,
	nutritionalValue?: GraphQLTypes["NutritionalValue"]
};
	["NutritionalValueOfProductMeta"]: {
	__typename: "NutritionalValueOfProductMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	product?: GraphQLTypes["FieldMeta"],
	amount?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	nutritionalValue?: GraphQLTypes["FieldMeta"]
};
	["NutritionalValue"]: {
	__typename: "NutritionalValue",
	_meta?: GraphQLTypes["NutritionalValueMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	products: Array<GraphQLTypes["NutritionalValueOfProduct"]>,
	suitabilityNutritionalValues: Array<GraphQLTypes["SuitabilityItem"]>,
	remoteId: string,
	icon?: GraphQLTypes["Image"],
	productsByRemoteId?: GraphQLTypes["NutritionalValueOfProduct"],
	suitabilityNutritionalValuesByRemoteId?: GraphQLTypes["SuitabilityItem"],
	paginateProducts: GraphQLTypes["NutritionalValueOfProductConnection"],
	paginateSuitabilityNutritionalValues: GraphQLTypes["SuitabilityItemConnection"]
};
	["NutritionalValueMeta"]: {
	__typename: "NutritionalValueMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	suitabilityNutritionalValues?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	icon?: GraphQLTypes["FieldMeta"]
};
	["NutritionalValueOfProductOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	product?: GraphQLTypes["ProductOrderBy"],
	amount?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	nutritionalValue?: GraphQLTypes["NutritionalValueOrderBy"]
};
	["NutritionalValueOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	icon?: GraphQLTypes["ImageOrderBy"]
};
	["SuitabilityItem"]: {
	__typename: "SuitabilityItem",
	_meta?: GraphQLTypes["SuitabilityItemMeta"],
	id: GraphQLTypes["UUID"],
	min?: number,
	max?: number,
	remoteId: string,
	order?: number,
	element?: GraphQLTypes["Element"],
	nutritionalValue?: GraphQLTypes["NutritionalValue"],
	category?: GraphQLTypes["SuitabilityCategory"]
};
	["SuitabilityItemMeta"]: {
	__typename: "SuitabilityItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	min?: GraphQLTypes["FieldMeta"],
	max?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	element?: GraphQLTypes["FieldMeta"],
	nutritionalValue?: GraphQLTypes["FieldMeta"],
	category?: GraphQLTypes["FieldMeta"]
};
	["Element"]: {
	__typename: "Element",
	_meta?: GraphQLTypes["ElementMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	products: Array<GraphQLTypes["ElementOfProduct"]>,
	featureDependencies: Array<GraphQLTypes["ProductFeature"]>,
	suitabilityElements: Array<GraphQLTypes["SuitabilityItem"]>,
	remoteId: string,
	unit?: string,
	filterOrder?: number,
	slug?: string,
	declensionSeventh?: string,
	productsByRemoteId?: GraphQLTypes["ElementOfProduct"],
	featureDependenciesByRemoteId?: GraphQLTypes["ProductFeature"],
	suitabilityElementsByRemoteId?: GraphQLTypes["SuitabilityItem"],
	paginateProducts: GraphQLTypes["ElementOfProductConnection"],
	paginateFeatureDependencies: GraphQLTypes["ProductFeatureConnection"],
	paginateSuitabilityElements: GraphQLTypes["SuitabilityItemConnection"]
};
	["ElementMeta"]: {
	__typename: "ElementMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	featureDependencies?: GraphQLTypes["FieldMeta"],
	suitabilityElements?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	unit?: GraphQLTypes["FieldMeta"],
	filterOrder?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	declensionSeventh?: GraphQLTypes["FieldMeta"]
};
	["ElementOfProduct"]: {
	__typename: "ElementOfProduct",
	_meta?: GraphQLTypes["ElementOfProductMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	amount?: number,
	product?: GraphQLTypes["Product"],
	remoteId: string,
	element?: GraphQLTypes["Element"]
};
	["ElementOfProductMeta"]: {
	__typename: "ElementOfProductMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	amount?: GraphQLTypes["FieldMeta"],
	product?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	element?: GraphQLTypes["FieldMeta"]
};
	["ElementOfProductOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	amount?: GraphQLTypes["OrderDirection"],
	product?: GraphQLTypes["ProductOrderBy"],
	remoteId?: GraphQLTypes["OrderDirection"],
	element?: GraphQLTypes["ElementOrderBy"]
};
	["ProductFeature"]: {
	__typename: "ProductFeature",
	_meta?: GraphQLTypes["ProductFeatureMeta"],
	id: GraphQLTypes["UUID"],
	text: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId: string,
	linkItem?: GraphQLTypes["Item"],
	dependentElement?: GraphQLTypes["Element"],
	dependentCategory?: GraphQLTypes["ItemCategory"],
	dependentSubCategory?: GraphQLTypes["ItemSubCategory"],
	dependentFlag?: GraphQLTypes["ProductFlag"]
};
	["ProductFeatureMeta"]: {
	__typename: "ProductFeatureMeta",
	id?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	category?: GraphQLTypes["FieldMeta"],
	value?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	linkItem?: GraphQLTypes["FieldMeta"],
	dependentElement?: GraphQLTypes["FieldMeta"],
	dependentCategory?: GraphQLTypes["FieldMeta"],
	dependentSubCategory?: GraphQLTypes["FieldMeta"],
	dependentFlag?: GraphQLTypes["FieldMeta"]
};
	["Item"]: {
	__typename: "Item",
	_meta?: GraphQLTypes["ItemMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	positiveForBodyTags: Array<GraphQLTypes["BodyTag"]>,
	negativeForBodyTags: Array<GraphQLTypes["BodyTag"]>,
	subCategories: Array<GraphQLTypes["ItemSubCategory"]>,
	categories: Array<GraphQLTypes["ItemCategory"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct: Array<GraphQLTypes["ProductFeature"]>,
	remoteId: string,
	image?: GraphQLTypes["Image"],
	referenceList?: GraphQLTypes["ReferenceList"],
	blogPost?: GraphQLTypes["BlogPost"],
	declensionFourth?: GraphQLTypes["ItemDeclensionFourthVariant"],
	declensionSeventh?: GraphQLTypes["ItemDeclensionSeventhVariant"],
	slug?: string,
	seo?: GraphQLTypes["Seo"],
	aliases: Array<GraphQLTypes["ItemAlias"]>,
	content?: GraphQLTypes["Content"],
	draft?: GraphQLTypes["Content"],
	featuresOfProductByRemoteId?: GraphQLTypes["ProductFeature"],
	aliasesByRemoteId?: GraphQLTypes["ItemAlias"],
	paginatePositiveForBodyTags: GraphQLTypes["BodyTagConnection"],
	paginateNegativeForBodyTags: GraphQLTypes["BodyTagConnection"],
	paginateSubCategories: GraphQLTypes["ItemSubCategoryConnection"],
	paginateCategories: GraphQLTypes["ItemCategoryConnection"],
	paginateFeaturesOfProduct: GraphQLTypes["ProductFeatureConnection"],
	paginateAliases: GraphQLTypes["ItemAliasConnection"]
};
	["ItemMeta"]: {
	__typename: "ItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	positiveForBodyTags?: GraphQLTypes["FieldMeta"],
	negativeForBodyTags?: GraphQLTypes["FieldMeta"],
	subCategories?: GraphQLTypes["FieldMeta"],
	categories?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	animalProteinStatus?: GraphQLTypes["FieldMeta"],
	carbohydrateStatus?: GraphQLTypes["FieldMeta"],
	featuresOfProduct?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	referenceList?: GraphQLTypes["FieldMeta"],
	blogPost?: GraphQLTypes["FieldMeta"],
	declensionFourth?: GraphQLTypes["FieldMeta"],
	declensionSeventh?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	aliases?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	draft?: GraphQLTypes["FieldMeta"]
};
	["BodyTagOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	category?: GraphQLTypes["BodyTagCategoryOrderBy"],
	icon?: GraphQLTypes["ImageOrderBy"],
	labelFor?: GraphQLTypes["OrderDirection"],
	slug?: GraphQLTypes["OrderDirection"]
};
	["ItemSubCategory"]: {
	__typename: "ItemSubCategory",
	_meta?: GraphQLTypes["ItemSubCategoryMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	items: Array<GraphQLTypes["Item"]>,
	isFlavorCategory: boolean,
	isAllergenTag: boolean,
	isMostCommonAllergenTag: boolean,
	products: Array<GraphQLTypes["Product"]>,
	featureDependencies: Array<GraphQLTypes["ProductFeature"]>,
	remoteId: string,
	category?: GraphQLTypes["ItemCategory"],
	flavorCategory?: GraphQLTypes["ItemFlavorCategory"],
	dogs: Array<GraphQLTypes["Dog"]>,
	iconNegative?: GraphQLTypes["Image"],
	negativeWording?: string,
	icon?: GraphQLTypes["Image"],
	brands: Array<GraphQLTypes["BrandFlavor"]>,
	productLines: Array<GraphQLTypes["ProductLineFlavor"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor: Array<GraphQLTypes["FilterCombo"]>,
	filterCombosAllergy: Array<GraphQLTypes["FilterCombo"]>,
	isFilterFlavor: boolean,
	featureDependenciesByRemoteId?: GraphQLTypes["ProductFeature"],
	filterCombosFlavorByRemoteId?: GraphQLTypes["FilterCombo"],
	filterCombosFlavorBySeo?: GraphQLTypes["FilterCombo"],
	filterCombosAllergyByRemoteId?: GraphQLTypes["FilterCombo"],
	filterCombosAllergyBySeo?: GraphQLTypes["FilterCombo"],
	paginateItems: GraphQLTypes["ItemConnection"],
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateFeatureDependencies: GraphQLTypes["ProductFeatureConnection"],
	paginateDogs: GraphQLTypes["DogConnection"],
	paginateBrands: GraphQLTypes["BrandFlavorConnection"],
	paginateProductLines: GraphQLTypes["ProductLineFlavorConnection"],
	paginateFilterCombosFlavor: GraphQLTypes["FilterComboConnection"],
	paginateFilterCombosAllergy: GraphQLTypes["FilterComboConnection"]
};
	["ItemSubCategoryMeta"]: {
	__typename: "ItemSubCategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	isFlavorCategory?: GraphQLTypes["FieldMeta"],
	isAllergenTag?: GraphQLTypes["FieldMeta"],
	isMostCommonAllergenTag?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	featureDependencies?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	category?: GraphQLTypes["FieldMeta"],
	flavorCategory?: GraphQLTypes["FieldMeta"],
	dogs?: GraphQLTypes["FieldMeta"],
	iconNegative?: GraphQLTypes["FieldMeta"],
	negativeWording?: GraphQLTypes["FieldMeta"],
	icon?: GraphQLTypes["FieldMeta"],
	brands?: GraphQLTypes["FieldMeta"],
	productLines?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	flavorSlug?: GraphQLTypes["FieldMeta"],
	flavorDeclensionSeventh?: GraphQLTypes["FieldMeta"],
	filterCombosFlavor?: GraphQLTypes["FieldMeta"],
	filterCombosAllergy?: GraphQLTypes["FieldMeta"],
	isFilterFlavor?: GraphQLTypes["FieldMeta"]
};
	["ProductFeatureOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	category?: GraphQLTypes["OrderDirection"],
	value?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	linkItem?: GraphQLTypes["ItemOrderBy"],
	dependentElement?: GraphQLTypes["ElementOrderBy"],
	dependentCategory?: GraphQLTypes["ItemCategoryOrderBy"],
	dependentSubCategory?: GraphQLTypes["ItemSubCategoryOrderBy"],
	dependentFlag?: GraphQLTypes["ProductFlagOrderBy"]
};
	["ProductFlagOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"]
};
	["ItemCategory"]: {
	__typename: "ItemCategory",
	_meta?: GraphQLTypes["ItemCategoryMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	shortDescription?: string,
	subCategories: Array<GraphQLTypes["ItemSubCategory"]>,
	blogPosts: Array<GraphQLTypes["BlogPost"]>,
	items: Array<GraphQLTypes["Item"]>,
	products: Array<GraphQLTypes["Product"]>,
	featureDependencies: Array<GraphQLTypes["ProductFeature"]>,
	declensionSixth?: string,
	remoteId: string,
	image?: GraphQLTypes["Image"],
	comparatorGroupId?: string,
	ads: Array<GraphQLTypes["Ad"]>,
	slug?: string,
	redirects: Array<GraphQLTypes["Redirect"]>,
	declensionsFourth: Array<GraphQLTypes["ItemDeclensionFourthVariant"]>,
	seo?: GraphQLTypes["Seo"],
	group?: GraphQLTypes["ItemGroup"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["Content"],
	draft?: GraphQLTypes["Content"],
	subCategoriesByRemoteId?: GraphQLTypes["ItemSubCategory"],
	subCategoriesBySlug?: GraphQLTypes["ItemSubCategory"],
	subCategoriesByFeatureDependencies?: GraphQLTypes["ItemSubCategory"],
	subCategoriesByBrands?: GraphQLTypes["ItemSubCategory"],
	subCategoriesByProductLines?: GraphQLTypes["ItemSubCategory"],
	subCategoriesByFilterCombosFlavor?: GraphQLTypes["ItemSubCategory"],
	subCategoriesByFilterCombosAllergy?: GraphQLTypes["ItemSubCategory"],
	featureDependenciesByRemoteId?: GraphQLTypes["ProductFeature"],
	redirectsByFrom?: GraphQLTypes["Redirect"],
	declensionsFourthByRemoteId?: GraphQLTypes["ItemDeclensionFourthVariant"],
	declensionsFourthBySlug?: GraphQLTypes["ItemDeclensionFourthVariant"],
	declensionsFourthByItems?: GraphQLTypes["ItemDeclensionFourthVariant"],
	declensionsFourthBySeo?: GraphQLTypes["ItemDeclensionFourthVariant"],
	declensionsFourthBySubcategory?: GraphQLTypes["ItemDeclensionFourthVariant"],
	declensionsFourthByElement?: GraphQLTypes["ItemDeclensionFourthVariant"],
	declensionsFourthByProducts?: GraphQLTypes["ItemDeclensionFourthVariant"],
	declensionsFourthByContent?: GraphQLTypes["ItemDeclensionFourthVariant"],
	declensionsFourthByDraft?: GraphQLTypes["ItemDeclensionFourthVariant"],
	paginateSubCategories: GraphQLTypes["ItemSubCategoryConnection"],
	paginateBlogPosts: GraphQLTypes["BlogPostConnection"],
	paginateItems: GraphQLTypes["ItemConnection"],
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateFeatureDependencies: GraphQLTypes["ProductFeatureConnection"],
	paginateAds: GraphQLTypes["AdConnection"],
	paginateRedirects: GraphQLTypes["RedirectConnection"],
	paginateDeclensionsFourth: GraphQLTypes["ItemDeclensionFourthVariantConnection"]
};
	["ItemCategoryMeta"]: {
	__typename: "ItemCategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	shortDescription?: GraphQLTypes["FieldMeta"],
	subCategories?: GraphQLTypes["FieldMeta"],
	blogPosts?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	featureDependencies?: GraphQLTypes["FieldMeta"],
	declensionSixth?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	comparatorGroupId?: GraphQLTypes["FieldMeta"],
	ads?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	redirects?: GraphQLTypes["FieldMeta"],
	declensionsFourth?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	group?: GraphQLTypes["FieldMeta"],
	declensionSeventh?: GraphQLTypes["FieldMeta"],
	slugWith?: GraphQLTypes["FieldMeta"],
	slugWithNegative?: GraphQLTypes["FieldMeta"],
	declensionSeventhNegative?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	draft?: GraphQLTypes["FieldMeta"]
};
	["Ad"]: {
	__typename: "Ad",
	_meta?: GraphQLTypes["AdMeta"],
	id: GraphQLTypes["UUID"],
	image?: GraphQLTypes["Image"],
	isBrandSectionVisible?: boolean,
	isBlogPostSectionVisible?: boolean,
	isIngredientSectionVisible?: boolean,
	isResultsVisible?: boolean,
	isSearchVisible?: boolean,
	blogPosts: Array<GraphQLTypes["BlogPost"]>,
	itemCategories: Array<GraphQLTypes["ItemCategory"]>,
	brands: Array<GraphQLTypes["Brand"]>,
	isActive: boolean,
	link: string,
	note?: string,
	activeFrom?: GraphQLTypes["DateTime"],
	activeUntil?: GraphQLTypes["DateTime"],
	slug?: string,
	contentReferences: Array<GraphQLTypes["ContentReference"]>,
	contentReferencesByImages?: GraphQLTypes["ContentReference"],
	contentReferencesByLink?: GraphQLTypes["ContentReference"],
	contentReferencesByList?: GraphQLTypes["ContentReference"],
	contentReferencesByOutline?: GraphQLTypes["ContentReference"],
	contentReferencesByVideo?: GraphQLTypes["ContentReference"],
	contentReferencesByImage?: GraphQLTypes["ContentReference"],
	paginateBlogPosts: GraphQLTypes["BlogPostConnection"],
	paginateItemCategories: GraphQLTypes["ItemCategoryConnection"],
	paginateBrands: GraphQLTypes["BrandConnection"],
	paginateContentReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["AdMeta"]: {
	__typename: "AdMeta",
	id?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	isBrandSectionVisible?: GraphQLTypes["FieldMeta"],
	isBlogPostSectionVisible?: GraphQLTypes["FieldMeta"],
	isIngredientSectionVisible?: GraphQLTypes["FieldMeta"],
	isResultsVisible?: GraphQLTypes["FieldMeta"],
	isSearchVisible?: GraphQLTypes["FieldMeta"],
	blogPosts?: GraphQLTypes["FieldMeta"],
	itemCategories?: GraphQLTypes["FieldMeta"],
	brands?: GraphQLTypes["FieldMeta"],
	isActive?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	note?: GraphQLTypes["FieldMeta"],
	activeFrom?: GraphQLTypes["FieldMeta"],
	activeUntil?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	contentReferences?: GraphQLTypes["FieldMeta"]
};
	["Brand"]: {
	__typename: "Brand",
	_meta?: GraphQLTypes["BrandMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	products: Array<GraphQLTypes["Product"]>,
	link?: string,
	countriesOfProduction: Array<GraphQLTypes["Country"]>,
	manufacturers: Array<GraphQLTypes["BrandManufacturer"]>,
	remoteId: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines: Array<GraphQLTypes["ProductLine"]>,
	logo?: GraphQLTypes["Image"],
	methodOfProduction?: GraphQLTypes["ProductionMethod"],
	distributor?: GraphQLTypes["BrandDistributor"],
	aliases: Array<GraphQLTypes["BrandAlias"]>,
	ads: Array<GraphQLTypes["Ad"]>,
	slug?: string,
	flavors: Array<GraphQLTypes["BrandFlavor"]>,
	seo?: GraphQLTypes["Seo"],
	customMetaDescription?: string,
	filterCombos: Array<GraphQLTypes["FilterCombo"]>,
	topx: Array<GraphQLTypes["TOPXBrand"]>,
	content?: GraphQLTypes["Content"],
	draft?: GraphQLTypes["Content"],
	productsByRemoteId?: GraphQLTypes["Product"],
	productsBySlug?: GraphQLTypes["Product"],
	productsByNutritionalValues?: GraphQLTypes["Product"],
	productsByReviews?: GraphQLTypes["Product"],
	productsByDogs?: GraphQLTypes["Product"],
	productsByPackagings?: GraphQLTypes["Product"],
	productsByElements?: GraphQLTypes["Product"],
	productsByFlags?: GraphQLTypes["Product"],
	productsByImage?: GraphQLTypes["Product"],
	productsByAliases?: GraphQLTypes["Product"],
	productsByEvaluation?: GraphQLTypes["Product"],
	productsBySeo?: GraphQLTypes["Product"],
	productsByItemDeclensionFourthCategories?: GraphQLTypes["Product"],
	productsByHeurekaImage?: GraphQLTypes["Product"],
	productsByTopx?: GraphQLTypes["Product"],
	productLinesByRemoteId?: GraphQLTypes["ProductLine"],
	productLinesBySlug?: GraphQLTypes["ProductLine"],
	productLinesByProducts?: GraphQLTypes["ProductLine"],
	productLinesByLogo?: GraphQLTypes["ProductLine"],
	productLinesByFlavors?: GraphQLTypes["ProductLine"],
	productLinesBySeo?: GraphQLTypes["ProductLine"],
	aliasesByRemoteId?: GraphQLTypes["BrandAlias"],
	filterCombosByRemoteId?: GraphQLTypes["FilterCombo"],
	filterCombosBySeo?: GraphQLTypes["FilterCombo"],
	topxByRemoteId?: GraphQLTypes["TOPXBrand"],
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateCountriesOfProduction: GraphQLTypes["CountryConnection"],
	paginateManufacturers: GraphQLTypes["BrandManufacturerConnection"],
	paginateProductLines: GraphQLTypes["ProductLineConnection"],
	paginateAliases: GraphQLTypes["BrandAliasConnection"],
	paginateAds: GraphQLTypes["AdConnection"],
	paginateFlavors: GraphQLTypes["BrandFlavorConnection"],
	paginateFilterCombos: GraphQLTypes["FilterComboConnection"],
	paginateTopx: GraphQLTypes["TOPXBrandConnection"]
};
	["BrandMeta"]: {
	__typename: "BrandMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	countriesOfProduction?: GraphQLTypes["FieldMeta"],
	manufacturers?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	promotedOnSearchPlace?: GraphQLTypes["FieldMeta"],
	promotedOnBrandsPagePlace?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	productLines?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	methodOfProduction?: GraphQLTypes["FieldMeta"],
	distributor?: GraphQLTypes["FieldMeta"],
	aliases?: GraphQLTypes["FieldMeta"],
	ads?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	flavors?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	customMetaDescription?: GraphQLTypes["FieldMeta"],
	filterCombos?: GraphQLTypes["FieldMeta"],
	topx?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	draft?: GraphQLTypes["FieldMeta"]
};
	["Country"]: {
	__typename: "Country",
	_meta?: GraphQLTypes["CountryMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	brands: Array<GraphQLTypes["Brand"]>,
	manufacturers: Array<GraphQLTypes["BrandManufacturer"]>,
	remoteId: string,
	region?: GraphQLTypes["Region"],
	manufacturersByRemoteId?: GraphQLTypes["BrandManufacturer"],
	paginateBrands: GraphQLTypes["BrandConnection"],
	paginateManufacturers: GraphQLTypes["BrandManufacturerConnection"]
};
	["CountryMeta"]: {
	__typename: "CountryMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	brands?: GraphQLTypes["FieldMeta"],
	manufacturers?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	region?: GraphQLTypes["FieldMeta"]
};
	["BrandManufacturer"]: {
	__typename: "BrandManufacturer",
	_meta?: GraphQLTypes["BrandManufacturerMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	link?: string,
	brands: Array<GraphQLTypes["Brand"]>,
	order?: number,
	remoteId: string,
	residence?: GraphQLTypes["Country"],
	paginateBrands: GraphQLTypes["BrandConnection"]
};
	["BrandManufacturerMeta"]: {
	__typename: "BrandManufacturerMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	brands?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	residence?: GraphQLTypes["FieldMeta"]
};
	["BrandConnection"]: {
	__typename: "BrandConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BrandEdge"]>
};
	["PageInfo"]: {
	__typename: "PageInfo",
	totalCount: number
};
	["BrandEdge"]: {
	__typename: "BrandEdge",
	node: GraphQLTypes["Brand"]
};
	["BrandManufacturerOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	residence?: GraphQLTypes["CountryOrderBy"]
};
	["CountryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	region?: GraphQLTypes["RegionOrderBy"]
};
	["RegionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	adjective?: GraphQLTypes["OrderDirection"],
	slug?: GraphQLTypes["OrderDirection"]
};
	["Region"]: {
	__typename: "Region",
	_meta?: GraphQLTypes["RegionMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	countries: Array<GraphQLTypes["Country"]>,
	remoteId: string,
	adjective?: string,
	slug?: string,
	filterCombos: Array<GraphQLTypes["FilterCombo"]>,
	countriesByRemoteId?: GraphQLTypes["Country"],
	countriesByManufacturers?: GraphQLTypes["Country"],
	filterCombosByRemoteId?: GraphQLTypes["FilterCombo"],
	filterCombosBySeo?: GraphQLTypes["FilterCombo"],
	paginateCountries: GraphQLTypes["CountryConnection"],
	paginateFilterCombos: GraphQLTypes["FilterComboConnection"]
};
	["RegionMeta"]: {
	__typename: "RegionMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	countries?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	adjective?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	filterCombos?: GraphQLTypes["FieldMeta"]
};
	["FilterCombo"]: {
	__typename: "FilterCombo",
	_meta?: GraphQLTypes["FilterComboMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["Seo"],
	breed?: GraphQLTypes["Breed"],
	brand?: GraphQLTypes["Brand"],
	region?: GraphQLTypes["Region"],
	ageCategory?: GraphQLTypes["AgeCategory"],
	treatment?: GraphQLTypes["BodyTag"],
	flavor?: GraphQLTypes["ItemSubCategory"],
	allergy?: GraphQLTypes["ItemSubCategory"]
};
	["FilterComboMeta"]: {
	__typename: "FilterComboMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	breed?: GraphQLTypes["FieldMeta"],
	brand?: GraphQLTypes["FieldMeta"],
	region?: GraphQLTypes["FieldMeta"],
	ageCategory?: GraphQLTypes["FieldMeta"],
	treatment?: GraphQLTypes["FieldMeta"],
	flavor?: GraphQLTypes["FieldMeta"],
	allergy?: GraphQLTypes["FieldMeta"]
};
	["Breed"]: {
	__typename: "Breed",
	_meta?: GraphQLTypes["BreedMeta"],
	id: GraphQLTypes["UUID"],
	dogs: Array<GraphQLTypes["Dog"]>,
	litterSize?: number,
	reviews: Array<GraphQLTypes["Review"]>,
	name: string,
	dailyEnergyRequirement?: number,
	ages: Array<GraphQLTypes["Age"]>,
	remoteId: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["SuitabilityCategory"],
	productReviews: Array<GraphQLTypes["ProductReview"]>,
	blogPostReviews: Array<GraphQLTypes["BlogPostReview"]>,
	labelFor?: string,
	size?: GraphQLTypes["DogSize"],
	slug?: string,
	filterCombos: Array<GraphQLTypes["FilterCombo"]>,
	dogsByReproduction?: GraphQLTypes["Dog"],
	dogsByAvatar?: GraphQLTypes["Dog"],
	productReviewsByProductReviewReactions?: GraphQLTypes["ProductReview"],
	productReviewsByStats?: GraphQLTypes["ProductReview"],
	blogPostReviewsByBlogPostReviewReactions?: GraphQLTypes["BlogPostReview"],
	blogPostReviewsByStats?: GraphQLTypes["BlogPostReview"],
	filterCombosByRemoteId?: GraphQLTypes["FilterCombo"],
	filterCombosBySeo?: GraphQLTypes["FilterCombo"],
	paginateDogs: GraphQLTypes["DogConnection"],
	paginateReviews: GraphQLTypes["ReviewConnection"],
	paginateAges: GraphQLTypes["AgeConnection"],
	paginateProductReviews: GraphQLTypes["ProductReviewConnection"],
	paginateBlogPostReviews: GraphQLTypes["BlogPostReviewConnection"],
	paginateFilterCombos: GraphQLTypes["FilterComboConnection"]
};
	["BreedMeta"]: {
	__typename: "BreedMeta",
	id?: GraphQLTypes["FieldMeta"],
	dogs?: GraphQLTypes["FieldMeta"],
	litterSize?: GraphQLTypes["FieldMeta"],
	reviews?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	dailyEnergyRequirement?: GraphQLTypes["FieldMeta"],
	ages?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	averageWeightFemale?: GraphQLTypes["FieldMeta"],
	averageWeightMale?: GraphQLTypes["FieldMeta"],
	suitabilityCategory?: GraphQLTypes["FieldMeta"],
	productReviews?: GraphQLTypes["FieldMeta"],
	blogPostReviews?: GraphQLTypes["FieldMeta"],
	labelFor?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	filterCombos?: GraphQLTypes["FieldMeta"]
};
	["Dog"]: {
	__typename: "Dog",
	_meta?: GraphQLTypes["DogMeta"],
	id: GraphQLTypes["UUID"],
	gender?: GraphQLTypes["GenderType"],
	weight: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["Breed"],
	age?: GraphQLTypes["Age"],
	bodyType?: GraphQLTypes["DogBodyType"],
	owner?: GraphQLTypes["User"],
	activity?: GraphQLTypes["DogActivity"],
	fedProduct?: GraphQLTypes["Product"],
	reproduction?: GraphQLTypes["DogReproduction"],
	allergies: Array<GraphQLTypes["ItemSubCategory"]>,
	illnesses: Array<GraphQLTypes["BodyTag"]>,
	name?: string,
	avatar?: GraphQLTypes["Image"],
	createdAt?: GraphQLTypes["DateTime"],
	paginateAllergies: GraphQLTypes["ItemSubCategoryConnection"],
	paginateIllnesses: GraphQLTypes["BodyTagConnection"]
};
	["DogMeta"]: {
	__typename: "DogMeta",
	id?: GraphQLTypes["FieldMeta"],
	gender?: GraphQLTypes["FieldMeta"],
	weight?: GraphQLTypes["FieldMeta"],
	customIdealWeight?: GraphQLTypes["FieldMeta"],
	breed?: GraphQLTypes["FieldMeta"],
	age?: GraphQLTypes["FieldMeta"],
	bodyType?: GraphQLTypes["FieldMeta"],
	owner?: GraphQLTypes["FieldMeta"],
	activity?: GraphQLTypes["FieldMeta"],
	fedProduct?: GraphQLTypes["FieldMeta"],
	reproduction?: GraphQLTypes["FieldMeta"],
	allergies?: GraphQLTypes["FieldMeta"],
	illnesses?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	avatar?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"]
};
	["Age"]: {
	__typename: "Age",
	_meta?: GraphQLTypes["AgeMeta"],
	id: GraphQLTypes["UUID"],
	dogs: Array<GraphQLTypes["Dog"]>,
	breeds: Array<GraphQLTypes["Breed"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	suitabilityCategories: Array<GraphQLTypes["SuitabilityCategory"]>,
	remoteId: string,
	productReviews: Array<GraphQLTypes["ProductReview"]>,
	blogPostReviews: Array<GraphQLTypes["BlogPostReview"]>,
	label?: string,
	categoryOrder?: string,
	dogsByReproduction?: GraphQLTypes["Dog"],
	dogsByAvatar?: GraphQLTypes["Dog"],
	productReviewsByProductReviewReactions?: GraphQLTypes["ProductReview"],
	productReviewsByStats?: GraphQLTypes["ProductReview"],
	blogPostReviewsByBlogPostReviewReactions?: GraphQLTypes["BlogPostReview"],
	blogPostReviewsByStats?: GraphQLTypes["BlogPostReview"],
	paginateDogs: GraphQLTypes["DogConnection"],
	paginateBreeds: GraphQLTypes["BreedConnection"],
	paginateSuitabilityCategories: GraphQLTypes["SuitabilityCategoryConnection"],
	paginateProductReviews: GraphQLTypes["ProductReviewConnection"],
	paginateBlogPostReviews: GraphQLTypes["BlogPostReviewConnection"]
};
	["AgeMeta"]: {
	__typename: "AgeMeta",
	id?: GraphQLTypes["FieldMeta"],
	dogs?: GraphQLTypes["FieldMeta"],
	breeds?: GraphQLTypes["FieldMeta"],
	ageRange?: GraphQLTypes["FieldMeta"],
	categoryLabel?: GraphQLTypes["FieldMeta"],
	suitabilityCategories?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	productReviews?: GraphQLTypes["FieldMeta"],
	blogPostReviews?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	categoryOrder?: GraphQLTypes["FieldMeta"]
};
	["DogOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	gender?: GraphQLTypes["OrderDirection"],
	weight?: GraphQLTypes["OrderDirection"],
	customIdealWeight?: GraphQLTypes["OrderDirection"],
	breed?: GraphQLTypes["BreedOrderBy"],
	age?: GraphQLTypes["AgeOrderBy"],
	bodyType?: GraphQLTypes["DogBodyTypeOrderBy"],
	owner?: GraphQLTypes["UserOrderBy"],
	activity?: GraphQLTypes["DogActivityOrderBy"],
	fedProduct?: GraphQLTypes["ProductOrderBy"],
	reproduction?: GraphQLTypes["DogReproductionOrderBy"],
	name?: GraphQLTypes["OrderDirection"],
	avatar?: GraphQLTypes["ImageOrderBy"],
	createdAt?: GraphQLTypes["OrderDirection"]
};
	["BreedOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	litterSize?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	dailyEnergyRequirement?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	averageWeightFemale?: GraphQLTypes["OrderDirection"],
	averageWeightMale?: GraphQLTypes["OrderDirection"],
	suitabilityCategory?: GraphQLTypes["SuitabilityCategoryOrderBy"],
	labelFor?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["DogSizeOrderBy"],
	slug?: GraphQLTypes["OrderDirection"]
};
	["DogSizeOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	suitabilityCategory?: GraphQLTypes["SuitabilityCategoryOrderBy"],
	name?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	isFilterVisible?: GraphQLTypes["OrderDirection"]
};
	["AgeOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	ageRange?: GraphQLTypes["OrderDirection"],
	categoryLabel?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	categoryOrder?: GraphQLTypes["OrderDirection"]
};
	["DogBodyTypeOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	value?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	category?: GraphQLTypes["DogBodyTypeCategoryOrderBy"],
	imageMain?: GraphQLTypes["ImageOrderBy"],
	imageFrom?: GraphQLTypes["ImageOrderBy"],
	imageTo?: GraphQLTypes["ImageOrderBy"]
};
	["DogBodyTypeCategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	imageMain?: GraphQLTypes["ImageOrderBy"]
};
	["DogReproductionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	breastfeedingPuppyCount?: GraphQLTypes["OrderDirection"],
	pregnancy?: GraphQLTypes["OrderDirection"],
	dog?: GraphQLTypes["DogOrderBy"],
	breastfeedingCategory?: GraphQLTypes["BreastfeedingCategoryOrderBy"]
};
	["BreastfeedingCategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	week?: GraphQLTypes["OrderDirection"],
	coeficient?: GraphQLTypes["OrderDirection"]
};
	["SuitabilityCategory"]: {
	__typename: "SuitabilityCategory",
	_meta?: GraphQLTypes["SuitabilityCategoryMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	dogSizes: Array<GraphQLTypes["DogSize"]>,
	dogActivities: Array<GraphQLTypes["DogActivity"]>,
	breeds: Array<GraphQLTypes["Breed"]>,
	suitabilityItems: Array<GraphQLTypes["SuitabilityItem"]>,
	dogAges: Array<GraphQLTypes["Age"]>,
	isPregnant: boolean,
	remoteId: string,
	isBreastfeeding: boolean,
	dogSizesByRemoteId?: GraphQLTypes["DogSize"],
	dogSizesByBreeds?: GraphQLTypes["DogSize"],
	dogActivitiesByRemoteId?: GraphQLTypes["DogActivity"],
	dogActivitiesByDogs?: GraphQLTypes["DogActivity"],
	dogActivitiesByProducts?: GraphQLTypes["DogActivity"],
	breedsByRemoteId?: GraphQLTypes["Breed"],
	breedsBySlug?: GraphQLTypes["Breed"],
	breedsByDogs?: GraphQLTypes["Breed"],
	breedsByProductReviews?: GraphQLTypes["Breed"],
	breedsByBlogPostReviews?: GraphQLTypes["Breed"],
	breedsByFilterCombos?: GraphQLTypes["Breed"],
	suitabilityItemsByRemoteId?: GraphQLTypes["SuitabilityItem"],
	paginateDogSizes: GraphQLTypes["DogSizeConnection"],
	paginateDogActivities: GraphQLTypes["DogActivityConnection"],
	paginateBreeds: GraphQLTypes["BreedConnection"],
	paginateSuitabilityItems: GraphQLTypes["SuitabilityItemConnection"],
	paginateDogAges: GraphQLTypes["AgeConnection"]
};
	["SuitabilityCategoryMeta"]: {
	__typename: "SuitabilityCategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	dogSizes?: GraphQLTypes["FieldMeta"],
	dogActivities?: GraphQLTypes["FieldMeta"],
	breeds?: GraphQLTypes["FieldMeta"],
	suitabilityItems?: GraphQLTypes["FieldMeta"],
	dogAges?: GraphQLTypes["FieldMeta"],
	isPregnant?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	isBreastfeeding?: GraphQLTypes["FieldMeta"]
};
	["DogSize"]: {
	__typename: "DogSize",
	_meta?: GraphQLTypes["DogSizeMeta"],
	id: GraphQLTypes["UUID"],
	breeds: Array<GraphQLTypes["Breed"]>,
	remoteId: string,
	products: Array<GraphQLTypes["Product"]>,
	suitabilityCategory?: GraphQLTypes["SuitabilityCategory"],
	name: GraphQLTypes["SizeType"],
	label?: string,
	order?: number,
	isFilterVisible?: boolean,
	breedsByRemoteId?: GraphQLTypes["Breed"],
	breedsBySlug?: GraphQLTypes["Breed"],
	breedsByDogs?: GraphQLTypes["Breed"],
	breedsByProductReviews?: GraphQLTypes["Breed"],
	breedsByBlogPostReviews?: GraphQLTypes["Breed"],
	breedsByFilterCombos?: GraphQLTypes["Breed"],
	paginateBreeds: GraphQLTypes["BreedConnection"],
	paginateProducts: GraphQLTypes["ProductConnection"]
};
	["DogSizeMeta"]: {
	__typename: "DogSizeMeta",
	id?: GraphQLTypes["FieldMeta"],
	breeds?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	suitabilityCategory?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	isFilterVisible?: GraphQLTypes["FieldMeta"]
};
	["DogSizeBreedsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["DogSizeBreedsBySlugUniqueWhere"]: {
		slug?: string
};
	["DogSizeBreedsByDogsUniqueWhere"]: {
		dogs?: GraphQLTypes["DogUniqueWhere"]
};
	["DogUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	reproduction?: GraphQLTypes["DogReproductionUniqueWhere"],
	avatar?: GraphQLTypes["ImageUniqueWhere"]
};
	["DogReproductionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	dog?: GraphQLTypes["DogUniqueWhere"]
};
	["ImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["DogSizeBreedsByProductReviewsUniqueWhere"]: {
		productReviews?: GraphQLTypes["ProductReviewUniqueWhere"]
};
	["ProductReviewUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	productReviewReactions?: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	stats?: GraphQLTypes["ProductReviewStatsUniqueWhere"]
};
	["ProductReviewReactionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	productReview?: GraphQLTypes["ProductReviewUniqueWhere"],
	user?: GraphQLTypes["UserUniqueWhere"]
};
	["UserUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	email?: string,
	tenantPersonId?: GraphQLTypes["UUID"],
	verifiedEmail?: string,
	dogs?: GraphQLTypes["DogUniqueWhere"],
	veterinary?: GraphQLTypes["VeterinaryUniqueWhere"],
	blogPostReviews?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	productReviews?: GraphQLTypes["ProductReviewUniqueWhere"],
	blogPostReviewReactions?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	productReviewReactions?: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	blogPosts?: GraphQLTypes["BlogPostUniqueWhere"],
	avatar?: GraphQLTypes["ImageUniqueWhere"],
	contactFormMessages?: GraphQLTypes["ContactFormMessageUniqueWhere"],
	bugReports?: GraphQLTypes["BugReportUniqueWhere"],
	protectedActions?: GraphQLTypes["ProtectedActionUniqueWhere"],
	tenantPerson?: GraphQLTypes["TenantPersonUniqueWhere"]
};
	["VeterinaryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	user?: GraphQLTypes["UserUniqueWhere"]
};
	["BlogPostReviewUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	blogPostReviewReactions?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	stats?: GraphQLTypes["BlogPostReviewStatsUniqueWhere"]
};
	["BlogPostReviewReactionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	blogPostReview?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	user?: GraphQLTypes["UserUniqueWhere"]
};
	["BlogPostReviewStatsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	blogPostReview?: GraphQLTypes["BlogPostReviewUniqueWhere"]
};
	["BlogPostUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	slug?: string,
	slugInternal?: string,
	reviews?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	items?: GraphQLTypes["ItemUniqueWhere"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	referenceList?: GraphQLTypes["ReferenceListUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	redirects?: GraphQLTypes["RedirectUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["ItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	slug?: string,
	featuresOfProduct?: GraphQLTypes["ProductFeatureUniqueWhere"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	referenceList?: GraphQLTypes["ReferenceListUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	aliases?: GraphQLTypes["ItemAliasUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["ProductFeatureUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["ReferenceListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	references?: GraphQLTypes["ReferenceUniqueWhere"]
};
	["ReferenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	ogImage?: GraphQLTypes["ImageUniqueWhere"],
	blogPage?: GraphQLTypes["BlogPageUniqueWhere"],
	brandsPage?: GraphQLTypes["BrandsPageUniqueWhere"],
	comparatorPage?: GraphQLTypes["ComparatorPageUniqueWhere"],
	genericPage?: GraphQLTypes["GenericPageUniqueWhere"],
	homePage?: GraphQLTypes["HomePageUniqueWhere"],
	ingredientsPage?: GraphQLTypes["IngredientsPageUniqueWhere"],
	loginPage?: GraphQLTypes["LoginPageUniqueWhere"],
	registerPage?: GraphQLTypes["RegisterPageUniqueWhere"],
	searchPage?: GraphQLTypes["SearchPageUniqueWhere"],
	wizardPage?: GraphQLTypes["WizardPageUniqueWhere"],
	contactPage?: GraphQLTypes["ContactPageUniqueWhere"]
};
	["BlogPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	redirects?: GraphQLTypes["RedirectUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["RedirectUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	from?: string
};
	["ContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: GraphQLTypes["ContentBlockUniqueWhere"]
};
	["ContentBlockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	automatedContentBlockSlug?: string,
	references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentReferenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	images?: GraphQLTypes["ContentReferenceGalleryImageUniqueWhere"],
	link?: GraphQLTypes["LinkUniqueWhere"],
	list?: GraphQLTypes["ContentReferenceListUniqueWhere"],
	outline?: GraphQLTypes["ContentLinksUniqueWhere"],
	video?: GraphQLTypes["VideoUniqueWhere"],
	image?: GraphQLTypes["ContentReferenceImageUniqueWhere"]
};
	["ContentReferenceGalleryImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["LinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ContentReferenceListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ContentLinksUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ContentLinksItemUniqueWhere"]
};
	["ContentLinksItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["VideoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ContentReferenceImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"]
};
	["BrandsPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	redirects?: GraphQLTypes["RedirectUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["ComparatorPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	redirects?: GraphQLTypes["RedirectUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["GenericPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	redirects?: GraphQLTypes["RedirectUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["LinkableUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	genericPage?: GraphQLTypes["GenericPageUniqueWhere"]
};
	["HomePageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["IngredientsPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["LoginPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["RegisterPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["SearchPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["WizardPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	redirects?: GraphQLTypes["RedirectUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ContactPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	redirects?: GraphQLTypes["RedirectUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["ItemAliasUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["ContactFormMessageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["BugReportUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ProtectedActionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	publicKey?: string
};
	["TenantPersonUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	user?: GraphQLTypes["UserUniqueWhere"]
};
	["ProductReviewStatsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	productReview?: GraphQLTypes["ProductReviewUniqueWhere"]
};
	["DogSizeBreedsByBlogPostReviewsUniqueWhere"]: {
		blogPostReviews?: GraphQLTypes["BlogPostReviewUniqueWhere"]
};
	["DogSizeBreedsByFilterCombosUniqueWhere"]: {
		filterCombos?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["FilterComboUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["BreedConnection"]: {
	__typename: "BreedConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BreedEdge"]>
};
	["BreedEdge"]: {
	__typename: "BreedEdge",
	node: GraphQLTypes["Breed"]
};
	["ProductConnection"]: {
	__typename: "ProductConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductEdge"]>
};
	["ProductEdge"]: {
	__typename: "ProductEdge",
	node: GraphQLTypes["Product"]
};
	["DogActivity"]: {
	__typename: "DogActivity",
	_meta?: GraphQLTypes["DogActivityMeta"],
	id: GraphQLTypes["UUID"],
	label: string,
	dogs: Array<GraphQLTypes["Dog"]>,
	products: Array<GraphQLTypes["Product"]>,
	dailyEnergyRequirementCoeficient?: number,
	remoteId: string,
	suitabilityCategory?: GraphQLTypes["SuitabilityCategory"],
	dogsByReproduction?: GraphQLTypes["Dog"],
	dogsByAvatar?: GraphQLTypes["Dog"],
	productsByRemoteId?: GraphQLTypes["Product"],
	productsBySlug?: GraphQLTypes["Product"],
	productsByNutritionalValues?: GraphQLTypes["Product"],
	productsByReviews?: GraphQLTypes["Product"],
	productsByDogs?: GraphQLTypes["Product"],
	productsByPackagings?: GraphQLTypes["Product"],
	productsByElements?: GraphQLTypes["Product"],
	productsByFlags?: GraphQLTypes["Product"],
	productsByImage?: GraphQLTypes["Product"],
	productsByAliases?: GraphQLTypes["Product"],
	productsByEvaluation?: GraphQLTypes["Product"],
	productsBySeo?: GraphQLTypes["Product"],
	productsByItemDeclensionFourthCategories?: GraphQLTypes["Product"],
	productsByHeurekaImage?: GraphQLTypes["Product"],
	productsByTopx?: GraphQLTypes["Product"],
	paginateDogs: GraphQLTypes["DogConnection"],
	paginateProducts: GraphQLTypes["ProductConnection"]
};
	["DogActivityMeta"]: {
	__typename: "DogActivityMeta",
	id?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	dogs?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	dailyEnergyRequirementCoeficient?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	suitabilityCategory?: GraphQLTypes["FieldMeta"]
};
	["DogActivityDogsByReproductionUniqueWhere"]: {
		reproduction?: GraphQLTypes["DogReproductionUniqueWhere"]
};
	["DogActivityDogsByAvatarUniqueWhere"]: {
		avatar?: GraphQLTypes["ImageUniqueWhere"]
};
	["DogActivityProductsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["DogActivityProductsBySlugUniqueWhere"]: {
		slug?: string
};
	["DogActivityProductsByNutritionalValuesUniqueWhere"]: {
		nutritionalValues?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"]
};
	["NutritionalValueOfProductUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["DogActivityProductsByReviewsUniqueWhere"]: {
		reviews?: GraphQLTypes["ProductReviewUniqueWhere"]
};
	["DogActivityProductsByDogsUniqueWhere"]: {
		dogs?: GraphQLTypes["DogUniqueWhere"]
};
	["DogActivityProductsByPackagingsUniqueWhere"]: {
		packagings?: GraphQLTypes["ProductPackageUniqueWhere"]
};
	["ProductPackageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	positionId?: string,
	externalId?: string
};
	["DogActivityProductsByElementsUniqueWhere"]: {
		elements?: GraphQLTypes["ElementOfProductUniqueWhere"]
};
	["ElementOfProductUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["DogActivityProductsByFlagsUniqueWhere"]: {
		flags?: GraphQLTypes["ProductFlagOfProductUniqueWhere"]
};
	["ProductFlagOfProductUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["DogActivityProductsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["DogActivityProductsByAliasesUniqueWhere"]: {
		aliases?: GraphQLTypes["ProductAliasUniqueWhere"]
};
	["ProductAliasUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["DogActivityProductsByEvaluationUniqueWhere"]: {
		evaluation?: GraphQLTypes["ProductEvaluationUniqueWhere"]
};
	["ProductEvaluationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	product?: GraphQLTypes["ProductUniqueWhere"]
};
	["ProductUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	slug?: string,
	nutritionalValues?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	reviews?: GraphQLTypes["ProductReviewUniqueWhere"],
	dogs?: GraphQLTypes["DogUniqueWhere"],
	packagings?: GraphQLTypes["ProductPackageUniqueWhere"],
	elements?: GraphQLTypes["ElementOfProductUniqueWhere"],
	flags?: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	aliases?: GraphQLTypes["ProductAliasUniqueWhere"],
	evaluation?: GraphQLTypes["ProductEvaluationUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	itemDeclensionFourthCategories?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"],
	heurekaImage?: GraphQLTypes["ImageUniqueWhere"],
	topx?: GraphQLTypes["TOPXProductUniqueWhere"]
};
	["ProductItemDeclensionFourthCategoryUniqueWhere"]: {
		id?: string
};
	["TOPXProductUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["DogActivityProductsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["DogActivityProductsByItemDeclensionFourthCategoriesUniqueWhere"]: {
		itemDeclensionFourthCategories?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"]
};
	["DogActivityProductsByHeurekaImageUniqueWhere"]: {
		heurekaImage?: GraphQLTypes["ImageUniqueWhere"]
};
	["DogActivityProductsByTopxUniqueWhere"]: {
		topx?: GraphQLTypes["TOPXProductUniqueWhere"]
};
	["DogConnection"]: {
	__typename: "DogConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DogEdge"]>
};
	["DogEdge"]: {
	__typename: "DogEdge",
	node: GraphQLTypes["Dog"]
};
	["SuitabilityItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	min?: GraphQLTypes["OrderDirection"],
	max?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	element?: GraphQLTypes["ElementOrderBy"],
	nutritionalValue?: GraphQLTypes["NutritionalValueOrderBy"],
	category?: GraphQLTypes["SuitabilityCategoryOrderBy"]
};
	["SuitabilityCategoryDogSizesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["SuitabilityCategoryDogSizesByBreedsUniqueWhere"]: {
		breeds?: GraphQLTypes["BreedUniqueWhere"]
};
	["BreedUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	slug?: string,
	dogs?: GraphQLTypes["DogUniqueWhere"],
	productReviews?: GraphQLTypes["ProductReviewUniqueWhere"],
	blogPostReviews?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	filterCombos?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["SuitabilityCategoryDogActivitiesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["SuitabilityCategoryDogActivitiesByDogsUniqueWhere"]: {
		dogs?: GraphQLTypes["DogUniqueWhere"]
};
	["SuitabilityCategoryDogActivitiesByProductsUniqueWhere"]: {
		products?: GraphQLTypes["ProductUniqueWhere"]
};
	["SuitabilityCategoryBreedsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["SuitabilityCategoryBreedsBySlugUniqueWhere"]: {
		slug?: string
};
	["SuitabilityCategoryBreedsByDogsUniqueWhere"]: {
		dogs?: GraphQLTypes["DogUniqueWhere"]
};
	["SuitabilityCategoryBreedsByProductReviewsUniqueWhere"]: {
		productReviews?: GraphQLTypes["ProductReviewUniqueWhere"]
};
	["SuitabilityCategoryBreedsByBlogPostReviewsUniqueWhere"]: {
		blogPostReviews?: GraphQLTypes["BlogPostReviewUniqueWhere"]
};
	["SuitabilityCategoryBreedsByFilterCombosUniqueWhere"]: {
		filterCombos?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["SuitabilityCategorySuitabilityItemsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["DogSizeConnection"]: {
	__typename: "DogSizeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DogSizeEdge"]>
};
	["DogSizeEdge"]: {
	__typename: "DogSizeEdge",
	node: GraphQLTypes["DogSize"]
};
	["DogActivityConnection"]: {
	__typename: "DogActivityConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DogActivityEdge"]>
};
	["DogActivityEdge"]: {
	__typename: "DogActivityEdge",
	node: GraphQLTypes["DogActivity"]
};
	["SuitabilityItemConnection"]: {
	__typename: "SuitabilityItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SuitabilityItemEdge"]>
};
	["SuitabilityItemEdge"]: {
	__typename: "SuitabilityItemEdge",
	node: GraphQLTypes["SuitabilityItem"]
};
	["AgeConnection"]: {
	__typename: "AgeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AgeEdge"]>
};
	["AgeEdge"]: {
	__typename: "AgeEdge",
	node: GraphQLTypes["Age"]
};
	["ProductReview"]: {
	__typename: "ProductReview",
	_meta?: GraphQLTypes["ProductReviewMeta"],
	id: GraphQLTypes["UUID"],
	text: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions: Array<GraphQLTypes["ProductReviewReaction"]>,
	score?: GraphQLTypes["Score"],
	product?: GraphQLTypes["Product"],
	user?: GraphQLTypes["User"],
	stats?: GraphQLTypes["ProductReviewStats"],
	fullName?: string,
	breed?: GraphQLTypes["Breed"],
	age?: GraphQLTypes["Age"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	productReviewReactionsByUser?: GraphQLTypes["ProductReviewReaction"],
	paginateProductReviewReactions: GraphQLTypes["ProductReviewReactionConnection"]
};
	["ProductReviewMeta"]: {
	__typename: "ProductReviewMeta",
	id?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	publishedAt?: GraphQLTypes["FieldMeta"],
	productReviewReactions?: GraphQLTypes["FieldMeta"],
	score?: GraphQLTypes["FieldMeta"],
	product?: GraphQLTypes["FieldMeta"],
	user?: GraphQLTypes["FieldMeta"],
	stats?: GraphQLTypes["FieldMeta"],
	fullName?: GraphQLTypes["FieldMeta"],
	breed?: GraphQLTypes["FieldMeta"],
	age?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	isVisible?: GraphQLTypes["FieldMeta"],
	response?: GraphQLTypes["FieldMeta"]
};
	["ProductReviewReaction"]: {
	__typename: "ProductReviewReaction",
	_meta?: GraphQLTypes["ProductReviewReactionMeta"],
	id: GraphQLTypes["UUID"],
	sentiment: GraphQLTypes["SentimentType"],
	user?: GraphQLTypes["User"],
	productReview?: GraphQLTypes["ProductReview"]
};
	["ProductReviewReactionMeta"]: {
	__typename: "ProductReviewReactionMeta",
	id?: GraphQLTypes["FieldMeta"],
	sentiment?: GraphQLTypes["FieldMeta"],
	user?: GraphQLTypes["FieldMeta"],
	productReview?: GraphQLTypes["FieldMeta"]
};
	["User"]: {
	__typename: "User",
	_meta?: GraphQLTypes["UserMeta"],
	id: GraphQLTypes["UUID"],
	dogs: Array<GraphQLTypes["Dog"]>,
	veterinary?: GraphQLTypes["Veterinary"],
	email: string,
	blogPostReviews: Array<GraphQLTypes["BlogPostReview"]>,
	productReviews: Array<GraphQLTypes["ProductReview"]>,
	blogPostReviewReactions: Array<GraphQLTypes["BlogPostReviewReaction"]>,
	productReviewReactions: Array<GraphQLTypes["ProductReviewReaction"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts: Array<GraphQLTypes["BlogPost"]>,
	createdAt: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["Image"],
	contactFormMessages: Array<GraphQLTypes["ContactFormMessage"]>,
	bugReports: Array<GraphQLTypes["BugReport"]>,
	verifiedEmail?: string,
	protectedActions: Array<GraphQLTypes["ProtectedAction"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["TenantPerson"],
	note?: string,
	dogsByReproduction?: GraphQLTypes["Dog"],
	dogsByAvatar?: GraphQLTypes["Dog"],
	blogPostReviewsByBlogPostReviewReactions?: GraphQLTypes["BlogPostReview"],
	blogPostReviewsByStats?: GraphQLTypes["BlogPostReview"],
	productReviewsByProductReviewReactions?: GraphQLTypes["ProductReview"],
	productReviewsByStats?: GraphQLTypes["ProductReview"],
	blogPostReviewReactionsByBlogPostReview?: GraphQLTypes["BlogPostReviewReaction"],
	productReviewReactionsByProductReview?: GraphQLTypes["ProductReviewReaction"],
	blogPostsBySlug?: GraphQLTypes["BlogPost"],
	blogPostsBySlugInternal?: GraphQLTypes["BlogPost"],
	blogPostsByReviews?: GraphQLTypes["BlogPost"],
	blogPostsByItems?: GraphQLTypes["BlogPost"],
	blogPostsByImage?: GraphQLTypes["BlogPost"],
	blogPostsByReferenceList?: GraphQLTypes["BlogPost"],
	blogPostsBySeo?: GraphQLTypes["BlogPost"],
	blogPostsByRedirects?: GraphQLTypes["BlogPost"],
	blogPostsByContent?: GraphQLTypes["BlogPost"],
	blogPostsByDraft?: GraphQLTypes["BlogPost"],
	protectedActionsByPublicKey?: GraphQLTypes["ProtectedAction"],
	paginateDogs: GraphQLTypes["DogConnection"],
	paginateBlogPostReviews: GraphQLTypes["BlogPostReviewConnection"],
	paginateProductReviews: GraphQLTypes["ProductReviewConnection"],
	paginateBlogPostReviewReactions: GraphQLTypes["BlogPostReviewReactionConnection"],
	paginateProductReviewReactions: GraphQLTypes["ProductReviewReactionConnection"],
	paginateBlogPosts: GraphQLTypes["BlogPostConnection"],
	paginateContactFormMessages: GraphQLTypes["ContactFormMessageConnection"],
	paginateBugReports: GraphQLTypes["BugReportConnection"],
	paginateProtectedActions: GraphQLTypes["ProtectedActionConnection"]
};
	["UserMeta"]: {
	__typename: "UserMeta",
	id?: GraphQLTypes["FieldMeta"],
	dogs?: GraphQLTypes["FieldMeta"],
	veterinary?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	blogPostReviews?: GraphQLTypes["FieldMeta"],
	productReviews?: GraphQLTypes["FieldMeta"],
	blogPostReviewReactions?: GraphQLTypes["FieldMeta"],
	productReviewReactions?: GraphQLTypes["FieldMeta"],
	tenantPersonId?: GraphQLTypes["FieldMeta"],
	fullName?: GraphQLTypes["FieldMeta"],
	blogPosts?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"],
	verifiedAt?: GraphQLTypes["FieldMeta"],
	avatar?: GraphQLTypes["FieldMeta"],
	contactFormMessages?: GraphQLTypes["FieldMeta"],
	bugReports?: GraphQLTypes["FieldMeta"],
	verifiedEmail?: GraphQLTypes["FieldMeta"],
	protectedActions?: GraphQLTypes["FieldMeta"],
	blockedAt?: GraphQLTypes["FieldMeta"],
	tenantPerson?: GraphQLTypes["FieldMeta"],
	note?: GraphQLTypes["FieldMeta"]
};
	["Veterinary"]: {
	__typename: "Veterinary",
	_meta?: GraphQLTypes["VeterinaryMeta"],
	id: GraphQLTypes["UUID"],
	user?: GraphQLTypes["User"]
};
	["VeterinaryMeta"]: {
	__typename: "VeterinaryMeta",
	id?: GraphQLTypes["FieldMeta"],
	user?: GraphQLTypes["FieldMeta"]
};
	["BlogPostReview"]: {
	__typename: "BlogPostReview",
	_meta?: GraphQLTypes["BlogPostReviewMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	text: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostReviewReactions: Array<GraphQLTypes["BlogPostReviewReaction"]>,
	blogPost?: GraphQLTypes["BlogPost"],
	user?: GraphQLTypes["User"],
	stats?: GraphQLTypes["BlogPostReviewStats"],
	fullName?: string,
	breed?: GraphQLTypes["Breed"],
	age?: GraphQLTypes["Age"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	blogPostReviewReactionsByUser?: GraphQLTypes["BlogPostReviewReaction"],
	paginateBlogPostReviewReactions: GraphQLTypes["BlogPostReviewReactionConnection"]
};
	["BlogPostReviewMeta"]: {
	__typename: "BlogPostReviewMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	publishedAt?: GraphQLTypes["FieldMeta"],
	blogPostReviewReactions?: GraphQLTypes["FieldMeta"],
	blogPost?: GraphQLTypes["FieldMeta"],
	user?: GraphQLTypes["FieldMeta"],
	stats?: GraphQLTypes["FieldMeta"],
	fullName?: GraphQLTypes["FieldMeta"],
	breed?: GraphQLTypes["FieldMeta"],
	age?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	isVisible?: GraphQLTypes["FieldMeta"],
	response?: GraphQLTypes["FieldMeta"]
};
	["BlogPostReviewReaction"]: {
	__typename: "BlogPostReviewReaction",
	_meta?: GraphQLTypes["BlogPostReviewReactionMeta"],
	id: GraphQLTypes["UUID"],
	sentiment: GraphQLTypes["SentimentType"],
	user?: GraphQLTypes["User"],
	blogPostReview?: GraphQLTypes["BlogPostReview"]
};
	["BlogPostReviewReactionMeta"]: {
	__typename: "BlogPostReviewReactionMeta",
	id?: GraphQLTypes["FieldMeta"],
	sentiment?: GraphQLTypes["FieldMeta"],
	user?: GraphQLTypes["FieldMeta"],
	blogPostReview?: GraphQLTypes["FieldMeta"]
};
	["BlogPostReviewReactionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	sentiment?: GraphQLTypes["OrderDirection"],
	user?: GraphQLTypes["UserOrderBy"],
	blogPostReview?: GraphQLTypes["BlogPostReviewOrderBy"]
};
	["BlogPostReviewOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	publishedAt?: GraphQLTypes["OrderDirection"],
	blogPost?: GraphQLTypes["BlogPostOrderBy"],
	user?: GraphQLTypes["UserOrderBy"],
	stats?: GraphQLTypes["BlogPostReviewStatsOrderBy"],
	fullName?: GraphQLTypes["OrderDirection"],
	breed?: GraphQLTypes["BreedOrderBy"],
	age?: GraphQLTypes["AgeOrderBy"],
	url?: GraphQLTypes["OrderDirection"],
	isVisible?: GraphQLTypes["OrderDirection"],
	response?: GraphQLTypes["OrderDirection"]
};
	["BlogPostReviewStatsOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	total?: GraphQLTypes["OrderDirection"],
	positive?: GraphQLTypes["OrderDirection"],
	negative?: GraphQLTypes["OrderDirection"],
	blogPostReview?: GraphQLTypes["BlogPostReviewOrderBy"]
};
	["BlogPostReviewStats"]: {
	__typename: "BlogPostReviewStats",
	_meta?: GraphQLTypes["BlogPostReviewStatsMeta"],
	id: GraphQLTypes["UUID"],
	total: number,
	positive: number,
	negative: number,
	blogPostReview?: GraphQLTypes["BlogPostReview"]
};
	["BlogPostReviewStatsMeta"]: {
	__typename: "BlogPostReviewStatsMeta",
	id?: GraphQLTypes["FieldMeta"],
	total?: GraphQLTypes["FieldMeta"],
	positive?: GraphQLTypes["FieldMeta"],
	negative?: GraphQLTypes["FieldMeta"],
	blogPostReview?: GraphQLTypes["FieldMeta"]
};
	["BlogPostReviewBlogPostReviewReactionsByUserUniqueWhere"]: {
		user?: GraphQLTypes["UserUniqueWhere"]
};
	["BlogPostReviewReactionConnection"]: {
	__typename: "BlogPostReviewReactionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostReviewReactionEdge"]>
};
	["BlogPostReviewReactionEdge"]: {
	__typename: "BlogPostReviewReactionEdge",
	node: GraphQLTypes["BlogPostReviewReaction"]
};
	["ProductReviewOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	publishedAt?: GraphQLTypes["OrderDirection"],
	score?: GraphQLTypes["ScoreOrderBy"],
	product?: GraphQLTypes["ProductOrderBy"],
	user?: GraphQLTypes["UserOrderBy"],
	stats?: GraphQLTypes["ProductReviewStatsOrderBy"],
	fullName?: GraphQLTypes["OrderDirection"],
	breed?: GraphQLTypes["BreedOrderBy"],
	age?: GraphQLTypes["AgeOrderBy"],
	url?: GraphQLTypes["OrderDirection"],
	isVisible?: GraphQLTypes["OrderDirection"],
	response?: GraphQLTypes["OrderDirection"]
};
	["ScoreOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	starsAmount?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"]
};
	["ProductReviewStatsOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	total?: GraphQLTypes["OrderDirection"],
	positive?: GraphQLTypes["OrderDirection"],
	negative?: GraphQLTypes["OrderDirection"],
	productReview?: GraphQLTypes["ProductReviewOrderBy"]
};
	["ProductReviewReactionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	sentiment?: GraphQLTypes["OrderDirection"],
	user?: GraphQLTypes["UserOrderBy"],
	productReview?: GraphQLTypes["ProductReviewOrderBy"]
};
	["ContactFormMessage"]: {
	__typename: "ContactFormMessage",
	_meta?: GraphQLTypes["ContactFormMessageMeta"],
	id: GraphQLTypes["UUID"],
	message?: string,
	email?: string,
	receivedAt?: GraphQLTypes["DateTime"],
	user?: GraphQLTypes["User"],
	isResolved?: boolean,
	url?: string
};
	["ContactFormMessageMeta"]: {
	__typename: "ContactFormMessageMeta",
	id?: GraphQLTypes["FieldMeta"],
	message?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	receivedAt?: GraphQLTypes["FieldMeta"],
	user?: GraphQLTypes["FieldMeta"],
	isResolved?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"]
};
	["ContactFormMessageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	message?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	receivedAt?: GraphQLTypes["OrderDirection"],
	user?: GraphQLTypes["UserOrderBy"],
	isResolved?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"]
};
	["BugReport"]: {
	__typename: "BugReport",
	_meta?: GraphQLTypes["BugReportMeta"],
	id: GraphQLTypes["UUID"],
	message?: string,
	receivedAt?: GraphQLTypes["DateTime"],
	isResolved?: boolean,
	user?: GraphQLTypes["User"],
	url?: string
};
	["BugReportMeta"]: {
	__typename: "BugReportMeta",
	id?: GraphQLTypes["FieldMeta"],
	message?: GraphQLTypes["FieldMeta"],
	receivedAt?: GraphQLTypes["FieldMeta"],
	isResolved?: GraphQLTypes["FieldMeta"],
	user?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"]
};
	["BugReportOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	message?: GraphQLTypes["OrderDirection"],
	receivedAt?: GraphQLTypes["OrderDirection"],
	isResolved?: GraphQLTypes["OrderDirection"],
	user?: GraphQLTypes["UserOrderBy"],
	url?: GraphQLTypes["OrderDirection"]
};
	["ProtectedAction"]: {
	__typename: "ProtectedAction",
	_meta?: GraphQLTypes["ProtectedActionMeta"],
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ProtectedActionType"],
	createdAt: GraphQLTypes["DateTime"],
	usedAt?: GraphQLTypes["DateTime"],
	expiresAt?: GraphQLTypes["DateTime"],
	publicKey: string,
	secretHash: string,
	verifyEmail?: string,
	createdMetadata?: GraphQLTypes["Json"],
	usedMetadata?: GraphQLTypes["Json"],
	user?: GraphQLTypes["User"]
};
	["ProtectedActionMeta"]: {
	__typename: "ProtectedActionMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"],
	usedAt?: GraphQLTypes["FieldMeta"],
	expiresAt?: GraphQLTypes["FieldMeta"],
	publicKey?: GraphQLTypes["FieldMeta"],
	secretHash?: GraphQLTypes["FieldMeta"],
	verifyEmail?: GraphQLTypes["FieldMeta"],
	createdMetadata?: GraphQLTypes["FieldMeta"],
	usedMetadata?: GraphQLTypes["FieldMeta"],
	user?: GraphQLTypes["FieldMeta"]
};
	["ProtectedActionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	createdAt?: GraphQLTypes["OrderDirection"],
	usedAt?: GraphQLTypes["OrderDirection"],
	expiresAt?: GraphQLTypes["OrderDirection"],
	publicKey?: GraphQLTypes["OrderDirection"],
	secretHash?: GraphQLTypes["OrderDirection"],
	verifyEmail?: GraphQLTypes["OrderDirection"],
	createdMetadata?: GraphQLTypes["OrderDirection"],
	usedMetadata?: GraphQLTypes["OrderDirection"],
	user?: GraphQLTypes["UserOrderBy"]
};
	["TenantPerson"]: {
	__typename: "TenantPerson",
	_meta?: GraphQLTypes["TenantPersonMeta"],
	id: GraphQLTypes["UUID"],
	identityId?: GraphQLTypes["UUID"],
	email?: string,
	roles?: string,
	user?: GraphQLTypes["User"]
};
	["TenantPersonMeta"]: {
	__typename: "TenantPersonMeta",
	id?: GraphQLTypes["FieldMeta"],
	identityId?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	roles?: GraphQLTypes["FieldMeta"],
	user?: GraphQLTypes["FieldMeta"]
};
	["UserDogsByReproductionUniqueWhere"]: {
		reproduction?: GraphQLTypes["DogReproductionUniqueWhere"]
};
	["UserDogsByAvatarUniqueWhere"]: {
		avatar?: GraphQLTypes["ImageUniqueWhere"]
};
	["UserBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"]: {
		blogPostReviewReactions?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"]
};
	["UserBlogPostReviewsByStatsUniqueWhere"]: {
		stats?: GraphQLTypes["BlogPostReviewStatsUniqueWhere"]
};
	["UserProductReviewsByProductReviewReactionsUniqueWhere"]: {
		productReviewReactions?: GraphQLTypes["ProductReviewReactionUniqueWhere"]
};
	["UserProductReviewsByStatsUniqueWhere"]: {
		stats?: GraphQLTypes["ProductReviewStatsUniqueWhere"]
};
	["UserBlogPostReviewReactionsByBlogPostReviewUniqueWhere"]: {
		blogPostReview?: GraphQLTypes["BlogPostReviewUniqueWhere"]
};
	["UserProductReviewReactionsByProductReviewUniqueWhere"]: {
		productReview?: GraphQLTypes["ProductReviewUniqueWhere"]
};
	["UserBlogPostsBySlugUniqueWhere"]: {
		slug?: string
};
	["UserBlogPostsBySlugInternalUniqueWhere"]: {
		slugInternal?: string
};
	["UserBlogPostsByReviewsUniqueWhere"]: {
		reviews?: GraphQLTypes["BlogPostReviewUniqueWhere"]
};
	["UserBlogPostsByItemsUniqueWhere"]: {
		items?: GraphQLTypes["ItemUniqueWhere"]
};
	["UserBlogPostsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["UserBlogPostsByReferenceListUniqueWhere"]: {
		referenceList?: GraphQLTypes["ReferenceListUniqueWhere"]
};
	["UserBlogPostsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["UserBlogPostsByRedirectsUniqueWhere"]: {
		redirects?: GraphQLTypes["RedirectUniqueWhere"]
};
	["UserBlogPostsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["UserBlogPostsByDraftUniqueWhere"]: {
		draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["UserProtectedActionsByPublicKeyUniqueWhere"]: {
		publicKey?: string
};
	["BlogPostReviewConnection"]: {
	__typename: "BlogPostReviewConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostReviewEdge"]>
};
	["BlogPostReviewEdge"]: {
	__typename: "BlogPostReviewEdge",
	node: GraphQLTypes["BlogPostReview"]
};
	["ProductReviewConnection"]: {
	__typename: "ProductReviewConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductReviewEdge"]>
};
	["ProductReviewEdge"]: {
	__typename: "ProductReviewEdge",
	node: GraphQLTypes["ProductReview"]
};
	["ProductReviewReactionConnection"]: {
	__typename: "ProductReviewReactionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductReviewReactionEdge"]>
};
	["ProductReviewReactionEdge"]: {
	__typename: "ProductReviewReactionEdge",
	node: GraphQLTypes["ProductReviewReaction"]
};
	["BlogPostConnection"]: {
	__typename: "BlogPostConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostEdge"]>
};
	["BlogPostEdge"]: {
	__typename: "BlogPostEdge",
	node: GraphQLTypes["BlogPost"]
};
	["ContactFormMessageConnection"]: {
	__typename: "ContactFormMessageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContactFormMessageEdge"]>
};
	["ContactFormMessageEdge"]: {
	__typename: "ContactFormMessageEdge",
	node: GraphQLTypes["ContactFormMessage"]
};
	["BugReportConnection"]: {
	__typename: "BugReportConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BugReportEdge"]>
};
	["BugReportEdge"]: {
	__typename: "BugReportEdge",
	node: GraphQLTypes["BugReport"]
};
	["ProtectedActionConnection"]: {
	__typename: "ProtectedActionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProtectedActionEdge"]>
};
	["ProtectedActionEdge"]: {
	__typename: "ProtectedActionEdge",
	node: GraphQLTypes["ProtectedAction"]
};
	["Score"]: {
	__typename: "Score",
	_meta?: GraphQLTypes["ScoreMeta"],
	id: GraphQLTypes["UUID"],
	label?: string,
	productReviews: Array<GraphQLTypes["ProductReview"]>,
	starsAmount?: number,
	remoteId: string,
	productReviewsByProductReviewReactions?: GraphQLTypes["ProductReview"],
	productReviewsByStats?: GraphQLTypes["ProductReview"],
	paginateProductReviews: GraphQLTypes["ProductReviewConnection"]
};
	["ScoreMeta"]: {
	__typename: "ScoreMeta",
	id?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	productReviews?: GraphQLTypes["FieldMeta"],
	starsAmount?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"]
};
	["ScoreProductReviewsByProductReviewReactionsUniqueWhere"]: {
		productReviewReactions?: GraphQLTypes["ProductReviewReactionUniqueWhere"]
};
	["ScoreProductReviewsByStatsUniqueWhere"]: {
		stats?: GraphQLTypes["ProductReviewStatsUniqueWhere"]
};
	["ProductReviewStats"]: {
	__typename: "ProductReviewStats",
	_meta?: GraphQLTypes["ProductReviewStatsMeta"],
	id: GraphQLTypes["UUID"],
	total: number,
	positive: number,
	negative: number,
	productReview?: GraphQLTypes["ProductReview"]
};
	["ProductReviewStatsMeta"]: {
	__typename: "ProductReviewStatsMeta",
	id?: GraphQLTypes["FieldMeta"],
	total?: GraphQLTypes["FieldMeta"],
	positive?: GraphQLTypes["FieldMeta"],
	negative?: GraphQLTypes["FieldMeta"],
	productReview?: GraphQLTypes["FieldMeta"]
};
	["ProductReviewProductReviewReactionsByUserUniqueWhere"]: {
		user?: GraphQLTypes["UserUniqueWhere"]
};
	["AgeDogsByReproductionUniqueWhere"]: {
		reproduction?: GraphQLTypes["DogReproductionUniqueWhere"]
};
	["AgeDogsByAvatarUniqueWhere"]: {
		avatar?: GraphQLTypes["ImageUniqueWhere"]
};
	["AgeProductReviewsByProductReviewReactionsUniqueWhere"]: {
		productReviewReactions?: GraphQLTypes["ProductReviewReactionUniqueWhere"]
};
	["AgeProductReviewsByStatsUniqueWhere"]: {
		stats?: GraphQLTypes["ProductReviewStatsUniqueWhere"]
};
	["AgeBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"]: {
		blogPostReviewReactions?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"]
};
	["AgeBlogPostReviewsByStatsUniqueWhere"]: {
		stats?: GraphQLTypes["BlogPostReviewStatsUniqueWhere"]
};
	["SuitabilityCategoryConnection"]: {
	__typename: "SuitabilityCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SuitabilityCategoryEdge"]>
};
	["SuitabilityCategoryEdge"]: {
	__typename: "SuitabilityCategoryEdge",
	node: GraphQLTypes["SuitabilityCategory"]
};
	["DogBodyType"]: {
	__typename: "DogBodyType",
	_meta?: GraphQLTypes["DogBodyTypeMeta"],
	id: GraphQLTypes["UUID"],
	name?: string,
	lead?: string,
	dogs: Array<GraphQLTypes["Dog"]>,
	order: number,
	value: number,
	remoteId: string,
	category?: GraphQLTypes["DogBodyTypeCategory"],
	imageMain?: GraphQLTypes["Image"],
	imageFrom?: GraphQLTypes["Image"],
	imageTo?: GraphQLTypes["Image"],
	dogsByReproduction?: GraphQLTypes["Dog"],
	dogsByAvatar?: GraphQLTypes["Dog"],
	paginateDogs: GraphQLTypes["DogConnection"]
};
	["DogBodyTypeMeta"]: {
	__typename: "DogBodyTypeMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	dogs?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	value?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	category?: GraphQLTypes["FieldMeta"],
	imageMain?: GraphQLTypes["FieldMeta"],
	imageFrom?: GraphQLTypes["FieldMeta"],
	imageTo?: GraphQLTypes["FieldMeta"]
};
	["DogBodyTypeCategory"]: {
	__typename: "DogBodyTypeCategory",
	_meta?: GraphQLTypes["DogBodyTypeCategoryMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	items: Array<GraphQLTypes["DogBodyType"]>,
	remoteId: string,
	imageMain?: GraphQLTypes["Image"],
	itemsByRemoteId?: GraphQLTypes["DogBodyType"],
	itemsByDogs?: GraphQLTypes["DogBodyType"],
	itemsByImageMain?: GraphQLTypes["DogBodyType"],
	itemsByImageFrom?: GraphQLTypes["DogBodyType"],
	itemsByImageTo?: GraphQLTypes["DogBodyType"],
	paginateItems: GraphQLTypes["DogBodyTypeConnection"]
};
	["DogBodyTypeCategoryMeta"]: {
	__typename: "DogBodyTypeCategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	imageMain?: GraphQLTypes["FieldMeta"]
};
	["DogBodyTypeCategoryItemsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["DogBodyTypeCategoryItemsByDogsUniqueWhere"]: {
		dogs?: GraphQLTypes["DogUniqueWhere"]
};
	["DogBodyTypeCategoryItemsByImageMainUniqueWhere"]: {
		imageMain?: GraphQLTypes["ImageUniqueWhere"]
};
	["DogBodyTypeCategoryItemsByImageFromUniqueWhere"]: {
		imageFrom?: GraphQLTypes["ImageUniqueWhere"]
};
	["DogBodyTypeCategoryItemsByImageToUniqueWhere"]: {
		imageTo?: GraphQLTypes["ImageUniqueWhere"]
};
	["DogBodyTypeConnection"]: {
	__typename: "DogBodyTypeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DogBodyTypeEdge"]>
};
	["DogBodyTypeEdge"]: {
	__typename: "DogBodyTypeEdge",
	node: GraphQLTypes["DogBodyType"]
};
	["DogBodyTypeDogsByReproductionUniqueWhere"]: {
		reproduction?: GraphQLTypes["DogReproductionUniqueWhere"]
};
	["DogBodyTypeDogsByAvatarUniqueWhere"]: {
		avatar?: GraphQLTypes["ImageUniqueWhere"]
};
	["DogReproduction"]: {
	__typename: "DogReproduction",
	_meta?: GraphQLTypes["DogReproductionMeta"],
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["DogReproductionType"],
	breastfeedingPuppyCount?: number,
	pregnancy?: GraphQLTypes["PregnantPeriodType"],
	dog?: GraphQLTypes["Dog"],
	breastfeedingCategory?: GraphQLTypes["BreastfeedingCategory"]
};
	["DogReproductionMeta"]: {
	__typename: "DogReproductionMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	breastfeedingPuppyCount?: GraphQLTypes["FieldMeta"],
	pregnancy?: GraphQLTypes["FieldMeta"],
	dog?: GraphQLTypes["FieldMeta"],
	breastfeedingCategory?: GraphQLTypes["FieldMeta"]
};
	["BreastfeedingCategory"]: {
	__typename: "BreastfeedingCategory",
	_meta?: GraphQLTypes["BreastfeedingCategoryMeta"],
	id: GraphQLTypes["UUID"],
	week: number,
	coeficient: number,
	dogs: Array<GraphQLTypes["DogReproduction"]>,
	dogsByDog?: GraphQLTypes["DogReproduction"],
	paginateDogs: GraphQLTypes["DogReproductionConnection"]
};
	["BreastfeedingCategoryMeta"]: {
	__typename: "BreastfeedingCategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	week?: GraphQLTypes["FieldMeta"],
	coeficient?: GraphQLTypes["FieldMeta"],
	dogs?: GraphQLTypes["FieldMeta"]
};
	["BreastfeedingCategoryDogsByDogUniqueWhere"]: {
		dog?: GraphQLTypes["DogUniqueWhere"]
};
	["DogReproductionConnection"]: {
	__typename: "DogReproductionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DogReproductionEdge"]>
};
	["DogReproductionEdge"]: {
	__typename: "DogReproductionEdge",
	node: GraphQLTypes["DogReproduction"]
};
	["ItemSubCategoryConnection"]: {
	__typename: "ItemSubCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ItemSubCategoryEdge"]>
};
	["ItemSubCategoryEdge"]: {
	__typename: "ItemSubCategoryEdge",
	node: GraphQLTypes["ItemSubCategory"]
};
	["BodyTagConnection"]: {
	__typename: "BodyTagConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BodyTagEdge"]>
};
	["BodyTagEdge"]: {
	__typename: "BodyTagEdge",
	node: GraphQLTypes["BodyTag"]
};
	["Review"]: {
	__typename: "Review",
	_meta?: GraphQLTypes["ReviewMeta"],
	id: GraphQLTypes["UUID"],
	dogBreeds: Array<GraphQLTypes["Breed"]>,
	text: string,
	remoteId: string,
	author?: string,
	paginateDogBreeds: GraphQLTypes["BreedConnection"]
};
	["ReviewMeta"]: {
	__typename: "ReviewMeta",
	id?: GraphQLTypes["FieldMeta"],
	dogBreeds?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	author?: GraphQLTypes["FieldMeta"]
};
	["ReviewOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	author?: GraphQLTypes["OrderDirection"]
};
	["FilterComboOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	breed?: GraphQLTypes["BreedOrderBy"],
	brand?: GraphQLTypes["BrandOrderBy"],
	region?: GraphQLTypes["RegionOrderBy"],
	ageCategory?: GraphQLTypes["AgeCategoryOrderBy"],
	treatment?: GraphQLTypes["BodyTagOrderBy"],
	flavor?: GraphQLTypes["ItemSubCategoryOrderBy"],
	allergy?: GraphQLTypes["ItemSubCategoryOrderBy"]
};
	["AgeCategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	labelFor?: GraphQLTypes["OrderDirection"],
	slug?: GraphQLTypes["OrderDirection"]
};
	["BreedDogsByReproductionUniqueWhere"]: {
		reproduction?: GraphQLTypes["DogReproductionUniqueWhere"]
};
	["BreedDogsByAvatarUniqueWhere"]: {
		avatar?: GraphQLTypes["ImageUniqueWhere"]
};
	["BreedProductReviewsByProductReviewReactionsUniqueWhere"]: {
		productReviewReactions?: GraphQLTypes["ProductReviewReactionUniqueWhere"]
};
	["BreedProductReviewsByStatsUniqueWhere"]: {
		stats?: GraphQLTypes["ProductReviewStatsUniqueWhere"]
};
	["BreedBlogPostReviewsByBlogPostReviewReactionsUniqueWhere"]: {
		blogPostReviewReactions?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"]
};
	["BreedBlogPostReviewsByStatsUniqueWhere"]: {
		stats?: GraphQLTypes["BlogPostReviewStatsUniqueWhere"]
};
	["BreedFilterCombosByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["BreedFilterCombosBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ReviewConnection"]: {
	__typename: "ReviewConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ReviewEdge"]>
};
	["ReviewEdge"]: {
	__typename: "ReviewEdge",
	node: GraphQLTypes["Review"]
};
	["FilterComboConnection"]: {
	__typename: "FilterComboConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FilterComboEdge"]>
};
	["FilterComboEdge"]: {
	__typename: "FilterComboEdge",
	node: GraphQLTypes["FilterCombo"]
};
	["AgeCategory"]: {
	__typename: "AgeCategory",
	_meta?: GraphQLTypes["AgeCategoryMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	order?: number,
	labelFor: string,
	products: Array<GraphQLTypes["Product"]>,
	slug?: string,
	filterCombos: Array<GraphQLTypes["FilterCombo"]>,
	filterCombosByRemoteId?: GraphQLTypes["FilterCombo"],
	filterCombosBySeo?: GraphQLTypes["FilterCombo"],
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateFilterCombos: GraphQLTypes["FilterComboConnection"]
};
	["AgeCategoryMeta"]: {
	__typename: "AgeCategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	labelFor?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	filterCombos?: GraphQLTypes["FieldMeta"]
};
	["AgeCategoryFilterCombosByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["AgeCategoryFilterCombosBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["RegionCountriesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["RegionCountriesByManufacturersUniqueWhere"]: {
		manufacturers?: GraphQLTypes["BrandManufacturerUniqueWhere"]
};
	["BrandManufacturerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["RegionFilterCombosByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["RegionFilterCombosBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["CountryConnection"]: {
	__typename: "CountryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CountryEdge"]>
};
	["CountryEdge"]: {
	__typename: "CountryEdge",
	node: GraphQLTypes["Country"]
};
	["CountryManufacturersByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["BrandManufacturerConnection"]: {
	__typename: "BrandManufacturerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BrandManufacturerEdge"]>
};
	["BrandManufacturerEdge"]: {
	__typename: "BrandManufacturerEdge",
	node: GraphQLTypes["BrandManufacturer"]
};
	["ProductLine"]: {
	__typename: "ProductLine",
	_meta?: GraphQLTypes["ProductLineMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	products: Array<GraphQLTypes["Product"]>,
	remoteId: string,
	lead?: string,
	order?: number,
	brand?: GraphQLTypes["Brand"],
	logo?: GraphQLTypes["Image"],
	aliases: Array<GraphQLTypes["ProductLineAlias"]>,
	slug?: string,
	flavors: Array<GraphQLTypes["ProductLineFlavor"]>,
	seo?: GraphQLTypes["Seo"],
	customMetaDescription?: string,
	productsByRemoteId?: GraphQLTypes["Product"],
	productsBySlug?: GraphQLTypes["Product"],
	productsByNutritionalValues?: GraphQLTypes["Product"],
	productsByReviews?: GraphQLTypes["Product"],
	productsByDogs?: GraphQLTypes["Product"],
	productsByPackagings?: GraphQLTypes["Product"],
	productsByElements?: GraphQLTypes["Product"],
	productsByFlags?: GraphQLTypes["Product"],
	productsByImage?: GraphQLTypes["Product"],
	productsByAliases?: GraphQLTypes["Product"],
	productsByEvaluation?: GraphQLTypes["Product"],
	productsBySeo?: GraphQLTypes["Product"],
	productsByItemDeclensionFourthCategories?: GraphQLTypes["Product"],
	productsByHeurekaImage?: GraphQLTypes["Product"],
	productsByTopx?: GraphQLTypes["Product"],
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateAliases: GraphQLTypes["ProductLineAliasConnection"],
	paginateFlavors: GraphQLTypes["ProductLineFlavorConnection"]
};
	["ProductLineMeta"]: {
	__typename: "ProductLineMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	brand?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	aliases?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	flavors?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	customMetaDescription?: GraphQLTypes["FieldMeta"]
};
	["ProductLineAlias"]: {
	__typename: "ProductLineAlias",
	_meta?: GraphQLTypes["ProductLineAliasMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	name: string,
	productLines: Array<GraphQLTypes["ProductLine"]>,
	paginateProductLines: GraphQLTypes["ProductLineConnection"]
};
	["ProductLineAliasMeta"]: {
	__typename: "ProductLineAliasMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	productLines?: GraphQLTypes["FieldMeta"]
};
	["ProductLineConnection"]: {
	__typename: "ProductLineConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductLineEdge"]>
};
	["ProductLineEdge"]: {
	__typename: "ProductLineEdge",
	node: GraphQLTypes["ProductLine"]
};
	["ProductLineAliasOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"]
};
	["ProductLineFlavor"]: {
	__typename: "ProductLineFlavor",
	_meta?: GraphQLTypes["ProductLineFlavorMeta"],
	id?: string,
	itemSubCategory?: GraphQLTypes["ItemSubCategory"],
	productLine?: GraphQLTypes["ProductLine"]
};
	["ProductLineFlavorMeta"]: {
	__typename: "ProductLineFlavorMeta",
	id?: GraphQLTypes["FieldMeta"],
	itemSubCategory?: GraphQLTypes["FieldMeta"],
	productLine?: GraphQLTypes["FieldMeta"]
};
	["ProductLineFlavorOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	itemSubCategory?: GraphQLTypes["ItemSubCategoryOrderBy"],
	productLine?: GraphQLTypes["ProductLineOrderBy"]
};
	["ProductLineProductsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ProductLineProductsBySlugUniqueWhere"]: {
		slug?: string
};
	["ProductLineProductsByNutritionalValuesUniqueWhere"]: {
		nutritionalValues?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"]
};
	["ProductLineProductsByReviewsUniqueWhere"]: {
		reviews?: GraphQLTypes["ProductReviewUniqueWhere"]
};
	["ProductLineProductsByDogsUniqueWhere"]: {
		dogs?: GraphQLTypes["DogUniqueWhere"]
};
	["ProductLineProductsByPackagingsUniqueWhere"]: {
		packagings?: GraphQLTypes["ProductPackageUniqueWhere"]
};
	["ProductLineProductsByElementsUniqueWhere"]: {
		elements?: GraphQLTypes["ElementOfProductUniqueWhere"]
};
	["ProductLineProductsByFlagsUniqueWhere"]: {
		flags?: GraphQLTypes["ProductFlagOfProductUniqueWhere"]
};
	["ProductLineProductsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["ProductLineProductsByAliasesUniqueWhere"]: {
		aliases?: GraphQLTypes["ProductAliasUniqueWhere"]
};
	["ProductLineProductsByEvaluationUniqueWhere"]: {
		evaluation?: GraphQLTypes["ProductEvaluationUniqueWhere"]
};
	["ProductLineProductsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ProductLineProductsByItemDeclensionFourthCategoriesUniqueWhere"]: {
		itemDeclensionFourthCategories?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"]
};
	["ProductLineProductsByHeurekaImageUniqueWhere"]: {
		heurekaImage?: GraphQLTypes["ImageUniqueWhere"]
};
	["ProductLineProductsByTopxUniqueWhere"]: {
		topx?: GraphQLTypes["TOPXProductUniqueWhere"]
};
	["ProductLineAliasConnection"]: {
	__typename: "ProductLineAliasConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductLineAliasEdge"]>
};
	["ProductLineAliasEdge"]: {
	__typename: "ProductLineAliasEdge",
	node: GraphQLTypes["ProductLineAlias"]
};
	["ProductLineFlavorConnection"]: {
	__typename: "ProductLineFlavorConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductLineFlavorEdge"]>
};
	["ProductLineFlavorEdge"]: {
	__typename: "ProductLineFlavorEdge",
	node: GraphQLTypes["ProductLineFlavor"]
};
	["ProductionMethod"]: {
	__typename: "ProductionMethod",
	_meta?: GraphQLTypes["ProductionMethodMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	brands: Array<GraphQLTypes["Brand"]>,
	remoteId: string,
	brandsByRemoteId?: GraphQLTypes["Brand"],
	brandsBySlug?: GraphQLTypes["Brand"],
	brandsByProducts?: GraphQLTypes["Brand"],
	brandsByProductLines?: GraphQLTypes["Brand"],
	brandsByLogo?: GraphQLTypes["Brand"],
	brandsByAliases?: GraphQLTypes["Brand"],
	brandsByFlavors?: GraphQLTypes["Brand"],
	brandsBySeo?: GraphQLTypes["Brand"],
	brandsByFilterCombos?: GraphQLTypes["Brand"],
	brandsByTopx?: GraphQLTypes["Brand"],
	brandsByContent?: GraphQLTypes["Brand"],
	brandsByDraft?: GraphQLTypes["Brand"],
	paginateBrands: GraphQLTypes["BrandConnection"]
};
	["ProductionMethodMeta"]: {
	__typename: "ProductionMethodMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	brands?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"]
};
	["ProductionMethodBrandsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ProductionMethodBrandsBySlugUniqueWhere"]: {
		slug?: string
};
	["ProductionMethodBrandsByProductsUniqueWhere"]: {
		products?: GraphQLTypes["ProductUniqueWhere"]
};
	["ProductionMethodBrandsByProductLinesUniqueWhere"]: {
		productLines?: GraphQLTypes["ProductLineUniqueWhere"]
};
	["ProductLineUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	slug?: string,
	products?: GraphQLTypes["ProductUniqueWhere"],
	logo?: GraphQLTypes["ImageUniqueWhere"],
	flavors?: GraphQLTypes["ProductLineFlavorUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ProductLineFlavorUniqueWhere"]: {
		id?: string
};
	["ProductionMethodBrandsByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"]
};
	["ProductionMethodBrandsByAliasesUniqueWhere"]: {
		aliases?: GraphQLTypes["BrandAliasUniqueWhere"]
};
	["BrandAliasUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["ProductionMethodBrandsByFlavorsUniqueWhere"]: {
		flavors?: GraphQLTypes["BrandFlavorUniqueWhere"]
};
	["BrandFlavorUniqueWhere"]: {
		id?: string
};
	["ProductionMethodBrandsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ProductionMethodBrandsByFilterCombosUniqueWhere"]: {
		filterCombos?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["ProductionMethodBrandsByTopxUniqueWhere"]: {
		topx?: GraphQLTypes["TOPXBrandUniqueWhere"]
};
	["TOPXBrandUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["ProductionMethodBrandsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["ProductionMethodBrandsByDraftUniqueWhere"]: {
		draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["BrandDistributor"]: {
	__typename: "BrandDistributor",
	_meta?: GraphQLTypes["BrandDistributorMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	brands: Array<GraphQLTypes["Brand"]>,
	link?: string,
	remoteId: string,
	brandsByRemoteId?: GraphQLTypes["Brand"],
	brandsBySlug?: GraphQLTypes["Brand"],
	brandsByProducts?: GraphQLTypes["Brand"],
	brandsByProductLines?: GraphQLTypes["Brand"],
	brandsByLogo?: GraphQLTypes["Brand"],
	brandsByAliases?: GraphQLTypes["Brand"],
	brandsByFlavors?: GraphQLTypes["Brand"],
	brandsBySeo?: GraphQLTypes["Brand"],
	brandsByFilterCombos?: GraphQLTypes["Brand"],
	brandsByTopx?: GraphQLTypes["Brand"],
	brandsByContent?: GraphQLTypes["Brand"],
	brandsByDraft?: GraphQLTypes["Brand"],
	paginateBrands: GraphQLTypes["BrandConnection"]
};
	["BrandDistributorMeta"]: {
	__typename: "BrandDistributorMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	brands?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"]
};
	["BrandDistributorBrandsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["BrandDistributorBrandsBySlugUniqueWhere"]: {
		slug?: string
};
	["BrandDistributorBrandsByProductsUniqueWhere"]: {
		products?: GraphQLTypes["ProductUniqueWhere"]
};
	["BrandDistributorBrandsByProductLinesUniqueWhere"]: {
		productLines?: GraphQLTypes["ProductLineUniqueWhere"]
};
	["BrandDistributorBrandsByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"]
};
	["BrandDistributorBrandsByAliasesUniqueWhere"]: {
		aliases?: GraphQLTypes["BrandAliasUniqueWhere"]
};
	["BrandDistributorBrandsByFlavorsUniqueWhere"]: {
		flavors?: GraphQLTypes["BrandFlavorUniqueWhere"]
};
	["BrandDistributorBrandsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["BrandDistributorBrandsByFilterCombosUniqueWhere"]: {
		filterCombos?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["BrandDistributorBrandsByTopxUniqueWhere"]: {
		topx?: GraphQLTypes["TOPXBrandUniqueWhere"]
};
	["BrandDistributorBrandsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["BrandDistributorBrandsByDraftUniqueWhere"]: {
		draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["BrandAlias"]: {
	__typename: "BrandAlias",
	_meta?: GraphQLTypes["BrandAliasMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	name: string,
	brand?: GraphQLTypes["Brand"]
};
	["BrandAliasMeta"]: {
	__typename: "BrandAliasMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	brand?: GraphQLTypes["FieldMeta"]
};
	["BrandAliasOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	brand?: GraphQLTypes["BrandOrderBy"]
};
	["BrandFlavor"]: {
	__typename: "BrandFlavor",
	_meta?: GraphQLTypes["BrandFlavorMeta"],
	id?: string,
	brand?: GraphQLTypes["Brand"],
	itemSubCategory?: GraphQLTypes["ItemSubCategory"]
};
	["BrandFlavorMeta"]: {
	__typename: "BrandFlavorMeta",
	id?: GraphQLTypes["FieldMeta"],
	brand?: GraphQLTypes["FieldMeta"],
	itemSubCategory?: GraphQLTypes["FieldMeta"]
};
	["BrandFlavorOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	brand?: GraphQLTypes["BrandOrderBy"],
	itemSubCategory?: GraphQLTypes["ItemSubCategoryOrderBy"]
};
	["TOPXBrand"]: {
	__typename: "TOPXBrand",
	_meta?: GraphQLTypes["TOPXBrandMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	order: number,
	orderType: GraphQLTypes["TOPXBrandOrderType"],
	brand?: GraphQLTypes["Brand"],
	category?: GraphQLTypes["TOPXBrandCategory"]
};
	["TOPXBrandMeta"]: {
	__typename: "TOPXBrandMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	orderType?: GraphQLTypes["FieldMeta"],
	brand?: GraphQLTypes["FieldMeta"],
	category?: GraphQLTypes["FieldMeta"]
};
	["TOPXBrandCategory"]: {
	__typename: "TOPXBrandCategory",
	_meta?: GraphQLTypes["TOPXBrandCategoryMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	brands: Array<GraphQLTypes["TOPXBrand"]>,
	brandsByRemoteId?: GraphQLTypes["TOPXBrand"],
	paginateBrands: GraphQLTypes["TOPXBrandConnection"]
};
	["TOPXBrandCategoryMeta"]: {
	__typename: "TOPXBrandCategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	brands?: GraphQLTypes["FieldMeta"]
};
	["TOPXBrandOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	orderType?: GraphQLTypes["OrderDirection"],
	brand?: GraphQLTypes["BrandOrderBy"],
	category?: GraphQLTypes["TOPXBrandCategoryOrderBy"]
};
	["TOPXBrandCategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"]
};
	["TOPXBrandCategoryBrandsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["TOPXBrandConnection"]: {
	__typename: "TOPXBrandConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TOPXBrandEdge"]>
};
	["TOPXBrandEdge"]: {
	__typename: "TOPXBrandEdge",
	node: GraphQLTypes["TOPXBrand"]
};
	["BrandProductsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["BrandProductsBySlugUniqueWhere"]: {
		slug?: string
};
	["BrandProductsByNutritionalValuesUniqueWhere"]: {
		nutritionalValues?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"]
};
	["BrandProductsByReviewsUniqueWhere"]: {
		reviews?: GraphQLTypes["ProductReviewUniqueWhere"]
};
	["BrandProductsByDogsUniqueWhere"]: {
		dogs?: GraphQLTypes["DogUniqueWhere"]
};
	["BrandProductsByPackagingsUniqueWhere"]: {
		packagings?: GraphQLTypes["ProductPackageUniqueWhere"]
};
	["BrandProductsByElementsUniqueWhere"]: {
		elements?: GraphQLTypes["ElementOfProductUniqueWhere"]
};
	["BrandProductsByFlagsUniqueWhere"]: {
		flags?: GraphQLTypes["ProductFlagOfProductUniqueWhere"]
};
	["BrandProductsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["BrandProductsByAliasesUniqueWhere"]: {
		aliases?: GraphQLTypes["ProductAliasUniqueWhere"]
};
	["BrandProductsByEvaluationUniqueWhere"]: {
		evaluation?: GraphQLTypes["ProductEvaluationUniqueWhere"]
};
	["BrandProductsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["BrandProductsByItemDeclensionFourthCategoriesUniqueWhere"]: {
		itemDeclensionFourthCategories?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"]
};
	["BrandProductsByHeurekaImageUniqueWhere"]: {
		heurekaImage?: GraphQLTypes["ImageUniqueWhere"]
};
	["BrandProductsByTopxUniqueWhere"]: {
		topx?: GraphQLTypes["TOPXProductUniqueWhere"]
};
	["BrandProductLinesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["BrandProductLinesBySlugUniqueWhere"]: {
		slug?: string
};
	["BrandProductLinesByProductsUniqueWhere"]: {
		products?: GraphQLTypes["ProductUniqueWhere"]
};
	["BrandProductLinesByLogoUniqueWhere"]: {
		logo?: GraphQLTypes["ImageUniqueWhere"]
};
	["BrandProductLinesByFlavorsUniqueWhere"]: {
		flavors?: GraphQLTypes["ProductLineFlavorUniqueWhere"]
};
	["BrandProductLinesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["BrandAliasesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["BrandFilterCombosByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["BrandFilterCombosBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["BrandTopxByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["BrandAliasConnection"]: {
	__typename: "BrandAliasConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BrandAliasEdge"]>
};
	["BrandAliasEdge"]: {
	__typename: "BrandAliasEdge",
	node: GraphQLTypes["BrandAlias"]
};
	["AdConnection"]: {
	__typename: "AdConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AdEdge"]>
};
	["AdEdge"]: {
	__typename: "AdEdge",
	node: GraphQLTypes["Ad"]
};
	["BrandFlavorConnection"]: {
	__typename: "BrandFlavorConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BrandFlavorEdge"]>
};
	["BrandFlavorEdge"]: {
	__typename: "BrandFlavorEdge",
	node: GraphQLTypes["BrandFlavor"]
};
	["AdContentReferencesByImagesUniqueWhere"]: {
		images?: GraphQLTypes["ContentReferenceGalleryImageUniqueWhere"]
};
	["AdContentReferencesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["AdContentReferencesByListUniqueWhere"]: {
		list?: GraphQLTypes["ContentReferenceListUniqueWhere"]
};
	["AdContentReferencesByOutlineUniqueWhere"]: {
		outline?: GraphQLTypes["ContentLinksUniqueWhere"]
};
	["AdContentReferencesByVideoUniqueWhere"]: {
		video?: GraphQLTypes["VideoUniqueWhere"]
};
	["AdContentReferencesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ContentReferenceImageUniqueWhere"]
};
	["ItemCategoryConnection"]: {
	__typename: "ItemCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ItemCategoryEdge"]>
};
	["ItemCategoryEdge"]: {
	__typename: "ItemCategoryEdge",
	node: GraphQLTypes["ItemCategory"]
};
	["ContentReferenceConnection"]: {
	__typename: "ContentReferenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
	__typename: "ContentReferenceEdge",
	node: GraphQLTypes["ContentReference"]
};
	["ItemDeclensionFourthVariant"]: {
	__typename: "ItemDeclensionFourthVariant",
	_meta?: GraphQLTypes["ItemDeclensionFourthVariantMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["Item"]>,
	label: string,
	remoteId: string,
	declensionSeventh?: string,
	isNegativ?: boolean,
	seo?: GraphQLTypes["Seo"],
	subcategory?: GraphQLTypes["ItemSubCategory"],
	category?: GraphQLTypes["ItemCategory"],
	element?: GraphQLTypes["Element"],
	products: Array<GraphQLTypes["ProductItemDeclensionFourthCategory"]>,
	slug: string,
	content?: GraphQLTypes["Content"],
	draft?: GraphQLTypes["Content"],
	itemsByRemoteId?: GraphQLTypes["Item"],
	itemsBySlug?: GraphQLTypes["Item"],
	itemsByFeaturesOfProduct?: GraphQLTypes["Item"],
	itemsByImage?: GraphQLTypes["Item"],
	itemsByReferenceList?: GraphQLTypes["Item"],
	itemsBySeo?: GraphQLTypes["Item"],
	itemsByAliases?: GraphQLTypes["Item"],
	itemsByContent?: GraphQLTypes["Item"],
	itemsByDraft?: GraphQLTypes["Item"],
	paginateItems: GraphQLTypes["ItemConnection"],
	paginateProducts: GraphQLTypes["ProductItemDeclensionFourthCategoryConnection"]
};
	["ItemDeclensionFourthVariantMeta"]: {
	__typename: "ItemDeclensionFourthVariantMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	declensionSeventh?: GraphQLTypes["FieldMeta"],
	isNegativ?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	subcategory?: GraphQLTypes["FieldMeta"],
	category?: GraphQLTypes["FieldMeta"],
	element?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	draft?: GraphQLTypes["FieldMeta"]
};
	["ProductItemDeclensionFourthCategory"]: {
	__typename: "ProductItemDeclensionFourthCategory",
	_meta?: GraphQLTypes["ProductItemDeclensionFourthCategoryMeta"],
	id?: string,
	declensionFourthCategory?: GraphQLTypes["ItemDeclensionFourthVariant"],
	product?: GraphQLTypes["Product"]
};
	["ProductItemDeclensionFourthCategoryMeta"]: {
	__typename: "ProductItemDeclensionFourthCategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	declensionFourthCategory?: GraphQLTypes["FieldMeta"],
	product?: GraphQLTypes["FieldMeta"]
};
	["ProductItemDeclensionFourthCategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	declensionFourthCategory?: GraphQLTypes["ItemDeclensionFourthVariantOrderBy"],
	product?: GraphQLTypes["ProductOrderBy"]
};
	["ItemDeclensionFourthVariantItemsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ItemDeclensionFourthVariantItemsBySlugUniqueWhere"]: {
		slug?: string
};
	["ItemDeclensionFourthVariantItemsByFeaturesOfProductUniqueWhere"]: {
		featuresOfProduct?: GraphQLTypes["ProductFeatureUniqueWhere"]
};
	["ItemDeclensionFourthVariantItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["ItemDeclensionFourthVariantItemsByReferenceListUniqueWhere"]: {
		referenceList?: GraphQLTypes["ReferenceListUniqueWhere"]
};
	["ItemDeclensionFourthVariantItemsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ItemDeclensionFourthVariantItemsByAliasesUniqueWhere"]: {
		aliases?: GraphQLTypes["ItemAliasUniqueWhere"]
};
	["ItemDeclensionFourthVariantItemsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["ItemDeclensionFourthVariantItemsByDraftUniqueWhere"]: {
		draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["ItemConnection"]: {
	__typename: "ItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ItemEdge"]>
};
	["ItemEdge"]: {
	__typename: "ItemEdge",
	node: GraphQLTypes["Item"]
};
	["ProductItemDeclensionFourthCategoryConnection"]: {
	__typename: "ProductItemDeclensionFourthCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductItemDeclensionFourthCategoryEdge"]>
};
	["ProductItemDeclensionFourthCategoryEdge"]: {
	__typename: "ProductItemDeclensionFourthCategoryEdge",
	node: GraphQLTypes["ProductItemDeclensionFourthCategory"]
};
	["ItemGroup"]: {
	__typename: "ItemGroup",
	_meta?: GraphQLTypes["ItemGroupMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	name: string,
	categories: Array<GraphQLTypes["ItemCategory"]>,
	categoriesByRemoteId?: GraphQLTypes["ItemCategory"],
	categoriesBySlug?: GraphQLTypes["ItemCategory"],
	categoriesBySubCategories?: GraphQLTypes["ItemCategory"],
	categoriesByFeatureDependencies?: GraphQLTypes["ItemCategory"],
	categoriesByImage?: GraphQLTypes["ItemCategory"],
	categoriesByRedirects?: GraphQLTypes["ItemCategory"],
	categoriesByDeclensionsFourth?: GraphQLTypes["ItemCategory"],
	categoriesBySeo?: GraphQLTypes["ItemCategory"],
	categoriesByContent?: GraphQLTypes["ItemCategory"],
	categoriesByDraft?: GraphQLTypes["ItemCategory"],
	paginateCategories: GraphQLTypes["ItemCategoryConnection"]
};
	["ItemGroupMeta"]: {
	__typename: "ItemGroupMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	categories?: GraphQLTypes["FieldMeta"]
};
	["ItemGroupCategoriesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ItemGroupCategoriesBySlugUniqueWhere"]: {
		slug?: string
};
	["ItemGroupCategoriesBySubCategoriesUniqueWhere"]: {
		subCategories?: GraphQLTypes["ItemSubCategoryUniqueWhere"]
};
	["ItemSubCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	slug?: string,
	featureDependencies?: GraphQLTypes["ProductFeatureUniqueWhere"],
	brands?: GraphQLTypes["BrandFlavorUniqueWhere"],
	productLines?: GraphQLTypes["ProductLineFlavorUniqueWhere"],
	filterCombosFlavor?: GraphQLTypes["FilterComboUniqueWhere"],
	filterCombosAllergy?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["ItemGroupCategoriesByFeatureDependenciesUniqueWhere"]: {
		featureDependencies?: GraphQLTypes["ProductFeatureUniqueWhere"]
};
	["ItemGroupCategoriesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["ItemGroupCategoriesByRedirectsUniqueWhere"]: {
		redirects?: GraphQLTypes["RedirectUniqueWhere"]
};
	["ItemGroupCategoriesByDeclensionsFourthUniqueWhere"]: {
		declensionsFourth?: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"]
};
	["ItemDeclensionFourthVariantUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	slug?: string,
	items?: GraphQLTypes["ItemUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	subcategory?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	element?: GraphQLTypes["ElementUniqueWhere"],
	products?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["ElementUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	products?: GraphQLTypes["ElementOfProductUniqueWhere"],
	featureDependencies?: GraphQLTypes["ProductFeatureUniqueWhere"],
	suitabilityElements?: GraphQLTypes["SuitabilityItemUniqueWhere"]
};
	["SuitabilityItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["ItemGroupCategoriesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ItemGroupCategoriesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["ItemGroupCategoriesByDraftUniqueWhere"]: {
		draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["ItemCategorySubCategoriesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ItemCategorySubCategoriesBySlugUniqueWhere"]: {
		slug?: string
};
	["ItemCategorySubCategoriesByFeatureDependenciesUniqueWhere"]: {
		featureDependencies?: GraphQLTypes["ProductFeatureUniqueWhere"]
};
	["ItemCategorySubCategoriesByBrandsUniqueWhere"]: {
		brands?: GraphQLTypes["BrandFlavorUniqueWhere"]
};
	["ItemCategorySubCategoriesByProductLinesUniqueWhere"]: {
		productLines?: GraphQLTypes["ProductLineFlavorUniqueWhere"]
};
	["ItemCategorySubCategoriesByFilterCombosFlavorUniqueWhere"]: {
		filterCombosFlavor?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["ItemCategorySubCategoriesByFilterCombosAllergyUniqueWhere"]: {
		filterCombosAllergy?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["ItemCategoryFeatureDependenciesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ItemCategoryRedirectsByFromUniqueWhere"]: {
		from?: string
};
	["ItemCategoryDeclensionsFourthByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ItemCategoryDeclensionsFourthBySlugUniqueWhere"]: {
		slug?: string
};
	["ItemCategoryDeclensionsFourthByItemsUniqueWhere"]: {
		items?: GraphQLTypes["ItemUniqueWhere"]
};
	["ItemCategoryDeclensionsFourthBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ItemCategoryDeclensionsFourthBySubcategoryUniqueWhere"]: {
		subcategory?: GraphQLTypes["ItemSubCategoryUniqueWhere"]
};
	["ItemCategoryDeclensionsFourthByElementUniqueWhere"]: {
		element?: GraphQLTypes["ElementUniqueWhere"]
};
	["ItemCategoryDeclensionsFourthByProductsUniqueWhere"]: {
		products?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"]
};
	["ItemCategoryDeclensionsFourthByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["ItemCategoryDeclensionsFourthByDraftUniqueWhere"]: {
		draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["ProductFeatureConnection"]: {
	__typename: "ProductFeatureConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductFeatureEdge"]>
};
	["ProductFeatureEdge"]: {
	__typename: "ProductFeatureEdge",
	node: GraphQLTypes["ProductFeature"]
};
	["RedirectConnection"]: {
	__typename: "RedirectConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RedirectEdge"]>
};
	["RedirectEdge"]: {
	__typename: "RedirectEdge",
	node: GraphQLTypes["Redirect"]
};
	["ItemDeclensionFourthVariantConnection"]: {
	__typename: "ItemDeclensionFourthVariantConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ItemDeclensionFourthVariantEdge"]>
};
	["ItemDeclensionFourthVariantEdge"]: {
	__typename: "ItemDeclensionFourthVariantEdge",
	node: GraphQLTypes["ItemDeclensionFourthVariant"]
};
	["ItemFlavorCategory"]: {
	__typename: "ItemFlavorCategory",
	_meta?: GraphQLTypes["ItemFlavorCategoryMeta"],
	id: GraphQLTypes["UUID"],
	name?: string,
	items: Array<GraphQLTypes["ItemSubCategory"]>,
	remoteId: string,
	color?: GraphQLTypes["Color"],
	itemsByRemoteId?: GraphQLTypes["ItemSubCategory"],
	itemsBySlug?: GraphQLTypes["ItemSubCategory"],
	itemsByFeatureDependencies?: GraphQLTypes["ItemSubCategory"],
	itemsByBrands?: GraphQLTypes["ItemSubCategory"],
	itemsByProductLines?: GraphQLTypes["ItemSubCategory"],
	itemsByFilterCombosFlavor?: GraphQLTypes["ItemSubCategory"],
	itemsByFilterCombosAllergy?: GraphQLTypes["ItemSubCategory"],
	paginateItems: GraphQLTypes["ItemSubCategoryConnection"]
};
	["ItemFlavorCategoryMeta"]: {
	__typename: "ItemFlavorCategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	color?: GraphQLTypes["FieldMeta"]
};
	["ItemFlavorCategoryItemsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ItemFlavorCategoryItemsBySlugUniqueWhere"]: {
		slug?: string
};
	["ItemFlavorCategoryItemsByFeatureDependenciesUniqueWhere"]: {
		featureDependencies?: GraphQLTypes["ProductFeatureUniqueWhere"]
};
	["ItemFlavorCategoryItemsByBrandsUniqueWhere"]: {
		brands?: GraphQLTypes["BrandFlavorUniqueWhere"]
};
	["ItemFlavorCategoryItemsByProductLinesUniqueWhere"]: {
		productLines?: GraphQLTypes["ProductLineFlavorUniqueWhere"]
};
	["ItemFlavorCategoryItemsByFilterCombosFlavorUniqueWhere"]: {
		filterCombosFlavor?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["ItemFlavorCategoryItemsByFilterCombosAllergyUniqueWhere"]: {
		filterCombosAllergy?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["ItemSubCategoryFeatureDependenciesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ItemSubCategoryFilterCombosFlavorByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ItemSubCategoryFilterCombosFlavorBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ItemSubCategoryFilterCombosAllergyByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ItemSubCategoryFilterCombosAllergyBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ReferenceList"]: {
	__typename: "ReferenceList",
	_meta?: GraphQLTypes["ReferenceListMeta"],
	id: GraphQLTypes["UUID"],
	references: Array<GraphQLTypes["Reference"]>,
	paginateReferences: GraphQLTypes["ReferenceConnection"]
};
	["ReferenceListMeta"]: {
	__typename: "ReferenceListMeta",
	id?: GraphQLTypes["FieldMeta"],
	references?: GraphQLTypes["FieldMeta"]
};
	["Reference"]: {
	__typename: "Reference",
	_meta?: GraphQLTypes["ReferenceMeta"],
	id: GraphQLTypes["UUID"],
	text?: string,
	link?: string,
	order?: number,
	list?: GraphQLTypes["ReferenceList"]
};
	["ReferenceMeta"]: {
	__typename: "ReferenceMeta",
	id?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"]
};
	["ReferenceOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ReferenceListOrderBy"]
};
	["ReferenceConnection"]: {
	__typename: "ReferenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ReferenceEdge"]>
};
	["ReferenceEdge"]: {
	__typename: "ReferenceEdge",
	node: GraphQLTypes["Reference"]
};
	["ItemDeclensionSeventhVariant"]: {
	__typename: "ItemDeclensionSeventhVariant",
	_meta?: GraphQLTypes["ItemDeclensionSeventhVariantMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["Item"]>,
	label: string,
	remoteId: string,
	itemsByRemoteId?: GraphQLTypes["Item"],
	itemsBySlug?: GraphQLTypes["Item"],
	itemsByFeaturesOfProduct?: GraphQLTypes["Item"],
	itemsByImage?: GraphQLTypes["Item"],
	itemsByReferenceList?: GraphQLTypes["Item"],
	itemsBySeo?: GraphQLTypes["Item"],
	itemsByAliases?: GraphQLTypes["Item"],
	itemsByContent?: GraphQLTypes["Item"],
	itemsByDraft?: GraphQLTypes["Item"],
	paginateItems: GraphQLTypes["ItemConnection"]
};
	["ItemDeclensionSeventhVariantMeta"]: {
	__typename: "ItemDeclensionSeventhVariantMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"]
};
	["ItemDeclensionSeventhVariantItemsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ItemDeclensionSeventhVariantItemsBySlugUniqueWhere"]: {
		slug?: string
};
	["ItemDeclensionSeventhVariantItemsByFeaturesOfProductUniqueWhere"]: {
		featuresOfProduct?: GraphQLTypes["ProductFeatureUniqueWhere"]
};
	["ItemDeclensionSeventhVariantItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["ItemDeclensionSeventhVariantItemsByReferenceListUniqueWhere"]: {
		referenceList?: GraphQLTypes["ReferenceListUniqueWhere"]
};
	["ItemDeclensionSeventhVariantItemsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ItemDeclensionSeventhVariantItemsByAliasesUniqueWhere"]: {
		aliases?: GraphQLTypes["ItemAliasUniqueWhere"]
};
	["ItemDeclensionSeventhVariantItemsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["ItemDeclensionSeventhVariantItemsByDraftUniqueWhere"]: {
		draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["ItemAlias"]: {
	__typename: "ItemAlias",
	_meta?: GraphQLTypes["ItemAliasMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	name: string,
	item?: GraphQLTypes["Item"]
};
	["ItemAliasMeta"]: {
	__typename: "ItemAliasMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	item?: GraphQLTypes["FieldMeta"]
};
	["ItemAliasOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	item?: GraphQLTypes["ItemOrderBy"]
};
	["ItemFeaturesOfProductByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ItemAliasesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ItemAliasConnection"]: {
	__typename: "ItemAliasConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ItemAliasEdge"]>
};
	["ItemAliasEdge"]: {
	__typename: "ItemAliasEdge",
	node: GraphQLTypes["ItemAlias"]
};
	["ProductFlag"]: {
	__typename: "ProductFlag",
	_meta?: GraphQLTypes["ProductFlagMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	productFeatures: Array<GraphQLTypes["ProductFeature"]>,
	products: Array<GraphQLTypes["ProductFlagOfProduct"]>,
	productFeaturesByRemoteId?: GraphQLTypes["ProductFeature"],
	productsByRemoteId?: GraphQLTypes["ProductFlagOfProduct"],
	paginateProductFeatures: GraphQLTypes["ProductFeatureConnection"],
	paginateProducts: GraphQLTypes["ProductFlagOfProductConnection"]
};
	["ProductFlagMeta"]: {
	__typename: "ProductFlagMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	productFeatures?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"]
};
	["ProductFlagOfProduct"]: {
	__typename: "ProductFlagOfProduct",
	_meta?: GraphQLTypes["ProductFlagOfProductMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	value?: GraphQLTypes["ProductFlagValue"],
	product?: GraphQLTypes["Product"],
	flag?: GraphQLTypes["ProductFlag"]
};
	["ProductFlagOfProductMeta"]: {
	__typename: "ProductFlagOfProductMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	value?: GraphQLTypes["FieldMeta"],
	product?: GraphQLTypes["FieldMeta"],
	flag?: GraphQLTypes["FieldMeta"]
};
	["ProductFlagOfProductOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	value?: GraphQLTypes["OrderDirection"],
	product?: GraphQLTypes["ProductOrderBy"],
	flag?: GraphQLTypes["ProductFlagOrderBy"]
};
	["ProductFlagProductFeaturesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ProductFlagProductsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ProductFlagOfProductConnection"]: {
	__typename: "ProductFlagOfProductConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductFlagOfProductEdge"]>
};
	["ProductFlagOfProductEdge"]: {
	__typename: "ProductFlagOfProductEdge",
	node: GraphQLTypes["ProductFlagOfProduct"]
};
	["ElementProductsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ElementFeatureDependenciesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ElementSuitabilityElementsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ElementOfProductConnection"]: {
	__typename: "ElementOfProductConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ElementOfProductEdge"]>
};
	["ElementOfProductEdge"]: {
	__typename: "ElementOfProductEdge",
	node: GraphQLTypes["ElementOfProduct"]
};
	["NutritionalValueProductsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["NutritionalValueSuitabilityNutritionalValuesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["NutritionalValueOfProductConnection"]: {
	__typename: "NutritionalValueOfProductConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NutritionalValueOfProductEdge"]>
};
	["NutritionalValueOfProductEdge"]: {
	__typename: "NutritionalValueOfProductEdge",
	node: GraphQLTypes["NutritionalValueOfProduct"]
};
	["ProductPackage"]: {
	__typename: "ProductPackage",
	_meta?: GraphQLTypes["ProductPackageMeta"],
	id: GraphQLTypes["UUID"],
	price?: number,
	order: number,
	link?: string,
	product?: GraphQLTypes["Product"],
	amount: number,
	externalId?: string,
	remoteId: string,
	label?: string,
	positionId?: string,
	heurekaPrice?: number,
	heurekaLink?: string
};
	["ProductPackageMeta"]: {
	__typename: "ProductPackageMeta",
	id?: GraphQLTypes["FieldMeta"],
	price?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	product?: GraphQLTypes["FieldMeta"],
	amount?: GraphQLTypes["FieldMeta"],
	externalId?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	positionId?: GraphQLTypes["FieldMeta"],
	heurekaPrice?: GraphQLTypes["FieldMeta"],
	heurekaLink?: GraphQLTypes["FieldMeta"]
};
	["ProductPackageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	price?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["OrderDirection"],
	product?: GraphQLTypes["ProductOrderBy"],
	amount?: GraphQLTypes["OrderDirection"],
	externalId?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	positionId?: GraphQLTypes["OrderDirection"],
	heurekaPrice?: GraphQLTypes["OrderDirection"],
	heurekaLink?: GraphQLTypes["OrderDirection"]
};
	["GranuleSize"]: {
	__typename: "GranuleSize",
	_meta?: GraphQLTypes["GranuleSizeMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	products: Array<GraphQLTypes["Product"]>,
	name: GraphQLTypes["GranuleSizeType"],
	paginateProducts: GraphQLTypes["ProductConnection"]
};
	["GranuleSizeMeta"]: {
	__typename: "GranuleSizeMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"]
};
	["GranuleSizeOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"]
};
	["ProductAlias"]: {
	__typename: "ProductAlias",
	_meta?: GraphQLTypes["ProductAliasMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	name: string,
	product?: GraphQLTypes["Product"]
};
	["ProductAliasMeta"]: {
	__typename: "ProductAliasMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	product?: GraphQLTypes["FieldMeta"]
};
	["ProductAliasOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	product?: GraphQLTypes["ProductOrderBy"]
};
	["ProductEvaluation"]: {
	__typename: "ProductEvaluation",
	_meta?: GraphQLTypes["ProductEvaluationMeta"],
	id: GraphQLTypes["UUID"],
	nazev?: string,
	vetDieta?: string,
	vetDieta1?: string,
	vetDieta2?: string,
	aktivita?: string,
	vek?: string,
	velikostPlemen?: string,
	hmotnostPlemene?: string,
	velikostGranuli?: string,
	velikostGranuliText?: string,
	doporucenaAktivitaDleMe?: string,
	vypocitanaMeVsMeVyrobce?: string,
	vypocitanaMeVsMeVyrobce2?: string,
	masoNaPrvnimMisteText?: string,
	zdrojeZivocisnychBilkovinDle1Vyskytu?: string,
	prichuteSeznam?: string,
	eliminacniDietaTextInterpunkce?: string,
	alergenyZadneNeobsahuje?: string,
	alergenyObsahuje?: string,
	alergenyNejakeNeobsahuje?: string,
	prospesneDruhyInterpunkce?: string,
	nevhodneDruhy?: string,
	kladneUcinkyCeleTelo?: string,
	kladneUcinkyHlava?: string,
	kladneUcinkyHrudnik?: string,
	kladneUcinkyBricho?: string,
	kladneUcinkySpodniCast?: string,
	zaporneUcinkyCeleTelo?: string,
	zaporneUcinkyHlava?: string,
	zaporneUcinkyHrudnik?: string,
	zaporneUcinkyBricho?: string,
	zaporneUcinkySpodniCast?: string,
	dsneuvedeno?: string,
	dsmalo?: string,
	dsprilis?: string,
	dsok?: string,
	d95malo?: string,
	d95prilis?: string,
	d95ok?: string,
	d110malo?: string,
	d110prilis?: string,
	d110ok?: string,
	sdo14reproMalo?: string,
	sdo14reproPrilis?: string,
	sdo14reproOk?: string,
	sdo15malo?: string,
	sdo15prilis?: string,
	sdo15ok?: string,
	s15malo?: string,
	s15prilis?: string,
	s15ok?: string,
	product?: GraphQLTypes["Product"],
	masoAnoNe?: string,
	eliminacniDietaAnoNe?: string,
	alergenyAnoNe?: string,
	plodnostKastraceNadpis?: string,
	plodnostKastraceText?: string,
	remoteId: string,
	stravitelnostNadpis?: string,
	stravitelnostProcenta?: string,
	stravitelnostSlovne?: string,
	stravitelnostChybiText?: string,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?: string
};
	["ProductEvaluationMeta"]: {
	__typename: "ProductEvaluationMeta",
	id?: GraphQLTypes["FieldMeta"],
	nazev?: GraphQLTypes["FieldMeta"],
	vetDieta?: GraphQLTypes["FieldMeta"],
	vetDieta1?: GraphQLTypes["FieldMeta"],
	vetDieta2?: GraphQLTypes["FieldMeta"],
	aktivita?: GraphQLTypes["FieldMeta"],
	vek?: GraphQLTypes["FieldMeta"],
	velikostPlemen?: GraphQLTypes["FieldMeta"],
	hmotnostPlemene?: GraphQLTypes["FieldMeta"],
	velikostGranuli?: GraphQLTypes["FieldMeta"],
	velikostGranuliText?: GraphQLTypes["FieldMeta"],
	doporucenaAktivitaDleMe?: GraphQLTypes["FieldMeta"],
	vypocitanaMeVsMeVyrobce?: GraphQLTypes["FieldMeta"],
	vypocitanaMeVsMeVyrobce2?: GraphQLTypes["FieldMeta"],
	masoNaPrvnimMisteText?: GraphQLTypes["FieldMeta"],
	zdrojeZivocisnychBilkovinDle1Vyskytu?: GraphQLTypes["FieldMeta"],
	prichuteSeznam?: GraphQLTypes["FieldMeta"],
	eliminacniDietaTextInterpunkce?: GraphQLTypes["FieldMeta"],
	alergenyZadneNeobsahuje?: GraphQLTypes["FieldMeta"],
	alergenyObsahuje?: GraphQLTypes["FieldMeta"],
	alergenyNejakeNeobsahuje?: GraphQLTypes["FieldMeta"],
	prospesneDruhyInterpunkce?: GraphQLTypes["FieldMeta"],
	nevhodneDruhy?: GraphQLTypes["FieldMeta"],
	kladneUcinkyCeleTelo?: GraphQLTypes["FieldMeta"],
	kladneUcinkyHlava?: GraphQLTypes["FieldMeta"],
	kladneUcinkyHrudnik?: GraphQLTypes["FieldMeta"],
	kladneUcinkyBricho?: GraphQLTypes["FieldMeta"],
	kladneUcinkySpodniCast?: GraphQLTypes["FieldMeta"],
	zaporneUcinkyCeleTelo?: GraphQLTypes["FieldMeta"],
	zaporneUcinkyHlava?: GraphQLTypes["FieldMeta"],
	zaporneUcinkyHrudnik?: GraphQLTypes["FieldMeta"],
	zaporneUcinkyBricho?: GraphQLTypes["FieldMeta"],
	zaporneUcinkySpodniCast?: GraphQLTypes["FieldMeta"],
	dsneuvedeno?: GraphQLTypes["FieldMeta"],
	dsmalo?: GraphQLTypes["FieldMeta"],
	dsprilis?: GraphQLTypes["FieldMeta"],
	dsok?: GraphQLTypes["FieldMeta"],
	d95malo?: GraphQLTypes["FieldMeta"],
	d95prilis?: GraphQLTypes["FieldMeta"],
	d95ok?: GraphQLTypes["FieldMeta"],
	d110malo?: GraphQLTypes["FieldMeta"],
	d110prilis?: GraphQLTypes["FieldMeta"],
	d110ok?: GraphQLTypes["FieldMeta"],
	sdo14reproMalo?: GraphQLTypes["FieldMeta"],
	sdo14reproPrilis?: GraphQLTypes["FieldMeta"],
	sdo14reproOk?: GraphQLTypes["FieldMeta"],
	sdo15malo?: GraphQLTypes["FieldMeta"],
	sdo15prilis?: GraphQLTypes["FieldMeta"],
	sdo15ok?: GraphQLTypes["FieldMeta"],
	s15malo?: GraphQLTypes["FieldMeta"],
	s15prilis?: GraphQLTypes["FieldMeta"],
	s15ok?: GraphQLTypes["FieldMeta"],
	product?: GraphQLTypes["FieldMeta"],
	masoAnoNe?: GraphQLTypes["FieldMeta"],
	eliminacniDietaAnoNe?: GraphQLTypes["FieldMeta"],
	alergenyAnoNe?: GraphQLTypes["FieldMeta"],
	plodnostKastraceNadpis?: GraphQLTypes["FieldMeta"],
	plodnostKastraceText?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	stravitelnostNadpis?: GraphQLTypes["FieldMeta"],
	stravitelnostProcenta?: GraphQLTypes["FieldMeta"],
	stravitelnostSlovne?: GraphQLTypes["FieldMeta"],
	stravitelnostChybiText?: GraphQLTypes["FieldMeta"],
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?: GraphQLTypes["FieldMeta"]
};
	["TOPXProduct"]: {
	__typename: "TOPXProduct",
	_meta?: GraphQLTypes["TOPXProductMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	order: number,
	orderType: GraphQLTypes["TOPXProductOrderType"],
	product?: GraphQLTypes["Product"],
	category?: GraphQLTypes["TOPXProductCategory"]
};
	["TOPXProductMeta"]: {
	__typename: "TOPXProductMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	orderType?: GraphQLTypes["FieldMeta"],
	product?: GraphQLTypes["FieldMeta"],
	category?: GraphQLTypes["FieldMeta"]
};
	["TOPXProductCategory"]: {
	__typename: "TOPXProductCategory",
	_meta?: GraphQLTypes["TOPXProductCategoryMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	products: Array<GraphQLTypes["TOPXProduct"]>,
	productsByRemoteId?: GraphQLTypes["TOPXProduct"],
	paginateProducts: GraphQLTypes["TOPXProductConnection"]
};
	["TOPXProductCategoryMeta"]: {
	__typename: "TOPXProductCategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"]
};
	["TOPXProductOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	orderType?: GraphQLTypes["OrderDirection"],
	product?: GraphQLTypes["ProductOrderBy"],
	category?: GraphQLTypes["TOPXProductCategoryOrderBy"]
};
	["TOPXProductCategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"]
};
	["TOPXProductCategoryProductsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["TOPXProductConnection"]: {
	__typename: "TOPXProductConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TOPXProductEdge"]>
};
	["TOPXProductEdge"]: {
	__typename: "TOPXProductEdge",
	node: GraphQLTypes["TOPXProduct"]
};
	["ProductNutritionalValuesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ProductReviewsByProductReviewReactionsUniqueWhere"]: {
		productReviewReactions?: GraphQLTypes["ProductReviewReactionUniqueWhere"]
};
	["ProductReviewsByStatsUniqueWhere"]: {
		stats?: GraphQLTypes["ProductReviewStatsUniqueWhere"]
};
	["ProductDogsByReproductionUniqueWhere"]: {
		reproduction?: GraphQLTypes["DogReproductionUniqueWhere"]
};
	["ProductDogsByAvatarUniqueWhere"]: {
		avatar?: GraphQLTypes["ImageUniqueWhere"]
};
	["ProductPackagingsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ProductPackagingsByPositionIdUniqueWhere"]: {
		positionId?: string
};
	["ProductPackagingsByExternalIdUniqueWhere"]: {
		externalId?: string
};
	["ProductElementsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ProductFlagsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ProductAliasesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ProductTopxByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ProductPackageConnection"]: {
	__typename: "ProductPackageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductPackageEdge"]>
};
	["ProductPackageEdge"]: {
	__typename: "ProductPackageEdge",
	node: GraphQLTypes["ProductPackage"]
};
	["GranuleSizeConnection"]: {
	__typename: "GranuleSizeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GranuleSizeEdge"]>
};
	["GranuleSizeEdge"]: {
	__typename: "GranuleSizeEdge",
	node: GraphQLTypes["GranuleSize"]
};
	["ProductAliasConnection"]: {
	__typename: "ProductAliasConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductAliasEdge"]>
};
	["ProductAliasEdge"]: {
	__typename: "ProductAliasEdge",
	node: GraphQLTypes["ProductAlias"]
};
	["AgeCategoryConnection"]: {
	__typename: "AgeCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AgeCategoryEdge"]>
};
	["AgeCategoryEdge"]: {
	__typename: "AgeCategoryEdge",
	node: GraphQLTypes["AgeCategory"]
};
	["BodyTagFilterCombosByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["BodyTagFilterCombosBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["BodyTagCategoryTagsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["BodyTagCategoryTagsByFilterCombosUniqueWhere"]: {
		filterCombos?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["ColorItemFlavorCategoriesByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["ColorItemFlavorCategoriesByItemsUniqueWhere"]: {
		items?: GraphQLTypes["ItemSubCategoryUniqueWhere"]
};
	["ItemFlavorCategoryConnection"]: {
	__typename: "ItemFlavorCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ItemFlavorCategoryEdge"]>
};
	["ItemFlavorCategoryEdge"]: {
	__typename: "ItemFlavorCategoryEdge",
	node: GraphQLTypes["ItemFlavorCategory"]
};
	["BlogPostReviewsByBlogPostReviewReactionsUniqueWhere"]: {
		blogPostReviewReactions?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"]
};
	["BlogPostReviewsByStatsUniqueWhere"]: {
		stats?: GraphQLTypes["BlogPostReviewStatsUniqueWhere"]
};
	["BlogPostItemsByRemoteIdUniqueWhere"]: {
		remoteId?: string
};
	["BlogPostItemsBySlugUniqueWhere"]: {
		slug?: string
};
	["BlogPostItemsByFeaturesOfProductUniqueWhere"]: {
		featuresOfProduct?: GraphQLTypes["ProductFeatureUniqueWhere"]
};
	["BlogPostItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["BlogPostItemsByReferenceListUniqueWhere"]: {
		referenceList?: GraphQLTypes["ReferenceListUniqueWhere"]
};
	["BlogPostItemsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["BlogPostItemsByAliasesUniqueWhere"]: {
		aliases?: GraphQLTypes["ItemAliasUniqueWhere"]
};
	["BlogPostItemsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["BlogPostItemsByDraftUniqueWhere"]: {
		draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["BlogPostRedirectsByFromUniqueWhere"]: {
		from?: string
};
	["BlogPostTagConnection"]: {
	__typename: "BlogPostTagConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostTagEdge"]>
};
	["BlogPostTagEdge"]: {
	__typename: "BlogPostTagEdge",
	node: GraphQLTypes["BlogPostTag"]
};
	["Link"]: {
	__typename: "Link",
	_meta?: GraphQLTypes["LinkMeta"],
	id: GraphQLTypes["UUID"],
	externalLink?: string,
	isTargetBlank: boolean
};
	["LinkMeta"]: {
	__typename: "LinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	externalLink?: GraphQLTypes["FieldMeta"],
	isTargetBlank?: GraphQLTypes["FieldMeta"]
};
	["ContentReferenceList"]: {
	__typename: "ContentReferenceList",
	_meta?: GraphQLTypes["ContentReferenceListMeta"],
	id: GraphQLTypes["UUID"],
	order?: number,
	relatedProduct?: GraphQLTypes["Product"],
	relatedBrand?: GraphQLTypes["Brand"],
	list?: GraphQLTypes["ContentReference"],
	badge?: string,
	badgeColor?: string
};
	["ContentReferenceListMeta"]: {
	__typename: "ContentReferenceListMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	relatedProduct?: GraphQLTypes["FieldMeta"],
	relatedBrand?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	badge?: GraphQLTypes["FieldMeta"],
	badgeColor?: GraphQLTypes["FieldMeta"]
};
	["ContentReferenceListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	relatedProduct?: GraphQLTypes["ProductOrderBy"],
	relatedBrand?: GraphQLTypes["BrandOrderBy"],
	list?: GraphQLTypes["ContentReferenceOrderBy"],
	badge?: GraphQLTypes["OrderDirection"],
	badgeColor?: GraphQLTypes["OrderDirection"]
};
	["ContentLinks"]: {
	__typename: "ContentLinks",
	_meta?: GraphQLTypes["ContentLinksMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ContentLinksItem"]>,
	paginateItems: GraphQLTypes["ContentLinksItemConnection"]
};
	["ContentLinksMeta"]: {
	__typename: "ContentLinksMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["ContentLinksItem"]: {
	__typename: "ContentLinksItem",
	_meta?: GraphQLTypes["ContentLinksItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string,
	target?: string,
	list?: GraphQLTypes["ContentLinks"]
};
	["ContentLinksItemMeta"]: {
	__typename: "ContentLinksItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"]
};
	["ContentLinksItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	target?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ContentLinksOrderBy"]
};
	["ContentLinksItemConnection"]: {
	__typename: "ContentLinksItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentLinksItemEdge"]>
};
	["ContentLinksItemEdge"]: {
	__typename: "ContentLinksItemEdge",
	node: GraphQLTypes["ContentLinksItem"]
};
	["Video"]: {
	__typename: "Video",
	_meta?: GraphQLTypes["VideoMeta"],
	id: GraphQLTypes["UUID"],
	src?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	duration?: number,
	poster?: GraphQLTypes["Image"]
};
	["VideoMeta"]: {
	__typename: "VideoMeta",
	id?: GraphQLTypes["FieldMeta"],
	src?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	duration?: GraphQLTypes["FieldMeta"],
	poster?: GraphQLTypes["FieldMeta"]
};
	["ContentReferenceImage"]: {
	__typename: "ContentReferenceImage",
	_meta?: GraphQLTypes["ContentReferenceImageMeta"],
	id: GraphQLTypes["UUID"],
	lead?: string,
	alignment?: GraphQLTypes["AlignmentType"],
	image?: GraphQLTypes["Image"],
	link?: string,
	targetBlank?: boolean
};
	["ContentReferenceImageMeta"]: {
	__typename: "ContentReferenceImageMeta",
	id?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	alignment?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	targetBlank?: GraphQLTypes["FieldMeta"]
};
	["ContentReferenceGalleryImageConnection"]: {
	__typename: "ContentReferenceGalleryImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceGalleryImageEdge"]>
};
	["ContentReferenceGalleryImageEdge"]: {
	__typename: "ContentReferenceGalleryImageEdge",
	node: GraphQLTypes["ContentReferenceGalleryImage"]
};
	["ContentReferenceListConnection"]: {
	__typename: "ContentReferenceListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceListEdge"]>
};
	["ContentReferenceListEdge"]: {
	__typename: "ContentReferenceListEdge",
	node: GraphQLTypes["ContentReferenceList"]
};
	["ContentBlockReferencesByImagesUniqueWhere"]: {
		images?: GraphQLTypes["ContentReferenceGalleryImageUniqueWhere"]
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["ContentBlockReferencesByListUniqueWhere"]: {
		list?: GraphQLTypes["ContentReferenceListUniqueWhere"]
};
	["ContentBlockReferencesByOutlineUniqueWhere"]: {
		outline?: GraphQLTypes["ContentLinksUniqueWhere"]
};
	["ContentBlockReferencesByVideoUniqueWhere"]: {
		video?: GraphQLTypes["VideoUniqueWhere"]
};
	["ContentBlockReferencesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ContentReferenceImageUniqueWhere"]
};
	["ContentBlocksByAutomatedContentBlockSlugUniqueWhere"]: {
		automatedContentBlockSlug?: string
};
	["ContentBlocksByReferencesUniqueWhere"]: {
		references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentBlockConnection"]: {
	__typename: "ContentBlockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
	__typename: "ContentBlockEdge",
	node: GraphQLTypes["ContentBlock"]
};
	["BrandsPageRedirectsByFromUniqueWhere"]: {
		from?: string
};
	["ComparatorPage"]: {
	__typename: "ComparatorPage",
	_meta?: GraphQLTypes["ComparatorPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	redirects: Array<GraphQLTypes["Redirect"]>,
	seo?: GraphQLTypes["Seo"],
	redirectsByFrom?: GraphQLTypes["Redirect"],
	paginateRedirects: GraphQLTypes["RedirectConnection"]
};
	["ComparatorPageMeta"]: {
	__typename: "ComparatorPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	redirects?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["ComparatorPageRedirectsByFromUniqueWhere"]: {
		from?: string
};
	["HomePage"]: {
	__typename: "HomePage",
	_meta?: GraphQLTypes["HomePageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	title: string,
	lead: string,
	seo?: GraphQLTypes["Seo"]
};
	["HomePageMeta"]: {
	__typename: "HomePageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["IngredientsPage"]: {
	__typename: "IngredientsPage",
	_meta?: GraphQLTypes["IngredientsPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["Seo"],
	content?: GraphQLTypes["Content"],
	draft?: GraphQLTypes["Content"]
};
	["IngredientsPageMeta"]: {
	__typename: "IngredientsPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	draft?: GraphQLTypes["FieldMeta"]
};
	["LoginPage"]: {
	__typename: "LoginPage",
	_meta?: GraphQLTypes["LoginPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	seo?: GraphQLTypes["Seo"]
};
	["LoginPageMeta"]: {
	__typename: "LoginPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["RegisterPage"]: {
	__typename: "RegisterPage",
	_meta?: GraphQLTypes["RegisterPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	seo?: GraphQLTypes["Seo"]
};
	["RegisterPageMeta"]: {
	__typename: "RegisterPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["SearchPage"]: {
	__typename: "SearchPage",
	_meta?: GraphQLTypes["SearchPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	seo?: GraphQLTypes["Seo"]
};
	["SearchPageMeta"]: {
	__typename: "SearchPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["WizardPage"]: {
	__typename: "WizardPage",
	_meta?: GraphQLTypes["WizardPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	redirects: Array<GraphQLTypes["Redirect"]>,
	seo?: GraphQLTypes["Seo"],
	redirectsByFrom?: GraphQLTypes["Redirect"],
	paginateRedirects: GraphQLTypes["RedirectConnection"]
};
	["WizardPageMeta"]: {
	__typename: "WizardPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	redirects?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["WizardPageRedirectsByFromUniqueWhere"]: {
		from?: string
};
	["ContactPage"]: {
	__typename: "ContactPage",
	_meta?: GraphQLTypes["ContactPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	title?: string,
	redirects: Array<GraphQLTypes["Redirect"]>,
	seo?: GraphQLTypes["Seo"],
	content?: GraphQLTypes["Content"],
	draft?: GraphQLTypes["Content"],
	redirectsByFrom?: GraphQLTypes["Redirect"],
	paginateRedirects: GraphQLTypes["RedirectConnection"]
};
	["ContactPageMeta"]: {
	__typename: "ContactPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	redirects?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	draft?: GraphQLTypes["FieldMeta"]
};
	["ContactPageRedirectsByFromUniqueWhere"]: {
		from?: string
};
	["GenericPageRedirectsByFromUniqueWhere"]: {
		from?: string
};
	["BlogPageRedirectsByFromUniqueWhere"]: {
		from?: string
};
	["BlogPageConnection"]: {
	__typename: "BlogPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPageEdge"]>
};
	["BlogPageEdge"]: {
	__typename: "BlogPageEdge",
	node: GraphQLTypes["BlogPage"]
};
	["_ValidationResult"]: {
	__typename: "_ValidationResult",
	valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
	__typename: "_ValidationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:{
	__typename:"_FieldPathFragment" | "_IndexPathFragment"
	['...on _FieldPathFragment']: '__union' & GraphQLTypes["_FieldPathFragment"];
	['...on _IndexPathFragment']: '__union' & GraphQLTypes["_IndexPathFragment"];
};
	["_FieldPathFragment"]: {
	__typename: "_FieldPathFragment",
	field: string
};
	["_IndexPathFragment"]: {
	__typename: "_IndexPathFragment",
	index: number,
	alias?: string
};
	["_ValidationMessage"]: {
	__typename: "_ValidationMessage",
	text: string
};
	["BlogPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	redirects?: Array<GraphQLTypes["BlogPageCreateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["BlogPageCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["BlogPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPageCreateRedirectsEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutBlogPageCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPageConnectOrCreateRedirectsRelationInput"],
	alias?: string
};
	["RedirectWithoutBlogPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectCreateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectCreateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectCreateBrandsPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectCreateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectCreateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectCreateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectCreateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateGenericPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageUniqueWhere"],
	create?: GraphQLTypes["GenericPageWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateGenericPageRelationInput"]
};
	["GenericPageWithoutRedirectsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["GenericPageCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["GenericPageCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["GenericPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["GenericPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GenericPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutGenericPageCreateInput"],
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateLinkRelationInput"]
};
	["LinkableWithoutGenericPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	_dummy_field_?: boolean
};
	["GenericPageConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkableUniqueWhere"],
	create: GraphQLTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutGenericPageCreateInput"],
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateSeoRelationInput"]
};
	["SeoWithoutGenericPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoCreateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoCreateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoCreateComparatorPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoCreateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoCreateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoCreateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoCreateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoCreateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoCreateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoCreateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateOgImageRelationInput"]
};
	["ImageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	remoteId?: string,
	hash?: string,
	_dummy_field_?: boolean
};
	["SeoConnectOrCreateOgImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["SeoCreateBlogPageEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPageUniqueWhere"],
	create?: GraphQLTypes["BlogPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateBlogPageRelationInput"]
};
	["BlogPageWithoutSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	redirects?: Array<GraphQLTypes["BlogPageCreateRedirectsEntityRelationInput"]>,
	content?: GraphQLTypes["BlogPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPageCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPageConnectOrCreateContentRelationInput"]
};
	["ContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: Array<GraphQLTypes["ContentCreateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentCreateBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentConnectOrCreateBlocksRelationInput"],
	alias?: string
};
	["ContentBlockWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]>,
	automatedContentBlockSlug?: string,
	_dummy_field_?: boolean
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentBlockConnectOrCreateReferencesRelationInput"],
	alias?: string
};
	["ContentReferenceWithoutBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	secondaryText?: string,
	fact?: string,
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	relatedBlogPost?: GraphQLTypes["ContentReferenceCreateRelatedBlogPostEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceCreateRelatedBrandEntityRelationInput"],
	relatedProduct?: GraphQLTypes["ContentReferenceCreateRelatedProductEntityRelationInput"],
	relatedIngredient?: GraphQLTypes["ContentReferenceCreateRelatedIngredientEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	badge?: string,
	longVersion?: boolean,
	relatedBrandFull?: GraphQLTypes["ContentReferenceCreateRelatedBrandFullEntityRelationInput"],
	relatedProductFull?: GraphQLTypes["ContentReferenceCreateRelatedProductFullEntityRelationInput"],
	list?: Array<GraphQLTypes["ContentReferenceCreateListEntityRelationInput"]>,
	outline?: GraphQLTypes["ContentReferenceCreateOutlineEntityRelationInput"],
	video?: GraphQLTypes["ContentReferenceCreateVideoEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	defaultOpen?: boolean,
	badgeColor?: string,
	isMain?: boolean,
	ad?: GraphQLTypes["ContentReferenceCreateAdEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateImagesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceGalleryImageUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceGalleryImageWithoutReferenceCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateImagesRelationInput"],
	alias?: string
};
	["ContentReferenceGalleryImageWithoutReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["ContentReferenceGalleryImageCreateImageEntityRelationInput"],
	lead?: string,
	alignment?: GraphQLTypes["AlignmentType"],
	_dummy_field_?: boolean
};
	["ContentReferenceGalleryImageCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceGalleryImageConnectOrCreateImageRelationInput"]
};
	["ContentReferenceGalleryImageConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceConnectOrCreateImagesRelationInput"]: {
		connect: GraphQLTypes["ContentReferenceGalleryImageUniqueWhere"],
	create: GraphQLTypes["ContentReferenceGalleryImageWithoutReferenceCreateInput"]
};
	["ContentReferenceCreateRelatedBlogPostEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateRelatedBlogPostRelationInput"]
};
	["BlogPostCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostCreateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostCreateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostCreateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostCreateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostCreateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostCreateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostCreateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostCreateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostCreateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostCreateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostCreateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostCreateBlogPostTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostTagUniqueWhere"],
	create?: GraphQLTypes["BlogPostTagWithoutBlogPostsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateBlogPostTagsRelationInput"],
	alias?: string
};
	["BlogPostTagUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	color?: GraphQLTypes["ColorUniqueWhere"]
};
	["ColorUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	bodyTagCategory?: GraphQLTypes["BodyTagCategoryUniqueWhere"],
	blogPostTag?: GraphQLTypes["BlogPostTagUniqueWhere"],
	itemFlavorCategories?: GraphQLTypes["ItemFlavorCategoryUniqueWhere"]
};
	["BodyTagCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	tags?: GraphQLTypes["BodyTagUniqueWhere"],
	color?: GraphQLTypes["ColorUniqueWhere"]
};
	["BodyTagUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	filterCombos?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["ItemFlavorCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	items?: GraphQLTypes["ItemSubCategoryUniqueWhere"]
};
	["BlogPostTagWithoutBlogPostsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	remoteId?: string,
	color?: GraphQLTypes["BlogPostTagCreateColorEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["BlogPostTagCreateColorEntityRelationInput"]: {
		connect?: GraphQLTypes["ColorUniqueWhere"],
	create?: GraphQLTypes["ColorWithoutBlogPostTagCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostTagConnectOrCreateColorRelationInput"]
};
	["ColorWithoutBlogPostTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	colorHex?: string,
	bodyTagCategory?: GraphQLTypes["ColorCreateBodyTagCategoryEntityRelationInput"],
	remoteId?: string,
	itemFlavorCategories?: Array<GraphQLTypes["ColorCreateItemFlavorCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ColorCreateBodyTagCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagCategoryUniqueWhere"],
	create?: GraphQLTypes["BodyTagCategoryWithoutColorCreateInput"],
	connectOrCreate?: GraphQLTypes["ColorConnectOrCreateBodyTagCategoryRelationInput"]
};
	["BodyTagCategoryWithoutColorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	tags?: Array<GraphQLTypes["BodyTagCategoryCreateTagsEntityRelationInput"]>,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["BodyTagCategoryCreateTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagUniqueWhere"],
	create?: GraphQLTypes["BodyTagWithoutCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagCategoryConnectOrCreateTagsRelationInput"],
	alias?: string
};
	["BodyTagWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagCreateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagCreatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagCreateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagCreatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagCreateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	icon?: GraphQLTypes["BodyTagCreateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagCreateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagCreateBlogPostsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostWithoutTagsCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagConnectOrCreateBlogPostsRelationInput"],
	alias?: string
};
	["BlogPostWithoutTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostCreateBlogPostTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostCreateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostCreateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostCreateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostCreateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostCreateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostCreateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostCreateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostCreateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostCreateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostCreateReviewsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	create?: GraphQLTypes["BlogPostReviewWithoutBlogPostCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateReviewsRelationInput"],
	alias?: string
};
	["BlogPostReviewWithoutBlogPostCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostReviewReactions?: Array<GraphQLTypes["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"]>,
	user?: GraphQLTypes["BlogPostReviewCreateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["BlogPostReviewCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["BlogPostReviewCreateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	create?: GraphQLTypes["BlogPostReviewReactionWithoutBlogPostReviewCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewConnectOrCreateBlogPostReviewReactionsRelationInput"],
	alias?: string
};
	["BlogPostReviewReactionWithoutBlogPostReviewCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	sentiment?: GraphQLTypes["SentimentType"],
	user?: GraphQLTypes["BlogPostReviewReactionCreateUserEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostReviewReactionCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutBlogPostReviewReactionsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewReactionConnectOrCreateUserRelationInput"]
};
	["UserWithoutBlogPostReviewReactionsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["UserCreateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserCreateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserCreateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserCreateProductReviewsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserCreateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserCreateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserCreateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserCreateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserCreateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserCreateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserCreateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserCreateDogsEntityRelationInput"]: {
		connect?: GraphQLTypes["DogUniqueWhere"],
	create?: GraphQLTypes["DogWithoutOwnerCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateDogsRelationInput"],
	alias?: string
};
	["DogWithoutOwnerCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogCreateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogCreateBodyTypeEntityRelationInput"],
	activity?: GraphQLTypes["DogCreateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogCreateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogCreateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogCreateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogCreateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogCreateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogCreateBreedEntityRelationInput"]: {
		connect?: GraphQLTypes["BreedUniqueWhere"],
	create?: GraphQLTypes["BreedWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateBreedRelationInput"]
};
	["BreedWithoutDogsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedCreateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedCreateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedCreateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedCreateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedCreateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedCreateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedCreateReviewsEntityRelationInput"]: {
		connect?: GraphQLTypes["ReviewUniqueWhere"],
	create?: GraphQLTypes["ReviewWithoutDogBreedsCreateInput"],
	connectOrCreate?: GraphQLTypes["BreedConnectOrCreateReviewsRelationInput"],
	alias?: string
};
	["ReviewUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["ReviewWithoutDogBreedsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	remoteId?: string,
	author?: string,
	_dummy_field_?: boolean
};
	["BreedConnectOrCreateReviewsRelationInput"]: {
		connect: GraphQLTypes["ReviewUniqueWhere"],
	create: GraphQLTypes["ReviewWithoutDogBreedsCreateInput"]
};
	["BreedCreateAgesEntityRelationInput"]: {
		connect?: GraphQLTypes["AgeUniqueWhere"],
	create?: GraphQLTypes["AgeWithoutBreedsCreateInput"],
	connectOrCreate?: GraphQLTypes["BreedConnectOrCreateAgesRelationInput"],
	alias?: string
};
	["AgeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	ageRange?: GraphQLTypes["AgeRangeType"],
	remoteId?: string,
	label?: string,
	dogs?: GraphQLTypes["DogUniqueWhere"],
	productReviews?: GraphQLTypes["ProductReviewUniqueWhere"],
	blogPostReviews?: GraphQLTypes["BlogPostReviewUniqueWhere"]
};
	["AgeWithoutBreedsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["AgeCreateDogsEntityRelationInput"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	suitabilityCategories?: Array<GraphQLTypes["AgeCreateSuitabilityCategoriesEntityRelationInput"]>,
	remoteId?: string,
	productReviews?: Array<GraphQLTypes["AgeCreateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["AgeCreateBlogPostReviewsEntityRelationInput"]>,
	label?: string,
	categoryOrder?: string,
	_dummy_field_?: boolean
};
	["AgeCreateDogsEntityRelationInput"]: {
		connect?: GraphQLTypes["DogUniqueWhere"],
	create?: GraphQLTypes["DogWithoutAgeCreateInput"],
	connectOrCreate?: GraphQLTypes["AgeConnectOrCreateDogsRelationInput"],
	alias?: string
};
	["DogWithoutAgeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogCreateBreedEntityRelationInput"],
	bodyType?: GraphQLTypes["DogCreateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogCreateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogCreateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogCreateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogCreateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogCreateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogCreateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogCreateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogCreateBodyTypeEntityRelationInput"]: {
		connect?: GraphQLTypes["DogBodyTypeUniqueWhere"],
	create?: GraphQLTypes["DogBodyTypeWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateBodyTypeRelationInput"]
};
	["DogBodyTypeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	dogs?: GraphQLTypes["DogUniqueWhere"],
	imageMain?: GraphQLTypes["ImageUniqueWhere"],
	imageFrom?: GraphQLTypes["ImageUniqueWhere"],
	imageTo?: GraphQLTypes["ImageUniqueWhere"]
};
	["DogBodyTypeWithoutDogsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	lead?: string,
	order?: number,
	value?: number,
	remoteId?: string,
	category?: GraphQLTypes["DogBodyTypeCreateCategoryEntityRelationInput"],
	imageMain?: GraphQLTypes["DogBodyTypeCreateImageMainEntityRelationInput"],
	imageFrom?: GraphQLTypes["DogBodyTypeCreateImageFromEntityRelationInput"],
	imageTo?: GraphQLTypes["DogBodyTypeCreateImageToEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogBodyTypeCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["DogBodyTypeCategoryUniqueWhere"],
	create?: GraphQLTypes["DogBodyTypeCategoryWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogBodyTypeConnectOrCreateCategoryRelationInput"]
};
	["DogBodyTypeCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	items?: GraphQLTypes["DogBodyTypeUniqueWhere"],
	imageMain?: GraphQLTypes["ImageUniqueWhere"]
};
	["DogBodyTypeCategoryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	remoteId?: string,
	imageMain?: GraphQLTypes["DogBodyTypeCategoryCreateImageMainEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogBodyTypeCategoryCreateImageMainEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["DogBodyTypeCategoryConnectOrCreateImageMainRelationInput"]
};
	["DogBodyTypeCategoryConnectOrCreateImageMainRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["DogBodyTypeConnectOrCreateCategoryRelationInput"]: {
		connect: GraphQLTypes["DogBodyTypeCategoryUniqueWhere"],
	create: GraphQLTypes["DogBodyTypeCategoryWithoutItemsCreateInput"]
};
	["DogBodyTypeCreateImageMainEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["DogBodyTypeConnectOrCreateImageMainRelationInput"]
};
	["DogBodyTypeConnectOrCreateImageMainRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["DogBodyTypeCreateImageFromEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["DogBodyTypeConnectOrCreateImageFromRelationInput"]
};
	["DogBodyTypeConnectOrCreateImageFromRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["DogBodyTypeCreateImageToEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["DogBodyTypeConnectOrCreateImageToRelationInput"]
};
	["DogBodyTypeConnectOrCreateImageToRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["DogConnectOrCreateBodyTypeRelationInput"]: {
		connect: GraphQLTypes["DogBodyTypeUniqueWhere"],
	create: GraphQLTypes["DogBodyTypeWithoutDogsCreateInput"]
};
	["DogCreateOwnerEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateOwnerRelationInput"]
};
	["UserWithoutDogsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	veterinary?: GraphQLTypes["UserCreateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserCreateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserCreateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserCreateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserCreateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserCreateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserCreateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserCreateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserCreateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserCreateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserCreateVeterinaryEntityRelationInput"]: {
		connect?: GraphQLTypes["VeterinaryUniqueWhere"],
	create?: GraphQLTypes["VeterinaryWithoutUserCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateVeterinaryRelationInput"]
};
	["VeterinaryWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["UserConnectOrCreateVeterinaryRelationInput"]: {
		connect: GraphQLTypes["VeterinaryUniqueWhere"],
	create: GraphQLTypes["VeterinaryWithoutUserCreateInput"]
};
	["UserCreateBlogPostReviewsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	create?: GraphQLTypes["BlogPostReviewWithoutUserCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateBlogPostReviewsRelationInput"],
	alias?: string
};
	["BlogPostReviewWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostReviewReactions?: Array<GraphQLTypes["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"]>,
	blogPost?: GraphQLTypes["BlogPostReviewCreateBlogPostEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["BlogPostReviewCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["BlogPostReviewCreateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["BlogPostReviewCreateBlogPostEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostWithoutReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewConnectOrCreateBlogPostRelationInput"]
};
	["BlogPostWithoutReviewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostCreateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostCreateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	itemCategories?: Array<GraphQLTypes["BlogPostCreateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostCreateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostCreateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostCreateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostCreateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostCreateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostCreateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostCreateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostCreateTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagUniqueWhere"],
	create?: GraphQLTypes["BodyTagWithoutBlogPostsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateTagsRelationInput"],
	alias?: string
};
	["BodyTagWithoutBlogPostsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	positiveProducts?: Array<GraphQLTypes["BodyTagCreatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagCreateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagCreatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagCreateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagCreateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagCreateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagCreateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagCreatePositiveProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutPositiveForBodyTagsCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagConnectOrCreatePositiveProductsRelationInput"],
	alias?: string
};
	["ProductWithoutPositiveForBodyTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreateNutritionalValuesEntityRelationInput"]: {
		connect?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	create?: GraphQLTypes["NutritionalValueOfProductWithoutProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateNutritionalValuesRelationInput"],
	alias?: string
};
	["NutritionalValueOfProductWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	amount?: number,
	remoteId?: string,
	nutritionalValue?: GraphQLTypes["NutritionalValueOfProductCreateNutritionalValueEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NutritionalValueOfProductCreateNutritionalValueEntityRelationInput"]: {
		connect?: GraphQLTypes["NutritionalValueUniqueWhere"],
	create?: GraphQLTypes["NutritionalValueWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["NutritionalValueOfProductConnectOrCreateNutritionalValueRelationInput"]
};
	["NutritionalValueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	products?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	suitabilityNutritionalValues?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	icon?: GraphQLTypes["ImageUniqueWhere"]
};
	["NutritionalValueWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	suitabilityNutritionalValues?: Array<GraphQLTypes["NutritionalValueCreateSuitabilityNutritionalValuesEntityRelationInput"]>,
	remoteId?: string,
	icon?: GraphQLTypes["NutritionalValueCreateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NutritionalValueCreateSuitabilityNutritionalValuesEntityRelationInput"]: {
		connect?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	create?: GraphQLTypes["SuitabilityItemWithoutNutritionalValueCreateInput"],
	connectOrCreate?: GraphQLTypes["NutritionalValueConnectOrCreateSuitabilityNutritionalValuesRelationInput"],
	alias?: string
};
	["SuitabilityItemWithoutNutritionalValueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	min?: number,
	max?: number,
	remoteId?: string,
	order?: number,
	element?: GraphQLTypes["SuitabilityItemCreateElementEntityRelationInput"],
	category?: GraphQLTypes["SuitabilityItemCreateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SuitabilityItemCreateElementEntityRelationInput"]: {
		connect?: GraphQLTypes["ElementUniqueWhere"],
	create?: GraphQLTypes["ElementWithoutSuitabilityElementsCreateInput"],
	connectOrCreate?: GraphQLTypes["SuitabilityItemConnectOrCreateElementRelationInput"]
};
	["ElementWithoutSuitabilityElementsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["ElementCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ElementCreateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	unit?: string,
	filterOrder?: number,
	slug?: string,
	declensionSeventh?: string,
	_dummy_field_?: boolean
};
	["ElementCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ElementOfProductUniqueWhere"],
	create?: GraphQLTypes["ElementOfProductWithoutElementCreateInput"],
	connectOrCreate?: GraphQLTypes["ElementConnectOrCreateProductsRelationInput"],
	alias?: string
};
	["ElementOfProductWithoutElementCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	amount?: number,
	product?: GraphQLTypes["ElementOfProductCreateProductEntityRelationInput"],
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ElementOfProductCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutElementsCreateInput"],
	connectOrCreate?: GraphQLTypes["ElementOfProductConnectOrCreateProductRelationInput"]
};
	["ProductWithoutElementsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreatePositiveForBodyTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagUniqueWhere"],
	create?: GraphQLTypes["BodyTagWithoutPositiveProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreatePositiveForBodyTagsRelationInput"],
	alias?: string
};
	["BodyTagWithoutPositiveProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagCreateBlogPostsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagCreateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagCreatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagCreateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagCreateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagCreateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagCreateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagCreateNegativeProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutNegativeForBodyTagsCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagConnectOrCreateNegativeProductsRelationInput"],
	alias?: string
};
	["ProductWithoutNegativeForBodyTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreateReviewsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductReviewUniqueWhere"],
	create?: GraphQLTypes["ProductReviewWithoutProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateReviewsRelationInput"],
	alias?: string
};
	["ProductReviewWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions?: Array<GraphQLTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"]>,
	score?: GraphQLTypes["ProductReviewCreateScoreEntityRelationInput"],
	user?: GraphQLTypes["ProductReviewCreateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["ProductReviewCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["ProductReviewCreateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ProductReviewCreateProductReviewReactionsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	create?: GraphQLTypes["ProductReviewReactionWithoutProductReviewCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewConnectOrCreateProductReviewReactionsRelationInput"],
	alias?: string
};
	["ProductReviewReactionWithoutProductReviewCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	sentiment?: GraphQLTypes["SentimentType"],
	user?: GraphQLTypes["ProductReviewReactionCreateUserEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductReviewReactionCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutProductReviewReactionsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewReactionConnectOrCreateUserRelationInput"]
};
	["UserWithoutProductReviewReactionsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["UserCreateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserCreateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserCreateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserCreateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserCreateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserCreateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserCreateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserCreateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserCreateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserCreateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserCreateProductReviewsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductReviewUniqueWhere"],
	create?: GraphQLTypes["ProductReviewWithoutUserCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateProductReviewsRelationInput"],
	alias?: string
};
	["ProductReviewWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions?: Array<GraphQLTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"]>,
	score?: GraphQLTypes["ProductReviewCreateScoreEntityRelationInput"],
	product?: GraphQLTypes["ProductReviewCreateProductEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["ProductReviewCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["ProductReviewCreateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ProductReviewCreateScoreEntityRelationInput"]: {
		connect?: GraphQLTypes["ScoreUniqueWhere"],
	create?: GraphQLTypes["ScoreWithoutProductReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewConnectOrCreateScoreRelationInput"]
};
	["ScoreUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	productReviews?: GraphQLTypes["ProductReviewUniqueWhere"]
};
	["ScoreWithoutProductReviewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: string,
	starsAmount?: number,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ProductReviewConnectOrCreateScoreRelationInput"]: {
		connect: GraphQLTypes["ScoreUniqueWhere"],
	create: GraphQLTypes["ScoreWithoutProductReviewsCreateInput"]
};
	["ProductReviewCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewConnectOrCreateProductRelationInput"]
};
	["ProductWithoutReviewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreateNegativeForBodyTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagUniqueWhere"],
	create?: GraphQLTypes["BodyTagWithoutNegativeProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateNegativeForBodyTagsRelationInput"],
	alias?: string
};
	["BodyTagWithoutNegativeProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagCreateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagCreatePositiveProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagCreatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagCreateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagCreateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagCreateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagCreateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagCreatePositiveItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemWithoutPositiveForBodyTagsCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagConnectOrCreatePositiveItemsRelationInput"],
	alias?: string
};
	["ItemWithoutPositiveForBodyTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	negativeForBodyTags?: Array<GraphQLTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemCreateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemCreateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemCreateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemCreateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemCreateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemCreateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemCreateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemCreateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemCreateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCreateNegativeForBodyTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagUniqueWhere"],
	create?: GraphQLTypes["BodyTagWithoutNegativeItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateNegativeForBodyTagsRelationInput"],
	alias?: string
};
	["BodyTagWithoutNegativeItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagCreateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagCreatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagCreateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagCreatePositiveItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagCreateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagCreateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagCreateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagCategoryUniqueWhere"],
	create?: GraphQLTypes["BodyTagCategoryWithoutTagsCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagConnectOrCreateCategoryRelationInput"]
};
	["BodyTagCategoryWithoutTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	remoteId?: string,
	color?: GraphQLTypes["BodyTagCategoryCreateColorEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BodyTagCategoryCreateColorEntityRelationInput"]: {
		connect?: GraphQLTypes["ColorUniqueWhere"],
	create?: GraphQLTypes["ColorWithoutBodyTagCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagCategoryConnectOrCreateColorRelationInput"]
};
	["ColorWithoutBodyTagCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	colorHex?: string,
	blogPostTag?: GraphQLTypes["ColorCreateBlogPostTagEntityRelationInput"],
	remoteId?: string,
	itemFlavorCategories?: Array<GraphQLTypes["ColorCreateItemFlavorCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ColorCreateBlogPostTagEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostTagUniqueWhere"],
	create?: GraphQLTypes["BlogPostTagWithoutColorCreateInput"],
	connectOrCreate?: GraphQLTypes["ColorConnectOrCreateBlogPostTagRelationInput"]
};
	["BlogPostTagWithoutColorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	blogPosts?: Array<GraphQLTypes["BlogPostTagCreateBlogPostsEntityRelationInput"]>,
	remoteId?: string,
	order?: number,
	_dummy_field_?: boolean
};
	["BlogPostTagCreateBlogPostsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostWithoutBlogPostTagsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostTagConnectOrCreateBlogPostsRelationInput"],
	alias?: string
};
	["BlogPostWithoutBlogPostTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	tags?: Array<GraphQLTypes["BlogPostCreateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostCreateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostCreateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostCreateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostCreateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostCreateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostCreateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostCreateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostCreateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostCreateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostCreateItemCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutBlogPostsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateItemCategoriesRelationInput"],
	alias?: string
};
	["ItemCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	slug?: string,
	subCategories?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	featureDependencies?: GraphQLTypes["ProductFeatureUniqueWhere"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	redirects?: GraphQLTypes["RedirectUniqueWhere"],
	declensionsFourth?: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["ItemCategoryWithoutBlogPostsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryCreateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryCreateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryCreateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryCreateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryCreateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryCreateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryCreateSubCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryWithoutCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateSubCategoriesRelationInput"],
	alias?: string
};
	["ItemSubCategoryWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryCreateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	flavorCategory?: GraphQLTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryCreateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryCreateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryCreateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemWithoutSubCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateItemsRelationInput"],
	alias?: string
};
	["ItemWithoutSubCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemCreateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemCreateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemCreateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemCreateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemCreateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemCreateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemCreateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemCreateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCreatePositiveForBodyTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagUniqueWhere"],
	create?: GraphQLTypes["BodyTagWithoutPositiveItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreatePositiveForBodyTagsRelationInput"],
	alias?: string
};
	["BodyTagWithoutPositiveItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagCreateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagCreatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagCreateNegativeProductsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagCreateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagCreateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagCreateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagCreateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagCreateNegativeItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemWithoutNegativeForBodyTagsCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagConnectOrCreateNegativeItemsRelationInput"],
	alias?: string
};
	["ItemWithoutNegativeForBodyTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemCreateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemCreateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemCreateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemCreateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemCreateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemCreateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemCreateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemCreateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemCreateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCreateSubCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateSubCategoriesRelationInput"],
	alias?: string
};
	["ItemSubCategoryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryCreateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryCreateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryCreateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryCreateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutItemSubCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateProductsRelationInput"],
	alias?: string
};
	["ProductWithoutItemSubCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreateDogsEntityRelationInput"]: {
		connect?: GraphQLTypes["DogUniqueWhere"],
	create?: GraphQLTypes["DogWithoutFedProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateDogsRelationInput"],
	alias?: string
};
	["DogWithoutFedProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogCreateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogCreateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogCreateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogCreateActivityEntityRelationInput"],
	reproduction?: GraphQLTypes["DogCreateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogCreateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogCreateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogCreateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogCreateAgeEntityRelationInput"]: {
		connect?: GraphQLTypes["AgeUniqueWhere"],
	create?: GraphQLTypes["AgeWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateAgeRelationInput"]
};
	["AgeWithoutDogsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	breeds?: Array<GraphQLTypes["AgeCreateBreedsEntityRelationInput"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	suitabilityCategories?: Array<GraphQLTypes["AgeCreateSuitabilityCategoriesEntityRelationInput"]>,
	remoteId?: string,
	productReviews?: Array<GraphQLTypes["AgeCreateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["AgeCreateBlogPostReviewsEntityRelationInput"]>,
	label?: string,
	categoryOrder?: string,
	_dummy_field_?: boolean
};
	["AgeCreateBreedsEntityRelationInput"]: {
		connect?: GraphQLTypes["BreedUniqueWhere"],
	create?: GraphQLTypes["BreedWithoutAgesCreateInput"],
	connectOrCreate?: GraphQLTypes["AgeConnectOrCreateBreedsRelationInput"],
	alias?: string
};
	["BreedWithoutAgesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["BreedCreateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedCreateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedCreateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedCreateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedCreateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedCreateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedCreateDogsEntityRelationInput"]: {
		connect?: GraphQLTypes["DogUniqueWhere"],
	create?: GraphQLTypes["DogWithoutBreedCreateInput"],
	connectOrCreate?: GraphQLTypes["BreedConnectOrCreateDogsRelationInput"],
	alias?: string
};
	["DogWithoutBreedCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	age?: GraphQLTypes["DogCreateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogCreateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogCreateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogCreateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogCreateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogCreateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogCreateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogCreateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogCreateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogCreateActivityEntityRelationInput"]: {
		connect?: GraphQLTypes["DogActivityUniqueWhere"],
	create?: GraphQLTypes["DogActivityWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateActivityRelationInput"]
};
	["DogActivityUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	dogs?: GraphQLTypes["DogUniqueWhere"],
	products?: GraphQLTypes["ProductUniqueWhere"]
};
	["DogActivityWithoutDogsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: string,
	products?: Array<GraphQLTypes["DogActivityCreateProductsEntityRelationInput"]>,
	dailyEnergyRequirementCoeficient?: number,
	remoteId?: string,
	suitabilityCategory?: GraphQLTypes["DogActivityCreateSuitabilityCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogActivityCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutRecommendedActivityCreateInput"],
	connectOrCreate?: GraphQLTypes["DogActivityConnectOrCreateProductsRelationInput"],
	alias?: string
};
	["ProductWithoutRecommendedActivityCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreatePackagingsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductPackageUniqueWhere"],
	create?: GraphQLTypes["ProductPackageWithoutProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreatePackagingsRelationInput"],
	alias?: string
};
	["ProductPackageWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	price?: number,
	order?: number,
	link?: string,
	amount?: number,
	externalId?: string,
	remoteId?: string,
	label?: string,
	positionId?: string,
	heurekaPrice?: number,
	heurekaLink?: string,
	_dummy_field_?: boolean
};
	["ProductConnectOrCreatePackagingsRelationInput"]: {
		connect: GraphQLTypes["ProductPackageUniqueWhere"],
	create: GraphQLTypes["ProductPackageWithoutProductCreateInput"]
};
	["ProductCreateItemSubCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateItemSubCategoriesRelationInput"],
	alias?: string
};
	["ItemSubCategoryWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryCreateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryCreateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryCreateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryCreateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryCreateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	create?: GraphQLTypes["ProductFeatureWithoutDependentSubCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateFeatureDependenciesRelationInput"],
	alias?: string
};
	["ProductFeatureWithoutDependentSubCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId?: string,
	linkItem?: GraphQLTypes["ProductFeatureCreateLinkItemEntityRelationInput"],
	dependentElement?: GraphQLTypes["ProductFeatureCreateDependentElementEntityRelationInput"],
	dependentCategory?: GraphQLTypes["ProductFeatureCreateDependentCategoryEntityRelationInput"],
	dependentFlag?: GraphQLTypes["ProductFeatureCreateDependentFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFeatureCreateLinkItemEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemWithoutFeaturesOfProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFeatureConnectOrCreateLinkItemRelationInput"]
};
	["ItemWithoutFeaturesOfProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemCreateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemCreateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	remoteId?: string,
	image?: GraphQLTypes["ItemCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemCreateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemCreateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemCreateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemCreateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemCreateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemCreateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCreateCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateCategoriesRelationInput"],
	alias?: string
};
	["ItemCategoryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryCreateBlogPostsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryCreateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryCreateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryCreateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryCreateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryCreateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryCreateBlogPostsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostWithoutItemCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateBlogPostsRelationInput"],
	alias?: string
};
	["BlogPostWithoutItemCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostCreateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostCreateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostCreateReviewsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostCreateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostCreateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostCreateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostCreateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostCreateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostCreateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostCreateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemWithoutBlogPostCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateItemsRelationInput"],
	alias?: string
};
	["ItemWithoutBlogPostCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemCreateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemCreateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemCreateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemCreateReferenceListEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemCreateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemCreateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemCreateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemCreateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCreateFeaturesOfProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	create?: GraphQLTypes["ProductFeatureWithoutLinkItemCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateFeaturesOfProductRelationInput"],
	alias?: string
};
	["ProductFeatureWithoutLinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId?: string,
	dependentElement?: GraphQLTypes["ProductFeatureCreateDependentElementEntityRelationInput"],
	dependentCategory?: GraphQLTypes["ProductFeatureCreateDependentCategoryEntityRelationInput"],
	dependentSubCategory?: GraphQLTypes["ProductFeatureCreateDependentSubCategoryEntityRelationInput"],
	dependentFlag?: GraphQLTypes["ProductFeatureCreateDependentFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFeatureCreateDependentElementEntityRelationInput"]: {
		connect?: GraphQLTypes["ElementUniqueWhere"],
	create?: GraphQLTypes["ElementWithoutFeatureDependenciesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFeatureConnectOrCreateDependentElementRelationInput"]
};
	["ElementWithoutFeatureDependenciesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["ElementCreateProductsEntityRelationInput"]>,
	suitabilityElements?: Array<GraphQLTypes["ElementCreateSuitabilityElementsEntityRelationInput"]>,
	remoteId?: string,
	unit?: string,
	filterOrder?: number,
	slug?: string,
	declensionSeventh?: string,
	_dummy_field_?: boolean
};
	["ElementCreateSuitabilityElementsEntityRelationInput"]: {
		connect?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	create?: GraphQLTypes["SuitabilityItemWithoutElementCreateInput"],
	connectOrCreate?: GraphQLTypes["ElementConnectOrCreateSuitabilityElementsRelationInput"],
	alias?: string
};
	["SuitabilityItemWithoutElementCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	min?: number,
	max?: number,
	remoteId?: string,
	order?: number,
	nutritionalValue?: GraphQLTypes["SuitabilityItemCreateNutritionalValueEntityRelationInput"],
	category?: GraphQLTypes["SuitabilityItemCreateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SuitabilityItemCreateNutritionalValueEntityRelationInput"]: {
		connect?: GraphQLTypes["NutritionalValueUniqueWhere"],
	create?: GraphQLTypes["NutritionalValueWithoutSuitabilityNutritionalValuesCreateInput"],
	connectOrCreate?: GraphQLTypes["SuitabilityItemConnectOrCreateNutritionalValueRelationInput"]
};
	["NutritionalValueWithoutSuitabilityNutritionalValuesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["NutritionalValueCreateProductsEntityRelationInput"]>,
	remoteId?: string,
	icon?: GraphQLTypes["NutritionalValueCreateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NutritionalValueCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	create?: GraphQLTypes["NutritionalValueOfProductWithoutNutritionalValueCreateInput"],
	connectOrCreate?: GraphQLTypes["NutritionalValueConnectOrCreateProductsRelationInput"],
	alias?: string
};
	["NutritionalValueOfProductWithoutNutritionalValueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	product?: GraphQLTypes["NutritionalValueOfProductCreateProductEntityRelationInput"],
	amount?: number,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["NutritionalValueOfProductCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutNutritionalValuesCreateInput"],
	connectOrCreate?: GraphQLTypes["NutritionalValueOfProductConnectOrCreateProductRelationInput"]
};
	["ProductWithoutNutritionalValuesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreateItemCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateItemCategoriesRelationInput"],
	alias?: string
};
	["ItemCategoryWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryCreateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryCreateItemsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryCreateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryCreateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryCreateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryCreateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryCreateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemWithoutCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateItemsRelationInput"],
	alias?: string
};
	["ItemWithoutCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemCreateSubCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemCreateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemCreateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemCreateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemCreateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemCreateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemCreateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemCreateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateImageRelationInput"]
};
	["ItemConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ItemCreateReferenceListEntityRelationInput"]: {
		connect?: GraphQLTypes["ReferenceListUniqueWhere"],
	create?: GraphQLTypes["ReferenceListCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateReferenceListRelationInput"]
};
	["ReferenceListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	references?: Array<GraphQLTypes["ReferenceListCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ReferenceListCreateReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ReferenceUniqueWhere"],
	create?: GraphQLTypes["ReferenceWithoutListCreateInput"],
	connectOrCreate?: GraphQLTypes["ReferenceListConnectOrCreateReferencesRelationInput"],
	alias?: string
};
	["ReferenceWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	link?: string,
	order?: number,
	_dummy_field_?: boolean
};
	["ReferenceListConnectOrCreateReferencesRelationInput"]: {
		connect: GraphQLTypes["ReferenceUniqueWhere"],
	create: GraphQLTypes["ReferenceWithoutListCreateInput"]
};
	["ItemConnectOrCreateReferenceListRelationInput"]: {
		connect: GraphQLTypes["ReferenceListUniqueWhere"],
	create: GraphQLTypes["ReferenceListCreateInput"]
};
	["ItemCreateBlogPostEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateBlogPostRelationInput"]
};
	["BlogPostWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostCreateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostCreateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostCreateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostCreateItemCategoriesEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostCreateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostCreateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostCreateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostCreateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostCreateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostCreateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateImageRelationInput"]
};
	["BlogPostConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["BlogPostCreateReferenceListEntityRelationInput"]: {
		connect?: GraphQLTypes["ReferenceListUniqueWhere"],
	create?: GraphQLTypes["ReferenceListCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateReferenceListRelationInput"]
};
	["BlogPostConnectOrCreateReferenceListRelationInput"]: {
		connect: GraphQLTypes["ReferenceListUniqueWhere"],
	create: GraphQLTypes["ReferenceListCreateInput"]
};
	["BlogPostCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutBlogPostsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateUserRelationInput"]
};
	["UserWithoutBlogPostsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["UserCreateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserCreateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserCreateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserCreateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserCreateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserCreateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserCreateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserCreateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserCreateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserCreateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserCreateBlogPostReviewReactionsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	create?: GraphQLTypes["BlogPostReviewReactionWithoutUserCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateBlogPostReviewReactionsRelationInput"],
	alias?: string
};
	["BlogPostReviewReactionWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	sentiment?: GraphQLTypes["SentimentType"],
	blogPostReview?: GraphQLTypes["BlogPostReviewReactionCreateBlogPostReviewEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostReviewReactionCreateBlogPostReviewEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	create?: GraphQLTypes["BlogPostReviewWithoutBlogPostReviewReactionsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewReactionConnectOrCreateBlogPostReviewRelationInput"]
};
	["BlogPostReviewWithoutBlogPostReviewReactionsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPost?: GraphQLTypes["BlogPostReviewCreateBlogPostEntityRelationInput"],
	user?: GraphQLTypes["BlogPostReviewCreateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["BlogPostReviewCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["BlogPostReviewCreateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["BlogPostReviewCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutBlogPostReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewConnectOrCreateUserRelationInput"]
};
	["UserWithoutBlogPostReviewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["UserCreateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserCreateVeterinaryEntityRelationInput"],
	email?: string,
	productReviews?: Array<GraphQLTypes["UserCreateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserCreateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserCreateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserCreateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserCreateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserCreateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserCreateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserCreateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserCreateProductReviewReactionsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	create?: GraphQLTypes["ProductReviewReactionWithoutUserCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateProductReviewReactionsRelationInput"],
	alias?: string
};
	["ProductReviewReactionWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	sentiment?: GraphQLTypes["SentimentType"],
	productReview?: GraphQLTypes["ProductReviewReactionCreateProductReviewEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductReviewReactionCreateProductReviewEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductReviewUniqueWhere"],
	create?: GraphQLTypes["ProductReviewWithoutProductReviewReactionsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewReactionConnectOrCreateProductReviewRelationInput"]
};
	["ProductReviewWithoutProductReviewReactionsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	score?: GraphQLTypes["ProductReviewCreateScoreEntityRelationInput"],
	product?: GraphQLTypes["ProductReviewCreateProductEntityRelationInput"],
	user?: GraphQLTypes["ProductReviewCreateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["ProductReviewCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["ProductReviewCreateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ProductReviewCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutProductReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewConnectOrCreateUserRelationInput"]
};
	["UserWithoutProductReviewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["UserCreateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserCreateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserCreateBlogPostReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserCreateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserCreateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserCreateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserCreateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserCreateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserCreateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserCreateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserCreateBlogPostsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostWithoutUserCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateBlogPostsRelationInput"],
	alias?: string
};
	["BlogPostWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostCreateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostCreateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostCreateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostCreateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostCreateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostCreateReferenceListEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostCreateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostCreateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostCreateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostCreateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostCreateAdsEntityRelationInput"]: {
		connect?: GraphQLTypes["AdUniqueWhere"],
	create?: GraphQLTypes["AdWithoutBlogPostsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateAdsRelationInput"],
	alias?: string
};
	["AdUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	slug?: string,
	image?: GraphQLTypes["ImageUniqueWhere"],
	contentReferences?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["AdWithoutBlogPostsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["AdCreateImageEntityRelationInput"],
	isBrandSectionVisible?: boolean,
	isBlogPostSectionVisible?: boolean,
	isIngredientSectionVisible?: boolean,
	isResultsVisible?: boolean,
	isSearchVisible?: boolean,
	itemCategories?: Array<GraphQLTypes["AdCreateItemCategoriesEntityRelationInput"]>,
	brands?: Array<GraphQLTypes["AdCreateBrandsEntityRelationInput"]>,
	isActive?: boolean,
	link?: string,
	note?: string,
	activeFrom?: GraphQLTypes["DateTime"],
	activeUntil?: GraphQLTypes["DateTime"],
	slug?: string,
	contentReferences?: Array<GraphQLTypes["AdCreateContentReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AdCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["AdConnectOrCreateImageRelationInput"]
};
	["AdConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["AdCreateItemCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutAdsCreateInput"],
	connectOrCreate?: GraphQLTypes["AdConnectOrCreateItemCategoriesRelationInput"],
	alias?: string
};
	["ItemCategoryWithoutAdsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryCreateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryCreateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryCreateImageEntityRelationInput"],
	comparatorGroupId?: string,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryCreateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryCreateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryCreateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutItemCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateProductsRelationInput"],
	alias?: string
};
	["ProductWithoutItemCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreateElementsEntityRelationInput"]: {
		connect?: GraphQLTypes["ElementOfProductUniqueWhere"],
	create?: GraphQLTypes["ElementOfProductWithoutProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateElementsRelationInput"],
	alias?: string
};
	["ElementOfProductWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	amount?: number,
	remoteId?: string,
	element?: GraphQLTypes["ElementOfProductCreateElementEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ElementOfProductCreateElementEntityRelationInput"]: {
		connect?: GraphQLTypes["ElementUniqueWhere"],
	create?: GraphQLTypes["ElementWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ElementOfProductConnectOrCreateElementRelationInput"]
};
	["ElementWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	featureDependencies?: Array<GraphQLTypes["ElementCreateFeatureDependenciesEntityRelationInput"]>,
	suitabilityElements?: Array<GraphQLTypes["ElementCreateSuitabilityElementsEntityRelationInput"]>,
	remoteId?: string,
	unit?: string,
	filterOrder?: number,
	slug?: string,
	declensionSeventh?: string,
	_dummy_field_?: boolean
};
	["ElementCreateFeatureDependenciesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	create?: GraphQLTypes["ProductFeatureWithoutDependentElementCreateInput"],
	connectOrCreate?: GraphQLTypes["ElementConnectOrCreateFeatureDependenciesRelationInput"],
	alias?: string
};
	["ProductFeatureWithoutDependentElementCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId?: string,
	linkItem?: GraphQLTypes["ProductFeatureCreateLinkItemEntityRelationInput"],
	dependentCategory?: GraphQLTypes["ProductFeatureCreateDependentCategoryEntityRelationInput"],
	dependentSubCategory?: GraphQLTypes["ProductFeatureCreateDependentSubCategoryEntityRelationInput"],
	dependentFlag?: GraphQLTypes["ProductFeatureCreateDependentFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFeatureCreateDependentCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutFeatureDependenciesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFeatureConnectOrCreateDependentCategoryRelationInput"]
};
	["ItemCategoryWithoutFeatureDependenciesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryCreateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryCreateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryCreateProductsEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryCreateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryCreateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryCreateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryCreateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryCreateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateImageRelationInput"]
};
	["ItemCategoryConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ItemCategoryCreateAdsEntityRelationInput"]: {
		connect?: GraphQLTypes["AdUniqueWhere"],
	create?: GraphQLTypes["AdWithoutItemCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateAdsRelationInput"],
	alias?: string
};
	["AdWithoutItemCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["AdCreateImageEntityRelationInput"],
	isBrandSectionVisible?: boolean,
	isBlogPostSectionVisible?: boolean,
	isIngredientSectionVisible?: boolean,
	isResultsVisible?: boolean,
	isSearchVisible?: boolean,
	blogPosts?: Array<GraphQLTypes["AdCreateBlogPostsEntityRelationInput"]>,
	brands?: Array<GraphQLTypes["AdCreateBrandsEntityRelationInput"]>,
	isActive?: boolean,
	link?: string,
	note?: string,
	activeFrom?: GraphQLTypes["DateTime"],
	activeUntil?: GraphQLTypes["DateTime"],
	slug?: string,
	contentReferences?: Array<GraphQLTypes["AdCreateContentReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AdCreateBlogPostsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostWithoutAdsCreateInput"],
	connectOrCreate?: GraphQLTypes["AdConnectOrCreateBlogPostsRelationInput"],
	alias?: string
};
	["BlogPostWithoutAdsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostCreateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostCreateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostCreateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostCreateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostCreateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostCreateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostCreateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostCreateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostCreateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostCreateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateSeoRelationInput"]
};
	["SeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoCreateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoCreateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoCreateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoCreateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoCreateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoCreateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoCreateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoCreateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoCreateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoCreateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoCreateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SeoCreateBrandsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandsPageUniqueWhere"],
	create?: GraphQLTypes["BrandsPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateBrandsPageRelationInput"]
};
	["BrandsPageWithoutSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	redirects?: Array<GraphQLTypes["BrandsPageCreateRedirectsEntityRelationInput"]>,
	content?: GraphQLTypes["BrandsPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandsPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandsPageCreateRedirectsEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutBrandsPageCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandsPageConnectOrCreateRedirectsRelationInput"],
	alias?: string
};
	["RedirectWithoutBrandsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectCreateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectCreateItemCategoryEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectCreateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectCreateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectCreateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectCreateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectCreateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateItemCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateItemCategoryRelationInput"]
};
	["ItemCategoryWithoutRedirectsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryCreateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryCreateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryCreateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryCreateAdsEntityRelationInput"]>,
	slug?: string,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryCreateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryCreateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryCreateFeatureDependenciesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	create?: GraphQLTypes["ProductFeatureWithoutDependentCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateFeatureDependenciesRelationInput"],
	alias?: string
};
	["ProductFeatureWithoutDependentCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId?: string,
	linkItem?: GraphQLTypes["ProductFeatureCreateLinkItemEntityRelationInput"],
	dependentElement?: GraphQLTypes["ProductFeatureCreateDependentElementEntityRelationInput"],
	dependentSubCategory?: GraphQLTypes["ProductFeatureCreateDependentSubCategoryEntityRelationInput"],
	dependentFlag?: GraphQLTypes["ProductFeatureCreateDependentFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFeatureCreateDependentSubCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryWithoutFeatureDependenciesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFeatureConnectOrCreateDependentSubCategoryRelationInput"]
};
	["ItemSubCategoryWithoutFeatureDependenciesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryCreateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryCreateProductsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryCreateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryCreateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryCreateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryCreateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutSubCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateCategoryRelationInput"]
};
	["ItemCategoryWithoutSubCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	shortDescription?: string,
	blogPosts?: Array<GraphQLTypes["ItemCategoryCreateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryCreateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryCreateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryCreateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryCreateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryCreateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryCreateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryCreateRedirectsEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutItemCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateRedirectsRelationInput"],
	alias?: string
};
	["RedirectWithoutItemCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectCreateGenericPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectCreateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectCreateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectCreateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectCreateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectCreateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectCreateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateBrandsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandsPageUniqueWhere"],
	create?: GraphQLTypes["BrandsPageWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateBrandsPageRelationInput"]
};
	["BrandsPageWithoutRedirectsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["BrandsPageCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["BrandsPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandsPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandsPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutBrandsPageCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandsPageConnectOrCreateSeoRelationInput"]
};
	["SeoWithoutBrandsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoCreateBlogPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoCreateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoCreateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoCreateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoCreateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoCreateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoCreateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoCreateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoCreateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoCreateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SeoCreateComparatorPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ComparatorPageUniqueWhere"],
	create?: GraphQLTypes["ComparatorPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateComparatorPageRelationInput"]
};
	["ComparatorPageWithoutSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	redirects?: Array<GraphQLTypes["ComparatorPageCreateRedirectsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ComparatorPageCreateRedirectsEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutComparatorPageCreateInput"],
	connectOrCreate?: GraphQLTypes["ComparatorPageConnectOrCreateRedirectsRelationInput"],
	alias?: string
};
	["RedirectWithoutComparatorPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectCreateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectCreateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectCreateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectCreateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectCreateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectCreateWizardPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectCreateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateBlogPageEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPageUniqueWhere"],
	create?: GraphQLTypes["BlogPageWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateBlogPageRelationInput"]
};
	["BlogPageWithoutRedirectsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["BlogPageCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["BlogPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutBlogPageCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPageConnectOrCreateSeoRelationInput"]
};
	["SeoWithoutBlogPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoCreateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoCreateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoCreateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoCreateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoCreateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoCreateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoCreateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoCreateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoCreateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoCreateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SeoCreateGenericPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageUniqueWhere"],
	create?: GraphQLTypes["GenericPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateGenericPageRelationInput"]
};
	["GenericPageWithoutSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["GenericPageCreateLinkEntityRelationInput"],
	redirects?: Array<GraphQLTypes["GenericPageCreateRedirectsEntityRelationInput"]>,
	content?: GraphQLTypes["GenericPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["GenericPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GenericPageCreateRedirectsEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutGenericPageCreateInput"],
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateRedirectsRelationInput"],
	alias?: string
};
	["RedirectWithoutGenericPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	to?: string,
	order?: number,
	from?: string,
	itemCategory?: GraphQLTypes["RedirectCreateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectCreateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectCreateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectCreateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectCreateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectCreateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectCreateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateContactPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactPageUniqueWhere"],
	create?: GraphQLTypes["ContactPageWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateContactPageRelationInput"]
};
	["ContactPageWithoutRedirectsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["ContactPageCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["ContactPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ContactPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutContactPageCreateInput"],
	connectOrCreate?: GraphQLTypes["ContactPageConnectOrCreateSeoRelationInput"]
};
	["SeoWithoutContactPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoCreateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoCreateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoCreateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoCreateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoCreateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoCreateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoCreateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoCreateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoCreateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoCreateWizardPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SeoCreateHomePageEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageUniqueWhere"],
	create?: GraphQLTypes["HomePageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateHomePageRelationInput"]
};
	["HomePageWithoutSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	lead?: string,
	_dummy_field_?: boolean
};
	["SeoConnectOrCreateHomePageRelationInput"]: {
		connect: GraphQLTypes["HomePageUniqueWhere"],
	create: GraphQLTypes["HomePageWithoutSeoCreateInput"]
};
	["SeoCreateIngredientsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["IngredientsPageUniqueWhere"],
	create?: GraphQLTypes["IngredientsPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateIngredientsPageRelationInput"]
};
	["IngredientsPageWithoutSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	content?: GraphQLTypes["IngredientsPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["IngredientsPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["IngredientsPageCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["IngredientsPageConnectOrCreateContentRelationInput"]
};
	["IngredientsPageConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["IngredientsPageCreateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["IngredientsPageConnectOrCreateDraftRelationInput"]
};
	["IngredientsPageConnectOrCreateDraftRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["SeoConnectOrCreateIngredientsPageRelationInput"]: {
		connect: GraphQLTypes["IngredientsPageUniqueWhere"],
	create: GraphQLTypes["IngredientsPageWithoutSeoCreateInput"]
};
	["SeoCreateLoginPageEntityRelationInput"]: {
		connect?: GraphQLTypes["LoginPageUniqueWhere"],
	create?: GraphQLTypes["LoginPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateLoginPageRelationInput"]
};
	["LoginPageWithoutSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["SeoConnectOrCreateLoginPageRelationInput"]: {
		connect: GraphQLTypes["LoginPageUniqueWhere"],
	create: GraphQLTypes["LoginPageWithoutSeoCreateInput"]
};
	["SeoCreateRegisterPageEntityRelationInput"]: {
		connect?: GraphQLTypes["RegisterPageUniqueWhere"],
	create?: GraphQLTypes["RegisterPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateRegisterPageRelationInput"]
};
	["RegisterPageWithoutSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["SeoConnectOrCreateRegisterPageRelationInput"]: {
		connect: GraphQLTypes["RegisterPageUniqueWhere"],
	create: GraphQLTypes["RegisterPageWithoutSeoCreateInput"]
};
	["SeoCreateSearchPageEntityRelationInput"]: {
		connect?: GraphQLTypes["SearchPageUniqueWhere"],
	create?: GraphQLTypes["SearchPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateSearchPageRelationInput"]
};
	["SearchPageWithoutSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["SeoConnectOrCreateSearchPageRelationInput"]: {
		connect: GraphQLTypes["SearchPageUniqueWhere"],
	create: GraphQLTypes["SearchPageWithoutSeoCreateInput"]
};
	["SeoCreateWizardPageEntityRelationInput"]: {
		connect?: GraphQLTypes["WizardPageUniqueWhere"],
	create?: GraphQLTypes["WizardPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateWizardPageRelationInput"]
};
	["WizardPageWithoutSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	redirects?: Array<GraphQLTypes["WizardPageCreateRedirectsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["WizardPageCreateRedirectsEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutWizardPageCreateInput"],
	connectOrCreate?: GraphQLTypes["WizardPageConnectOrCreateRedirectsRelationInput"],
	alias?: string
};
	["RedirectWithoutWizardPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectCreateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectCreateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectCreateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectCreateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectCreateContactPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectCreateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectCreateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateComparatorPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ComparatorPageUniqueWhere"],
	create?: GraphQLTypes["ComparatorPageWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateComparatorPageRelationInput"]
};
	["ComparatorPageWithoutRedirectsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["ComparatorPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ComparatorPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutComparatorPageCreateInput"],
	connectOrCreate?: GraphQLTypes["ComparatorPageConnectOrCreateSeoRelationInput"]
};
	["SeoWithoutComparatorPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoCreateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoCreateBrandsPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoCreateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoCreateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoCreateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoCreateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoCreateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoCreateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoCreateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoCreateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SeoCreateContactPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactPageUniqueWhere"],
	create?: GraphQLTypes["ContactPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateContactPageRelationInput"]
};
	["ContactPageWithoutSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	redirects?: Array<GraphQLTypes["ContactPageCreateRedirectsEntityRelationInput"]>,
	content?: GraphQLTypes["ContactPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ContactPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactPageCreateRedirectsEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutContactPageCreateInput"],
	connectOrCreate?: GraphQLTypes["ContactPageConnectOrCreateRedirectsRelationInput"],
	alias?: string
};
	["RedirectWithoutContactPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectCreateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectCreateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectCreateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectCreateBlogPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectCreateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectCreateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectCreateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateWizardPageEntityRelationInput"]: {
		connect?: GraphQLTypes["WizardPageUniqueWhere"],
	create?: GraphQLTypes["WizardPageWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateWizardPageRelationInput"]
};
	["WizardPageWithoutRedirectsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["WizardPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["WizardPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutWizardPageCreateInput"],
	connectOrCreate?: GraphQLTypes["WizardPageConnectOrCreateSeoRelationInput"]
};
	["SeoWithoutWizardPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoCreateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoCreateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoCreateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoCreateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoCreateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoCreateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoCreateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoCreateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoCreateSearchPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoCreateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["WizardPageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoWithoutWizardPageCreateInput"]
};
	["RedirectConnectOrCreateWizardPageRelationInput"]: {
		connect: GraphQLTypes["WizardPageUniqueWhere"],
	create: GraphQLTypes["WizardPageWithoutRedirectsCreateInput"]
};
	["RedirectCreateBlogPostEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateBlogPostRelationInput"]
};
	["BlogPostWithoutRedirectsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostCreateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostCreateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostCreateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostCreateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostCreateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostCreateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostCreateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostCreateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostCreateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostCreateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateContentRelationInput"]
};
	["BlogPostConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["BlogPostCreateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateDraftRelationInput"]
};
	["BlogPostConnectOrCreateDraftRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["RedirectConnectOrCreateBlogPostRelationInput"]: {
		connect: GraphQLTypes["BlogPostUniqueWhere"],
	create: GraphQLTypes["BlogPostWithoutRedirectsCreateInput"]
};
	["ContactPageConnectOrCreateRedirectsRelationInput"]: {
		connect: GraphQLTypes["RedirectUniqueWhere"],
	create: GraphQLTypes["RedirectWithoutContactPageCreateInput"]
};
	["ContactPageCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ContactPageConnectOrCreateContentRelationInput"]
};
	["ContactPageConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ContactPageCreateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ContactPageConnectOrCreateDraftRelationInput"]
};
	["ContactPageConnectOrCreateDraftRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["SeoConnectOrCreateContactPageRelationInput"]: {
		connect: GraphQLTypes["ContactPageUniqueWhere"],
	create: GraphQLTypes["ContactPageWithoutSeoCreateInput"]
};
	["ComparatorPageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoWithoutComparatorPageCreateInput"]
};
	["RedirectConnectOrCreateComparatorPageRelationInput"]: {
		connect: GraphQLTypes["ComparatorPageUniqueWhere"],
	create: GraphQLTypes["ComparatorPageWithoutRedirectsCreateInput"]
};
	["WizardPageConnectOrCreateRedirectsRelationInput"]: {
		connect: GraphQLTypes["RedirectUniqueWhere"],
	create: GraphQLTypes["RedirectWithoutWizardPageCreateInput"]
};
	["SeoConnectOrCreateWizardPageRelationInput"]: {
		connect: GraphQLTypes["WizardPageUniqueWhere"],
	create: GraphQLTypes["WizardPageWithoutSeoCreateInput"]
};
	["ContactPageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoWithoutContactPageCreateInput"]
};
	["RedirectConnectOrCreateContactPageRelationInput"]: {
		connect: GraphQLTypes["ContactPageUniqueWhere"],
	create: GraphQLTypes["ContactPageWithoutRedirectsCreateInput"]
};
	["GenericPageConnectOrCreateRedirectsRelationInput"]: {
		connect: GraphQLTypes["RedirectUniqueWhere"],
	create: GraphQLTypes["RedirectWithoutGenericPageCreateInput"]
};
	["GenericPageCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateContentRelationInput"]
};
	["GenericPageConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["GenericPageCreateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateDraftRelationInput"]
};
	["GenericPageConnectOrCreateDraftRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["SeoConnectOrCreateGenericPageRelationInput"]: {
		connect: GraphQLTypes["GenericPageUniqueWhere"],
	create: GraphQLTypes["GenericPageWithoutSeoCreateInput"]
};
	["BlogPageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoWithoutBlogPageCreateInput"]
};
	["BlogPageCreateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPageConnectOrCreateDraftRelationInput"]
};
	["BlogPageConnectOrCreateDraftRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["RedirectConnectOrCreateBlogPageRelationInput"]: {
		connect: GraphQLTypes["BlogPageUniqueWhere"],
	create: GraphQLTypes["BlogPageWithoutRedirectsCreateInput"]
};
	["ComparatorPageConnectOrCreateRedirectsRelationInput"]: {
		connect: GraphQLTypes["RedirectUniqueWhere"],
	create: GraphQLTypes["RedirectWithoutComparatorPageCreateInput"]
};
	["SeoConnectOrCreateComparatorPageRelationInput"]: {
		connect: GraphQLTypes["ComparatorPageUniqueWhere"],
	create: GraphQLTypes["ComparatorPageWithoutSeoCreateInput"]
};
	["BrandsPageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoWithoutBrandsPageCreateInput"]
};
	["BrandsPageCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandsPageConnectOrCreateContentRelationInput"]
};
	["BrandsPageConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["BrandsPageCreateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandsPageConnectOrCreateDraftRelationInput"]
};
	["BrandsPageConnectOrCreateDraftRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["RedirectConnectOrCreateBrandsPageRelationInput"]: {
		connect: GraphQLTypes["BrandsPageUniqueWhere"],
	create: GraphQLTypes["BrandsPageWithoutRedirectsCreateInput"]
};
	["ItemCategoryConnectOrCreateRedirectsRelationInput"]: {
		connect: GraphQLTypes["RedirectUniqueWhere"],
	create: GraphQLTypes["RedirectWithoutItemCategoryCreateInput"]
};
	["ItemCategoryCreateDeclensionsFourthEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"],
	create?: GraphQLTypes["ItemDeclensionFourthVariantWithoutCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateDeclensionsFourthRelationInput"],
	alias?: string
};
	["ItemDeclensionFourthVariantWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ItemDeclensionFourthVariantCreateItemsEntityRelationInput"]>,
	label?: string,
	remoteId?: string,
	declensionSeventh?: string,
	isNegativ?: boolean,
	seo?: GraphQLTypes["ItemDeclensionFourthVariantCreateSeoEntityRelationInput"],
	subcategory?: GraphQLTypes["ItemDeclensionFourthVariantCreateSubcategoryEntityRelationInput"],
	element?: GraphQLTypes["ItemDeclensionFourthVariantCreateElementEntityRelationInput"],
	products?: Array<GraphQLTypes["ItemDeclensionFourthVariantCreateProductsEntityRelationInput"]>,
	slug?: string,
	content?: GraphQLTypes["ItemDeclensionFourthVariantCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemDeclensionFourthVariantCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemDeclensionFourthVariantCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemWithoutDeclensionFourthCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateItemsRelationInput"],
	alias?: string
};
	["ItemWithoutDeclensionFourthCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemCreateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemCreateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemCreateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemCreateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemCreateBlogPostEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemCreateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemCreateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemCreateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCreateDeclensionSeventhEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemDeclensionSeventhVariantUniqueWhere"],
	create?: GraphQLTypes["ItemDeclensionSeventhVariantWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateDeclensionSeventhRelationInput"]
};
	["ItemDeclensionSeventhVariantUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	items?: GraphQLTypes["ItemUniqueWhere"]
};
	["ItemDeclensionSeventhVariantWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: string,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ItemConnectOrCreateDeclensionSeventhRelationInput"]: {
		connect: GraphQLTypes["ItemDeclensionSeventhVariantUniqueWhere"],
	create: GraphQLTypes["ItemDeclensionSeventhVariantWithoutItemsCreateInput"]
};
	["ItemCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateSeoRelationInput"]
};
	["ItemConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["ItemCreateAliasesEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemAliasUniqueWhere"],
	create?: GraphQLTypes["ItemAliasWithoutItemCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateAliasesRelationInput"],
	alias?: string
};
	["ItemAliasWithoutItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	name?: string,
	_dummy_field_?: boolean
};
	["ItemConnectOrCreateAliasesRelationInput"]: {
		connect: GraphQLTypes["ItemAliasUniqueWhere"],
	create: GraphQLTypes["ItemAliasWithoutItemCreateInput"]
};
	["ItemCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateContentRelationInput"]
};
	["ItemConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ItemCreateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateDraftRelationInput"]
};
	["ItemConnectOrCreateDraftRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ItemDeclensionFourthVariantConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["ItemUniqueWhere"],
	create: GraphQLTypes["ItemWithoutDeclensionFourthCreateInput"]
};
	["ItemDeclensionFourthVariantCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateSeoRelationInput"]
};
	["ItemDeclensionFourthVariantConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["ItemDeclensionFourthVariantCreateSubcategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateSubcategoryRelationInput"]
};
	["ItemSubCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryCreateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryCreateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryCreateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryCreateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryCreateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemFlavorCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemFlavorCategoryWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateFlavorCategoryRelationInput"]
};
	["ItemFlavorCategoryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	remoteId?: string,
	color?: GraphQLTypes["ItemFlavorCategoryCreateColorEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemFlavorCategoryCreateColorEntityRelationInput"]: {
		connect?: GraphQLTypes["ColorUniqueWhere"],
	create?: GraphQLTypes["ColorWithoutItemFlavorCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemFlavorCategoryConnectOrCreateColorRelationInput"]
};
	["ColorWithoutItemFlavorCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	colorHex?: string,
	bodyTagCategory?: GraphQLTypes["ColorCreateBodyTagCategoryEntityRelationInput"],
	blogPostTag?: GraphQLTypes["ColorCreateBlogPostTagEntityRelationInput"],
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ItemFlavorCategoryConnectOrCreateColorRelationInput"]: {
		connect: GraphQLTypes["ColorUniqueWhere"],
	create: GraphQLTypes["ColorWithoutItemFlavorCategoriesCreateInput"]
};
	["ItemSubCategoryConnectOrCreateFlavorCategoryRelationInput"]: {
		connect: GraphQLTypes["ItemFlavorCategoryUniqueWhere"],
	create: GraphQLTypes["ItemFlavorCategoryWithoutItemsCreateInput"]
};
	["ItemSubCategoryCreateDogsEntityRelationInput"]: {
		connect?: GraphQLTypes["DogUniqueWhere"],
	create?: GraphQLTypes["DogWithoutAllergiesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateDogsRelationInput"],
	alias?: string
};
	["DogWithoutAllergiesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogCreateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogCreateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogCreateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogCreateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogCreateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogCreateReproductionEntityRelationInput"],
	illnesses?: Array<GraphQLTypes["DogCreateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogCreateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogCreateFedProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateFedProductRelationInput"]
};
	["ProductWithoutDogsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreateRecommendedDogSizesEntityRelationInput"]: {
		connect?: GraphQLTypes["DogSizeUniqueWhere"],
	create?: GraphQLTypes["DogSizeWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateRecommendedDogSizesRelationInput"],
	alias?: string
};
	["DogSizeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	breeds?: GraphQLTypes["BreedUniqueWhere"]
};
	["DogSizeWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	breeds?: Array<GraphQLTypes["DogSizeCreateBreedsEntityRelationInput"]>,
	remoteId?: string,
	suitabilityCategory?: GraphQLTypes["DogSizeCreateSuitabilityCategoryEntityRelationInput"],
	name?: GraphQLTypes["SizeType"],
	label?: string,
	order?: number,
	isFilterVisible?: boolean,
	_dummy_field_?: boolean
};
	["DogSizeCreateBreedsEntityRelationInput"]: {
		connect?: GraphQLTypes["BreedUniqueWhere"],
	create?: GraphQLTypes["BreedWithoutSizeCreateInput"],
	connectOrCreate?: GraphQLTypes["DogSizeConnectOrCreateBreedsRelationInput"],
	alias?: string
};
	["BreedWithoutSizeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["BreedCreateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedCreateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedCreateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedCreateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedCreateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedCreateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedCreateSuitabilityCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create?: GraphQLTypes["SuitabilityCategoryWithoutBreedsCreateInput"],
	connectOrCreate?: GraphQLTypes["BreedConnectOrCreateSuitabilityCategoryRelationInput"]
};
	["SuitabilityCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	dogSizes?: GraphQLTypes["DogSizeUniqueWhere"],
	dogActivities?: GraphQLTypes["DogActivityUniqueWhere"],
	breeds?: GraphQLTypes["BreedUniqueWhere"],
	suitabilityItems?: GraphQLTypes["SuitabilityItemUniqueWhere"]
};
	["SuitabilityCategoryWithoutBreedsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	dogSizes?: Array<GraphQLTypes["SuitabilityCategoryCreateDogSizesEntityRelationInput"]>,
	dogActivities?: Array<GraphQLTypes["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"]>,
	suitabilityItems?: Array<GraphQLTypes["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"]>,
	dogAges?: Array<GraphQLTypes["SuitabilityCategoryCreateDogAgesEntityRelationInput"]>,
	isPregnant?: boolean,
	remoteId?: string,
	isBreastfeeding?: boolean,
	_dummy_field_?: boolean
};
	["SuitabilityCategoryCreateDogSizesEntityRelationInput"]: {
		connect?: GraphQLTypes["DogSizeUniqueWhere"],
	create?: GraphQLTypes["DogSizeWithoutSuitabilityCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["SuitabilityCategoryConnectOrCreateDogSizesRelationInput"],
	alias?: string
};
	["DogSizeWithoutSuitabilityCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	breeds?: Array<GraphQLTypes["DogSizeCreateBreedsEntityRelationInput"]>,
	remoteId?: string,
	products?: Array<GraphQLTypes["DogSizeCreateProductsEntityRelationInput"]>,
	name?: GraphQLTypes["SizeType"],
	label?: string,
	order?: number,
	isFilterVisible?: boolean,
	_dummy_field_?: boolean
};
	["DogSizeCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutRecommendedDogSizesCreateInput"],
	connectOrCreate?: GraphQLTypes["DogSizeConnectOrCreateProductsRelationInput"],
	alias?: string
};
	["ProductWithoutRecommendedDogSizesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreateGranuleSizesEntityRelationInput"]: {
		connect?: GraphQLTypes["GranuleSizeUniqueWhere"],
	create?: GraphQLTypes["GranuleSizeWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateGranuleSizesRelationInput"],
	alias?: string
};
	["GranuleSizeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["GranuleSizeWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	name?: GraphQLTypes["GranuleSizeType"],
	_dummy_field_?: boolean
};
	["ProductConnectOrCreateGranuleSizesRelationInput"]: {
		connect: GraphQLTypes["GranuleSizeUniqueWhere"],
	create: GraphQLTypes["GranuleSizeWithoutProductsCreateInput"]
};
	["ProductCreateProductLineEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductLineUniqueWhere"],
	create?: GraphQLTypes["ProductLineWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateProductLineRelationInput"]
};
	["ProductLineWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	remoteId?: string,
	lead?: string,
	order?: number,
	brand?: GraphQLTypes["ProductLineCreateBrandEntityRelationInput"],
	logo?: GraphQLTypes["ProductLineCreateLogoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ProductLineCreateAliasesEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["ProductLineCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["ProductLineCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	_dummy_field_?: boolean
};
	["ProductLineCreateBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutProductLinesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductLineConnectOrCreateBrandRelationInput"]
};
	["BrandUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	slug?: string,
	products?: GraphQLTypes["ProductUniqueWhere"],
	productLines?: GraphQLTypes["ProductLineUniqueWhere"],
	logo?: GraphQLTypes["ImageUniqueWhere"],
	aliases?: GraphQLTypes["BrandAliasUniqueWhere"],
	flavors?: GraphQLTypes["BrandFlavorUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	filterCombos?: GraphQLTypes["FilterComboUniqueWhere"],
	topx?: GraphQLTypes["TOPXBrandUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["BrandWithoutProductLinesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["BrandCreateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandCreateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	logo?: GraphQLTypes["BrandCreateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandCreateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandCreateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandCreateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandCreateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandCreateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandCreateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutBrandCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateProductsRelationInput"],
	alias?: string
};
	["ProductWithoutBrandCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreateFlagsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	create?: GraphQLTypes["ProductFlagOfProductWithoutProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateFlagsRelationInput"],
	alias?: string
};
	["ProductFlagOfProductWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	value?: GraphQLTypes["ProductFlagValue"],
	flag?: GraphQLTypes["ProductFlagOfProductCreateFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFlagOfProductCreateFlagEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductFlagUniqueWhere"],
	create?: GraphQLTypes["ProductFlagWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFlagOfProductConnectOrCreateFlagRelationInput"]
};
	["ProductFlagUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	productFeatures?: GraphQLTypes["ProductFeatureUniqueWhere"],
	products?: GraphQLTypes["ProductFlagOfProductUniqueWhere"]
};
	["ProductFlagWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	productFeatures?: Array<GraphQLTypes["ProductFlagCreateProductFeaturesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductFlagCreateProductFeaturesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	create?: GraphQLTypes["ProductFeatureWithoutDependentFlagCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFlagConnectOrCreateProductFeaturesRelationInput"],
	alias?: string
};
	["ProductFeatureWithoutDependentFlagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId?: string,
	linkItem?: GraphQLTypes["ProductFeatureCreateLinkItemEntityRelationInput"],
	dependentElement?: GraphQLTypes["ProductFeatureCreateDependentElementEntityRelationInput"],
	dependentCategory?: GraphQLTypes["ProductFeatureCreateDependentCategoryEntityRelationInput"],
	dependentSubCategory?: GraphQLTypes["ProductFeatureCreateDependentSubCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFlagConnectOrCreateProductFeaturesRelationInput"]: {
		connect: GraphQLTypes["ProductFeatureUniqueWhere"],
	create: GraphQLTypes["ProductFeatureWithoutDependentFlagCreateInput"]
};
	["ProductFlagOfProductConnectOrCreateFlagRelationInput"]: {
		connect: GraphQLTypes["ProductFlagUniqueWhere"],
	create: GraphQLTypes["ProductFlagWithoutProductsCreateInput"]
};
	["ProductConnectOrCreateFlagsRelationInput"]: {
		connect: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	create: GraphQLTypes["ProductFlagOfProductWithoutProductCreateInput"]
};
	["ProductCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateImageRelationInput"]
};
	["ProductConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ProductCreateRecommendedActivityEntityRelationInput"]: {
		connect?: GraphQLTypes["DogActivityUniqueWhere"],
	create?: GraphQLTypes["DogActivityWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateRecommendedActivityRelationInput"]
};
	["DogActivityWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: string,
	dogs?: Array<GraphQLTypes["DogActivityCreateDogsEntityRelationInput"]>,
	dailyEnergyRequirementCoeficient?: number,
	remoteId?: string,
	suitabilityCategory?: GraphQLTypes["DogActivityCreateSuitabilityCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogActivityCreateDogsEntityRelationInput"]: {
		connect?: GraphQLTypes["DogUniqueWhere"],
	create?: GraphQLTypes["DogWithoutActivityCreateInput"],
	connectOrCreate?: GraphQLTypes["DogActivityConnectOrCreateDogsRelationInput"],
	alias?: string
};
	["DogWithoutActivityCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogCreateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogCreateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogCreateOwnerEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogCreateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogCreateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogCreateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogCreateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogCreateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogCreateReproductionEntityRelationInput"]: {
		connect?: GraphQLTypes["DogReproductionUniqueWhere"],
	create?: GraphQLTypes["DogReproductionWithoutDogCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateReproductionRelationInput"]
};
	["DogReproductionWithoutDogCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["DogReproductionType"],
	breastfeedingPuppyCount?: number,
	pregnancy?: GraphQLTypes["PregnantPeriodType"],
	breastfeedingCategory?: GraphQLTypes["DogReproductionCreateBreastfeedingCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogReproductionCreateBreastfeedingCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["BreastfeedingCategoryUniqueWhere"],
	create?: GraphQLTypes["BreastfeedingCategoryWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogReproductionConnectOrCreateBreastfeedingCategoryRelationInput"]
};
	["BreastfeedingCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: GraphQLTypes["DogReproductionUniqueWhere"]
};
	["BreastfeedingCategoryWithoutDogsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	week?: number,
	coeficient?: number,
	_dummy_field_?: boolean
};
	["DogReproductionConnectOrCreateBreastfeedingCategoryRelationInput"]: {
		connect: GraphQLTypes["BreastfeedingCategoryUniqueWhere"],
	create: GraphQLTypes["BreastfeedingCategoryWithoutDogsCreateInput"]
};
	["DogConnectOrCreateReproductionRelationInput"]: {
		connect: GraphQLTypes["DogReproductionUniqueWhere"],
	create: GraphQLTypes["DogReproductionWithoutDogCreateInput"]
};
	["DogCreateAllergiesEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateAllergiesRelationInput"],
	alias?: string
};
	["ItemSubCategoryWithoutDogsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryCreateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryCreateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"],
	iconNegative?: GraphQLTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryCreateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryCreateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryCreateIconNegativeEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateIconNegativeRelationInput"]
};
	["ItemSubCategoryConnectOrCreateIconNegativeRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ItemSubCategoryCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateIconRelationInput"]
};
	["ItemSubCategoryConnectOrCreateIconRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ItemSubCategoryCreateBrandsEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandFlavorUniqueWhere"],
	alias?: string
};
	["ItemSubCategoryCreateProductLinesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductLineFlavorUniqueWhere"],
	alias?: string
};
	["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"]: {
		connect?: GraphQLTypes["FilterComboUniqueWhere"],
	create?: GraphQLTypes["FilterComboWithoutFlavorCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateFilterCombosFlavorRelationInput"],
	alias?: string
};
	["FilterComboWithoutFlavorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboCreateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboCreateBreedEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboCreateBrandEntityRelationInput"],
	region?: GraphQLTypes["FilterComboCreateRegionEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboCreateAgeCategoryEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboCreateTreatmentEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboCreateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilterComboCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateSeoRelationInput"]
};
	["FilterComboConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["FilterComboCreateBreedEntityRelationInput"]: {
		connect?: GraphQLTypes["BreedUniqueWhere"],
	create?: GraphQLTypes["BreedWithoutFilterCombosCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateBreedRelationInput"]
};
	["BreedWithoutFilterCombosCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["BreedCreateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedCreateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedCreateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedCreateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedCreateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedCreateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedCreateSizeEntityRelationInput"],
	slug?: string,
	_dummy_field_?: boolean
};
	["BreedCreateProductReviewsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductReviewUniqueWhere"],
	create?: GraphQLTypes["ProductReviewWithoutBreedCreateInput"],
	connectOrCreate?: GraphQLTypes["BreedConnectOrCreateProductReviewsRelationInput"],
	alias?: string
};
	["ProductReviewWithoutBreedCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions?: Array<GraphQLTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"]>,
	score?: GraphQLTypes["ProductReviewCreateScoreEntityRelationInput"],
	product?: GraphQLTypes["ProductReviewCreateProductEntityRelationInput"],
	user?: GraphQLTypes["ProductReviewCreateUserEntityRelationInput"],
	fullName?: string,
	age?: GraphQLTypes["ProductReviewCreateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ProductReviewCreateAgeEntityRelationInput"]: {
		connect?: GraphQLTypes["AgeUniqueWhere"],
	create?: GraphQLTypes["AgeWithoutProductReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewConnectOrCreateAgeRelationInput"]
};
	["AgeWithoutProductReviewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["AgeCreateDogsEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["AgeCreateBreedsEntityRelationInput"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	suitabilityCategories?: Array<GraphQLTypes["AgeCreateSuitabilityCategoriesEntityRelationInput"]>,
	remoteId?: string,
	blogPostReviews?: Array<GraphQLTypes["AgeCreateBlogPostReviewsEntityRelationInput"]>,
	label?: string,
	categoryOrder?: string,
	_dummy_field_?: boolean
};
	["AgeCreateSuitabilityCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create?: GraphQLTypes["SuitabilityCategoryWithoutDogAgesCreateInput"],
	connectOrCreate?: GraphQLTypes["AgeConnectOrCreateSuitabilityCategoriesRelationInput"],
	alias?: string
};
	["SuitabilityCategoryWithoutDogAgesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	dogSizes?: Array<GraphQLTypes["SuitabilityCategoryCreateDogSizesEntityRelationInput"]>,
	dogActivities?: Array<GraphQLTypes["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["SuitabilityCategoryCreateBreedsEntityRelationInput"]>,
	suitabilityItems?: Array<GraphQLTypes["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"]>,
	isPregnant?: boolean,
	remoteId?: string,
	isBreastfeeding?: boolean,
	_dummy_field_?: boolean
};
	["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"]: {
		connect?: GraphQLTypes["DogActivityUniqueWhere"],
	create?: GraphQLTypes["DogActivityWithoutSuitabilityCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["SuitabilityCategoryConnectOrCreateDogActivitiesRelationInput"],
	alias?: string
};
	["DogActivityWithoutSuitabilityCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: string,
	dogs?: Array<GraphQLTypes["DogActivityCreateDogsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["DogActivityCreateProductsEntityRelationInput"]>,
	dailyEnergyRequirementCoeficient?: number,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["SuitabilityCategoryConnectOrCreateDogActivitiesRelationInput"]: {
		connect: GraphQLTypes["DogActivityUniqueWhere"],
	create: GraphQLTypes["DogActivityWithoutSuitabilityCategoryCreateInput"]
};
	["SuitabilityCategoryCreateBreedsEntityRelationInput"]: {
		connect?: GraphQLTypes["BreedUniqueWhere"],
	create?: GraphQLTypes["BreedWithoutSuitabilityCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["SuitabilityCategoryConnectOrCreateBreedsRelationInput"],
	alias?: string
};
	["BreedWithoutSuitabilityCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["BreedCreateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedCreateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedCreateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	productReviews?: Array<GraphQLTypes["BreedCreateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedCreateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedCreateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedCreateBlogPostReviewsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	create?: GraphQLTypes["BlogPostReviewWithoutBreedCreateInput"],
	connectOrCreate?: GraphQLTypes["BreedConnectOrCreateBlogPostReviewsRelationInput"],
	alias?: string
};
	["BlogPostReviewWithoutBreedCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostReviewReactions?: Array<GraphQLTypes["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"]>,
	blogPost?: GraphQLTypes["BlogPostReviewCreateBlogPostEntityRelationInput"],
	user?: GraphQLTypes["BlogPostReviewCreateUserEntityRelationInput"],
	fullName?: string,
	age?: GraphQLTypes["BlogPostReviewCreateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["BlogPostReviewCreateAgeEntityRelationInput"]: {
		connect?: GraphQLTypes["AgeUniqueWhere"],
	create?: GraphQLTypes["AgeWithoutBlogPostReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewConnectOrCreateAgeRelationInput"]
};
	["AgeWithoutBlogPostReviewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["AgeCreateDogsEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["AgeCreateBreedsEntityRelationInput"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	suitabilityCategories?: Array<GraphQLTypes["AgeCreateSuitabilityCategoriesEntityRelationInput"]>,
	remoteId?: string,
	productReviews?: Array<GraphQLTypes["AgeCreateProductReviewsEntityRelationInput"]>,
	label?: string,
	categoryOrder?: string,
	_dummy_field_?: boolean
};
	["AgeCreateProductReviewsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductReviewUniqueWhere"],
	create?: GraphQLTypes["ProductReviewWithoutAgeCreateInput"],
	connectOrCreate?: GraphQLTypes["AgeConnectOrCreateProductReviewsRelationInput"],
	alias?: string
};
	["ProductReviewWithoutAgeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions?: Array<GraphQLTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"]>,
	score?: GraphQLTypes["ProductReviewCreateScoreEntityRelationInput"],
	product?: GraphQLTypes["ProductReviewCreateProductEntityRelationInput"],
	user?: GraphQLTypes["ProductReviewCreateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["ProductReviewCreateBreedEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ProductReviewCreateBreedEntityRelationInput"]: {
		connect?: GraphQLTypes["BreedUniqueWhere"],
	create?: GraphQLTypes["BreedWithoutProductReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewConnectOrCreateBreedRelationInput"]
};
	["BreedWithoutProductReviewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["BreedCreateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedCreateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedCreateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedCreateSuitabilityCategoryEntityRelationInput"],
	blogPostReviews?: Array<GraphQLTypes["BreedCreateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedCreateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedCreateSizeEntityRelationInput"]: {
		connect?: GraphQLTypes["DogSizeUniqueWhere"],
	create?: GraphQLTypes["DogSizeWithoutBreedsCreateInput"],
	connectOrCreate?: GraphQLTypes["BreedConnectOrCreateSizeRelationInput"]
};
	["DogSizeWithoutBreedsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	products?: Array<GraphQLTypes["DogSizeCreateProductsEntityRelationInput"]>,
	suitabilityCategory?: GraphQLTypes["DogSizeCreateSuitabilityCategoryEntityRelationInput"],
	name?: GraphQLTypes["SizeType"],
	label?: string,
	order?: number,
	isFilterVisible?: boolean,
	_dummy_field_?: boolean
};
	["DogSizeCreateSuitabilityCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create?: GraphQLTypes["SuitabilityCategoryWithoutDogSizesCreateInput"],
	connectOrCreate?: GraphQLTypes["DogSizeConnectOrCreateSuitabilityCategoryRelationInput"]
};
	["SuitabilityCategoryWithoutDogSizesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	dogActivities?: Array<GraphQLTypes["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["SuitabilityCategoryCreateBreedsEntityRelationInput"]>,
	suitabilityItems?: Array<GraphQLTypes["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"]>,
	dogAges?: Array<GraphQLTypes["SuitabilityCategoryCreateDogAgesEntityRelationInput"]>,
	isPregnant?: boolean,
	remoteId?: string,
	isBreastfeeding?: boolean,
	_dummy_field_?: boolean
};
	["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	create?: GraphQLTypes["SuitabilityItemWithoutCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["SuitabilityCategoryConnectOrCreateSuitabilityItemsRelationInput"],
	alias?: string
};
	["SuitabilityItemWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	min?: number,
	max?: number,
	remoteId?: string,
	order?: number,
	element?: GraphQLTypes["SuitabilityItemCreateElementEntityRelationInput"],
	nutritionalValue?: GraphQLTypes["SuitabilityItemCreateNutritionalValueEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SuitabilityCategoryConnectOrCreateSuitabilityItemsRelationInput"]: {
		connect: GraphQLTypes["SuitabilityItemUniqueWhere"],
	create: GraphQLTypes["SuitabilityItemWithoutCategoryCreateInput"]
};
	["SuitabilityCategoryCreateDogAgesEntityRelationInput"]: {
		connect?: GraphQLTypes["AgeUniqueWhere"],
	create?: GraphQLTypes["AgeWithoutSuitabilityCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["SuitabilityCategoryConnectOrCreateDogAgesRelationInput"],
	alias?: string
};
	["AgeWithoutSuitabilityCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["AgeCreateDogsEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["AgeCreateBreedsEntityRelationInput"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	remoteId?: string,
	productReviews?: Array<GraphQLTypes["AgeCreateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["AgeCreateBlogPostReviewsEntityRelationInput"]>,
	label?: string,
	categoryOrder?: string,
	_dummy_field_?: boolean
};
	["AgeCreateBlogPostReviewsEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	create?: GraphQLTypes["BlogPostReviewWithoutAgeCreateInput"],
	connectOrCreate?: GraphQLTypes["AgeConnectOrCreateBlogPostReviewsRelationInput"],
	alias?: string
};
	["BlogPostReviewWithoutAgeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostReviewReactions?: Array<GraphQLTypes["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"]>,
	blogPost?: GraphQLTypes["BlogPostReviewCreateBlogPostEntityRelationInput"],
	user?: GraphQLTypes["BlogPostReviewCreateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["BlogPostReviewCreateBreedEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["BlogPostReviewCreateBreedEntityRelationInput"]: {
		connect?: GraphQLTypes["BreedUniqueWhere"],
	create?: GraphQLTypes["BreedWithoutBlogPostReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewConnectOrCreateBreedRelationInput"]
};
	["BreedWithoutBlogPostReviewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["BreedCreateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedCreateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedCreateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedCreateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedCreateProductReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedCreateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedCreateFilterCombosEntityRelationInput"]: {
		connect?: GraphQLTypes["FilterComboUniqueWhere"],
	create?: GraphQLTypes["FilterComboWithoutBreedCreateInput"],
	connectOrCreate?: GraphQLTypes["BreedConnectOrCreateFilterCombosRelationInput"],
	alias?: string
};
	["FilterComboWithoutBreedCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboCreateSeoEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboCreateBrandEntityRelationInput"],
	region?: GraphQLTypes["FilterComboCreateRegionEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboCreateAgeCategoryEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboCreateTreatmentEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboCreateFlavorEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboCreateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilterComboCreateBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutFilterCombosCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateBrandRelationInput"]
};
	["BrandWithoutFilterCombosCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["BrandCreateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandCreateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandCreateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandCreateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandCreateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandCreateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandCreateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandCreateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	topx?: Array<GraphQLTypes["BrandCreateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandCreateCountriesOfProductionEntityRelationInput"]: {
		connect?: GraphQLTypes["CountryUniqueWhere"],
	create?: GraphQLTypes["CountryWithoutBrandsCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateCountriesOfProductionRelationInput"],
	alias?: string
};
	["CountryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	manufacturers?: GraphQLTypes["BrandManufacturerUniqueWhere"]
};
	["CountryWithoutBrandsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	manufacturers?: Array<GraphQLTypes["CountryCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	region?: GraphQLTypes["CountryCreateRegionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["CountryCreateManufacturersEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandManufacturerUniqueWhere"],
	create?: GraphQLTypes["BrandManufacturerWithoutResidenceCreateInput"],
	connectOrCreate?: GraphQLTypes["CountryConnectOrCreateManufacturersRelationInput"],
	alias?: string
};
	["BrandManufacturerWithoutResidenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	link?: string,
	brands?: Array<GraphQLTypes["BrandManufacturerCreateBrandsEntityRelationInput"]>,
	order?: number,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["BrandManufacturerCreateBrandsEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutManufacturersCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandManufacturerConnectOrCreateBrandsRelationInput"],
	alias?: string
};
	["BrandWithoutManufacturersCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["BrandCreateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandCreateCountriesOfProductionEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandCreateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandCreateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandCreateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandCreateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandCreateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandCreateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandCreateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandCreateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandCreateProductLinesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductLineUniqueWhere"],
	create?: GraphQLTypes["ProductLineWithoutBrandCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateProductLinesRelationInput"],
	alias?: string
};
	["ProductLineWithoutBrandCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["ProductLineCreateProductsEntityRelationInput"]>,
	remoteId?: string,
	lead?: string,
	order?: number,
	logo?: GraphQLTypes["ProductLineCreateLogoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ProductLineCreateAliasesEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["ProductLineCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["ProductLineCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	_dummy_field_?: boolean
};
	["ProductLineCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutProductLineCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductLineConnectOrCreateProductsRelationInput"],
	alias?: string
};
	["ProductWithoutProductLineCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreateBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateBrandRelationInput"]
};
	["BrandWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandCreateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandCreateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandCreateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandCreateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandCreateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandCreateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandCreateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandCreateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandCreateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandCreateManufacturersEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandManufacturerUniqueWhere"],
	create?: GraphQLTypes["BrandManufacturerWithoutBrandsCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateManufacturersRelationInput"],
	alias?: string
};
	["BrandManufacturerWithoutBrandsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	link?: string,
	order?: number,
	remoteId?: string,
	residence?: GraphQLTypes["BrandManufacturerCreateResidenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandManufacturerCreateResidenceEntityRelationInput"]: {
		connect?: GraphQLTypes["CountryUniqueWhere"],
	create?: GraphQLTypes["CountryWithoutManufacturersCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandManufacturerConnectOrCreateResidenceRelationInput"]
};
	["CountryWithoutManufacturersCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	brands?: Array<GraphQLTypes["CountryCreateBrandsEntityRelationInput"]>,
	remoteId?: string,
	region?: GraphQLTypes["CountryCreateRegionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["CountryCreateBrandsEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutCountriesOfProductionCreateInput"],
	connectOrCreate?: GraphQLTypes["CountryConnectOrCreateBrandsRelationInput"],
	alias?: string
};
	["BrandWithoutCountriesOfProductionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["BrandCreateProductsEntityRelationInput"]>,
	link?: string,
	manufacturers?: Array<GraphQLTypes["BrandCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandCreateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandCreateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandCreateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandCreateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandCreateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandCreateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandCreateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandCreateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateLogoRelationInput"]
};
	["BrandConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["BrandCreateMethodOfProductionEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductionMethodUniqueWhere"],
	create?: GraphQLTypes["ProductionMethodWithoutBrandsCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateMethodOfProductionRelationInput"]
};
	["ProductionMethodUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	brands?: GraphQLTypes["BrandUniqueWhere"]
};
	["ProductionMethodWithoutBrandsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["BrandConnectOrCreateMethodOfProductionRelationInput"]: {
		connect: GraphQLTypes["ProductionMethodUniqueWhere"],
	create: GraphQLTypes["ProductionMethodWithoutBrandsCreateInput"]
};
	["BrandCreateDistributorEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandDistributorUniqueWhere"],
	create?: GraphQLTypes["BrandDistributorWithoutBrandsCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateDistributorRelationInput"]
};
	["BrandDistributorUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	brands?: GraphQLTypes["BrandUniqueWhere"]
};
	["BrandDistributorWithoutBrandsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	link?: string,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["BrandConnectOrCreateDistributorRelationInput"]: {
		connect: GraphQLTypes["BrandDistributorUniqueWhere"],
	create: GraphQLTypes["BrandDistributorWithoutBrandsCreateInput"]
};
	["BrandCreateAliasesEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandAliasUniqueWhere"],
	create?: GraphQLTypes["BrandAliasWithoutBrandCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateAliasesRelationInput"],
	alias?: string
};
	["BrandAliasWithoutBrandCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	name?: string,
	_dummy_field_?: boolean
};
	["BrandConnectOrCreateAliasesRelationInput"]: {
		connect: GraphQLTypes["BrandAliasUniqueWhere"],
	create: GraphQLTypes["BrandAliasWithoutBrandCreateInput"]
};
	["BrandCreateAdsEntityRelationInput"]: {
		connect?: GraphQLTypes["AdUniqueWhere"],
	create?: GraphQLTypes["AdWithoutBrandsCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateAdsRelationInput"],
	alias?: string
};
	["AdWithoutBrandsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["AdCreateImageEntityRelationInput"],
	isBrandSectionVisible?: boolean,
	isBlogPostSectionVisible?: boolean,
	isIngredientSectionVisible?: boolean,
	isResultsVisible?: boolean,
	isSearchVisible?: boolean,
	blogPosts?: Array<GraphQLTypes["AdCreateBlogPostsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["AdCreateItemCategoriesEntityRelationInput"]>,
	isActive?: boolean,
	link?: string,
	note?: string,
	activeFrom?: GraphQLTypes["DateTime"],
	activeUntil?: GraphQLTypes["DateTime"],
	slug?: string,
	contentReferences?: Array<GraphQLTypes["AdCreateContentReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AdCreateContentReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutAdCreateInput"],
	connectOrCreate?: GraphQLTypes["AdConnectOrCreateContentReferencesRelationInput"],
	alias?: string
};
	["ContentReferenceWithoutAdCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fact?: string,
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	relatedBlogPost?: GraphQLTypes["ContentReferenceCreateRelatedBlogPostEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceCreateRelatedBrandEntityRelationInput"],
	relatedProduct?: GraphQLTypes["ContentReferenceCreateRelatedProductEntityRelationInput"],
	relatedIngredient?: GraphQLTypes["ContentReferenceCreateRelatedIngredientEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	badge?: string,
	longVersion?: boolean,
	relatedBrandFull?: GraphQLTypes["ContentReferenceCreateRelatedBrandFullEntityRelationInput"],
	relatedProductFull?: GraphQLTypes["ContentReferenceCreateRelatedProductFullEntityRelationInput"],
	list?: Array<GraphQLTypes["ContentReferenceCreateListEntityRelationInput"]>,
	outline?: GraphQLTypes["ContentReferenceCreateOutlineEntityRelationInput"],
	video?: GraphQLTypes["ContentReferenceCreateVideoEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	defaultOpen?: boolean,
	badgeColor?: string,
	isMain?: boolean,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateBlockRelationInput"]
};
	["ContentBlockWithoutReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"],
	automatedContentBlockSlug?: string,
	_dummy_field_?: boolean
};
	["ContentBlockCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentBlockConnectOrCreateContentRelationInput"]
};
	["ContentWithoutBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ContentBlockConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceConnectOrCreateBlockRelationInput"]: {
		connect: GraphQLTypes["ContentBlockUniqueWhere"],
	create: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceCreateRelatedBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateRelatedBrandRelationInput"]
};
	["BrandCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["BrandCreateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandCreateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandCreateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandCreateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandCreateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandCreateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandCreateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandCreateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandCreateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandCreateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandCreateFlavorsEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandFlavorUniqueWhere"],
	alias?: string
};
	["BrandCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateSeoRelationInput"]
};
	["BrandConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["BrandCreateFilterCombosEntityRelationInput"]: {
		connect?: GraphQLTypes["FilterComboUniqueWhere"],
	create?: GraphQLTypes["FilterComboWithoutBrandCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateFilterCombosRelationInput"],
	alias?: string
};
	["FilterComboWithoutBrandCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboCreateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboCreateBreedEntityRelationInput"],
	region?: GraphQLTypes["FilterComboCreateRegionEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboCreateAgeCategoryEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboCreateTreatmentEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboCreateFlavorEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboCreateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilterComboCreateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"],
	create?: GraphQLTypes["RegionWithoutFilterCombosCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateRegionRelationInput"]
};
	["RegionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	countries?: GraphQLTypes["CountryUniqueWhere"],
	filterCombos?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["RegionWithoutFilterCombosCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	countries?: Array<GraphQLTypes["RegionCreateCountriesEntityRelationInput"]>,
	remoteId?: string,
	adjective?: string,
	slug?: string,
	_dummy_field_?: boolean
};
	["RegionCreateCountriesEntityRelationInput"]: {
		connect?: GraphQLTypes["CountryUniqueWhere"],
	create?: GraphQLTypes["CountryWithoutRegionCreateInput"],
	connectOrCreate?: GraphQLTypes["RegionConnectOrCreateCountriesRelationInput"],
	alias?: string
};
	["CountryWithoutRegionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	brands?: Array<GraphQLTypes["CountryCreateBrandsEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["CountryCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["RegionConnectOrCreateCountriesRelationInput"]: {
		connect: GraphQLTypes["CountryUniqueWhere"],
	create: GraphQLTypes["CountryWithoutRegionCreateInput"]
};
	["FilterComboConnectOrCreateRegionRelationInput"]: {
		connect: GraphQLTypes["RegionUniqueWhere"],
	create: GraphQLTypes["RegionWithoutFilterCombosCreateInput"]
};
	["FilterComboCreateAgeCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["AgeCategoryUniqueWhere"],
	create?: GraphQLTypes["AgeCategoryWithoutFilterCombosCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateAgeCategoryRelationInput"]
};
	["AgeCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	slug?: string,
	filterCombos?: GraphQLTypes["FilterComboUniqueWhere"]
};
	["AgeCategoryWithoutFilterCombosCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	order?: number,
	labelFor?: string,
	products?: Array<GraphQLTypes["AgeCategoryCreateProductsEntityRelationInput"]>,
	slug?: string,
	_dummy_field_?: boolean
};
	["AgeCategoryCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutAgeCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["AgeCategoryConnectOrCreateProductsRelationInput"],
	alias?: string
};
	["ProductWithoutAgeCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreateAliasesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductAliasUniqueWhere"],
	create?: GraphQLTypes["ProductAliasWithoutProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateAliasesRelationInput"],
	alias?: string
};
	["ProductAliasWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	name?: string,
	_dummy_field_?: boolean
};
	["ProductConnectOrCreateAliasesRelationInput"]: {
		connect: GraphQLTypes["ProductAliasUniqueWhere"],
	create: GraphQLTypes["ProductAliasWithoutProductCreateInput"]
};
	["ProductCreateEvaluationEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductEvaluationUniqueWhere"],
	create?: GraphQLTypes["ProductEvaluationWithoutProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateEvaluationRelationInput"]
};
	["ProductEvaluationWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nazev?: string,
	vetDieta?: string,
	vetDieta1?: string,
	vetDieta2?: string,
	aktivita?: string,
	vek?: string,
	velikostPlemen?: string,
	hmotnostPlemene?: string,
	velikostGranuli?: string,
	velikostGranuliText?: string,
	doporucenaAktivitaDleMe?: string,
	vypocitanaMeVsMeVyrobce?: string,
	vypocitanaMeVsMeVyrobce2?: string,
	masoNaPrvnimMisteText?: string,
	zdrojeZivocisnychBilkovinDle1Vyskytu?: string,
	prichuteSeznam?: string,
	eliminacniDietaTextInterpunkce?: string,
	alergenyZadneNeobsahuje?: string,
	alergenyObsahuje?: string,
	alergenyNejakeNeobsahuje?: string,
	prospesneDruhyInterpunkce?: string,
	nevhodneDruhy?: string,
	kladneUcinkyCeleTelo?: string,
	kladneUcinkyHlava?: string,
	kladneUcinkyHrudnik?: string,
	kladneUcinkyBricho?: string,
	kladneUcinkySpodniCast?: string,
	zaporneUcinkyCeleTelo?: string,
	zaporneUcinkyHlava?: string,
	zaporneUcinkyHrudnik?: string,
	zaporneUcinkyBricho?: string,
	zaporneUcinkySpodniCast?: string,
	dsneuvedeno?: string,
	dsmalo?: string,
	dsprilis?: string,
	dsok?: string,
	d95malo?: string,
	d95prilis?: string,
	d95ok?: string,
	d110malo?: string,
	d110prilis?: string,
	d110ok?: string,
	sdo14reproMalo?: string,
	sdo14reproPrilis?: string,
	sdo14reproOk?: string,
	sdo15malo?: string,
	sdo15prilis?: string,
	sdo15ok?: string,
	s15malo?: string,
	s15prilis?: string,
	s15ok?: string,
	masoAnoNe?: string,
	eliminacniDietaAnoNe?: string,
	alergenyAnoNe?: string,
	plodnostKastraceNadpis?: string,
	plodnostKastraceText?: string,
	remoteId?: string,
	stravitelnostNadpis?: string,
	stravitelnostProcenta?: string,
	stravitelnostSlovne?: string,
	stravitelnostChybiText?: string,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?: string,
	_dummy_field_?: boolean
};
	["ProductConnectOrCreateEvaluationRelationInput"]: {
		connect: GraphQLTypes["ProductEvaluationUniqueWhere"],
	create: GraphQLTypes["ProductEvaluationWithoutProductCreateInput"]
};
	["ProductCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateSeoRelationInput"]
};
	["ProductConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"],
	alias?: string
};
	["ProductCreateHeurekaImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateHeurekaImageRelationInput"]
};
	["ProductConnectOrCreateHeurekaImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ProductCreateTopxEntityRelationInput"]: {
		connect?: GraphQLTypes["TOPXProductUniqueWhere"],
	create?: GraphQLTypes["TOPXProductWithoutProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateTopxRelationInput"],
	alias?: string
};
	["TOPXProductWithoutProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	order?: number,
	orderType?: GraphQLTypes["TOPXProductOrderType"],
	category?: GraphQLTypes["TOPXProductCreateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXProductCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["TOPXProductCategoryUniqueWhere"],
	create?: GraphQLTypes["TOPXProductCategoryWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["TOPXProductConnectOrCreateCategoryRelationInput"]
};
	["TOPXProductCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	products?: GraphQLTypes["TOPXProductUniqueWhere"]
};
	["TOPXProductCategoryWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	_dummy_field_?: boolean
};
	["TOPXProductConnectOrCreateCategoryRelationInput"]: {
		connect: GraphQLTypes["TOPXProductCategoryUniqueWhere"],
	create: GraphQLTypes["TOPXProductCategoryWithoutProductsCreateInput"]
};
	["ProductConnectOrCreateTopxRelationInput"]: {
		connect: GraphQLTypes["TOPXProductUniqueWhere"],
	create: GraphQLTypes["TOPXProductWithoutProductCreateInput"]
};
	["AgeCategoryConnectOrCreateProductsRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutAgeCategoriesCreateInput"]
};
	["FilterComboConnectOrCreateAgeCategoryRelationInput"]: {
		connect: GraphQLTypes["AgeCategoryUniqueWhere"],
	create: GraphQLTypes["AgeCategoryWithoutFilterCombosCreateInput"]
};
	["FilterComboCreateTreatmentEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagUniqueWhere"],
	create?: GraphQLTypes["BodyTagWithoutFilterCombosCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateTreatmentRelationInput"]
};
	["BodyTagWithoutFilterCombosCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagCreateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagCreatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagCreateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagCreatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagCreateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagCreateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagCreateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagCreateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	_dummy_field_?: boolean
};
	["BodyTagCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagConnectOrCreateIconRelationInput"]
};
	["BodyTagConnectOrCreateIconRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["BodyTagCreateDogsEntityRelationInput"]: {
		connect?: GraphQLTypes["DogUniqueWhere"],
	create?: GraphQLTypes["DogWithoutIllnessesCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagConnectOrCreateDogsRelationInput"],
	alias?: string
};
	["DogWithoutIllnessesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogCreateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogCreateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogCreateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogCreateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogCreateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogCreateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogCreateAllergiesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogCreateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogCreateAvatarEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateAvatarRelationInput"]
};
	["DogConnectOrCreateAvatarRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["BodyTagConnectOrCreateDogsRelationInput"]: {
		connect: GraphQLTypes["DogUniqueWhere"],
	create: GraphQLTypes["DogWithoutIllnessesCreateInput"]
};
	["FilterComboConnectOrCreateTreatmentRelationInput"]: {
		connect: GraphQLTypes["BodyTagUniqueWhere"],
	create: GraphQLTypes["BodyTagWithoutFilterCombosCreateInput"]
};
	["FilterComboCreateFlavorEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryWithoutFilterCombosFlavorCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateFlavorRelationInput"]
};
	["ItemSubCategoryWithoutFilterCombosFlavorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryCreateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryCreateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryCreateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryCreateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryCreateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"]: {
		connect?: GraphQLTypes["FilterComboUniqueWhere"],
	create?: GraphQLTypes["FilterComboWithoutAllergyCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateFilterCombosAllergyRelationInput"],
	alias?: string
};
	["FilterComboWithoutAllergyCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboCreateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboCreateBreedEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboCreateBrandEntityRelationInput"],
	region?: GraphQLTypes["FilterComboCreateRegionEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboCreateAgeCategoryEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboCreateTreatmentEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboCreateFlavorEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemSubCategoryConnectOrCreateFilterCombosAllergyRelationInput"]: {
		connect: GraphQLTypes["FilterComboUniqueWhere"],
	create: GraphQLTypes["FilterComboWithoutAllergyCreateInput"]
};
	["FilterComboConnectOrCreateFlavorRelationInput"]: {
		connect: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create: GraphQLTypes["ItemSubCategoryWithoutFilterCombosFlavorCreateInput"]
};
	["FilterComboCreateAllergyEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryWithoutFilterCombosAllergyCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateAllergyRelationInput"]
};
	["ItemSubCategoryWithoutFilterCombosAllergyCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryCreateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryCreateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryCreateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryCreateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryCreateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryCreateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["FilterComboConnectOrCreateAllergyRelationInput"]: {
		connect: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create: GraphQLTypes["ItemSubCategoryWithoutFilterCombosAllergyCreateInput"]
};
	["BrandConnectOrCreateFilterCombosRelationInput"]: {
		connect: GraphQLTypes["FilterComboUniqueWhere"],
	create: GraphQLTypes["FilterComboWithoutBrandCreateInput"]
};
	["BrandCreateTopxEntityRelationInput"]: {
		connect?: GraphQLTypes["TOPXBrandUniqueWhere"],
	create?: GraphQLTypes["TOPXBrandWithoutBrandCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateTopxRelationInput"],
	alias?: string
};
	["TOPXBrandWithoutBrandCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	order?: number,
	orderType?: GraphQLTypes["TOPXBrandOrderType"],
	category?: GraphQLTypes["TOPXBrandCreateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXBrandCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["TOPXBrandCategoryUniqueWhere"],
	create?: GraphQLTypes["TOPXBrandCategoryWithoutBrandsCreateInput"],
	connectOrCreate?: GraphQLTypes["TOPXBrandConnectOrCreateCategoryRelationInput"]
};
	["TOPXBrandCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	brands?: GraphQLTypes["TOPXBrandUniqueWhere"]
};
	["TOPXBrandCategoryWithoutBrandsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	_dummy_field_?: boolean
};
	["TOPXBrandConnectOrCreateCategoryRelationInput"]: {
		connect: GraphQLTypes["TOPXBrandCategoryUniqueWhere"],
	create: GraphQLTypes["TOPXBrandCategoryWithoutBrandsCreateInput"]
};
	["BrandConnectOrCreateTopxRelationInput"]: {
		connect: GraphQLTypes["TOPXBrandUniqueWhere"],
	create: GraphQLTypes["TOPXBrandWithoutBrandCreateInput"]
};
	["BrandCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateContentRelationInput"]
};
	["BrandConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["BrandCreateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateDraftRelationInput"]
};
	["BrandConnectOrCreateDraftRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ContentReferenceConnectOrCreateRelatedBrandRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandCreateInput"]
};
	["ContentReferenceCreateRelatedProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateRelatedProductRelationInput"]
};
	["ProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductCreateAgeCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["AgeCategoryUniqueWhere"],
	create?: GraphQLTypes["AgeCategoryWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateAgeCategoriesRelationInput"],
	alias?: string
};
	["AgeCategoryWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	order?: number,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["AgeCategoryCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AgeCategoryCreateFilterCombosEntityRelationInput"]: {
		connect?: GraphQLTypes["FilterComboUniqueWhere"],
	create?: GraphQLTypes["FilterComboWithoutAgeCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["AgeCategoryConnectOrCreateFilterCombosRelationInput"],
	alias?: string
};
	["FilterComboWithoutAgeCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboCreateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboCreateBreedEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboCreateBrandEntityRelationInput"],
	region?: GraphQLTypes["FilterComboCreateRegionEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboCreateTreatmentEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboCreateFlavorEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboCreateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AgeCategoryConnectOrCreateFilterCombosRelationInput"]: {
		connect: GraphQLTypes["FilterComboUniqueWhere"],
	create: GraphQLTypes["FilterComboWithoutAgeCategoryCreateInput"]
};
	["ProductConnectOrCreateAgeCategoriesRelationInput"]: {
		connect: GraphQLTypes["AgeCategoryUniqueWhere"],
	create: GraphQLTypes["AgeCategoryWithoutProductsCreateInput"]
};
	["ContentReferenceConnectOrCreateRelatedProductRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductCreateInput"]
};
	["ContentReferenceCreateRelatedIngredientEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateRelatedIngredientRelationInput"]
};
	["ItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemCreateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemCreateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemCreateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemCreateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemCreateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemCreateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemCreateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemCreateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemCreateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCreateDeclensionFourthEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"],
	create?: GraphQLTypes["ItemDeclensionFourthVariantWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateDeclensionFourthRelationInput"]
};
	["ItemDeclensionFourthVariantWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: string,
	remoteId?: string,
	declensionSeventh?: string,
	isNegativ?: boolean,
	seo?: GraphQLTypes["ItemDeclensionFourthVariantCreateSeoEntityRelationInput"],
	subcategory?: GraphQLTypes["ItemDeclensionFourthVariantCreateSubcategoryEntityRelationInput"],
	category?: GraphQLTypes["ItemDeclensionFourthVariantCreateCategoryEntityRelationInput"],
	element?: GraphQLTypes["ItemDeclensionFourthVariantCreateElementEntityRelationInput"],
	products?: Array<GraphQLTypes["ItemDeclensionFourthVariantCreateProductsEntityRelationInput"]>,
	slug?: string,
	content?: GraphQLTypes["ItemDeclensionFourthVariantCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemDeclensionFourthVariantCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemDeclensionFourthVariantCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutDeclensionsFourthCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateCategoryRelationInput"]
};
	["ItemCategoryWithoutDeclensionsFourthCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryCreateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryCreateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryCreateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryCreateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryCreateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryCreateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryCreateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateSeoRelationInput"]
};
	["ItemCategoryConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["ItemCategoryCreateGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemGroupUniqueWhere"],
	create?: GraphQLTypes["ItemGroupWithoutCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateGroupRelationInput"]
};
	["ItemGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	categories?: GraphQLTypes["ItemCategoryUniqueWhere"]
};
	["ItemGroupWithoutCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	name?: string,
	_dummy_field_?: boolean
};
	["ItemCategoryConnectOrCreateGroupRelationInput"]: {
		connect: GraphQLTypes["ItemGroupUniqueWhere"],
	create: GraphQLTypes["ItemGroupWithoutCategoriesCreateInput"]
};
	["ItemCategoryCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateContentRelationInput"]
};
	["ItemCategoryConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ItemCategoryCreateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateDraftRelationInput"]
};
	["ItemCategoryConnectOrCreateDraftRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ItemDeclensionFourthVariantConnectOrCreateCategoryRelationInput"]: {
		connect: GraphQLTypes["ItemCategoryUniqueWhere"],
	create: GraphQLTypes["ItemCategoryWithoutDeclensionsFourthCreateInput"]
};
	["ItemDeclensionFourthVariantCreateElementEntityRelationInput"]: {
		connect?: GraphQLTypes["ElementUniqueWhere"],
	create?: GraphQLTypes["ElementCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateElementRelationInput"]
};
	["ElementCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["ElementCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ElementCreateFeatureDependenciesEntityRelationInput"]>,
	suitabilityElements?: Array<GraphQLTypes["ElementCreateSuitabilityElementsEntityRelationInput"]>,
	remoteId?: string,
	unit?: string,
	filterOrder?: number,
	slug?: string,
	declensionSeventh?: string,
	_dummy_field_?: boolean
};
	["ItemDeclensionFourthVariantConnectOrCreateElementRelationInput"]: {
		connect: GraphQLTypes["ElementUniqueWhere"],
	create: GraphQLTypes["ElementCreateInput"]
};
	["ItemDeclensionFourthVariantCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"],
	alias?: string
};
	["ItemDeclensionFourthVariantCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateContentRelationInput"]
};
	["ItemDeclensionFourthVariantConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ItemDeclensionFourthVariantCreateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateDraftRelationInput"]
};
	["ItemDeclensionFourthVariantConnectOrCreateDraftRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ItemConnectOrCreateDeclensionFourthRelationInput"]: {
		connect: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"],
	create: GraphQLTypes["ItemDeclensionFourthVariantWithoutItemsCreateInput"]
};
	["ContentReferenceConnectOrCreateRelatedIngredientRelationInput"]: {
		connect: GraphQLTypes["ItemUniqueWhere"],
	create: GraphQLTypes["ItemCreateInput"]
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateLinkRelationInput"]
};
	["LinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	externalLink?: string,
	isTargetBlank?: boolean,
	_dummy_field_?: boolean
};
	["ContentReferenceConnectOrCreateLinkRelationInput"]: {
		connect: GraphQLTypes["LinkUniqueWhere"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceCreateRelatedBrandFullEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateRelatedBrandFullRelationInput"]
};
	["ContentReferenceConnectOrCreateRelatedBrandFullRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandCreateInput"]
};
	["ContentReferenceCreateRelatedProductFullEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateRelatedProductFullRelationInput"]
};
	["ContentReferenceConnectOrCreateRelatedProductFullRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductCreateInput"]
};
	["ContentReferenceCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceListUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceListWithoutListCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateListRelationInput"],
	alias?: string
};
	["ContentReferenceListWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	relatedProduct?: GraphQLTypes["ContentReferenceListCreateRelatedProductEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceListCreateRelatedBrandEntityRelationInput"],
	badge?: string,
	badgeColor?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceListCreateRelatedProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceListConnectOrCreateRelatedProductRelationInput"]
};
	["ContentReferenceListConnectOrCreateRelatedProductRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductCreateInput"]
};
	["ContentReferenceListCreateRelatedBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceListConnectOrCreateRelatedBrandRelationInput"]
};
	["ContentReferenceListConnectOrCreateRelatedBrandRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandCreateInput"]
};
	["ContentReferenceConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["ContentReferenceListUniqueWhere"],
	create: GraphQLTypes["ContentReferenceListWithoutListCreateInput"]
};
	["ContentReferenceCreateOutlineEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentLinksUniqueWhere"],
	create?: GraphQLTypes["ContentLinksCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateOutlineRelationInput"]
};
	["ContentLinksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ContentLinksCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentLinksCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentLinksItemUniqueWhere"],
	create?: GraphQLTypes["ContentLinksItemWithoutListCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentLinksConnectOrCreateItemsRelationInput"],
	alias?: string
};
	["ContentLinksItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	target?: string,
	_dummy_field_?: boolean
};
	["ContentLinksConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["ContentLinksItemUniqueWhere"],
	create: GraphQLTypes["ContentLinksItemWithoutListCreateInput"]
};
	["ContentReferenceConnectOrCreateOutlineRelationInput"]: {
		connect: GraphQLTypes["ContentLinksUniqueWhere"],
	create: GraphQLTypes["ContentLinksCreateInput"]
};
	["ContentReferenceCreateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"],
	create?: GraphQLTypes["VideoCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateVideoRelationInput"]
};
	["VideoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	src?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	duration?: number,
	poster?: GraphQLTypes["VideoCreatePosterEntityRelationInput"],
	_dummy_field_?: boolean
};
	["VideoCreatePosterEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["VideoConnectOrCreatePosterRelationInput"]
};
	["VideoConnectOrCreatePosterRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceConnectOrCreateVideoRelationInput"]: {
		connect: GraphQLTypes["VideoUniqueWhere"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceImageUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateImageRelationInput"]
};
	["ContentReferenceImageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	lead?: string,
	alignment?: GraphQLTypes["AlignmentType"],
	image?: GraphQLTypes["ContentReferenceImageCreateImageEntityRelationInput"],
	link?: string,
	targetBlank?: boolean,
	_dummy_field_?: boolean
};
	["ContentReferenceImageCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceImageConnectOrCreateImageRelationInput"]
};
	["ContentReferenceImageConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ContentReferenceImageUniqueWhere"],
	create: GraphQLTypes["ContentReferenceImageCreateInput"]
};
	["AdConnectOrCreateContentReferencesRelationInput"]: {
		connect: GraphQLTypes["ContentReferenceUniqueWhere"],
	create: GraphQLTypes["ContentReferenceWithoutAdCreateInput"]
};
	["BrandConnectOrCreateAdsRelationInput"]: {
		connect: GraphQLTypes["AdUniqueWhere"],
	create: GraphQLTypes["AdWithoutBrandsCreateInput"]
};
	["CountryConnectOrCreateBrandsRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandWithoutCountriesOfProductionCreateInput"]
};
	["CountryCreateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"],
	create?: GraphQLTypes["RegionWithoutCountriesCreateInput"],
	connectOrCreate?: GraphQLTypes["CountryConnectOrCreateRegionRelationInput"]
};
	["RegionWithoutCountriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	remoteId?: string,
	adjective?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["RegionCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RegionCreateFilterCombosEntityRelationInput"]: {
		connect?: GraphQLTypes["FilterComboUniqueWhere"],
	create?: GraphQLTypes["FilterComboWithoutRegionCreateInput"],
	connectOrCreate?: GraphQLTypes["RegionConnectOrCreateFilterCombosRelationInput"],
	alias?: string
};
	["FilterComboWithoutRegionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboCreateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboCreateBreedEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboCreateBrandEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboCreateAgeCategoryEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboCreateTreatmentEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboCreateFlavorEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboCreateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RegionConnectOrCreateFilterCombosRelationInput"]: {
		connect: GraphQLTypes["FilterComboUniqueWhere"],
	create: GraphQLTypes["FilterComboWithoutRegionCreateInput"]
};
	["CountryConnectOrCreateRegionRelationInput"]: {
		connect: GraphQLTypes["RegionUniqueWhere"],
	create: GraphQLTypes["RegionWithoutCountriesCreateInput"]
};
	["BrandManufacturerConnectOrCreateResidenceRelationInput"]: {
		connect: GraphQLTypes["CountryUniqueWhere"],
	create: GraphQLTypes["CountryWithoutManufacturersCreateInput"]
};
	["BrandConnectOrCreateManufacturersRelationInput"]: {
		connect: GraphQLTypes["BrandManufacturerUniqueWhere"],
	create: GraphQLTypes["BrandManufacturerWithoutBrandsCreateInput"]
};
	["ProductConnectOrCreateBrandRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandWithoutProductsCreateInput"]
};
	["ProductLineConnectOrCreateProductsRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutProductLineCreateInput"]
};
	["ProductLineCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductLineConnectOrCreateLogoRelationInput"]
};
	["ProductLineConnectOrCreateLogoRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ProductLineCreateAliasesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductLineAliasUniqueWhere"],
	create?: GraphQLTypes["ProductLineAliasWithoutProductLinesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductLineConnectOrCreateAliasesRelationInput"],
	alias?: string
};
	["ProductLineAliasUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["ProductLineAliasWithoutProductLinesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	name?: string,
	_dummy_field_?: boolean
};
	["ProductLineConnectOrCreateAliasesRelationInput"]: {
		connect: GraphQLTypes["ProductLineAliasUniqueWhere"],
	create: GraphQLTypes["ProductLineAliasWithoutProductLinesCreateInput"]
};
	["ProductLineCreateFlavorsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductLineFlavorUniqueWhere"],
	alias?: string
};
	["ProductLineCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductLineConnectOrCreateSeoRelationInput"]
};
	["ProductLineConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["BrandConnectOrCreateProductLinesRelationInput"]: {
		connect: GraphQLTypes["ProductLineUniqueWhere"],
	create: GraphQLTypes["ProductLineWithoutBrandCreateInput"]
};
	["BrandManufacturerConnectOrCreateBrandsRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandWithoutManufacturersCreateInput"]
};
	["CountryConnectOrCreateManufacturersRelationInput"]: {
		connect: GraphQLTypes["BrandManufacturerUniqueWhere"],
	create: GraphQLTypes["BrandManufacturerWithoutResidenceCreateInput"]
};
	["BrandConnectOrCreateCountriesOfProductionRelationInput"]: {
		connect: GraphQLTypes["CountryUniqueWhere"],
	create: GraphQLTypes["CountryWithoutBrandsCreateInput"]
};
	["FilterComboConnectOrCreateBrandRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandWithoutFilterCombosCreateInput"]
};
	["BreedConnectOrCreateFilterCombosRelationInput"]: {
		connect: GraphQLTypes["FilterComboUniqueWhere"],
	create: GraphQLTypes["FilterComboWithoutBreedCreateInput"]
};
	["BlogPostReviewConnectOrCreateBreedRelationInput"]: {
		connect: GraphQLTypes["BreedUniqueWhere"],
	create: GraphQLTypes["BreedWithoutBlogPostReviewsCreateInput"]
};
	["AgeConnectOrCreateBlogPostReviewsRelationInput"]: {
		connect: GraphQLTypes["BlogPostReviewUniqueWhere"],
	create: GraphQLTypes["BlogPostReviewWithoutAgeCreateInput"]
};
	["SuitabilityCategoryConnectOrCreateDogAgesRelationInput"]: {
		connect: GraphQLTypes["AgeUniqueWhere"],
	create: GraphQLTypes["AgeWithoutSuitabilityCategoriesCreateInput"]
};
	["DogSizeConnectOrCreateSuitabilityCategoryRelationInput"]: {
		connect: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create: GraphQLTypes["SuitabilityCategoryWithoutDogSizesCreateInput"]
};
	["BreedConnectOrCreateSizeRelationInput"]: {
		connect: GraphQLTypes["DogSizeUniqueWhere"],
	create: GraphQLTypes["DogSizeWithoutBreedsCreateInput"]
};
	["ProductReviewConnectOrCreateBreedRelationInput"]: {
		connect: GraphQLTypes["BreedUniqueWhere"],
	create: GraphQLTypes["BreedWithoutProductReviewsCreateInput"]
};
	["AgeConnectOrCreateProductReviewsRelationInput"]: {
		connect: GraphQLTypes["ProductReviewUniqueWhere"],
	create: GraphQLTypes["ProductReviewWithoutAgeCreateInput"]
};
	["BlogPostReviewConnectOrCreateAgeRelationInput"]: {
		connect: GraphQLTypes["AgeUniqueWhere"],
	create: GraphQLTypes["AgeWithoutBlogPostReviewsCreateInput"]
};
	["BreedConnectOrCreateBlogPostReviewsRelationInput"]: {
		connect: GraphQLTypes["BlogPostReviewUniqueWhere"],
	create: GraphQLTypes["BlogPostReviewWithoutBreedCreateInput"]
};
	["SuitabilityCategoryConnectOrCreateBreedsRelationInput"]: {
		connect: GraphQLTypes["BreedUniqueWhere"],
	create: GraphQLTypes["BreedWithoutSuitabilityCategoryCreateInput"]
};
	["AgeConnectOrCreateSuitabilityCategoriesRelationInput"]: {
		connect: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create: GraphQLTypes["SuitabilityCategoryWithoutDogAgesCreateInput"]
};
	["ProductReviewConnectOrCreateAgeRelationInput"]: {
		connect: GraphQLTypes["AgeUniqueWhere"],
	create: GraphQLTypes["AgeWithoutProductReviewsCreateInput"]
};
	["BreedConnectOrCreateProductReviewsRelationInput"]: {
		connect: GraphQLTypes["ProductReviewUniqueWhere"],
	create: GraphQLTypes["ProductReviewWithoutBreedCreateInput"]
};
	["FilterComboConnectOrCreateBreedRelationInput"]: {
		connect: GraphQLTypes["BreedUniqueWhere"],
	create: GraphQLTypes["BreedWithoutFilterCombosCreateInput"]
};
	["ItemSubCategoryConnectOrCreateFilterCombosFlavorRelationInput"]: {
		connect: GraphQLTypes["FilterComboUniqueWhere"],
	create: GraphQLTypes["FilterComboWithoutFlavorCreateInput"]
};
	["DogConnectOrCreateAllergiesRelationInput"]: {
		connect: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create: GraphQLTypes["ItemSubCategoryWithoutDogsCreateInput"]
};
	["DogCreateIllnessesEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagUniqueWhere"],
	create?: GraphQLTypes["BodyTagWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateIllnessesRelationInput"],
	alias?: string
};
	["BodyTagWithoutDogsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagCreateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagCreatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagCreateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagCreatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagCreateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagCreateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagCreateIconEntityRelationInput"],
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagCreateFilterCombosEntityRelationInput"]: {
		connect?: GraphQLTypes["FilterComboUniqueWhere"],
	create?: GraphQLTypes["FilterComboWithoutTreatmentCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagConnectOrCreateFilterCombosRelationInput"],
	alias?: string
};
	["FilterComboWithoutTreatmentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboCreateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboCreateBreedEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboCreateBrandEntityRelationInput"],
	region?: GraphQLTypes["FilterComboCreateRegionEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboCreateAgeCategoryEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboCreateFlavorEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboCreateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BodyTagConnectOrCreateFilterCombosRelationInput"]: {
		connect: GraphQLTypes["FilterComboUniqueWhere"],
	create: GraphQLTypes["FilterComboWithoutTreatmentCreateInput"]
};
	["DogConnectOrCreateIllnessesRelationInput"]: {
		connect: GraphQLTypes["BodyTagUniqueWhere"],
	create: GraphQLTypes["BodyTagWithoutDogsCreateInput"]
};
	["DogActivityConnectOrCreateDogsRelationInput"]: {
		connect: GraphQLTypes["DogUniqueWhere"],
	create: GraphQLTypes["DogWithoutActivityCreateInput"]
};
	["DogActivityCreateSuitabilityCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create?: GraphQLTypes["SuitabilityCategoryWithoutDogActivitiesCreateInput"],
	connectOrCreate?: GraphQLTypes["DogActivityConnectOrCreateSuitabilityCategoryRelationInput"]
};
	["SuitabilityCategoryWithoutDogActivitiesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	dogSizes?: Array<GraphQLTypes["SuitabilityCategoryCreateDogSizesEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["SuitabilityCategoryCreateBreedsEntityRelationInput"]>,
	suitabilityItems?: Array<GraphQLTypes["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"]>,
	dogAges?: Array<GraphQLTypes["SuitabilityCategoryCreateDogAgesEntityRelationInput"]>,
	isPregnant?: boolean,
	remoteId?: string,
	isBreastfeeding?: boolean,
	_dummy_field_?: boolean
};
	["DogActivityConnectOrCreateSuitabilityCategoryRelationInput"]: {
		connect: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create: GraphQLTypes["SuitabilityCategoryWithoutDogActivitiesCreateInput"]
};
	["ProductConnectOrCreateRecommendedActivityRelationInput"]: {
		connect: GraphQLTypes["DogActivityUniqueWhere"],
	create: GraphQLTypes["DogActivityWithoutProductsCreateInput"]
};
	["BrandConnectOrCreateProductsRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutBrandCreateInput"]
};
	["ProductLineConnectOrCreateBrandRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandWithoutProductLinesCreateInput"]
};
	["ProductConnectOrCreateProductLineRelationInput"]: {
		connect: GraphQLTypes["ProductLineUniqueWhere"],
	create: GraphQLTypes["ProductLineWithoutProductsCreateInput"]
};
	["DogSizeConnectOrCreateProductsRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutRecommendedDogSizesCreateInput"]
};
	["SuitabilityCategoryConnectOrCreateDogSizesRelationInput"]: {
		connect: GraphQLTypes["DogSizeUniqueWhere"],
	create: GraphQLTypes["DogSizeWithoutSuitabilityCategoryCreateInput"]
};
	["BreedConnectOrCreateSuitabilityCategoryRelationInput"]: {
		connect: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create: GraphQLTypes["SuitabilityCategoryWithoutBreedsCreateInput"]
};
	["DogSizeConnectOrCreateBreedsRelationInput"]: {
		connect: GraphQLTypes["BreedUniqueWhere"],
	create: GraphQLTypes["BreedWithoutSizeCreateInput"]
};
	["ProductConnectOrCreateRecommendedDogSizesRelationInput"]: {
		connect: GraphQLTypes["DogSizeUniqueWhere"],
	create: GraphQLTypes["DogSizeWithoutProductsCreateInput"]
};
	["DogConnectOrCreateFedProductRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutDogsCreateInput"]
};
	["ItemSubCategoryConnectOrCreateDogsRelationInput"]: {
		connect: GraphQLTypes["DogUniqueWhere"],
	create: GraphQLTypes["DogWithoutAllergiesCreateInput"]
};
	["ItemDeclensionFourthVariantConnectOrCreateSubcategoryRelationInput"]: {
		connect: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create: GraphQLTypes["ItemSubCategoryCreateInput"]
};
	["ItemCategoryConnectOrCreateDeclensionsFourthRelationInput"]: {
		connect: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"],
	create: GraphQLTypes["ItemDeclensionFourthVariantWithoutCategoryCreateInput"]
};
	["ItemSubCategoryConnectOrCreateCategoryRelationInput"]: {
		connect: GraphQLTypes["ItemCategoryUniqueWhere"],
	create: GraphQLTypes["ItemCategoryWithoutSubCategoriesCreateInput"]
};
	["ProductFeatureConnectOrCreateDependentSubCategoryRelationInput"]: {
		connect: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create: GraphQLTypes["ItemSubCategoryWithoutFeatureDependenciesCreateInput"]
};
	["ProductFeatureCreateDependentFlagEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductFlagUniqueWhere"],
	create?: GraphQLTypes["ProductFlagWithoutProductFeaturesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFeatureConnectOrCreateDependentFlagRelationInput"]
};
	["ProductFlagWithoutProductFeaturesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	products?: Array<GraphQLTypes["ProductFlagCreateProductsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductFlagCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	create?: GraphQLTypes["ProductFlagOfProductWithoutFlagCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFlagConnectOrCreateProductsRelationInput"],
	alias?: string
};
	["ProductFlagOfProductWithoutFlagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	value?: GraphQLTypes["ProductFlagValue"],
	product?: GraphQLTypes["ProductFlagOfProductCreateProductEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFlagOfProductCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutFlagsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFlagOfProductConnectOrCreateProductRelationInput"]
};
	["ProductWithoutFlagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductFlagOfProductConnectOrCreateProductRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutFlagsCreateInput"]
};
	["ProductFlagConnectOrCreateProductsRelationInput"]: {
		connect: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	create: GraphQLTypes["ProductFlagOfProductWithoutFlagCreateInput"]
};
	["ProductFeatureConnectOrCreateDependentFlagRelationInput"]: {
		connect: GraphQLTypes["ProductFlagUniqueWhere"],
	create: GraphQLTypes["ProductFlagWithoutProductFeaturesCreateInput"]
};
	["ItemCategoryConnectOrCreateFeatureDependenciesRelationInput"]: {
		connect: GraphQLTypes["ProductFeatureUniqueWhere"],
	create: GraphQLTypes["ProductFeatureWithoutDependentCategoryCreateInput"]
};
	["RedirectConnectOrCreateItemCategoryRelationInput"]: {
		connect: GraphQLTypes["ItemCategoryUniqueWhere"],
	create: GraphQLTypes["ItemCategoryWithoutRedirectsCreateInput"]
};
	["BrandsPageConnectOrCreateRedirectsRelationInput"]: {
		connect: GraphQLTypes["RedirectUniqueWhere"],
	create: GraphQLTypes["RedirectWithoutBrandsPageCreateInput"]
};
	["SeoConnectOrCreateBrandsPageRelationInput"]: {
		connect: GraphQLTypes["BrandsPageUniqueWhere"],
	create: GraphQLTypes["BrandsPageWithoutSeoCreateInput"]
};
	["BlogPostConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["BlogPostCreateRedirectsEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutBlogPostCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateRedirectsRelationInput"],
	alias?: string
};
	["RedirectWithoutBlogPostCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectCreateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectCreateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectCreateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectCreateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectCreateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectCreateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectCreateComparatorPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostConnectOrCreateRedirectsRelationInput"]: {
		connect: GraphQLTypes["RedirectUniqueWhere"],
	create: GraphQLTypes["RedirectWithoutBlogPostCreateInput"]
};
	["AdConnectOrCreateBlogPostsRelationInput"]: {
		connect: GraphQLTypes["BlogPostUniqueWhere"],
	create: GraphQLTypes["BlogPostWithoutAdsCreateInput"]
};
	["AdCreateBrandsEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutAdsCreateInput"],
	connectOrCreate?: GraphQLTypes["AdConnectOrCreateBrandsRelationInput"],
	alias?: string
};
	["BrandWithoutAdsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["BrandCreateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandCreateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandCreateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandCreateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandCreateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandCreateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandCreateAliasesEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandCreateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandCreateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AdConnectOrCreateBrandsRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandWithoutAdsCreateInput"]
};
	["ItemCategoryConnectOrCreateAdsRelationInput"]: {
		connect: GraphQLTypes["AdUniqueWhere"],
	create: GraphQLTypes["AdWithoutItemCategoriesCreateInput"]
};
	["ProductFeatureConnectOrCreateDependentCategoryRelationInput"]: {
		connect: GraphQLTypes["ItemCategoryUniqueWhere"],
	create: GraphQLTypes["ItemCategoryWithoutFeatureDependenciesCreateInput"]
};
	["ElementConnectOrCreateFeatureDependenciesRelationInput"]: {
		connect: GraphQLTypes["ProductFeatureUniqueWhere"],
	create: GraphQLTypes["ProductFeatureWithoutDependentElementCreateInput"]
};
	["ElementOfProductConnectOrCreateElementRelationInput"]: {
		connect: GraphQLTypes["ElementUniqueWhere"],
	create: GraphQLTypes["ElementWithoutProductsCreateInput"]
};
	["ProductConnectOrCreateElementsRelationInput"]: {
		connect: GraphQLTypes["ElementOfProductUniqueWhere"],
	create: GraphQLTypes["ElementOfProductWithoutProductCreateInput"]
};
	["ItemCategoryConnectOrCreateProductsRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutItemCategoriesCreateInput"]
};
	["AdConnectOrCreateItemCategoriesRelationInput"]: {
		connect: GraphQLTypes["ItemCategoryUniqueWhere"],
	create: GraphQLTypes["ItemCategoryWithoutAdsCreateInput"]
};
	["BlogPostConnectOrCreateAdsRelationInput"]: {
		connect: GraphQLTypes["AdUniqueWhere"],
	create: GraphQLTypes["AdWithoutBlogPostsCreateInput"]
};
	["UserConnectOrCreateBlogPostsRelationInput"]: {
		connect: GraphQLTypes["BlogPostUniqueWhere"],
	create: GraphQLTypes["BlogPostWithoutUserCreateInput"]
};
	["UserCreateAvatarEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateAvatarRelationInput"]
};
	["UserConnectOrCreateAvatarRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["UserCreateContactFormMessagesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactFormMessageUniqueWhere"],
	create?: GraphQLTypes["ContactFormMessageWithoutUserCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateContactFormMessagesRelationInput"],
	alias?: string
};
	["ContactFormMessageWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	message?: string,
	email?: string,
	receivedAt?: GraphQLTypes["DateTime"],
	isResolved?: boolean,
	url?: string,
	_dummy_field_?: boolean
};
	["UserConnectOrCreateContactFormMessagesRelationInput"]: {
		connect: GraphQLTypes["ContactFormMessageUniqueWhere"],
	create: GraphQLTypes["ContactFormMessageWithoutUserCreateInput"]
};
	["UserCreateBugReportsEntityRelationInput"]: {
		connect?: GraphQLTypes["BugReportUniqueWhere"],
	create?: GraphQLTypes["BugReportWithoutUserCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateBugReportsRelationInput"],
	alias?: string
};
	["BugReportWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	message?: string,
	receivedAt?: GraphQLTypes["DateTime"],
	isResolved?: boolean,
	url?: string,
	_dummy_field_?: boolean
};
	["UserConnectOrCreateBugReportsRelationInput"]: {
		connect: GraphQLTypes["BugReportUniqueWhere"],
	create: GraphQLTypes["BugReportWithoutUserCreateInput"]
};
	["UserCreateProtectedActionsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProtectedActionUniqueWhere"],
	create?: GraphQLTypes["ProtectedActionWithoutUserCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateProtectedActionsRelationInput"],
	alias?: string
};
	["ProtectedActionWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ProtectedActionType"],
	createdAt?: GraphQLTypes["DateTime"],
	usedAt?: GraphQLTypes["DateTime"],
	expiresAt?: GraphQLTypes["DateTime"],
	publicKey?: string,
	secretHash?: string,
	verifyEmail?: string,
	createdMetadata?: GraphQLTypes["Json"],
	usedMetadata?: GraphQLTypes["Json"],
	_dummy_field_?: boolean
};
	["UserConnectOrCreateProtectedActionsRelationInput"]: {
		connect: GraphQLTypes["ProtectedActionUniqueWhere"],
	create: GraphQLTypes["ProtectedActionWithoutUserCreateInput"]
};
	["UserCreateTenantPersonEntityRelationInput"]: {
		connect?: GraphQLTypes["TenantPersonUniqueWhere"]
};
	["ProductReviewConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutProductReviewsCreateInput"]
};
	["ProductReviewReactionConnectOrCreateProductReviewRelationInput"]: {
		connect: GraphQLTypes["ProductReviewUniqueWhere"],
	create: GraphQLTypes["ProductReviewWithoutProductReviewReactionsCreateInput"]
};
	["UserConnectOrCreateProductReviewReactionsRelationInput"]: {
		connect: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	create: GraphQLTypes["ProductReviewReactionWithoutUserCreateInput"]
};
	["BlogPostReviewConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutBlogPostReviewsCreateInput"]
};
	["BlogPostReviewReactionConnectOrCreateBlogPostReviewRelationInput"]: {
		connect: GraphQLTypes["BlogPostReviewUniqueWhere"],
	create: GraphQLTypes["BlogPostReviewWithoutBlogPostReviewReactionsCreateInput"]
};
	["UserConnectOrCreateBlogPostReviewReactionsRelationInput"]: {
		connect: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	create: GraphQLTypes["BlogPostReviewReactionWithoutUserCreateInput"]
};
	["BlogPostConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutBlogPostsCreateInput"]
};
	["ItemConnectOrCreateBlogPostRelationInput"]: {
		connect: GraphQLTypes["BlogPostUniqueWhere"],
	create: GraphQLTypes["BlogPostWithoutItemsCreateInput"]
};
	["ItemCategoryConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["ItemUniqueWhere"],
	create: GraphQLTypes["ItemWithoutCategoriesCreateInput"]
};
	["ProductConnectOrCreateItemCategoriesRelationInput"]: {
		connect: GraphQLTypes["ItemCategoryUniqueWhere"],
	create: GraphQLTypes["ItemCategoryWithoutProductsCreateInput"]
};
	["NutritionalValueOfProductConnectOrCreateProductRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutNutritionalValuesCreateInput"]
};
	["NutritionalValueConnectOrCreateProductsRelationInput"]: {
		connect: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	create: GraphQLTypes["NutritionalValueOfProductWithoutNutritionalValueCreateInput"]
};
	["NutritionalValueCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["NutritionalValueConnectOrCreateIconRelationInput"]
};
	["NutritionalValueConnectOrCreateIconRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["SuitabilityItemConnectOrCreateNutritionalValueRelationInput"]: {
		connect: GraphQLTypes["NutritionalValueUniqueWhere"],
	create: GraphQLTypes["NutritionalValueWithoutSuitabilityNutritionalValuesCreateInput"]
};
	["SuitabilityItemCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create?: GraphQLTypes["SuitabilityCategoryWithoutSuitabilityItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["SuitabilityItemConnectOrCreateCategoryRelationInput"]
};
	["SuitabilityCategoryWithoutSuitabilityItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	dogSizes?: Array<GraphQLTypes["SuitabilityCategoryCreateDogSizesEntityRelationInput"]>,
	dogActivities?: Array<GraphQLTypes["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["SuitabilityCategoryCreateBreedsEntityRelationInput"]>,
	dogAges?: Array<GraphQLTypes["SuitabilityCategoryCreateDogAgesEntityRelationInput"]>,
	isPregnant?: boolean,
	remoteId?: string,
	isBreastfeeding?: boolean,
	_dummy_field_?: boolean
};
	["SuitabilityItemConnectOrCreateCategoryRelationInput"]: {
		connect: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create: GraphQLTypes["SuitabilityCategoryWithoutSuitabilityItemsCreateInput"]
};
	["ElementConnectOrCreateSuitabilityElementsRelationInput"]: {
		connect: GraphQLTypes["SuitabilityItemUniqueWhere"],
	create: GraphQLTypes["SuitabilityItemWithoutElementCreateInput"]
};
	["ProductFeatureConnectOrCreateDependentElementRelationInput"]: {
		connect: GraphQLTypes["ElementUniqueWhere"],
	create: GraphQLTypes["ElementWithoutFeatureDependenciesCreateInput"]
};
	["ItemConnectOrCreateFeaturesOfProductRelationInput"]: {
		connect: GraphQLTypes["ProductFeatureUniqueWhere"],
	create: GraphQLTypes["ProductFeatureWithoutLinkItemCreateInput"]
};
	["BlogPostConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["ItemUniqueWhere"],
	create: GraphQLTypes["ItemWithoutBlogPostCreateInput"]
};
	["ItemCategoryConnectOrCreateBlogPostsRelationInput"]: {
		connect: GraphQLTypes["BlogPostUniqueWhere"],
	create: GraphQLTypes["BlogPostWithoutItemCategoriesCreateInput"]
};
	["ItemConnectOrCreateCategoriesRelationInput"]: {
		connect: GraphQLTypes["ItemCategoryUniqueWhere"],
	create: GraphQLTypes["ItemCategoryWithoutItemsCreateInput"]
};
	["ProductFeatureConnectOrCreateLinkItemRelationInput"]: {
		connect: GraphQLTypes["ItemUniqueWhere"],
	create: GraphQLTypes["ItemWithoutFeaturesOfProductCreateInput"]
};
	["ItemSubCategoryConnectOrCreateFeatureDependenciesRelationInput"]: {
		connect: GraphQLTypes["ProductFeatureUniqueWhere"],
	create: GraphQLTypes["ProductFeatureWithoutDependentSubCategoryCreateInput"]
};
	["ProductConnectOrCreateItemSubCategoriesRelationInput"]: {
		connect: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create: GraphQLTypes["ItemSubCategoryWithoutProductsCreateInput"]
};
	["DogActivityConnectOrCreateProductsRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutRecommendedActivityCreateInput"]
};
	["DogConnectOrCreateActivityRelationInput"]: {
		connect: GraphQLTypes["DogActivityUniqueWhere"],
	create: GraphQLTypes["DogActivityWithoutDogsCreateInput"]
};
	["BreedConnectOrCreateDogsRelationInput"]: {
		connect: GraphQLTypes["DogUniqueWhere"],
	create: GraphQLTypes["DogWithoutBreedCreateInput"]
};
	["AgeConnectOrCreateBreedsRelationInput"]: {
		connect: GraphQLTypes["BreedUniqueWhere"],
	create: GraphQLTypes["BreedWithoutAgesCreateInput"]
};
	["DogConnectOrCreateAgeRelationInput"]: {
		connect: GraphQLTypes["AgeUniqueWhere"],
	create: GraphQLTypes["AgeWithoutDogsCreateInput"]
};
	["ProductConnectOrCreateDogsRelationInput"]: {
		connect: GraphQLTypes["DogUniqueWhere"],
	create: GraphQLTypes["DogWithoutFedProductCreateInput"]
};
	["ItemSubCategoryConnectOrCreateProductsRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutItemSubCategoriesCreateInput"]
};
	["ItemConnectOrCreateSubCategoriesRelationInput"]: {
		connect: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create: GraphQLTypes["ItemSubCategoryWithoutItemsCreateInput"]
};
	["BodyTagConnectOrCreateNegativeItemsRelationInput"]: {
		connect: GraphQLTypes["ItemUniqueWhere"],
	create: GraphQLTypes["ItemWithoutNegativeForBodyTagsCreateInput"]
};
	["ItemConnectOrCreatePositiveForBodyTagsRelationInput"]: {
		connect: GraphQLTypes["BodyTagUniqueWhere"],
	create: GraphQLTypes["BodyTagWithoutPositiveItemsCreateInput"]
};
	["ItemSubCategoryConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["ItemUniqueWhere"],
	create: GraphQLTypes["ItemWithoutSubCategoriesCreateInput"]
};
	["ItemCategoryConnectOrCreateSubCategoriesRelationInput"]: {
		connect: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create: GraphQLTypes["ItemSubCategoryWithoutCategoryCreateInput"]
};
	["BlogPostConnectOrCreateItemCategoriesRelationInput"]: {
		connect: GraphQLTypes["ItemCategoryUniqueWhere"],
	create: GraphQLTypes["ItemCategoryWithoutBlogPostsCreateInput"]
};
	["BlogPostTagConnectOrCreateBlogPostsRelationInput"]: {
		connect: GraphQLTypes["BlogPostUniqueWhere"],
	create: GraphQLTypes["BlogPostWithoutBlogPostTagsCreateInput"]
};
	["ColorConnectOrCreateBlogPostTagRelationInput"]: {
		connect: GraphQLTypes["BlogPostTagUniqueWhere"],
	create: GraphQLTypes["BlogPostTagWithoutColorCreateInput"]
};
	["ColorCreateItemFlavorCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemFlavorCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemFlavorCategoryWithoutColorCreateInput"],
	connectOrCreate?: GraphQLTypes["ColorConnectOrCreateItemFlavorCategoriesRelationInput"],
	alias?: string
};
	["ItemFlavorCategoryWithoutColorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	items?: Array<GraphQLTypes["ItemFlavorCategoryCreateItemsEntityRelationInput"]>,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ItemFlavorCategoryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryWithoutFlavorCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemFlavorCategoryConnectOrCreateItemsRelationInput"],
	alias?: string
};
	["ItemSubCategoryWithoutFlavorCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryCreateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryCreateCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryCreateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryCreateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryCreateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryCreateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryCreateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryCreateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemFlavorCategoryConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create: GraphQLTypes["ItemSubCategoryWithoutFlavorCategoryCreateInput"]
};
	["ColorConnectOrCreateItemFlavorCategoriesRelationInput"]: {
		connect: GraphQLTypes["ItemFlavorCategoryUniqueWhere"],
	create: GraphQLTypes["ItemFlavorCategoryWithoutColorCreateInput"]
};
	["BodyTagCategoryConnectOrCreateColorRelationInput"]: {
		connect: GraphQLTypes["ColorUniqueWhere"],
	create: GraphQLTypes["ColorWithoutBodyTagCategoryCreateInput"]
};
	["BodyTagConnectOrCreateCategoryRelationInput"]: {
		connect: GraphQLTypes["BodyTagCategoryUniqueWhere"],
	create: GraphQLTypes["BodyTagCategoryWithoutTagsCreateInput"]
};
	["ItemConnectOrCreateNegativeForBodyTagsRelationInput"]: {
		connect: GraphQLTypes["BodyTagUniqueWhere"],
	create: GraphQLTypes["BodyTagWithoutNegativeItemsCreateInput"]
};
	["BodyTagConnectOrCreatePositiveItemsRelationInput"]: {
		connect: GraphQLTypes["ItemUniqueWhere"],
	create: GraphQLTypes["ItemWithoutPositiveForBodyTagsCreateInput"]
};
	["ProductConnectOrCreateNegativeForBodyTagsRelationInput"]: {
		connect: GraphQLTypes["BodyTagUniqueWhere"],
	create: GraphQLTypes["BodyTagWithoutNegativeProductsCreateInput"]
};
	["ProductReviewConnectOrCreateProductRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutReviewsCreateInput"]
};
	["UserConnectOrCreateProductReviewsRelationInput"]: {
		connect: GraphQLTypes["ProductReviewUniqueWhere"],
	create: GraphQLTypes["ProductReviewWithoutUserCreateInput"]
};
	["ProductReviewReactionConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutProductReviewReactionsCreateInput"]
};
	["ProductReviewConnectOrCreateProductReviewReactionsRelationInput"]: {
		connect: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	create: GraphQLTypes["ProductReviewReactionWithoutProductReviewCreateInput"]
};
	["ProductConnectOrCreateReviewsRelationInput"]: {
		connect: GraphQLTypes["ProductReviewUniqueWhere"],
	create: GraphQLTypes["ProductReviewWithoutProductCreateInput"]
};
	["BodyTagConnectOrCreateNegativeProductsRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutNegativeForBodyTagsCreateInput"]
};
	["ProductConnectOrCreatePositiveForBodyTagsRelationInput"]: {
		connect: GraphQLTypes["BodyTagUniqueWhere"],
	create: GraphQLTypes["BodyTagWithoutPositiveProductsCreateInput"]
};
	["ElementOfProductConnectOrCreateProductRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutElementsCreateInput"]
};
	["ElementConnectOrCreateProductsRelationInput"]: {
		connect: GraphQLTypes["ElementOfProductUniqueWhere"],
	create: GraphQLTypes["ElementOfProductWithoutElementCreateInput"]
};
	["SuitabilityItemConnectOrCreateElementRelationInput"]: {
		connect: GraphQLTypes["ElementUniqueWhere"],
	create: GraphQLTypes["ElementWithoutSuitabilityElementsCreateInput"]
};
	["NutritionalValueConnectOrCreateSuitabilityNutritionalValuesRelationInput"]: {
		connect: GraphQLTypes["SuitabilityItemUniqueWhere"],
	create: GraphQLTypes["SuitabilityItemWithoutNutritionalValueCreateInput"]
};
	["NutritionalValueOfProductConnectOrCreateNutritionalValueRelationInput"]: {
		connect: GraphQLTypes["NutritionalValueUniqueWhere"],
	create: GraphQLTypes["NutritionalValueWithoutProductsCreateInput"]
};
	["ProductConnectOrCreateNutritionalValuesRelationInput"]: {
		connect: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	create: GraphQLTypes["NutritionalValueOfProductWithoutProductCreateInput"]
};
	["BodyTagConnectOrCreatePositiveProductsRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutPositiveForBodyTagsCreateInput"]
};
	["BlogPostConnectOrCreateTagsRelationInput"]: {
		connect: GraphQLTypes["BodyTagUniqueWhere"],
	create: GraphQLTypes["BodyTagWithoutBlogPostsCreateInput"]
};
	["BlogPostReviewConnectOrCreateBlogPostRelationInput"]: {
		connect: GraphQLTypes["BlogPostUniqueWhere"],
	create: GraphQLTypes["BlogPostWithoutReviewsCreateInput"]
};
	["UserConnectOrCreateBlogPostReviewsRelationInput"]: {
		connect: GraphQLTypes["BlogPostReviewUniqueWhere"],
	create: GraphQLTypes["BlogPostReviewWithoutUserCreateInput"]
};
	["DogConnectOrCreateOwnerRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutDogsCreateInput"]
};
	["AgeConnectOrCreateDogsRelationInput"]: {
		connect: GraphQLTypes["DogUniqueWhere"],
	create: GraphQLTypes["DogWithoutAgeCreateInput"]
};
	["BreedConnectOrCreateAgesRelationInput"]: {
		connect: GraphQLTypes["AgeUniqueWhere"],
	create: GraphQLTypes["AgeWithoutBreedsCreateInput"]
};
	["DogConnectOrCreateBreedRelationInput"]: {
		connect: GraphQLTypes["BreedUniqueWhere"],
	create: GraphQLTypes["BreedWithoutDogsCreateInput"]
};
	["UserConnectOrCreateDogsRelationInput"]: {
		connect: GraphQLTypes["DogUniqueWhere"],
	create: GraphQLTypes["DogWithoutOwnerCreateInput"]
};
	["BlogPostReviewReactionConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutBlogPostReviewReactionsCreateInput"]
};
	["BlogPostReviewConnectOrCreateBlogPostReviewReactionsRelationInput"]: {
		connect: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	create: GraphQLTypes["BlogPostReviewReactionWithoutBlogPostReviewCreateInput"]
};
	["BlogPostConnectOrCreateReviewsRelationInput"]: {
		connect: GraphQLTypes["BlogPostReviewUniqueWhere"],
	create: GraphQLTypes["BlogPostReviewWithoutBlogPostCreateInput"]
};
	["BodyTagConnectOrCreateBlogPostsRelationInput"]: {
		connect: GraphQLTypes["BlogPostUniqueWhere"],
	create: GraphQLTypes["BlogPostWithoutTagsCreateInput"]
};
	["BodyTagCategoryConnectOrCreateTagsRelationInput"]: {
		connect: GraphQLTypes["BodyTagUniqueWhere"],
	create: GraphQLTypes["BodyTagWithoutCategoryCreateInput"]
};
	["ColorConnectOrCreateBodyTagCategoryRelationInput"]: {
		connect: GraphQLTypes["BodyTagCategoryUniqueWhere"],
	create: GraphQLTypes["BodyTagCategoryWithoutColorCreateInput"]
};
	["BlogPostTagConnectOrCreateColorRelationInput"]: {
		connect: GraphQLTypes["ColorUniqueWhere"],
	create: GraphQLTypes["ColorWithoutBlogPostTagCreateInput"]
};
	["BlogPostConnectOrCreateBlogPostTagsRelationInput"]: {
		connect: GraphQLTypes["BlogPostTagUniqueWhere"],
	create: GraphQLTypes["BlogPostTagWithoutBlogPostsCreateInput"]
};
	["ContentReferenceConnectOrCreateRelatedBlogPostRelationInput"]: {
		connect: GraphQLTypes["BlogPostUniqueWhere"],
	create: GraphQLTypes["BlogPostCreateInput"]
};
	["ContentReferenceCreateAdEntityRelationInput"]: {
		connect?: GraphQLTypes["AdUniqueWhere"],
	create?: GraphQLTypes["AdWithoutContentReferencesCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateAdRelationInput"]
};
	["AdWithoutContentReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["AdCreateImageEntityRelationInput"],
	isBrandSectionVisible?: boolean,
	isBlogPostSectionVisible?: boolean,
	isIngredientSectionVisible?: boolean,
	isResultsVisible?: boolean,
	isSearchVisible?: boolean,
	blogPosts?: Array<GraphQLTypes["AdCreateBlogPostsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["AdCreateItemCategoriesEntityRelationInput"]>,
	brands?: Array<GraphQLTypes["AdCreateBrandsEntityRelationInput"]>,
	isActive?: boolean,
	link?: string,
	note?: string,
	activeFrom?: GraphQLTypes["DateTime"],
	activeUntil?: GraphQLTypes["DateTime"],
	slug?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceConnectOrCreateAdRelationInput"]: {
		connect: GraphQLTypes["AdUniqueWhere"],
	create: GraphQLTypes["AdWithoutContentReferencesCreateInput"]
};
	["ContentBlockConnectOrCreateReferencesRelationInput"]: {
		connect: GraphQLTypes["ContentReferenceUniqueWhere"],
	create: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentConnectOrCreateBlocksRelationInput"]: {
		connect: GraphQLTypes["ContentBlockUniqueWhere"],
	create: GraphQLTypes["ContentBlockWithoutContentCreateInput"]
};
	["BlogPageConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["SeoConnectOrCreateBlogPageRelationInput"]: {
		connect: GraphQLTypes["BlogPageUniqueWhere"],
	create: GraphQLTypes["BlogPageWithoutSeoCreateInput"]
};
	["GenericPageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoWithoutGenericPageCreateInput"]
};
	["RedirectConnectOrCreateGenericPageRelationInput"]: {
		connect: GraphQLTypes["GenericPageUniqueWhere"],
	create: GraphQLTypes["GenericPageWithoutRedirectsCreateInput"]
};
	["BlogPageConnectOrCreateRedirectsRelationInput"]: {
		connect: GraphQLTypes["RedirectUniqueWhere"],
	create: GraphQLTypes["RedirectWithoutBlogPageCreateInput"]
};
	["BlogPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	redirects?: Array<GraphQLTypes["BlogPageUpdateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["BlogPageUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["BlogPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPageUpdateRedirectsEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutBlogPageCreateInput"],
	update?: GraphQLTypes["BlogPageUpdateRedirectsRelationInput"],
	upsert?: GraphQLTypes["BlogPageUpsertRedirectsRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: GraphQLTypes["RedirectUniqueWhere"],
	delete?: GraphQLTypes["RedirectUniqueWhere"],
	alias?: string
};
	["BlogPageUpdateRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	data: GraphQLTypes["RedirectWithoutBlogPageUpdateInput"]
};
	["RedirectWithoutBlogPageUpdateInput"]: {
		to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectUpdateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectUpdateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectUpdateBrandsPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectUpdateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectUpdateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectUpdateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectUpdateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateGenericPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageUniqueWhere"],
	create?: GraphQLTypes["GenericPageWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateGenericPageRelationInput"],
	update?: GraphQLTypes["GenericPageWithoutRedirectsUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertGenericPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["GenericPageWithoutRedirectsUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["GenericPageUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["GenericPageUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["GenericPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["GenericPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GenericPageUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutGenericPageCreateInput"],
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateLinkRelationInput"],
	update?: GraphQLTypes["LinkableWithoutGenericPageUpdateInput"],
	upsert?: GraphQLTypes["GenericPageUpsertLinkRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutGenericPageUpdateInput"]: {
		url?: string,
	_dummy_field_?: boolean
};
	["GenericPageUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkableWithoutGenericPageUpdateInput"],
	create: GraphQLTypes["LinkableWithoutGenericPageCreateInput"]
};
	["GenericPageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutGenericPageCreateInput"],
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoWithoutGenericPageUpdateInput"],
	upsert?: GraphQLTypes["GenericPageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoWithoutGenericPageUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoUpdateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoUpdateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoUpdateComparatorPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoUpdateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoUpdateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoUpdateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoUpdateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoUpdateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoUpdateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoUpdateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SeoUpdateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateOgImageRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertOgImageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageUpdateInput"]: {
		url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	remoteId?: string,
	hash?: string,
	_dummy_field_?: boolean
};
	["SeoUpsertOgImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["SeoUpdateBlogPageEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPageUniqueWhere"],
	create?: GraphQLTypes["BlogPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateBlogPageRelationInput"],
	update?: GraphQLTypes["BlogPageWithoutSeoUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertBlogPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPageWithoutSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	redirects?: Array<GraphQLTypes["BlogPageUpdateRedirectsEntityRelationInput"]>,
	content?: GraphQLTypes["BlogPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPageUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPageConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["BlogPageUpsertContentRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentUpdateInput"]: {
		blocks?: Array<GraphQLTypes["ContentUpdateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentUpdateBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateBlocksRelationInput"],
	upsert?: GraphQLTypes["ContentUpsertBlocksRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	disconnect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: GraphQLTypes["ContentBlockUniqueWhere"],
	alias?: string
};
	["ContentUpdateBlocksRelationInput"]: {
		by: GraphQLTypes["ContentBlockUniqueWhere"],
	data: GraphQLTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
		order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]>,
	automatedContentBlockSlug?: string,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"],
	update?: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"],
	alias?: string
};
	["ContentBlockUpdateReferencesRelationInput"]: {
		by: GraphQLTypes["ContentReferenceUniqueWhere"],
	data: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	secondaryText?: string,
	fact?: string,
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	relatedBlogPost?: GraphQLTypes["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceUpdateRelatedBrandEntityRelationInput"],
	relatedProduct?: GraphQLTypes["ContentReferenceUpdateRelatedProductEntityRelationInput"],
	relatedIngredient?: GraphQLTypes["ContentReferenceUpdateRelatedIngredientEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	badge?: string,
	longVersion?: boolean,
	relatedBrandFull?: GraphQLTypes["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"],
	relatedProductFull?: GraphQLTypes["ContentReferenceUpdateRelatedProductFullEntityRelationInput"],
	list?: Array<GraphQLTypes["ContentReferenceUpdateListEntityRelationInput"]>,
	outline?: GraphQLTypes["ContentReferenceUpdateOutlineEntityRelationInput"],
	video?: GraphQLTypes["ContentReferenceUpdateVideoEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	defaultOpen?: boolean,
	badgeColor?: string,
	isMain?: boolean,
	ad?: GraphQLTypes["ContentReferenceUpdateAdEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateImagesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceGalleryImageWithoutReferenceCreateInput"],
	update?: GraphQLTypes["ContentReferenceUpdateImagesRelationInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertImagesRelationInput"],
	connect?: GraphQLTypes["ContentReferenceGalleryImageUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceGalleryImageUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceGalleryImageUniqueWhere"],
	alias?: string
};
	["ContentReferenceUpdateImagesRelationInput"]: {
		by: GraphQLTypes["ContentReferenceGalleryImageUniqueWhere"],
	data: GraphQLTypes["ContentReferenceGalleryImageWithoutReferenceUpdateInput"]
};
	["ContentReferenceGalleryImageWithoutReferenceUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["ContentReferenceGalleryImageUpdateImageEntityRelationInput"],
	lead?: string,
	alignment?: GraphQLTypes["AlignmentType"],
	_dummy_field_?: boolean
};
	["ContentReferenceGalleryImageUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceGalleryImageConnectOrCreateImageRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceGalleryImageUpsertImageRelationInput"],
	delete?: boolean
};
	["ContentReferenceGalleryImageUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpsertImagesRelationInput"]: {
		by: GraphQLTypes["ContentReferenceGalleryImageUniqueWhere"],
	update: GraphQLTypes["ContentReferenceGalleryImageWithoutReferenceUpdateInput"],
	create: GraphQLTypes["ContentReferenceGalleryImageWithoutReferenceCreateInput"]
};
	["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateRelatedBlogPostRelationInput"],
	update?: GraphQLTypes["BlogPostUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertRelatedBlogPostRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPostUpdateInput"]: {
		author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostUpdateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostUpdateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostUpdateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostUpdateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostUpdateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostUpdateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostUpdateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostUpdateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostUpdateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostUpdateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostUpdateBlogPostTagsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostTagWithoutBlogPostsCreateInput"],
	update?: GraphQLTypes["BlogPostUpdateBlogPostTagsRelationInput"],
	upsert?: GraphQLTypes["BlogPostUpsertBlogPostTagsRelationInput"],
	connect?: GraphQLTypes["BlogPostTagUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostTagUniqueWhere"],
	delete?: GraphQLTypes["BlogPostTagUniqueWhere"],
	alias?: string
};
	["BlogPostUpdateBlogPostTagsRelationInput"]: {
		by: GraphQLTypes["BlogPostTagUniqueWhere"],
	data: GraphQLTypes["BlogPostTagWithoutBlogPostsUpdateInput"]
};
	["BlogPostTagWithoutBlogPostsUpdateInput"]: {
		name?: string,
	remoteId?: string,
	color?: GraphQLTypes["BlogPostTagUpdateColorEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["BlogPostTagUpdateColorEntityRelationInput"]: {
		connect?: GraphQLTypes["ColorUniqueWhere"],
	create?: GraphQLTypes["ColorWithoutBlogPostTagCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostTagConnectOrCreateColorRelationInput"],
	update?: GraphQLTypes["ColorWithoutBlogPostTagUpdateInput"],
	upsert?: GraphQLTypes["BlogPostTagUpsertColorRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ColorWithoutBlogPostTagUpdateInput"]: {
		name?: string,
	colorHex?: string,
	bodyTagCategory?: GraphQLTypes["ColorUpdateBodyTagCategoryEntityRelationInput"],
	remoteId?: string,
	itemFlavorCategories?: Array<GraphQLTypes["ColorUpdateItemFlavorCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ColorUpdateBodyTagCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagCategoryUniqueWhere"],
	create?: GraphQLTypes["BodyTagCategoryWithoutColorCreateInput"],
	connectOrCreate?: GraphQLTypes["ColorConnectOrCreateBodyTagCategoryRelationInput"],
	update?: GraphQLTypes["BodyTagCategoryWithoutColorUpdateInput"],
	upsert?: GraphQLTypes["ColorUpsertBodyTagCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BodyTagCategoryWithoutColorUpdateInput"]: {
		name?: string,
	tags?: Array<GraphQLTypes["BodyTagCategoryUpdateTagsEntityRelationInput"]>,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["BodyTagCategoryUpdateTagsEntityRelationInput"]: {
		create?: GraphQLTypes["BodyTagWithoutCategoryCreateInput"],
	update?: GraphQLTypes["BodyTagCategoryUpdateTagsRelationInput"],
	upsert?: GraphQLTypes["BodyTagCategoryUpsertTagsRelationInput"],
	connect?: GraphQLTypes["BodyTagUniqueWhere"],
	disconnect?: GraphQLTypes["BodyTagUniqueWhere"],
	delete?: GraphQLTypes["BodyTagUniqueWhere"],
	alias?: string
};
	["BodyTagCategoryUpdateTagsRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	data: GraphQLTypes["BodyTagWithoutCategoryUpdateInput"]
};
	["BodyTagWithoutCategoryUpdateInput"]: {
		name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagUpdateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagUpdatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagUpdateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagUpdatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagUpdateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	icon?: GraphQLTypes["BodyTagUpdateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagUpdateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagUpdateBlogPostsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostWithoutTagsCreateInput"],
	update?: GraphQLTypes["BodyTagUpdateBlogPostsRelationInput"],
	upsert?: GraphQLTypes["BodyTagUpsertBlogPostsRelationInput"],
	connect?: GraphQLTypes["BlogPostUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostUniqueWhere"],
	delete?: GraphQLTypes["BlogPostUniqueWhere"],
	alias?: string
};
	["BodyTagUpdateBlogPostsRelationInput"]: {
		by: GraphQLTypes["BlogPostUniqueWhere"],
	data: GraphQLTypes["BlogPostWithoutTagsUpdateInput"]
};
	["BlogPostWithoutTagsUpdateInput"]: {
		author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostUpdateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostUpdateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostUpdateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostUpdateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostUpdateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostUpdateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostUpdateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostUpdateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostUpdateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostUpdateReviewsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostReviewWithoutBlogPostCreateInput"],
	update?: GraphQLTypes["BlogPostUpdateReviewsRelationInput"],
	upsert?: GraphQLTypes["BlogPostUpsertReviewsRelationInput"],
	connect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	delete?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	alias?: string
};
	["BlogPostUpdateReviewsRelationInput"]: {
		by: GraphQLTypes["BlogPostReviewUniqueWhere"],
	data: GraphQLTypes["BlogPostReviewWithoutBlogPostUpdateInput"]
};
	["BlogPostReviewWithoutBlogPostUpdateInput"]: {
		title?: string,
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostReviewReactions?: Array<GraphQLTypes["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	user?: GraphQLTypes["BlogPostReviewUpdateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["BlogPostReviewUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["BlogPostReviewUpdateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostReviewReactionWithoutBlogPostReviewCreateInput"],
	update?: GraphQLTypes["BlogPostReviewUpdateBlogPostReviewReactionsRelationInput"],
	upsert?: GraphQLTypes["BlogPostReviewUpsertBlogPostReviewReactionsRelationInput"],
	connect?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	delete?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	alias?: string
};
	["BlogPostReviewUpdateBlogPostReviewReactionsRelationInput"]: {
		by: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	data: GraphQLTypes["BlogPostReviewReactionWithoutBlogPostReviewUpdateInput"]
};
	["BlogPostReviewReactionWithoutBlogPostReviewUpdateInput"]: {
		sentiment?: GraphQLTypes["SentimentType"],
	user?: GraphQLTypes["BlogPostReviewReactionUpdateUserEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostReviewReactionUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutBlogPostReviewReactionsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewReactionConnectOrCreateUserRelationInput"],
	update?: GraphQLTypes["UserWithoutBlogPostReviewReactionsUpdateInput"],
	upsert?: GraphQLTypes["BlogPostReviewReactionUpsertUserRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["UserWithoutBlogPostReviewReactionsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["UserUpdateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserUpdateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserUpdateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserUpdateProductReviewsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserUpdateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserUpdateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserUpdateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserUpdateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserUpdateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserUpdateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserUpdateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserUpdateDogsEntityRelationInput"]: {
		create?: GraphQLTypes["DogWithoutOwnerCreateInput"],
	update?: GraphQLTypes["UserUpdateDogsRelationInput"],
	upsert?: GraphQLTypes["UserUpsertDogsRelationInput"],
	connect?: GraphQLTypes["DogUniqueWhere"],
	disconnect?: GraphQLTypes["DogUniqueWhere"],
	delete?: GraphQLTypes["DogUniqueWhere"],
	alias?: string
};
	["UserUpdateDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	data: GraphQLTypes["DogWithoutOwnerUpdateInput"]
};
	["DogWithoutOwnerUpdateInput"]: {
		gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogUpdateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogUpdateBodyTypeEntityRelationInput"],
	activity?: GraphQLTypes["DogUpdateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogUpdateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogUpdateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogUpdateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogUpdateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogUpdateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogUpdateBreedEntityRelationInput"]: {
		connect?: GraphQLTypes["BreedUniqueWhere"],
	create?: GraphQLTypes["BreedWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateBreedRelationInput"],
	update?: GraphQLTypes["BreedWithoutDogsUpdateInput"],
	upsert?: GraphQLTypes["DogUpsertBreedRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BreedWithoutDogsUpdateInput"]: {
		litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedUpdateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedUpdateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedUpdateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedUpdateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedUpdateReviewsEntityRelationInput"]: {
		create?: GraphQLTypes["ReviewWithoutDogBreedsCreateInput"],
	update?: GraphQLTypes["BreedUpdateReviewsRelationInput"],
	upsert?: GraphQLTypes["BreedUpsertReviewsRelationInput"],
	connect?: GraphQLTypes["ReviewUniqueWhere"],
	disconnect?: GraphQLTypes["ReviewUniqueWhere"],
	delete?: GraphQLTypes["ReviewUniqueWhere"],
	alias?: string
};
	["BreedUpdateReviewsRelationInput"]: {
		by: GraphQLTypes["ReviewUniqueWhere"],
	data: GraphQLTypes["ReviewWithoutDogBreedsUpdateInput"]
};
	["ReviewWithoutDogBreedsUpdateInput"]: {
		text?: string,
	remoteId?: string,
	author?: string,
	_dummy_field_?: boolean
};
	["BreedUpsertReviewsRelationInput"]: {
		by: GraphQLTypes["ReviewUniqueWhere"],
	update: GraphQLTypes["ReviewWithoutDogBreedsUpdateInput"],
	create: GraphQLTypes["ReviewWithoutDogBreedsCreateInput"]
};
	["BreedUpdateAgesEntityRelationInput"]: {
		create?: GraphQLTypes["AgeWithoutBreedsCreateInput"],
	update?: GraphQLTypes["BreedUpdateAgesRelationInput"],
	upsert?: GraphQLTypes["BreedUpsertAgesRelationInput"],
	connect?: GraphQLTypes["AgeUniqueWhere"],
	disconnect?: GraphQLTypes["AgeUniqueWhere"],
	delete?: GraphQLTypes["AgeUniqueWhere"],
	alias?: string
};
	["BreedUpdateAgesRelationInput"]: {
		by: GraphQLTypes["AgeUniqueWhere"],
	data: GraphQLTypes["AgeWithoutBreedsUpdateInput"]
};
	["AgeWithoutBreedsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["AgeUpdateDogsEntityRelationInput"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	suitabilityCategories?: Array<GraphQLTypes["AgeUpdateSuitabilityCategoriesEntityRelationInput"]>,
	remoteId?: string,
	productReviews?: Array<GraphQLTypes["AgeUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["AgeUpdateBlogPostReviewsEntityRelationInput"]>,
	label?: string,
	categoryOrder?: string,
	_dummy_field_?: boolean
};
	["AgeUpdateDogsEntityRelationInput"]: {
		create?: GraphQLTypes["DogWithoutAgeCreateInput"],
	update?: GraphQLTypes["AgeUpdateDogsRelationInput"],
	upsert?: GraphQLTypes["AgeUpsertDogsRelationInput"],
	connect?: GraphQLTypes["DogUniqueWhere"],
	disconnect?: GraphQLTypes["DogUniqueWhere"],
	delete?: GraphQLTypes["DogUniqueWhere"],
	alias?: string
};
	["AgeUpdateDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	data: GraphQLTypes["DogWithoutAgeUpdateInput"]
};
	["DogWithoutAgeUpdateInput"]: {
		gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogUpdateBreedEntityRelationInput"],
	bodyType?: GraphQLTypes["DogUpdateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogUpdateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogUpdateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogUpdateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogUpdateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogUpdateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogUpdateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogUpdateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogUpdateBodyTypeEntityRelationInput"]: {
		connect?: GraphQLTypes["DogBodyTypeUniqueWhere"],
	create?: GraphQLTypes["DogBodyTypeWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateBodyTypeRelationInput"],
	update?: GraphQLTypes["DogBodyTypeWithoutDogsUpdateInput"],
	upsert?: GraphQLTypes["DogUpsertBodyTypeRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["DogBodyTypeWithoutDogsUpdateInput"]: {
		name?: string,
	lead?: string,
	order?: number,
	value?: number,
	remoteId?: string,
	category?: GraphQLTypes["DogBodyTypeUpdateCategoryEntityRelationInput"],
	imageMain?: GraphQLTypes["DogBodyTypeUpdateImageMainEntityRelationInput"],
	imageFrom?: GraphQLTypes["DogBodyTypeUpdateImageFromEntityRelationInput"],
	imageTo?: GraphQLTypes["DogBodyTypeUpdateImageToEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogBodyTypeUpdateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["DogBodyTypeCategoryUniqueWhere"],
	create?: GraphQLTypes["DogBodyTypeCategoryWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogBodyTypeConnectOrCreateCategoryRelationInput"],
	update?: GraphQLTypes["DogBodyTypeCategoryWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["DogBodyTypeUpsertCategoryRelationInput"],
	delete?: boolean
};
	["DogBodyTypeCategoryWithoutItemsUpdateInput"]: {
		name?: string,
	remoteId?: string,
	imageMain?: GraphQLTypes["DogBodyTypeCategoryUpdateImageMainEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogBodyTypeCategoryUpdateImageMainEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["DogBodyTypeCategoryConnectOrCreateImageMainRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["DogBodyTypeCategoryUpsertImageMainRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["DogBodyTypeCategoryUpsertImageMainRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["DogBodyTypeUpsertCategoryRelationInput"]: {
		update: GraphQLTypes["DogBodyTypeCategoryWithoutItemsUpdateInput"],
	create: GraphQLTypes["DogBodyTypeCategoryWithoutItemsCreateInput"]
};
	["DogBodyTypeUpdateImageMainEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["DogBodyTypeConnectOrCreateImageMainRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["DogBodyTypeUpsertImageMainRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["DogBodyTypeUpsertImageMainRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["DogBodyTypeUpdateImageFromEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["DogBodyTypeConnectOrCreateImageFromRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["DogBodyTypeUpsertImageFromRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["DogBodyTypeUpsertImageFromRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["DogBodyTypeUpdateImageToEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["DogBodyTypeConnectOrCreateImageToRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["DogBodyTypeUpsertImageToRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["DogBodyTypeUpsertImageToRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["DogUpsertBodyTypeRelationInput"]: {
		update: GraphQLTypes["DogBodyTypeWithoutDogsUpdateInput"],
	create: GraphQLTypes["DogBodyTypeWithoutDogsCreateInput"]
};
	["DogUpdateOwnerEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateOwnerRelationInput"],
	update?: GraphQLTypes["UserWithoutDogsUpdateInput"],
	upsert?: GraphQLTypes["DogUpsertOwnerRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["UserWithoutDogsUpdateInput"]: {
		veterinary?: GraphQLTypes["UserUpdateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserUpdateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserUpdateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserUpdateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserUpdateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserUpdateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserUpdateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserUpdateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserUpdateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserUpdateVeterinaryEntityRelationInput"]: {
		connect?: GraphQLTypes["VeterinaryUniqueWhere"],
	create?: GraphQLTypes["VeterinaryWithoutUserCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateVeterinaryRelationInput"],
	update?: GraphQLTypes["VeterinaryWithoutUserUpdateInput"],
	upsert?: GraphQLTypes["UserUpsertVeterinaryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["VeterinaryWithoutUserUpdateInput"]: {
		_dummy_field_?: boolean
};
	["UserUpsertVeterinaryRelationInput"]: {
		update: GraphQLTypes["VeterinaryWithoutUserUpdateInput"],
	create: GraphQLTypes["VeterinaryWithoutUserCreateInput"]
};
	["UserUpdateBlogPostReviewsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostReviewWithoutUserCreateInput"],
	update?: GraphQLTypes["UserUpdateBlogPostReviewsRelationInput"],
	upsert?: GraphQLTypes["UserUpsertBlogPostReviewsRelationInput"],
	connect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	delete?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	alias?: string
};
	["UserUpdateBlogPostReviewsRelationInput"]: {
		by: GraphQLTypes["BlogPostReviewUniqueWhere"],
	data: GraphQLTypes["BlogPostReviewWithoutUserUpdateInput"]
};
	["BlogPostReviewWithoutUserUpdateInput"]: {
		title?: string,
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostReviewReactions?: Array<GraphQLTypes["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	blogPost?: GraphQLTypes["BlogPostReviewUpdateBlogPostEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["BlogPostReviewUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["BlogPostReviewUpdateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["BlogPostReviewUpdateBlogPostEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostWithoutReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewConnectOrCreateBlogPostRelationInput"],
	update?: GraphQLTypes["BlogPostWithoutReviewsUpdateInput"],
	upsert?: GraphQLTypes["BlogPostReviewUpsertBlogPostRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPostWithoutReviewsUpdateInput"]: {
		author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostUpdateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	itemCategories?: Array<GraphQLTypes["BlogPostUpdateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostUpdateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostUpdateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostUpdateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostUpdateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostUpdateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostUpdateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostUpdateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostUpdateTagsEntityRelationInput"]: {
		create?: GraphQLTypes["BodyTagWithoutBlogPostsCreateInput"],
	update?: GraphQLTypes["BlogPostUpdateTagsRelationInput"],
	upsert?: GraphQLTypes["BlogPostUpsertTagsRelationInput"],
	connect?: GraphQLTypes["BodyTagUniqueWhere"],
	disconnect?: GraphQLTypes["BodyTagUniqueWhere"],
	delete?: GraphQLTypes["BodyTagUniqueWhere"],
	alias?: string
};
	["BlogPostUpdateTagsRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	data: GraphQLTypes["BodyTagWithoutBlogPostsUpdateInput"]
};
	["BodyTagWithoutBlogPostsUpdateInput"]: {
		name?: string,
	positiveProducts?: Array<GraphQLTypes["BodyTagUpdatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagUpdateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagUpdatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagUpdateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagUpdateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagUpdateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagUpdateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagUpdatePositiveProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutPositiveForBodyTagsCreateInput"],
	update?: GraphQLTypes["BodyTagUpdatePositiveProductsRelationInput"],
	upsert?: GraphQLTypes["BodyTagUpsertPositiveProductsRelationInput"],
	connect?: GraphQLTypes["ProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductUniqueWhere"],
	delete?: GraphQLTypes["ProductUniqueWhere"],
	alias?: string
};
	["BodyTagUpdatePositiveProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	data: GraphQLTypes["ProductWithoutPositiveForBodyTagsUpdateInput"]
};
	["ProductWithoutPositiveForBodyTagsUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdateNutritionalValuesEntityRelationInput"]: {
		create?: GraphQLTypes["NutritionalValueOfProductWithoutProductCreateInput"],
	update?: GraphQLTypes["ProductUpdateNutritionalValuesRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertNutritionalValuesRelationInput"],
	connect?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	disconnect?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	delete?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	alias?: string
};
	["ProductUpdateNutritionalValuesRelationInput"]: {
		by: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	data: GraphQLTypes["NutritionalValueOfProductWithoutProductUpdateInput"]
};
	["NutritionalValueOfProductWithoutProductUpdateInput"]: {
		order?: number,
	amount?: number,
	remoteId?: string,
	nutritionalValue?: GraphQLTypes["NutritionalValueOfProductUpdateNutritionalValueEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NutritionalValueOfProductUpdateNutritionalValueEntityRelationInput"]: {
		connect?: GraphQLTypes["NutritionalValueUniqueWhere"],
	create?: GraphQLTypes["NutritionalValueWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["NutritionalValueOfProductConnectOrCreateNutritionalValueRelationInput"],
	update?: GraphQLTypes["NutritionalValueWithoutProductsUpdateInput"],
	upsert?: GraphQLTypes["NutritionalValueOfProductUpsertNutritionalValueRelationInput"],
	delete?: boolean
};
	["NutritionalValueWithoutProductsUpdateInput"]: {
		name?: string,
	suitabilityNutritionalValues?: Array<GraphQLTypes["NutritionalValueUpdateSuitabilityNutritionalValuesEntityRelationInput"]>,
	remoteId?: string,
	icon?: GraphQLTypes["NutritionalValueUpdateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NutritionalValueUpdateSuitabilityNutritionalValuesEntityRelationInput"]: {
		create?: GraphQLTypes["SuitabilityItemWithoutNutritionalValueCreateInput"],
	update?: GraphQLTypes["NutritionalValueUpdateSuitabilityNutritionalValuesRelationInput"],
	upsert?: GraphQLTypes["NutritionalValueUpsertSuitabilityNutritionalValuesRelationInput"],
	connect?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	disconnect?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	delete?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	alias?: string
};
	["NutritionalValueUpdateSuitabilityNutritionalValuesRelationInput"]: {
		by: GraphQLTypes["SuitabilityItemUniqueWhere"],
	data: GraphQLTypes["SuitabilityItemWithoutNutritionalValueUpdateInput"]
};
	["SuitabilityItemWithoutNutritionalValueUpdateInput"]: {
		min?: number,
	max?: number,
	remoteId?: string,
	order?: number,
	element?: GraphQLTypes["SuitabilityItemUpdateElementEntityRelationInput"],
	category?: GraphQLTypes["SuitabilityItemUpdateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SuitabilityItemUpdateElementEntityRelationInput"]: {
		connect?: GraphQLTypes["ElementUniqueWhere"],
	create?: GraphQLTypes["ElementWithoutSuitabilityElementsCreateInput"],
	connectOrCreate?: GraphQLTypes["SuitabilityItemConnectOrCreateElementRelationInput"],
	update?: GraphQLTypes["ElementWithoutSuitabilityElementsUpdateInput"],
	upsert?: GraphQLTypes["SuitabilityItemUpsertElementRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ElementWithoutSuitabilityElementsUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["ElementUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ElementUpdateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	unit?: string,
	filterOrder?: number,
	slug?: string,
	declensionSeventh?: string,
	_dummy_field_?: boolean
};
	["ElementUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ElementOfProductWithoutElementCreateInput"],
	update?: GraphQLTypes["ElementUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["ElementUpsertProductsRelationInput"],
	connect?: GraphQLTypes["ElementOfProductUniqueWhere"],
	disconnect?: GraphQLTypes["ElementOfProductUniqueWhere"],
	delete?: GraphQLTypes["ElementOfProductUniqueWhere"],
	alias?: string
};
	["ElementUpdateProductsRelationInput"]: {
		by: GraphQLTypes["ElementOfProductUniqueWhere"],
	data: GraphQLTypes["ElementOfProductWithoutElementUpdateInput"]
};
	["ElementOfProductWithoutElementUpdateInput"]: {
		order?: number,
	amount?: number,
	product?: GraphQLTypes["ElementOfProductUpdateProductEntityRelationInput"],
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ElementOfProductUpdateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutElementsCreateInput"],
	connectOrCreate?: GraphQLTypes["ElementOfProductConnectOrCreateProductRelationInput"],
	update?: GraphQLTypes["ProductWithoutElementsUpdateInput"],
	upsert?: GraphQLTypes["ElementOfProductUpsertProductRelationInput"],
	delete?: boolean
};
	["ProductWithoutElementsUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdatePositiveForBodyTagsEntityRelationInput"]: {
		create?: GraphQLTypes["BodyTagWithoutPositiveProductsCreateInput"],
	update?: GraphQLTypes["ProductUpdatePositiveForBodyTagsRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertPositiveForBodyTagsRelationInput"],
	connect?: GraphQLTypes["BodyTagUniqueWhere"],
	disconnect?: GraphQLTypes["BodyTagUniqueWhere"],
	delete?: GraphQLTypes["BodyTagUniqueWhere"],
	alias?: string
};
	["ProductUpdatePositiveForBodyTagsRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	data: GraphQLTypes["BodyTagWithoutPositiveProductsUpdateInput"]
};
	["BodyTagWithoutPositiveProductsUpdateInput"]: {
		name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagUpdateBlogPostsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagUpdateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagUpdatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagUpdateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagUpdateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagUpdateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagUpdateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagUpdateNegativeProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutNegativeForBodyTagsCreateInput"],
	update?: GraphQLTypes["BodyTagUpdateNegativeProductsRelationInput"],
	upsert?: GraphQLTypes["BodyTagUpsertNegativeProductsRelationInput"],
	connect?: GraphQLTypes["ProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductUniqueWhere"],
	delete?: GraphQLTypes["ProductUniqueWhere"],
	alias?: string
};
	["BodyTagUpdateNegativeProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	data: GraphQLTypes["ProductWithoutNegativeForBodyTagsUpdateInput"]
};
	["ProductWithoutNegativeForBodyTagsUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdateReviewsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductReviewWithoutProductCreateInput"],
	update?: GraphQLTypes["ProductUpdateReviewsRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertReviewsRelationInput"],
	connect?: GraphQLTypes["ProductReviewUniqueWhere"],
	disconnect?: GraphQLTypes["ProductReviewUniqueWhere"],
	delete?: GraphQLTypes["ProductReviewUniqueWhere"],
	alias?: string
};
	["ProductUpdateReviewsRelationInput"]: {
		by: GraphQLTypes["ProductReviewUniqueWhere"],
	data: GraphQLTypes["ProductReviewWithoutProductUpdateInput"]
};
	["ProductReviewWithoutProductUpdateInput"]: {
		text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions?: Array<GraphQLTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"]>,
	score?: GraphQLTypes["ProductReviewUpdateScoreEntityRelationInput"],
	user?: GraphQLTypes["ProductReviewUpdateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["ProductReviewUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["ProductReviewUpdateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ProductReviewUpdateProductReviewReactionsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductReviewReactionWithoutProductReviewCreateInput"],
	update?: GraphQLTypes["ProductReviewUpdateProductReviewReactionsRelationInput"],
	upsert?: GraphQLTypes["ProductReviewUpsertProductReviewReactionsRelationInput"],
	connect?: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	disconnect?: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	delete?: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	alias?: string
};
	["ProductReviewUpdateProductReviewReactionsRelationInput"]: {
		by: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	data: GraphQLTypes["ProductReviewReactionWithoutProductReviewUpdateInput"]
};
	["ProductReviewReactionWithoutProductReviewUpdateInput"]: {
		sentiment?: GraphQLTypes["SentimentType"],
	user?: GraphQLTypes["ProductReviewReactionUpdateUserEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductReviewReactionUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutProductReviewReactionsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewReactionConnectOrCreateUserRelationInput"],
	update?: GraphQLTypes["UserWithoutProductReviewReactionsUpdateInput"],
	upsert?: GraphQLTypes["ProductReviewReactionUpsertUserRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["UserWithoutProductReviewReactionsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["UserUpdateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserUpdateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserUpdateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserUpdateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserUpdateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserUpdateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserUpdateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserUpdateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserUpdateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserUpdateProductReviewsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductReviewWithoutUserCreateInput"],
	update?: GraphQLTypes["UserUpdateProductReviewsRelationInput"],
	upsert?: GraphQLTypes["UserUpsertProductReviewsRelationInput"],
	connect?: GraphQLTypes["ProductReviewUniqueWhere"],
	disconnect?: GraphQLTypes["ProductReviewUniqueWhere"],
	delete?: GraphQLTypes["ProductReviewUniqueWhere"],
	alias?: string
};
	["UserUpdateProductReviewsRelationInput"]: {
		by: GraphQLTypes["ProductReviewUniqueWhere"],
	data: GraphQLTypes["ProductReviewWithoutUserUpdateInput"]
};
	["ProductReviewWithoutUserUpdateInput"]: {
		text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions?: Array<GraphQLTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"]>,
	score?: GraphQLTypes["ProductReviewUpdateScoreEntityRelationInput"],
	product?: GraphQLTypes["ProductReviewUpdateProductEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["ProductReviewUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["ProductReviewUpdateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ProductReviewUpdateScoreEntityRelationInput"]: {
		connect?: GraphQLTypes["ScoreUniqueWhere"],
	create?: GraphQLTypes["ScoreWithoutProductReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewConnectOrCreateScoreRelationInput"],
	update?: GraphQLTypes["ScoreWithoutProductReviewsUpdateInput"],
	upsert?: GraphQLTypes["ProductReviewUpsertScoreRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ScoreWithoutProductReviewsUpdateInput"]: {
		label?: string,
	starsAmount?: number,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ProductReviewUpsertScoreRelationInput"]: {
		update: GraphQLTypes["ScoreWithoutProductReviewsUpdateInput"],
	create: GraphQLTypes["ScoreWithoutProductReviewsCreateInput"]
};
	["ProductReviewUpdateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewConnectOrCreateProductRelationInput"],
	update?: GraphQLTypes["ProductWithoutReviewsUpdateInput"],
	upsert?: GraphQLTypes["ProductReviewUpsertProductRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductWithoutReviewsUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdateNegativeForBodyTagsEntityRelationInput"]: {
		create?: GraphQLTypes["BodyTagWithoutNegativeProductsCreateInput"],
	update?: GraphQLTypes["ProductUpdateNegativeForBodyTagsRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertNegativeForBodyTagsRelationInput"],
	connect?: GraphQLTypes["BodyTagUniqueWhere"],
	disconnect?: GraphQLTypes["BodyTagUniqueWhere"],
	delete?: GraphQLTypes["BodyTagUniqueWhere"],
	alias?: string
};
	["ProductUpdateNegativeForBodyTagsRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	data: GraphQLTypes["BodyTagWithoutNegativeProductsUpdateInput"]
};
	["BodyTagWithoutNegativeProductsUpdateInput"]: {
		name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagUpdateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagUpdatePositiveProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagUpdatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagUpdateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagUpdateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagUpdateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagUpdateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagUpdatePositiveItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ItemWithoutPositiveForBodyTagsCreateInput"],
	update?: GraphQLTypes["BodyTagUpdatePositiveItemsRelationInput"],
	upsert?: GraphQLTypes["BodyTagUpsertPositiveItemsRelationInput"],
	connect?: GraphQLTypes["ItemUniqueWhere"],
	disconnect?: GraphQLTypes["ItemUniqueWhere"],
	delete?: GraphQLTypes["ItemUniqueWhere"],
	alias?: string
};
	["BodyTagUpdatePositiveItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	data: GraphQLTypes["ItemWithoutPositiveForBodyTagsUpdateInput"]
};
	["ItemWithoutPositiveForBodyTagsUpdateInput"]: {
		name?: string,
	negativeForBodyTags?: Array<GraphQLTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemUpdateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemUpdateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemUpdateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemUpdateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemUpdateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemUpdateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemUpdateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemUpdateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemUpdateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemUpdateNegativeForBodyTagsEntityRelationInput"]: {
		create?: GraphQLTypes["BodyTagWithoutNegativeItemsCreateInput"],
	update?: GraphQLTypes["ItemUpdateNegativeForBodyTagsRelationInput"],
	upsert?: GraphQLTypes["ItemUpsertNegativeForBodyTagsRelationInput"],
	connect?: GraphQLTypes["BodyTagUniqueWhere"],
	disconnect?: GraphQLTypes["BodyTagUniqueWhere"],
	delete?: GraphQLTypes["BodyTagUniqueWhere"],
	alias?: string
};
	["ItemUpdateNegativeForBodyTagsRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	data: GraphQLTypes["BodyTagWithoutNegativeItemsUpdateInput"]
};
	["BodyTagWithoutNegativeItemsUpdateInput"]: {
		name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagUpdateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagUpdatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagUpdateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagUpdatePositiveItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagUpdateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagUpdateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagUpdateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagUpdateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagCategoryUniqueWhere"],
	create?: GraphQLTypes["BodyTagCategoryWithoutTagsCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagConnectOrCreateCategoryRelationInput"],
	update?: GraphQLTypes["BodyTagCategoryWithoutTagsUpdateInput"],
	upsert?: GraphQLTypes["BodyTagUpsertCategoryRelationInput"],
	delete?: boolean
};
	["BodyTagCategoryWithoutTagsUpdateInput"]: {
		name?: string,
	remoteId?: string,
	color?: GraphQLTypes["BodyTagCategoryUpdateColorEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BodyTagCategoryUpdateColorEntityRelationInput"]: {
		connect?: GraphQLTypes["ColorUniqueWhere"],
	create?: GraphQLTypes["ColorWithoutBodyTagCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagCategoryConnectOrCreateColorRelationInput"],
	update?: GraphQLTypes["ColorWithoutBodyTagCategoryUpdateInput"],
	upsert?: GraphQLTypes["BodyTagCategoryUpsertColorRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ColorWithoutBodyTagCategoryUpdateInput"]: {
		name?: string,
	colorHex?: string,
	blogPostTag?: GraphQLTypes["ColorUpdateBlogPostTagEntityRelationInput"],
	remoteId?: string,
	itemFlavorCategories?: Array<GraphQLTypes["ColorUpdateItemFlavorCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ColorUpdateBlogPostTagEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostTagUniqueWhere"],
	create?: GraphQLTypes["BlogPostTagWithoutColorCreateInput"],
	connectOrCreate?: GraphQLTypes["ColorConnectOrCreateBlogPostTagRelationInput"],
	update?: GraphQLTypes["BlogPostTagWithoutColorUpdateInput"],
	upsert?: GraphQLTypes["ColorUpsertBlogPostTagRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPostTagWithoutColorUpdateInput"]: {
		name?: string,
	blogPosts?: Array<GraphQLTypes["BlogPostTagUpdateBlogPostsEntityRelationInput"]>,
	remoteId?: string,
	order?: number,
	_dummy_field_?: boolean
};
	["BlogPostTagUpdateBlogPostsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostWithoutBlogPostTagsCreateInput"],
	update?: GraphQLTypes["BlogPostTagUpdateBlogPostsRelationInput"],
	upsert?: GraphQLTypes["BlogPostTagUpsertBlogPostsRelationInput"],
	connect?: GraphQLTypes["BlogPostUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostUniqueWhere"],
	delete?: GraphQLTypes["BlogPostUniqueWhere"],
	alias?: string
};
	["BlogPostTagUpdateBlogPostsRelationInput"]: {
		by: GraphQLTypes["BlogPostUniqueWhere"],
	data: GraphQLTypes["BlogPostWithoutBlogPostTagsUpdateInput"]
};
	["BlogPostWithoutBlogPostTagsUpdateInput"]: {
		author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	tags?: Array<GraphQLTypes["BlogPostUpdateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostUpdateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostUpdateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostUpdateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostUpdateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostUpdateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostUpdateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostUpdateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostUpdateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostUpdateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostUpdateItemCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ItemCategoryWithoutBlogPostsCreateInput"],
	update?: GraphQLTypes["BlogPostUpdateItemCategoriesRelationInput"],
	upsert?: GraphQLTypes["BlogPostUpsertItemCategoriesRelationInput"],
	connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	delete?: GraphQLTypes["ItemCategoryUniqueWhere"],
	alias?: string
};
	["BlogPostUpdateItemCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemCategoryUniqueWhere"],
	data: GraphQLTypes["ItemCategoryWithoutBlogPostsUpdateInput"]
};
	["ItemCategoryWithoutBlogPostsUpdateInput"]: {
		name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryUpdateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryUpdateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryUpdateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryUpdateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryUpdateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryUpdateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryUpdateSubCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ItemSubCategoryWithoutCategoryCreateInput"],
	update?: GraphQLTypes["ItemCategoryUpdateSubCategoriesRelationInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertSubCategoriesRelationInput"],
	connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	delete?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	alias?: string
};
	["ItemCategoryUpdateSubCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	data: GraphQLTypes["ItemSubCategoryWithoutCategoryUpdateInput"]
};
	["ItemSubCategoryWithoutCategoryUpdateInput"]: {
		name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryUpdateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	flavorCategory?: GraphQLTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryUpdateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryUpdateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ItemWithoutSubCategoriesCreateInput"],
	update?: GraphQLTypes["ItemSubCategoryUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ItemSubCategoryUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ItemUniqueWhere"],
	disconnect?: GraphQLTypes["ItemUniqueWhere"],
	delete?: GraphQLTypes["ItemUniqueWhere"],
	alias?: string
};
	["ItemSubCategoryUpdateItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	data: GraphQLTypes["ItemWithoutSubCategoriesUpdateInput"]
};
	["ItemWithoutSubCategoriesUpdateInput"]: {
		name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemUpdateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemUpdateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemUpdateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemUpdateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemUpdateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemUpdateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemUpdateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemUpdateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemUpdatePositiveForBodyTagsEntityRelationInput"]: {
		create?: GraphQLTypes["BodyTagWithoutPositiveItemsCreateInput"],
	update?: GraphQLTypes["ItemUpdatePositiveForBodyTagsRelationInput"],
	upsert?: GraphQLTypes["ItemUpsertPositiveForBodyTagsRelationInput"],
	connect?: GraphQLTypes["BodyTagUniqueWhere"],
	disconnect?: GraphQLTypes["BodyTagUniqueWhere"],
	delete?: GraphQLTypes["BodyTagUniqueWhere"],
	alias?: string
};
	["ItemUpdatePositiveForBodyTagsRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	data: GraphQLTypes["BodyTagWithoutPositiveItemsUpdateInput"]
};
	["BodyTagWithoutPositiveItemsUpdateInput"]: {
		name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagUpdateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagUpdatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagUpdateNegativeProductsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagUpdateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagUpdateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagUpdateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagUpdateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagUpdateNegativeItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ItemWithoutNegativeForBodyTagsCreateInput"],
	update?: GraphQLTypes["BodyTagUpdateNegativeItemsRelationInput"],
	upsert?: GraphQLTypes["BodyTagUpsertNegativeItemsRelationInput"],
	connect?: GraphQLTypes["ItemUniqueWhere"],
	disconnect?: GraphQLTypes["ItemUniqueWhere"],
	delete?: GraphQLTypes["ItemUniqueWhere"],
	alias?: string
};
	["BodyTagUpdateNegativeItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	data: GraphQLTypes["ItemWithoutNegativeForBodyTagsUpdateInput"]
};
	["ItemWithoutNegativeForBodyTagsUpdateInput"]: {
		name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemUpdateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemUpdateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemUpdateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemUpdateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemUpdateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemUpdateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemUpdateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemUpdateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemUpdateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemUpdateSubCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ItemSubCategoryWithoutItemsCreateInput"],
	update?: GraphQLTypes["ItemUpdateSubCategoriesRelationInput"],
	upsert?: GraphQLTypes["ItemUpsertSubCategoriesRelationInput"],
	connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	delete?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	alias?: string
};
	["ItemUpdateSubCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	data: GraphQLTypes["ItemSubCategoryWithoutItemsUpdateInput"]
};
	["ItemSubCategoryWithoutItemsUpdateInput"]: {
		name?: string,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryUpdateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryUpdateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutItemSubCategoriesCreateInput"],
	update?: GraphQLTypes["ItemSubCategoryUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["ItemSubCategoryUpsertProductsRelationInput"],
	connect?: GraphQLTypes["ProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductUniqueWhere"],
	delete?: GraphQLTypes["ProductUniqueWhere"],
	alias?: string
};
	["ItemSubCategoryUpdateProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	data: GraphQLTypes["ProductWithoutItemSubCategoriesUpdateInput"]
};
	["ProductWithoutItemSubCategoriesUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdateDogsEntityRelationInput"]: {
		create?: GraphQLTypes["DogWithoutFedProductCreateInput"],
	update?: GraphQLTypes["ProductUpdateDogsRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertDogsRelationInput"],
	connect?: GraphQLTypes["DogUniqueWhere"],
	disconnect?: GraphQLTypes["DogUniqueWhere"],
	delete?: GraphQLTypes["DogUniqueWhere"],
	alias?: string
};
	["ProductUpdateDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	data: GraphQLTypes["DogWithoutFedProductUpdateInput"]
};
	["DogWithoutFedProductUpdateInput"]: {
		gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogUpdateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogUpdateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogUpdateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogUpdateActivityEntityRelationInput"],
	reproduction?: GraphQLTypes["DogUpdateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogUpdateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogUpdateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogUpdateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogUpdateAgeEntityRelationInput"]: {
		connect?: GraphQLTypes["AgeUniqueWhere"],
	create?: GraphQLTypes["AgeWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateAgeRelationInput"],
	update?: GraphQLTypes["AgeWithoutDogsUpdateInput"],
	upsert?: GraphQLTypes["DogUpsertAgeRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["AgeWithoutDogsUpdateInput"]: {
		breeds?: Array<GraphQLTypes["AgeUpdateBreedsEntityRelationInput"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	suitabilityCategories?: Array<GraphQLTypes["AgeUpdateSuitabilityCategoriesEntityRelationInput"]>,
	remoteId?: string,
	productReviews?: Array<GraphQLTypes["AgeUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["AgeUpdateBlogPostReviewsEntityRelationInput"]>,
	label?: string,
	categoryOrder?: string,
	_dummy_field_?: boolean
};
	["AgeUpdateBreedsEntityRelationInput"]: {
		create?: GraphQLTypes["BreedWithoutAgesCreateInput"],
	update?: GraphQLTypes["AgeUpdateBreedsRelationInput"],
	upsert?: GraphQLTypes["AgeUpsertBreedsRelationInput"],
	connect?: GraphQLTypes["BreedUniqueWhere"],
	disconnect?: GraphQLTypes["BreedUniqueWhere"],
	delete?: GraphQLTypes["BreedUniqueWhere"],
	alias?: string
};
	["AgeUpdateBreedsRelationInput"]: {
		by: GraphQLTypes["BreedUniqueWhere"],
	data: GraphQLTypes["BreedWithoutAgesUpdateInput"]
};
	["BreedWithoutAgesUpdateInput"]: {
		dogs?: Array<GraphQLTypes["BreedUpdateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedUpdateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedUpdateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedUpdateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedUpdateDogsEntityRelationInput"]: {
		create?: GraphQLTypes["DogWithoutBreedCreateInput"],
	update?: GraphQLTypes["BreedUpdateDogsRelationInput"],
	upsert?: GraphQLTypes["BreedUpsertDogsRelationInput"],
	connect?: GraphQLTypes["DogUniqueWhere"],
	disconnect?: GraphQLTypes["DogUniqueWhere"],
	delete?: GraphQLTypes["DogUniqueWhere"],
	alias?: string
};
	["BreedUpdateDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	data: GraphQLTypes["DogWithoutBreedUpdateInput"]
};
	["DogWithoutBreedUpdateInput"]: {
		gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	age?: GraphQLTypes["DogUpdateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogUpdateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogUpdateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogUpdateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogUpdateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogUpdateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogUpdateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogUpdateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogUpdateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogUpdateActivityEntityRelationInput"]: {
		connect?: GraphQLTypes["DogActivityUniqueWhere"],
	create?: GraphQLTypes["DogActivityWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateActivityRelationInput"],
	update?: GraphQLTypes["DogActivityWithoutDogsUpdateInput"],
	upsert?: GraphQLTypes["DogUpsertActivityRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["DogActivityWithoutDogsUpdateInput"]: {
		label?: string,
	products?: Array<GraphQLTypes["DogActivityUpdateProductsEntityRelationInput"]>,
	dailyEnergyRequirementCoeficient?: number,
	remoteId?: string,
	suitabilityCategory?: GraphQLTypes["DogActivityUpdateSuitabilityCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogActivityUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutRecommendedActivityCreateInput"],
	update?: GraphQLTypes["DogActivityUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["DogActivityUpsertProductsRelationInput"],
	connect?: GraphQLTypes["ProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductUniqueWhere"],
	delete?: GraphQLTypes["ProductUniqueWhere"],
	alias?: string
};
	["DogActivityUpdateProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	data: GraphQLTypes["ProductWithoutRecommendedActivityUpdateInput"]
};
	["ProductWithoutRecommendedActivityUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdatePackagingsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductPackageWithoutProductCreateInput"],
	update?: GraphQLTypes["ProductUpdatePackagingsRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertPackagingsRelationInput"],
	connect?: GraphQLTypes["ProductPackageUniqueWhere"],
	disconnect?: GraphQLTypes["ProductPackageUniqueWhere"],
	delete?: GraphQLTypes["ProductPackageUniqueWhere"],
	alias?: string
};
	["ProductUpdatePackagingsRelationInput"]: {
		by: GraphQLTypes["ProductPackageUniqueWhere"],
	data: GraphQLTypes["ProductPackageWithoutProductUpdateInput"]
};
	["ProductPackageWithoutProductUpdateInput"]: {
		price?: number,
	order?: number,
	link?: string,
	amount?: number,
	externalId?: string,
	remoteId?: string,
	label?: string,
	positionId?: string,
	heurekaPrice?: number,
	heurekaLink?: string,
	_dummy_field_?: boolean
};
	["ProductUpsertPackagingsRelationInput"]: {
		by: GraphQLTypes["ProductPackageUniqueWhere"],
	update: GraphQLTypes["ProductPackageWithoutProductUpdateInput"],
	create: GraphQLTypes["ProductPackageWithoutProductCreateInput"]
};
	["ProductUpdateItemSubCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ItemSubCategoryWithoutProductsCreateInput"],
	update?: GraphQLTypes["ProductUpdateItemSubCategoriesRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertItemSubCategoriesRelationInput"],
	connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	delete?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	alias?: string
};
	["ProductUpdateItemSubCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	data: GraphQLTypes["ItemSubCategoryWithoutProductsUpdateInput"]
};
	["ItemSubCategoryWithoutProductsUpdateInput"]: {
		name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryUpdateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryUpdateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryUpdateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductFeatureWithoutDependentSubCategoryCreateInput"],
	update?: GraphQLTypes["ItemSubCategoryUpdateFeatureDependenciesRelationInput"],
	upsert?: GraphQLTypes["ItemSubCategoryUpsertFeatureDependenciesRelationInput"],
	connect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	disconnect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	delete?: GraphQLTypes["ProductFeatureUniqueWhere"],
	alias?: string
};
	["ItemSubCategoryUpdateFeatureDependenciesRelationInput"]: {
		by: GraphQLTypes["ProductFeatureUniqueWhere"],
	data: GraphQLTypes["ProductFeatureWithoutDependentSubCategoryUpdateInput"]
};
	["ProductFeatureWithoutDependentSubCategoryUpdateInput"]: {
		text?: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId?: string,
	linkItem?: GraphQLTypes["ProductFeatureUpdateLinkItemEntityRelationInput"],
	dependentElement?: GraphQLTypes["ProductFeatureUpdateDependentElementEntityRelationInput"],
	dependentCategory?: GraphQLTypes["ProductFeatureUpdateDependentCategoryEntityRelationInput"],
	dependentFlag?: GraphQLTypes["ProductFeatureUpdateDependentFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFeatureUpdateLinkItemEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemWithoutFeaturesOfProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFeatureConnectOrCreateLinkItemRelationInput"],
	update?: GraphQLTypes["ItemWithoutFeaturesOfProductUpdateInput"],
	upsert?: GraphQLTypes["ProductFeatureUpsertLinkItemRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemWithoutFeaturesOfProductUpdateInput"]: {
		name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemUpdateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemUpdateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	remoteId?: string,
	image?: GraphQLTypes["ItemUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemUpdateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemUpdateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemUpdateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemUpdateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemUpdateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemUpdateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemUpdateCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ItemCategoryWithoutItemsCreateInput"],
	update?: GraphQLTypes["ItemUpdateCategoriesRelationInput"],
	upsert?: GraphQLTypes["ItemUpsertCategoriesRelationInput"],
	connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	delete?: GraphQLTypes["ItemCategoryUniqueWhere"],
	alias?: string
};
	["ItemUpdateCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemCategoryUniqueWhere"],
	data: GraphQLTypes["ItemCategoryWithoutItemsUpdateInput"]
};
	["ItemCategoryWithoutItemsUpdateInput"]: {
		name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryUpdateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryUpdateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryUpdateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryUpdateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryUpdateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryUpdateBlogPostsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostWithoutItemCategoriesCreateInput"],
	update?: GraphQLTypes["ItemCategoryUpdateBlogPostsRelationInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertBlogPostsRelationInput"],
	connect?: GraphQLTypes["BlogPostUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostUniqueWhere"],
	delete?: GraphQLTypes["BlogPostUniqueWhere"],
	alias?: string
};
	["ItemCategoryUpdateBlogPostsRelationInput"]: {
		by: GraphQLTypes["BlogPostUniqueWhere"],
	data: GraphQLTypes["BlogPostWithoutItemCategoriesUpdateInput"]
};
	["BlogPostWithoutItemCategoriesUpdateInput"]: {
		author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostUpdateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostUpdateReviewsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostUpdateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostUpdateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostUpdateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostUpdateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostUpdateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostUpdateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostUpdateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ItemWithoutBlogPostCreateInput"],
	update?: GraphQLTypes["BlogPostUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["BlogPostUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ItemUniqueWhere"],
	disconnect?: GraphQLTypes["ItemUniqueWhere"],
	delete?: GraphQLTypes["ItemUniqueWhere"],
	alias?: string
};
	["BlogPostUpdateItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	data: GraphQLTypes["ItemWithoutBlogPostUpdateInput"]
};
	["ItemWithoutBlogPostUpdateInput"]: {
		name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemUpdateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemUpdateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemUpdateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemUpdateReferenceListEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemUpdateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemUpdateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemUpdateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemUpdateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemUpdateFeaturesOfProductEntityRelationInput"]: {
		create?: GraphQLTypes["ProductFeatureWithoutLinkItemCreateInput"],
	update?: GraphQLTypes["ItemUpdateFeaturesOfProductRelationInput"],
	upsert?: GraphQLTypes["ItemUpsertFeaturesOfProductRelationInput"],
	connect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	disconnect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	delete?: GraphQLTypes["ProductFeatureUniqueWhere"],
	alias?: string
};
	["ItemUpdateFeaturesOfProductRelationInput"]: {
		by: GraphQLTypes["ProductFeatureUniqueWhere"],
	data: GraphQLTypes["ProductFeatureWithoutLinkItemUpdateInput"]
};
	["ProductFeatureWithoutLinkItemUpdateInput"]: {
		text?: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId?: string,
	dependentElement?: GraphQLTypes["ProductFeatureUpdateDependentElementEntityRelationInput"],
	dependentCategory?: GraphQLTypes["ProductFeatureUpdateDependentCategoryEntityRelationInput"],
	dependentSubCategory?: GraphQLTypes["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"],
	dependentFlag?: GraphQLTypes["ProductFeatureUpdateDependentFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFeatureUpdateDependentElementEntityRelationInput"]: {
		connect?: GraphQLTypes["ElementUniqueWhere"],
	create?: GraphQLTypes["ElementWithoutFeatureDependenciesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFeatureConnectOrCreateDependentElementRelationInput"],
	update?: GraphQLTypes["ElementWithoutFeatureDependenciesUpdateInput"],
	upsert?: GraphQLTypes["ProductFeatureUpsertDependentElementRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ElementWithoutFeatureDependenciesUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["ElementUpdateProductsEntityRelationInput"]>,
	suitabilityElements?: Array<GraphQLTypes["ElementUpdateSuitabilityElementsEntityRelationInput"]>,
	remoteId?: string,
	unit?: string,
	filterOrder?: number,
	slug?: string,
	declensionSeventh?: string,
	_dummy_field_?: boolean
};
	["ElementUpdateSuitabilityElementsEntityRelationInput"]: {
		create?: GraphQLTypes["SuitabilityItemWithoutElementCreateInput"],
	update?: GraphQLTypes["ElementUpdateSuitabilityElementsRelationInput"],
	upsert?: GraphQLTypes["ElementUpsertSuitabilityElementsRelationInput"],
	connect?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	disconnect?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	delete?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	alias?: string
};
	["ElementUpdateSuitabilityElementsRelationInput"]: {
		by: GraphQLTypes["SuitabilityItemUniqueWhere"],
	data: GraphQLTypes["SuitabilityItemWithoutElementUpdateInput"]
};
	["SuitabilityItemWithoutElementUpdateInput"]: {
		min?: number,
	max?: number,
	remoteId?: string,
	order?: number,
	nutritionalValue?: GraphQLTypes["SuitabilityItemUpdateNutritionalValueEntityRelationInput"],
	category?: GraphQLTypes["SuitabilityItemUpdateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SuitabilityItemUpdateNutritionalValueEntityRelationInput"]: {
		connect?: GraphQLTypes["NutritionalValueUniqueWhere"],
	create?: GraphQLTypes["NutritionalValueWithoutSuitabilityNutritionalValuesCreateInput"],
	connectOrCreate?: GraphQLTypes["SuitabilityItemConnectOrCreateNutritionalValueRelationInput"],
	update?: GraphQLTypes["NutritionalValueWithoutSuitabilityNutritionalValuesUpdateInput"],
	upsert?: GraphQLTypes["SuitabilityItemUpsertNutritionalValueRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["NutritionalValueWithoutSuitabilityNutritionalValuesUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["NutritionalValueUpdateProductsEntityRelationInput"]>,
	remoteId?: string,
	icon?: GraphQLTypes["NutritionalValueUpdateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NutritionalValueUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["NutritionalValueOfProductWithoutNutritionalValueCreateInput"],
	update?: GraphQLTypes["NutritionalValueUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["NutritionalValueUpsertProductsRelationInput"],
	connect?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	disconnect?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	delete?: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	alias?: string
};
	["NutritionalValueUpdateProductsRelationInput"]: {
		by: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	data: GraphQLTypes["NutritionalValueOfProductWithoutNutritionalValueUpdateInput"]
};
	["NutritionalValueOfProductWithoutNutritionalValueUpdateInput"]: {
		order?: number,
	product?: GraphQLTypes["NutritionalValueOfProductUpdateProductEntityRelationInput"],
	amount?: number,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["NutritionalValueOfProductUpdateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutNutritionalValuesCreateInput"],
	connectOrCreate?: GraphQLTypes["NutritionalValueOfProductConnectOrCreateProductRelationInput"],
	update?: GraphQLTypes["ProductWithoutNutritionalValuesUpdateInput"],
	upsert?: GraphQLTypes["NutritionalValueOfProductUpsertProductRelationInput"],
	delete?: boolean
};
	["ProductWithoutNutritionalValuesUpdateInput"]: {
		name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdateItemCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ItemCategoryWithoutProductsCreateInput"],
	update?: GraphQLTypes["ProductUpdateItemCategoriesRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertItemCategoriesRelationInput"],
	connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	delete?: GraphQLTypes["ItemCategoryUniqueWhere"],
	alias?: string
};
	["ProductUpdateItemCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemCategoryUniqueWhere"],
	data: GraphQLTypes["ItemCategoryWithoutProductsUpdateInput"]
};
	["ItemCategoryWithoutProductsUpdateInput"]: {
		name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryUpdateItemsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryUpdateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryUpdateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryUpdateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryUpdateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryUpdateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ItemWithoutCategoriesCreateInput"],
	update?: GraphQLTypes["ItemCategoryUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ItemUniqueWhere"],
	disconnect?: GraphQLTypes["ItemUniqueWhere"],
	delete?: GraphQLTypes["ItemUniqueWhere"],
	alias?: string
};
	["ItemCategoryUpdateItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	data: GraphQLTypes["ItemWithoutCategoriesUpdateInput"]
};
	["ItemWithoutCategoriesUpdateInput"]: {
		name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemUpdateSubCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemUpdateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemUpdateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemUpdateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemUpdateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemUpdateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemUpdateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemUpdateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateImageRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ItemUpsertImageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ItemUpdateReferenceListEntityRelationInput"]: {
		connect?: GraphQLTypes["ReferenceListUniqueWhere"],
	create?: GraphQLTypes["ReferenceListCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateReferenceListRelationInput"],
	update?: GraphQLTypes["ReferenceListUpdateInput"],
	upsert?: GraphQLTypes["ItemUpsertReferenceListRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ReferenceListUpdateInput"]: {
		references?: Array<GraphQLTypes["ReferenceListUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ReferenceListUpdateReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ReferenceWithoutListCreateInput"],
	update?: GraphQLTypes["ReferenceListUpdateReferencesRelationInput"],
	upsert?: GraphQLTypes["ReferenceListUpsertReferencesRelationInput"],
	connect?: GraphQLTypes["ReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["ReferenceUniqueWhere"],
	delete?: GraphQLTypes["ReferenceUniqueWhere"],
	alias?: string
};
	["ReferenceListUpdateReferencesRelationInput"]: {
		by: GraphQLTypes["ReferenceUniqueWhere"],
	data: GraphQLTypes["ReferenceWithoutListUpdateInput"]
};
	["ReferenceWithoutListUpdateInput"]: {
		text?: string,
	link?: string,
	order?: number,
	_dummy_field_?: boolean
};
	["ReferenceListUpsertReferencesRelationInput"]: {
		by: GraphQLTypes["ReferenceUniqueWhere"],
	update: GraphQLTypes["ReferenceWithoutListUpdateInput"],
	create: GraphQLTypes["ReferenceWithoutListCreateInput"]
};
	["ItemUpsertReferenceListRelationInput"]: {
		update: GraphQLTypes["ReferenceListUpdateInput"],
	create: GraphQLTypes["ReferenceListCreateInput"]
};
	["ItemUpdateBlogPostEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateBlogPostRelationInput"],
	update?: GraphQLTypes["BlogPostWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ItemUpsertBlogPostRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPostWithoutItemsUpdateInput"]: {
		author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostUpdateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostUpdateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostUpdateItemCategoriesEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostUpdateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostUpdateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostUpdateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostUpdateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostUpdateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostUpdateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateImageRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["BlogPostUpsertImageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPostUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["BlogPostUpdateReferenceListEntityRelationInput"]: {
		connect?: GraphQLTypes["ReferenceListUniqueWhere"],
	create?: GraphQLTypes["ReferenceListCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateReferenceListRelationInput"],
	update?: GraphQLTypes["ReferenceListUpdateInput"],
	upsert?: GraphQLTypes["BlogPostUpsertReferenceListRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPostUpsertReferenceListRelationInput"]: {
		update: GraphQLTypes["ReferenceListUpdateInput"],
	create: GraphQLTypes["ReferenceListCreateInput"]
};
	["BlogPostUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutBlogPostsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateUserRelationInput"],
	update?: GraphQLTypes["UserWithoutBlogPostsUpdateInput"],
	upsert?: GraphQLTypes["BlogPostUpsertUserRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["UserWithoutBlogPostsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["UserUpdateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserUpdateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserUpdateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserUpdateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserUpdateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserUpdateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserUpdateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserUpdateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserUpdateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserUpdateBlogPostReviewReactionsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostReviewReactionWithoutUserCreateInput"],
	update?: GraphQLTypes["UserUpdateBlogPostReviewReactionsRelationInput"],
	upsert?: GraphQLTypes["UserUpsertBlogPostReviewReactionsRelationInput"],
	connect?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	delete?: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	alias?: string
};
	["UserUpdateBlogPostReviewReactionsRelationInput"]: {
		by: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	data: GraphQLTypes["BlogPostReviewReactionWithoutUserUpdateInput"]
};
	["BlogPostReviewReactionWithoutUserUpdateInput"]: {
		sentiment?: GraphQLTypes["SentimentType"],
	blogPostReview?: GraphQLTypes["BlogPostReviewReactionUpdateBlogPostReviewEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostReviewReactionUpdateBlogPostReviewEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	create?: GraphQLTypes["BlogPostReviewWithoutBlogPostReviewReactionsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewReactionConnectOrCreateBlogPostReviewRelationInput"],
	update?: GraphQLTypes["BlogPostReviewWithoutBlogPostReviewReactionsUpdateInput"],
	upsert?: GraphQLTypes["BlogPostReviewReactionUpsertBlogPostReviewRelationInput"],
	delete?: boolean
};
	["BlogPostReviewWithoutBlogPostReviewReactionsUpdateInput"]: {
		title?: string,
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPost?: GraphQLTypes["BlogPostReviewUpdateBlogPostEntityRelationInput"],
	user?: GraphQLTypes["BlogPostReviewUpdateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["BlogPostReviewUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["BlogPostReviewUpdateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["BlogPostReviewUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutBlogPostReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewConnectOrCreateUserRelationInput"],
	update?: GraphQLTypes["UserWithoutBlogPostReviewsUpdateInput"],
	upsert?: GraphQLTypes["BlogPostReviewUpsertUserRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["UserWithoutBlogPostReviewsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["UserUpdateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserUpdateVeterinaryEntityRelationInput"],
	email?: string,
	productReviews?: Array<GraphQLTypes["UserUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserUpdateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserUpdateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserUpdateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserUpdateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserUpdateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserUpdateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserUpdateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserUpdateProductReviewReactionsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductReviewReactionWithoutUserCreateInput"],
	update?: GraphQLTypes["UserUpdateProductReviewReactionsRelationInput"],
	upsert?: GraphQLTypes["UserUpsertProductReviewReactionsRelationInput"],
	connect?: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	disconnect?: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	delete?: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	alias?: string
};
	["UserUpdateProductReviewReactionsRelationInput"]: {
		by: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	data: GraphQLTypes["ProductReviewReactionWithoutUserUpdateInput"]
};
	["ProductReviewReactionWithoutUserUpdateInput"]: {
		sentiment?: GraphQLTypes["SentimentType"],
	productReview?: GraphQLTypes["ProductReviewReactionUpdateProductReviewEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductReviewReactionUpdateProductReviewEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductReviewUniqueWhere"],
	create?: GraphQLTypes["ProductReviewWithoutProductReviewReactionsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewReactionConnectOrCreateProductReviewRelationInput"],
	update?: GraphQLTypes["ProductReviewWithoutProductReviewReactionsUpdateInput"],
	upsert?: GraphQLTypes["ProductReviewReactionUpsertProductReviewRelationInput"],
	delete?: boolean
};
	["ProductReviewWithoutProductReviewReactionsUpdateInput"]: {
		text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	score?: GraphQLTypes["ProductReviewUpdateScoreEntityRelationInput"],
	product?: GraphQLTypes["ProductReviewUpdateProductEntityRelationInput"],
	user?: GraphQLTypes["ProductReviewUpdateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["ProductReviewUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["ProductReviewUpdateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ProductReviewUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutProductReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewConnectOrCreateUserRelationInput"],
	update?: GraphQLTypes["UserWithoutProductReviewsUpdateInput"],
	upsert?: GraphQLTypes["ProductReviewUpsertUserRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["UserWithoutProductReviewsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["UserUpdateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserUpdateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserUpdateBlogPostReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserUpdateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserUpdateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserUpdateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserUpdateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserUpdateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserUpdateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserUpdateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserUpdateBlogPostsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostWithoutUserCreateInput"],
	update?: GraphQLTypes["UserUpdateBlogPostsRelationInput"],
	upsert?: GraphQLTypes["UserUpsertBlogPostsRelationInput"],
	connect?: GraphQLTypes["BlogPostUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostUniqueWhere"],
	delete?: GraphQLTypes["BlogPostUniqueWhere"],
	alias?: string
};
	["UserUpdateBlogPostsRelationInput"]: {
		by: GraphQLTypes["BlogPostUniqueWhere"],
	data: GraphQLTypes["BlogPostWithoutUserUpdateInput"]
};
	["BlogPostWithoutUserUpdateInput"]: {
		author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostUpdateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostUpdateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostUpdateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostUpdateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostUpdateReferenceListEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostUpdateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostUpdateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostUpdateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostUpdateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostUpdateAdsEntityRelationInput"]: {
		create?: GraphQLTypes["AdWithoutBlogPostsCreateInput"],
	update?: GraphQLTypes["BlogPostUpdateAdsRelationInput"],
	upsert?: GraphQLTypes["BlogPostUpsertAdsRelationInput"],
	connect?: GraphQLTypes["AdUniqueWhere"],
	disconnect?: GraphQLTypes["AdUniqueWhere"],
	delete?: GraphQLTypes["AdUniqueWhere"],
	alias?: string
};
	["BlogPostUpdateAdsRelationInput"]: {
		by: GraphQLTypes["AdUniqueWhere"],
	data: GraphQLTypes["AdWithoutBlogPostsUpdateInput"]
};
	["AdWithoutBlogPostsUpdateInput"]: {
		image?: GraphQLTypes["AdUpdateImageEntityRelationInput"],
	isBrandSectionVisible?: boolean,
	isBlogPostSectionVisible?: boolean,
	isIngredientSectionVisible?: boolean,
	isResultsVisible?: boolean,
	isSearchVisible?: boolean,
	itemCategories?: Array<GraphQLTypes["AdUpdateItemCategoriesEntityRelationInput"]>,
	brands?: Array<GraphQLTypes["AdUpdateBrandsEntityRelationInput"]>,
	isActive?: boolean,
	link?: string,
	note?: string,
	activeFrom?: GraphQLTypes["DateTime"],
	activeUntil?: GraphQLTypes["DateTime"],
	slug?: string,
	contentReferences?: Array<GraphQLTypes["AdUpdateContentReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AdUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["AdConnectOrCreateImageRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["AdUpsertImageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["AdUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["AdUpdateItemCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ItemCategoryWithoutAdsCreateInput"],
	update?: GraphQLTypes["AdUpdateItemCategoriesRelationInput"],
	upsert?: GraphQLTypes["AdUpsertItemCategoriesRelationInput"],
	connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	delete?: GraphQLTypes["ItemCategoryUniqueWhere"],
	alias?: string
};
	["AdUpdateItemCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemCategoryUniqueWhere"],
	data: GraphQLTypes["ItemCategoryWithoutAdsUpdateInput"]
};
	["ItemCategoryWithoutAdsUpdateInput"]: {
		name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryUpdateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryUpdateImageEntityRelationInput"],
	comparatorGroupId?: string,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryUpdateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryUpdateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryUpdateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutItemCategoriesCreateInput"],
	update?: GraphQLTypes["ItemCategoryUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertProductsRelationInput"],
	connect?: GraphQLTypes["ProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductUniqueWhere"],
	delete?: GraphQLTypes["ProductUniqueWhere"],
	alias?: string
};
	["ItemCategoryUpdateProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	data: GraphQLTypes["ProductWithoutItemCategoriesUpdateInput"]
};
	["ProductWithoutItemCategoriesUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdateElementsEntityRelationInput"]: {
		create?: GraphQLTypes["ElementOfProductWithoutProductCreateInput"],
	update?: GraphQLTypes["ProductUpdateElementsRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertElementsRelationInput"],
	connect?: GraphQLTypes["ElementOfProductUniqueWhere"],
	disconnect?: GraphQLTypes["ElementOfProductUniqueWhere"],
	delete?: GraphQLTypes["ElementOfProductUniqueWhere"],
	alias?: string
};
	["ProductUpdateElementsRelationInput"]: {
		by: GraphQLTypes["ElementOfProductUniqueWhere"],
	data: GraphQLTypes["ElementOfProductWithoutProductUpdateInput"]
};
	["ElementOfProductWithoutProductUpdateInput"]: {
		order?: number,
	amount?: number,
	remoteId?: string,
	element?: GraphQLTypes["ElementOfProductUpdateElementEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ElementOfProductUpdateElementEntityRelationInput"]: {
		connect?: GraphQLTypes["ElementUniqueWhere"],
	create?: GraphQLTypes["ElementWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ElementOfProductConnectOrCreateElementRelationInput"],
	update?: GraphQLTypes["ElementWithoutProductsUpdateInput"],
	upsert?: GraphQLTypes["ElementOfProductUpsertElementRelationInput"],
	delete?: boolean
};
	["ElementWithoutProductsUpdateInput"]: {
		name?: string,
	featureDependencies?: Array<GraphQLTypes["ElementUpdateFeatureDependenciesEntityRelationInput"]>,
	suitabilityElements?: Array<GraphQLTypes["ElementUpdateSuitabilityElementsEntityRelationInput"]>,
	remoteId?: string,
	unit?: string,
	filterOrder?: number,
	slug?: string,
	declensionSeventh?: string,
	_dummy_field_?: boolean
};
	["ElementUpdateFeatureDependenciesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductFeatureWithoutDependentElementCreateInput"],
	update?: GraphQLTypes["ElementUpdateFeatureDependenciesRelationInput"],
	upsert?: GraphQLTypes["ElementUpsertFeatureDependenciesRelationInput"],
	connect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	disconnect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	delete?: GraphQLTypes["ProductFeatureUniqueWhere"],
	alias?: string
};
	["ElementUpdateFeatureDependenciesRelationInput"]: {
		by: GraphQLTypes["ProductFeatureUniqueWhere"],
	data: GraphQLTypes["ProductFeatureWithoutDependentElementUpdateInput"]
};
	["ProductFeatureWithoutDependentElementUpdateInput"]: {
		text?: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId?: string,
	linkItem?: GraphQLTypes["ProductFeatureUpdateLinkItemEntityRelationInput"],
	dependentCategory?: GraphQLTypes["ProductFeatureUpdateDependentCategoryEntityRelationInput"],
	dependentSubCategory?: GraphQLTypes["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"],
	dependentFlag?: GraphQLTypes["ProductFeatureUpdateDependentFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFeatureUpdateDependentCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutFeatureDependenciesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFeatureConnectOrCreateDependentCategoryRelationInput"],
	update?: GraphQLTypes["ItemCategoryWithoutFeatureDependenciesUpdateInput"],
	upsert?: GraphQLTypes["ProductFeatureUpsertDependentCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemCategoryWithoutFeatureDependenciesUpdateInput"]: {
		name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryUpdateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryUpdateProductsEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryUpdateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryUpdateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryUpdateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryUpdateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryUpdateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateImageRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertImageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemCategoryUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ItemCategoryUpdateAdsEntityRelationInput"]: {
		create?: GraphQLTypes["AdWithoutItemCategoriesCreateInput"],
	update?: GraphQLTypes["ItemCategoryUpdateAdsRelationInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertAdsRelationInput"],
	connect?: GraphQLTypes["AdUniqueWhere"],
	disconnect?: GraphQLTypes["AdUniqueWhere"],
	delete?: GraphQLTypes["AdUniqueWhere"],
	alias?: string
};
	["ItemCategoryUpdateAdsRelationInput"]: {
		by: GraphQLTypes["AdUniqueWhere"],
	data: GraphQLTypes["AdWithoutItemCategoriesUpdateInput"]
};
	["AdWithoutItemCategoriesUpdateInput"]: {
		image?: GraphQLTypes["AdUpdateImageEntityRelationInput"],
	isBrandSectionVisible?: boolean,
	isBlogPostSectionVisible?: boolean,
	isIngredientSectionVisible?: boolean,
	isResultsVisible?: boolean,
	isSearchVisible?: boolean,
	blogPosts?: Array<GraphQLTypes["AdUpdateBlogPostsEntityRelationInput"]>,
	brands?: Array<GraphQLTypes["AdUpdateBrandsEntityRelationInput"]>,
	isActive?: boolean,
	link?: string,
	note?: string,
	activeFrom?: GraphQLTypes["DateTime"],
	activeUntil?: GraphQLTypes["DateTime"],
	slug?: string,
	contentReferences?: Array<GraphQLTypes["AdUpdateContentReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AdUpdateBlogPostsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostWithoutAdsCreateInput"],
	update?: GraphQLTypes["AdUpdateBlogPostsRelationInput"],
	upsert?: GraphQLTypes["AdUpsertBlogPostsRelationInput"],
	connect?: GraphQLTypes["BlogPostUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostUniqueWhere"],
	delete?: GraphQLTypes["BlogPostUniqueWhere"],
	alias?: string
};
	["AdUpdateBlogPostsRelationInput"]: {
		by: GraphQLTypes["BlogPostUniqueWhere"],
	data: GraphQLTypes["BlogPostWithoutAdsUpdateInput"]
};
	["BlogPostWithoutAdsUpdateInput"]: {
		author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostUpdateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostUpdateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostUpdateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostUpdateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostUpdateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostUpdateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostUpdateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	redirects?: Array<GraphQLTypes["BlogPostUpdateRedirectsEntityRelationInput"]>,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostUpdateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["BlogPostUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoUpdateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoUpdateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoUpdateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoUpdateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoUpdateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoUpdateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoUpdateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoUpdateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoUpdateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoUpdateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoUpdateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SeoUpdateBrandsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandsPageUniqueWhere"],
	create?: GraphQLTypes["BrandsPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateBrandsPageRelationInput"],
	update?: GraphQLTypes["BrandsPageWithoutSeoUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertBrandsPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandsPageWithoutSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	redirects?: Array<GraphQLTypes["BrandsPageUpdateRedirectsEntityRelationInput"]>,
	content?: GraphQLTypes["BrandsPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandsPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandsPageUpdateRedirectsEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutBrandsPageCreateInput"],
	update?: GraphQLTypes["BrandsPageUpdateRedirectsRelationInput"],
	upsert?: GraphQLTypes["BrandsPageUpsertRedirectsRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: GraphQLTypes["RedirectUniqueWhere"],
	delete?: GraphQLTypes["RedirectUniqueWhere"],
	alias?: string
};
	["BrandsPageUpdateRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	data: GraphQLTypes["RedirectWithoutBrandsPageUpdateInput"]
};
	["RedirectWithoutBrandsPageUpdateInput"]: {
		to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectUpdateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectUpdateItemCategoryEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectUpdateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectUpdateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectUpdateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectUpdateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectUpdateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateItemCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateItemCategoryRelationInput"],
	update?: GraphQLTypes["ItemCategoryWithoutRedirectsUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertItemCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemCategoryWithoutRedirectsUpdateInput"]: {
		name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryUpdateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryUpdateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryUpdateAdsEntityRelationInput"]>,
	slug?: string,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryUpdateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryUpdateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductFeatureWithoutDependentCategoryCreateInput"],
	update?: GraphQLTypes["ItemCategoryUpdateFeatureDependenciesRelationInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertFeatureDependenciesRelationInput"],
	connect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	disconnect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	delete?: GraphQLTypes["ProductFeatureUniqueWhere"],
	alias?: string
};
	["ItemCategoryUpdateFeatureDependenciesRelationInput"]: {
		by: GraphQLTypes["ProductFeatureUniqueWhere"],
	data: GraphQLTypes["ProductFeatureWithoutDependentCategoryUpdateInput"]
};
	["ProductFeatureWithoutDependentCategoryUpdateInput"]: {
		text?: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId?: string,
	linkItem?: GraphQLTypes["ProductFeatureUpdateLinkItemEntityRelationInput"],
	dependentElement?: GraphQLTypes["ProductFeatureUpdateDependentElementEntityRelationInput"],
	dependentSubCategory?: GraphQLTypes["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"],
	dependentFlag?: GraphQLTypes["ProductFeatureUpdateDependentFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryWithoutFeatureDependenciesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFeatureConnectOrCreateDependentSubCategoryRelationInput"],
	update?: GraphQLTypes["ItemSubCategoryWithoutFeatureDependenciesUpdateInput"],
	upsert?: GraphQLTypes["ProductFeatureUpsertDependentSubCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemSubCategoryWithoutFeatureDependenciesUpdateInput"]: {
		name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryUpdateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryUpdateProductsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryUpdateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryUpdateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryUpdateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutSubCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateCategoryRelationInput"],
	update?: GraphQLTypes["ItemCategoryWithoutSubCategoriesUpdateInput"],
	upsert?: GraphQLTypes["ItemSubCategoryUpsertCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemCategoryWithoutSubCategoriesUpdateInput"]: {
		name?: string,
	shortDescription?: string,
	blogPosts?: Array<GraphQLTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryUpdateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryUpdateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryUpdateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryUpdateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryUpdateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryUpdateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryUpdateRedirectsEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutItemCategoryCreateInput"],
	update?: GraphQLTypes["ItemCategoryUpdateRedirectsRelationInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertRedirectsRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: GraphQLTypes["RedirectUniqueWhere"],
	delete?: GraphQLTypes["RedirectUniqueWhere"],
	alias?: string
};
	["ItemCategoryUpdateRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	data: GraphQLTypes["RedirectWithoutItemCategoryUpdateInput"]
};
	["RedirectWithoutItemCategoryUpdateInput"]: {
		to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectUpdateGenericPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectUpdateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectUpdateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectUpdateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectUpdateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectUpdateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectUpdateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateBrandsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandsPageUniqueWhere"],
	create?: GraphQLTypes["BrandsPageWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateBrandsPageRelationInput"],
	update?: GraphQLTypes["BrandsPageWithoutRedirectsUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertBrandsPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandsPageWithoutRedirectsUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["BrandsPageUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["BrandsPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandsPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandsPageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutBrandsPageCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandsPageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoWithoutBrandsPageUpdateInput"],
	upsert?: GraphQLTypes["BrandsPageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoWithoutBrandsPageUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoUpdateBlogPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoUpdateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoUpdateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoUpdateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoUpdateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoUpdateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoUpdateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoUpdateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoUpdateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoUpdateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SeoUpdateComparatorPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ComparatorPageUniqueWhere"],
	create?: GraphQLTypes["ComparatorPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateComparatorPageRelationInput"],
	update?: GraphQLTypes["ComparatorPageWithoutSeoUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertComparatorPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ComparatorPageWithoutSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	redirects?: Array<GraphQLTypes["ComparatorPageUpdateRedirectsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ComparatorPageUpdateRedirectsEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutComparatorPageCreateInput"],
	update?: GraphQLTypes["ComparatorPageUpdateRedirectsRelationInput"],
	upsert?: GraphQLTypes["ComparatorPageUpsertRedirectsRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: GraphQLTypes["RedirectUniqueWhere"],
	delete?: GraphQLTypes["RedirectUniqueWhere"],
	alias?: string
};
	["ComparatorPageUpdateRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	data: GraphQLTypes["RedirectWithoutComparatorPageUpdateInput"]
};
	["RedirectWithoutComparatorPageUpdateInput"]: {
		to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectUpdateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectUpdateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectUpdateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectUpdateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectUpdateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectUpdateWizardPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectUpdateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateBlogPageEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPageUniqueWhere"],
	create?: GraphQLTypes["BlogPageWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateBlogPageRelationInput"],
	update?: GraphQLTypes["BlogPageWithoutRedirectsUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertBlogPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPageWithoutRedirectsUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["BlogPageUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["BlogPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutBlogPageCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoWithoutBlogPageUpdateInput"],
	upsert?: GraphQLTypes["BlogPageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoWithoutBlogPageUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoUpdateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoUpdateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoUpdateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoUpdateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoUpdateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoUpdateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoUpdateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoUpdateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoUpdateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoUpdateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SeoUpdateGenericPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageUniqueWhere"],
	create?: GraphQLTypes["GenericPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateGenericPageRelationInput"],
	update?: GraphQLTypes["GenericPageWithoutSeoUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertGenericPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["GenericPageWithoutSeoUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["GenericPageUpdateLinkEntityRelationInput"],
	redirects?: Array<GraphQLTypes["GenericPageUpdateRedirectsEntityRelationInput"]>,
	content?: GraphQLTypes["GenericPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["GenericPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GenericPageUpdateRedirectsEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutGenericPageCreateInput"],
	update?: GraphQLTypes["GenericPageUpdateRedirectsRelationInput"],
	upsert?: GraphQLTypes["GenericPageUpsertRedirectsRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: GraphQLTypes["RedirectUniqueWhere"],
	delete?: GraphQLTypes["RedirectUniqueWhere"],
	alias?: string
};
	["GenericPageUpdateRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	data: GraphQLTypes["RedirectWithoutGenericPageUpdateInput"]
};
	["RedirectWithoutGenericPageUpdateInput"]: {
		to?: string,
	order?: number,
	from?: string,
	itemCategory?: GraphQLTypes["RedirectUpdateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectUpdateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectUpdateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectUpdateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectUpdateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectUpdateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectUpdateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateContactPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactPageUniqueWhere"],
	create?: GraphQLTypes["ContactPageWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateContactPageRelationInput"],
	update?: GraphQLTypes["ContactPageWithoutRedirectsUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertContactPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContactPageWithoutRedirectsUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["ContactPageUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["ContactPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ContactPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactPageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutContactPageCreateInput"],
	connectOrCreate?: GraphQLTypes["ContactPageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoWithoutContactPageUpdateInput"],
	upsert?: GraphQLTypes["ContactPageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoWithoutContactPageUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoUpdateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoUpdateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoUpdateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoUpdateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoUpdateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoUpdateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoUpdateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoUpdateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoUpdateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoUpdateWizardPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SeoUpdateHomePageEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageUniqueWhere"],
	create?: GraphQLTypes["HomePageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateHomePageRelationInput"],
	update?: GraphQLTypes["HomePageWithoutSeoUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertHomePageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageWithoutSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	lead?: string,
	_dummy_field_?: boolean
};
	["SeoUpsertHomePageRelationInput"]: {
		update: GraphQLTypes["HomePageWithoutSeoUpdateInput"],
	create: GraphQLTypes["HomePageWithoutSeoCreateInput"]
};
	["SeoUpdateIngredientsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["IngredientsPageUniqueWhere"],
	create?: GraphQLTypes["IngredientsPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateIngredientsPageRelationInput"],
	update?: GraphQLTypes["IngredientsPageWithoutSeoUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertIngredientsPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["IngredientsPageWithoutSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	content?: GraphQLTypes["IngredientsPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["IngredientsPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["IngredientsPageUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["IngredientsPageConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["IngredientsPageUpsertContentRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["IngredientsPageUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["IngredientsPageUpdateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["IngredientsPageConnectOrCreateDraftRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["IngredientsPageUpsertDraftRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["IngredientsPageUpsertDraftRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["SeoUpsertIngredientsPageRelationInput"]: {
		update: GraphQLTypes["IngredientsPageWithoutSeoUpdateInput"],
	create: GraphQLTypes["IngredientsPageWithoutSeoCreateInput"]
};
	["SeoUpdateLoginPageEntityRelationInput"]: {
		connect?: GraphQLTypes["LoginPageUniqueWhere"],
	create?: GraphQLTypes["LoginPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateLoginPageRelationInput"],
	update?: GraphQLTypes["LoginPageWithoutSeoUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertLoginPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["LoginPageWithoutSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["SeoUpsertLoginPageRelationInput"]: {
		update: GraphQLTypes["LoginPageWithoutSeoUpdateInput"],
	create: GraphQLTypes["LoginPageWithoutSeoCreateInput"]
};
	["SeoUpdateRegisterPageEntityRelationInput"]: {
		connect?: GraphQLTypes["RegisterPageUniqueWhere"],
	create?: GraphQLTypes["RegisterPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateRegisterPageRelationInput"],
	update?: GraphQLTypes["RegisterPageWithoutSeoUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertRegisterPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["RegisterPageWithoutSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["SeoUpsertRegisterPageRelationInput"]: {
		update: GraphQLTypes["RegisterPageWithoutSeoUpdateInput"],
	create: GraphQLTypes["RegisterPageWithoutSeoCreateInput"]
};
	["SeoUpdateSearchPageEntityRelationInput"]: {
		connect?: GraphQLTypes["SearchPageUniqueWhere"],
	create?: GraphQLTypes["SearchPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateSearchPageRelationInput"],
	update?: GraphQLTypes["SearchPageWithoutSeoUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertSearchPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SearchPageWithoutSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["SeoUpsertSearchPageRelationInput"]: {
		update: GraphQLTypes["SearchPageWithoutSeoUpdateInput"],
	create: GraphQLTypes["SearchPageWithoutSeoCreateInput"]
};
	["SeoUpdateWizardPageEntityRelationInput"]: {
		connect?: GraphQLTypes["WizardPageUniqueWhere"],
	create?: GraphQLTypes["WizardPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateWizardPageRelationInput"],
	update?: GraphQLTypes["WizardPageWithoutSeoUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertWizardPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["WizardPageWithoutSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	redirects?: Array<GraphQLTypes["WizardPageUpdateRedirectsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["WizardPageUpdateRedirectsEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutWizardPageCreateInput"],
	update?: GraphQLTypes["WizardPageUpdateRedirectsRelationInput"],
	upsert?: GraphQLTypes["WizardPageUpsertRedirectsRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: GraphQLTypes["RedirectUniqueWhere"],
	delete?: GraphQLTypes["RedirectUniqueWhere"],
	alias?: string
};
	["WizardPageUpdateRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	data: GraphQLTypes["RedirectWithoutWizardPageUpdateInput"]
};
	["RedirectWithoutWizardPageUpdateInput"]: {
		to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectUpdateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectUpdateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectUpdateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectUpdateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectUpdateContactPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectUpdateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectUpdateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateComparatorPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ComparatorPageUniqueWhere"],
	create?: GraphQLTypes["ComparatorPageWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateComparatorPageRelationInput"],
	update?: GraphQLTypes["ComparatorPageWithoutRedirectsUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertComparatorPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ComparatorPageWithoutRedirectsUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["ComparatorPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ComparatorPageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutComparatorPageCreateInput"],
	connectOrCreate?: GraphQLTypes["ComparatorPageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoWithoutComparatorPageUpdateInput"],
	upsert?: GraphQLTypes["ComparatorPageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoWithoutComparatorPageUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoUpdateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoUpdateBrandsPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoUpdateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoUpdateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoUpdateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoUpdateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoUpdateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoUpdateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoUpdateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoUpdateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SeoUpdateContactPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactPageUniqueWhere"],
	create?: GraphQLTypes["ContactPageWithoutSeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoConnectOrCreateContactPageRelationInput"],
	update?: GraphQLTypes["ContactPageWithoutSeoUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertContactPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContactPageWithoutSeoUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	redirects?: Array<GraphQLTypes["ContactPageUpdateRedirectsEntityRelationInput"]>,
	content?: GraphQLTypes["ContactPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ContactPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactPageUpdateRedirectsEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutContactPageCreateInput"],
	update?: GraphQLTypes["ContactPageUpdateRedirectsRelationInput"],
	upsert?: GraphQLTypes["ContactPageUpsertRedirectsRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: GraphQLTypes["RedirectUniqueWhere"],
	delete?: GraphQLTypes["RedirectUniqueWhere"],
	alias?: string
};
	["ContactPageUpdateRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	data: GraphQLTypes["RedirectWithoutContactPageUpdateInput"]
};
	["RedirectWithoutContactPageUpdateInput"]: {
		to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectUpdateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectUpdateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectUpdateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectUpdateBlogPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectUpdateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectUpdateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectUpdateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateWizardPageEntityRelationInput"]: {
		connect?: GraphQLTypes["WizardPageUniqueWhere"],
	create?: GraphQLTypes["WizardPageWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateWizardPageRelationInput"],
	update?: GraphQLTypes["WizardPageWithoutRedirectsUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertWizardPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["WizardPageWithoutRedirectsUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["WizardPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["WizardPageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutWizardPageCreateInput"],
	connectOrCreate?: GraphQLTypes["WizardPageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoWithoutWizardPageUpdateInput"],
	upsert?: GraphQLTypes["WizardPageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoWithoutWizardPageUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoUpdateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoUpdateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoUpdateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoUpdateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoUpdateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoUpdateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoUpdateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoUpdateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoUpdateSearchPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoUpdateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["WizardPageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoWithoutWizardPageUpdateInput"],
	create: GraphQLTypes["SeoWithoutWizardPageCreateInput"]
};
	["RedirectUpsertWizardPageRelationInput"]: {
		update: GraphQLTypes["WizardPageWithoutRedirectsUpdateInput"],
	create: GraphQLTypes["WizardPageWithoutRedirectsCreateInput"]
};
	["RedirectUpdateBlogPostEntityRelationInput"]: {
		connect?: GraphQLTypes["BlogPostUniqueWhere"],
	create?: GraphQLTypes["BlogPostWithoutRedirectsCreateInput"],
	connectOrCreate?: GraphQLTypes["RedirectConnectOrCreateBlogPostRelationInput"],
	update?: GraphQLTypes["BlogPostWithoutRedirectsUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertBlogPostRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPostWithoutRedirectsUpdateInput"]: {
		author?: string,
	readingTime?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostTags?: Array<GraphQLTypes["BlogPostUpdateBlogPostTagsEntityRelationInput"]>,
	tags?: Array<GraphQLTypes["BlogPostUpdateTagsEntityRelationInput"]>,
	title?: string,
	listedOnHomePage?: boolean,
	reviews?: Array<GraphQLTypes["BlogPostUpdateReviewsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["BlogPostUpdateItemCategoriesEntityRelationInput"]>,
	items?: Array<GraphQLTypes["BlogPostUpdateItemsEntityRelationInput"]>,
	image?: GraphQLTypes["BlogPostUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["BlogPostUpdateReferenceListEntityRelationInput"],
	user?: GraphQLTypes["BlogPostUpdateUserEntityRelationInput"],
	isComparatorLinked?: boolean,
	ads?: Array<GraphQLTypes["BlogPostUpdateAdsEntityRelationInput"]>,
	slug?: string,
	lead?: string,
	seo?: GraphQLTypes["BlogPostUpdateSeoEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	note?: string,
	isActive?: boolean,
	automated?: boolean,
	content?: GraphQLTypes["BlogPostUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BlogPostUpdateDraftEntityRelationInput"],
	slugInternal?: string,
	_dummy_field_?: boolean
};
	["BlogPostUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["BlogPostUpsertContentRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPostUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["BlogPostUpdateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostConnectOrCreateDraftRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["BlogPostUpsertDraftRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPostUpsertDraftRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["RedirectUpsertBlogPostRelationInput"]: {
		update: GraphQLTypes["BlogPostWithoutRedirectsUpdateInput"],
	create: GraphQLTypes["BlogPostWithoutRedirectsCreateInput"]
};
	["ContactPageUpsertRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	update: GraphQLTypes["RedirectWithoutContactPageUpdateInput"],
	create: GraphQLTypes["RedirectWithoutContactPageCreateInput"]
};
	["ContactPageUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ContactPageConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ContactPageUpsertContentRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContactPageUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ContactPageUpdateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ContactPageConnectOrCreateDraftRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ContactPageUpsertDraftRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContactPageUpsertDraftRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["SeoUpsertContactPageRelationInput"]: {
		update: GraphQLTypes["ContactPageWithoutSeoUpdateInput"],
	create: GraphQLTypes["ContactPageWithoutSeoCreateInput"]
};
	["ComparatorPageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoWithoutComparatorPageUpdateInput"],
	create: GraphQLTypes["SeoWithoutComparatorPageCreateInput"]
};
	["RedirectUpsertComparatorPageRelationInput"]: {
		update: GraphQLTypes["ComparatorPageWithoutRedirectsUpdateInput"],
	create: GraphQLTypes["ComparatorPageWithoutRedirectsCreateInput"]
};
	["WizardPageUpsertRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	update: GraphQLTypes["RedirectWithoutWizardPageUpdateInput"],
	create: GraphQLTypes["RedirectWithoutWizardPageCreateInput"]
};
	["SeoUpsertWizardPageRelationInput"]: {
		update: GraphQLTypes["WizardPageWithoutSeoUpdateInput"],
	create: GraphQLTypes["WizardPageWithoutSeoCreateInput"]
};
	["ContactPageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoWithoutContactPageUpdateInput"],
	create: GraphQLTypes["SeoWithoutContactPageCreateInput"]
};
	["RedirectUpsertContactPageRelationInput"]: {
		update: GraphQLTypes["ContactPageWithoutRedirectsUpdateInput"],
	create: GraphQLTypes["ContactPageWithoutRedirectsCreateInput"]
};
	["GenericPageUpsertRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	update: GraphQLTypes["RedirectWithoutGenericPageUpdateInput"],
	create: GraphQLTypes["RedirectWithoutGenericPageCreateInput"]
};
	["GenericPageUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["GenericPageUpsertContentRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["GenericPageUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["GenericPageUpdateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["GenericPageConnectOrCreateDraftRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["GenericPageUpsertDraftRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["GenericPageUpsertDraftRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["SeoUpsertGenericPageRelationInput"]: {
		update: GraphQLTypes["GenericPageWithoutSeoUpdateInput"],
	create: GraphQLTypes["GenericPageWithoutSeoCreateInput"]
};
	["BlogPageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoWithoutBlogPageUpdateInput"],
	create: GraphQLTypes["SeoWithoutBlogPageCreateInput"]
};
	["BlogPageUpdateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPageConnectOrCreateDraftRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["BlogPageUpsertDraftRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BlogPageUpsertDraftRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["RedirectUpsertBlogPageRelationInput"]: {
		update: GraphQLTypes["BlogPageWithoutRedirectsUpdateInput"],
	create: GraphQLTypes["BlogPageWithoutRedirectsCreateInput"]
};
	["ComparatorPageUpsertRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	update: GraphQLTypes["RedirectWithoutComparatorPageUpdateInput"],
	create: GraphQLTypes["RedirectWithoutComparatorPageCreateInput"]
};
	["SeoUpsertComparatorPageRelationInput"]: {
		update: GraphQLTypes["ComparatorPageWithoutSeoUpdateInput"],
	create: GraphQLTypes["ComparatorPageWithoutSeoCreateInput"]
};
	["BrandsPageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoWithoutBrandsPageUpdateInput"],
	create: GraphQLTypes["SeoWithoutBrandsPageCreateInput"]
};
	["BrandsPageUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandsPageConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["BrandsPageUpsertContentRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandsPageUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["BrandsPageUpdateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandsPageConnectOrCreateDraftRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["BrandsPageUpsertDraftRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandsPageUpsertDraftRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["RedirectUpsertBrandsPageRelationInput"]: {
		update: GraphQLTypes["BrandsPageWithoutRedirectsUpdateInput"],
	create: GraphQLTypes["BrandsPageWithoutRedirectsCreateInput"]
};
	["ItemCategoryUpsertRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	update: GraphQLTypes["RedirectWithoutItemCategoryUpdateInput"],
	create: GraphQLTypes["RedirectWithoutItemCategoryCreateInput"]
};
	["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"]: {
		create?: GraphQLTypes["ItemDeclensionFourthVariantWithoutCategoryCreateInput"],
	update?: GraphQLTypes["ItemCategoryUpdateDeclensionsFourthRelationInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertDeclensionsFourthRelationInput"],
	connect?: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"],
	disconnect?: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"],
	delete?: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"],
	alias?: string
};
	["ItemCategoryUpdateDeclensionsFourthRelationInput"]: {
		by: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"],
	data: GraphQLTypes["ItemDeclensionFourthVariantWithoutCategoryUpdateInput"]
};
	["ItemDeclensionFourthVariantWithoutCategoryUpdateInput"]: {
		items?: Array<GraphQLTypes["ItemDeclensionFourthVariantUpdateItemsEntityRelationInput"]>,
	label?: string,
	remoteId?: string,
	declensionSeventh?: string,
	isNegativ?: boolean,
	seo?: GraphQLTypes["ItemDeclensionFourthVariantUpdateSeoEntityRelationInput"],
	subcategory?: GraphQLTypes["ItemDeclensionFourthVariantUpdateSubcategoryEntityRelationInput"],
	element?: GraphQLTypes["ItemDeclensionFourthVariantUpdateElementEntityRelationInput"],
	products?: Array<GraphQLTypes["ItemDeclensionFourthVariantUpdateProductsEntityRelationInput"]>,
	slug?: string,
	content?: GraphQLTypes["ItemDeclensionFourthVariantUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemDeclensionFourthVariantUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemDeclensionFourthVariantUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ItemWithoutDeclensionFourthCreateInput"],
	update?: GraphQLTypes["ItemDeclensionFourthVariantUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ItemDeclensionFourthVariantUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ItemUniqueWhere"],
	disconnect?: GraphQLTypes["ItemUniqueWhere"],
	delete?: GraphQLTypes["ItemUniqueWhere"],
	alias?: string
};
	["ItemDeclensionFourthVariantUpdateItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	data: GraphQLTypes["ItemWithoutDeclensionFourthUpdateInput"]
};
	["ItemWithoutDeclensionFourthUpdateInput"]: {
		name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemUpdateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemUpdateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemUpdateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemUpdateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemUpdateBlogPostEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemUpdateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemUpdateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemUpdateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemUpdateDeclensionSeventhEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemDeclensionSeventhVariantUniqueWhere"],
	create?: GraphQLTypes["ItemDeclensionSeventhVariantWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateDeclensionSeventhRelationInput"],
	update?: GraphQLTypes["ItemDeclensionSeventhVariantWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ItemUpsertDeclensionSeventhRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemDeclensionSeventhVariantWithoutItemsUpdateInput"]: {
		label?: string,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ItemUpsertDeclensionSeventhRelationInput"]: {
		update: GraphQLTypes["ItemDeclensionSeventhVariantWithoutItemsUpdateInput"],
	create: GraphQLTypes["ItemDeclensionSeventhVariantWithoutItemsCreateInput"]
};
	["ItemUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ItemUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["ItemUpdateAliasesEntityRelationInput"]: {
		create?: GraphQLTypes["ItemAliasWithoutItemCreateInput"],
	update?: GraphQLTypes["ItemUpdateAliasesRelationInput"],
	upsert?: GraphQLTypes["ItemUpsertAliasesRelationInput"],
	connect?: GraphQLTypes["ItemAliasUniqueWhere"],
	disconnect?: GraphQLTypes["ItemAliasUniqueWhere"],
	delete?: GraphQLTypes["ItemAliasUniqueWhere"],
	alias?: string
};
	["ItemUpdateAliasesRelationInput"]: {
		by: GraphQLTypes["ItemAliasUniqueWhere"],
	data: GraphQLTypes["ItemAliasWithoutItemUpdateInput"]
};
	["ItemAliasWithoutItemUpdateInput"]: {
		remoteId?: string,
	name?: string,
	_dummy_field_?: boolean
};
	["ItemUpsertAliasesRelationInput"]: {
		by: GraphQLTypes["ItemAliasUniqueWhere"],
	update: GraphQLTypes["ItemAliasWithoutItemUpdateInput"],
	create: GraphQLTypes["ItemAliasWithoutItemCreateInput"]
};
	["ItemUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ItemUpsertContentRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ItemUpdateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateDraftRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ItemUpsertDraftRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemUpsertDraftRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ItemDeclensionFourthVariantUpsertItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	update: GraphQLTypes["ItemWithoutDeclensionFourthUpdateInput"],
	create: GraphQLTypes["ItemWithoutDeclensionFourthCreateInput"]
};
	["ItemDeclensionFourthVariantUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ItemDeclensionFourthVariantUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemDeclensionFourthVariantUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["ItemDeclensionFourthVariantUpdateSubcategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateSubcategoryRelationInput"],
	update?: GraphQLTypes["ItemSubCategoryUpdateInput"],
	upsert?: GraphQLTypes["ItemDeclensionFourthVariantUpsertSubcategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemSubCategoryUpdateInput"]: {
		name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryUpdateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryUpdateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryUpdateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemFlavorCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemFlavorCategoryWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateFlavorCategoryRelationInput"],
	update?: GraphQLTypes["ItemFlavorCategoryWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ItemSubCategoryUpsertFlavorCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemFlavorCategoryWithoutItemsUpdateInput"]: {
		name?: string,
	remoteId?: string,
	color?: GraphQLTypes["ItemFlavorCategoryUpdateColorEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemFlavorCategoryUpdateColorEntityRelationInput"]: {
		connect?: GraphQLTypes["ColorUniqueWhere"],
	create?: GraphQLTypes["ColorWithoutItemFlavorCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemFlavorCategoryConnectOrCreateColorRelationInput"],
	update?: GraphQLTypes["ColorWithoutItemFlavorCategoriesUpdateInput"],
	upsert?: GraphQLTypes["ItemFlavorCategoryUpsertColorRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ColorWithoutItemFlavorCategoriesUpdateInput"]: {
		name?: string,
	colorHex?: string,
	bodyTagCategory?: GraphQLTypes["ColorUpdateBodyTagCategoryEntityRelationInput"],
	blogPostTag?: GraphQLTypes["ColorUpdateBlogPostTagEntityRelationInput"],
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ItemFlavorCategoryUpsertColorRelationInput"]: {
		update: GraphQLTypes["ColorWithoutItemFlavorCategoriesUpdateInput"],
	create: GraphQLTypes["ColorWithoutItemFlavorCategoriesCreateInput"]
};
	["ItemSubCategoryUpsertFlavorCategoryRelationInput"]: {
		update: GraphQLTypes["ItemFlavorCategoryWithoutItemsUpdateInput"],
	create: GraphQLTypes["ItemFlavorCategoryWithoutItemsCreateInput"]
};
	["ItemSubCategoryUpdateDogsEntityRelationInput"]: {
		create?: GraphQLTypes["DogWithoutAllergiesCreateInput"],
	update?: GraphQLTypes["ItemSubCategoryUpdateDogsRelationInput"],
	upsert?: GraphQLTypes["ItemSubCategoryUpsertDogsRelationInput"],
	connect?: GraphQLTypes["DogUniqueWhere"],
	disconnect?: GraphQLTypes["DogUniqueWhere"],
	delete?: GraphQLTypes["DogUniqueWhere"],
	alias?: string
};
	["ItemSubCategoryUpdateDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	data: GraphQLTypes["DogWithoutAllergiesUpdateInput"]
};
	["DogWithoutAllergiesUpdateInput"]: {
		gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogUpdateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogUpdateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogUpdateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogUpdateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogUpdateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogUpdateReproductionEntityRelationInput"],
	illnesses?: Array<GraphQLTypes["DogUpdateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogUpdateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogUpdateFedProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateFedProductRelationInput"],
	update?: GraphQLTypes["ProductWithoutDogsUpdateInput"],
	upsert?: GraphQLTypes["DogUpsertFedProductRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductWithoutDogsUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdateRecommendedDogSizesEntityRelationInput"]: {
		create?: GraphQLTypes["DogSizeWithoutProductsCreateInput"],
	update?: GraphQLTypes["ProductUpdateRecommendedDogSizesRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertRecommendedDogSizesRelationInput"],
	connect?: GraphQLTypes["DogSizeUniqueWhere"],
	disconnect?: GraphQLTypes["DogSizeUniqueWhere"],
	delete?: GraphQLTypes["DogSizeUniqueWhere"],
	alias?: string
};
	["ProductUpdateRecommendedDogSizesRelationInput"]: {
		by: GraphQLTypes["DogSizeUniqueWhere"],
	data: GraphQLTypes["DogSizeWithoutProductsUpdateInput"]
};
	["DogSizeWithoutProductsUpdateInput"]: {
		breeds?: Array<GraphQLTypes["DogSizeUpdateBreedsEntityRelationInput"]>,
	remoteId?: string,
	suitabilityCategory?: GraphQLTypes["DogSizeUpdateSuitabilityCategoryEntityRelationInput"],
	name?: GraphQLTypes["SizeType"],
	label?: string,
	order?: number,
	isFilterVisible?: boolean,
	_dummy_field_?: boolean
};
	["DogSizeUpdateBreedsEntityRelationInput"]: {
		create?: GraphQLTypes["BreedWithoutSizeCreateInput"],
	update?: GraphQLTypes["DogSizeUpdateBreedsRelationInput"],
	upsert?: GraphQLTypes["DogSizeUpsertBreedsRelationInput"],
	connect?: GraphQLTypes["BreedUniqueWhere"],
	disconnect?: GraphQLTypes["BreedUniqueWhere"],
	delete?: GraphQLTypes["BreedUniqueWhere"],
	alias?: string
};
	["DogSizeUpdateBreedsRelationInput"]: {
		by: GraphQLTypes["BreedUniqueWhere"],
	data: GraphQLTypes["BreedWithoutSizeUpdateInput"]
};
	["BreedWithoutSizeUpdateInput"]: {
		dogs?: Array<GraphQLTypes["BreedUpdateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedUpdateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedUpdateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedUpdateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedUpdateSuitabilityCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create?: GraphQLTypes["SuitabilityCategoryWithoutBreedsCreateInput"],
	connectOrCreate?: GraphQLTypes["BreedConnectOrCreateSuitabilityCategoryRelationInput"],
	update?: GraphQLTypes["SuitabilityCategoryWithoutBreedsUpdateInput"],
	upsert?: GraphQLTypes["BreedUpsertSuitabilityCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SuitabilityCategoryWithoutBreedsUpdateInput"]: {
		name?: string,
	dogSizes?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogSizesEntityRelationInput"]>,
	dogActivities?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"]>,
	suitabilityItems?: Array<GraphQLTypes["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"]>,
	dogAges?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogAgesEntityRelationInput"]>,
	isPregnant?: boolean,
	remoteId?: string,
	isBreastfeeding?: boolean,
	_dummy_field_?: boolean
};
	["SuitabilityCategoryUpdateDogSizesEntityRelationInput"]: {
		create?: GraphQLTypes["DogSizeWithoutSuitabilityCategoryCreateInput"],
	update?: GraphQLTypes["SuitabilityCategoryUpdateDogSizesRelationInput"],
	upsert?: GraphQLTypes["SuitabilityCategoryUpsertDogSizesRelationInput"],
	connect?: GraphQLTypes["DogSizeUniqueWhere"],
	disconnect?: GraphQLTypes["DogSizeUniqueWhere"],
	delete?: GraphQLTypes["DogSizeUniqueWhere"],
	alias?: string
};
	["SuitabilityCategoryUpdateDogSizesRelationInput"]: {
		by: GraphQLTypes["DogSizeUniqueWhere"],
	data: GraphQLTypes["DogSizeWithoutSuitabilityCategoryUpdateInput"]
};
	["DogSizeWithoutSuitabilityCategoryUpdateInput"]: {
		breeds?: Array<GraphQLTypes["DogSizeUpdateBreedsEntityRelationInput"]>,
	remoteId?: string,
	products?: Array<GraphQLTypes["DogSizeUpdateProductsEntityRelationInput"]>,
	name?: GraphQLTypes["SizeType"],
	label?: string,
	order?: number,
	isFilterVisible?: boolean,
	_dummy_field_?: boolean
};
	["DogSizeUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutRecommendedDogSizesCreateInput"],
	update?: GraphQLTypes["DogSizeUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["DogSizeUpsertProductsRelationInput"],
	connect?: GraphQLTypes["ProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductUniqueWhere"],
	delete?: GraphQLTypes["ProductUniqueWhere"],
	alias?: string
};
	["DogSizeUpdateProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	data: GraphQLTypes["ProductWithoutRecommendedDogSizesUpdateInput"]
};
	["ProductWithoutRecommendedDogSizesUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdateGranuleSizesEntityRelationInput"]: {
		create?: GraphQLTypes["GranuleSizeWithoutProductsCreateInput"],
	update?: GraphQLTypes["ProductUpdateGranuleSizesRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertGranuleSizesRelationInput"],
	connect?: GraphQLTypes["GranuleSizeUniqueWhere"],
	disconnect?: GraphQLTypes["GranuleSizeUniqueWhere"],
	delete?: GraphQLTypes["GranuleSizeUniqueWhere"],
	alias?: string
};
	["ProductUpdateGranuleSizesRelationInput"]: {
		by: GraphQLTypes["GranuleSizeUniqueWhere"],
	data: GraphQLTypes["GranuleSizeWithoutProductsUpdateInput"]
};
	["GranuleSizeWithoutProductsUpdateInput"]: {
		remoteId?: string,
	name?: GraphQLTypes["GranuleSizeType"],
	_dummy_field_?: boolean
};
	["ProductUpsertGranuleSizesRelationInput"]: {
		by: GraphQLTypes["GranuleSizeUniqueWhere"],
	update: GraphQLTypes["GranuleSizeWithoutProductsUpdateInput"],
	create: GraphQLTypes["GranuleSizeWithoutProductsCreateInput"]
};
	["ProductUpdateProductLineEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductLineUniqueWhere"],
	create?: GraphQLTypes["ProductLineWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateProductLineRelationInput"],
	update?: GraphQLTypes["ProductLineWithoutProductsUpdateInput"],
	upsert?: GraphQLTypes["ProductUpsertProductLineRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductLineWithoutProductsUpdateInput"]: {
		name?: string,
	remoteId?: string,
	lead?: string,
	order?: number,
	brand?: GraphQLTypes["ProductLineUpdateBrandEntityRelationInput"],
	logo?: GraphQLTypes["ProductLineUpdateLogoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ProductLineUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["ProductLineUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["ProductLineUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	_dummy_field_?: boolean
};
	["ProductLineUpdateBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutProductLinesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductLineConnectOrCreateBrandRelationInput"],
	update?: GraphQLTypes["BrandWithoutProductLinesUpdateInput"],
	upsert?: GraphQLTypes["ProductLineUpsertBrandRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandWithoutProductLinesUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["BrandUpdateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandUpdateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	logo?: GraphQLTypes["BrandUpdateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandUpdateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandUpdateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandUpdateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandUpdateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandUpdateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandUpdateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutBrandCreateInput"],
	update?: GraphQLTypes["BrandUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["BrandUpsertProductsRelationInput"],
	connect?: GraphQLTypes["ProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductUniqueWhere"],
	delete?: GraphQLTypes["ProductUniqueWhere"],
	alias?: string
};
	["BrandUpdateProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	data: GraphQLTypes["ProductWithoutBrandUpdateInput"]
};
	["ProductWithoutBrandUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdateFlagsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductFlagOfProductWithoutProductCreateInput"],
	update?: GraphQLTypes["ProductUpdateFlagsRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertFlagsRelationInput"],
	connect?: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	delete?: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	alias?: string
};
	["ProductUpdateFlagsRelationInput"]: {
		by: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	data: GraphQLTypes["ProductFlagOfProductWithoutProductUpdateInput"]
};
	["ProductFlagOfProductWithoutProductUpdateInput"]: {
		remoteId?: string,
	value?: GraphQLTypes["ProductFlagValue"],
	flag?: GraphQLTypes["ProductFlagOfProductUpdateFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFlagOfProductUpdateFlagEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductFlagUniqueWhere"],
	create?: GraphQLTypes["ProductFlagWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFlagOfProductConnectOrCreateFlagRelationInput"],
	update?: GraphQLTypes["ProductFlagWithoutProductsUpdateInput"],
	upsert?: GraphQLTypes["ProductFlagOfProductUpsertFlagRelationInput"],
	delete?: boolean
};
	["ProductFlagWithoutProductsUpdateInput"]: {
		remoteId?: string,
	productFeatures?: Array<GraphQLTypes["ProductFlagUpdateProductFeaturesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductFlagUpdateProductFeaturesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductFeatureWithoutDependentFlagCreateInput"],
	update?: GraphQLTypes["ProductFlagUpdateProductFeaturesRelationInput"],
	upsert?: GraphQLTypes["ProductFlagUpsertProductFeaturesRelationInput"],
	connect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	disconnect?: GraphQLTypes["ProductFeatureUniqueWhere"],
	delete?: GraphQLTypes["ProductFeatureUniqueWhere"],
	alias?: string
};
	["ProductFlagUpdateProductFeaturesRelationInput"]: {
		by: GraphQLTypes["ProductFeatureUniqueWhere"],
	data: GraphQLTypes["ProductFeatureWithoutDependentFlagUpdateInput"]
};
	["ProductFeatureWithoutDependentFlagUpdateInput"]: {
		text?: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId?: string,
	linkItem?: GraphQLTypes["ProductFeatureUpdateLinkItemEntityRelationInput"],
	dependentElement?: GraphQLTypes["ProductFeatureUpdateDependentElementEntityRelationInput"],
	dependentCategory?: GraphQLTypes["ProductFeatureUpdateDependentCategoryEntityRelationInput"],
	dependentSubCategory?: GraphQLTypes["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFlagUpsertProductFeaturesRelationInput"]: {
		by: GraphQLTypes["ProductFeatureUniqueWhere"],
	update: GraphQLTypes["ProductFeatureWithoutDependentFlagUpdateInput"],
	create: GraphQLTypes["ProductFeatureWithoutDependentFlagCreateInput"]
};
	["ProductFlagOfProductUpsertFlagRelationInput"]: {
		update: GraphQLTypes["ProductFlagWithoutProductsUpdateInput"],
	create: GraphQLTypes["ProductFlagWithoutProductsCreateInput"]
};
	["ProductUpsertFlagsRelationInput"]: {
		by: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	update: GraphQLTypes["ProductFlagOfProductWithoutProductUpdateInput"],
	create: GraphQLTypes["ProductFlagOfProductWithoutProductCreateInput"]
};
	["ProductUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateImageRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ProductUpsertImageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ProductUpdateRecommendedActivityEntityRelationInput"]: {
		connect?: GraphQLTypes["DogActivityUniqueWhere"],
	create?: GraphQLTypes["DogActivityWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateRecommendedActivityRelationInput"],
	update?: GraphQLTypes["DogActivityWithoutProductsUpdateInput"],
	upsert?: GraphQLTypes["ProductUpsertRecommendedActivityRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["DogActivityWithoutProductsUpdateInput"]: {
		label?: string,
	dogs?: Array<GraphQLTypes["DogActivityUpdateDogsEntityRelationInput"]>,
	dailyEnergyRequirementCoeficient?: number,
	remoteId?: string,
	suitabilityCategory?: GraphQLTypes["DogActivityUpdateSuitabilityCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogActivityUpdateDogsEntityRelationInput"]: {
		create?: GraphQLTypes["DogWithoutActivityCreateInput"],
	update?: GraphQLTypes["DogActivityUpdateDogsRelationInput"],
	upsert?: GraphQLTypes["DogActivityUpsertDogsRelationInput"],
	connect?: GraphQLTypes["DogUniqueWhere"],
	disconnect?: GraphQLTypes["DogUniqueWhere"],
	delete?: GraphQLTypes["DogUniqueWhere"],
	alias?: string
};
	["DogActivityUpdateDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	data: GraphQLTypes["DogWithoutActivityUpdateInput"]
};
	["DogWithoutActivityUpdateInput"]: {
		gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogUpdateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogUpdateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogUpdateOwnerEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogUpdateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogUpdateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogUpdateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogUpdateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogUpdateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogUpdateReproductionEntityRelationInput"]: {
		connect?: GraphQLTypes["DogReproductionUniqueWhere"],
	create?: GraphQLTypes["DogReproductionWithoutDogCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateReproductionRelationInput"],
	update?: GraphQLTypes["DogReproductionWithoutDogUpdateInput"],
	upsert?: GraphQLTypes["DogUpsertReproductionRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["DogReproductionWithoutDogUpdateInput"]: {
		type?: GraphQLTypes["DogReproductionType"],
	breastfeedingPuppyCount?: number,
	pregnancy?: GraphQLTypes["PregnantPeriodType"],
	breastfeedingCategory?: GraphQLTypes["DogReproductionUpdateBreastfeedingCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogReproductionUpdateBreastfeedingCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["BreastfeedingCategoryUniqueWhere"],
	create?: GraphQLTypes["BreastfeedingCategoryWithoutDogsCreateInput"],
	connectOrCreate?: GraphQLTypes["DogReproductionConnectOrCreateBreastfeedingCategoryRelationInput"],
	update?: GraphQLTypes["BreastfeedingCategoryWithoutDogsUpdateInput"],
	upsert?: GraphQLTypes["DogReproductionUpsertBreastfeedingCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BreastfeedingCategoryWithoutDogsUpdateInput"]: {
		week?: number,
	coeficient?: number,
	_dummy_field_?: boolean
};
	["DogReproductionUpsertBreastfeedingCategoryRelationInput"]: {
		update: GraphQLTypes["BreastfeedingCategoryWithoutDogsUpdateInput"],
	create: GraphQLTypes["BreastfeedingCategoryWithoutDogsCreateInput"]
};
	["DogUpsertReproductionRelationInput"]: {
		update: GraphQLTypes["DogReproductionWithoutDogUpdateInput"],
	create: GraphQLTypes["DogReproductionWithoutDogCreateInput"]
};
	["DogUpdateAllergiesEntityRelationInput"]: {
		create?: GraphQLTypes["ItemSubCategoryWithoutDogsCreateInput"],
	update?: GraphQLTypes["DogUpdateAllergiesRelationInput"],
	upsert?: GraphQLTypes["DogUpsertAllergiesRelationInput"],
	connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	delete?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	alias?: string
};
	["DogUpdateAllergiesRelationInput"]: {
		by: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	data: GraphQLTypes["ItemSubCategoryWithoutDogsUpdateInput"]
};
	["ItemSubCategoryWithoutDogsUpdateInput"]: {
		name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryUpdateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"],
	iconNegative?: GraphQLTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryUpdateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryUpdateIconNegativeEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateIconNegativeRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ItemSubCategoryUpsertIconNegativeRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemSubCategoryUpsertIconNegativeRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ItemSubCategoryUpdateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemSubCategoryConnectOrCreateIconRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ItemSubCategoryUpsertIconRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemSubCategoryUpsertIconRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ItemSubCategoryUpdateBrandsEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandFlavorUniqueWhere"],
	disconnect?: GraphQLTypes["BrandFlavorUniqueWhere"],
	delete?: GraphQLTypes["BrandFlavorUniqueWhere"],
	alias?: string
};
	["ItemSubCategoryUpdateProductLinesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductLineFlavorUniqueWhere"],
	disconnect?: GraphQLTypes["ProductLineFlavorUniqueWhere"],
	delete?: GraphQLTypes["ProductLineFlavorUniqueWhere"],
	alias?: string
};
	["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"]: {
		create?: GraphQLTypes["FilterComboWithoutFlavorCreateInput"],
	update?: GraphQLTypes["ItemSubCategoryUpdateFilterCombosFlavorRelationInput"],
	upsert?: GraphQLTypes["ItemSubCategoryUpsertFilterCombosFlavorRelationInput"],
	connect?: GraphQLTypes["FilterComboUniqueWhere"],
	disconnect?: GraphQLTypes["FilterComboUniqueWhere"],
	delete?: GraphQLTypes["FilterComboUniqueWhere"],
	alias?: string
};
	["ItemSubCategoryUpdateFilterCombosFlavorRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	data: GraphQLTypes["FilterComboWithoutFlavorUpdateInput"]
};
	["FilterComboWithoutFlavorUpdateInput"]: {
		remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboUpdateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboUpdateBreedEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboUpdateBrandEntityRelationInput"],
	region?: GraphQLTypes["FilterComboUpdateRegionEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboUpdateAgeCategoryEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboUpdateTreatmentEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboUpdateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilterComboUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["FilterComboUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["FilterComboUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["FilterComboUpdateBreedEntityRelationInput"]: {
		connect?: GraphQLTypes["BreedUniqueWhere"],
	create?: GraphQLTypes["BreedWithoutFilterCombosCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateBreedRelationInput"],
	update?: GraphQLTypes["BreedWithoutFilterCombosUpdateInput"],
	upsert?: GraphQLTypes["FilterComboUpsertBreedRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BreedWithoutFilterCombosUpdateInput"]: {
		dogs?: Array<GraphQLTypes["BreedUpdateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedUpdateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedUpdateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedUpdateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedUpdateSizeEntityRelationInput"],
	slug?: string,
	_dummy_field_?: boolean
};
	["BreedUpdateProductReviewsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductReviewWithoutBreedCreateInput"],
	update?: GraphQLTypes["BreedUpdateProductReviewsRelationInput"],
	upsert?: GraphQLTypes["BreedUpsertProductReviewsRelationInput"],
	connect?: GraphQLTypes["ProductReviewUniqueWhere"],
	disconnect?: GraphQLTypes["ProductReviewUniqueWhere"],
	delete?: GraphQLTypes["ProductReviewUniqueWhere"],
	alias?: string
};
	["BreedUpdateProductReviewsRelationInput"]: {
		by: GraphQLTypes["ProductReviewUniqueWhere"],
	data: GraphQLTypes["ProductReviewWithoutBreedUpdateInput"]
};
	["ProductReviewWithoutBreedUpdateInput"]: {
		text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions?: Array<GraphQLTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"]>,
	score?: GraphQLTypes["ProductReviewUpdateScoreEntityRelationInput"],
	product?: GraphQLTypes["ProductReviewUpdateProductEntityRelationInput"],
	user?: GraphQLTypes["ProductReviewUpdateUserEntityRelationInput"],
	fullName?: string,
	age?: GraphQLTypes["ProductReviewUpdateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ProductReviewUpdateAgeEntityRelationInput"]: {
		connect?: GraphQLTypes["AgeUniqueWhere"],
	create?: GraphQLTypes["AgeWithoutProductReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewConnectOrCreateAgeRelationInput"],
	update?: GraphQLTypes["AgeWithoutProductReviewsUpdateInput"],
	upsert?: GraphQLTypes["ProductReviewUpsertAgeRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["AgeWithoutProductReviewsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["AgeUpdateDogsEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["AgeUpdateBreedsEntityRelationInput"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	suitabilityCategories?: Array<GraphQLTypes["AgeUpdateSuitabilityCategoriesEntityRelationInput"]>,
	remoteId?: string,
	blogPostReviews?: Array<GraphQLTypes["AgeUpdateBlogPostReviewsEntityRelationInput"]>,
	label?: string,
	categoryOrder?: string,
	_dummy_field_?: boolean
};
	["AgeUpdateSuitabilityCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["SuitabilityCategoryWithoutDogAgesCreateInput"],
	update?: GraphQLTypes["AgeUpdateSuitabilityCategoriesRelationInput"],
	upsert?: GraphQLTypes["AgeUpsertSuitabilityCategoriesRelationInput"],
	connect?: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	delete?: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	alias?: string
};
	["AgeUpdateSuitabilityCategoriesRelationInput"]: {
		by: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	data: GraphQLTypes["SuitabilityCategoryWithoutDogAgesUpdateInput"]
};
	["SuitabilityCategoryWithoutDogAgesUpdateInput"]: {
		name?: string,
	dogSizes?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogSizesEntityRelationInput"]>,
	dogActivities?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["SuitabilityCategoryUpdateBreedsEntityRelationInput"]>,
	suitabilityItems?: Array<GraphQLTypes["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"]>,
	isPregnant?: boolean,
	remoteId?: string,
	isBreastfeeding?: boolean,
	_dummy_field_?: boolean
};
	["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"]: {
		create?: GraphQLTypes["DogActivityWithoutSuitabilityCategoryCreateInput"],
	update?: GraphQLTypes["SuitabilityCategoryUpdateDogActivitiesRelationInput"],
	upsert?: GraphQLTypes["SuitabilityCategoryUpsertDogActivitiesRelationInput"],
	connect?: GraphQLTypes["DogActivityUniqueWhere"],
	disconnect?: GraphQLTypes["DogActivityUniqueWhere"],
	delete?: GraphQLTypes["DogActivityUniqueWhere"],
	alias?: string
};
	["SuitabilityCategoryUpdateDogActivitiesRelationInput"]: {
		by: GraphQLTypes["DogActivityUniqueWhere"],
	data: GraphQLTypes["DogActivityWithoutSuitabilityCategoryUpdateInput"]
};
	["DogActivityWithoutSuitabilityCategoryUpdateInput"]: {
		label?: string,
	dogs?: Array<GraphQLTypes["DogActivityUpdateDogsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["DogActivityUpdateProductsEntityRelationInput"]>,
	dailyEnergyRequirementCoeficient?: number,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["SuitabilityCategoryUpsertDogActivitiesRelationInput"]: {
		by: GraphQLTypes["DogActivityUniqueWhere"],
	update: GraphQLTypes["DogActivityWithoutSuitabilityCategoryUpdateInput"],
	create: GraphQLTypes["DogActivityWithoutSuitabilityCategoryCreateInput"]
};
	["SuitabilityCategoryUpdateBreedsEntityRelationInput"]: {
		create?: GraphQLTypes["BreedWithoutSuitabilityCategoryCreateInput"],
	update?: GraphQLTypes["SuitabilityCategoryUpdateBreedsRelationInput"],
	upsert?: GraphQLTypes["SuitabilityCategoryUpsertBreedsRelationInput"],
	connect?: GraphQLTypes["BreedUniqueWhere"],
	disconnect?: GraphQLTypes["BreedUniqueWhere"],
	delete?: GraphQLTypes["BreedUniqueWhere"],
	alias?: string
};
	["SuitabilityCategoryUpdateBreedsRelationInput"]: {
		by: GraphQLTypes["BreedUniqueWhere"],
	data: GraphQLTypes["BreedWithoutSuitabilityCategoryUpdateInput"]
};
	["BreedWithoutSuitabilityCategoryUpdateInput"]: {
		dogs?: Array<GraphQLTypes["BreedUpdateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedUpdateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedUpdateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	productReviews?: Array<GraphQLTypes["BreedUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedUpdateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedUpdateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedUpdateBlogPostReviewsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostReviewWithoutBreedCreateInput"],
	update?: GraphQLTypes["BreedUpdateBlogPostReviewsRelationInput"],
	upsert?: GraphQLTypes["BreedUpsertBlogPostReviewsRelationInput"],
	connect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	delete?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	alias?: string
};
	["BreedUpdateBlogPostReviewsRelationInput"]: {
		by: GraphQLTypes["BlogPostReviewUniqueWhere"],
	data: GraphQLTypes["BlogPostReviewWithoutBreedUpdateInput"]
};
	["BlogPostReviewWithoutBreedUpdateInput"]: {
		title?: string,
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostReviewReactions?: Array<GraphQLTypes["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	blogPost?: GraphQLTypes["BlogPostReviewUpdateBlogPostEntityRelationInput"],
	user?: GraphQLTypes["BlogPostReviewUpdateUserEntityRelationInput"],
	fullName?: string,
	age?: GraphQLTypes["BlogPostReviewUpdateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["BlogPostReviewUpdateAgeEntityRelationInput"]: {
		connect?: GraphQLTypes["AgeUniqueWhere"],
	create?: GraphQLTypes["AgeWithoutBlogPostReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewConnectOrCreateAgeRelationInput"],
	update?: GraphQLTypes["AgeWithoutBlogPostReviewsUpdateInput"],
	upsert?: GraphQLTypes["BlogPostReviewUpsertAgeRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["AgeWithoutBlogPostReviewsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["AgeUpdateDogsEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["AgeUpdateBreedsEntityRelationInput"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	suitabilityCategories?: Array<GraphQLTypes["AgeUpdateSuitabilityCategoriesEntityRelationInput"]>,
	remoteId?: string,
	productReviews?: Array<GraphQLTypes["AgeUpdateProductReviewsEntityRelationInput"]>,
	label?: string,
	categoryOrder?: string,
	_dummy_field_?: boolean
};
	["AgeUpdateProductReviewsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductReviewWithoutAgeCreateInput"],
	update?: GraphQLTypes["AgeUpdateProductReviewsRelationInput"],
	upsert?: GraphQLTypes["AgeUpsertProductReviewsRelationInput"],
	connect?: GraphQLTypes["ProductReviewUniqueWhere"],
	disconnect?: GraphQLTypes["ProductReviewUniqueWhere"],
	delete?: GraphQLTypes["ProductReviewUniqueWhere"],
	alias?: string
};
	["AgeUpdateProductReviewsRelationInput"]: {
		by: GraphQLTypes["ProductReviewUniqueWhere"],
	data: GraphQLTypes["ProductReviewWithoutAgeUpdateInput"]
};
	["ProductReviewWithoutAgeUpdateInput"]: {
		text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions?: Array<GraphQLTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"]>,
	score?: GraphQLTypes["ProductReviewUpdateScoreEntityRelationInput"],
	product?: GraphQLTypes["ProductReviewUpdateProductEntityRelationInput"],
	user?: GraphQLTypes["ProductReviewUpdateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["ProductReviewUpdateBreedEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ProductReviewUpdateBreedEntityRelationInput"]: {
		connect?: GraphQLTypes["BreedUniqueWhere"],
	create?: GraphQLTypes["BreedWithoutProductReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductReviewConnectOrCreateBreedRelationInput"],
	update?: GraphQLTypes["BreedWithoutProductReviewsUpdateInput"],
	upsert?: GraphQLTypes["ProductReviewUpsertBreedRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BreedWithoutProductReviewsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["BreedUpdateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedUpdateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedUpdateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"],
	blogPostReviews?: Array<GraphQLTypes["BreedUpdateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedUpdateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedUpdateSizeEntityRelationInput"]: {
		connect?: GraphQLTypes["DogSizeUniqueWhere"],
	create?: GraphQLTypes["DogSizeWithoutBreedsCreateInput"],
	connectOrCreate?: GraphQLTypes["BreedConnectOrCreateSizeRelationInput"],
	update?: GraphQLTypes["DogSizeWithoutBreedsUpdateInput"],
	upsert?: GraphQLTypes["BreedUpsertSizeRelationInput"]
};
	["DogSizeWithoutBreedsUpdateInput"]: {
		remoteId?: string,
	products?: Array<GraphQLTypes["DogSizeUpdateProductsEntityRelationInput"]>,
	suitabilityCategory?: GraphQLTypes["DogSizeUpdateSuitabilityCategoryEntityRelationInput"],
	name?: GraphQLTypes["SizeType"],
	label?: string,
	order?: number,
	isFilterVisible?: boolean,
	_dummy_field_?: boolean
};
	["DogSizeUpdateSuitabilityCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create?: GraphQLTypes["SuitabilityCategoryWithoutDogSizesCreateInput"],
	connectOrCreate?: GraphQLTypes["DogSizeConnectOrCreateSuitabilityCategoryRelationInput"],
	update?: GraphQLTypes["SuitabilityCategoryWithoutDogSizesUpdateInput"],
	upsert?: GraphQLTypes["DogSizeUpsertSuitabilityCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SuitabilityCategoryWithoutDogSizesUpdateInput"]: {
		name?: string,
	dogActivities?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["SuitabilityCategoryUpdateBreedsEntityRelationInput"]>,
	suitabilityItems?: Array<GraphQLTypes["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"]>,
	dogAges?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogAgesEntityRelationInput"]>,
	isPregnant?: boolean,
	remoteId?: string,
	isBreastfeeding?: boolean,
	_dummy_field_?: boolean
};
	["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"]: {
		create?: GraphQLTypes["SuitabilityItemWithoutCategoryCreateInput"],
	update?: GraphQLTypes["SuitabilityCategoryUpdateSuitabilityItemsRelationInput"],
	upsert?: GraphQLTypes["SuitabilityCategoryUpsertSuitabilityItemsRelationInput"],
	connect?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	disconnect?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	delete?: GraphQLTypes["SuitabilityItemUniqueWhere"],
	alias?: string
};
	["SuitabilityCategoryUpdateSuitabilityItemsRelationInput"]: {
		by: GraphQLTypes["SuitabilityItemUniqueWhere"],
	data: GraphQLTypes["SuitabilityItemWithoutCategoryUpdateInput"]
};
	["SuitabilityItemWithoutCategoryUpdateInput"]: {
		min?: number,
	max?: number,
	remoteId?: string,
	order?: number,
	element?: GraphQLTypes["SuitabilityItemUpdateElementEntityRelationInput"],
	nutritionalValue?: GraphQLTypes["SuitabilityItemUpdateNutritionalValueEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SuitabilityCategoryUpsertSuitabilityItemsRelationInput"]: {
		by: GraphQLTypes["SuitabilityItemUniqueWhere"],
	update: GraphQLTypes["SuitabilityItemWithoutCategoryUpdateInput"],
	create: GraphQLTypes["SuitabilityItemWithoutCategoryCreateInput"]
};
	["SuitabilityCategoryUpdateDogAgesEntityRelationInput"]: {
		create?: GraphQLTypes["AgeWithoutSuitabilityCategoriesCreateInput"],
	update?: GraphQLTypes["SuitabilityCategoryUpdateDogAgesRelationInput"],
	upsert?: GraphQLTypes["SuitabilityCategoryUpsertDogAgesRelationInput"],
	connect?: GraphQLTypes["AgeUniqueWhere"],
	disconnect?: GraphQLTypes["AgeUniqueWhere"],
	delete?: GraphQLTypes["AgeUniqueWhere"],
	alias?: string
};
	["SuitabilityCategoryUpdateDogAgesRelationInput"]: {
		by: GraphQLTypes["AgeUniqueWhere"],
	data: GraphQLTypes["AgeWithoutSuitabilityCategoriesUpdateInput"]
};
	["AgeWithoutSuitabilityCategoriesUpdateInput"]: {
		dogs?: Array<GraphQLTypes["AgeUpdateDogsEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["AgeUpdateBreedsEntityRelationInput"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	remoteId?: string,
	productReviews?: Array<GraphQLTypes["AgeUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["AgeUpdateBlogPostReviewsEntityRelationInput"]>,
	label?: string,
	categoryOrder?: string,
	_dummy_field_?: boolean
};
	["AgeUpdateBlogPostReviewsEntityRelationInput"]: {
		create?: GraphQLTypes["BlogPostReviewWithoutAgeCreateInput"],
	update?: GraphQLTypes["AgeUpdateBlogPostReviewsRelationInput"],
	upsert?: GraphQLTypes["AgeUpsertBlogPostReviewsRelationInput"],
	connect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	disconnect?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	delete?: GraphQLTypes["BlogPostReviewUniqueWhere"],
	alias?: string
};
	["AgeUpdateBlogPostReviewsRelationInput"]: {
		by: GraphQLTypes["BlogPostReviewUniqueWhere"],
	data: GraphQLTypes["BlogPostReviewWithoutAgeUpdateInput"]
};
	["BlogPostReviewWithoutAgeUpdateInput"]: {
		title?: string,
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostReviewReactions?: Array<GraphQLTypes["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	blogPost?: GraphQLTypes["BlogPostReviewUpdateBlogPostEntityRelationInput"],
	user?: GraphQLTypes["BlogPostReviewUpdateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["BlogPostReviewUpdateBreedEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["BlogPostReviewUpdateBreedEntityRelationInput"]: {
		connect?: GraphQLTypes["BreedUniqueWhere"],
	create?: GraphQLTypes["BreedWithoutBlogPostReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["BlogPostReviewConnectOrCreateBreedRelationInput"],
	update?: GraphQLTypes["BreedWithoutBlogPostReviewsUpdateInput"],
	upsert?: GraphQLTypes["BlogPostReviewUpsertBreedRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BreedWithoutBlogPostReviewsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["BreedUpdateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedUpdateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedUpdateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedUpdateProductReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedUpdateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedUpdateFilterCombosEntityRelationInput"]: {
		create?: GraphQLTypes["FilterComboWithoutBreedCreateInput"],
	update?: GraphQLTypes["BreedUpdateFilterCombosRelationInput"],
	upsert?: GraphQLTypes["BreedUpsertFilterCombosRelationInput"],
	connect?: GraphQLTypes["FilterComboUniqueWhere"],
	disconnect?: GraphQLTypes["FilterComboUniqueWhere"],
	delete?: GraphQLTypes["FilterComboUniqueWhere"],
	alias?: string
};
	["BreedUpdateFilterCombosRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	data: GraphQLTypes["FilterComboWithoutBreedUpdateInput"]
};
	["FilterComboWithoutBreedUpdateInput"]: {
		remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboUpdateSeoEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboUpdateBrandEntityRelationInput"],
	region?: GraphQLTypes["FilterComboUpdateRegionEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboUpdateAgeCategoryEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboUpdateTreatmentEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboUpdateFlavorEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboUpdateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilterComboUpdateBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutFilterCombosCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateBrandRelationInput"],
	update?: GraphQLTypes["BrandWithoutFilterCombosUpdateInput"],
	upsert?: GraphQLTypes["FilterComboUpsertBrandRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandWithoutFilterCombosUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["BrandUpdateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandUpdateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandUpdateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandUpdateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandUpdateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandUpdateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandUpdateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandUpdateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	topx?: Array<GraphQLTypes["BrandUpdateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandUpdateCountriesOfProductionEntityRelationInput"]: {
		create?: GraphQLTypes["CountryWithoutBrandsCreateInput"],
	update?: GraphQLTypes["BrandUpdateCountriesOfProductionRelationInput"],
	upsert?: GraphQLTypes["BrandUpsertCountriesOfProductionRelationInput"],
	connect?: GraphQLTypes["CountryUniqueWhere"],
	disconnect?: GraphQLTypes["CountryUniqueWhere"],
	delete?: GraphQLTypes["CountryUniqueWhere"],
	alias?: string
};
	["BrandUpdateCountriesOfProductionRelationInput"]: {
		by: GraphQLTypes["CountryUniqueWhere"],
	data: GraphQLTypes["CountryWithoutBrandsUpdateInput"]
};
	["CountryWithoutBrandsUpdateInput"]: {
		name?: string,
	manufacturers?: Array<GraphQLTypes["CountryUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	region?: GraphQLTypes["CountryUpdateRegionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["CountryUpdateManufacturersEntityRelationInput"]: {
		create?: GraphQLTypes["BrandManufacturerWithoutResidenceCreateInput"],
	update?: GraphQLTypes["CountryUpdateManufacturersRelationInput"],
	upsert?: GraphQLTypes["CountryUpsertManufacturersRelationInput"],
	connect?: GraphQLTypes["BrandManufacturerUniqueWhere"],
	disconnect?: GraphQLTypes["BrandManufacturerUniqueWhere"],
	delete?: GraphQLTypes["BrandManufacturerUniqueWhere"],
	alias?: string
};
	["CountryUpdateManufacturersRelationInput"]: {
		by: GraphQLTypes["BrandManufacturerUniqueWhere"],
	data: GraphQLTypes["BrandManufacturerWithoutResidenceUpdateInput"]
};
	["BrandManufacturerWithoutResidenceUpdateInput"]: {
		name?: string,
	link?: string,
	brands?: Array<GraphQLTypes["BrandManufacturerUpdateBrandsEntityRelationInput"]>,
	order?: number,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["BrandManufacturerUpdateBrandsEntityRelationInput"]: {
		create?: GraphQLTypes["BrandWithoutManufacturersCreateInput"],
	update?: GraphQLTypes["BrandManufacturerUpdateBrandsRelationInput"],
	upsert?: GraphQLTypes["BrandManufacturerUpsertBrandsRelationInput"],
	connect?: GraphQLTypes["BrandUniqueWhere"],
	disconnect?: GraphQLTypes["BrandUniqueWhere"],
	delete?: GraphQLTypes["BrandUniqueWhere"],
	alias?: string
};
	["BrandManufacturerUpdateBrandsRelationInput"]: {
		by: GraphQLTypes["BrandUniqueWhere"],
	data: GraphQLTypes["BrandWithoutManufacturersUpdateInput"]
};
	["BrandWithoutManufacturersUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["BrandUpdateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandUpdateCountriesOfProductionEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandUpdateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandUpdateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandUpdateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandUpdateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandUpdateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandUpdateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandUpdateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandUpdateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandUpdateProductLinesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductLineWithoutBrandCreateInput"],
	update?: GraphQLTypes["BrandUpdateProductLinesRelationInput"],
	upsert?: GraphQLTypes["BrandUpsertProductLinesRelationInput"],
	connect?: GraphQLTypes["ProductLineUniqueWhere"],
	disconnect?: GraphQLTypes["ProductLineUniqueWhere"],
	delete?: GraphQLTypes["ProductLineUniqueWhere"],
	alias?: string
};
	["BrandUpdateProductLinesRelationInput"]: {
		by: GraphQLTypes["ProductLineUniqueWhere"],
	data: GraphQLTypes["ProductLineWithoutBrandUpdateInput"]
};
	["ProductLineWithoutBrandUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["ProductLineUpdateProductsEntityRelationInput"]>,
	remoteId?: string,
	lead?: string,
	order?: number,
	logo?: GraphQLTypes["ProductLineUpdateLogoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ProductLineUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["ProductLineUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["ProductLineUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	_dummy_field_?: boolean
};
	["ProductLineUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutProductLineCreateInput"],
	update?: GraphQLTypes["ProductLineUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["ProductLineUpsertProductsRelationInput"],
	connect?: GraphQLTypes["ProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductUniqueWhere"],
	delete?: GraphQLTypes["ProductUniqueWhere"],
	alias?: string
};
	["ProductLineUpdateProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	data: GraphQLTypes["ProductWithoutProductLineUpdateInput"]
};
	["ProductWithoutProductLineUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdateBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateBrandRelationInput"],
	update?: GraphQLTypes["BrandWithoutProductsUpdateInput"],
	upsert?: GraphQLTypes["ProductUpsertBrandRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandWithoutProductsUpdateInput"]: {
		name?: string,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandUpdateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandUpdateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandUpdateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandUpdateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandUpdateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandUpdateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandUpdateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandUpdateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandUpdateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandUpdateManufacturersEntityRelationInput"]: {
		create?: GraphQLTypes["BrandManufacturerWithoutBrandsCreateInput"],
	update?: GraphQLTypes["BrandUpdateManufacturersRelationInput"],
	upsert?: GraphQLTypes["BrandUpsertManufacturersRelationInput"],
	connect?: GraphQLTypes["BrandManufacturerUniqueWhere"],
	disconnect?: GraphQLTypes["BrandManufacturerUniqueWhere"],
	delete?: GraphQLTypes["BrandManufacturerUniqueWhere"],
	alias?: string
};
	["BrandUpdateManufacturersRelationInput"]: {
		by: GraphQLTypes["BrandManufacturerUniqueWhere"],
	data: GraphQLTypes["BrandManufacturerWithoutBrandsUpdateInput"]
};
	["BrandManufacturerWithoutBrandsUpdateInput"]: {
		name?: string,
	link?: string,
	order?: number,
	remoteId?: string,
	residence?: GraphQLTypes["BrandManufacturerUpdateResidenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandManufacturerUpdateResidenceEntityRelationInput"]: {
		connect?: GraphQLTypes["CountryUniqueWhere"],
	create?: GraphQLTypes["CountryWithoutManufacturersCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandManufacturerConnectOrCreateResidenceRelationInput"],
	update?: GraphQLTypes["CountryWithoutManufacturersUpdateInput"],
	upsert?: GraphQLTypes["BrandManufacturerUpsertResidenceRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["CountryWithoutManufacturersUpdateInput"]: {
		name?: string,
	brands?: Array<GraphQLTypes["CountryUpdateBrandsEntityRelationInput"]>,
	remoteId?: string,
	region?: GraphQLTypes["CountryUpdateRegionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["CountryUpdateBrandsEntityRelationInput"]: {
		create?: GraphQLTypes["BrandWithoutCountriesOfProductionCreateInput"],
	update?: GraphQLTypes["CountryUpdateBrandsRelationInput"],
	upsert?: GraphQLTypes["CountryUpsertBrandsRelationInput"],
	connect?: GraphQLTypes["BrandUniqueWhere"],
	disconnect?: GraphQLTypes["BrandUniqueWhere"],
	delete?: GraphQLTypes["BrandUniqueWhere"],
	alias?: string
};
	["CountryUpdateBrandsRelationInput"]: {
		by: GraphQLTypes["BrandUniqueWhere"],
	data: GraphQLTypes["BrandWithoutCountriesOfProductionUpdateInput"]
};
	["BrandWithoutCountriesOfProductionUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["BrandUpdateProductsEntityRelationInput"]>,
	link?: string,
	manufacturers?: Array<GraphQLTypes["BrandUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandUpdateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandUpdateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandUpdateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandUpdateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandUpdateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandUpdateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandUpdateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandUpdateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateLogoRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["BrandUpsertLogoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["BrandUpdateMethodOfProductionEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductionMethodUniqueWhere"],
	create?: GraphQLTypes["ProductionMethodWithoutBrandsCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateMethodOfProductionRelationInput"],
	update?: GraphQLTypes["ProductionMethodWithoutBrandsUpdateInput"],
	upsert?: GraphQLTypes["BrandUpsertMethodOfProductionRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductionMethodWithoutBrandsUpdateInput"]: {
		name?: string,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["BrandUpsertMethodOfProductionRelationInput"]: {
		update: GraphQLTypes["ProductionMethodWithoutBrandsUpdateInput"],
	create: GraphQLTypes["ProductionMethodWithoutBrandsCreateInput"]
};
	["BrandUpdateDistributorEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandDistributorUniqueWhere"],
	create?: GraphQLTypes["BrandDistributorWithoutBrandsCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateDistributorRelationInput"],
	update?: GraphQLTypes["BrandDistributorWithoutBrandsUpdateInput"],
	upsert?: GraphQLTypes["BrandUpsertDistributorRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandDistributorWithoutBrandsUpdateInput"]: {
		name?: string,
	link?: string,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["BrandUpsertDistributorRelationInput"]: {
		update: GraphQLTypes["BrandDistributorWithoutBrandsUpdateInput"],
	create: GraphQLTypes["BrandDistributorWithoutBrandsCreateInput"]
};
	["BrandUpdateAliasesEntityRelationInput"]: {
		create?: GraphQLTypes["BrandAliasWithoutBrandCreateInput"],
	update?: GraphQLTypes["BrandUpdateAliasesRelationInput"],
	upsert?: GraphQLTypes["BrandUpsertAliasesRelationInput"],
	connect?: GraphQLTypes["BrandAliasUniqueWhere"],
	disconnect?: GraphQLTypes["BrandAliasUniqueWhere"],
	delete?: GraphQLTypes["BrandAliasUniqueWhere"],
	alias?: string
};
	["BrandUpdateAliasesRelationInput"]: {
		by: GraphQLTypes["BrandAliasUniqueWhere"],
	data: GraphQLTypes["BrandAliasWithoutBrandUpdateInput"]
};
	["BrandAliasWithoutBrandUpdateInput"]: {
		remoteId?: string,
	name?: string,
	_dummy_field_?: boolean
};
	["BrandUpsertAliasesRelationInput"]: {
		by: GraphQLTypes["BrandAliasUniqueWhere"],
	update: GraphQLTypes["BrandAliasWithoutBrandUpdateInput"],
	create: GraphQLTypes["BrandAliasWithoutBrandCreateInput"]
};
	["BrandUpdateAdsEntityRelationInput"]: {
		create?: GraphQLTypes["AdWithoutBrandsCreateInput"],
	update?: GraphQLTypes["BrandUpdateAdsRelationInput"],
	upsert?: GraphQLTypes["BrandUpsertAdsRelationInput"],
	connect?: GraphQLTypes["AdUniqueWhere"],
	disconnect?: GraphQLTypes["AdUniqueWhere"],
	delete?: GraphQLTypes["AdUniqueWhere"],
	alias?: string
};
	["BrandUpdateAdsRelationInput"]: {
		by: GraphQLTypes["AdUniqueWhere"],
	data: GraphQLTypes["AdWithoutBrandsUpdateInput"]
};
	["AdWithoutBrandsUpdateInput"]: {
		image?: GraphQLTypes["AdUpdateImageEntityRelationInput"],
	isBrandSectionVisible?: boolean,
	isBlogPostSectionVisible?: boolean,
	isIngredientSectionVisible?: boolean,
	isResultsVisible?: boolean,
	isSearchVisible?: boolean,
	blogPosts?: Array<GraphQLTypes["AdUpdateBlogPostsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["AdUpdateItemCategoriesEntityRelationInput"]>,
	isActive?: boolean,
	link?: string,
	note?: string,
	activeFrom?: GraphQLTypes["DateTime"],
	activeUntil?: GraphQLTypes["DateTime"],
	slug?: string,
	contentReferences?: Array<GraphQLTypes["AdUpdateContentReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AdUpdateContentReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutAdCreateInput"],
	update?: GraphQLTypes["AdUpdateContentReferencesRelationInput"],
	upsert?: GraphQLTypes["AdUpsertContentReferencesRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"],
	alias?: string
};
	["AdUpdateContentReferencesRelationInput"]: {
		by: GraphQLTypes["ContentReferenceUniqueWhere"],
	data: GraphQLTypes["ContentReferenceWithoutAdUpdateInput"]
};
	["ContentReferenceWithoutAdUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fact?: string,
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	relatedBlogPost?: GraphQLTypes["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceUpdateRelatedBrandEntityRelationInput"],
	relatedProduct?: GraphQLTypes["ContentReferenceUpdateRelatedProductEntityRelationInput"],
	relatedIngredient?: GraphQLTypes["ContentReferenceUpdateRelatedIngredientEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	badge?: string,
	longVersion?: boolean,
	relatedBrandFull?: GraphQLTypes["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"],
	relatedProductFull?: GraphQLTypes["ContentReferenceUpdateRelatedProductFullEntityRelationInput"],
	list?: Array<GraphQLTypes["ContentReferenceUpdateListEntityRelationInput"]>,
	outline?: GraphQLTypes["ContentReferenceUpdateOutlineEntityRelationInput"],
	video?: GraphQLTypes["ContentReferenceUpdateVideoEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	defaultOpen?: boolean,
	badgeColor?: string,
	isMain?: boolean,
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateBlockRelationInput"],
	update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"],
	delete?: boolean
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"],
	automatedContentBlockSlug?: string,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentBlockConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertContentRelationInput"],
	delete?: boolean
};
	["ContentWithoutBlocksUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ContentBlockUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	create: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceUpsertBlockRelationInput"]: {
		update: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	create: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentReferenceUpdateRelatedBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateRelatedBrandRelationInput"],
	update?: GraphQLTypes["BrandUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertRelatedBrandRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["BrandUpdateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandUpdateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandUpdateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandUpdateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandUpdateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandUpdateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandUpdateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandUpdateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandUpdateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandUpdateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandUpdateFlavorsEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandFlavorUniqueWhere"],
	disconnect?: GraphQLTypes["BrandFlavorUniqueWhere"],
	delete?: GraphQLTypes["BrandFlavorUniqueWhere"],
	alias?: string
};
	["BrandUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["BrandUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["BrandUpdateFilterCombosEntityRelationInput"]: {
		create?: GraphQLTypes["FilterComboWithoutBrandCreateInput"],
	update?: GraphQLTypes["BrandUpdateFilterCombosRelationInput"],
	upsert?: GraphQLTypes["BrandUpsertFilterCombosRelationInput"],
	connect?: GraphQLTypes["FilterComboUniqueWhere"],
	disconnect?: GraphQLTypes["FilterComboUniqueWhere"],
	delete?: GraphQLTypes["FilterComboUniqueWhere"],
	alias?: string
};
	["BrandUpdateFilterCombosRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	data: GraphQLTypes["FilterComboWithoutBrandUpdateInput"]
};
	["FilterComboWithoutBrandUpdateInput"]: {
		remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboUpdateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboUpdateBreedEntityRelationInput"],
	region?: GraphQLTypes["FilterComboUpdateRegionEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboUpdateAgeCategoryEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboUpdateTreatmentEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboUpdateFlavorEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboUpdateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilterComboUpdateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"],
	create?: GraphQLTypes["RegionWithoutFilterCombosCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateRegionRelationInput"],
	update?: GraphQLTypes["RegionWithoutFilterCombosUpdateInput"],
	upsert?: GraphQLTypes["FilterComboUpsertRegionRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["RegionWithoutFilterCombosUpdateInput"]: {
		name?: string,
	countries?: Array<GraphQLTypes["RegionUpdateCountriesEntityRelationInput"]>,
	remoteId?: string,
	adjective?: string,
	slug?: string,
	_dummy_field_?: boolean
};
	["RegionUpdateCountriesEntityRelationInput"]: {
		create?: GraphQLTypes["CountryWithoutRegionCreateInput"],
	update?: GraphQLTypes["RegionUpdateCountriesRelationInput"],
	upsert?: GraphQLTypes["RegionUpsertCountriesRelationInput"],
	connect?: GraphQLTypes["CountryUniqueWhere"],
	disconnect?: GraphQLTypes["CountryUniqueWhere"],
	delete?: GraphQLTypes["CountryUniqueWhere"],
	alias?: string
};
	["RegionUpdateCountriesRelationInput"]: {
		by: GraphQLTypes["CountryUniqueWhere"],
	data: GraphQLTypes["CountryWithoutRegionUpdateInput"]
};
	["CountryWithoutRegionUpdateInput"]: {
		name?: string,
	brands?: Array<GraphQLTypes["CountryUpdateBrandsEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["CountryUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["RegionUpsertCountriesRelationInput"]: {
		by: GraphQLTypes["CountryUniqueWhere"],
	update: GraphQLTypes["CountryWithoutRegionUpdateInput"],
	create: GraphQLTypes["CountryWithoutRegionCreateInput"]
};
	["FilterComboUpsertRegionRelationInput"]: {
		update: GraphQLTypes["RegionWithoutFilterCombosUpdateInput"],
	create: GraphQLTypes["RegionWithoutFilterCombosCreateInput"]
};
	["FilterComboUpdateAgeCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["AgeCategoryUniqueWhere"],
	create?: GraphQLTypes["AgeCategoryWithoutFilterCombosCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateAgeCategoryRelationInput"],
	update?: GraphQLTypes["AgeCategoryWithoutFilterCombosUpdateInput"],
	upsert?: GraphQLTypes["FilterComboUpsertAgeCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["AgeCategoryWithoutFilterCombosUpdateInput"]: {
		remoteId?: string,
	order?: number,
	labelFor?: string,
	products?: Array<GraphQLTypes["AgeCategoryUpdateProductsEntityRelationInput"]>,
	slug?: string,
	_dummy_field_?: boolean
};
	["AgeCategoryUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutAgeCategoriesCreateInput"],
	update?: GraphQLTypes["AgeCategoryUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["AgeCategoryUpsertProductsRelationInput"],
	connect?: GraphQLTypes["ProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductUniqueWhere"],
	delete?: GraphQLTypes["ProductUniqueWhere"],
	alias?: string
};
	["AgeCategoryUpdateProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	data: GraphQLTypes["ProductWithoutAgeCategoriesUpdateInput"]
};
	["ProductWithoutAgeCategoriesUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdateAliasesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductAliasWithoutProductCreateInput"],
	update?: GraphQLTypes["ProductUpdateAliasesRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertAliasesRelationInput"],
	connect?: GraphQLTypes["ProductAliasUniqueWhere"],
	disconnect?: GraphQLTypes["ProductAliasUniqueWhere"],
	delete?: GraphQLTypes["ProductAliasUniqueWhere"],
	alias?: string
};
	["ProductUpdateAliasesRelationInput"]: {
		by: GraphQLTypes["ProductAliasUniqueWhere"],
	data: GraphQLTypes["ProductAliasWithoutProductUpdateInput"]
};
	["ProductAliasWithoutProductUpdateInput"]: {
		remoteId?: string,
	name?: string,
	_dummy_field_?: boolean
};
	["ProductUpsertAliasesRelationInput"]: {
		by: GraphQLTypes["ProductAliasUniqueWhere"],
	update: GraphQLTypes["ProductAliasWithoutProductUpdateInput"],
	create: GraphQLTypes["ProductAliasWithoutProductCreateInput"]
};
	["ProductUpdateEvaluationEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductEvaluationUniqueWhere"],
	create?: GraphQLTypes["ProductEvaluationWithoutProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateEvaluationRelationInput"],
	update?: GraphQLTypes["ProductEvaluationWithoutProductUpdateInput"],
	upsert?: GraphQLTypes["ProductUpsertEvaluationRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductEvaluationWithoutProductUpdateInput"]: {
		nazev?: string,
	vetDieta?: string,
	vetDieta1?: string,
	vetDieta2?: string,
	aktivita?: string,
	vek?: string,
	velikostPlemen?: string,
	hmotnostPlemene?: string,
	velikostGranuli?: string,
	velikostGranuliText?: string,
	doporucenaAktivitaDleMe?: string,
	vypocitanaMeVsMeVyrobce?: string,
	vypocitanaMeVsMeVyrobce2?: string,
	masoNaPrvnimMisteText?: string,
	zdrojeZivocisnychBilkovinDle1Vyskytu?: string,
	prichuteSeznam?: string,
	eliminacniDietaTextInterpunkce?: string,
	alergenyZadneNeobsahuje?: string,
	alergenyObsahuje?: string,
	alergenyNejakeNeobsahuje?: string,
	prospesneDruhyInterpunkce?: string,
	nevhodneDruhy?: string,
	kladneUcinkyCeleTelo?: string,
	kladneUcinkyHlava?: string,
	kladneUcinkyHrudnik?: string,
	kladneUcinkyBricho?: string,
	kladneUcinkySpodniCast?: string,
	zaporneUcinkyCeleTelo?: string,
	zaporneUcinkyHlava?: string,
	zaporneUcinkyHrudnik?: string,
	zaporneUcinkyBricho?: string,
	zaporneUcinkySpodniCast?: string,
	dsneuvedeno?: string,
	dsmalo?: string,
	dsprilis?: string,
	dsok?: string,
	d95malo?: string,
	d95prilis?: string,
	d95ok?: string,
	d110malo?: string,
	d110prilis?: string,
	d110ok?: string,
	sdo14reproMalo?: string,
	sdo14reproPrilis?: string,
	sdo14reproOk?: string,
	sdo15malo?: string,
	sdo15prilis?: string,
	sdo15ok?: string,
	s15malo?: string,
	s15prilis?: string,
	s15ok?: string,
	masoAnoNe?: string,
	eliminacniDietaAnoNe?: string,
	alergenyAnoNe?: string,
	plodnostKastraceNadpis?: string,
	plodnostKastraceText?: string,
	remoteId?: string,
	stravitelnostNadpis?: string,
	stravitelnostProcenta?: string,
	stravitelnostSlovne?: string,
	stravitelnostChybiText?: string,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?: string,
	_dummy_field_?: boolean
};
	["ProductUpsertEvaluationRelationInput"]: {
		update: GraphQLTypes["ProductEvaluationWithoutProductUpdateInput"],
	create: GraphQLTypes["ProductEvaluationWithoutProductCreateInput"]
};
	["ProductUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ProductUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"],
	delete?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"],
	alias?: string
};
	["ProductUpdateHeurekaImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductConnectOrCreateHeurekaImageRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ProductUpsertHeurekaImageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductUpsertHeurekaImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ProductUpdateTopxEntityRelationInput"]: {
		create?: GraphQLTypes["TOPXProductWithoutProductCreateInput"],
	update?: GraphQLTypes["ProductUpdateTopxRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertTopxRelationInput"],
	connect?: GraphQLTypes["TOPXProductUniqueWhere"],
	disconnect?: GraphQLTypes["TOPXProductUniqueWhere"],
	delete?: GraphQLTypes["TOPXProductUniqueWhere"],
	alias?: string
};
	["ProductUpdateTopxRelationInput"]: {
		by: GraphQLTypes["TOPXProductUniqueWhere"],
	data: GraphQLTypes["TOPXProductWithoutProductUpdateInput"]
};
	["TOPXProductWithoutProductUpdateInput"]: {
		remoteId?: string,
	order?: number,
	orderType?: GraphQLTypes["TOPXProductOrderType"],
	category?: GraphQLTypes["TOPXProductUpdateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXProductUpdateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["TOPXProductCategoryUniqueWhere"],
	create?: GraphQLTypes["TOPXProductCategoryWithoutProductsCreateInput"],
	connectOrCreate?: GraphQLTypes["TOPXProductConnectOrCreateCategoryRelationInput"],
	update?: GraphQLTypes["TOPXProductCategoryWithoutProductsUpdateInput"],
	upsert?: GraphQLTypes["TOPXProductUpsertCategoryRelationInput"],
	delete?: boolean
};
	["TOPXProductCategoryWithoutProductsUpdateInput"]: {
		remoteId?: string,
	_dummy_field_?: boolean
};
	["TOPXProductUpsertCategoryRelationInput"]: {
		update: GraphQLTypes["TOPXProductCategoryWithoutProductsUpdateInput"],
	create: GraphQLTypes["TOPXProductCategoryWithoutProductsCreateInput"]
};
	["ProductUpsertTopxRelationInput"]: {
		by: GraphQLTypes["TOPXProductUniqueWhere"],
	update: GraphQLTypes["TOPXProductWithoutProductUpdateInput"],
	create: GraphQLTypes["TOPXProductWithoutProductCreateInput"]
};
	["AgeCategoryUpsertProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	update: GraphQLTypes["ProductWithoutAgeCategoriesUpdateInput"],
	create: GraphQLTypes["ProductWithoutAgeCategoriesCreateInput"]
};
	["FilterComboUpsertAgeCategoryRelationInput"]: {
		update: GraphQLTypes["AgeCategoryWithoutFilterCombosUpdateInput"],
	create: GraphQLTypes["AgeCategoryWithoutFilterCombosCreateInput"]
};
	["FilterComboUpdateTreatmentEntityRelationInput"]: {
		connect?: GraphQLTypes["BodyTagUniqueWhere"],
	create?: GraphQLTypes["BodyTagWithoutFilterCombosCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateTreatmentRelationInput"],
	update?: GraphQLTypes["BodyTagWithoutFilterCombosUpdateInput"],
	upsert?: GraphQLTypes["FilterComboUpsertTreatmentRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BodyTagWithoutFilterCombosUpdateInput"]: {
		name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagUpdateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagUpdatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagUpdateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagUpdatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagUpdateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagUpdateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagUpdateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagUpdateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	_dummy_field_?: boolean
};
	["BodyTagUpdateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["BodyTagConnectOrCreateIconRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["BodyTagUpsertIconRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BodyTagUpsertIconRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["BodyTagUpdateDogsEntityRelationInput"]: {
		create?: GraphQLTypes["DogWithoutIllnessesCreateInput"],
	update?: GraphQLTypes["BodyTagUpdateDogsRelationInput"],
	upsert?: GraphQLTypes["BodyTagUpsertDogsRelationInput"],
	connect?: GraphQLTypes["DogUniqueWhere"],
	disconnect?: GraphQLTypes["DogUniqueWhere"],
	delete?: GraphQLTypes["DogUniqueWhere"],
	alias?: string
};
	["BodyTagUpdateDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	data: GraphQLTypes["DogWithoutIllnessesUpdateInput"]
};
	["DogWithoutIllnessesUpdateInput"]: {
		gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogUpdateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogUpdateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogUpdateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogUpdateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogUpdateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogUpdateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogUpdateAllergiesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogUpdateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogUpdateAvatarEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["DogConnectOrCreateAvatarRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["DogUpsertAvatarRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["DogUpsertAvatarRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["BodyTagUpsertDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	update: GraphQLTypes["DogWithoutIllnessesUpdateInput"],
	create: GraphQLTypes["DogWithoutIllnessesCreateInput"]
};
	["FilterComboUpsertTreatmentRelationInput"]: {
		update: GraphQLTypes["BodyTagWithoutFilterCombosUpdateInput"],
	create: GraphQLTypes["BodyTagWithoutFilterCombosCreateInput"]
};
	["FilterComboUpdateFlavorEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryWithoutFilterCombosFlavorCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateFlavorRelationInput"],
	update?: GraphQLTypes["ItemSubCategoryWithoutFilterCombosFlavorUpdateInput"],
	upsert?: GraphQLTypes["FilterComboUpsertFlavorRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemSubCategoryWithoutFilterCombosFlavorUpdateInput"]: {
		name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryUpdateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryUpdateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryUpdateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"]: {
		create?: GraphQLTypes["FilterComboWithoutAllergyCreateInput"],
	update?: GraphQLTypes["ItemSubCategoryUpdateFilterCombosAllergyRelationInput"],
	upsert?: GraphQLTypes["ItemSubCategoryUpsertFilterCombosAllergyRelationInput"],
	connect?: GraphQLTypes["FilterComboUniqueWhere"],
	disconnect?: GraphQLTypes["FilterComboUniqueWhere"],
	delete?: GraphQLTypes["FilterComboUniqueWhere"],
	alias?: string
};
	["ItemSubCategoryUpdateFilterCombosAllergyRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	data: GraphQLTypes["FilterComboWithoutAllergyUpdateInput"]
};
	["FilterComboWithoutAllergyUpdateInput"]: {
		remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboUpdateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboUpdateBreedEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboUpdateBrandEntityRelationInput"],
	region?: GraphQLTypes["FilterComboUpdateRegionEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboUpdateAgeCategoryEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboUpdateTreatmentEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboUpdateFlavorEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemSubCategoryUpsertFilterCombosAllergyRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	update: GraphQLTypes["FilterComboWithoutAllergyUpdateInput"],
	create: GraphQLTypes["FilterComboWithoutAllergyCreateInput"]
};
	["FilterComboUpsertFlavorRelationInput"]: {
		update: GraphQLTypes["ItemSubCategoryWithoutFilterCombosFlavorUpdateInput"],
	create: GraphQLTypes["ItemSubCategoryWithoutFilterCombosFlavorCreateInput"]
};
	["FilterComboUpdateAllergyEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemSubCategoryWithoutFilterCombosAllergyCreateInput"],
	connectOrCreate?: GraphQLTypes["FilterComboConnectOrCreateAllergyRelationInput"],
	update?: GraphQLTypes["ItemSubCategoryWithoutFilterCombosAllergyUpdateInput"],
	upsert?: GraphQLTypes["FilterComboUpsertAllergyRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemSubCategoryWithoutFilterCombosAllergyUpdateInput"]: {
		name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryUpdateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"],
	flavorCategory?: GraphQLTypes["ItemSubCategoryUpdateFlavorCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryUpdateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryUpdateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["FilterComboUpsertAllergyRelationInput"]: {
		update: GraphQLTypes["ItemSubCategoryWithoutFilterCombosAllergyUpdateInput"],
	create: GraphQLTypes["ItemSubCategoryWithoutFilterCombosAllergyCreateInput"]
};
	["BrandUpsertFilterCombosRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	update: GraphQLTypes["FilterComboWithoutBrandUpdateInput"],
	create: GraphQLTypes["FilterComboWithoutBrandCreateInput"]
};
	["BrandUpdateTopxEntityRelationInput"]: {
		create?: GraphQLTypes["TOPXBrandWithoutBrandCreateInput"],
	update?: GraphQLTypes["BrandUpdateTopxRelationInput"],
	upsert?: GraphQLTypes["BrandUpsertTopxRelationInput"],
	connect?: GraphQLTypes["TOPXBrandUniqueWhere"],
	disconnect?: GraphQLTypes["TOPXBrandUniqueWhere"],
	delete?: GraphQLTypes["TOPXBrandUniqueWhere"],
	alias?: string
};
	["BrandUpdateTopxRelationInput"]: {
		by: GraphQLTypes["TOPXBrandUniqueWhere"],
	data: GraphQLTypes["TOPXBrandWithoutBrandUpdateInput"]
};
	["TOPXBrandWithoutBrandUpdateInput"]: {
		remoteId?: string,
	order?: number,
	orderType?: GraphQLTypes["TOPXBrandOrderType"],
	category?: GraphQLTypes["TOPXBrandUpdateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXBrandUpdateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["TOPXBrandCategoryUniqueWhere"],
	create?: GraphQLTypes["TOPXBrandCategoryWithoutBrandsCreateInput"],
	connectOrCreate?: GraphQLTypes["TOPXBrandConnectOrCreateCategoryRelationInput"],
	update?: GraphQLTypes["TOPXBrandCategoryWithoutBrandsUpdateInput"],
	upsert?: GraphQLTypes["TOPXBrandUpsertCategoryRelationInput"],
	delete?: boolean
};
	["TOPXBrandCategoryWithoutBrandsUpdateInput"]: {
		remoteId?: string,
	_dummy_field_?: boolean
};
	["TOPXBrandUpsertCategoryRelationInput"]: {
		update: GraphQLTypes["TOPXBrandCategoryWithoutBrandsUpdateInput"],
	create: GraphQLTypes["TOPXBrandCategoryWithoutBrandsCreateInput"]
};
	["BrandUpsertTopxRelationInput"]: {
		by: GraphQLTypes["TOPXBrandUniqueWhere"],
	update: GraphQLTypes["TOPXBrandWithoutBrandUpdateInput"],
	create: GraphQLTypes["TOPXBrandWithoutBrandCreateInput"]
};
	["BrandUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["BrandUpsertContentRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["BrandUpdateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandConnectOrCreateDraftRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["BrandUpsertDraftRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandUpsertDraftRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ContentReferenceUpsertRelatedBrandRelationInput"]: {
		update: GraphQLTypes["BrandUpdateInput"],
	create: GraphQLTypes["BrandCreateInput"]
};
	["ContentReferenceUpdateRelatedProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateRelatedProductRelationInput"],
	update?: GraphQLTypes["ProductUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertRelatedProductRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductUpdateAgeCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["AgeCategoryWithoutProductsCreateInput"],
	update?: GraphQLTypes["ProductUpdateAgeCategoriesRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertAgeCategoriesRelationInput"],
	connect?: GraphQLTypes["AgeCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["AgeCategoryUniqueWhere"],
	delete?: GraphQLTypes["AgeCategoryUniqueWhere"],
	alias?: string
};
	["ProductUpdateAgeCategoriesRelationInput"]: {
		by: GraphQLTypes["AgeCategoryUniqueWhere"],
	data: GraphQLTypes["AgeCategoryWithoutProductsUpdateInput"]
};
	["AgeCategoryWithoutProductsUpdateInput"]: {
		remoteId?: string,
	order?: number,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["AgeCategoryUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AgeCategoryUpdateFilterCombosEntityRelationInput"]: {
		create?: GraphQLTypes["FilterComboWithoutAgeCategoryCreateInput"],
	update?: GraphQLTypes["AgeCategoryUpdateFilterCombosRelationInput"],
	upsert?: GraphQLTypes["AgeCategoryUpsertFilterCombosRelationInput"],
	connect?: GraphQLTypes["FilterComboUniqueWhere"],
	disconnect?: GraphQLTypes["FilterComboUniqueWhere"],
	delete?: GraphQLTypes["FilterComboUniqueWhere"],
	alias?: string
};
	["AgeCategoryUpdateFilterCombosRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	data: GraphQLTypes["FilterComboWithoutAgeCategoryUpdateInput"]
};
	["FilterComboWithoutAgeCategoryUpdateInput"]: {
		remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboUpdateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboUpdateBreedEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboUpdateBrandEntityRelationInput"],
	region?: GraphQLTypes["FilterComboUpdateRegionEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboUpdateTreatmentEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboUpdateFlavorEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboUpdateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AgeCategoryUpsertFilterCombosRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	update: GraphQLTypes["FilterComboWithoutAgeCategoryUpdateInput"],
	create: GraphQLTypes["FilterComboWithoutAgeCategoryCreateInput"]
};
	["ProductUpsertAgeCategoriesRelationInput"]: {
		by: GraphQLTypes["AgeCategoryUniqueWhere"],
	update: GraphQLTypes["AgeCategoryWithoutProductsUpdateInput"],
	create: GraphQLTypes["AgeCategoryWithoutProductsCreateInput"]
};
	["ContentReferenceUpsertRelatedProductRelationInput"]: {
		update: GraphQLTypes["ProductUpdateInput"],
	create: GraphQLTypes["ProductCreateInput"]
};
	["ContentReferenceUpdateRelatedIngredientEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateRelatedIngredientRelationInput"],
	update?: GraphQLTypes["ItemUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertRelatedIngredientRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemUpdateInput"]: {
		name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemUpdateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemUpdateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemUpdateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemUpdateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemUpdateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemUpdateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemUpdateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemUpdateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemUpdateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemUpdateDeclensionFourthEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"],
	create?: GraphQLTypes["ItemDeclensionFourthVariantWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemConnectOrCreateDeclensionFourthRelationInput"],
	update?: GraphQLTypes["ItemDeclensionFourthVariantWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ItemUpsertDeclensionFourthRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemDeclensionFourthVariantWithoutItemsUpdateInput"]: {
		label?: string,
	remoteId?: string,
	declensionSeventh?: string,
	isNegativ?: boolean,
	seo?: GraphQLTypes["ItemDeclensionFourthVariantUpdateSeoEntityRelationInput"],
	subcategory?: GraphQLTypes["ItemDeclensionFourthVariantUpdateSubcategoryEntityRelationInput"],
	category?: GraphQLTypes["ItemDeclensionFourthVariantUpdateCategoryEntityRelationInput"],
	element?: GraphQLTypes["ItemDeclensionFourthVariantUpdateElementEntityRelationInput"],
	products?: Array<GraphQLTypes["ItemDeclensionFourthVariantUpdateProductsEntityRelationInput"]>,
	slug?: string,
	content?: GraphQLTypes["ItemDeclensionFourthVariantUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemDeclensionFourthVariantUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemDeclensionFourthVariantUpdateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutDeclensionsFourthCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateCategoryRelationInput"],
	update?: GraphQLTypes["ItemCategoryWithoutDeclensionsFourthUpdateInput"],
	upsert?: GraphQLTypes["ItemDeclensionFourthVariantUpsertCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemCategoryWithoutDeclensionsFourthUpdateInput"]: {
		name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryUpdateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryUpdateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryUpdateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryUpdateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryUpdateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryUpdateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemCategoryUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["ItemCategoryUpdateGroupEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemGroupUniqueWhere"],
	create?: GraphQLTypes["ItemGroupWithoutCategoriesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateGroupRelationInput"],
	update?: GraphQLTypes["ItemGroupWithoutCategoriesUpdateInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertGroupRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemGroupWithoutCategoriesUpdateInput"]: {
		remoteId?: string,
	name?: string,
	_dummy_field_?: boolean
};
	["ItemCategoryUpsertGroupRelationInput"]: {
		update: GraphQLTypes["ItemGroupWithoutCategoriesUpdateInput"],
	create: GraphQLTypes["ItemGroupWithoutCategoriesCreateInput"]
};
	["ItemCategoryUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertContentRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemCategoryUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ItemCategoryUpdateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemCategoryConnectOrCreateDraftRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ItemCategoryUpsertDraftRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemCategoryUpsertDraftRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ItemDeclensionFourthVariantUpsertCategoryRelationInput"]: {
		update: GraphQLTypes["ItemCategoryWithoutDeclensionsFourthUpdateInput"],
	create: GraphQLTypes["ItemCategoryWithoutDeclensionsFourthCreateInput"]
};
	["ItemDeclensionFourthVariantUpdateElementEntityRelationInput"]: {
		connect?: GraphQLTypes["ElementUniqueWhere"],
	create?: GraphQLTypes["ElementCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateElementRelationInput"],
	update?: GraphQLTypes["ElementUpdateInput"],
	upsert?: GraphQLTypes["ItemDeclensionFourthVariantUpsertElementRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ElementUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["ElementUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ElementUpdateFeatureDependenciesEntityRelationInput"]>,
	suitabilityElements?: Array<GraphQLTypes["ElementUpdateSuitabilityElementsEntityRelationInput"]>,
	remoteId?: string,
	unit?: string,
	filterOrder?: number,
	slug?: string,
	declensionSeventh?: string,
	_dummy_field_?: boolean
};
	["ItemDeclensionFourthVariantUpsertElementRelationInput"]: {
		update: GraphQLTypes["ElementUpdateInput"],
	create: GraphQLTypes["ElementCreateInput"]
};
	["ItemDeclensionFourthVariantUpdateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"],
	delete?: GraphQLTypes["ProductItemDeclensionFourthCategoryUniqueWhere"],
	alias?: string
};
	["ItemDeclensionFourthVariantUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ItemDeclensionFourthVariantUpsertContentRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemDeclensionFourthVariantUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ItemDeclensionFourthVariantUpdateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionFourthVariantConnectOrCreateDraftRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ItemDeclensionFourthVariantUpsertDraftRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemDeclensionFourthVariantUpsertDraftRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ItemUpsertDeclensionFourthRelationInput"]: {
		update: GraphQLTypes["ItemDeclensionFourthVariantWithoutItemsUpdateInput"],
	create: GraphQLTypes["ItemDeclensionFourthVariantWithoutItemsCreateInput"]
};
	["ContentReferenceUpsertRelatedIngredientRelationInput"]: {
		update: GraphQLTypes["ItemUpdateInput"],
	create: GraphQLTypes["ItemCreateInput"]
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateLinkRelationInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkUpdateInput"]: {
		externalLink?: string,
	isTargetBlank?: boolean,
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertLinkRelationInput"]: {
		update: GraphQLTypes["LinkUpdateInput"],
	create: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateRelatedBrandFullRelationInput"],
	update?: GraphQLTypes["BrandUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertRelatedBrandFullRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertRelatedBrandFullRelationInput"]: {
		update: GraphQLTypes["BrandUpdateInput"],
	create: GraphQLTypes["BrandCreateInput"]
};
	["ContentReferenceUpdateRelatedProductFullEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateRelatedProductFullRelationInput"],
	update?: GraphQLTypes["ProductUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertRelatedProductFullRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertRelatedProductFullRelationInput"]: {
		update: GraphQLTypes["ProductUpdateInput"],
	create: GraphQLTypes["ProductCreateInput"]
};
	["ContentReferenceUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceListWithoutListCreateInput"],
	update?: GraphQLTypes["ContentReferenceUpdateListRelationInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertListRelationInput"],
	connect?: GraphQLTypes["ContentReferenceListUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceListUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceListUniqueWhere"],
	alias?: string
};
	["ContentReferenceUpdateListRelationInput"]: {
		by: GraphQLTypes["ContentReferenceListUniqueWhere"],
	data: GraphQLTypes["ContentReferenceListWithoutListUpdateInput"]
};
	["ContentReferenceListWithoutListUpdateInput"]: {
		order?: number,
	relatedProduct?: GraphQLTypes["ContentReferenceListUpdateRelatedProductEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceListUpdateRelatedBrandEntityRelationInput"],
	badge?: string,
	badgeColor?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceListUpdateRelatedProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceListConnectOrCreateRelatedProductRelationInput"],
	update?: GraphQLTypes["ProductUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceListUpsertRelatedProductRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceListUpsertRelatedProductRelationInput"]: {
		update: GraphQLTypes["ProductUpdateInput"],
	create: GraphQLTypes["ProductCreateInput"]
};
	["ContentReferenceListUpdateRelatedBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceListConnectOrCreateRelatedBrandRelationInput"],
	update?: GraphQLTypes["BrandUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceListUpsertRelatedBrandRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceListUpsertRelatedBrandRelationInput"]: {
		update: GraphQLTypes["BrandUpdateInput"],
	create: GraphQLTypes["BrandCreateInput"]
};
	["ContentReferenceUpsertListRelationInput"]: {
		by: GraphQLTypes["ContentReferenceListUniqueWhere"],
	update: GraphQLTypes["ContentReferenceListWithoutListUpdateInput"],
	create: GraphQLTypes["ContentReferenceListWithoutListCreateInput"]
};
	["ContentReferenceUpdateOutlineEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentLinksUniqueWhere"],
	create?: GraphQLTypes["ContentLinksCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateOutlineRelationInput"],
	update?: GraphQLTypes["ContentLinksUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertOutlineRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentLinksUpdateInput"]: {
		items?: Array<GraphQLTypes["ContentLinksUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentLinksUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ContentLinksItemWithoutListCreateInput"],
	update?: GraphQLTypes["ContentLinksUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ContentLinksUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ContentLinksItemUniqueWhere"],
	disconnect?: GraphQLTypes["ContentLinksItemUniqueWhere"],
	delete?: GraphQLTypes["ContentLinksItemUniqueWhere"],
	alias?: string
};
	["ContentLinksUpdateItemsRelationInput"]: {
		by: GraphQLTypes["ContentLinksItemUniqueWhere"],
	data: GraphQLTypes["ContentLinksItemWithoutListUpdateInput"]
};
	["ContentLinksItemWithoutListUpdateInput"]: {
		order?: number,
	title?: string,
	target?: string,
	_dummy_field_?: boolean
};
	["ContentLinksUpsertItemsRelationInput"]: {
		by: GraphQLTypes["ContentLinksItemUniqueWhere"],
	update: GraphQLTypes["ContentLinksItemWithoutListUpdateInput"],
	create: GraphQLTypes["ContentLinksItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertOutlineRelationInput"]: {
		update: GraphQLTypes["ContentLinksUpdateInput"],
	create: GraphQLTypes["ContentLinksCreateInput"]
};
	["ContentReferenceUpdateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"],
	create?: GraphQLTypes["VideoCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateVideoRelationInput"],
	update?: GraphQLTypes["VideoUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertVideoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["VideoUpdateInput"]: {
		src?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	duration?: number,
	poster?: GraphQLTypes["VideoUpdatePosterEntityRelationInput"],
	_dummy_field_?: boolean
};
	["VideoUpdatePosterEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["VideoConnectOrCreatePosterRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["VideoUpsertPosterRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["VideoUpsertPosterRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpsertVideoRelationInput"]: {
		update: GraphQLTypes["VideoUpdateInput"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceImageUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateImageRelationInput"],
	update?: GraphQLTypes["ContentReferenceImageUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertImageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceImageUpdateInput"]: {
		lead?: string,
	alignment?: GraphQLTypes["AlignmentType"],
	image?: GraphQLTypes["ContentReferenceImageUpdateImageEntityRelationInput"],
	link?: string,
	targetBlank?: boolean,
	_dummy_field_?: boolean
};
	["ContentReferenceImageUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceImageConnectOrCreateImageRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceImageUpsertImageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceImageUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpsertImageRelationInput"]: {
		update: GraphQLTypes["ContentReferenceImageUpdateInput"],
	create: GraphQLTypes["ContentReferenceImageCreateInput"]
};
	["AdUpsertContentReferencesRelationInput"]: {
		by: GraphQLTypes["ContentReferenceUniqueWhere"],
	update: GraphQLTypes["ContentReferenceWithoutAdUpdateInput"],
	create: GraphQLTypes["ContentReferenceWithoutAdCreateInput"]
};
	["BrandUpsertAdsRelationInput"]: {
		by: GraphQLTypes["AdUniqueWhere"],
	update: GraphQLTypes["AdWithoutBrandsUpdateInput"],
	create: GraphQLTypes["AdWithoutBrandsCreateInput"]
};
	["CountryUpsertBrandsRelationInput"]: {
		by: GraphQLTypes["BrandUniqueWhere"],
	update: GraphQLTypes["BrandWithoutCountriesOfProductionUpdateInput"],
	create: GraphQLTypes["BrandWithoutCountriesOfProductionCreateInput"]
};
	["CountryUpdateRegionEntityRelationInput"]: {
		connect?: GraphQLTypes["RegionUniqueWhere"],
	create?: GraphQLTypes["RegionWithoutCountriesCreateInput"],
	connectOrCreate?: GraphQLTypes["CountryConnectOrCreateRegionRelationInput"],
	update?: GraphQLTypes["RegionWithoutCountriesUpdateInput"],
	upsert?: GraphQLTypes["CountryUpsertRegionRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["RegionWithoutCountriesUpdateInput"]: {
		name?: string,
	remoteId?: string,
	adjective?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["RegionUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RegionUpdateFilterCombosEntityRelationInput"]: {
		create?: GraphQLTypes["FilterComboWithoutRegionCreateInput"],
	update?: GraphQLTypes["RegionUpdateFilterCombosRelationInput"],
	upsert?: GraphQLTypes["RegionUpsertFilterCombosRelationInput"],
	connect?: GraphQLTypes["FilterComboUniqueWhere"],
	disconnect?: GraphQLTypes["FilterComboUniqueWhere"],
	delete?: GraphQLTypes["FilterComboUniqueWhere"],
	alias?: string
};
	["RegionUpdateFilterCombosRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	data: GraphQLTypes["FilterComboWithoutRegionUpdateInput"]
};
	["FilterComboWithoutRegionUpdateInput"]: {
		remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboUpdateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboUpdateBreedEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboUpdateBrandEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboUpdateAgeCategoryEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboUpdateTreatmentEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboUpdateFlavorEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboUpdateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RegionUpsertFilterCombosRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	update: GraphQLTypes["FilterComboWithoutRegionUpdateInput"],
	create: GraphQLTypes["FilterComboWithoutRegionCreateInput"]
};
	["CountryUpsertRegionRelationInput"]: {
		update: GraphQLTypes["RegionWithoutCountriesUpdateInput"],
	create: GraphQLTypes["RegionWithoutCountriesCreateInput"]
};
	["BrandManufacturerUpsertResidenceRelationInput"]: {
		update: GraphQLTypes["CountryWithoutManufacturersUpdateInput"],
	create: GraphQLTypes["CountryWithoutManufacturersCreateInput"]
};
	["BrandUpsertManufacturersRelationInput"]: {
		by: GraphQLTypes["BrandManufacturerUniqueWhere"],
	update: GraphQLTypes["BrandManufacturerWithoutBrandsUpdateInput"],
	create: GraphQLTypes["BrandManufacturerWithoutBrandsCreateInput"]
};
	["ProductUpsertBrandRelationInput"]: {
		update: GraphQLTypes["BrandWithoutProductsUpdateInput"],
	create: GraphQLTypes["BrandWithoutProductsCreateInput"]
};
	["ProductLineUpsertProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	update: GraphQLTypes["ProductWithoutProductLineUpdateInput"],
	create: GraphQLTypes["ProductWithoutProductLineCreateInput"]
};
	["ProductLineUpdateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductLineConnectOrCreateLogoRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ProductLineUpsertLogoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductLineUpsertLogoRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ProductLineUpdateAliasesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductLineAliasWithoutProductLinesCreateInput"],
	update?: GraphQLTypes["ProductLineUpdateAliasesRelationInput"],
	upsert?: GraphQLTypes["ProductLineUpsertAliasesRelationInput"],
	connect?: GraphQLTypes["ProductLineAliasUniqueWhere"],
	disconnect?: GraphQLTypes["ProductLineAliasUniqueWhere"],
	delete?: GraphQLTypes["ProductLineAliasUniqueWhere"],
	alias?: string
};
	["ProductLineUpdateAliasesRelationInput"]: {
		by: GraphQLTypes["ProductLineAliasUniqueWhere"],
	data: GraphQLTypes["ProductLineAliasWithoutProductLinesUpdateInput"]
};
	["ProductLineAliasWithoutProductLinesUpdateInput"]: {
		remoteId?: string,
	name?: string,
	_dummy_field_?: boolean
};
	["ProductLineUpsertAliasesRelationInput"]: {
		by: GraphQLTypes["ProductLineAliasUniqueWhere"],
	update: GraphQLTypes["ProductLineAliasWithoutProductLinesUpdateInput"],
	create: GraphQLTypes["ProductLineAliasWithoutProductLinesCreateInput"]
};
	["ProductLineUpdateFlavorsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductLineFlavorUniqueWhere"],
	disconnect?: GraphQLTypes["ProductLineFlavorUniqueWhere"],
	delete?: GraphQLTypes["ProductLineFlavorUniqueWhere"],
	alias?: string
};
	["ProductLineUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductLineConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ProductLineUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductLineUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["BrandUpsertProductLinesRelationInput"]: {
		by: GraphQLTypes["ProductLineUniqueWhere"],
	update: GraphQLTypes["ProductLineWithoutBrandUpdateInput"],
	create: GraphQLTypes["ProductLineWithoutBrandCreateInput"]
};
	["BrandManufacturerUpsertBrandsRelationInput"]: {
		by: GraphQLTypes["BrandUniqueWhere"],
	update: GraphQLTypes["BrandWithoutManufacturersUpdateInput"],
	create: GraphQLTypes["BrandWithoutManufacturersCreateInput"]
};
	["CountryUpsertManufacturersRelationInput"]: {
		by: GraphQLTypes["BrandManufacturerUniqueWhere"],
	update: GraphQLTypes["BrandManufacturerWithoutResidenceUpdateInput"],
	create: GraphQLTypes["BrandManufacturerWithoutResidenceCreateInput"]
};
	["BrandUpsertCountriesOfProductionRelationInput"]: {
		by: GraphQLTypes["CountryUniqueWhere"],
	update: GraphQLTypes["CountryWithoutBrandsUpdateInput"],
	create: GraphQLTypes["CountryWithoutBrandsCreateInput"]
};
	["FilterComboUpsertBrandRelationInput"]: {
		update: GraphQLTypes["BrandWithoutFilterCombosUpdateInput"],
	create: GraphQLTypes["BrandWithoutFilterCombosCreateInput"]
};
	["BreedUpsertFilterCombosRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	update: GraphQLTypes["FilterComboWithoutBreedUpdateInput"],
	create: GraphQLTypes["FilterComboWithoutBreedCreateInput"]
};
	["BlogPostReviewUpsertBreedRelationInput"]: {
		update: GraphQLTypes["BreedWithoutBlogPostReviewsUpdateInput"],
	create: GraphQLTypes["BreedWithoutBlogPostReviewsCreateInput"]
};
	["AgeUpsertBlogPostReviewsRelationInput"]: {
		by: GraphQLTypes["BlogPostReviewUniqueWhere"],
	update: GraphQLTypes["BlogPostReviewWithoutAgeUpdateInput"],
	create: GraphQLTypes["BlogPostReviewWithoutAgeCreateInput"]
};
	["SuitabilityCategoryUpsertDogAgesRelationInput"]: {
		by: GraphQLTypes["AgeUniqueWhere"],
	update: GraphQLTypes["AgeWithoutSuitabilityCategoriesUpdateInput"],
	create: GraphQLTypes["AgeWithoutSuitabilityCategoriesCreateInput"]
};
	["DogSizeUpsertSuitabilityCategoryRelationInput"]: {
		update: GraphQLTypes["SuitabilityCategoryWithoutDogSizesUpdateInput"],
	create: GraphQLTypes["SuitabilityCategoryWithoutDogSizesCreateInput"]
};
	["BreedUpsertSizeRelationInput"]: {
		update: GraphQLTypes["DogSizeWithoutBreedsUpdateInput"],
	create: GraphQLTypes["DogSizeWithoutBreedsCreateInput"]
};
	["ProductReviewUpsertBreedRelationInput"]: {
		update: GraphQLTypes["BreedWithoutProductReviewsUpdateInput"],
	create: GraphQLTypes["BreedWithoutProductReviewsCreateInput"]
};
	["AgeUpsertProductReviewsRelationInput"]: {
		by: GraphQLTypes["ProductReviewUniqueWhere"],
	update: GraphQLTypes["ProductReviewWithoutAgeUpdateInput"],
	create: GraphQLTypes["ProductReviewWithoutAgeCreateInput"]
};
	["BlogPostReviewUpsertAgeRelationInput"]: {
		update: GraphQLTypes["AgeWithoutBlogPostReviewsUpdateInput"],
	create: GraphQLTypes["AgeWithoutBlogPostReviewsCreateInput"]
};
	["BreedUpsertBlogPostReviewsRelationInput"]: {
		by: GraphQLTypes["BlogPostReviewUniqueWhere"],
	update: GraphQLTypes["BlogPostReviewWithoutBreedUpdateInput"],
	create: GraphQLTypes["BlogPostReviewWithoutBreedCreateInput"]
};
	["SuitabilityCategoryUpsertBreedsRelationInput"]: {
		by: GraphQLTypes["BreedUniqueWhere"],
	update: GraphQLTypes["BreedWithoutSuitabilityCategoryUpdateInput"],
	create: GraphQLTypes["BreedWithoutSuitabilityCategoryCreateInput"]
};
	["AgeUpsertSuitabilityCategoriesRelationInput"]: {
		by: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	update: GraphQLTypes["SuitabilityCategoryWithoutDogAgesUpdateInput"],
	create: GraphQLTypes["SuitabilityCategoryWithoutDogAgesCreateInput"]
};
	["ProductReviewUpsertAgeRelationInput"]: {
		update: GraphQLTypes["AgeWithoutProductReviewsUpdateInput"],
	create: GraphQLTypes["AgeWithoutProductReviewsCreateInput"]
};
	["BreedUpsertProductReviewsRelationInput"]: {
		by: GraphQLTypes["ProductReviewUniqueWhere"],
	update: GraphQLTypes["ProductReviewWithoutBreedUpdateInput"],
	create: GraphQLTypes["ProductReviewWithoutBreedCreateInput"]
};
	["FilterComboUpsertBreedRelationInput"]: {
		update: GraphQLTypes["BreedWithoutFilterCombosUpdateInput"],
	create: GraphQLTypes["BreedWithoutFilterCombosCreateInput"]
};
	["ItemSubCategoryUpsertFilterCombosFlavorRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	update: GraphQLTypes["FilterComboWithoutFlavorUpdateInput"],
	create: GraphQLTypes["FilterComboWithoutFlavorCreateInput"]
};
	["DogUpsertAllergiesRelationInput"]: {
		by: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	update: GraphQLTypes["ItemSubCategoryWithoutDogsUpdateInput"],
	create: GraphQLTypes["ItemSubCategoryWithoutDogsCreateInput"]
};
	["DogUpdateIllnessesEntityRelationInput"]: {
		create?: GraphQLTypes["BodyTagWithoutDogsCreateInput"],
	update?: GraphQLTypes["DogUpdateIllnessesRelationInput"],
	upsert?: GraphQLTypes["DogUpsertIllnessesRelationInput"],
	connect?: GraphQLTypes["BodyTagUniqueWhere"],
	disconnect?: GraphQLTypes["BodyTagUniqueWhere"],
	delete?: GraphQLTypes["BodyTagUniqueWhere"],
	alias?: string
};
	["DogUpdateIllnessesRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	data: GraphQLTypes["BodyTagWithoutDogsUpdateInput"]
};
	["BodyTagWithoutDogsUpdateInput"]: {
		name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagUpdateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagUpdatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagUpdateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagUpdatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagUpdateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagUpdateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagUpdateIconEntityRelationInput"],
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagUpdateFilterCombosEntityRelationInput"]: {
		create?: GraphQLTypes["FilterComboWithoutTreatmentCreateInput"],
	update?: GraphQLTypes["BodyTagUpdateFilterCombosRelationInput"],
	upsert?: GraphQLTypes["BodyTagUpsertFilterCombosRelationInput"],
	connect?: GraphQLTypes["FilterComboUniqueWhere"],
	disconnect?: GraphQLTypes["FilterComboUniqueWhere"],
	delete?: GraphQLTypes["FilterComboUniqueWhere"],
	alias?: string
};
	["BodyTagUpdateFilterCombosRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	data: GraphQLTypes["FilterComboWithoutTreatmentUpdateInput"]
};
	["FilterComboWithoutTreatmentUpdateInput"]: {
		remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboUpdateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboUpdateBreedEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboUpdateBrandEntityRelationInput"],
	region?: GraphQLTypes["FilterComboUpdateRegionEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboUpdateAgeCategoryEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboUpdateFlavorEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboUpdateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BodyTagUpsertFilterCombosRelationInput"]: {
		by: GraphQLTypes["FilterComboUniqueWhere"],
	update: GraphQLTypes["FilterComboWithoutTreatmentUpdateInput"],
	create: GraphQLTypes["FilterComboWithoutTreatmentCreateInput"]
};
	["DogUpsertIllnessesRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	update: GraphQLTypes["BodyTagWithoutDogsUpdateInput"],
	create: GraphQLTypes["BodyTagWithoutDogsCreateInput"]
};
	["DogActivityUpsertDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	update: GraphQLTypes["DogWithoutActivityUpdateInput"],
	create: GraphQLTypes["DogWithoutActivityCreateInput"]
};
	["DogActivityUpdateSuitabilityCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create?: GraphQLTypes["SuitabilityCategoryWithoutDogActivitiesCreateInput"],
	connectOrCreate?: GraphQLTypes["DogActivityConnectOrCreateSuitabilityCategoryRelationInput"],
	update?: GraphQLTypes["SuitabilityCategoryWithoutDogActivitiesUpdateInput"],
	upsert?: GraphQLTypes["DogActivityUpsertSuitabilityCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SuitabilityCategoryWithoutDogActivitiesUpdateInput"]: {
		name?: string,
	dogSizes?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogSizesEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["SuitabilityCategoryUpdateBreedsEntityRelationInput"]>,
	suitabilityItems?: Array<GraphQLTypes["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"]>,
	dogAges?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogAgesEntityRelationInput"]>,
	isPregnant?: boolean,
	remoteId?: string,
	isBreastfeeding?: boolean,
	_dummy_field_?: boolean
};
	["DogActivityUpsertSuitabilityCategoryRelationInput"]: {
		update: GraphQLTypes["SuitabilityCategoryWithoutDogActivitiesUpdateInput"],
	create: GraphQLTypes["SuitabilityCategoryWithoutDogActivitiesCreateInput"]
};
	["ProductUpsertRecommendedActivityRelationInput"]: {
		update: GraphQLTypes["DogActivityWithoutProductsUpdateInput"],
	create: GraphQLTypes["DogActivityWithoutProductsCreateInput"]
};
	["BrandUpsertProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	update: GraphQLTypes["ProductWithoutBrandUpdateInput"],
	create: GraphQLTypes["ProductWithoutBrandCreateInput"]
};
	["ProductLineUpsertBrandRelationInput"]: {
		update: GraphQLTypes["BrandWithoutProductLinesUpdateInput"],
	create: GraphQLTypes["BrandWithoutProductLinesCreateInput"]
};
	["ProductUpsertProductLineRelationInput"]: {
		update: GraphQLTypes["ProductLineWithoutProductsUpdateInput"],
	create: GraphQLTypes["ProductLineWithoutProductsCreateInput"]
};
	["DogSizeUpsertProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	update: GraphQLTypes["ProductWithoutRecommendedDogSizesUpdateInput"],
	create: GraphQLTypes["ProductWithoutRecommendedDogSizesCreateInput"]
};
	["SuitabilityCategoryUpsertDogSizesRelationInput"]: {
		by: GraphQLTypes["DogSizeUniqueWhere"],
	update: GraphQLTypes["DogSizeWithoutSuitabilityCategoryUpdateInput"],
	create: GraphQLTypes["DogSizeWithoutSuitabilityCategoryCreateInput"]
};
	["BreedUpsertSuitabilityCategoryRelationInput"]: {
		update: GraphQLTypes["SuitabilityCategoryWithoutBreedsUpdateInput"],
	create: GraphQLTypes["SuitabilityCategoryWithoutBreedsCreateInput"]
};
	["DogSizeUpsertBreedsRelationInput"]: {
		by: GraphQLTypes["BreedUniqueWhere"],
	update: GraphQLTypes["BreedWithoutSizeUpdateInput"],
	create: GraphQLTypes["BreedWithoutSizeCreateInput"]
};
	["ProductUpsertRecommendedDogSizesRelationInput"]: {
		by: GraphQLTypes["DogSizeUniqueWhere"],
	update: GraphQLTypes["DogSizeWithoutProductsUpdateInput"],
	create: GraphQLTypes["DogSizeWithoutProductsCreateInput"]
};
	["DogUpsertFedProductRelationInput"]: {
		update: GraphQLTypes["ProductWithoutDogsUpdateInput"],
	create: GraphQLTypes["ProductWithoutDogsCreateInput"]
};
	["ItemSubCategoryUpsertDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	update: GraphQLTypes["DogWithoutAllergiesUpdateInput"],
	create: GraphQLTypes["DogWithoutAllergiesCreateInput"]
};
	["ItemDeclensionFourthVariantUpsertSubcategoryRelationInput"]: {
		update: GraphQLTypes["ItemSubCategoryUpdateInput"],
	create: GraphQLTypes["ItemSubCategoryCreateInput"]
};
	["ItemCategoryUpsertDeclensionsFourthRelationInput"]: {
		by: GraphQLTypes["ItemDeclensionFourthVariantUniqueWhere"],
	update: GraphQLTypes["ItemDeclensionFourthVariantWithoutCategoryUpdateInput"],
	create: GraphQLTypes["ItemDeclensionFourthVariantWithoutCategoryCreateInput"]
};
	["ItemSubCategoryUpsertCategoryRelationInput"]: {
		update: GraphQLTypes["ItemCategoryWithoutSubCategoriesUpdateInput"],
	create: GraphQLTypes["ItemCategoryWithoutSubCategoriesCreateInput"]
};
	["ProductFeatureUpsertDependentSubCategoryRelationInput"]: {
		update: GraphQLTypes["ItemSubCategoryWithoutFeatureDependenciesUpdateInput"],
	create: GraphQLTypes["ItemSubCategoryWithoutFeatureDependenciesCreateInput"]
};
	["ProductFeatureUpdateDependentFlagEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductFlagUniqueWhere"],
	create?: GraphQLTypes["ProductFlagWithoutProductFeaturesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFeatureConnectOrCreateDependentFlagRelationInput"],
	update?: GraphQLTypes["ProductFlagWithoutProductFeaturesUpdateInput"],
	upsert?: GraphQLTypes["ProductFeatureUpsertDependentFlagRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductFlagWithoutProductFeaturesUpdateInput"]: {
		remoteId?: string,
	products?: Array<GraphQLTypes["ProductFlagUpdateProductsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductFlagUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductFlagOfProductWithoutFlagCreateInput"],
	update?: GraphQLTypes["ProductFlagUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["ProductFlagUpsertProductsRelationInput"],
	connect?: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	delete?: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	alias?: string
};
	["ProductFlagUpdateProductsRelationInput"]: {
		by: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	data: GraphQLTypes["ProductFlagOfProductWithoutFlagUpdateInput"]
};
	["ProductFlagOfProductWithoutFlagUpdateInput"]: {
		remoteId?: string,
	value?: GraphQLTypes["ProductFlagValue"],
	product?: GraphQLTypes["ProductFlagOfProductUpdateProductEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFlagOfProductUpdateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutFlagsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductFlagOfProductConnectOrCreateProductRelationInput"],
	update?: GraphQLTypes["ProductWithoutFlagsUpdateInput"],
	upsert?: GraphQLTypes["ProductFlagOfProductUpsertProductRelationInput"],
	delete?: boolean
};
	["ProductWithoutFlagsUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductFlagOfProductUpsertProductRelationInput"]: {
		update: GraphQLTypes["ProductWithoutFlagsUpdateInput"],
	create: GraphQLTypes["ProductWithoutFlagsCreateInput"]
};
	["ProductFlagUpsertProductsRelationInput"]: {
		by: GraphQLTypes["ProductFlagOfProductUniqueWhere"],
	update: GraphQLTypes["ProductFlagOfProductWithoutFlagUpdateInput"],
	create: GraphQLTypes["ProductFlagOfProductWithoutFlagCreateInput"]
};
	["ProductFeatureUpsertDependentFlagRelationInput"]: {
		update: GraphQLTypes["ProductFlagWithoutProductFeaturesUpdateInput"],
	create: GraphQLTypes["ProductFlagWithoutProductFeaturesCreateInput"]
};
	["ItemCategoryUpsertFeatureDependenciesRelationInput"]: {
		by: GraphQLTypes["ProductFeatureUniqueWhere"],
	update: GraphQLTypes["ProductFeatureWithoutDependentCategoryUpdateInput"],
	create: GraphQLTypes["ProductFeatureWithoutDependentCategoryCreateInput"]
};
	["RedirectUpsertItemCategoryRelationInput"]: {
		update: GraphQLTypes["ItemCategoryWithoutRedirectsUpdateInput"],
	create: GraphQLTypes["ItemCategoryWithoutRedirectsCreateInput"]
};
	["BrandsPageUpsertRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	update: GraphQLTypes["RedirectWithoutBrandsPageUpdateInput"],
	create: GraphQLTypes["RedirectWithoutBrandsPageCreateInput"]
};
	["SeoUpsertBrandsPageRelationInput"]: {
		update: GraphQLTypes["BrandsPageWithoutSeoUpdateInput"],
	create: GraphQLTypes["BrandsPageWithoutSeoCreateInput"]
};
	["BlogPostUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["BlogPostUpdateRedirectsEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutBlogPostCreateInput"],
	update?: GraphQLTypes["BlogPostUpdateRedirectsRelationInput"],
	upsert?: GraphQLTypes["BlogPostUpsertRedirectsRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: GraphQLTypes["RedirectUniqueWhere"],
	delete?: GraphQLTypes["RedirectUniqueWhere"],
	alias?: string
};
	["BlogPostUpdateRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	data: GraphQLTypes["RedirectWithoutBlogPostUpdateInput"]
};
	["RedirectWithoutBlogPostUpdateInput"]: {
		to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectUpdateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectUpdateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectUpdateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectUpdateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectUpdateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectUpdateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectUpdateComparatorPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostUpsertRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	update: GraphQLTypes["RedirectWithoutBlogPostUpdateInput"],
	create: GraphQLTypes["RedirectWithoutBlogPostCreateInput"]
};
	["AdUpsertBlogPostsRelationInput"]: {
		by: GraphQLTypes["BlogPostUniqueWhere"],
	update: GraphQLTypes["BlogPostWithoutAdsUpdateInput"],
	create: GraphQLTypes["BlogPostWithoutAdsCreateInput"]
};
	["AdUpdateBrandsEntityRelationInput"]: {
		create?: GraphQLTypes["BrandWithoutAdsCreateInput"],
	update?: GraphQLTypes["AdUpdateBrandsRelationInput"],
	upsert?: GraphQLTypes["AdUpsertBrandsRelationInput"],
	connect?: GraphQLTypes["BrandUniqueWhere"],
	disconnect?: GraphQLTypes["BrandUniqueWhere"],
	delete?: GraphQLTypes["BrandUniqueWhere"],
	alias?: string
};
	["AdUpdateBrandsRelationInput"]: {
		by: GraphQLTypes["BrandUniqueWhere"],
	data: GraphQLTypes["BrandWithoutAdsUpdateInput"]
};
	["BrandWithoutAdsUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["BrandUpdateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandUpdateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandUpdateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandUpdateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandUpdateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandUpdateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandUpdateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandUpdateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AdUpsertBrandsRelationInput"]: {
		by: GraphQLTypes["BrandUniqueWhere"],
	update: GraphQLTypes["BrandWithoutAdsUpdateInput"],
	create: GraphQLTypes["BrandWithoutAdsCreateInput"]
};
	["ItemCategoryUpsertAdsRelationInput"]: {
		by: GraphQLTypes["AdUniqueWhere"],
	update: GraphQLTypes["AdWithoutItemCategoriesUpdateInput"],
	create: GraphQLTypes["AdWithoutItemCategoriesCreateInput"]
};
	["ProductFeatureUpsertDependentCategoryRelationInput"]: {
		update: GraphQLTypes["ItemCategoryWithoutFeatureDependenciesUpdateInput"],
	create: GraphQLTypes["ItemCategoryWithoutFeatureDependenciesCreateInput"]
};
	["ElementUpsertFeatureDependenciesRelationInput"]: {
		by: GraphQLTypes["ProductFeatureUniqueWhere"],
	update: GraphQLTypes["ProductFeatureWithoutDependentElementUpdateInput"],
	create: GraphQLTypes["ProductFeatureWithoutDependentElementCreateInput"]
};
	["ElementOfProductUpsertElementRelationInput"]: {
		update: GraphQLTypes["ElementWithoutProductsUpdateInput"],
	create: GraphQLTypes["ElementWithoutProductsCreateInput"]
};
	["ProductUpsertElementsRelationInput"]: {
		by: GraphQLTypes["ElementOfProductUniqueWhere"],
	update: GraphQLTypes["ElementOfProductWithoutProductUpdateInput"],
	create: GraphQLTypes["ElementOfProductWithoutProductCreateInput"]
};
	["ItemCategoryUpsertProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	update: GraphQLTypes["ProductWithoutItemCategoriesUpdateInput"],
	create: GraphQLTypes["ProductWithoutItemCategoriesCreateInput"]
};
	["AdUpsertItemCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemCategoryUniqueWhere"],
	update: GraphQLTypes["ItemCategoryWithoutAdsUpdateInput"],
	create: GraphQLTypes["ItemCategoryWithoutAdsCreateInput"]
};
	["BlogPostUpsertAdsRelationInput"]: {
		by: GraphQLTypes["AdUniqueWhere"],
	update: GraphQLTypes["AdWithoutBlogPostsUpdateInput"],
	create: GraphQLTypes["AdWithoutBlogPostsCreateInput"]
};
	["UserUpsertBlogPostsRelationInput"]: {
		by: GraphQLTypes["BlogPostUniqueWhere"],
	update: GraphQLTypes["BlogPostWithoutUserUpdateInput"],
	create: GraphQLTypes["BlogPostWithoutUserCreateInput"]
};
	["UserUpdateAvatarEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["UserConnectOrCreateAvatarRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["UserUpsertAvatarRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["UserUpsertAvatarRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["UserUpdateContactFormMessagesEntityRelationInput"]: {
		create?: GraphQLTypes["ContactFormMessageWithoutUserCreateInput"],
	update?: GraphQLTypes["UserUpdateContactFormMessagesRelationInput"],
	upsert?: GraphQLTypes["UserUpsertContactFormMessagesRelationInput"],
	connect?: GraphQLTypes["ContactFormMessageUniqueWhere"],
	disconnect?: GraphQLTypes["ContactFormMessageUniqueWhere"],
	delete?: GraphQLTypes["ContactFormMessageUniqueWhere"],
	alias?: string
};
	["UserUpdateContactFormMessagesRelationInput"]: {
		by: GraphQLTypes["ContactFormMessageUniqueWhere"],
	data: GraphQLTypes["ContactFormMessageWithoutUserUpdateInput"]
};
	["ContactFormMessageWithoutUserUpdateInput"]: {
		message?: string,
	email?: string,
	receivedAt?: GraphQLTypes["DateTime"],
	isResolved?: boolean,
	url?: string,
	_dummy_field_?: boolean
};
	["UserUpsertContactFormMessagesRelationInput"]: {
		by: GraphQLTypes["ContactFormMessageUniqueWhere"],
	update: GraphQLTypes["ContactFormMessageWithoutUserUpdateInput"],
	create: GraphQLTypes["ContactFormMessageWithoutUserCreateInput"]
};
	["UserUpdateBugReportsEntityRelationInput"]: {
		create?: GraphQLTypes["BugReportWithoutUserCreateInput"],
	update?: GraphQLTypes["UserUpdateBugReportsRelationInput"],
	upsert?: GraphQLTypes["UserUpsertBugReportsRelationInput"],
	connect?: GraphQLTypes["BugReportUniqueWhere"],
	disconnect?: GraphQLTypes["BugReportUniqueWhere"],
	delete?: GraphQLTypes["BugReportUniqueWhere"],
	alias?: string
};
	["UserUpdateBugReportsRelationInput"]: {
		by: GraphQLTypes["BugReportUniqueWhere"],
	data: GraphQLTypes["BugReportWithoutUserUpdateInput"]
};
	["BugReportWithoutUserUpdateInput"]: {
		message?: string,
	receivedAt?: GraphQLTypes["DateTime"],
	isResolved?: boolean,
	url?: string,
	_dummy_field_?: boolean
};
	["UserUpsertBugReportsRelationInput"]: {
		by: GraphQLTypes["BugReportUniqueWhere"],
	update: GraphQLTypes["BugReportWithoutUserUpdateInput"],
	create: GraphQLTypes["BugReportWithoutUserCreateInput"]
};
	["UserUpdateProtectedActionsEntityRelationInput"]: {
		create?: GraphQLTypes["ProtectedActionWithoutUserCreateInput"],
	update?: GraphQLTypes["UserUpdateProtectedActionsRelationInput"],
	upsert?: GraphQLTypes["UserUpsertProtectedActionsRelationInput"],
	connect?: GraphQLTypes["ProtectedActionUniqueWhere"],
	disconnect?: GraphQLTypes["ProtectedActionUniqueWhere"],
	delete?: GraphQLTypes["ProtectedActionUniqueWhere"],
	alias?: string
};
	["UserUpdateProtectedActionsRelationInput"]: {
		by: GraphQLTypes["ProtectedActionUniqueWhere"],
	data: GraphQLTypes["ProtectedActionWithoutUserUpdateInput"]
};
	["ProtectedActionWithoutUserUpdateInput"]: {
		type?: GraphQLTypes["ProtectedActionType"],
	createdAt?: GraphQLTypes["DateTime"],
	usedAt?: GraphQLTypes["DateTime"],
	expiresAt?: GraphQLTypes["DateTime"],
	publicKey?: string,
	secretHash?: string,
	verifyEmail?: string,
	createdMetadata?: GraphQLTypes["Json"],
	usedMetadata?: GraphQLTypes["Json"],
	_dummy_field_?: boolean
};
	["UserUpsertProtectedActionsRelationInput"]: {
		by: GraphQLTypes["ProtectedActionUniqueWhere"],
	update: GraphQLTypes["ProtectedActionWithoutUserUpdateInput"],
	create: GraphQLTypes["ProtectedActionWithoutUserCreateInput"]
};
	["UserUpdateTenantPersonEntityRelationInput"]: {
		connect?: GraphQLTypes["TenantPersonUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductReviewUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutProductReviewsUpdateInput"],
	create: GraphQLTypes["UserWithoutProductReviewsCreateInput"]
};
	["ProductReviewReactionUpsertProductReviewRelationInput"]: {
		update: GraphQLTypes["ProductReviewWithoutProductReviewReactionsUpdateInput"],
	create: GraphQLTypes["ProductReviewWithoutProductReviewReactionsCreateInput"]
};
	["UserUpsertProductReviewReactionsRelationInput"]: {
		by: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	update: GraphQLTypes["ProductReviewReactionWithoutUserUpdateInput"],
	create: GraphQLTypes["ProductReviewReactionWithoutUserCreateInput"]
};
	["BlogPostReviewUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutBlogPostReviewsUpdateInput"],
	create: GraphQLTypes["UserWithoutBlogPostReviewsCreateInput"]
};
	["BlogPostReviewReactionUpsertBlogPostReviewRelationInput"]: {
		update: GraphQLTypes["BlogPostReviewWithoutBlogPostReviewReactionsUpdateInput"],
	create: GraphQLTypes["BlogPostReviewWithoutBlogPostReviewReactionsCreateInput"]
};
	["UserUpsertBlogPostReviewReactionsRelationInput"]: {
		by: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	update: GraphQLTypes["BlogPostReviewReactionWithoutUserUpdateInput"],
	create: GraphQLTypes["BlogPostReviewReactionWithoutUserCreateInput"]
};
	["BlogPostUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutBlogPostsUpdateInput"],
	create: GraphQLTypes["UserWithoutBlogPostsCreateInput"]
};
	["ItemUpsertBlogPostRelationInput"]: {
		update: GraphQLTypes["BlogPostWithoutItemsUpdateInput"],
	create: GraphQLTypes["BlogPostWithoutItemsCreateInput"]
};
	["ItemCategoryUpsertItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	update: GraphQLTypes["ItemWithoutCategoriesUpdateInput"],
	create: GraphQLTypes["ItemWithoutCategoriesCreateInput"]
};
	["ProductUpsertItemCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemCategoryUniqueWhere"],
	update: GraphQLTypes["ItemCategoryWithoutProductsUpdateInput"],
	create: GraphQLTypes["ItemCategoryWithoutProductsCreateInput"]
};
	["NutritionalValueOfProductUpsertProductRelationInput"]: {
		update: GraphQLTypes["ProductWithoutNutritionalValuesUpdateInput"],
	create: GraphQLTypes["ProductWithoutNutritionalValuesCreateInput"]
};
	["NutritionalValueUpsertProductsRelationInput"]: {
		by: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	update: GraphQLTypes["NutritionalValueOfProductWithoutNutritionalValueUpdateInput"],
	create: GraphQLTypes["NutritionalValueOfProductWithoutNutritionalValueCreateInput"]
};
	["NutritionalValueUpdateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["NutritionalValueConnectOrCreateIconRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["NutritionalValueUpsertIconRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["NutritionalValueUpsertIconRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["SuitabilityItemUpsertNutritionalValueRelationInput"]: {
		update: GraphQLTypes["NutritionalValueWithoutSuitabilityNutritionalValuesUpdateInput"],
	create: GraphQLTypes["NutritionalValueWithoutSuitabilityNutritionalValuesCreateInput"]
};
	["SuitabilityItemUpdateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["SuitabilityCategoryUniqueWhere"],
	create?: GraphQLTypes["SuitabilityCategoryWithoutSuitabilityItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["SuitabilityItemConnectOrCreateCategoryRelationInput"],
	update?: GraphQLTypes["SuitabilityCategoryWithoutSuitabilityItemsUpdateInput"],
	upsert?: GraphQLTypes["SuitabilityItemUpsertCategoryRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SuitabilityCategoryWithoutSuitabilityItemsUpdateInput"]: {
		name?: string,
	dogSizes?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogSizesEntityRelationInput"]>,
	dogActivities?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["SuitabilityCategoryUpdateBreedsEntityRelationInput"]>,
	dogAges?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogAgesEntityRelationInput"]>,
	isPregnant?: boolean,
	remoteId?: string,
	isBreastfeeding?: boolean,
	_dummy_field_?: boolean
};
	["SuitabilityItemUpsertCategoryRelationInput"]: {
		update: GraphQLTypes["SuitabilityCategoryWithoutSuitabilityItemsUpdateInput"],
	create: GraphQLTypes["SuitabilityCategoryWithoutSuitabilityItemsCreateInput"]
};
	["ElementUpsertSuitabilityElementsRelationInput"]: {
		by: GraphQLTypes["SuitabilityItemUniqueWhere"],
	update: GraphQLTypes["SuitabilityItemWithoutElementUpdateInput"],
	create: GraphQLTypes["SuitabilityItemWithoutElementCreateInput"]
};
	["ProductFeatureUpsertDependentElementRelationInput"]: {
		update: GraphQLTypes["ElementWithoutFeatureDependenciesUpdateInput"],
	create: GraphQLTypes["ElementWithoutFeatureDependenciesCreateInput"]
};
	["ItemUpsertFeaturesOfProductRelationInput"]: {
		by: GraphQLTypes["ProductFeatureUniqueWhere"],
	update: GraphQLTypes["ProductFeatureWithoutLinkItemUpdateInput"],
	create: GraphQLTypes["ProductFeatureWithoutLinkItemCreateInput"]
};
	["BlogPostUpsertItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	update: GraphQLTypes["ItemWithoutBlogPostUpdateInput"],
	create: GraphQLTypes["ItemWithoutBlogPostCreateInput"]
};
	["ItemCategoryUpsertBlogPostsRelationInput"]: {
		by: GraphQLTypes["BlogPostUniqueWhere"],
	update: GraphQLTypes["BlogPostWithoutItemCategoriesUpdateInput"],
	create: GraphQLTypes["BlogPostWithoutItemCategoriesCreateInput"]
};
	["ItemUpsertCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemCategoryUniqueWhere"],
	update: GraphQLTypes["ItemCategoryWithoutItemsUpdateInput"],
	create: GraphQLTypes["ItemCategoryWithoutItemsCreateInput"]
};
	["ProductFeatureUpsertLinkItemRelationInput"]: {
		update: GraphQLTypes["ItemWithoutFeaturesOfProductUpdateInput"],
	create: GraphQLTypes["ItemWithoutFeaturesOfProductCreateInput"]
};
	["ItemSubCategoryUpsertFeatureDependenciesRelationInput"]: {
		by: GraphQLTypes["ProductFeatureUniqueWhere"],
	update: GraphQLTypes["ProductFeatureWithoutDependentSubCategoryUpdateInput"],
	create: GraphQLTypes["ProductFeatureWithoutDependentSubCategoryCreateInput"]
};
	["ProductUpsertItemSubCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	update: GraphQLTypes["ItemSubCategoryWithoutProductsUpdateInput"],
	create: GraphQLTypes["ItemSubCategoryWithoutProductsCreateInput"]
};
	["DogActivityUpsertProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	update: GraphQLTypes["ProductWithoutRecommendedActivityUpdateInput"],
	create: GraphQLTypes["ProductWithoutRecommendedActivityCreateInput"]
};
	["DogUpsertActivityRelationInput"]: {
		update: GraphQLTypes["DogActivityWithoutDogsUpdateInput"],
	create: GraphQLTypes["DogActivityWithoutDogsCreateInput"]
};
	["BreedUpsertDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	update: GraphQLTypes["DogWithoutBreedUpdateInput"],
	create: GraphQLTypes["DogWithoutBreedCreateInput"]
};
	["AgeUpsertBreedsRelationInput"]: {
		by: GraphQLTypes["BreedUniqueWhere"],
	update: GraphQLTypes["BreedWithoutAgesUpdateInput"],
	create: GraphQLTypes["BreedWithoutAgesCreateInput"]
};
	["DogUpsertAgeRelationInput"]: {
		update: GraphQLTypes["AgeWithoutDogsUpdateInput"],
	create: GraphQLTypes["AgeWithoutDogsCreateInput"]
};
	["ProductUpsertDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	update: GraphQLTypes["DogWithoutFedProductUpdateInput"],
	create: GraphQLTypes["DogWithoutFedProductCreateInput"]
};
	["ItemSubCategoryUpsertProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	update: GraphQLTypes["ProductWithoutItemSubCategoriesUpdateInput"],
	create: GraphQLTypes["ProductWithoutItemSubCategoriesCreateInput"]
};
	["ItemUpsertSubCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	update: GraphQLTypes["ItemSubCategoryWithoutItemsUpdateInput"],
	create: GraphQLTypes["ItemSubCategoryWithoutItemsCreateInput"]
};
	["BodyTagUpsertNegativeItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	update: GraphQLTypes["ItemWithoutNegativeForBodyTagsUpdateInput"],
	create: GraphQLTypes["ItemWithoutNegativeForBodyTagsCreateInput"]
};
	["ItemUpsertPositiveForBodyTagsRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	update: GraphQLTypes["BodyTagWithoutPositiveItemsUpdateInput"],
	create: GraphQLTypes["BodyTagWithoutPositiveItemsCreateInput"]
};
	["ItemSubCategoryUpsertItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	update: GraphQLTypes["ItemWithoutSubCategoriesUpdateInput"],
	create: GraphQLTypes["ItemWithoutSubCategoriesCreateInput"]
};
	["ItemCategoryUpsertSubCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	update: GraphQLTypes["ItemSubCategoryWithoutCategoryUpdateInput"],
	create: GraphQLTypes["ItemSubCategoryWithoutCategoryCreateInput"]
};
	["BlogPostUpsertItemCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemCategoryUniqueWhere"],
	update: GraphQLTypes["ItemCategoryWithoutBlogPostsUpdateInput"],
	create: GraphQLTypes["ItemCategoryWithoutBlogPostsCreateInput"]
};
	["BlogPostTagUpsertBlogPostsRelationInput"]: {
		by: GraphQLTypes["BlogPostUniqueWhere"],
	update: GraphQLTypes["BlogPostWithoutBlogPostTagsUpdateInput"],
	create: GraphQLTypes["BlogPostWithoutBlogPostTagsCreateInput"]
};
	["ColorUpsertBlogPostTagRelationInput"]: {
		update: GraphQLTypes["BlogPostTagWithoutColorUpdateInput"],
	create: GraphQLTypes["BlogPostTagWithoutColorCreateInput"]
};
	["ColorUpdateItemFlavorCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ItemFlavorCategoryWithoutColorCreateInput"],
	update?: GraphQLTypes["ColorUpdateItemFlavorCategoriesRelationInput"],
	upsert?: GraphQLTypes["ColorUpsertItemFlavorCategoriesRelationInput"],
	connect?: GraphQLTypes["ItemFlavorCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ItemFlavorCategoryUniqueWhere"],
	delete?: GraphQLTypes["ItemFlavorCategoryUniqueWhere"],
	alias?: string
};
	["ColorUpdateItemFlavorCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemFlavorCategoryUniqueWhere"],
	data: GraphQLTypes["ItemFlavorCategoryWithoutColorUpdateInput"]
};
	["ItemFlavorCategoryWithoutColorUpdateInput"]: {
		name?: string,
	items?: Array<GraphQLTypes["ItemFlavorCategoryUpdateItemsEntityRelationInput"]>,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ItemFlavorCategoryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ItemSubCategoryWithoutFlavorCategoryCreateInput"],
	update?: GraphQLTypes["ItemFlavorCategoryUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ItemFlavorCategoryUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	delete?: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	alias?: string
};
	["ItemFlavorCategoryUpdateItemsRelationInput"]: {
		by: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	data: GraphQLTypes["ItemSubCategoryWithoutFlavorCategoryUpdateInput"]
};
	["ItemSubCategoryWithoutFlavorCategoryUpdateInput"]: {
		name?: string,
	items?: Array<GraphQLTypes["ItemSubCategoryUpdateItemsEntityRelationInput"]>,
	isFlavorCategory?: boolean,
	isAllergenTag?: boolean,
	isMostCommonAllergenTag?: boolean,
	products?: Array<GraphQLTypes["ItemSubCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemSubCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["ItemSubCategoryUpdateCategoryEntityRelationInput"],
	dogs?: Array<GraphQLTypes["ItemSubCategoryUpdateDogsEntityRelationInput"]>,
	iconNegative?: GraphQLTypes["ItemSubCategoryUpdateIconNegativeEntityRelationInput"],
	negativeWording?: string,
	icon?: GraphQLTypes["ItemSubCategoryUpdateIconEntityRelationInput"],
	brands?: Array<GraphQLTypes["ItemSubCategoryUpdateBrandsEntityRelationInput"]>,
	productLines?: Array<GraphQLTypes["ItemSubCategoryUpdateProductLinesEntityRelationInput"]>,
	slug?: string,
	flavorSlug?: string,
	flavorDeclensionSeventh?: string,
	filterCombosFlavor?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosFlavorEntityRelationInput"]>,
	filterCombosAllergy?: Array<GraphQLTypes["ItemSubCategoryUpdateFilterCombosAllergyEntityRelationInput"]>,
	isFilterFlavor?: boolean,
	_dummy_field_?: boolean
};
	["ItemFlavorCategoryUpsertItemsRelationInput"]: {
		by: GraphQLTypes["ItemSubCategoryUniqueWhere"],
	update: GraphQLTypes["ItemSubCategoryWithoutFlavorCategoryUpdateInput"],
	create: GraphQLTypes["ItemSubCategoryWithoutFlavorCategoryCreateInput"]
};
	["ColorUpsertItemFlavorCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemFlavorCategoryUniqueWhere"],
	update: GraphQLTypes["ItemFlavorCategoryWithoutColorUpdateInput"],
	create: GraphQLTypes["ItemFlavorCategoryWithoutColorCreateInput"]
};
	["BodyTagCategoryUpsertColorRelationInput"]: {
		update: GraphQLTypes["ColorWithoutBodyTagCategoryUpdateInput"],
	create: GraphQLTypes["ColorWithoutBodyTagCategoryCreateInput"]
};
	["BodyTagUpsertCategoryRelationInput"]: {
		update: GraphQLTypes["BodyTagCategoryWithoutTagsUpdateInput"],
	create: GraphQLTypes["BodyTagCategoryWithoutTagsCreateInput"]
};
	["ItemUpsertNegativeForBodyTagsRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	update: GraphQLTypes["BodyTagWithoutNegativeItemsUpdateInput"],
	create: GraphQLTypes["BodyTagWithoutNegativeItemsCreateInput"]
};
	["BodyTagUpsertPositiveItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	update: GraphQLTypes["ItemWithoutPositiveForBodyTagsUpdateInput"],
	create: GraphQLTypes["ItemWithoutPositiveForBodyTagsCreateInput"]
};
	["ProductUpsertNegativeForBodyTagsRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	update: GraphQLTypes["BodyTagWithoutNegativeProductsUpdateInput"],
	create: GraphQLTypes["BodyTagWithoutNegativeProductsCreateInput"]
};
	["ProductReviewUpsertProductRelationInput"]: {
		update: GraphQLTypes["ProductWithoutReviewsUpdateInput"],
	create: GraphQLTypes["ProductWithoutReviewsCreateInput"]
};
	["UserUpsertProductReviewsRelationInput"]: {
		by: GraphQLTypes["ProductReviewUniqueWhere"],
	update: GraphQLTypes["ProductReviewWithoutUserUpdateInput"],
	create: GraphQLTypes["ProductReviewWithoutUserCreateInput"]
};
	["ProductReviewReactionUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutProductReviewReactionsUpdateInput"],
	create: GraphQLTypes["UserWithoutProductReviewReactionsCreateInput"]
};
	["ProductReviewUpsertProductReviewReactionsRelationInput"]: {
		by: GraphQLTypes["ProductReviewReactionUniqueWhere"],
	update: GraphQLTypes["ProductReviewReactionWithoutProductReviewUpdateInput"],
	create: GraphQLTypes["ProductReviewReactionWithoutProductReviewCreateInput"]
};
	["ProductUpsertReviewsRelationInput"]: {
		by: GraphQLTypes["ProductReviewUniqueWhere"],
	update: GraphQLTypes["ProductReviewWithoutProductUpdateInput"],
	create: GraphQLTypes["ProductReviewWithoutProductCreateInput"]
};
	["BodyTagUpsertNegativeProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	update: GraphQLTypes["ProductWithoutNegativeForBodyTagsUpdateInput"],
	create: GraphQLTypes["ProductWithoutNegativeForBodyTagsCreateInput"]
};
	["ProductUpsertPositiveForBodyTagsRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	update: GraphQLTypes["BodyTagWithoutPositiveProductsUpdateInput"],
	create: GraphQLTypes["BodyTagWithoutPositiveProductsCreateInput"]
};
	["ElementOfProductUpsertProductRelationInput"]: {
		update: GraphQLTypes["ProductWithoutElementsUpdateInput"],
	create: GraphQLTypes["ProductWithoutElementsCreateInput"]
};
	["ElementUpsertProductsRelationInput"]: {
		by: GraphQLTypes["ElementOfProductUniqueWhere"],
	update: GraphQLTypes["ElementOfProductWithoutElementUpdateInput"],
	create: GraphQLTypes["ElementOfProductWithoutElementCreateInput"]
};
	["SuitabilityItemUpsertElementRelationInput"]: {
		update: GraphQLTypes["ElementWithoutSuitabilityElementsUpdateInput"],
	create: GraphQLTypes["ElementWithoutSuitabilityElementsCreateInput"]
};
	["NutritionalValueUpsertSuitabilityNutritionalValuesRelationInput"]: {
		by: GraphQLTypes["SuitabilityItemUniqueWhere"],
	update: GraphQLTypes["SuitabilityItemWithoutNutritionalValueUpdateInput"],
	create: GraphQLTypes["SuitabilityItemWithoutNutritionalValueCreateInput"]
};
	["NutritionalValueOfProductUpsertNutritionalValueRelationInput"]: {
		update: GraphQLTypes["NutritionalValueWithoutProductsUpdateInput"],
	create: GraphQLTypes["NutritionalValueWithoutProductsCreateInput"]
};
	["ProductUpsertNutritionalValuesRelationInput"]: {
		by: GraphQLTypes["NutritionalValueOfProductUniqueWhere"],
	update: GraphQLTypes["NutritionalValueOfProductWithoutProductUpdateInput"],
	create: GraphQLTypes["NutritionalValueOfProductWithoutProductCreateInput"]
};
	["BodyTagUpsertPositiveProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	update: GraphQLTypes["ProductWithoutPositiveForBodyTagsUpdateInput"],
	create: GraphQLTypes["ProductWithoutPositiveForBodyTagsCreateInput"]
};
	["BlogPostUpsertTagsRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	update: GraphQLTypes["BodyTagWithoutBlogPostsUpdateInput"],
	create: GraphQLTypes["BodyTagWithoutBlogPostsCreateInput"]
};
	["BlogPostReviewUpsertBlogPostRelationInput"]: {
		update: GraphQLTypes["BlogPostWithoutReviewsUpdateInput"],
	create: GraphQLTypes["BlogPostWithoutReviewsCreateInput"]
};
	["UserUpsertBlogPostReviewsRelationInput"]: {
		by: GraphQLTypes["BlogPostReviewUniqueWhere"],
	update: GraphQLTypes["BlogPostReviewWithoutUserUpdateInput"],
	create: GraphQLTypes["BlogPostReviewWithoutUserCreateInput"]
};
	["DogUpsertOwnerRelationInput"]: {
		update: GraphQLTypes["UserWithoutDogsUpdateInput"],
	create: GraphQLTypes["UserWithoutDogsCreateInput"]
};
	["AgeUpsertDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	update: GraphQLTypes["DogWithoutAgeUpdateInput"],
	create: GraphQLTypes["DogWithoutAgeCreateInput"]
};
	["BreedUpsertAgesRelationInput"]: {
		by: GraphQLTypes["AgeUniqueWhere"],
	update: GraphQLTypes["AgeWithoutBreedsUpdateInput"],
	create: GraphQLTypes["AgeWithoutBreedsCreateInput"]
};
	["DogUpsertBreedRelationInput"]: {
		update: GraphQLTypes["BreedWithoutDogsUpdateInput"],
	create: GraphQLTypes["BreedWithoutDogsCreateInput"]
};
	["UserUpsertDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	update: GraphQLTypes["DogWithoutOwnerUpdateInput"],
	create: GraphQLTypes["DogWithoutOwnerCreateInput"]
};
	["BlogPostReviewReactionUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutBlogPostReviewReactionsUpdateInput"],
	create: GraphQLTypes["UserWithoutBlogPostReviewReactionsCreateInput"]
};
	["BlogPostReviewUpsertBlogPostReviewReactionsRelationInput"]: {
		by: GraphQLTypes["BlogPostReviewReactionUniqueWhere"],
	update: GraphQLTypes["BlogPostReviewReactionWithoutBlogPostReviewUpdateInput"],
	create: GraphQLTypes["BlogPostReviewReactionWithoutBlogPostReviewCreateInput"]
};
	["BlogPostUpsertReviewsRelationInput"]: {
		by: GraphQLTypes["BlogPostReviewUniqueWhere"],
	update: GraphQLTypes["BlogPostReviewWithoutBlogPostUpdateInput"],
	create: GraphQLTypes["BlogPostReviewWithoutBlogPostCreateInput"]
};
	["BodyTagUpsertBlogPostsRelationInput"]: {
		by: GraphQLTypes["BlogPostUniqueWhere"],
	update: GraphQLTypes["BlogPostWithoutTagsUpdateInput"],
	create: GraphQLTypes["BlogPostWithoutTagsCreateInput"]
};
	["BodyTagCategoryUpsertTagsRelationInput"]: {
		by: GraphQLTypes["BodyTagUniqueWhere"],
	update: GraphQLTypes["BodyTagWithoutCategoryUpdateInput"],
	create: GraphQLTypes["BodyTagWithoutCategoryCreateInput"]
};
	["ColorUpsertBodyTagCategoryRelationInput"]: {
		update: GraphQLTypes["BodyTagCategoryWithoutColorUpdateInput"],
	create: GraphQLTypes["BodyTagCategoryWithoutColorCreateInput"]
};
	["BlogPostTagUpsertColorRelationInput"]: {
		update: GraphQLTypes["ColorWithoutBlogPostTagUpdateInput"],
	create: GraphQLTypes["ColorWithoutBlogPostTagCreateInput"]
};
	["BlogPostUpsertBlogPostTagsRelationInput"]: {
		by: GraphQLTypes["BlogPostTagUniqueWhere"],
	update: GraphQLTypes["BlogPostTagWithoutBlogPostsUpdateInput"],
	create: GraphQLTypes["BlogPostTagWithoutBlogPostsCreateInput"]
};
	["ContentReferenceUpsertRelatedBlogPostRelationInput"]: {
		update: GraphQLTypes["BlogPostUpdateInput"],
	create: GraphQLTypes["BlogPostCreateInput"]
};
	["ContentReferenceUpdateAdEntityRelationInput"]: {
		connect?: GraphQLTypes["AdUniqueWhere"],
	create?: GraphQLTypes["AdWithoutContentReferencesCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceConnectOrCreateAdRelationInput"],
	update?: GraphQLTypes["AdWithoutContentReferencesUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertAdRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["AdWithoutContentReferencesUpdateInput"]: {
		image?: GraphQLTypes["AdUpdateImageEntityRelationInput"],
	isBrandSectionVisible?: boolean,
	isBlogPostSectionVisible?: boolean,
	isIngredientSectionVisible?: boolean,
	isResultsVisible?: boolean,
	isSearchVisible?: boolean,
	blogPosts?: Array<GraphQLTypes["AdUpdateBlogPostsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["AdUpdateItemCategoriesEntityRelationInput"]>,
	brands?: Array<GraphQLTypes["AdUpdateBrandsEntityRelationInput"]>,
	isActive?: boolean,
	link?: string,
	note?: string,
	activeFrom?: GraphQLTypes["DateTime"],
	activeUntil?: GraphQLTypes["DateTime"],
	slug?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertAdRelationInput"]: {
		update: GraphQLTypes["AdWithoutContentReferencesUpdateInput"],
	create: GraphQLTypes["AdWithoutContentReferencesCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
		by: GraphQLTypes["ContentReferenceUniqueWhere"],
	update: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"],
	create: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
		by: GraphQLTypes["ContentBlockUniqueWhere"],
	update: GraphQLTypes["ContentBlockWithoutContentUpdateInput"],
	create: GraphQLTypes["ContentBlockWithoutContentCreateInput"]
};
	["BlogPageUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["SeoUpsertBlogPageRelationInput"]: {
		update: GraphQLTypes["BlogPageWithoutSeoUpdateInput"],
	create: GraphQLTypes["BlogPageWithoutSeoCreateInput"]
};
	["GenericPageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoWithoutGenericPageUpdateInput"],
	create: GraphQLTypes["SeoWithoutGenericPageCreateInput"]
};
	["RedirectUpsertGenericPageRelationInput"]: {
		update: GraphQLTypes["GenericPageWithoutRedirectsUpdateInput"],
	create: GraphQLTypes["GenericPageWithoutRedirectsCreateInput"]
};
	["BlogPageUpsertRedirectsRelationInput"]: {
		by: GraphQLTypes["RedirectUniqueWhere"],
	update: GraphQLTypes["RedirectWithoutBlogPageUpdateInput"],
	create: GraphQLTypes["RedirectWithoutBlogPageCreateInput"]
};
	["BlogPostTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	blogPosts?: Array<GraphQLTypes["BlogPostTagCreateBlogPostsEntityRelationInput"]>,
	remoteId?: string,
	color?: GraphQLTypes["BlogPostTagCreateColorEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["BlogPostTagUpdateInput"]: {
		name?: string,
	blogPosts?: Array<GraphQLTypes["BlogPostTagUpdateBlogPostsEntityRelationInput"]>,
	remoteId?: string,
	color?: GraphQLTypes["BlogPostTagUpdateColorEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["BodyTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagCreateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagCreatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagCreateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagCreatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagCreateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagCreateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagCreateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagCreateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagUpdateInput"]: {
		name?: string,
	blogPosts?: Array<GraphQLTypes["BodyTagUpdateBlogPostsEntityRelationInput"]>,
	positiveProducts?: Array<GraphQLTypes["BodyTagUpdatePositiveProductsEntityRelationInput"]>,
	negativeProducts?: Array<GraphQLTypes["BodyTagUpdateNegativeProductsEntityRelationInput"]>,
	positiveItems?: Array<GraphQLTypes["BodyTagUpdatePositiveItemsEntityRelationInput"]>,
	negativeItems?: Array<GraphQLTypes["BodyTagUpdateNegativeItemsEntityRelationInput"]>,
	remoteId?: string,
	category?: GraphQLTypes["BodyTagUpdateCategoryEntityRelationInput"],
	icon?: GraphQLTypes["BodyTagUpdateIconEntityRelationInput"],
	dogs?: Array<GraphQLTypes["BodyTagUpdateDogsEntityRelationInput"]>,
	labelFor?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BodyTagUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BodyTagCategoryConnection"]: {
	__typename: "BodyTagCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BodyTagCategoryEdge"]>
};
	["BodyTagCategoryEdge"]: {
	__typename: "BodyTagCategoryEdge",
	node: GraphQLTypes["BodyTagCategory"]
};
	["BodyTagCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	tags?: Array<GraphQLTypes["BodyTagCategoryCreateTagsEntityRelationInput"]>,
	remoteId?: string,
	color?: GraphQLTypes["BodyTagCategoryCreateColorEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BodyTagCategoryUpdateInput"]: {
		name?: string,
	tags?: Array<GraphQLTypes["BodyTagCategoryUpdateTagsEntityRelationInput"]>,
	remoteId?: string,
	color?: GraphQLTypes["BodyTagCategoryUpdateColorEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentConnection"]: {
	__typename: "ContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentEdge"]>
};
	["ContentEdge"]: {
	__typename: "ContentEdge",
	node: GraphQLTypes["Content"]
};
	["ContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]>,
	automatedContentBlockSlug?: string,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]>,
	automatedContentBlockSlug?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fact?: string,
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	relatedBlogPost?: GraphQLTypes["ContentReferenceCreateRelatedBlogPostEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceCreateRelatedBrandEntityRelationInput"],
	relatedProduct?: GraphQLTypes["ContentReferenceCreateRelatedProductEntityRelationInput"],
	relatedIngredient?: GraphQLTypes["ContentReferenceCreateRelatedIngredientEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	badge?: string,
	longVersion?: boolean,
	relatedBrandFull?: GraphQLTypes["ContentReferenceCreateRelatedBrandFullEntityRelationInput"],
	relatedProductFull?: GraphQLTypes["ContentReferenceCreateRelatedProductFullEntityRelationInput"],
	list?: Array<GraphQLTypes["ContentReferenceCreateListEntityRelationInput"]>,
	outline?: GraphQLTypes["ContentReferenceCreateOutlineEntityRelationInput"],
	video?: GraphQLTypes["ContentReferenceCreateVideoEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	defaultOpen?: boolean,
	badgeColor?: string,
	isMain?: boolean,
	ad?: GraphQLTypes["ContentReferenceCreateAdEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fact?: string,
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	relatedBlogPost?: GraphQLTypes["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceUpdateRelatedBrandEntityRelationInput"],
	relatedProduct?: GraphQLTypes["ContentReferenceUpdateRelatedProductEntityRelationInput"],
	relatedIngredient?: GraphQLTypes["ContentReferenceUpdateRelatedIngredientEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	badge?: string,
	longVersion?: boolean,
	relatedBrandFull?: GraphQLTypes["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"],
	relatedProductFull?: GraphQLTypes["ContentReferenceUpdateRelatedProductFullEntityRelationInput"],
	list?: Array<GraphQLTypes["ContentReferenceUpdateListEntityRelationInput"]>,
	outline?: GraphQLTypes["ContentReferenceUpdateOutlineEntityRelationInput"],
	video?: GraphQLTypes["ContentReferenceUpdateVideoEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	defaultOpen?: boolean,
	badgeColor?: string,
	isMain?: boolean,
	ad?: GraphQLTypes["ContentReferenceUpdateAdEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DidYouKnow"]: {
	__typename: "DidYouKnow",
	_meta?: GraphQLTypes["DidYouKnowMeta"],
	id: GraphQLTypes["UUID"],
	text: string,
	remoteId: string
};
	["DidYouKnowMeta"]: {
	__typename: "DidYouKnowMeta",
	id?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"]
};
	["DidYouKnowUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["DidYouKnowWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	text?: GraphQLTypes["StringCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["DidYouKnowWhere"] | undefined>,
	or?: Array<GraphQLTypes["DidYouKnowWhere"] | undefined>,
	not?: GraphQLTypes["DidYouKnowWhere"]
};
	["DidYouKnowOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"]
};
	["DidYouKnowConnection"]: {
	__typename: "DidYouKnowConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DidYouKnowEdge"]>
};
	["DidYouKnowEdge"]: {
	__typename: "DidYouKnowEdge",
	node: GraphQLTypes["DidYouKnow"]
};
	["DidYouKnowCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["DidYouKnowUpdateInput"]: {
		text?: string,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ImageConnection"]: {
	__typename: "ImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
	__typename: "ImageEdge",
	node: GraphQLTypes["Image"]
};
	["Medium"]: {
	__typename: "Medium",
	_meta?: GraphQLTypes["MediumMeta"],
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["MediumType"],
	colorTheme?: GraphQLTypes["ColorTheme"],
	image?: GraphQLTypes["Image"],
	video?: GraphQLTypes["Video"]
};
	["MediumMeta"]: {
	__typename: "MediumMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	colorTheme?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	video?: GraphQLTypes["FieldMeta"]
};
	["MediumType"]: MediumType;
	["ColorTheme"]: ColorTheme;
	["MediumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["MediumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["MediumTypeCondition"],
	colorTheme?: GraphQLTypes["ColorThemeCondition"],
	image?: GraphQLTypes["ImageWhere"],
	video?: GraphQLTypes["VideoWhere"],
	and?: Array<GraphQLTypes["MediumWhere"] | undefined>,
	or?: Array<GraphQLTypes["MediumWhere"] | undefined>,
	not?: GraphQLTypes["MediumWhere"]
};
	["MediumTypeCondition"]: {
		and?: Array<GraphQLTypes["MediumTypeCondition"]>,
	or?: Array<GraphQLTypes["MediumTypeCondition"]>,
	not?: GraphQLTypes["MediumTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["MediumType"],
	notEq?: GraphQLTypes["MediumType"],
	in?: Array<GraphQLTypes["MediumType"]>,
	notIn?: Array<GraphQLTypes["MediumType"]>,
	lt?: GraphQLTypes["MediumType"],
	lte?: GraphQLTypes["MediumType"],
	gt?: GraphQLTypes["MediumType"],
	gte?: GraphQLTypes["MediumType"]
};
	["ColorThemeCondition"]: {
		and?: Array<GraphQLTypes["ColorThemeCondition"]>,
	or?: Array<GraphQLTypes["ColorThemeCondition"]>,
	not?: GraphQLTypes["ColorThemeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ColorTheme"],
	notEq?: GraphQLTypes["ColorTheme"],
	in?: Array<GraphQLTypes["ColorTheme"]>,
	notIn?: Array<GraphQLTypes["ColorTheme"]>,
	lt?: GraphQLTypes["ColorTheme"],
	lte?: GraphQLTypes["ColorTheme"],
	gt?: GraphQLTypes["ColorTheme"],
	gte?: GraphQLTypes["ColorTheme"]
};
	["MediumOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	colorTheme?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	video?: GraphQLTypes["VideoOrderBy"]
};
	["MediumConnection"]: {
	__typename: "MediumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumEdge"]>
};
	["MediumEdge"]: {
	__typename: "MediumEdge",
	node: GraphQLTypes["Medium"]
};
	["MediumCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["MediumType"],
	colorTheme?: GraphQLTypes["ColorTheme"],
	image?: GraphQLTypes["MediumCreateImageEntityRelationInput"],
	video?: GraphQLTypes["MediumCreateVideoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MediumCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["MediumConnectOrCreateImageRelationInput"]
};
	["MediumConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["MediumCreateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"],
	create?: GraphQLTypes["VideoCreateInput"],
	connectOrCreate?: GraphQLTypes["MediumConnectOrCreateVideoRelationInput"]
};
	["MediumConnectOrCreateVideoRelationInput"]: {
		connect: GraphQLTypes["VideoUniqueWhere"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["MediumUpdateInput"]: {
		type?: GraphQLTypes["MediumType"],
	colorTheme?: GraphQLTypes["ColorTheme"],
	image?: GraphQLTypes["MediumUpdateImageEntityRelationInput"],
	video?: GraphQLTypes["MediumUpdateVideoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MediumUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["MediumConnectOrCreateImageRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["MediumUpsertImageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["MediumUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["MediumUpdateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"],
	create?: GraphQLTypes["VideoCreateInput"],
	connectOrCreate?: GraphQLTypes["MediumConnectOrCreateVideoRelationInput"],
	update?: GraphQLTypes["VideoUpdateInput"],
	upsert?: GraphQLTypes["MediumUpsertVideoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["MediumUpsertVideoRelationInput"]: {
		update: GraphQLTypes["VideoUpdateInput"],
	create: GraphQLTypes["VideoCreateInput"]
};
	["NutritionalValueConnection"]: {
	__typename: "NutritionalValueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NutritionalValueEdge"]>
};
	["NutritionalValueEdge"]: {
	__typename: "NutritionalValueEdge",
	node: GraphQLTypes["NutritionalValue"]
};
	["NutritionalValueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["NutritionalValueCreateProductsEntityRelationInput"]>,
	suitabilityNutritionalValues?: Array<GraphQLTypes["NutritionalValueCreateSuitabilityNutritionalValuesEntityRelationInput"]>,
	remoteId?: string,
	icon?: GraphQLTypes["NutritionalValueCreateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NutritionalValueUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["NutritionalValueUpdateProductsEntityRelationInput"]>,
	suitabilityNutritionalValues?: Array<GraphQLTypes["NutritionalValueUpdateSuitabilityNutritionalValuesEntityRelationInput"]>,
	remoteId?: string,
	icon?: GraphQLTypes["NutritionalValueUpdateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["Page"]: {
	__typename: "Page",
	_meta?: GraphQLTypes["PageMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	seo?: GraphQLTypes["Seo"],
	content?: GraphQLTypes["Content"],
	draft?: GraphQLTypes["Content"]
};
	["PageMeta"]: {
	__typename: "PageMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	draft?: GraphQLTypes["FieldMeta"]
};
	["PageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	draft?: GraphQLTypes["ContentUniqueWhere"]
};
	["PageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	content?: GraphQLTypes["ContentWhere"],
	draft?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["PageWhere"] | undefined>,
	or?: Array<GraphQLTypes["PageWhere"] | undefined>,
	not?: GraphQLTypes["PageWhere"]
};
	["PageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	draft?: GraphQLTypes["ContentOrderBy"]
};
	["PageConnection"]: {
	__typename: "PageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PageEdge"]>
};
	["PageEdge"]: {
	__typename: "PageEdge",
	node: GraphQLTypes["Page"]
};
	["PageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	seo?: GraphQLTypes["PageCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["PageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["PageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["PageConnectOrCreateSeoRelationInput"]
};
	["PageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["PageCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["PageConnectOrCreateContentRelationInput"]
};
	["PageConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["PageCreateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["PageConnectOrCreateDraftRelationInput"]
};
	["PageConnectOrCreateDraftRelationInput"]: {
		connect: GraphQLTypes["ContentUniqueWhere"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["PageUpdateInput"]: {
		title?: string,
	seo?: GraphQLTypes["PageUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["PageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["PageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["PageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["PageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["PageUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["PageConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["PageUpsertContentRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["PageUpdateDraftEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"],
	connectOrCreate?: GraphQLTypes["PageConnectOrCreateDraftRelationInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["PageUpsertDraftRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageUpsertDraftRelationInput"]: {
		update: GraphQLTypes["ContentUpdateInput"],
	create: GraphQLTypes["ContentCreateInput"]
};
	["ReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	link?: string,
	order?: number,
	list?: GraphQLTypes["ReferenceCreateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ReferenceCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ReferenceListUniqueWhere"],
	create?: GraphQLTypes["ReferenceListWithoutReferencesCreateInput"],
	connectOrCreate?: GraphQLTypes["ReferenceConnectOrCreateListRelationInput"]
};
	["ReferenceListWithoutReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ReferenceConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["ReferenceListUniqueWhere"],
	create: GraphQLTypes["ReferenceListWithoutReferencesCreateInput"]
};
	["ReferenceUpdateInput"]: {
		text?: string,
	link?: string,
	order?: number,
	list?: GraphQLTypes["ReferenceUpdateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ReferenceUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ReferenceListUniqueWhere"],
	create?: GraphQLTypes["ReferenceListWithoutReferencesCreateInput"],
	connectOrCreate?: GraphQLTypes["ReferenceConnectOrCreateListRelationInput"],
	update?: GraphQLTypes["ReferenceListWithoutReferencesUpdateInput"],
	upsert?: GraphQLTypes["ReferenceUpsertListRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ReferenceListWithoutReferencesUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ReferenceUpsertListRelationInput"]: {
		update: GraphQLTypes["ReferenceListWithoutReferencesUpdateInput"],
	create: GraphQLTypes["ReferenceListWithoutReferencesCreateInput"]
};
	["ReferenceListConnection"]: {
	__typename: "ReferenceListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ReferenceListEdge"]>
};
	["ReferenceListEdge"]: {
	__typename: "ReferenceListEdge",
	node: GraphQLTypes["ReferenceList"]
};
	["SeoConnection"]: {
	__typename: "SeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
	__typename: "SeoEdge",
	node: GraphQLTypes["Seo"]
};
	["VideoConnection"]: {
	__typename: "VideoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VideoEdge"]>
};
	["VideoEdge"]: {
	__typename: "VideoEdge",
	node: GraphQLTypes["Video"]
};
	["BrandDistributorConnection"]: {
	__typename: "BrandDistributorConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BrandDistributorEdge"]>
};
	["BrandDistributorEdge"]: {
	__typename: "BrandDistributorEdge",
	node: GraphQLTypes["BrandDistributor"]
};
	["BrandDistributorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	brands?: Array<GraphQLTypes["BrandDistributorCreateBrandsEntityRelationInput"]>,
	link?: string,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["BrandDistributorCreateBrandsEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutDistributorCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandDistributorConnectOrCreateBrandsRelationInput"],
	alias?: string
};
	["BrandWithoutDistributorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["BrandCreateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandCreateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandCreateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandCreateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandCreateMethodOfProductionEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandCreateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandCreateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandCreateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandCreateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandDistributorConnectOrCreateBrandsRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandWithoutDistributorCreateInput"]
};
	["BrandDistributorUpdateInput"]: {
		name?: string,
	brands?: Array<GraphQLTypes["BrandDistributorUpdateBrandsEntityRelationInput"]>,
	link?: string,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["BrandDistributorUpdateBrandsEntityRelationInput"]: {
		create?: GraphQLTypes["BrandWithoutDistributorCreateInput"],
	update?: GraphQLTypes["BrandDistributorUpdateBrandsRelationInput"],
	upsert?: GraphQLTypes["BrandDistributorUpsertBrandsRelationInput"],
	connect?: GraphQLTypes["BrandUniqueWhere"],
	disconnect?: GraphQLTypes["BrandUniqueWhere"],
	delete?: GraphQLTypes["BrandUniqueWhere"],
	alias?: string
};
	["BrandDistributorUpdateBrandsRelationInput"]: {
		by: GraphQLTypes["BrandUniqueWhere"],
	data: GraphQLTypes["BrandWithoutDistributorUpdateInput"]
};
	["BrandWithoutDistributorUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["BrandUpdateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandUpdateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandUpdateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandUpdateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandUpdateMethodOfProductionEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandUpdateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandUpdateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandUpdateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandUpdateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandDistributorUpsertBrandsRelationInput"]: {
		by: GraphQLTypes["BrandUniqueWhere"],
	update: GraphQLTypes["BrandWithoutDistributorUpdateInput"],
	create: GraphQLTypes["BrandWithoutDistributorCreateInput"]
};
	["DogSizeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	breeds?: Array<GraphQLTypes["DogSizeCreateBreedsEntityRelationInput"]>,
	remoteId?: string,
	products?: Array<GraphQLTypes["DogSizeCreateProductsEntityRelationInput"]>,
	suitabilityCategory?: GraphQLTypes["DogSizeCreateSuitabilityCategoryEntityRelationInput"],
	name?: GraphQLTypes["SizeType"],
	label?: string,
	order?: number,
	isFilterVisible?: boolean,
	_dummy_field_?: boolean
};
	["DogSizeUpdateInput"]: {
		breeds?: Array<GraphQLTypes["DogSizeUpdateBreedsEntityRelationInput"]>,
	remoteId?: string,
	products?: Array<GraphQLTypes["DogSizeUpdateProductsEntityRelationInput"]>,
	suitabilityCategory?: GraphQLTypes["DogSizeUpdateSuitabilityCategoryEntityRelationInput"],
	name?: GraphQLTypes["SizeType"],
	label?: string,
	order?: number,
	isFilterVisible?: boolean,
	_dummy_field_?: boolean
};
	["ProductionMethodConnection"]: {
	__typename: "ProductionMethodConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductionMethodEdge"]>
};
	["ProductionMethodEdge"]: {
	__typename: "ProductionMethodEdge",
	node: GraphQLTypes["ProductionMethod"]
};
	["ProductionMethodCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	brands?: Array<GraphQLTypes["ProductionMethodCreateBrandsEntityRelationInput"]>,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ProductionMethodCreateBrandsEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutMethodOfProductionCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductionMethodConnectOrCreateBrandsRelationInput"],
	alias?: string
};
	["BrandWithoutMethodOfProductionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["BrandCreateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandCreateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandCreateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandCreateLogoEntityRelationInput"],
	distributor?: GraphQLTypes["BrandCreateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandCreateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandCreateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandCreateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandCreateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductionMethodConnectOrCreateBrandsRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandWithoutMethodOfProductionCreateInput"]
};
	["ProductionMethodUpdateInput"]: {
		name?: string,
	brands?: Array<GraphQLTypes["ProductionMethodUpdateBrandsEntityRelationInput"]>,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ProductionMethodUpdateBrandsEntityRelationInput"]: {
		create?: GraphQLTypes["BrandWithoutMethodOfProductionCreateInput"],
	update?: GraphQLTypes["ProductionMethodUpdateBrandsRelationInput"],
	upsert?: GraphQLTypes["ProductionMethodUpsertBrandsRelationInput"],
	connect?: GraphQLTypes["BrandUniqueWhere"],
	disconnect?: GraphQLTypes["BrandUniqueWhere"],
	delete?: GraphQLTypes["BrandUniqueWhere"],
	alias?: string
};
	["ProductionMethodUpdateBrandsRelationInput"]: {
		by: GraphQLTypes["BrandUniqueWhere"],
	data: GraphQLTypes["BrandWithoutMethodOfProductionUpdateInput"]
};
	["BrandWithoutMethodOfProductionUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["BrandUpdateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandUpdateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandUpdateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandUpdateLogoEntityRelationInput"],
	distributor?: GraphQLTypes["BrandUpdateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandUpdateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandUpdateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandUpdateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandUpdateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductionMethodUpsertBrandsRelationInput"]: {
		by: GraphQLTypes["BrandUniqueWhere"],
	update: GraphQLTypes["BrandWithoutMethodOfProductionUpdateInput"],
	create: GraphQLTypes["BrandWithoutMethodOfProductionCreateInput"]
};
	["ProductLineCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["ProductLineCreateProductsEntityRelationInput"]>,
	remoteId?: string,
	lead?: string,
	order?: number,
	brand?: GraphQLTypes["ProductLineCreateBrandEntityRelationInput"],
	logo?: GraphQLTypes["ProductLineCreateLogoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ProductLineCreateAliasesEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["ProductLineCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["ProductLineCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	_dummy_field_?: boolean
};
	["ProductLineUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["ProductLineUpdateProductsEntityRelationInput"]>,
	remoteId?: string,
	lead?: string,
	order?: number,
	brand?: GraphQLTypes["ProductLineUpdateBrandEntityRelationInput"],
	logo?: GraphQLTypes["ProductLineUpdateLogoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ProductLineUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["ProductLineUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["ProductLineUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	_dummy_field_?: boolean
};
	["BreedCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["BreedCreateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedCreateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedCreateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedCreateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedCreateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedCreateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedCreateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreedUpdateInput"]: {
		dogs?: Array<GraphQLTypes["BreedUpdateDogsEntityRelationInput"]>,
	litterSize?: number,
	reviews?: Array<GraphQLTypes["BreedUpdateReviewsEntityRelationInput"]>,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedUpdateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedUpdateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedUpdateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["DogCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogCreateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogCreateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogCreateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogCreateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogCreateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogCreateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogCreateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogCreateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogCreateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogUpdateInput"]: {
		gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogUpdateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogUpdateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogUpdateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogUpdateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogUpdateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogUpdateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogUpdateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogUpdateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogUpdateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["UserConnection"]: {
	__typename: "UserConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserEdge"]>
};
	["UserEdge"]: {
	__typename: "UserEdge",
	node: GraphQLTypes["User"]
};
	["UserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["UserCreateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserCreateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserCreateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserCreateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserCreateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserCreateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserCreateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserCreateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserCreateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserCreateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserCreateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["UserUpdateInput"]: {
		dogs?: Array<GraphQLTypes["UserUpdateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserUpdateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserUpdateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserUpdateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserUpdateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserUpdateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserUpdateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserUpdateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserUpdateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserUpdateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["VeterinaryConnection"]: {
	__typename: "VeterinaryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VeterinaryEdge"]>
};
	["VeterinaryEdge"]: {
	__typename: "VeterinaryEdge",
	node: GraphQLTypes["Veterinary"]
};
	["VeterinaryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	user?: GraphQLTypes["VeterinaryCreateUserEntityRelationInput"],
	_dummy_field_?: boolean
};
	["VeterinaryCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutVeterinaryCreateInput"],
	connectOrCreate?: GraphQLTypes["VeterinaryConnectOrCreateUserRelationInput"]
};
	["UserWithoutVeterinaryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["UserCreateDogsEntityRelationInput"]>,
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserCreateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserCreateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserCreateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserCreateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserCreateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserCreateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserCreateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserCreateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserCreateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["VeterinaryConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutVeterinaryCreateInput"]
};
	["VeterinaryUpdateInput"]: {
		user?: GraphQLTypes["VeterinaryUpdateUserEntityRelationInput"],
	_dummy_field_?: boolean
};
	["VeterinaryUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutVeterinaryCreateInput"],
	connectOrCreate?: GraphQLTypes["VeterinaryConnectOrCreateUserRelationInput"],
	update?: GraphQLTypes["UserWithoutVeterinaryUpdateInput"],
	upsert?: GraphQLTypes["VeterinaryUpsertUserRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["UserWithoutVeterinaryUpdateInput"]: {
		dogs?: Array<GraphQLTypes["UserUpdateDogsEntityRelationInput"]>,
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserUpdateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserUpdateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserUpdateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserUpdateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserUpdateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserUpdateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserUpdateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserUpdateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["VeterinaryUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutVeterinaryUpdateInput"],
	create: GraphQLTypes["UserWithoutVeterinaryCreateInput"]
};
	["NutritionalValueOfProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	product?: GraphQLTypes["NutritionalValueOfProductCreateProductEntityRelationInput"],
	amount?: number,
	remoteId?: string,
	nutritionalValue?: GraphQLTypes["NutritionalValueOfProductCreateNutritionalValueEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NutritionalValueOfProductUpdateInput"]: {
		order?: number,
	product?: GraphQLTypes["NutritionalValueOfProductUpdateProductEntityRelationInput"],
	amount?: number,
	remoteId?: string,
	nutritionalValue?: GraphQLTypes["NutritionalValueOfProductUpdateNutritionalValueEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ReviewCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogBreeds?: Array<GraphQLTypes["ReviewCreateDogBreedsEntityRelationInput"]>,
	text?: string,
	remoteId?: string,
	author?: string,
	_dummy_field_?: boolean
};
	["ReviewCreateDogBreedsEntityRelationInput"]: {
		connect?: GraphQLTypes["BreedUniqueWhere"],
	create?: GraphQLTypes["BreedWithoutReviewsCreateInput"],
	connectOrCreate?: GraphQLTypes["ReviewConnectOrCreateDogBreedsRelationInput"],
	alias?: string
};
	["BreedWithoutReviewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["BreedCreateDogsEntityRelationInput"]>,
	litterSize?: number,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedCreateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedCreateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedCreateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedCreateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedCreateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ReviewConnectOrCreateDogBreedsRelationInput"]: {
		connect: GraphQLTypes["BreedUniqueWhere"],
	create: GraphQLTypes["BreedWithoutReviewsCreateInput"]
};
	["ReviewUpdateInput"]: {
		dogBreeds?: Array<GraphQLTypes["ReviewUpdateDogBreedsEntityRelationInput"]>,
	text?: string,
	remoteId?: string,
	author?: string,
	_dummy_field_?: boolean
};
	["ReviewUpdateDogBreedsEntityRelationInput"]: {
		create?: GraphQLTypes["BreedWithoutReviewsCreateInput"],
	update?: GraphQLTypes["ReviewUpdateDogBreedsRelationInput"],
	upsert?: GraphQLTypes["ReviewUpsertDogBreedsRelationInput"],
	connect?: GraphQLTypes["BreedUniqueWhere"],
	disconnect?: GraphQLTypes["BreedUniqueWhere"],
	delete?: GraphQLTypes["BreedUniqueWhere"],
	alias?: string
};
	["ReviewUpdateDogBreedsRelationInput"]: {
		by: GraphQLTypes["BreedUniqueWhere"],
	data: GraphQLTypes["BreedWithoutReviewsUpdateInput"]
};
	["BreedWithoutReviewsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["BreedUpdateDogsEntityRelationInput"]>,
	litterSize?: number,
	name?: string,
	dailyEnergyRequirement?: number,
	ages?: Array<GraphQLTypes["BreedUpdateAgesEntityRelationInput"]>,
	remoteId?: string,
	averageWeightFemale?: number,
	averageWeightMale?: number,
	suitabilityCategory?: GraphQLTypes["BreedUpdateSuitabilityCategoryEntityRelationInput"],
	productReviews?: Array<GraphQLTypes["BreedUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["BreedUpdateBlogPostReviewsEntityRelationInput"]>,
	labelFor?: string,
	size?: GraphQLTypes["BreedUpdateSizeEntityRelationInput"],
	slug?: string,
	filterCombos?: Array<GraphQLTypes["BreedUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ReviewUpsertDogBreedsRelationInput"]: {
		by: GraphQLTypes["BreedUniqueWhere"],
	update: GraphQLTypes["BreedWithoutReviewsUpdateInput"],
	create: GraphQLTypes["BreedWithoutReviewsCreateInput"]
};
	["DogBodyTypeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	lead?: string,
	dogs?: Array<GraphQLTypes["DogBodyTypeCreateDogsEntityRelationInput"]>,
	order?: number,
	value?: number,
	remoteId?: string,
	category?: GraphQLTypes["DogBodyTypeCreateCategoryEntityRelationInput"],
	imageMain?: GraphQLTypes["DogBodyTypeCreateImageMainEntityRelationInput"],
	imageFrom?: GraphQLTypes["DogBodyTypeCreateImageFromEntityRelationInput"],
	imageTo?: GraphQLTypes["DogBodyTypeCreateImageToEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogBodyTypeCreateDogsEntityRelationInput"]: {
		connect?: GraphQLTypes["DogUniqueWhere"],
	create?: GraphQLTypes["DogWithoutBodyTypeCreateInput"],
	connectOrCreate?: GraphQLTypes["DogBodyTypeConnectOrCreateDogsRelationInput"],
	alias?: string
};
	["DogWithoutBodyTypeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogCreateAgeEntityRelationInput"],
	owner?: GraphQLTypes["DogCreateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogCreateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogCreateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogCreateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogCreateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogCreateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogCreateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogBodyTypeConnectOrCreateDogsRelationInput"]: {
		connect: GraphQLTypes["DogUniqueWhere"],
	create: GraphQLTypes["DogWithoutBodyTypeCreateInput"]
};
	["DogBodyTypeUpdateInput"]: {
		name?: string,
	lead?: string,
	dogs?: Array<GraphQLTypes["DogBodyTypeUpdateDogsEntityRelationInput"]>,
	order?: number,
	value?: number,
	remoteId?: string,
	category?: GraphQLTypes["DogBodyTypeUpdateCategoryEntityRelationInput"],
	imageMain?: GraphQLTypes["DogBodyTypeUpdateImageMainEntityRelationInput"],
	imageFrom?: GraphQLTypes["DogBodyTypeUpdateImageFromEntityRelationInput"],
	imageTo?: GraphQLTypes["DogBodyTypeUpdateImageToEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogBodyTypeUpdateDogsEntityRelationInput"]: {
		create?: GraphQLTypes["DogWithoutBodyTypeCreateInput"],
	update?: GraphQLTypes["DogBodyTypeUpdateDogsRelationInput"],
	upsert?: GraphQLTypes["DogBodyTypeUpsertDogsRelationInput"],
	connect?: GraphQLTypes["DogUniqueWhere"],
	disconnect?: GraphQLTypes["DogUniqueWhere"],
	delete?: GraphQLTypes["DogUniqueWhere"],
	alias?: string
};
	["DogBodyTypeUpdateDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	data: GraphQLTypes["DogWithoutBodyTypeUpdateInput"]
};
	["DogWithoutBodyTypeUpdateInput"]: {
		gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogUpdateAgeEntityRelationInput"],
	owner?: GraphQLTypes["DogUpdateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogUpdateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogUpdateFedProductEntityRelationInput"],
	reproduction?: GraphQLTypes["DogUpdateReproductionEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogUpdateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogUpdateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogUpdateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogBodyTypeUpsertDogsRelationInput"]: {
		by: GraphQLTypes["DogUniqueWhere"],
	update: GraphQLTypes["DogWithoutBodyTypeUpdateInput"],
	create: GraphQLTypes["DogWithoutBodyTypeCreateInput"]
};
	["DogBodyTypeCategoryConnection"]: {
	__typename: "DogBodyTypeCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DogBodyTypeCategoryEdge"]>
};
	["DogBodyTypeCategoryEdge"]: {
	__typename: "DogBodyTypeCategoryEdge",
	node: GraphQLTypes["DogBodyTypeCategory"]
};
	["DogBodyTypeCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	items?: Array<GraphQLTypes["DogBodyTypeCategoryCreateItemsEntityRelationInput"]>,
	remoteId?: string,
	imageMain?: GraphQLTypes["DogBodyTypeCategoryCreateImageMainEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogBodyTypeCategoryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["DogBodyTypeUniqueWhere"],
	create?: GraphQLTypes["DogBodyTypeWithoutCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["DogBodyTypeCategoryConnectOrCreateItemsRelationInput"],
	alias?: string
};
	["DogBodyTypeWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	lead?: string,
	dogs?: Array<GraphQLTypes["DogBodyTypeCreateDogsEntityRelationInput"]>,
	order?: number,
	value?: number,
	remoteId?: string,
	imageMain?: GraphQLTypes["DogBodyTypeCreateImageMainEntityRelationInput"],
	imageFrom?: GraphQLTypes["DogBodyTypeCreateImageFromEntityRelationInput"],
	imageTo?: GraphQLTypes["DogBodyTypeCreateImageToEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogBodyTypeCategoryConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["DogBodyTypeUniqueWhere"],
	create: GraphQLTypes["DogBodyTypeWithoutCategoryCreateInput"]
};
	["DogBodyTypeCategoryUpdateInput"]: {
		name?: string,
	items?: Array<GraphQLTypes["DogBodyTypeCategoryUpdateItemsEntityRelationInput"]>,
	remoteId?: string,
	imageMain?: GraphQLTypes["DogBodyTypeCategoryUpdateImageMainEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogBodyTypeCategoryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["DogBodyTypeWithoutCategoryCreateInput"],
	update?: GraphQLTypes["DogBodyTypeCategoryUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["DogBodyTypeCategoryUpsertItemsRelationInput"],
	connect?: GraphQLTypes["DogBodyTypeUniqueWhere"],
	disconnect?: GraphQLTypes["DogBodyTypeUniqueWhere"],
	delete?: GraphQLTypes["DogBodyTypeUniqueWhere"],
	alias?: string
};
	["DogBodyTypeCategoryUpdateItemsRelationInput"]: {
		by: GraphQLTypes["DogBodyTypeUniqueWhere"],
	data: GraphQLTypes["DogBodyTypeWithoutCategoryUpdateInput"]
};
	["DogBodyTypeWithoutCategoryUpdateInput"]: {
		name?: string,
	lead?: string,
	dogs?: Array<GraphQLTypes["DogBodyTypeUpdateDogsEntityRelationInput"]>,
	order?: number,
	value?: number,
	remoteId?: string,
	imageMain?: GraphQLTypes["DogBodyTypeUpdateImageMainEntityRelationInput"],
	imageFrom?: GraphQLTypes["DogBodyTypeUpdateImageFromEntityRelationInput"],
	imageTo?: GraphQLTypes["DogBodyTypeUpdateImageToEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogBodyTypeCategoryUpsertItemsRelationInput"]: {
		by: GraphQLTypes["DogBodyTypeUniqueWhere"],
	update: GraphQLTypes["DogBodyTypeWithoutCategoryUpdateInput"],
	create: GraphQLTypes["DogBodyTypeWithoutCategoryCreateInput"]
};
	["LinkConnection"]: {
	__typename: "LinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
	__typename: "LinkEdge",
	node: GraphQLTypes["Link"]
};
	["Url"]: {
	__typename: "Url",
	_meta?: GraphQLTypes["UrlMeta"],
	id: GraphQLTypes["UUID"],
	url: string
};
	["UrlMeta"]: {
	__typename: "UrlMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"]
};
	["UrlUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["UrlWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["UrlWhere"] | undefined>,
	or?: Array<GraphQLTypes["UrlWhere"] | undefined>,
	not?: GraphQLTypes["UrlWhere"]
};
	["UrlOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"]
};
	["UrlConnection"]: {
	__typename: "UrlConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UrlEdge"]>
};
	["UrlEdge"]: {
	__typename: "UrlEdge",
	node: GraphQLTypes["Url"]
};
	["UrlCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	_dummy_field_?: boolean
};
	["UrlUpdateInput"]: {
		url?: string,
	_dummy_field_?: boolean
};
	["Footer"]: {
	__typename: "Footer",
	_meta?: GraphQLTypes["FooterMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	items: Array<GraphQLTypes["FooterLink"]>,
	copyright?: string,
	paginateItems: GraphQLTypes["FooterLinkConnection"]
};
	["FooterMeta"]: {
	__typename: "FooterMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	copyright?: GraphQLTypes["FieldMeta"]
};
	["FooterLink"]: {
	__typename: "FooterLink",
	_meta?: GraphQLTypes["FooterLinkMeta"],
	id: GraphQLTypes["UUID"],
	label: string,
	order: number,
	footer?: GraphQLTypes["Footer"],
	link?: string,
	targetBlank?: boolean
};
	["FooterLinkMeta"]: {
	__typename: "FooterLinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	footer?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	targetBlank?: GraphQLTypes["FieldMeta"]
};
	["FooterWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	items?: GraphQLTypes["FooterLinkWhere"],
	copyright?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	not?: GraphQLTypes["FooterWhere"]
};
	["FooterLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	label?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	footer?: GraphQLTypes["FooterWhere"],
	link?: GraphQLTypes["StringCondition"],
	targetBlank?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["FooterLinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterLinkWhere"] | undefined>,
	not?: GraphQLTypes["FooterLinkWhere"]
};
	["FooterLinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	footer?: GraphQLTypes["FooterOrderBy"],
	link?: GraphQLTypes["OrderDirection"],
	targetBlank?: GraphQLTypes["OrderDirection"]
};
	["FooterOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	copyright?: GraphQLTypes["OrderDirection"]
};
	["FooterLinkConnection"]: {
	__typename: "FooterLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterLinkEdge"]>
};
	["FooterLinkEdge"]: {
	__typename: "FooterLinkEdge",
	node: GraphQLTypes["FooterLink"]
};
	["FooterUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	items?: GraphQLTypes["FooterLinkUniqueWhere"]
};
	["FooterLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["FooterConnection"]: {
	__typename: "FooterConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterEdge"]>
};
	["FooterEdge"]: {
	__typename: "FooterEdge",
	node: GraphQLTypes["Footer"]
};
	["FooterCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	items?: Array<GraphQLTypes["FooterCreateItemsEntityRelationInput"]>,
	copyright?: string,
	_dummy_field_?: boolean
};
	["FooterCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLinkUniqueWhere"],
	create?: GraphQLTypes["FooterLinkWithoutFooterCreateInput"],
	connectOrCreate?: GraphQLTypes["FooterConnectOrCreateItemsRelationInput"],
	alias?: string
};
	["FooterLinkWithoutFooterCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: string,
	order?: number,
	link?: string,
	targetBlank?: boolean,
	_dummy_field_?: boolean
};
	["FooterConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["FooterLinkUniqueWhere"],
	create: GraphQLTypes["FooterLinkWithoutFooterCreateInput"]
};
	["FooterUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	items?: Array<GraphQLTypes["FooterUpdateItemsEntityRelationInput"]>,
	copyright?: string,
	_dummy_field_?: boolean
};
	["FooterUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLinkWithoutFooterCreateInput"],
	update?: GraphQLTypes["FooterUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["FooterUpsertItemsRelationInput"],
	connect?: GraphQLTypes["FooterLinkUniqueWhere"],
	disconnect?: GraphQLTypes["FooterLinkUniqueWhere"],
	delete?: GraphQLTypes["FooterLinkUniqueWhere"],
	alias?: string
};
	["FooterUpdateItemsRelationInput"]: {
		by: GraphQLTypes["FooterLinkUniqueWhere"],
	data: GraphQLTypes["FooterLinkWithoutFooterUpdateInput"]
};
	["FooterLinkWithoutFooterUpdateInput"]: {
		label?: string,
	order?: number,
	link?: string,
	targetBlank?: boolean,
	_dummy_field_?: boolean
};
	["FooterUpsertItemsRelationInput"]: {
		by: GraphQLTypes["FooterLinkUniqueWhere"],
	update: GraphQLTypes["FooterLinkWithoutFooterUpdateInput"],
	create: GraphQLTypes["FooterLinkWithoutFooterCreateInput"]
};
	["FooterLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: string,
	order?: number,
	footer?: GraphQLTypes["FooterLinkCreateFooterEntityRelationInput"],
	link?: string,
	targetBlank?: boolean,
	_dummy_field_?: boolean
};
	["FooterLinkCreateFooterEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterUniqueWhere"],
	create?: GraphQLTypes["FooterWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["FooterLinkConnectOrCreateFooterRelationInput"]
};
	["FooterWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	copyright?: string,
	_dummy_field_?: boolean
};
	["FooterLinkConnectOrCreateFooterRelationInput"]: {
		connect: GraphQLTypes["FooterUniqueWhere"],
	create: GraphQLTypes["FooterWithoutItemsCreateInput"]
};
	["FooterLinkUpdateInput"]: {
		label?: string,
	order?: number,
	footer?: GraphQLTypes["FooterLinkUpdateFooterEntityRelationInput"],
	link?: string,
	targetBlank?: boolean,
	_dummy_field_?: boolean
};
	["FooterLinkUpdateFooterEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterUniqueWhere"],
	create?: GraphQLTypes["FooterWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["FooterLinkConnectOrCreateFooterRelationInput"],
	update?: GraphQLTypes["FooterWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["FooterLinkUpsertFooterRelationInput"],
	delete?: boolean
};
	["FooterWithoutItemsUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	copyright?: string,
	_dummy_field_?: boolean
};
	["FooterLinkUpsertFooterRelationInput"]: {
		update: GraphQLTypes["FooterWithoutItemsUpdateInput"],
	create: GraphQLTypes["FooterWithoutItemsCreateInput"]
};
	["BrandsPageConnection"]: {
	__typename: "BrandsPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BrandsPageEdge"]>
};
	["BrandsPageEdge"]: {
	__typename: "BrandsPageEdge",
	node: GraphQLTypes["BrandsPage"]
};
	["BrandsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	redirects?: Array<GraphQLTypes["BrandsPageCreateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandsPageCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["BrandsPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandsPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandsPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	redirects?: Array<GraphQLTypes["BrandsPageUpdateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandsPageUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["BrandsPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandsPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageConnection"]: {
	__typename: "HomePageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HomePageEdge"]>
};
	["HomePageEdge"]: {
	__typename: "HomePageEdge",
	node: GraphQLTypes["HomePage"]
};
	["HomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["HomePageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutHomePageCreateInput"],
	connectOrCreate?: GraphQLTypes["HomePageConnectOrCreateSeoRelationInput"]
};
	["SeoWithoutHomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoCreateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoCreateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoCreateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoCreateGenericPageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoCreateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoCreateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoCreateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoCreateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoCreateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoCreateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["HomePageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoWithoutHomePageCreateInput"]
};
	["HomePageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutHomePageCreateInput"],
	connectOrCreate?: GraphQLTypes["HomePageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoWithoutHomePageUpdateInput"],
	upsert?: GraphQLTypes["HomePageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoWithoutHomePageUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoUpdateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoUpdateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoUpdateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoUpdateGenericPageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoUpdateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoUpdateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoUpdateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoUpdateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoUpdateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoUpdateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["HomePageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoWithoutHomePageUpdateInput"],
	create: GraphQLTypes["SeoWithoutHomePageCreateInput"]
};
	["IngredientsPageConnection"]: {
	__typename: "IngredientsPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IngredientsPageEdge"]>
};
	["IngredientsPageEdge"]: {
	__typename: "IngredientsPageEdge",
	node: GraphQLTypes["IngredientsPage"]
};
	["IngredientsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["IngredientsPageCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["IngredientsPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["IngredientsPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["IngredientsPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutIngredientsPageCreateInput"],
	connectOrCreate?: GraphQLTypes["IngredientsPageConnectOrCreateSeoRelationInput"]
};
	["SeoWithoutIngredientsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoCreateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoCreateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoCreateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoCreateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoCreateHomePageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoCreateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoCreateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoCreateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoCreateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoCreateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["IngredientsPageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoWithoutIngredientsPageCreateInput"]
};
	["IngredientsPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	seo?: GraphQLTypes["IngredientsPageUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["IngredientsPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["IngredientsPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["IngredientsPageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutIngredientsPageCreateInput"],
	connectOrCreate?: GraphQLTypes["IngredientsPageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoWithoutIngredientsPageUpdateInput"],
	upsert?: GraphQLTypes["IngredientsPageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoWithoutIngredientsPageUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoUpdateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoUpdateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoUpdateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoUpdateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoUpdateHomePageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoUpdateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoUpdateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoUpdateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoUpdateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoUpdateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["IngredientsPageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoWithoutIngredientsPageUpdateInput"],
	create: GraphQLTypes["SeoWithoutIngredientsPageCreateInput"]
};
	["ProductReviewCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions?: Array<GraphQLTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"]>,
	score?: GraphQLTypes["ProductReviewCreateScoreEntityRelationInput"],
	product?: GraphQLTypes["ProductReviewCreateProductEntityRelationInput"],
	user?: GraphQLTypes["ProductReviewCreateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["ProductReviewCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["ProductReviewCreateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ProductReviewUpdateInput"]: {
		text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions?: Array<GraphQLTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"]>,
	score?: GraphQLTypes["ProductReviewUpdateScoreEntityRelationInput"],
	product?: GraphQLTypes["ProductReviewUpdateProductEntityRelationInput"],
	user?: GraphQLTypes["ProductReviewUpdateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["ProductReviewUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["ProductReviewUpdateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ScoreConnection"]: {
	__typename: "ScoreConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ScoreEdge"]>
};
	["ScoreEdge"]: {
	__typename: "ScoreEdge",
	node: GraphQLTypes["Score"]
};
	["ScoreCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: string,
	productReviews?: Array<GraphQLTypes["ScoreCreateProductReviewsEntityRelationInput"]>,
	starsAmount?: number,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ScoreCreateProductReviewsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductReviewUniqueWhere"],
	create?: GraphQLTypes["ProductReviewWithoutScoreCreateInput"],
	connectOrCreate?: GraphQLTypes["ScoreConnectOrCreateProductReviewsRelationInput"],
	alias?: string
};
	["ProductReviewWithoutScoreCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions?: Array<GraphQLTypes["ProductReviewCreateProductReviewReactionsEntityRelationInput"]>,
	product?: GraphQLTypes["ProductReviewCreateProductEntityRelationInput"],
	user?: GraphQLTypes["ProductReviewCreateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["ProductReviewCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["ProductReviewCreateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ScoreConnectOrCreateProductReviewsRelationInput"]: {
		connect: GraphQLTypes["ProductReviewUniqueWhere"],
	create: GraphQLTypes["ProductReviewWithoutScoreCreateInput"]
};
	["ScoreUpdateInput"]: {
		label?: string,
	productReviews?: Array<GraphQLTypes["ScoreUpdateProductReviewsEntityRelationInput"]>,
	starsAmount?: number,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ScoreUpdateProductReviewsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductReviewWithoutScoreCreateInput"],
	update?: GraphQLTypes["ScoreUpdateProductReviewsRelationInput"],
	upsert?: GraphQLTypes["ScoreUpsertProductReviewsRelationInput"],
	connect?: GraphQLTypes["ProductReviewUniqueWhere"],
	disconnect?: GraphQLTypes["ProductReviewUniqueWhere"],
	delete?: GraphQLTypes["ProductReviewUniqueWhere"],
	alias?: string
};
	["ScoreUpdateProductReviewsRelationInput"]: {
		by: GraphQLTypes["ProductReviewUniqueWhere"],
	data: GraphQLTypes["ProductReviewWithoutScoreUpdateInput"]
};
	["ProductReviewWithoutScoreUpdateInput"]: {
		text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	productReviewReactions?: Array<GraphQLTypes["ProductReviewUpdateProductReviewReactionsEntityRelationInput"]>,
	product?: GraphQLTypes["ProductReviewUpdateProductEntityRelationInput"],
	user?: GraphQLTypes["ProductReviewUpdateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["ProductReviewUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["ProductReviewUpdateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["ScoreUpsertProductReviewsRelationInput"]: {
		by: GraphQLTypes["ProductReviewUniqueWhere"],
	update: GraphQLTypes["ProductReviewWithoutScoreUpdateInput"],
	create: GraphQLTypes["ProductReviewWithoutScoreCreateInput"]
};
	["AgeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["AgeCreateDogsEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["AgeCreateBreedsEntityRelationInput"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	suitabilityCategories?: Array<GraphQLTypes["AgeCreateSuitabilityCategoriesEntityRelationInput"]>,
	remoteId?: string,
	productReviews?: Array<GraphQLTypes["AgeCreateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["AgeCreateBlogPostReviewsEntityRelationInput"]>,
	label?: string,
	categoryOrder?: string,
	_dummy_field_?: boolean
};
	["AgeUpdateInput"]: {
		dogs?: Array<GraphQLTypes["AgeUpdateDogsEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["AgeUpdateBreedsEntityRelationInput"]>,
	ageRange?: GraphQLTypes["AgeRangeType"],
	categoryLabel?: GraphQLTypes["AgeLabelType"],
	suitabilityCategories?: Array<GraphQLTypes["AgeUpdateSuitabilityCategoriesEntityRelationInput"]>,
	remoteId?: string,
	productReviews?: Array<GraphQLTypes["AgeUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviews?: Array<GraphQLTypes["AgeUpdateBlogPostReviewsEntityRelationInput"]>,
	label?: string,
	categoryOrder?: string,
	_dummy_field_?: boolean
};
	["CountryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	brands?: Array<GraphQLTypes["CountryCreateBrandsEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["CountryCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	region?: GraphQLTypes["CountryCreateRegionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["CountryUpdateInput"]: {
		name?: string,
	brands?: Array<GraphQLTypes["CountryUpdateBrandsEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["CountryUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	region?: GraphQLTypes["CountryUpdateRegionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostReviewCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostReviewReactions?: Array<GraphQLTypes["BlogPostReviewCreateBlogPostReviewReactionsEntityRelationInput"]>,
	blogPost?: GraphQLTypes["BlogPostReviewCreateBlogPostEntityRelationInput"],
	user?: GraphQLTypes["BlogPostReviewCreateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["BlogPostReviewCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["BlogPostReviewCreateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["BlogPostReviewUpdateInput"]: {
		title?: string,
	text?: string,
	publishedAt?: GraphQLTypes["DateTime"],
	blogPostReviewReactions?: Array<GraphQLTypes["BlogPostReviewUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	blogPost?: GraphQLTypes["BlogPostReviewUpdateBlogPostEntityRelationInput"],
	user?: GraphQLTypes["BlogPostReviewUpdateUserEntityRelationInput"],
	fullName?: string,
	breed?: GraphQLTypes["BlogPostReviewUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["BlogPostReviewUpdateAgeEntityRelationInput"],
	url?: string,
	isVisible?: boolean,
	response?: string,
	_dummy_field_?: boolean
};
	["DogActivityCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: string,
	dogs?: Array<GraphQLTypes["DogActivityCreateDogsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["DogActivityCreateProductsEntityRelationInput"]>,
	dailyEnergyRequirementCoeficient?: number,
	remoteId?: string,
	suitabilityCategory?: GraphQLTypes["DogActivityCreateSuitabilityCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogActivityUpdateInput"]: {
		label?: string,
	dogs?: Array<GraphQLTypes["DogActivityUpdateDogsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["DogActivityUpdateProductsEntityRelationInput"]>,
	dailyEnergyRequirementCoeficient?: number,
	remoteId?: string,
	suitabilityCategory?: GraphQLTypes["DogActivityUpdateSuitabilityCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["Social"]: {
	__typename: "Social",
	_meta?: GraphQLTypes["SocialMeta"],
	id: GraphQLTypes["UUID"],
	label: GraphQLTypes["SocialType"],
	link?: string
};
	["SocialMeta"]: {
	__typename: "SocialMeta",
	id?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["SocialType"]: SocialType;
	["SocialUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SocialWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	label?: GraphQLTypes["SocialTypeCondition"],
	link?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["SocialWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialWhere"] | undefined>,
	not?: GraphQLTypes["SocialWhere"]
};
	["SocialTypeCondition"]: {
		and?: Array<GraphQLTypes["SocialTypeCondition"]>,
	or?: Array<GraphQLTypes["SocialTypeCondition"]>,
	not?: GraphQLTypes["SocialTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["SocialType"],
	notEq?: GraphQLTypes["SocialType"],
	in?: Array<GraphQLTypes["SocialType"]>,
	notIn?: Array<GraphQLTypes["SocialType"]>,
	lt?: GraphQLTypes["SocialType"],
	lte?: GraphQLTypes["SocialType"],
	gt?: GraphQLTypes["SocialType"],
	gte?: GraphQLTypes["SocialType"]
};
	["SocialOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["OrderDirection"]
};
	["SocialConnection"]: {
	__typename: "SocialConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialEdge"]>
};
	["SocialEdge"]: {
	__typename: "SocialEdge",
	node: GraphQLTypes["Social"]
};
	["SocialCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: GraphQLTypes["SocialType"],
	link?: string,
	_dummy_field_?: boolean
};
	["SocialUpdateInput"]: {
		label?: GraphQLTypes["SocialType"],
	link?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceGalleryImageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	reference?: GraphQLTypes["ContentReferenceGalleryImageCreateReferenceEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceGalleryImageCreateImageEntityRelationInput"],
	lead?: string,
	alignment?: GraphQLTypes["AlignmentType"],
	_dummy_field_?: boolean
};
	["ContentReferenceGalleryImageCreateReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutImagesCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceGalleryImageConnectOrCreateReferenceRelationInput"]
};
	["ContentReferenceWithoutImagesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fact?: string,
	relatedBlogPost?: GraphQLTypes["ContentReferenceCreateRelatedBlogPostEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceCreateRelatedBrandEntityRelationInput"],
	relatedProduct?: GraphQLTypes["ContentReferenceCreateRelatedProductEntityRelationInput"],
	relatedIngredient?: GraphQLTypes["ContentReferenceCreateRelatedIngredientEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	badge?: string,
	longVersion?: boolean,
	relatedBrandFull?: GraphQLTypes["ContentReferenceCreateRelatedBrandFullEntityRelationInput"],
	relatedProductFull?: GraphQLTypes["ContentReferenceCreateRelatedProductFullEntityRelationInput"],
	list?: Array<GraphQLTypes["ContentReferenceCreateListEntityRelationInput"]>,
	outline?: GraphQLTypes["ContentReferenceCreateOutlineEntityRelationInput"],
	video?: GraphQLTypes["ContentReferenceCreateVideoEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	defaultOpen?: boolean,
	badgeColor?: string,
	isMain?: boolean,
	ad?: GraphQLTypes["ContentReferenceCreateAdEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceGalleryImageConnectOrCreateReferenceRelationInput"]: {
		connect: GraphQLTypes["ContentReferenceUniqueWhere"],
	create: GraphQLTypes["ContentReferenceWithoutImagesCreateInput"]
};
	["ContentReferenceGalleryImageUpdateInput"]: {
		order?: number,
	reference?: GraphQLTypes["ContentReferenceGalleryImageUpdateReferenceEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceGalleryImageUpdateImageEntityRelationInput"],
	lead?: string,
	alignment?: GraphQLTypes["AlignmentType"],
	_dummy_field_?: boolean
};
	["ContentReferenceGalleryImageUpdateReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutImagesCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceGalleryImageConnectOrCreateReferenceRelationInput"],
	update?: GraphQLTypes["ContentReferenceWithoutImagesUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceGalleryImageUpsertReferenceRelationInput"],
	delete?: boolean
};
	["ContentReferenceWithoutImagesUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fact?: string,
	relatedBlogPost?: GraphQLTypes["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceUpdateRelatedBrandEntityRelationInput"],
	relatedProduct?: GraphQLTypes["ContentReferenceUpdateRelatedProductEntityRelationInput"],
	relatedIngredient?: GraphQLTypes["ContentReferenceUpdateRelatedIngredientEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	badge?: string,
	longVersion?: boolean,
	relatedBrandFull?: GraphQLTypes["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"],
	relatedProductFull?: GraphQLTypes["ContentReferenceUpdateRelatedProductFullEntityRelationInput"],
	list?: Array<GraphQLTypes["ContentReferenceUpdateListEntityRelationInput"]>,
	outline?: GraphQLTypes["ContentReferenceUpdateOutlineEntityRelationInput"],
	video?: GraphQLTypes["ContentReferenceUpdateVideoEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	defaultOpen?: boolean,
	badgeColor?: string,
	isMain?: boolean,
	ad?: GraphQLTypes["ContentReferenceUpdateAdEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceGalleryImageUpsertReferenceRelationInput"]: {
		update: GraphQLTypes["ContentReferenceWithoutImagesUpdateInput"],
	create: GraphQLTypes["ContentReferenceWithoutImagesCreateInput"]
};
	["ItemCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryCreateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryCreateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryCreateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryCreateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryCreateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryCreateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryCreateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemCategoryUpdateInput"]: {
		name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryUpdateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryUpdateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryUpdateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryUpdateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryUpdateSeoEntityRelationInput"],
	group?: GraphQLTypes["ItemCategoryUpdateGroupEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemFlavorCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	items?: Array<GraphQLTypes["ItemFlavorCategoryCreateItemsEntityRelationInput"]>,
	remoteId?: string,
	color?: GraphQLTypes["ItemFlavorCategoryCreateColorEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemFlavorCategoryUpdateInput"]: {
		name?: string,
	items?: Array<GraphQLTypes["ItemFlavorCategoryUpdateItemsEntityRelationInput"]>,
	remoteId?: string,
	color?: GraphQLTypes["ItemFlavorCategoryUpdateColorEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemDeclensionFourthVariantCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ItemDeclensionFourthVariantCreateItemsEntityRelationInput"]>,
	label?: string,
	remoteId?: string,
	declensionSeventh?: string,
	isNegativ?: boolean,
	seo?: GraphQLTypes["ItemDeclensionFourthVariantCreateSeoEntityRelationInput"],
	subcategory?: GraphQLTypes["ItemDeclensionFourthVariantCreateSubcategoryEntityRelationInput"],
	category?: GraphQLTypes["ItemDeclensionFourthVariantCreateCategoryEntityRelationInput"],
	element?: GraphQLTypes["ItemDeclensionFourthVariantCreateElementEntityRelationInput"],
	products?: Array<GraphQLTypes["ItemDeclensionFourthVariantCreateProductsEntityRelationInput"]>,
	slug?: string,
	content?: GraphQLTypes["ItemDeclensionFourthVariantCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemDeclensionFourthVariantCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemDeclensionFourthVariantUpdateInput"]: {
		items?: Array<GraphQLTypes["ItemDeclensionFourthVariantUpdateItemsEntityRelationInput"]>,
	label?: string,
	remoteId?: string,
	declensionSeventh?: string,
	isNegativ?: boolean,
	seo?: GraphQLTypes["ItemDeclensionFourthVariantUpdateSeoEntityRelationInput"],
	subcategory?: GraphQLTypes["ItemDeclensionFourthVariantUpdateSubcategoryEntityRelationInput"],
	category?: GraphQLTypes["ItemDeclensionFourthVariantUpdateCategoryEntityRelationInput"],
	element?: GraphQLTypes["ItemDeclensionFourthVariantUpdateElementEntityRelationInput"],
	products?: Array<GraphQLTypes["ItemDeclensionFourthVariantUpdateProductsEntityRelationInput"]>,
	slug?: string,
	content?: GraphQLTypes["ItemDeclensionFourthVariantUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemDeclensionFourthVariantUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemDeclensionSeventhVariantConnection"]: {
	__typename: "ItemDeclensionSeventhVariantConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ItemDeclensionSeventhVariantEdge"]>
};
	["ItemDeclensionSeventhVariantEdge"]: {
	__typename: "ItemDeclensionSeventhVariantEdge",
	node: GraphQLTypes["ItemDeclensionSeventhVariant"]
};
	["ItemDeclensionSeventhVariantCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ItemDeclensionSeventhVariantCreateItemsEntityRelationInput"]>,
	label?: string,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ItemDeclensionSeventhVariantCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemWithoutDeclensionSeventhCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemDeclensionSeventhVariantConnectOrCreateItemsRelationInput"],
	alias?: string
};
	["ItemWithoutDeclensionSeventhCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemCreateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemCreateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemCreateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemCreateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemCreateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemCreateDeclensionFourthEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemCreateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemCreateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemDeclensionSeventhVariantConnectOrCreateItemsRelationInput"]: {
		connect: GraphQLTypes["ItemUniqueWhere"],
	create: GraphQLTypes["ItemWithoutDeclensionSeventhCreateInput"]
};
	["ItemDeclensionSeventhVariantUpdateInput"]: {
		items?: Array<GraphQLTypes["ItemDeclensionSeventhVariantUpdateItemsEntityRelationInput"]>,
	label?: string,
	remoteId?: string,
	_dummy_field_?: boolean
};
	["ItemDeclensionSeventhVariantUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ItemWithoutDeclensionSeventhCreateInput"],
	update?: GraphQLTypes["ItemDeclensionSeventhVariantUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ItemDeclensionSeventhVariantUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ItemUniqueWhere"],
	disconnect?: GraphQLTypes["ItemUniqueWhere"],
	delete?: GraphQLTypes["ItemUniqueWhere"],
	alias?: string
};
	["ItemDeclensionSeventhVariantUpdateItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	data: GraphQLTypes["ItemWithoutDeclensionSeventhUpdateInput"]
};
	["ItemWithoutDeclensionSeventhUpdateInput"]: {
		name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemUpdateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemUpdateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemUpdateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemUpdateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemUpdateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemUpdateDeclensionFourthEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemUpdateSeoEntityRelationInput"],
	aliases?: Array<GraphQLTypes["ItemUpdateAliasesEntityRelationInput"]>,
	content?: GraphQLTypes["ItemUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemDeclensionSeventhVariantUpsertItemsRelationInput"]: {
		by: GraphQLTypes["ItemUniqueWhere"],
	update: GraphQLTypes["ItemWithoutDeclensionSeventhUpdateInput"],
	create: GraphQLTypes["ItemWithoutDeclensionSeventhCreateInput"]
};
	["MediaCard"]: {
	__typename: "MediaCard",
	_meta?: GraphQLTypes["MediaCardMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	lead: string,
	buttonLabel: string,
	image?: GraphQLTypes["Image"],
	link?: string,
	order?: number
};
	["MediaCardMeta"]: {
	__typename: "MediaCardMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	buttonLabel?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"]
};
	["MediaCardUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"]
};
	["MediaCardWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	lead?: GraphQLTypes["StringCondition"],
	buttonLabel?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	link?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	and?: Array<GraphQLTypes["MediaCardWhere"] | undefined>,
	or?: Array<GraphQLTypes["MediaCardWhere"] | undefined>,
	not?: GraphQLTypes["MediaCardWhere"]
};
	["MediaCardOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	buttonLabel?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	link?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"]
};
	["MediaCardConnection"]: {
	__typename: "MediaCardConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediaCardEdge"]>
};
	["MediaCardEdge"]: {
	__typename: "MediaCardEdge",
	node: GraphQLTypes["MediaCard"]
};
	["MediaCardCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	lead?: string,
	buttonLabel?: string,
	image?: GraphQLTypes["MediaCardCreateImageEntityRelationInput"],
	link?: string,
	order?: number,
	_dummy_field_?: boolean
};
	["MediaCardCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["MediaCardConnectOrCreateImageRelationInput"]
};
	["MediaCardConnectOrCreateImageRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["MediaCardUpdateInput"]: {
		title?: string,
	lead?: string,
	buttonLabel?: string,
	image?: GraphQLTypes["MediaCardUpdateImageEntityRelationInput"],
	link?: string,
	order?: number,
	_dummy_field_?: boolean
};
	["MediaCardUpdateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["MediaCardConnectOrCreateImageRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["MediaCardUpsertImageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["MediaCardUpsertImageRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["InfoCard"]: {
	__typename: "InfoCard",
	_meta?: GraphQLTypes["InfoCardMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	lead: string,
	order?: number
};
	["InfoCardMeta"]: {
	__typename: "InfoCardMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"]
};
	["InfoCardUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["InfoCardWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	lead?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	and?: Array<GraphQLTypes["InfoCardWhere"] | undefined>,
	or?: Array<GraphQLTypes["InfoCardWhere"] | undefined>,
	not?: GraphQLTypes["InfoCardWhere"]
};
	["InfoCardOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"]
};
	["InfoCardConnection"]: {
	__typename: "InfoCardConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["InfoCardEdge"]>
};
	["InfoCardEdge"]: {
	__typename: "InfoCardEdge",
	node: GraphQLTypes["InfoCard"]
};
	["InfoCardCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	lead?: string,
	order?: number,
	_dummy_field_?: boolean
};
	["InfoCardUpdateInput"]: {
		title?: string,
	lead?: string,
	order?: number,
	_dummy_field_?: boolean
};
	["NumberedCard"]: {
	__typename: "NumberedCard",
	_meta?: GraphQLTypes["NumberedCardMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	lead: string,
	order?: number,
	link?: string
};
	["NumberedCardMeta"]: {
	__typename: "NumberedCardMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	lead?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["NumberedCardUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["NumberedCardWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	lead?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["NumberedCardWhere"] | undefined>,
	or?: Array<GraphQLTypes["NumberedCardWhere"] | undefined>,
	not?: GraphQLTypes["NumberedCardWhere"]
};
	["NumberedCardOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	lead?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["OrderDirection"]
};
	["NumberedCardConnection"]: {
	__typename: "NumberedCardConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NumberedCardEdge"]>
};
	["NumberedCardEdge"]: {
	__typename: "NumberedCardEdge",
	node: GraphQLTypes["NumberedCard"]
};
	["NumberedCardCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	lead?: string,
	order?: number,
	link?: string,
	_dummy_field_?: boolean
};
	["NumberedCardUpdateInput"]: {
		title?: string,
	lead?: string,
	order?: number,
	link?: string,
	_dummy_field_?: boolean
};
	["RegisterClaim"]: {
	__typename: "RegisterClaim",
	_meta?: GraphQLTypes["RegisterClaimMeta"],
	id: GraphQLTypes["UUID"],
	text: string,
	order?: number
};
	["RegisterClaimMeta"]: {
	__typename: "RegisterClaimMeta",
	id?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"]
};
	["RegisterClaimUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["RegisterClaimWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	text?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	and?: Array<GraphQLTypes["RegisterClaimWhere"] | undefined>,
	or?: Array<GraphQLTypes["RegisterClaimWhere"] | undefined>,
	not?: GraphQLTypes["RegisterClaimWhere"]
};
	["RegisterClaimOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"]
};
	["RegisterClaimConnection"]: {
	__typename: "RegisterClaimConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RegisterClaimEdge"]>
};
	["RegisterClaimEdge"]: {
	__typename: "RegisterClaimEdge",
	node: GraphQLTypes["RegisterClaim"]
};
	["RegisterClaimCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	order?: number,
	_dummy_field_?: boolean
};
	["RegisterClaimUpdateInput"]: {
		text?: string,
	order?: number,
	_dummy_field_?: boolean
};
	["BlogPostReviewReactionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	sentiment?: GraphQLTypes["SentimentType"],
	user?: GraphQLTypes["BlogPostReviewReactionCreateUserEntityRelationInput"],
	blogPostReview?: GraphQLTypes["BlogPostReviewReactionCreateBlogPostReviewEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BlogPostReviewReactionUpdateInput"]: {
		sentiment?: GraphQLTypes["SentimentType"],
	user?: GraphQLTypes["BlogPostReviewReactionUpdateUserEntityRelationInput"],
	blogPostReview?: GraphQLTypes["BlogPostReviewReactionUpdateBlogPostReviewEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductReviewReactionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	sentiment?: GraphQLTypes["SentimentType"],
	user?: GraphQLTypes["ProductReviewReactionCreateUserEntityRelationInput"],
	productReview?: GraphQLTypes["ProductReviewReactionCreateProductReviewEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductReviewReactionUpdateInput"]: {
		sentiment?: GraphQLTypes["SentimentType"],
	user?: GraphQLTypes["ProductReviewReactionUpdateUserEntityRelationInput"],
	productReview?: GraphQLTypes["ProductReviewReactionUpdateProductReviewEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductPackageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	price?: number,
	order?: number,
	link?: string,
	product?: GraphQLTypes["ProductPackageCreateProductEntityRelationInput"],
	amount?: number,
	externalId?: string,
	remoteId?: string,
	label?: string,
	positionId?: string,
	heurekaPrice?: number,
	heurekaLink?: string,
	_dummy_field_?: boolean
};
	["ProductPackageCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutPackagingsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductPackageConnectOrCreateProductRelationInput"]
};
	["ProductWithoutPackagingsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductPackageConnectOrCreateProductRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutPackagingsCreateInput"]
};
	["ProductPackageUpdateInput"]: {
		price?: number,
	order?: number,
	link?: string,
	product?: GraphQLTypes["ProductPackageUpdateProductEntityRelationInput"],
	amount?: number,
	externalId?: string,
	remoteId?: string,
	label?: string,
	positionId?: string,
	heurekaPrice?: number,
	heurekaLink?: string,
	_dummy_field_?: boolean
};
	["ProductPackageUpdateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutPackagingsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductPackageConnectOrCreateProductRelationInput"],
	update?: GraphQLTypes["ProductWithoutPackagingsUpdateInput"],
	upsert?: GraphQLTypes["ProductPackageUpsertProductRelationInput"],
	delete?: boolean
};
	["ProductWithoutPackagingsUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductPackageUpsertProductRelationInput"]: {
		update: GraphQLTypes["ProductWithoutPackagingsUpdateInput"],
	create: GraphQLTypes["ProductWithoutPackagingsCreateInput"]
};
	["BrandManufacturerCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	link?: string,
	brands?: Array<GraphQLTypes["BrandManufacturerCreateBrandsEntityRelationInput"]>,
	order?: number,
	remoteId?: string,
	residence?: GraphQLTypes["BrandManufacturerCreateResidenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandManufacturerUpdateInput"]: {
		name?: string,
	link?: string,
	brands?: Array<GraphQLTypes["BrandManufacturerUpdateBrandsEntityRelationInput"]>,
	order?: number,
	remoteId?: string,
	residence?: GraphQLTypes["BrandManufacturerUpdateResidenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ElementConnection"]: {
	__typename: "ElementConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ElementEdge"]>
};
	["ElementEdge"]: {
	__typename: "ElementEdge",
	node: GraphQLTypes["Element"]
};
	["ElementOfProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	amount?: number,
	product?: GraphQLTypes["ElementOfProductCreateProductEntityRelationInput"],
	remoteId?: string,
	element?: GraphQLTypes["ElementOfProductCreateElementEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ElementOfProductUpdateInput"]: {
		order?: number,
	amount?: number,
	product?: GraphQLTypes["ElementOfProductUpdateProductEntityRelationInput"],
	remoteId?: string,
	element?: GraphQLTypes["ElementOfProductUpdateElementEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SuitabilityCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	dogSizes?: Array<GraphQLTypes["SuitabilityCategoryCreateDogSizesEntityRelationInput"]>,
	dogActivities?: Array<GraphQLTypes["SuitabilityCategoryCreateDogActivitiesEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["SuitabilityCategoryCreateBreedsEntityRelationInput"]>,
	suitabilityItems?: Array<GraphQLTypes["SuitabilityCategoryCreateSuitabilityItemsEntityRelationInput"]>,
	dogAges?: Array<GraphQLTypes["SuitabilityCategoryCreateDogAgesEntityRelationInput"]>,
	isPregnant?: boolean,
	remoteId?: string,
	isBreastfeeding?: boolean,
	_dummy_field_?: boolean
};
	["SuitabilityCategoryUpdateInput"]: {
		name?: string,
	dogSizes?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogSizesEntityRelationInput"]>,
	dogActivities?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogActivitiesEntityRelationInput"]>,
	breeds?: Array<GraphQLTypes["SuitabilityCategoryUpdateBreedsEntityRelationInput"]>,
	suitabilityItems?: Array<GraphQLTypes["SuitabilityCategoryUpdateSuitabilityItemsEntityRelationInput"]>,
	dogAges?: Array<GraphQLTypes["SuitabilityCategoryUpdateDogAgesEntityRelationInput"]>,
	isPregnant?: boolean,
	remoteId?: string,
	isBreastfeeding?: boolean,
	_dummy_field_?: boolean
};
	["ProductFeatureCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId?: string,
	linkItem?: GraphQLTypes["ProductFeatureCreateLinkItemEntityRelationInput"],
	dependentElement?: GraphQLTypes["ProductFeatureCreateDependentElementEntityRelationInput"],
	dependentCategory?: GraphQLTypes["ProductFeatureCreateDependentCategoryEntityRelationInput"],
	dependentSubCategory?: GraphQLTypes["ProductFeatureCreateDependentSubCategoryEntityRelationInput"],
	dependentFlag?: GraphQLTypes["ProductFeatureCreateDependentFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFeatureUpdateInput"]: {
		text?: string,
	category?: GraphQLTypes["FeatureCategoryType"],
	value?: GraphQLTypes["FeatureValueType"],
	remoteId?: string,
	linkItem?: GraphQLTypes["ProductFeatureUpdateLinkItemEntityRelationInput"],
	dependentElement?: GraphQLTypes["ProductFeatureUpdateDependentElementEntityRelationInput"],
	dependentCategory?: GraphQLTypes["ProductFeatureUpdateDependentCategoryEntityRelationInput"],
	dependentSubCategory?: GraphQLTypes["ProductFeatureUpdateDependentSubCategoryEntityRelationInput"],
	dependentFlag?: GraphQLTypes["ProductFeatureUpdateDependentFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SuitabilityItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	min?: number,
	max?: number,
	remoteId?: string,
	order?: number,
	element?: GraphQLTypes["SuitabilityItemCreateElementEntityRelationInput"],
	nutritionalValue?: GraphQLTypes["SuitabilityItemCreateNutritionalValueEntityRelationInput"],
	category?: GraphQLTypes["SuitabilityItemCreateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SuitabilityItemUpdateInput"]: {
		min?: number,
	max?: number,
	remoteId?: string,
	order?: number,
	element?: GraphQLTypes["SuitabilityItemUpdateElementEntityRelationInput"],
	nutritionalValue?: GraphQLTypes["SuitabilityItemUpdateNutritionalValueEntityRelationInput"],
	category?: GraphQLTypes["SuitabilityItemUpdateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RegionConnection"]: {
	__typename: "RegionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RegionEdge"]>
};
	["RegionEdge"]: {
	__typename: "RegionEdge",
	node: GraphQLTypes["Region"]
};
	["RegionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	countries?: Array<GraphQLTypes["RegionCreateCountriesEntityRelationInput"]>,
	remoteId?: string,
	adjective?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["RegionCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RegionUpdateInput"]: {
		name?: string,
	countries?: Array<GraphQLTypes["RegionUpdateCountriesEntityRelationInput"]>,
	remoteId?: string,
	adjective?: string,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["RegionUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["GranuleSizeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	products?: Array<GraphQLTypes["GranuleSizeCreateProductsEntityRelationInput"]>,
	name?: GraphQLTypes["GranuleSizeType"],
	_dummy_field_?: boolean
};
	["GranuleSizeCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutGranuleSizesCreateInput"],
	connectOrCreate?: GraphQLTypes["GranuleSizeConnectOrCreateProductsRelationInput"],
	alias?: string
};
	["ProductWithoutGranuleSizesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["GranuleSizeConnectOrCreateProductsRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutGranuleSizesCreateInput"]
};
	["GranuleSizeUpdateInput"]: {
		remoteId?: string,
	products?: Array<GraphQLTypes["GranuleSizeUpdateProductsEntityRelationInput"]>,
	name?: GraphQLTypes["GranuleSizeType"],
	_dummy_field_?: boolean
};
	["GranuleSizeUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutGranuleSizesCreateInput"],
	update?: GraphQLTypes["GranuleSizeUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["GranuleSizeUpsertProductsRelationInput"],
	connect?: GraphQLTypes["ProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductUniqueWhere"],
	delete?: GraphQLTypes["ProductUniqueWhere"],
	alias?: string
};
	["GranuleSizeUpdateProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	data: GraphQLTypes["ProductWithoutGranuleSizesUpdateInput"]
};
	["ProductWithoutGranuleSizesUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["GranuleSizeUpsertProductsRelationInput"]: {
		by: GraphQLTypes["ProductUniqueWhere"],
	update: GraphQLTypes["ProductWithoutGranuleSizesUpdateInput"],
	create: GraphQLTypes["ProductWithoutGranuleSizesCreateInput"]
};
	["ItemAliasCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	name?: string,
	item?: GraphQLTypes["ItemAliasCreateItemEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemAliasCreateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemWithoutAliasesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemAliasConnectOrCreateItemRelationInput"]
};
	["ItemWithoutAliasesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemCreateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemCreateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemCreateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemCreateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemCreateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemCreateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemCreateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemCreateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemCreateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["ItemCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemAliasConnectOrCreateItemRelationInput"]: {
		connect: GraphQLTypes["ItemUniqueWhere"],
	create: GraphQLTypes["ItemWithoutAliasesCreateInput"]
};
	["ItemAliasUpdateInput"]: {
		remoteId?: string,
	name?: string,
	item?: GraphQLTypes["ItemAliasUpdateItemEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemAliasUpdateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemUniqueWhere"],
	create?: GraphQLTypes["ItemWithoutAliasesCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemAliasConnectOrCreateItemRelationInput"],
	update?: GraphQLTypes["ItemWithoutAliasesUpdateInput"],
	upsert?: GraphQLTypes["ItemAliasUpsertItemRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ItemWithoutAliasesUpdateInput"]: {
		name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ItemUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ItemUpdateNegativeForBodyTagsEntityRelationInput"]>,
	subCategories?: Array<GraphQLTypes["ItemUpdateSubCategoriesEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["ItemUpdateCategoriesEntityRelationInput"]>,
	lead?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	featuresOfProduct?: Array<GraphQLTypes["ItemUpdateFeaturesOfProductEntityRelationInput"]>,
	remoteId?: string,
	image?: GraphQLTypes["ItemUpdateImageEntityRelationInput"],
	referenceList?: GraphQLTypes["ItemUpdateReferenceListEntityRelationInput"],
	blogPost?: GraphQLTypes["ItemUpdateBlogPostEntityRelationInput"],
	declensionFourth?: GraphQLTypes["ItemUpdateDeclensionFourthEntityRelationInput"],
	declensionSeventh?: GraphQLTypes["ItemUpdateDeclensionSeventhEntityRelationInput"],
	slug?: string,
	seo?: GraphQLTypes["ItemUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["ItemUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemAliasUpsertItemRelationInput"]: {
		update: GraphQLTypes["ItemWithoutAliasesUpdateInput"],
	create: GraphQLTypes["ItemWithoutAliasesCreateInput"]
};
	["SemanticKey"]: {
	__typename: "SemanticKey",
	_meta?: GraphQLTypes["SemanticKeyMeta"],
	id: GraphQLTypes["UUID"],
	key: string,
	value?: string
};
	["SemanticKeyMeta"]: {
	__typename: "SemanticKeyMeta",
	id?: GraphQLTypes["FieldMeta"],
	key?: GraphQLTypes["FieldMeta"],
	value?: GraphQLTypes["FieldMeta"]
};
	["SemanticKeyUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	key?: string
};
	["SemanticKeyWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	key?: GraphQLTypes["StringCondition"],
	value?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["SemanticKeyWhere"] | undefined>,
	or?: Array<GraphQLTypes["SemanticKeyWhere"] | undefined>,
	not?: GraphQLTypes["SemanticKeyWhere"]
};
	["SemanticKeyOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	key?: GraphQLTypes["OrderDirection"],
	value?: GraphQLTypes["OrderDirection"]
};
	["SemanticKeyConnection"]: {
	__typename: "SemanticKeyConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SemanticKeyEdge"]>
};
	["SemanticKeyEdge"]: {
	__typename: "SemanticKeyEdge",
	node: GraphQLTypes["SemanticKey"]
};
	["SemanticKeyCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	key?: string,
	value?: string,
	_dummy_field_?: boolean
};
	["SemanticKeyUpdateInput"]: {
		key?: string,
	value?: string,
	_dummy_field_?: boolean
};
	["ProductFlagConnection"]: {
	__typename: "ProductFlagConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductFlagEdge"]>
};
	["ProductFlagEdge"]: {
	__typename: "ProductFlagEdge",
	node: GraphQLTypes["ProductFlag"]
};
	["ProductFlagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	productFeatures?: Array<GraphQLTypes["ProductFlagCreateProductFeaturesEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ProductFlagCreateProductsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductFlagUpdateInput"]: {
		remoteId?: string,
	productFeatures?: Array<GraphQLTypes["ProductFlagUpdateProductFeaturesEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ProductFlagUpdateProductsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductFlagOfProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	value?: GraphQLTypes["ProductFlagValue"],
	product?: GraphQLTypes["ProductFlagOfProductCreateProductEntityRelationInput"],
	flag?: GraphQLTypes["ProductFlagOfProductCreateFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductFlagOfProductUpdateInput"]: {
		remoteId?: string,
	value?: GraphQLTypes["ProductFlagValue"],
	product?: GraphQLTypes["ProductFlagOfProductUpdateProductEntityRelationInput"],
	flag?: GraphQLTypes["ProductFlagOfProductUpdateFlagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductEvaluationConnection"]: {
	__typename: "ProductEvaluationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductEvaluationEdge"]>
};
	["ProductEvaluationEdge"]: {
	__typename: "ProductEvaluationEdge",
	node: GraphQLTypes["ProductEvaluation"]
};
	["ProductEvaluationCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nazev?: string,
	vetDieta?: string,
	vetDieta1?: string,
	vetDieta2?: string,
	aktivita?: string,
	vek?: string,
	velikostPlemen?: string,
	hmotnostPlemene?: string,
	velikostGranuli?: string,
	velikostGranuliText?: string,
	doporucenaAktivitaDleMe?: string,
	vypocitanaMeVsMeVyrobce?: string,
	vypocitanaMeVsMeVyrobce2?: string,
	masoNaPrvnimMisteText?: string,
	zdrojeZivocisnychBilkovinDle1Vyskytu?: string,
	prichuteSeznam?: string,
	eliminacniDietaTextInterpunkce?: string,
	alergenyZadneNeobsahuje?: string,
	alergenyObsahuje?: string,
	alergenyNejakeNeobsahuje?: string,
	prospesneDruhyInterpunkce?: string,
	nevhodneDruhy?: string,
	kladneUcinkyCeleTelo?: string,
	kladneUcinkyHlava?: string,
	kladneUcinkyHrudnik?: string,
	kladneUcinkyBricho?: string,
	kladneUcinkySpodniCast?: string,
	zaporneUcinkyCeleTelo?: string,
	zaporneUcinkyHlava?: string,
	zaporneUcinkyHrudnik?: string,
	zaporneUcinkyBricho?: string,
	zaporneUcinkySpodniCast?: string,
	dsneuvedeno?: string,
	dsmalo?: string,
	dsprilis?: string,
	dsok?: string,
	d95malo?: string,
	d95prilis?: string,
	d95ok?: string,
	d110malo?: string,
	d110prilis?: string,
	d110ok?: string,
	sdo14reproMalo?: string,
	sdo14reproPrilis?: string,
	sdo14reproOk?: string,
	sdo15malo?: string,
	sdo15prilis?: string,
	sdo15ok?: string,
	s15malo?: string,
	s15prilis?: string,
	s15ok?: string,
	product?: GraphQLTypes["ProductEvaluationCreateProductEntityRelationInput"],
	masoAnoNe?: string,
	eliminacniDietaAnoNe?: string,
	alergenyAnoNe?: string,
	plodnostKastraceNadpis?: string,
	plodnostKastraceText?: string,
	remoteId?: string,
	stravitelnostNadpis?: string,
	stravitelnostProcenta?: string,
	stravitelnostSlovne?: string,
	stravitelnostChybiText?: string,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?: string,
	_dummy_field_?: boolean
};
	["ProductEvaluationCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutEvaluationCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductEvaluationConnectOrCreateProductRelationInput"]
};
	["ProductWithoutEvaluationCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductEvaluationConnectOrCreateProductRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutEvaluationCreateInput"]
};
	["ProductEvaluationUpdateInput"]: {
		nazev?: string,
	vetDieta?: string,
	vetDieta1?: string,
	vetDieta2?: string,
	aktivita?: string,
	vek?: string,
	velikostPlemen?: string,
	hmotnostPlemene?: string,
	velikostGranuli?: string,
	velikostGranuliText?: string,
	doporucenaAktivitaDleMe?: string,
	vypocitanaMeVsMeVyrobce?: string,
	vypocitanaMeVsMeVyrobce2?: string,
	masoNaPrvnimMisteText?: string,
	zdrojeZivocisnychBilkovinDle1Vyskytu?: string,
	prichuteSeznam?: string,
	eliminacniDietaTextInterpunkce?: string,
	alergenyZadneNeobsahuje?: string,
	alergenyObsahuje?: string,
	alergenyNejakeNeobsahuje?: string,
	prospesneDruhyInterpunkce?: string,
	nevhodneDruhy?: string,
	kladneUcinkyCeleTelo?: string,
	kladneUcinkyHlava?: string,
	kladneUcinkyHrudnik?: string,
	kladneUcinkyBricho?: string,
	kladneUcinkySpodniCast?: string,
	zaporneUcinkyCeleTelo?: string,
	zaporneUcinkyHlava?: string,
	zaporneUcinkyHrudnik?: string,
	zaporneUcinkyBricho?: string,
	zaporneUcinkySpodniCast?: string,
	dsneuvedeno?: string,
	dsmalo?: string,
	dsprilis?: string,
	dsok?: string,
	d95malo?: string,
	d95prilis?: string,
	d95ok?: string,
	d110malo?: string,
	d110prilis?: string,
	d110ok?: string,
	sdo14reproMalo?: string,
	sdo14reproPrilis?: string,
	sdo14reproOk?: string,
	sdo15malo?: string,
	sdo15prilis?: string,
	sdo15ok?: string,
	s15malo?: string,
	s15prilis?: string,
	s15ok?: string,
	product?: GraphQLTypes["ProductEvaluationUpdateProductEntityRelationInput"],
	masoAnoNe?: string,
	eliminacniDietaAnoNe?: string,
	alergenyAnoNe?: string,
	plodnostKastraceNadpis?: string,
	plodnostKastraceText?: string,
	remoteId?: string,
	stravitelnostNadpis?: string,
	stravitelnostProcenta?: string,
	stravitelnostSlovne?: string,
	stravitelnostChybiText?: string,
	zdrojeZivocisnychBilkovinDle1VyskytuVeta?: string,
	_dummy_field_?: boolean
};
	["ProductEvaluationUpdateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutEvaluationCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductEvaluationConnectOrCreateProductRelationInput"],
	update?: GraphQLTypes["ProductWithoutEvaluationUpdateInput"],
	upsert?: GraphQLTypes["ProductEvaluationUpsertProductRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductWithoutEvaluationUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductEvaluationUpsertProductRelationInput"]: {
		update: GraphQLTypes["ProductWithoutEvaluationUpdateInput"],
	create: GraphQLTypes["ProductWithoutEvaluationCreateInput"]
};
	["AdCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["AdCreateImageEntityRelationInput"],
	isBrandSectionVisible?: boolean,
	isBlogPostSectionVisible?: boolean,
	isIngredientSectionVisible?: boolean,
	isResultsVisible?: boolean,
	isSearchVisible?: boolean,
	blogPosts?: Array<GraphQLTypes["AdCreateBlogPostsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["AdCreateItemCategoriesEntityRelationInput"]>,
	brands?: Array<GraphQLTypes["AdCreateBrandsEntityRelationInput"]>,
	isActive?: boolean,
	link?: string,
	note?: string,
	activeFrom?: GraphQLTypes["DateTime"],
	activeUntil?: GraphQLTypes["DateTime"],
	slug?: string,
	contentReferences?: Array<GraphQLTypes["AdCreateContentReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AdUpdateInput"]: {
		image?: GraphQLTypes["AdUpdateImageEntityRelationInput"],
	isBrandSectionVisible?: boolean,
	isBlogPostSectionVisible?: boolean,
	isIngredientSectionVisible?: boolean,
	isResultsVisible?: boolean,
	isSearchVisible?: boolean,
	blogPosts?: Array<GraphQLTypes["AdUpdateBlogPostsEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["AdUpdateItemCategoriesEntityRelationInput"]>,
	brands?: Array<GraphQLTypes["AdUpdateBrandsEntityRelationInput"]>,
	isActive?: boolean,
	link?: string,
	note?: string,
	activeFrom?: GraphQLTypes["DateTime"],
	activeUntil?: GraphQLTypes["DateTime"],
	slug?: string,
	contentReferences?: Array<GraphQLTypes["AdUpdateContentReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EvaluationInfo"]: {
	__typename: "EvaluationInfo",
	_meta?: GraphQLTypes["EvaluationInfoMeta"],
	id: GraphQLTypes["UUID"],
	veterinaryDietIcon?: GraphQLTypes["Image"],
	unique: GraphQLTypes["One"],
	veterinaryDiet?: GraphQLTypes["ContentText"],
	disclaimer?: GraphQLTypes["ContentText"],
	veterinaryDietTitle?: string
};
	["EvaluationInfoMeta"]: {
	__typename: "EvaluationInfoMeta",
	id?: GraphQLTypes["FieldMeta"],
	veterinaryDietIcon?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	veterinaryDiet?: GraphQLTypes["FieldMeta"],
	disclaimer?: GraphQLTypes["FieldMeta"],
	veterinaryDietTitle?: GraphQLTypes["FieldMeta"]
};
	["ContentText"]: {
	__typename: "ContentText",
	_meta?: GraphQLTypes["ContentTextMeta"],
	id: GraphQLTypes["UUID"],
	blocks: Array<GraphQLTypes["ContentTextBlock"]>,
	paginateBlocks: GraphQLTypes["ContentTextBlockConnection"]
};
	["ContentTextMeta"]: {
	__typename: "ContentTextMeta",
	id?: GraphQLTypes["FieldMeta"],
	blocks?: GraphQLTypes["FieldMeta"]
};
	["ContentTextBlock"]: {
	__typename: "ContentTextBlock",
	_meta?: GraphQLTypes["ContentTextBlockMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["ContentText"]
};
	["ContentTextBlockMeta"]: {
	__typename: "ContentTextBlockMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	json?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"]
};
	["ContentTextWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	blocks?: GraphQLTypes["ContentTextBlockWhere"],
	and?: Array<GraphQLTypes["ContentTextWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentTextWhere"] | undefined>,
	not?: GraphQLTypes["ContentTextWhere"]
};
	["ContentTextBlockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	json?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentTextWhere"],
	and?: Array<GraphQLTypes["ContentTextBlockWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentTextBlockWhere"] | undefined>,
	not?: GraphQLTypes["ContentTextBlockWhere"]
};
	["ContentTextBlockOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	json?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentTextOrderBy"]
};
	["ContentTextOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["ContentTextBlockConnection"]: {
	__typename: "ContentTextBlockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentTextBlockEdge"]>
};
	["ContentTextBlockEdge"]: {
	__typename: "ContentTextBlockEdge",
	node: GraphQLTypes["ContentTextBlock"]
};
	["EvaluationInfoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	veterinaryDietIcon?: GraphQLTypes["ImageUniqueWhere"]
};
	["EvaluationInfoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	veterinaryDietIcon?: GraphQLTypes["ImageWhere"],
	unique?: GraphQLTypes["OneCondition"],
	veterinaryDiet?: GraphQLTypes["ContentTextWhere"],
	disclaimer?: GraphQLTypes["ContentTextWhere"],
	veterinaryDietTitle?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["EvaluationInfoWhere"] | undefined>,
	or?: Array<GraphQLTypes["EvaluationInfoWhere"] | undefined>,
	not?: GraphQLTypes["EvaluationInfoWhere"]
};
	["EvaluationInfoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	veterinaryDietIcon?: GraphQLTypes["ImageOrderBy"],
	unique?: GraphQLTypes["OrderDirection"],
	veterinaryDiet?: GraphQLTypes["ContentTextOrderBy"],
	disclaimer?: GraphQLTypes["ContentTextOrderBy"],
	veterinaryDietTitle?: GraphQLTypes["OrderDirection"]
};
	["EvaluationInfoConnection"]: {
	__typename: "EvaluationInfoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EvaluationInfoEdge"]>
};
	["EvaluationInfoEdge"]: {
	__typename: "EvaluationInfoEdge",
	node: GraphQLTypes["EvaluationInfo"]
};
	["EvaluationInfoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	veterinaryDietIcon?: GraphQLTypes["EvaluationInfoCreateVeterinaryDietIconEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	veterinaryDiet?: GraphQLTypes["EvaluationInfoCreateVeterinaryDietEntityRelationInput"],
	disclaimer?: GraphQLTypes["EvaluationInfoCreateDisclaimerEntityRelationInput"],
	veterinaryDietTitle?: string,
	_dummy_field_?: boolean
};
	["EvaluationInfoCreateVeterinaryDietIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["EvaluationInfoConnectOrCreateVeterinaryDietIconRelationInput"]
};
	["EvaluationInfoConnectOrCreateVeterinaryDietIconRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["EvaluationInfoCreateVeterinaryDietEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentTextUniqueWhere"],
	create?: GraphQLTypes["ContentTextCreateInput"],
	connectOrCreate?: GraphQLTypes["EvaluationInfoConnectOrCreateVeterinaryDietRelationInput"]
};
	["ContentTextUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: GraphQLTypes["ContentTextBlockUniqueWhere"]
};
	["ContentTextBlockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ContentTextCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: Array<GraphQLTypes["ContentTextCreateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentTextCreateBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentTextBlockUniqueWhere"],
	create?: GraphQLTypes["ContentTextBlockWithoutContentCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentTextConnectOrCreateBlocksRelationInput"],
	alias?: string
};
	["ContentTextBlockWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	_dummy_field_?: boolean
};
	["ContentTextConnectOrCreateBlocksRelationInput"]: {
		connect: GraphQLTypes["ContentTextBlockUniqueWhere"],
	create: GraphQLTypes["ContentTextBlockWithoutContentCreateInput"]
};
	["EvaluationInfoConnectOrCreateVeterinaryDietRelationInput"]: {
		connect: GraphQLTypes["ContentTextUniqueWhere"],
	create: GraphQLTypes["ContentTextCreateInput"]
};
	["EvaluationInfoCreateDisclaimerEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentTextUniqueWhere"],
	create?: GraphQLTypes["ContentTextCreateInput"],
	connectOrCreate?: GraphQLTypes["EvaluationInfoConnectOrCreateDisclaimerRelationInput"]
};
	["EvaluationInfoConnectOrCreateDisclaimerRelationInput"]: {
		connect: GraphQLTypes["ContentTextUniqueWhere"],
	create: GraphQLTypes["ContentTextCreateInput"]
};
	["EvaluationInfoUpdateInput"]: {
		veterinaryDietIcon?: GraphQLTypes["EvaluationInfoUpdateVeterinaryDietIconEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	veterinaryDiet?: GraphQLTypes["EvaluationInfoUpdateVeterinaryDietEntityRelationInput"],
	disclaimer?: GraphQLTypes["EvaluationInfoUpdateDisclaimerEntityRelationInput"],
	veterinaryDietTitle?: string,
	_dummy_field_?: boolean
};
	["EvaluationInfoUpdateVeterinaryDietIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["EvaluationInfoConnectOrCreateVeterinaryDietIconRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["EvaluationInfoUpsertVeterinaryDietIconRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["EvaluationInfoUpsertVeterinaryDietIconRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["EvaluationInfoUpdateVeterinaryDietEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentTextUniqueWhere"],
	create?: GraphQLTypes["ContentTextCreateInput"],
	connectOrCreate?: GraphQLTypes["EvaluationInfoConnectOrCreateVeterinaryDietRelationInput"],
	update?: GraphQLTypes["ContentTextUpdateInput"],
	upsert?: GraphQLTypes["EvaluationInfoUpsertVeterinaryDietRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentTextUpdateInput"]: {
		blocks?: Array<GraphQLTypes["ContentTextUpdateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentTextUpdateBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentTextBlockWithoutContentCreateInput"],
	update?: GraphQLTypes["ContentTextUpdateBlocksRelationInput"],
	upsert?: GraphQLTypes["ContentTextUpsertBlocksRelationInput"],
	connect?: GraphQLTypes["ContentTextBlockUniqueWhere"],
	disconnect?: GraphQLTypes["ContentTextBlockUniqueWhere"],
	delete?: GraphQLTypes["ContentTextBlockUniqueWhere"],
	alias?: string
};
	["ContentTextUpdateBlocksRelationInput"]: {
		by: GraphQLTypes["ContentTextBlockUniqueWhere"],
	data: GraphQLTypes["ContentTextBlockWithoutContentUpdateInput"]
};
	["ContentTextBlockWithoutContentUpdateInput"]: {
		order?: number,
	json?: string,
	_dummy_field_?: boolean
};
	["ContentTextUpsertBlocksRelationInput"]: {
		by: GraphQLTypes["ContentTextBlockUniqueWhere"],
	update: GraphQLTypes["ContentTextBlockWithoutContentUpdateInput"],
	create: GraphQLTypes["ContentTextBlockWithoutContentCreateInput"]
};
	["EvaluationInfoUpsertVeterinaryDietRelationInput"]: {
		update: GraphQLTypes["ContentTextUpdateInput"],
	create: GraphQLTypes["ContentTextCreateInput"]
};
	["EvaluationInfoUpdateDisclaimerEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentTextUniqueWhere"],
	create?: GraphQLTypes["ContentTextCreateInput"],
	connectOrCreate?: GraphQLTypes["EvaluationInfoConnectOrCreateDisclaimerRelationInput"],
	update?: GraphQLTypes["ContentTextUpdateInput"],
	upsert?: GraphQLTypes["EvaluationInfoUpsertDisclaimerRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["EvaluationInfoUpsertDisclaimerRelationInput"]: {
		update: GraphQLTypes["ContentTextUpdateInput"],
	create: GraphQLTypes["ContentTextCreateInput"]
};
	["ConsumptionMessage"]: {
	__typename: "ConsumptionMessage",
	_meta?: GraphQLTypes["ConsumptionMessageMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	finalWording?: string,
	isHighlighted: boolean,
	numberOfDays?: number
};
	["ConsumptionMessageMeta"]: {
	__typename: "ConsumptionMessageMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	finalWording?: GraphQLTypes["FieldMeta"],
	isHighlighted?: GraphQLTypes["FieldMeta"],
	numberOfDays?: GraphQLTypes["FieldMeta"]
};
	["ConsumptionMessageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["ConsumptionMessageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	finalWording?: GraphQLTypes["StringCondition"],
	isHighlighted?: GraphQLTypes["BooleanCondition"],
	numberOfDays?: GraphQLTypes["IntCondition"],
	and?: Array<GraphQLTypes["ConsumptionMessageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ConsumptionMessageWhere"] | undefined>,
	not?: GraphQLTypes["ConsumptionMessageWhere"]
};
	["ConsumptionMessageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	finalWording?: GraphQLTypes["OrderDirection"],
	isHighlighted?: GraphQLTypes["OrderDirection"],
	numberOfDays?: GraphQLTypes["OrderDirection"]
};
	["ConsumptionMessageConnection"]: {
	__typename: "ConsumptionMessageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ConsumptionMessageEdge"]>
};
	["ConsumptionMessageEdge"]: {
	__typename: "ConsumptionMessageEdge",
	node: GraphQLTypes["ConsumptionMessage"]
};
	["ConsumptionMessageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	finalWording?: string,
	isHighlighted?: boolean,
	numberOfDays?: number,
	_dummy_field_?: boolean
};
	["ConsumptionMessageUpdateInput"]: {
		remoteId?: string,
	finalWording?: string,
	isHighlighted?: boolean,
	numberOfDays?: number,
	_dummy_field_?: boolean
};
	["ContentTextConnection"]: {
	__typename: "ContentTextConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentTextEdge"]>
};
	["ContentTextEdge"]: {
	__typename: "ContentTextEdge",
	node: GraphQLTypes["ContentText"]
};
	["ContentTextBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentTextBlockCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentTextBlockCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentTextUniqueWhere"],
	create?: GraphQLTypes["ContentTextWithoutBlocksCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentTextBlockConnectOrCreateContentRelationInput"]
};
	["ContentTextWithoutBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ContentTextBlockConnectOrCreateContentRelationInput"]: {
		connect: GraphQLTypes["ContentTextUniqueWhere"],
	create: GraphQLTypes["ContentTextWithoutBlocksCreateInput"]
};
	["ContentTextBlockUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentTextBlockUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentTextBlockUpdateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentTextUniqueWhere"],
	create?: GraphQLTypes["ContentTextWithoutBlocksCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentTextBlockConnectOrCreateContentRelationInput"],
	update?: GraphQLTypes["ContentTextWithoutBlocksUpdateInput"],
	upsert?: GraphQLTypes["ContentTextBlockUpsertContentRelationInput"],
	delete?: boolean
};
	["ContentTextWithoutBlocksUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ContentTextBlockUpsertContentRelationInput"]: {
		update: GraphQLTypes["ContentTextWithoutBlocksUpdateInput"],
	create: GraphQLTypes["ContentTextWithoutBlocksCreateInput"]
};
	["ProductReviewStatsConnection"]: {
	__typename: "ProductReviewStatsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductReviewStatsEdge"]>
};
	["ProductReviewStatsEdge"]: {
	__typename: "ProductReviewStatsEdge",
	node: GraphQLTypes["ProductReviewStats"]
};
	["BlogPostReviewStatsConnection"]: {
	__typename: "BlogPostReviewStatsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BlogPostReviewStatsEdge"]>
};
	["BlogPostReviewStatsEdge"]: {
	__typename: "BlogPostReviewStatsEdge",
	node: GraphQLTypes["BlogPostReviewStats"]
};
	["ComparatorPageConnection"]: {
	__typename: "ComparatorPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ComparatorPageEdge"]>
};
	["ComparatorPageEdge"]: {
	__typename: "ComparatorPageEdge",
	node: GraphQLTypes["ComparatorPage"]
};
	["ComparatorPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	redirects?: Array<GraphQLTypes["ComparatorPageCreateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["ComparatorPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ComparatorPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	redirects?: Array<GraphQLTypes["ComparatorPageUpdateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["ComparatorPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LoginPageConnection"]: {
	__typename: "LoginPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LoginPageEdge"]>
};
	["LoginPageEdge"]: {
	__typename: "LoginPageEdge",
	node: GraphQLTypes["LoginPage"]
};
	["LoginPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["LoginPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LoginPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutLoginPageCreateInput"],
	connectOrCreate?: GraphQLTypes["LoginPageConnectOrCreateSeoRelationInput"]
};
	["SeoWithoutLoginPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoCreateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoCreateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoCreateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoCreateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoCreateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoCreateIngredientsPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoCreateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoCreateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoCreateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoCreateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["LoginPageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoWithoutLoginPageCreateInput"]
};
	["LoginPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["LoginPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LoginPageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutLoginPageCreateInput"],
	connectOrCreate?: GraphQLTypes["LoginPageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoWithoutLoginPageUpdateInput"],
	upsert?: GraphQLTypes["LoginPageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoWithoutLoginPageUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoUpdateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoUpdateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoUpdateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoUpdateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoUpdateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoUpdateIngredientsPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoUpdateRegisterPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoUpdateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoUpdateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoUpdateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["LoginPageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoWithoutLoginPageUpdateInput"],
	create: GraphQLTypes["SeoWithoutLoginPageCreateInput"]
};
	["RegisterPageConnection"]: {
	__typename: "RegisterPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RegisterPageEdge"]>
};
	["RegisterPageEdge"]: {
	__typename: "RegisterPageEdge",
	node: GraphQLTypes["RegisterPage"]
};
	["RegisterPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["RegisterPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RegisterPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutRegisterPageCreateInput"],
	connectOrCreate?: GraphQLTypes["RegisterPageConnectOrCreateSeoRelationInput"]
};
	["SeoWithoutRegisterPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoCreateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoCreateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoCreateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoCreateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoCreateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoCreateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoCreateLoginPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoCreateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoCreateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoCreateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["RegisterPageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoWithoutRegisterPageCreateInput"]
};
	["RegisterPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["RegisterPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RegisterPageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutRegisterPageCreateInput"],
	connectOrCreate?: GraphQLTypes["RegisterPageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoWithoutRegisterPageUpdateInput"],
	upsert?: GraphQLTypes["RegisterPageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoWithoutRegisterPageUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoUpdateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoUpdateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoUpdateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoUpdateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoUpdateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoUpdateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoUpdateLoginPageEntityRelationInput"],
	searchPage?: GraphQLTypes["SeoUpdateSearchPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoUpdateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoUpdateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["RegisterPageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoWithoutRegisterPageUpdateInput"],
	create: GraphQLTypes["SeoWithoutRegisterPageCreateInput"]
};
	["ResultsPage"]: {
	__typename: "ResultsPage",
	_meta?: GraphQLTypes["ResultsPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	seo?: GraphQLTypes["Seo"]
};
	["ResultsPageMeta"]: {
	__typename: "ResultsPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["ResultsPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ResultsPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["ResultsPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ResultsPageWhere"] | undefined>,
	not?: GraphQLTypes["ResultsPageWhere"]
};
	["ResultsPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["ResultsPageConnection"]: {
	__typename: "ResultsPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ResultsPageEdge"]>
};
	["ResultsPageEdge"]: {
	__typename: "ResultsPageEdge",
	node: GraphQLTypes["ResultsPage"]
};
	["ResultsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["ResultsPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ResultsPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["ResultsPageConnectOrCreateSeoRelationInput"]
};
	["ResultsPageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["ResultsPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["ResultsPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ResultsPageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["ResultsPageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ResultsPageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ResultsPageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["SearchPageConnection"]: {
	__typename: "SearchPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SearchPageEdge"]>
};
	["SearchPageEdge"]: {
	__typename: "SearchPageEdge",
	node: GraphQLTypes["SearchPage"]
};
	["SearchPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SearchPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SearchPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutSearchPageCreateInput"],
	connectOrCreate?: GraphQLTypes["SearchPageConnectOrCreateSeoRelationInput"]
};
	["SeoWithoutSearchPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoCreateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoCreateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoCreateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoCreateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoCreateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoCreateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoCreateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoCreateRegisterPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoCreateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoCreateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SearchPageConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoWithoutSearchPageCreateInput"]
};
	["SearchPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SearchPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SearchPageUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutSearchPageCreateInput"],
	connectOrCreate?: GraphQLTypes["SearchPageConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoWithoutSearchPageUpdateInput"],
	upsert?: GraphQLTypes["SearchPageUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoWithoutSearchPageUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	blogPage?: GraphQLTypes["SeoUpdateBlogPageEntityRelationInput"],
	brandsPage?: GraphQLTypes["SeoUpdateBrandsPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["SeoUpdateComparatorPageEntityRelationInput"],
	genericPage?: GraphQLTypes["SeoUpdateGenericPageEntityRelationInput"],
	homePage?: GraphQLTypes["SeoUpdateHomePageEntityRelationInput"],
	ingredientsPage?: GraphQLTypes["SeoUpdateIngredientsPageEntityRelationInput"],
	loginPage?: GraphQLTypes["SeoUpdateLoginPageEntityRelationInput"],
	registerPage?: GraphQLTypes["SeoUpdateRegisterPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["SeoUpdateWizardPageEntityRelationInput"],
	contactPage?: GraphQLTypes["SeoUpdateContactPageEntityRelationInput"],
	group?: GraphQLTypes["GroupType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SearchPageUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoWithoutSearchPageUpdateInput"],
	create: GraphQLTypes["SeoWithoutSearchPageCreateInput"]
};
	["WizardPageConnection"]: {
	__typename: "WizardPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["WizardPageEdge"]>
};
	["WizardPageEdge"]: {
	__typename: "WizardPageEdge",
	node: GraphQLTypes["WizardPage"]
};
	["WizardPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	redirects?: Array<GraphQLTypes["WizardPageCreateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["WizardPageCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["WizardPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	redirects?: Array<GraphQLTypes["WizardPageUpdateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["WizardPageUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BreastfeedingCategoryConnection"]: {
	__typename: "BreastfeedingCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BreastfeedingCategoryEdge"]>
};
	["BreastfeedingCategoryEdge"]: {
	__typename: "BreastfeedingCategoryEdge",
	node: GraphQLTypes["BreastfeedingCategory"]
};
	["BreastfeedingCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	week?: number,
	coeficient?: number,
	dogs?: Array<GraphQLTypes["BreastfeedingCategoryCreateDogsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreastfeedingCategoryCreateDogsEntityRelationInput"]: {
		connect?: GraphQLTypes["DogReproductionUniqueWhere"],
	create?: GraphQLTypes["DogReproductionWithoutBreastfeedingCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["BreastfeedingCategoryConnectOrCreateDogsRelationInput"],
	alias?: string
};
	["DogReproductionWithoutBreastfeedingCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["DogReproductionType"],
	breastfeedingPuppyCount?: number,
	pregnancy?: GraphQLTypes["PregnantPeriodType"],
	dog?: GraphQLTypes["DogReproductionCreateDogEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogReproductionCreateDogEntityRelationInput"]: {
		connect?: GraphQLTypes["DogUniqueWhere"],
	create?: GraphQLTypes["DogWithoutReproductionCreateInput"],
	connectOrCreate?: GraphQLTypes["DogReproductionConnectOrCreateDogRelationInput"]
};
	["DogWithoutReproductionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogCreateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogCreateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogCreateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogCreateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogCreateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogCreateFedProductEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogCreateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogCreateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogCreateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogReproductionConnectOrCreateDogRelationInput"]: {
		connect: GraphQLTypes["DogUniqueWhere"],
	create: GraphQLTypes["DogWithoutReproductionCreateInput"]
};
	["BreastfeedingCategoryConnectOrCreateDogsRelationInput"]: {
		connect: GraphQLTypes["DogReproductionUniqueWhere"],
	create: GraphQLTypes["DogReproductionWithoutBreastfeedingCategoryCreateInput"]
};
	["BreastfeedingCategoryUpdateInput"]: {
		week?: number,
	coeficient?: number,
	dogs?: Array<GraphQLTypes["BreastfeedingCategoryUpdateDogsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BreastfeedingCategoryUpdateDogsEntityRelationInput"]: {
		create?: GraphQLTypes["DogReproductionWithoutBreastfeedingCategoryCreateInput"],
	update?: GraphQLTypes["BreastfeedingCategoryUpdateDogsRelationInput"],
	upsert?: GraphQLTypes["BreastfeedingCategoryUpsertDogsRelationInput"],
	connect?: GraphQLTypes["DogReproductionUniqueWhere"],
	disconnect?: GraphQLTypes["DogReproductionUniqueWhere"],
	delete?: GraphQLTypes["DogReproductionUniqueWhere"],
	alias?: string
};
	["BreastfeedingCategoryUpdateDogsRelationInput"]: {
		by: GraphQLTypes["DogReproductionUniqueWhere"],
	data: GraphQLTypes["DogReproductionWithoutBreastfeedingCategoryUpdateInput"]
};
	["DogReproductionWithoutBreastfeedingCategoryUpdateInput"]: {
		type?: GraphQLTypes["DogReproductionType"],
	breastfeedingPuppyCount?: number,
	pregnancy?: GraphQLTypes["PregnantPeriodType"],
	dog?: GraphQLTypes["DogReproductionUpdateDogEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogReproductionUpdateDogEntityRelationInput"]: {
		connect?: GraphQLTypes["DogUniqueWhere"],
	create?: GraphQLTypes["DogWithoutReproductionCreateInput"],
	connectOrCreate?: GraphQLTypes["DogReproductionConnectOrCreateDogRelationInput"],
	update?: GraphQLTypes["DogWithoutReproductionUpdateInput"],
	upsert?: GraphQLTypes["DogReproductionUpsertDogRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["DogWithoutReproductionUpdateInput"]: {
		gender?: GraphQLTypes["GenderType"],
	weight?: number,
	customIdealWeight?: number,
	breed?: GraphQLTypes["DogUpdateBreedEntityRelationInput"],
	age?: GraphQLTypes["DogUpdateAgeEntityRelationInput"],
	bodyType?: GraphQLTypes["DogUpdateBodyTypeEntityRelationInput"],
	owner?: GraphQLTypes["DogUpdateOwnerEntityRelationInput"],
	activity?: GraphQLTypes["DogUpdateActivityEntityRelationInput"],
	fedProduct?: GraphQLTypes["DogUpdateFedProductEntityRelationInput"],
	allergies?: Array<GraphQLTypes["DogUpdateAllergiesEntityRelationInput"]>,
	illnesses?: Array<GraphQLTypes["DogUpdateIllnessesEntityRelationInput"]>,
	name?: string,
	avatar?: GraphQLTypes["DogUpdateAvatarEntityRelationInput"],
	createdAt?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["DogReproductionUpsertDogRelationInput"]: {
		update: GraphQLTypes["DogWithoutReproductionUpdateInput"],
	create: GraphQLTypes["DogWithoutReproductionCreateInput"]
};
	["BreastfeedingCategoryUpsertDogsRelationInput"]: {
		by: GraphQLTypes["DogReproductionUniqueWhere"],
	update: GraphQLTypes["DogReproductionWithoutBreastfeedingCategoryUpdateInput"],
	create: GraphQLTypes["DogReproductionWithoutBreastfeedingCategoryCreateInput"]
};
	["DogReproductionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["DogReproductionType"],
	breastfeedingPuppyCount?: number,
	pregnancy?: GraphQLTypes["PregnantPeriodType"],
	dog?: GraphQLTypes["DogReproductionCreateDogEntityRelationInput"],
	breastfeedingCategory?: GraphQLTypes["DogReproductionCreateBreastfeedingCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DogReproductionUpdateInput"]: {
		type?: GraphQLTypes["DogReproductionType"],
	breastfeedingPuppyCount?: number,
	pregnancy?: GraphQLTypes["PregnantPeriodType"],
	dog?: GraphQLTypes["DogReproductionUpdateDogEntityRelationInput"],
	breastfeedingCategory?: GraphQLTypes["DogReproductionUpdateBreastfeedingCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactFormMessageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	message?: string,
	email?: string,
	receivedAt?: GraphQLTypes["DateTime"],
	user?: GraphQLTypes["ContactFormMessageCreateUserEntityRelationInput"],
	isResolved?: boolean,
	url?: string,
	_dummy_field_?: boolean
};
	["ContactFormMessageCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutContactFormMessagesCreateInput"],
	connectOrCreate?: GraphQLTypes["ContactFormMessageConnectOrCreateUserRelationInput"]
};
	["UserWithoutContactFormMessagesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["UserCreateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserCreateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserCreateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserCreateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserCreateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserCreateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserCreateAvatarEntityRelationInput"],
	bugReports?: Array<GraphQLTypes["UserCreateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserCreateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserCreateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["ContactFormMessageConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutContactFormMessagesCreateInput"]
};
	["ContactFormMessageUpdateInput"]: {
		message?: string,
	email?: string,
	receivedAt?: GraphQLTypes["DateTime"],
	user?: GraphQLTypes["ContactFormMessageUpdateUserEntityRelationInput"],
	isResolved?: boolean,
	url?: string,
	_dummy_field_?: boolean
};
	["ContactFormMessageUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutContactFormMessagesCreateInput"],
	connectOrCreate?: GraphQLTypes["ContactFormMessageConnectOrCreateUserRelationInput"],
	update?: GraphQLTypes["UserWithoutContactFormMessagesUpdateInput"],
	upsert?: GraphQLTypes["ContactFormMessageUpsertUserRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["UserWithoutContactFormMessagesUpdateInput"]: {
		dogs?: Array<GraphQLTypes["UserUpdateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserUpdateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserUpdateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserUpdateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserUpdateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserUpdateAvatarEntityRelationInput"],
	bugReports?: Array<GraphQLTypes["UserUpdateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserUpdateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserUpdateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["ContactFormMessageUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutContactFormMessagesUpdateInput"],
	create: GraphQLTypes["UserWithoutContactFormMessagesCreateInput"]
};
	["ContactPageConnection"]: {
	__typename: "ContactPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContactPageEdge"]>
};
	["ContactPageEdge"]: {
	__typename: "ContactPageEdge",
	node: GraphQLTypes["ContactPage"]
};
	["ContactPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	title?: string,
	redirects?: Array<GraphQLTypes["ContactPageCreateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["ContactPageCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["ContactPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ContactPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	title?: string,
	redirects?: Array<GraphQLTypes["ContactPageUpdateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["ContactPageUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["ContactPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ContactPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BugReportCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	message?: string,
	receivedAt?: GraphQLTypes["DateTime"],
	isResolved?: boolean,
	user?: GraphQLTypes["BugReportCreateUserEntityRelationInput"],
	url?: string,
	_dummy_field_?: boolean
};
	["BugReportCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutBugReportsCreateInput"],
	connectOrCreate?: GraphQLTypes["BugReportConnectOrCreateUserRelationInput"]
};
	["UserWithoutBugReportsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["UserCreateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserCreateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserCreateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserCreateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserCreateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserCreateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserCreateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserCreateContactFormMessagesEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserCreateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserCreateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["BugReportConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutBugReportsCreateInput"]
};
	["BugReportUpdateInput"]: {
		message?: string,
	receivedAt?: GraphQLTypes["DateTime"],
	isResolved?: boolean,
	user?: GraphQLTypes["BugReportUpdateUserEntityRelationInput"],
	url?: string,
	_dummy_field_?: boolean
};
	["BugReportUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutBugReportsCreateInput"],
	connectOrCreate?: GraphQLTypes["BugReportConnectOrCreateUserRelationInput"],
	update?: GraphQLTypes["UserWithoutBugReportsUpdateInput"],
	upsert?: GraphQLTypes["BugReportUpsertUserRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["UserWithoutBugReportsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["UserUpdateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserUpdateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserUpdateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserUpdateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserUpdateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserUpdateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserUpdateContactFormMessagesEntityRelationInput"]>,
	verifiedEmail?: string,
	protectedActions?: Array<GraphQLTypes["UserUpdateProtectedActionsEntityRelationInput"]>,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserUpdateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["BugReportUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutBugReportsUpdateInput"],
	create: GraphQLTypes["UserWithoutBugReportsCreateInput"]
};
	["ColorConnection"]: {
	__typename: "ColorConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ColorEdge"]>
};
	["ColorEdge"]: {
	__typename: "ColorEdge",
	node: GraphQLTypes["Color"]
};
	["ColorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	colorHex?: string,
	bodyTagCategory?: GraphQLTypes["ColorCreateBodyTagCategoryEntityRelationInput"],
	blogPostTag?: GraphQLTypes["ColorCreateBlogPostTagEntityRelationInput"],
	remoteId?: string,
	itemFlavorCategories?: Array<GraphQLTypes["ColorCreateItemFlavorCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ColorUpdateInput"]: {
		name?: string,
	colorHex?: string,
	bodyTagCategory?: GraphQLTypes["ColorUpdateBodyTagCategoryEntityRelationInput"],
	blogPostTag?: GraphQLTypes["ColorUpdateBlogPostTagEntityRelationInput"],
	remoteId?: string,
	itemFlavorCategories?: Array<GraphQLTypes["ColorUpdateItemFlavorCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ItemGroupConnection"]: {
	__typename: "ItemGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ItemGroupEdge"]>
};
	["ItemGroupEdge"]: {
	__typename: "ItemGroupEdge",
	node: GraphQLTypes["ItemGroup"]
};
	["ItemGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	name?: string,
	categories?: Array<GraphQLTypes["ItemGroupCreateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ItemGroupCreateCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	create?: GraphQLTypes["ItemCategoryWithoutGroupCreateInput"],
	connectOrCreate?: GraphQLTypes["ItemGroupConnectOrCreateCategoriesRelationInput"],
	alias?: string
};
	["ItemCategoryWithoutGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryCreateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryCreateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryCreateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryCreateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryCreateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryCreateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryCreateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryCreateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryCreateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryCreateSeoEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemGroupConnectOrCreateCategoriesRelationInput"]: {
		connect: GraphQLTypes["ItemCategoryUniqueWhere"],
	create: GraphQLTypes["ItemCategoryWithoutGroupCreateInput"]
};
	["ItemGroupUpdateInput"]: {
		remoteId?: string,
	name?: string,
	categories?: Array<GraphQLTypes["ItemGroupUpdateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ItemGroupUpdateCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ItemCategoryWithoutGroupCreateInput"],
	update?: GraphQLTypes["ItemGroupUpdateCategoriesRelationInput"],
	upsert?: GraphQLTypes["ItemGroupUpsertCategoriesRelationInput"],
	connect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ItemCategoryUniqueWhere"],
	delete?: GraphQLTypes["ItemCategoryUniqueWhere"],
	alias?: string
};
	["ItemGroupUpdateCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemCategoryUniqueWhere"],
	data: GraphQLTypes["ItemCategoryWithoutGroupUpdateInput"]
};
	["ItemCategoryWithoutGroupUpdateInput"]: {
		name?: string,
	shortDescription?: string,
	subCategories?: Array<GraphQLTypes["ItemCategoryUpdateSubCategoriesEntityRelationInput"]>,
	blogPosts?: Array<GraphQLTypes["ItemCategoryUpdateBlogPostsEntityRelationInput"]>,
	items?: Array<GraphQLTypes["ItemCategoryUpdateItemsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["ItemCategoryUpdateProductsEntityRelationInput"]>,
	featureDependencies?: Array<GraphQLTypes["ItemCategoryUpdateFeatureDependenciesEntityRelationInput"]>,
	declensionSixth?: string,
	remoteId?: string,
	image?: GraphQLTypes["ItemCategoryUpdateImageEntityRelationInput"],
	comparatorGroupId?: string,
	ads?: Array<GraphQLTypes["ItemCategoryUpdateAdsEntityRelationInput"]>,
	slug?: string,
	redirects?: Array<GraphQLTypes["ItemCategoryUpdateRedirectsEntityRelationInput"]>,
	declensionsFourth?: Array<GraphQLTypes["ItemCategoryUpdateDeclensionsFourthEntityRelationInput"]>,
	seo?: GraphQLTypes["ItemCategoryUpdateSeoEntityRelationInput"],
	declensionSeventh?: string,
	slugWith?: string,
	slugWithNegative?: string,
	declensionSeventhNegative?: string,
	content?: GraphQLTypes["ItemCategoryUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["ItemCategoryUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ItemGroupUpsertCategoriesRelationInput"]: {
		by: GraphQLTypes["ItemCategoryUniqueWhere"],
	update: GraphQLTypes["ItemCategoryWithoutGroupUpdateInput"],
	create: GraphQLTypes["ItemCategoryWithoutGroupCreateInput"]
};
	["SearchResult"]: {
	__typename: "SearchResult",
	_meta?: GraphQLTypes["SearchResultMeta"],
	id: GraphQLTypes["UUID"],
	brand?: GraphQLTypes["Brand"],
	brandName?: string,
	productLine?: GraphQLTypes["ProductLine"],
	productLineName?: string,
	product?: GraphQLTypes["Product"],
	productName?: string,
	searchable: string
};
	["SearchResultMeta"]: {
	__typename: "SearchResultMeta",
	id?: GraphQLTypes["FieldMeta"],
	brand?: GraphQLTypes["FieldMeta"],
	brandName?: GraphQLTypes["FieldMeta"],
	productLine?: GraphQLTypes["FieldMeta"],
	productLineName?: GraphQLTypes["FieldMeta"],
	product?: GraphQLTypes["FieldMeta"],
	productName?: GraphQLTypes["FieldMeta"],
	searchable?: GraphQLTypes["FieldMeta"]
};
	["SearchResultUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SearchResultWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	brand?: GraphQLTypes["BrandWhere"],
	brandName?: GraphQLTypes["StringCondition"],
	productLine?: GraphQLTypes["ProductLineWhere"],
	productLineName?: GraphQLTypes["StringCondition"],
	product?: GraphQLTypes["ProductWhere"],
	productName?: GraphQLTypes["StringCondition"],
	searchable?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["SearchResultWhere"] | undefined>,
	or?: Array<GraphQLTypes["SearchResultWhere"] | undefined>,
	not?: GraphQLTypes["SearchResultWhere"]
};
	["SearchResultOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	brand?: GraphQLTypes["BrandOrderBy"],
	brandName?: GraphQLTypes["OrderDirection"],
	productLine?: GraphQLTypes["ProductLineOrderBy"],
	productLineName?: GraphQLTypes["OrderDirection"],
	product?: GraphQLTypes["ProductOrderBy"],
	productName?: GraphQLTypes["OrderDirection"],
	searchable?: GraphQLTypes["OrderDirection"]
};
	["SearchResultConnection"]: {
	__typename: "SearchResultConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SearchResultEdge"]>
};
	["SearchResultEdge"]: {
	__typename: "SearchResultEdge",
	node: GraphQLTypes["SearchResult"]
};
	["ProductEvaluationSummary"]: {
	__typename: "ProductEvaluationSummary",
	_meta?: GraphQLTypes["ProductEvaluationSummaryMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	title: string,
	icon?: GraphQLTypes["Image"]
};
	["ProductEvaluationSummaryMeta"]: {
	__typename: "ProductEvaluationSummaryMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	icon?: GraphQLTypes["FieldMeta"]
};
	["ProductEvaluationSummaryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string
};
	["ProductEvaluationSummaryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	title?: GraphQLTypes["StringCondition"],
	icon?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["ProductEvaluationSummaryWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductEvaluationSummaryWhere"] | undefined>,
	not?: GraphQLTypes["ProductEvaluationSummaryWhere"]
};
	["ProductEvaluationSummaryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	icon?: GraphQLTypes["ImageOrderBy"]
};
	["ProductEvaluationSummaryConnection"]: {
	__typename: "ProductEvaluationSummaryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductEvaluationSummaryEdge"]>
};
	["ProductEvaluationSummaryEdge"]: {
	__typename: "ProductEvaluationSummaryEdge",
	node: GraphQLTypes["ProductEvaluationSummary"]
};
	["ProductEvaluationSummaryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	title?: string,
	icon?: GraphQLTypes["ProductEvaluationSummaryCreateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductEvaluationSummaryCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductEvaluationSummaryConnectOrCreateIconRelationInput"]
};
	["ProductEvaluationSummaryConnectOrCreateIconRelationInput"]: {
		connect: GraphQLTypes["ImageUniqueWhere"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ProductEvaluationSummaryUpdateInput"]: {
		remoteId?: string,
	title?: string,
	icon?: GraphQLTypes["ProductEvaluationSummaryUpdateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductEvaluationSummaryUpdateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductEvaluationSummaryConnectOrCreateIconRelationInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ProductEvaluationSummaryUpsertIconRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductEvaluationSummaryUpsertIconRelationInput"]: {
		update: GraphQLTypes["ImageUpdateInput"],
	create: GraphQLTypes["ImageCreateInput"]
};
	["ProtectedActionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ProtectedActionType"],
	createdAt?: GraphQLTypes["DateTime"],
	usedAt?: GraphQLTypes["DateTime"],
	expiresAt?: GraphQLTypes["DateTime"],
	publicKey?: string,
	secretHash?: string,
	verifyEmail?: string,
	createdMetadata?: GraphQLTypes["Json"],
	usedMetadata?: GraphQLTypes["Json"],
	user?: GraphQLTypes["ProtectedActionCreateUserEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProtectedActionCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutProtectedActionsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProtectedActionConnectOrCreateUserRelationInput"]
};
	["UserWithoutProtectedActionsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dogs?: Array<GraphQLTypes["UserCreateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserCreateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserCreateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserCreateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserCreateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserCreateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserCreateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserCreateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserCreateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserCreateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserCreateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["ProtectedActionConnectOrCreateUserRelationInput"]: {
		connect: GraphQLTypes["UserUniqueWhere"],
	create: GraphQLTypes["UserWithoutProtectedActionsCreateInput"]
};
	["ProtectedActionUpdateInput"]: {
		type?: GraphQLTypes["ProtectedActionType"],
	createdAt?: GraphQLTypes["DateTime"],
	usedAt?: GraphQLTypes["DateTime"],
	expiresAt?: GraphQLTypes["DateTime"],
	publicKey?: string,
	secretHash?: string,
	verifyEmail?: string,
	createdMetadata?: GraphQLTypes["Json"],
	usedMetadata?: GraphQLTypes["Json"],
	user?: GraphQLTypes["ProtectedActionUpdateUserEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProtectedActionUpdateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutProtectedActionsCreateInput"],
	connectOrCreate?: GraphQLTypes["ProtectedActionConnectOrCreateUserRelationInput"],
	update?: GraphQLTypes["UserWithoutProtectedActionsUpdateInput"],
	upsert?: GraphQLTypes["ProtectedActionUpsertUserRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["UserWithoutProtectedActionsUpdateInput"]: {
		dogs?: Array<GraphQLTypes["UserUpdateDogsEntityRelationInput"]>,
	veterinary?: GraphQLTypes["UserUpdateVeterinaryEntityRelationInput"],
	email?: string,
	blogPostReviews?: Array<GraphQLTypes["UserUpdateBlogPostReviewsEntityRelationInput"]>,
	productReviews?: Array<GraphQLTypes["UserUpdateProductReviewsEntityRelationInput"]>,
	blogPostReviewReactions?: Array<GraphQLTypes["UserUpdateBlogPostReviewReactionsEntityRelationInput"]>,
	productReviewReactions?: Array<GraphQLTypes["UserUpdateProductReviewReactionsEntityRelationInput"]>,
	tenantPersonId?: GraphQLTypes["UUID"],
	fullName?: string,
	blogPosts?: Array<GraphQLTypes["UserUpdateBlogPostsEntityRelationInput"]>,
	createdAt?: GraphQLTypes["DateTime"],
	verifiedAt?: GraphQLTypes["DateTime"],
	avatar?: GraphQLTypes["UserUpdateAvatarEntityRelationInput"],
	contactFormMessages?: Array<GraphQLTypes["UserUpdateContactFormMessagesEntityRelationInput"]>,
	bugReports?: Array<GraphQLTypes["UserUpdateBugReportsEntityRelationInput"]>,
	verifiedEmail?: string,
	blockedAt?: GraphQLTypes["DateTime"],
	tenantPerson?: GraphQLTypes["UserUpdateTenantPersonEntityRelationInput"],
	note?: string,
	_dummy_field_?: boolean
};
	["ProtectedActionUpsertUserRelationInput"]: {
		update: GraphQLTypes["UserWithoutProtectedActionsUpdateInput"],
	create: GraphQLTypes["UserWithoutProtectedActionsCreateInput"]
};
	["BrandAliasCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	name?: string,
	brand?: GraphQLTypes["BrandAliasCreateBrandEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandAliasCreateBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutAliasesCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandAliasConnectOrCreateBrandRelationInput"]
};
	["BrandWithoutAliasesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["BrandCreateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandCreateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandCreateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandCreateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandCreateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandCreateDistributorEntityRelationInput"],
	ads?: Array<GraphQLTypes["BrandCreateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandCreateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandCreateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandAliasConnectOrCreateBrandRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandWithoutAliasesCreateInput"]
};
	["BrandAliasUpdateInput"]: {
		remoteId?: string,
	name?: string,
	brand?: GraphQLTypes["BrandAliasUpdateBrandEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandAliasUpdateBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutAliasesCreateInput"],
	connectOrCreate?: GraphQLTypes["BrandAliasConnectOrCreateBrandRelationInput"],
	update?: GraphQLTypes["BrandWithoutAliasesUpdateInput"],
	upsert?: GraphQLTypes["BrandAliasUpsertBrandRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["BrandWithoutAliasesUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["BrandUpdateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandUpdateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandUpdateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandUpdateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandUpdateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandUpdateDistributorEntityRelationInput"],
	ads?: Array<GraphQLTypes["BrandUpdateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandUpdateFilterCombosEntityRelationInput"]>,
	topx?: Array<GraphQLTypes["BrandUpdateTopxEntityRelationInput"]>,
	content?: GraphQLTypes["BrandUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BrandAliasUpsertBrandRelationInput"]: {
		update: GraphQLTypes["BrandWithoutAliasesUpdateInput"],
	create: GraphQLTypes["BrandWithoutAliasesCreateInput"]
};
	["ProductAliasCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	name?: string,
	product?: GraphQLTypes["ProductAliasCreateProductEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductAliasCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutAliasesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductAliasConnectOrCreateProductRelationInput"]
};
	["ProductWithoutAliasesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductCreateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductAliasConnectOrCreateProductRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutAliasesCreateInput"]
};
	["ProductAliasUpdateInput"]: {
		remoteId?: string,
	name?: string,
	product?: GraphQLTypes["ProductAliasUpdateProductEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ProductAliasUpdateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutAliasesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductAliasConnectOrCreateProductRelationInput"],
	update?: GraphQLTypes["ProductWithoutAliasesUpdateInput"],
	upsert?: GraphQLTypes["ProductAliasUpsertProductRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ProductWithoutAliasesUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	topx?: Array<GraphQLTypes["ProductUpdateTopxEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductAliasUpsertProductRelationInput"]: {
		update: GraphQLTypes["ProductWithoutAliasesUpdateInput"],
	create: GraphQLTypes["ProductWithoutAliasesCreateInput"]
};
	["ProductLineAliasCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	name?: string,
	productLines?: Array<GraphQLTypes["ProductLineAliasCreateProductLinesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductLineAliasCreateProductLinesEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductLineUniqueWhere"],
	create?: GraphQLTypes["ProductLineWithoutAliasesCreateInput"],
	connectOrCreate?: GraphQLTypes["ProductLineAliasConnectOrCreateProductLinesRelationInput"],
	alias?: string
};
	["ProductLineWithoutAliasesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["ProductLineCreateProductsEntityRelationInput"]>,
	remoteId?: string,
	lead?: string,
	order?: number,
	brand?: GraphQLTypes["ProductLineCreateBrandEntityRelationInput"],
	logo?: GraphQLTypes["ProductLineCreateLogoEntityRelationInput"],
	slug?: string,
	flavors?: Array<GraphQLTypes["ProductLineCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["ProductLineCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	_dummy_field_?: boolean
};
	["ProductLineAliasConnectOrCreateProductLinesRelationInput"]: {
		connect: GraphQLTypes["ProductLineUniqueWhere"],
	create: GraphQLTypes["ProductLineWithoutAliasesCreateInput"]
};
	["ProductLineAliasUpdateInput"]: {
		remoteId?: string,
	name?: string,
	productLines?: Array<GraphQLTypes["ProductLineAliasUpdateProductLinesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ProductLineAliasUpdateProductLinesEntityRelationInput"]: {
		create?: GraphQLTypes["ProductLineWithoutAliasesCreateInput"],
	update?: GraphQLTypes["ProductLineAliasUpdateProductLinesRelationInput"],
	upsert?: GraphQLTypes["ProductLineAliasUpsertProductLinesRelationInput"],
	connect?: GraphQLTypes["ProductLineUniqueWhere"],
	disconnect?: GraphQLTypes["ProductLineUniqueWhere"],
	delete?: GraphQLTypes["ProductLineUniqueWhere"],
	alias?: string
};
	["ProductLineAliasUpdateProductLinesRelationInput"]: {
		by: GraphQLTypes["ProductLineUniqueWhere"],
	data: GraphQLTypes["ProductLineWithoutAliasesUpdateInput"]
};
	["ProductLineWithoutAliasesUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["ProductLineUpdateProductsEntityRelationInput"]>,
	remoteId?: string,
	lead?: string,
	order?: number,
	brand?: GraphQLTypes["ProductLineUpdateBrandEntityRelationInput"],
	logo?: GraphQLTypes["ProductLineUpdateLogoEntityRelationInput"],
	slug?: string,
	flavors?: Array<GraphQLTypes["ProductLineUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["ProductLineUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	_dummy_field_?: boolean
};
	["ProductLineAliasUpsertProductLinesRelationInput"]: {
		by: GraphQLTypes["ProductLineUniqueWhere"],
	update: GraphQLTypes["ProductLineWithoutAliasesUpdateInput"],
	create: GraphQLTypes["ProductLineWithoutAliasesCreateInput"]
};
	["GenericPageConnection"]: {
	__typename: "GenericPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GenericPageEdge"]>
};
	["GenericPageEdge"]: {
	__typename: "GenericPageEdge",
	node: GraphQLTypes["GenericPage"]
};
	["GenericPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["GenericPageCreateLinkEntityRelationInput"],
	redirects?: Array<GraphQLTypes["GenericPageCreateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["GenericPageCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["GenericPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["GenericPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GenericPageUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["GenericPageUpdateLinkEntityRelationInput"],
	redirects?: Array<GraphQLTypes["GenericPageUpdateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["GenericPageUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["GenericPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["GenericPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableConnection"]: {
	__typename: "LinkableConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
	__typename: "LinkableEdge",
	node: GraphQLTypes["Linkable"]
};
	["LinkableCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	genericPage?: GraphQLTypes["LinkableCreateGenericPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreateGenericPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageUniqueWhere"],
	create?: GraphQLTypes["GenericPageWithoutLinkCreateInput"],
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateGenericPageRelationInput"]
};
	["GenericPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	redirects?: Array<GraphQLTypes["GenericPageCreateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["GenericPageCreateSeoEntityRelationInput"],
	content?: GraphQLTypes["GenericPageCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["GenericPageCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableConnectOrCreateGenericPageRelationInput"]: {
		connect: GraphQLTypes["GenericPageUniqueWhere"],
	create: GraphQLTypes["GenericPageWithoutLinkCreateInput"]
};
	["LinkableUpdateInput"]: {
		url?: string,
	genericPage?: GraphQLTypes["LinkableUpdateGenericPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdateGenericPageEntityRelationInput"]: {
		connect?: GraphQLTypes["GenericPageUniqueWhere"],
	create?: GraphQLTypes["GenericPageWithoutLinkCreateInput"],
	connectOrCreate?: GraphQLTypes["LinkableConnectOrCreateGenericPageRelationInput"],
	update?: GraphQLTypes["GenericPageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertGenericPageRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["GenericPageWithoutLinkUpdateInput"]: {
		title?: string,
	redirects?: Array<GraphQLTypes["GenericPageUpdateRedirectsEntityRelationInput"]>,
	seo?: GraphQLTypes["GenericPageUpdateSeoEntityRelationInput"],
	content?: GraphQLTypes["GenericPageUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["GenericPageUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpsertGenericPageRelationInput"]: {
		update: GraphQLTypes["GenericPageWithoutLinkUpdateInput"],
	create: GraphQLTypes["GenericPageWithoutLinkCreateInput"]
};
	["ContentLinksConnection"]: {
	__typename: "ContentLinksConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentLinksEdge"]>
};
	["ContentLinksEdge"]: {
	__typename: "ContentLinksEdge",
	node: GraphQLTypes["ContentLinks"]
};
	["ContentLinksItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	target?: string,
	list?: GraphQLTypes["ContentLinksItemCreateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentLinksItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentLinksUniqueWhere"],
	create?: GraphQLTypes["ContentLinksWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentLinksItemConnectOrCreateListRelationInput"]
};
	["ContentLinksWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ContentLinksItemConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["ContentLinksUniqueWhere"],
	create: GraphQLTypes["ContentLinksWithoutItemsCreateInput"]
};
	["ContentLinksItemUpdateInput"]: {
		order?: number,
	title?: string,
	target?: string,
	list?: GraphQLTypes["ContentLinksItemUpdateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentLinksItemUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentLinksUniqueWhere"],
	create?: GraphQLTypes["ContentLinksWithoutItemsCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentLinksItemConnectOrCreateListRelationInput"],
	update?: GraphQLTypes["ContentLinksWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ContentLinksItemUpsertListRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentLinksWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ContentLinksItemUpsertListRelationInput"]: {
		update: GraphQLTypes["ContentLinksWithoutItemsUpdateInput"],
	create: GraphQLTypes["ContentLinksWithoutItemsCreateInput"]
};
	["RedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectCreateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectCreateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectCreateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectCreateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectCreateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectCreateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectCreateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectCreateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateInput"]: {
		to?: string,
	order?: number,
	from?: string,
	genericPage?: GraphQLTypes["RedirectUpdateGenericPageEntityRelationInput"],
	itemCategory?: GraphQLTypes["RedirectUpdateItemCategoryEntityRelationInput"],
	brandsPage?: GraphQLTypes["RedirectUpdateBrandsPageEntityRelationInput"],
	blogPage?: GraphQLTypes["RedirectUpdateBlogPageEntityRelationInput"],
	contactPage?: GraphQLTypes["RedirectUpdateContactPageEntityRelationInput"],
	wizardPage?: GraphQLTypes["RedirectUpdateWizardPageEntityRelationInput"],
	comparatorPage?: GraphQLTypes["RedirectUpdateComparatorPageEntityRelationInput"],
	blogPost?: GraphQLTypes["RedirectUpdateBlogPostEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceImageConnection"]: {
	__typename: "ContentReferenceImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceImageEdge"]>
};
	["ContentReferenceImageEdge"]: {
	__typename: "ContentReferenceImageEdge",
	node: GraphQLTypes["ContentReferenceImage"]
};
	["SeoData"]: {
	__typename: "SeoData",
	_meta?: GraphQLTypes["SeoDataMeta"],
	id: GraphQLTypes["UUID"],
	remoteId: string,
	url: string,
	seo?: GraphQLTypes["Seo"]
};
	["SeoDataMeta"]: {
	__typename: "SeoDataMeta",
	id?: GraphQLTypes["FieldMeta"],
	remoteId?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["SeoDataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	url?: string,
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["SeoDataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	remoteId?: GraphQLTypes["StringCondition"],
	url?: GraphQLTypes["StringCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["SeoDataWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoDataWhere"] | undefined>,
	not?: GraphQLTypes["SeoDataWhere"]
};
	["SeoDataOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	remoteId?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["SeoDataConnection"]: {
	__typename: "SeoDataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoDataEdge"]>
};
	["SeoDataEdge"]: {
	__typename: "SeoDataEdge",
	node: GraphQLTypes["SeoData"]
};
	["SeoDataCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	url?: string,
	seo?: GraphQLTypes["SeoDataCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoDataCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoDataConnectOrCreateSeoRelationInput"]
};
	["SeoDataConnectOrCreateSeoRelationInput"]: {
		connect: GraphQLTypes["SeoUniqueWhere"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["SeoDataUpdateInput"]: {
		remoteId?: string,
	url?: string,
	seo?: GraphQLTypes["SeoDataUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoDataUpdateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"],
	connectOrCreate?: GraphQLTypes["SeoDataConnectOrCreateSeoRelationInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["SeoDataUpsertSeoRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoDataUpsertSeoRelationInput"]: {
		update: GraphQLTypes["SeoUpdateInput"],
	create: GraphQLTypes["SeoCreateInput"]
};
	["TenantPersonConnection"]: {
	__typename: "TenantPersonConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TenantPersonEdge"]>
};
	["TenantPersonEdge"]: {
	__typename: "TenantPersonEdge",
	node: GraphQLTypes["TenantPerson"]
};
	["AgeCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	order?: number,
	labelFor?: string,
	products?: Array<GraphQLTypes["AgeCategoryCreateProductsEntityRelationInput"]>,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["AgeCategoryCreateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AgeCategoryUpdateInput"]: {
		remoteId?: string,
	order?: number,
	labelFor?: string,
	products?: Array<GraphQLTypes["AgeCategoryUpdateProductsEntityRelationInput"]>,
	slug?: string,
	filterCombos?: Array<GraphQLTypes["AgeCategoryUpdateFilterCombosEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FilterComboCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboCreateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboCreateBreedEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboCreateBrandEntityRelationInput"],
	region?: GraphQLTypes["FilterComboCreateRegionEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboCreateAgeCategoryEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboCreateTreatmentEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboCreateFlavorEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboCreateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FilterComboUpdateInput"]: {
		remoteId?: string,
	title?: string,
	lead?: string,
	seo?: GraphQLTypes["FilterComboUpdateSeoEntityRelationInput"],
	breed?: GraphQLTypes["FilterComboUpdateBreedEntityRelationInput"],
	brand?: GraphQLTypes["FilterComboUpdateBrandEntityRelationInput"],
	region?: GraphQLTypes["FilterComboUpdateRegionEntityRelationInput"],
	ageCategory?: GraphQLTypes["FilterComboUpdateAgeCategoryEntityRelationInput"],
	treatment?: GraphQLTypes["FilterComboUpdateTreatmentEntityRelationInput"],
	flavor?: GraphQLTypes["FilterComboUpdateFlavorEntityRelationInput"],
	allergy?: GraphQLTypes["FilterComboUpdateAllergyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImportCache"]: {
	__typename: "ImportCache",
	_meta?: GraphQLTypes["ImportCacheMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	latestImportAt?: GraphQLTypes["DateTime"],
	latestImportHash?: string
};
	["ImportCacheMeta"]: {
	__typename: "ImportCacheMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	latestImportAt?: GraphQLTypes["FieldMeta"],
	latestImportHash?: GraphQLTypes["FieldMeta"]
};
	["ImportCacheUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"]
};
	["ImportCacheWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	latestImportAt?: GraphQLTypes["DateTimeCondition"],
	latestImportHash?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ImportCacheWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImportCacheWhere"] | undefined>,
	not?: GraphQLTypes["ImportCacheWhere"]
};
	["ImportCacheOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	latestImportAt?: GraphQLTypes["OrderDirection"],
	latestImportHash?: GraphQLTypes["OrderDirection"]
};
	["ImportCacheConnection"]: {
	__typename: "ImportCacheConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImportCacheEdge"]>
};
	["ImportCacheEdge"]: {
	__typename: "ImportCacheEdge",
	node: GraphQLTypes["ImportCache"]
};
	["ImportCacheCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	latestImportAt?: GraphQLTypes["DateTime"],
	latestImportHash?: string,
	_dummy_field_?: boolean
};
	["ImportCacheUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	latestImportAt?: GraphQLTypes["DateTime"],
	latestImportHash?: string,
	_dummy_field_?: boolean
};
	["Site"]: {
	__typename: "Site",
	_meta?: GraphQLTypes["SiteMeta"],
	id: GraphQLTypes["UUID"],
	reindexingAt?: GraphQLTypes["DateTime"],
	unique: GraphQLTypes["One"]
};
	["SiteMeta"]: {
	__typename: "SiteMeta",
	id?: GraphQLTypes["FieldMeta"],
	reindexingAt?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"]
};
	["SiteUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"]
};
	["SiteWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	reindexingAt?: GraphQLTypes["DateTimeCondition"],
	unique?: GraphQLTypes["OneCondition"],
	and?: Array<GraphQLTypes["SiteWhere"] | undefined>,
	or?: Array<GraphQLTypes["SiteWhere"] | undefined>,
	not?: GraphQLTypes["SiteWhere"]
};
	["SiteOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	reindexingAt?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"]
};
	["SiteConnection"]: {
	__typename: "SiteConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SiteEdge"]>
};
	["SiteEdge"]: {
	__typename: "SiteEdge",
	node: GraphQLTypes["Site"]
};
	["SiteCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	reindexingAt?: GraphQLTypes["DateTime"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["SiteUpdateInput"]: {
		reindexingAt?: GraphQLTypes["DateTime"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["ContactSubmission"]: {
	__typename: "ContactSubmission",
	_meta?: GraphQLTypes["ContactSubmissionMeta"],
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	eBookVariant?: GraphQLTypes["BookType"],
	email?: string,
	newsletterSubscribed: boolean
};
	["ContactSubmissionMeta"]: {
	__typename: "ContactSubmissionMeta",
	id?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"],
	eBookVariant?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	newsletterSubscribed?: GraphQLTypes["FieldMeta"]
};
	["BookType"]: BookType;
	["ContactSubmissionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ContactSubmissionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	eBookVariant?: GraphQLTypes["BookTypeCondition"],
	email?: GraphQLTypes["StringCondition"],
	newsletterSubscribed?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["ContactSubmissionWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContactSubmissionWhere"] | undefined>,
	not?: GraphQLTypes["ContactSubmissionWhere"]
};
	["BookTypeCondition"]: {
		and?: Array<GraphQLTypes["BookTypeCondition"]>,
	or?: Array<GraphQLTypes["BookTypeCondition"]>,
	not?: GraphQLTypes["BookTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["BookType"],
	notEq?: GraphQLTypes["BookType"],
	in?: Array<GraphQLTypes["BookType"]>,
	notIn?: Array<GraphQLTypes["BookType"]>,
	lt?: GraphQLTypes["BookType"],
	lte?: GraphQLTypes["BookType"],
	gt?: GraphQLTypes["BookType"],
	gte?: GraphQLTypes["BookType"]
};
	["ContactSubmissionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	createdAt?: GraphQLTypes["OrderDirection"],
	eBookVariant?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	newsletterSubscribed?: GraphQLTypes["OrderDirection"]
};
	["ContactSubmissionConnection"]: {
	__typename: "ContactSubmissionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContactSubmissionEdge"]>
};
	["ContactSubmissionEdge"]: {
	__typename: "ContactSubmissionEdge",
	node: GraphQLTypes["ContactSubmission"]
};
	["ContactSubmissionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"],
	eBookVariant?: GraphQLTypes["BookType"],
	email?: string,
	newsletterSubscribed?: boolean,
	_dummy_field_?: boolean
};
	["ContactSubmissionUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"],
	eBookVariant?: GraphQLTypes["BookType"],
	email?: string,
	newsletterSubscribed?: boolean,
	_dummy_field_?: boolean
};
	["TOPXBrandCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	order?: number,
	orderType?: GraphQLTypes["TOPXBrandOrderType"],
	brand?: GraphQLTypes["TOPXBrandCreateBrandEntityRelationInput"],
	category?: GraphQLTypes["TOPXBrandCreateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXBrandCreateBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutTopxCreateInput"],
	connectOrCreate?: GraphQLTypes["TOPXBrandConnectOrCreateBrandRelationInput"]
};
	["BrandWithoutTopxCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	products?: Array<GraphQLTypes["BrandCreateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandCreateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandCreateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandCreateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandCreateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandCreateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandCreateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandCreateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandCreateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandCreateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandCreateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandCreateFilterCombosEntityRelationInput"]>,
	content?: GraphQLTypes["BrandCreateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandCreateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXBrandConnectOrCreateBrandRelationInput"]: {
		connect: GraphQLTypes["BrandUniqueWhere"],
	create: GraphQLTypes["BrandWithoutTopxCreateInput"]
};
	["TOPXBrandUpdateInput"]: {
		remoteId?: string,
	order?: number,
	orderType?: GraphQLTypes["TOPXBrandOrderType"],
	brand?: GraphQLTypes["TOPXBrandUpdateBrandEntityRelationInput"],
	category?: GraphQLTypes["TOPXBrandUpdateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXBrandUpdateBrandEntityRelationInput"]: {
		connect?: GraphQLTypes["BrandUniqueWhere"],
	create?: GraphQLTypes["BrandWithoutTopxCreateInput"],
	connectOrCreate?: GraphQLTypes["TOPXBrandConnectOrCreateBrandRelationInput"],
	update?: GraphQLTypes["BrandWithoutTopxUpdateInput"],
	upsert?: GraphQLTypes["TOPXBrandUpsertBrandRelationInput"],
	delete?: boolean
};
	["BrandWithoutTopxUpdateInput"]: {
		name?: string,
	products?: Array<GraphQLTypes["BrandUpdateProductsEntityRelationInput"]>,
	link?: string,
	countriesOfProduction?: Array<GraphQLTypes["BrandUpdateCountriesOfProductionEntityRelationInput"]>,
	manufacturers?: Array<GraphQLTypes["BrandUpdateManufacturersEntityRelationInput"]>,
	remoteId?: string,
	promotedOnSearchPlace?: number,
	promotedOnBrandsPagePlace?: number,
	lead?: string,
	productLines?: Array<GraphQLTypes["BrandUpdateProductLinesEntityRelationInput"]>,
	logo?: GraphQLTypes["BrandUpdateLogoEntityRelationInput"],
	methodOfProduction?: GraphQLTypes["BrandUpdateMethodOfProductionEntityRelationInput"],
	distributor?: GraphQLTypes["BrandUpdateDistributorEntityRelationInput"],
	aliases?: Array<GraphQLTypes["BrandUpdateAliasesEntityRelationInput"]>,
	ads?: Array<GraphQLTypes["BrandUpdateAdsEntityRelationInput"]>,
	slug?: string,
	flavors?: Array<GraphQLTypes["BrandUpdateFlavorsEntityRelationInput"]>,
	seo?: GraphQLTypes["BrandUpdateSeoEntityRelationInput"],
	customMetaDescription?: string,
	filterCombos?: Array<GraphQLTypes["BrandUpdateFilterCombosEntityRelationInput"]>,
	content?: GraphQLTypes["BrandUpdateContentEntityRelationInput"],
	draft?: GraphQLTypes["BrandUpdateDraftEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXBrandUpsertBrandRelationInput"]: {
		update: GraphQLTypes["BrandWithoutTopxUpdateInput"],
	create: GraphQLTypes["BrandWithoutTopxCreateInput"]
};
	["TOPXBrandCategoryConnection"]: {
	__typename: "TOPXBrandCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TOPXBrandCategoryEdge"]>
};
	["TOPXBrandCategoryEdge"]: {
	__typename: "TOPXBrandCategoryEdge",
	node: GraphQLTypes["TOPXBrandCategory"]
};
	["TOPXBrandCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	brands?: Array<GraphQLTypes["TOPXBrandCategoryCreateBrandsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TOPXBrandCategoryCreateBrandsEntityRelationInput"]: {
		connect?: GraphQLTypes["TOPXBrandUniqueWhere"],
	create?: GraphQLTypes["TOPXBrandWithoutCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["TOPXBrandCategoryConnectOrCreateBrandsRelationInput"],
	alias?: string
};
	["TOPXBrandWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	order?: number,
	orderType?: GraphQLTypes["TOPXBrandOrderType"],
	brand?: GraphQLTypes["TOPXBrandCreateBrandEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXBrandCategoryConnectOrCreateBrandsRelationInput"]: {
		connect: GraphQLTypes["TOPXBrandUniqueWhere"],
	create: GraphQLTypes["TOPXBrandWithoutCategoryCreateInput"]
};
	["TOPXBrandCategoryUpdateInput"]: {
		remoteId?: string,
	brands?: Array<GraphQLTypes["TOPXBrandCategoryUpdateBrandsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TOPXBrandCategoryUpdateBrandsEntityRelationInput"]: {
		create?: GraphQLTypes["TOPXBrandWithoutCategoryCreateInput"],
	update?: GraphQLTypes["TOPXBrandCategoryUpdateBrandsRelationInput"],
	upsert?: GraphQLTypes["TOPXBrandCategoryUpsertBrandsRelationInput"],
	connect?: GraphQLTypes["TOPXBrandUniqueWhere"],
	disconnect?: GraphQLTypes["TOPXBrandUniqueWhere"],
	delete?: GraphQLTypes["TOPXBrandUniqueWhere"],
	alias?: string
};
	["TOPXBrandCategoryUpdateBrandsRelationInput"]: {
		by: GraphQLTypes["TOPXBrandUniqueWhere"],
	data: GraphQLTypes["TOPXBrandWithoutCategoryUpdateInput"]
};
	["TOPXBrandWithoutCategoryUpdateInput"]: {
		remoteId?: string,
	order?: number,
	orderType?: GraphQLTypes["TOPXBrandOrderType"],
	brand?: GraphQLTypes["TOPXBrandUpdateBrandEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXBrandCategoryUpsertBrandsRelationInput"]: {
		by: GraphQLTypes["TOPXBrandUniqueWhere"],
	update: GraphQLTypes["TOPXBrandWithoutCategoryUpdateInput"],
	create: GraphQLTypes["TOPXBrandWithoutCategoryCreateInput"]
};
	["TOPXProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	order?: number,
	orderType?: GraphQLTypes["TOPXProductOrderType"],
	product?: GraphQLTypes["TOPXProductCreateProductEntityRelationInput"],
	category?: GraphQLTypes["TOPXProductCreateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXProductCreateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutTopxCreateInput"],
	connectOrCreate?: GraphQLTypes["TOPXProductConnectOrCreateProductRelationInput"]
};
	["ProductWithoutTopxCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	nutritionalValues?: Array<GraphQLTypes["ProductCreateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductCreatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductCreateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductCreateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductCreateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductCreatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductCreateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductCreateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductCreateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductCreateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductCreateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductCreateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductCreateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductCreateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductCreateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductCreateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductCreateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductCreateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductCreateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductCreateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductCreateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductCreateHeurekaImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXProductConnectOrCreateProductRelationInput"]: {
		connect: GraphQLTypes["ProductUniqueWhere"],
	create: GraphQLTypes["ProductWithoutTopxCreateInput"]
};
	["TOPXProductUpdateInput"]: {
		remoteId?: string,
	order?: number,
	orderType?: GraphQLTypes["TOPXProductOrderType"],
	product?: GraphQLTypes["TOPXProductUpdateProductEntityRelationInput"],
	category?: GraphQLTypes["TOPXProductUpdateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXProductUpdateProductEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutTopxCreateInput"],
	connectOrCreate?: GraphQLTypes["TOPXProductConnectOrCreateProductRelationInput"],
	update?: GraphQLTypes["ProductWithoutTopxUpdateInput"],
	upsert?: GraphQLTypes["TOPXProductUpsertProductRelationInput"],
	delete?: boolean
};
	["ProductWithoutTopxUpdateInput"]: {
		nutritionalValues?: Array<GraphQLTypes["ProductUpdateNutritionalValuesEntityRelationInput"]>,
	name?: string,
	positiveForBodyTags?: Array<GraphQLTypes["ProductUpdatePositiveForBodyTagsEntityRelationInput"]>,
	negativeForBodyTags?: Array<GraphQLTypes["ProductUpdateNegativeForBodyTagsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ProductUpdateReviewsEntityRelationInput"]>,
	score?: number,
	dogs?: Array<GraphQLTypes["ProductUpdateDogsEntityRelationInput"]>,
	firstFiveItems?: string,
	detailedComposition?: string,
	guaranteedAnalysis?: string,
	isVeterinaryDiet?: boolean,
	packagings?: Array<GraphQLTypes["ProductUpdatePackagingsEntityRelationInput"]>,
	itemSubCategories?: Array<GraphQLTypes["ProductUpdateItemSubCategoriesEntityRelationInput"]>,
	itemCategories?: Array<GraphQLTypes["ProductUpdateItemCategoriesEntityRelationInput"]>,
	elements?: Array<GraphQLTypes["ProductUpdateElementsEntityRelationInput"]>,
	isSearchVisible?: boolean,
	isSuitableForEliminationDiet?: boolean,
	remoteId?: string,
	recommendedDogSizes?: Array<GraphQLTypes["ProductUpdateRecommendedDogSizesEntityRelationInput"]>,
	granuleSizes?: Array<GraphQLTypes["ProductUpdateGranuleSizesEntityRelationInput"]>,
	productLine?: GraphQLTypes["ProductUpdateProductLineEntityRelationInput"],
	flags?: Array<GraphQLTypes["ProductUpdateFlagsEntityRelationInput"]>,
	image?: GraphQLTypes["ProductUpdateImageEntityRelationInput"],
	recommendedActivity?: GraphQLTypes["ProductUpdateRecommendedActivityEntityRelationInput"],
	brand?: GraphQLTypes["ProductUpdateBrandEntityRelationInput"],
	metabolizedEnergy?: number,
	cheapnessValue?: number,
	aliases?: Array<GraphQLTypes["ProductUpdateAliasesEntityRelationInput"]>,
	slug?: string,
	animalProteinStatus?: GraphQLTypes["ContentAmount"],
	carbohydrateStatus?: GraphQLTypes["ContentAmount"],
	evaluation?: GraphQLTypes["ProductUpdateEvaluationEntityRelationInput"],
	missingComposition?: boolean,
	seo?: GraphQLTypes["ProductUpdateSeoEntityRelationInput"],
	czkPerMetabolizedEnergy?: number,
	itemDeclensionFourthCategories?: Array<GraphQLTypes["ProductUpdateItemDeclensionFourthCategoriesEntityRelationInput"]>,
	ageCategories?: Array<GraphQLTypes["ProductUpdateAgeCategoriesEntityRelationInput"]>,
	customMetaTitle?: string,
	customMetaDescription?: string,
	isSuitableForCastrated?: boolean,
	heurekaImage?: GraphQLTypes["ProductUpdateHeurekaImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXProductUpsertProductRelationInput"]: {
		update: GraphQLTypes["ProductWithoutTopxUpdateInput"],
	create: GraphQLTypes["ProductWithoutTopxCreateInput"]
};
	["TOPXProductCategoryConnection"]: {
	__typename: "TOPXProductCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TOPXProductCategoryEdge"]>
};
	["TOPXProductCategoryEdge"]: {
	__typename: "TOPXProductCategoryEdge",
	node: GraphQLTypes["TOPXProductCategory"]
};
	["TOPXProductCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	products?: Array<GraphQLTypes["TOPXProductCategoryCreateProductsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TOPXProductCategoryCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["TOPXProductUniqueWhere"],
	create?: GraphQLTypes["TOPXProductWithoutCategoryCreateInput"],
	connectOrCreate?: GraphQLTypes["TOPXProductCategoryConnectOrCreateProductsRelationInput"],
	alias?: string
};
	["TOPXProductWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	remoteId?: string,
	order?: number,
	orderType?: GraphQLTypes["TOPXProductOrderType"],
	product?: GraphQLTypes["TOPXProductCreateProductEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXProductCategoryConnectOrCreateProductsRelationInput"]: {
		connect: GraphQLTypes["TOPXProductUniqueWhere"],
	create: GraphQLTypes["TOPXProductWithoutCategoryCreateInput"]
};
	["TOPXProductCategoryUpdateInput"]: {
		remoteId?: string,
	products?: Array<GraphQLTypes["TOPXProductCategoryUpdateProductsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TOPXProductCategoryUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["TOPXProductWithoutCategoryCreateInput"],
	update?: GraphQLTypes["TOPXProductCategoryUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["TOPXProductCategoryUpsertProductsRelationInput"],
	connect?: GraphQLTypes["TOPXProductUniqueWhere"],
	disconnect?: GraphQLTypes["TOPXProductUniqueWhere"],
	delete?: GraphQLTypes["TOPXProductUniqueWhere"],
	alias?: string
};
	["TOPXProductCategoryUpdateProductsRelationInput"]: {
		by: GraphQLTypes["TOPXProductUniqueWhere"],
	data: GraphQLTypes["TOPXProductWithoutCategoryUpdateInput"]
};
	["TOPXProductWithoutCategoryUpdateInput"]: {
		remoteId?: string,
	order?: number,
	orderType?: GraphQLTypes["TOPXProductOrderType"],
	product?: GraphQLTypes["TOPXProductUpdateProductEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TOPXProductCategoryUpsertProductsRelationInput"]: {
		by: GraphQLTypes["TOPXProductUniqueWhere"],
	update: GraphQLTypes["TOPXProductWithoutCategoryUpdateInput"],
	create: GraphQLTypes["TOPXProductWithoutCategoryCreateInput"]
};
	["ContentReferenceListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	relatedProduct?: GraphQLTypes["ContentReferenceListCreateRelatedProductEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceListCreateRelatedBrandEntityRelationInput"],
	list?: GraphQLTypes["ContentReferenceListCreateListEntityRelationInput"],
	badge?: string,
	badgeColor?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceListCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutListCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceListConnectOrCreateListRelationInput"]
};
	["ContentReferenceWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fact?: string,
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	relatedBlogPost?: GraphQLTypes["ContentReferenceCreateRelatedBlogPostEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceCreateRelatedBrandEntityRelationInput"],
	relatedProduct?: GraphQLTypes["ContentReferenceCreateRelatedProductEntityRelationInput"],
	relatedIngredient?: GraphQLTypes["ContentReferenceCreateRelatedIngredientEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	badge?: string,
	longVersion?: boolean,
	relatedBrandFull?: GraphQLTypes["ContentReferenceCreateRelatedBrandFullEntityRelationInput"],
	relatedProductFull?: GraphQLTypes["ContentReferenceCreateRelatedProductFullEntityRelationInput"],
	outline?: GraphQLTypes["ContentReferenceCreateOutlineEntityRelationInput"],
	video?: GraphQLTypes["ContentReferenceCreateVideoEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	defaultOpen?: boolean,
	badgeColor?: string,
	isMain?: boolean,
	ad?: GraphQLTypes["ContentReferenceCreateAdEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceListConnectOrCreateListRelationInput"]: {
		connect: GraphQLTypes["ContentReferenceUniqueWhere"],
	create: GraphQLTypes["ContentReferenceWithoutListCreateInput"]
};
	["ContentReferenceListUpdateInput"]: {
		order?: number,
	relatedProduct?: GraphQLTypes["ContentReferenceListUpdateRelatedProductEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceListUpdateRelatedBrandEntityRelationInput"],
	list?: GraphQLTypes["ContentReferenceListUpdateListEntityRelationInput"],
	badge?: string,
	badgeColor?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceListUpdateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutListCreateInput"],
	connectOrCreate?: GraphQLTypes["ContentReferenceListConnectOrCreateListRelationInput"],
	update?: GraphQLTypes["ContentReferenceWithoutListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceListUpsertListRelationInput"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceWithoutListUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	fact?: string,
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	relatedBlogPost?: GraphQLTypes["ContentReferenceUpdateRelatedBlogPostEntityRelationInput"],
	relatedBrand?: GraphQLTypes["ContentReferenceUpdateRelatedBrandEntityRelationInput"],
	relatedProduct?: GraphQLTypes["ContentReferenceUpdateRelatedProductEntityRelationInput"],
	relatedIngredient?: GraphQLTypes["ContentReferenceUpdateRelatedIngredientEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	badge?: string,
	longVersion?: boolean,
	relatedBrandFull?: GraphQLTypes["ContentReferenceUpdateRelatedBrandFullEntityRelationInput"],
	relatedProductFull?: GraphQLTypes["ContentReferenceUpdateRelatedProductFullEntityRelationInput"],
	outline?: GraphQLTypes["ContentReferenceUpdateOutlineEntityRelationInput"],
	video?: GraphQLTypes["ContentReferenceUpdateVideoEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	defaultOpen?: boolean,
	badgeColor?: string,
	isMain?: boolean,
	ad?: GraphQLTypes["ContentReferenceUpdateAdEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceListUpsertListRelationInput"]: {
		update: GraphQLTypes["ContentReferenceWithoutListUpdateInput"],
	create: GraphQLTypes["ContentReferenceWithoutListCreateInput"]
};
	["BrandCount"]: {
	__typename: "BrandCount",
	_meta?: GraphQLTypes["BrandCountMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	count: number
};
	["BrandCountMeta"]: {
	__typename: "BrandCountMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	count?: GraphQLTypes["FieldMeta"]
};
	["BrandCountUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"]
};
	["BrandCountWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	count?: GraphQLTypes["IntCondition"],
	and?: Array<GraphQLTypes["BrandCountWhere"] | undefined>,
	or?: Array<GraphQLTypes["BrandCountWhere"] | undefined>,
	not?: GraphQLTypes["BrandCountWhere"]
};
	["BrandCountOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	count?: GraphQLTypes["OrderDirection"]
};
	["BrandCountConnection"]: {
	__typename: "BrandCountConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BrandCountEdge"]>
};
	["BrandCountEdge"]: {
	__typename: "BrandCountEdge",
	node: GraphQLTypes["BrandCount"]
};
	["ProductCount"]: {
	__typename: "ProductCount",
	_meta?: GraphQLTypes["ProductCountMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	count: number
};
	["ProductCountMeta"]: {
	__typename: "ProductCountMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	count?: GraphQLTypes["FieldMeta"]
};
	["ProductCountUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"]
};
	["ProductCountWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	count?: GraphQLTypes["IntCondition"],
	and?: Array<GraphQLTypes["ProductCountWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductCountWhere"] | undefined>,
	not?: GraphQLTypes["ProductCountWhere"]
};
	["ProductCountOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	count?: GraphQLTypes["OrderDirection"]
};
	["ProductCountConnection"]: {
	__typename: "ProductCountConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductCountEdge"]>
};
	["ProductCountEdge"]: {
	__typename: "ProductCountEdge",
	node: GraphQLTypes["ProductCount"]
};
	["QueryTransaction"]: {
	__typename: "QueryTransaction",
	schema?: GraphQLTypes["_Schema"],
	s3DummyQuery?: string,
	getBlogPage?: GraphQLTypes["BlogPage"],
	listBlogPage: Array<GraphQLTypes["BlogPage"]>,
	paginateBlogPage: GraphQLTypes["BlogPageConnection"],
	validateCreateBlogPage: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPage: GraphQLTypes["_ValidationResult"],
	getBlogPost?: GraphQLTypes["BlogPost"],
	listBlogPost: Array<GraphQLTypes["BlogPost"]>,
	paginateBlogPost: GraphQLTypes["BlogPostConnection"],
	validateCreateBlogPost: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPost: GraphQLTypes["_ValidationResult"],
	getBlogPostTag?: GraphQLTypes["BlogPostTag"],
	listBlogPostTag: Array<GraphQLTypes["BlogPostTag"]>,
	paginateBlogPostTag: GraphQLTypes["BlogPostTagConnection"],
	validateCreateBlogPostTag: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostTag: GraphQLTypes["_ValidationResult"],
	getBodyTag?: GraphQLTypes["BodyTag"],
	listBodyTag: Array<GraphQLTypes["BodyTag"]>,
	paginateBodyTag: GraphQLTypes["BodyTagConnection"],
	validateCreateBodyTag: GraphQLTypes["_ValidationResult"],
	validateUpdateBodyTag: GraphQLTypes["_ValidationResult"],
	getBodyTagCategory?: GraphQLTypes["BodyTagCategory"],
	listBodyTagCategory: Array<GraphQLTypes["BodyTagCategory"]>,
	paginateBodyTagCategory: GraphQLTypes["BodyTagCategoryConnection"],
	validateCreateBodyTagCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateBodyTagCategory: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getDidYouKnow?: GraphQLTypes["DidYouKnow"],
	listDidYouKnow: Array<GraphQLTypes["DidYouKnow"]>,
	paginateDidYouKnow: GraphQLTypes["DidYouKnowConnection"],
	validateCreateDidYouKnow: GraphQLTypes["_ValidationResult"],
	validateUpdateDidYouKnow: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"],
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getNutritionalValue?: GraphQLTypes["NutritionalValue"],
	listNutritionalValue: Array<GraphQLTypes["NutritionalValue"]>,
	paginateNutritionalValue: GraphQLTypes["NutritionalValueConnection"],
	validateCreateNutritionalValue: GraphQLTypes["_ValidationResult"],
	validateUpdateNutritionalValue: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"],
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	getReference?: GraphQLTypes["Reference"],
	listReference: Array<GraphQLTypes["Reference"]>,
	paginateReference: GraphQLTypes["ReferenceConnection"],
	validateCreateReference: GraphQLTypes["_ValidationResult"],
	validateUpdateReference: GraphQLTypes["_ValidationResult"],
	getReferenceList?: GraphQLTypes["ReferenceList"],
	listReferenceList: Array<GraphQLTypes["ReferenceList"]>,
	paginateReferenceList: GraphQLTypes["ReferenceListConnection"],
	validateCreateReferenceList: GraphQLTypes["_ValidationResult"],
	validateUpdateReferenceList: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"],
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getBrand?: GraphQLTypes["Brand"],
	listBrand: Array<GraphQLTypes["Brand"]>,
	paginateBrand: GraphQLTypes["BrandConnection"],
	validateCreateBrand: GraphQLTypes["_ValidationResult"],
	validateUpdateBrand: GraphQLTypes["_ValidationResult"],
	getBrandDistributor?: GraphQLTypes["BrandDistributor"],
	listBrandDistributor: Array<GraphQLTypes["BrandDistributor"]>,
	paginateBrandDistributor: GraphQLTypes["BrandDistributorConnection"],
	validateCreateBrandDistributor: GraphQLTypes["_ValidationResult"],
	validateUpdateBrandDistributor: GraphQLTypes["_ValidationResult"],
	getDogSize?: GraphQLTypes["DogSize"],
	listDogSize: Array<GraphQLTypes["DogSize"]>,
	paginateDogSize: GraphQLTypes["DogSizeConnection"],
	validateCreateDogSize: GraphQLTypes["_ValidationResult"],
	validateUpdateDogSize: GraphQLTypes["_ValidationResult"],
	getProduct?: GraphQLTypes["Product"],
	listProduct: Array<GraphQLTypes["Product"]>,
	paginateProduct: GraphQLTypes["ProductConnection"],
	validateCreateProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateProduct: GraphQLTypes["_ValidationResult"],
	getProductionMethod?: GraphQLTypes["ProductionMethod"],
	listProductionMethod: Array<GraphQLTypes["ProductionMethod"]>,
	paginateProductionMethod: GraphQLTypes["ProductionMethodConnection"],
	validateCreateProductionMethod: GraphQLTypes["_ValidationResult"],
	validateUpdateProductionMethod: GraphQLTypes["_ValidationResult"],
	getProductLine?: GraphQLTypes["ProductLine"],
	listProductLine: Array<GraphQLTypes["ProductLine"]>,
	paginateProductLine: GraphQLTypes["ProductLineConnection"],
	validateCreateProductLine: GraphQLTypes["_ValidationResult"],
	validateUpdateProductLine: GraphQLTypes["_ValidationResult"],
	getBreed?: GraphQLTypes["Breed"],
	listBreed: Array<GraphQLTypes["Breed"]>,
	paginateBreed: GraphQLTypes["BreedConnection"],
	validateCreateBreed: GraphQLTypes["_ValidationResult"],
	validateUpdateBreed: GraphQLTypes["_ValidationResult"],
	getDog?: GraphQLTypes["Dog"],
	listDog: Array<GraphQLTypes["Dog"]>,
	paginateDog: GraphQLTypes["DogConnection"],
	validateCreateDog: GraphQLTypes["_ValidationResult"],
	validateUpdateDog: GraphQLTypes["_ValidationResult"],
	getUser?: GraphQLTypes["User"],
	listUser: Array<GraphQLTypes["User"]>,
	paginateUser: GraphQLTypes["UserConnection"],
	validateCreateUser: GraphQLTypes["_ValidationResult"],
	validateUpdateUser: GraphQLTypes["_ValidationResult"],
	getVeterinary?: GraphQLTypes["Veterinary"],
	listVeterinary: Array<GraphQLTypes["Veterinary"]>,
	paginateVeterinary: GraphQLTypes["VeterinaryConnection"],
	validateCreateVeterinary: GraphQLTypes["_ValidationResult"],
	validateUpdateVeterinary: GraphQLTypes["_ValidationResult"],
	getNutritionalValueOfProduct?: GraphQLTypes["NutritionalValueOfProduct"],
	listNutritionalValueOfProduct: Array<GraphQLTypes["NutritionalValueOfProduct"]>,
	paginateNutritionalValueOfProduct: GraphQLTypes["NutritionalValueOfProductConnection"],
	validateCreateNutritionalValueOfProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateNutritionalValueOfProduct: GraphQLTypes["_ValidationResult"],
	getReview?: GraphQLTypes["Review"],
	listReview: Array<GraphQLTypes["Review"]>,
	paginateReview: GraphQLTypes["ReviewConnection"],
	validateCreateReview: GraphQLTypes["_ValidationResult"],
	validateUpdateReview: GraphQLTypes["_ValidationResult"],
	getDogBodyType?: GraphQLTypes["DogBodyType"],
	listDogBodyType: Array<GraphQLTypes["DogBodyType"]>,
	paginateDogBodyType: GraphQLTypes["DogBodyTypeConnection"],
	validateCreateDogBodyType: GraphQLTypes["_ValidationResult"],
	validateUpdateDogBodyType: GraphQLTypes["_ValidationResult"],
	getDogBodyTypeCategory?: GraphQLTypes["DogBodyTypeCategory"],
	listDogBodyTypeCategory: Array<GraphQLTypes["DogBodyTypeCategory"]>,
	paginateDogBodyTypeCategory: GraphQLTypes["DogBodyTypeCategoryConnection"],
	validateCreateDogBodyTypeCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateDogBodyTypeCategory: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getUrl?: GraphQLTypes["Url"],
	listUrl: Array<GraphQLTypes["Url"]>,
	paginateUrl: GraphQLTypes["UrlConnection"],
	validateCreateUrl: GraphQLTypes["_ValidationResult"],
	validateUpdateUrl: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getFooterLink?: GraphQLTypes["FooterLink"],
	listFooterLink: Array<GraphQLTypes["FooterLink"]>,
	paginateFooterLink: GraphQLTypes["FooterLinkConnection"],
	validateCreateFooterLink: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLink: GraphQLTypes["_ValidationResult"],
	getBrandsPage?: GraphQLTypes["BrandsPage"],
	listBrandsPage: Array<GraphQLTypes["BrandsPage"]>,
	paginateBrandsPage: GraphQLTypes["BrandsPageConnection"],
	validateCreateBrandsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateBrandsPage: GraphQLTypes["_ValidationResult"],
	getHomePage?: GraphQLTypes["HomePage"],
	listHomePage: Array<GraphQLTypes["HomePage"]>,
	paginateHomePage: GraphQLTypes["HomePageConnection"],
	validateCreateHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePage: GraphQLTypes["_ValidationResult"],
	getIngredientsPage?: GraphQLTypes["IngredientsPage"],
	listIngredientsPage: Array<GraphQLTypes["IngredientsPage"]>,
	paginateIngredientsPage: GraphQLTypes["IngredientsPageConnection"],
	validateCreateIngredientsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateIngredientsPage: GraphQLTypes["_ValidationResult"],
	getProductReview?: GraphQLTypes["ProductReview"],
	listProductReview: Array<GraphQLTypes["ProductReview"]>,
	paginateProductReview: GraphQLTypes["ProductReviewConnection"],
	validateCreateProductReview: GraphQLTypes["_ValidationResult"],
	validateUpdateProductReview: GraphQLTypes["_ValidationResult"],
	getScore?: GraphQLTypes["Score"],
	listScore: Array<GraphQLTypes["Score"]>,
	paginateScore: GraphQLTypes["ScoreConnection"],
	validateCreateScore: GraphQLTypes["_ValidationResult"],
	validateUpdateScore: GraphQLTypes["_ValidationResult"],
	getAge?: GraphQLTypes["Age"],
	listAge: Array<GraphQLTypes["Age"]>,
	paginateAge: GraphQLTypes["AgeConnection"],
	validateCreateAge: GraphQLTypes["_ValidationResult"],
	validateUpdateAge: GraphQLTypes["_ValidationResult"],
	getCountry?: GraphQLTypes["Country"],
	listCountry: Array<GraphQLTypes["Country"]>,
	paginateCountry: GraphQLTypes["CountryConnection"],
	validateCreateCountry: GraphQLTypes["_ValidationResult"],
	validateUpdateCountry: GraphQLTypes["_ValidationResult"],
	getBlogPostReview?: GraphQLTypes["BlogPostReview"],
	listBlogPostReview: Array<GraphQLTypes["BlogPostReview"]>,
	paginateBlogPostReview: GraphQLTypes["BlogPostReviewConnection"],
	validateCreateBlogPostReview: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostReview: GraphQLTypes["_ValidationResult"],
	getDogActivity?: GraphQLTypes["DogActivity"],
	listDogActivity: Array<GraphQLTypes["DogActivity"]>,
	paginateDogActivity: GraphQLTypes["DogActivityConnection"],
	validateCreateDogActivity: GraphQLTypes["_ValidationResult"],
	validateUpdateDogActivity: GraphQLTypes["_ValidationResult"],
	getSocial?: GraphQLTypes["Social"],
	listSocial: Array<GraphQLTypes["Social"]>,
	paginateSocial: GraphQLTypes["SocialConnection"],
	validateCreateSocial: GraphQLTypes["_ValidationResult"],
	validateUpdateSocial: GraphQLTypes["_ValidationResult"],
	getContentReferenceGalleryImage?: GraphQLTypes["ContentReferenceGalleryImage"],
	listContentReferenceGalleryImage: Array<GraphQLTypes["ContentReferenceGalleryImage"]>,
	paginateContentReferenceGalleryImage: GraphQLTypes["ContentReferenceGalleryImageConnection"],
	validateCreateContentReferenceGalleryImage: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReferenceGalleryImage: GraphQLTypes["_ValidationResult"],
	getItem?: GraphQLTypes["Item"],
	listItem: Array<GraphQLTypes["Item"]>,
	paginateItem: GraphQLTypes["ItemConnection"],
	validateCreateItem: GraphQLTypes["_ValidationResult"],
	validateUpdateItem: GraphQLTypes["_ValidationResult"],
	getItemSubCategory?: GraphQLTypes["ItemSubCategory"],
	listItemSubCategory: Array<GraphQLTypes["ItemSubCategory"]>,
	paginateItemSubCategory: GraphQLTypes["ItemSubCategoryConnection"],
	validateCreateItemSubCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateItemSubCategory: GraphQLTypes["_ValidationResult"],
	getItemCategory?: GraphQLTypes["ItemCategory"],
	listItemCategory: Array<GraphQLTypes["ItemCategory"]>,
	paginateItemCategory: GraphQLTypes["ItemCategoryConnection"],
	validateCreateItemCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateItemCategory: GraphQLTypes["_ValidationResult"],
	getItemFlavorCategory?: GraphQLTypes["ItemFlavorCategory"],
	listItemFlavorCategory: Array<GraphQLTypes["ItemFlavorCategory"]>,
	paginateItemFlavorCategory: GraphQLTypes["ItemFlavorCategoryConnection"],
	validateCreateItemFlavorCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateItemFlavorCategory: GraphQLTypes["_ValidationResult"],
	getItemDeclensionFourthVariant?: GraphQLTypes["ItemDeclensionFourthVariant"],
	listItemDeclensionFourthVariant: Array<GraphQLTypes["ItemDeclensionFourthVariant"]>,
	paginateItemDeclensionFourthVariant: GraphQLTypes["ItemDeclensionFourthVariantConnection"],
	validateCreateItemDeclensionFourthVariant: GraphQLTypes["_ValidationResult"],
	validateUpdateItemDeclensionFourthVariant: GraphQLTypes["_ValidationResult"],
	getItemDeclensionSeventhVariant?: GraphQLTypes["ItemDeclensionSeventhVariant"],
	listItemDeclensionSeventhVariant: Array<GraphQLTypes["ItemDeclensionSeventhVariant"]>,
	paginateItemDeclensionSeventhVariant: GraphQLTypes["ItemDeclensionSeventhVariantConnection"],
	validateCreateItemDeclensionSeventhVariant: GraphQLTypes["_ValidationResult"],
	validateUpdateItemDeclensionSeventhVariant: GraphQLTypes["_ValidationResult"],
	getMediaCard?: GraphQLTypes["MediaCard"],
	listMediaCard: Array<GraphQLTypes["MediaCard"]>,
	paginateMediaCard: GraphQLTypes["MediaCardConnection"],
	validateCreateMediaCard: GraphQLTypes["_ValidationResult"],
	validateUpdateMediaCard: GraphQLTypes["_ValidationResult"],
	getInfoCard?: GraphQLTypes["InfoCard"],
	listInfoCard: Array<GraphQLTypes["InfoCard"]>,
	paginateInfoCard: GraphQLTypes["InfoCardConnection"],
	validateCreateInfoCard: GraphQLTypes["_ValidationResult"],
	validateUpdateInfoCard: GraphQLTypes["_ValidationResult"],
	getNumberedCard?: GraphQLTypes["NumberedCard"],
	listNumberedCard: Array<GraphQLTypes["NumberedCard"]>,
	paginateNumberedCard: GraphQLTypes["NumberedCardConnection"],
	validateCreateNumberedCard: GraphQLTypes["_ValidationResult"],
	validateUpdateNumberedCard: GraphQLTypes["_ValidationResult"],
	getRegisterClaim?: GraphQLTypes["RegisterClaim"],
	listRegisterClaim: Array<GraphQLTypes["RegisterClaim"]>,
	paginateRegisterClaim: GraphQLTypes["RegisterClaimConnection"],
	validateCreateRegisterClaim: GraphQLTypes["_ValidationResult"],
	validateUpdateRegisterClaim: GraphQLTypes["_ValidationResult"],
	getBlogPostReviewReaction?: GraphQLTypes["BlogPostReviewReaction"],
	listBlogPostReviewReaction: Array<GraphQLTypes["BlogPostReviewReaction"]>,
	paginateBlogPostReviewReaction: GraphQLTypes["BlogPostReviewReactionConnection"],
	validateCreateBlogPostReviewReaction: GraphQLTypes["_ValidationResult"],
	validateUpdateBlogPostReviewReaction: GraphQLTypes["_ValidationResult"],
	getProductReviewReaction?: GraphQLTypes["ProductReviewReaction"],
	listProductReviewReaction: Array<GraphQLTypes["ProductReviewReaction"]>,
	paginateProductReviewReaction: GraphQLTypes["ProductReviewReactionConnection"],
	validateCreateProductReviewReaction: GraphQLTypes["_ValidationResult"],
	validateUpdateProductReviewReaction: GraphQLTypes["_ValidationResult"],
	getProductPackage?: GraphQLTypes["ProductPackage"],
	listProductPackage: Array<GraphQLTypes["ProductPackage"]>,
	paginateProductPackage: GraphQLTypes["ProductPackageConnection"],
	validateCreateProductPackage: GraphQLTypes["_ValidationResult"],
	validateUpdateProductPackage: GraphQLTypes["_ValidationResult"],
	getBrandManufacturer?: GraphQLTypes["BrandManufacturer"],
	listBrandManufacturer: Array<GraphQLTypes["BrandManufacturer"]>,
	paginateBrandManufacturer: GraphQLTypes["BrandManufacturerConnection"],
	validateCreateBrandManufacturer: GraphQLTypes["_ValidationResult"],
	validateUpdateBrandManufacturer: GraphQLTypes["_ValidationResult"],
	getElement?: GraphQLTypes["Element"],
	listElement: Array<GraphQLTypes["Element"]>,
	paginateElement: GraphQLTypes["ElementConnection"],
	validateCreateElement: GraphQLTypes["_ValidationResult"],
	validateUpdateElement: GraphQLTypes["_ValidationResult"],
	getElementOfProduct?: GraphQLTypes["ElementOfProduct"],
	listElementOfProduct: Array<GraphQLTypes["ElementOfProduct"]>,
	paginateElementOfProduct: GraphQLTypes["ElementOfProductConnection"],
	validateCreateElementOfProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateElementOfProduct: GraphQLTypes["_ValidationResult"],
	getSuitabilityCategory?: GraphQLTypes["SuitabilityCategory"],
	listSuitabilityCategory: Array<GraphQLTypes["SuitabilityCategory"]>,
	paginateSuitabilityCategory: GraphQLTypes["SuitabilityCategoryConnection"],
	validateCreateSuitabilityCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateSuitabilityCategory: GraphQLTypes["_ValidationResult"],
	getProductFeature?: GraphQLTypes["ProductFeature"],
	listProductFeature: Array<GraphQLTypes["ProductFeature"]>,
	paginateProductFeature: GraphQLTypes["ProductFeatureConnection"],
	validateCreateProductFeature: GraphQLTypes["_ValidationResult"],
	validateUpdateProductFeature: GraphQLTypes["_ValidationResult"],
	getSuitabilityItem?: GraphQLTypes["SuitabilityItem"],
	listSuitabilityItem: Array<GraphQLTypes["SuitabilityItem"]>,
	paginateSuitabilityItem: GraphQLTypes["SuitabilityItemConnection"],
	validateCreateSuitabilityItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSuitabilityItem: GraphQLTypes["_ValidationResult"],
	getRegion?: GraphQLTypes["Region"],
	listRegion: Array<GraphQLTypes["Region"]>,
	paginateRegion: GraphQLTypes["RegionConnection"],
	validateCreateRegion: GraphQLTypes["_ValidationResult"],
	validateUpdateRegion: GraphQLTypes["_ValidationResult"],
	getGranuleSize?: GraphQLTypes["GranuleSize"],
	listGranuleSize: Array<GraphQLTypes["GranuleSize"]>,
	paginateGranuleSize: GraphQLTypes["GranuleSizeConnection"],
	validateCreateGranuleSize: GraphQLTypes["_ValidationResult"],
	validateUpdateGranuleSize: GraphQLTypes["_ValidationResult"],
	getItemAlias?: GraphQLTypes["ItemAlias"],
	listItemAlias: Array<GraphQLTypes["ItemAlias"]>,
	paginateItemAlias: GraphQLTypes["ItemAliasConnection"],
	validateCreateItemAlias: GraphQLTypes["_ValidationResult"],
	validateUpdateItemAlias: GraphQLTypes["_ValidationResult"],
	getSemanticKey?: GraphQLTypes["SemanticKey"],
	listSemanticKey: Array<GraphQLTypes["SemanticKey"]>,
	paginateSemanticKey: GraphQLTypes["SemanticKeyConnection"],
	validateCreateSemanticKey: GraphQLTypes["_ValidationResult"],
	validateUpdateSemanticKey: GraphQLTypes["_ValidationResult"],
	getProductFlag?: GraphQLTypes["ProductFlag"],
	listProductFlag: Array<GraphQLTypes["ProductFlag"]>,
	paginateProductFlag: GraphQLTypes["ProductFlagConnection"],
	validateCreateProductFlag: GraphQLTypes["_ValidationResult"],
	validateUpdateProductFlag: GraphQLTypes["_ValidationResult"],
	getProductFlagOfProduct?: GraphQLTypes["ProductFlagOfProduct"],
	listProductFlagOfProduct: Array<GraphQLTypes["ProductFlagOfProduct"]>,
	paginateProductFlagOfProduct: GraphQLTypes["ProductFlagOfProductConnection"],
	validateCreateProductFlagOfProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateProductFlagOfProduct: GraphQLTypes["_ValidationResult"],
	getProductEvaluation?: GraphQLTypes["ProductEvaluation"],
	listProductEvaluation: Array<GraphQLTypes["ProductEvaluation"]>,
	paginateProductEvaluation: GraphQLTypes["ProductEvaluationConnection"],
	validateCreateProductEvaluation: GraphQLTypes["_ValidationResult"],
	validateUpdateProductEvaluation: GraphQLTypes["_ValidationResult"],
	getAd?: GraphQLTypes["Ad"],
	listAd: Array<GraphQLTypes["Ad"]>,
	paginateAd: GraphQLTypes["AdConnection"],
	validateCreateAd: GraphQLTypes["_ValidationResult"],
	validateUpdateAd: GraphQLTypes["_ValidationResult"],
	getEvaluationInfo?: GraphQLTypes["EvaluationInfo"],
	listEvaluationInfo: Array<GraphQLTypes["EvaluationInfo"]>,
	paginateEvaluationInfo: GraphQLTypes["EvaluationInfoConnection"],
	validateCreateEvaluationInfo: GraphQLTypes["_ValidationResult"],
	validateUpdateEvaluationInfo: GraphQLTypes["_ValidationResult"],
	getConsumptionMessage?: GraphQLTypes["ConsumptionMessage"],
	listConsumptionMessage: Array<GraphQLTypes["ConsumptionMessage"]>,
	paginateConsumptionMessage: GraphQLTypes["ConsumptionMessageConnection"],
	validateCreateConsumptionMessage: GraphQLTypes["_ValidationResult"],
	validateUpdateConsumptionMessage: GraphQLTypes["_ValidationResult"],
	getContentText?: GraphQLTypes["ContentText"],
	listContentText: Array<GraphQLTypes["ContentText"]>,
	paginateContentText: GraphQLTypes["ContentTextConnection"],
	validateCreateContentText: GraphQLTypes["_ValidationResult"],
	validateUpdateContentText: GraphQLTypes["_ValidationResult"],
	getContentTextBlock?: GraphQLTypes["ContentTextBlock"],
	listContentTextBlock: Array<GraphQLTypes["ContentTextBlock"]>,
	paginateContentTextBlock: GraphQLTypes["ContentTextBlockConnection"],
	validateCreateContentTextBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentTextBlock: GraphQLTypes["_ValidationResult"],
	getProductReviewStats?: GraphQLTypes["ProductReviewStats"],
	listProductReviewStats: Array<GraphQLTypes["ProductReviewStats"]>,
	paginateProductReviewStats: GraphQLTypes["ProductReviewStatsConnection"],
	getBlogPostReviewStats?: GraphQLTypes["BlogPostReviewStats"],
	listBlogPostReviewStats: Array<GraphQLTypes["BlogPostReviewStats"]>,
	paginateBlogPostReviewStats: GraphQLTypes["BlogPostReviewStatsConnection"],
	getComparatorPage?: GraphQLTypes["ComparatorPage"],
	listComparatorPage: Array<GraphQLTypes["ComparatorPage"]>,
	paginateComparatorPage: GraphQLTypes["ComparatorPageConnection"],
	validateCreateComparatorPage: GraphQLTypes["_ValidationResult"],
	validateUpdateComparatorPage: GraphQLTypes["_ValidationResult"],
	getLoginPage?: GraphQLTypes["LoginPage"],
	listLoginPage: Array<GraphQLTypes["LoginPage"]>,
	paginateLoginPage: GraphQLTypes["LoginPageConnection"],
	validateCreateLoginPage: GraphQLTypes["_ValidationResult"],
	validateUpdateLoginPage: GraphQLTypes["_ValidationResult"],
	getRegisterPage?: GraphQLTypes["RegisterPage"],
	listRegisterPage: Array<GraphQLTypes["RegisterPage"]>,
	paginateRegisterPage: GraphQLTypes["RegisterPageConnection"],
	validateCreateRegisterPage: GraphQLTypes["_ValidationResult"],
	validateUpdateRegisterPage: GraphQLTypes["_ValidationResult"],
	getResultsPage?: GraphQLTypes["ResultsPage"],
	listResultsPage: Array<GraphQLTypes["ResultsPage"]>,
	paginateResultsPage: GraphQLTypes["ResultsPageConnection"],
	validateCreateResultsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateResultsPage: GraphQLTypes["_ValidationResult"],
	getSearchPage?: GraphQLTypes["SearchPage"],
	listSearchPage: Array<GraphQLTypes["SearchPage"]>,
	paginateSearchPage: GraphQLTypes["SearchPageConnection"],
	validateCreateSearchPage: GraphQLTypes["_ValidationResult"],
	validateUpdateSearchPage: GraphQLTypes["_ValidationResult"],
	getWizardPage?: GraphQLTypes["WizardPage"],
	listWizardPage: Array<GraphQLTypes["WizardPage"]>,
	paginateWizardPage: GraphQLTypes["WizardPageConnection"],
	validateCreateWizardPage: GraphQLTypes["_ValidationResult"],
	validateUpdateWizardPage: GraphQLTypes["_ValidationResult"],
	getBreastfeedingCategory?: GraphQLTypes["BreastfeedingCategory"],
	listBreastfeedingCategory: Array<GraphQLTypes["BreastfeedingCategory"]>,
	paginateBreastfeedingCategory: GraphQLTypes["BreastfeedingCategoryConnection"],
	validateCreateBreastfeedingCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateBreastfeedingCategory: GraphQLTypes["_ValidationResult"],
	getDogReproduction?: GraphQLTypes["DogReproduction"],
	listDogReproduction: Array<GraphQLTypes["DogReproduction"]>,
	paginateDogReproduction: GraphQLTypes["DogReproductionConnection"],
	validateCreateDogReproduction: GraphQLTypes["_ValidationResult"],
	validateUpdateDogReproduction: GraphQLTypes["_ValidationResult"],
	getContactFormMessage?: GraphQLTypes["ContactFormMessage"],
	listContactFormMessage: Array<GraphQLTypes["ContactFormMessage"]>,
	paginateContactFormMessage: GraphQLTypes["ContactFormMessageConnection"],
	validateCreateContactFormMessage: GraphQLTypes["_ValidationResult"],
	validateUpdateContactFormMessage: GraphQLTypes["_ValidationResult"],
	getContactPage?: GraphQLTypes["ContactPage"],
	listContactPage: Array<GraphQLTypes["ContactPage"]>,
	paginateContactPage: GraphQLTypes["ContactPageConnection"],
	validateCreateContactPage: GraphQLTypes["_ValidationResult"],
	validateUpdateContactPage: GraphQLTypes["_ValidationResult"],
	getBugReport?: GraphQLTypes["BugReport"],
	listBugReport: Array<GraphQLTypes["BugReport"]>,
	paginateBugReport: GraphQLTypes["BugReportConnection"],
	validateCreateBugReport: GraphQLTypes["_ValidationResult"],
	validateUpdateBugReport: GraphQLTypes["_ValidationResult"],
	getColor?: GraphQLTypes["Color"],
	listColor: Array<GraphQLTypes["Color"]>,
	paginateColor: GraphQLTypes["ColorConnection"],
	validateCreateColor: GraphQLTypes["_ValidationResult"],
	validateUpdateColor: GraphQLTypes["_ValidationResult"],
	getItemGroup?: GraphQLTypes["ItemGroup"],
	listItemGroup: Array<GraphQLTypes["ItemGroup"]>,
	paginateItemGroup: GraphQLTypes["ItemGroupConnection"],
	validateCreateItemGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateItemGroup: GraphQLTypes["_ValidationResult"],
	getSearchResult?: GraphQLTypes["SearchResult"],
	listSearchResult: Array<GraphQLTypes["SearchResult"]>,
	paginateSearchResult: GraphQLTypes["SearchResultConnection"],
	getProductEvaluationSummary?: GraphQLTypes["ProductEvaluationSummary"],
	listProductEvaluationSummary: Array<GraphQLTypes["ProductEvaluationSummary"]>,
	paginateProductEvaluationSummary: GraphQLTypes["ProductEvaluationSummaryConnection"],
	validateCreateProductEvaluationSummary: GraphQLTypes["_ValidationResult"],
	validateUpdateProductEvaluationSummary: GraphQLTypes["_ValidationResult"],
	getProtectedAction?: GraphQLTypes["ProtectedAction"],
	listProtectedAction: Array<GraphQLTypes["ProtectedAction"]>,
	paginateProtectedAction: GraphQLTypes["ProtectedActionConnection"],
	validateCreateProtectedAction: GraphQLTypes["_ValidationResult"],
	validateUpdateProtectedAction: GraphQLTypes["_ValidationResult"],
	getBrandAlias?: GraphQLTypes["BrandAlias"],
	listBrandAlias: Array<GraphQLTypes["BrandAlias"]>,
	paginateBrandAlias: GraphQLTypes["BrandAliasConnection"],
	validateCreateBrandAlias: GraphQLTypes["_ValidationResult"],
	validateUpdateBrandAlias: GraphQLTypes["_ValidationResult"],
	getProductAlias?: GraphQLTypes["ProductAlias"],
	listProductAlias: Array<GraphQLTypes["ProductAlias"]>,
	paginateProductAlias: GraphQLTypes["ProductAliasConnection"],
	validateCreateProductAlias: GraphQLTypes["_ValidationResult"],
	validateUpdateProductAlias: GraphQLTypes["_ValidationResult"],
	getProductLineAlias?: GraphQLTypes["ProductLineAlias"],
	listProductLineAlias: Array<GraphQLTypes["ProductLineAlias"]>,
	paginateProductLineAlias: GraphQLTypes["ProductLineAliasConnection"],
	validateCreateProductLineAlias: GraphQLTypes["_ValidationResult"],
	validateUpdateProductLineAlias: GraphQLTypes["_ValidationResult"],
	getGenericPage?: GraphQLTypes["GenericPage"],
	listGenericPage: Array<GraphQLTypes["GenericPage"]>,
	paginateGenericPage: GraphQLTypes["GenericPageConnection"],
	validateCreateGenericPage: GraphQLTypes["_ValidationResult"],
	validateUpdateGenericPage: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getContentLinks?: GraphQLTypes["ContentLinks"],
	listContentLinks: Array<GraphQLTypes["ContentLinks"]>,
	paginateContentLinks: GraphQLTypes["ContentLinksConnection"],
	validateCreateContentLinks: GraphQLTypes["_ValidationResult"],
	validateUpdateContentLinks: GraphQLTypes["_ValidationResult"],
	getContentLinksItem?: GraphQLTypes["ContentLinksItem"],
	listContentLinksItem: Array<GraphQLTypes["ContentLinksItem"]>,
	paginateContentLinksItem: GraphQLTypes["ContentLinksItemConnection"],
	validateCreateContentLinksItem: GraphQLTypes["_ValidationResult"],
	validateUpdateContentLinksItem: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"],
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getContentReferenceImage?: GraphQLTypes["ContentReferenceImage"],
	listContentReferenceImage: Array<GraphQLTypes["ContentReferenceImage"]>,
	paginateContentReferenceImage: GraphQLTypes["ContentReferenceImageConnection"],
	validateCreateContentReferenceImage: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReferenceImage: GraphQLTypes["_ValidationResult"],
	getSeoData?: GraphQLTypes["SeoData"],
	listSeoData: Array<GraphQLTypes["SeoData"]>,
	paginateSeoData: GraphQLTypes["SeoDataConnection"],
	validateCreateSeoData: GraphQLTypes["_ValidationResult"],
	validateUpdateSeoData: GraphQLTypes["_ValidationResult"],
	getTenantPerson?: GraphQLTypes["TenantPerson"],
	listTenantPerson: Array<GraphQLTypes["TenantPerson"]>,
	paginateTenantPerson: GraphQLTypes["TenantPersonConnection"],
	getBrandFlavor?: GraphQLTypes["BrandFlavor"],
	listBrandFlavor: Array<GraphQLTypes["BrandFlavor"]>,
	paginateBrandFlavor: GraphQLTypes["BrandFlavorConnection"],
	getProductLineFlavor?: GraphQLTypes["ProductLineFlavor"],
	listProductLineFlavor: Array<GraphQLTypes["ProductLineFlavor"]>,
	paginateProductLineFlavor: GraphQLTypes["ProductLineFlavorConnection"],
	getProductItemDeclensionFourthCategory?: GraphQLTypes["ProductItemDeclensionFourthCategory"],
	listProductItemDeclensionFourthCategory: Array<GraphQLTypes["ProductItemDeclensionFourthCategory"]>,
	paginateProductItemDeclensionFourthCategory: GraphQLTypes["ProductItemDeclensionFourthCategoryConnection"],
	getAgeCategory?: GraphQLTypes["AgeCategory"],
	listAgeCategory: Array<GraphQLTypes["AgeCategory"]>,
	paginateAgeCategory: GraphQLTypes["AgeCategoryConnection"],
	validateCreateAgeCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateAgeCategory: GraphQLTypes["_ValidationResult"],
	getFilterCombo?: GraphQLTypes["FilterCombo"],
	listFilterCombo: Array<GraphQLTypes["FilterCombo"]>,
	paginateFilterCombo: GraphQLTypes["FilterComboConnection"],
	validateCreateFilterCombo: GraphQLTypes["_ValidationResult"],
	validateUpdateFilterCombo: GraphQLTypes["_ValidationResult"],
	getImportCache?: GraphQLTypes["ImportCache"],
	listImportCache: Array<GraphQLTypes["ImportCache"]>,
	paginateImportCache: GraphQLTypes["ImportCacheConnection"],
	validateCreateImportCache: GraphQLTypes["_ValidationResult"],
	validateUpdateImportCache: GraphQLTypes["_ValidationResult"],
	getSite?: GraphQLTypes["Site"],
	listSite: Array<GraphQLTypes["Site"]>,
	paginateSite: GraphQLTypes["SiteConnection"],
	validateCreateSite: GraphQLTypes["_ValidationResult"],
	validateUpdateSite: GraphQLTypes["_ValidationResult"],
	getContactSubmission?: GraphQLTypes["ContactSubmission"],
	listContactSubmission: Array<GraphQLTypes["ContactSubmission"]>,
	paginateContactSubmission: GraphQLTypes["ContactSubmissionConnection"],
	validateCreateContactSubmission: GraphQLTypes["_ValidationResult"],
	validateUpdateContactSubmission: GraphQLTypes["_ValidationResult"],
	getTOPXBrand?: GraphQLTypes["TOPXBrand"],
	listTOPXBrand: Array<GraphQLTypes["TOPXBrand"]>,
	paginateTOPXBrand: GraphQLTypes["TOPXBrandConnection"],
	validateCreateTOPXBrand: GraphQLTypes["_ValidationResult"],
	validateUpdateTOPXBrand: GraphQLTypes["_ValidationResult"],
	getTOPXBrandCategory?: GraphQLTypes["TOPXBrandCategory"],
	listTOPXBrandCategory: Array<GraphQLTypes["TOPXBrandCategory"]>,
	paginateTOPXBrandCategory: GraphQLTypes["TOPXBrandCategoryConnection"],
	validateCreateTOPXBrandCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateTOPXBrandCategory: GraphQLTypes["_ValidationResult"],
	getTOPXProduct?: GraphQLTypes["TOPXProduct"],
	listTOPXProduct: Array<GraphQLTypes["TOPXProduct"]>,
	paginateTOPXProduct: GraphQLTypes["TOPXProductConnection"],
	validateCreateTOPXProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateTOPXProduct: GraphQLTypes["_ValidationResult"],
	getTOPXProductCategory?: GraphQLTypes["TOPXProductCategory"],
	listTOPXProductCategory: Array<GraphQLTypes["TOPXProductCategory"]>,
	paginateTOPXProductCategory: GraphQLTypes["TOPXProductCategoryConnection"],
	validateCreateTOPXProductCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateTOPXProductCategory: GraphQLTypes["_ValidationResult"],
	getContentReferenceList?: GraphQLTypes["ContentReferenceList"],
	listContentReferenceList: Array<GraphQLTypes["ContentReferenceList"]>,
	paginateContentReferenceList: GraphQLTypes["ContentReferenceListConnection"],
	validateCreateContentReferenceList: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReferenceList: GraphQLTypes["_ValidationResult"],
	getBrandCount?: GraphQLTypes["BrandCount"],
	listBrandCount: Array<GraphQLTypes["BrandCount"]>,
	paginateBrandCount: GraphQLTypes["BrandCountConnection"],
	getProductCount?: GraphQLTypes["ProductCount"],
	listProductCount: Array<GraphQLTypes["ProductCount"]>,
	paginateProductCount: GraphQLTypes["ProductCountConnection"]
};
	["Info"]: {
	__typename: "Info",
	description?: string
};
	["Mutation"]: {
	__typename: "Mutation",
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"],
	createBlogPage: GraphQLTypes["BlogPageCreateResult"],
	deleteBlogPage: GraphQLTypes["BlogPageDeleteResult"],
	updateBlogPage: GraphQLTypes["BlogPageUpdateResult"],
	upsertBlogPage: GraphQLTypes["BlogPageUpsertResult"],
	createBlogPost: GraphQLTypes["BlogPostCreateResult"],
	deleteBlogPost: GraphQLTypes["BlogPostDeleteResult"],
	updateBlogPost: GraphQLTypes["BlogPostUpdateResult"],
	upsertBlogPost: GraphQLTypes["BlogPostUpsertResult"],
	createBlogPostTag: GraphQLTypes["BlogPostTagCreateResult"],
	deleteBlogPostTag: GraphQLTypes["BlogPostTagDeleteResult"],
	updateBlogPostTag: GraphQLTypes["BlogPostTagUpdateResult"],
	upsertBlogPostTag: GraphQLTypes["BlogPostTagUpsertResult"],
	createBodyTag: GraphQLTypes["BodyTagCreateResult"],
	deleteBodyTag: GraphQLTypes["BodyTagDeleteResult"],
	updateBodyTag: GraphQLTypes["BodyTagUpdateResult"],
	upsertBodyTag: GraphQLTypes["BodyTagUpsertResult"],
	createBodyTagCategory: GraphQLTypes["BodyTagCategoryCreateResult"],
	deleteBodyTagCategory: GraphQLTypes["BodyTagCategoryDeleteResult"],
	updateBodyTagCategory: GraphQLTypes["BodyTagCategoryUpdateResult"],
	upsertBodyTagCategory: GraphQLTypes["BodyTagCategoryUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createDidYouKnow: GraphQLTypes["DidYouKnowCreateResult"],
	deleteDidYouKnow: GraphQLTypes["DidYouKnowDeleteResult"],
	updateDidYouKnow: GraphQLTypes["DidYouKnowUpdateResult"],
	upsertDidYouKnow: GraphQLTypes["DidYouKnowUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createNutritionalValue: GraphQLTypes["NutritionalValueCreateResult"],
	deleteNutritionalValue: GraphQLTypes["NutritionalValueDeleteResult"],
	updateNutritionalValue: GraphQLTypes["NutritionalValueUpdateResult"],
	upsertNutritionalValue: GraphQLTypes["NutritionalValueUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	createReference: GraphQLTypes["ReferenceCreateResult"],
	deleteReference: GraphQLTypes["ReferenceDeleteResult"],
	updateReference: GraphQLTypes["ReferenceUpdateResult"],
	upsertReference: GraphQLTypes["ReferenceUpsertResult"],
	createReferenceList: GraphQLTypes["ReferenceListCreateResult"],
	deleteReferenceList: GraphQLTypes["ReferenceListDeleteResult"],
	updateReferenceList: GraphQLTypes["ReferenceListUpdateResult"],
	upsertReferenceList: GraphQLTypes["ReferenceListUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createBrand: GraphQLTypes["BrandCreateResult"],
	deleteBrand: GraphQLTypes["BrandDeleteResult"],
	updateBrand: GraphQLTypes["BrandUpdateResult"],
	upsertBrand: GraphQLTypes["BrandUpsertResult"],
	createBrandDistributor: GraphQLTypes["BrandDistributorCreateResult"],
	deleteBrandDistributor: GraphQLTypes["BrandDistributorDeleteResult"],
	updateBrandDistributor: GraphQLTypes["BrandDistributorUpdateResult"],
	upsertBrandDistributor: GraphQLTypes["BrandDistributorUpsertResult"],
	createDogSize: GraphQLTypes["DogSizeCreateResult"],
	deleteDogSize: GraphQLTypes["DogSizeDeleteResult"],
	updateDogSize: GraphQLTypes["DogSizeUpdateResult"],
	upsertDogSize: GraphQLTypes["DogSizeUpsertResult"],
	createProduct: GraphQLTypes["ProductCreateResult"],
	deleteProduct: GraphQLTypes["ProductDeleteResult"],
	updateProduct: GraphQLTypes["ProductUpdateResult"],
	upsertProduct: GraphQLTypes["ProductUpsertResult"],
	createProductionMethod: GraphQLTypes["ProductionMethodCreateResult"],
	deleteProductionMethod: GraphQLTypes["ProductionMethodDeleteResult"],
	updateProductionMethod: GraphQLTypes["ProductionMethodUpdateResult"],
	upsertProductionMethod: GraphQLTypes["ProductionMethodUpsertResult"],
	createProductLine: GraphQLTypes["ProductLineCreateResult"],
	deleteProductLine: GraphQLTypes["ProductLineDeleteResult"],
	updateProductLine: GraphQLTypes["ProductLineUpdateResult"],
	upsertProductLine: GraphQLTypes["ProductLineUpsertResult"],
	createBreed: GraphQLTypes["BreedCreateResult"],
	deleteBreed: GraphQLTypes["BreedDeleteResult"],
	updateBreed: GraphQLTypes["BreedUpdateResult"],
	upsertBreed: GraphQLTypes["BreedUpsertResult"],
	createDog: GraphQLTypes["DogCreateResult"],
	deleteDog: GraphQLTypes["DogDeleteResult"],
	updateDog: GraphQLTypes["DogUpdateResult"],
	upsertDog: GraphQLTypes["DogUpsertResult"],
	createUser: GraphQLTypes["UserCreateResult"],
	deleteUser: GraphQLTypes["UserDeleteResult"],
	updateUser: GraphQLTypes["UserUpdateResult"],
	upsertUser: GraphQLTypes["UserUpsertResult"],
	createVeterinary: GraphQLTypes["VeterinaryCreateResult"],
	deleteVeterinary: GraphQLTypes["VeterinaryDeleteResult"],
	updateVeterinary: GraphQLTypes["VeterinaryUpdateResult"],
	upsertVeterinary: GraphQLTypes["VeterinaryUpsertResult"],
	createNutritionalValueOfProduct: GraphQLTypes["NutritionalValueOfProductCreateResult"],
	deleteNutritionalValueOfProduct: GraphQLTypes["NutritionalValueOfProductDeleteResult"],
	updateNutritionalValueOfProduct: GraphQLTypes["NutritionalValueOfProductUpdateResult"],
	upsertNutritionalValueOfProduct: GraphQLTypes["NutritionalValueOfProductUpsertResult"],
	createReview: GraphQLTypes["ReviewCreateResult"],
	deleteReview: GraphQLTypes["ReviewDeleteResult"],
	updateReview: GraphQLTypes["ReviewUpdateResult"],
	upsertReview: GraphQLTypes["ReviewUpsertResult"],
	createDogBodyType: GraphQLTypes["DogBodyTypeCreateResult"],
	deleteDogBodyType: GraphQLTypes["DogBodyTypeDeleteResult"],
	updateDogBodyType: GraphQLTypes["DogBodyTypeUpdateResult"],
	upsertDogBodyType: GraphQLTypes["DogBodyTypeUpsertResult"],
	createDogBodyTypeCategory: GraphQLTypes["DogBodyTypeCategoryCreateResult"],
	deleteDogBodyTypeCategory: GraphQLTypes["DogBodyTypeCategoryDeleteResult"],
	updateDogBodyTypeCategory: GraphQLTypes["DogBodyTypeCategoryUpdateResult"],
	upsertDogBodyTypeCategory: GraphQLTypes["DogBodyTypeCategoryUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createUrl: GraphQLTypes["UrlCreateResult"],
	deleteUrl: GraphQLTypes["UrlDeleteResult"],
	updateUrl: GraphQLTypes["UrlUpdateResult"],
	upsertUrl: GraphQLTypes["UrlUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createFooterLink: GraphQLTypes["FooterLinkCreateResult"],
	deleteFooterLink: GraphQLTypes["FooterLinkDeleteResult"],
	updateFooterLink: GraphQLTypes["FooterLinkUpdateResult"],
	upsertFooterLink: GraphQLTypes["FooterLinkUpsertResult"],
	createBrandsPage: GraphQLTypes["BrandsPageCreateResult"],
	deleteBrandsPage: GraphQLTypes["BrandsPageDeleteResult"],
	updateBrandsPage: GraphQLTypes["BrandsPageUpdateResult"],
	upsertBrandsPage: GraphQLTypes["BrandsPageUpsertResult"],
	createHomePage: GraphQLTypes["HomePageCreateResult"],
	deleteHomePage: GraphQLTypes["HomePageDeleteResult"],
	updateHomePage: GraphQLTypes["HomePageUpdateResult"],
	upsertHomePage: GraphQLTypes["HomePageUpsertResult"],
	createIngredientsPage: GraphQLTypes["IngredientsPageCreateResult"],
	deleteIngredientsPage: GraphQLTypes["IngredientsPageDeleteResult"],
	updateIngredientsPage: GraphQLTypes["IngredientsPageUpdateResult"],
	upsertIngredientsPage: GraphQLTypes["IngredientsPageUpsertResult"],
	createProductReview: GraphQLTypes["ProductReviewCreateResult"],
	deleteProductReview: GraphQLTypes["ProductReviewDeleteResult"],
	updateProductReview: GraphQLTypes["ProductReviewUpdateResult"],
	upsertProductReview: GraphQLTypes["ProductReviewUpsertResult"],
	createScore: GraphQLTypes["ScoreCreateResult"],
	deleteScore: GraphQLTypes["ScoreDeleteResult"],
	updateScore: GraphQLTypes["ScoreUpdateResult"],
	upsertScore: GraphQLTypes["ScoreUpsertResult"],
	createAge: GraphQLTypes["AgeCreateResult"],
	deleteAge: GraphQLTypes["AgeDeleteResult"],
	updateAge: GraphQLTypes["AgeUpdateResult"],
	upsertAge: GraphQLTypes["AgeUpsertResult"],
	createCountry: GraphQLTypes["CountryCreateResult"],
	deleteCountry: GraphQLTypes["CountryDeleteResult"],
	updateCountry: GraphQLTypes["CountryUpdateResult"],
	upsertCountry: GraphQLTypes["CountryUpsertResult"],
	createBlogPostReview: GraphQLTypes["BlogPostReviewCreateResult"],
	deleteBlogPostReview: GraphQLTypes["BlogPostReviewDeleteResult"],
	updateBlogPostReview: GraphQLTypes["BlogPostReviewUpdateResult"],
	upsertBlogPostReview: GraphQLTypes["BlogPostReviewUpsertResult"],
	createDogActivity: GraphQLTypes["DogActivityCreateResult"],
	deleteDogActivity: GraphQLTypes["DogActivityDeleteResult"],
	updateDogActivity: GraphQLTypes["DogActivityUpdateResult"],
	upsertDogActivity: GraphQLTypes["DogActivityUpsertResult"],
	createSocial: GraphQLTypes["SocialCreateResult"],
	deleteSocial: GraphQLTypes["SocialDeleteResult"],
	updateSocial: GraphQLTypes["SocialUpdateResult"],
	upsertSocial: GraphQLTypes["SocialUpsertResult"],
	createContentReferenceGalleryImage: GraphQLTypes["ContentReferenceGalleryImageCreateResult"],
	deleteContentReferenceGalleryImage: GraphQLTypes["ContentReferenceGalleryImageDeleteResult"],
	updateContentReferenceGalleryImage: GraphQLTypes["ContentReferenceGalleryImageUpdateResult"],
	upsertContentReferenceGalleryImage: GraphQLTypes["ContentReferenceGalleryImageUpsertResult"],
	createItem: GraphQLTypes["ItemCreateResult"],
	deleteItem: GraphQLTypes["ItemDeleteResult"],
	updateItem: GraphQLTypes["ItemUpdateResult"],
	upsertItem: GraphQLTypes["ItemUpsertResult"],
	createItemSubCategory: GraphQLTypes["ItemSubCategoryCreateResult"],
	deleteItemSubCategory: GraphQLTypes["ItemSubCategoryDeleteResult"],
	updateItemSubCategory: GraphQLTypes["ItemSubCategoryUpdateResult"],
	upsertItemSubCategory: GraphQLTypes["ItemSubCategoryUpsertResult"],
	createItemCategory: GraphQLTypes["ItemCategoryCreateResult"],
	deleteItemCategory: GraphQLTypes["ItemCategoryDeleteResult"],
	updateItemCategory: GraphQLTypes["ItemCategoryUpdateResult"],
	upsertItemCategory: GraphQLTypes["ItemCategoryUpsertResult"],
	createItemFlavorCategory: GraphQLTypes["ItemFlavorCategoryCreateResult"],
	deleteItemFlavorCategory: GraphQLTypes["ItemFlavorCategoryDeleteResult"],
	updateItemFlavorCategory: GraphQLTypes["ItemFlavorCategoryUpdateResult"],
	upsertItemFlavorCategory: GraphQLTypes["ItemFlavorCategoryUpsertResult"],
	createItemDeclensionFourthVariant: GraphQLTypes["ItemDeclensionFourthVariantCreateResult"],
	deleteItemDeclensionFourthVariant: GraphQLTypes["ItemDeclensionFourthVariantDeleteResult"],
	updateItemDeclensionFourthVariant: GraphQLTypes["ItemDeclensionFourthVariantUpdateResult"],
	upsertItemDeclensionFourthVariant: GraphQLTypes["ItemDeclensionFourthVariantUpsertResult"],
	createItemDeclensionSeventhVariant: GraphQLTypes["ItemDeclensionSeventhVariantCreateResult"],
	deleteItemDeclensionSeventhVariant: GraphQLTypes["ItemDeclensionSeventhVariantDeleteResult"],
	updateItemDeclensionSeventhVariant: GraphQLTypes["ItemDeclensionSeventhVariantUpdateResult"],
	upsertItemDeclensionSeventhVariant: GraphQLTypes["ItemDeclensionSeventhVariantUpsertResult"],
	createMediaCard: GraphQLTypes["MediaCardCreateResult"],
	deleteMediaCard: GraphQLTypes["MediaCardDeleteResult"],
	updateMediaCard: GraphQLTypes["MediaCardUpdateResult"],
	upsertMediaCard: GraphQLTypes["MediaCardUpsertResult"],
	createInfoCard: GraphQLTypes["InfoCardCreateResult"],
	deleteInfoCard: GraphQLTypes["InfoCardDeleteResult"],
	updateInfoCard: GraphQLTypes["InfoCardUpdateResult"],
	upsertInfoCard: GraphQLTypes["InfoCardUpsertResult"],
	createNumberedCard: GraphQLTypes["NumberedCardCreateResult"],
	deleteNumberedCard: GraphQLTypes["NumberedCardDeleteResult"],
	updateNumberedCard: GraphQLTypes["NumberedCardUpdateResult"],
	upsertNumberedCard: GraphQLTypes["NumberedCardUpsertResult"],
	createRegisterClaim: GraphQLTypes["RegisterClaimCreateResult"],
	deleteRegisterClaim: GraphQLTypes["RegisterClaimDeleteResult"],
	updateRegisterClaim: GraphQLTypes["RegisterClaimUpdateResult"],
	upsertRegisterClaim: GraphQLTypes["RegisterClaimUpsertResult"],
	createBlogPostReviewReaction: GraphQLTypes["BlogPostReviewReactionCreateResult"],
	deleteBlogPostReviewReaction: GraphQLTypes["BlogPostReviewReactionDeleteResult"],
	updateBlogPostReviewReaction: GraphQLTypes["BlogPostReviewReactionUpdateResult"],
	upsertBlogPostReviewReaction: GraphQLTypes["BlogPostReviewReactionUpsertResult"],
	createProductReviewReaction: GraphQLTypes["ProductReviewReactionCreateResult"],
	deleteProductReviewReaction: GraphQLTypes["ProductReviewReactionDeleteResult"],
	updateProductReviewReaction: GraphQLTypes["ProductReviewReactionUpdateResult"],
	upsertProductReviewReaction: GraphQLTypes["ProductReviewReactionUpsertResult"],
	createProductPackage: GraphQLTypes["ProductPackageCreateResult"],
	deleteProductPackage: GraphQLTypes["ProductPackageDeleteResult"],
	updateProductPackage: GraphQLTypes["ProductPackageUpdateResult"],
	upsertProductPackage: GraphQLTypes["ProductPackageUpsertResult"],
	createBrandManufacturer: GraphQLTypes["BrandManufacturerCreateResult"],
	deleteBrandManufacturer: GraphQLTypes["BrandManufacturerDeleteResult"],
	updateBrandManufacturer: GraphQLTypes["BrandManufacturerUpdateResult"],
	upsertBrandManufacturer: GraphQLTypes["BrandManufacturerUpsertResult"],
	createElement: GraphQLTypes["ElementCreateResult"],
	deleteElement: GraphQLTypes["ElementDeleteResult"],
	updateElement: GraphQLTypes["ElementUpdateResult"],
	upsertElement: GraphQLTypes["ElementUpsertResult"],
	createElementOfProduct: GraphQLTypes["ElementOfProductCreateResult"],
	deleteElementOfProduct: GraphQLTypes["ElementOfProductDeleteResult"],
	updateElementOfProduct: GraphQLTypes["ElementOfProductUpdateResult"],
	upsertElementOfProduct: GraphQLTypes["ElementOfProductUpsertResult"],
	createSuitabilityCategory: GraphQLTypes["SuitabilityCategoryCreateResult"],
	deleteSuitabilityCategory: GraphQLTypes["SuitabilityCategoryDeleteResult"],
	updateSuitabilityCategory: GraphQLTypes["SuitabilityCategoryUpdateResult"],
	upsertSuitabilityCategory: GraphQLTypes["SuitabilityCategoryUpsertResult"],
	createProductFeature: GraphQLTypes["ProductFeatureCreateResult"],
	deleteProductFeature: GraphQLTypes["ProductFeatureDeleteResult"],
	updateProductFeature: GraphQLTypes["ProductFeatureUpdateResult"],
	upsertProductFeature: GraphQLTypes["ProductFeatureUpsertResult"],
	createSuitabilityItem: GraphQLTypes["SuitabilityItemCreateResult"],
	deleteSuitabilityItem: GraphQLTypes["SuitabilityItemDeleteResult"],
	updateSuitabilityItem: GraphQLTypes["SuitabilityItemUpdateResult"],
	upsertSuitabilityItem: GraphQLTypes["SuitabilityItemUpsertResult"],
	createRegion: GraphQLTypes["RegionCreateResult"],
	deleteRegion: GraphQLTypes["RegionDeleteResult"],
	updateRegion: GraphQLTypes["RegionUpdateResult"],
	upsertRegion: GraphQLTypes["RegionUpsertResult"],
	createGranuleSize: GraphQLTypes["GranuleSizeCreateResult"],
	deleteGranuleSize: GraphQLTypes["GranuleSizeDeleteResult"],
	updateGranuleSize: GraphQLTypes["GranuleSizeUpdateResult"],
	upsertGranuleSize: GraphQLTypes["GranuleSizeUpsertResult"],
	createItemAlias: GraphQLTypes["ItemAliasCreateResult"],
	deleteItemAlias: GraphQLTypes["ItemAliasDeleteResult"],
	updateItemAlias: GraphQLTypes["ItemAliasUpdateResult"],
	upsertItemAlias: GraphQLTypes["ItemAliasUpsertResult"],
	createSemanticKey: GraphQLTypes["SemanticKeyCreateResult"],
	deleteSemanticKey: GraphQLTypes["SemanticKeyDeleteResult"],
	updateSemanticKey: GraphQLTypes["SemanticKeyUpdateResult"],
	upsertSemanticKey: GraphQLTypes["SemanticKeyUpsertResult"],
	createProductFlag: GraphQLTypes["ProductFlagCreateResult"],
	deleteProductFlag: GraphQLTypes["ProductFlagDeleteResult"],
	updateProductFlag: GraphQLTypes["ProductFlagUpdateResult"],
	upsertProductFlag: GraphQLTypes["ProductFlagUpsertResult"],
	createProductFlagOfProduct: GraphQLTypes["ProductFlagOfProductCreateResult"],
	deleteProductFlagOfProduct: GraphQLTypes["ProductFlagOfProductDeleteResult"],
	updateProductFlagOfProduct: GraphQLTypes["ProductFlagOfProductUpdateResult"],
	upsertProductFlagOfProduct: GraphQLTypes["ProductFlagOfProductUpsertResult"],
	createProductEvaluation: GraphQLTypes["ProductEvaluationCreateResult"],
	deleteProductEvaluation: GraphQLTypes["ProductEvaluationDeleteResult"],
	updateProductEvaluation: GraphQLTypes["ProductEvaluationUpdateResult"],
	upsertProductEvaluation: GraphQLTypes["ProductEvaluationUpsertResult"],
	createAd: GraphQLTypes["AdCreateResult"],
	deleteAd: GraphQLTypes["AdDeleteResult"],
	updateAd: GraphQLTypes["AdUpdateResult"],
	upsertAd: GraphQLTypes["AdUpsertResult"],
	createEvaluationInfo: GraphQLTypes["EvaluationInfoCreateResult"],
	deleteEvaluationInfo: GraphQLTypes["EvaluationInfoDeleteResult"],
	updateEvaluationInfo: GraphQLTypes["EvaluationInfoUpdateResult"],
	upsertEvaluationInfo: GraphQLTypes["EvaluationInfoUpsertResult"],
	createConsumptionMessage: GraphQLTypes["ConsumptionMessageCreateResult"],
	deleteConsumptionMessage: GraphQLTypes["ConsumptionMessageDeleteResult"],
	updateConsumptionMessage: GraphQLTypes["ConsumptionMessageUpdateResult"],
	upsertConsumptionMessage: GraphQLTypes["ConsumptionMessageUpsertResult"],
	createContentText: GraphQLTypes["ContentTextCreateResult"],
	deleteContentText: GraphQLTypes["ContentTextDeleteResult"],
	updateContentText: GraphQLTypes["ContentTextUpdateResult"],
	upsertContentText: GraphQLTypes["ContentTextUpsertResult"],
	createContentTextBlock: GraphQLTypes["ContentTextBlockCreateResult"],
	deleteContentTextBlock: GraphQLTypes["ContentTextBlockDeleteResult"],
	updateContentTextBlock: GraphQLTypes["ContentTextBlockUpdateResult"],
	upsertContentTextBlock: GraphQLTypes["ContentTextBlockUpsertResult"],
	createComparatorPage: GraphQLTypes["ComparatorPageCreateResult"],
	deleteComparatorPage: GraphQLTypes["ComparatorPageDeleteResult"],
	updateComparatorPage: GraphQLTypes["ComparatorPageUpdateResult"],
	upsertComparatorPage: GraphQLTypes["ComparatorPageUpsertResult"],
	createLoginPage: GraphQLTypes["LoginPageCreateResult"],
	deleteLoginPage: GraphQLTypes["LoginPageDeleteResult"],
	updateLoginPage: GraphQLTypes["LoginPageUpdateResult"],
	upsertLoginPage: GraphQLTypes["LoginPageUpsertResult"],
	createRegisterPage: GraphQLTypes["RegisterPageCreateResult"],
	deleteRegisterPage: GraphQLTypes["RegisterPageDeleteResult"],
	updateRegisterPage: GraphQLTypes["RegisterPageUpdateResult"],
	upsertRegisterPage: GraphQLTypes["RegisterPageUpsertResult"],
	createResultsPage: GraphQLTypes["ResultsPageCreateResult"],
	deleteResultsPage: GraphQLTypes["ResultsPageDeleteResult"],
	updateResultsPage: GraphQLTypes["ResultsPageUpdateResult"],
	upsertResultsPage: GraphQLTypes["ResultsPageUpsertResult"],
	createSearchPage: GraphQLTypes["SearchPageCreateResult"],
	deleteSearchPage: GraphQLTypes["SearchPageDeleteResult"],
	updateSearchPage: GraphQLTypes["SearchPageUpdateResult"],
	upsertSearchPage: GraphQLTypes["SearchPageUpsertResult"],
	createWizardPage: GraphQLTypes["WizardPageCreateResult"],
	deleteWizardPage: GraphQLTypes["WizardPageDeleteResult"],
	updateWizardPage: GraphQLTypes["WizardPageUpdateResult"],
	upsertWizardPage: GraphQLTypes["WizardPageUpsertResult"],
	createBreastfeedingCategory: GraphQLTypes["BreastfeedingCategoryCreateResult"],
	deleteBreastfeedingCategory: GraphQLTypes["BreastfeedingCategoryDeleteResult"],
	updateBreastfeedingCategory: GraphQLTypes["BreastfeedingCategoryUpdateResult"],
	upsertBreastfeedingCategory: GraphQLTypes["BreastfeedingCategoryUpsertResult"],
	createDogReproduction: GraphQLTypes["DogReproductionCreateResult"],
	deleteDogReproduction: GraphQLTypes["DogReproductionDeleteResult"],
	updateDogReproduction: GraphQLTypes["DogReproductionUpdateResult"],
	upsertDogReproduction: GraphQLTypes["DogReproductionUpsertResult"],
	createContactFormMessage: GraphQLTypes["ContactFormMessageCreateResult"],
	deleteContactFormMessage: GraphQLTypes["ContactFormMessageDeleteResult"],
	updateContactFormMessage: GraphQLTypes["ContactFormMessageUpdateResult"],
	upsertContactFormMessage: GraphQLTypes["ContactFormMessageUpsertResult"],
	createContactPage: GraphQLTypes["ContactPageCreateResult"],
	deleteContactPage: GraphQLTypes["ContactPageDeleteResult"],
	updateContactPage: GraphQLTypes["ContactPageUpdateResult"],
	upsertContactPage: GraphQLTypes["ContactPageUpsertResult"],
	createBugReport: GraphQLTypes["BugReportCreateResult"],
	deleteBugReport: GraphQLTypes["BugReportDeleteResult"],
	updateBugReport: GraphQLTypes["BugReportUpdateResult"],
	upsertBugReport: GraphQLTypes["BugReportUpsertResult"],
	createColor: GraphQLTypes["ColorCreateResult"],
	deleteColor: GraphQLTypes["ColorDeleteResult"],
	updateColor: GraphQLTypes["ColorUpdateResult"],
	upsertColor: GraphQLTypes["ColorUpsertResult"],
	createItemGroup: GraphQLTypes["ItemGroupCreateResult"],
	deleteItemGroup: GraphQLTypes["ItemGroupDeleteResult"],
	updateItemGroup: GraphQLTypes["ItemGroupUpdateResult"],
	upsertItemGroup: GraphQLTypes["ItemGroupUpsertResult"],
	createProductEvaluationSummary: GraphQLTypes["ProductEvaluationSummaryCreateResult"],
	deleteProductEvaluationSummary: GraphQLTypes["ProductEvaluationSummaryDeleteResult"],
	updateProductEvaluationSummary: GraphQLTypes["ProductEvaluationSummaryUpdateResult"],
	upsertProductEvaluationSummary: GraphQLTypes["ProductEvaluationSummaryUpsertResult"],
	createProtectedAction: GraphQLTypes["ProtectedActionCreateResult"],
	deleteProtectedAction: GraphQLTypes["ProtectedActionDeleteResult"],
	updateProtectedAction: GraphQLTypes["ProtectedActionUpdateResult"],
	upsertProtectedAction: GraphQLTypes["ProtectedActionUpsertResult"],
	createBrandAlias: GraphQLTypes["BrandAliasCreateResult"],
	deleteBrandAlias: GraphQLTypes["BrandAliasDeleteResult"],
	updateBrandAlias: GraphQLTypes["BrandAliasUpdateResult"],
	upsertBrandAlias: GraphQLTypes["BrandAliasUpsertResult"],
	createProductAlias: GraphQLTypes["ProductAliasCreateResult"],
	deleteProductAlias: GraphQLTypes["ProductAliasDeleteResult"],
	updateProductAlias: GraphQLTypes["ProductAliasUpdateResult"],
	upsertProductAlias: GraphQLTypes["ProductAliasUpsertResult"],
	createProductLineAlias: GraphQLTypes["ProductLineAliasCreateResult"],
	deleteProductLineAlias: GraphQLTypes["ProductLineAliasDeleteResult"],
	updateProductLineAlias: GraphQLTypes["ProductLineAliasUpdateResult"],
	upsertProductLineAlias: GraphQLTypes["ProductLineAliasUpsertResult"],
	createGenericPage: GraphQLTypes["GenericPageCreateResult"],
	deleteGenericPage: GraphQLTypes["GenericPageDeleteResult"],
	updateGenericPage: GraphQLTypes["GenericPageUpdateResult"],
	upsertGenericPage: GraphQLTypes["GenericPageUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createContentLinks: GraphQLTypes["ContentLinksCreateResult"],
	deleteContentLinks: GraphQLTypes["ContentLinksDeleteResult"],
	updateContentLinks: GraphQLTypes["ContentLinksUpdateResult"],
	upsertContentLinks: GraphQLTypes["ContentLinksUpsertResult"],
	createContentLinksItem: GraphQLTypes["ContentLinksItemCreateResult"],
	deleteContentLinksItem: GraphQLTypes["ContentLinksItemDeleteResult"],
	updateContentLinksItem: GraphQLTypes["ContentLinksItemUpdateResult"],
	upsertContentLinksItem: GraphQLTypes["ContentLinksItemUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createContentReferenceImage: GraphQLTypes["ContentReferenceImageCreateResult"],
	deleteContentReferenceImage: GraphQLTypes["ContentReferenceImageDeleteResult"],
	updateContentReferenceImage: GraphQLTypes["ContentReferenceImageUpdateResult"],
	upsertContentReferenceImage: GraphQLTypes["ContentReferenceImageUpsertResult"],
	createSeoData: GraphQLTypes["SeoDataCreateResult"],
	deleteSeoData: GraphQLTypes["SeoDataDeleteResult"],
	updateSeoData: GraphQLTypes["SeoDataUpdateResult"],
	upsertSeoData: GraphQLTypes["SeoDataUpsertResult"],
	createAgeCategory: GraphQLTypes["AgeCategoryCreateResult"],
	deleteAgeCategory: GraphQLTypes["AgeCategoryDeleteResult"],
	updateAgeCategory: GraphQLTypes["AgeCategoryUpdateResult"],
	upsertAgeCategory: GraphQLTypes["AgeCategoryUpsertResult"],
	createFilterCombo: GraphQLTypes["FilterComboCreateResult"],
	deleteFilterCombo: GraphQLTypes["FilterComboDeleteResult"],
	updateFilterCombo: GraphQLTypes["FilterComboUpdateResult"],
	upsertFilterCombo: GraphQLTypes["FilterComboUpsertResult"],
	createImportCache: GraphQLTypes["ImportCacheCreateResult"],
	deleteImportCache: GraphQLTypes["ImportCacheDeleteResult"],
	updateImportCache: GraphQLTypes["ImportCacheUpdateResult"],
	upsertImportCache: GraphQLTypes["ImportCacheUpsertResult"],
	createSite: GraphQLTypes["SiteCreateResult"],
	deleteSite: GraphQLTypes["SiteDeleteResult"],
	updateSite: GraphQLTypes["SiteUpdateResult"],
	upsertSite: GraphQLTypes["SiteUpsertResult"],
	createContactSubmission: GraphQLTypes["ContactSubmissionCreateResult"],
	deleteContactSubmission: GraphQLTypes["ContactSubmissionDeleteResult"],
	updateContactSubmission: GraphQLTypes["ContactSubmissionUpdateResult"],
	upsertContactSubmission: GraphQLTypes["ContactSubmissionUpsertResult"],
	createTOPXBrand: GraphQLTypes["TOPXBrandCreateResult"],
	deleteTOPXBrand: GraphQLTypes["TOPXBrandDeleteResult"],
	updateTOPXBrand: GraphQLTypes["TOPXBrandUpdateResult"],
	upsertTOPXBrand: GraphQLTypes["TOPXBrandUpsertResult"],
	createTOPXBrandCategory: GraphQLTypes["TOPXBrandCategoryCreateResult"],
	deleteTOPXBrandCategory: GraphQLTypes["TOPXBrandCategoryDeleteResult"],
	updateTOPXBrandCategory: GraphQLTypes["TOPXBrandCategoryUpdateResult"],
	upsertTOPXBrandCategory: GraphQLTypes["TOPXBrandCategoryUpsertResult"],
	createTOPXProduct: GraphQLTypes["TOPXProductCreateResult"],
	deleteTOPXProduct: GraphQLTypes["TOPXProductDeleteResult"],
	updateTOPXProduct: GraphQLTypes["TOPXProductUpdateResult"],
	upsertTOPXProduct: GraphQLTypes["TOPXProductUpsertResult"],
	createTOPXProductCategory: GraphQLTypes["TOPXProductCategoryCreateResult"],
	deleteTOPXProductCategory: GraphQLTypes["TOPXProductCategoryDeleteResult"],
	updateTOPXProductCategory: GraphQLTypes["TOPXProductCategoryUpdateResult"],
	upsertTOPXProductCategory: GraphQLTypes["TOPXProductCategoryUpsertResult"],
	createContentReferenceList: GraphQLTypes["ContentReferenceListCreateResult"],
	deleteContentReferenceList: GraphQLTypes["ContentReferenceListDeleteResult"],
	updateContentReferenceList: GraphQLTypes["ContentReferenceListUpdateResult"],
	upsertContentReferenceList: GraphQLTypes["ContentReferenceListUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"]
};
	["S3SignedUpload"]: {
	__typename: "S3SignedUpload",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
	__typename: "S3Header",
	key: string,
	value: string
};
	["S3GenerateSignedUploadInput"]: {
		contentType?: string,
	/** If not provided, extension is detected from a content-type. */
	extension?: string,
	/** Signed URL expiration. */
	expiration?: number,
	/** Uploaded file size. Required when you enable ACL size limits. */
	size?: number,
	/** Can be used as a "directory". */
	prefix?: string,
	/** Suffix after generated id and before the extension. */
	suffix?: string,
	/** This only affects Content-disposition header. Does not affect actual object key. */
	fileName?: string,
	contentDisposition?: GraphQLTypes["S33ContentDisposition"],
	/** If not supported by S3 provider, an error is thrown. */
	acl?: GraphQLTypes["S3Acl"]
};
	["S33ContentDisposition"]: S33ContentDisposition;
	["S3Acl"]: S3Acl;
	["S3SignedRead"]: {
	__typename: "S3SignedRead",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	objectKey: string,
	bucket: string
};
	["BlogPageCreateResult"]: {
	__typename: "BlogPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: {
	__typename:"BlogPageCreateResult" | "BlogPageDeleteResult" | "BlogPageUpdateResult" | "BlogPageUpsertResult" | "BlogPostCreateResult" | "BlogPostDeleteResult" | "BlogPostUpdateResult" | "BlogPostUpsertResult" | "BlogPostTagCreateResult" | "BlogPostTagDeleteResult" | "BlogPostTagUpdateResult" | "BlogPostTagUpsertResult" | "BodyTagCreateResult" | "BodyTagDeleteResult" | "BodyTagUpdateResult" | "BodyTagUpsertResult" | "BodyTagCategoryCreateResult" | "BodyTagCategoryDeleteResult" | "BodyTagCategoryUpdateResult" | "BodyTagCategoryUpsertResult" | "ContentCreateResult" | "ContentDeleteResult" | "ContentUpdateResult" | "ContentUpsertResult" | "ContentBlockCreateResult" | "ContentBlockDeleteResult" | "ContentBlockUpdateResult" | "ContentBlockUpsertResult" | "ContentReferenceCreateResult" | "ContentReferenceDeleteResult" | "ContentReferenceUpdateResult" | "ContentReferenceUpsertResult" | "DidYouKnowCreateResult" | "DidYouKnowDeleteResult" | "DidYouKnowUpdateResult" | "DidYouKnowUpsertResult" | "ImageCreateResult" | "ImageDeleteResult" | "ImageUpdateResult" | "ImageUpsertResult" | "MediumCreateResult" | "MediumDeleteResult" | "MediumUpdateResult" | "MediumUpsertResult" | "NutritionalValueCreateResult" | "NutritionalValueDeleteResult" | "NutritionalValueUpdateResult" | "NutritionalValueUpsertResult" | "PageCreateResult" | "PageDeleteResult" | "PageUpdateResult" | "PageUpsertResult" | "ReferenceCreateResult" | "ReferenceDeleteResult" | "ReferenceUpdateResult" | "ReferenceUpsertResult" | "ReferenceListCreateResult" | "ReferenceListDeleteResult" | "ReferenceListUpdateResult" | "ReferenceListUpsertResult" | "SeoCreateResult" | "SeoDeleteResult" | "SeoUpdateResult" | "SeoUpsertResult" | "VideoCreateResult" | "VideoDeleteResult" | "VideoUpdateResult" | "VideoUpsertResult" | "BrandCreateResult" | "BrandDeleteResult" | "BrandUpdateResult" | "BrandUpsertResult" | "BrandDistributorCreateResult" | "BrandDistributorDeleteResult" | "BrandDistributorUpdateResult" | "BrandDistributorUpsertResult" | "DogSizeCreateResult" | "DogSizeDeleteResult" | "DogSizeUpdateResult" | "DogSizeUpsertResult" | "ProductCreateResult" | "ProductDeleteResult" | "ProductUpdateResult" | "ProductUpsertResult" | "ProductionMethodCreateResult" | "ProductionMethodDeleteResult" | "ProductionMethodUpdateResult" | "ProductionMethodUpsertResult" | "ProductLineCreateResult" | "ProductLineDeleteResult" | "ProductLineUpdateResult" | "ProductLineUpsertResult" | "BreedCreateResult" | "BreedDeleteResult" | "BreedUpdateResult" | "BreedUpsertResult" | "DogCreateResult" | "DogDeleteResult" | "DogUpdateResult" | "DogUpsertResult" | "UserCreateResult" | "UserDeleteResult" | "UserUpdateResult" | "UserUpsertResult" | "VeterinaryCreateResult" | "VeterinaryDeleteResult" | "VeterinaryUpdateResult" | "VeterinaryUpsertResult" | "NutritionalValueOfProductCreateResult" | "NutritionalValueOfProductDeleteResult" | "NutritionalValueOfProductUpdateResult" | "NutritionalValueOfProductUpsertResult" | "ReviewCreateResult" | "ReviewDeleteResult" | "ReviewUpdateResult" | "ReviewUpsertResult" | "DogBodyTypeCreateResult" | "DogBodyTypeDeleteResult" | "DogBodyTypeUpdateResult" | "DogBodyTypeUpsertResult" | "DogBodyTypeCategoryCreateResult" | "DogBodyTypeCategoryDeleteResult" | "DogBodyTypeCategoryUpdateResult" | "DogBodyTypeCategoryUpsertResult" | "LinkCreateResult" | "LinkDeleteResult" | "LinkUpdateResult" | "LinkUpsertResult" | "UrlCreateResult" | "UrlDeleteResult" | "UrlUpdateResult" | "UrlUpsertResult" | "FooterCreateResult" | "FooterDeleteResult" | "FooterUpdateResult" | "FooterUpsertResult" | "FooterLinkCreateResult" | "FooterLinkDeleteResult" | "FooterLinkUpdateResult" | "FooterLinkUpsertResult" | "BrandsPageCreateResult" | "BrandsPageDeleteResult" | "BrandsPageUpdateResult" | "BrandsPageUpsertResult" | "HomePageCreateResult" | "HomePageDeleteResult" | "HomePageUpdateResult" | "HomePageUpsertResult" | "IngredientsPageCreateResult" | "IngredientsPageDeleteResult" | "IngredientsPageUpdateResult" | "IngredientsPageUpsertResult" | "ProductReviewCreateResult" | "ProductReviewDeleteResult" | "ProductReviewUpdateResult" | "ProductReviewUpsertResult" | "ScoreCreateResult" | "ScoreDeleteResult" | "ScoreUpdateResult" | "ScoreUpsertResult" | "AgeCreateResult" | "AgeDeleteResult" | "AgeUpdateResult" | "AgeUpsertResult" | "CountryCreateResult" | "CountryDeleteResult" | "CountryUpdateResult" | "CountryUpsertResult" | "BlogPostReviewCreateResult" | "BlogPostReviewDeleteResult" | "BlogPostReviewUpdateResult" | "BlogPostReviewUpsertResult" | "DogActivityCreateResult" | "DogActivityDeleteResult" | "DogActivityUpdateResult" | "DogActivityUpsertResult" | "SocialCreateResult" | "SocialDeleteResult" | "SocialUpdateResult" | "SocialUpsertResult" | "ContentReferenceGalleryImageCreateResult" | "ContentReferenceGalleryImageDeleteResult" | "ContentReferenceGalleryImageUpdateResult" | "ContentReferenceGalleryImageUpsertResult" | "ItemCreateResult" | "ItemDeleteResult" | "ItemUpdateResult" | "ItemUpsertResult" | "ItemSubCategoryCreateResult" | "ItemSubCategoryDeleteResult" | "ItemSubCategoryUpdateResult" | "ItemSubCategoryUpsertResult" | "ItemCategoryCreateResult" | "ItemCategoryDeleteResult" | "ItemCategoryUpdateResult" | "ItemCategoryUpsertResult" | "ItemFlavorCategoryCreateResult" | "ItemFlavorCategoryDeleteResult" | "ItemFlavorCategoryUpdateResult" | "ItemFlavorCategoryUpsertResult" | "ItemDeclensionFourthVariantCreateResult" | "ItemDeclensionFourthVariantDeleteResult" | "ItemDeclensionFourthVariantUpdateResult" | "ItemDeclensionFourthVariantUpsertResult" | "ItemDeclensionSeventhVariantCreateResult" | "ItemDeclensionSeventhVariantDeleteResult" | "ItemDeclensionSeventhVariantUpdateResult" | "ItemDeclensionSeventhVariantUpsertResult" | "MediaCardCreateResult" | "MediaCardDeleteResult" | "MediaCardUpdateResult" | "MediaCardUpsertResult" | "InfoCardCreateResult" | "InfoCardDeleteResult" | "InfoCardUpdateResult" | "InfoCardUpsertResult" | "NumberedCardCreateResult" | "NumberedCardDeleteResult" | "NumberedCardUpdateResult" | "NumberedCardUpsertResult" | "RegisterClaimCreateResult" | "RegisterClaimDeleteResult" | "RegisterClaimUpdateResult" | "RegisterClaimUpsertResult" | "BlogPostReviewReactionCreateResult" | "BlogPostReviewReactionDeleteResult" | "BlogPostReviewReactionUpdateResult" | "BlogPostReviewReactionUpsertResult" | "ProductReviewReactionCreateResult" | "ProductReviewReactionDeleteResult" | "ProductReviewReactionUpdateResult" | "ProductReviewReactionUpsertResult" | "ProductPackageCreateResult" | "ProductPackageDeleteResult" | "ProductPackageUpdateResult" | "ProductPackageUpsertResult" | "BrandManufacturerCreateResult" | "BrandManufacturerDeleteResult" | "BrandManufacturerUpdateResult" | "BrandManufacturerUpsertResult" | "ElementCreateResult" | "ElementDeleteResult" | "ElementUpdateResult" | "ElementUpsertResult" | "ElementOfProductCreateResult" | "ElementOfProductDeleteResult" | "ElementOfProductUpdateResult" | "ElementOfProductUpsertResult" | "SuitabilityCategoryCreateResult" | "SuitabilityCategoryDeleteResult" | "SuitabilityCategoryUpdateResult" | "SuitabilityCategoryUpsertResult" | "ProductFeatureCreateResult" | "ProductFeatureDeleteResult" | "ProductFeatureUpdateResult" | "ProductFeatureUpsertResult" | "SuitabilityItemCreateResult" | "SuitabilityItemDeleteResult" | "SuitabilityItemUpdateResult" | "SuitabilityItemUpsertResult" | "RegionCreateResult" | "RegionDeleteResult" | "RegionUpdateResult" | "RegionUpsertResult" | "GranuleSizeCreateResult" | "GranuleSizeDeleteResult" | "GranuleSizeUpdateResult" | "GranuleSizeUpsertResult" | "ItemAliasCreateResult" | "ItemAliasDeleteResult" | "ItemAliasUpdateResult" | "ItemAliasUpsertResult" | "SemanticKeyCreateResult" | "SemanticKeyDeleteResult" | "SemanticKeyUpdateResult" | "SemanticKeyUpsertResult" | "ProductFlagCreateResult" | "ProductFlagDeleteResult" | "ProductFlagUpdateResult" | "ProductFlagUpsertResult" | "ProductFlagOfProductCreateResult" | "ProductFlagOfProductDeleteResult" | "ProductFlagOfProductUpdateResult" | "ProductFlagOfProductUpsertResult" | "ProductEvaluationCreateResult" | "ProductEvaluationDeleteResult" | "ProductEvaluationUpdateResult" | "ProductEvaluationUpsertResult" | "AdCreateResult" | "AdDeleteResult" | "AdUpdateResult" | "AdUpsertResult" | "EvaluationInfoCreateResult" | "EvaluationInfoDeleteResult" | "EvaluationInfoUpdateResult" | "EvaluationInfoUpsertResult" | "ConsumptionMessageCreateResult" | "ConsumptionMessageDeleteResult" | "ConsumptionMessageUpdateResult" | "ConsumptionMessageUpsertResult" | "ContentTextCreateResult" | "ContentTextDeleteResult" | "ContentTextUpdateResult" | "ContentTextUpsertResult" | "ContentTextBlockCreateResult" | "ContentTextBlockDeleteResult" | "ContentTextBlockUpdateResult" | "ContentTextBlockUpsertResult" | "ComparatorPageCreateResult" | "ComparatorPageDeleteResult" | "ComparatorPageUpdateResult" | "ComparatorPageUpsertResult" | "LoginPageCreateResult" | "LoginPageDeleteResult" | "LoginPageUpdateResult" | "LoginPageUpsertResult" | "RegisterPageCreateResult" | "RegisterPageDeleteResult" | "RegisterPageUpdateResult" | "RegisterPageUpsertResult" | "ResultsPageCreateResult" | "ResultsPageDeleteResult" | "ResultsPageUpdateResult" | "ResultsPageUpsertResult" | "SearchPageCreateResult" | "SearchPageDeleteResult" | "SearchPageUpdateResult" | "SearchPageUpsertResult" | "WizardPageCreateResult" | "WizardPageDeleteResult" | "WizardPageUpdateResult" | "WizardPageUpsertResult" | "BreastfeedingCategoryCreateResult" | "BreastfeedingCategoryDeleteResult" | "BreastfeedingCategoryUpdateResult" | "BreastfeedingCategoryUpsertResult" | "DogReproductionCreateResult" | "DogReproductionDeleteResult" | "DogReproductionUpdateResult" | "DogReproductionUpsertResult" | "ContactFormMessageCreateResult" | "ContactFormMessageDeleteResult" | "ContactFormMessageUpdateResult" | "ContactFormMessageUpsertResult" | "ContactPageCreateResult" | "ContactPageDeleteResult" | "ContactPageUpdateResult" | "ContactPageUpsertResult" | "BugReportCreateResult" | "BugReportDeleteResult" | "BugReportUpdateResult" | "BugReportUpsertResult" | "ColorCreateResult" | "ColorDeleteResult" | "ColorUpdateResult" | "ColorUpsertResult" | "ItemGroupCreateResult" | "ItemGroupDeleteResult" | "ItemGroupUpdateResult" | "ItemGroupUpsertResult" | "ProductEvaluationSummaryCreateResult" | "ProductEvaluationSummaryDeleteResult" | "ProductEvaluationSummaryUpdateResult" | "ProductEvaluationSummaryUpsertResult" | "ProtectedActionCreateResult" | "ProtectedActionDeleteResult" | "ProtectedActionUpdateResult" | "ProtectedActionUpsertResult" | "BrandAliasCreateResult" | "BrandAliasDeleteResult" | "BrandAliasUpdateResult" | "BrandAliasUpsertResult" | "ProductAliasCreateResult" | "ProductAliasDeleteResult" | "ProductAliasUpdateResult" | "ProductAliasUpsertResult" | "ProductLineAliasCreateResult" | "ProductLineAliasDeleteResult" | "ProductLineAliasUpdateResult" | "ProductLineAliasUpsertResult" | "GenericPageCreateResult" | "GenericPageDeleteResult" | "GenericPageUpdateResult" | "GenericPageUpsertResult" | "LinkableCreateResult" | "LinkableDeleteResult" | "LinkableUpdateResult" | "LinkableUpsertResult" | "ContentLinksCreateResult" | "ContentLinksDeleteResult" | "ContentLinksUpdateResult" | "ContentLinksUpsertResult" | "ContentLinksItemCreateResult" | "ContentLinksItemDeleteResult" | "ContentLinksItemUpdateResult" | "ContentLinksItemUpsertResult" | "RedirectCreateResult" | "RedirectDeleteResult" | "RedirectUpdateResult" | "RedirectUpsertResult" | "ContentReferenceImageCreateResult" | "ContentReferenceImageDeleteResult" | "ContentReferenceImageUpdateResult" | "ContentReferenceImageUpsertResult" | "SeoDataCreateResult" | "SeoDataDeleteResult" | "SeoDataUpdateResult" | "SeoDataUpsertResult" | "AgeCategoryCreateResult" | "AgeCategoryDeleteResult" | "AgeCategoryUpdateResult" | "AgeCategoryUpsertResult" | "FilterComboCreateResult" | "FilterComboDeleteResult" | "FilterComboUpdateResult" | "FilterComboUpsertResult" | "ImportCacheCreateResult" | "ImportCacheDeleteResult" | "ImportCacheUpdateResult" | "ImportCacheUpsertResult" | "SiteCreateResult" | "SiteDeleteResult" | "SiteUpdateResult" | "SiteUpsertResult" | "ContactSubmissionCreateResult" | "ContactSubmissionDeleteResult" | "ContactSubmissionUpdateResult" | "ContactSubmissionUpsertResult" | "TOPXBrandCreateResult" | "TOPXBrandDeleteResult" | "TOPXBrandUpdateResult" | "TOPXBrandUpsertResult" | "TOPXBrandCategoryCreateResult" | "TOPXBrandCategoryDeleteResult" | "TOPXBrandCategoryUpdateResult" | "TOPXBrandCategoryUpsertResult" | "TOPXProductCreateResult" | "TOPXProductDeleteResult" | "TOPXProductUpdateResult" | "TOPXProductUpsertResult" | "TOPXProductCategoryCreateResult" | "TOPXProductCategoryDeleteResult" | "TOPXProductCategoryUpdateResult" | "TOPXProductCategoryUpsertResult" | "ContentReferenceListCreateResult" | "ContentReferenceListDeleteResult" | "ContentReferenceListUpdateResult" | "ContentReferenceListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>
	['...on BlogPageCreateResult']: '__union' & GraphQLTypes["BlogPageCreateResult"];
	['...on BlogPageDeleteResult']: '__union' & GraphQLTypes["BlogPageDeleteResult"];
	['...on BlogPageUpdateResult']: '__union' & GraphQLTypes["BlogPageUpdateResult"];
	['...on BlogPageUpsertResult']: '__union' & GraphQLTypes["BlogPageUpsertResult"];
	['...on BlogPostCreateResult']: '__union' & GraphQLTypes["BlogPostCreateResult"];
	['...on BlogPostDeleteResult']: '__union' & GraphQLTypes["BlogPostDeleteResult"];
	['...on BlogPostUpdateResult']: '__union' & GraphQLTypes["BlogPostUpdateResult"];
	['...on BlogPostUpsertResult']: '__union' & GraphQLTypes["BlogPostUpsertResult"];
	['...on BlogPostTagCreateResult']: '__union' & GraphQLTypes["BlogPostTagCreateResult"];
	['...on BlogPostTagDeleteResult']: '__union' & GraphQLTypes["BlogPostTagDeleteResult"];
	['...on BlogPostTagUpdateResult']: '__union' & GraphQLTypes["BlogPostTagUpdateResult"];
	['...on BlogPostTagUpsertResult']: '__union' & GraphQLTypes["BlogPostTagUpsertResult"];
	['...on BodyTagCreateResult']: '__union' & GraphQLTypes["BodyTagCreateResult"];
	['...on BodyTagDeleteResult']: '__union' & GraphQLTypes["BodyTagDeleteResult"];
	['...on BodyTagUpdateResult']: '__union' & GraphQLTypes["BodyTagUpdateResult"];
	['...on BodyTagUpsertResult']: '__union' & GraphQLTypes["BodyTagUpsertResult"];
	['...on BodyTagCategoryCreateResult']: '__union' & GraphQLTypes["BodyTagCategoryCreateResult"];
	['...on BodyTagCategoryDeleteResult']: '__union' & GraphQLTypes["BodyTagCategoryDeleteResult"];
	['...on BodyTagCategoryUpdateResult']: '__union' & GraphQLTypes["BodyTagCategoryUpdateResult"];
	['...on BodyTagCategoryUpsertResult']: '__union' & GraphQLTypes["BodyTagCategoryUpsertResult"];
	['...on ContentCreateResult']: '__union' & GraphQLTypes["ContentCreateResult"];
	['...on ContentDeleteResult']: '__union' & GraphQLTypes["ContentDeleteResult"];
	['...on ContentUpdateResult']: '__union' & GraphQLTypes["ContentUpdateResult"];
	['...on ContentUpsertResult']: '__union' & GraphQLTypes["ContentUpsertResult"];
	['...on ContentBlockCreateResult']: '__union' & GraphQLTypes["ContentBlockCreateResult"];
	['...on ContentBlockDeleteResult']: '__union' & GraphQLTypes["ContentBlockDeleteResult"];
	['...on ContentBlockUpdateResult']: '__union' & GraphQLTypes["ContentBlockUpdateResult"];
	['...on ContentBlockUpsertResult']: '__union' & GraphQLTypes["ContentBlockUpsertResult"];
	['...on ContentReferenceCreateResult']: '__union' & GraphQLTypes["ContentReferenceCreateResult"];
	['...on ContentReferenceDeleteResult']: '__union' & GraphQLTypes["ContentReferenceDeleteResult"];
	['...on ContentReferenceUpdateResult']: '__union' & GraphQLTypes["ContentReferenceUpdateResult"];
	['...on ContentReferenceUpsertResult']: '__union' & GraphQLTypes["ContentReferenceUpsertResult"];
	['...on DidYouKnowCreateResult']: '__union' & GraphQLTypes["DidYouKnowCreateResult"];
	['...on DidYouKnowDeleteResult']: '__union' & GraphQLTypes["DidYouKnowDeleteResult"];
	['...on DidYouKnowUpdateResult']: '__union' & GraphQLTypes["DidYouKnowUpdateResult"];
	['...on DidYouKnowUpsertResult']: '__union' & GraphQLTypes["DidYouKnowUpsertResult"];
	['...on ImageCreateResult']: '__union' & GraphQLTypes["ImageCreateResult"];
	['...on ImageDeleteResult']: '__union' & GraphQLTypes["ImageDeleteResult"];
	['...on ImageUpdateResult']: '__union' & GraphQLTypes["ImageUpdateResult"];
	['...on ImageUpsertResult']: '__union' & GraphQLTypes["ImageUpsertResult"];
	['...on MediumCreateResult']: '__union' & GraphQLTypes["MediumCreateResult"];
	['...on MediumDeleteResult']: '__union' & GraphQLTypes["MediumDeleteResult"];
	['...on MediumUpdateResult']: '__union' & GraphQLTypes["MediumUpdateResult"];
	['...on MediumUpsertResult']: '__union' & GraphQLTypes["MediumUpsertResult"];
	['...on NutritionalValueCreateResult']: '__union' & GraphQLTypes["NutritionalValueCreateResult"];
	['...on NutritionalValueDeleteResult']: '__union' & GraphQLTypes["NutritionalValueDeleteResult"];
	['...on NutritionalValueUpdateResult']: '__union' & GraphQLTypes["NutritionalValueUpdateResult"];
	['...on NutritionalValueUpsertResult']: '__union' & GraphQLTypes["NutritionalValueUpsertResult"];
	['...on PageCreateResult']: '__union' & GraphQLTypes["PageCreateResult"];
	['...on PageDeleteResult']: '__union' & GraphQLTypes["PageDeleteResult"];
	['...on PageUpdateResult']: '__union' & GraphQLTypes["PageUpdateResult"];
	['...on PageUpsertResult']: '__union' & GraphQLTypes["PageUpsertResult"];
	['...on ReferenceCreateResult']: '__union' & GraphQLTypes["ReferenceCreateResult"];
	['...on ReferenceDeleteResult']: '__union' & GraphQLTypes["ReferenceDeleteResult"];
	['...on ReferenceUpdateResult']: '__union' & GraphQLTypes["ReferenceUpdateResult"];
	['...on ReferenceUpsertResult']: '__union' & GraphQLTypes["ReferenceUpsertResult"];
	['...on ReferenceListCreateResult']: '__union' & GraphQLTypes["ReferenceListCreateResult"];
	['...on ReferenceListDeleteResult']: '__union' & GraphQLTypes["ReferenceListDeleteResult"];
	['...on ReferenceListUpdateResult']: '__union' & GraphQLTypes["ReferenceListUpdateResult"];
	['...on ReferenceListUpsertResult']: '__union' & GraphQLTypes["ReferenceListUpsertResult"];
	['...on SeoCreateResult']: '__union' & GraphQLTypes["SeoCreateResult"];
	['...on SeoDeleteResult']: '__union' & GraphQLTypes["SeoDeleteResult"];
	['...on SeoUpdateResult']: '__union' & GraphQLTypes["SeoUpdateResult"];
	['...on SeoUpsertResult']: '__union' & GraphQLTypes["SeoUpsertResult"];
	['...on VideoCreateResult']: '__union' & GraphQLTypes["VideoCreateResult"];
	['...on VideoDeleteResult']: '__union' & GraphQLTypes["VideoDeleteResult"];
	['...on VideoUpdateResult']: '__union' & GraphQLTypes["VideoUpdateResult"];
	['...on VideoUpsertResult']: '__union' & GraphQLTypes["VideoUpsertResult"];
	['...on BrandCreateResult']: '__union' & GraphQLTypes["BrandCreateResult"];
	['...on BrandDeleteResult']: '__union' & GraphQLTypes["BrandDeleteResult"];
	['...on BrandUpdateResult']: '__union' & GraphQLTypes["BrandUpdateResult"];
	['...on BrandUpsertResult']: '__union' & GraphQLTypes["BrandUpsertResult"];
	['...on BrandDistributorCreateResult']: '__union' & GraphQLTypes["BrandDistributorCreateResult"];
	['...on BrandDistributorDeleteResult']: '__union' & GraphQLTypes["BrandDistributorDeleteResult"];
	['...on BrandDistributorUpdateResult']: '__union' & GraphQLTypes["BrandDistributorUpdateResult"];
	['...on BrandDistributorUpsertResult']: '__union' & GraphQLTypes["BrandDistributorUpsertResult"];
	['...on DogSizeCreateResult']: '__union' & GraphQLTypes["DogSizeCreateResult"];
	['...on DogSizeDeleteResult']: '__union' & GraphQLTypes["DogSizeDeleteResult"];
	['...on DogSizeUpdateResult']: '__union' & GraphQLTypes["DogSizeUpdateResult"];
	['...on DogSizeUpsertResult']: '__union' & GraphQLTypes["DogSizeUpsertResult"];
	['...on ProductCreateResult']: '__union' & GraphQLTypes["ProductCreateResult"];
	['...on ProductDeleteResult']: '__union' & GraphQLTypes["ProductDeleteResult"];
	['...on ProductUpdateResult']: '__union' & GraphQLTypes["ProductUpdateResult"];
	['...on ProductUpsertResult']: '__union' & GraphQLTypes["ProductUpsertResult"];
	['...on ProductionMethodCreateResult']: '__union' & GraphQLTypes["ProductionMethodCreateResult"];
	['...on ProductionMethodDeleteResult']: '__union' & GraphQLTypes["ProductionMethodDeleteResult"];
	['...on ProductionMethodUpdateResult']: '__union' & GraphQLTypes["ProductionMethodUpdateResult"];
	['...on ProductionMethodUpsertResult']: '__union' & GraphQLTypes["ProductionMethodUpsertResult"];
	['...on ProductLineCreateResult']: '__union' & GraphQLTypes["ProductLineCreateResult"];
	['...on ProductLineDeleteResult']: '__union' & GraphQLTypes["ProductLineDeleteResult"];
	['...on ProductLineUpdateResult']: '__union' & GraphQLTypes["ProductLineUpdateResult"];
	['...on ProductLineUpsertResult']: '__union' & GraphQLTypes["ProductLineUpsertResult"];
	['...on BreedCreateResult']: '__union' & GraphQLTypes["BreedCreateResult"];
	['...on BreedDeleteResult']: '__union' & GraphQLTypes["BreedDeleteResult"];
	['...on BreedUpdateResult']: '__union' & GraphQLTypes["BreedUpdateResult"];
	['...on BreedUpsertResult']: '__union' & GraphQLTypes["BreedUpsertResult"];
	['...on DogCreateResult']: '__union' & GraphQLTypes["DogCreateResult"];
	['...on DogDeleteResult']: '__union' & GraphQLTypes["DogDeleteResult"];
	['...on DogUpdateResult']: '__union' & GraphQLTypes["DogUpdateResult"];
	['...on DogUpsertResult']: '__union' & GraphQLTypes["DogUpsertResult"];
	['...on UserCreateResult']: '__union' & GraphQLTypes["UserCreateResult"];
	['...on UserDeleteResult']: '__union' & GraphQLTypes["UserDeleteResult"];
	['...on UserUpdateResult']: '__union' & GraphQLTypes["UserUpdateResult"];
	['...on UserUpsertResult']: '__union' & GraphQLTypes["UserUpsertResult"];
	['...on VeterinaryCreateResult']: '__union' & GraphQLTypes["VeterinaryCreateResult"];
	['...on VeterinaryDeleteResult']: '__union' & GraphQLTypes["VeterinaryDeleteResult"];
	['...on VeterinaryUpdateResult']: '__union' & GraphQLTypes["VeterinaryUpdateResult"];
	['...on VeterinaryUpsertResult']: '__union' & GraphQLTypes["VeterinaryUpsertResult"];
	['...on NutritionalValueOfProductCreateResult']: '__union' & GraphQLTypes["NutritionalValueOfProductCreateResult"];
	['...on NutritionalValueOfProductDeleteResult']: '__union' & GraphQLTypes["NutritionalValueOfProductDeleteResult"];
	['...on NutritionalValueOfProductUpdateResult']: '__union' & GraphQLTypes["NutritionalValueOfProductUpdateResult"];
	['...on NutritionalValueOfProductUpsertResult']: '__union' & GraphQLTypes["NutritionalValueOfProductUpsertResult"];
	['...on ReviewCreateResult']: '__union' & GraphQLTypes["ReviewCreateResult"];
	['...on ReviewDeleteResult']: '__union' & GraphQLTypes["ReviewDeleteResult"];
	['...on ReviewUpdateResult']: '__union' & GraphQLTypes["ReviewUpdateResult"];
	['...on ReviewUpsertResult']: '__union' & GraphQLTypes["ReviewUpsertResult"];
	['...on DogBodyTypeCreateResult']: '__union' & GraphQLTypes["DogBodyTypeCreateResult"];
	['...on DogBodyTypeDeleteResult']: '__union' & GraphQLTypes["DogBodyTypeDeleteResult"];
	['...on DogBodyTypeUpdateResult']: '__union' & GraphQLTypes["DogBodyTypeUpdateResult"];
	['...on DogBodyTypeUpsertResult']: '__union' & GraphQLTypes["DogBodyTypeUpsertResult"];
	['...on DogBodyTypeCategoryCreateResult']: '__union' & GraphQLTypes["DogBodyTypeCategoryCreateResult"];
	['...on DogBodyTypeCategoryDeleteResult']: '__union' & GraphQLTypes["DogBodyTypeCategoryDeleteResult"];
	['...on DogBodyTypeCategoryUpdateResult']: '__union' & GraphQLTypes["DogBodyTypeCategoryUpdateResult"];
	['...on DogBodyTypeCategoryUpsertResult']: '__union' & GraphQLTypes["DogBodyTypeCategoryUpsertResult"];
	['...on LinkCreateResult']: '__union' & GraphQLTypes["LinkCreateResult"];
	['...on LinkDeleteResult']: '__union' & GraphQLTypes["LinkDeleteResult"];
	['...on LinkUpdateResult']: '__union' & GraphQLTypes["LinkUpdateResult"];
	['...on LinkUpsertResult']: '__union' & GraphQLTypes["LinkUpsertResult"];
	['...on UrlCreateResult']: '__union' & GraphQLTypes["UrlCreateResult"];
	['...on UrlDeleteResult']: '__union' & GraphQLTypes["UrlDeleteResult"];
	['...on UrlUpdateResult']: '__union' & GraphQLTypes["UrlUpdateResult"];
	['...on UrlUpsertResult']: '__union' & GraphQLTypes["UrlUpsertResult"];
	['...on FooterCreateResult']: '__union' & GraphQLTypes["FooterCreateResult"];
	['...on FooterDeleteResult']: '__union' & GraphQLTypes["FooterDeleteResult"];
	['...on FooterUpdateResult']: '__union' & GraphQLTypes["FooterUpdateResult"];
	['...on FooterUpsertResult']: '__union' & GraphQLTypes["FooterUpsertResult"];
	['...on FooterLinkCreateResult']: '__union' & GraphQLTypes["FooterLinkCreateResult"];
	['...on FooterLinkDeleteResult']: '__union' & GraphQLTypes["FooterLinkDeleteResult"];
	['...on FooterLinkUpdateResult']: '__union' & GraphQLTypes["FooterLinkUpdateResult"];
	['...on FooterLinkUpsertResult']: '__union' & GraphQLTypes["FooterLinkUpsertResult"];
	['...on BrandsPageCreateResult']: '__union' & GraphQLTypes["BrandsPageCreateResult"];
	['...on BrandsPageDeleteResult']: '__union' & GraphQLTypes["BrandsPageDeleteResult"];
	['...on BrandsPageUpdateResult']: '__union' & GraphQLTypes["BrandsPageUpdateResult"];
	['...on BrandsPageUpsertResult']: '__union' & GraphQLTypes["BrandsPageUpsertResult"];
	['...on HomePageCreateResult']: '__union' & GraphQLTypes["HomePageCreateResult"];
	['...on HomePageDeleteResult']: '__union' & GraphQLTypes["HomePageDeleteResult"];
	['...on HomePageUpdateResult']: '__union' & GraphQLTypes["HomePageUpdateResult"];
	['...on HomePageUpsertResult']: '__union' & GraphQLTypes["HomePageUpsertResult"];
	['...on IngredientsPageCreateResult']: '__union' & GraphQLTypes["IngredientsPageCreateResult"];
	['...on IngredientsPageDeleteResult']: '__union' & GraphQLTypes["IngredientsPageDeleteResult"];
	['...on IngredientsPageUpdateResult']: '__union' & GraphQLTypes["IngredientsPageUpdateResult"];
	['...on IngredientsPageUpsertResult']: '__union' & GraphQLTypes["IngredientsPageUpsertResult"];
	['...on ProductReviewCreateResult']: '__union' & GraphQLTypes["ProductReviewCreateResult"];
	['...on ProductReviewDeleteResult']: '__union' & GraphQLTypes["ProductReviewDeleteResult"];
	['...on ProductReviewUpdateResult']: '__union' & GraphQLTypes["ProductReviewUpdateResult"];
	['...on ProductReviewUpsertResult']: '__union' & GraphQLTypes["ProductReviewUpsertResult"];
	['...on ScoreCreateResult']: '__union' & GraphQLTypes["ScoreCreateResult"];
	['...on ScoreDeleteResult']: '__union' & GraphQLTypes["ScoreDeleteResult"];
	['...on ScoreUpdateResult']: '__union' & GraphQLTypes["ScoreUpdateResult"];
	['...on ScoreUpsertResult']: '__union' & GraphQLTypes["ScoreUpsertResult"];
	['...on AgeCreateResult']: '__union' & GraphQLTypes["AgeCreateResult"];
	['...on AgeDeleteResult']: '__union' & GraphQLTypes["AgeDeleteResult"];
	['...on AgeUpdateResult']: '__union' & GraphQLTypes["AgeUpdateResult"];
	['...on AgeUpsertResult']: '__union' & GraphQLTypes["AgeUpsertResult"];
	['...on CountryCreateResult']: '__union' & GraphQLTypes["CountryCreateResult"];
	['...on CountryDeleteResult']: '__union' & GraphQLTypes["CountryDeleteResult"];
	['...on CountryUpdateResult']: '__union' & GraphQLTypes["CountryUpdateResult"];
	['...on CountryUpsertResult']: '__union' & GraphQLTypes["CountryUpsertResult"];
	['...on BlogPostReviewCreateResult']: '__union' & GraphQLTypes["BlogPostReviewCreateResult"];
	['...on BlogPostReviewDeleteResult']: '__union' & GraphQLTypes["BlogPostReviewDeleteResult"];
	['...on BlogPostReviewUpdateResult']: '__union' & GraphQLTypes["BlogPostReviewUpdateResult"];
	['...on BlogPostReviewUpsertResult']: '__union' & GraphQLTypes["BlogPostReviewUpsertResult"];
	['...on DogActivityCreateResult']: '__union' & GraphQLTypes["DogActivityCreateResult"];
	['...on DogActivityDeleteResult']: '__union' & GraphQLTypes["DogActivityDeleteResult"];
	['...on DogActivityUpdateResult']: '__union' & GraphQLTypes["DogActivityUpdateResult"];
	['...on DogActivityUpsertResult']: '__union' & GraphQLTypes["DogActivityUpsertResult"];
	['...on SocialCreateResult']: '__union' & GraphQLTypes["SocialCreateResult"];
	['...on SocialDeleteResult']: '__union' & GraphQLTypes["SocialDeleteResult"];
	['...on SocialUpdateResult']: '__union' & GraphQLTypes["SocialUpdateResult"];
	['...on SocialUpsertResult']: '__union' & GraphQLTypes["SocialUpsertResult"];
	['...on ContentReferenceGalleryImageCreateResult']: '__union' & GraphQLTypes["ContentReferenceGalleryImageCreateResult"];
	['...on ContentReferenceGalleryImageDeleteResult']: '__union' & GraphQLTypes["ContentReferenceGalleryImageDeleteResult"];
	['...on ContentReferenceGalleryImageUpdateResult']: '__union' & GraphQLTypes["ContentReferenceGalleryImageUpdateResult"];
	['...on ContentReferenceGalleryImageUpsertResult']: '__union' & GraphQLTypes["ContentReferenceGalleryImageUpsertResult"];
	['...on ItemCreateResult']: '__union' & GraphQLTypes["ItemCreateResult"];
	['...on ItemDeleteResult']: '__union' & GraphQLTypes["ItemDeleteResult"];
	['...on ItemUpdateResult']: '__union' & GraphQLTypes["ItemUpdateResult"];
	['...on ItemUpsertResult']: '__union' & GraphQLTypes["ItemUpsertResult"];
	['...on ItemSubCategoryCreateResult']: '__union' & GraphQLTypes["ItemSubCategoryCreateResult"];
	['...on ItemSubCategoryDeleteResult']: '__union' & GraphQLTypes["ItemSubCategoryDeleteResult"];
	['...on ItemSubCategoryUpdateResult']: '__union' & GraphQLTypes["ItemSubCategoryUpdateResult"];
	['...on ItemSubCategoryUpsertResult']: '__union' & GraphQLTypes["ItemSubCategoryUpsertResult"];
	['...on ItemCategoryCreateResult']: '__union' & GraphQLTypes["ItemCategoryCreateResult"];
	['...on ItemCategoryDeleteResult']: '__union' & GraphQLTypes["ItemCategoryDeleteResult"];
	['...on ItemCategoryUpdateResult']: '__union' & GraphQLTypes["ItemCategoryUpdateResult"];
	['...on ItemCategoryUpsertResult']: '__union' & GraphQLTypes["ItemCategoryUpsertResult"];
	['...on ItemFlavorCategoryCreateResult']: '__union' & GraphQLTypes["ItemFlavorCategoryCreateResult"];
	['...on ItemFlavorCategoryDeleteResult']: '__union' & GraphQLTypes["ItemFlavorCategoryDeleteResult"];
	['...on ItemFlavorCategoryUpdateResult']: '__union' & GraphQLTypes["ItemFlavorCategoryUpdateResult"];
	['...on ItemFlavorCategoryUpsertResult']: '__union' & GraphQLTypes["ItemFlavorCategoryUpsertResult"];
	['...on ItemDeclensionFourthVariantCreateResult']: '__union' & GraphQLTypes["ItemDeclensionFourthVariantCreateResult"];
	['...on ItemDeclensionFourthVariantDeleteResult']: '__union' & GraphQLTypes["ItemDeclensionFourthVariantDeleteResult"];
	['...on ItemDeclensionFourthVariantUpdateResult']: '__union' & GraphQLTypes["ItemDeclensionFourthVariantUpdateResult"];
	['...on ItemDeclensionFourthVariantUpsertResult']: '__union' & GraphQLTypes["ItemDeclensionFourthVariantUpsertResult"];
	['...on ItemDeclensionSeventhVariantCreateResult']: '__union' & GraphQLTypes["ItemDeclensionSeventhVariantCreateResult"];
	['...on ItemDeclensionSeventhVariantDeleteResult']: '__union' & GraphQLTypes["ItemDeclensionSeventhVariantDeleteResult"];
	['...on ItemDeclensionSeventhVariantUpdateResult']: '__union' & GraphQLTypes["ItemDeclensionSeventhVariantUpdateResult"];
	['...on ItemDeclensionSeventhVariantUpsertResult']: '__union' & GraphQLTypes["ItemDeclensionSeventhVariantUpsertResult"];
	['...on MediaCardCreateResult']: '__union' & GraphQLTypes["MediaCardCreateResult"];
	['...on MediaCardDeleteResult']: '__union' & GraphQLTypes["MediaCardDeleteResult"];
	['...on MediaCardUpdateResult']: '__union' & GraphQLTypes["MediaCardUpdateResult"];
	['...on MediaCardUpsertResult']: '__union' & GraphQLTypes["MediaCardUpsertResult"];
	['...on InfoCardCreateResult']: '__union' & GraphQLTypes["InfoCardCreateResult"];
	['...on InfoCardDeleteResult']: '__union' & GraphQLTypes["InfoCardDeleteResult"];
	['...on InfoCardUpdateResult']: '__union' & GraphQLTypes["InfoCardUpdateResult"];
	['...on InfoCardUpsertResult']: '__union' & GraphQLTypes["InfoCardUpsertResult"];
	['...on NumberedCardCreateResult']: '__union' & GraphQLTypes["NumberedCardCreateResult"];
	['...on NumberedCardDeleteResult']: '__union' & GraphQLTypes["NumberedCardDeleteResult"];
	['...on NumberedCardUpdateResult']: '__union' & GraphQLTypes["NumberedCardUpdateResult"];
	['...on NumberedCardUpsertResult']: '__union' & GraphQLTypes["NumberedCardUpsertResult"];
	['...on RegisterClaimCreateResult']: '__union' & GraphQLTypes["RegisterClaimCreateResult"];
	['...on RegisterClaimDeleteResult']: '__union' & GraphQLTypes["RegisterClaimDeleteResult"];
	['...on RegisterClaimUpdateResult']: '__union' & GraphQLTypes["RegisterClaimUpdateResult"];
	['...on RegisterClaimUpsertResult']: '__union' & GraphQLTypes["RegisterClaimUpsertResult"];
	['...on BlogPostReviewReactionCreateResult']: '__union' & GraphQLTypes["BlogPostReviewReactionCreateResult"];
	['...on BlogPostReviewReactionDeleteResult']: '__union' & GraphQLTypes["BlogPostReviewReactionDeleteResult"];
	['...on BlogPostReviewReactionUpdateResult']: '__union' & GraphQLTypes["BlogPostReviewReactionUpdateResult"];
	['...on BlogPostReviewReactionUpsertResult']: '__union' & GraphQLTypes["BlogPostReviewReactionUpsertResult"];
	['...on ProductReviewReactionCreateResult']: '__union' & GraphQLTypes["ProductReviewReactionCreateResult"];
	['...on ProductReviewReactionDeleteResult']: '__union' & GraphQLTypes["ProductReviewReactionDeleteResult"];
	['...on ProductReviewReactionUpdateResult']: '__union' & GraphQLTypes["ProductReviewReactionUpdateResult"];
	['...on ProductReviewReactionUpsertResult']: '__union' & GraphQLTypes["ProductReviewReactionUpsertResult"];
	['...on ProductPackageCreateResult']: '__union' & GraphQLTypes["ProductPackageCreateResult"];
	['...on ProductPackageDeleteResult']: '__union' & GraphQLTypes["ProductPackageDeleteResult"];
	['...on ProductPackageUpdateResult']: '__union' & GraphQLTypes["ProductPackageUpdateResult"];
	['...on ProductPackageUpsertResult']: '__union' & GraphQLTypes["ProductPackageUpsertResult"];
	['...on BrandManufacturerCreateResult']: '__union' & GraphQLTypes["BrandManufacturerCreateResult"];
	['...on BrandManufacturerDeleteResult']: '__union' & GraphQLTypes["BrandManufacturerDeleteResult"];
	['...on BrandManufacturerUpdateResult']: '__union' & GraphQLTypes["BrandManufacturerUpdateResult"];
	['...on BrandManufacturerUpsertResult']: '__union' & GraphQLTypes["BrandManufacturerUpsertResult"];
	['...on ElementCreateResult']: '__union' & GraphQLTypes["ElementCreateResult"];
	['...on ElementDeleteResult']: '__union' & GraphQLTypes["ElementDeleteResult"];
	['...on ElementUpdateResult']: '__union' & GraphQLTypes["ElementUpdateResult"];
	['...on ElementUpsertResult']: '__union' & GraphQLTypes["ElementUpsertResult"];
	['...on ElementOfProductCreateResult']: '__union' & GraphQLTypes["ElementOfProductCreateResult"];
	['...on ElementOfProductDeleteResult']: '__union' & GraphQLTypes["ElementOfProductDeleteResult"];
	['...on ElementOfProductUpdateResult']: '__union' & GraphQLTypes["ElementOfProductUpdateResult"];
	['...on ElementOfProductUpsertResult']: '__union' & GraphQLTypes["ElementOfProductUpsertResult"];
	['...on SuitabilityCategoryCreateResult']: '__union' & GraphQLTypes["SuitabilityCategoryCreateResult"];
	['...on SuitabilityCategoryDeleteResult']: '__union' & GraphQLTypes["SuitabilityCategoryDeleteResult"];
	['...on SuitabilityCategoryUpdateResult']: '__union' & GraphQLTypes["SuitabilityCategoryUpdateResult"];
	['...on SuitabilityCategoryUpsertResult']: '__union' & GraphQLTypes["SuitabilityCategoryUpsertResult"];
	['...on ProductFeatureCreateResult']: '__union' & GraphQLTypes["ProductFeatureCreateResult"];
	['...on ProductFeatureDeleteResult']: '__union' & GraphQLTypes["ProductFeatureDeleteResult"];
	['...on ProductFeatureUpdateResult']: '__union' & GraphQLTypes["ProductFeatureUpdateResult"];
	['...on ProductFeatureUpsertResult']: '__union' & GraphQLTypes["ProductFeatureUpsertResult"];
	['...on SuitabilityItemCreateResult']: '__union' & GraphQLTypes["SuitabilityItemCreateResult"];
	['...on SuitabilityItemDeleteResult']: '__union' & GraphQLTypes["SuitabilityItemDeleteResult"];
	['...on SuitabilityItemUpdateResult']: '__union' & GraphQLTypes["SuitabilityItemUpdateResult"];
	['...on SuitabilityItemUpsertResult']: '__union' & GraphQLTypes["SuitabilityItemUpsertResult"];
	['...on RegionCreateResult']: '__union' & GraphQLTypes["RegionCreateResult"];
	['...on RegionDeleteResult']: '__union' & GraphQLTypes["RegionDeleteResult"];
	['...on RegionUpdateResult']: '__union' & GraphQLTypes["RegionUpdateResult"];
	['...on RegionUpsertResult']: '__union' & GraphQLTypes["RegionUpsertResult"];
	['...on GranuleSizeCreateResult']: '__union' & GraphQLTypes["GranuleSizeCreateResult"];
	['...on GranuleSizeDeleteResult']: '__union' & GraphQLTypes["GranuleSizeDeleteResult"];
	['...on GranuleSizeUpdateResult']: '__union' & GraphQLTypes["GranuleSizeUpdateResult"];
	['...on GranuleSizeUpsertResult']: '__union' & GraphQLTypes["GranuleSizeUpsertResult"];
	['...on ItemAliasCreateResult']: '__union' & GraphQLTypes["ItemAliasCreateResult"];
	['...on ItemAliasDeleteResult']: '__union' & GraphQLTypes["ItemAliasDeleteResult"];
	['...on ItemAliasUpdateResult']: '__union' & GraphQLTypes["ItemAliasUpdateResult"];
	['...on ItemAliasUpsertResult']: '__union' & GraphQLTypes["ItemAliasUpsertResult"];
	['...on SemanticKeyCreateResult']: '__union' & GraphQLTypes["SemanticKeyCreateResult"];
	['...on SemanticKeyDeleteResult']: '__union' & GraphQLTypes["SemanticKeyDeleteResult"];
	['...on SemanticKeyUpdateResult']: '__union' & GraphQLTypes["SemanticKeyUpdateResult"];
	['...on SemanticKeyUpsertResult']: '__union' & GraphQLTypes["SemanticKeyUpsertResult"];
	['...on ProductFlagCreateResult']: '__union' & GraphQLTypes["ProductFlagCreateResult"];
	['...on ProductFlagDeleteResult']: '__union' & GraphQLTypes["ProductFlagDeleteResult"];
	['...on ProductFlagUpdateResult']: '__union' & GraphQLTypes["ProductFlagUpdateResult"];
	['...on ProductFlagUpsertResult']: '__union' & GraphQLTypes["ProductFlagUpsertResult"];
	['...on ProductFlagOfProductCreateResult']: '__union' & GraphQLTypes["ProductFlagOfProductCreateResult"];
	['...on ProductFlagOfProductDeleteResult']: '__union' & GraphQLTypes["ProductFlagOfProductDeleteResult"];
	['...on ProductFlagOfProductUpdateResult']: '__union' & GraphQLTypes["ProductFlagOfProductUpdateResult"];
	['...on ProductFlagOfProductUpsertResult']: '__union' & GraphQLTypes["ProductFlagOfProductUpsertResult"];
	['...on ProductEvaluationCreateResult']: '__union' & GraphQLTypes["ProductEvaluationCreateResult"];
	['...on ProductEvaluationDeleteResult']: '__union' & GraphQLTypes["ProductEvaluationDeleteResult"];
	['...on ProductEvaluationUpdateResult']: '__union' & GraphQLTypes["ProductEvaluationUpdateResult"];
	['...on ProductEvaluationUpsertResult']: '__union' & GraphQLTypes["ProductEvaluationUpsertResult"];
	['...on AdCreateResult']: '__union' & GraphQLTypes["AdCreateResult"];
	['...on AdDeleteResult']: '__union' & GraphQLTypes["AdDeleteResult"];
	['...on AdUpdateResult']: '__union' & GraphQLTypes["AdUpdateResult"];
	['...on AdUpsertResult']: '__union' & GraphQLTypes["AdUpsertResult"];
	['...on EvaluationInfoCreateResult']: '__union' & GraphQLTypes["EvaluationInfoCreateResult"];
	['...on EvaluationInfoDeleteResult']: '__union' & GraphQLTypes["EvaluationInfoDeleteResult"];
	['...on EvaluationInfoUpdateResult']: '__union' & GraphQLTypes["EvaluationInfoUpdateResult"];
	['...on EvaluationInfoUpsertResult']: '__union' & GraphQLTypes["EvaluationInfoUpsertResult"];
	['...on ConsumptionMessageCreateResult']: '__union' & GraphQLTypes["ConsumptionMessageCreateResult"];
	['...on ConsumptionMessageDeleteResult']: '__union' & GraphQLTypes["ConsumptionMessageDeleteResult"];
	['...on ConsumptionMessageUpdateResult']: '__union' & GraphQLTypes["ConsumptionMessageUpdateResult"];
	['...on ConsumptionMessageUpsertResult']: '__union' & GraphQLTypes["ConsumptionMessageUpsertResult"];
	['...on ContentTextCreateResult']: '__union' & GraphQLTypes["ContentTextCreateResult"];
	['...on ContentTextDeleteResult']: '__union' & GraphQLTypes["ContentTextDeleteResult"];
	['...on ContentTextUpdateResult']: '__union' & GraphQLTypes["ContentTextUpdateResult"];
	['...on ContentTextUpsertResult']: '__union' & GraphQLTypes["ContentTextUpsertResult"];
	['...on ContentTextBlockCreateResult']: '__union' & GraphQLTypes["ContentTextBlockCreateResult"];
	['...on ContentTextBlockDeleteResult']: '__union' & GraphQLTypes["ContentTextBlockDeleteResult"];
	['...on ContentTextBlockUpdateResult']: '__union' & GraphQLTypes["ContentTextBlockUpdateResult"];
	['...on ContentTextBlockUpsertResult']: '__union' & GraphQLTypes["ContentTextBlockUpsertResult"];
	['...on ComparatorPageCreateResult']: '__union' & GraphQLTypes["ComparatorPageCreateResult"];
	['...on ComparatorPageDeleteResult']: '__union' & GraphQLTypes["ComparatorPageDeleteResult"];
	['...on ComparatorPageUpdateResult']: '__union' & GraphQLTypes["ComparatorPageUpdateResult"];
	['...on ComparatorPageUpsertResult']: '__union' & GraphQLTypes["ComparatorPageUpsertResult"];
	['...on LoginPageCreateResult']: '__union' & GraphQLTypes["LoginPageCreateResult"];
	['...on LoginPageDeleteResult']: '__union' & GraphQLTypes["LoginPageDeleteResult"];
	['...on LoginPageUpdateResult']: '__union' & GraphQLTypes["LoginPageUpdateResult"];
	['...on LoginPageUpsertResult']: '__union' & GraphQLTypes["LoginPageUpsertResult"];
	['...on RegisterPageCreateResult']: '__union' & GraphQLTypes["RegisterPageCreateResult"];
	['...on RegisterPageDeleteResult']: '__union' & GraphQLTypes["RegisterPageDeleteResult"];
	['...on RegisterPageUpdateResult']: '__union' & GraphQLTypes["RegisterPageUpdateResult"];
	['...on RegisterPageUpsertResult']: '__union' & GraphQLTypes["RegisterPageUpsertResult"];
	['...on ResultsPageCreateResult']: '__union' & GraphQLTypes["ResultsPageCreateResult"];
	['...on ResultsPageDeleteResult']: '__union' & GraphQLTypes["ResultsPageDeleteResult"];
	['...on ResultsPageUpdateResult']: '__union' & GraphQLTypes["ResultsPageUpdateResult"];
	['...on ResultsPageUpsertResult']: '__union' & GraphQLTypes["ResultsPageUpsertResult"];
	['...on SearchPageCreateResult']: '__union' & GraphQLTypes["SearchPageCreateResult"];
	['...on SearchPageDeleteResult']: '__union' & GraphQLTypes["SearchPageDeleteResult"];
	['...on SearchPageUpdateResult']: '__union' & GraphQLTypes["SearchPageUpdateResult"];
	['...on SearchPageUpsertResult']: '__union' & GraphQLTypes["SearchPageUpsertResult"];
	['...on WizardPageCreateResult']: '__union' & GraphQLTypes["WizardPageCreateResult"];
	['...on WizardPageDeleteResult']: '__union' & GraphQLTypes["WizardPageDeleteResult"];
	['...on WizardPageUpdateResult']: '__union' & GraphQLTypes["WizardPageUpdateResult"];
	['...on WizardPageUpsertResult']: '__union' & GraphQLTypes["WizardPageUpsertResult"];
	['...on BreastfeedingCategoryCreateResult']: '__union' & GraphQLTypes["BreastfeedingCategoryCreateResult"];
	['...on BreastfeedingCategoryDeleteResult']: '__union' & GraphQLTypes["BreastfeedingCategoryDeleteResult"];
	['...on BreastfeedingCategoryUpdateResult']: '__union' & GraphQLTypes["BreastfeedingCategoryUpdateResult"];
	['...on BreastfeedingCategoryUpsertResult']: '__union' & GraphQLTypes["BreastfeedingCategoryUpsertResult"];
	['...on DogReproductionCreateResult']: '__union' & GraphQLTypes["DogReproductionCreateResult"];
	['...on DogReproductionDeleteResult']: '__union' & GraphQLTypes["DogReproductionDeleteResult"];
	['...on DogReproductionUpdateResult']: '__union' & GraphQLTypes["DogReproductionUpdateResult"];
	['...on DogReproductionUpsertResult']: '__union' & GraphQLTypes["DogReproductionUpsertResult"];
	['...on ContactFormMessageCreateResult']: '__union' & GraphQLTypes["ContactFormMessageCreateResult"];
	['...on ContactFormMessageDeleteResult']: '__union' & GraphQLTypes["ContactFormMessageDeleteResult"];
	['...on ContactFormMessageUpdateResult']: '__union' & GraphQLTypes["ContactFormMessageUpdateResult"];
	['...on ContactFormMessageUpsertResult']: '__union' & GraphQLTypes["ContactFormMessageUpsertResult"];
	['...on ContactPageCreateResult']: '__union' & GraphQLTypes["ContactPageCreateResult"];
	['...on ContactPageDeleteResult']: '__union' & GraphQLTypes["ContactPageDeleteResult"];
	['...on ContactPageUpdateResult']: '__union' & GraphQLTypes["ContactPageUpdateResult"];
	['...on ContactPageUpsertResult']: '__union' & GraphQLTypes["ContactPageUpsertResult"];
	['...on BugReportCreateResult']: '__union' & GraphQLTypes["BugReportCreateResult"];
	['...on BugReportDeleteResult']: '__union' & GraphQLTypes["BugReportDeleteResult"];
	['...on BugReportUpdateResult']: '__union' & GraphQLTypes["BugReportUpdateResult"];
	['...on BugReportUpsertResult']: '__union' & GraphQLTypes["BugReportUpsertResult"];
	['...on ColorCreateResult']: '__union' & GraphQLTypes["ColorCreateResult"];
	['...on ColorDeleteResult']: '__union' & GraphQLTypes["ColorDeleteResult"];
	['...on ColorUpdateResult']: '__union' & GraphQLTypes["ColorUpdateResult"];
	['...on ColorUpsertResult']: '__union' & GraphQLTypes["ColorUpsertResult"];
	['...on ItemGroupCreateResult']: '__union' & GraphQLTypes["ItemGroupCreateResult"];
	['...on ItemGroupDeleteResult']: '__union' & GraphQLTypes["ItemGroupDeleteResult"];
	['...on ItemGroupUpdateResult']: '__union' & GraphQLTypes["ItemGroupUpdateResult"];
	['...on ItemGroupUpsertResult']: '__union' & GraphQLTypes["ItemGroupUpsertResult"];
	['...on ProductEvaluationSummaryCreateResult']: '__union' & GraphQLTypes["ProductEvaluationSummaryCreateResult"];
	['...on ProductEvaluationSummaryDeleteResult']: '__union' & GraphQLTypes["ProductEvaluationSummaryDeleteResult"];
	['...on ProductEvaluationSummaryUpdateResult']: '__union' & GraphQLTypes["ProductEvaluationSummaryUpdateResult"];
	['...on ProductEvaluationSummaryUpsertResult']: '__union' & GraphQLTypes["ProductEvaluationSummaryUpsertResult"];
	['...on ProtectedActionCreateResult']: '__union' & GraphQLTypes["ProtectedActionCreateResult"];
	['...on ProtectedActionDeleteResult']: '__union' & GraphQLTypes["ProtectedActionDeleteResult"];
	['...on ProtectedActionUpdateResult']: '__union' & GraphQLTypes["ProtectedActionUpdateResult"];
	['...on ProtectedActionUpsertResult']: '__union' & GraphQLTypes["ProtectedActionUpsertResult"];
	['...on BrandAliasCreateResult']: '__union' & GraphQLTypes["BrandAliasCreateResult"];
	['...on BrandAliasDeleteResult']: '__union' & GraphQLTypes["BrandAliasDeleteResult"];
	['...on BrandAliasUpdateResult']: '__union' & GraphQLTypes["BrandAliasUpdateResult"];
	['...on BrandAliasUpsertResult']: '__union' & GraphQLTypes["BrandAliasUpsertResult"];
	['...on ProductAliasCreateResult']: '__union' & GraphQLTypes["ProductAliasCreateResult"];
	['...on ProductAliasDeleteResult']: '__union' & GraphQLTypes["ProductAliasDeleteResult"];
	['...on ProductAliasUpdateResult']: '__union' & GraphQLTypes["ProductAliasUpdateResult"];
	['...on ProductAliasUpsertResult']: '__union' & GraphQLTypes["ProductAliasUpsertResult"];
	['...on ProductLineAliasCreateResult']: '__union' & GraphQLTypes["ProductLineAliasCreateResult"];
	['...on ProductLineAliasDeleteResult']: '__union' & GraphQLTypes["ProductLineAliasDeleteResult"];
	['...on ProductLineAliasUpdateResult']: '__union' & GraphQLTypes["ProductLineAliasUpdateResult"];
	['...on ProductLineAliasUpsertResult']: '__union' & GraphQLTypes["ProductLineAliasUpsertResult"];
	['...on GenericPageCreateResult']: '__union' & GraphQLTypes["GenericPageCreateResult"];
	['...on GenericPageDeleteResult']: '__union' & GraphQLTypes["GenericPageDeleteResult"];
	['...on GenericPageUpdateResult']: '__union' & GraphQLTypes["GenericPageUpdateResult"];
	['...on GenericPageUpsertResult']: '__union' & GraphQLTypes["GenericPageUpsertResult"];
	['...on LinkableCreateResult']: '__union' & GraphQLTypes["LinkableCreateResult"];
	['...on LinkableDeleteResult']: '__union' & GraphQLTypes["LinkableDeleteResult"];
	['...on LinkableUpdateResult']: '__union' & GraphQLTypes["LinkableUpdateResult"];
	['...on LinkableUpsertResult']: '__union' & GraphQLTypes["LinkableUpsertResult"];
	['...on ContentLinksCreateResult']: '__union' & GraphQLTypes["ContentLinksCreateResult"];
	['...on ContentLinksDeleteResult']: '__union' & GraphQLTypes["ContentLinksDeleteResult"];
	['...on ContentLinksUpdateResult']: '__union' & GraphQLTypes["ContentLinksUpdateResult"];
	['...on ContentLinksUpsertResult']: '__union' & GraphQLTypes["ContentLinksUpsertResult"];
	['...on ContentLinksItemCreateResult']: '__union' & GraphQLTypes["ContentLinksItemCreateResult"];
	['...on ContentLinksItemDeleteResult']: '__union' & GraphQLTypes["ContentLinksItemDeleteResult"];
	['...on ContentLinksItemUpdateResult']: '__union' & GraphQLTypes["ContentLinksItemUpdateResult"];
	['...on ContentLinksItemUpsertResult']: '__union' & GraphQLTypes["ContentLinksItemUpsertResult"];
	['...on RedirectCreateResult']: '__union' & GraphQLTypes["RedirectCreateResult"];
	['...on RedirectDeleteResult']: '__union' & GraphQLTypes["RedirectDeleteResult"];
	['...on RedirectUpdateResult']: '__union' & GraphQLTypes["RedirectUpdateResult"];
	['...on RedirectUpsertResult']: '__union' & GraphQLTypes["RedirectUpsertResult"];
	['...on ContentReferenceImageCreateResult']: '__union' & GraphQLTypes["ContentReferenceImageCreateResult"];
	['...on ContentReferenceImageDeleteResult']: '__union' & GraphQLTypes["ContentReferenceImageDeleteResult"];
	['...on ContentReferenceImageUpdateResult']: '__union' & GraphQLTypes["ContentReferenceImageUpdateResult"];
	['...on ContentReferenceImageUpsertResult']: '__union' & GraphQLTypes["ContentReferenceImageUpsertResult"];
	['...on SeoDataCreateResult']: '__union' & GraphQLTypes["SeoDataCreateResult"];
	['...on SeoDataDeleteResult']: '__union' & GraphQLTypes["SeoDataDeleteResult"];
	['...on SeoDataUpdateResult']: '__union' & GraphQLTypes["SeoDataUpdateResult"];
	['...on SeoDataUpsertResult']: '__union' & GraphQLTypes["SeoDataUpsertResult"];
	['...on AgeCategoryCreateResult']: '__union' & GraphQLTypes["AgeCategoryCreateResult"];
	['...on AgeCategoryDeleteResult']: '__union' & GraphQLTypes["AgeCategoryDeleteResult"];
	['...on AgeCategoryUpdateResult']: '__union' & GraphQLTypes["AgeCategoryUpdateResult"];
	['...on AgeCategoryUpsertResult']: '__union' & GraphQLTypes["AgeCategoryUpsertResult"];
	['...on FilterComboCreateResult']: '__union' & GraphQLTypes["FilterComboCreateResult"];
	['...on FilterComboDeleteResult']: '__union' & GraphQLTypes["FilterComboDeleteResult"];
	['...on FilterComboUpdateResult']: '__union' & GraphQLTypes["FilterComboUpdateResult"];
	['...on FilterComboUpsertResult']: '__union' & GraphQLTypes["FilterComboUpsertResult"];
	['...on ImportCacheCreateResult']: '__union' & GraphQLTypes["ImportCacheCreateResult"];
	['...on ImportCacheDeleteResult']: '__union' & GraphQLTypes["ImportCacheDeleteResult"];
	['...on ImportCacheUpdateResult']: '__union' & GraphQLTypes["ImportCacheUpdateResult"];
	['...on ImportCacheUpsertResult']: '__union' & GraphQLTypes["ImportCacheUpsertResult"];
	['...on SiteCreateResult']: '__union' & GraphQLTypes["SiteCreateResult"];
	['...on SiteDeleteResult']: '__union' & GraphQLTypes["SiteDeleteResult"];
	['...on SiteUpdateResult']: '__union' & GraphQLTypes["SiteUpdateResult"];
	['...on SiteUpsertResult']: '__union' & GraphQLTypes["SiteUpsertResult"];
	['...on ContactSubmissionCreateResult']: '__union' & GraphQLTypes["ContactSubmissionCreateResult"];
	['...on ContactSubmissionDeleteResult']: '__union' & GraphQLTypes["ContactSubmissionDeleteResult"];
	['...on ContactSubmissionUpdateResult']: '__union' & GraphQLTypes["ContactSubmissionUpdateResult"];
	['...on ContactSubmissionUpsertResult']: '__union' & GraphQLTypes["ContactSubmissionUpsertResult"];
	['...on TOPXBrandCreateResult']: '__union' & GraphQLTypes["TOPXBrandCreateResult"];
	['...on TOPXBrandDeleteResult']: '__union' & GraphQLTypes["TOPXBrandDeleteResult"];
	['...on TOPXBrandUpdateResult']: '__union' & GraphQLTypes["TOPXBrandUpdateResult"];
	['...on TOPXBrandUpsertResult']: '__union' & GraphQLTypes["TOPXBrandUpsertResult"];
	['...on TOPXBrandCategoryCreateResult']: '__union' & GraphQLTypes["TOPXBrandCategoryCreateResult"];
	['...on TOPXBrandCategoryDeleteResult']: '__union' & GraphQLTypes["TOPXBrandCategoryDeleteResult"];
	['...on TOPXBrandCategoryUpdateResult']: '__union' & GraphQLTypes["TOPXBrandCategoryUpdateResult"];
	['...on TOPXBrandCategoryUpsertResult']: '__union' & GraphQLTypes["TOPXBrandCategoryUpsertResult"];
	['...on TOPXProductCreateResult']: '__union' & GraphQLTypes["TOPXProductCreateResult"];
	['...on TOPXProductDeleteResult']: '__union' & GraphQLTypes["TOPXProductDeleteResult"];
	['...on TOPXProductUpdateResult']: '__union' & GraphQLTypes["TOPXProductUpdateResult"];
	['...on TOPXProductUpsertResult']: '__union' & GraphQLTypes["TOPXProductUpsertResult"];
	['...on TOPXProductCategoryCreateResult']: '__union' & GraphQLTypes["TOPXProductCategoryCreateResult"];
	['...on TOPXProductCategoryDeleteResult']: '__union' & GraphQLTypes["TOPXProductCategoryDeleteResult"];
	['...on TOPXProductCategoryUpdateResult']: '__union' & GraphQLTypes["TOPXProductCategoryUpdateResult"];
	['...on TOPXProductCategoryUpsertResult']: '__union' & GraphQLTypes["TOPXProductCategoryUpsertResult"];
	['...on ContentReferenceListCreateResult']: '__union' & GraphQLTypes["ContentReferenceListCreateResult"];
	['...on ContentReferenceListDeleteResult']: '__union' & GraphQLTypes["ContentReferenceListDeleteResult"];
	['...on ContentReferenceListUpdateResult']: '__union' & GraphQLTypes["ContentReferenceListUpdateResult"];
	['...on ContentReferenceListUpsertResult']: '__union' & GraphQLTypes["ContentReferenceListUpsertResult"];
};
	["_MutationError"]: {
	__typename: "_MutationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<GraphQLTypes["_PathFragment"]>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string
};
	["_MutationErrorType"]: _MutationErrorType;
	["BlogPageDeleteResult"]: {
	__typename: "BlogPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPage"]
};
	["BlogPageUpdateResult"]: {
	__typename: "BlogPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPageUpsertResult"]: {
	__typename: "BlogPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostCreateResult"]: {
	__typename: "BlogPostCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPost"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostDeleteResult"]: {
	__typename: "BlogPostDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPost"]
};
	["BlogPostUpdateResult"]: {
	__typename: "BlogPostUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPost"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostUpsertResult"]: {
	__typename: "BlogPostUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPost"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostTagCreateResult"]: {
	__typename: "BlogPostTagCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostTagDeleteResult"]: {
	__typename: "BlogPostTagDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostTag"]
};
	["BlogPostTagUpdateResult"]: {
	__typename: "BlogPostTagUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostTagUpsertResult"]: {
	__typename: "BlogPostTagUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BodyTagCreateResult"]: {
	__typename: "BodyTagCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BodyTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BodyTagDeleteResult"]: {
	__typename: "BodyTagDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BodyTag"]
};
	["BodyTagUpdateResult"]: {
	__typename: "BodyTagUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BodyTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BodyTagUpsertResult"]: {
	__typename: "BodyTagUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BodyTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BodyTagCategoryCreateResult"]: {
	__typename: "BodyTagCategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BodyTagCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BodyTagCategoryDeleteResult"]: {
	__typename: "BodyTagCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BodyTagCategory"]
};
	["BodyTagCategoryUpdateResult"]: {
	__typename: "BodyTagCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BodyTagCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BodyTagCategoryUpsertResult"]: {
	__typename: "BodyTagCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BodyTagCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
	__typename: "ContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
	__typename: "ContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"]
};
	["ContentUpdateResult"]: {
	__typename: "ContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
	__typename: "ContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
	__typename: "ContentBlockCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
	__typename: "ContentBlockDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
	__typename: "ContentBlockUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
	__typename: "ContentBlockUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
	__typename: "ContentReferenceCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
	__typename: "ContentReferenceDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
	__typename: "ContentReferenceUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
	__typename: "ContentReferenceUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DidYouKnowCreateResult"]: {
	__typename: "DidYouKnowCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DidYouKnow"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DidYouKnowDeleteResult"]: {
	__typename: "DidYouKnowDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DidYouKnow"]
};
	["DidYouKnowUpdateResult"]: {
	__typename: "DidYouKnowUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DidYouKnow"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DidYouKnowUpsertResult"]: {
	__typename: "DidYouKnowUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DidYouKnow"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
	__typename: "ImageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
	__typename: "ImageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"]
};
	["ImageUpdateResult"]: {
	__typename: "ImageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
	__typename: "ImageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumCreateResult"]: {
	__typename: "MediumCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumDeleteResult"]: {
	__typename: "MediumDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"]
};
	["MediumUpdateResult"]: {
	__typename: "MediumUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumUpsertResult"]: {
	__typename: "MediumUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NutritionalValueCreateResult"]: {
	__typename: "NutritionalValueCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionalValue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NutritionalValueDeleteResult"]: {
	__typename: "NutritionalValueDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionalValue"]
};
	["NutritionalValueUpdateResult"]: {
	__typename: "NutritionalValueUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionalValue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NutritionalValueUpsertResult"]: {
	__typename: "NutritionalValueUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionalValue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageCreateResult"]: {
	__typename: "PageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageDeleteResult"]: {
	__typename: "PageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"]
};
	["PageUpdateResult"]: {
	__typename: "PageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageUpsertResult"]: {
	__typename: "PageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReferenceCreateResult"]: {
	__typename: "ReferenceCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Reference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReferenceDeleteResult"]: {
	__typename: "ReferenceDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Reference"]
};
	["ReferenceUpdateResult"]: {
	__typename: "ReferenceUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Reference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReferenceUpsertResult"]: {
	__typename: "ReferenceUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Reference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReferenceListCreateResult"]: {
	__typename: "ReferenceListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReferenceList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReferenceListDeleteResult"]: {
	__typename: "ReferenceListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReferenceList"]
};
	["ReferenceListUpdateResult"]: {
	__typename: "ReferenceListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReferenceList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReferenceListUpsertResult"]: {
	__typename: "ReferenceListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReferenceList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
	__typename: "SeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
	__typename: "SeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"]
};
	["SeoUpdateResult"]: {
	__typename: "SeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
	__typename: "SeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
	__typename: "VideoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
	__typename: "VideoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"]
};
	["VideoUpdateResult"]: {
	__typename: "VideoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
	__typename: "VideoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandCreateResult"]: {
	__typename: "BrandCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Brand"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandDeleteResult"]: {
	__typename: "BrandDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Brand"]
};
	["BrandUpdateResult"]: {
	__typename: "BrandUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Brand"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandUpsertResult"]: {
	__typename: "BrandUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Brand"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandDistributorCreateResult"]: {
	__typename: "BrandDistributorCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandDistributor"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandDistributorDeleteResult"]: {
	__typename: "BrandDistributorDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandDistributor"]
};
	["BrandDistributorUpdateResult"]: {
	__typename: "BrandDistributorUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandDistributor"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandDistributorUpsertResult"]: {
	__typename: "BrandDistributorUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandDistributor"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogSizeCreateResult"]: {
	__typename: "DogSizeCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogSize"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogSizeDeleteResult"]: {
	__typename: "DogSizeDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogSize"]
};
	["DogSizeUpdateResult"]: {
	__typename: "DogSizeUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogSize"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogSizeUpsertResult"]: {
	__typename: "DogSizeUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogSize"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCreateResult"]: {
	__typename: "ProductCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductDeleteResult"]: {
	__typename: "ProductDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"]
};
	["ProductUpdateResult"]: {
	__typename: "ProductUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductUpsertResult"]: {
	__typename: "ProductUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductionMethodCreateResult"]: {
	__typename: "ProductionMethodCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductionMethod"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductionMethodDeleteResult"]: {
	__typename: "ProductionMethodDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductionMethod"]
};
	["ProductionMethodUpdateResult"]: {
	__typename: "ProductionMethodUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductionMethod"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductionMethodUpsertResult"]: {
	__typename: "ProductionMethodUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductionMethod"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductLineCreateResult"]: {
	__typename: "ProductLineCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLine"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductLineDeleteResult"]: {
	__typename: "ProductLineDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLine"]
};
	["ProductLineUpdateResult"]: {
	__typename: "ProductLineUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLine"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductLineUpsertResult"]: {
	__typename: "ProductLineUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLine"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BreedCreateResult"]: {
	__typename: "BreedCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Breed"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BreedDeleteResult"]: {
	__typename: "BreedDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Breed"]
};
	["BreedUpdateResult"]: {
	__typename: "BreedUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Breed"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BreedUpsertResult"]: {
	__typename: "BreedUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Breed"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogCreateResult"]: {
	__typename: "DogCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Dog"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogDeleteResult"]: {
	__typename: "DogDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Dog"]
};
	["DogUpdateResult"]: {
	__typename: "DogUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Dog"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogUpsertResult"]: {
	__typename: "DogUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Dog"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserCreateResult"]: {
	__typename: "UserCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserDeleteResult"]: {
	__typename: "UserDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"]
};
	["UserUpdateResult"]: {
	__typename: "UserUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserUpsertResult"]: {
	__typename: "UserUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VeterinaryCreateResult"]: {
	__typename: "VeterinaryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Veterinary"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VeterinaryDeleteResult"]: {
	__typename: "VeterinaryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Veterinary"]
};
	["VeterinaryUpdateResult"]: {
	__typename: "VeterinaryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Veterinary"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VeterinaryUpsertResult"]: {
	__typename: "VeterinaryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Veterinary"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NutritionalValueOfProductCreateResult"]: {
	__typename: "NutritionalValueOfProductCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionalValueOfProduct"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NutritionalValueOfProductDeleteResult"]: {
	__typename: "NutritionalValueOfProductDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionalValueOfProduct"]
};
	["NutritionalValueOfProductUpdateResult"]: {
	__typename: "NutritionalValueOfProductUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionalValueOfProduct"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NutritionalValueOfProductUpsertResult"]: {
	__typename: "NutritionalValueOfProductUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NutritionalValueOfProduct"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReviewCreateResult"]: {
	__typename: "ReviewCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Review"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReviewDeleteResult"]: {
	__typename: "ReviewDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Review"]
};
	["ReviewUpdateResult"]: {
	__typename: "ReviewUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Review"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReviewUpsertResult"]: {
	__typename: "ReviewUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Review"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogBodyTypeCreateResult"]: {
	__typename: "DogBodyTypeCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogBodyType"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogBodyTypeDeleteResult"]: {
	__typename: "DogBodyTypeDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogBodyType"]
};
	["DogBodyTypeUpdateResult"]: {
	__typename: "DogBodyTypeUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogBodyType"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogBodyTypeUpsertResult"]: {
	__typename: "DogBodyTypeUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogBodyType"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogBodyTypeCategoryCreateResult"]: {
	__typename: "DogBodyTypeCategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogBodyTypeCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogBodyTypeCategoryDeleteResult"]: {
	__typename: "DogBodyTypeCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogBodyTypeCategory"]
};
	["DogBodyTypeCategoryUpdateResult"]: {
	__typename: "DogBodyTypeCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogBodyTypeCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogBodyTypeCategoryUpsertResult"]: {
	__typename: "DogBodyTypeCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogBodyTypeCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
	__typename: "LinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
	__typename: "LinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"]
};
	["LinkUpdateResult"]: {
	__typename: "LinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
	__typename: "LinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UrlCreateResult"]: {
	__typename: "UrlCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Url"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UrlDeleteResult"]: {
	__typename: "UrlDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Url"]
};
	["UrlUpdateResult"]: {
	__typename: "UrlUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Url"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UrlUpsertResult"]: {
	__typename: "UrlUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Url"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
	__typename: "FooterCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
	__typename: "FooterDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"]
};
	["FooterUpdateResult"]: {
	__typename: "FooterUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
	__typename: "FooterUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinkCreateResult"]: {
	__typename: "FooterLinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinkDeleteResult"]: {
	__typename: "FooterLinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLink"]
};
	["FooterLinkUpdateResult"]: {
	__typename: "FooterLinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinkUpsertResult"]: {
	__typename: "FooterLinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandsPageCreateResult"]: {
	__typename: "BrandsPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandsPageDeleteResult"]: {
	__typename: "BrandsPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandsPage"]
};
	["BrandsPageUpdateResult"]: {
	__typename: "BrandsPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandsPageUpsertResult"]: {
	__typename: "BrandsPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageCreateResult"]: {
	__typename: "HomePageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageDeleteResult"]: {
	__typename: "HomePageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"]
};
	["HomePageUpdateResult"]: {
	__typename: "HomePageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageUpsertResult"]: {
	__typename: "HomePageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientsPageCreateResult"]: {
	__typename: "IngredientsPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientsPageDeleteResult"]: {
	__typename: "IngredientsPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientsPage"]
};
	["IngredientsPageUpdateResult"]: {
	__typename: "IngredientsPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["IngredientsPageUpsertResult"]: {
	__typename: "IngredientsPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IngredientsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductReviewCreateResult"]: {
	__typename: "ProductReviewCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductReview"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductReviewDeleteResult"]: {
	__typename: "ProductReviewDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductReview"]
};
	["ProductReviewUpdateResult"]: {
	__typename: "ProductReviewUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductReview"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductReviewUpsertResult"]: {
	__typename: "ProductReviewUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductReview"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ScoreCreateResult"]: {
	__typename: "ScoreCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Score"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ScoreDeleteResult"]: {
	__typename: "ScoreDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Score"]
};
	["ScoreUpdateResult"]: {
	__typename: "ScoreUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Score"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ScoreUpsertResult"]: {
	__typename: "ScoreUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Score"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AgeCreateResult"]: {
	__typename: "AgeCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Age"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AgeDeleteResult"]: {
	__typename: "AgeDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Age"]
};
	["AgeUpdateResult"]: {
	__typename: "AgeUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Age"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AgeUpsertResult"]: {
	__typename: "AgeUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Age"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CountryCreateResult"]: {
	__typename: "CountryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Country"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CountryDeleteResult"]: {
	__typename: "CountryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Country"]
};
	["CountryUpdateResult"]: {
	__typename: "CountryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Country"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CountryUpsertResult"]: {
	__typename: "CountryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Country"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostReviewCreateResult"]: {
	__typename: "BlogPostReviewCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostReview"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostReviewDeleteResult"]: {
	__typename: "BlogPostReviewDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostReview"]
};
	["BlogPostReviewUpdateResult"]: {
	__typename: "BlogPostReviewUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostReview"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostReviewUpsertResult"]: {
	__typename: "BlogPostReviewUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostReview"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogActivityCreateResult"]: {
	__typename: "DogActivityCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogActivity"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogActivityDeleteResult"]: {
	__typename: "DogActivityDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogActivity"]
};
	["DogActivityUpdateResult"]: {
	__typename: "DogActivityUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogActivity"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogActivityUpsertResult"]: {
	__typename: "DogActivityUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogActivity"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialCreateResult"]: {
	__typename: "SocialCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Social"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialDeleteResult"]: {
	__typename: "SocialDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Social"]
};
	["SocialUpdateResult"]: {
	__typename: "SocialUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Social"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialUpsertResult"]: {
	__typename: "SocialUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Social"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceGalleryImageCreateResult"]: {
	__typename: "ContentReferenceGalleryImageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReferenceGalleryImage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceGalleryImageDeleteResult"]: {
	__typename: "ContentReferenceGalleryImageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReferenceGalleryImage"]
};
	["ContentReferenceGalleryImageUpdateResult"]: {
	__typename: "ContentReferenceGalleryImageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReferenceGalleryImage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceGalleryImageUpsertResult"]: {
	__typename: "ContentReferenceGalleryImageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReferenceGalleryImage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemCreateResult"]: {
	__typename: "ItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Item"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemDeleteResult"]: {
	__typename: "ItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Item"]
};
	["ItemUpdateResult"]: {
	__typename: "ItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Item"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemUpsertResult"]: {
	__typename: "ItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Item"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemSubCategoryCreateResult"]: {
	__typename: "ItemSubCategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemSubCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemSubCategoryDeleteResult"]: {
	__typename: "ItemSubCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemSubCategory"]
};
	["ItemSubCategoryUpdateResult"]: {
	__typename: "ItemSubCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemSubCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemSubCategoryUpsertResult"]: {
	__typename: "ItemSubCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemSubCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemCategoryCreateResult"]: {
	__typename: "ItemCategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemCategoryDeleteResult"]: {
	__typename: "ItemCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemCategory"]
};
	["ItemCategoryUpdateResult"]: {
	__typename: "ItemCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemCategoryUpsertResult"]: {
	__typename: "ItemCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemFlavorCategoryCreateResult"]: {
	__typename: "ItemFlavorCategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemFlavorCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemFlavorCategoryDeleteResult"]: {
	__typename: "ItemFlavorCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemFlavorCategory"]
};
	["ItemFlavorCategoryUpdateResult"]: {
	__typename: "ItemFlavorCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemFlavorCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemFlavorCategoryUpsertResult"]: {
	__typename: "ItemFlavorCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemFlavorCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemDeclensionFourthVariantCreateResult"]: {
	__typename: "ItemDeclensionFourthVariantCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemDeclensionFourthVariant"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemDeclensionFourthVariantDeleteResult"]: {
	__typename: "ItemDeclensionFourthVariantDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemDeclensionFourthVariant"]
};
	["ItemDeclensionFourthVariantUpdateResult"]: {
	__typename: "ItemDeclensionFourthVariantUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemDeclensionFourthVariant"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemDeclensionFourthVariantUpsertResult"]: {
	__typename: "ItemDeclensionFourthVariantUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemDeclensionFourthVariant"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemDeclensionSeventhVariantCreateResult"]: {
	__typename: "ItemDeclensionSeventhVariantCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemDeclensionSeventhVariant"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemDeclensionSeventhVariantDeleteResult"]: {
	__typename: "ItemDeclensionSeventhVariantDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemDeclensionSeventhVariant"]
};
	["ItemDeclensionSeventhVariantUpdateResult"]: {
	__typename: "ItemDeclensionSeventhVariantUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemDeclensionSeventhVariant"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemDeclensionSeventhVariantUpsertResult"]: {
	__typename: "ItemDeclensionSeventhVariantUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemDeclensionSeventhVariant"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediaCardCreateResult"]: {
	__typename: "MediaCardCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediaCard"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediaCardDeleteResult"]: {
	__typename: "MediaCardDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediaCard"]
};
	["MediaCardUpdateResult"]: {
	__typename: "MediaCardUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediaCard"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediaCardUpsertResult"]: {
	__typename: "MediaCardUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediaCard"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoCardCreateResult"]: {
	__typename: "InfoCardCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCard"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoCardDeleteResult"]: {
	__typename: "InfoCardDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCard"]
};
	["InfoCardUpdateResult"]: {
	__typename: "InfoCardUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCard"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["InfoCardUpsertResult"]: {
	__typename: "InfoCardUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["InfoCard"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NumberedCardCreateResult"]: {
	__typename: "NumberedCardCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NumberedCard"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NumberedCardDeleteResult"]: {
	__typename: "NumberedCardDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NumberedCard"]
};
	["NumberedCardUpdateResult"]: {
	__typename: "NumberedCardUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NumberedCard"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NumberedCardUpsertResult"]: {
	__typename: "NumberedCardUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NumberedCard"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegisterClaimCreateResult"]: {
	__typename: "RegisterClaimCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RegisterClaim"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegisterClaimDeleteResult"]: {
	__typename: "RegisterClaimDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RegisterClaim"]
};
	["RegisterClaimUpdateResult"]: {
	__typename: "RegisterClaimUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RegisterClaim"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegisterClaimUpsertResult"]: {
	__typename: "RegisterClaimUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RegisterClaim"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostReviewReactionCreateResult"]: {
	__typename: "BlogPostReviewReactionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostReviewReaction"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostReviewReactionDeleteResult"]: {
	__typename: "BlogPostReviewReactionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostReviewReaction"]
};
	["BlogPostReviewReactionUpdateResult"]: {
	__typename: "BlogPostReviewReactionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostReviewReaction"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BlogPostReviewReactionUpsertResult"]: {
	__typename: "BlogPostReviewReactionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BlogPostReviewReaction"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductReviewReactionCreateResult"]: {
	__typename: "ProductReviewReactionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductReviewReaction"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductReviewReactionDeleteResult"]: {
	__typename: "ProductReviewReactionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductReviewReaction"]
};
	["ProductReviewReactionUpdateResult"]: {
	__typename: "ProductReviewReactionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductReviewReaction"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductReviewReactionUpsertResult"]: {
	__typename: "ProductReviewReactionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductReviewReaction"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackageCreateResult"]: {
	__typename: "ProductPackageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPackage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackageDeleteResult"]: {
	__typename: "ProductPackageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPackage"]
};
	["ProductPackageUpdateResult"]: {
	__typename: "ProductPackageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPackage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductPackageUpsertResult"]: {
	__typename: "ProductPackageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductPackage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandManufacturerCreateResult"]: {
	__typename: "BrandManufacturerCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandManufacturer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandManufacturerDeleteResult"]: {
	__typename: "BrandManufacturerDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandManufacturer"]
};
	["BrandManufacturerUpdateResult"]: {
	__typename: "BrandManufacturerUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandManufacturer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandManufacturerUpsertResult"]: {
	__typename: "BrandManufacturerUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandManufacturer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ElementCreateResult"]: {
	__typename: "ElementCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Element"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ElementDeleteResult"]: {
	__typename: "ElementDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Element"]
};
	["ElementUpdateResult"]: {
	__typename: "ElementUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Element"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ElementUpsertResult"]: {
	__typename: "ElementUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Element"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ElementOfProductCreateResult"]: {
	__typename: "ElementOfProductCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ElementOfProduct"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ElementOfProductDeleteResult"]: {
	__typename: "ElementOfProductDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ElementOfProduct"]
};
	["ElementOfProductUpdateResult"]: {
	__typename: "ElementOfProductUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ElementOfProduct"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ElementOfProductUpsertResult"]: {
	__typename: "ElementOfProductUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ElementOfProduct"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuitabilityCategoryCreateResult"]: {
	__typename: "SuitabilityCategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuitabilityCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuitabilityCategoryDeleteResult"]: {
	__typename: "SuitabilityCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuitabilityCategory"]
};
	["SuitabilityCategoryUpdateResult"]: {
	__typename: "SuitabilityCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuitabilityCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuitabilityCategoryUpsertResult"]: {
	__typename: "SuitabilityCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuitabilityCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductFeatureCreateResult"]: {
	__typename: "ProductFeatureCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductFeature"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductFeatureDeleteResult"]: {
	__typename: "ProductFeatureDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductFeature"]
};
	["ProductFeatureUpdateResult"]: {
	__typename: "ProductFeatureUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductFeature"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductFeatureUpsertResult"]: {
	__typename: "ProductFeatureUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductFeature"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuitabilityItemCreateResult"]: {
	__typename: "SuitabilityItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuitabilityItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuitabilityItemDeleteResult"]: {
	__typename: "SuitabilityItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuitabilityItem"]
};
	["SuitabilityItemUpdateResult"]: {
	__typename: "SuitabilityItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuitabilityItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SuitabilityItemUpsertResult"]: {
	__typename: "SuitabilityItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SuitabilityItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegionCreateResult"]: {
	__typename: "RegionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Region"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegionDeleteResult"]: {
	__typename: "RegionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Region"]
};
	["RegionUpdateResult"]: {
	__typename: "RegionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Region"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegionUpsertResult"]: {
	__typename: "RegionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Region"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GranuleSizeCreateResult"]: {
	__typename: "GranuleSizeCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GranuleSize"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GranuleSizeDeleteResult"]: {
	__typename: "GranuleSizeDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GranuleSize"]
};
	["GranuleSizeUpdateResult"]: {
	__typename: "GranuleSizeUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GranuleSize"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GranuleSizeUpsertResult"]: {
	__typename: "GranuleSizeUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GranuleSize"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemAliasCreateResult"]: {
	__typename: "ItemAliasCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemAlias"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemAliasDeleteResult"]: {
	__typename: "ItemAliasDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemAlias"]
};
	["ItemAliasUpdateResult"]: {
	__typename: "ItemAliasUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemAlias"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemAliasUpsertResult"]: {
	__typename: "ItemAliasUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemAlias"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SemanticKeyCreateResult"]: {
	__typename: "SemanticKeyCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SemanticKey"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SemanticKeyDeleteResult"]: {
	__typename: "SemanticKeyDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SemanticKey"]
};
	["SemanticKeyUpdateResult"]: {
	__typename: "SemanticKeyUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SemanticKey"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SemanticKeyUpsertResult"]: {
	__typename: "SemanticKeyUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SemanticKey"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductFlagCreateResult"]: {
	__typename: "ProductFlagCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductFlag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductFlagDeleteResult"]: {
	__typename: "ProductFlagDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductFlag"]
};
	["ProductFlagUpdateResult"]: {
	__typename: "ProductFlagUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductFlag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductFlagUpsertResult"]: {
	__typename: "ProductFlagUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductFlag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductFlagOfProductCreateResult"]: {
	__typename: "ProductFlagOfProductCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductFlagOfProduct"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductFlagOfProductDeleteResult"]: {
	__typename: "ProductFlagOfProductDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductFlagOfProduct"]
};
	["ProductFlagOfProductUpdateResult"]: {
	__typename: "ProductFlagOfProductUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductFlagOfProduct"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductFlagOfProductUpsertResult"]: {
	__typename: "ProductFlagOfProductUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductFlagOfProduct"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductEvaluationCreateResult"]: {
	__typename: "ProductEvaluationCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductEvaluation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductEvaluationDeleteResult"]: {
	__typename: "ProductEvaluationDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductEvaluation"]
};
	["ProductEvaluationUpdateResult"]: {
	__typename: "ProductEvaluationUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductEvaluation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductEvaluationUpsertResult"]: {
	__typename: "ProductEvaluationUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductEvaluation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AdCreateResult"]: {
	__typename: "AdCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Ad"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AdDeleteResult"]: {
	__typename: "AdDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Ad"]
};
	["AdUpdateResult"]: {
	__typename: "AdUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Ad"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AdUpsertResult"]: {
	__typename: "AdUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Ad"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EvaluationInfoCreateResult"]: {
	__typename: "EvaluationInfoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EvaluationInfo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EvaluationInfoDeleteResult"]: {
	__typename: "EvaluationInfoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EvaluationInfo"]
};
	["EvaluationInfoUpdateResult"]: {
	__typename: "EvaluationInfoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EvaluationInfo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EvaluationInfoUpsertResult"]: {
	__typename: "EvaluationInfoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EvaluationInfo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ConsumptionMessageCreateResult"]: {
	__typename: "ConsumptionMessageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ConsumptionMessage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ConsumptionMessageDeleteResult"]: {
	__typename: "ConsumptionMessageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ConsumptionMessage"]
};
	["ConsumptionMessageUpdateResult"]: {
	__typename: "ConsumptionMessageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ConsumptionMessage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ConsumptionMessageUpsertResult"]: {
	__typename: "ConsumptionMessageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ConsumptionMessage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentTextCreateResult"]: {
	__typename: "ContentTextCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentText"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentTextDeleteResult"]: {
	__typename: "ContentTextDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentText"]
};
	["ContentTextUpdateResult"]: {
	__typename: "ContentTextUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentText"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentTextUpsertResult"]: {
	__typename: "ContentTextUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentText"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentTextBlockCreateResult"]: {
	__typename: "ContentTextBlockCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentTextBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentTextBlockDeleteResult"]: {
	__typename: "ContentTextBlockDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentTextBlock"]
};
	["ContentTextBlockUpdateResult"]: {
	__typename: "ContentTextBlockUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentTextBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentTextBlockUpsertResult"]: {
	__typename: "ContentTextBlockUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentTextBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ComparatorPageCreateResult"]: {
	__typename: "ComparatorPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ComparatorPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ComparatorPageDeleteResult"]: {
	__typename: "ComparatorPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ComparatorPage"]
};
	["ComparatorPageUpdateResult"]: {
	__typename: "ComparatorPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ComparatorPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ComparatorPageUpsertResult"]: {
	__typename: "ComparatorPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ComparatorPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LoginPageCreateResult"]: {
	__typename: "LoginPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LoginPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LoginPageDeleteResult"]: {
	__typename: "LoginPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LoginPage"]
};
	["LoginPageUpdateResult"]: {
	__typename: "LoginPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LoginPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LoginPageUpsertResult"]: {
	__typename: "LoginPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LoginPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegisterPageCreateResult"]: {
	__typename: "RegisterPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RegisterPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegisterPageDeleteResult"]: {
	__typename: "RegisterPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RegisterPage"]
};
	["RegisterPageUpdateResult"]: {
	__typename: "RegisterPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RegisterPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RegisterPageUpsertResult"]: {
	__typename: "RegisterPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RegisterPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ResultsPageCreateResult"]: {
	__typename: "ResultsPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ResultsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ResultsPageDeleteResult"]: {
	__typename: "ResultsPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ResultsPage"]
};
	["ResultsPageUpdateResult"]: {
	__typename: "ResultsPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ResultsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ResultsPageUpsertResult"]: {
	__typename: "ResultsPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ResultsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SearchPageCreateResult"]: {
	__typename: "SearchPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SearchPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SearchPageDeleteResult"]: {
	__typename: "SearchPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SearchPage"]
};
	["SearchPageUpdateResult"]: {
	__typename: "SearchPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SearchPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SearchPageUpsertResult"]: {
	__typename: "SearchPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SearchPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["WizardPageCreateResult"]: {
	__typename: "WizardPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WizardPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["WizardPageDeleteResult"]: {
	__typename: "WizardPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WizardPage"]
};
	["WizardPageUpdateResult"]: {
	__typename: "WizardPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WizardPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["WizardPageUpsertResult"]: {
	__typename: "WizardPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["WizardPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BreastfeedingCategoryCreateResult"]: {
	__typename: "BreastfeedingCategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BreastfeedingCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BreastfeedingCategoryDeleteResult"]: {
	__typename: "BreastfeedingCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BreastfeedingCategory"]
};
	["BreastfeedingCategoryUpdateResult"]: {
	__typename: "BreastfeedingCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BreastfeedingCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BreastfeedingCategoryUpsertResult"]: {
	__typename: "BreastfeedingCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BreastfeedingCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogReproductionCreateResult"]: {
	__typename: "DogReproductionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogReproduction"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogReproductionDeleteResult"]: {
	__typename: "DogReproductionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogReproduction"]
};
	["DogReproductionUpdateResult"]: {
	__typename: "DogReproductionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogReproduction"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DogReproductionUpsertResult"]: {
	__typename: "DogReproductionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DogReproduction"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactFormMessageCreateResult"]: {
	__typename: "ContactFormMessageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactFormMessage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactFormMessageDeleteResult"]: {
	__typename: "ContactFormMessageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactFormMessage"]
};
	["ContactFormMessageUpdateResult"]: {
	__typename: "ContactFormMessageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactFormMessage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactFormMessageUpsertResult"]: {
	__typename: "ContactFormMessageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactFormMessage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactPageCreateResult"]: {
	__typename: "ContactPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactPageDeleteResult"]: {
	__typename: "ContactPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactPage"]
};
	["ContactPageUpdateResult"]: {
	__typename: "ContactPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactPageUpsertResult"]: {
	__typename: "ContactPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BugReportCreateResult"]: {
	__typename: "BugReportCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BugReport"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BugReportDeleteResult"]: {
	__typename: "BugReportDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BugReport"]
};
	["BugReportUpdateResult"]: {
	__typename: "BugReportUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BugReport"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BugReportUpsertResult"]: {
	__typename: "BugReportUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BugReport"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ColorCreateResult"]: {
	__typename: "ColorCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Color"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ColorDeleteResult"]: {
	__typename: "ColorDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Color"]
};
	["ColorUpdateResult"]: {
	__typename: "ColorUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Color"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ColorUpsertResult"]: {
	__typename: "ColorUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Color"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemGroupCreateResult"]: {
	__typename: "ItemGroupCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemGroupDeleteResult"]: {
	__typename: "ItemGroupDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemGroup"]
};
	["ItemGroupUpdateResult"]: {
	__typename: "ItemGroupUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ItemGroupUpsertResult"]: {
	__typename: "ItemGroupUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ItemGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductEvaluationSummaryCreateResult"]: {
	__typename: "ProductEvaluationSummaryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductEvaluationSummary"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductEvaluationSummaryDeleteResult"]: {
	__typename: "ProductEvaluationSummaryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductEvaluationSummary"]
};
	["ProductEvaluationSummaryUpdateResult"]: {
	__typename: "ProductEvaluationSummaryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductEvaluationSummary"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductEvaluationSummaryUpsertResult"]: {
	__typename: "ProductEvaluationSummaryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductEvaluationSummary"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedActionCreateResult"]: {
	__typename: "ProtectedActionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedAction"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedActionDeleteResult"]: {
	__typename: "ProtectedActionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedAction"]
};
	["ProtectedActionUpdateResult"]: {
	__typename: "ProtectedActionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedAction"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProtectedActionUpsertResult"]: {
	__typename: "ProtectedActionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProtectedAction"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandAliasCreateResult"]: {
	__typename: "BrandAliasCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandAlias"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandAliasDeleteResult"]: {
	__typename: "BrandAliasDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandAlias"]
};
	["BrandAliasUpdateResult"]: {
	__typename: "BrandAliasUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandAlias"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BrandAliasUpsertResult"]: {
	__typename: "BrandAliasUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BrandAlias"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductAliasCreateResult"]: {
	__typename: "ProductAliasCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductAlias"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductAliasDeleteResult"]: {
	__typename: "ProductAliasDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductAlias"]
};
	["ProductAliasUpdateResult"]: {
	__typename: "ProductAliasUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductAlias"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductAliasUpsertResult"]: {
	__typename: "ProductAliasUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductAlias"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductLineAliasCreateResult"]: {
	__typename: "ProductLineAliasCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLineAlias"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductLineAliasDeleteResult"]: {
	__typename: "ProductLineAliasDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLineAlias"]
};
	["ProductLineAliasUpdateResult"]: {
	__typename: "ProductLineAliasUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLineAlias"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductLineAliasUpsertResult"]: {
	__typename: "ProductLineAliasUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ProductLineAlias"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageCreateResult"]: {
	__typename: "GenericPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageDeleteResult"]: {
	__typename: "GenericPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"]
};
	["GenericPageUpdateResult"]: {
	__typename: "GenericPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GenericPageUpsertResult"]: {
	__typename: "GenericPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GenericPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
	__typename: "LinkableCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
	__typename: "LinkableDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
	__typename: "LinkableUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
	__typename: "LinkableUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentLinksCreateResult"]: {
	__typename: "ContentLinksCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentLinks"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentLinksDeleteResult"]: {
	__typename: "ContentLinksDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentLinks"]
};
	["ContentLinksUpdateResult"]: {
	__typename: "ContentLinksUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentLinks"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentLinksUpsertResult"]: {
	__typename: "ContentLinksUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentLinks"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentLinksItemCreateResult"]: {
	__typename: "ContentLinksItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentLinksItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentLinksItemDeleteResult"]: {
	__typename: "ContentLinksItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentLinksItem"]
};
	["ContentLinksItemUpdateResult"]: {
	__typename: "ContentLinksItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentLinksItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentLinksItemUpsertResult"]: {
	__typename: "ContentLinksItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentLinksItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
	__typename: "RedirectCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
	__typename: "RedirectDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"]
};
	["RedirectUpdateResult"]: {
	__typename: "RedirectUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
	__typename: "RedirectUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceImageCreateResult"]: {
	__typename: "ContentReferenceImageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReferenceImage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceImageDeleteResult"]: {
	__typename: "ContentReferenceImageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReferenceImage"]
};
	["ContentReferenceImageUpdateResult"]: {
	__typename: "ContentReferenceImageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReferenceImage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceImageUpsertResult"]: {
	__typename: "ContentReferenceImageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReferenceImage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDataCreateResult"]: {
	__typename: "SeoDataCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoData"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDataDeleteResult"]: {
	__typename: "SeoDataDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoData"]
};
	["SeoDataUpdateResult"]: {
	__typename: "SeoDataUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoData"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDataUpsertResult"]: {
	__typename: "SeoDataUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoData"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AgeCategoryCreateResult"]: {
	__typename: "AgeCategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AgeCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AgeCategoryDeleteResult"]: {
	__typename: "AgeCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AgeCategory"]
};
	["AgeCategoryUpdateResult"]: {
	__typename: "AgeCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AgeCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AgeCategoryUpsertResult"]: {
	__typename: "AgeCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AgeCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilterComboCreateResult"]: {
	__typename: "FilterComboCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilterCombo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilterComboDeleteResult"]: {
	__typename: "FilterComboDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilterCombo"]
};
	["FilterComboUpdateResult"]: {
	__typename: "FilterComboUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilterCombo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FilterComboUpsertResult"]: {
	__typename: "FilterComboUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FilterCombo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImportCacheCreateResult"]: {
	__typename: "ImportCacheCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImportCache"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImportCacheDeleteResult"]: {
	__typename: "ImportCacheDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImportCache"]
};
	["ImportCacheUpdateResult"]: {
	__typename: "ImportCacheUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImportCache"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImportCacheUpsertResult"]: {
	__typename: "ImportCacheUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImportCache"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteCreateResult"]: {
	__typename: "SiteCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Site"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteDeleteResult"]: {
	__typename: "SiteDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Site"]
};
	["SiteUpdateResult"]: {
	__typename: "SiteUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Site"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SiteUpsertResult"]: {
	__typename: "SiteUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Site"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactSubmissionCreateResult"]: {
	__typename: "ContactSubmissionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactSubmission"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactSubmissionDeleteResult"]: {
	__typename: "ContactSubmissionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactSubmission"]
};
	["ContactSubmissionUpdateResult"]: {
	__typename: "ContactSubmissionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactSubmission"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactSubmissionUpsertResult"]: {
	__typename: "ContactSubmissionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactSubmission"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TOPXBrandCreateResult"]: {
	__typename: "TOPXBrandCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXBrand"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TOPXBrandDeleteResult"]: {
	__typename: "TOPXBrandDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXBrand"]
};
	["TOPXBrandUpdateResult"]: {
	__typename: "TOPXBrandUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXBrand"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TOPXBrandUpsertResult"]: {
	__typename: "TOPXBrandUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXBrand"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TOPXBrandCategoryCreateResult"]: {
	__typename: "TOPXBrandCategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXBrandCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TOPXBrandCategoryDeleteResult"]: {
	__typename: "TOPXBrandCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXBrandCategory"]
};
	["TOPXBrandCategoryUpdateResult"]: {
	__typename: "TOPXBrandCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXBrandCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TOPXBrandCategoryUpsertResult"]: {
	__typename: "TOPXBrandCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXBrandCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TOPXProductCreateResult"]: {
	__typename: "TOPXProductCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXProduct"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TOPXProductDeleteResult"]: {
	__typename: "TOPXProductDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXProduct"]
};
	["TOPXProductUpdateResult"]: {
	__typename: "TOPXProductUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXProduct"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TOPXProductUpsertResult"]: {
	__typename: "TOPXProductUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXProduct"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TOPXProductCategoryCreateResult"]: {
	__typename: "TOPXProductCategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXProductCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TOPXProductCategoryDeleteResult"]: {
	__typename: "TOPXProductCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXProductCategory"]
};
	["TOPXProductCategoryUpdateResult"]: {
	__typename: "TOPXProductCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXProductCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TOPXProductCategoryUpsertResult"]: {
	__typename: "TOPXProductCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TOPXProductCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceListCreateResult"]: {
	__typename: "ContentReferenceListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReferenceList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceListDeleteResult"]: {
	__typename: "ContentReferenceListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReferenceList"]
};
	["ContentReferenceListUpdateResult"]: {
	__typename: "ContentReferenceListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReferenceList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceListUpsertResult"]: {
	__typename: "ContentReferenceListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReferenceList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
	__typename: "MutationTransaction",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"],
	createBlogPage: GraphQLTypes["BlogPageCreateResult"],
	deleteBlogPage: GraphQLTypes["BlogPageDeleteResult"],
	updateBlogPage: GraphQLTypes["BlogPageUpdateResult"],
	upsertBlogPage: GraphQLTypes["BlogPageUpsertResult"],
	createBlogPost: GraphQLTypes["BlogPostCreateResult"],
	deleteBlogPost: GraphQLTypes["BlogPostDeleteResult"],
	updateBlogPost: GraphQLTypes["BlogPostUpdateResult"],
	upsertBlogPost: GraphQLTypes["BlogPostUpsertResult"],
	createBlogPostTag: GraphQLTypes["BlogPostTagCreateResult"],
	deleteBlogPostTag: GraphQLTypes["BlogPostTagDeleteResult"],
	updateBlogPostTag: GraphQLTypes["BlogPostTagUpdateResult"],
	upsertBlogPostTag: GraphQLTypes["BlogPostTagUpsertResult"],
	createBodyTag: GraphQLTypes["BodyTagCreateResult"],
	deleteBodyTag: GraphQLTypes["BodyTagDeleteResult"],
	updateBodyTag: GraphQLTypes["BodyTagUpdateResult"],
	upsertBodyTag: GraphQLTypes["BodyTagUpsertResult"],
	createBodyTagCategory: GraphQLTypes["BodyTagCategoryCreateResult"],
	deleteBodyTagCategory: GraphQLTypes["BodyTagCategoryDeleteResult"],
	updateBodyTagCategory: GraphQLTypes["BodyTagCategoryUpdateResult"],
	upsertBodyTagCategory: GraphQLTypes["BodyTagCategoryUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createDidYouKnow: GraphQLTypes["DidYouKnowCreateResult"],
	deleteDidYouKnow: GraphQLTypes["DidYouKnowDeleteResult"],
	updateDidYouKnow: GraphQLTypes["DidYouKnowUpdateResult"],
	upsertDidYouKnow: GraphQLTypes["DidYouKnowUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createNutritionalValue: GraphQLTypes["NutritionalValueCreateResult"],
	deleteNutritionalValue: GraphQLTypes["NutritionalValueDeleteResult"],
	updateNutritionalValue: GraphQLTypes["NutritionalValueUpdateResult"],
	upsertNutritionalValue: GraphQLTypes["NutritionalValueUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	createReference: GraphQLTypes["ReferenceCreateResult"],
	deleteReference: GraphQLTypes["ReferenceDeleteResult"],
	updateReference: GraphQLTypes["ReferenceUpdateResult"],
	upsertReference: GraphQLTypes["ReferenceUpsertResult"],
	createReferenceList: GraphQLTypes["ReferenceListCreateResult"],
	deleteReferenceList: GraphQLTypes["ReferenceListDeleteResult"],
	updateReferenceList: GraphQLTypes["ReferenceListUpdateResult"],
	upsertReferenceList: GraphQLTypes["ReferenceListUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createBrand: GraphQLTypes["BrandCreateResult"],
	deleteBrand: GraphQLTypes["BrandDeleteResult"],
	updateBrand: GraphQLTypes["BrandUpdateResult"],
	upsertBrand: GraphQLTypes["BrandUpsertResult"],
	createBrandDistributor: GraphQLTypes["BrandDistributorCreateResult"],
	deleteBrandDistributor: GraphQLTypes["BrandDistributorDeleteResult"],
	updateBrandDistributor: GraphQLTypes["BrandDistributorUpdateResult"],
	upsertBrandDistributor: GraphQLTypes["BrandDistributorUpsertResult"],
	createDogSize: GraphQLTypes["DogSizeCreateResult"],
	deleteDogSize: GraphQLTypes["DogSizeDeleteResult"],
	updateDogSize: GraphQLTypes["DogSizeUpdateResult"],
	upsertDogSize: GraphQLTypes["DogSizeUpsertResult"],
	createProduct: GraphQLTypes["ProductCreateResult"],
	deleteProduct: GraphQLTypes["ProductDeleteResult"],
	updateProduct: GraphQLTypes["ProductUpdateResult"],
	upsertProduct: GraphQLTypes["ProductUpsertResult"],
	createProductionMethod: GraphQLTypes["ProductionMethodCreateResult"],
	deleteProductionMethod: GraphQLTypes["ProductionMethodDeleteResult"],
	updateProductionMethod: GraphQLTypes["ProductionMethodUpdateResult"],
	upsertProductionMethod: GraphQLTypes["ProductionMethodUpsertResult"],
	createProductLine: GraphQLTypes["ProductLineCreateResult"],
	deleteProductLine: GraphQLTypes["ProductLineDeleteResult"],
	updateProductLine: GraphQLTypes["ProductLineUpdateResult"],
	upsertProductLine: GraphQLTypes["ProductLineUpsertResult"],
	createBreed: GraphQLTypes["BreedCreateResult"],
	deleteBreed: GraphQLTypes["BreedDeleteResult"],
	updateBreed: GraphQLTypes["BreedUpdateResult"],
	upsertBreed: GraphQLTypes["BreedUpsertResult"],
	createDog: GraphQLTypes["DogCreateResult"],
	deleteDog: GraphQLTypes["DogDeleteResult"],
	updateDog: GraphQLTypes["DogUpdateResult"],
	upsertDog: GraphQLTypes["DogUpsertResult"],
	createUser: GraphQLTypes["UserCreateResult"],
	deleteUser: GraphQLTypes["UserDeleteResult"],
	updateUser: GraphQLTypes["UserUpdateResult"],
	upsertUser: GraphQLTypes["UserUpsertResult"],
	createVeterinary: GraphQLTypes["VeterinaryCreateResult"],
	deleteVeterinary: GraphQLTypes["VeterinaryDeleteResult"],
	updateVeterinary: GraphQLTypes["VeterinaryUpdateResult"],
	upsertVeterinary: GraphQLTypes["VeterinaryUpsertResult"],
	createNutritionalValueOfProduct: GraphQLTypes["NutritionalValueOfProductCreateResult"],
	deleteNutritionalValueOfProduct: GraphQLTypes["NutritionalValueOfProductDeleteResult"],
	updateNutritionalValueOfProduct: GraphQLTypes["NutritionalValueOfProductUpdateResult"],
	upsertNutritionalValueOfProduct: GraphQLTypes["NutritionalValueOfProductUpsertResult"],
	createReview: GraphQLTypes["ReviewCreateResult"],
	deleteReview: GraphQLTypes["ReviewDeleteResult"],
	updateReview: GraphQLTypes["ReviewUpdateResult"],
	upsertReview: GraphQLTypes["ReviewUpsertResult"],
	createDogBodyType: GraphQLTypes["DogBodyTypeCreateResult"],
	deleteDogBodyType: GraphQLTypes["DogBodyTypeDeleteResult"],
	updateDogBodyType: GraphQLTypes["DogBodyTypeUpdateResult"],
	upsertDogBodyType: GraphQLTypes["DogBodyTypeUpsertResult"],
	createDogBodyTypeCategory: GraphQLTypes["DogBodyTypeCategoryCreateResult"],
	deleteDogBodyTypeCategory: GraphQLTypes["DogBodyTypeCategoryDeleteResult"],
	updateDogBodyTypeCategory: GraphQLTypes["DogBodyTypeCategoryUpdateResult"],
	upsertDogBodyTypeCategory: GraphQLTypes["DogBodyTypeCategoryUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createUrl: GraphQLTypes["UrlCreateResult"],
	deleteUrl: GraphQLTypes["UrlDeleteResult"],
	updateUrl: GraphQLTypes["UrlUpdateResult"],
	upsertUrl: GraphQLTypes["UrlUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createFooterLink: GraphQLTypes["FooterLinkCreateResult"],
	deleteFooterLink: GraphQLTypes["FooterLinkDeleteResult"],
	updateFooterLink: GraphQLTypes["FooterLinkUpdateResult"],
	upsertFooterLink: GraphQLTypes["FooterLinkUpsertResult"],
	createBrandsPage: GraphQLTypes["BrandsPageCreateResult"],
	deleteBrandsPage: GraphQLTypes["BrandsPageDeleteResult"],
	updateBrandsPage: GraphQLTypes["BrandsPageUpdateResult"],
	upsertBrandsPage: GraphQLTypes["BrandsPageUpsertResult"],
	createHomePage: GraphQLTypes["HomePageCreateResult"],
	deleteHomePage: GraphQLTypes["HomePageDeleteResult"],
	updateHomePage: GraphQLTypes["HomePageUpdateResult"],
	upsertHomePage: GraphQLTypes["HomePageUpsertResult"],
	createIngredientsPage: GraphQLTypes["IngredientsPageCreateResult"],
	deleteIngredientsPage: GraphQLTypes["IngredientsPageDeleteResult"],
	updateIngredientsPage: GraphQLTypes["IngredientsPageUpdateResult"],
	upsertIngredientsPage: GraphQLTypes["IngredientsPageUpsertResult"],
	createProductReview: GraphQLTypes["ProductReviewCreateResult"],
	deleteProductReview: GraphQLTypes["ProductReviewDeleteResult"],
	updateProductReview: GraphQLTypes["ProductReviewUpdateResult"],
	upsertProductReview: GraphQLTypes["ProductReviewUpsertResult"],
	createScore: GraphQLTypes["ScoreCreateResult"],
	deleteScore: GraphQLTypes["ScoreDeleteResult"],
	updateScore: GraphQLTypes["ScoreUpdateResult"],
	upsertScore: GraphQLTypes["ScoreUpsertResult"],
	createAge: GraphQLTypes["AgeCreateResult"],
	deleteAge: GraphQLTypes["AgeDeleteResult"],
	updateAge: GraphQLTypes["AgeUpdateResult"],
	upsertAge: GraphQLTypes["AgeUpsertResult"],
	createCountry: GraphQLTypes["CountryCreateResult"],
	deleteCountry: GraphQLTypes["CountryDeleteResult"],
	updateCountry: GraphQLTypes["CountryUpdateResult"],
	upsertCountry: GraphQLTypes["CountryUpsertResult"],
	createBlogPostReview: GraphQLTypes["BlogPostReviewCreateResult"],
	deleteBlogPostReview: GraphQLTypes["BlogPostReviewDeleteResult"],
	updateBlogPostReview: GraphQLTypes["BlogPostReviewUpdateResult"],
	upsertBlogPostReview: GraphQLTypes["BlogPostReviewUpsertResult"],
	createDogActivity: GraphQLTypes["DogActivityCreateResult"],
	deleteDogActivity: GraphQLTypes["DogActivityDeleteResult"],
	updateDogActivity: GraphQLTypes["DogActivityUpdateResult"],
	upsertDogActivity: GraphQLTypes["DogActivityUpsertResult"],
	createSocial: GraphQLTypes["SocialCreateResult"],
	deleteSocial: GraphQLTypes["SocialDeleteResult"],
	updateSocial: GraphQLTypes["SocialUpdateResult"],
	upsertSocial: GraphQLTypes["SocialUpsertResult"],
	createContentReferenceGalleryImage: GraphQLTypes["ContentReferenceGalleryImageCreateResult"],
	deleteContentReferenceGalleryImage: GraphQLTypes["ContentReferenceGalleryImageDeleteResult"],
	updateContentReferenceGalleryImage: GraphQLTypes["ContentReferenceGalleryImageUpdateResult"],
	upsertContentReferenceGalleryImage: GraphQLTypes["ContentReferenceGalleryImageUpsertResult"],
	createItem: GraphQLTypes["ItemCreateResult"],
	deleteItem: GraphQLTypes["ItemDeleteResult"],
	updateItem: GraphQLTypes["ItemUpdateResult"],
	upsertItem: GraphQLTypes["ItemUpsertResult"],
	createItemSubCategory: GraphQLTypes["ItemSubCategoryCreateResult"],
	deleteItemSubCategory: GraphQLTypes["ItemSubCategoryDeleteResult"],
	updateItemSubCategory: GraphQLTypes["ItemSubCategoryUpdateResult"],
	upsertItemSubCategory: GraphQLTypes["ItemSubCategoryUpsertResult"],
	createItemCategory: GraphQLTypes["ItemCategoryCreateResult"],
	deleteItemCategory: GraphQLTypes["ItemCategoryDeleteResult"],
	updateItemCategory: GraphQLTypes["ItemCategoryUpdateResult"],
	upsertItemCategory: GraphQLTypes["ItemCategoryUpsertResult"],
	createItemFlavorCategory: GraphQLTypes["ItemFlavorCategoryCreateResult"],
	deleteItemFlavorCategory: GraphQLTypes["ItemFlavorCategoryDeleteResult"],
	updateItemFlavorCategory: GraphQLTypes["ItemFlavorCategoryUpdateResult"],
	upsertItemFlavorCategory: GraphQLTypes["ItemFlavorCategoryUpsertResult"],
	createItemDeclensionFourthVariant: GraphQLTypes["ItemDeclensionFourthVariantCreateResult"],
	deleteItemDeclensionFourthVariant: GraphQLTypes["ItemDeclensionFourthVariantDeleteResult"],
	updateItemDeclensionFourthVariant: GraphQLTypes["ItemDeclensionFourthVariantUpdateResult"],
	upsertItemDeclensionFourthVariant: GraphQLTypes["ItemDeclensionFourthVariantUpsertResult"],
	createItemDeclensionSeventhVariant: GraphQLTypes["ItemDeclensionSeventhVariantCreateResult"],
	deleteItemDeclensionSeventhVariant: GraphQLTypes["ItemDeclensionSeventhVariantDeleteResult"],
	updateItemDeclensionSeventhVariant: GraphQLTypes["ItemDeclensionSeventhVariantUpdateResult"],
	upsertItemDeclensionSeventhVariant: GraphQLTypes["ItemDeclensionSeventhVariantUpsertResult"],
	createMediaCard: GraphQLTypes["MediaCardCreateResult"],
	deleteMediaCard: GraphQLTypes["MediaCardDeleteResult"],
	updateMediaCard: GraphQLTypes["MediaCardUpdateResult"],
	upsertMediaCard: GraphQLTypes["MediaCardUpsertResult"],
	createInfoCard: GraphQLTypes["InfoCardCreateResult"],
	deleteInfoCard: GraphQLTypes["InfoCardDeleteResult"],
	updateInfoCard: GraphQLTypes["InfoCardUpdateResult"],
	upsertInfoCard: GraphQLTypes["InfoCardUpsertResult"],
	createNumberedCard: GraphQLTypes["NumberedCardCreateResult"],
	deleteNumberedCard: GraphQLTypes["NumberedCardDeleteResult"],
	updateNumberedCard: GraphQLTypes["NumberedCardUpdateResult"],
	upsertNumberedCard: GraphQLTypes["NumberedCardUpsertResult"],
	createRegisterClaim: GraphQLTypes["RegisterClaimCreateResult"],
	deleteRegisterClaim: GraphQLTypes["RegisterClaimDeleteResult"],
	updateRegisterClaim: GraphQLTypes["RegisterClaimUpdateResult"],
	upsertRegisterClaim: GraphQLTypes["RegisterClaimUpsertResult"],
	createBlogPostReviewReaction: GraphQLTypes["BlogPostReviewReactionCreateResult"],
	deleteBlogPostReviewReaction: GraphQLTypes["BlogPostReviewReactionDeleteResult"],
	updateBlogPostReviewReaction: GraphQLTypes["BlogPostReviewReactionUpdateResult"],
	upsertBlogPostReviewReaction: GraphQLTypes["BlogPostReviewReactionUpsertResult"],
	createProductReviewReaction: GraphQLTypes["ProductReviewReactionCreateResult"],
	deleteProductReviewReaction: GraphQLTypes["ProductReviewReactionDeleteResult"],
	updateProductReviewReaction: GraphQLTypes["ProductReviewReactionUpdateResult"],
	upsertProductReviewReaction: GraphQLTypes["ProductReviewReactionUpsertResult"],
	createProductPackage: GraphQLTypes["ProductPackageCreateResult"],
	deleteProductPackage: GraphQLTypes["ProductPackageDeleteResult"],
	updateProductPackage: GraphQLTypes["ProductPackageUpdateResult"],
	upsertProductPackage: GraphQLTypes["ProductPackageUpsertResult"],
	createBrandManufacturer: GraphQLTypes["BrandManufacturerCreateResult"],
	deleteBrandManufacturer: GraphQLTypes["BrandManufacturerDeleteResult"],
	updateBrandManufacturer: GraphQLTypes["BrandManufacturerUpdateResult"],
	upsertBrandManufacturer: GraphQLTypes["BrandManufacturerUpsertResult"],
	createElement: GraphQLTypes["ElementCreateResult"],
	deleteElement: GraphQLTypes["ElementDeleteResult"],
	updateElement: GraphQLTypes["ElementUpdateResult"],
	upsertElement: GraphQLTypes["ElementUpsertResult"],
	createElementOfProduct: GraphQLTypes["ElementOfProductCreateResult"],
	deleteElementOfProduct: GraphQLTypes["ElementOfProductDeleteResult"],
	updateElementOfProduct: GraphQLTypes["ElementOfProductUpdateResult"],
	upsertElementOfProduct: GraphQLTypes["ElementOfProductUpsertResult"],
	createSuitabilityCategory: GraphQLTypes["SuitabilityCategoryCreateResult"],
	deleteSuitabilityCategory: GraphQLTypes["SuitabilityCategoryDeleteResult"],
	updateSuitabilityCategory: GraphQLTypes["SuitabilityCategoryUpdateResult"],
	upsertSuitabilityCategory: GraphQLTypes["SuitabilityCategoryUpsertResult"],
	createProductFeature: GraphQLTypes["ProductFeatureCreateResult"],
	deleteProductFeature: GraphQLTypes["ProductFeatureDeleteResult"],
	updateProductFeature: GraphQLTypes["ProductFeatureUpdateResult"],
	upsertProductFeature: GraphQLTypes["ProductFeatureUpsertResult"],
	createSuitabilityItem: GraphQLTypes["SuitabilityItemCreateResult"],
	deleteSuitabilityItem: GraphQLTypes["SuitabilityItemDeleteResult"],
	updateSuitabilityItem: GraphQLTypes["SuitabilityItemUpdateResult"],
	upsertSuitabilityItem: GraphQLTypes["SuitabilityItemUpsertResult"],
	createRegion: GraphQLTypes["RegionCreateResult"],
	deleteRegion: GraphQLTypes["RegionDeleteResult"],
	updateRegion: GraphQLTypes["RegionUpdateResult"],
	upsertRegion: GraphQLTypes["RegionUpsertResult"],
	createGranuleSize: GraphQLTypes["GranuleSizeCreateResult"],
	deleteGranuleSize: GraphQLTypes["GranuleSizeDeleteResult"],
	updateGranuleSize: GraphQLTypes["GranuleSizeUpdateResult"],
	upsertGranuleSize: GraphQLTypes["GranuleSizeUpsertResult"],
	createItemAlias: GraphQLTypes["ItemAliasCreateResult"],
	deleteItemAlias: GraphQLTypes["ItemAliasDeleteResult"],
	updateItemAlias: GraphQLTypes["ItemAliasUpdateResult"],
	upsertItemAlias: GraphQLTypes["ItemAliasUpsertResult"],
	createSemanticKey: GraphQLTypes["SemanticKeyCreateResult"],
	deleteSemanticKey: GraphQLTypes["SemanticKeyDeleteResult"],
	updateSemanticKey: GraphQLTypes["SemanticKeyUpdateResult"],
	upsertSemanticKey: GraphQLTypes["SemanticKeyUpsertResult"],
	createProductFlag: GraphQLTypes["ProductFlagCreateResult"],
	deleteProductFlag: GraphQLTypes["ProductFlagDeleteResult"],
	updateProductFlag: GraphQLTypes["ProductFlagUpdateResult"],
	upsertProductFlag: GraphQLTypes["ProductFlagUpsertResult"],
	createProductFlagOfProduct: GraphQLTypes["ProductFlagOfProductCreateResult"],
	deleteProductFlagOfProduct: GraphQLTypes["ProductFlagOfProductDeleteResult"],
	updateProductFlagOfProduct: GraphQLTypes["ProductFlagOfProductUpdateResult"],
	upsertProductFlagOfProduct: GraphQLTypes["ProductFlagOfProductUpsertResult"],
	createProductEvaluation: GraphQLTypes["ProductEvaluationCreateResult"],
	deleteProductEvaluation: GraphQLTypes["ProductEvaluationDeleteResult"],
	updateProductEvaluation: GraphQLTypes["ProductEvaluationUpdateResult"],
	upsertProductEvaluation: GraphQLTypes["ProductEvaluationUpsertResult"],
	createAd: GraphQLTypes["AdCreateResult"],
	deleteAd: GraphQLTypes["AdDeleteResult"],
	updateAd: GraphQLTypes["AdUpdateResult"],
	upsertAd: GraphQLTypes["AdUpsertResult"],
	createEvaluationInfo: GraphQLTypes["EvaluationInfoCreateResult"],
	deleteEvaluationInfo: GraphQLTypes["EvaluationInfoDeleteResult"],
	updateEvaluationInfo: GraphQLTypes["EvaluationInfoUpdateResult"],
	upsertEvaluationInfo: GraphQLTypes["EvaluationInfoUpsertResult"],
	createConsumptionMessage: GraphQLTypes["ConsumptionMessageCreateResult"],
	deleteConsumptionMessage: GraphQLTypes["ConsumptionMessageDeleteResult"],
	updateConsumptionMessage: GraphQLTypes["ConsumptionMessageUpdateResult"],
	upsertConsumptionMessage: GraphQLTypes["ConsumptionMessageUpsertResult"],
	createContentText: GraphQLTypes["ContentTextCreateResult"],
	deleteContentText: GraphQLTypes["ContentTextDeleteResult"],
	updateContentText: GraphQLTypes["ContentTextUpdateResult"],
	upsertContentText: GraphQLTypes["ContentTextUpsertResult"],
	createContentTextBlock: GraphQLTypes["ContentTextBlockCreateResult"],
	deleteContentTextBlock: GraphQLTypes["ContentTextBlockDeleteResult"],
	updateContentTextBlock: GraphQLTypes["ContentTextBlockUpdateResult"],
	upsertContentTextBlock: GraphQLTypes["ContentTextBlockUpsertResult"],
	createComparatorPage: GraphQLTypes["ComparatorPageCreateResult"],
	deleteComparatorPage: GraphQLTypes["ComparatorPageDeleteResult"],
	updateComparatorPage: GraphQLTypes["ComparatorPageUpdateResult"],
	upsertComparatorPage: GraphQLTypes["ComparatorPageUpsertResult"],
	createLoginPage: GraphQLTypes["LoginPageCreateResult"],
	deleteLoginPage: GraphQLTypes["LoginPageDeleteResult"],
	updateLoginPage: GraphQLTypes["LoginPageUpdateResult"],
	upsertLoginPage: GraphQLTypes["LoginPageUpsertResult"],
	createRegisterPage: GraphQLTypes["RegisterPageCreateResult"],
	deleteRegisterPage: GraphQLTypes["RegisterPageDeleteResult"],
	updateRegisterPage: GraphQLTypes["RegisterPageUpdateResult"],
	upsertRegisterPage: GraphQLTypes["RegisterPageUpsertResult"],
	createResultsPage: GraphQLTypes["ResultsPageCreateResult"],
	deleteResultsPage: GraphQLTypes["ResultsPageDeleteResult"],
	updateResultsPage: GraphQLTypes["ResultsPageUpdateResult"],
	upsertResultsPage: GraphQLTypes["ResultsPageUpsertResult"],
	createSearchPage: GraphQLTypes["SearchPageCreateResult"],
	deleteSearchPage: GraphQLTypes["SearchPageDeleteResult"],
	updateSearchPage: GraphQLTypes["SearchPageUpdateResult"],
	upsertSearchPage: GraphQLTypes["SearchPageUpsertResult"],
	createWizardPage: GraphQLTypes["WizardPageCreateResult"],
	deleteWizardPage: GraphQLTypes["WizardPageDeleteResult"],
	updateWizardPage: GraphQLTypes["WizardPageUpdateResult"],
	upsertWizardPage: GraphQLTypes["WizardPageUpsertResult"],
	createBreastfeedingCategory: GraphQLTypes["BreastfeedingCategoryCreateResult"],
	deleteBreastfeedingCategory: GraphQLTypes["BreastfeedingCategoryDeleteResult"],
	updateBreastfeedingCategory: GraphQLTypes["BreastfeedingCategoryUpdateResult"],
	upsertBreastfeedingCategory: GraphQLTypes["BreastfeedingCategoryUpsertResult"],
	createDogReproduction: GraphQLTypes["DogReproductionCreateResult"],
	deleteDogReproduction: GraphQLTypes["DogReproductionDeleteResult"],
	updateDogReproduction: GraphQLTypes["DogReproductionUpdateResult"],
	upsertDogReproduction: GraphQLTypes["DogReproductionUpsertResult"],
	createContactFormMessage: GraphQLTypes["ContactFormMessageCreateResult"],
	deleteContactFormMessage: GraphQLTypes["ContactFormMessageDeleteResult"],
	updateContactFormMessage: GraphQLTypes["ContactFormMessageUpdateResult"],
	upsertContactFormMessage: GraphQLTypes["ContactFormMessageUpsertResult"],
	createContactPage: GraphQLTypes["ContactPageCreateResult"],
	deleteContactPage: GraphQLTypes["ContactPageDeleteResult"],
	updateContactPage: GraphQLTypes["ContactPageUpdateResult"],
	upsertContactPage: GraphQLTypes["ContactPageUpsertResult"],
	createBugReport: GraphQLTypes["BugReportCreateResult"],
	deleteBugReport: GraphQLTypes["BugReportDeleteResult"],
	updateBugReport: GraphQLTypes["BugReportUpdateResult"],
	upsertBugReport: GraphQLTypes["BugReportUpsertResult"],
	createColor: GraphQLTypes["ColorCreateResult"],
	deleteColor: GraphQLTypes["ColorDeleteResult"],
	updateColor: GraphQLTypes["ColorUpdateResult"],
	upsertColor: GraphQLTypes["ColorUpsertResult"],
	createItemGroup: GraphQLTypes["ItemGroupCreateResult"],
	deleteItemGroup: GraphQLTypes["ItemGroupDeleteResult"],
	updateItemGroup: GraphQLTypes["ItemGroupUpdateResult"],
	upsertItemGroup: GraphQLTypes["ItemGroupUpsertResult"],
	createProductEvaluationSummary: GraphQLTypes["ProductEvaluationSummaryCreateResult"],
	deleteProductEvaluationSummary: GraphQLTypes["ProductEvaluationSummaryDeleteResult"],
	updateProductEvaluationSummary: GraphQLTypes["ProductEvaluationSummaryUpdateResult"],
	upsertProductEvaluationSummary: GraphQLTypes["ProductEvaluationSummaryUpsertResult"],
	createProtectedAction: GraphQLTypes["ProtectedActionCreateResult"],
	deleteProtectedAction: GraphQLTypes["ProtectedActionDeleteResult"],
	updateProtectedAction: GraphQLTypes["ProtectedActionUpdateResult"],
	upsertProtectedAction: GraphQLTypes["ProtectedActionUpsertResult"],
	createBrandAlias: GraphQLTypes["BrandAliasCreateResult"],
	deleteBrandAlias: GraphQLTypes["BrandAliasDeleteResult"],
	updateBrandAlias: GraphQLTypes["BrandAliasUpdateResult"],
	upsertBrandAlias: GraphQLTypes["BrandAliasUpsertResult"],
	createProductAlias: GraphQLTypes["ProductAliasCreateResult"],
	deleteProductAlias: GraphQLTypes["ProductAliasDeleteResult"],
	updateProductAlias: GraphQLTypes["ProductAliasUpdateResult"],
	upsertProductAlias: GraphQLTypes["ProductAliasUpsertResult"],
	createProductLineAlias: GraphQLTypes["ProductLineAliasCreateResult"],
	deleteProductLineAlias: GraphQLTypes["ProductLineAliasDeleteResult"],
	updateProductLineAlias: GraphQLTypes["ProductLineAliasUpdateResult"],
	upsertProductLineAlias: GraphQLTypes["ProductLineAliasUpsertResult"],
	createGenericPage: GraphQLTypes["GenericPageCreateResult"],
	deleteGenericPage: GraphQLTypes["GenericPageDeleteResult"],
	updateGenericPage: GraphQLTypes["GenericPageUpdateResult"],
	upsertGenericPage: GraphQLTypes["GenericPageUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createContentLinks: GraphQLTypes["ContentLinksCreateResult"],
	deleteContentLinks: GraphQLTypes["ContentLinksDeleteResult"],
	updateContentLinks: GraphQLTypes["ContentLinksUpdateResult"],
	upsertContentLinks: GraphQLTypes["ContentLinksUpsertResult"],
	createContentLinksItem: GraphQLTypes["ContentLinksItemCreateResult"],
	deleteContentLinksItem: GraphQLTypes["ContentLinksItemDeleteResult"],
	updateContentLinksItem: GraphQLTypes["ContentLinksItemUpdateResult"],
	upsertContentLinksItem: GraphQLTypes["ContentLinksItemUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createContentReferenceImage: GraphQLTypes["ContentReferenceImageCreateResult"],
	deleteContentReferenceImage: GraphQLTypes["ContentReferenceImageDeleteResult"],
	updateContentReferenceImage: GraphQLTypes["ContentReferenceImageUpdateResult"],
	upsertContentReferenceImage: GraphQLTypes["ContentReferenceImageUpsertResult"],
	createSeoData: GraphQLTypes["SeoDataCreateResult"],
	deleteSeoData: GraphQLTypes["SeoDataDeleteResult"],
	updateSeoData: GraphQLTypes["SeoDataUpdateResult"],
	upsertSeoData: GraphQLTypes["SeoDataUpsertResult"],
	createAgeCategory: GraphQLTypes["AgeCategoryCreateResult"],
	deleteAgeCategory: GraphQLTypes["AgeCategoryDeleteResult"],
	updateAgeCategory: GraphQLTypes["AgeCategoryUpdateResult"],
	upsertAgeCategory: GraphQLTypes["AgeCategoryUpsertResult"],
	createFilterCombo: GraphQLTypes["FilterComboCreateResult"],
	deleteFilterCombo: GraphQLTypes["FilterComboDeleteResult"],
	updateFilterCombo: GraphQLTypes["FilterComboUpdateResult"],
	upsertFilterCombo: GraphQLTypes["FilterComboUpsertResult"],
	createImportCache: GraphQLTypes["ImportCacheCreateResult"],
	deleteImportCache: GraphQLTypes["ImportCacheDeleteResult"],
	updateImportCache: GraphQLTypes["ImportCacheUpdateResult"],
	upsertImportCache: GraphQLTypes["ImportCacheUpsertResult"],
	createSite: GraphQLTypes["SiteCreateResult"],
	deleteSite: GraphQLTypes["SiteDeleteResult"],
	updateSite: GraphQLTypes["SiteUpdateResult"],
	upsertSite: GraphQLTypes["SiteUpsertResult"],
	createContactSubmission: GraphQLTypes["ContactSubmissionCreateResult"],
	deleteContactSubmission: GraphQLTypes["ContactSubmissionDeleteResult"],
	updateContactSubmission: GraphQLTypes["ContactSubmissionUpdateResult"],
	upsertContactSubmission: GraphQLTypes["ContactSubmissionUpsertResult"],
	createTOPXBrand: GraphQLTypes["TOPXBrandCreateResult"],
	deleteTOPXBrand: GraphQLTypes["TOPXBrandDeleteResult"],
	updateTOPXBrand: GraphQLTypes["TOPXBrandUpdateResult"],
	upsertTOPXBrand: GraphQLTypes["TOPXBrandUpsertResult"],
	createTOPXBrandCategory: GraphQLTypes["TOPXBrandCategoryCreateResult"],
	deleteTOPXBrandCategory: GraphQLTypes["TOPXBrandCategoryDeleteResult"],
	updateTOPXBrandCategory: GraphQLTypes["TOPXBrandCategoryUpdateResult"],
	upsertTOPXBrandCategory: GraphQLTypes["TOPXBrandCategoryUpsertResult"],
	createTOPXProduct: GraphQLTypes["TOPXProductCreateResult"],
	deleteTOPXProduct: GraphQLTypes["TOPXProductDeleteResult"],
	updateTOPXProduct: GraphQLTypes["TOPXProductUpdateResult"],
	upsertTOPXProduct: GraphQLTypes["TOPXProductUpsertResult"],
	createTOPXProductCategory: GraphQLTypes["TOPXProductCategoryCreateResult"],
	deleteTOPXProductCategory: GraphQLTypes["TOPXProductCategoryDeleteResult"],
	updateTOPXProductCategory: GraphQLTypes["TOPXProductCategoryUpdateResult"],
	upsertTOPXProductCategory: GraphQLTypes["TOPXProductCategoryUpsertResult"],
	createContentReferenceList: GraphQLTypes["ContentReferenceListCreateResult"],
	deleteContentReferenceList: GraphQLTypes["ContentReferenceListDeleteResult"],
	updateContentReferenceList: GraphQLTypes["ContentReferenceListUpdateResult"],
	upsertContentReferenceList: GraphQLTypes["ContentReferenceListUpsertResult"],
	query?: GraphQLTypes["Query"]
};
	["MutationTransactionOptions"]: {
		deferForeignKeyConstraints?: boolean,
	deferUniqueConstraints?: boolean
}
    }
export enum _RelationSide {
	owning = "owning",
	inverse = "inverse"
}
export enum _OnDeleteBehaviour {
	restrict = "restrict",
	cascade = "cascade",
	setNull = "setNull"
}
export enum _OrderByDirection {
	asc = "asc",
	desc = "desc"
}
export enum One {
	One = "One"
}
export enum SentimentType {
	positive = "positive",
	negative = "negative"
}
export enum GenderType {
	male = "male",
	female = "female"
}
export enum AgeRangeType {
	puppyNewbornToSeven = "puppyNewbornToSeven",
	puppyEightToThirteen = "puppyEightToThirteen",
	puppyFourteenToEight = "puppyFourteenToEight",
	puppyFourteenToTen = "puppyFourteenToTen",
	puppyFourteenToTwelve = "puppyFourteenToTwelve",
	puppyFourteenToEighteen = "puppyFourteenToEighteen",
	puppyFourteenToTwentyFour = "puppyFourteenToTwentyFour",
	adultNinePlus = "adultNinePlus",
	adultElevenPlus = "adultElevenPlus",
	adultThirteenPlus = "adultThirteenPlus",
	adultNineteenPlus = "adultNineteenPlus",
	adultTwentyFivePlus = "adultTwentyFivePlus"
}
export enum AgeLabelType {
	puppy = "puppy",
	adult = "adult"
}
export enum FeatureCategoryType {
	positive = "positive",
	negative = "negative",
	allergy = "allergy"
}
export enum FeatureValueType {
	zero = "zero",
	moreThanZero = "moreThanZero",
	one = "one",
	minusOne = "minusOne"
}
export enum ProductFlagValue {
	zero = "zero",
	one = "one",
	twoAndMore = "twoAndMore",
	noData = "noData",
	minusOne = "minusOne"
}
export enum GranuleSizeType {
	S = "S",
	M = "M",
	L = "L"
}
export enum ContentReferenceType {
	richtext = "richtext",
	fact = "fact",
	gallery = "gallery",
	hr = "hr",
	link = "link",
	clear = "clear",
	outline = "outline",
	quote = "quote",
	relatedBlogPost = "relatedBlogPost",
	relatedBrand = "relatedBrand",
	relatedBrandFull = "relatedBrandFull",
	relatedProduct = "relatedProduct",
	relatedProductFull = "relatedProductFull",
	relatedIngredient = "relatedIngredient",
	video = "video",
	image = "image",
	list = "list",
	ad = "ad"
}
export enum AlignmentType {
	left = "left",
	right = "right",
	center = "center"
}
export enum GroupType {
	section = "section",
	detail = "detail"
}
export enum TOPXBrandOrderType {
	top = "top",
	bottom = "bottom"
}
export enum ContentAmount {
	zero = "zero",
	one = "one",
	twoAndMore = "twoAndMore",
	noData = "noData"
}
export enum TOPXProductOrderType {
	top = "top",
	bottom = "bottom"
}
export enum SizeType {
	XS = "XS",
	S = "S",
	M = "M",
	L = "L",
	XL = "XL"
}
export enum DogReproductionType {
	castrated = "castrated",
	breastfeeding = "breastfeeding",
	pregnant = "pregnant"
}
export enum PregnantPeriodType {
	firstHalf = "firstHalf",
	secondHalf = "secondHalf"
}
export enum ProtectedActionType {
	ResetPassword = "ResetPassword",
	VerifyEmail = "VerifyEmail"
}
export enum OrderDirection {
	asc = "asc",
	desc = "desc",
	ascNullsFirst = "ascNullsFirst",
	descNullsLast = "descNullsLast"
}
export enum MediumType {
	image = "image",
	video = "video"
}
export enum ColorTheme {
	light = "light",
	dark = "dark"
}
export enum SocialType {
	facebook = "facebook",
	instagram = "instagram",
	twitter = "twitter"
}
export enum BookType {
	adult = "adult",
	puppyFemale = "puppyFemale",
	senior = "senior",
	puppy = "puppy"
}
export enum S33ContentDisposition {
	ATTACHMENT = "ATTACHMENT",
	INLINE = "INLINE"
}
export enum S3Acl {
	PUBLIC_READ = "PUBLIC_READ",
	PRIVATE = "PRIVATE",
	NONE = "NONE"
}
export enum _MutationErrorType {
	NotNullConstraintViolation = "NotNullConstraintViolation",
	UniqueConstraintViolation = "UniqueConstraintViolation",
	ForeignKeyConstraintViolation = "ForeignKeyConstraintViolation",
	NotFoundOrDenied = "NotFoundOrDenied",
	NonUniqueWhereInput = "NonUniqueWhereInput",
	InvalidDataInput = "InvalidDataInput",
	SqlError = "SqlError"
}
export class GraphQLError extends Error {
    constructor(public response: GraphQLResponse) {
      super("");
      console.error(response);
    }
    override toString() {
      return "GraphQL Response Error";
    }
  }


export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<
  UnwrapPromise<ReturnType<T>>
>;
export type ZeusHook<
  T extends (
    ...args: any[]
  ) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>
> = ZeusState<ReturnType<T>[N]>;

type WithTypeNameValue<T> = T & {
  __typename?: boolean;
};
type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
type IsArray<T, U> = T extends Array<infer R> ? InputType<R, U>[] : InputType<T, U>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;

type IsInterfaced<SRC extends DeepAnify<DST>, DST> = FlattenArray<SRC> extends ZEUS_INTERFACES | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P]>
          : {}
        : never;
    }[keyof DST] &
      {
        [P in keyof Omit<
          Pick<
            SRC,
            {
              [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
            }[keyof DST]
          >,
          '__typename'
        >]: IsPayLoad<DST[P]> extends boolean ? SRC[P] : IsArray<SRC[P], DST[P]>;
      }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends boolean ? SRC[P] : IsArray<SRC[P], DST[P]>;
    };

export type MapType<SRC, DST> = SRC extends DeepAnify<DST> ? IsInterfaced<SRC, DST> : never;
export type InputType<SRC, DST> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P]>;
    } &
      MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>>
  : MapType<SRC, IsPayLoad<DST>>;
type Func<P extends any[], R> = (...args: P) => R;
type AnyFunc = Func<any, any>;
export type ArgsType<F extends AnyFunc> = F extends Func<infer P, any> ? P : never;
export type OperationOptions = {
  variables?: Record<string, any>;
  operationName?: string;
};
export type SubscriptionToGraphQL<Z, T> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z>; errors?: string[] }) => void) => void;
  open: () => void;
};
export type SelectionFunction<V> = <T>(t: T | V) => T;
export type fetchOptions = ArgsType<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (
  ...args: infer R
) => WebSocket
  ? R
  : never;
export type chainOptions =
  | [fetchOptions[0], fetchOptions[1] & {websocket?: websocketOptions}]
  | [fetchOptions[0]];
export type FetchFunction = (
  query: string,
  variables?: Record<string, any>,
) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;



export const ZeusSelect = <T>() => ((t: any) => t) as SelectionFunction<T>;

export const ScalarResolver = (scalar: string, value: any) => {
  switch (scalar) {
    case 'String':
      return  `${JSON.stringify(value)}`;
    case 'Int':
      return `${value}`;
    case 'Float':
      return `${value}`;
    case 'Boolean':
      return `${value}`;
    case 'ID':
      return `"${value}"`;
    case 'enum':
      return `${value}`;
    case 'scalar':
      return `${value}`;
    default:
      return false;
  }
};


export const TypesPropsResolver = ({
    value,
    type,
    name,
    key,
    blockArrays
}: {
    value: any;
    type: string;
    name: string;
    key?: string;
    blockArrays?: boolean;
}): string => {
    if (value === null) {
        return `null`;
    }
    let resolvedValue = AllTypesProps[type][name];
    if (key) {
        resolvedValue = resolvedValue[key];
    }
    if (!resolvedValue) {
        throw new Error(`Cannot resolve ${type} ${name}${key ? ` ${key}` : ''}`)
    }
    const typeResolved = resolvedValue.type;
    const isArray = resolvedValue.array;
    const isArrayRequired = resolvedValue.arrayRequired;
    if (typeof value === 'string' && value.startsWith(`ZEUS_VAR$`)) {
        const isRequired = resolvedValue.required ? '!' : '';
        let t = `${typeResolved}`;
        if (isArray) {
          if (isRequired) {
              t = `${t}!`;
          }
          t = `[${t}]`;
          if(isArrayRequired){
            t = `${t}!`;
          }
        }else{
          if (isRequired) {
                t = `${t}!`;
          }
        }
        return `\$${value.split(`ZEUS_VAR$`)[1]}__ZEUS_VAR__${t}`;
    }
    if (isArray && !blockArrays) {
        return `[${value
        .map((v: any) => TypesPropsResolver({ value: v, type, name, key, blockArrays: true }))
        .join(',')}]`;
    }
    const reslovedScalar = ScalarResolver(typeResolved, value);
    if (!reslovedScalar) {
        const resolvedType = AllTypesProps[typeResolved];
        if (typeof resolvedType === 'object') {
        const argsKeys = Object.keys(resolvedType);
        return `{${argsKeys
            .filter((ak) => value[ak] !== undefined)
            .map(
            (ak) => `${ak}:${TypesPropsResolver({ value: value[ak], type: typeResolved, name: ak })}`
            )}}`;
        }
        return ScalarResolver(AllTypesProps[typeResolved], value) as string;
    }
    return reslovedScalar;
};


const isArrayFunction = (
  parent: string[],
  a: any[]
) => {
  const [values, r] = a;
  const [mainKey, key, ...keys] = parent;
  const keyValues = Object.keys(values).filter((k) => typeof values[k] !== 'undefined');

  if (!keys.length) {
      return keyValues.length > 0
        ? `(${keyValues
            .map(
              (v) =>
                `${v}:${TypesPropsResolver({
                  value: values[v],
                  type: mainKey,
                  name: key,
                  key: v
                })}`
            )
            .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
        : traverseToSeekArrays(parent, r);
    }

  const [typeResolverKey] = keys.splice(keys.length - 1, 1);
  let valueToResolve = ReturnTypes[mainKey][key];
  for (const k of keys) {
    valueToResolve = ReturnTypes[valueToResolve][k];
  }

  const argumentString =
    keyValues.length > 0
      ? `(${keyValues
          .map(
            (v) =>
              `${v}:${TypesPropsResolver({
                value: values[v],
                type: valueToResolve,
                name: typeResolverKey,
                key: v
              })}`
          )
          .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
      : traverseToSeekArrays(parent, r);
  return argumentString;
};


const resolveKV = (k: string, v: boolean | string | { [x: string]: boolean | string }) =>
  typeof v === 'boolean' ? k : typeof v === 'object' ? `${k}{${objectToTree(v)}}` : `${k}${v}`;


const objectToTree = (o: { [x: string]: boolean | string }): string =>
  `{${Object.keys(o).map((k) => `${resolveKV(k, o[k])}`).join(' ')}}`;


const traverseToSeekArrays = (parent: string[], a?: any): string => {
  if (!a) return '';
  if (Object.keys(a).length === 0) {
    return '';
  }
  let b: Record<string, any> = {};
  if (Array.isArray(a)) {
    return isArrayFunction([...parent], a);
  } else {
    if (typeof a === 'object') {
      Object.keys(a)
        .filter((k) => typeof a[k] !== 'undefined')
        .forEach((k) => {
        if (k === '__alias') {
          Object.keys(a[k]).forEach((aliasKey) => {
            const aliasOperations = a[k][aliasKey];
            const aliasOperationName = Object.keys(aliasOperations)[0];
            const aliasOperation = aliasOperations[aliasOperationName];
            b[
              `${aliasOperationName}__alias__${aliasKey}: ${aliasOperationName}`
            ] = traverseToSeekArrays([...parent, aliasOperationName], aliasOperation);
          });
        } else {
          b[k] = traverseToSeekArrays([...parent, k], a[k]);
        }
      });
    } else {
      return '';
    }
  }
  return objectToTree(b);
};  


const buildQuery = (type: string, a?: Record<any, any>) => 
  traverseToSeekArrays([type], a);


const inspectVariables = (query: string) => {
  const regex = /\$\b\w*__ZEUS_VAR__\[?[^!^\]^\s^,^\)^\}]*[!]?[\]]?[!]?/g;
  let result;
  const AllVariables: string[] = [];
  while ((result = regex.exec(query))) {
    if (AllVariables.includes(result[0])) {
      continue;
    }
    AllVariables.push(result[0]);
  }
  if (!AllVariables.length) {
    return query;
  }
  let filteredQuery = query;
  AllVariables.forEach((variable) => {
    while (filteredQuery.includes(variable)) {
      filteredQuery = filteredQuery.replace(variable, variable.split('__ZEUS_VAR__')[0]);
    }
  });
  return `(${AllVariables.map((a) => a.split('__ZEUS_VAR__'))
    .map(([variableName, variableType]) => `${variableName}:${variableType}`)
    .join(', ')})${filteredQuery}`;
};


export const queryConstruct = (t: 'query' | 'mutation' | 'subscription', tName: string, operationName?: string) => (o: Record<any, any>) =>
  `${t.toLowerCase()}${operationName ? ' ' + operationName : ''}${inspectVariables(buildQuery(tName, o))}`;
  

export const fullChainConstruct = (fn: FetchFunction) => (t: 'query' | 'mutation' | 'subscription', tName: string) => (
  o: Record<any, any>,
  options?: OperationOptions,
) => fn(queryConstruct(t, tName, options?.operationName)(o), options?.variables).then((r:any) => { 
  seekForAliases(r)
  return r
});


export const fullSubscriptionConstruct = (fn: SubscriptionFunction) => (
  t: 'query' | 'mutation' | 'subscription',
  tName: string,
) => (o: Record<any, any>, options?: OperationOptions) =>
  fn(queryConstruct(t, tName, options?.operationName)(o));


const seekForAliases = (response: any) => {
  const traverseAlias = (value: any) => {
    if (Array.isArray(value)) {
      value.forEach(seekForAliases);
    } else {
      if (typeof value === 'object') {
        seekForAliases(value);
      }
    }
  };
  if (typeof response === 'object' && response) {
    const keys = Object.keys(response);
    if (keys.length < 1) {
      return;
    }
    keys.forEach((k) => {
      const value = response[k];
      if (k.indexOf('__alias__') !== -1) {
        const [operation, alias] = k.split('__alias__');
        response[alias] = {
          [operation]: value,
        };
        delete response[k];
      }
      traverseAlias(value);
    });
  }
};


export const $ = (t: TemplateStringsArray): any => `ZEUS_VAR$${t.join('')}`;


export const resolverFor = <
  X,
  T extends keyof ValueTypes,
  Z extends keyof ValueTypes[T],
>(
  type: T,
  field: Z,
  fn: (
    args: Required<ValueTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : any,
) => fn as (args?: any,source?: any) => any;


const handleFetchResponse = (
  response: Parameters<Extract<Parameters<ReturnType<typeof fetch>['then']>[0], Function>>[0]
): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response.text().then(text => {
        try { reject(JSON.parse(text)); }
        catch (err) { reject(text); }
      }).catch(reject);
    });
  }
  return response.json() as any;
};

export const apiFetch = (options: fetchOptions) => (query: string, variables: Record<string, any> = {}) => {
    let fetchFunction = fetch;
    let queryString = query;
    let fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      queryString = encodeURIComponent(query);
      return fetchFunction(`${options[0]}?query=${queryString}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetchFunction(`${options[0]}`, {
      body: JSON.stringify({ query: queryString, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      ...fetchOptions
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };
  

export const apiSubscription = (options: chainOptions) => (
    query: string,
  ) => {
    try {
      const queryString = options[0] + '?query=' + encodeURIComponent(query);
      const wsString = queryString.replace('http', 'ws');
      const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
      const webSocketOptions = options[1]?.websocket || [host];
      const ws = new WebSocket(...webSocketOptions);
      return {
        ws,
        on: (e: (args: any) => void) => {
          ws.onmessage = (event:any) => {
            if(event.data){
              const parsed: any = JSON.parse(event.data)
              const data = parsed.data
              if (data) {
                seekForAliases(data);
              }
              return e(data);
            }
          };
        },
        off: (e: (args: any) => void) => {
          ws.onclose = e;
        },
        error: (e: (args: any) => void) => {
          ws.onerror = e;
        },
        open: (e: () => void) => {
          ws.onopen = e;
        },
      };
    } catch {
      throw new Error('No websockets implemented');
    }
  };



const allOperations = {
    "query": "Query",
    "mutation": "Mutation"
}

export type GenericOperation<O> = O extends 'query'
  ? "Query"
  : O extends 'mutation'
  ? "Mutation"
  : never

export const Thunder = (fn: FetchFunction) => <
  O extends 'query' | 'mutation',
  R extends keyof ValueTypes = GenericOperation<O>
>(
  operation: O,
) => <Z extends ValueTypes[R]>(o: Z | ValueTypes[R], ops?: OperationOptions) =>
  fullChainConstruct(fn)(operation, allOperations[operation])(o as any, ops) as Promise<InputType<GraphQLTypes[R], Z>>;

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));  
  
export const SubscriptionThunder = (fn: SubscriptionFunction) => <
  O extends 'query' | 'mutation',
  R extends keyof ValueTypes = GenericOperation<O>
>(
  operation: O,
) => <Z extends ValueTypes[R]>(
  o: Z | ValueTypes[R],
  ops?: OperationOptions
)=>
  fullSubscriptionConstruct(fn)(operation, allOperations[operation])(
    o as any,
    ops,
  ) as SubscriptionToGraphQL<Z, GraphQLTypes[R]>;

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends 'query' | 'mutation',
  R extends keyof ValueTypes = GenericOperation<O>
>(
  operation: O,
  o: Z | ValueTypes[R],
  operationName?: string,
) => queryConstruct(operation, allOperations[operation], operationName)(o as any);
export const Selector = <T extends keyof ValueTypes>(key: T) => ZeusSelect<ValueTypes[T]>();
  

export const Gql = Chain('http://localhost:1481/content/granulepodlupou/live')
export type FragmentResult<K extends keyof GraphQLTypes, Q extends unknown | ((...args: any[]) => unknown)> = InputType<
	GraphQLTypes[K],
	Q extends (...args: any[]) => unknown ? ReturnType<Q> : Q
>